webpackJsonp([1,0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.noop = noop;
	exports.isDef = isDef;
	exports.isFunction = isFunction;
	exports.isObject = isObject;
	exports.isPromise = isPromise;
	exports.get = get;
	exports.isServer = exports.addUnit = exports.createNamespace = void 0;
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	var _create = __webpack_require__(393);
	
	exports.createNamespace = _create.createNamespace;
	
	var _unit = __webpack_require__(395);
	
	exports.addUnit = _unit.addUnit;
	var isServer = _vue.default.prototype.$isServer;
	exports.isServer = isServer;
	
	function noop() {}
	
	function isDef(val) {
	  return val !== undefined && val !== null;
	}
	
	function isFunction(val) {
	  return typeof val === 'function';
	}
	
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	function isPromise(val) {
	  return isObject(val) && isFunction(val.then) && isFunction(val.catch);
	}
	
	function get(object, path) {
	  var keys = path.split('.');
	  var result = object;
	  keys.forEach(function (key) {
	    result = isDef(result[key]) ? result[key] : '';
	  });
	  return result;
	}

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";function _extends(){return _extends=Object.assign||function(a){for(var b,c=1;c<arguments.length;c++)for(var d in b=arguments[c],b)Object.prototype.hasOwnProperty.call(b,d)&&(a[d]=b[d]);return a},_extends.apply(this,arguments)}var normalMerge=["attrs","props","domProps"],toArrayMerge=["class","style","directives"],functionalMerge=["on","nativeOn"],mergeJsxProps=function(a){return a.reduce(function(c,a){for(var b in a)if(!c[b])c[b]=a[b];else if(-1!==normalMerge.indexOf(b))c[b]=_extends({},c[b],a[b]);else if(-1!==toArrayMerge.indexOf(b)){var d=c[b]instanceof Array?c[b]:[c[b]],e=a[b]instanceof Array?a[b]:[a[b]];c[b]=d.concat(e)}else if(-1!==functionalMerge.indexOf(b)){for(var f in a[b])if(c[b][f]){var g=c[b][f]instanceof Array?c[b][f]:[c[b][f]],h=a[b][f]instanceof Array?a[b][f]:[a[b][f]];c[b][f]=g.concat(h)}else c[b][f]=a[b][f];}else if("hook"==b)for(var i in a[b])c[b][i]=c[b][i]?mergeFn(c[b][i],a[b][i]):a[b][i];else c[b]=a[b];return c},{})},mergeFn=function(a,b){return function(){a&&a.apply(this,arguments),b&&b.apply(this,arguments)}};module.exports=mergeJsxProps;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.inherit = inherit;
	exports.emit = emit;
	exports.mount = mount;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	var inheritKey = ['ref', 'style', 'class', 'attrs', 'nativeOn', 'directives', 'staticClass', 'staticStyle'];
	var mapInheritKey = {
	  nativeOn: 'on'
	}; // inherit partial context, map nativeOn to on
	
	function inherit(context, inheritListeners) {
	  var result = inheritKey.reduce(function (obj, key) {
	    if (context.data[key]) {
	      obj[mapInheritKey[key] || key] = context.data[key];
	    }
	
	    return obj;
	  }, {});
	
	  if (inheritListeners) {
	    result.on = result.on || {};
	    (0, _extends2.default)(result.on, context.data.on);
	  }
	
	  return result;
	} // emit event
	
	
	function emit(context, eventName) {
	  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var listeners = context.listeners[eventName];
	
	  if (listeners) {
	    if (Array.isArray(listeners)) {
	      listeners.forEach(function (listener) {
	        listener.apply(void 0, args);
	      });
	    } else {
	      listeners.apply(void 0, args);
	    }
	  }
	} // mount functional component
	
	
	function mount(Component, data) {
	  var instance = new _vue.default({
	    el: document.createElement('div'),
	    props: Component.props,
	    render: function render(h) {
	      return h(Component, (0, _extends2.default)({
	        props: this.$props
	      }, data));
	    }
	  });
	  document.body.appendChild(instance.$el);
	  return instance;
	}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
	 * Vue.js v2.5.17
	 * (c) 2014-2018 Evan You
	 * Released under the MIT License.
	 */
	'use strict';
	
	/*  */
	
	var emptyObject = Object.freeze({});
	
	// these helpers produces better vm code in JS engines due to their
	// explicitness and function inlining
	function isUndef (v) {
	  return v === undefined || v === null
	}
	
	function isDef (v) {
	  return v !== undefined && v !== null
	}
	
	function isTrue (v) {
	  return v === true
	}
	
	function isFalse (v) {
	  return v === false
	}
	
	/**
	 * Check if value is primitive
	 */
	function isPrimitive (value) {
	  return (
	    typeof value === 'string' ||
	    typeof value === 'number' ||
	    // $flow-disable-line
	    typeof value === 'symbol' ||
	    typeof value === 'boolean'
	  )
	}
	
	/**
	 * Quick object check - this is primarily used to tell
	 * Objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 */
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	/**
	 * Get the raw type string of a value e.g. [object Object]
	 */
	var _toString = Object.prototype.toString;
	
	function toRawType (value) {
	  return _toString.call(value).slice(8, -1)
	}
	
	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 */
	function isPlainObject (obj) {
	  return _toString.call(obj) === '[object Object]'
	}
	
	function isRegExp (v) {
	  return _toString.call(v) === '[object RegExp]'
	}
	
	/**
	 * Check if val is a valid array index.
	 */
	function isValidArrayIndex (val) {
	  var n = parseFloat(String(val));
	  return n >= 0 && Math.floor(n) === n && isFinite(val)
	}
	
	/**
	 * Convert a value to a string that is actually rendered.
	 */
	function toString (val) {
	  return val == null
	    ? ''
	    : typeof val === 'object'
	      ? JSON.stringify(val, null, 2)
	      : String(val)
	}
	
	/**
	 * Convert a input value to a number for persistence.
	 * If the conversion fails, return original string.
	 */
	function toNumber (val) {
	  var n = parseFloat(val);
	  return isNaN(n) ? val : n
	}
	
	/**
	 * Make a map and return a function for checking if a key
	 * is in that map.
	 */
	function makeMap (
	  str,
	  expectsLowerCase
	) {
	  var map = Object.create(null);
	  var list = str.split(',');
	  for (var i = 0; i < list.length; i++) {
	    map[list[i]] = true;
	  }
	  return expectsLowerCase
	    ? function (val) { return map[val.toLowerCase()]; }
	    : function (val) { return map[val]; }
	}
	
	/**
	 * Check if a tag is a built-in tag.
	 */
	var isBuiltInTag = makeMap('slot,component', true);
	
	/**
	 * Check if a attribute is a reserved attribute.
	 */
	var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
	
	/**
	 * Remove an item from an array
	 */
	function remove (arr, item) {
	  if (arr.length) {
	    var index = arr.indexOf(item);
	    if (index > -1) {
	      return arr.splice(index, 1)
	    }
	  }
	}
	
	/**
	 * Check whether the object has the property.
	 */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn (obj, key) {
	  return hasOwnProperty.call(obj, key)
	}
	
	/**
	 * Create a cached version of a pure function.
	 */
	function cached (fn) {
	  var cache = Object.create(null);
	  return (function cachedFn (str) {
	    var hit = cache[str];
	    return hit || (cache[str] = fn(str))
	  })
	}
	
	/**
	 * Camelize a hyphen-delimited string.
	 */
	var camelizeRE = /-(\w)/g;
	var camelize = cached(function (str) {
	  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
	});
	
	/**
	 * Capitalize a string.
	 */
	var capitalize = cached(function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1)
	});
	
	/**
	 * Hyphenate a camelCase string.
	 */
	var hyphenateRE = /\B([A-Z])/g;
	var hyphenate = cached(function (str) {
	  return str.replace(hyphenateRE, '-$1').toLowerCase()
	});
	
	/**
	 * Simple bind polyfill for environments that do not support it... e.g.
	 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
	 * now more performant in most browsers, but removing it would be breaking for
	 * code that was able to run in PhantomJS 1.x, so this must be kept for
	 * backwards compatibility.
	 */
	
	/* istanbul ignore next */
	function polyfillBind (fn, ctx) {
	  function boundFn (a) {
	    var l = arguments.length;
	    return l
	      ? l > 1
	        ? fn.apply(ctx, arguments)
	        : fn.call(ctx, a)
	      : fn.call(ctx)
	  }
	
	  boundFn._length = fn.length;
	  return boundFn
	}
	
	function nativeBind (fn, ctx) {
	  return fn.bind(ctx)
	}
	
	var bind = Function.prototype.bind
	  ? nativeBind
	  : polyfillBind;
	
	/**
	 * Convert an Array-like object to a real Array.
	 */
	function toArray (list, start) {
	  start = start || 0;
	  var i = list.length - start;
	  var ret = new Array(i);
	  while (i--) {
	    ret[i] = list[i + start];
	  }
	  return ret
	}
	
	/**
	 * Mix properties into target object.
	 */
	function extend (to, _from) {
	  for (var key in _from) {
	    to[key] = _from[key];
	  }
	  return to
	}
	
	/**
	 * Merge an Array of Objects into a single Object.
	 */
	function toObject (arr) {
	  var res = {};
	  for (var i = 0; i < arr.length; i++) {
	    if (arr[i]) {
	      extend(res, arr[i]);
	    }
	  }
	  return res
	}
	
	/**
	 * Perform no operation.
	 * Stubbing args to make Flow happy without leaving useless transpiled code
	 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
	 */
	function noop (a, b, c) {}
	
	/**
	 * Always return false.
	 */
	var no = function (a, b, c) { return false; };
	
	/**
	 * Return same value
	 */
	var identity = function (_) { return _; };
	
	/**
	 * Generate a static keys string from compiler modules.
	 */
	
	
	/**
	 * Check if two values are loosely equal - that is,
	 * if they are plain objects, do they have the same shape?
	 */
	function looseEqual (a, b) {
	  if (a === b) { return true }
	  var isObjectA = isObject(a);
	  var isObjectB = isObject(b);
	  if (isObjectA && isObjectB) {
	    try {
	      var isArrayA = Array.isArray(a);
	      var isArrayB = Array.isArray(b);
	      if (isArrayA && isArrayB) {
	        return a.length === b.length && a.every(function (e, i) {
	          return looseEqual(e, b[i])
	        })
	      } else if (!isArrayA && !isArrayB) {
	        var keysA = Object.keys(a);
	        var keysB = Object.keys(b);
	        return keysA.length === keysB.length && keysA.every(function (key) {
	          return looseEqual(a[key], b[key])
	        })
	      } else {
	        /* istanbul ignore next */
	        return false
	      }
	    } catch (e) {
	      /* istanbul ignore next */
	      return false
	    }
	  } else if (!isObjectA && !isObjectB) {
	    return String(a) === String(b)
	  } else {
	    return false
	  }
	}
	
	function looseIndexOf (arr, val) {
	  for (var i = 0; i < arr.length; i++) {
	    if (looseEqual(arr[i], val)) { return i }
	  }
	  return -1
	}
	
	/**
	 * Ensure a function is called only once.
	 */
	function once (fn) {
	  var called = false;
	  return function () {
	    if (!called) {
	      called = true;
	      fn.apply(this, arguments);
	    }
	  }
	}
	
	var SSR_ATTR = 'data-server-rendered';
	
	var ASSET_TYPES = [
	  'component',
	  'directive',
	  'filter'
	];
	
	var LIFECYCLE_HOOKS = [
	  'beforeCreate',
	  'created',
	  'beforeMount',
	  'mounted',
	  'beforeUpdate',
	  'updated',
	  'beforeDestroy',
	  'destroyed',
	  'activated',
	  'deactivated',
	  'errorCaptured'
	];
	
	/*  */
	
	var config = ({
	  /**
	   * Option merge strategies (used in core/util/options)
	   */
	  // $flow-disable-line
	  optionMergeStrategies: Object.create(null),
	
	  /**
	   * Whether to suppress warnings.
	   */
	  silent: false,
	
	  /**
	   * Show production mode tip message on boot?
	   */
	  productionTip: ("production") !== 'production',
	
	  /**
	   * Whether to enable devtools
	   */
	  devtools: ("production") !== 'production',
	
	  /**
	   * Whether to record perf
	   */
	  performance: false,
	
	  /**
	   * Error handler for watcher errors
	   */
	  errorHandler: null,
	
	  /**
	   * Warn handler for watcher warns
	   */
	  warnHandler: null,
	
	  /**
	   * Ignore certain custom elements
	   */
	  ignoredElements: [],
	
	  /**
	   * Custom user key aliases for v-on
	   */
	  // $flow-disable-line
	  keyCodes: Object.create(null),
	
	  /**
	   * Check if a tag is reserved so that it cannot be registered as a
	   * component. This is platform-dependent and may be overwritten.
	   */
	  isReservedTag: no,
	
	  /**
	   * Check if an attribute is reserved so that it cannot be used as a component
	   * prop. This is platform-dependent and may be overwritten.
	   */
	  isReservedAttr: no,
	
	  /**
	   * Check if a tag is an unknown element.
	   * Platform-dependent.
	   */
	  isUnknownElement: no,
	
	  /**
	   * Get the namespace of an element
	   */
	  getTagNamespace: noop,
	
	  /**
	   * Parse the real tag name for the specific platform.
	   */
	  parsePlatformTagName: identity,
	
	  /**
	   * Check if an attribute must be bound using property, e.g. value
	   * Platform-dependent.
	   */
	  mustUseProp: no,
	
	  /**
	   * Exposed for legacy reasons
	   */
	  _lifecycleHooks: LIFECYCLE_HOOKS
	})
	
	/*  */
	
	/**
	 * Check if a string starts with $ or _
	 */
	function isReserved (str) {
	  var c = (str + '').charCodeAt(0);
	  return c === 0x24 || c === 0x5F
	}
	
	/**
	 * Define a property.
	 */
	function def (obj, key, val, enumerable) {
	  Object.defineProperty(obj, key, {
	    value: val,
	    enumerable: !!enumerable,
	    writable: true,
	    configurable: true
	  });
	}
	
	/**
	 * Parse simple path.
	 */
	var bailRE = /[^\w.$]/;
	function parsePath (path) {
	  if (bailRE.test(path)) {
	    return
	  }
	  var segments = path.split('.');
	  return function (obj) {
	    for (var i = 0; i < segments.length; i++) {
	      if (!obj) { return }
	      obj = obj[segments[i]];
	    }
	    return obj
	  }
	}
	
	/*  */
	
	// can we use __proto__?
	var hasProto = '__proto__' in {};
	
	// Browser environment sniffing
	var inBrowser = typeof window !== 'undefined';
	var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
	var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
	var UA = inBrowser && window.navigator.userAgent.toLowerCase();
	var isIE = UA && /msie|trident/.test(UA);
	var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	var isEdge = UA && UA.indexOf('edge/') > 0;
	var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
	var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
	var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
	
	// Firefox has a "watch" function on Object.prototype...
	var nativeWatch = ({}).watch;
	
	var supportsPassive = false;
	if (inBrowser) {
	  try {
	    var opts = {};
	    Object.defineProperty(opts, 'passive', ({
	      get: function get () {
	        /* istanbul ignore next */
	        supportsPassive = true;
	      }
	    })); // https://github.com/facebook/flow/issues/285
	    window.addEventListener('test-passive', null, opts);
	  } catch (e) {}
	}
	
	// this needs to be lazy-evaled because vue may be required before
	// vue-server-renderer can set VUE_ENV
	var _isServer;
	var isServerRendering = function () {
	  if (_isServer === undefined) {
	    /* istanbul ignore if */
	    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
	      // detect presence of vue-server-renderer and avoid
	      // Webpack shimming the process
	      _isServer = global['process'].env.VUE_ENV === 'server';
	    } else {
	      _isServer = false;
	    }
	  }
	  return _isServer
	};
	
	// detect devtools
	var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	/* istanbul ignore next */
	function isNative (Ctor) {
	  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
	}
	
	var hasSymbol =
	  typeof Symbol !== 'undefined' && isNative(Symbol) &&
	  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);
	
	var _Set;
	/* istanbul ignore if */ // $flow-disable-line
	if (typeof Set !== 'undefined' && isNative(Set)) {
	  // use native Set when available.
	  _Set = Set;
	} else {
	  // a non-standard Set polyfill that only works with primitive keys.
	  _Set = (function () {
	    function Set () {
	      this.set = Object.create(null);
	    }
	    Set.prototype.has = function has (key) {
	      return this.set[key] === true
	    };
	    Set.prototype.add = function add (key) {
	      this.set[key] = true;
	    };
	    Set.prototype.clear = function clear () {
	      this.set = Object.create(null);
	    };
	
	    return Set;
	  }());
	}
	
	/*  */
	
	var warn = noop;
	var tip = noop;
	var generateComponentTrace = (noop); // work around flow check
	var formatComponentName = (noop);
	
	if (false) {
	  var hasConsole = typeof console !== 'undefined';
	  var classifyRE = /(?:^|[-_])(\w)/g;
	  var classify = function (str) { return str
	    .replace(classifyRE, function (c) { return c.toUpperCase(); })
	    .replace(/[-_]/g, ''); };
	
	  warn = function (msg, vm) {
	    var trace = vm ? generateComponentTrace(vm) : '';
	
	    if (config.warnHandler) {
	      config.warnHandler.call(null, msg, vm, trace);
	    } else if (hasConsole && (!config.silent)) {
	      console.error(("[Vue warn]: " + msg + trace));
	    }
	  };
	
	  tip = function (msg, vm) {
	    if (hasConsole && (!config.silent)) {
	      console.warn("[Vue tip]: " + msg + (
	        vm ? generateComponentTrace(vm) : ''
	      ));
	    }
	  };
	
	  formatComponentName = function (vm, includeFile) {
	    if (vm.$root === vm) {
	      return '<Root>'
	    }
	    var options = typeof vm === 'function' && vm.cid != null
	      ? vm.options
	      : vm._isVue
	        ? vm.$options || vm.constructor.options
	        : vm || {};
	    var name = options.name || options._componentTag;
	    var file = options.__file;
	    if (!name && file) {
	      var match = file.match(/([^/\\]+)\.vue$/);
	      name = match && match[1];
	    }
	
	    return (
	      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
	      (file && includeFile !== false ? (" at " + file) : '')
	    )
	  };
	
	  var repeat = function (str, n) {
	    var res = '';
	    while (n) {
	      if (n % 2 === 1) { res += str; }
	      if (n > 1) { str += str; }
	      n >>= 1;
	    }
	    return res
	  };
	
	  generateComponentTrace = function (vm) {
	    if (vm._isVue && vm.$parent) {
	      var tree = [];
	      var currentRecursiveSequence = 0;
	      while (vm) {
	        if (tree.length > 0) {
	          var last = tree[tree.length - 1];
	          if (last.constructor === vm.constructor) {
	            currentRecursiveSequence++;
	            vm = vm.$parent;
	            continue
	          } else if (currentRecursiveSequence > 0) {
	            tree[tree.length - 1] = [last, currentRecursiveSequence];
	            currentRecursiveSequence = 0;
	          }
	        }
	        tree.push(vm);
	        vm = vm.$parent;
	      }
	      return '\n\nfound in\n\n' + tree
	        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
	            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
	            : formatComponentName(vm))); })
	        .join('\n')
	    } else {
	      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
	    }
	  };
	}
	
	/*  */
	
	
	var uid = 0;
	
	/**
	 * A dep is an observable that can have multiple
	 * directives subscribing to it.
	 */
	var Dep = function Dep () {
	  this.id = uid++;
	  this.subs = [];
	};
	
	Dep.prototype.addSub = function addSub (sub) {
	  this.subs.push(sub);
	};
	
	Dep.prototype.removeSub = function removeSub (sub) {
	  remove(this.subs, sub);
	};
	
	Dep.prototype.depend = function depend () {
	  if (Dep.target) {
	    Dep.target.addDep(this);
	  }
	};
	
	Dep.prototype.notify = function notify () {
	  // stabilize the subscriber list first
	  var subs = this.subs.slice();
	  for (var i = 0, l = subs.length; i < l; i++) {
	    subs[i].update();
	  }
	};
	
	// the current target watcher being evaluated.
	// this is globally unique because there could be only one
	// watcher being evaluated at any time.
	Dep.target = null;
	var targetStack = [];
	
	function pushTarget (_target) {
	  if (Dep.target) { targetStack.push(Dep.target); }
	  Dep.target = _target;
	}
	
	function popTarget () {
	  Dep.target = targetStack.pop();
	}
	
	/*  */
	
	var VNode = function VNode (
	  tag,
	  data,
	  children,
	  text,
	  elm,
	  context,
	  componentOptions,
	  asyncFactory
	) {
	  this.tag = tag;
	  this.data = data;
	  this.children = children;
	  this.text = text;
	  this.elm = elm;
	  this.ns = undefined;
	  this.context = context;
	  this.fnContext = undefined;
	  this.fnOptions = undefined;
	  this.fnScopeId = undefined;
	  this.key = data && data.key;
	  this.componentOptions = componentOptions;
	  this.componentInstance = undefined;
	  this.parent = undefined;
	  this.raw = false;
	  this.isStatic = false;
	  this.isRootInsert = true;
	  this.isComment = false;
	  this.isCloned = false;
	  this.isOnce = false;
	  this.asyncFactory = asyncFactory;
	  this.asyncMeta = undefined;
	  this.isAsyncPlaceholder = false;
	};
	
	var prototypeAccessors = { child: { configurable: true } };
	
	// DEPRECATED: alias for componentInstance for backwards compat.
	/* istanbul ignore next */
	prototypeAccessors.child.get = function () {
	  return this.componentInstance
	};
	
	Object.defineProperties( VNode.prototype, prototypeAccessors );
	
	var createEmptyVNode = function (text) {
	  if ( text === void 0 ) text = '';
	
	  var node = new VNode();
	  node.text = text;
	  node.isComment = true;
	  return node
	};
	
	function createTextVNode (val) {
	  return new VNode(undefined, undefined, undefined, String(val))
	}
	
	// optimized shallow clone
	// used for static nodes and slot nodes because they may be reused across
	// multiple renders, cloning them avoids errors when DOM manipulations rely
	// on their elm reference.
	function cloneVNode (vnode) {
	  var cloned = new VNode(
	    vnode.tag,
	    vnode.data,
	    vnode.children,
	    vnode.text,
	    vnode.elm,
	    vnode.context,
	    vnode.componentOptions,
	    vnode.asyncFactory
	  );
	  cloned.ns = vnode.ns;
	  cloned.isStatic = vnode.isStatic;
	  cloned.key = vnode.key;
	  cloned.isComment = vnode.isComment;
	  cloned.fnContext = vnode.fnContext;
	  cloned.fnOptions = vnode.fnOptions;
	  cloned.fnScopeId = vnode.fnScopeId;
	  cloned.isCloned = true;
	  return cloned
	}
	
	/*
	 * not type checking this file because flow doesn't play well with
	 * dynamically accessing methods on Array prototype
	 */
	
	var arrayProto = Array.prototype;
	var arrayMethods = Object.create(arrayProto);
	
	var methodsToPatch = [
	  'push',
	  'pop',
	  'shift',
	  'unshift',
	  'splice',
	  'sort',
	  'reverse'
	];
	
	/**
	 * Intercept mutating methods and emit events
	 */
	methodsToPatch.forEach(function (method) {
	  // cache original method
	  var original = arrayProto[method];
	  def(arrayMethods, method, function mutator () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    var result = original.apply(this, args);
	    var ob = this.__ob__;
	    var inserted;
	    switch (method) {
	      case 'push':
	      case 'unshift':
	        inserted = args;
	        break
	      case 'splice':
	        inserted = args.slice(2);
	        break
	    }
	    if (inserted) { ob.observeArray(inserted); }
	    // notify change
	    ob.dep.notify();
	    return result
	  });
	});
	
	/*  */
	
	var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
	
	/**
	 * In some cases we may want to disable observation inside a component's
	 * update computation.
	 */
	var shouldObserve = true;
	
	function toggleObserving (value) {
	  shouldObserve = value;
	}
	
	/**
	 * Observer class that is attached to each observed
	 * object. Once attached, the observer converts the target
	 * object's property keys into getter/setters that
	 * collect dependencies and dispatch updates.
	 */
	var Observer = function Observer (value) {
	  this.value = value;
	  this.dep = new Dep();
	  this.vmCount = 0;
	  def(value, '__ob__', this);
	  if (Array.isArray(value)) {
	    var augment = hasProto
	      ? protoAugment
	      : copyAugment;
	    augment(value, arrayMethods, arrayKeys);
	    this.observeArray(value);
	  } else {
	    this.walk(value);
	  }
	};
	
	/**
	 * Walk through each property and convert them into
	 * getter/setters. This method should only be called when
	 * value type is Object.
	 */
	Observer.prototype.walk = function walk (obj) {
	  var keys = Object.keys(obj);
	  for (var i = 0; i < keys.length; i++) {
	    defineReactive(obj, keys[i]);
	  }
	};
	
	/**
	 * Observe a list of Array items.
	 */
	Observer.prototype.observeArray = function observeArray (items) {
	  for (var i = 0, l = items.length; i < l; i++) {
	    observe(items[i]);
	  }
	};
	
	// helpers
	
	/**
	 * Augment an target Object or Array by intercepting
	 * the prototype chain using __proto__
	 */
	function protoAugment (target, src, keys) {
	  /* eslint-disable no-proto */
	  target.__proto__ = src;
	  /* eslint-enable no-proto */
	}
	
	/**
	 * Augment an target Object or Array by defining
	 * hidden properties.
	 */
	/* istanbul ignore next */
	function copyAugment (target, src, keys) {
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var key = keys[i];
	    def(target, key, src[key]);
	  }
	}
	
	/**
	 * Attempt to create an observer instance for a value,
	 * returns the new observer if successfully observed,
	 * or the existing observer if the value already has one.
	 */
	function observe (value, asRootData) {
	  if (!isObject(value) || value instanceof VNode) {
	    return
	  }
	  var ob;
	  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
	    ob = value.__ob__;
	  } else if (
	    shouldObserve &&
	    !isServerRendering() &&
	    (Array.isArray(value) || isPlainObject(value)) &&
	    Object.isExtensible(value) &&
	    !value._isVue
	  ) {
	    ob = new Observer(value);
	  }
	  if (asRootData && ob) {
	    ob.vmCount++;
	  }
	  return ob
	}
	
	/**
	 * Define a reactive property on an Object.
	 */
	function defineReactive (
	  obj,
	  key,
	  val,
	  customSetter,
	  shallow
	) {
	  var dep = new Dep();
	
	  var property = Object.getOwnPropertyDescriptor(obj, key);
	  if (property && property.configurable === false) {
	    return
	  }
	
	  // cater for pre-defined getter/setters
	  var getter = property && property.get;
	  if (!getter && arguments.length === 2) {
	    val = obj[key];
	  }
	  var setter = property && property.set;
	
	  var childOb = !shallow && observe(val);
	  Object.defineProperty(obj, key, {
	    enumerable: true,
	    configurable: true,
	    get: function reactiveGetter () {
	      var value = getter ? getter.call(obj) : val;
	      if (Dep.target) {
	        dep.depend();
	        if (childOb) {
	          childOb.dep.depend();
	          if (Array.isArray(value)) {
	            dependArray(value);
	          }
	        }
	      }
	      return value
	    },
	    set: function reactiveSetter (newVal) {
	      var value = getter ? getter.call(obj) : val;
	      /* eslint-disable no-self-compare */
	      if (newVal === value || (newVal !== newVal && value !== value)) {
	        return
	      }
	      /* eslint-enable no-self-compare */
	      if (false) {
	        customSetter();
	      }
	      if (setter) {
	        setter.call(obj, newVal);
	      } else {
	        val = newVal;
	      }
	      childOb = !shallow && observe(newVal);
	      dep.notify();
	    }
	  });
	}
	
	/**
	 * Set a property on an object. Adds the new property and
	 * triggers change notification if the property doesn't
	 * already exist.
	 */
	function set (target, key, val) {
	  if (false
	  ) {
	    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
	  }
	  if (Array.isArray(target) && isValidArrayIndex(key)) {
	    target.length = Math.max(target.length, key);
	    target.splice(key, 1, val);
	    return val
	  }
	  if (key in target && !(key in Object.prototype)) {
	    target[key] = val;
	    return val
	  }
	  var ob = (target).__ob__;
	  if (target._isVue || (ob && ob.vmCount)) {
	    ("production") !== 'production' && warn(
	      'Avoid adding reactive properties to a Vue instance or its root $data ' +
	      'at runtime - declare it upfront in the data option.'
	    );
	    return val
	  }
	  if (!ob) {
	    target[key] = val;
	    return val
	  }
	  defineReactive(ob.value, key, val);
	  ob.dep.notify();
	  return val
	}
	
	/**
	 * Delete a property and trigger change if necessary.
	 */
	function del (target, key) {
	  if (false
	  ) {
	    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
	  }
	  if (Array.isArray(target) && isValidArrayIndex(key)) {
	    target.splice(key, 1);
	    return
	  }
	  var ob = (target).__ob__;
	  if (target._isVue || (ob && ob.vmCount)) {
	    ("production") !== 'production' && warn(
	      'Avoid deleting properties on a Vue instance or its root $data ' +
	      '- just set it to null.'
	    );
	    return
	  }
	  if (!hasOwn(target, key)) {
	    return
	  }
	  delete target[key];
	  if (!ob) {
	    return
	  }
	  ob.dep.notify();
	}
	
	/**
	 * Collect dependencies on array elements when the array is touched, since
	 * we cannot intercept array element access like property getters.
	 */
	function dependArray (value) {
	  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
	    e = value[i];
	    e && e.__ob__ && e.__ob__.dep.depend();
	    if (Array.isArray(e)) {
	      dependArray(e);
	    }
	  }
	}
	
	/*  */
	
	/**
	 * Option overwriting strategies are functions that handle
	 * how to merge a parent option value and a child option
	 * value into the final value.
	 */
	var strats = config.optionMergeStrategies;
	
	/**
	 * Options with restrictions
	 */
	if (false) {
	  strats.el = strats.propsData = function (parent, child, vm, key) {
	    if (!vm) {
	      warn(
	        "option \"" + key + "\" can only be used during instance " +
	        'creation with the `new` keyword.'
	      );
	    }
	    return defaultStrat(parent, child)
	  };
	}
	
	/**
	 * Helper that recursively merges two data objects together.
	 */
	function mergeData (to, from) {
	  if (!from) { return to }
	  var key, toVal, fromVal;
	  var keys = Object.keys(from);
	  for (var i = 0; i < keys.length; i++) {
	    key = keys[i];
	    toVal = to[key];
	    fromVal = from[key];
	    if (!hasOwn(to, key)) {
	      set(to, key, fromVal);
	    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
	      mergeData(toVal, fromVal);
	    }
	  }
	  return to
	}
	
	/**
	 * Data
	 */
	function mergeDataOrFn (
	  parentVal,
	  childVal,
	  vm
	) {
	  if (!vm) {
	    // in a Vue.extend merge, both should be functions
	    if (!childVal) {
	      return parentVal
	    }
	    if (!parentVal) {
	      return childVal
	    }
	    // when parentVal & childVal are both present,
	    // we need to return a function that returns the
	    // merged result of both functions... no need to
	    // check if parentVal is a function here because
	    // it has to be a function to pass previous merges.
	    return function mergedDataFn () {
	      return mergeData(
	        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
	        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
	      )
	    }
	  } else {
	    return function mergedInstanceDataFn () {
	      // instance merge
	      var instanceData = typeof childVal === 'function'
	        ? childVal.call(vm, vm)
	        : childVal;
	      var defaultData = typeof parentVal === 'function'
	        ? parentVal.call(vm, vm)
	        : parentVal;
	      if (instanceData) {
	        return mergeData(instanceData, defaultData)
	      } else {
	        return defaultData
	      }
	    }
	  }
	}
	
	strats.data = function (
	  parentVal,
	  childVal,
	  vm
	) {
	  if (!vm) {
	    if (childVal && typeof childVal !== 'function') {
	      ("production") !== 'production' && warn(
	        'The "data" option should be a function ' +
	        'that returns a per-instance value in component ' +
	        'definitions.',
	        vm
	      );
	
	      return parentVal
	    }
	    return mergeDataOrFn(parentVal, childVal)
	  }
	
	  return mergeDataOrFn(parentVal, childVal, vm)
	};
	
	/**
	 * Hooks and props are merged as arrays.
	 */
	function mergeHook (
	  parentVal,
	  childVal
	) {
	  return childVal
	    ? parentVal
	      ? parentVal.concat(childVal)
	      : Array.isArray(childVal)
	        ? childVal
	        : [childVal]
	    : parentVal
	}
	
	LIFECYCLE_HOOKS.forEach(function (hook) {
	  strats[hook] = mergeHook;
	});
	
	/**
	 * Assets
	 *
	 * When a vm is present (instance creation), we need to do
	 * a three-way merge between constructor options, instance
	 * options and parent options.
	 */
	function mergeAssets (
	  parentVal,
	  childVal,
	  vm,
	  key
	) {
	  var res = Object.create(parentVal || null);
	  if (childVal) {
	    ("production") !== 'production' && assertObjectType(key, childVal, vm);
	    return extend(res, childVal)
	  } else {
	    return res
	  }
	}
	
	ASSET_TYPES.forEach(function (type) {
	  strats[type + 's'] = mergeAssets;
	});
	
	/**
	 * Watchers.
	 *
	 * Watchers hashes should not overwrite one
	 * another, so we merge them as arrays.
	 */
	strats.watch = function (
	  parentVal,
	  childVal,
	  vm,
	  key
	) {
	  // work around Firefox's Object.prototype.watch...
	  if (parentVal === nativeWatch) { parentVal = undefined; }
	  if (childVal === nativeWatch) { childVal = undefined; }
	  /* istanbul ignore if */
	  if (!childVal) { return Object.create(parentVal || null) }
	  if (false) {
	    assertObjectType(key, childVal, vm);
	  }
	  if (!parentVal) { return childVal }
	  var ret = {};
	  extend(ret, parentVal);
	  for (var key$1 in childVal) {
	    var parent = ret[key$1];
	    var child = childVal[key$1];
	    if (parent && !Array.isArray(parent)) {
	      parent = [parent];
	    }
	    ret[key$1] = parent
	      ? parent.concat(child)
	      : Array.isArray(child) ? child : [child];
	  }
	  return ret
	};
	
	/**
	 * Other object hashes.
	 */
	strats.props =
	strats.methods =
	strats.inject =
	strats.computed = function (
	  parentVal,
	  childVal,
	  vm,
	  key
	) {
	  if (childVal && ("production") !== 'production') {
	    assertObjectType(key, childVal, vm);
	  }
	  if (!parentVal) { return childVal }
	  var ret = Object.create(null);
	  extend(ret, parentVal);
	  if (childVal) { extend(ret, childVal); }
	  return ret
	};
	strats.provide = mergeDataOrFn;
	
	/**
	 * Default strategy.
	 */
	var defaultStrat = function (parentVal, childVal) {
	  return childVal === undefined
	    ? parentVal
	    : childVal
	};
	
	/**
	 * Validate component names
	 */
	function checkComponents (options) {
	  for (var key in options.components) {
	    validateComponentName(key);
	  }
	}
	
	function validateComponentName (name) {
	  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
	    warn(
	      'Invalid component name: "' + name + '". Component names ' +
	      'can only contain alphanumeric characters and the hyphen, ' +
	      'and must start with a letter.'
	    );
	  }
	  if (isBuiltInTag(name) || config.isReservedTag(name)) {
	    warn(
	      'Do not use built-in or reserved HTML elements as component ' +
	      'id: ' + name
	    );
	  }
	}
	
	/**
	 * Ensure all props option syntax are normalized into the
	 * Object-based format.
	 */
	function normalizeProps (options, vm) {
	  var props = options.props;
	  if (!props) { return }
	  var res = {};
	  var i, val, name;
	  if (Array.isArray(props)) {
	    i = props.length;
	    while (i--) {
	      val = props[i];
	      if (typeof val === 'string') {
	        name = camelize(val);
	        res[name] = { type: null };
	      } else if (false) {
	        warn('props must be strings when using array syntax.');
	      }
	    }
	  } else if (isPlainObject(props)) {
	    for (var key in props) {
	      val = props[key];
	      name = camelize(key);
	      res[name] = isPlainObject(val)
	        ? val
	        : { type: val };
	    }
	  } else if (false) {
	    warn(
	      "Invalid value for option \"props\": expected an Array or an Object, " +
	      "but got " + (toRawType(props)) + ".",
	      vm
	    );
	  }
	  options.props = res;
	}
	
	/**
	 * Normalize all injections into Object-based format
	 */
	function normalizeInject (options, vm) {
	  var inject = options.inject;
	  if (!inject) { return }
	  var normalized = options.inject = {};
	  if (Array.isArray(inject)) {
	    for (var i = 0; i < inject.length; i++) {
	      normalized[inject[i]] = { from: inject[i] };
	    }
	  } else if (isPlainObject(inject)) {
	    for (var key in inject) {
	      var val = inject[key];
	      normalized[key] = isPlainObject(val)
	        ? extend({ from: key }, val)
	        : { from: val };
	    }
	  } else if (false) {
	    warn(
	      "Invalid value for option \"inject\": expected an Array or an Object, " +
	      "but got " + (toRawType(inject)) + ".",
	      vm
	    );
	  }
	}
	
	/**
	 * Normalize raw function directives into object format.
	 */
	function normalizeDirectives (options) {
	  var dirs = options.directives;
	  if (dirs) {
	    for (var key in dirs) {
	      var def = dirs[key];
	      if (typeof def === 'function') {
	        dirs[key] = { bind: def, update: def };
	      }
	    }
	  }
	}
	
	function assertObjectType (name, value, vm) {
	  if (!isPlainObject(value)) {
	    warn(
	      "Invalid value for option \"" + name + "\": expected an Object, " +
	      "but got " + (toRawType(value)) + ".",
	      vm
	    );
	  }
	}
	
	/**
	 * Merge two option objects into a new one.
	 * Core utility used in both instantiation and inheritance.
	 */
	function mergeOptions (
	  parent,
	  child,
	  vm
	) {
	  if (false) {
	    checkComponents(child);
	  }
	
	  if (typeof child === 'function') {
	    child = child.options;
	  }
	
	  normalizeProps(child, vm);
	  normalizeInject(child, vm);
	  normalizeDirectives(child);
	  var extendsFrom = child.extends;
	  if (extendsFrom) {
	    parent = mergeOptions(parent, extendsFrom, vm);
	  }
	  if (child.mixins) {
	    for (var i = 0, l = child.mixins.length; i < l; i++) {
	      parent = mergeOptions(parent, child.mixins[i], vm);
	    }
	  }
	  var options = {};
	  var key;
	  for (key in parent) {
	    mergeField(key);
	  }
	  for (key in child) {
	    if (!hasOwn(parent, key)) {
	      mergeField(key);
	    }
	  }
	  function mergeField (key) {
	    var strat = strats[key] || defaultStrat;
	    options[key] = strat(parent[key], child[key], vm, key);
	  }
	  return options
	}
	
	/**
	 * Resolve an asset.
	 * This function is used because child instances need access
	 * to assets defined in its ancestor chain.
	 */
	function resolveAsset (
	  options,
	  type,
	  id,
	  warnMissing
	) {
	  /* istanbul ignore if */
	  if (typeof id !== 'string') {
	    return
	  }
	  var assets = options[type];
	  // check local registration variations first
	  if (hasOwn(assets, id)) { return assets[id] }
	  var camelizedId = camelize(id);
	  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
	  var PascalCaseId = capitalize(camelizedId);
	  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
	  // fallback to prototype chain
	  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
	  if (false) {
	    warn(
	      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
	      options
	    );
	  }
	  return res
	}
	
	/*  */
	
	function validateProp (
	  key,
	  propOptions,
	  propsData,
	  vm
	) {
	  var prop = propOptions[key];
	  var absent = !hasOwn(propsData, key);
	  var value = propsData[key];
	  // boolean casting
	  var booleanIndex = getTypeIndex(Boolean, prop.type);
	  if (booleanIndex > -1) {
	    if (absent && !hasOwn(prop, 'default')) {
	      value = false;
	    } else if (value === '' || value === hyphenate(key)) {
	      // only cast empty string / same name to boolean if
	      // boolean has higher priority
	      var stringIndex = getTypeIndex(String, prop.type);
	      if (stringIndex < 0 || booleanIndex < stringIndex) {
	        value = true;
	      }
	    }
	  }
	  // check default value
	  if (value === undefined) {
	    value = getPropDefaultValue(vm, prop, key);
	    // since the default value is a fresh copy,
	    // make sure to observe it.
	    var prevShouldObserve = shouldObserve;
	    toggleObserving(true);
	    observe(value);
	    toggleObserving(prevShouldObserve);
	  }
	  if (
	    false
	  ) {
	    assertProp(prop, key, value, vm, absent);
	  }
	  return value
	}
	
	/**
	 * Get the default value of a prop.
	 */
	function getPropDefaultValue (vm, prop, key) {
	  // no default, return undefined
	  if (!hasOwn(prop, 'default')) {
	    return undefined
	  }
	  var def = prop.default;
	  // warn against non-factory defaults for Object & Array
	  if (false) {
	    warn(
	      'Invalid default value for prop "' + key + '": ' +
	      'Props with type Object/Array must use a factory function ' +
	      'to return the default value.',
	      vm
	    );
	  }
	  // the raw prop value was also undefined from previous render,
	  // return previous default value to avoid unnecessary watcher trigger
	  if (vm && vm.$options.propsData &&
	    vm.$options.propsData[key] === undefined &&
	    vm._props[key] !== undefined
	  ) {
	    return vm._props[key]
	  }
	  // call factory function for non-Function types
	  // a value is Function if its prototype is function even across different execution context
	  return typeof def === 'function' && getType(prop.type) !== 'Function'
	    ? def.call(vm)
	    : def
	}
	
	/**
	 * Assert whether a prop is valid.
	 */
	function assertProp (
	  prop,
	  name,
	  value,
	  vm,
	  absent
	) {
	  if (prop.required && absent) {
	    warn(
	      'Missing required prop: "' + name + '"',
	      vm
	    );
	    return
	  }
	  if (value == null && !prop.required) {
	    return
	  }
	  var type = prop.type;
	  var valid = !type || type === true;
	  var expectedTypes = [];
	  if (type) {
	    if (!Array.isArray(type)) {
	      type = [type];
	    }
	    for (var i = 0; i < type.length && !valid; i++) {
	      var assertedType = assertType(value, type[i]);
	      expectedTypes.push(assertedType.expectedType || '');
	      valid = assertedType.valid;
	    }
	  }
	  if (!valid) {
	    warn(
	      "Invalid prop: type check failed for prop \"" + name + "\"." +
	      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
	      ", got " + (toRawType(value)) + ".",
	      vm
	    );
	    return
	  }
	  var validator = prop.validator;
	  if (validator) {
	    if (!validator(value)) {
	      warn(
	        'Invalid prop: custom validator check failed for prop "' + name + '".',
	        vm
	      );
	    }
	  }
	}
	
	var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;
	
	function assertType (value, type) {
	  var valid;
	  var expectedType = getType(type);
	  if (simpleCheckRE.test(expectedType)) {
	    var t = typeof value;
	    valid = t === expectedType.toLowerCase();
	    // for primitive wrapper objects
	    if (!valid && t === 'object') {
	      valid = value instanceof type;
	    }
	  } else if (expectedType === 'Object') {
	    valid = isPlainObject(value);
	  } else if (expectedType === 'Array') {
	    valid = Array.isArray(value);
	  } else {
	    valid = value instanceof type;
	  }
	  return {
	    valid: valid,
	    expectedType: expectedType
	  }
	}
	
	/**
	 * Use function string name to check built-in types,
	 * because a simple equality check will fail when running
	 * across different vms / iframes.
	 */
	function getType (fn) {
	  var match = fn && fn.toString().match(/^\s*function (\w+)/);
	  return match ? match[1] : ''
	}
	
	function isSameType (a, b) {
	  return getType(a) === getType(b)
	}
	
	function getTypeIndex (type, expectedTypes) {
	  if (!Array.isArray(expectedTypes)) {
	    return isSameType(expectedTypes, type) ? 0 : -1
	  }
	  for (var i = 0, len = expectedTypes.length; i < len; i++) {
	    if (isSameType(expectedTypes[i], type)) {
	      return i
	    }
	  }
	  return -1
	}
	
	/*  */
	
	function handleError (err, vm, info) {
	  if (vm) {
	    var cur = vm;
	    while ((cur = cur.$parent)) {
	      var hooks = cur.$options.errorCaptured;
	      if (hooks) {
	        for (var i = 0; i < hooks.length; i++) {
	          try {
	            var capture = hooks[i].call(cur, err, vm, info) === false;
	            if (capture) { return }
	          } catch (e) {
	            globalHandleError(e, cur, 'errorCaptured hook');
	          }
	        }
	      }
	    }
	  }
	  globalHandleError(err, vm, info);
	}
	
	function globalHandleError (err, vm, info) {
	  if (config.errorHandler) {
	    try {
	      return config.errorHandler.call(null, err, vm, info)
	    } catch (e) {
	      logError(e, null, 'config.errorHandler');
	    }
	  }
	  logError(err, vm, info);
	}
	
	function logError (err, vm, info) {
	  if (false) {
	    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
	  }
	  /* istanbul ignore else */
	  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
	    console.error(err);
	  } else {
	    throw err
	  }
	}
	
	/*  */
	/* globals MessageChannel */
	
	var callbacks = [];
	var pending = false;
	
	function flushCallbacks () {
	  pending = false;
	  var copies = callbacks.slice(0);
	  callbacks.length = 0;
	  for (var i = 0; i < copies.length; i++) {
	    copies[i]();
	  }
	}
	
	// Here we have async deferring wrappers using both microtasks and (macro) tasks.
	// In < 2.4 we used microtasks everywhere, but there are some scenarios where
	// microtasks have too high a priority and fire in between supposedly
	// sequential events (e.g. #4521, #6690) or even between bubbling of the same
	// event (#6566). However, using (macro) tasks everywhere also has subtle problems
	// when state is changed right before repaint (e.g. #6813, out-in transitions).
	// Here we use microtask by default, but expose a way to force (macro) task when
	// needed (e.g. in event handlers attached by v-on).
	var microTimerFunc;
	var macroTimerFunc;
	var useMacroTask = false;
	
	// Determine (macro) task defer implementation.
	// Technically setImmediate should be the ideal choice, but it's only available
	// in IE. The only polyfill that consistently queues the callback after all DOM
	// events triggered in the same loop is by using MessageChannel.
	/* istanbul ignore if */
	if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
	  macroTimerFunc = function () {
	    setImmediate(flushCallbacks);
	  };
	} else if (typeof MessageChannel !== 'undefined' && (
	  isNative(MessageChannel) ||
	  // PhantomJS
	  MessageChannel.toString() === '[object MessageChannelConstructor]'
	)) {
	  var channel = new MessageChannel();
	  var port = channel.port2;
	  channel.port1.onmessage = flushCallbacks;
	  macroTimerFunc = function () {
	    port.postMessage(1);
	  };
	} else {
	  /* istanbul ignore next */
	  macroTimerFunc = function () {
	    setTimeout(flushCallbacks, 0);
	  };
	}
	
	// Determine microtask defer implementation.
	/* istanbul ignore next, $flow-disable-line */
	if (typeof Promise !== 'undefined' && isNative(Promise)) {
	  var p = Promise.resolve();
	  microTimerFunc = function () {
	    p.then(flushCallbacks);
	    // in problematic UIWebViews, Promise.then doesn't completely break, but
	    // it can get stuck in a weird state where callbacks are pushed into the
	    // microtask queue but the queue isn't being flushed, until the browser
	    // needs to do some other work, e.g. handle a timer. Therefore we can
	    // "force" the microtask queue to be flushed by adding an empty timer.
	    if (isIOS) { setTimeout(noop); }
	  };
	} else {
	  // fallback to macro
	  microTimerFunc = macroTimerFunc;
	}
	
	/**
	 * Wrap a function so that if any code inside triggers state change,
	 * the changes are queued using a (macro) task instead of a microtask.
	 */
	function withMacroTask (fn) {
	  return fn._withTask || (fn._withTask = function () {
	    useMacroTask = true;
	    var res = fn.apply(null, arguments);
	    useMacroTask = false;
	    return res
	  })
	}
	
	function nextTick (cb, ctx) {
	  var _resolve;
	  callbacks.push(function () {
	    if (cb) {
	      try {
	        cb.call(ctx);
	      } catch (e) {
	        handleError(e, ctx, 'nextTick');
	      }
	    } else if (_resolve) {
	      _resolve(ctx);
	    }
	  });
	  if (!pending) {
	    pending = true;
	    if (useMacroTask) {
	      macroTimerFunc();
	    } else {
	      microTimerFunc();
	    }
	  }
	  // $flow-disable-line
	  if (!cb && typeof Promise !== 'undefined') {
	    return new Promise(function (resolve) {
	      _resolve = resolve;
	    })
	  }
	}
	
	/*  */
	
	/* not type checking this file because flow doesn't play well with Proxy */
	
	var initProxy;
	
	if (false) {
	  var allowedGlobals = makeMap(
	    'Infinity,undefined,NaN,isFinite,isNaN,' +
	    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
	    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
	    'require' // for Webpack/Browserify
	  );
	
	  var warnNonPresent = function (target, key) {
	    warn(
	      "Property or method \"" + key + "\" is not defined on the instance but " +
	      'referenced during render. Make sure that this property is reactive, ' +
	      'either in the data option, or for class-based components, by ' +
	      'initializing the property. ' +
	      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
	      target
	    );
	  };
	
	  var hasProxy =
	    typeof Proxy !== 'undefined' && isNative(Proxy);
	
	  if (hasProxy) {
	    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
	    config.keyCodes = new Proxy(config.keyCodes, {
	      set: function set (target, key, value) {
	        if (isBuiltInModifier(key)) {
	          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
	          return false
	        } else {
	          target[key] = value;
	          return true
	        }
	      }
	    });
	  }
	
	  var hasHandler = {
	    has: function has (target, key) {
	      var has = key in target;
	      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
	      if (!has && !isAllowed) {
	        warnNonPresent(target, key);
	      }
	      return has || !isAllowed
	    }
	  };
	
	  var getHandler = {
	    get: function get (target, key) {
	      if (typeof key === 'string' && !(key in target)) {
	        warnNonPresent(target, key);
	      }
	      return target[key]
	    }
	  };
	
	  initProxy = function initProxy (vm) {
	    if (hasProxy) {
	      // determine which proxy handler to use
	      var options = vm.$options;
	      var handlers = options.render && options.render._withStripped
	        ? getHandler
	        : hasHandler;
	      vm._renderProxy = new Proxy(vm, handlers);
	    } else {
	      vm._renderProxy = vm;
	    }
	  };
	}
	
	/*  */
	
	var seenObjects = new _Set();
	
	/**
	 * Recursively traverse an object to evoke all converted
	 * getters, so that every nested property inside the object
	 * is collected as a "deep" dependency.
	 */
	function traverse (val) {
	  _traverse(val, seenObjects);
	  seenObjects.clear();
	}
	
	function _traverse (val, seen) {
	  var i, keys;
	  var isA = Array.isArray(val);
	  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
	    return
	  }
	  if (val.__ob__) {
	    var depId = val.__ob__.dep.id;
	    if (seen.has(depId)) {
	      return
	    }
	    seen.add(depId);
	  }
	  if (isA) {
	    i = val.length;
	    while (i--) { _traverse(val[i], seen); }
	  } else {
	    keys = Object.keys(val);
	    i = keys.length;
	    while (i--) { _traverse(val[keys[i]], seen); }
	  }
	}
	
	var mark;
	var measure;
	
	if (false) {
	  var perf = inBrowser && window.performance;
	  /* istanbul ignore if */
	  if (
	    perf &&
	    perf.mark &&
	    perf.measure &&
	    perf.clearMarks &&
	    perf.clearMeasures
	  ) {
	    mark = function (tag) { return perf.mark(tag); };
	    measure = function (name, startTag, endTag) {
	      perf.measure(name, startTag, endTag);
	      perf.clearMarks(startTag);
	      perf.clearMarks(endTag);
	      perf.clearMeasures(name);
	    };
	  }
	}
	
	/*  */
	
	var normalizeEvent = cached(function (name) {
	  var passive = name.charAt(0) === '&';
	  name = passive ? name.slice(1) : name;
	  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
	  name = once$$1 ? name.slice(1) : name;
	  var capture = name.charAt(0) === '!';
	  name = capture ? name.slice(1) : name;
	  return {
	    name: name,
	    once: once$$1,
	    capture: capture,
	    passive: passive
	  }
	});
	
	function createFnInvoker (fns) {
	  function invoker () {
	    var arguments$1 = arguments;
	
	    var fns = invoker.fns;
	    if (Array.isArray(fns)) {
	      var cloned = fns.slice();
	      for (var i = 0; i < cloned.length; i++) {
	        cloned[i].apply(null, arguments$1);
	      }
	    } else {
	      // return handler return value for single handlers
	      return fns.apply(null, arguments)
	    }
	  }
	  invoker.fns = fns;
	  return invoker
	}
	
	function updateListeners (
	  on,
	  oldOn,
	  add,
	  remove$$1,
	  vm
	) {
	  var name, def, cur, old, event;
	  for (name in on) {
	    def = cur = on[name];
	    old = oldOn[name];
	    event = normalizeEvent(name);
	    /* istanbul ignore if */
	    if (isUndef(cur)) {
	      ("production") !== 'production' && warn(
	        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
	        vm
	      );
	    } else if (isUndef(old)) {
	      if (isUndef(cur.fns)) {
	        cur = on[name] = createFnInvoker(cur);
	      }
	      add(event.name, cur, event.once, event.capture, event.passive, event.params);
	    } else if (cur !== old) {
	      old.fns = cur;
	      on[name] = old;
	    }
	  }
	  for (name in oldOn) {
	    if (isUndef(on[name])) {
	      event = normalizeEvent(name);
	      remove$$1(event.name, oldOn[name], event.capture);
	    }
	  }
	}
	
	/*  */
	
	function mergeVNodeHook (def, hookKey, hook) {
	  if (def instanceof VNode) {
	    def = def.data.hook || (def.data.hook = {});
	  }
	  var invoker;
	  var oldHook = def[hookKey];
	
	  function wrappedHook () {
	    hook.apply(this, arguments);
	    // important: remove merged hook to ensure it's called only once
	    // and prevent memory leak
	    remove(invoker.fns, wrappedHook);
	  }
	
	  if (isUndef(oldHook)) {
	    // no existing hook
	    invoker = createFnInvoker([wrappedHook]);
	  } else {
	    /* istanbul ignore if */
	    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
	      // already a merged invoker
	      invoker = oldHook;
	      invoker.fns.push(wrappedHook);
	    } else {
	      // existing plain hook
	      invoker = createFnInvoker([oldHook, wrappedHook]);
	    }
	  }
	
	  invoker.merged = true;
	  def[hookKey] = invoker;
	}
	
	/*  */
	
	function extractPropsFromVNodeData (
	  data,
	  Ctor,
	  tag
	) {
	  // we are only extracting raw values here.
	  // validation and default values are handled in the child
	  // component itself.
	  var propOptions = Ctor.options.props;
	  if (isUndef(propOptions)) {
	    return
	  }
	  var res = {};
	  var attrs = data.attrs;
	  var props = data.props;
	  if (isDef(attrs) || isDef(props)) {
	    for (var key in propOptions) {
	      var altKey = hyphenate(key);
	      if (false) {
	        var keyInLowerCase = key.toLowerCase();
	        if (
	          key !== keyInLowerCase &&
	          attrs && hasOwn(attrs, keyInLowerCase)
	        ) {
	          tip(
	            "Prop \"" + keyInLowerCase + "\" is passed to component " +
	            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
	            " \"" + key + "\". " +
	            "Note that HTML attributes are case-insensitive and camelCased " +
	            "props need to use their kebab-case equivalents when using in-DOM " +
	            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
	          );
	        }
	      }
	      checkProp(res, props, key, altKey, true) ||
	      checkProp(res, attrs, key, altKey, false);
	    }
	  }
	  return res
	}
	
	function checkProp (
	  res,
	  hash,
	  key,
	  altKey,
	  preserve
	) {
	  if (isDef(hash)) {
	    if (hasOwn(hash, key)) {
	      res[key] = hash[key];
	      if (!preserve) {
	        delete hash[key];
	      }
	      return true
	    } else if (hasOwn(hash, altKey)) {
	      res[key] = hash[altKey];
	      if (!preserve) {
	        delete hash[altKey];
	      }
	      return true
	    }
	  }
	  return false
	}
	
	/*  */
	
	// The template compiler attempts to minimize the need for normalization by
	// statically analyzing the template at compile time.
	//
	// For plain HTML markup, normalization can be completely skipped because the
	// generated render function is guaranteed to return Array<VNode>. There are
	// two cases where extra normalization is needed:
	
	// 1. When the children contains components - because a functional component
	// may return an Array instead of a single root. In this case, just a simple
	// normalization is needed - if any child is an Array, we flatten the whole
	// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
	// because functional components already normalize their own children.
	function simpleNormalizeChildren (children) {
	  for (var i = 0; i < children.length; i++) {
	    if (Array.isArray(children[i])) {
	      return Array.prototype.concat.apply([], children)
	    }
	  }
	  return children
	}
	
	// 2. When the children contains constructs that always generated nested Arrays,
	// e.g. <template>, <slot>, v-for, or when the children is provided by user
	// with hand-written render functions / JSX. In such cases a full normalization
	// is needed to cater to all possible types of children values.
	function normalizeChildren (children) {
	  return isPrimitive(children)
	    ? [createTextVNode(children)]
	    : Array.isArray(children)
	      ? normalizeArrayChildren(children)
	      : undefined
	}
	
	function isTextNode (node) {
	  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
	}
	
	function normalizeArrayChildren (children, nestedIndex) {
	  var res = [];
	  var i, c, lastIndex, last;
	  for (i = 0; i < children.length; i++) {
	    c = children[i];
	    if (isUndef(c) || typeof c === 'boolean') { continue }
	    lastIndex = res.length - 1;
	    last = res[lastIndex];
	    //  nested
	    if (Array.isArray(c)) {
	      if (c.length > 0) {
	        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
	        // merge adjacent text nodes
	        if (isTextNode(c[0]) && isTextNode(last)) {
	          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
	          c.shift();
	        }
	        res.push.apply(res, c);
	      }
	    } else if (isPrimitive(c)) {
	      if (isTextNode(last)) {
	        // merge adjacent text nodes
	        // this is necessary for SSR hydration because text nodes are
	        // essentially merged when rendered to HTML strings
	        res[lastIndex] = createTextVNode(last.text + c);
	      } else if (c !== '') {
	        // convert primitive to vnode
	        res.push(createTextVNode(c));
	      }
	    } else {
	      if (isTextNode(c) && isTextNode(last)) {
	        // merge adjacent text nodes
	        res[lastIndex] = createTextVNode(last.text + c.text);
	      } else {
	        // default key for nested array children (likely generated by v-for)
	        if (isTrue(children._isVList) &&
	          isDef(c.tag) &&
	          isUndef(c.key) &&
	          isDef(nestedIndex)) {
	          c.key = "__vlist" + nestedIndex + "_" + i + "__";
	        }
	        res.push(c);
	      }
	    }
	  }
	  return res
	}
	
	/*  */
	
	function ensureCtor (comp, base) {
	  if (
	    comp.__esModule ||
	    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
	  ) {
	    comp = comp.default;
	  }
	  return isObject(comp)
	    ? base.extend(comp)
	    : comp
	}
	
	function createAsyncPlaceholder (
	  factory,
	  data,
	  context,
	  children,
	  tag
	) {
	  var node = createEmptyVNode();
	  node.asyncFactory = factory;
	  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
	  return node
	}
	
	function resolveAsyncComponent (
	  factory,
	  baseCtor,
	  context
	) {
	  if (isTrue(factory.error) && isDef(factory.errorComp)) {
	    return factory.errorComp
	  }
	
	  if (isDef(factory.resolved)) {
	    return factory.resolved
	  }
	
	  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
	    return factory.loadingComp
	  }
	
	  if (isDef(factory.contexts)) {
	    // already pending
	    factory.contexts.push(context);
	  } else {
	    var contexts = factory.contexts = [context];
	    var sync = true;
	
	    var forceRender = function () {
	      for (var i = 0, l = contexts.length; i < l; i++) {
	        contexts[i].$forceUpdate();
	      }
	    };
	
	    var resolve = once(function (res) {
	      // cache resolved
	      factory.resolved = ensureCtor(res, baseCtor);
	      // invoke callbacks only if this is not a synchronous resolve
	      // (async resolves are shimmed as synchronous during SSR)
	      if (!sync) {
	        forceRender();
	      }
	    });
	
	    var reject = once(function (reason) {
	      ("production") !== 'production' && warn(
	        "Failed to resolve async component: " + (String(factory)) +
	        (reason ? ("\nReason: " + reason) : '')
	      );
	      if (isDef(factory.errorComp)) {
	        factory.error = true;
	        forceRender();
	      }
	    });
	
	    var res = factory(resolve, reject);
	
	    if (isObject(res)) {
	      if (typeof res.then === 'function') {
	        // () => Promise
	        if (isUndef(factory.resolved)) {
	          res.then(resolve, reject);
	        }
	      } else if (isDef(res.component) && typeof res.component.then === 'function') {
	        res.component.then(resolve, reject);
	
	        if (isDef(res.error)) {
	          factory.errorComp = ensureCtor(res.error, baseCtor);
	        }
	
	        if (isDef(res.loading)) {
	          factory.loadingComp = ensureCtor(res.loading, baseCtor);
	          if (res.delay === 0) {
	            factory.loading = true;
	          } else {
	            setTimeout(function () {
	              if (isUndef(factory.resolved) && isUndef(factory.error)) {
	                factory.loading = true;
	                forceRender();
	              }
	            }, res.delay || 200);
	          }
	        }
	
	        if (isDef(res.timeout)) {
	          setTimeout(function () {
	            if (isUndef(factory.resolved)) {
	              reject(
	                 false
	                  ? ("timeout (" + (res.timeout) + "ms)")
	                  : null
	              );
	            }
	          }, res.timeout);
	        }
	      }
	    }
	
	    sync = false;
	    // return in case resolved synchronously
	    return factory.loading
	      ? factory.loadingComp
	      : factory.resolved
	  }
	}
	
	/*  */
	
	function isAsyncPlaceholder (node) {
	  return node.isComment && node.asyncFactory
	}
	
	/*  */
	
	function getFirstComponentChild (children) {
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      var c = children[i];
	      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
	        return c
	      }
	    }
	  }
	}
	
	/*  */
	
	/*  */
	
	function initEvents (vm) {
	  vm._events = Object.create(null);
	  vm._hasHookEvent = false;
	  // init parent attached events
	  var listeners = vm.$options._parentListeners;
	  if (listeners) {
	    updateComponentListeners(vm, listeners);
	  }
	}
	
	var target;
	
	function add (event, fn, once) {
	  if (once) {
	    target.$once(event, fn);
	  } else {
	    target.$on(event, fn);
	  }
	}
	
	function remove$1 (event, fn) {
	  target.$off(event, fn);
	}
	
	function updateComponentListeners (
	  vm,
	  listeners,
	  oldListeners
	) {
	  target = vm;
	  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
	  target = undefined;
	}
	
	function eventsMixin (Vue) {
	  var hookRE = /^hook:/;
	  Vue.prototype.$on = function (event, fn) {
	    var this$1 = this;
	
	    var vm = this;
	    if (Array.isArray(event)) {
	      for (var i = 0, l = event.length; i < l; i++) {
	        this$1.$on(event[i], fn);
	      }
	    } else {
	      (vm._events[event] || (vm._events[event] = [])).push(fn);
	      // optimize hook:event cost by using a boolean flag marked at registration
	      // instead of a hash lookup
	      if (hookRE.test(event)) {
	        vm._hasHookEvent = true;
	      }
	    }
	    return vm
	  };
	
	  Vue.prototype.$once = function (event, fn) {
	    var vm = this;
	    function on () {
	      vm.$off(event, on);
	      fn.apply(vm, arguments);
	    }
	    on.fn = fn;
	    vm.$on(event, on);
	    return vm
	  };
	
	  Vue.prototype.$off = function (event, fn) {
	    var this$1 = this;
	
	    var vm = this;
	    // all
	    if (!arguments.length) {
	      vm._events = Object.create(null);
	      return vm
	    }
	    // array of events
	    if (Array.isArray(event)) {
	      for (var i = 0, l = event.length; i < l; i++) {
	        this$1.$off(event[i], fn);
	      }
	      return vm
	    }
	    // specific event
	    var cbs = vm._events[event];
	    if (!cbs) {
	      return vm
	    }
	    if (!fn) {
	      vm._events[event] = null;
	      return vm
	    }
	    if (fn) {
	      // specific handler
	      var cb;
	      var i$1 = cbs.length;
	      while (i$1--) {
	        cb = cbs[i$1];
	        if (cb === fn || cb.fn === fn) {
	          cbs.splice(i$1, 1);
	          break
	        }
	      }
	    }
	    return vm
	  };
	
	  Vue.prototype.$emit = function (event) {
	    var vm = this;
	    if (false) {
	      var lowerCaseEvent = event.toLowerCase();
	      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
	        tip(
	          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
	          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
	          "Note that HTML attributes are case-insensitive and you cannot use " +
	          "v-on to listen to camelCase events when using in-DOM templates. " +
	          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
	        );
	      }
	    }
	    var cbs = vm._events[event];
	    if (cbs) {
	      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
	      var args = toArray(arguments, 1);
	      for (var i = 0, l = cbs.length; i < l; i++) {
	        try {
	          cbs[i].apply(vm, args);
	        } catch (e) {
	          handleError(e, vm, ("event handler for \"" + event + "\""));
	        }
	      }
	    }
	    return vm
	  };
	}
	
	/*  */
	
	
	
	/**
	 * Runtime helper for resolving raw children VNodes into a slot object.
	 */
	function resolveSlots (
	  children,
	  context
	) {
	  var slots = {};
	  if (!children) {
	    return slots
	  }
	  for (var i = 0, l = children.length; i < l; i++) {
	    var child = children[i];
	    var data = child.data;
	    // remove slot attribute if the node is resolved as a Vue slot node
	    if (data && data.attrs && data.attrs.slot) {
	      delete data.attrs.slot;
	    }
	    // named slots should only be respected if the vnode was rendered in the
	    // same context.
	    if ((child.context === context || child.fnContext === context) &&
	      data && data.slot != null
	    ) {
	      var name = data.slot;
	      var slot = (slots[name] || (slots[name] = []));
	      if (child.tag === 'template') {
	        slot.push.apply(slot, child.children || []);
	      } else {
	        slot.push(child);
	      }
	    } else {
	      (slots.default || (slots.default = [])).push(child);
	    }
	  }
	  // ignore slots that contains only whitespace
	  for (var name$1 in slots) {
	    if (slots[name$1].every(isWhitespace)) {
	      delete slots[name$1];
	    }
	  }
	  return slots
	}
	
	function isWhitespace (node) {
	  return (node.isComment && !node.asyncFactory) || node.text === ' '
	}
	
	function resolveScopedSlots (
	  fns, // see flow/vnode
	  res
	) {
	  res = res || {};
	  for (var i = 0; i < fns.length; i++) {
	    if (Array.isArray(fns[i])) {
	      resolveScopedSlots(fns[i], res);
	    } else {
	      res[fns[i].key] = fns[i].fn;
	    }
	  }
	  return res
	}
	
	/*  */
	
	var activeInstance = null;
	var isUpdatingChildComponent = false;
	
	function initLifecycle (vm) {
	  var options = vm.$options;
	
	  // locate first non-abstract parent
	  var parent = options.parent;
	  if (parent && !options.abstract) {
	    while (parent.$options.abstract && parent.$parent) {
	      parent = parent.$parent;
	    }
	    parent.$children.push(vm);
	  }
	
	  vm.$parent = parent;
	  vm.$root = parent ? parent.$root : vm;
	
	  vm.$children = [];
	  vm.$refs = {};
	
	  vm._watcher = null;
	  vm._inactive = null;
	  vm._directInactive = false;
	  vm._isMounted = false;
	  vm._isDestroyed = false;
	  vm._isBeingDestroyed = false;
	}
	
	function lifecycleMixin (Vue) {
	  Vue.prototype._update = function (vnode, hydrating) {
	    var vm = this;
	    if (vm._isMounted) {
	      callHook(vm, 'beforeUpdate');
	    }
	    var prevEl = vm.$el;
	    var prevVnode = vm._vnode;
	    var prevActiveInstance = activeInstance;
	    activeInstance = vm;
	    vm._vnode = vnode;
	    // Vue.prototype.__patch__ is injected in entry points
	    // based on the rendering backend used.
	    if (!prevVnode) {
	      // initial render
	      vm.$el = vm.__patch__(
	        vm.$el, vnode, hydrating, false /* removeOnly */,
	        vm.$options._parentElm,
	        vm.$options._refElm
	      );
	      // no need for the ref nodes after initial patch
	      // this prevents keeping a detached DOM tree in memory (#5851)
	      vm.$options._parentElm = vm.$options._refElm = null;
	    } else {
	      // updates
	      vm.$el = vm.__patch__(prevVnode, vnode);
	    }
	    activeInstance = prevActiveInstance;
	    // update __vue__ reference
	    if (prevEl) {
	      prevEl.__vue__ = null;
	    }
	    if (vm.$el) {
	      vm.$el.__vue__ = vm;
	    }
	    // if parent is an HOC, update its $el as well
	    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
	      vm.$parent.$el = vm.$el;
	    }
	    // updated hook is called by the scheduler to ensure that children are
	    // updated in a parent's updated hook.
	  };
	
	  Vue.prototype.$forceUpdate = function () {
	    var vm = this;
	    if (vm._watcher) {
	      vm._watcher.update();
	    }
	  };
	
	  Vue.prototype.$destroy = function () {
	    var vm = this;
	    if (vm._isBeingDestroyed) {
	      return
	    }
	    callHook(vm, 'beforeDestroy');
	    vm._isBeingDestroyed = true;
	    // remove self from parent
	    var parent = vm.$parent;
	    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
	      remove(parent.$children, vm);
	    }
	    // teardown watchers
	    if (vm._watcher) {
	      vm._watcher.teardown();
	    }
	    var i = vm._watchers.length;
	    while (i--) {
	      vm._watchers[i].teardown();
	    }
	    // remove reference from data ob
	    // frozen object may not have observer.
	    if (vm._data.__ob__) {
	      vm._data.__ob__.vmCount--;
	    }
	    // call the last hook...
	    vm._isDestroyed = true;
	    // invoke destroy hooks on current rendered tree
	    vm.__patch__(vm._vnode, null);
	    // fire destroyed hook
	    callHook(vm, 'destroyed');
	    // turn off all instance listeners.
	    vm.$off();
	    // remove __vue__ reference
	    if (vm.$el) {
	      vm.$el.__vue__ = null;
	    }
	    // release circular reference (#6759)
	    if (vm.$vnode) {
	      vm.$vnode.parent = null;
	    }
	  };
	}
	
	function mountComponent (
	  vm,
	  el,
	  hydrating
	) {
	  vm.$el = el;
	  if (!vm.$options.render) {
	    vm.$options.render = createEmptyVNode;
	    if (false) {
	      /* istanbul ignore if */
	      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
	        vm.$options.el || el) {
	        warn(
	          'You are using the runtime-only build of Vue where the template ' +
	          'compiler is not available. Either pre-compile the templates into ' +
	          'render functions, or use the compiler-included build.',
	          vm
	        );
	      } else {
	        warn(
	          'Failed to mount component: template or render function not defined.',
	          vm
	        );
	      }
	    }
	  }
	  callHook(vm, 'beforeMount');
	
	  var updateComponent;
	  /* istanbul ignore if */
	  if (false) {
	    updateComponent = function () {
	      var name = vm._name;
	      var id = vm._uid;
	      var startTag = "vue-perf-start:" + id;
	      var endTag = "vue-perf-end:" + id;
	
	      mark(startTag);
	      var vnode = vm._render();
	      mark(endTag);
	      measure(("vue " + name + " render"), startTag, endTag);
	
	      mark(startTag);
	      vm._update(vnode, hydrating);
	      mark(endTag);
	      measure(("vue " + name + " patch"), startTag, endTag);
	    };
	  } else {
	    updateComponent = function () {
	      vm._update(vm._render(), hydrating);
	    };
	  }
	
	  // we set this to vm._watcher inside the watcher's constructor
	  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
	  // component's mounted hook), which relies on vm._watcher being already defined
	  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
	  hydrating = false;
	
	  // manually mounted instance, call mounted on self
	  // mounted is called for render-created child components in its inserted hook
	  if (vm.$vnode == null) {
	    vm._isMounted = true;
	    callHook(vm, 'mounted');
	  }
	  return vm
	}
	
	function updateChildComponent (
	  vm,
	  propsData,
	  listeners,
	  parentVnode,
	  renderChildren
	) {
	  if (false) {
	    isUpdatingChildComponent = true;
	  }
	
	  // determine whether component has slot children
	  // we need to do this before overwriting $options._renderChildren
	  var hasChildren = !!(
	    renderChildren ||               // has new static slots
	    vm.$options._renderChildren ||  // has old static slots
	    parentVnode.data.scopedSlots || // has new scoped slots
	    vm.$scopedSlots !== emptyObject // has old scoped slots
	  );
	
	  vm.$options._parentVnode = parentVnode;
	  vm.$vnode = parentVnode; // update vm's placeholder node without re-render
	
	  if (vm._vnode) { // update child tree's parent
	    vm._vnode.parent = parentVnode;
	  }
	  vm.$options._renderChildren = renderChildren;
	
	  // update $attrs and $listeners hash
	  // these are also reactive so they may trigger child update if the child
	  // used them during render
	  vm.$attrs = parentVnode.data.attrs || emptyObject;
	  vm.$listeners = listeners || emptyObject;
	
	  // update props
	  if (propsData && vm.$options.props) {
	    toggleObserving(false);
	    var props = vm._props;
	    var propKeys = vm.$options._propKeys || [];
	    for (var i = 0; i < propKeys.length; i++) {
	      var key = propKeys[i];
	      var propOptions = vm.$options.props; // wtf flow?
	      props[key] = validateProp(key, propOptions, propsData, vm);
	    }
	    toggleObserving(true);
	    // keep a copy of raw propsData
	    vm.$options.propsData = propsData;
	  }
	
	  // update listeners
	  listeners = listeners || emptyObject;
	  var oldListeners = vm.$options._parentListeners;
	  vm.$options._parentListeners = listeners;
	  updateComponentListeners(vm, listeners, oldListeners);
	
	  // resolve slots + force update if has children
	  if (hasChildren) {
	    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
	    vm.$forceUpdate();
	  }
	
	  if (false) {
	    isUpdatingChildComponent = false;
	  }
	}
	
	function isInInactiveTree (vm) {
	  while (vm && (vm = vm.$parent)) {
	    if (vm._inactive) { return true }
	  }
	  return false
	}
	
	function activateChildComponent (vm, direct) {
	  if (direct) {
	    vm._directInactive = false;
	    if (isInInactiveTree(vm)) {
	      return
	    }
	  } else if (vm._directInactive) {
	    return
	  }
	  if (vm._inactive || vm._inactive === null) {
	    vm._inactive = false;
	    for (var i = 0; i < vm.$children.length; i++) {
	      activateChildComponent(vm.$children[i]);
	    }
	    callHook(vm, 'activated');
	  }
	}
	
	function deactivateChildComponent (vm, direct) {
	  if (direct) {
	    vm._directInactive = true;
	    if (isInInactiveTree(vm)) {
	      return
	    }
	  }
	  if (!vm._inactive) {
	    vm._inactive = true;
	    for (var i = 0; i < vm.$children.length; i++) {
	      deactivateChildComponent(vm.$children[i]);
	    }
	    callHook(vm, 'deactivated');
	  }
	}
	
	function callHook (vm, hook) {
	  // #7573 disable dep collection when invoking lifecycle hooks
	  pushTarget();
	  var handlers = vm.$options[hook];
	  if (handlers) {
	    for (var i = 0, j = handlers.length; i < j; i++) {
	      try {
	        handlers[i].call(vm);
	      } catch (e) {
	        handleError(e, vm, (hook + " hook"));
	      }
	    }
	  }
	  if (vm._hasHookEvent) {
	    vm.$emit('hook:' + hook);
	  }
	  popTarget();
	}
	
	/*  */
	
	
	var MAX_UPDATE_COUNT = 100;
	
	var queue = [];
	var activatedChildren = [];
	var has = {};
	var circular = {};
	var waiting = false;
	var flushing = false;
	var index = 0;
	
	/**
	 * Reset the scheduler's state.
	 */
	function resetSchedulerState () {
	  index = queue.length = activatedChildren.length = 0;
	  has = {};
	  if (false) {
	    circular = {};
	  }
	  waiting = flushing = false;
	}
	
	/**
	 * Flush both queues and run the watchers.
	 */
	function flushSchedulerQueue () {
	  flushing = true;
	  var watcher, id;
	
	  // Sort queue before flush.
	  // This ensures that:
	  // 1. Components are updated from parent to child. (because parent is always
	  //    created before the child)
	  // 2. A component's user watchers are run before its render watcher (because
	  //    user watchers are created before the render watcher)
	  // 3. If a component is destroyed during a parent component's watcher run,
	  //    its watchers can be skipped.
	  queue.sort(function (a, b) { return a.id - b.id; });
	
	  // do not cache length because more watchers might be pushed
	  // as we run existing watchers
	  for (index = 0; index < queue.length; index++) {
	    watcher = queue[index];
	    id = watcher.id;
	    has[id] = null;
	    watcher.run();
	    // in dev build, check and stop circular updates.
	    if (false) {
	      circular[id] = (circular[id] || 0) + 1;
	      if (circular[id] > MAX_UPDATE_COUNT) {
	        warn(
	          'You may have an infinite update loop ' + (
	            watcher.user
	              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
	              : "in a component render function."
	          ),
	          watcher.vm
	        );
	        break
	      }
	    }
	  }
	
	  // keep copies of post queues before resetting state
	  var activatedQueue = activatedChildren.slice();
	  var updatedQueue = queue.slice();
	
	  resetSchedulerState();
	
	  // call component updated and activated hooks
	  callActivatedHooks(activatedQueue);
	  callUpdatedHooks(updatedQueue);
	
	  // devtool hook
	  /* istanbul ignore if */
	  if (devtools && config.devtools) {
	    devtools.emit('flush');
	  }
	}
	
	function callUpdatedHooks (queue) {
	  var i = queue.length;
	  while (i--) {
	    var watcher = queue[i];
	    var vm = watcher.vm;
	    if (vm._watcher === watcher && vm._isMounted) {
	      callHook(vm, 'updated');
	    }
	  }
	}
	
	/**
	 * Queue a kept-alive component that was activated during patch.
	 * The queue will be processed after the entire tree has been patched.
	 */
	function queueActivatedComponent (vm) {
	  // setting _inactive to false here so that a render function can
	  // rely on checking whether it's in an inactive tree (e.g. router-view)
	  vm._inactive = false;
	  activatedChildren.push(vm);
	}
	
	function callActivatedHooks (queue) {
	  for (var i = 0; i < queue.length; i++) {
	    queue[i]._inactive = true;
	    activateChildComponent(queue[i], true /* true */);
	  }
	}
	
	/**
	 * Push a watcher into the watcher queue.
	 * Jobs with duplicate IDs will be skipped unless it's
	 * pushed when the queue is being flushed.
	 */
	function queueWatcher (watcher) {
	  var id = watcher.id;
	  if (has[id] == null) {
	    has[id] = true;
	    if (!flushing) {
	      queue.push(watcher);
	    } else {
	      // if already flushing, splice the watcher based on its id
	      // if already past its id, it will be run next immediately.
	      var i = queue.length - 1;
	      while (i > index && queue[i].id > watcher.id) {
	        i--;
	      }
	      queue.splice(i + 1, 0, watcher);
	    }
	    // queue the flush
	    if (!waiting) {
	      waiting = true;
	      nextTick(flushSchedulerQueue);
	    }
	  }
	}
	
	/*  */
	
	var uid$1 = 0;
	
	/**
	 * A watcher parses an expression, collects dependencies,
	 * and fires callback when the expression value changes.
	 * This is used for both the $watch() api and directives.
	 */
	var Watcher = function Watcher (
	  vm,
	  expOrFn,
	  cb,
	  options,
	  isRenderWatcher
	) {
	  this.vm = vm;
	  if (isRenderWatcher) {
	    vm._watcher = this;
	  }
	  vm._watchers.push(this);
	  // options
	  if (options) {
	    this.deep = !!options.deep;
	    this.user = !!options.user;
	    this.lazy = !!options.lazy;
	    this.sync = !!options.sync;
	  } else {
	    this.deep = this.user = this.lazy = this.sync = false;
	  }
	  this.cb = cb;
	  this.id = ++uid$1; // uid for batching
	  this.active = true;
	  this.dirty = this.lazy; // for lazy watchers
	  this.deps = [];
	  this.newDeps = [];
	  this.depIds = new _Set();
	  this.newDepIds = new _Set();
	  this.expression =  false
	    ? expOrFn.toString()
	    : '';
	  // parse expression for getter
	  if (typeof expOrFn === 'function') {
	    this.getter = expOrFn;
	  } else {
	    this.getter = parsePath(expOrFn);
	    if (!this.getter) {
	      this.getter = function () {};
	      ("production") !== 'production' && warn(
	        "Failed watching path: \"" + expOrFn + "\" " +
	        'Watcher only accepts simple dot-delimited paths. ' +
	        'For full control, use a function instead.',
	        vm
	      );
	    }
	  }
	  this.value = this.lazy
	    ? undefined
	    : this.get();
	};
	
	/**
	 * Evaluate the getter, and re-collect dependencies.
	 */
	Watcher.prototype.get = function get () {
	  pushTarget(this);
	  var value;
	  var vm = this.vm;
	  try {
	    value = this.getter.call(vm, vm);
	  } catch (e) {
	    if (this.user) {
	      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
	    } else {
	      throw e
	    }
	  } finally {
	    // "touch" every property so they are all tracked as
	    // dependencies for deep watching
	    if (this.deep) {
	      traverse(value);
	    }
	    popTarget();
	    this.cleanupDeps();
	  }
	  return value
	};
	
	/**
	 * Add a dependency to this directive.
	 */
	Watcher.prototype.addDep = function addDep (dep) {
	  var id = dep.id;
	  if (!this.newDepIds.has(id)) {
	    this.newDepIds.add(id);
	    this.newDeps.push(dep);
	    if (!this.depIds.has(id)) {
	      dep.addSub(this);
	    }
	  }
	};
	
	/**
	 * Clean up for dependency collection.
	 */
	Watcher.prototype.cleanupDeps = function cleanupDeps () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    var dep = this$1.deps[i];
	    if (!this$1.newDepIds.has(dep.id)) {
	      dep.removeSub(this$1);
	    }
	  }
	  var tmp = this.depIds;
	  this.depIds = this.newDepIds;
	  this.newDepIds = tmp;
	  this.newDepIds.clear();
	  tmp = this.deps;
	  this.deps = this.newDeps;
	  this.newDeps = tmp;
	  this.newDeps.length = 0;
	};
	
	/**
	 * Subscriber interface.
	 * Will be called when a dependency changes.
	 */
	Watcher.prototype.update = function update () {
	  /* istanbul ignore else */
	  if (this.lazy) {
	    this.dirty = true;
	  } else if (this.sync) {
	    this.run();
	  } else {
	    queueWatcher(this);
	  }
	};
	
	/**
	 * Scheduler job interface.
	 * Will be called by the scheduler.
	 */
	Watcher.prototype.run = function run () {
	  if (this.active) {
	    var value = this.get();
	    if (
	      value !== this.value ||
	      // Deep watchers and watchers on Object/Arrays should fire even
	      // when the value is the same, because the value may
	      // have mutated.
	      isObject(value) ||
	      this.deep
	    ) {
	      // set new value
	      var oldValue = this.value;
	      this.value = value;
	      if (this.user) {
	        try {
	          this.cb.call(this.vm, value, oldValue);
	        } catch (e) {
	          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
	        }
	      } else {
	        this.cb.call(this.vm, value, oldValue);
	      }
	    }
	  }
	};
	
	/**
	 * Evaluate the value of the watcher.
	 * This only gets called for lazy watchers.
	 */
	Watcher.prototype.evaluate = function evaluate () {
	  this.value = this.get();
	  this.dirty = false;
	};
	
	/**
	 * Depend on all deps collected by this watcher.
	 */
	Watcher.prototype.depend = function depend () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    this$1.deps[i].depend();
	  }
	};
	
	/**
	 * Remove self from all dependencies' subscriber list.
	 */
	Watcher.prototype.teardown = function teardown () {
	    var this$1 = this;
	
	  if (this.active) {
	    // remove self from vm's watcher list
	    // this is a somewhat expensive operation so we skip it
	    // if the vm is being destroyed.
	    if (!this.vm._isBeingDestroyed) {
	      remove(this.vm._watchers, this);
	    }
	    var i = this.deps.length;
	    while (i--) {
	      this$1.deps[i].removeSub(this$1);
	    }
	    this.active = false;
	  }
	};
	
	/*  */
	
	var sharedPropertyDefinition = {
	  enumerable: true,
	  configurable: true,
	  get: noop,
	  set: noop
	};
	
	function proxy (target, sourceKey, key) {
	  sharedPropertyDefinition.get = function proxyGetter () {
	    return this[sourceKey][key]
	  };
	  sharedPropertyDefinition.set = function proxySetter (val) {
	    this[sourceKey][key] = val;
	  };
	  Object.defineProperty(target, key, sharedPropertyDefinition);
	}
	
	function initState (vm) {
	  vm._watchers = [];
	  var opts = vm.$options;
	  if (opts.props) { initProps(vm, opts.props); }
	  if (opts.methods) { initMethods(vm, opts.methods); }
	  if (opts.data) {
	    initData(vm);
	  } else {
	    observe(vm._data = {}, true /* asRootData */);
	  }
	  if (opts.computed) { initComputed(vm, opts.computed); }
	  if (opts.watch && opts.watch !== nativeWatch) {
	    initWatch(vm, opts.watch);
	  }
	}
	
	function initProps (vm, propsOptions) {
	  var propsData = vm.$options.propsData || {};
	  var props = vm._props = {};
	  // cache prop keys so that future props updates can iterate using Array
	  // instead of dynamic object key enumeration.
	  var keys = vm.$options._propKeys = [];
	  var isRoot = !vm.$parent;
	  // root instance props should be converted
	  if (!isRoot) {
	    toggleObserving(false);
	  }
	  var loop = function ( key ) {
	    keys.push(key);
	    var value = validateProp(key, propsOptions, propsData, vm);
	    /* istanbul ignore else */
	    if (false) {
	      var hyphenatedKey = hyphenate(key);
	      if (isReservedAttribute(hyphenatedKey) ||
	          config.isReservedAttr(hyphenatedKey)) {
	        warn(
	          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
	          vm
	        );
	      }
	      defineReactive(props, key, value, function () {
	        if (vm.$parent && !isUpdatingChildComponent) {
	          warn(
	            "Avoid mutating a prop directly since the value will be " +
	            "overwritten whenever the parent component re-renders. " +
	            "Instead, use a data or computed property based on the prop's " +
	            "value. Prop being mutated: \"" + key + "\"",
	            vm
	          );
	        }
	      });
	    } else {
	      defineReactive(props, key, value);
	    }
	    // static props are already proxied on the component's prototype
	    // during Vue.extend(). We only need to proxy props defined at
	    // instantiation here.
	    if (!(key in vm)) {
	      proxy(vm, "_props", key);
	    }
	  };
	
	  for (var key in propsOptions) loop( key );
	  toggleObserving(true);
	}
	
	function initData (vm) {
	  var data = vm.$options.data;
	  data = vm._data = typeof data === 'function'
	    ? getData(data, vm)
	    : data || {};
	  if (!isPlainObject(data)) {
	    data = {};
	    ("production") !== 'production' && warn(
	      'data functions should return an object:\n' +
	      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
	      vm
	    );
	  }
	  // proxy data on instance
	  var keys = Object.keys(data);
	  var props = vm.$options.props;
	  var methods = vm.$options.methods;
	  var i = keys.length;
	  while (i--) {
	    var key = keys[i];
	    if (false) {
	      if (methods && hasOwn(methods, key)) {
	        warn(
	          ("Method \"" + key + "\" has already been defined as a data property."),
	          vm
	        );
	      }
	    }
	    if (props && hasOwn(props, key)) {
	      ("production") !== 'production' && warn(
	        "The data property \"" + key + "\" is already declared as a prop. " +
	        "Use prop default value instead.",
	        vm
	      );
	    } else if (!isReserved(key)) {
	      proxy(vm, "_data", key);
	    }
	  }
	  // observe data
	  observe(data, true /* asRootData */);
	}
	
	function getData (data, vm) {
	  // #7573 disable dep collection when invoking data getters
	  pushTarget();
	  try {
	    return data.call(vm, vm)
	  } catch (e) {
	    handleError(e, vm, "data()");
	    return {}
	  } finally {
	    popTarget();
	  }
	}
	
	var computedWatcherOptions = { lazy: true };
	
	function initComputed (vm, computed) {
	  // $flow-disable-line
	  var watchers = vm._computedWatchers = Object.create(null);
	  // computed properties are just getters during SSR
	  var isSSR = isServerRendering();
	
	  for (var key in computed) {
	    var userDef = computed[key];
	    var getter = typeof userDef === 'function' ? userDef : userDef.get;
	    if (false) {
	      warn(
	        ("Getter is missing for computed property \"" + key + "\"."),
	        vm
	      );
	    }
	
	    if (!isSSR) {
	      // create internal watcher for the computed property.
	      watchers[key] = new Watcher(
	        vm,
	        getter || noop,
	        noop,
	        computedWatcherOptions
	      );
	    }
	
	    // component-defined computed properties are already defined on the
	    // component prototype. We only need to define computed properties defined
	    // at instantiation here.
	    if (!(key in vm)) {
	      defineComputed(vm, key, userDef);
	    } else if (false) {
	      if (key in vm.$data) {
	        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
	      } else if (vm.$options.props && key in vm.$options.props) {
	        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
	      }
	    }
	  }
	}
	
	function defineComputed (
	  target,
	  key,
	  userDef
	) {
	  var shouldCache = !isServerRendering();
	  if (typeof userDef === 'function') {
	    sharedPropertyDefinition.get = shouldCache
	      ? createComputedGetter(key)
	      : userDef;
	    sharedPropertyDefinition.set = noop;
	  } else {
	    sharedPropertyDefinition.get = userDef.get
	      ? shouldCache && userDef.cache !== false
	        ? createComputedGetter(key)
	        : userDef.get
	      : noop;
	    sharedPropertyDefinition.set = userDef.set
	      ? userDef.set
	      : noop;
	  }
	  if (false) {
	    sharedPropertyDefinition.set = function () {
	      warn(
	        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
	        this
	      );
	    };
	  }
	  Object.defineProperty(target, key, sharedPropertyDefinition);
	}
	
	function createComputedGetter (key) {
	  return function computedGetter () {
	    var watcher = this._computedWatchers && this._computedWatchers[key];
	    if (watcher) {
	      if (watcher.dirty) {
	        watcher.evaluate();
	      }
	      if (Dep.target) {
	        watcher.depend();
	      }
	      return watcher.value
	    }
	  }
	}
	
	function initMethods (vm, methods) {
	  var props = vm.$options.props;
	  for (var key in methods) {
	    if (false) {
	      if (methods[key] == null) {
	        warn(
	          "Method \"" + key + "\" has an undefined value in the component definition. " +
	          "Did you reference the function correctly?",
	          vm
	        );
	      }
	      if (props && hasOwn(props, key)) {
	        warn(
	          ("Method \"" + key + "\" has already been defined as a prop."),
	          vm
	        );
	      }
	      if ((key in vm) && isReserved(key)) {
	        warn(
	          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
	          "Avoid defining component methods that start with _ or $."
	        );
	      }
	    }
	    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
	  }
	}
	
	function initWatch (vm, watch) {
	  for (var key in watch) {
	    var handler = watch[key];
	    if (Array.isArray(handler)) {
	      for (var i = 0; i < handler.length; i++) {
	        createWatcher(vm, key, handler[i]);
	      }
	    } else {
	      createWatcher(vm, key, handler);
	    }
	  }
	}
	
	function createWatcher (
	  vm,
	  expOrFn,
	  handler,
	  options
	) {
	  if (isPlainObject(handler)) {
	    options = handler;
	    handler = handler.handler;
	  }
	  if (typeof handler === 'string') {
	    handler = vm[handler];
	  }
	  return vm.$watch(expOrFn, handler, options)
	}
	
	function stateMixin (Vue) {
	  // flow somehow has problems with directly declared definition object
	  // when using Object.defineProperty, so we have to procedurally build up
	  // the object here.
	  var dataDef = {};
	  dataDef.get = function () { return this._data };
	  var propsDef = {};
	  propsDef.get = function () { return this._props };
	  if (false) {
	    dataDef.set = function (newData) {
	      warn(
	        'Avoid replacing instance root $data. ' +
	        'Use nested data properties instead.',
	        this
	      );
	    };
	    propsDef.set = function () {
	      warn("$props is readonly.", this);
	    };
	  }
	  Object.defineProperty(Vue.prototype, '$data', dataDef);
	  Object.defineProperty(Vue.prototype, '$props', propsDef);
	
	  Vue.prototype.$set = set;
	  Vue.prototype.$delete = del;
	
	  Vue.prototype.$watch = function (
	    expOrFn,
	    cb,
	    options
	  ) {
	    var vm = this;
	    if (isPlainObject(cb)) {
	      return createWatcher(vm, expOrFn, cb, options)
	    }
	    options = options || {};
	    options.user = true;
	    var watcher = new Watcher(vm, expOrFn, cb, options);
	    if (options.immediate) {
	      cb.call(vm, watcher.value);
	    }
	    return function unwatchFn () {
	      watcher.teardown();
	    }
	  };
	}
	
	/*  */
	
	function initProvide (vm) {
	  var provide = vm.$options.provide;
	  if (provide) {
	    vm._provided = typeof provide === 'function'
	      ? provide.call(vm)
	      : provide;
	  }
	}
	
	function initInjections (vm) {
	  var result = resolveInject(vm.$options.inject, vm);
	  if (result) {
	    toggleObserving(false);
	    Object.keys(result).forEach(function (key) {
	      /* istanbul ignore else */
	      if (false) {
	        defineReactive(vm, key, result[key], function () {
	          warn(
	            "Avoid mutating an injected value directly since the changes will be " +
	            "overwritten whenever the provided component re-renders. " +
	            "injection being mutated: \"" + key + "\"",
	            vm
	          );
	        });
	      } else {
	        defineReactive(vm, key, result[key]);
	      }
	    });
	    toggleObserving(true);
	  }
	}
	
	function resolveInject (inject, vm) {
	  if (inject) {
	    // inject is :any because flow is not smart enough to figure out cached
	    var result = Object.create(null);
	    var keys = hasSymbol
	      ? Reflect.ownKeys(inject).filter(function (key) {
	        /* istanbul ignore next */
	        return Object.getOwnPropertyDescriptor(inject, key).enumerable
	      })
	      : Object.keys(inject);
	
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	      var provideKey = inject[key].from;
	      var source = vm;
	      while (source) {
	        if (source._provided && hasOwn(source._provided, provideKey)) {
	          result[key] = source._provided[provideKey];
	          break
	        }
	        source = source.$parent;
	      }
	      if (!source) {
	        if ('default' in inject[key]) {
	          var provideDefault = inject[key].default;
	          result[key] = typeof provideDefault === 'function'
	            ? provideDefault.call(vm)
	            : provideDefault;
	        } else if (false) {
	          warn(("Injection \"" + key + "\" not found"), vm);
	        }
	      }
	    }
	    return result
	  }
	}
	
	/*  */
	
	/**
	 * Runtime helper for rendering v-for lists.
	 */
	function renderList (
	  val,
	  render
	) {
	  var ret, i, l, keys, key;
	  if (Array.isArray(val) || typeof val === 'string') {
	    ret = new Array(val.length);
	    for (i = 0, l = val.length; i < l; i++) {
	      ret[i] = render(val[i], i);
	    }
	  } else if (typeof val === 'number') {
	    ret = new Array(val);
	    for (i = 0; i < val; i++) {
	      ret[i] = render(i + 1, i);
	    }
	  } else if (isObject(val)) {
	    keys = Object.keys(val);
	    ret = new Array(keys.length);
	    for (i = 0, l = keys.length; i < l; i++) {
	      key = keys[i];
	      ret[i] = render(val[key], key, i);
	    }
	  }
	  if (isDef(ret)) {
	    (ret)._isVList = true;
	  }
	  return ret
	}
	
	/*  */
	
	/**
	 * Runtime helper for rendering <slot>
	 */
	function renderSlot (
	  name,
	  fallback,
	  props,
	  bindObject
	) {
	  var scopedSlotFn = this.$scopedSlots[name];
	  var nodes;
	  if (scopedSlotFn) { // scoped slot
	    props = props || {};
	    if (bindObject) {
	      if (false) {
	        warn(
	          'slot v-bind without argument expects an Object',
	          this
	        );
	      }
	      props = extend(extend({}, bindObject), props);
	    }
	    nodes = scopedSlotFn(props) || fallback;
	  } else {
	    var slotNodes = this.$slots[name];
	    // warn duplicate slot usage
	    if (slotNodes) {
	      if (false) {
	        warn(
	          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
	          "- this will likely cause render errors.",
	          this
	        );
	      }
	      slotNodes._rendered = true;
	    }
	    nodes = slotNodes || fallback;
	  }
	
	  var target = props && props.slot;
	  if (target) {
	    return this.$createElement('template', { slot: target }, nodes)
	  } else {
	    return nodes
	  }
	}
	
	/*  */
	
	/**
	 * Runtime helper for resolving filters
	 */
	function resolveFilter (id) {
	  return resolveAsset(this.$options, 'filters', id, true) || identity
	}
	
	/*  */
	
	function isKeyNotMatch (expect, actual) {
	  if (Array.isArray(expect)) {
	    return expect.indexOf(actual) === -1
	  } else {
	    return expect !== actual
	  }
	}
	
	/**
	 * Runtime helper for checking keyCodes from config.
	 * exposed as Vue.prototype._k
	 * passing in eventKeyName as last argument separately for backwards compat
	 */
	function checkKeyCodes (
	  eventKeyCode,
	  key,
	  builtInKeyCode,
	  eventKeyName,
	  builtInKeyName
	) {
	  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
	  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
	    return isKeyNotMatch(builtInKeyName, eventKeyName)
	  } else if (mappedKeyCode) {
	    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
	  } else if (eventKeyName) {
	    return hyphenate(eventKeyName) !== key
	  }
	}
	
	/*  */
	
	/**
	 * Runtime helper for merging v-bind="object" into a VNode's data.
	 */
	function bindObjectProps (
	  data,
	  tag,
	  value,
	  asProp,
	  isSync
	) {
	  if (value) {
	    if (!isObject(value)) {
	      ("production") !== 'production' && warn(
	        'v-bind without argument expects an Object or Array value',
	        this
	      );
	    } else {
	      if (Array.isArray(value)) {
	        value = toObject(value);
	      }
	      var hash;
	      var loop = function ( key ) {
	        if (
	          key === 'class' ||
	          key === 'style' ||
	          isReservedAttribute(key)
	        ) {
	          hash = data;
	        } else {
	          var type = data.attrs && data.attrs.type;
	          hash = asProp || config.mustUseProp(tag, type, key)
	            ? data.domProps || (data.domProps = {})
	            : data.attrs || (data.attrs = {});
	        }
	        if (!(key in hash)) {
	          hash[key] = value[key];
	
	          if (isSync) {
	            var on = data.on || (data.on = {});
	            on[("update:" + key)] = function ($event) {
	              value[key] = $event;
	            };
	          }
	        }
	      };
	
	      for (var key in value) loop( key );
	    }
	  }
	  return data
	}
	
	/*  */
	
	/**
	 * Runtime helper for rendering static trees.
	 */
	function renderStatic (
	  index,
	  isInFor
	) {
	  var cached = this._staticTrees || (this._staticTrees = []);
	  var tree = cached[index];
	  // if has already-rendered static tree and not inside v-for,
	  // we can reuse the same tree.
	  if (tree && !isInFor) {
	    return tree
	  }
	  // otherwise, render a fresh tree.
	  tree = cached[index] = this.$options.staticRenderFns[index].call(
	    this._renderProxy,
	    null,
	    this // for render fns generated for functional component templates
	  );
	  markStatic(tree, ("__static__" + index), false);
	  return tree
	}
	
	/**
	 * Runtime helper for v-once.
	 * Effectively it means marking the node as static with a unique key.
	 */
	function markOnce (
	  tree,
	  index,
	  key
	) {
	  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
	  return tree
	}
	
	function markStatic (
	  tree,
	  key,
	  isOnce
	) {
	  if (Array.isArray(tree)) {
	    for (var i = 0; i < tree.length; i++) {
	      if (tree[i] && typeof tree[i] !== 'string') {
	        markStaticNode(tree[i], (key + "_" + i), isOnce);
	      }
	    }
	  } else {
	    markStaticNode(tree, key, isOnce);
	  }
	}
	
	function markStaticNode (node, key, isOnce) {
	  node.isStatic = true;
	  node.key = key;
	  node.isOnce = isOnce;
	}
	
	/*  */
	
	function bindObjectListeners (data, value) {
	  if (value) {
	    if (!isPlainObject(value)) {
	      ("production") !== 'production' && warn(
	        'v-on without argument expects an Object value',
	        this
	      );
	    } else {
	      var on = data.on = data.on ? extend({}, data.on) : {};
	      for (var key in value) {
	        var existing = on[key];
	        var ours = value[key];
	        on[key] = existing ? [].concat(existing, ours) : ours;
	      }
	    }
	  }
	  return data
	}
	
	/*  */
	
	function installRenderHelpers (target) {
	  target._o = markOnce;
	  target._n = toNumber;
	  target._s = toString;
	  target._l = renderList;
	  target._t = renderSlot;
	  target._q = looseEqual;
	  target._i = looseIndexOf;
	  target._m = renderStatic;
	  target._f = resolveFilter;
	  target._k = checkKeyCodes;
	  target._b = bindObjectProps;
	  target._v = createTextVNode;
	  target._e = createEmptyVNode;
	  target._u = resolveScopedSlots;
	  target._g = bindObjectListeners;
	}
	
	/*  */
	
	function FunctionalRenderContext (
	  data,
	  props,
	  children,
	  parent,
	  Ctor
	) {
	  var options = Ctor.options;
	  // ensure the createElement function in functional components
	  // gets a unique context - this is necessary for correct named slot check
	  var contextVm;
	  if (hasOwn(parent, '_uid')) {
	    contextVm = Object.create(parent);
	    // $flow-disable-line
	    contextVm._original = parent;
	  } else {
	    // the context vm passed in is a functional context as well.
	    // in this case we want to make sure we are able to get a hold to the
	    // real context instance.
	    contextVm = parent;
	    // $flow-disable-line
	    parent = parent._original;
	  }
	  var isCompiled = isTrue(options._compiled);
	  var needNormalization = !isCompiled;
	
	  this.data = data;
	  this.props = props;
	  this.children = children;
	  this.parent = parent;
	  this.listeners = data.on || emptyObject;
	  this.injections = resolveInject(options.inject, parent);
	  this.slots = function () { return resolveSlots(children, parent); };
	
	  // support for compiled functional template
	  if (isCompiled) {
	    // exposing $options for renderStatic()
	    this.$options = options;
	    // pre-resolve slots for renderSlot()
	    this.$slots = this.slots();
	    this.$scopedSlots = data.scopedSlots || emptyObject;
	  }
	
	  if (options._scopeId) {
	    this._c = function (a, b, c, d) {
	      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
	      if (vnode && !Array.isArray(vnode)) {
	        vnode.fnScopeId = options._scopeId;
	        vnode.fnContext = parent;
	      }
	      return vnode
	    };
	  } else {
	    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
	  }
	}
	
	installRenderHelpers(FunctionalRenderContext.prototype);
	
	function createFunctionalComponent (
	  Ctor,
	  propsData,
	  data,
	  contextVm,
	  children
	) {
	  var options = Ctor.options;
	  var props = {};
	  var propOptions = options.props;
	  if (isDef(propOptions)) {
	    for (var key in propOptions) {
	      props[key] = validateProp(key, propOptions, propsData || emptyObject);
	    }
	  } else {
	    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
	    if (isDef(data.props)) { mergeProps(props, data.props); }
	  }
	
	  var renderContext = new FunctionalRenderContext(
	    data,
	    props,
	    children,
	    contextVm,
	    Ctor
	  );
	
	  var vnode = options.render.call(null, renderContext._c, renderContext);
	
	  if (vnode instanceof VNode) {
	    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
	  } else if (Array.isArray(vnode)) {
	    var vnodes = normalizeChildren(vnode) || [];
	    var res = new Array(vnodes.length);
	    for (var i = 0; i < vnodes.length; i++) {
	      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
	    }
	    return res
	  }
	}
	
	function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
	  // #7817 clone node before setting fnContext, otherwise if the node is reused
	  // (e.g. it was from a cached normal slot) the fnContext causes named slots
	  // that should not be matched to match.
	  var clone = cloneVNode(vnode);
	  clone.fnContext = contextVm;
	  clone.fnOptions = options;
	  if (data.slot) {
	    (clone.data || (clone.data = {})).slot = data.slot;
	  }
	  return clone
	}
	
	function mergeProps (to, from) {
	  for (var key in from) {
	    to[camelize(key)] = from[key];
	  }
	}
	
	/*  */
	
	
	
	
	// Register the component hook to weex native render engine.
	// The hook will be triggered by native, not javascript.
	
	
	// Updates the state of the component to weex native render engine.
	
	/*  */
	
	// https://github.com/Hanks10100/weex-native-directive/tree/master/component
	
	// listening on native callback
	
	/*  */
	
	/*  */
	
	// inline hooks to be invoked on component VNodes during patch
	var componentVNodeHooks = {
	  init: function init (
	    vnode,
	    hydrating,
	    parentElm,
	    refElm
	  ) {
	    if (
	      vnode.componentInstance &&
	      !vnode.componentInstance._isDestroyed &&
	      vnode.data.keepAlive
	    ) {
	      // kept-alive components, treat as a patch
	      var mountedNode = vnode; // work around flow
	      componentVNodeHooks.prepatch(mountedNode, mountedNode);
	    } else {
	      var child = vnode.componentInstance = createComponentInstanceForVnode(
	        vnode,
	        activeInstance,
	        parentElm,
	        refElm
	      );
	      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
	    }
	  },
	
	  prepatch: function prepatch (oldVnode, vnode) {
	    var options = vnode.componentOptions;
	    var child = vnode.componentInstance = oldVnode.componentInstance;
	    updateChildComponent(
	      child,
	      options.propsData, // updated props
	      options.listeners, // updated listeners
	      vnode, // new parent vnode
	      options.children // new children
	    );
	  },
	
	  insert: function insert (vnode) {
	    var context = vnode.context;
	    var componentInstance = vnode.componentInstance;
	    if (!componentInstance._isMounted) {
	      componentInstance._isMounted = true;
	      callHook(componentInstance, 'mounted');
	    }
	    if (vnode.data.keepAlive) {
	      if (context._isMounted) {
	        // vue-router#1212
	        // During updates, a kept-alive component's child components may
	        // change, so directly walking the tree here may call activated hooks
	        // on incorrect children. Instead we push them into a queue which will
	        // be processed after the whole patch process ended.
	        queueActivatedComponent(componentInstance);
	      } else {
	        activateChildComponent(componentInstance, true /* direct */);
	      }
	    }
	  },
	
	  destroy: function destroy (vnode) {
	    var componentInstance = vnode.componentInstance;
	    if (!componentInstance._isDestroyed) {
	      if (!vnode.data.keepAlive) {
	        componentInstance.$destroy();
	      } else {
	        deactivateChildComponent(componentInstance, true /* direct */);
	      }
	    }
	  }
	};
	
	var hooksToMerge = Object.keys(componentVNodeHooks);
	
	function createComponent (
	  Ctor,
	  data,
	  context,
	  children,
	  tag
	) {
	  if (isUndef(Ctor)) {
	    return
	  }
	
	  var baseCtor = context.$options._base;
	
	  // plain options object: turn it into a constructor
	  if (isObject(Ctor)) {
	    Ctor = baseCtor.extend(Ctor);
	  }
	
	  // if at this stage it's not a constructor or an async component factory,
	  // reject.
	  if (typeof Ctor !== 'function') {
	    if (false) {
	      warn(("Invalid Component definition: " + (String(Ctor))), context);
	    }
	    return
	  }
	
	  // async component
	  var asyncFactory;
	  if (isUndef(Ctor.cid)) {
	    asyncFactory = Ctor;
	    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
	    if (Ctor === undefined) {
	      // return a placeholder node for async component, which is rendered
	      // as a comment node but preserves all the raw information for the node.
	      // the information will be used for async server-rendering and hydration.
	      return createAsyncPlaceholder(
	        asyncFactory,
	        data,
	        context,
	        children,
	        tag
	      )
	    }
	  }
	
	  data = data || {};
	
	  // resolve constructor options in case global mixins are applied after
	  // component constructor creation
	  resolveConstructorOptions(Ctor);
	
	  // transform component v-model data into props & events
	  if (isDef(data.model)) {
	    transformModel(Ctor.options, data);
	  }
	
	  // extract props
	  var propsData = extractPropsFromVNodeData(data, Ctor, tag);
	
	  // functional component
	  if (isTrue(Ctor.options.functional)) {
	    return createFunctionalComponent(Ctor, propsData, data, context, children)
	  }
	
	  // extract listeners, since these needs to be treated as
	  // child component listeners instead of DOM listeners
	  var listeners = data.on;
	  // replace with listeners with .native modifier
	  // so it gets processed during parent component patch.
	  data.on = data.nativeOn;
	
	  if (isTrue(Ctor.options.abstract)) {
	    // abstract components do not keep anything
	    // other than props & listeners & slot
	
	    // work around flow
	    var slot = data.slot;
	    data = {};
	    if (slot) {
	      data.slot = slot;
	    }
	  }
	
	  // install component management hooks onto the placeholder node
	  installComponentHooks(data);
	
	  // return a placeholder vnode
	  var name = Ctor.options.name || tag;
	  var vnode = new VNode(
	    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
	    data, undefined, undefined, undefined, context,
	    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
	    asyncFactory
	  );
	
	  // Weex specific: invoke recycle-list optimized @render function for
	  // extracting cell-slot template.
	  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
	  /* istanbul ignore if */
	  return vnode
	}
	
	function createComponentInstanceForVnode (
	  vnode, // we know it's MountedComponentVNode but flow doesn't
	  parent, // activeInstance in lifecycle state
	  parentElm,
	  refElm
	) {
	  var options = {
	    _isComponent: true,
	    parent: parent,
	    _parentVnode: vnode,
	    _parentElm: parentElm || null,
	    _refElm: refElm || null
	  };
	  // check inline-template render functions
	  var inlineTemplate = vnode.data.inlineTemplate;
	  if (isDef(inlineTemplate)) {
	    options.render = inlineTemplate.render;
	    options.staticRenderFns = inlineTemplate.staticRenderFns;
	  }
	  return new vnode.componentOptions.Ctor(options)
	}
	
	function installComponentHooks (data) {
	  var hooks = data.hook || (data.hook = {});
	  for (var i = 0; i < hooksToMerge.length; i++) {
	    var key = hooksToMerge[i];
	    hooks[key] = componentVNodeHooks[key];
	  }
	}
	
	// transform component v-model info (value and callback) into
	// prop and event handler respectively.
	function transformModel (options, data) {
	  var prop = (options.model && options.model.prop) || 'value';
	  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
	  var on = data.on || (data.on = {});
	  if (isDef(on[event])) {
	    on[event] = [data.model.callback].concat(on[event]);
	  } else {
	    on[event] = data.model.callback;
	  }
	}
	
	/*  */
	
	var SIMPLE_NORMALIZE = 1;
	var ALWAYS_NORMALIZE = 2;
	
	// wrapper function for providing a more flexible interface
	// without getting yelled at by flow
	function createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType,
	  alwaysNormalize
	) {
	  if (Array.isArray(data) || isPrimitive(data)) {
	    normalizationType = children;
	    children = data;
	    data = undefined;
	  }
	  if (isTrue(alwaysNormalize)) {
	    normalizationType = ALWAYS_NORMALIZE;
	  }
	  return _createElement(context, tag, data, children, normalizationType)
	}
	
	function _createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType
	) {
	  if (isDef(data) && isDef((data).__ob__)) {
	    ("production") !== 'production' && warn(
	      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
	      'Always create fresh vnode data objects in each render!',
	      context
	    );
	    return createEmptyVNode()
	  }
	  // object syntax in v-bind
	  if (isDef(data) && isDef(data.is)) {
	    tag = data.is;
	  }
	  if (!tag) {
	    // in case of component :is set to falsy value
	    return createEmptyVNode()
	  }
	  // warn against non-primitive key
	  if (false
	  ) {
	    {
	      warn(
	        'Avoid using non-primitive value as key, ' +
	        'use string/number value instead.',
	        context
	      );
	    }
	  }
	  // support single function children as default scoped slot
	  if (Array.isArray(children) &&
	    typeof children[0] === 'function'
	  ) {
	    data = data || {};
	    data.scopedSlots = { default: children[0] };
	    children.length = 0;
	  }
	  if (normalizationType === ALWAYS_NORMALIZE) {
	    children = normalizeChildren(children);
	  } else if (normalizationType === SIMPLE_NORMALIZE) {
	    children = simpleNormalizeChildren(children);
	  }
	  var vnode, ns;
	  if (typeof tag === 'string') {
	    var Ctor;
	    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
	    if (config.isReservedTag(tag)) {
	      // platform built-in elements
	      vnode = new VNode(
	        config.parsePlatformTagName(tag), data, children,
	        undefined, undefined, context
	      );
	    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
	      // component
	      vnode = createComponent(Ctor, data, context, children, tag);
	    } else {
	      // unknown or unlisted namespaced elements
	      // check at runtime because it may get assigned a namespace when its
	      // parent normalizes children
	      vnode = new VNode(
	        tag, data, children,
	        undefined, undefined, context
	      );
	    }
	  } else {
	    // direct component options / constructor
	    vnode = createComponent(tag, data, context, children);
	  }
	  if (Array.isArray(vnode)) {
	    return vnode
	  } else if (isDef(vnode)) {
	    if (isDef(ns)) { applyNS(vnode, ns); }
	    if (isDef(data)) { registerDeepBindings(data); }
	    return vnode
	  } else {
	    return createEmptyVNode()
	  }
	}
	
	function applyNS (vnode, ns, force) {
	  vnode.ns = ns;
	  if (vnode.tag === 'foreignObject') {
	    // use default namespace inside foreignObject
	    ns = undefined;
	    force = true;
	  }
	  if (isDef(vnode.children)) {
	    for (var i = 0, l = vnode.children.length; i < l; i++) {
	      var child = vnode.children[i];
	      if (isDef(child.tag) && (
	        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
	        applyNS(child, ns, force);
	      }
	    }
	  }
	}
	
	// ref #5318
	// necessary to ensure parent re-render when deep bindings like :style and
	// :class are used on slot nodes
	function registerDeepBindings (data) {
	  if (isObject(data.style)) {
	    traverse(data.style);
	  }
	  if (isObject(data.class)) {
	    traverse(data.class);
	  }
	}
	
	/*  */
	
	function initRender (vm) {
	  vm._vnode = null; // the root of the child tree
	  vm._staticTrees = null; // v-once cached trees
	  var options = vm.$options;
	  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
	  var renderContext = parentVnode && parentVnode.context;
	  vm.$slots = resolveSlots(options._renderChildren, renderContext);
	  vm.$scopedSlots = emptyObject;
	  // bind the createElement fn to this instance
	  // so that we get proper render context inside it.
	  // args order: tag, data, children, normalizationType, alwaysNormalize
	  // internal version is used by render functions compiled from templates
	  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
	  // normalization is always applied for the public version, used in
	  // user-written render functions.
	  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };
	
	  // $attrs & $listeners are exposed for easier HOC creation.
	  // they need to be reactive so that HOCs using them are always updated
	  var parentData = parentVnode && parentVnode.data;
	
	  /* istanbul ignore else */
	  if (false) {
	    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
	      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
	    }, true);
	    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
	      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
	    }, true);
	  } else {
	    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
	    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
	  }
	}
	
	function renderMixin (Vue) {
	  // install runtime convenience helpers
	  installRenderHelpers(Vue.prototype);
	
	  Vue.prototype.$nextTick = function (fn) {
	    return nextTick(fn, this)
	  };
	
	  Vue.prototype._render = function () {
	    var vm = this;
	    var ref = vm.$options;
	    var render = ref.render;
	    var _parentVnode = ref._parentVnode;
	
	    // reset _rendered flag on slots for duplicate slot check
	    if (false) {
	      for (var key in vm.$slots) {
	        // $flow-disable-line
	        vm.$slots[key]._rendered = false;
	      }
	    }
	
	    if (_parentVnode) {
	      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
	    }
	
	    // set parent vnode. this allows render functions to have access
	    // to the data on the placeholder node.
	    vm.$vnode = _parentVnode;
	    // render self
	    var vnode;
	    try {
	      vnode = render.call(vm._renderProxy, vm.$createElement);
	    } catch (e) {
	      handleError(e, vm, "render");
	      // return error render result,
	      // or previous vnode to prevent render error causing blank component
	      /* istanbul ignore else */
	      if (false) {
	        if (vm.$options.renderError) {
	          try {
	            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
	          } catch (e) {
	            handleError(e, vm, "renderError");
	            vnode = vm._vnode;
	          }
	        } else {
	          vnode = vm._vnode;
	        }
	      } else {
	        vnode = vm._vnode;
	      }
	    }
	    // return empty vnode in case the render function errored out
	    if (!(vnode instanceof VNode)) {
	      if (false) {
	        warn(
	          'Multiple root nodes returned from render function. Render function ' +
	          'should return a single root node.',
	          vm
	        );
	      }
	      vnode = createEmptyVNode();
	    }
	    // set parent
	    vnode.parent = _parentVnode;
	    return vnode
	  };
	}
	
	/*  */
	
	var uid$3 = 0;
	
	function initMixin (Vue) {
	  Vue.prototype._init = function (options) {
	    var vm = this;
	    // a uid
	    vm._uid = uid$3++;
	
	    var startTag, endTag;
	    /* istanbul ignore if */
	    if (false) {
	      startTag = "vue-perf-start:" + (vm._uid);
	      endTag = "vue-perf-end:" + (vm._uid);
	      mark(startTag);
	    }
	
	    // a flag to avoid this being observed
	    vm._isVue = true;
	    // merge options
	    if (options && options._isComponent) {
	      // optimize internal component instantiation
	      // since dynamic options merging is pretty slow, and none of the
	      // internal component options needs special treatment.
	      initInternalComponent(vm, options);
	    } else {
	      vm.$options = mergeOptions(
	        resolveConstructorOptions(vm.constructor),
	        options || {},
	        vm
	      );
	    }
	    /* istanbul ignore else */
	    if (false) {
	      initProxy(vm);
	    } else {
	      vm._renderProxy = vm;
	    }
	    // expose real self
	    vm._self = vm;
	    initLifecycle(vm);
	    initEvents(vm);
	    initRender(vm);
	    callHook(vm, 'beforeCreate');
	    initInjections(vm); // resolve injections before data/props
	    initState(vm);
	    initProvide(vm); // resolve provide after data/props
	    callHook(vm, 'created');
	
	    /* istanbul ignore if */
	    if (false) {
	      vm._name = formatComponentName(vm, false);
	      mark(endTag);
	      measure(("vue " + (vm._name) + " init"), startTag, endTag);
	    }
	
	    if (vm.$options.el) {
	      vm.$mount(vm.$options.el);
	    }
	  };
	}
	
	function initInternalComponent (vm, options) {
	  var opts = vm.$options = Object.create(vm.constructor.options);
	  // doing this because it's faster than dynamic enumeration.
	  var parentVnode = options._parentVnode;
	  opts.parent = options.parent;
	  opts._parentVnode = parentVnode;
	  opts._parentElm = options._parentElm;
	  opts._refElm = options._refElm;
	
	  var vnodeComponentOptions = parentVnode.componentOptions;
	  opts.propsData = vnodeComponentOptions.propsData;
	  opts._parentListeners = vnodeComponentOptions.listeners;
	  opts._renderChildren = vnodeComponentOptions.children;
	  opts._componentTag = vnodeComponentOptions.tag;
	
	  if (options.render) {
	    opts.render = options.render;
	    opts.staticRenderFns = options.staticRenderFns;
	  }
	}
	
	function resolveConstructorOptions (Ctor) {
	  var options = Ctor.options;
	  if (Ctor.super) {
	    var superOptions = resolveConstructorOptions(Ctor.super);
	    var cachedSuperOptions = Ctor.superOptions;
	    if (superOptions !== cachedSuperOptions) {
	      // super option changed,
	      // need to resolve new options.
	      Ctor.superOptions = superOptions;
	      // check if there are any late-modified/attached options (#4976)
	      var modifiedOptions = resolveModifiedOptions(Ctor);
	      // update base extend options
	      if (modifiedOptions) {
	        extend(Ctor.extendOptions, modifiedOptions);
	      }
	      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
	      if (options.name) {
	        options.components[options.name] = Ctor;
	      }
	    }
	  }
	  return options
	}
	
	function resolveModifiedOptions (Ctor) {
	  var modified;
	  var latest = Ctor.options;
	  var extended = Ctor.extendOptions;
	  var sealed = Ctor.sealedOptions;
	  for (var key in latest) {
	    if (latest[key] !== sealed[key]) {
	      if (!modified) { modified = {}; }
	      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
	    }
	  }
	  return modified
	}
	
	function dedupe (latest, extended, sealed) {
	  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
	  // between merges
	  if (Array.isArray(latest)) {
	    var res = [];
	    sealed = Array.isArray(sealed) ? sealed : [sealed];
	    extended = Array.isArray(extended) ? extended : [extended];
	    for (var i = 0; i < latest.length; i++) {
	      // push original options and not sealed options to exclude duplicated options
	      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
	        res.push(latest[i]);
	      }
	    }
	    return res
	  } else {
	    return latest
	  }
	}
	
	function Vue (options) {
	  if (false
	  ) {
	    warn('Vue is a constructor and should be called with the `new` keyword');
	  }
	  this._init(options);
	}
	
	initMixin(Vue);
	stateMixin(Vue);
	eventsMixin(Vue);
	lifecycleMixin(Vue);
	renderMixin(Vue);
	
	/*  */
	
	function initUse (Vue) {
	  Vue.use = function (plugin) {
	    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
	    if (installedPlugins.indexOf(plugin) > -1) {
	      return this
	    }
	
	    // additional parameters
	    var args = toArray(arguments, 1);
	    args.unshift(this);
	    if (typeof plugin.install === 'function') {
	      plugin.install.apply(plugin, args);
	    } else if (typeof plugin === 'function') {
	      plugin.apply(null, args);
	    }
	    installedPlugins.push(plugin);
	    return this
	  };
	}
	
	/*  */
	
	function initMixin$1 (Vue) {
	  Vue.mixin = function (mixin) {
	    this.options = mergeOptions(this.options, mixin);
	    return this
	  };
	}
	
	/*  */
	
	function initExtend (Vue) {
	  /**
	   * Each instance constructor, including Vue, has a unique
	   * cid. This enables us to create wrapped "child
	   * constructors" for prototypal inheritance and cache them.
	   */
	  Vue.cid = 0;
	  var cid = 1;
	
	  /**
	   * Class inheritance
	   */
	  Vue.extend = function (extendOptions) {
	    extendOptions = extendOptions || {};
	    var Super = this;
	    var SuperId = Super.cid;
	    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
	    if (cachedCtors[SuperId]) {
	      return cachedCtors[SuperId]
	    }
	
	    var name = extendOptions.name || Super.options.name;
	    if (false) {
	      validateComponentName(name);
	    }
	
	    var Sub = function VueComponent (options) {
	      this._init(options);
	    };
	    Sub.prototype = Object.create(Super.prototype);
	    Sub.prototype.constructor = Sub;
	    Sub.cid = cid++;
	    Sub.options = mergeOptions(
	      Super.options,
	      extendOptions
	    );
	    Sub['super'] = Super;
	
	    // For props and computed properties, we define the proxy getters on
	    // the Vue instances at extension time, on the extended prototype. This
	    // avoids Object.defineProperty calls for each instance created.
	    if (Sub.options.props) {
	      initProps$1(Sub);
	    }
	    if (Sub.options.computed) {
	      initComputed$1(Sub);
	    }
	
	    // allow further extension/mixin/plugin usage
	    Sub.extend = Super.extend;
	    Sub.mixin = Super.mixin;
	    Sub.use = Super.use;
	
	    // create asset registers, so extended classes
	    // can have their private assets too.
	    ASSET_TYPES.forEach(function (type) {
	      Sub[type] = Super[type];
	    });
	    // enable recursive self-lookup
	    if (name) {
	      Sub.options.components[name] = Sub;
	    }
	
	    // keep a reference to the super options at extension time.
	    // later at instantiation we can check if Super's options have
	    // been updated.
	    Sub.superOptions = Super.options;
	    Sub.extendOptions = extendOptions;
	    Sub.sealedOptions = extend({}, Sub.options);
	
	    // cache constructor
	    cachedCtors[SuperId] = Sub;
	    return Sub
	  };
	}
	
	function initProps$1 (Comp) {
	  var props = Comp.options.props;
	  for (var key in props) {
	    proxy(Comp.prototype, "_props", key);
	  }
	}
	
	function initComputed$1 (Comp) {
	  var computed = Comp.options.computed;
	  for (var key in computed) {
	    defineComputed(Comp.prototype, key, computed[key]);
	  }
	}
	
	/*  */
	
	function initAssetRegisters (Vue) {
	  /**
	   * Create asset registration methods.
	   */
	  ASSET_TYPES.forEach(function (type) {
	    Vue[type] = function (
	      id,
	      definition
	    ) {
	      if (!definition) {
	        return this.options[type + 's'][id]
	      } else {
	        /* istanbul ignore if */
	        if (false) {
	          validateComponentName(id);
	        }
	        if (type === 'component' && isPlainObject(definition)) {
	          definition.name = definition.name || id;
	          definition = this.options._base.extend(definition);
	        }
	        if (type === 'directive' && typeof definition === 'function') {
	          definition = { bind: definition, update: definition };
	        }
	        this.options[type + 's'][id] = definition;
	        return definition
	      }
	    };
	  });
	}
	
	/*  */
	
	function getComponentName (opts) {
	  return opts && (opts.Ctor.options.name || opts.tag)
	}
	
	function matches (pattern, name) {
	  if (Array.isArray(pattern)) {
	    return pattern.indexOf(name) > -1
	  } else if (typeof pattern === 'string') {
	    return pattern.split(',').indexOf(name) > -1
	  } else if (isRegExp(pattern)) {
	    return pattern.test(name)
	  }
	  /* istanbul ignore next */
	  return false
	}
	
	function pruneCache (keepAliveInstance, filter) {
	  var cache = keepAliveInstance.cache;
	  var keys = keepAliveInstance.keys;
	  var _vnode = keepAliveInstance._vnode;
	  for (var key in cache) {
	    var cachedNode = cache[key];
	    if (cachedNode) {
	      var name = getComponentName(cachedNode.componentOptions);
	      if (name && !filter(name)) {
	        pruneCacheEntry(cache, key, keys, _vnode);
	      }
	    }
	  }
	}
	
	function pruneCacheEntry (
	  cache,
	  key,
	  keys,
	  current
	) {
	  var cached$$1 = cache[key];
	  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
	    cached$$1.componentInstance.$destroy();
	  }
	  cache[key] = null;
	  remove(keys, key);
	}
	
	var patternTypes = [String, RegExp, Array];
	
	var KeepAlive = {
	  name: 'keep-alive',
	  abstract: true,
	
	  props: {
	    include: patternTypes,
	    exclude: patternTypes,
	    max: [String, Number]
	  },
	
	  created: function created () {
	    this.cache = Object.create(null);
	    this.keys = [];
	  },
	
	  destroyed: function destroyed () {
	    var this$1 = this;
	
	    for (var key in this$1.cache) {
	      pruneCacheEntry(this$1.cache, key, this$1.keys);
	    }
	  },
	
	  mounted: function mounted () {
	    var this$1 = this;
	
	    this.$watch('include', function (val) {
	      pruneCache(this$1, function (name) { return matches(val, name); });
	    });
	    this.$watch('exclude', function (val) {
	      pruneCache(this$1, function (name) { return !matches(val, name); });
	    });
	  },
	
	  render: function render () {
	    var slot = this.$slots.default;
	    var vnode = getFirstComponentChild(slot);
	    var componentOptions = vnode && vnode.componentOptions;
	    if (componentOptions) {
	      // check pattern
	      var name = getComponentName(componentOptions);
	      var ref = this;
	      var include = ref.include;
	      var exclude = ref.exclude;
	      if (
	        // not included
	        (include && (!name || !matches(include, name))) ||
	        // excluded
	        (exclude && name && matches(exclude, name))
	      ) {
	        return vnode
	      }
	
	      var ref$1 = this;
	      var cache = ref$1.cache;
	      var keys = ref$1.keys;
	      var key = vnode.key == null
	        // same constructor may get registered as different local components
	        // so cid alone is not enough (#3269)
	        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
	        : vnode.key;
	      if (cache[key]) {
	        vnode.componentInstance = cache[key].componentInstance;
	        // make current key freshest
	        remove(keys, key);
	        keys.push(key);
	      } else {
	        cache[key] = vnode;
	        keys.push(key);
	        // prune oldest entry
	        if (this.max && keys.length > parseInt(this.max)) {
	          pruneCacheEntry(cache, keys[0], keys, this._vnode);
	        }
	      }
	
	      vnode.data.keepAlive = true;
	    }
	    return vnode || (slot && slot[0])
	  }
	}
	
	var builtInComponents = {
	  KeepAlive: KeepAlive
	}
	
	/*  */
	
	function initGlobalAPI (Vue) {
	  // config
	  var configDef = {};
	  configDef.get = function () { return config; };
	  if (false) {
	    configDef.set = function () {
	      warn(
	        'Do not replace the Vue.config object, set individual fields instead.'
	      );
	    };
	  }
	  Object.defineProperty(Vue, 'config', configDef);
	
	  // exposed util methods.
	  // NOTE: these are not considered part of the public API - avoid relying on
	  // them unless you are aware of the risk.
	  Vue.util = {
	    warn: warn,
	    extend: extend,
	    mergeOptions: mergeOptions,
	    defineReactive: defineReactive
	  };
	
	  Vue.set = set;
	  Vue.delete = del;
	  Vue.nextTick = nextTick;
	
	  Vue.options = Object.create(null);
	  ASSET_TYPES.forEach(function (type) {
	    Vue.options[type + 's'] = Object.create(null);
	  });
	
	  // this is used to identify the "base" constructor to extend all plain-object
	  // components with in Weex's multi-instance scenarios.
	  Vue.options._base = Vue;
	
	  extend(Vue.options.components, builtInComponents);
	
	  initUse(Vue);
	  initMixin$1(Vue);
	  initExtend(Vue);
	  initAssetRegisters(Vue);
	}
	
	initGlobalAPI(Vue);
	
	Object.defineProperty(Vue.prototype, '$isServer', {
	  get: isServerRendering
	});
	
	Object.defineProperty(Vue.prototype, '$ssrContext', {
	  get: function get () {
	    /* istanbul ignore next */
	    return this.$vnode && this.$vnode.ssrContext
	  }
	});
	
	// expose FunctionalRenderContext for ssr runtime helper installation
	Object.defineProperty(Vue, 'FunctionalRenderContext', {
	  value: FunctionalRenderContext
	});
	
	Vue.version = '2.5.17';
	
	/*  */
	
	// these are reserved for web because they are directly compiled away
	// during template compilation
	var isReservedAttr = makeMap('style,class');
	
	// attributes that should be using props for binding
	var acceptValue = makeMap('input,textarea,option,select,progress');
	var mustUseProp = function (tag, type, attr) {
	  return (
	    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
	    (attr === 'selected' && tag === 'option') ||
	    (attr === 'checked' && tag === 'input') ||
	    (attr === 'muted' && tag === 'video')
	  )
	};
	
	var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
	
	var isBooleanAttr = makeMap(
	  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
	  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
	  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
	  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
	  'required,reversed,scoped,seamless,selected,sortable,translate,' +
	  'truespeed,typemustmatch,visible'
	);
	
	var xlinkNS = 'http://www.w3.org/1999/xlink';
	
	var isXlink = function (name) {
	  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
	};
	
	var getXlinkProp = function (name) {
	  return isXlink(name) ? name.slice(6, name.length) : ''
	};
	
	var isFalsyAttrValue = function (val) {
	  return val == null || val === false
	};
	
	/*  */
	
	function genClassForVnode (vnode) {
	  var data = vnode.data;
	  var parentNode = vnode;
	  var childNode = vnode;
	  while (isDef(childNode.componentInstance)) {
	    childNode = childNode.componentInstance._vnode;
	    if (childNode && childNode.data) {
	      data = mergeClassData(childNode.data, data);
	    }
	  }
	  while (isDef(parentNode = parentNode.parent)) {
	    if (parentNode && parentNode.data) {
	      data = mergeClassData(data, parentNode.data);
	    }
	  }
	  return renderClass(data.staticClass, data.class)
	}
	
	function mergeClassData (child, parent) {
	  return {
	    staticClass: concat(child.staticClass, parent.staticClass),
	    class: isDef(child.class)
	      ? [child.class, parent.class]
	      : parent.class
	  }
	}
	
	function renderClass (
	  staticClass,
	  dynamicClass
	) {
	  if (isDef(staticClass) || isDef(dynamicClass)) {
	    return concat(staticClass, stringifyClass(dynamicClass))
	  }
	  /* istanbul ignore next */
	  return ''
	}
	
	function concat (a, b) {
	  return a ? b ? (a + ' ' + b) : a : (b || '')
	}
	
	function stringifyClass (value) {
	  if (Array.isArray(value)) {
	    return stringifyArray(value)
	  }
	  if (isObject(value)) {
	    return stringifyObject(value)
	  }
	  if (typeof value === 'string') {
	    return value
	  }
	  /* istanbul ignore next */
	  return ''
	}
	
	function stringifyArray (value) {
	  var res = '';
	  var stringified;
	  for (var i = 0, l = value.length; i < l; i++) {
	    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
	      if (res) { res += ' '; }
	      res += stringified;
	    }
	  }
	  return res
	}
	
	function stringifyObject (value) {
	  var res = '';
	  for (var key in value) {
	    if (value[key]) {
	      if (res) { res += ' '; }
	      res += key;
	    }
	  }
	  return res
	}
	
	/*  */
	
	var namespaceMap = {
	  svg: 'http://www.w3.org/2000/svg',
	  math: 'http://www.w3.org/1998/Math/MathML'
	};
	
	var isHTMLTag = makeMap(
	  'html,body,base,head,link,meta,style,title,' +
	  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
	  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
	  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
	  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
	  'embed,object,param,source,canvas,script,noscript,del,ins,' +
	  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
	  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
	  'output,progress,select,textarea,' +
	  'details,dialog,menu,menuitem,summary,' +
	  'content,element,shadow,template,blockquote,iframe,tfoot'
	);
	
	// this map is intentionally selective, only covering SVG elements that may
	// contain child elements.
	var isSVG = makeMap(
	  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
	  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
	  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
	  true
	);
	
	
	
	var isReservedTag = function (tag) {
	  return isHTMLTag(tag) || isSVG(tag)
	};
	
	function getTagNamespace (tag) {
	  if (isSVG(tag)) {
	    return 'svg'
	  }
	  // basic support for MathML
	  // note it doesn't support other MathML elements being component roots
	  if (tag === 'math') {
	    return 'math'
	  }
	}
	
	var unknownElementCache = Object.create(null);
	function isUnknownElement (tag) {
	  /* istanbul ignore if */
	  if (!inBrowser) {
	    return true
	  }
	  if (isReservedTag(tag)) {
	    return false
	  }
	  tag = tag.toLowerCase();
	  /* istanbul ignore if */
	  if (unknownElementCache[tag] != null) {
	    return unknownElementCache[tag]
	  }
	  var el = document.createElement(tag);
	  if (tag.indexOf('-') > -1) {
	    // http://stackoverflow.com/a/28210364/1070244
	    return (unknownElementCache[tag] = (
	      el.constructor === window.HTMLUnknownElement ||
	      el.constructor === window.HTMLElement
	    ))
	  } else {
	    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
	  }
	}
	
	var isTextInputType = makeMap('text,number,password,search,email,tel,url');
	
	/*  */
	
	/**
	 * Query an element selector if it's not an element already.
	 */
	function query (el) {
	  if (typeof el === 'string') {
	    var selected = document.querySelector(el);
	    if (!selected) {
	      ("production") !== 'production' && warn(
	        'Cannot find element: ' + el
	      );
	      return document.createElement('div')
	    }
	    return selected
	  } else {
	    return el
	  }
	}
	
	/*  */
	
	function createElement$1 (tagName, vnode) {
	  var elm = document.createElement(tagName);
	  if (tagName !== 'select') {
	    return elm
	  }
	  // false or null will remove the attribute but undefined will not
	  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
	    elm.setAttribute('multiple', 'multiple');
	  }
	  return elm
	}
	
	function createElementNS (namespace, tagName) {
	  return document.createElementNS(namespaceMap[namespace], tagName)
	}
	
	function createTextNode (text) {
	  return document.createTextNode(text)
	}
	
	function createComment (text) {
	  return document.createComment(text)
	}
	
	function insertBefore (parentNode, newNode, referenceNode) {
	  parentNode.insertBefore(newNode, referenceNode);
	}
	
	function removeChild (node, child) {
	  node.removeChild(child);
	}
	
	function appendChild (node, child) {
	  node.appendChild(child);
	}
	
	function parentNode (node) {
	  return node.parentNode
	}
	
	function nextSibling (node) {
	  return node.nextSibling
	}
	
	function tagName (node) {
	  return node.tagName
	}
	
	function setTextContent (node, text) {
	  node.textContent = text;
	}
	
	function setStyleScope (node, scopeId) {
	  node.setAttribute(scopeId, '');
	}
	
	
	var nodeOps = Object.freeze({
		createElement: createElement$1,
		createElementNS: createElementNS,
		createTextNode: createTextNode,
		createComment: createComment,
		insertBefore: insertBefore,
		removeChild: removeChild,
		appendChild: appendChild,
		parentNode: parentNode,
		nextSibling: nextSibling,
		tagName: tagName,
		setTextContent: setTextContent,
		setStyleScope: setStyleScope
	});
	
	/*  */
	
	var ref = {
	  create: function create (_, vnode) {
	    registerRef(vnode);
	  },
	  update: function update (oldVnode, vnode) {
	    if (oldVnode.data.ref !== vnode.data.ref) {
	      registerRef(oldVnode, true);
	      registerRef(vnode);
	    }
	  },
	  destroy: function destroy (vnode) {
	    registerRef(vnode, true);
	  }
	}
	
	function registerRef (vnode, isRemoval) {
	  var key = vnode.data.ref;
	  if (!isDef(key)) { return }
	
	  var vm = vnode.context;
	  var ref = vnode.componentInstance || vnode.elm;
	  var refs = vm.$refs;
	  if (isRemoval) {
	    if (Array.isArray(refs[key])) {
	      remove(refs[key], ref);
	    } else if (refs[key] === ref) {
	      refs[key] = undefined;
	    }
	  } else {
	    if (vnode.data.refInFor) {
	      if (!Array.isArray(refs[key])) {
	        refs[key] = [ref];
	      } else if (refs[key].indexOf(ref) < 0) {
	        // $flow-disable-line
	        refs[key].push(ref);
	      }
	    } else {
	      refs[key] = ref;
	    }
	  }
	}
	
	/**
	 * Virtual DOM patching algorithm based on Snabbdom by
	 * Simon Friis Vindum (@paldepind)
	 * Licensed under the MIT License
	 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
	 *
	 * modified by Evan You (@yyx990803)
	 *
	 * Not type-checking this because this file is perf-critical and the cost
	 * of making flow understand it is not worth it.
	 */
	
	var emptyNode = new VNode('', {}, []);
	
	var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
	
	function sameVnode (a, b) {
	  return (
	    a.key === b.key && (
	      (
	        a.tag === b.tag &&
	        a.isComment === b.isComment &&
	        isDef(a.data) === isDef(b.data) &&
	        sameInputType(a, b)
	      ) || (
	        isTrue(a.isAsyncPlaceholder) &&
	        a.asyncFactory === b.asyncFactory &&
	        isUndef(b.asyncFactory.error)
	      )
	    )
	  )
	}
	
	function sameInputType (a, b) {
	  if (a.tag !== 'input') { return true }
	  var i;
	  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
	  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
	  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
	}
	
	function createKeyToOldIdx (children, beginIdx, endIdx) {
	  var i, key;
	  var map = {};
	  for (i = beginIdx; i <= endIdx; ++i) {
	    key = children[i].key;
	    if (isDef(key)) { map[key] = i; }
	  }
	  return map
	}
	
	function createPatchFunction (backend) {
	  var i, j;
	  var cbs = {};
	
	  var modules = backend.modules;
	  var nodeOps = backend.nodeOps;
	
	  for (i = 0; i < hooks.length; ++i) {
	    cbs[hooks[i]] = [];
	    for (j = 0; j < modules.length; ++j) {
	      if (isDef(modules[j][hooks[i]])) {
	        cbs[hooks[i]].push(modules[j][hooks[i]]);
	      }
	    }
	  }
	
	  function emptyNodeAt (elm) {
	    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
	  }
	
	  function createRmCb (childElm, listeners) {
	    function remove () {
	      if (--remove.listeners === 0) {
	        removeNode(childElm);
	      }
	    }
	    remove.listeners = listeners;
	    return remove
	  }
	
	  function removeNode (el) {
	    var parent = nodeOps.parentNode(el);
	    // element may have already been removed due to v-html / v-text
	    if (isDef(parent)) {
	      nodeOps.removeChild(parent, el);
	    }
	  }
	
	  function isUnknownElement$$1 (vnode, inVPre) {
	    return (
	      !inVPre &&
	      !vnode.ns &&
	      !(
	        config.ignoredElements.length &&
	        config.ignoredElements.some(function (ignore) {
	          return isRegExp(ignore)
	            ? ignore.test(vnode.tag)
	            : ignore === vnode.tag
	        })
	      ) &&
	      config.isUnknownElement(vnode.tag)
	    )
	  }
	
	  var creatingElmInVPre = 0;
	
	  function createElm (
	    vnode,
	    insertedVnodeQueue,
	    parentElm,
	    refElm,
	    nested,
	    ownerArray,
	    index
	  ) {
	    if (isDef(vnode.elm) && isDef(ownerArray)) {
	      // This vnode was used in a previous render!
	      // now it's used as a new node, overwriting its elm would cause
	      // potential patch errors down the road when it's used as an insertion
	      // reference node. Instead, we clone the node on-demand before creating
	      // associated DOM element for it.
	      vnode = ownerArray[index] = cloneVNode(vnode);
	    }
	
	    vnode.isRootInsert = !nested; // for transition enter check
	    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
	      return
	    }
	
	    var data = vnode.data;
	    var children = vnode.children;
	    var tag = vnode.tag;
	    if (isDef(tag)) {
	      if (false) {
	        if (data && data.pre) {
	          creatingElmInVPre++;
	        }
	        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
	          warn(
	            'Unknown custom element: <' + tag + '> - did you ' +
	            'register the component correctly? For recursive components, ' +
	            'make sure to provide the "name" option.',
	            vnode.context
	          );
	        }
	      }
	
	      vnode.elm = vnode.ns
	        ? nodeOps.createElementNS(vnode.ns, tag)
	        : nodeOps.createElement(tag, vnode);
	      setScope(vnode);
	
	      /* istanbul ignore if */
	      {
	        createChildren(vnode, children, insertedVnodeQueue);
	        if (isDef(data)) {
	          invokeCreateHooks(vnode, insertedVnodeQueue);
	        }
	        insert(parentElm, vnode.elm, refElm);
	      }
	
	      if (false) {
	        creatingElmInVPre--;
	      }
	    } else if (isTrue(vnode.isComment)) {
	      vnode.elm = nodeOps.createComment(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    } else {
	      vnode.elm = nodeOps.createTextNode(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    }
	  }
	
	  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i = vnode.data;
	    if (isDef(i)) {
	      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
	      if (isDef(i = i.hook) && isDef(i = i.init)) {
	        i(vnode, false /* hydrating */, parentElm, refElm);
	      }
	      // after calling the init hook, if the vnode is a child component
	      // it should've created a child instance and mounted it. the child
	      // component also has set the placeholder vnode's elm.
	      // in that case we can just return the element and be done.
	      if (isDef(vnode.componentInstance)) {
	        initComponent(vnode, insertedVnodeQueue);
	        if (isTrue(isReactivated)) {
	          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
	        }
	        return true
	      }
	    }
	  }
	
	  function initComponent (vnode, insertedVnodeQueue) {
	    if (isDef(vnode.data.pendingInsert)) {
	      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
	      vnode.data.pendingInsert = null;
	    }
	    vnode.elm = vnode.componentInstance.$el;
	    if (isPatchable(vnode)) {
	      invokeCreateHooks(vnode, insertedVnodeQueue);
	      setScope(vnode);
	    } else {
	      // empty component root.
	      // skip all element-related modules except for ref (#3455)
	      registerRef(vnode);
	      // make sure to invoke the insert hook
	      insertedVnodeQueue.push(vnode);
	    }
	  }
	
	  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i;
	    // hack for #4339: a reactivated component with inner transition
	    // does not trigger because the inner node's created hooks are not called
	    // again. It's not ideal to involve module-specific logic in here but
	    // there doesn't seem to be a better way to do it.
	    var innerNode = vnode;
	    while (innerNode.componentInstance) {
	      innerNode = innerNode.componentInstance._vnode;
	      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
	        for (i = 0; i < cbs.activate.length; ++i) {
	          cbs.activate[i](emptyNode, innerNode);
	        }
	        insertedVnodeQueue.push(innerNode);
	        break
	      }
	    }
	    // unlike a newly created component,
	    // a reactivated keep-alive component doesn't insert itself
	    insert(parentElm, vnode.elm, refElm);
	  }
	
	  function insert (parent, elm, ref$$1) {
	    if (isDef(parent)) {
	      if (isDef(ref$$1)) {
	        if (ref$$1.parentNode === parent) {
	          nodeOps.insertBefore(parent, elm, ref$$1);
	        }
	      } else {
	        nodeOps.appendChild(parent, elm);
	      }
	    }
	  }
	
	  function createChildren (vnode, children, insertedVnodeQueue) {
	    if (Array.isArray(children)) {
	      if (false) {
	        checkDuplicateKeys(children);
	      }
	      for (var i = 0; i < children.length; ++i) {
	        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
	      }
	    } else if (isPrimitive(vnode.text)) {
	      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
	    }
	  }
	
	  function isPatchable (vnode) {
	    while (vnode.componentInstance) {
	      vnode = vnode.componentInstance._vnode;
	    }
	    return isDef(vnode.tag)
	  }
	
	  function invokeCreateHooks (vnode, insertedVnodeQueue) {
	    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
	      cbs.create[i$1](emptyNode, vnode);
	    }
	    i = vnode.data.hook; // Reuse variable
	    if (isDef(i)) {
	      if (isDef(i.create)) { i.create(emptyNode, vnode); }
	      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
	    }
	  }
	
	  // set scope id attribute for scoped CSS.
	  // this is implemented as a special case to avoid the overhead
	  // of going through the normal attribute patching process.
	  function setScope (vnode) {
	    var i;
	    if (isDef(i = vnode.fnScopeId)) {
	      nodeOps.setStyleScope(vnode.elm, i);
	    } else {
	      var ancestor = vnode;
	      while (ancestor) {
	        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
	          nodeOps.setStyleScope(vnode.elm, i);
	        }
	        ancestor = ancestor.parent;
	      }
	    }
	    // for slot content they should also get the scopeId from the host instance.
	    if (isDef(i = activeInstance) &&
	      i !== vnode.context &&
	      i !== vnode.fnContext &&
	      isDef(i = i.$options._scopeId)
	    ) {
	      nodeOps.setStyleScope(vnode.elm, i);
	    }
	  }
	
	  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
	    }
	  }
	
	  function invokeDestroyHook (vnode) {
	    var i, j;
	    var data = vnode.data;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
	      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
	    }
	    if (isDef(i = vnode.children)) {
	      for (j = 0; j < vnode.children.length; ++j) {
	        invokeDestroyHook(vnode.children[j]);
	      }
	    }
	  }
	
	  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      var ch = vnodes[startIdx];
	      if (isDef(ch)) {
	        if (isDef(ch.tag)) {
	          removeAndInvokeRemoveHook(ch);
	          invokeDestroyHook(ch);
	        } else { // Text node
	          removeNode(ch.elm);
	        }
	      }
	    }
	  }
	
	  function removeAndInvokeRemoveHook (vnode, rm) {
	    if (isDef(rm) || isDef(vnode.data)) {
	      var i;
	      var listeners = cbs.remove.length + 1;
	      if (isDef(rm)) {
	        // we have a recursively passed down rm callback
	        // increase the listeners count
	        rm.listeners += listeners;
	      } else {
	        // directly removing
	        rm = createRmCb(vnode.elm, listeners);
	      }
	      // recursively invoke hooks on child component root node
	      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
	        removeAndInvokeRemoveHook(i, rm);
	      }
	      for (i = 0; i < cbs.remove.length; ++i) {
	        cbs.remove[i](vnode, rm);
	      }
	      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
	        i(vnode, rm);
	      } else {
	        rm();
	      }
	    } else {
	      removeNode(vnode.elm);
	    }
	  }
	
	  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
	    var oldStartIdx = 0;
	    var newStartIdx = 0;
	    var oldEndIdx = oldCh.length - 1;
	    var oldStartVnode = oldCh[0];
	    var oldEndVnode = oldCh[oldEndIdx];
	    var newEndIdx = newCh.length - 1;
	    var newStartVnode = newCh[0];
	    var newEndVnode = newCh[newEndIdx];
	    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
	
	    // removeOnly is a special flag used only by <transition-group>
	    // to ensure removed elements stay in correct relative positions
	    // during leaving transitions
	    var canMove = !removeOnly;
	
	    if (false) {
	      checkDuplicateKeys(newCh);
	    }
	
	    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
	      if (isUndef(oldStartVnode)) {
	        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
	      } else if (isUndef(oldEndVnode)) {
	        oldEndVnode = oldCh[--oldEndIdx];
	      } else if (sameVnode(oldStartVnode, newStartVnode)) {
	        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
	        oldStartVnode = oldCh[++oldStartIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else if (sameVnode(oldEndVnode, newEndVnode)) {
	        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
	        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
	        oldStartVnode = oldCh[++oldStartIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
	        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else {
	        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
	        idxInOld = isDef(newStartVnode.key)
	          ? oldKeyToIdx[newStartVnode.key]
	          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
	        if (isUndef(idxInOld)) { // New element
	          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
	        } else {
	          vnodeToMove = oldCh[idxInOld];
	          if (sameVnode(vnodeToMove, newStartVnode)) {
	            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
	            oldCh[idxInOld] = undefined;
	            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
	          } else {
	            // same key but different element. treat as new element
	            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
	          }
	        }
	        newStartVnode = newCh[++newStartIdx];
	      }
	    }
	    if (oldStartIdx > oldEndIdx) {
	      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
	      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
	    } else if (newStartIdx > newEndIdx) {
	      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
	    }
	  }
	
	  function checkDuplicateKeys (children) {
	    var seenKeys = {};
	    for (var i = 0; i < children.length; i++) {
	      var vnode = children[i];
	      var key = vnode.key;
	      if (isDef(key)) {
	        if (seenKeys[key]) {
	          warn(
	            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
	            vnode.context
	          );
	        } else {
	          seenKeys[key] = true;
	        }
	      }
	    }
	  }
	
	  function findIdxInOld (node, oldCh, start, end) {
	    for (var i = start; i < end; i++) {
	      var c = oldCh[i];
	      if (isDef(c) && sameVnode(node, c)) { return i }
	    }
	  }
	
	  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
	    if (oldVnode === vnode) {
	      return
	    }
	
	    var elm = vnode.elm = oldVnode.elm;
	
	    if (isTrue(oldVnode.isAsyncPlaceholder)) {
	      if (isDef(vnode.asyncFactory.resolved)) {
	        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
	      } else {
	        vnode.isAsyncPlaceholder = true;
	      }
	      return
	    }
	
	    // reuse element for static trees.
	    // note we only do this if the vnode is cloned -
	    // if the new node is not cloned it means the render functions have been
	    // reset by the hot-reload-api and we need to do a proper re-render.
	    if (isTrue(vnode.isStatic) &&
	      isTrue(oldVnode.isStatic) &&
	      vnode.key === oldVnode.key &&
	      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
	    ) {
	      vnode.componentInstance = oldVnode.componentInstance;
	      return
	    }
	
	    var i;
	    var data = vnode.data;
	    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
	      i(oldVnode, vnode);
	    }
	
	    var oldCh = oldVnode.children;
	    var ch = vnode.children;
	    if (isDef(data) && isPatchable(vnode)) {
	      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
	      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
	    }
	    if (isUndef(vnode.text)) {
	      if (isDef(oldCh) && isDef(ch)) {
	        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
	      } else if (isDef(ch)) {
	        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
	        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
	      } else if (isDef(oldCh)) {
	        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
	      } else if (isDef(oldVnode.text)) {
	        nodeOps.setTextContent(elm, '');
	      }
	    } else if (oldVnode.text !== vnode.text) {
	      nodeOps.setTextContent(elm, vnode.text);
	    }
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
	    }
	  }
	
	  function invokeInsertHook (vnode, queue, initial) {
	    // delay insert hooks for component root nodes, invoke them after the
	    // element is really inserted
	    if (isTrue(initial) && isDef(vnode.parent)) {
	      vnode.parent.data.pendingInsert = queue;
	    } else {
	      for (var i = 0; i < queue.length; ++i) {
	        queue[i].data.hook.insert(queue[i]);
	      }
	    }
	  }
	
	  var hydrationBailed = false;
	  // list of modules that can skip create hook during hydration because they
	  // are already rendered on the client or has no need for initialization
	  // Note: style is excluded because it relies on initial clone for future
	  // deep updates (#7063).
	  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
	
	  // Note: this is a browser-only function so we can assume elms are DOM nodes.
	  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
	    var i;
	    var tag = vnode.tag;
	    var data = vnode.data;
	    var children = vnode.children;
	    inVPre = inVPre || (data && data.pre);
	    vnode.elm = elm;
	
	    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
	      vnode.isAsyncPlaceholder = true;
	      return true
	    }
	    // assert node match
	    if (false) {
	      if (!assertNodeMatch(elm, vnode, inVPre)) {
	        return false
	      }
	    }
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
	      if (isDef(i = vnode.componentInstance)) {
	        // child component. it should have hydrated its own tree.
	        initComponent(vnode, insertedVnodeQueue);
	        return true
	      }
	    }
	    if (isDef(tag)) {
	      if (isDef(children)) {
	        // empty element, allow client to pick up and populate children
	        if (!elm.hasChildNodes()) {
	          createChildren(vnode, children, insertedVnodeQueue);
	        } else {
	          // v-html and domProps: innerHTML
	          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
	            if (i !== elm.innerHTML) {
	              /* istanbul ignore if */
	              if (false
	              ) {
	                hydrationBailed = true;
	                console.warn('Parent: ', elm);
	                console.warn('server innerHTML: ', i);
	                console.warn('client innerHTML: ', elm.innerHTML);
	              }
	              return false
	            }
	          } else {
	            // iterate and compare children lists
	            var childrenMatch = true;
	            var childNode = elm.firstChild;
	            for (var i$1 = 0; i$1 < children.length; i$1++) {
	              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
	                childrenMatch = false;
	                break
	              }
	              childNode = childNode.nextSibling;
	            }
	            // if childNode is not null, it means the actual childNodes list is
	            // longer than the virtual children list.
	            if (!childrenMatch || childNode) {
	              /* istanbul ignore if */
	              if (false
	              ) {
	                hydrationBailed = true;
	                console.warn('Parent: ', elm);
	                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
	              }
	              return false
	            }
	          }
	        }
	      }
	      if (isDef(data)) {
	        var fullInvoke = false;
	        for (var key in data) {
	          if (!isRenderedModule(key)) {
	            fullInvoke = true;
	            invokeCreateHooks(vnode, insertedVnodeQueue);
	            break
	          }
	        }
	        if (!fullInvoke && data['class']) {
	          // ensure collecting deps for deep class bindings for future updates
	          traverse(data['class']);
	        }
	      }
	    } else if (elm.data !== vnode.text) {
	      elm.data = vnode.text;
	    }
	    return true
	  }
	
	  function assertNodeMatch (node, vnode, inVPre) {
	    if (isDef(vnode.tag)) {
	      return vnode.tag.indexOf('vue-component') === 0 || (
	        !isUnknownElement$$1(vnode, inVPre) &&
	        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
	      )
	    } else {
	      return node.nodeType === (vnode.isComment ? 8 : 3)
	    }
	  }
	
	  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
	    if (isUndef(vnode)) {
	      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
	      return
	    }
	
	    var isInitialPatch = false;
	    var insertedVnodeQueue = [];
	
	    if (isUndef(oldVnode)) {
	      // empty mount (likely as component), create new root element
	      isInitialPatch = true;
	      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
	    } else {
	      var isRealElement = isDef(oldVnode.nodeType);
	      if (!isRealElement && sameVnode(oldVnode, vnode)) {
	        // patch existing root node
	        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
	      } else {
	        if (isRealElement) {
	          // mounting to a real element
	          // check if this is server-rendered content and if we can perform
	          // a successful hydration.
	          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
	            oldVnode.removeAttribute(SSR_ATTR);
	            hydrating = true;
	          }
	          if (isTrue(hydrating)) {
	            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
	              invokeInsertHook(vnode, insertedVnodeQueue, true);
	              return oldVnode
	            } else if (false) {
	              warn(
	                'The client-side rendered virtual DOM tree is not matching ' +
	                'server-rendered content. This is likely caused by incorrect ' +
	                'HTML markup, for example nesting block-level elements inside ' +
	                '<p>, or missing <tbody>. Bailing hydration and performing ' +
	                'full client-side render.'
	              );
	            }
	          }
	          // either not server-rendered, or hydration failed.
	          // create an empty node and replace it
	          oldVnode = emptyNodeAt(oldVnode);
	        }
	
	        // replacing existing element
	        var oldElm = oldVnode.elm;
	        var parentElm$1 = nodeOps.parentNode(oldElm);
	
	        // create new node
	        createElm(
	          vnode,
	          insertedVnodeQueue,
	          // extremely rare edge case: do not insert if old element is in a
	          // leaving transition. Only happens when combining transition +
	          // keep-alive + HOCs. (#4590)
	          oldElm._leaveCb ? null : parentElm$1,
	          nodeOps.nextSibling(oldElm)
	        );
	
	        // update parent placeholder node element, recursively
	        if (isDef(vnode.parent)) {
	          var ancestor = vnode.parent;
	          var patchable = isPatchable(vnode);
	          while (ancestor) {
	            for (var i = 0; i < cbs.destroy.length; ++i) {
	              cbs.destroy[i](ancestor);
	            }
	            ancestor.elm = vnode.elm;
	            if (patchable) {
	              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
	                cbs.create[i$1](emptyNode, ancestor);
	              }
	              // #6513
	              // invoke insert hooks that may have been merged by create hooks.
	              // e.g. for directives that uses the "inserted" hook.
	              var insert = ancestor.data.hook.insert;
	              if (insert.merged) {
	                // start at index 1 to avoid re-invoking component mounted hook
	                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
	                  insert.fns[i$2]();
	                }
	              }
	            } else {
	              registerRef(ancestor);
	            }
	            ancestor = ancestor.parent;
	          }
	        }
	
	        // destroy old node
	        if (isDef(parentElm$1)) {
	          removeVnodes(parentElm$1, [oldVnode], 0, 0);
	        } else if (isDef(oldVnode.tag)) {
	          invokeDestroyHook(oldVnode);
	        }
	      }
	    }
	
	    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
	    return vnode.elm
	  }
	}
	
	/*  */
	
	var directives = {
	  create: updateDirectives,
	  update: updateDirectives,
	  destroy: function unbindDirectives (vnode) {
	    updateDirectives(vnode, emptyNode);
	  }
	}
	
	function updateDirectives (oldVnode, vnode) {
	  if (oldVnode.data.directives || vnode.data.directives) {
	    _update(oldVnode, vnode);
	  }
	}
	
	function _update (oldVnode, vnode) {
	  var isCreate = oldVnode === emptyNode;
	  var isDestroy = vnode === emptyNode;
	  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
	  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);
	
	  var dirsWithInsert = [];
	  var dirsWithPostpatch = [];
	
	  var key, oldDir, dir;
	  for (key in newDirs) {
	    oldDir = oldDirs[key];
	    dir = newDirs[key];
	    if (!oldDir) {
	      // new directive, bind
	      callHook$1(dir, 'bind', vnode, oldVnode);
	      if (dir.def && dir.def.inserted) {
	        dirsWithInsert.push(dir);
	      }
	    } else {
	      // existing directive, update
	      dir.oldValue = oldDir.value;
	      callHook$1(dir, 'update', vnode, oldVnode);
	      if (dir.def && dir.def.componentUpdated) {
	        dirsWithPostpatch.push(dir);
	      }
	    }
	  }
	
	  if (dirsWithInsert.length) {
	    var callInsert = function () {
	      for (var i = 0; i < dirsWithInsert.length; i++) {
	        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
	      }
	    };
	    if (isCreate) {
	      mergeVNodeHook(vnode, 'insert', callInsert);
	    } else {
	      callInsert();
	    }
	  }
	
	  if (dirsWithPostpatch.length) {
	    mergeVNodeHook(vnode, 'postpatch', function () {
	      for (var i = 0; i < dirsWithPostpatch.length; i++) {
	        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
	      }
	    });
	  }
	
	  if (!isCreate) {
	    for (key in oldDirs) {
	      if (!newDirs[key]) {
	        // no longer present, unbind
	        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
	      }
	    }
	  }
	}
	
	var emptyModifiers = Object.create(null);
	
	function normalizeDirectives$1 (
	  dirs,
	  vm
	) {
	  var res = Object.create(null);
	  if (!dirs) {
	    // $flow-disable-line
	    return res
	  }
	  var i, dir;
	  for (i = 0; i < dirs.length; i++) {
	    dir = dirs[i];
	    if (!dir.modifiers) {
	      // $flow-disable-line
	      dir.modifiers = emptyModifiers;
	    }
	    res[getRawDirName(dir)] = dir;
	    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
	  }
	  // $flow-disable-line
	  return res
	}
	
	function getRawDirName (dir) {
	  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
	}
	
	function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
	  var fn = dir.def && dir.def[hook];
	  if (fn) {
	    try {
	      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
	    } catch (e) {
	      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
	    }
	  }
	}
	
	var baseModules = [
	  ref,
	  directives
	]
	
	/*  */
	
	function updateAttrs (oldVnode, vnode) {
	  var opts = vnode.componentOptions;
	  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
	    return
	  }
	  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
	    return
	  }
	  var key, cur, old;
	  var elm = vnode.elm;
	  var oldAttrs = oldVnode.data.attrs || {};
	  var attrs = vnode.data.attrs || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (isDef(attrs.__ob__)) {
	    attrs = vnode.data.attrs = extend({}, attrs);
	  }
	
	  for (key in attrs) {
	    cur = attrs[key];
	    old = oldAttrs[key];
	    if (old !== cur) {
	      setAttr(elm, key, cur);
	    }
	  }
	  // #4391: in IE9, setting type can reset value for input[type=radio]
	  // #6666: IE/Edge forces progress value down to 1 before setting a max
	  /* istanbul ignore if */
	  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
	    setAttr(elm, 'value', attrs.value);
	  }
	  for (key in oldAttrs) {
	    if (isUndef(attrs[key])) {
	      if (isXlink(key)) {
	        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
	      } else if (!isEnumeratedAttr(key)) {
	        elm.removeAttribute(key);
	      }
	    }
	  }
	}
	
	function setAttr (el, key, value) {
	  if (el.tagName.indexOf('-') > -1) {
	    baseSetAttr(el, key, value);
	  } else if (isBooleanAttr(key)) {
	    // set attribute for blank value
	    // e.g. <option disabled>Select one</option>
	    if (isFalsyAttrValue(value)) {
	      el.removeAttribute(key);
	    } else {
	      // technically allowfullscreen is a boolean attribute for <iframe>,
	      // but Flash expects a value of "true" when used on <embed> tag
	      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
	        ? 'true'
	        : key;
	      el.setAttribute(key, value);
	    }
	  } else if (isEnumeratedAttr(key)) {
	    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
	  } else if (isXlink(key)) {
	    if (isFalsyAttrValue(value)) {
	      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
	    } else {
	      el.setAttributeNS(xlinkNS, key, value);
	    }
	  } else {
	    baseSetAttr(el, key, value);
	  }
	}
	
	function baseSetAttr (el, key, value) {
	  if (isFalsyAttrValue(value)) {
	    el.removeAttribute(key);
	  } else {
	    // #7138: IE10 & 11 fires input event when setting placeholder on
	    // <textarea>... block the first input event and remove the blocker
	    // immediately.
	    /* istanbul ignore if */
	    if (
	      isIE && !isIE9 &&
	      el.tagName === 'TEXTAREA' &&
	      key === 'placeholder' && !el.__ieph
	    ) {
	      var blocker = function (e) {
	        e.stopImmediatePropagation();
	        el.removeEventListener('input', blocker);
	      };
	      el.addEventListener('input', blocker);
	      // $flow-disable-line
	      el.__ieph = true; /* IE placeholder patched */
	    }
	    el.setAttribute(key, value);
	  }
	}
	
	var attrs = {
	  create: updateAttrs,
	  update: updateAttrs
	}
	
	/*  */
	
	function updateClass (oldVnode, vnode) {
	  var el = vnode.elm;
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	  if (
	    isUndef(data.staticClass) &&
	    isUndef(data.class) && (
	      isUndef(oldData) || (
	        isUndef(oldData.staticClass) &&
	        isUndef(oldData.class)
	      )
	    )
	  ) {
	    return
	  }
	
	  var cls = genClassForVnode(vnode);
	
	  // handle transition classes
	  var transitionClass = el._transitionClasses;
	  if (isDef(transitionClass)) {
	    cls = concat(cls, stringifyClass(transitionClass));
	  }
	
	  // set the class
	  if (cls !== el._prevClass) {
	    el.setAttribute('class', cls);
	    el._prevClass = cls;
	  }
	}
	
	var klass = {
	  create: updateClass,
	  update: updateClass
	}
	
	/*  */
	
	/*  */
	
	
	
	
	
	
	
	
	
	// add a raw attr (use this in preTransforms)
	
	
	
	
	
	
	
	
	// note: this only removes the attr from the Array (attrsList) so that it
	// doesn't get processed by processAttrs.
	// By default it does NOT remove it from the map (attrsMap) because the map is
	// needed during codegen.
	
	/*  */
	
	/**
	 * Cross-platform code generation for component v-model
	 */
	
	
	/**
	 * Cross-platform codegen helper for generating v-model value assignment code.
	 */
	
	/*  */
	
	// in some cases, the event used has to be determined at runtime
	// so we used some reserved tokens during compile.
	var RANGE_TOKEN = '__r';
	var CHECKBOX_RADIO_TOKEN = '__c';
	
	/*  */
	
	// normalize v-model event tokens that can only be determined at runtime.
	// it's important to place the event as the first in the array because
	// the whole point is ensuring the v-model callback gets called before
	// user-attached handlers.
	function normalizeEvents (on) {
	  /* istanbul ignore if */
	  if (isDef(on[RANGE_TOKEN])) {
	    // IE input[type=range] only supports `change` event
	    var event = isIE ? 'change' : 'input';
	    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
	    delete on[RANGE_TOKEN];
	  }
	  // This was originally intended to fix #4521 but no longer necessary
	  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
	  /* istanbul ignore if */
	  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
	    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
	    delete on[CHECKBOX_RADIO_TOKEN];
	  }
	}
	
	var target$1;
	
	function createOnceHandler (handler, event, capture) {
	  var _target = target$1; // save current target element in closure
	  return function onceHandler () {
	    var res = handler.apply(null, arguments);
	    if (res !== null) {
	      remove$2(event, onceHandler, capture, _target);
	    }
	  }
	}
	
	function add$1 (
	  event,
	  handler,
	  once$$1,
	  capture,
	  passive
	) {
	  handler = withMacroTask(handler);
	  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
	  target$1.addEventListener(
	    event,
	    handler,
	    supportsPassive
	      ? { capture: capture, passive: passive }
	      : capture
	  );
	}
	
	function remove$2 (
	  event,
	  handler,
	  capture,
	  _target
	) {
	  (_target || target$1).removeEventListener(
	    event,
	    handler._withTask || handler,
	    capture
	  );
	}
	
	function updateDOMListeners (oldVnode, vnode) {
	  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
	    return
	  }
	  var on = vnode.data.on || {};
	  var oldOn = oldVnode.data.on || {};
	  target$1 = vnode.elm;
	  normalizeEvents(on);
	  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
	  target$1 = undefined;
	}
	
	var events = {
	  create: updateDOMListeners,
	  update: updateDOMListeners
	}
	
	/*  */
	
	function updateDOMProps (oldVnode, vnode) {
	  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
	    return
	  }
	  var key, cur;
	  var elm = vnode.elm;
	  var oldProps = oldVnode.data.domProps || {};
	  var props = vnode.data.domProps || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (isDef(props.__ob__)) {
	    props = vnode.data.domProps = extend({}, props);
	  }
	
	  for (key in oldProps) {
	    if (isUndef(props[key])) {
	      elm[key] = '';
	    }
	  }
	  for (key in props) {
	    cur = props[key];
	    // ignore children if the node has textContent or innerHTML,
	    // as these will throw away existing DOM nodes and cause removal errors
	    // on subsequent patches (#3360)
	    if (key === 'textContent' || key === 'innerHTML') {
	      if (vnode.children) { vnode.children.length = 0; }
	      if (cur === oldProps[key]) { continue }
	      // #6601 work around Chrome version <= 55 bug where single textNode
	      // replaced by innerHTML/textContent retains its parentNode property
	      if (elm.childNodes.length === 1) {
	        elm.removeChild(elm.childNodes[0]);
	      }
	    }
	
	    if (key === 'value') {
	      // store value as _value as well since
	      // non-string values will be stringified
	      elm._value = cur;
	      // avoid resetting cursor position when value is the same
	      var strCur = isUndef(cur) ? '' : String(cur);
	      if (shouldUpdateValue(elm, strCur)) {
	        elm.value = strCur;
	      }
	    } else {
	      elm[key] = cur;
	    }
	  }
	}
	
	// check platforms/web/util/attrs.js acceptValue
	
	
	function shouldUpdateValue (elm, checkVal) {
	  return (!elm.composing && (
	    elm.tagName === 'OPTION' ||
	    isNotInFocusAndDirty(elm, checkVal) ||
	    isDirtyWithModifiers(elm, checkVal)
	  ))
	}
	
	function isNotInFocusAndDirty (elm, checkVal) {
	  // return true when textbox (.number and .trim) loses focus and its value is
	  // not equal to the updated value
	  var notInFocus = true;
	  // #6157
	  // work around IE bug when accessing document.activeElement in an iframe
	  try { notInFocus = document.activeElement !== elm; } catch (e) {}
	  return notInFocus && elm.value !== checkVal
	}
	
	function isDirtyWithModifiers (elm, newVal) {
	  var value = elm.value;
	  var modifiers = elm._vModifiers; // injected by v-model runtime
	  if (isDef(modifiers)) {
	    if (modifiers.lazy) {
	      // inputs with lazy should only be updated when not in focus
	      return false
	    }
	    if (modifiers.number) {
	      return toNumber(value) !== toNumber(newVal)
	    }
	    if (modifiers.trim) {
	      return value.trim() !== newVal.trim()
	    }
	  }
	  return value !== newVal
	}
	
	var domProps = {
	  create: updateDOMProps,
	  update: updateDOMProps
	}
	
	/*  */
	
	var parseStyleText = cached(function (cssText) {
	  var res = {};
	  var listDelimiter = /;(?![^(]*\))/g;
	  var propertyDelimiter = /:(.+)/;
	  cssText.split(listDelimiter).forEach(function (item) {
	    if (item) {
	      var tmp = item.split(propertyDelimiter);
	      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
	    }
	  });
	  return res
	});
	
	// merge static and dynamic style data on the same vnode
	function normalizeStyleData (data) {
	  var style = normalizeStyleBinding(data.style);
	  // static style is pre-processed into an object during compilation
	  // and is always a fresh object, so it's safe to merge into it
	  return data.staticStyle
	    ? extend(data.staticStyle, style)
	    : style
	}
	
	// normalize possible array / string values into Object
	function normalizeStyleBinding (bindingStyle) {
	  if (Array.isArray(bindingStyle)) {
	    return toObject(bindingStyle)
	  }
	  if (typeof bindingStyle === 'string') {
	    return parseStyleText(bindingStyle)
	  }
	  return bindingStyle
	}
	
	/**
	 * parent component style should be after child's
	 * so that parent component's style could override it
	 */
	function getStyle (vnode, checkChild) {
	  var res = {};
	  var styleData;
	
	  if (checkChild) {
	    var childNode = vnode;
	    while (childNode.componentInstance) {
	      childNode = childNode.componentInstance._vnode;
	      if (
	        childNode && childNode.data &&
	        (styleData = normalizeStyleData(childNode.data))
	      ) {
	        extend(res, styleData);
	      }
	    }
	  }
	
	  if ((styleData = normalizeStyleData(vnode.data))) {
	    extend(res, styleData);
	  }
	
	  var parentNode = vnode;
	  while ((parentNode = parentNode.parent)) {
	    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
	      extend(res, styleData);
	    }
	  }
	  return res
	}
	
	/*  */
	
	var cssVarRE = /^--/;
	var importantRE = /\s*!important$/;
	var setProp = function (el, name, val) {
	  /* istanbul ignore if */
	  if (cssVarRE.test(name)) {
	    el.style.setProperty(name, val);
	  } else if (importantRE.test(val)) {
	    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
	  } else {
	    var normalizedName = normalize(name);
	    if (Array.isArray(val)) {
	      // Support values array created by autoprefixer, e.g.
	      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
	      // Set them one by one, and the browser will only set those it can recognize
	      for (var i = 0, len = val.length; i < len; i++) {
	        el.style[normalizedName] = val[i];
	      }
	    } else {
	      el.style[normalizedName] = val;
	    }
	  }
	};
	
	var vendorNames = ['Webkit', 'Moz', 'ms'];
	
	var emptyStyle;
	var normalize = cached(function (prop) {
	  emptyStyle = emptyStyle || document.createElement('div').style;
	  prop = camelize(prop);
	  if (prop !== 'filter' && (prop in emptyStyle)) {
	    return prop
	  }
	  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
	  for (var i = 0; i < vendorNames.length; i++) {
	    var name = vendorNames[i] + capName;
	    if (name in emptyStyle) {
	      return name
	    }
	  }
	});
	
	function updateStyle (oldVnode, vnode) {
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	
	  if (isUndef(data.staticStyle) && isUndef(data.style) &&
	    isUndef(oldData.staticStyle) && isUndef(oldData.style)
	  ) {
	    return
	  }
	
	  var cur, name;
	  var el = vnode.elm;
	  var oldStaticStyle = oldData.staticStyle;
	  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
	
	  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
	  var oldStyle = oldStaticStyle || oldStyleBinding;
	
	  var style = normalizeStyleBinding(vnode.data.style) || {};
	
	  // store normalized style under a different key for next diff
	  // make sure to clone it if it's reactive, since the user likely wants
	  // to mutate it.
	  vnode.data.normalizedStyle = isDef(style.__ob__)
	    ? extend({}, style)
	    : style;
	
	  var newStyle = getStyle(vnode, true);
	
	  for (name in oldStyle) {
	    if (isUndef(newStyle[name])) {
	      setProp(el, name, '');
	    }
	  }
	  for (name in newStyle) {
	    cur = newStyle[name];
	    if (cur !== oldStyle[name]) {
	      // ie9 setting to null has no effect, must use empty string
	      setProp(el, name, cur == null ? '' : cur);
	    }
	  }
	}
	
	var style = {
	  create: updateStyle,
	  update: updateStyle
	}
	
	/*  */
	
	/**
	 * Add class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function addClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !(cls = cls.trim())) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
	    } else {
	      el.classList.add(cls);
	    }
	  } else {
	    var cur = " " + (el.getAttribute('class') || '') + " ";
	    if (cur.indexOf(' ' + cls + ' ') < 0) {
	      el.setAttribute('class', (cur + cls).trim());
	    }
	  }
	}
	
	/**
	 * Remove class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function removeClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !(cls = cls.trim())) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
	    } else {
	      el.classList.remove(cls);
	    }
	    if (!el.classList.length) {
	      el.removeAttribute('class');
	    }
	  } else {
	    var cur = " " + (el.getAttribute('class') || '') + " ";
	    var tar = ' ' + cls + ' ';
	    while (cur.indexOf(tar) >= 0) {
	      cur = cur.replace(tar, ' ');
	    }
	    cur = cur.trim();
	    if (cur) {
	      el.setAttribute('class', cur);
	    } else {
	      el.removeAttribute('class');
	    }
	  }
	}
	
	/*  */
	
	function resolveTransition (def) {
	  if (!def) {
	    return
	  }
	  /* istanbul ignore else */
	  if (typeof def === 'object') {
	    var res = {};
	    if (def.css !== false) {
	      extend(res, autoCssTransition(def.name || 'v'));
	    }
	    extend(res, def);
	    return res
	  } else if (typeof def === 'string') {
	    return autoCssTransition(def)
	  }
	}
	
	var autoCssTransition = cached(function (name) {
	  return {
	    enterClass: (name + "-enter"),
	    enterToClass: (name + "-enter-to"),
	    enterActiveClass: (name + "-enter-active"),
	    leaveClass: (name + "-leave"),
	    leaveToClass: (name + "-leave-to"),
	    leaveActiveClass: (name + "-leave-active")
	  }
	});
	
	var hasTransition = inBrowser && !isIE9;
	var TRANSITION = 'transition';
	var ANIMATION = 'animation';
	
	// Transition property/event sniffing
	var transitionProp = 'transition';
	var transitionEndEvent = 'transitionend';
	var animationProp = 'animation';
	var animationEndEvent = 'animationend';
	if (hasTransition) {
	  /* istanbul ignore if */
	  if (window.ontransitionend === undefined &&
	    window.onwebkittransitionend !== undefined
	  ) {
	    transitionProp = 'WebkitTransition';
	    transitionEndEvent = 'webkitTransitionEnd';
	  }
	  if (window.onanimationend === undefined &&
	    window.onwebkitanimationend !== undefined
	  ) {
	    animationProp = 'WebkitAnimation';
	    animationEndEvent = 'webkitAnimationEnd';
	  }
	}
	
	// binding to window is necessary to make hot reload work in IE in strict mode
	var raf = inBrowser
	  ? window.requestAnimationFrame
	    ? window.requestAnimationFrame.bind(window)
	    : setTimeout
	  : /* istanbul ignore next */ function (fn) { return fn(); };
	
	function nextFrame (fn) {
	  raf(function () {
	    raf(fn);
	  });
	}
	
	function addTransitionClass (el, cls) {
	  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
	  if (transitionClasses.indexOf(cls) < 0) {
	    transitionClasses.push(cls);
	    addClass(el, cls);
	  }
	}
	
	function removeTransitionClass (el, cls) {
	  if (el._transitionClasses) {
	    remove(el._transitionClasses, cls);
	  }
	  removeClass(el, cls);
	}
	
	function whenTransitionEnds (
	  el,
	  expectedType,
	  cb
	) {
	  var ref = getTransitionInfo(el, expectedType);
	  var type = ref.type;
	  var timeout = ref.timeout;
	  var propCount = ref.propCount;
	  if (!type) { return cb() }
	  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
	  var ended = 0;
	  var end = function () {
	    el.removeEventListener(event, onEnd);
	    cb();
	  };
	  var onEnd = function (e) {
	    if (e.target === el) {
	      if (++ended >= propCount) {
	        end();
	      }
	    }
	  };
	  setTimeout(function () {
	    if (ended < propCount) {
	      end();
	    }
	  }, timeout + 1);
	  el.addEventListener(event, onEnd);
	}
	
	var transformRE = /\b(transform|all)(,|$)/;
	
	function getTransitionInfo (el, expectedType) {
	  var styles = window.getComputedStyle(el);
	  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
	  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
	  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
	  var animationDelays = styles[animationProp + 'Delay'].split(', ');
	  var animationDurations = styles[animationProp + 'Duration'].split(', ');
	  var animationTimeout = getTimeout(animationDelays, animationDurations);
	
	  var type;
	  var timeout = 0;
	  var propCount = 0;
	  /* istanbul ignore if */
	  if (expectedType === TRANSITION) {
	    if (transitionTimeout > 0) {
	      type = TRANSITION;
	      timeout = transitionTimeout;
	      propCount = transitionDurations.length;
	    }
	  } else if (expectedType === ANIMATION) {
	    if (animationTimeout > 0) {
	      type = ANIMATION;
	      timeout = animationTimeout;
	      propCount = animationDurations.length;
	    }
	  } else {
	    timeout = Math.max(transitionTimeout, animationTimeout);
	    type = timeout > 0
	      ? transitionTimeout > animationTimeout
	        ? TRANSITION
	        : ANIMATION
	      : null;
	    propCount = type
	      ? type === TRANSITION
	        ? transitionDurations.length
	        : animationDurations.length
	      : 0;
	  }
	  var hasTransform =
	    type === TRANSITION &&
	    transformRE.test(styles[transitionProp + 'Property']);
	  return {
	    type: type,
	    timeout: timeout,
	    propCount: propCount,
	    hasTransform: hasTransform
	  }
	}
	
	function getTimeout (delays, durations) {
	  /* istanbul ignore next */
	  while (delays.length < durations.length) {
	    delays = delays.concat(delays);
	  }
	
	  return Math.max.apply(null, durations.map(function (d, i) {
	    return toMs(d) + toMs(delays[i])
	  }))
	}
	
	function toMs (s) {
	  return Number(s.slice(0, -1)) * 1000
	}
	
	/*  */
	
	function enter (vnode, toggleDisplay) {
	  var el = vnode.elm;
	
	  // call leave callback now
	  if (isDef(el._leaveCb)) {
	    el._leaveCb.cancelled = true;
	    el._leaveCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (isUndef(data)) {
	    return
	  }
	
	  /* istanbul ignore if */
	  if (isDef(el._enterCb) || el.nodeType !== 1) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var enterClass = data.enterClass;
	  var enterToClass = data.enterToClass;
	  var enterActiveClass = data.enterActiveClass;
	  var appearClass = data.appearClass;
	  var appearToClass = data.appearToClass;
	  var appearActiveClass = data.appearActiveClass;
	  var beforeEnter = data.beforeEnter;
	  var enter = data.enter;
	  var afterEnter = data.afterEnter;
	  var enterCancelled = data.enterCancelled;
	  var beforeAppear = data.beforeAppear;
	  var appear = data.appear;
	  var afterAppear = data.afterAppear;
	  var appearCancelled = data.appearCancelled;
	  var duration = data.duration;
	
	  // activeInstance will always be the <transition> component managing this
	  // transition. One edge case to check is when the <transition> is placed
	  // as the root node of a child component. In that case we need to check
	  // <transition>'s parent for appear check.
	  var context = activeInstance;
	  var transitionNode = activeInstance.$vnode;
	  while (transitionNode && transitionNode.parent) {
	    transitionNode = transitionNode.parent;
	    context = transitionNode.context;
	  }
	
	  var isAppear = !context._isMounted || !vnode.isRootInsert;
	
	  if (isAppear && !appear && appear !== '') {
	    return
	  }
	
	  var startClass = isAppear && appearClass
	    ? appearClass
	    : enterClass;
	  var activeClass = isAppear && appearActiveClass
	    ? appearActiveClass
	    : enterActiveClass;
	  var toClass = isAppear && appearToClass
	    ? appearToClass
	    : enterToClass;
	
	  var beforeEnterHook = isAppear
	    ? (beforeAppear || beforeEnter)
	    : beforeEnter;
	  var enterHook = isAppear
	    ? (typeof appear === 'function' ? appear : enter)
	    : enter;
	  var afterEnterHook = isAppear
	    ? (afterAppear || afterEnter)
	    : afterEnter;
	  var enterCancelledHook = isAppear
	    ? (appearCancelled || enterCancelled)
	    : enterCancelled;
	
	  var explicitEnterDuration = toNumber(
	    isObject(duration)
	      ? duration.enter
	      : duration
	  );
	
	  if (false) {
	    checkDuration(explicitEnterDuration, 'enter', vnode);
	  }
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl = getHookArgumentsLength(enterHook);
	
	  var cb = el._enterCb = once(function () {
	    if (expectsCSS) {
	      removeTransitionClass(el, toClass);
	      removeTransitionClass(el, activeClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, startClass);
	      }
	      enterCancelledHook && enterCancelledHook(el);
	    } else {
	      afterEnterHook && afterEnterHook(el);
	    }
	    el._enterCb = null;
	  });
	
	  if (!vnode.data.show) {
	    // remove pending leave element on enter by injecting an insert hook
	    mergeVNodeHook(vnode, 'insert', function () {
	      var parent = el.parentNode;
	      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
	      if (pendingNode &&
	        pendingNode.tag === vnode.tag &&
	        pendingNode.elm._leaveCb
	      ) {
	        pendingNode.elm._leaveCb();
	      }
	      enterHook && enterHook(el, cb);
	    });
	  }
	
	  // start enter transition
	  beforeEnterHook && beforeEnterHook(el);
	  if (expectsCSS) {
	    addTransitionClass(el, startClass);
	    addTransitionClass(el, activeClass);
	    nextFrame(function () {
	      removeTransitionClass(el, startClass);
	      if (!cb.cancelled) {
	        addTransitionClass(el, toClass);
	        if (!userWantsControl) {
	          if (isValidDuration(explicitEnterDuration)) {
	            setTimeout(cb, explicitEnterDuration);
	          } else {
	            whenTransitionEnds(el, type, cb);
	          }
	        }
	      }
	    });
	  }
	
	  if (vnode.data.show) {
	    toggleDisplay && toggleDisplay();
	    enterHook && enterHook(el, cb);
	  }
	
	  if (!expectsCSS && !userWantsControl) {
	    cb();
	  }
	}
	
	function leave (vnode, rm) {
	  var el = vnode.elm;
	
	  // call enter callback now
	  if (isDef(el._enterCb)) {
	    el._enterCb.cancelled = true;
	    el._enterCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (isUndef(data) || el.nodeType !== 1) {
	    return rm()
	  }
	
	  /* istanbul ignore if */
	  if (isDef(el._leaveCb)) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var leaveClass = data.leaveClass;
	  var leaveToClass = data.leaveToClass;
	  var leaveActiveClass = data.leaveActiveClass;
	  var beforeLeave = data.beforeLeave;
	  var leave = data.leave;
	  var afterLeave = data.afterLeave;
	  var leaveCancelled = data.leaveCancelled;
	  var delayLeave = data.delayLeave;
	  var duration = data.duration;
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl = getHookArgumentsLength(leave);
	
	  var explicitLeaveDuration = toNumber(
	    isObject(duration)
	      ? duration.leave
	      : duration
	  );
	
	  if (false) {
	    checkDuration(explicitLeaveDuration, 'leave', vnode);
	  }
	
	  var cb = el._leaveCb = once(function () {
	    if (el.parentNode && el.parentNode._pending) {
	      el.parentNode._pending[vnode.key] = null;
	    }
	    if (expectsCSS) {
	      removeTransitionClass(el, leaveToClass);
	      removeTransitionClass(el, leaveActiveClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, leaveClass);
	      }
	      leaveCancelled && leaveCancelled(el);
	    } else {
	      rm();
	      afterLeave && afterLeave(el);
	    }
	    el._leaveCb = null;
	  });
	
	  if (delayLeave) {
	    delayLeave(performLeave);
	  } else {
	    performLeave();
	  }
	
	  function performLeave () {
	    // the delayed leave may have already been cancelled
	    if (cb.cancelled) {
	      return
	    }
	    // record leaving element
	    if (!vnode.data.show) {
	      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
	    }
	    beforeLeave && beforeLeave(el);
	    if (expectsCSS) {
	      addTransitionClass(el, leaveClass);
	      addTransitionClass(el, leaveActiveClass);
	      nextFrame(function () {
	        removeTransitionClass(el, leaveClass);
	        if (!cb.cancelled) {
	          addTransitionClass(el, leaveToClass);
	          if (!userWantsControl) {
	            if (isValidDuration(explicitLeaveDuration)) {
	              setTimeout(cb, explicitLeaveDuration);
	            } else {
	              whenTransitionEnds(el, type, cb);
	            }
	          }
	        }
	      });
	    }
	    leave && leave(el, cb);
	    if (!expectsCSS && !userWantsControl) {
	      cb();
	    }
	  }
	}
	
	// only used in dev mode
	function checkDuration (val, name, vnode) {
	  if (typeof val !== 'number') {
	    warn(
	      "<transition> explicit " + name + " duration is not a valid number - " +
	      "got " + (JSON.stringify(val)) + ".",
	      vnode.context
	    );
	  } else if (isNaN(val)) {
	    warn(
	      "<transition> explicit " + name + " duration is NaN - " +
	      'the duration expression might be incorrect.',
	      vnode.context
	    );
	  }
	}
	
	function isValidDuration (val) {
	  return typeof val === 'number' && !isNaN(val)
	}
	
	/**
	 * Normalize a transition hook's argument length. The hook may be:
	 * - a merged hook (invoker) with the original in .fns
	 * - a wrapped component method (check ._length)
	 * - a plain function (.length)
	 */
	function getHookArgumentsLength (fn) {
	  if (isUndef(fn)) {
	    return false
	  }
	  var invokerFns = fn.fns;
	  if (isDef(invokerFns)) {
	    // invoker
	    return getHookArgumentsLength(
	      Array.isArray(invokerFns)
	        ? invokerFns[0]
	        : invokerFns
	    )
	  } else {
	    return (fn._length || fn.length) > 1
	  }
	}
	
	function _enter (_, vnode) {
	  if (vnode.data.show !== true) {
	    enter(vnode);
	  }
	}
	
	var transition = inBrowser ? {
	  create: _enter,
	  activate: _enter,
	  remove: function remove$$1 (vnode, rm) {
	    /* istanbul ignore else */
	    if (vnode.data.show !== true) {
	      leave(vnode, rm);
	    } else {
	      rm();
	    }
	  }
	} : {}
	
	var platformModules = [
	  attrs,
	  klass,
	  events,
	  domProps,
	  style,
	  transition
	]
	
	/*  */
	
	// the directive module should be applied last, after all
	// built-in modules have been applied.
	var modules = platformModules.concat(baseModules);
	
	var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });
	
	/**
	 * Not type checking this file because flow doesn't like attaching
	 * properties to Elements.
	 */
	
	/* istanbul ignore if */
	if (isIE9) {
	  // http://www.matts411.com/post/internet-explorer-9-oninput/
	  document.addEventListener('selectionchange', function () {
	    var el = document.activeElement;
	    if (el && el.vmodel) {
	      trigger(el, 'input');
	    }
	  });
	}
	
	var directive = {
	  inserted: function inserted (el, binding, vnode, oldVnode) {
	    if (vnode.tag === 'select') {
	      // #6903
	      if (oldVnode.elm && !oldVnode.elm._vOptions) {
	        mergeVNodeHook(vnode, 'postpatch', function () {
	          directive.componentUpdated(el, binding, vnode);
	        });
	      } else {
	        setSelected(el, binding, vnode.context);
	      }
	      el._vOptions = [].map.call(el.options, getValue);
	    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
	      el._vModifiers = binding.modifiers;
	      if (!binding.modifiers.lazy) {
	        el.addEventListener('compositionstart', onCompositionStart);
	        el.addEventListener('compositionend', onCompositionEnd);
	        // Safari < 10.2 & UIWebView doesn't fire compositionend when
	        // switching focus before confirming composition choice
	        // this also fixes the issue where some browsers e.g. iOS Chrome
	        // fires "change" instead of "input" on autocomplete.
	        el.addEventListener('change', onCompositionEnd);
	        /* istanbul ignore if */
	        if (isIE9) {
	          el.vmodel = true;
	        }
	      }
	    }
	  },
	
	  componentUpdated: function componentUpdated (el, binding, vnode) {
	    if (vnode.tag === 'select') {
	      setSelected(el, binding, vnode.context);
	      // in case the options rendered by v-for have changed,
	      // it's possible that the value is out-of-sync with the rendered options.
	      // detect such cases and filter out values that no longer has a matching
	      // option in the DOM.
	      var prevOptions = el._vOptions;
	      var curOptions = el._vOptions = [].map.call(el.options, getValue);
	      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
	        // trigger change event if
	        // no matching option found for at least one value
	        var needReset = el.multiple
	          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
	          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
	        if (needReset) {
	          trigger(el, 'change');
	        }
	      }
	    }
	  }
	};
	
	function setSelected (el, binding, vm) {
	  actuallySetSelected(el, binding, vm);
	  /* istanbul ignore if */
	  if (isIE || isEdge) {
	    setTimeout(function () {
	      actuallySetSelected(el, binding, vm);
	    }, 0);
	  }
	}
	
	function actuallySetSelected (el, binding, vm) {
	  var value = binding.value;
	  var isMultiple = el.multiple;
	  if (isMultiple && !Array.isArray(value)) {
	    ("production") !== 'production' && warn(
	      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
	      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
	      vm
	    );
	    return
	  }
	  var selected, option;
	  for (var i = 0, l = el.options.length; i < l; i++) {
	    option = el.options[i];
	    if (isMultiple) {
	      selected = looseIndexOf(value, getValue(option)) > -1;
	      if (option.selected !== selected) {
	        option.selected = selected;
	      }
	    } else {
	      if (looseEqual(getValue(option), value)) {
	        if (el.selectedIndex !== i) {
	          el.selectedIndex = i;
	        }
	        return
	      }
	    }
	  }
	  if (!isMultiple) {
	    el.selectedIndex = -1;
	  }
	}
	
	function hasNoMatchingOption (value, options) {
	  return options.every(function (o) { return !looseEqual(o, value); })
	}
	
	function getValue (option) {
	  return '_value' in option
	    ? option._value
	    : option.value
	}
	
	function onCompositionStart (e) {
	  e.target.composing = true;
	}
	
	function onCompositionEnd (e) {
	  // prevent triggering an input event for no reason
	  if (!e.target.composing) { return }
	  e.target.composing = false;
	  trigger(e.target, 'input');
	}
	
	function trigger (el, type) {
	  var e = document.createEvent('HTMLEvents');
	  e.initEvent(type, true, true);
	  el.dispatchEvent(e);
	}
	
	/*  */
	
	// recursively search for possible transition defined inside the component root
	function locateNode (vnode) {
	  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
	    ? locateNode(vnode.componentInstance._vnode)
	    : vnode
	}
	
	var show = {
	  bind: function bind (el, ref, vnode) {
	    var value = ref.value;
	
	    vnode = locateNode(vnode);
	    var transition$$1 = vnode.data && vnode.data.transition;
	    var originalDisplay = el.__vOriginalDisplay =
	      el.style.display === 'none' ? '' : el.style.display;
	    if (value && transition$$1) {
	      vnode.data.show = true;
	      enter(vnode, function () {
	        el.style.display = originalDisplay;
	      });
	    } else {
	      el.style.display = value ? originalDisplay : 'none';
	    }
	  },
	
	  update: function update (el, ref, vnode) {
	    var value = ref.value;
	    var oldValue = ref.oldValue;
	
	    /* istanbul ignore if */
	    if (!value === !oldValue) { return }
	    vnode = locateNode(vnode);
	    var transition$$1 = vnode.data && vnode.data.transition;
	    if (transition$$1) {
	      vnode.data.show = true;
	      if (value) {
	        enter(vnode, function () {
	          el.style.display = el.__vOriginalDisplay;
	        });
	      } else {
	        leave(vnode, function () {
	          el.style.display = 'none';
	        });
	      }
	    } else {
	      el.style.display = value ? el.__vOriginalDisplay : 'none';
	    }
	  },
	
	  unbind: function unbind (
	    el,
	    binding,
	    vnode,
	    oldVnode,
	    isDestroy
	  ) {
	    if (!isDestroy) {
	      el.style.display = el.__vOriginalDisplay;
	    }
	  }
	}
	
	var platformDirectives = {
	  model: directive,
	  show: show
	}
	
	/*  */
	
	// Provides transition support for a single element/component.
	// supports transition mode (out-in / in-out)
	
	var transitionProps = {
	  name: String,
	  appear: Boolean,
	  css: Boolean,
	  mode: String,
	  type: String,
	  enterClass: String,
	  leaveClass: String,
	  enterToClass: String,
	  leaveToClass: String,
	  enterActiveClass: String,
	  leaveActiveClass: String,
	  appearClass: String,
	  appearActiveClass: String,
	  appearToClass: String,
	  duration: [Number, String, Object]
	};
	
	// in case the child is also an abstract component, e.g. <keep-alive>
	// we want to recursively retrieve the real component to be rendered
	function getRealChild (vnode) {
	  var compOptions = vnode && vnode.componentOptions;
	  if (compOptions && compOptions.Ctor.options.abstract) {
	    return getRealChild(getFirstComponentChild(compOptions.children))
	  } else {
	    return vnode
	  }
	}
	
	function extractTransitionData (comp) {
	  var data = {};
	  var options = comp.$options;
	  // props
	  for (var key in options.propsData) {
	    data[key] = comp[key];
	  }
	  // events.
	  // extract listeners and pass them directly to the transition methods
	  var listeners = options._parentListeners;
	  for (var key$1 in listeners) {
	    data[camelize(key$1)] = listeners[key$1];
	  }
	  return data
	}
	
	function placeholder (h, rawChild) {
	  if (/\d-keep-alive$/.test(rawChild.tag)) {
	    return h('keep-alive', {
	      props: rawChild.componentOptions.propsData
	    })
	  }
	}
	
	function hasParentTransition (vnode) {
	  while ((vnode = vnode.parent)) {
	    if (vnode.data.transition) {
	      return true
	    }
	  }
	}
	
	function isSameChild (child, oldChild) {
	  return oldChild.key === child.key && oldChild.tag === child.tag
	}
	
	var Transition = {
	  name: 'transition',
	  props: transitionProps,
	  abstract: true,
	
	  render: function render (h) {
	    var this$1 = this;
	
	    var children = this.$slots.default;
	    if (!children) {
	      return
	    }
	
	    // filter out text nodes (possible whitespaces)
	    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
	    /* istanbul ignore if */
	    if (!children.length) {
	      return
	    }
	
	    // warn multiple elements
	    if (false) {
	      warn(
	        '<transition> can only be used on a single element. Use ' +
	        '<transition-group> for lists.',
	        this.$parent
	      );
	    }
	
	    var mode = this.mode;
	
	    // warn invalid mode
	    if (false
	    ) {
	      warn(
	        'invalid <transition> mode: ' + mode,
	        this.$parent
	      );
	    }
	
	    var rawChild = children[0];
	
	    // if this is a component root node and the component's
	    // parent container node also has transition, skip.
	    if (hasParentTransition(this.$vnode)) {
	      return rawChild
	    }
	
	    // apply transition data to child
	    // use getRealChild() to ignore abstract components e.g. keep-alive
	    var child = getRealChild(rawChild);
	    /* istanbul ignore if */
	    if (!child) {
	      return rawChild
	    }
	
	    if (this._leaving) {
	      return placeholder(h, rawChild)
	    }
	
	    // ensure a key that is unique to the vnode type and to this transition
	    // component instance. This key will be used to remove pending leaving nodes
	    // during entering.
	    var id = "__transition-" + (this._uid) + "-";
	    child.key = child.key == null
	      ? child.isComment
	        ? id + 'comment'
	        : id + child.tag
	      : isPrimitive(child.key)
	        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
	        : child.key;
	
	    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
	    var oldRawChild = this._vnode;
	    var oldChild = getRealChild(oldRawChild);
	
	    // mark v-show
	    // so that the transition module can hand over the control to the directive
	    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
	      child.data.show = true;
	    }
	
	    if (
	      oldChild &&
	      oldChild.data &&
	      !isSameChild(child, oldChild) &&
	      !isAsyncPlaceholder(oldChild) &&
	      // #6687 component root is a comment node
	      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
	    ) {
	      // replace old child transition data with fresh one
	      // important for dynamic transitions!
	      var oldData = oldChild.data.transition = extend({}, data);
	      // handle transition mode
	      if (mode === 'out-in') {
	        // return placeholder node and queue update when leave finishes
	        this._leaving = true;
	        mergeVNodeHook(oldData, 'afterLeave', function () {
	          this$1._leaving = false;
	          this$1.$forceUpdate();
	        });
	        return placeholder(h, rawChild)
	      } else if (mode === 'in-out') {
	        if (isAsyncPlaceholder(child)) {
	          return oldRawChild
	        }
	        var delayedLeave;
	        var performLeave = function () { delayedLeave(); };
	        mergeVNodeHook(data, 'afterEnter', performLeave);
	        mergeVNodeHook(data, 'enterCancelled', performLeave);
	        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
	      }
	    }
	
	    return rawChild
	  }
	}
	
	/*  */
	
	// Provides transition support for list items.
	// supports move transitions using the FLIP technique.
	
	// Because the vdom's children update algorithm is "unstable" - i.e.
	// it doesn't guarantee the relative positioning of removed elements,
	// we force transition-group to update its children into two passes:
	// in the first pass, we remove all nodes that need to be removed,
	// triggering their leaving transition; in the second pass, we insert/move
	// into the final desired state. This way in the second pass removed
	// nodes will remain where they should be.
	
	var props = extend({
	  tag: String,
	  moveClass: String
	}, transitionProps);
	
	delete props.mode;
	
	var TransitionGroup = {
	  props: props,
	
	  render: function render (h) {
	    var tag = this.tag || this.$vnode.data.tag || 'span';
	    var map = Object.create(null);
	    var prevChildren = this.prevChildren = this.children;
	    var rawChildren = this.$slots.default || [];
	    var children = this.children = [];
	    var transitionData = extractTransitionData(this);
	
	    for (var i = 0; i < rawChildren.length; i++) {
	      var c = rawChildren[i];
	      if (c.tag) {
	        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
	          children.push(c);
	          map[c.key] = c
	          ;(c.data || (c.data = {})).transition = transitionData;
	        } else if (false) {
	          var opts = c.componentOptions;
	          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
	          warn(("<transition-group> children must be keyed: <" + name + ">"));
	        }
	      }
	    }
	
	    if (prevChildren) {
	      var kept = [];
	      var removed = [];
	      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
	        var c$1 = prevChildren[i$1];
	        c$1.data.transition = transitionData;
	        c$1.data.pos = c$1.elm.getBoundingClientRect();
	        if (map[c$1.key]) {
	          kept.push(c$1);
	        } else {
	          removed.push(c$1);
	        }
	      }
	      this.kept = h(tag, null, kept);
	      this.removed = removed;
	    }
	
	    return h(tag, null, children)
	  },
	
	  beforeUpdate: function beforeUpdate () {
	    // force removing pass
	    this.__patch__(
	      this._vnode,
	      this.kept,
	      false, // hydrating
	      true // removeOnly (!important, avoids unnecessary moves)
	    );
	    this._vnode = this.kept;
	  },
	
	  updated: function updated () {
	    var children = this.prevChildren;
	    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
	    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
	      return
	    }
	
	    // we divide the work into three loops to avoid mixing DOM reads and writes
	    // in each iteration - which helps prevent layout thrashing.
	    children.forEach(callPendingCbs);
	    children.forEach(recordPosition);
	    children.forEach(applyTranslation);
	
	    // force reflow to put everything in position
	    // assign to this to avoid being removed in tree-shaking
	    // $flow-disable-line
	    this._reflow = document.body.offsetHeight;
	
	    children.forEach(function (c) {
	      if (c.data.moved) {
	        var el = c.elm;
	        var s = el.style;
	        addTransitionClass(el, moveClass);
	        s.transform = s.WebkitTransform = s.transitionDuration = '';
	        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
	          if (!e || /transform$/.test(e.propertyName)) {
	            el.removeEventListener(transitionEndEvent, cb);
	            el._moveCb = null;
	            removeTransitionClass(el, moveClass);
	          }
	        });
	      }
	    });
	  },
	
	  methods: {
	    hasMove: function hasMove (el, moveClass) {
	      /* istanbul ignore if */
	      if (!hasTransition) {
	        return false
	      }
	      /* istanbul ignore if */
	      if (this._hasMove) {
	        return this._hasMove
	      }
	      // Detect whether an element with the move class applied has
	      // CSS transitions. Since the element may be inside an entering
	      // transition at this very moment, we make a clone of it and remove
	      // all other transition classes applied to ensure only the move class
	      // is applied.
	      var clone = el.cloneNode();
	      if (el._transitionClasses) {
	        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
	      }
	      addClass(clone, moveClass);
	      clone.style.display = 'none';
	      this.$el.appendChild(clone);
	      var info = getTransitionInfo(clone);
	      this.$el.removeChild(clone);
	      return (this._hasMove = info.hasTransform)
	    }
	  }
	}
	
	function callPendingCbs (c) {
	  /* istanbul ignore if */
	  if (c.elm._moveCb) {
	    c.elm._moveCb();
	  }
	  /* istanbul ignore if */
	  if (c.elm._enterCb) {
	    c.elm._enterCb();
	  }
	}
	
	function recordPosition (c) {
	  c.data.newPos = c.elm.getBoundingClientRect();
	}
	
	function applyTranslation (c) {
	  var oldPos = c.data.pos;
	  var newPos = c.data.newPos;
	  var dx = oldPos.left - newPos.left;
	  var dy = oldPos.top - newPos.top;
	  if (dx || dy) {
	    c.data.moved = true;
	    var s = c.elm.style;
	    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
	    s.transitionDuration = '0s';
	  }
	}
	
	var platformComponents = {
	  Transition: Transition,
	  TransitionGroup: TransitionGroup
	}
	
	/*  */
	
	// install platform specific utils
	Vue.config.mustUseProp = mustUseProp;
	Vue.config.isReservedTag = isReservedTag;
	Vue.config.isReservedAttr = isReservedAttr;
	Vue.config.getTagNamespace = getTagNamespace;
	Vue.config.isUnknownElement = isUnknownElement;
	
	// install platform runtime directives & components
	extend(Vue.options.directives, platformDirectives);
	extend(Vue.options.components, platformComponents);
	
	// install platform patch function
	Vue.prototype.__patch__ = inBrowser ? patch : noop;
	
	// public mount method
	Vue.prototype.$mount = function (
	  el,
	  hydrating
	) {
	  el = el && inBrowser ? query(el) : undefined;
	  return mountComponent(this, el, hydrating)
	};
	
	// devtools global hook
	/* istanbul ignore next */
	if (inBrowser) {
	  setTimeout(function () {
	    if (config.devtools) {
	      if (devtools) {
	        devtools.emit('init', Vue);
	      } else if (
	        false
	      ) {
	        console[console.info ? 'info' : 'log'](
	          'Download the Vue Devtools extension for a better development experience:\n' +
	          'https://github.com/vuejs/vue-devtools'
	        );
	      }
	    }
	    if (false
	    ) {
	      console[console.info ? 'info' : 'log'](
	        "You are running Vue in development mode.\n" +
	        "Make sure to turn on production mode when deploying for production.\n" +
	        "See more tips at https://vuejs.org/guide/deployment.html"
	      );
	    }
	  }, 0);
	}
	
	/*  */
	
	module.exports = Vue;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(307).setImmediate))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.BORDER_UNSET_TOP_BOTTOM = exports.BORDER_TOP_BOTTOM = exports.BORDER_SURROUND = exports.BORDER_BOTTOM = exports.BORDER_LEFT = exports.BORDER_TOP = exports.BORDER = exports.WHITE = exports.GREEN = exports.BLUE = exports.RED = void 0;
	// color
	var RED = '#ee0a24';
	exports.RED = RED;
	var BLUE = '#1989fa';
	exports.BLUE = BLUE;
	var GREEN = '#07c160';
	exports.GREEN = GREEN;
	var WHITE = '#fff'; // border
	
	exports.WHITE = WHITE;
	var BORDER = 'van-hairline';
	exports.BORDER = BORDER;
	var BORDER_TOP = BORDER + "--top";
	exports.BORDER_TOP = BORDER_TOP;
	var BORDER_LEFT = BORDER + "--left";
	exports.BORDER_LEFT = BORDER_LEFT;
	var BORDER_BOTTOM = BORDER + "--bottom";
	exports.BORDER_BOTTOM = BORDER_BOTTOM;
	var BORDER_SURROUND = BORDER + "--surround";
	exports.BORDER_SURROUND = BORDER_SURROUND;
	var BORDER_TOP_BOTTOM = BORDER + "--top-bottom";
	exports.BORDER_TOP_BOTTOM = BORDER_TOP_BOTTOM;
	var BORDER_UNSET_TOP_BOTTOM = BORDER + "-unset--top-bottom";
	exports.BORDER_UNSET_TOP_BOTTOM = BORDER_UNSET_TOP_BOTTOM;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _info = _interopRequireDefault(__webpack_require__(35));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('icon'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function isImage(name) {
	  return name ? name.indexOf('/') !== -1 : false;
	} // compatible with legacy usage, should be removed in next major version
	
	
	var LEGACY_MAP = {
	  medel: 'medal',
	  'medel-o': 'medal-o'
	};
	
	function correctName(name) {
	  return name && LEGACY_MAP[name] || name;
	}
	
	function Icon(h, props, slots, ctx) {
	  var name = correctName(props.name);
	  var imageIcon = isImage(name);
	  return h(props.tag, (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": [props.classPrefix, imageIcon ? '' : props.classPrefix + "-" + name],
	    "style": {
	      color: props.color,
	      fontSize: (0, _utils.addUnit)(props.size)
	    }
	  }, (0, _functional.inherit)(ctx, true)]), [slots.default && slots.default(), imageIcon && h("img", {
	    "class": bem('image'),
	    "attrs": {
	      "src": name
	    }
	  }), h(_info.default, {
	    "attrs": {
	      "dot": props.dot,
	      "info": props.info
	    }
	  })]);
	}
	
	Icon.props = {
	  dot: Boolean,
	  name: String,
	  size: [Number, String],
	  info: [Number, String],
	  color: String,
	  tag: {
	    type: String,
	    default: 'i'
	  },
	  classPrefix: {
	    type: String,
	    default: bem()
	  }
	};
	
	var _default = createComponent(Icon);
	
	exports.default = _default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.ChildrenMixin = ChildrenMixin;
	exports.ParentMixin = ParentMixin;
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	function flattenVNodes(vnodes) {
	  var result = [];
	
	  function traverse(vnodes) {
	    vnodes.forEach(function (vnode) {
	      result.push(vnode);
	
	      if (vnode.children) {
	        traverse(vnode.children);
	      }
	    });
	  }
	
	  traverse(vnodes);
	  return result;
	}
	
	function ChildrenMixin(_parent, options) {
	  var _inject, _computed;
	
	  if (options === void 0) {
	    options = {};
	  }
	
	  var indexKey = options.indexKey || 'index';
	  return _vue.default.extend({
	    inject: (_inject = {}, _inject[_parent] = {
	      default: null
	    }, _inject),
	    computed: (_computed = {
	      parent: function parent() {
	        if (this.disableBindRelation) {
	          return null;
	        }
	
	        return this[_parent];
	      }
	    }, _computed[indexKey] = function () {
	      this.bindRelation();
	      return this.parent.children.indexOf(this);
	    }, _computed),
	    mounted: function mounted() {
	      this.bindRelation();
	    },
	    beforeDestroy: function beforeDestroy() {
	      var _this = this;
	
	      if (this.parent) {
	        this.parent.children = this.parent.children.filter(function (item) {
	          return item !== _this;
	        });
	      }
	    },
	    methods: {
	      bindRelation: function bindRelation() {
	        if (!this.parent || this.parent.children.indexOf(this) !== -1) {
	          return;
	        }
	
	        var children = [].concat(this.parent.children, [this]);
	        var vnodes = flattenVNodes(this.parent.slots());
	        children.sort(function (a, b) {
	          return vnodes.indexOf(a.$vnode) - vnodes.indexOf(b.$vnode);
	        });
	        this.parent.children = children;
	      }
	    }
	  });
	}
	
	function ParentMixin(parent) {
	  return {
	    provide: function provide() {
	      var _ref;
	
	      return _ref = {}, _ref[parent] = this, _ref;
	    },
	    data: function data() {
	      return {
	        children: []
	      };
	    }
	  };
	}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.on = on;
	exports.off = off;
	exports.stopPropagation = stopPropagation;
	exports.preventDefault = preventDefault;
	exports.supportsPassive = void 0;
	
	var _ = __webpack_require__(1);
	
	// eslint-disable-next-line import/no-mutable-exports
	var supportsPassive = false;
	exports.supportsPassive = supportsPassive;
	
	if (!_.isServer) {
	  try {
	    var opts = {};
	    Object.defineProperty(opts, 'passive', {
	      // eslint-disable-next-line getter-return
	      get: function get() {
	        /* istanbul ignore next */
	        exports.supportsPassive = supportsPassive = true;
	      }
	    });
	    window.addEventListener('test-passive', null, opts); // eslint-disable-next-line no-empty
	  } catch (e) {}
	}
	
	function on(target, event, handler, passive) {
	  if (passive === void 0) {
	    passive = false;
	  }
	
	  if (!_.isServer) {
	    target.addEventListener(event, handler, supportsPassive ? {
	      capture: false,
	      passive: passive
	    } : false);
	  }
	}
	
	function off(target, event, handler) {
	  if (!_.isServer) {
	    target.removeEventListener(event, handler);
	  }
	}
	
	function stopPropagation(event) {
	  event.stopPropagation();
	}
	
	function preventDefault(event, isStopPropagation) {
	  /* istanbul ignore else */
	  if (typeof event.cancelable !== 'boolean' || event.cancelable) {
	    event.preventDefault();
	  }
	
	  if (isStopPropagation) {
	    stopPropagation(event);
	  }
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warning = undefined;
	
	var _extends2 = __webpack_require__(67);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.format = format;
	exports.isEmptyValue = isEmptyValue;
	exports.isEmptyObject = isEmptyObject;
	exports.asyncMap = asyncMap;
	exports.complementError = complementError;
	exports.deepMerge = deepMerge;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var formatRegExp = /%[sdj%]/g;
	
	var warning = exports.warning = function warning() {};
	
	// don't print warning message when in production env or node runtime
	if (false) {
	  exports.warning = warning = function warning(type, errors) {
	    if (typeof console !== 'undefined' && console.warn) {
	      if (errors.every(function (e) {
	        return typeof e === 'string';
	      })) {
	        console.warn(type, errors);
	      }
	    }
	  };
	}
	
	function format() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var i = 1;
	  var f = args[0];
	  var len = args.length;
	  if (typeof f === 'function') {
	    return f.apply(null, args.slice(1));
	  }
	  if (typeof f === 'string') {
	    var str = String(f).replace(formatRegExp, function (x) {
	      if (x === '%%') {
	        return '%';
	      }
	      if (i >= len) {
	        return x;
	      }
	      switch (x) {
	        case '%s':
	          return String(args[i++]);
	        case '%d':
	          return Number(args[i++]);
	        case '%j':
	          try {
	            return JSON.stringify(args[i++]);
	          } catch (_) {
	            return '[Circular]';
	          }
	          break;
	        default:
	          return x;
	      }
	    });
	    for (var arg = args[i]; i < len; arg = args[++i]) {
	      str += ' ' + arg;
	    }
	    return str;
	  }
	  return f;
	}
	
	function isNativeStringType(type) {
	  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
	}
	
	function isEmptyValue(value, type) {
	  if (value === undefined || value === null) {
	    return true;
	  }
	  if (type === 'array' && Array.isArray(value) && !value.length) {
	    return true;
	  }
	  if (isNativeStringType(type) && typeof value === 'string' && !value) {
	    return true;
	  }
	  return false;
	}
	
	function isEmptyObject(obj) {
	  return Object.keys(obj).length === 0;
	}
	
	function asyncParallelArray(arr, func, callback) {
	  var results = [];
	  var total = 0;
	  var arrLength = arr.length;
	
	  function count(errors) {
	    results.push.apply(results, errors);
	    total++;
	    if (total === arrLength) {
	      callback(results);
	    }
	  }
	
	  arr.forEach(function (a) {
	    func(a, count);
	  });
	}
	
	function asyncSerialArray(arr, func, callback) {
	  var index = 0;
	  var arrLength = arr.length;
	
	  function next(errors) {
	    if (errors && errors.length) {
	      callback(errors);
	      return;
	    }
	    var original = index;
	    index = index + 1;
	    if (original < arrLength) {
	      func(arr[original], next);
	    } else {
	      callback([]);
	    }
	  }
	
	  next([]);
	}
	
	function flattenObjArr(objArr) {
	  var ret = [];
	  Object.keys(objArr).forEach(function (k) {
	    ret.push.apply(ret, objArr[k]);
	  });
	  return ret;
	}
	
	function asyncMap(objArr, option, func, callback) {
	  if (option.first) {
	    var flattenArr = flattenObjArr(objArr);
	    return asyncSerialArray(flattenArr, func, callback);
	  }
	  var firstFields = option.firstFields || [];
	  if (firstFields === true) {
	    firstFields = Object.keys(objArr);
	  }
	  var objArrKeys = Object.keys(objArr);
	  var objArrLength = objArrKeys.length;
	  var total = 0;
	  var results = [];
	  var next = function next(errors) {
	    results.push.apply(results, errors);
	    total++;
	    if (total === objArrLength) {
	      callback(results);
	    }
	  };
	  objArrKeys.forEach(function (key) {
	    var arr = objArr[key];
	    if (firstFields.indexOf(key) !== -1) {
	      asyncSerialArray(arr, func, next);
	    } else {
	      asyncParallelArray(arr, func, next);
	    }
	  });
	}
	
	function complementError(rule) {
	  return function (oe) {
	    if (oe && oe.message) {
	      oe.field = oe.field || rule.fullField;
	      return oe;
	    }
	    return {
	      message: oe,
	      field: oe.field || rule.fullField
	    };
	  };
	}
	
	function deepMerge(target, source) {
	  if (source) {
	    for (var s in source) {
	      if (source.hasOwnProperty(s)) {
	        var value = source[s];
	        if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) === 'object' && (0, _typeof3['default'])(target[s]) === 'object') {
	          target[s] = (0, _extends3['default'])({}, target[s], value);
	        } else {
	          target[s] = value;
	        }
	      }
	    }
	  }
	  return target;
	}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _required = __webpack_require__(102);
	
	var _required2 = _interopRequireDefault(_required);
	
	var _whitespace = __webpack_require__(184);
	
	var _whitespace2 = _interopRequireDefault(_whitespace);
	
	var _type = __webpack_require__(183);
	
	var _type2 = _interopRequireDefault(_type);
	
	var _range = __webpack_require__(182);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _enum = __webpack_require__(180);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	var _pattern = __webpack_require__(181);
	
	var _pattern2 = _interopRequireDefault(_pattern);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  required: _required2['default'],
	  whitespace: _whitespace2['default'],
	  type: _type2['default'],
	  range: _range2['default'],
	  'enum': _enum2['default'],
	  pattern: _pattern2['default']
	};
	module.exports = exports['default'];

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(74)('wks');
	var uid = __webpack_require__(55);
	var Symbol = __webpack_require__(13).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _router = __webpack_require__(24);
	
	var _shared = __webpack_require__(92);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('cell'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function Cell(h, props, slots, ctx) {
	  var icon = props.icon,
	      size = props.size,
	      title = props.title,
	      label = props.label,
	      value = props.value,
	      isLink = props.isLink;
	  var showTitle = slots.title || (0, _utils.isDef)(title);
	
	  function Label() {
	    var showLabel = slots.label || (0, _utils.isDef)(label);
	
	    if (showLabel) {
	      return h("div", {
	        "class": [bem('label'), props.labelClass]
	      }, [slots.label ? slots.label() : label]);
	    }
	  }
	
	  function Title() {
	    if (showTitle) {
	      return h("div", {
	        "class": [bem('title'), props.titleClass],
	        "style": props.titleStyle
	      }, [slots.title ? slots.title() : h("span", [title]), Label()]);
	    }
	  }
	
	  function Value() {
	    var showValue = slots.default || (0, _utils.isDef)(value);
	
	    if (showValue) {
	      return h("div", {
	        "class": [bem('value', {
	          alone: !showTitle
	        }), props.valueClass]
	      }, [slots.default ? slots.default() : h("span", [value])]);
	    }
	  }
	
	  function LeftIcon() {
	    if (slots.icon) {
	      return slots.icon();
	    }
	
	    if (icon) {
	      return h(_icon.default, {
	        "class": bem('left-icon'),
	        "attrs": {
	          "name": icon,
	          "classPrefix": props.iconPrefix
	        }
	      });
	    }
	  }
	
	  function RightIcon() {
	    var rightIconSlot = slots['right-icon'];
	
	    if (rightIconSlot) {
	      return rightIconSlot();
	    }
	
	    if (isLink) {
	      var arrowDirection = props.arrowDirection;
	      return h(_icon.default, {
	        "class": bem('right-icon'),
	        "attrs": {
	          "name": arrowDirection ? "arrow-" + arrowDirection : 'arrow'
	        }
	      });
	    }
	  }
	
	  function onClick(event) {
	    (0, _functional.emit)(ctx, 'click', event);
	    (0, _router.functionalRoute)(ctx);
	  }
	
	  var clickable = isLink || props.clickable;
	  var classes = {
	    clickable: clickable,
	    center: props.center,
	    required: props.required,
	    borderless: !props.border
	  };
	
	  if (size) {
	    classes[size] = size;
	  }
	
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem(classes),
	    "attrs": {
	      "role": clickable ? 'button' : null,
	      "tabindex": clickable ? 0 : null
	    },
	    "on": {
	      "click": onClick
	    }
	  }, (0, _functional.inherit)(ctx)]), [LeftIcon(), Title(), Value(), RightIcon(), slots.extra == null ? void 0 : slots.extra()]);
	}
	
	Cell.props = (0, _extends2.default)({}, _shared.cellProps, {}, _router.routeProps);
	
	var _default = createComponent(Cell);
	
	exports.default = _default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(107);
	var isBuffer = __webpack_require__(294);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _constant = __webpack_require__(7);
	
	var _router = __webpack_require__(24);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _loading = _interopRequireDefault(__webpack_require__(18));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('button'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function Button(h, props, slots, ctx) {
	  var _ref;
	
	  var tag = props.tag,
	      icon = props.icon,
	      type = props.type,
	      color = props.color,
	      plain = props.plain,
	      disabled = props.disabled,
	      loading = props.loading,
	      hairline = props.hairline,
	      loadingText = props.loadingText;
	  var style = {};
	
	  if (color) {
	    style.color = plain ? color : _constant.WHITE;
	
	    if (!plain) {
	      // Use background instead of backgroundColor to make linear-gradient work
	      style.background = color;
	    } // hide border when color is linear-gradient
	
	
	    if (color.indexOf('gradient') !== -1) {
	      style.border = 0;
	    } else {
	      style.borderColor = color;
	    }
	  }
	
	  function onClick(event) {
	    if (!loading && !disabled) {
	      (0, _functional.emit)(ctx, 'click', event);
	      (0, _router.functionalRoute)(ctx);
	    }
	  }
	
	  function onTouchstart(event) {
	    (0, _functional.emit)(ctx, 'touchstart', event);
	  }
	
	  var classes = [bem([type, props.size, {
	    plain: plain,
	    loading: loading,
	    disabled: disabled,
	    hairline: hairline,
	    block: props.block,
	    round: props.round,
	    square: props.square
	  }]), (_ref = {}, _ref[_constant.BORDER_SURROUND] = hairline, _ref)];
	
	  function Content() {
	    var content = [];
	
	    if (loading) {
	      content.push(h(_loading.default, {
	        "class": bem('loading'),
	        "attrs": {
	          "size": props.loadingSize,
	          "type": props.loadingType,
	          "color": "currentColor"
	        }
	      }));
	    } else if (icon) {
	      content.push(h(_icon.default, {
	        "attrs": {
	          "name": icon,
	          "classPrefix": props.iconPrefix
	        },
	        "class": bem('icon')
	      }));
	    }
	
	    var text;
	
	    if (loading) {
	      text = loadingText;
	    } else {
	      text = slots.default ? slots.default() : props.text;
	    }
	
	    if (text) {
	      content.push(h("span", {
	        "class": bem('text')
	      }, [text]));
	    }
	
	    return content;
	  }
	
	  return h(tag, (0, _babelHelperVueJsxMergeProps.default)([{
	    "style": style,
	    "class": classes,
	    "attrs": {
	      "type": props.nativeType,
	      "disabled": disabled
	    },
	    "on": {
	      "click": onClick,
	      "touchstart": onTouchstart
	    }
	  }, (0, _functional.inherit)(ctx)]), [Content()]);
	}
	
	Button.props = (0, _extends2.default)({}, _router.routeProps, {
	  text: String,
	  icon: String,
	  color: String,
	  block: Boolean,
	  plain: Boolean,
	  round: Boolean,
	  square: Boolean,
	  loading: Boolean,
	  hairline: Boolean,
	  disabled: Boolean,
	  nativeType: String,
	  loadingText: String,
	  loadingType: String,
	  tag: {
	    type: String,
	    default: 'button'
	  },
	  type: {
	    type: String,
	    default: 'default'
	  },
	  size: {
	    type: String,
	    default: 'normal'
	  },
	  loadingSize: {
	    type: String,
	    default: '20px'
	  }
	});
	
	var _default = createComponent(Button);
	
	exports.default = _default;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	// Utils
	var _createNamespace = (0, _utils.createNamespace)('loading'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function LoadingIcon(h, props) {
	  if (props.type === 'spinner') {
	    var Spin = [];
	
	    for (var i = 0; i < 12; i++) {
	      Spin.push(h("i"));
	    }
	
	    return Spin;
	  }
	
	  return h("svg", {
	    "class": bem('circular'),
	    "attrs": {
	      "viewBox": "25 25 50 50"
	    }
	  }, [h("circle", {
	    "attrs": {
	      "cx": "50",
	      "cy": "50",
	      "r": "20",
	      "fill": "none"
	    }
	  })]);
	}
	
	function LoadingText(h, props, slots) {
	  if (slots.default) {
	    var style = props.textSize && {
	      fontSize: (0, _utils.addUnit)(props.textSize)
	    };
	    return h("span", {
	      "class": bem('text'),
	      "style": style
	    }, [slots.default()]);
	  }
	}
	
	function Loading(h, props, slots, ctx) {
	  var color = props.color,
	      size = props.size,
	      type = props.type;
	  var style = {
	    color: color
	  };
	
	  if (size) {
	    var iconSize = (0, _utils.addUnit)(size);
	    style.width = iconSize;
	    style.height = iconSize;
	  }
	
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem([type, {
	      vertical: props.vertical
	    }])
	  }, (0, _functional.inherit)(ctx, true)]), [h("span", {
	    "class": bem('spinner', type),
	    "style": style
	  }, [LoadingIcon(h, props)]), LoadingText(h, props, slots)]);
	}
	
	Loading.props = {
	  color: String,
	  size: [Number, String],
	  vertical: Boolean,
	  textSize: [Number, String],
	  type: {
	    type: String,
	    default: 'circular'
	  }
	};
	
	var _default = createComponent(Loading);
	
	exports.default = _default;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.TouchMixin = void 0;
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	var _event = __webpack_require__(10);
	
	var MIN_DISTANCE = 10;
	
	function getDirection(x, y) {
	  if (x > y && x > MIN_DISTANCE) {
	    return 'horizontal';
	  }
	
	  if (y > x && y > MIN_DISTANCE) {
	    return 'vertical';
	  }
	
	  return '';
	}
	
	var TouchMixin = _vue.default.extend({
	  data: function data() {
	    return {
	      direction: ''
	    };
	  },
	  methods: {
	    touchStart: function touchStart(event) {
	      this.resetTouchStatus();
	      this.startX = event.touches[0].clientX;
	      this.startY = event.touches[0].clientY;
	    },
	    touchMove: function touchMove(event) {
	      var touch = event.touches[0];
	      this.deltaX = touch.clientX - this.startX;
	      this.deltaY = touch.clientY - this.startY;
	      this.offsetX = Math.abs(this.deltaX);
	      this.offsetY = Math.abs(this.deltaY);
	      this.direction = this.direction || getDirection(this.offsetX, this.offsetY);
	    },
	    resetTouchStatus: function resetTouchStatus() {
	      this.direction = '';
	      this.deltaX = 0;
	      this.deltaY = 0;
	      this.offsetX = 0;
	      this.offsetY = 0;
	    },
	    // avoid Vue 2.6 event bubble issues by manually binding events
	    // https://github.com/youzan/vant/issues/3015
	    bindTouchEvent: function bindTouchEvent(el) {
	      var _ref = this,
	          onTouchStart = _ref.onTouchStart,
	          onTouchMove = _ref.onTouchMove,
	          onTouchEnd = _ref.onTouchEnd;
	
	      (0, _event.on)(el, 'touchstart', onTouchStart);
	      (0, _event.on)(el, 'touchmove', onTouchMove);
	
	      if (onTouchEnd) {
	        (0, _event.on)(el, 'touchend', onTouchEnd);
	        (0, _event.on)(el, 'touchcancel', onTouchEnd);
	      }
	    }
	  }
	});
	
	exports.TouchMixin = TouchMixin;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.0' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isEmpty = exports.isEqual = exports.arrayEquals = exports.looseEqual = exports.capitalize = exports.kebabCase = exports.autoprefixer = exports.isFirefox = exports.isEdge = exports.isIE = exports.coerceTruthyValueToArray = exports.arrayFind = exports.arrayFindIndex = exports.escapeRegexpString = exports.valueEquals = exports.generateId = exports.getValueByPath = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.noop = noop;
	exports.hasOwn = hasOwn;
	exports.toObject = toObject;
	exports.getPropByPath = getPropByPath;
	exports.rafThrottle = rafThrottle;
	exports.objToArray = objToArray;
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _types = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function noop() {};
	
	function hasOwn(obj, key) {
	  return hasOwnProperty.call(obj, key);
	};
	
	function extend(to, _from) {
	  for (var key in _from) {
	    to[key] = _from[key];
	  }
	  return to;
	};
	
	function toObject(arr) {
	  var res = {};
	  for (var i = 0; i < arr.length; i++) {
	    if (arr[i]) {
	      extend(res, arr[i]);
	    }
	  }
	  return res;
	};
	
	var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
	  prop = prop || '';
	  var paths = prop.split('.');
	  var current = object;
	  var result = null;
	  for (var i = 0, j = paths.length; i < j; i++) {
	    var path = paths[i];
	    if (!current) break;
	
	    if (i === j - 1) {
	      result = current[path];
	      break;
	    }
	    current = current[path];
	  }
	  return result;
	};
	
	function getPropByPath(obj, path, strict) {
	  var tempObj = obj;
	  path = path.replace(/\[(\w+)\]/g, '.$1');
	  path = path.replace(/^\./, '');
	
	  var keyArr = path.split('.');
	  var i = 0;
	  for (var len = keyArr.length; i < len - 1; ++i) {
	    if (!tempObj && !strict) break;
	    var key = keyArr[i];
	    if (key in tempObj) {
	      tempObj = tempObj[key];
	    } else {
	      if (strict) {
	        throw new Error('please transfer a valid prop path to form item!');
	      }
	      break;
	    }
	  }
	  return {
	    o: tempObj,
	    k: keyArr[i],
	    v: tempObj ? tempObj[keyArr[i]] : null
	  };
	};
	
	var generateId = exports.generateId = function generateId() {
	  return Math.floor(Math.random() * 10000);
	};
	
	var valueEquals = exports.valueEquals = function valueEquals(a, b) {
	  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
	  if (a === b) return true;
	  if (!(a instanceof Array)) return false;
	  if (!(b instanceof Array)) return false;
	  if (a.length !== b.length) return false;
	  for (var i = 0; i !== a.length; ++i) {
	    if (a[i] !== b[i]) return false;
	  }
	  return true;
	};
	
	var escapeRegexpString = exports.escapeRegexpString = function escapeRegexpString() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
	};
	
	// TODO: use native Array.find, Array.findIndex when IE support is dropped
	var arrayFindIndex = exports.arrayFindIndex = function arrayFindIndex(arr, pred) {
	  for (var i = 0; i !== arr.length; ++i) {
	    if (pred(arr[i])) {
	      return i;
	    }
	  }
	  return -1;
	};
	
	var arrayFind = exports.arrayFind = function arrayFind(arr, pred) {
	  var idx = arrayFindIndex(arr, pred);
	  return idx !== -1 ? arr[idx] : undefined;
	};
	
	// coerce truthy value to array
	var coerceTruthyValueToArray = exports.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
	  if (Array.isArray(val)) {
	    return val;
	  } else if (val) {
	    return [val];
	  } else {
	    return [];
	  }
	};
	
	var isIE = exports.isIE = function isIE() {
	  return !_vue2.default.prototype.$isServer && !isNaN(Number(document.documentMode));
	};
	
	var isEdge = exports.isEdge = function isEdge() {
	  return !_vue2.default.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
	};
	
	var isFirefox = exports.isFirefox = function isFirefox() {
	  return !_vue2.default.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
	};
	
	var autoprefixer = exports.autoprefixer = function autoprefixer(style) {
	  if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') return style;
	  var rules = ['transform', 'transition', 'animation'];
	  var prefixes = ['ms-', 'webkit-'];
	  rules.forEach(function (rule) {
	    var value = style[rule];
	    if (rule && value) {
	      prefixes.forEach(function (prefix) {
	        style[prefix + rule] = value;
	      });
	    }
	  });
	  return style;
	};
	
	var kebabCase = exports.kebabCase = function kebabCase(str) {
	  var hyphenateRE = /([^-])([A-Z])/g;
	  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
	};
	
	var capitalize = exports.capitalize = function capitalize(str) {
	  if (!(0, _types.isString)(str)) return str;
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	var looseEqual = exports.looseEqual = function looseEqual(a, b) {
	  var isObjectA = (0, _types.isObject)(a);
	  var isObjectB = (0, _types.isObject)(b);
	  if (isObjectA && isObjectB) {
	    return JSON.stringify(a) === JSON.stringify(b);
	  } else if (!isObjectA && !isObjectB) {
	    return String(a) === String(b);
	  } else {
	    return false;
	  }
	};
	
	var arrayEquals = exports.arrayEquals = function arrayEquals(arrayA, arrayB) {
	  arrayA = arrayA || [];
	  arrayB = arrayB || [];
	
	  if (arrayA.length !== arrayB.length) {
	    return false;
	  }
	
	  for (var i = 0; i < arrayA.length; i++) {
	    if (!looseEqual(arrayA[i], arrayB[i])) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var isEqual = exports.isEqual = function isEqual(value1, value2) {
	  if (Array.isArray(value1) && Array.isArray(value2)) {
	    return arrayEquals(value1, value2);
	  }
	  return looseEqual(value1, value2);
	};
	
	var isEmpty = exports.isEmpty = function isEmpty(val) {
	  // null or undefined
	  if (val == null) return true;
	
	  if (typeof val === 'boolean') return false;
	
	  if (typeof val === 'number') return !val;
	
	  if (val instanceof Error) return val.message === '';
	
	  switch (Object.prototype.toString.call(val)) {
	    // String or Array
	    case '[object String]':
	    case '[object Array]':
	      return !val.length;
	
	    // Map or Set or File
	    case '[object File]':
	    case '[object Map]':
	    case '[object Set]':
	      {
	        return !val.size;
	      }
	    // Plain Object
	    case '[object Object]':
	      {
	        return !Object.keys(val).length;
	      }
	  }
	
	  return false;
	};
	
	function rafThrottle(fn) {
	  var locked = false;
	  return function () {
	    var _this = this;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (locked) return;
	    locked = true;
	    window.requestAnimationFrame(function (_) {
	      fn.apply(_this, args);
	      locked = false;
	    });
	  };
	}
	
	function objToArray(obj) {
	  if (Array.isArray(obj)) {
	    return obj;
	  }
	  return isEmpty(obj) ? [] : [obj];
	}

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.getScroller = getScroller;
	exports.getScrollTop = getScrollTop;
	exports.setScrollTop = setScrollTop;
	exports.getRootScrollTop = getRootScrollTop;
	exports.setRootScrollTop = setRootScrollTop;
	exports.getElementTop = getElementTop;
	exports.getVisibleHeight = getVisibleHeight;
	exports.getVisibleTop = getVisibleTop;
	
	function isWindow(val) {
	  return val === window;
	} // get nearest scroll element
	// http://w3help.org/zh-cn/causes/SD9013
	// http://stackoverflow.com/questions/17016740/onscroll-function-is-not-working-for-chrome
	
	
	var overflowScrollReg = /scroll|auto/i;
	
	function getScroller(el, root) {
	  if (root === void 0) {
	    root = window;
	  }
	
	  var node = el;
	
	  while (node && node.tagName !== 'HTML' && node.nodeType === 1 && node !== root) {
	    var _window$getComputedSt = window.getComputedStyle(node),
	        overflowY = _window$getComputedSt.overflowY;
	
	    if (overflowScrollReg.test(overflowY)) {
	      if (node.tagName !== 'BODY') {
	        return node;
	      } // see: https://github.com/youzan/vant/issues/3823
	
	
	      var _window$getComputedSt2 = window.getComputedStyle(node.parentNode),
	          htmlOverflowY = _window$getComputedSt2.overflowY;
	
	      if (overflowScrollReg.test(htmlOverflowY)) {
	        return node;
	      }
	    }
	
	    node = node.parentNode;
	  }
	
	  return root;
	}
	
	function getScrollTop(el) {
	  return 'scrollTop' in el ? el.scrollTop : el.pageYOffset;
	}
	
	function setScrollTop(el, value) {
	  if ('scrollTop' in el) {
	    el.scrollTop = value;
	  } else {
	    el.scrollTo(el.scrollX, value);
	  }
	}
	
	function getRootScrollTop() {
	  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
	}
	
	function setRootScrollTop(value) {
	  setScrollTop(window, value);
	  setScrollTop(document.body, value);
	} // get distance from element top to page top or scroller top
	
	
	function getElementTop(el, scroller) {
	  if (isWindow(el)) {
	    return 0;
	  }
	
	  var scrollTop = scroller ? getScrollTop(scroller) : getRootScrollTop();
	  return el.getBoundingClientRect().top + scrollTop;
	}
	
	function getVisibleHeight(el) {
	  if (isWindow(el)) {
	    return el.innerHeight;
	  }
	
	  return el.getBoundingClientRect().height;
	}
	
	function getVisibleTop(el) {
	  if (isWindow(el)) {
	    return 0;
	  }
	
	  return el.getBoundingClientRect().top;
	}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isInContainer = exports.getScrollContainer = exports.isScroll = exports.getStyle = exports.once = exports.off = exports.on = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* istanbul ignore next */
	
	exports.hasClass = hasClass;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	exports.setStyle = setStyle;
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isServer = _vue2.default.prototype.$isServer;
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var ieVersion = isServer ? 0 : Number(document.documentMode);
	
	/* istanbul ignore next */
	var trim = function trim(string) {
	  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
	};
	/* istanbul ignore next */
	var camelCase = function camelCase(name) {
	  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
	    return offset ? letter.toUpperCase() : letter;
	  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
	};
	
	/* istanbul ignore next */
	var on = exports.on = function () {
	  if (!isServer && document.addEventListener) {
	    return function (element, event, handler) {
	      if (element && event && handler) {
	        element.addEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function (element, event, handler) {
	      if (element && event && handler) {
	        element.attachEvent('on' + event, handler);
	      }
	    };
	  }
	}();
	
	/* istanbul ignore next */
	var off = exports.off = function () {
	  if (!isServer && document.removeEventListener) {
	    return function (element, event, handler) {
	      if (element && event) {
	        element.removeEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function (element, event, handler) {
	      if (element && event) {
	        element.detachEvent('on' + event, handler);
	      }
	    };
	  }
	}();
	
	/* istanbul ignore next */
	var once = exports.once = function once(el, event, fn) {
	  var listener = function listener() {
	    if (fn) {
	      fn.apply(this, arguments);
	    }
	    off(el, event, listener);
	  };
	  on(el, event, listener);
	};
	
	/* istanbul ignore next */
	function hasClass(el, cls) {
	  if (!el || !cls) return false;
	  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
	  if (el.classList) {
	    return el.classList.contains(cls);
	  } else {
	    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
	  }
	};
	
	/* istanbul ignore next */
	function addClass(el, cls) {
	  if (!el) return;
	  var curClass = el.className;
	  var classes = (cls || '').split(' ');
	
	  for (var i = 0, j = classes.length; i < j; i++) {
	    var clsName = classes[i];
	    if (!clsName) continue;
	
	    if (el.classList) {
	      el.classList.add(clsName);
	    } else if (!hasClass(el, clsName)) {
	      curClass += ' ' + clsName;
	    }
	  }
	  if (!el.classList) {
	    el.className = curClass;
	  }
	};
	
	/* istanbul ignore next */
	function removeClass(el, cls) {
	  if (!el || !cls) return;
	  var classes = cls.split(' ');
	  var curClass = ' ' + el.className + ' ';
	
	  for (var i = 0, j = classes.length; i < j; i++) {
	    var clsName = classes[i];
	    if (!clsName) continue;
	
	    if (el.classList) {
	      el.classList.remove(clsName);
	    } else if (hasClass(el, clsName)) {
	      curClass = curClass.replace(' ' + clsName + ' ', ' ');
	    }
	  }
	  if (!el.classList) {
	    el.className = trim(curClass);
	  }
	};
	
	/* istanbul ignore next */
	var getStyle = exports.getStyle = ieVersion < 9 ? function (element, styleName) {
	  if (isServer) return;
	  if (!element || !styleName) return null;
	  styleName = camelCase(styleName);
	  if (styleName === 'float') {
	    styleName = 'styleFloat';
	  }
	  try {
	    switch (styleName) {
	      case 'opacity':
	        try {
	          return element.filters.item('alpha').opacity / 100;
	        } catch (e) {
	          return 1.0;
	        }
	      default:
	        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
	    }
	  } catch (e) {
	    return element.style[styleName];
	  }
	} : function (element, styleName) {
	  if (isServer) return;
	  if (!element || !styleName) return null;
	  styleName = camelCase(styleName);
	  if (styleName === 'float') {
	    styleName = 'cssFloat';
	  }
	  try {
	    var computed = document.defaultView.getComputedStyle(element, '');
	    return element.style[styleName] || computed ? computed[styleName] : null;
	  } catch (e) {
	    return element.style[styleName];
	  }
	};
	
	/* istanbul ignore next */
	function setStyle(element, styleName, value) {
	  if (!element || !styleName) return;
	
	  if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
	    for (var prop in styleName) {
	      if (styleName.hasOwnProperty(prop)) {
	        setStyle(element, prop, styleName[prop]);
	      }
	    }
	  } else {
	    styleName = camelCase(styleName);
	    if (styleName === 'opacity' && ieVersion < 9) {
	      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
	    } else {
	      element.style[styleName] = value;
	    }
	  }
	};
	
	var isScroll = exports.isScroll = function isScroll(el, vertical) {
	  if (isServer) return;
	
	  var determinedDirection = vertical !== null || vertical !== undefined;
	  var overflow = determinedDirection ? vertical ? getStyle(el, 'overflow-y') : getStyle(el, 'overflow-x') : getStyle(el, 'overflow');
	
	  return overflow.match(/(scroll|auto)/);
	};
	
	var getScrollContainer = exports.getScrollContainer = function getScrollContainer(el, vertical) {
	  if (isServer) return;
	
	  var parent = el;
	  while (parent) {
	    if ([window, document, document.documentElement].includes(parent)) {
	      return window;
	    }
	    if (isScroll(parent, vertical)) {
	      return parent;
	    }
	    parent = parent.parentNode;
	  }
	
	  return parent;
	};
	
	var isInContainer = exports.isInContainer = function isInContainer(el, container) {
	  if (isServer || !el || !container) return false;
	
	  var elRect = el.getBoundingClientRect();
	  var containerRect = void 0;
	
	  if ([window, document, document.documentElement, null, undefined].includes(container)) {
	    containerRect = {
	      top: 0,
	      right: window.innerWidth,
	      bottom: window.innerHeight,
	      left: 0
	    };
	  } else {
	    containerRect = container.getBoundingClientRect();
	  }
	
	  return elRect.top < containerRect.bottom && elRect.bottom > containerRect.top && elRect.right > containerRect.left && elRect.left < containerRect.right;
	};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.route = route;
	exports.functionalRoute = functionalRoute;
	exports.routeProps = void 0;
	
	/**
	 * Vue Router support
	 */
	function route(router, config) {
	  var to = config.to,
	      url = config.url,
	      replace = config.replace;
	
	  if (to && router) {
	    var promise = router[replace ? 'replace' : 'push'](to);
	    /* istanbul ignore else */
	
	    if (promise && promise.catch) {
	      promise.catch(function (err) {
	        /* istanbul ignore if */
	        if (err && err.name !== 'NavigationDuplicated') {
	          throw err;
	        }
	      });
	    }
	  } else if (url) {
	    replace ? location.replace(url) : location.href = url;
	  }
	}
	
	function functionalRoute(context) {
	  route(context.parent && context.parent.$router, context.props);
	}
	
	var routeProps = {
	  url: String,
	  replace: Boolean,
	  to: [String, Object]
	};
	exports.routeProps = routeProps;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(41)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(28);
	var IE8_DOM_DEFINE = __webpack_require__(114);
	var toPrimitive = __webpack_require__(76);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(25) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.FieldMixin = void 0;
	var FieldMixin = {
	  inject: {
	    vanField: {
	      default: null
	    }
	  },
	  watch: {
	    value: function value() {
	      var field = this.vanField;
	
	      if (field) {
	        field.resetValidation();
	        field.validateWithTrigger('onChange');
	      }
	    }
	  },
	  created: function created() {
	    var field = this.vanField;
	
	    if (field && !field.children) {
	      field.children = this;
	    }
	  }
	};
	exports.FieldMixin = FieldMixin;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(42);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var core = __webpack_require__(20);
	var ctx = __webpack_require__(50);
	var hide = __webpack_require__(31);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(26);
	var createDesc = __webpack_require__(53);
	module.exports = __webpack_require__(25) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(115);
	var defined = __webpack_require__(68);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function _broadcast(componentName, eventName, params) {
	  this.$children.forEach(function (child) {
	    var name = child.$options.componentName;
	
	    if (name === componentName) {
	      child.$emit.apply(child, [eventName].concat(params));
	    } else {
	      _broadcast.apply(child, [componentName, eventName].concat([params]));
	    }
	  });
	}
	exports.default = {
	  methods: {
	    dispatch: function dispatch(componentName, eventName, params) {
	      var parent = this.$parent || this.$root;
	      var name = parent.$options.componentName;
	
	      while (parent && (!name || name !== componentName)) {
	        parent = parent.$parent;
	
	        if (parent) {
	          name = parent.$options.componentName;
	        }
	      }
	      if (parent) {
	        parent.$emit.apply(parent, [eventName].concat(params));
	      }
	    },
	    broadcast: function broadcast(componentName, eventName, params) {
	      _broadcast.call(this, componentName, eventName, params);
	    }
	  }
	};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(145);
	
	var _event = __webpack_require__(10);
	
	var _resetScroll = __webpack_require__(172);
	
	var _utils2 = __webpack_require__(1);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _cell = _interopRequireDefault(__webpack_require__(15));
	
	var _shared = __webpack_require__(92);
	
	// Utils
	// Components
	var _createNamespace = (0, _utils2.createNamespace)('field'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  inheritAttrs: false,
	  provide: function provide() {
	    return {
	      vanField: this
	    };
	  },
	  inject: {
	    vanForm: {
	      default: null
	    }
	  },
	  props: (0, _extends2.default)({}, _shared.cellProps, {
	    name: String,
	    rules: Array,
	    error: Boolean,
	    disabled: Boolean,
	    readonly: Boolean,
	    autosize: [Boolean, Object],
	    leftIcon: String,
	    rightIcon: String,
	    clearable: Boolean,
	    formatter: Function,
	    maxlength: [Number, String],
	    labelWidth: [Number, String],
	    labelClass: null,
	    labelAlign: String,
	    inputAlign: String,
	    placeholder: String,
	    errorMessage: String,
	    errorMessageAlign: String,
	    showWordLimit: Boolean,
	    type: {
	      type: String,
	      default: 'text'
	    }
	  }),
	  data: function data() {
	    return {
	      focused: false,
	      validateMessage: ''
	    };
	  },
	  watch: {
	    value: function value() {
	      this.resetValidation();
	      this.validateWithTrigger('onChange');
	      this.$nextTick(this.adjustSize);
	    }
	  },
	  mounted: function mounted() {
	    this.format();
	    this.$nextTick(this.adjustSize);
	
	    if (this.vanForm) {
	      this.vanForm.fields.push(this);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _this = this;
	
	    if (this.vanForm) {
	      this.vanForm.fields = this.vanForm.fields.filter(function (item) {
	        return item !== _this;
	      });
	    }
	  },
	  computed: {
	    showClear: function showClear() {
	      return this.clearable && this.focused && this.value !== '' && (0, _utils2.isDef)(this.value) && !this.readonly;
	    },
	    listeners: function listeners() {
	      var listeners = (0, _extends2.default)({}, this.$listeners, {
	        input: this.onInput,
	        keypress: this.onKeypress,
	        focus: this.onFocus,
	        blur: this.onBlur
	      });
	      delete listeners.click;
	      return listeners;
	    },
	    labelStyle: function labelStyle() {
	      var labelWidth = this.getProp('labelWidth');
	
	      if (labelWidth) {
	        return {
	          width: (0, _utils2.addUnit)(labelWidth)
	        };
	      }
	    },
	    formValue: function formValue() {
	      if (this.children && this.inputSlot) {
	        return this.children.value;
	      }
	
	      return this.value;
	    },
	    inputSlot: function inputSlot() {
	      return this.slots('input');
	    }
	  },
	  methods: {
	    // @exposed-api
	    focus: function focus() {
	      if (this.$refs.input) {
	        this.$refs.input.focus();
	      }
	    },
	    // @exposed-api
	    blur: function blur() {
	      if (this.$refs.input) {
	        this.$refs.input.blur();
	      }
	    },
	    runValidator: function runValidator(value, rule) {
	      return new Promise(function (resolve) {
	        var returnVal = rule.validator(value, rule);
	
	        if ((0, _utils2.isPromise)(returnVal)) {
	          return returnVal.then(resolve);
	        }
	
	        resolve(returnVal);
	      });
	    },
	    isEmptyValue: function isEmptyValue(value) {
	      if (Array.isArray(value)) {
	        return !value.length;
	      }
	
	      return !value;
	    },
	    runSyncRule: function runSyncRule(value, rule) {
	      if (rule.required && this.isEmptyValue(value)) {
	        return false;
	      }
	
	      if (rule.pattern && !rule.pattern.test(value)) {
	        return false;
	      }
	
	      return true;
	    },
	    getRuleMessage: function getRuleMessage(value, rule) {
	      var message = rule.message;
	
	      if ((0, _utils2.isFunction)(message)) {
	        return message(value, rule);
	      }
	
	      return message;
	    },
	    runRules: function runRules(rules) {
	      var _this2 = this;
	
	      return rules.reduce(function (promise, rule) {
	        return promise.then(function () {
	          if (_this2.validateMessage) {
	            return;
	          }
	
	          var value = _this2.formValue;
	
	          if (rule.formatter) {
	            value = rule.formatter(value, rule);
	          }
	
	          if (!_this2.runSyncRule(value, rule)) {
	            _this2.validateMessage = _this2.getRuleMessage(value, rule);
	            return;
	          }
	
	          if (rule.validator) {
	            return _this2.runValidator(value, rule).then(function (result) {
	              if (result === false) {
	                _this2.validateMessage = _this2.getRuleMessage(value, rule);
	              }
	            });
	          }
	        });
	      }, Promise.resolve());
	    },
	    validate: function validate(rules) {
	      var _this3 = this;
	
	      if (rules === void 0) {
	        rules = this.rules;
	      }
	
	      return new Promise(function (resolve) {
	        if (!rules) {
	          resolve();
	        }
	
	        _this3.runRules(rules).then(function () {
	          if (_this3.validateMessage) {
	            resolve({
	              name: _this3.name,
	              message: _this3.validateMessage
	            });
	          } else {
	            resolve();
	          }
	        });
	      });
	    },
	    validateWithTrigger: function validateWithTrigger(trigger) {
	      if (this.vanForm && this.rules) {
	        var defaultTrigger = this.vanForm.validateTrigger === trigger;
	        var rules = this.rules.filter(function (rule) {
	          if (rule.trigger) {
	            return rule.trigger === trigger;
	          }
	
	          return defaultTrigger;
	        });
	        this.validate(rules);
	      }
	    },
	    resetValidation: function resetValidation() {
	      if (this.validateMessage) {
	        this.validateMessage = '';
	      }
	    },
	    format: function format(target) {
	      if (target === void 0) {
	        target = this.$refs.input;
	      }
	
	      if (!target) {
	        return;
	      }
	
	      var _target = target,
	          value = _target.value;
	      var maxlength = this.maxlength; // native maxlength not work when type is number
	
	      if ((0, _utils2.isDef)(maxlength) && value.length > maxlength) {
	        value = value.slice(0, maxlength);
	        target.value = value;
	      }
	
	      if (this.type === 'number' || this.type === 'digit') {
	        var originValue = value;
	        var allowDot = this.type === 'number';
	        value = (0, _utils.formatNumber)(value, allowDot);
	
	        if (value !== originValue) {
	          target.value = value;
	        }
	      }
	
	      if (this.formatter) {
	        var _originValue = value;
	        value = this.formatter(value);
	
	        if (value !== _originValue) {
	          target.value = value;
	        }
	      }
	
	      return value;
	    },
	    onInput: function onInput(event) {
	      // not update v-model when composing
	      if (event.target.composing) {
	        return;
	      }
	
	      this.$emit('input', this.format(event.target));
	    },
	    onFocus: function onFocus(event) {
	      this.focused = true;
	      this.$emit('focus', event); // hack for safari
	
	      /* istanbul ignore if */
	
	      if (this.readonly) {
	        this.blur();
	      }
	    },
	    onBlur: function onBlur(event) {
	      this.focused = false;
	      this.$emit('blur', event);
	      this.validateWithTrigger('onBlur');
	      (0, _resetScroll.resetScroll)();
	    },
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	    },
	    onClickLeftIcon: function onClickLeftIcon(event) {
	      this.$emit('click-left-icon', event);
	    },
	    onClickRightIcon: function onClickRightIcon(event) {
	      this.$emit('click-right-icon', event);
	    },
	    onClear: function onClear(event) {
	      (0, _event.preventDefault)(event);
	      this.$emit('input', '');
	      this.$emit('clear', event);
	    },
	    onKeypress: function onKeypress(event) {
	      // trigger blur after click keyboard search button
	
	      /* istanbul ignore next */
	      if (this.type === 'search' && event.keyCode === 13) {
	        this.blur();
	      }
	
	      this.$emit('keypress', event);
	    },
	    adjustSize: function adjustSize() {
	      var input = this.$refs.input;
	
	      if (!(this.type === 'textarea' && this.autosize) || !input) {
	        return;
	      }
	
	      input.style.height = 'auto';
	      var height = input.scrollHeight;
	
	      if ((0, _utils2.isObject)(this.autosize)) {
	        var _this$autosize = this.autosize,
	            maxHeight = _this$autosize.maxHeight,
	            minHeight = _this$autosize.minHeight;
	
	        if (maxHeight) {
	          height = Math.min(height, maxHeight);
	        }
	
	        if (minHeight) {
	          height = Math.max(height, minHeight);
	        }
	      }
	
	      if (height) {
	        input.style.height = height + 'px';
	      }
	    },
	    genInput: function genInput() {
	      var h = this.$createElement;
	      var type = this.type;
	      var inputAlign = this.getProp('inputAlign');
	
	      if (this.inputSlot) {
	        return h("div", {
	          "class": bem('control', [inputAlign, 'custom'])
	        }, [this.inputSlot]);
	      }
	
	      var inputProps = {
	        ref: 'input',
	        class: bem('control', inputAlign),
	        domProps: {
	          value: this.value
	        },
	        attrs: (0, _extends2.default)({}, this.$attrs, {
	          name: this.name,
	          disabled: this.disabled,
	          readonly: this.readonly,
	          placeholder: this.placeholder
	        }),
	        on: this.listeners,
	        // add model directive to skip IME composition
	        directives: [{
	          name: 'model',
	          value: this.value
	        }]
	      };
	
	      if (type === 'textarea') {
	        return h("textarea", (0, _babelHelperVueJsxMergeProps.default)([{}, inputProps]));
	      }
	
	      var inputType = type;
	      var inputMode; // type="number" is weired in iOS, and can't prevent dot in Android
	      // so use inputmode to set keyboard in mordern browers
	
	      if (type === 'number') {
	        inputType = 'text';
	        inputMode = 'decimal';
	      }
	
	      if (type === 'digit') {
	        inputType = 'tel';
	        inputMode = 'numeric';
	      }
	
	      return h("input", (0, _babelHelperVueJsxMergeProps.default)([{
	        "attrs": {
	          "type": inputType,
	          "inputmode": inputMode
	        }
	      }, inputProps]));
	    },
	    genLeftIcon: function genLeftIcon() {
	      var h = this.$createElement;
	      var showLeftIcon = this.slots('left-icon') || this.leftIcon;
	
	      if (showLeftIcon) {
	        return h("div", {
	          "class": bem('left-icon'),
	          "on": {
	            "click": this.onClickLeftIcon
	          }
	        }, [this.slots('left-icon') || h(_icon.default, {
	          "attrs": {
	            "name": this.leftIcon,
	            "classPrefix": this.iconPrefix
	          }
	        })]);
	      }
	    },
	    genRightIcon: function genRightIcon() {
	      var h = this.$createElement;
	      var slots = this.slots;
	      var showRightIcon = slots('right-icon') || this.rightIcon;
	
	      if (showRightIcon) {
	        return h("div", {
	          "class": bem('right-icon'),
	          "on": {
	            "click": this.onClickRightIcon
	          }
	        }, [slots('right-icon') || h(_icon.default, {
	          "attrs": {
	            "name": this.rightIcon,
	            "classPrefix": this.iconPrefix
	          }
	        })]);
	      }
	    },
	    genWordLimit: function genWordLimit() {
	      var h = this.$createElement;
	
	      if (this.showWordLimit && this.maxlength) {
	        var count = this.value.length;
	        var full = count >= this.maxlength;
	        return h("div", {
	          "class": bem('word-limit')
	        }, [h("span", {
	          "class": bem('word-num', {
	            full: full
	          })
	        }, [count]), "/", this.maxlength]);
	      }
	    },
	    genMessage: function genMessage() {
	      var h = this.$createElement;
	      var message = this.errorMessage || this.validateMessage;
	
	      if (message) {
	        var errorMessageAlign = this.getProp('errorMessageAlign');
	        return h("div", {
	          "class": bem('error-message', errorMessageAlign)
	        }, [message]);
	      }
	    },
	    getProp: function getProp(key) {
	      if ((0, _utils2.isDef)(this[key])) {
	        return this[key];
	      }
	
	      if (this.vanForm && (0, _utils2.isDef)(this.vanForm[key])) {
	        return this.vanForm[key];
	      }
	    },
	    genLabel: function genLabel() {
	      var h = this.$createElement;
	      var colon = this.getProp('colon') ? ':' : '';
	
	      if (this.slots('label')) {
	        return [this.slots('label'), colon];
	      }
	
	      if (this.label) {
	        return h("span", [this.label + colon]);
	      }
	    }
	  },
	  render: function render() {
	    var _bem;
	
	    var h = arguments[0];
	    var slots = this.slots;
	    var labelAlign = this.getProp('labelAlign');
	    var scopedSlots = {
	      icon: this.genLeftIcon
	    };
	    var Label = this.genLabel();
	
	    if (Label) {
	      scopedSlots.title = function () {
	        return Label;
	      };
	    }
	
	    return h(_cell.default, {
	      "attrs": {
	        "icon": this.leftIcon,
	        "size": this.size,
	        "center": this.center,
	        "border": this.border,
	        "isLink": this.isLink,
	        "required": this.required,
	        "clickable": this.clickable,
	        "titleStyle": this.labelStyle,
	        "valueClass": bem('value'),
	        "titleClass": [bem('label', labelAlign), this.labelClass],
	        "arrowDirection": this.arrowDirection
	      },
	      "scopedSlots": scopedSlots,
	      "class": bem((_bem = {
	        error: this.error || this.validateMessage
	      }, _bem["label-" + labelAlign] = labelAlign, _bem['min-height'] = this.type === 'textarea' && !this.autosize, _bem)),
	      "on": {
	        "click": this.onClick
	      }
	    }, [h("div", {
	      "class": bem('body')
	    }, [this.genInput(), this.showClear && h(_icon.default, {
	      "attrs": {
	        "name": "clear"
	      },
	      "class": bem('clear'),
	      "on": {
	        "touchstart": this.onClear
	      }
	    }), this.genRightIcon(), slots('button') && h("div", {
	      "class": bem('button')
	    }, [slots('button')])]), this.genWordLimit(), this.genMessage()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	// Utils
	var _createNamespace = (0, _utils.createNamespace)('info'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function Info(h, props, slots, ctx) {
	  var dot = props.dot,
	      info = props.info;
	  var showInfo = (0, _utils.isDef)(info) && info !== '';
	
	  if (!dot && !showInfo) {
	    return;
	  }
	
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem({
	      dot: dot
	    })
	  }, (0, _functional.inherit)(ctx, true)]), [dot ? '' : props.info]);
	}
	
	Info.props = {
	  dot: Boolean,
	  info: [Number, String]
	};
	
	var _default = createComponent(Info);
	
	exports.default = _default;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.BindEventMixin = BindEventMixin;
	
	var _event = __webpack_require__(10);
	
	/**
	 * Bind event when mounted or activated
	 */
	function BindEventMixin(handler) {
	  function bind() {
	    if (!this.binded) {
	      handler.call(this, _event.on, true);
	      this.binded = true;
	    }
	  }
	
	  function unbind() {
	    if (this.binded) {
	      handler.call(this, _event.off, false);
	      this.binded = false;
	    }
	  }
	
	  return {
	    mounted: bind,
	    activated: bind,
	    deactivated: unbind,
	    beforeDestroy: unbind
	  };
	}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _popup = __webpack_require__(39);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _createNamespace = (0, _utils.createNamespace)('popup'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _popup.PopupMixin)()],
	  props: {
	    round: Boolean,
	    duration: [Number, String],
	    closeable: Boolean,
	    transition: String,
	    safeAreaInsetBottom: Boolean,
	    closeIcon: {
	      type: String,
	      default: 'cross'
	    },
	    closeIconPosition: {
	      type: String,
	      default: 'top-right'
	    },
	    position: {
	      type: String,
	      default: 'center'
	    },
	    overlay: {
	      type: Boolean,
	      default: true
	    },
	    closeOnClickOverlay: {
	      type: Boolean,
	      default: true
	    }
	  },
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    var createEmitter = function createEmitter(eventName) {
	      return function (event) {
	        return _this.$emit(eventName, event);
	      };
	    };
	
	    this.onClick = createEmitter('click');
	    this.onOpened = createEmitter('opened');
	    this.onClosed = createEmitter('closed');
	  },
	  render: function render() {
	    var _bem;
	
	    var h = arguments[0];
	
	    if (!this.shouldRender) {
	      return;
	    }
	
	    var round = this.round,
	        position = this.position,
	        duration = this.duration;
	    var isCenter = position === 'center';
	    var transitionName = this.transition || (isCenter ? 'van-fade' : "van-popup-slide-" + position);
	    var style = {};
	
	    if ((0, _utils.isDef)(duration)) {
	      var key = isCenter ? 'animationDuration' : 'transitionDuration';
	      style[key] = duration + "s";
	    }
	
	    return h("transition", {
	      "attrs": {
	        "name": transitionName
	      },
	      "on": {
	        "afterEnter": this.onOpened,
	        "afterLeave": this.onClosed
	      }
	    }, [h("div", {
	      "directives": [{
	        name: "show",
	        value: this.value
	      }],
	      "style": style,
	      "class": bem((_bem = {
	        round: round
	      }, _bem[position] = position, _bem['safe-area-inset-bottom'] = this.safeAreaInsetBottom, _bem)),
	      "on": {
	        "click": this.onClick
	      }
	    }, [this.slots(), this.closeable && h(_icon.default, {
	      "attrs": {
	        "role": "button",
	        "tabindex": "0",
	        "name": this.closeIcon
	      },
	      "class": bem('close-icon', this.closeIconPosition),
	      "on": {
	        "click": this.close
	      }
	    })])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.camelize = camelize;
	exports.padZero = padZero;
	var camelizeRE = /-(\w)/g;
	
	function camelize(str) {
	  return str.replace(camelizeRE, function (_, c) {
	    return c.toUpperCase();
	  });
	}
	
	function padZero(num, targetLength) {
	  if (targetLength === void 0) {
	    targetLength = 2;
	  }
	
	  var str = num + '';
	
	  while (str.length < targetLength) {
	    str = '0' + str;
	  }
	
	  return str;
	}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.PopupMixin = PopupMixin;
	exports.popupMixinProps = void 0;
	
	var _context = __webpack_require__(148);
	
	var _overlay = __webpack_require__(354);
	
	var _event = __webpack_require__(10);
	
	var _node = __webpack_require__(171);
	
	var _scroll = __webpack_require__(22);
	
	var _touch = __webpack_require__(19);
	
	var _portal = __webpack_require__(149);
	
	var _closeOnPopstate = __webpack_require__(353);
	
	// Context
	// Utils
	// Mixins
	var popupMixinProps = {
	  // whether to show popup
	  value: Boolean,
	  // whether to show overlay
	  overlay: Boolean,
	  // overlay custom style
	  overlayStyle: Object,
	  // overlay custom class name
	  overlayClass: String,
	  // whether to close popup when click overlay
	  closeOnClickOverlay: Boolean,
	  // z-index
	  zIndex: [Number, String],
	  // prevent body scroll
	  lockScroll: {
	    type: Boolean,
	    default: true
	  },
	  // whether to lazy render
	  lazyRender: {
	    type: Boolean,
	    default: true
	  }
	};
	exports.popupMixinProps = popupMixinProps;
	
	function PopupMixin(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  return {
	    mixins: [_touch.TouchMixin, _closeOnPopstate.CloseOnPopstateMixin, (0, _portal.PortalMixin)({
	      afterPortal: function afterPortal() {
	        if (this.overlay) {
	          (0, _overlay.updateOverlay)();
	        }
	      }
	    })],
	    props: popupMixinProps,
	    data: function data() {
	      return {
	        inited: this.value
	      };
	    },
	    computed: {
	      shouldRender: function shouldRender() {
	        return this.inited || !this.lazyRender;
	      }
	    },
	    watch: {
	      value: function value(val) {
	        var type = val ? 'open' : 'close';
	        this.inited = this.inited || this.value;
	        this[type]();
	
	        if (!options.skipToggleEvent) {
	          this.$emit(type);
	        }
	      },
	      overlay: 'renderOverlay'
	    },
	    mounted: function mounted() {
	      if (this.value) {
	        this.open();
	      }
	    },
	
	    /* istanbul ignore next */
	    activated: function activated() {
	      if (this.shouldReopen) {
	        this.$emit('input', true);
	        this.shouldReopen = false;
	      }
	    },
	    beforeDestroy: function beforeDestroy() {
	      this.close();
	
	      if (this.getContainer) {
	        (0, _node.removeNode)(this.$el);
	      }
	    },
	
	    /* istanbul ignore next */
	    deactivated: function deactivated() {
	      if (this.value) {
	        this.close();
	        this.shouldReopen = true;
	      }
	    },
	    methods: {
	      open: function open() {
	        /* istanbul ignore next */
	        if (this.$isServer || this.opened) {
	          return;
	        } // cover default zIndex
	
	
	        if (this.zIndex !== undefined) {
	          _context.context.zIndex = this.zIndex;
	        }
	
	        this.opened = true;
	        this.renderOverlay();
	
	        if (this.lockScroll) {
	          (0, _event.on)(document, 'touchstart', this.touchStart);
	          (0, _event.on)(document, 'touchmove', this.onTouchMove);
	
	          if (!_context.context.lockCount) {
	            document.body.classList.add('van-overflow-hidden');
	          }
	
	          _context.context.lockCount++;
	        }
	      },
	      close: function close() {
	        if (!this.opened) {
	          return;
	        }
	
	        if (this.lockScroll) {
	          _context.context.lockCount--;
	          (0, _event.off)(document, 'touchstart', this.touchStart);
	          (0, _event.off)(document, 'touchmove', this.onTouchMove);
	
	          if (!_context.context.lockCount) {
	            document.body.classList.remove('van-overflow-hidden');
	          }
	        }
	
	        this.opened = false;
	        (0, _overlay.closeOverlay)(this);
	        this.$emit('input', false);
	      },
	      onTouchMove: function onTouchMove(event) {
	        this.touchMove(event);
	        var direction = this.deltaY > 0 ? '10' : '01';
	        var el = (0, _scroll.getScroller)(event.target, this.$el);
	        var scrollHeight = el.scrollHeight,
	            offsetHeight = el.offsetHeight,
	            scrollTop = el.scrollTop;
	        var status = '11';
	        /* istanbul ignore next */
	
	        if (scrollTop === 0) {
	          status = offsetHeight >= scrollHeight ? '00' : '01';
	        } else if (scrollTop + offsetHeight >= scrollHeight) {
	          status = '10';
	        }
	        /* istanbul ignore next */
	
	
	        if (status !== '11' && this.direction === 'vertical' && !(parseInt(status, 2) & parseInt(direction, 2))) {
	          (0, _event.preventDefault)(event, true);
	        }
	      },
	      renderOverlay: function renderOverlay() {
	        var _this = this;
	
	        if (this.$isServer || !this.value) {
	          return;
	        }
	
	        this.$nextTick(function () {
	          _this.updateZIndex(_this.overlay ? 1 : 0);
	
	          if (_this.overlay) {
	            (0, _overlay.openOverlay)(_this, {
	              zIndex: _context.context.zIndex++,
	              duration: _this.duration,
	              className: _this.overlayClass,
	              customStyle: _this.overlayStyle
	            });
	          } else {
	            (0, _overlay.closeOverlay)(_this);
	          }
	        });
	      },
	      updateZIndex: function updateZIndex(value) {
	        if (value === void 0) {
	          value = 0;
	        }
	
	        this.$el.style.zIndex = ++_context.context.zIndex + value;
	      }
	    }
	  };
	}

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(119);
	var enumBugKeys = __webpack_require__(70);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	exports.__esModule = true;
	exports.raf = raf;
	exports.doubleRaf = doubleRaf;
	exports.cancelRaf = cancelRaf;
	
	var _ = __webpack_require__(1);
	
	/**
	 * requestAnimationFrame polyfill
	 */
	var prev = Date.now();
	/* istanbul ignore next */
	
	function fallback(fn) {
	  var curr = Date.now();
	  var ms = Math.max(0, 16 - (curr - prev));
	  var id = setTimeout(fn, ms);
	  prev = curr + ms;
	  return id;
	}
	/* istanbul ignore next */
	
	
	var root = _.isServer ? global : window;
	/* istanbul ignore next */
	
	var iRaf = root.requestAnimationFrame || fallback;
	/* istanbul ignore next */
	
	var iCancel = root.cancelAnimationFrame || root.clearTimeout;
	
	function raf(fn) {
	  return iRaf.call(root, fn);
	} // double raf for animation
	
	
	function doubleRaf(fn) {
	  raf(function () {
	    raf(fn);
	  });
	}
	
	function cancelRaf(id) {
	  iCancel.call(root, id);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isHidden = isHidden;
	
	function isHidden(el) {
	  var style = window.getComputedStyle(el);
	  var hidden = style.display === 'none'; // offsetParent returns null in the following situations:
	  // 1. The element or its parent element has the display property set to none.
	  // 2. The element has the position property set to fixed
	
	  var parentHidden = el.offsetParent === null && style.position !== 'fixed';
	  return hidden || parentHidden;
	}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.range = range;
	
	function range(num, min, max) {
	  return Math.min(Math.max(num, min), max);
	}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(228);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(227);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(49);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(26).f;
	var has = __webpack_require__(30);
	var TAG = __webpack_require__(14)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (target) {
	  for (var i = 1, j = arguments.length; i < j; i++) {
	    var source = arguments[i] || {};
	    for (var prop in source) {
	      if (source.hasOwnProperty(prop)) {
	        var value = source[prop];
	        if (value !== undefined) {
	          target[prop] = value;
	        }
	      }
	    }
	  }
	
	  return target;
	};
	
	;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isDef = isDef;
	exports.isKorean = isKorean;
	function isDef(val) {
	  return val !== undefined && val !== null;
	}
	function isKorean(text) {
	  var reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
	  return reg.test(text);
	}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _popup = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopperJS = _vue2.default.prototype.$isServer ? function () {} : __webpack_require__(287);
	var stop = function stop(e) {
	  return e.stopPropagation();
	};
	
	/**
	 * @param {HTMLElement} [reference=$refs.reference] - The reference element used to position the popper.
	 * @param {HTMLElement} [popper=$refs.popper] - The HTML element used as popper, or a configuration used to generate the popper.
	 * @param {String} [placement=button] - Placement of the popper accepted values: top(-start, -end), right(-start, -end), bottom(-start, -end), left(-start, -end)
	 * @param {Number} [offset=0] - Amount of pixels the popper will be shifted (can be negative).
	 * @param {Boolean} [visible=false] Visibility of the popup element.
	 * @param {Boolean} [visible-arrow=false] Visibility of the arrow, no style.
	 */
	exports.default = {
	  props: {
	    transformOrigin: {
	      type: [Boolean, String],
	      default: true
	    },
	    placement: {
	      type: String,
	      default: 'bottom'
	    },
	    boundariesPadding: {
	      type: Number,
	      default: 5
	    },
	    reference: {},
	    popper: {},
	    offset: {
	      default: 0
	    },
	    value: Boolean,
	    visibleArrow: Boolean,
	    arrowOffset: {
	      type: Number,
	      default: 35
	    },
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    popperOptions: {
	      type: Object,
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      showPopper: false,
	      currentPlacement: ''
	    };
	  },
	
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(val) {
	        this.showPopper = val;
	        this.$emit('input', val);
	      }
	    },
	
	    showPopper: function showPopper(val) {
	      if (this.disabled) return;
	      val ? this.updatePopper() : this.destroyPopper();
	      this.$emit('input', val);
	    }
	  },
	
	  methods: {
	    createPopper: function createPopper() {
	      var _this = this;
	
	      if (this.$isServer) return;
	      this.currentPlacement = this.currentPlacement || this.placement;
	      if (!/^(top|bottom|left|right)(-start|-end)?$/g.test(this.currentPlacement)) {
	        return;
	      }
	
	      var options = this.popperOptions;
	      var popper = this.popperElm = this.popperElm || this.popper || this.$refs.popper;
	      var reference = this.referenceElm = this.referenceElm || this.reference || this.$refs.reference;
	
	      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
	        reference = this.referenceElm = this.$slots.reference[0].elm;
	      }
	
	      if (!popper || !reference) return;
	      if (this.visibleArrow) this.appendArrow(popper);
	      if (this.appendToBody) document.body.appendChild(this.popperElm);
	      if (this.popperJS && this.popperJS.destroy) {
	        this.popperJS.destroy();
	      }
	
	      options.placement = this.currentPlacement;
	      options.offset = this.offset;
	      options.arrowOffset = this.arrowOffset;
	      this.popperJS = new PopperJS(reference, popper, options);
	      this.popperJS.onCreate(function (_) {
	        _this.$emit('created', _this);
	        _this.resetTransformOrigin();
	        _this.$nextTick(_this.updatePopper);
	      });
	      if (typeof options.onUpdate === 'function') {
	        this.popperJS.onUpdate(options.onUpdate);
	      }
	      this.popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
	      this.popperElm.addEventListener('click', stop);
	    },
	    updatePopper: function updatePopper() {
	      var popperJS = this.popperJS;
	      if (popperJS) {
	        popperJS.update();
	        if (popperJS._popper) {
	          popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
	        }
	      } else {
	        this.createPopper();
	      }
	    },
	    doDestroy: function doDestroy(forceDestroy) {
	      /* istanbul ignore if */
	      if (!this.popperJS || this.showPopper && !forceDestroy) return;
	      this.popperJS.destroy();
	      this.popperJS = null;
	    },
	    destroyPopper: function destroyPopper() {
	      if (this.popperJS) {
	        this.resetTransformOrigin();
	      }
	    },
	    resetTransformOrigin: function resetTransformOrigin() {
	      if (!this.transformOrigin) return;
	      var placementMap = {
	        top: 'bottom',
	        bottom: 'top',
	        left: 'right',
	        right: 'left'
	      };
	      var placement = this.popperJS._popper.getAttribute('x-placement').split('-')[0];
	      var origin = placementMap[placement];
	      this.popperJS._popper.style.transformOrigin = typeof this.transformOrigin === 'string' ? this.transformOrigin : ['top', 'bottom'].indexOf(placement) > -1 ? 'center ' + origin : origin + ' center';
	    },
	    appendArrow: function appendArrow(element) {
	      var hash = void 0;
	      if (this.appended) {
	        return;
	      }
	
	      this.appended = true;
	
	      for (var item in element.attributes) {
	        if (/^_v-/.test(element.attributes[item].name)) {
	          hash = element.attributes[item].name;
	          break;
	        }
	      }
	
	      var arrow = document.createElement('div');
	
	      if (hash) {
	        arrow.setAttribute(hash, '');
	      }
	      arrow.setAttribute('x-arrow', '');
	      arrow.className = 'popper__arrow';
	      element.appendChild(arrow);
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.doDestroy(true);
	    if (this.popperElm && this.popperElm.parentNode === document.body) {
	      this.popperElm.removeEventListener('click', stop);
	      document.body.removeChild(this.popperElm);
	    }
	  },
	
	
	  // call destroy in keep-alive mode
	  deactivated: function deactivated() {
	    this.$options.beforeDestroy[0].call(this);
	  }
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable no-undefined */
	
	var throttle = __webpack_require__(89);
	
	/**
	 * Debounce execution of a function. Debouncing, unlike throttling,
	 * guarantees that a function is only executed a single time, either at the
	 * very beginning of a series of calls, or at the very end.
	 *
	 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {Boolean}  [atBegin]     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
	 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
	 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
	 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                  to `callback` when the debounced-function is executed.
	 *
	 * @return {Function} A new, debounced function.
	 */
	module.exports = function ( delay, atBegin, callback ) {
		return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _createNamespace = (0, _utils.createNamespace)('image'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  props: {
	    src: String,
	    fit: String,
	    alt: String,
	    round: Boolean,
	    width: [Number, String],
	    height: [Number, String],
	    radius: [Number, String],
	    lazyLoad: Boolean,
	    showError: {
	      type: Boolean,
	      default: true
	    },
	    showLoading: {
	      type: Boolean,
	      default: true
	    },
	    errorIcon: {
	      type: String,
	      default: 'warning-o'
	    },
	    loadingIcon: {
	      type: String,
	      default: 'photo-o'
	    }
	  },
	  data: function data() {
	    return {
	      loading: true,
	      error: false
	    };
	  },
	  watch: {
	    src: function src() {
	      this.loading = true;
	      this.error = false;
	    }
	  },
	  computed: {
	    style: function style() {
	      var style = {};
	
	      if ((0, _utils.isDef)(this.width)) {
	        style.width = (0, _utils.addUnit)(this.width);
	      }
	
	      if ((0, _utils.isDef)(this.height)) {
	        style.height = (0, _utils.addUnit)(this.height);
	      }
	
	      if ((0, _utils.isDef)(this.radius)) {
	        style.overflow = 'hidden';
	        style.borderRadius = (0, _utils.addUnit)(this.radius);
	      }
	
	      return style;
	    }
	  },
	  created: function created() {
	    var $Lazyload = this.$Lazyload;
	
	    if ($Lazyload) {
	      $Lazyload.$on('loaded', this.onLazyLoaded);
	      $Lazyload.$on('error', this.onLazyLoadError);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    var $Lazyload = this.$Lazyload;
	
	    if ($Lazyload) {
	      $Lazyload.$off('loaded', this.onLazyLoaded);
	      $Lazyload.$off('error', this.onLazyLoadError);
	    }
	  },
	  methods: {
	    onLoad: function onLoad(event) {
	      this.loading = false;
	      this.$emit('load', event);
	    },
	    onLazyLoaded: function onLazyLoaded(_ref) {
	      var el = _ref.el;
	
	      if (el === this.$refs.image && this.loading) {
	        this.onLoad();
	      }
	    },
	    onLazyLoadError: function onLazyLoadError(_ref2) {
	      var el = _ref2.el;
	
	      if (el === this.$refs.image && !this.error) {
	        this.onError();
	      }
	    },
	    onError: function onError(event) {
	      this.error = true;
	      this.loading = false;
	      this.$emit('error', event);
	    },
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	    },
	    genPlaceholder: function genPlaceholder() {
	      var h = this.$createElement;
	
	      if (this.loading && this.showLoading) {
	        return h("div", {
	          "class": bem('loading')
	        }, [this.slots('loading') || h(_icon.default, {
	          "attrs": {
	            "name": this.loadingIcon
	          },
	          "class": bem('loading-icon')
	        })]);
	      }
	
	      if (this.error && this.showError) {
	        return h("div", {
	          "class": bem('error')
	        }, [this.slots('error') || h(_icon.default, {
	          "attrs": {
	            "name": this.errorIcon
	          },
	          "class": bem('error-icon')
	        })]);
	      }
	    },
	    genImage: function genImage() {
	      var h = this.$createElement;
	      var imgData = {
	        class: bem('img'),
	        attrs: {
	          alt: this.alt
	        },
	        style: {
	          objectFit: this.fit
	        }
	      };
	
	      if (this.error) {
	        return;
	      }
	
	      if (this.lazyLoad) {
	        return h("img", (0, _babelHelperVueJsxMergeProps.default)([{
	          "ref": "image",
	          "directives": [{
	            name: "lazy",
	            value: this.src
	          }]
	        }, imgData]));
	      }
	
	      return h("img", (0, _babelHelperVueJsxMergeProps.default)([{
	        "attrs": {
	          "src": this.src
	        },
	        "on": {
	          "load": this.onLoad,
	          "error": this.onError
	        }
	      }, imgData]));
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "class": bem({
	        round: this.round
	      }),
	      "style": this.style,
	      "on": {
	        "click": this.onClick
	      }
	    }, [this.genImage(), this.genPlaceholder()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	var _deepAssign = __webpack_require__(170);
	
	var _zhCN = _interopRequireDefault(__webpack_require__(352));
	
	var proto = _vue.default.prototype;
	var defineReactive = _vue.default.util.defineReactive;
	defineReactive(proto, '$vantLang', 'zh-CN');
	defineReactive(proto, '$vantMessages', {
	  'zh-CN': _zhCN.default
	});
	var _default = {
	  messages: function messages() {
	    return proto.$vantMessages[proto.$vantLang];
	  },
	  use: function use(lang, messages) {
	    var _this$add;
	
	    proto.$vantLang = lang;
	    this.add((_this$add = {}, _this$add[lang] = messages, _this$add));
	  },
	  add: function add(messages) {
	    if (messages === void 0) {
	      messages = {};
	    }
	
	    (0, _deepAssign.deepAssign)(proto.$vantMessages, messages);
	  }
	};
	exports.default = _default;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.UNSELECTED_SKU_VALUE_ID = exports.LIMIT_TYPE = void 0;
	var LIMIT_TYPE = {
	  QUOTA_LIMIT: 0,
	  STOCK_LIMIT: 1
	};
	exports.LIMIT_TYPE = LIMIT_TYPE;
	var UNSELECTED_SKU_VALUE_ID = '';
	exports.UNSELECTED_SKU_VALUE_ID = UNSELECTED_SKU_VALUE_ID;
	var _default = {
	  LIMIT_TYPE: LIMIT_TYPE,
	  UNSELECTED_SKU_VALUE_ID: UNSELECTED_SKU_VALUE_ID
	};
	exports.default = _default;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _constant = __webpack_require__(7);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('tag'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function Tag(h, props, slots, ctx) {
	  var _style, _ref;
	
	  var type = props.type,
	      mark = props.mark,
	      plain = props.plain,
	      color = props.color,
	      round = props.round,
	      size = props.size;
	  var key = plain ? 'color' : 'backgroundColor';
	  var style = (_style = {}, _style[key] = color, _style);
	
	  if (props.textColor) {
	    style.color = props.textColor;
	  }
	
	  var classes = {
	    mark: mark,
	    plain: plain,
	    round: round
	  };
	
	  if (size) {
	    classes[size] = size;
	  }
	
	  var CloseIcon = props.closeable && h(_icon.default, {
	    "attrs": {
	      "name": "cross"
	    },
	    "class": bem('close'),
	    "on": {
	      "click": function click(event) {
	        event.stopPropagation();
	        (0, _functional.emit)(ctx, 'close');
	      }
	    }
	  });
	  return h("transition", {
	    "attrs": {
	      "name": props.closeable ? 'van-fade' : null
	    }
	  }, [h("span", (0, _babelHelperVueJsxMergeProps.default)([{
	    "key": "content",
	    "style": style,
	    "class": [bem([classes, type]), (_ref = {}, _ref[_constant.BORDER_SURROUND] = plain, _ref)]
	  }, (0, _functional.inherit)(ctx, true)]), [slots.default == null ? void 0 : slots.default(), CloseIcon])]);
	}
	
	Tag.props = {
	  size: String,
	  mark: Boolean,
	  color: String,
	  plain: Boolean,
	  round: Boolean,
	  textColor: String,
	  closeable: Boolean,
	  type: {
	    type: String,
	    default: 'default'
	  }
	};
	
	var _default = createComponent(Tag);
	
	exports.default = _default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	var _Toast = _interopRequireDefault(__webpack_require__(386));
	
	var _utils = __webpack_require__(1);
	
	var _node = __webpack_require__(171);
	
	var defaultOptions = {
	  icon: '',
	  type: 'text',
	  // @deprecated
	  mask: false,
	  value: true,
	  message: '',
	  className: '',
	  overlay: false,
	  onClose: null,
	  onOpened: null,
	  duration: 2000,
	  iconPrefix: undefined,
	  position: 'middle',
	  transition: 'van-fade',
	  forbidClick: false,
	  loadingType: undefined,
	  getContainer: 'body',
	  overlayStyle: null,
	  closeOnClick: false,
	  closeOnClickOverlay: false
	}; // default options of specific type
	
	var defaultOptionsMap = {};
	var queue = [];
	var multiple = false;
	var currentOptions = (0, _extends2.default)({}, defaultOptions);
	
	function parseOptions(message) {
	  if ((0, _utils.isObject)(message)) {
	    return message;
	  }
	
	  return {
	    message: message
	  };
	}
	
	function createInstance() {
	  /* istanbul ignore if */
	  if (_utils.isServer) {
	    return {};
	  }
	
	  if (!queue.length || multiple) {
	    var toast = new (_vue.default.extend(_Toast.default))({
	      el: document.createElement('div')
	    });
	    toast.$on('input', function (value) {
	      toast.value = value;
	    });
	    queue.push(toast);
	  }
	
	  return queue[queue.length - 1];
	} // transform toast options to popup props
	
	
	function transformOptions(options) {
	  return (0, _extends2.default)({}, options, {
	    overlay: options.mask || options.overlay,
	    mask: undefined,
	    duration: undefined
	  });
	}
	
	function Toast(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var toast = createInstance(); // should add z-index if previous toast has not disappeared
	
	  if (toast.value) {
	    toast.updateZIndex();
	  }
	
	  options = parseOptions(options);
	  options = (0, _extends2.default)({}, currentOptions, {}, defaultOptionsMap[options.type || currentOptions.type], {}, options);
	
	  options.clear = function () {
	    toast.value = false;
	
	    if (options.onClose) {
	      options.onClose();
	    }
	
	    if (multiple && !_utils.isServer) {
	      toast.$on('closed', function () {
	        clearTimeout(toast.timer);
	        queue = queue.filter(function (item) {
	          return item !== toast;
	        });
	        (0, _node.removeNode)(toast.$el);
	        toast.$destroy();
	      });
	    }
	  };
	
	  (0, _extends2.default)(toast, transformOptions(options));
	  clearTimeout(toast.timer);
	
	  if (options.duration > 0) {
	    toast.timer = setTimeout(function () {
	      toast.clear();
	    }, options.duration);
	  }
	
	  return toast;
	}
	
	var createMethod = function createMethod(type) {
	  return function (options) {
	    return Toast((0, _extends2.default)({
	      type: type
	    }, parseOptions(options)));
	  };
	};
	
	['loading', 'success', 'fail'].forEach(function (method) {
	  Toast[method] = createMethod(method);
	});
	
	Toast.clear = function (all) {
	  if (queue.length) {
	    if (all) {
	      queue.forEach(function (toast) {
	        toast.clear();
	      });
	      queue = [];
	    } else if (!multiple) {
	      queue[0].clear();
	    } else {
	      queue.shift().clear();
	    }
	  }
	};
	
	Toast.setDefaultOptions = function (type, options) {
	  if (typeof type === 'string') {
	    defaultOptionsMap[type] = options;
	  } else {
	    (0, _extends2.default)(currentOptions, type);
	  }
	};
	
	Toast.resetDefaultOptions = function (type) {
	  if (typeof type === 'string') {
	    defaultOptionsMap[type] = null;
	  } else {
	    currentOptions = (0, _extends2.default)({}, defaultOptions);
	    defaultOptionsMap = {};
	  }
	};
	
	Toast.allowMultiple = function (value) {
	  if (value === void 0) {
	    value = true;
	  }
	
	  multiple = value;
	};
	
	Toast.install = function () {
	  _vue.default.use(_Toast.default);
	};
	
	_vue.default.prototype.$toast = Toast;
	var _default = Toast;
	exports.default = _default;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isNumeric = isNumeric;
	exports.isNaN = isNaN;
	
	function isNumeric(val) {
	  return /^\d+(\.\d+)?$/.test(val);
	}
	
	function isNaN(val) {
	  if (Number.isNaN) {
	    return Number.isNaN(val);
	  } // eslint-disable-next-line no-self-compare
	
	
	  return val !== val;
	}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(16);
	var normalizeHeaderName = __webpack_require__(215);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(103);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(103);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(224);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(42);
	var document = __webpack_require__(13).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(49);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(74)('keys');
	var uid = __webpack_require__(55);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(42);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var core = __webpack_require__(20);
	var LIBRARY = __webpack_require__(51);
	var wksExt = __webpack_require__(78);
	var defineProperty = __webpack_require__(26).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(14);


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 76);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 11:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(131);
	
	/***/ }),
	
	/***/ 21:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(57);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(33);
	
	/***/ }),
	
	/***/ 76:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        _vm.type === "textarea" ? "el-textarea" : "el-input",
	        _vm.inputSize ? "el-input--" + _vm.inputSize : "",
	        {
	          "is-disabled": _vm.inputDisabled,
	          "is-exceed": _vm.inputExceed,
	          "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
	          "el-input-group--append": _vm.$slots.append,
	          "el-input-group--prepend": _vm.$slots.prepend,
	          "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
	          "el-input--suffix":
	            _vm.$slots.suffix ||
	            _vm.suffixIcon ||
	            _vm.clearable ||
	            _vm.showPassword
	        }
	      ],
	      on: {
	        mouseenter: function($event) {
	          _vm.hovering = true
	        },
	        mouseleave: function($event) {
	          _vm.hovering = false
	        }
	      }
	    },
	    [
	      _vm.type !== "textarea"
	        ? [
	            _vm.$slots.prepend
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__prepend" },
	                  [_vm._t("prepend")],
	                  2
	                )
	              : _vm._e(),
	            _vm.type !== "textarea"
	              ? _c(
	                  "input",
	                  _vm._b(
	                    {
	                      ref: "input",
	                      staticClass: "el-input__inner",
	                      attrs: {
	                        tabindex: _vm.tabindex,
	                        type: _vm.showPassword
	                          ? _vm.passwordVisible
	                            ? "text"
	                            : "password"
	                          : _vm.type,
	                        disabled: _vm.inputDisabled,
	                        readonly: _vm.readonly,
	                        autocomplete: _vm.autoComplete || _vm.autocomplete,
	                        "aria-label": _vm.label
	                      },
	                      on: {
	                        compositionstart: _vm.handleCompositionStart,
	                        compositionupdate: _vm.handleCompositionUpdate,
	                        compositionend: _vm.handleCompositionEnd,
	                        input: _vm.handleInput,
	                        focus: _vm.handleFocus,
	                        blur: _vm.handleBlur,
	                        change: _vm.handleChange
	                      }
	                    },
	                    "input",
	                    _vm.$attrs,
	                    false
	                  )
	                )
	              : _vm._e(),
	            _vm.$slots.prefix || _vm.prefixIcon
	              ? _c(
	                  "span",
	                  { staticClass: "el-input__prefix" },
	                  [
	                    _vm._t("prefix"),
	                    _vm.prefixIcon
	                      ? _c("i", {
	                          staticClass: "el-input__icon",
	                          class: _vm.prefixIcon
	                        })
	                      : _vm._e()
	                  ],
	                  2
	                )
	              : _vm._e(),
	            _vm.getSuffixVisible()
	              ? _c("span", { staticClass: "el-input__suffix" }, [
	                  _c(
	                    "span",
	                    { staticClass: "el-input__suffix-inner" },
	                    [
	                      !_vm.showClear ||
	                      !_vm.showPwdVisible ||
	                      !_vm.isWordLimitVisible
	                        ? [
	                            _vm._t("suffix"),
	                            _vm.suffixIcon
	                              ? _c("i", {
	                                  staticClass: "el-input__icon",
	                                  class: _vm.suffixIcon
	                                })
	                              : _vm._e()
	                          ]
	                        : _vm._e(),
	                      _vm.showClear
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-circle-close el-input__clear",
	                            on: {
	                              mousedown: function($event) {
	                                $event.preventDefault()
	                              },
	                              click: _vm.clear
	                            }
	                          })
	                        : _vm._e(),
	                      _vm.showPwdVisible
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-view el-input__clear",
	                            on: { click: _vm.handlePasswordVisible }
	                          })
	                        : _vm._e(),
	                      _vm.isWordLimitVisible
	                        ? _c("span", { staticClass: "el-input__count" }, [
	                            _c(
	                              "span",
	                              { staticClass: "el-input__count-inner" },
	                              [
	                                _vm._v(
	                                  "\n            " +
	                                    _vm._s(_vm.textLength) +
	                                    "/" +
	                                    _vm._s(_vm.upperLimit) +
	                                    "\n          "
	                                )
	                              ]
	                            )
	                          ])
	                        : _vm._e()
	                    ],
	                    2
	                  ),
	                  _vm.validateState
	                    ? _c("i", {
	                        staticClass: "el-input__icon",
	                        class: ["el-input__validateIcon", _vm.validateIcon]
	                      })
	                    : _vm._e()
	                ])
	              : _vm._e(),
	            _vm.$slots.append
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__append" },
	                  [_vm._t("append")],
	                  2
	                )
	              : _vm._e()
	          ]
	        : _c(
	            "textarea",
	            _vm._b(
	              {
	                ref: "textarea",
	                staticClass: "el-textarea__inner",
	                style: _vm.textareaStyle,
	                attrs: {
	                  tabindex: _vm.tabindex,
	                  disabled: _vm.inputDisabled,
	                  readonly: _vm.readonly,
	                  autocomplete: _vm.autoComplete || _vm.autocomplete,
	                  "aria-label": _vm.label
	                },
	                on: {
	                  compositionstart: _vm.handleCompositionStart,
	                  compositionupdate: _vm.handleCompositionUpdate,
	                  compositionend: _vm.handleCompositionEnd,
	                  input: _vm.handleInput,
	                  focus: _vm.handleFocus,
	                  blur: _vm.handleBlur,
	                  change: _vm.handleChange
	                }
	              },
	              "textarea",
	              _vm.$attrs,
	              false
	            )
	          ),
	      _vm.isWordLimitVisible && _vm.type === "textarea"
	        ? _c("span", { staticClass: "el-input__count" }, [
	            _vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))
	          ])
	        : _vm._e()
	    ],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
	var migrating_ = __webpack_require__(11);
	var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);
	
	// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
	var hiddenTextarea = void 0;
	
	var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
	
	var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	
	function calculateNodeStyling(targetElement) {
	  var style = window.getComputedStyle(targetElement);
	
	  var boxSizing = style.getPropertyValue('box-sizing');
	
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	
	  var contextStyle = CONTEXT_STYLE.map(function (name) {
	    return name + ':' + style.getPropertyValue(name);
	  }).join(';');
	
	  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
	}
	
	function calcTextareaHeight(targetElement) {
	  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  }
	
	  var _calculateNodeStyling = calculateNodeStyling(targetElement),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      contextStyle = _calculateNodeStyling.contextStyle;
	
	  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
	  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';
	
	  var height = hiddenTextarea.scrollHeight;
	  var result = {};
	
	  if (boxSizing === 'border-box') {
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    height = height - paddingSize;
	  }
	
	  hiddenTextarea.value = '';
	  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	  if (minRows !== null) {
	    var minHeight = singleRowHeight * minRows;
	    if (boxSizing === 'border-box') {
	      minHeight = minHeight + paddingSize + borderSize;
	    }
	    height = Math.max(minHeight, height);
	    result.minHeight = minHeight + 'px';
	  }
	  if (maxRows !== null) {
	    var maxHeight = singleRowHeight * maxRows;
	    if (boxSizing === 'border-box') {
	      maxHeight = maxHeight + paddingSize + borderSize;
	    }
	    height = Math.min(maxHeight, height);
	  }
	  result.height = height + 'px';
	  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
	  hiddenTextarea = null;
	  return result;
	};
	// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
	var merge_ = __webpack_require__(9);
	var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(21);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	/* harmony default export */ var inputvue_type_script_lang_js_ = ({
	  name: 'ElInput',
	
	  componentName: 'ElInput',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  inheritAttrs: false,
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      textareaCalcStyle: {},
	      hovering: false,
	      focused: false,
	      isComposing: false,
	      passwordVisible: false
	    };
	  },
	
	
	  props: {
	    value: [String, Number],
	    size: String,
	    resize: String,
	    form: String,
	    disabled: Boolean,
	    readonly: Boolean,
	    type: {
	      type: String,
	      default: 'text'
	    },
	    autosize: {
	      type: [Boolean, Object],
	      default: false
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    validateEvent: {
	      type: Boolean,
	      default: true
	    },
	    suffixIcon: String,
	    prefixIcon: String,
	    label: String,
	    clearable: {
	      type: Boolean,
	      default: false
	    },
	    showPassword: {
	      type: Boolean,
	      default: false
	    },
	    showWordLimit: {
	      type: Boolean,
	      default: false
	    },
	    tabindex: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    validateState: function validateState() {
	      return this.elFormItem ? this.elFormItem.validateState : '';
	    },
	    needStatusIcon: function needStatusIcon() {
	      return this.elForm ? this.elForm.statusIcon : false;
	    },
	    validateIcon: function validateIcon() {
	      return {
	        validating: 'el-icon-loading',
	        success: 'el-icon-circle-check',
	        error: 'el-icon-circle-close'
	      }[this.validateState];
	    },
	    textareaStyle: function textareaStyle() {
	      return merge_default()({}, this.textareaCalcStyle, { resize: this.resize });
	    },
	    inputSize: function inputSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputDisabled: function inputDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    nativeInputValue: function nativeInputValue() {
	      return this.value === null || this.value === undefined ? '' : String(this.value);
	    },
	    showClear: function showClear() {
	      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
	    },
	    showPwdVisible: function showPwdVisible() {
	      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
	    },
	    isWordLimitVisible: function isWordLimitVisible() {
	      return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
	    },
	    upperLimit: function upperLimit() {
	      return this.$attrs.maxlength;
	    },
	    textLength: function textLength() {
	      if (typeof this.value === 'number') {
	        return String(this.value).length;
	      }
	
	      return (this.value || '').length;
	    },
	    inputExceed: function inputExceed() {
	      // show exceed style if length of initial value greater then maxlength
	      return this.isWordLimitVisible && this.textLength > this.upperLimit;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.$nextTick(this.resizeTextarea);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', [val]);
	      }
	    },
	
	    // native input value is set explicitly
	    // do not use v-model / :value in template
	    // see: https://github.com/ElemeFE/element/issues/14521
	    nativeInputValue: function nativeInputValue() {
	      this.setNativeInputValue();
	    },
	
	    // when change between <input> and <textarea>,
	    // update DOM dependent value and styles
	    // https://github.com/ElemeFE/element/issues/14857
	    type: function type() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.setNativeInputValue();
	        _this.resizeTextarea();
	        _this.updateIconOffset();
	      });
	    }
	  },
	
	  methods: {
	    focus: function focus() {
	      this.getInput().focus();
	    },
	    blur: function blur() {
	      this.getInput().blur();
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
	          'on-icon-click': 'on-icon-click is removed.'
	        },
	        events: {
	          'click': 'click is removed.'
	        }
	      };
	    },
	    handleBlur: function handleBlur(event) {
	      this.focused = false;
	      this.$emit('blur', event);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
	      }
	    },
	    select: function select() {
	      this.getInput().select();
	    },
	    resizeTextarea: function resizeTextarea() {
	      if (this.$isServer) return;
	      var autosize = this.autosize,
	          type = this.type;
	
	      if (type !== 'textarea') return;
	      if (!autosize) {
	        this.textareaCalcStyle = {
	          minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
	        };
	        return;
	      }
	      var minRows = autosize.minRows;
	      var maxRows = autosize.maxRows;
	
	      this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
	    },
	    setNativeInputValue: function setNativeInputValue() {
	      var input = this.getInput();
	      if (!input) return;
	      if (input.value === this.nativeInputValue) return;
	      input.value = this.nativeInputValue;
	    },
	    handleFocus: function handleFocus(event) {
	      this.focused = true;
	      this.$emit('focus', event);
	    },
	    handleCompositionStart: function handleCompositionStart() {
	      this.isComposing = true;
	    },
	    handleCompositionUpdate: function handleCompositionUpdate(event) {
	      var text = event.target.value;
	      var lastCharacter = text[text.length - 1] || '';
	      this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
	    },
	    handleCompositionEnd: function handleCompositionEnd(event) {
	      if (this.isComposing) {
	        this.isComposing = false;
	        this.handleInput(event);
	      }
	    },
	    handleInput: function handleInput(event) {
	      // should not emit input during composition
	      // see: https://github.com/ElemeFE/element/issues/10516
	      if (this.isComposing) return;
	
	      // hack for https://github.com/ElemeFE/element/issues/8548
	      // should remove the following line when we don't support IE
	      if (event.target.value === this.nativeInputValue) return;
	
	      this.$emit('input', event.target.value);
	
	      // ensure native input value is controlled
	      // see: https://github.com/ElemeFE/element/issues/12850
	      this.$nextTick(this.setNativeInputValue);
	    },
	    handleChange: function handleChange(event) {
	      this.$emit('change', event.target.value);
	    },
	    calcIconOffset: function calcIconOffset(place) {
	      var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
	      if (!elList.length) return;
	      var el = null;
	      for (var i = 0; i < elList.length; i++) {
	        if (elList[i].parentNode === this.$el) {
	          el = elList[i];
	          break;
	        }
	      }
	      if (!el) return;
	      var pendantMap = {
	        suffix: 'append',
	        prefix: 'prepend'
	      };
	
	      var pendant = pendantMap[place];
	      if (this.$slots[pendant]) {
	        el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
	      } else {
	        el.removeAttribute('style');
	      }
	    },
	    updateIconOffset: function updateIconOffset() {
	      this.calcIconOffset('prefix');
	      this.calcIconOffset('suffix');
	    },
	    clear: function clear() {
	      this.$emit('input', '');
	      this.$emit('change', '');
	      this.$emit('clear');
	    },
	    handlePasswordVisible: function handlePasswordVisible() {
	      this.passwordVisible = !this.passwordVisible;
	      this.focus();
	    },
	    getInput: function getInput() {
	      return this.$refs.input || this.$refs.textarea;
	    },
	    getSuffixVisible: function getSuffixVisible() {
	      return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
	    }
	  },
	
	  created: function created() {
	    this.$on('inputSelect', this.select);
	  },
	  mounted: function mounted() {
	    this.setNativeInputValue();
	    this.resizeTextarea();
	    this.updateIconOffset();
	  },
	  updated: function updated() {
	    this.$nextTick(this.updateIconOffset);
	  }
	});
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/input/src/input.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_inputvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/input/src/input.vue"
	/* harmony default export */ var input = (component.exports);
	// CONCATENATED MODULE: ./packages/input/index.js
	
	
	/* istanbul ignore next */
	input.install = function (Vue) {
	  Vue.component(input.name, input);
	};
	
	/* harmony default export */ var packages_input = __webpack_exports__["default"] = (input);
	
	/***/ }),
	
	/***/ 9:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(56);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.i18n = exports.use = exports.t = undefined;
	
	var _zhCN = __webpack_require__(277);
	
	var _zhCN2 = _interopRequireDefault(_zhCN);
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _deepmerge = __webpack_require__(269);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _format = __webpack_require__(276);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = (0, _format2.default)(_vue2.default);
	var lang = _zhCN2.default;
	var merged = false;
	var i18nHandler = function i18nHandler() {
	  var vuei18n = Object.getPrototypeOf(this || _vue2.default).$t;
	  if (typeof vuei18n === 'function' && !!_vue2.default.locale) {
	    if (!merged) {
	      merged = true;
	      _vue2.default.locale(_vue2.default.config.lang, (0, _deepmerge2.default)(lang, _vue2.default.locale(_vue2.default.config.lang) || {}, { clone: true }));
	    }
	    return vuei18n.apply(this, arguments);
	  }
	};
	
	var t = exports.t = function t(path, options) {
	  var value = i18nHandler.apply(this, arguments);
	  if (value !== null && value !== undefined) return value;
	
	  var array = path.split('.');
	  var current = lang;
	
	  for (var i = 0, j = array.length; i < j; i++) {
	    var property = array[i];
	    value = current[property];
	    if (i === j - 1) return format(value, options);
	    if (!value) return '';
	    current = value;
	  }
	  return '';
	};
	
	var use = exports.use = function use(l) {
	  lang = l || lang;
	};
	
	var i18n = exports.i18n = function i18n(fn) {
	  i18nHandler = fn || i18nHandler;
	};
	
	exports.default = { use: use, t: t, i18n: i18n };

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (ref) {
	  return {
	    methods: {
	      focus: function focus() {
	        this.$refs[ref].focus();
	      }
	    }
	  };
	};
	
	;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _locale = __webpack_require__(80);
	
	exports.default = {
	  methods: {
	    t: function t() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _locale.t.apply(this, args);
	    }
	  }
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 127);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 127:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
	var resize_event_ = __webpack_require__(16);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
	var scrollbar_width_ = __webpack_require__(38);
	var scrollbar_width_default = /*#__PURE__*/__webpack_require__.n(scrollbar_width_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(2);
	
	// CONCATENATED MODULE: ./packages/scrollbar/src/util.js
	var BAR_MAP = {
	  vertical: {
	    offset: 'offsetHeight',
	    scroll: 'scrollTop',
	    scrollSize: 'scrollHeight',
	    size: 'height',
	    key: 'vertical',
	    axis: 'Y',
	    client: 'clientY',
	    direction: 'top'
	  },
	  horizontal: {
	    offset: 'offsetWidth',
	    scroll: 'scrollLeft',
	    scrollSize: 'scrollWidth',
	    size: 'width',
	    key: 'horizontal',
	    axis: 'X',
	    client: 'clientX',
	    direction: 'left'
	  }
	};
	
	function renderThumbStyle(_ref) {
	  var move = _ref.move,
	      size = _ref.size,
	      bar = _ref.bar;
	
	  var style = {};
	  var translate = 'translate' + bar.axis + '(' + move + '%)';
	
	  style[bar.size] = size;
	  style.transform = translate;
	  style.msTransform = translate;
	  style.webkitTransform = translate;
	
	  return style;
	};
	// CONCATENATED MODULE: ./packages/scrollbar/src/bar.js
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var src_bar = ({
	  name: 'Bar',
	
	  props: {
	    vertical: Boolean,
	    size: String,
	    move: Number
	  },
	
	  computed: {
	    bar: function bar() {
	      return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
	    },
	    wrap: function wrap() {
	      return this.$parent.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var size = this.size,
	        move = this.move,
	        bar = this.bar;
	
	
	    return h(
	      'div',
	      {
	        'class': ['el-scrollbar__bar', 'is-' + bar.key],
	        on: {
	          'mousedown': this.clickTrackHandler
	        }
	      },
	      [h('div', {
	        ref: 'thumb',
	        'class': 'el-scrollbar__thumb',
	        on: {
	          'mousedown': this.clickThumbHandler
	        },
	
	        style: renderThumbStyle({ size: size, move: move, bar: bar }) })]
	    );
	  },
	
	
	  methods: {
	    clickThumbHandler: function clickThumbHandler(e) {
	      // prevent click event of right button
	      if (e.ctrlKey || e.button === 2) {
	        return;
	      }
	      this.startDrag(e);
	      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
	    },
	    clickTrackHandler: function clickTrackHandler(e) {
	      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
	      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
	      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    startDrag: function startDrag(e) {
	      e.stopImmediatePropagation();
	      this.cursorDown = true;
	
	      Object(dom_["on"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      Object(dom_["on"])(document, 'mouseup', this.mouseUpDocumentHandler);
	      document.onselectstart = function () {
	        return false;
	      };
	    },
	    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
	      if (this.cursorDown === false) return;
	      var prevPage = this[this.bar.axis];
	
	      if (!prevPage) return;
	
	      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
	      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
	      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
	      this.cursorDown = false;
	      this[this.bar.axis] = 0;
	      Object(dom_["off"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      document.onselectstart = null;
	    }
	  },
	
	  destroyed: function destroyed() {
	    Object(dom_["off"])(document, 'mouseup', this.mouseUpDocumentHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/src/main.js
	// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js
	
	
	
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var main = ({
	  name: 'ElScrollbar',
	
	  components: { Bar: src_bar },
	
	  props: {
	    native: Boolean,
	    wrapStyle: {},
	    wrapClass: {},
	    viewClass: {},
	    viewStyle: {},
	    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
	    tag: {
	      type: String,
	      default: 'div'
	    }
	  },
	
	  data: function data() {
	    return {
	      sizeWidth: '0',
	      sizeHeight: '0',
	      moveX: 0,
	      moveY: 0
	    };
	  },
	
	
	  computed: {
	    wrap: function wrap() {
	      return this.$refs.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var gutter = scrollbar_width_default()();
	    var style = this.wrapStyle;
	
	    if (gutter) {
	      var gutterWith = '-' + gutter + 'px';
	      var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';
	
	      if (Array.isArray(this.wrapStyle)) {
	        style = Object(util_["toObject"])(this.wrapStyle);
	        style.marginRight = style.marginBottom = gutterWith;
	      } else if (typeof this.wrapStyle === 'string') {
	        style += gutterStyle;
	      } else {
	        style = gutterStyle;
	      }
	    }
	    var view = h(this.tag, {
	      class: ['el-scrollbar__view', this.viewClass],
	      style: this.viewStyle,
	      ref: 'resize'
	    }, this.$slots.default);
	    var wrap = h(
	      'div',
	      {
	        ref: 'wrap',
	        style: style,
	        on: {
	          'scroll': this.handleScroll
	        },
	
	        'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] },
	      [[view]]
	    );
	    var nodes = void 0;
	
	    if (!this.native) {
	      nodes = [wrap, h(src_bar, {
	        attrs: {
	          move: this.moveX,
	          size: this.sizeWidth }
	      }), h(src_bar, {
	        attrs: {
	          vertical: true,
	          move: this.moveY,
	          size: this.sizeHeight }
	      })];
	    } else {
	      nodes = [h(
	        'div',
	        {
	          ref: 'wrap',
	          'class': [this.wrapClass, 'el-scrollbar__wrap'],
	          style: style },
	        [[view]]
	      )];
	    }
	    return h('div', { class: 'el-scrollbar' }, nodes);
	  },
	
	
	  methods: {
	    handleScroll: function handleScroll() {
	      var wrap = this.wrap;
	
	      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
	      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
	    },
	    update: function update() {
	      var heightPercentage = void 0,
	          widthPercentage = void 0;
	      var wrap = this.wrap;
	      if (!wrap) return;
	
	      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
	      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;
	
	      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
	      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.native) return;
	    this.$nextTick(this.update);
	    !this.noresize && Object(resize_event_["addResizeListener"])(this.$refs.resize, this.update);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.native) return;
	    !this.noresize && Object(resize_event_["removeResizeListener"])(this.$refs.resize, this.update);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/index.js
	
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.component(main.name, main);
	};
	
	/* harmony default export */ var scrollbar = __webpack_exports__["default"] = (main);
	
	/***/ }),
	
	/***/ 16:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(85);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(23);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(21);
	
	/***/ }),
	
	/***/ 38:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(87);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var aria = aria || {};
	
	aria.Utils = aria.Utils || {};
	
	/**
	 * @desc Set focus on descendant nodes until the first focusable element is
	 *       found.
	 * @param element
	 *          DOM node for which to find the first focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	aria.Utils.focusFirstDescendant = function (element) {
	  for (var i = 0; i < element.childNodes.length; i++) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Find the last descendant node that is focusable.
	 * @param element
	 *          DOM node for which to find the last focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	
	aria.Utils.focusLastDescendant = function (element) {
	  for (var i = element.childNodes.length - 1; i >= 0; i--) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Set Attempt to set focus on the current node.
	 * @param element
	 *          The node to attempt to focus on.
	 * @returns
	 *  true if element is focused.
	 */
	aria.Utils.attemptFocus = function (element) {
	  if (!aria.Utils.isFocusable(element)) {
	    return false;
	  }
	  aria.Utils.IgnoreUtilFocusChanges = true;
	  try {
	    element.focus();
	  } catch (e) {}
	  aria.Utils.IgnoreUtilFocusChanges = false;
	  return document.activeElement === element;
	};
	
	aria.Utils.isFocusable = function (element) {
	  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
	    return true;
	  }
	
	  if (element.disabled) {
	    return false;
	  }
	
	  switch (element.nodeName) {
	    case 'A':
	      return !!element.href && element.rel !== 'ignore';
	    case 'INPUT':
	      return element.type !== 'hidden' && element.type !== 'file';
	    case 'BUTTON':
	    case 'SELECT':
	    case 'TEXTAREA':
	      return true;
	    default:
	      return false;
	  }
	};
	
	/**
	 * 触发一个事件
	 * mouseenter, mouseleave, mouseover, keyup, change, click 等
	 * @param  {Element} elm
	 * @param  {String} name
	 * @param  {*} opts
	 */
	aria.Utils.triggerEvent = function (elm, name) {
	  var eventName = void 0;
	
	  if (/^mouse|click/.test(name)) {
	    eventName = 'MouseEvents';
	  } else if (/^key/.test(name)) {
	    eventName = 'KeyboardEvent';
	  } else {
	    eventName = 'HTMLEvents';
	  }
	  var evt = document.createEvent(eventName);
	
	  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    opts[_key - 2] = arguments[_key];
	  }
	
	  evt.initEvent.apply(evt, [name].concat(opts));
	  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);
	
	  return elm;
	};
	
	aria.Utils.keys = {
	  tab: 9,
	  enter: 13,
	  space: 32,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  esc: 27
	};
	
	exports.default = aria.Utils;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.removeResizeListener = exports.addResizeListener = undefined;
	
	var _resizeObserverPolyfill = __webpack_require__(304);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isServer = typeof window === 'undefined';
	
	/* istanbul ignore next */
	var resizeHandler = function resizeHandler(entries) {
	  for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var entry = _ref;
	
	    var listeners = entry.target.__resizeListeners__ || [];
	    if (listeners.length) {
	      listeners.forEach(function (fn) {
	        fn();
	      });
	    }
	  }
	};
	
	/* istanbul ignore next */
	var addResizeListener = exports.addResizeListener = function addResizeListener(element, fn) {
	  if (isServer) return;
	  if (!element.__resizeListeners__) {
	    element.__resizeListeners__ = [];
	    element.__ro__ = new _resizeObserverPolyfill2.default(resizeHandler);
	    element.__ro__.observe(element);
	  }
	  element.__resizeListeners__.push(fn);
	};
	
	/* istanbul ignore next */
	var removeResizeListener = exports.removeResizeListener = function removeResizeListener(element, fn) {
	  if (!element || !element.__resizeListeners__) return;
	  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	  if (!element.__resizeListeners__.length) {
	    element.__ro__.disconnect();
	  }
	};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = scrollIntoView;
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollIntoView(container, selected) {
	  if (_vue2.default.prototype.$isServer) return;
	
	  if (!selected) {
	    container.scrollTop = 0;
	    return;
	  }
	
	  var offsetParents = [];
	  var pointer = selected.offsetParent;
	  while (pointer && container !== pointer && container.contains(pointer)) {
	    offsetParents.push(pointer);
	    pointer = pointer.offsetParent;
	  }
	  var top = selected.offsetTop + offsetParents.reduce(function (prev, curr) {
	    return prev + curr.offsetTop;
	  }, 0);
	  var bottom = top + selected.offsetHeight;
	  var viewRectTop = container.scrollTop;
	  var viewRectBottom = viewRectTop + container.clientHeight;
	
	  if (top < viewRectTop) {
	    container.scrollTop = top;
	  } else if (bottom > viewRectBottom) {
	    container.scrollTop = bottom - container.clientHeight;
	  }
	}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  if (_vue2.default.prototype.$isServer) return 0;
	  if (scrollBarWidth !== undefined) return scrollBarWidth;
	
	  var outer = document.createElement('div');
	  outer.className = 'el-scrollbar__wrap';
	  outer.style.visibility = 'hidden';
	  outer.style.width = '100px';
	  outer.style.position = 'absolute';
	  outer.style.top = '-9999px';
	  document.body.appendChild(outer);
	
	  var widthNoScroll = outer.offsetWidth;
	  outer.style.overflow = 'scroll';
	
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  outer.appendChild(inner);
	
	  var widthWithScroll = inner.offsetWidth;
	  outer.parentNode.removeChild(outer);
	  scrollBarWidth = widthNoScroll - widthWithScroll;
	
	  return scrollBarWidth;
	};
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scrollBarWidth = void 0;
	
	;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	/* eslint-disable no-undefined,no-param-reassign,no-shadow */
	
	/**
	 * Throttle execution of a function. Especially useful for rate limiting
	 * execution of handlers on events like resize and scroll.
	 *
	 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
	 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
	 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
	 *                                    the internal counter is reset)
	 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                    to `callback` when the throttled-function is executed.
	 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
	 *                                    schedule `callback` to execute after `delay` ms.
	 *
	 * @return {Function}  A new, throttled, function.
	 */
	module.exports = function ( delay, noTrailing, callback, debounceMode ) {
	
		// After wrapper has stopped being called, this timeout ensures that
		// `callback` is executed at the proper times in `throttle` and `end`
		// debounce modes.
		var timeoutID;
	
		// Keep track of the last time `callback` was executed.
		var lastExec = 0;
	
		// `noTrailing` defaults to falsy.
		if ( typeof noTrailing !== 'boolean' ) {
			debounceMode = callback;
			callback = noTrailing;
			noTrailing = undefined;
		}
	
		// The `wrapper` function encapsulates all of the throttling / debouncing
		// functionality and when executed will limit the rate at which `callback`
		// is executed.
		function wrapper () {
	
			var self = this;
			var elapsed = Number(new Date()) - lastExec;
			var args = arguments;
	
			// Execute `callback` and update the `lastExec` timestamp.
			function exec () {
				lastExec = Number(new Date());
				callback.apply(self, args);
			}
	
			// If `debounceMode` is true (at begin) this is used to clear the flag
			// to allow future `callback` executions.
			function clear () {
				timeoutID = undefined;
			}
	
			if ( debounceMode && !timeoutID ) {
				// Since `wrapper` is being called for the first time and
				// `debounceMode` is true (at begin), execute `callback`.
				exec();
			}
	
			// Clear any existing timeout.
			if ( timeoutID ) {
				clearTimeout(timeoutID);
			}
	
			if ( debounceMode === undefined && elapsed > delay ) {
				// In throttle mode, if `delay` time has been exceeded, execute
				// `callback`.
				exec();
	
			} else if ( noTrailing !== true ) {
				// In trailing throttle mode, since `delay` time has not been
				// exceeded, schedule `callback` to execute `delay` ms after most
				// recent execution.
				//
				// If `debounceMode` is true (at begin), schedule `clear` to execute
				// after `delay` ms.
				//
				// If `debounceMode` is false (at end), schedule `callback` to
				// execute after `delay` ms.
				timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
			}
	
		}
	
		// Return the wrapper function.
		return wrapper;
	
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.formatMonthTitle = formatMonthTitle;
	exports.compareMonth = compareMonth;
	exports.compareDay = compareDay;
	exports.getPrevDay = getPrevDay;
	exports.getNextDay = getNextDay;
	exports.calcDateNum = calcDateNum;
	exports.copyDates = copyDates;
	exports.ROW_HEIGHT = exports.t = exports.bem = exports.createComponent = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _createNamespace = (0, _utils.createNamespace)('calendar'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	exports.t = t;
	exports.bem = bem;
	exports.createComponent = createComponent;
	var ROW_HEIGHT = 64;
	exports.ROW_HEIGHT = ROW_HEIGHT;
	
	function formatMonthTitle(date) {
	  return t('monthTitle', date.getFullYear(), date.getMonth() + 1);
	}
	
	function compareMonth(date1, date2) {
	  var year1 = date1.getFullYear();
	  var year2 = date2.getFullYear();
	  var month1 = date1.getMonth();
	  var month2 = date2.getMonth();
	
	  if (year1 === year2) {
	    return month1 === month2 ? 0 : month1 > month2 ? 1 : -1;
	  }
	
	  return year1 > year2 ? 1 : -1;
	}
	
	function compareDay(day1, day2) {
	  var compareMonthResult = compareMonth(day1, day2);
	
	  if (compareMonthResult === 0) {
	    var date1 = day1.getDate();
	    var date2 = day2.getDate();
	    return date1 === date2 ? 0 : date1 > date2 ? 1 : -1;
	  }
	
	  return compareMonthResult;
	}
	
	function getDayByOffset(date, offset) {
	  date = new Date(date);
	  date.setDate(date.getDate() + offset);
	  return date;
	}
	
	function getPrevDay(date) {
	  return getDayByOffset(date, -1);
	}
	
	function getNextDay(date) {
	  return getDayByOffset(date, 1);
	}
	
	function calcDateNum(date) {
	  var day1 = date[0].getTime();
	  var day2 = date[1].getTime();
	  return (day2 - day1) / (1000 * 60 * 60 * 24) + 1;
	}
	
	function copyDates(dates) {
	  if (Array.isArray(dates)) {
	    return dates.map(function (date) {
	      if (date === null) {
	        return date;
	      }
	
	      return new Date(date);
	    });
	  }
	
	  return new Date(dates);
	}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _constant = __webpack_require__(7);
	
	// Utils
	var _createNamespace = (0, _utils.createNamespace)('cell-group'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function CellGroup(h, props, slots, ctx) {
	  var _ref;
	
	  var Group = h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": [bem(), (_ref = {}, _ref[_constant.BORDER_TOP_BOTTOM] = props.border, _ref)]
	  }, (0, _functional.inherit)(ctx, true)]), [slots.default == null ? void 0 : slots.default()]);
	
	  if (props.title || slots.title) {
	    return h("div", [h("div", {
	      "class": bem('title')
	    }, [slots.title ? slots.title() : props.title]), Group]);
	  }
	
	  return Group;
	}
	
	CellGroup.props = {
	  title: String,
	  border: {
	    type: Boolean,
	    default: true
	  }
	};
	
	var _default = createComponent(CellGroup);
	
	exports.default = _default;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.cellProps = void 0;
	var cellProps = {
	  icon: String,
	  size: String,
	  center: Boolean,
	  isLink: Boolean,
	  required: Boolean,
	  clickable: Boolean,
	  iconPrefix: String,
	  titleStyle: null,
	  titleClass: null,
	  valueClass: null,
	  labelClass: null,
	  title: [Number, String],
	  value: [Number, String],
	  label: [Number, String],
	  arrowDirection: String,
	  border: {
	    type: Boolean,
	    default: true
	  }
	};
	exports.cellProps = cellProps;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.times = times;
	exports.getTrueValue = getTrueValue;
	exports.getMonthEndDay = getMonthEndDay;
	
	var _number = __webpack_require__(65);
	
	function times(n, iteratee) {
	  var index = -1;
	  var result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	
	  return result;
	}
	
	function getTrueValue(value) {
	  if (!value) {
	    return 0;
	  }
	
	  while ((0, _number.isNaN)(parseInt(value, 10))) {
	    if (value.length > 1) {
	      value = value.slice(1);
	    } else {
	      return 0;
	    }
	  }
	
	  return parseInt(value, 10);
	}
	
	function getMonthEndDay(year, month) {
	  return 32 - new Date(year, month - 1, 32).getDate();
	}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	var _Dialog = _interopRequireDefault(__webpack_require__(336));
	
	var _utils = __webpack_require__(1);
	
	var instance;
	
	function isInDocument(element) {
	  return document.body.contains(element);
	}
	
	function initInstance() {
	  if (instance) {
	    instance.$destroy();
	  }
	
	  instance = new (_vue.default.extend(_Dialog.default))({
	    el: document.createElement('div'),
	    // avoid missing animation when first rendered
	    propsData: {
	      lazyRender: false
	    }
	  });
	  instance.$on('input', function (value) {
	    instance.value = value;
	  });
	}
	
	function Dialog(options) {
	  /* istanbul ignore if */
	  if (_utils.isServer) {
	    return Promise.resolve();
	  }
	
	  return new Promise(function (resolve, reject) {
	    if (!instance || !isInDocument(instance.$el)) {
	      initInstance();
	    }
	
	    (0, _extends2.default)(instance, Dialog.currentOptions, options, {
	      resolve: resolve,
	      reject: reject
	    });
	  });
	}
	
	Dialog.defaultOptions = {
	  value: true,
	  title: '',
	  width: '',
	  message: '',
	  overlay: true,
	  className: '',
	  lockScroll: true,
	  transition: 'van-dialog-bounce',
	  beforeClose: null,
	  overlayClass: '',
	  overlayStyle: null,
	  messageAlign: '',
	  getContainer: 'body',
	  cancelButtonText: '',
	  cancelButtonColor: null,
	  confirmButtonText: '',
	  confirmButtonColor: null,
	  showConfirmButton: true,
	  showCancelButton: false,
	  closeOnPopstate: false,
	  closeOnClickOverlay: false,
	  callback: function callback(action) {
	    instance[action === 'confirm' ? 'resolve' : 'reject'](action);
	  }
	};
	Dialog.alert = Dialog;
	
	Dialog.confirm = function (options) {
	  return Dialog((0, _extends2.default)({
	    showCancelButton: true
	  }, options));
	};
	
	Dialog.close = function () {
	  if (instance) {
	    instance.value = false;
	  }
	};
	
	Dialog.setDefaultOptions = function (options) {
	  (0, _extends2.default)(Dialog.currentOptions, options);
	};
	
	Dialog.resetDefaultOptions = function () {
	  Dialog.currentOptions = (0, _extends2.default)({}, Dialog.defaultOptions);
	};
	
	Dialog.resetDefaultOptions();
	
	Dialog.install = function () {
	  _vue.default.use(_Dialog.default);
	};
	
	Dialog.Component = _Dialog.default;
	_vue.default.prototype.$dialog = Dialog;
	var _default = Dialog;
	exports.default = _default;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	var _ImagePreview = _interopRequireDefault(__webpack_require__(346));
	
	var _utils = __webpack_require__(1);
	
	var instance;
	var defaultConfig = {
	  loop: true,
	  images: [],
	  value: true,
	  minZoom: 1 / 3,
	  maxZoom: 3,
	  className: '',
	  onClose: null,
	  onChange: null,
	  lazyLoad: false,
	  showIndex: true,
	  closeable: false,
	  closeIcon: 'clear',
	  asyncClose: false,
	  startPosition: 0,
	  swipeDuration: 500,
	  showIndicators: false,
	  closeOnPopstate: false,
	  closeIconPosition: 'top-right'
	};
	
	var initInstance = function initInstance() {
	  instance = new (_vue.default.extend(_ImagePreview.default))({
	    el: document.createElement('div')
	  });
	  document.body.appendChild(instance.$el);
	  instance.$on('change', function (index) {
	    if (instance.onChange) {
	      instance.onChange(index);
	    }
	  });
	  instance.$on('scale', function (data) {
	    if (instance.onScale) {
	      instance.onScale(data);
	    }
	  });
	};
	
	var ImagePreview = function ImagePreview(images, startPosition) {
	  if (startPosition === void 0) {
	    startPosition = 0;
	  }
	
	  /* istanbul ignore if */
	  if (_utils.isServer) {
	    return;
	  }
	
	  if (!instance) {
	    initInstance();
	  }
	
	  var options = Array.isArray(images) ? {
	    images: images,
	    startPosition: startPosition
	  } : images;
	  (0, _extends2.default)(instance, defaultConfig, options);
	  instance.$once('input', function (show) {
	    instance.value = show;
	  });
	
	  if (options.onClose) {
	    instance.$off('close');
	    instance.$once('close', options.onClose);
	  }
	
	  return instance;
	};
	
	ImagePreview.install = function () {
	  _vue.default.use(_ImagePreview.default);
	};
	
	var _default = ImagePreview;
	exports.default = _default;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _event = __webpack_require__(10);
	
	var _constant = __webpack_require__(7);
	
	var _shared = __webpack_require__(97);
	
	var _loading = _interopRequireDefault(__webpack_require__(18));
	
	var _PickerColumn = _interopRequireDefault(__webpack_require__(365));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('picker'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	var _default2 = createComponent({
	  props: (0, _extends2.default)({}, _shared.pickerProps, {
	    defaultIndex: {
	      type: [Number, String],
	      default: 0
	    },
	    columns: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    toolbarPosition: {
	      type: String,
	      default: 'top'
	    },
	    valueKey: {
	      type: String,
	      default: 'text'
	    }
	  }),
	  data: function data() {
	    return {
	      children: [],
	      formattedColumns: []
	    };
	  },
	  computed: {
	    dataType: function dataType() {
	      var columns = this.columns;
	      var firstColumn = columns[0] || {};
	
	      if (firstColumn.children) {
	        return 'cascade';
	      }
	
	      if (firstColumn.values) {
	        return 'object';
	      }
	
	      return 'text';
	    }
	  },
	  watch: {
	    columns: {
	      handler: 'format',
	      immediate: true
	    }
	  },
	  methods: {
	    format: function format() {
	      var columns = this.columns,
	          dataType = this.dataType;
	
	      if (dataType === 'text') {
	        this.formattedColumns = [{
	          values: columns
	        }];
	      } else if (dataType === 'cascade') {
	        this.formatCascade();
	      } else {
	        this.formattedColumns = columns;
	      }
	    },
	    formatCascade: function formatCascade() {
	      var _this = this;
	
	      var formatted = [];
	      var cursor = {
	        children: this.columns
	      };
	
	      while (cursor && cursor.children) {
	        var defaultIndex = cursor.defaultIndex || +this.defaultIndex;
	        formatted.push({
	          values: cursor.children.map(function (item) {
	            return item[_this.valueKey];
	          }),
	          className: cursor.className,
	          defaultIndex: defaultIndex
	        });
	        cursor = cursor.children[defaultIndex];
	      }
	
	      this.formattedColumns = formatted;
	    },
	    emit: function emit(event) {
	      if (this.dataType === 'text') {
	        this.$emit(event, this.getColumnValue(0), this.getColumnIndex(0));
	      } else {
	        this.$emit(event, this.getValues(), this.getIndexes());
	      }
	    },
	    onCascadeChange: function onCascadeChange(columnIndex) {
	      var _this2 = this;
	
	      var cursor = {
	        children: this.columns
	      };
	      var indexes = this.getIndexes();
	
	      for (var i = 0; i <= columnIndex; i++) {
	        cursor = cursor.children[indexes[i]];
	      }
	
	      while (cursor.children) {
	        columnIndex++;
	        this.setColumnValues(columnIndex, cursor.children.map(function (item) {
	          return item[_this2.valueKey];
	        }));
	        cursor = cursor.children[cursor.defaultIndex || 0];
	      }
	    },
	    onChange: function onChange(columnIndex) {
	      if (this.dataType === 'cascade') {
	        this.onCascadeChange(columnIndex);
	      }
	
	      if (this.dataType === 'text') {
	        this.$emit('change', this, this.getColumnValue(0), this.getColumnIndex(0));
	      } else {
	        this.$emit('change', this, this.getValues(), columnIndex);
	      }
	    },
	    // get column instance by index
	    getColumn: function getColumn(index) {
	      return this.children[index];
	    },
	    // @exposed-api
	    // get column value by index
	    getColumnValue: function getColumnValue(index) {
	      var column = this.getColumn(index);
	      return column && column.getValue();
	    },
	    // @exposed-api
	    // set column value by index
	    setColumnValue: function setColumnValue(index, value) {
	      var column = this.getColumn(index);
	      column && column.setValue(value);
	    },
	    // @exposed-api
	    // get column option index by column index
	    getColumnIndex: function getColumnIndex(columnIndex) {
	      return (this.getColumn(columnIndex) || {}).currentIndex;
	    },
	    // @exposed-api
	    // set column option index by column index
	    setColumnIndex: function setColumnIndex(columnIndex, optionIndex) {
	      var column = this.getColumn(columnIndex);
	      column && column.setIndex(optionIndex);
	    },
	    // @exposed-api
	    // get options of column by index
	    getColumnValues: function getColumnValues(index) {
	      return (this.children[index] || {}).options;
	    },
	    // @exposed-api
	    // set options of column by index
	    setColumnValues: function setColumnValues(index, options) {
	      var column = this.children[index];
	
	      if (column) {
	        column.setOptions(options);
	      }
	    },
	    // @exposed-api
	    // get values of all columns
	    getValues: function getValues() {
	      return this.children.map(function (child) {
	        return child.getValue();
	      });
	    },
	    // @exposed-api
	    // set values of all columns
	    setValues: function setValues(values) {
	      var _this3 = this;
	
	      values.forEach(function (value, index) {
	        _this3.setColumnValue(index, value);
	      });
	    },
	    // @exposed-api
	    // get indexes of all columns
	    getIndexes: function getIndexes() {
	      return this.children.map(function (child) {
	        return child.currentIndex;
	      });
	    },
	    // @exposed-api
	    // set indexes of all columns
	    setIndexes: function setIndexes(indexes) {
	      var _this4 = this;
	
	      indexes.forEach(function (optionIndex, columnIndex) {
	        _this4.setColumnIndex(columnIndex, optionIndex);
	      });
	    },
	    // @exposed-api
	    confirm: function confirm() {
	      this.children.forEach(function (child) {
	        return child.stopMomentum();
	      });
	      this.emit('confirm');
	    },
	    cancel: function cancel() {
	      this.emit('cancel');
	    },
	    genTitle: function genTitle() {
	      var h = this.$createElement;
	      var titleSlot = this.slots('title');
	
	      if (titleSlot) {
	        return titleSlot;
	      }
	
	      if (this.title) {
	        return h("div", {
	          "class": ['van-ellipsis', bem('title')]
	        }, [this.title]);
	      }
	    },
	    genToolbar: function genToolbar() {
	      var h = this.$createElement;
	
	      if (this.showToolbar) {
	        return h("div", {
	          "class": [_constant.BORDER_TOP_BOTTOM, bem('toolbar')]
	        }, [this.slots() || [h("button", {
	          "attrs": {
	            "type": "button"
	          },
	          "class": bem('cancel'),
	          "on": {
	            "click": this.cancel
	          }
	        }, [this.cancelButtonText || t('cancel')]), this.genTitle(), h("button", {
	          "attrs": {
	            "type": "button"
	          },
	          "class": bem('confirm'),
	          "on": {
	            "click": this.confirm
	          }
	        }, [this.confirmButtonText || t('confirm')])]]);
	      }
	    },
	    genColumns: function genColumns() {
	      var _this5 = this;
	
	      var h = this.$createElement;
	      return this.formattedColumns.map(function (item, columnIndex) {
	        return h(_PickerColumn.default, {
	          "attrs": {
	            "valueKey": _this5.valueKey,
	            "allowHtml": _this5.allowHtml,
	            "className": item.className,
	            "itemHeight": _this5.itemHeight,
	            "defaultIndex": item.defaultIndex || +_this5.defaultIndex,
	            "swipeDuration": _this5.swipeDuration,
	            "visibleItemCount": _this5.visibleItemCount,
	            "initialOptions": item.values
	          },
	          "on": {
	            "change": function change() {
	              _this5.onChange(columnIndex);
	            }
	          }
	        });
	      });
	    }
	  },
	  render: function render(h) {
	    var itemHeight = +this.itemHeight;
	    var wrapHeight = itemHeight * this.visibleItemCount;
	    var frameStyle = {
	      height: itemHeight + "px"
	    };
	    var columnsStyle = {
	      height: wrapHeight + "px"
	    };
	    var maskStyle = {
	      backgroundSize: "100% " + (wrapHeight - itemHeight) / 2 + "px"
	    };
	    return h("div", {
	      "class": bem()
	    }, [this.toolbarPosition === 'top' ? this.genToolbar() : h(), this.loading ? h(_loading.default, {
	      "class": bem('loading')
	    }) : h(), this.slots('columns-top'), h("div", {
	      "class": bem('columns'),
	      "style": columnsStyle,
	      "on": {
	        "touchmove": _event.preventDefault
	      }
	    }, [this.genColumns(), h("div", {
	      "class": bem('mask'),
	      "style": maskStyle
	    }), h("div", {
	      "class": [_constant.BORDER_UNSET_TOP_BOTTOM, bem('frame')],
	      "style": frameStyle
	    })]), this.slots('columns-bottom'), this.toolbarPosition === 'bottom' ? this.genToolbar() : h()]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.pickerProps = void 0;
	var pickerProps = {
	  title: String,
	  loading: Boolean,
	  showToolbar: Boolean,
	  cancelButtonText: String,
	  confirmButtonText: String,
	  allowHtml: {
	    type: Boolean,
	    default: true
	  },
	  visibleItemCount: {
	    type: [Number, String],
	    default: 5
	  },
	  itemHeight: {
	    type: [Number, String],
	    default: 44
	  },
	  swipeDuration: {
	    type: [Number, String],
	    default: 1000
	  }
	};
	exports.pickerProps = pickerProps;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _field = __webpack_require__(27);
	
	var _relation = __webpack_require__(9);
	
	var _createNamespace = (0, _utils.createNamespace)('radio-group'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ParentMixin)('vanRadio'), _field.FieldMixin],
	  props: {
	    value: null,
	    disabled: Boolean,
	    direction: String,
	    checkedColor: String,
	    iconSize: [Number, String]
	  },
	  watch: {
	    value: function value(_value) {
	      this.$emit('change', _value);
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "class": bem([this.direction]),
	      "attrs": {
	        "role": "radiogroup"
	      }
	    }, [this.slots()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _checkbox = __webpack_require__(146);
	
	var _createNamespace = (0, _utils.createNamespace)('radio'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _checkbox.CheckboxMixin)({
	    bem: bem,
	    role: 'radio',
	    parent: 'vanRadio'
	  })],
	  computed: {
	    currentValue: {
	      get: function get() {
	        return this.parent ? this.parent.value : this.value;
	      },
	      set: function set(val) {
	        (this.parent || this).$emit('input', val);
	      }
	    },
	    checked: function checked() {
	      return this.currentValue === this.name;
	    }
	  },
	  methods: {
	    toggle: function toggle() {
	      this.currentValue = this.name;
	    }
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = exports.getSelectedProperties = exports.getSelectedPropValues = exports.isSkuChoosable = exports.getSelectedSkuValues = exports.getSkuComb = exports.isAllSelected = exports.normalizePropList = exports.normalizeSkuTree = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(3));
	
	var _constants = __webpack_require__(62);
	
	/*
	  normalize sku tree
	
	  [
	    {
	      count: 2,
	      k: "品种", // 规格名称 skuKeyName
	      k_id: "1200", // skuKeyId
	      k_s: "s1" // skuKeyStr
	      v: [ // skuValues
	        { // skuValue
	          id: "1201", // skuValueId
	          name: "萌" // 具体的规格值 skuValueName
	        }, {
	          id: "973",
	          name: "帅"
	        }
	      ]
	    },
	    ...
	  ]
	                |
	                v
	  {
	    s1: [{
	      id: "1201",
	      name: "萌"
	    }, {
	      id: "973",
	      name: "帅"
	    }],
	    ...
	  }
	 */
	var normalizeSkuTree = function normalizeSkuTree(skuTree) {
	  var normalizedTree = {};
	  skuTree.forEach(function (treeItem) {
	    normalizedTree[treeItem.k_s] = treeItem.v;
	  });
	  return normalizedTree;
	};
	
	exports.normalizeSkuTree = normalizeSkuTree;
	
	var normalizePropList = function normalizePropList(propList) {
	  var normalizedProp = {};
	  propList.forEach(function (item) {
	    var itemObj = {};
	    item.v.forEach(function (it) {
	      itemObj[it.id] = it;
	    });
	    normalizedProp[item.k_id] = itemObj;
	  });
	  return normalizedProp;
	}; // 判断是否所有的sku都已经选中
	
	
	exports.normalizePropList = normalizePropList;
	
	var isAllSelected = function isAllSelected(skuTree, selectedSku) {
	  // 筛选selectedSku对象中key值不为空的值
	  var selected = Object.keys(selectedSku).filter(function (skuKeyStr) {
	    return selectedSku[skuKeyStr] !== _constants.UNSELECTED_SKU_VALUE_ID;
	  });
	  return skuTree.length === selected.length;
	}; // 根据已选择的 sku 获取 skuComb
	
	
	exports.isAllSelected = isAllSelected;
	
	var getSkuComb = function getSkuComb(skuList, selectedSku) {
	  var skuComb = skuList.filter(function (item) {
	    return Object.keys(selectedSku).every(function (skuKeyStr) {
	      return String(item[skuKeyStr]) === String(selectedSku[skuKeyStr]);
	    });
	  });
	  return skuComb[0];
	}; // 获取已选择的sku名称
	
	
	exports.getSkuComb = getSkuComb;
	
	var getSelectedSkuValues = function getSelectedSkuValues(skuTree, selectedSku) {
	  var normalizedTree = normalizeSkuTree(skuTree);
	  return Object.keys(selectedSku).reduce(function (selectedValues, skuKeyStr) {
	    var skuValues = normalizedTree[skuKeyStr];
	    var skuValueId = selectedSku[skuKeyStr];
	
	    if (skuValueId !== _constants.UNSELECTED_SKU_VALUE_ID) {
	      var skuValue = skuValues.filter(function (value) {
	        return value.id === skuValueId;
	      })[0];
	      skuValue && selectedValues.push(skuValue);
	    }
	
	    return selectedValues;
	  }, []);
	}; // 判断sku是否可选
	
	
	exports.getSelectedSkuValues = getSelectedSkuValues;
	
	var isSkuChoosable = function isSkuChoosable(skuList, selectedSku, skuToChoose) {
	  var _extends2;
	
	  var key = skuToChoose.key,
	      valueId = skuToChoose.valueId; // 先假设sku已选中，拼入已选中sku对象中
	
	  var matchedSku = (0, _extends3.default)({}, selectedSku, (_extends2 = {}, _extends2[key] = valueId, _extends2)); // 再判断剩余sku是否全部不可选，若不可选则当前sku不可选中
	
	  var skusToCheck = Object.keys(matchedSku).filter(function (skuKey) {
	    return matchedSku[skuKey] !== _constants.UNSELECTED_SKU_VALUE_ID;
	  });
	  var filteredSku = skuList.filter(function (sku) {
	    return skusToCheck.every(function (skuKey) {
	      return String(matchedSku[skuKey]) === String(sku[skuKey]);
	    });
	  });
	  var stock = filteredSku.reduce(function (total, sku) {
	    total += sku.stock_num;
	    return total;
	  }, 0);
	  return stock > 0;
	};
	
	exports.isSkuChoosable = isSkuChoosable;
	
	var getSelectedPropValues = function getSelectedPropValues(propList, selectedProp) {
	  var normalizeProp = normalizePropList(propList);
	  return Object.keys(selectedProp).reduce(function (acc, cur) {
	    selectedProp[cur].forEach(function (it) {
	      acc.push((0, _extends3.default)({}, normalizeProp[cur][it]));
	    });
	    return acc;
	  }, []);
	};
	
	exports.getSelectedPropValues = getSelectedPropValues;
	
	var getSelectedProperties = function getSelectedProperties(propList, selectedProp) {
	  var list = [];
	  (propList || []).forEach(function (prop) {
	    if (selectedProp[prop.k_id] && selectedProp[prop.k_id].length > 0) {
	      var v = [];
	      prop.v.forEach(function (it) {
	        if (selectedProp[prop.k_id].indexOf(it.id) > -1) {
	          v.push((0, _extends3.default)({}, it));
	        }
	      });
	      list.push((0, _extends3.default)({}, prop, {
	        v: v
	      }));
	    }
	  });
	  return list;
	};
	
	exports.getSelectedProperties = getSelectedProperties;
	var _default = {
	  normalizeSkuTree: normalizeSkuTree,
	  getSkuComb: getSkuComb,
	  getSelectedSkuValues: getSelectedSkuValues,
	  isAllSelected: isAllSelected,
	  isSkuChoosable: isSkuChoosable,
	  getSelectedPropValues: getSelectedPropValues,
	  getSelectedProperties: getSelectedProperties
	};
	exports.default = _default;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _shared = __webpack_require__(166);
	
	var _field = __webpack_require__(27);
	
	var _loading = _interopRequireDefault(__webpack_require__(18));
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('switch'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [_field.FieldMixin],
	  props: _shared.switchProps,
	  computed: {
	    checked: function checked() {
	      return this.value === this.activeValue;
	    },
	    style: function style() {
	      return {
	        fontSize: (0, _utils.addUnit)(this.size),
	        backgroundColor: this.checked ? this.activeColor : this.inactiveColor
	      };
	    }
	  },
	  methods: {
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	
	      if (!this.disabled && !this.loading) {
	        var newValue = this.checked ? this.inactiveValue : this.activeValue;
	        this.$emit('input', newValue);
	        this.$emit('change', newValue);
	      }
	    },
	    genLoading: function genLoading() {
	      var h = this.$createElement;
	
	      if (this.loading) {
	        var color = this.checked ? this.activeColor : this.inactiveColor;
	        return h(_loading.default, {
	          "class": bem('loading'),
	          "attrs": {
	            "color": color
	          }
	        });
	      }
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    var checked = this.checked,
	        loading = this.loading,
	        disabled = this.disabled;
	    return h("div", {
	      "class": bem({
	        on: checked,
	        loading: loading,
	        disabled: disabled
	      }),
	      "attrs": {
	        "role": "switch",
	        "aria-checked": String(checked)
	      },
	      "style": this.style,
	      "on": {
	        "click": this.onClick
	      }
	    }, [h("div", {
	      "class": bem('node')
	    }, [this.genLoading()])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(11);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating required fields.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function required(rule, value, source, errors, options, type) {
	  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
	    errors.push(util.format(options.messages.required, rule.fullField));
	  }
	}
	
	exports['default'] = required;
	module.exports = exports['default'];

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	var settle = __webpack_require__(207);
	var buildURL = __webpack_require__(210);
	var parseHeaders = __webpack_require__(216);
	var isURLSameOrigin = __webpack_require__(214);
	var createError = __webpack_require__(106);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(209);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(212);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(206);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/
	
	module.exports = function mergeJSXProps (objs) {
	  return objs.reduce(function (a, b) {
	    var aa, bb, key, nestedKey, temp
	    for (key in b) {
	      aa = a[key]
	      bb = b[key]
	      if (aa && nestRE.test(key)) {
	        // normalize class
	        if (key === 'class') {
	          if (typeof aa === 'string') {
	            temp = aa
	            a[key] = aa = {}
	            aa[temp] = true
	          }
	          if (typeof bb === 'string') {
	            temp = bb
	            b[key] = bb = {}
	            bb[temp] = true
	          }
	        }
	        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
	          // merge functions
	          for (nestedKey in bb) {
	            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey])
	          }
	        } else if (Array.isArray(aa)) {
	          a[key] = aa.concat(bb)
	        } else if (Array.isArray(bb)) {
	          a[key] = [aa].concat(bb)
	        } else {
	          for (nestedKey in bb) {
	            aa[nestedKey] = bb[nestedKey]
	          }
	        }
	      } else {
	        a[key] = b[key]
	      }
	    }
	    return a
	  }, {})
	}
	
	function mergeFn (a, b) {
	  return function () {
	    a && a.apply(this, arguments)
	    b && b.apply(this, arguments)
	  }
	}


/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(40);
	var TAG = __webpack_require__(14)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(13).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(25) && !__webpack_require__(41)(function () {
	  return Object.defineProperty(__webpack_require__(69)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(40);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(51);
	var $export = __webpack_require__(29);
	var redefine = __webpack_require__(122);
	var hide = __webpack_require__(31);
	var has = __webpack_require__(30);
	var Iterators = __webpack_require__(43);
	var $iterCreate = __webpack_require__(244);
	var setToStringTag = __webpack_require__(54);
	var getPrototypeOf = __webpack_require__(254);
	var ITERATOR = __webpack_require__(14)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(28);
	var dPs = __webpack_require__(251);
	var enumBugKeys = __webpack_require__(70);
	var IE_PROTO = __webpack_require__(73)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(69)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(113).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(119);
	var hiddenKeys = __webpack_require__(70).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(30);
	var toIObject = __webpack_require__(32);
	var arrayIndexOf = __webpack_require__(237)(false);
	var IE_PROTO = __webpack_require__(73)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var newPromiseCapability = __webpack_require__(71);
	
	module.exports = function (C, x) {
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(31);


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(28);
	var aFunction = __webpack_require__(49);
	var SPECIES = __webpack_require__(14)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(50);
	var invoke = __webpack_require__(240);
	var html = __webpack_require__(113);
	var cel = __webpack_require__(69);
	var global = __webpack_require__(13);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(40)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(75);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(68);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 127 */
/***/ (function(module, exports) {



/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(257)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(116)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(260);
	var global = __webpack_require__(13);
	var hide = __webpack_require__(31);
	var Iterators = __webpack_require__(43);
	var TO_STRING_TAG = __webpack_require__(14)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 83);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(33);
	
	/***/ }),
	
	/***/ 83:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-checkbox",
	      class: [
	        _vm.border && _vm.checkboxSize
	          ? "el-checkbox--" + _vm.checkboxSize
	          : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.isChecked }
	      ],
	      attrs: { id: _vm.id }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-checkbox__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.isChecked,
	            "is-indeterminate": _vm.indeterminate,
	            "is-focus": _vm.focus
	          },
	          attrs: {
	            tabindex: _vm.indeterminate ? 0 : false,
	            role: _vm.indeterminate ? "checkbox" : false,
	            "aria-checked": _vm.indeterminate ? "mixed" : false
	          }
	        },
	        [
	          _c("span", { staticClass: "el-checkbox__inner" }),
	          _vm.trueLabel || _vm.falseLabel
	            ? _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  name: _vm.name,
	                  disabled: _vm.isDisabled,
	                  "true-value": _vm.trueLabel,
	                  "false-value": _vm.falseLabel
	                },
	                domProps: {
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, null) > -1
	                    : _vm._q(_vm.model, _vm.trueLabel)
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
	                      if (Array.isArray($$a)) {
	                        var $$v = null,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	            : _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  disabled: _vm.isDisabled,
	                  name: _vm.name
	                },
	                domProps: {
	                  value: _vm.label,
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, _vm.label) > -1
	                    : _vm.model
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? true : false
	                      if (Array.isArray($$a)) {
	                        var $$v = _vm.label,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	        ]
	      ),
	      _vm.$slots.default || _vm.label
	        ? _c(
	            "span",
	            { staticClass: "el-checkbox__label" },
	            [
	              _vm._t("default"),
	              !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
	  name: 'ElCheckbox',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElCheckbox',
	
	  data: function data() {
	    return {
	      selfModel: false,
	      focus: false,
	      isLimitExceeded: false
	    };
	  },
	
	
	  computed: {
	    model: {
	      get: function get() {
	        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.isLimitExceeded = false;
	          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
	
	          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
	
	          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	          this.selfModel = val;
	        }
	      }
	    },
	
	    isChecked: function isChecked() {
	      if ({}.toString.call(this.model) === '[object Boolean]') {
	        return this.model;
	      } else if (Array.isArray(this.model)) {
	        return this.model.indexOf(this.label) > -1;
	      } else if (this.model !== null && this.model !== undefined) {
	        return this.model === this.trueLabel;
	      }
	    },
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElCheckboxGroup') {
	          parent = parent.$parent;
	        } else {
	          this._checkboxGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	    store: function store() {
	      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
	    },
	
	
	    /* used to make the isDisabled judgment under max/min props */
	    isLimitDisabled: function isLimitDisabled() {
	      var _checkboxGroup = this._checkboxGroup,
	          max = _checkboxGroup.max,
	          min = _checkboxGroup.min;
	
	      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxSize: function checkboxSize() {
	      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
	    }
	  },
	
	  props: {
	    value: {},
	    label: {},
	    indeterminate: Boolean,
	    disabled: Boolean,
	    checked: Boolean,
	    name: String,
	    trueLabel: [String, Number],
	    falseLabel: [String, Number],
	    id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    border: Boolean,
	    size: String
	  },
	
	  methods: {
	    addToStore: function addToStore() {
	      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
	        this.model.push(this.label);
	      } else {
	        this.model = this.trueLabel || true;
	      }
	    },
	    handleChange: function handleChange(ev) {
	      var _this = this;
	
	      if (this.isLimitExceeded) return;
	      var value = void 0;
	      if (ev.target.checked) {
	        value = this.trueLabel === undefined ? true : this.trueLabel;
	      } else {
	        value = this.falseLabel === undefined ? false : this.falseLabel;
	      }
	      this.$emit('change', value, ev);
	      this.$nextTick(function () {
	        if (_this.isGroup) {
	          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
	        }
	      });
	    }
	  },
	
	  created: function created() {
	    this.checked && this.addToStore();
	  },
	  mounted: function mounted() {
	    // 为indeterminate元素 添加aria-controls 属性
	    if (this.indeterminate) {
	      this.$el.setAttribute('aria-controls', this.controls);
	    }
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', _value);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_checkboxvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/checkbox/src/checkbox.vue"
	/* harmony default export */ var src_checkbox = (component.exports);
	// CONCATENATED MODULE: ./packages/checkbox/index.js
	
	
	/* istanbul ignore next */
	src_checkbox.install = function (Vue) {
	  Vue.component(src_checkbox.name, src_checkbox);
	};
	
	/* harmony default export */ var packages_checkbox = __webpack_exports__["default"] = (src_checkbox);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _util = __webpack_require__(21);
	
	/**
	 * Show migrating guide in browser console.
	 *
	 * Usage:
	 * import Migrating from 'element-ui/src/mixins/migrating';
	 *
	 * mixins: [Migrating]
	 *
	 * add getMigratingConfig method for your component.
	 *  getMigratingConfig() {
	 *    return {
	 *      props: {
	 *        'allow-no-selection': 'allow-no-selection is removed.',
	 *        'selection-mode': 'selection-mode is removed.'
	 *      },
	 *      events: {
	 *        selectionchange: 'selectionchange is renamed to selection-change.'
	 *      }
	 *    };
	 *  },
	 */
	exports.default = {
	  mounted: function mounted() {
	    if (true) return;
	    if (!this.$vnode) return;
	
	    var _getMigratingConfig = this.getMigratingConfig(),
	        _getMigratingConfig$p = _getMigratingConfig.props,
	        props = _getMigratingConfig$p === undefined ? {} : _getMigratingConfig$p,
	        _getMigratingConfig$e = _getMigratingConfig.events,
	        events = _getMigratingConfig$e === undefined ? {} : _getMigratingConfig$e;
	
	    var _$vnode = this.$vnode,
	        data = _$vnode.data,
	        componentOptions = _$vnode.componentOptions;
	
	    var definedProps = data.attrs || {};
	    var definedEvents = componentOptions.listeners || {};
	
	    for (var propName in definedProps) {
	      propName = (0, _util.kebabCase)(propName); // compatible with camel case
	      if (props[propName]) {
	        console.warn('[Element Migrating][' + this.$options.name + '][Attribute]: ' + props[propName]);
	      }
	    }
	
	    for (var eventName in definedEvents) {
	      eventName = (0, _util.kebabCase)(eventName); // compatible with camel case
	      if (events[eventName]) {
	        console.warn('[Element Migrating][' + this.$options.name + '][Event]: ' + events[eventName]);
	      }
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {},
	        events: {}
	      };
	    }
	  }
	};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 116);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 116:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-radio",
	      class: [
	        _vm.border && _vm.radioSize ? "el-radio--" + _vm.radioSize : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-focus": _vm.focus },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.model === _vm.label }
	      ],
	      attrs: {
	        role: "radio",
	        "aria-checked": _vm.model === _vm.label,
	        "aria-disabled": _vm.isDisabled,
	        tabindex: _vm.tabIndex
	      },
	      on: {
	        keydown: function($event) {
	          if (
	            !("button" in $event) &&
	            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
	          ) {
	            return null
	          }
	          $event.stopPropagation()
	          $event.preventDefault()
	          _vm.model = _vm.isDisabled ? _vm.model : _vm.label
	        }
	      }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.model === _vm.label
	          }
	        },
	        [
	          _c("span", { staticClass: "el-radio__inner" }),
	          _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            ref: "radio",
	            staticClass: "el-radio__original",
	            attrs: {
	              type: "radio",
	              "aria-hidden": "true",
	              name: _vm.name,
	              disabled: _vm.isDisabled,
	              tabindex: "-1"
	            },
	            domProps: {
	              value: _vm.label,
	              checked: _vm._q(_vm.model, _vm.label)
	            },
	            on: {
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              },
	              change: [
	                function($event) {
	                  _vm.model = _vm.label
	                },
	                _vm.handleChange
	              ]
	            }
	          })
	        ]
	      ),
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__label",
	          on: {
	            keydown: function($event) {
	              $event.stopPropagation()
	            }
	          }
	        },
	        [
	          _vm._t("default"),
	          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var radiovue_type_script_lang_js_ = ({
	  name: 'ElRadio',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElRadio',
	
	  props: {
	    value: {},
	    label: {},
	    disabled: Boolean,
	    name: String,
	    border: Boolean,
	    size: String
	  },
	
	  data: function data() {
	    return {
	      focus: false
	    };
	  },
	
	  computed: {
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElRadioGroup') {
	          parent = parent.$parent;
	        } else {
	          this._radioGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	
	    model: {
	      get: function get() {
	        return this.isGroup ? this._radioGroup.value : this.value;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.dispatch('ElRadioGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	        }
	        this.$refs.radio && (this.$refs.radio.checked = this.model === this.label);
	      }
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    radioSize: function radioSize() {
	      var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    tabIndex: function tabIndex() {
	      return this.isDisabled || this.isGroup && this.model !== this.label ? -1 : 0;
	    }
	  },
	
	  methods: {
	    handleChange: function handleChange() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.$emit('change', _this.model);
	        _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radiovue_type_script_lang_js_ = (radiovue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_radiovue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/radio/src/radio.vue"
	/* harmony default export */ var src_radio = (component.exports);
	// CONCATENATED MODULE: ./packages/radio/index.js
	
	
	/* istanbul ignore next */
	src_radio.install = function (Vue) {
	  Vue.component(src_radio.name, src_radio);
	};
	
	/* harmony default export */ var packages_radio = __webpack_exports__["default"] = (src_radio);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(33);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 124);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 124:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var tagvue_type_script_lang_js_ = ({
	  name: 'ElTag',
	  props: {
	    text: String,
	    closable: Boolean,
	    type: String,
	    hit: Boolean,
	    disableTransitions: Boolean,
	    color: String,
	    size: String,
	    effect: {
	      type: String,
	      default: 'light',
	      validator: function validator(val) {
	        return ['dark', 'light', 'plain'].indexOf(val) !== -1;
	      }
	    }
	  },
	  methods: {
	    handleClose: function handleClose(event) {
	      event.stopPropagation();
	      this.$emit('close', event);
	    },
	    handleClick: function handleClick(event) {
	      this.$emit('click', event);
	    }
	  },
	  computed: {
	    tagSize: function tagSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    }
	  },
	  render: function render(h) {
	    var type = this.type,
	        tagSize = this.tagSize,
	        hit = this.hit,
	        effect = this.effect;
	
	    var classes = ['el-tag', type ? 'el-tag--' + type : '', tagSize ? 'el-tag--' + tagSize : '', effect ? 'el-tag--' + effect : '', hit && 'is-hit'];
	    var tagEl = h(
	      'span',
	      {
	        'class': classes,
	        style: { backgroundColor: this.color },
	        on: {
	          'click': this.handleClick
	        }
	      },
	      [this.$slots.default, this.closable && h('i', { 'class': 'el-tag__close el-icon-close', on: {
	          'click': this.handleClose
	        }
	      })]
	    );
	
	    return this.disableTransitions ? tagEl : h(
	      'transition',
	      {
	        attrs: { name: 'el-zoom-in-center' }
	      },
	      [tagEl]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tagvue_type_script_lang_js_ = (tagvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue
	var render, staticRenderFns
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_tagvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/tag/src/tag.vue"
	/* harmony default export */ var tag = (component.exports);
	// CONCATENATED MODULE: ./packages/tag/index.js
	
	
	/* istanbul ignore next */
	tag.install = function (Vue) {
	  Vue.component(tag.name, tag);
	};
	
	/* harmony default export */ var packages_tag = __webpack_exports__["default"] = (tag);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _dom = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nodeList = [];
	var ctx = '@@clickoutsideContext';
	
	var startClick = void 0;
	var seed = 0;
	
	!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mousedown', function (e) {
	  return startClick = e;
	});
	
	!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mouseup', function (e) {
	  nodeList.forEach(function (node) {
	    return node[ctx].documentHandler(e, startClick);
	  });
	});
	
	function createDocumentHandler(el, binding, vnode) {
	  return function () {
	    var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;
	
	    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
	      vnode.context[el[ctx].methodName]();
	    } else {
	      el[ctx].bindingFn && el[ctx].bindingFn();
	    }
	  };
	}
	
	/**
	 * v-clickoutside
	 * @desc 点击元素外面才会触发的事件
	 * @example
	 * ```vue
	 * <div v-element-clickoutside="handleClose">
	 * ```
	 */
	exports.default = {
	  bind: function bind(el, binding, vnode) {
	    nodeList.push(el);
	    var id = seed++;
	    el[ctx] = {
	      id: id,
	      documentHandler: createDocumentHandler(el, binding, vnode),
	      methodName: binding.expression,
	      bindingFn: binding.value
	    };
	  },
	  update: function update(el, binding, vnode) {
	    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
	    el[ctx].methodName = binding.expression;
	    el[ctx].bindingFn = binding.value;
	  },
	  unbind: function unbind(el) {
	    var len = nodeList.length;
	
	    for (var i = 0; i < len; i++) {
	      if (nodeList[i][ctx].id === el[ctx].id) {
	        nodeList.splice(i, 1);
	        break;
	      }
	    }
	    delete el[ctx];
	  }
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/* Modified from https://github.com/taylorhakes/fecha
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2015 Taylor Hakes
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 *     The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 *     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 *     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 *     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	
	/*eslint-disable*/
	// 把 YYYY-MM-DD 改成了 yyyy-MM-dd
	(function (main) {
	  'use strict';
	
	  /**
	   * Parse or format dates
	   * @class fecha
	   */
	
	  var fecha = {};
	  var token = /d{1,4}|M{1,4}|yy(?:yy)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
	  var twoDigits = '\\d\\d?';
	  var threeDigits = '\\d{3}';
	  var fourDigits = '\\d{4}';
	  var word = '[^\\s]+';
	  var literal = /\[([^]*?)\]/gm;
	  var noop = function noop() {};
	
	  function regexEscape(str) {
	    return str.replace(/[|\\{()[^$+*?.-]/g, '\\$&');
	  }
	
	  function shorten(arr, sLen) {
	    var newArr = [];
	    for (var i = 0, len = arr.length; i < len; i++) {
	      newArr.push(arr[i].substr(0, sLen));
	    }
	    return newArr;
	  }
	
	  function monthUpdate(arrName) {
	    return function (d, v, i18n) {
	      var index = i18n[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());
	      if (~index) {
	        d.month = index;
	      }
	    };
	  }
	
	  function pad(val, len) {
	    val = String(val);
	    len = len || 2;
	    while (val.length < len) {
	      val = '0' + val;
	    }
	    return val;
	  }
	
	  var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	  var monthNamesShort = shorten(monthNames, 3);
	  var dayNamesShort = shorten(dayNames, 3);
	  fecha.i18n = {
	    dayNamesShort: dayNamesShort,
	    dayNames: dayNames,
	    monthNamesShort: monthNamesShort,
	    monthNames: monthNames,
	    amPm: ['am', 'pm'],
	    DoFn: function DoFn(D) {
	      return D + ['th', 'st', 'nd', 'rd'][D % 10 > 3 ? 0 : (D - D % 10 !== 10) * D % 10];
	    }
	  };
	
	  var formatFlags = {
	    D: function D(dateObj) {
	      return dateObj.getDay();
	    },
	    DD: function DD(dateObj) {
	      return pad(dateObj.getDay());
	    },
	    Do: function Do(dateObj, i18n) {
	      return i18n.DoFn(dateObj.getDate());
	    },
	    d: function d(dateObj) {
	      return dateObj.getDate();
	    },
	    dd: function dd(dateObj) {
	      return pad(dateObj.getDate());
	    },
	    ddd: function ddd(dateObj, i18n) {
	      return i18n.dayNamesShort[dateObj.getDay()];
	    },
	    dddd: function dddd(dateObj, i18n) {
	      return i18n.dayNames[dateObj.getDay()];
	    },
	    M: function M(dateObj) {
	      return dateObj.getMonth() + 1;
	    },
	    MM: function MM(dateObj) {
	      return pad(dateObj.getMonth() + 1);
	    },
	    MMM: function MMM(dateObj, i18n) {
	      return i18n.monthNamesShort[dateObj.getMonth()];
	    },
	    MMMM: function MMMM(dateObj, i18n) {
	      return i18n.monthNames[dateObj.getMonth()];
	    },
	    yy: function yy(dateObj) {
	      return pad(String(dateObj.getFullYear()), 4).substr(2);
	    },
	    yyyy: function yyyy(dateObj) {
	      return pad(dateObj.getFullYear(), 4);
	    },
	    h: function h(dateObj) {
	      return dateObj.getHours() % 12 || 12;
	    },
	    hh: function hh(dateObj) {
	      return pad(dateObj.getHours() % 12 || 12);
	    },
	    H: function H(dateObj) {
	      return dateObj.getHours();
	    },
	    HH: function HH(dateObj) {
	      return pad(dateObj.getHours());
	    },
	    m: function m(dateObj) {
	      return dateObj.getMinutes();
	    },
	    mm: function mm(dateObj) {
	      return pad(dateObj.getMinutes());
	    },
	    s: function s(dateObj) {
	      return dateObj.getSeconds();
	    },
	    ss: function ss(dateObj) {
	      return pad(dateObj.getSeconds());
	    },
	    S: function S(dateObj) {
	      return Math.round(dateObj.getMilliseconds() / 100);
	    },
	    SS: function SS(dateObj) {
	      return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
	    },
	    SSS: function SSS(dateObj) {
	      return pad(dateObj.getMilliseconds(), 3);
	    },
	    a: function a(dateObj, i18n) {
	      return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
	    },
	    A: function A(dateObj, i18n) {
	      return dateObj.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase();
	    },
	    ZZ: function ZZ(dateObj) {
	      var o = dateObj.getTimezoneOffset();
	      return (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4);
	    }
	  };
	
	  var parseFlags = {
	    d: [twoDigits, function (d, v) {
	      d.day = v;
	    }],
	    Do: [twoDigits + word, function (d, v) {
	      d.day = parseInt(v, 10);
	    }],
	    M: [twoDigits, function (d, v) {
	      d.month = v - 1;
	    }],
	    yy: [twoDigits, function (d, v) {
	      var da = new Date(),
	          cent = +('' + da.getFullYear()).substr(0, 2);
	      d.year = '' + (v > 68 ? cent - 1 : cent) + v;
	    }],
	    h: [twoDigits, function (d, v) {
	      d.hour = v;
	    }],
	    m: [twoDigits, function (d, v) {
	      d.minute = v;
	    }],
	    s: [twoDigits, function (d, v) {
	      d.second = v;
	    }],
	    yyyy: [fourDigits, function (d, v) {
	      d.year = v;
	    }],
	    S: ['\\d', function (d, v) {
	      d.millisecond = v * 100;
	    }],
	    SS: ['\\d{2}', function (d, v) {
	      d.millisecond = v * 10;
	    }],
	    SSS: [threeDigits, function (d, v) {
	      d.millisecond = v;
	    }],
	    D: [twoDigits, noop],
	    ddd: [word, noop],
	    MMM: [word, monthUpdate('monthNamesShort')],
	    MMMM: [word, monthUpdate('monthNames')],
	    a: [word, function (d, v, i18n) {
	      var val = v.toLowerCase();
	      if (val === i18n.amPm[0]) {
	        d.isPm = false;
	      } else if (val === i18n.amPm[1]) {
	        d.isPm = true;
	      }
	    }],
	    ZZ: ['[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z', function (d, v) {
	      var parts = (v + '').match(/([+-]|\d\d)/gi),
	          minutes;
	
	      if (parts) {
	        minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
	        d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
	      }
	    }]
	  };
	  parseFlags.dd = parseFlags.d;
	  parseFlags.dddd = parseFlags.ddd;
	  parseFlags.DD = parseFlags.D;
	  parseFlags.mm = parseFlags.m;
	  parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
	  parseFlags.MM = parseFlags.M;
	  parseFlags.ss = parseFlags.s;
	  parseFlags.A = parseFlags.a;
	
	  // Some common format strings
	  fecha.masks = {
	    default: 'ddd MMM dd yyyy HH:mm:ss',
	    shortDate: 'M/D/yy',
	    mediumDate: 'MMM d, yyyy',
	    longDate: 'MMMM d, yyyy',
	    fullDate: 'dddd, MMMM d, yyyy',
	    shortTime: 'HH:mm',
	    mediumTime: 'HH:mm:ss',
	    longTime: 'HH:mm:ss.SSS'
	  };
	
	  /***
	   * Format a date
	   * @method format
	   * @param {Date|number} dateObj
	   * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
	   */
	  fecha.format = function (dateObj, mask, i18nSettings) {
	    var i18n = i18nSettings || fecha.i18n;
	
	    if (typeof dateObj === 'number') {
	      dateObj = new Date(dateObj);
	    }
	
	    if (Object.prototype.toString.call(dateObj) !== '[object Date]' || isNaN(dateObj.getTime())) {
	      throw new Error('Invalid Date in fecha.format');
	    }
	
	    mask = fecha.masks[mask] || mask || fecha.masks['default'];
	
	    var literals = [];
	
	    // Make literals inactive by replacing them with ??
	    mask = mask.replace(literal, function ($0, $1) {
	      literals.push($1);
	      return '@@@';
	    });
	    // Apply formatting rules
	    mask = mask.replace(token, function ($0) {
	      return $0 in formatFlags ? formatFlags[$0](dateObj, i18n) : $0.slice(1, $0.length - 1);
	    });
	    // Inline literal values back into the formatted value
	    return mask.replace(/@@@/g, function () {
	      return literals.shift();
	    });
	  };
	
	  /**
	   * Parse a date string into an object, changes - into /
	   * @method parse
	   * @param {string} dateStr Date string
	   * @param {string} format Date parse format
	   * @returns {Date|boolean}
	   */
	  fecha.parse = function (dateStr, format, i18nSettings) {
	    var i18n = i18nSettings || fecha.i18n;
	
	    if (typeof format !== 'string') {
	      throw new Error('Invalid format in fecha.parse');
	    }
	
	    format = fecha.masks[format] || format;
	
	    // Avoid regular expression denial of service, fail early for really long strings
	    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
	    if (dateStr.length > 1000) {
	      return null;
	    }
	
	    var dateInfo = {};
	    var parseInfo = [];
	    var literals = [];
	    format = format.replace(literal, function ($0, $1) {
	      literals.push($1);
	      return '@@@';
	    });
	    var newFormat = regexEscape(format).replace(token, function ($0) {
	      if (parseFlags[$0]) {
	        var info = parseFlags[$0];
	        parseInfo.push(info[1]);
	        return '(' + info[0] + ')';
	      }
	
	      return $0;
	    });
	    newFormat = newFormat.replace(/@@@/g, function () {
	      return literals.shift();
	    });
	    var matches = dateStr.match(new RegExp(newFormat, 'i'));
	    if (!matches) {
	      return null;
	    }
	
	    for (var i = 1; i < matches.length; i++) {
	      parseInfo[i - 1](dateInfo, matches[i], i18n);
	    }
	
	    var today = new Date();
	    if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12) {
	      dateInfo.hour = +dateInfo.hour + 12;
	    } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
	      dateInfo.hour = 0;
	    }
	
	    var date;
	    if (dateInfo.timezoneOffset != null) {
	      dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
	      date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
	    } else {
	      date = new Date(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0);
	    }
	    return date;
	  };
	
	  /* istanbul ignore next */
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = fecha;
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return fecha;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    main.fecha = fecha;
	  }
	})(undefined);

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PopupManager = undefined;
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _merge = __webpack_require__(56);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _popupManager = __webpack_require__(288);
	
	var _popupManager2 = _interopRequireDefault(_popupManager);
	
	var _scrollbarWidth = __webpack_require__(87);
	
	var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);
	
	var _dom = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var idSeed = 1;
	
	var scrollBarWidth = void 0;
	
	exports.default = {
	  props: {
	    visible: {
	      type: Boolean,
	      default: false
	    },
	    openDelay: {},
	    closeDelay: {},
	    zIndex: {},
	    modal: {
	      type: Boolean,
	      default: false
	    },
	    modalFade: {
	      type: Boolean,
	      default: true
	    },
	    modalClass: {},
	    modalAppendToBody: {
	      type: Boolean,
	      default: false
	    },
	    lockScroll: {
	      type: Boolean,
	      default: true
	    },
	    closeOnPressEscape: {
	      type: Boolean,
	      default: false
	    },
	    closeOnClickModal: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  beforeMount: function beforeMount() {
	    this._popupId = 'popup-' + idSeed++;
	    _popupManager2.default.register(this._popupId, this);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _popupManager2.default.deregister(this._popupId);
	    _popupManager2.default.closeModal(this._popupId);
	
	    this.restoreBodyStyle();
	  },
	  data: function data() {
	    return {
	      opened: false,
	      bodyPaddingRight: null,
	      computedBodyPaddingRight: 0,
	      withoutHiddenClass: true,
	      rendered: false
	    };
	  },
	
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        if (this._opening) return;
	        if (!this.rendered) {
	          this.rendered = true;
	          _vue2.default.nextTick(function () {
	            _this.open();
	          });
	        } else {
	          this.open();
	        }
	      } else {
	        this.close();
	      }
	    }
	  },
	
	  methods: {
	    open: function open(options) {
	      var _this2 = this;
	
	      if (!this.rendered) {
	        this.rendered = true;
	      }
	
	      var props = (0, _merge2.default)({}, this.$props || this, options);
	
	      if (this._closeTimer) {
	        clearTimeout(this._closeTimer);
	        this._closeTimer = null;
	      }
	      clearTimeout(this._openTimer);
	
	      var openDelay = Number(props.openDelay);
	      if (openDelay > 0) {
	        this._openTimer = setTimeout(function () {
	          _this2._openTimer = null;
	          _this2.doOpen(props);
	        }, openDelay);
	      } else {
	        this.doOpen(props);
	      }
	    },
	    doOpen: function doOpen(props) {
	      if (this.$isServer) return;
	      if (this.willOpen && !this.willOpen()) return;
	      if (this.opened) return;
	
	      this._opening = true;
	
	      var dom = this.$el;
	
	      var modal = props.modal;
	
	      var zIndex = props.zIndex;
	      if (zIndex) {
	        _popupManager2.default.zIndex = zIndex;
	      }
	
	      if (modal) {
	        if (this._closing) {
	          _popupManager2.default.closeModal(this._popupId);
	          this._closing = false;
	        }
	        _popupManager2.default.openModal(this._popupId, _popupManager2.default.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
	        if (props.lockScroll) {
	          this.withoutHiddenClass = !(0, _dom.hasClass)(document.body, 'el-popup-parent--hidden');
	          if (this.withoutHiddenClass) {
	            this.bodyPaddingRight = document.body.style.paddingRight;
	            this.computedBodyPaddingRight = parseInt((0, _dom.getStyle)(document.body, 'paddingRight'), 10);
	          }
	          scrollBarWidth = (0, _scrollbarWidth2.default)();
	          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
	          var bodyOverflowY = (0, _dom.getStyle)(document.body, 'overflowY');
	          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
	            document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px';
	          }
	          (0, _dom.addClass)(document.body, 'el-popup-parent--hidden');
	        }
	      }
	
	      if (getComputedStyle(dom).position === 'static') {
	        dom.style.position = 'absolute';
	      }
	
	      dom.style.zIndex = _popupManager2.default.nextZIndex();
	      this.opened = true;
	
	      this.onOpen && this.onOpen();
	
	      this.doAfterOpen();
	    },
	    doAfterOpen: function doAfterOpen() {
	      this._opening = false;
	    },
	    close: function close() {
	      var _this3 = this;
	
	      if (this.willClose && !this.willClose()) return;
	
	      if (this._openTimer !== null) {
	        clearTimeout(this._openTimer);
	        this._openTimer = null;
	      }
	      clearTimeout(this._closeTimer);
	
	      var closeDelay = Number(this.closeDelay);
	
	      if (closeDelay > 0) {
	        this._closeTimer = setTimeout(function () {
	          _this3._closeTimer = null;
	          _this3.doClose();
	        }, closeDelay);
	      } else {
	        this.doClose();
	      }
	    },
	    doClose: function doClose() {
	      this._closing = true;
	
	      this.onClose && this.onClose();
	
	      if (this.lockScroll) {
	        setTimeout(this.restoreBodyStyle, 200);
	      }
	
	      this.opened = false;
	
	      this.doAfterClose();
	    },
	    doAfterClose: function doAfterClose() {
	      _popupManager2.default.closeModal(this._popupId);
	      this._closing = false;
	    },
	    restoreBodyStyle: function restoreBodyStyle() {
	      if (this.modal && this.withoutHiddenClass) {
	        document.body.style.paddingRight = this.bodyPaddingRight;
	        (0, _dom.removeClass)(document.body, 'el-popup-parent--hidden');
	      }
	      this.withoutHiddenClass = true;
	    }
	  }
	};
	exports.PopupManager = _popupManager2.default;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isString = isString;
	exports.isObject = isObject;
	exports.isHtmlElement = isHtmlElement;
	function isString(obj) {
	  return Object.prototype.toString.call(obj) === '[object String]';
	}
	
	function isObject(obj) {
	  return Object.prototype.toString.call(obj) === '[object Object]';
	}
	
	function isHtmlElement(node) {
	  return node && node.nodeType === Node.ELEMENT_NODE;
	}
	
	var isFunction = exports.isFunction = function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	};
	
	var isUndefined = exports.isUndefined = function isUndefined(val) {
	  return val === void 0;
	};
	
	var isDefined = exports.isDefined = function isDefined(val) {
	  return val !== undefined && val !== null;
	};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   3.3.1
	 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  return typeof x === 'function' || typeof x === 'object' && x !== null;
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	var _isArray = undefined;
	if (!Array.isArray) {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	} else {
	  _isArray = Array.isArray;
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = undefined;
	var customSchedulerFn = undefined;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  return function () {
	    vertxNext(flush);
	  };
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var r = require;
	    var vertx = __webpack_require__(405);
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = undefined;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var _arguments = arguments;
	
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	  if (_state) {
	    (function () {
	      var callback = _arguments[_state - 1];
	      asap(function () {
	        return invokeCallback(_state, child, callback, parent._result);
	      });
	    })();
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  _resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(16);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	var GET_THEN_ERROR = new ErrorObject();
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function getThen(promise) {
	  try {
	    return promise.then;
	  } catch (error) {
	    GET_THEN_ERROR.error = error;
	    return GET_THEN_ERROR;
	  }
	}
	
	function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        _resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      _reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      _reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    _reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return _resolve(promise, value);
	    }, function (reason) {
	      return _reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$) {
	  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$ === GET_THEN_ERROR) {
	      _reject(promise, GET_THEN_ERROR.error);
	    } else if (then$$ === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$)) {
	      handleForeignThenable(promise, maybeThenable, then$$);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function _resolve(promise, value) {
	  if (promise === value) {
	    _reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    handleMaybeThenable(promise, value, getThen(value));
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function _reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = undefined,
	      callback = undefined,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function ErrorObject() {
	  this.error = null;
	}
	
	var TRY_CATCH_ERROR = new ErrorObject();
	
	function tryCatch(callback, detail) {
	  try {
	    return callback(detail);
	  } catch (e) {
	    TRY_CATCH_ERROR.error = e;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = undefined,
	      error = undefined,
	      succeeded = undefined,
	      failed = undefined;
	
	  if (hasCallback) {
	    value = tryCatch(callback, detail);
	
	    if (value === TRY_CATCH_ERROR) {
	      failed = true;
	      error = value.error;
	      value = null;
	    } else {
	      succeeded = true;
	    }
	
	    if (promise === value) {
	      _reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	    succeeded = true;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	      _resolve(promise, value);
	    } else if (failed) {
	      _reject(promise, error);
	    } else if (settled === FULFILLED) {
	      fulfill(promise, value);
	    } else if (settled === REJECTED) {
	      _reject(promise, value);
	    }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      _resolve(promise, value);
	    }, function rejectPromise(reason) {
	      _reject(promise, reason);
	    });
	  } catch (e) {
	    _reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function Enumerator(Constructor, input) {
	  this._instanceConstructor = Constructor;
	  this.promise = new Constructor(noop);
	
	  if (!this.promise[PROMISE_ID]) {
	    makePromise(this.promise);
	  }
	
	  if (isArray(input)) {
	    this._input = input;
	    this.length = input.length;
	    this._remaining = input.length;
	
	    this._result = new Array(this.length);
	
	    if (this.length === 0) {
	      fulfill(this.promise, this._result);
	    } else {
	      this.length = this.length || 0;
	      this._enumerate();
	      if (this._remaining === 0) {
	        fulfill(this.promise, this._result);
	      }
	    }
	  } else {
	    _reject(this.promise, validationError());
	  }
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	};
	
	Enumerator.prototype._enumerate = function () {
	  var length = this.length;
	  var _input = this._input;
	
	  for (var i = 0; this._state === PENDING && i < length; i++) {
	    this._eachEntry(_input[i], i);
	  }
	};
	
	Enumerator.prototype._eachEntry = function (entry, i) {
	  var c = this._instanceConstructor;
	  var resolve$$ = c.resolve;
	
	  if (resolve$$ === resolve) {
	    var _then = getThen(entry);
	
	    if (_then === then && entry._state !== PENDING) {
	      this._settledAt(entry._state, i, entry._result);
	    } else if (typeof _then !== 'function') {
	      this._remaining--;
	      this._result[i] = entry;
	    } else if (c === Promise) {
	      var promise = new c(noop);
	      handleMaybeThenable(promise, entry, _then);
	      this._willSettleAt(promise, i);
	    } else {
	      this._willSettleAt(new c(function (resolve$$) {
	        return resolve$$(entry);
	      }), i);
	    }
	  } else {
	    this._willSettleAt(resolve$$(entry), i);
	  }
	};
	
	Enumerator.prototype._settledAt = function (state, i, value) {
	  var promise = this.promise;
	
	  if (promise._state === PENDING) {
	    this._remaining--;
	
	    if (state === REJECTED) {
	      _reject(promise, value);
	    } else {
	      this._result[i] = value;
	    }
	  }
	
	  if (this._remaining === 0) {
	    fulfill(promise, this._result);
	  }
	};
	
	Enumerator.prototype._willSettleAt = function (promise, i) {
	  var enumerator = this;
	
	  subscribe(promise, undefined, function (value) {
	    return enumerator._settledAt(FULFILLED, i, value);
	  }, function (reason) {
	    return enumerator._settledAt(REJECTED, i, reason);
	  });
	};
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  _reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {function} resolver
	  Useful for tooling.
	  @constructor
	*/
	function Promise(resolver) {
	  this[PROMISE_ID] = nextId();
	  this._result = this._state = undefined;
	  this._subscribers = [];
	
	  if (noop !== resolver) {
	    typeof resolver !== 'function' && needsResolver();
	    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	  }
	}
	
	Promise.all = all;
	Promise.race = race;
	Promise.resolve = resolve;
	Promise.reject = reject;
	Promise._setScheduler = setScheduler;
	Promise._setAsap = setAsap;
	Promise._asap = asap;
	
	Promise.prototype = {
	  constructor: Promise,
	
	  /**
	    The primary way of interacting with a promise is through its `then` method,
	    which registers callbacks to receive either a promise's eventual value or the
	    reason why the promise cannot be fulfilled.
	  
	    ```js
	    findUser().then(function(user){
	      // user is available
	    }, function(reason){
	      // user is unavailable, and you are given the reason why
	    });
	    ```
	  
	    Chaining
	    --------
	  
	    The return value of `then` is itself a promise.  This second, 'downstream'
	    promise is resolved with the return value of the first promise's fulfillment
	    or rejection handler, or rejected if the handler throws an exception.
	  
	    ```js
	    findUser().then(function (user) {
	      return user.name;
	    }, function (reason) {
	      return 'default name';
	    }).then(function (userName) {
	      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	      // will be `'default name'`
	    });
	  
	    findUser().then(function (user) {
	      throw new Error('Found user, but still unhappy');
	    }, function (reason) {
	      throw new Error('`findUser` rejected and we're unhappy');
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	    });
	    ```
	    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	  
	    ```js
	    findUser().then(function (user) {
	      throw new PedagogicalException('Upstream error');
	    }).then(function (value) {
	      // never reached
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // The `PedgagocialException` is propagated all the way down to here
	    });
	    ```
	  
	    Assimilation
	    ------------
	  
	    Sometimes the value you want to propagate to a downstream promise can only be
	    retrieved asynchronously. This can be achieved by returning a promise in the
	    fulfillment or rejection handler. The downstream promise will then be pending
	    until the returned promise is settled. This is called *assimilation*.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // The user's comments are now available
	    });
	    ```
	  
	    If the assimliated promise rejects, then the downstream promise will also reject.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // If `findCommentsByAuthor` fulfills, we'll have the value here
	    }, function (reason) {
	      // If `findCommentsByAuthor` rejects, we'll have the reason here
	    });
	    ```
	  
	    Simple Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let result;
	  
	    try {
	      result = findResult();
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	    findResult(function(result, err){
	      if (err) {
	        // failure
	      } else {
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findResult().then(function(result){
	      // success
	    }, function(reason){
	      // failure
	    });
	    ```
	  
	    Advanced Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let author, books;
	  
	    try {
	      author = findAuthor();
	      books  = findBooksByAuthor(author);
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	  
	    function foundBooks(books) {
	  
	    }
	  
	    function failure(reason) {
	  
	    }
	  
	    findAuthor(function(author, err){
	      if (err) {
	        failure(err);
	        // failure
	      } else {
	        try {
	          findBoooksByAuthor(author, function(books, err) {
	            if (err) {
	              failure(err);
	            } else {
	              try {
	                foundBooks(books);
	              } catch(reason) {
	                failure(reason);
	              }
	            }
	          });
	        } catch(error) {
	          failure(err);
	        }
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findAuthor().
	      then(findBooksByAuthor).
	      then(function(books){
	        // found books
	    }).catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method then
	    @param {Function} onFulfilled
	    @param {Function} onRejected
	    Useful for tooling.
	    @return {Promise}
	  */
	  then: then,
	
	  /**
	    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	    as the catch block of a try/catch statement.
	  
	    ```js
	    function findAuthor(){
	      throw new Error('couldn't find that author');
	    }
	  
	    // synchronous
	    try {
	      findAuthor();
	    } catch(reason) {
	      // something went wrong
	    }
	  
	    // async with promises
	    findAuthor().catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method catch
	    @param {Function} onRejection
	    Useful for tooling.
	    @return {Promise}
	  */
	  'catch': function _catch(onRejection) {
	    return this.then(null, onRejection);
	  }
	};
	
	function polyfill() {
	    var local = undefined;
	
	    if (typeof global !== 'undefined') {
	        local = global;
	    } else if (typeof self !== 'undefined') {
	        local = self;
	    } else {
	        try {
	            local = Function('return this')();
	        } catch (e) {
	            throw new Error('polyfill failed because global object is unavailable in this environment');
	        }
	    }
	
	    var P = local.Promise;
	
	    if (P) {
	        var promiseToString = null;
	        try {
	            promiseToString = Object.prototype.toString.call(P.resolve());
	        } catch (e) {
	            // silently ignored
	        }
	
	        if (promiseToString === '[object Promise]' && !P.cast) {
	            return;
	        }
	    }
	
	    local.Promise = Promise;
	}
	
	polyfill();
	// Strange compat..
	Promise.polyfill = polyfill;
	Promise.Promise = Promise;
	
	return Promise;
	
	})));
	//# sourceMappingURL=es6-promise.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88), (function() { return this; }())))

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return value;
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	exports.arrayToObject = function (source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	exports.merge = function (target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = exports.arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = exports.merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (Object.prototype.hasOwnProperty.call(acc, key)) {
	            acc[key] = exports.merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	exports.decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	exports.encode = function (str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D || // -
	            c === 0x2E || // .
	            c === 0x5F || // _
	            c === 0x7E || // ~
	            (c >= 0x30 && c <= 0x39) || // 0-9
	            (c >= 0x41 && c <= 0x5A) || // a-z
	            (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)] + hexTable[0x80 | ((c >> 12) & 0x3F)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]; // eslint-disable-line max-len
	    }
	
	    return out;
	};
	
	exports.compact = function (obj, references) {
	    if (typeof obj !== 'object' || obj === null) {
	        return obj;
	    }
	
	    var refs = references || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0; i < obj.length; ++i) {
	            if (obj[i] && typeof obj[i] === 'object') {
	                compacted.push(exports.compact(obj[i], refs));
	            } else if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    keys.forEach(function (key) {
	        obj[key] = exports.compact(obj[key], refs);
	    });
	
	    return obj;
	};
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	exports.isBuffer = function (obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _shared = __webpack_require__(97);
	
	var _picker = _interopRequireDefault(__webpack_require__(96));
	
	var _createNamespace = (0, _utils.createNamespace)('area'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var PLACEHOLDER_CODE = '000000';
	
	function isOverseaCode(code) {
	  return code[0] === '9';
	}
	
	function pickSlots(instance, keys) {
	  var $slots = instance.$slots,
	      $scopedSlots = instance.$scopedSlots;
	  var scopedSlots = {};
	  keys.forEach(function (key) {
	    if ($scopedSlots[key]) {
	      scopedSlots[key] = $scopedSlots[key];
	    } else if ($slots[key]) {
	      scopedSlots[key] = function () {
	        return $slots[key];
	      };
	    }
	  });
	  return scopedSlots;
	}
	
	var _default2 = createComponent({
	  props: (0, _extends2.default)({}, _shared.pickerProps, {
	    value: String,
	    areaList: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    columnsNum: {
	      type: [Number, String],
	      default: 3
	    },
	    isOverseaCode: {
	      type: Function,
	      default: isOverseaCode
	    },
	    columnsPlaceholder: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  }),
	  data: function data() {
	    return {
	      code: this.value,
	      columns: [{
	        values: []
	      }, {
	        values: []
	      }, {
	        values: []
	      }]
	    };
	  },
	  computed: {
	    province: function province() {
	      return this.areaList.province_list || {};
	    },
	    city: function city() {
	      return this.areaList.city_list || {};
	    },
	    county: function county() {
	      return this.areaList.county_list || {};
	    },
	    displayColumns: function displayColumns() {
	      return this.columns.slice(0, +this.columnsNum);
	    },
	    placeholderMap: function placeholderMap() {
	      return {
	        province: this.columnsPlaceholder[0] || '',
	        city: this.columnsPlaceholder[1] || '',
	        county: this.columnsPlaceholder[2] || ''
	      };
	    }
	  },
	  watch: {
	    value: function value(val) {
	      this.code = val;
	      this.setValues();
	    },
	    areaList: {
	      deep: true,
	      handler: 'setValues'
	    },
	    columnsNum: function columnsNum() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.setValues();
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.setValues();
	  },
	  methods: {
	    // get list by code
	    getList: function getList(type, code) {
	      var result = [];
	
	      if (type !== 'province' && !code) {
	        return result;
	      }
	
	      var list = this[type];
	      result = Object.keys(list).map(function (listCode) {
	        return {
	          code: listCode,
	          name: list[listCode]
	        };
	      });
	
	      if (code) {
	        // oversea code
	        if (this.isOverseaCode(code) && type === 'city') {
	          code = '9';
	        }
	
	        result = result.filter(function (item) {
	          return item.code.indexOf(code) === 0;
	        });
	      }
	
	      if (this.placeholderMap[type] && result.length) {
	        // set columns placeholder
	        var codeFill = '';
	
	        if (type === 'city') {
	          codeFill = PLACEHOLDER_CODE.slice(2, 4);
	        } else if (type === 'county') {
	          codeFill = PLACEHOLDER_CODE.slice(4, 6);
	        }
	
	        result.unshift({
	          code: "" + code + codeFill,
	          name: this.placeholderMap[type]
	        });
	      }
	
	      return result;
	    },
	    // get index by code
	    getIndex: function getIndex(type, code) {
	      var compareNum = type === 'province' ? 2 : type === 'city' ? 4 : 6;
	      var list = this.getList(type, code.slice(0, compareNum - 2)); // oversea code
	
	      if (this.isOverseaCode(code) && type === 'province') {
	        compareNum = 1;
	      }
	
	      code = code.slice(0, compareNum);
	
	      for (var i = 0; i < list.length; i++) {
	        if (list[i].code.slice(0, compareNum) === code) {
	          return i;
	        }
	      }
	
	      return 0;
	    },
	    // parse output columns data
	    parseOutputValues: function parseOutputValues(values) {
	      var _this2 = this;
	
	      return values.map(function (value, index) {
	        // save undefined value
	        if (!value) return value;
	        value = JSON.parse(JSON.stringify(value));
	
	        if (!value.code || value.name === _this2.columnsPlaceholder[index]) {
	          value.code = '';
	          value.name = '';
	        }
	
	        return value;
	      });
	    },
	    onChange: function onChange(picker, values, index) {
	      this.code = values[index].code;
	      this.setValues();
	      var getValues = picker.getValues();
	      getValues = this.parseOutputValues(getValues);
	      this.$emit('change', picker, getValues, index);
	    },
	    onConfirm: function onConfirm(values, index) {
	      values = this.parseOutputValues(values);
	      this.setValues();
	      this.$emit('confirm', values, index);
	    },
	    setValues: function setValues() {
	      var code = this.code;
	
	      if (!code) {
	        if (this.columnsPlaceholder.length) {
	          code = PLACEHOLDER_CODE;
	        } else if (Object.keys(this.county)[0]) {
	          code = Object.keys(this.county)[0];
	        } else {
	          code = '';
	        }
	      }
	
	      var picker = this.$refs.picker;
	      var province = this.getList('province');
	      var city = this.getList('city', code.slice(0, 2));
	
	      if (!picker) {
	        return;
	      }
	
	      picker.setColumnValues(0, province);
	      picker.setColumnValues(1, city);
	
	      if (city.length && code.slice(2, 4) === '00' && !this.isOverseaCode(code)) {
	        code = city[0].code;
	      }
	
	      picker.setColumnValues(2, this.getList('county', code.slice(0, 4)));
	      picker.setIndexes([this.getIndex('province', code), this.getIndex('city', code), this.getIndex('county', code)]);
	    },
	    getValues: function getValues() {
	      var picker = this.$refs.picker;
	      var getValues = picker ? picker.getValues().filter(function (value) {
	        return !!value;
	      }) : [];
	      getValues = this.parseOutputValues(getValues);
	      return getValues;
	    },
	    getArea: function getArea() {
	      var values = this.getValues();
	      var area = {
	        code: '',
	        country: '',
	        province: '',
	        city: '',
	        county: ''
	      };
	
	      if (!values.length) {
	        return area;
	      }
	
	      var names = values.map(function (item) {
	        return item.name;
	      });
	      var validValues = values.filter(function (value) {
	        return !!value.code;
	      });
	      area.code = validValues.length ? validValues[validValues.length - 1].code : '';
	
	      if (this.isOverseaCode(area.code)) {
	        area.country = names[1] || '';
	        area.province = names[2] || '';
	      } else {
	        area.province = names[0] || '';
	        area.city = names[1] || '';
	        area.county = names[2] || '';
	      }
	
	      return area;
	    },
	    // @exposed-api
	    reset: function reset(code) {
	      this.code = code || '';
	      this.setValues();
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    var on = (0, _extends2.default)({}, this.$listeners, {
	      change: this.onChange,
	      confirm: this.onConfirm
	    });
	    return h(_picker.default, {
	      "ref": "picker",
	      "class": bem(),
	      "attrs": {
	        "showToolbar": true,
	        "valueKey": "name",
	        "title": this.title,
	        "loading": this.loading,
	        "columns": this.displayColumns,
	        "itemHeight": this.itemHeight,
	        "swipeDuration": this.swipeDuration,
	        "visibleItemCount": this.visibleItemCount,
	        "cancelButtonText": this.cancelButtonText,
	        "confirmButtonText": this.confirmButtonText
	      },
	      "scopedSlots": pickSlots(this, ['title', 'columns-top', 'columns-bottom']),
	      "on": (0, _extends2.default)({}, on)
	    });
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _checkbox = __webpack_require__(146);
	
	var _createNamespace = (0, _utils.createNamespace)('checkbox'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _checkbox.CheckboxMixin)({
	    bem: bem,
	    role: 'checkbox',
	    parent: 'vanCheckbox'
	  })],
	  computed: {
	    checked: {
	      get: function get() {
	        if (this.parent) {
	          return this.parent.value.indexOf(this.name) !== -1;
	        }
	
	        return this.value;
	      },
	      set: function set(val) {
	        if (this.parent) {
	          this.setParentValue(val);
	        } else {
	          this.$emit('input', val);
	        }
	      }
	    }
	  },
	  watch: {
	    value: function value(val) {
	      this.$emit('change', val);
	    }
	  },
	  methods: {
	    // @exposed-api
	    toggle: function toggle(checked) {
	      var _this = this;
	
	      if (checked === void 0) {
	        checked = !this.checked;
	      }
	
	      // When toggle method is called multiple times at the same time,
	      // only the last call is valid.
	      // This is a hack for usage inside Cell.
	      clearTimeout(this.toggleTask);
	      this.toggleTask = setTimeout(function () {
	        _this.checked = checked;
	      });
	    },
	    setParentValue: function setParentValue(val) {
	      var parent = this.parent;
	      var value = parent.value.slice();
	
	      if (val) {
	        if (parent.max && value.length >= parent.max) {
	          return;
	        }
	        /* istanbul ignore else */
	
	
	        if (value.indexOf(this.name) === -1) {
	          value.push(this.name);
	          parent.$emit('input', value);
	        }
	      } else {
	        var index = value.indexOf(this.name);
	        /* istanbul ignore else */
	
	        if (index !== -1) {
	          value.splice(index, 1);
	          parent.$emit('input', value);
	        }
	      }
	    }
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _constant = __webpack_require__(7);
	
	var _string = __webpack_require__(38);
	
	var _checkbox = _interopRequireDefault(__webpack_require__(142));
	
	var _createNamespace = (0, _utils.createNamespace)('coupon'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	function getDate(timeStamp) {
	  var date = new Date(timeStamp * 1000);
	  return date.getFullYear() + "." + (0, _string.padZero)(date.getMonth() + 1) + "." + (0, _string.padZero)(date.getDate());
	}
	
	function formatDiscount(discount) {
	  return (discount / 10).toFixed(discount % 10 === 0 ? 0 : 1);
	}
	
	function formatAmount(amount) {
	  return (amount / 100).toFixed(amount % 100 === 0 ? 0 : amount % 10 === 0 ? 1 : 2);
	}
	
	var _default = createComponent({
	  props: {
	    coupon: Object,
	    chosen: Boolean,
	    disabled: Boolean,
	    currency: {
	      type: String,
	      default: '¥'
	    }
	  },
	  computed: {
	    validPeriod: function validPeriod() {
	      var _this$coupon = this.coupon,
	          startAt = _this$coupon.startAt,
	          endAt = _this$coupon.endAt;
	      return getDate(startAt) + " - " + getDate(endAt);
	    },
	    faceAmount: function faceAmount() {
	      var coupon = this.coupon;
	
	      if (coupon.valueDesc) {
	        return coupon.valueDesc + "<span>" + (coupon.unitDesc || '') + "</span>";
	      }
	
	      if (coupon.denominations) {
	        var denominations = formatAmount(coupon.denominations);
	        return "<span>" + this.currency + "</span> " + denominations;
	      }
	
	      if (coupon.discount) {
	        return t('discount', formatDiscount(coupon.discount));
	      }
	
	      return '';
	    },
	    conditionMessage: function conditionMessage() {
	      var condition = formatAmount(this.coupon.originCondition);
	      return condition === '0' ? t('unlimited') : t('condition', condition);
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    var coupon = this.coupon,
	        disabled = this.disabled;
	    var description = disabled && coupon.reason || coupon.description;
	    return h("div", {
	      "class": bem({
	        disabled: disabled
	      })
	    }, [h("div", {
	      "class": bem('content')
	    }, [h("div", {
	      "class": bem('head')
	    }, [h("h2", {
	      "class": bem('amount'),
	      "domProps": {
	        "innerHTML": this.faceAmount
	      }
	    }), h("p", {
	      "class": bem('condition')
	    }, [this.coupon.condition || this.conditionMessage])]), h("div", {
	      "class": bem('body')
	    }, [h("p", {
	      "class": bem('name')
	    }, [coupon.name]), h("p", {
	      "class": bem('valid')
	    }, [this.validPeriod]), !this.disabled && h(_checkbox.default, {
	      "attrs": {
	        "size": 18,
	        "value": this.chosen,
	        "checkedColor": _constant.RED
	      },
	      "class": bem('corner')
	    })])]), description && h("p", {
	      "class": bem('description')
	    }, [description])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.TimePickerMixin = exports.sharedProps = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(93);
	
	var _string = __webpack_require__(38);
	
	var _shared = __webpack_require__(97);
	
	var _picker = _interopRequireDefault(__webpack_require__(96));
	
	var sharedProps = (0, _extends2.default)({}, _shared.pickerProps, {
	  value: null,
	  filter: Function,
	  showToolbar: {
	    type: Boolean,
	    default: true
	  },
	  formatter: {
	    type: Function,
	    default: function _default(type, value) {
	      return value;
	    }
	  }
	});
	exports.sharedProps = sharedProps;
	var TimePickerMixin = {
	  data: function data() {
	    return {
	      innerValue: this.formatValue(this.value)
	    };
	  },
	  computed: {
	    originColumns: function originColumns() {
	      var _this = this;
	
	      return this.ranges.map(function (_ref) {
	        var type = _ref.type,
	            rangeArr = _ref.range;
	        var values = (0, _utils.times)(rangeArr[1] - rangeArr[0] + 1, function (index) {
	          var value = (0, _string.padZero)(rangeArr[0] + index);
	          return value;
	        });
	
	        if (_this.filter) {
	          values = _this.filter(type, values);
	        }
	
	        return {
	          type: type,
	          values: values
	        };
	      });
	    },
	    columns: function columns() {
	      var _this2 = this;
	
	      return this.originColumns.map(function (column) {
	        return {
	          values: column.values.map(function (value) {
	            return _this2.formatter(column.type, value);
	          })
	        };
	      });
	    }
	  },
	  watch: {
	    columns: 'updateColumnValue',
	    innerValue: function innerValue(val) {
	      this.$emit('input', val);
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.updateColumnValue();
	    this.$nextTick(function () {
	      _this3.updateInnerValue();
	    });
	  },
	  methods: {
	    // @exposed-api
	    getPicker: function getPicker() {
	      return this.$refs.picker;
	    },
	    onConfirm: function onConfirm() {
	      this.$emit('confirm', this.innerValue);
	    },
	    onCancel: function onCancel() {
	      this.$emit('cancel');
	    }
	  },
	  render: function render() {
	    var _this4 = this;
	
	    var h = arguments[0];
	    var props = {};
	    Object.keys(_shared.pickerProps).forEach(function (key) {
	      props[key] = _this4[key];
	    });
	    return h(_picker.default, {
	      "ref": "picker",
	      "attrs": {
	        "columns": this.columns
	      },
	      "on": {
	        "change": this.onChange,
	        "confirm": this.onConfirm,
	        "cancel": this.onCancel
	      },
	      "props": (0, _extends2.default)({}, props)
	    });
	  }
	};
	exports.TimePickerMixin = TimePickerMixin;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.formatNumber = formatNumber;
	
	function formatNumber(value, allowDot) {
	  if (allowDot) {
	    var dotIndex = value.indexOf('.');
	
	    if (dotIndex > -1) {
	      value = value.slice(0, dotIndex + 1) + value.slice(dotIndex).replace(/\./g, '');
	    }
	  } else {
	    value = value.split('.')[0];
	  }
	
	  var regExp = allowDot ? /[^0-9.]/g : /\D/g;
	  return value.replace(regExp, '');
	}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.CheckboxMixin = void 0;
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _field = __webpack_require__(27);
	
	var _relation = __webpack_require__(9);
	
	var _utils = __webpack_require__(1);
	
	/**
	 * Common part of Checkbox & Radio
	 */
	var CheckboxMixin = function CheckboxMixin(_ref) {
	  var parent = _ref.parent,
	      bem = _ref.bem,
	      role = _ref.role;
	  return {
	    mixins: [(0, _relation.ChildrenMixin)(parent), _field.FieldMixin],
	    props: {
	      name: null,
	      value: null,
	      disabled: Boolean,
	      iconSize: [Number, String],
	      checkedColor: String,
	      labelPosition: String,
	      labelDisabled: Boolean,
	      shape: {
	        type: String,
	        default: 'round'
	      },
	      bindGroup: {
	        type: Boolean,
	        default: true
	      }
	    },
	    computed: {
	      disableBindRelation: function disableBindRelation() {
	        return !this.bindGroup;
	      },
	      isDisabled: function isDisabled() {
	        return this.parent && this.parent.disabled || this.disabled;
	      },
	      direction: function direction() {
	        return this.parent && this.parent.direction || null;
	      },
	      iconStyle: function iconStyle() {
	        var checkedColor = this.checkedColor || this.parent && this.parent.checkedColor;
	
	        if (checkedColor && this.checked && !this.isDisabled) {
	          return {
	            borderColor: checkedColor,
	            backgroundColor: checkedColor
	          };
	        }
	      },
	      tabindex: function tabindex() {
	        if (this.isDisabled || role === 'radio' && !this.checked) {
	          return -1;
	        }
	
	        return 0;
	      }
	    },
	    methods: {
	      onClick: function onClick(event) {
	        var target = event.target;
	        var icon = this.$refs.icon;
	        var iconClicked = icon === target || icon.contains(target);
	
	        if (!this.isDisabled && (iconClicked || !this.labelDisabled)) {
	          this.toggle();
	        }
	
	        this.$emit('click', event);
	      },
	      genIcon: function genIcon() {
	        var h = this.$createElement;
	        var checked = this.checked;
	        var iconSize = this.iconSize || this.parent && this.parent.iconSize;
	        return h("div", {
	          "ref": "icon",
	          "class": bem('icon', [this.shape, {
	            disabled: this.isDisabled,
	            checked: checked
	          }]),
	          "style": {
	            fontSize: (0, _utils.addUnit)(iconSize)
	          }
	        }, [this.slots('icon', {
	          checked: checked
	        }) || h(_icon.default, {
	          "attrs": {
	            "name": "success"
	          },
	          "style": this.iconStyle
	        })]);
	      },
	      genLabel: function genLabel() {
	        var h = this.$createElement;
	        var slot = this.slots();
	
	        if (slot) {
	          return h("span", {
	            "class": bem('label', [this.labelPosition, {
	              disabled: this.isDisabled
	            }])
	          }, [slot]);
	        }
	      }
	    },
	    render: function render() {
	      var h = arguments[0];
	      var Children = [this.genIcon()];
	
	      if (this.labelPosition === 'left') {
	        Children.unshift(this.genLabel());
	      } else {
	        Children.push(this.genLabel());
	      }
	
	      return h("div", {
	        "attrs": {
	          "role": role,
	          "tabindex": this.tabindex,
	          "aria-checked": String(this.checked)
	        },
	        "class": bem([{
	          disabled: this.isDisabled,
	          'label-disabled': this.labelDisabled
	        }, this.direction]),
	        "on": {
	          "click": this.onClick
	        }
	      }, [Children]);
	    }
	  };
	};
	
	exports.CheckboxMixin = CheckboxMixin;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.ClickOutsideMixin = void 0;
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	var _event = __webpack_require__(10);
	
	/**
	 * Listen to click outside event
	 */
	var ClickOutsideMixin = function ClickOutsideMixin(config) {
	  return _vue.default.extend({
	    props: {
	      closeOnClickOutside: {
	        type: Boolean,
	        default: true
	      }
	    },
	    data: function data() {
	      var _this = this;
	
	      var clickOutsideHandler = function clickOutsideHandler(event) {
	        if (_this.closeOnClickOutside && !_this.$el.contains(event.target)) {
	          _this[config.method]();
	        }
	      };
	
	      return {
	        clickOutsideHandler: clickOutsideHandler
	      };
	    },
	    mounted: function mounted() {
	      (0, _event.on)(document, config.event, this.clickOutsideHandler);
	    },
	    beforeDestroy: function beforeDestroy() {
	      (0, _event.off)(document, config.event, this.clickOutsideHandler);
	    }
	  });
	};
	
	exports.ClickOutsideMixin = ClickOutsideMixin;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.context = void 0;
	var context = {
	  zIndex: 2000,
	  lockCount: 0,
	  stack: [],
	
	  get top() {
	    return this.stack[this.stack.length - 1];
	  }
	
	};
	exports.context = context;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.PortalMixin = PortalMixin;
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	function getElement(selector) {
	  if (typeof selector === 'string') {
	    return document.querySelector(selector);
	  }
	
	  return selector();
	}
	
	function PortalMixin(_ref) {
	  var ref = _ref.ref,
	      afterPortal = _ref.afterPortal;
	  return _vue.default.extend({
	    props: {
	      getContainer: [String, Function]
	    },
	    watch: {
	      getContainer: 'portal'
	    },
	    mounted: function mounted() {
	      if (this.getContainer) {
	        this.portal();
	      }
	    },
	    methods: {
	      portal: function portal() {
	        var getContainer = this.getContainer;
	        var el = ref ? this.$refs[ref] : this.$el;
	        var container;
	
	        if (getContainer) {
	          container = getElement(getContainer);
	        } else if (this.$parent) {
	          container = this.$parent.$el;
	        }
	
	        if (container && container !== el.parentNode) {
	          container.appendChild(el);
	        }
	
	        if (afterPortal) {
	          afterPortal.call(this);
	        }
	      }
	    }
	  });
	}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _event = __webpack_require__(10);
	
	// Utils
	var _createNamespace = (0, _utils.createNamespace)('overlay'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function preventTouchMove(event) {
	  (0, _event.preventDefault)(event, true);
	}
	
	function Overlay(h, props, slots, ctx) {
	  var style = (0, _extends2.default)({
	    zIndex: props.zIndex
	  }, props.customStyle);
	
	  if ((0, _utils.isDef)(props.duration)) {
	    style.animationDuration = props.duration + "s";
	  }
	
	  return h("transition", {
	    "attrs": {
	      "name": "van-fade"
	    }
	  }, [h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "directives": [{
	      name: "show",
	      value: props.show
	    }],
	    "style": style,
	    "class": [bem(), props.className],
	    "on": {
	      "touchmove": preventTouchMove
	    }
	  }, (0, _functional.inherit)(ctx, true)]), [slots.default && slots.default()])]);
	}
	
	Overlay.props = {
	  show: Boolean,
	  zIndex: [Number, String],
	  duration: [Number, String],
	  className: null,
	  customStyle: Object
	};
	
	var _default = createComponent(Overlay);
	
	exports.default = _default;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _relation = __webpack_require__(9);
	
	var _router = __webpack_require__(24);
	
	var _info = _interopRequireDefault(__webpack_require__(35));
	
	var _createNamespace = (0, _utils.createNamespace)('sidebar-item'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ChildrenMixin)('vanSidebar')],
	  props: (0, _extends2.default)({}, _router.routeProps, {
	    dot: Boolean,
	    info: [Number, String],
	    title: String,
	    disabled: Boolean
	  }),
	  computed: {
	    select: function select() {
	      return this.index === +this.parent.activeKey;
	    }
	  },
	  methods: {
	    onClick: function onClick() {
	      if (this.disabled) {
	        return;
	      }
	
	      this.$emit('click', this.index);
	      this.parent.$emit('input', this.index);
	      this.parent.$emit('change', this.index);
	      (0, _router.route)(this.$router, this);
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("a", {
	      "class": bem({
	        select: this.select,
	        disabled: this.disabled
	      }),
	      "on": {
	        "click": this.onClick
	      }
	    }, [h("div", {
	      "class": bem('text')
	    }, [this.title, h(_info.default, {
	      "attrs": {
	        "dot": this.dot,
	        "info": this.info
	      },
	      "class": bem('info')
	    })])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _relation = __webpack_require__(9);
	
	var _createNamespace = (0, _utils.createNamespace)('sidebar'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ParentMixin)('vanSidebar')],
	  model: {
	    prop: 'activeKey'
	  },
	  props: {
	    activeKey: {
	      type: [Number, String],
	      default: 0
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "class": bem()
	    }, [this.slots()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _button = _interopRequireDefault(__webpack_require__(17));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('sku-actions'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	function SkuActions(h, props, slots, ctx) {
	  var createEmitter = function createEmitter(name) {
	    return function () {
	      props.skuEventBus.$emit(name);
	    };
	  };
	
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem()
	  }, (0, _functional.inherit)(ctx)]), [props.showAddCartBtn && h(_button.default, {
	    "attrs": {
	      "size": "large",
	      "type": "warning",
	      "text": props.addCartText || t('addCart')
	    },
	    "on": {
	      "click": createEmitter('sku:addCart')
	    }
	  }), h(_button.default, {
	    "attrs": {
	      "size": "large",
	      "type": "danger",
	      "text": props.buyText || t('buy')
	    },
	    "on": {
	      "click": createEmitter('sku:buy')
	    }
	  })]);
	}
	
	SkuActions.props = {
	  buyText: String,
	  addCartText: String,
	  skuEventBus: Object,
	  showAddCartBtn: Boolean
	};
	
	var _default = createComponent(SkuActions);
	
	exports.default = _default;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _constant = __webpack_require__(7);
	
	// Utils
	var _createNamespace = (0, _utils.createNamespace)('sku-header'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function getSkuImg(sku, selectedSku) {
	  var img;
	  sku.tree.some(function (item) {
	    var id = selectedSku[item.k_s];
	
	    if (id && item.v) {
	      var matchedSku = item.v.filter(function (skuValue) {
	        return skuValue.id === id;
	      })[0] || {};
	      img = matchedSku.previewImgUrl || matchedSku.imgUrl || matchedSku.img_url;
	      return img;
	    }
	
	    return false;
	  });
	  return img;
	}
	
	function SkuHeader(h, props, slots, ctx) {
	  var sku = props.sku,
	      goods = props.goods,
	      skuEventBus = props.skuEventBus,
	      selectedSku = props.selectedSku;
	  var goodsImg = getSkuImg(sku, selectedSku) || goods.picture;
	
	  var previewImage = function previewImage() {
	    skuEventBus.$emit('sku:previewImage', goodsImg);
	  };
	
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": [bem(), _constant.BORDER_BOTTOM]
	  }, (0, _functional.inherit)(ctx)]), [h("div", {
	    "class": bem('img-wrap'),
	    "on": {
	      "click": previewImage
	    }
	  }, [h("img", {
	    "attrs": {
	      "src": goodsImg
	    }
	  }), slots['sku-header-image-extra'] == null ? void 0 : slots['sku-header-image-extra']()]), h("div", {
	    "class": bem('goods-info')
	  }, [slots.default && slots.default()])]);
	}
	
	SkuHeader.props = {
	  sku: Object,
	  goods: Object,
	  skuEventBus: Object,
	  selectedSku: Object
	};
	
	var _default = createComponent(SkuHeader);
	
	exports.default = _default;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	// Utils
	var _createNamespace = (0, _utils.createNamespace)('sku-header-item'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function SkuHeader(h, props, slots, ctx) {
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem()
	  }, (0, _functional.inherit)(ctx)]), [slots.default && slots.default()]);
	}
	
	var _default = createComponent(SkuHeader);
	
	exports.default = _default;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _email = __webpack_require__(396);
	
	var _number = __webpack_require__(65);
	
	var _cell = _interopRequireDefault(__webpack_require__(15));
	
	var _field = _interopRequireDefault(__webpack_require__(34));
	
	var _cellGroup = _interopRequireDefault(__webpack_require__(91));
	
	var _SkuImgUploader = _interopRequireDefault(__webpack_require__(373));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('sku-messages'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	var _default2 = createComponent({
	  props: {
	    messages: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    messageConfig: Object,
	    goodsId: [Number, String]
	  },
	  data: function data() {
	    return {
	      messageValues: this.resetMessageValues(this.messages)
	    };
	  },
	  watch: {
	    messages: function messages(val) {
	      this.messageValues = this.resetMessageValues(val);
	    }
	  },
	  methods: {
	    resetMessageValues: function resetMessageValues(messages) {
	      var messageConfig = this.messageConfig;
	      var _messageConfig$initia = messageConfig.initialMessages,
	          initialMessages = _messageConfig$initia === void 0 ? {} : _messageConfig$initia;
	      return (messages || []).map(function (message) {
	        return {
	          value: initialMessages[message.name] || ''
	        };
	      });
	    },
	    getType: function getType(message) {
	      if (+message.multiple === 1) {
	        return 'textarea';
	      }
	
	      if (message.type === 'id_no') {
	        return 'text';
	      }
	
	      return message.datetime > 0 ? 'datetime-local' : message.type;
	    },
	    getMessages: function getMessages() {
	      var _this = this;
	
	      var messages = {};
	      this.messageValues.forEach(function (item, index) {
	        var value = item.value;
	
	        if (_this.messages[index].datetime > 0) {
	          value = value.replace(/T/g, ' ');
	        }
	
	        messages["message_" + index] = value;
	      });
	      return messages;
	    },
	    getCartMessages: function getCartMessages() {
	      var _this2 = this;
	
	      var messages = {};
	      this.messageValues.forEach(function (item, index) {
	        var value = item.value;
	        var message = _this2.messages[index];
	
	        if (message.datetime > 0) {
	          value = value.replace(/T/g, ' ');
	        }
	
	        messages[message.name] = value;
	      });
	      return messages;
	    },
	    getPlaceholder: function getPlaceholder(message) {
	      var type = +message.multiple === 1 ? 'textarea' : message.type;
	      var map = this.messageConfig.placeholderMap || {};
	      return message.placeholder || map[type] || t("placeholder." + type);
	    },
	    validateMessages: function validateMessages() {
	      var values = this.messageValues;
	
	      for (var i = 0; i < values.length; i++) {
	        var value = values[i].value;
	        var message = this.messages[i];
	
	        if (value === '') {
	          // 必填字段的校验
	          if (String(message.required) === '1') {
	            var textType = t(message.type === 'image' ? 'upload' : 'fill');
	            return textType + message.name;
	          }
	        } else {
	          if (message.type === 'tel' && !(0, _number.isNumeric)(value)) {
	            return t('invalid.tel');
	          }
	
	          if (message.type === 'mobile' && !/^\d{6,20}$/.test(value)) {
	            return t('invalid.mobile');
	          }
	
	          if (message.type === 'email' && !(0, _email.isEmail)(value)) {
	            return t('invalid.email');
	          }
	
	          if (message.type === 'id_no' && (value.length < 15 || value.length > 18)) {
	            return t('invalid.id_no');
	          }
	        }
	      }
	    },
	    genMessage: function genMessage(message, index) {
	      var _this3 = this;
	
	      var h = this.$createElement;
	
	      if (message.type === 'image') {
	        return h(_cell.default, {
	          "key": this.goodsId + "-" + index,
	          "attrs": {
	            "title": message.name,
	            "label": t('imageLabel'),
	            "required": String(message.required) === '1',
	            "valueClass": bem('image-cell-value')
	          },
	          "class": bem('image-cell')
	        }, [h(_SkuImgUploader.default, {
	          "attrs": {
	            "maxSize": this.messageConfig.uploadMaxSize,
	            "uploadImg": this.messageConfig.uploadImg
	          },
	          "model": {
	            value: _this3.messageValues[index].value,
	            callback: function callback($$v) {
	              _this3.$set(_this3.messageValues[index], "value", $$v);
	            }
	          }
	        })]);
	      }
	
	      return h(_field.default, {
	        "attrs": {
	          "maxlength": "200",
	          "label": message.name,
	          "required": String(message.required) === '1',
	          "placeholder": this.getPlaceholder(message),
	          "type": this.getType(message)
	        },
	        "key": this.goodsId + "-" + index,
	        "model": {
	          value: _this3.messageValues[index].value,
	          callback: function callback($$v) {
	            _this3.$set(_this3.messageValues[index], "value", $$v);
	          }
	        }
	      });
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h(_cellGroup.default, {
	      "class": bem(),
	      "attrs": {
	        "border": this.messages.length > 0
	      }
	    }, [this.messages.map(this.genMessage)]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _constant = __webpack_require__(7);
	
	// Utils
	var _createNamespace = (0, _utils.createNamespace)('sku-row'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	function SkuRow(h, props, slots, ctx) {
	  var multipleNode = props.skuRow.is_multiple && h("span", {
	    "class": bem('title-multiple')
	  }, ["\uFF08", t('multiple'), "\uFF09"]);
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": [bem(), _constant.BORDER_BOTTOM]
	  }, (0, _functional.inherit)(ctx)]), [h("div", {
	    "class": bem('title')
	  }, [props.skuRow.k, multipleNode]), slots.default && slots.default()]);
	}
	
	SkuRow.props = {
	  skuRow: Object
	};
	
	var _default = createComponent(SkuRow);
	
	exports.default = _default;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _skuHelper = __webpack_require__(100);
	
	var _createNamespace = (0, _utils.createNamespace)('sku-row-item'),
	    createComponent = _createNamespace[0];
	
	var _default2 = createComponent({
	  props: {
	    skuValue: Object,
	    skuKeyStr: String,
	    skuEventBus: Object,
	    selectedSku: Object,
	    skuList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: {
	    choosable: function choosable() {
	      return (0, _skuHelper.isSkuChoosable)(this.skuList, this.selectedSku, {
	        key: this.skuKeyStr,
	        valueId: this.skuValue.id
	      });
	    }
	  },
	  methods: {
	    onSelect: function onSelect() {
	      if (this.choosable) {
	        this.skuEventBus.$emit('sku:select', (0, _extends2.default)({}, this.skuValue, {
	          skuKeyStr: this.skuKeyStr
	        }));
	      }
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    var choosed = this.skuValue.id === this.selectedSku[this.skuKeyStr];
	    var imgUrl = this.skuValue.imgUrl || this.skuValue.img_url;
	    return h("span", {
	      "class": ['van-sku-row__item', {
	        'van-sku-row__item--active': choosed,
	        'van-sku-row__item--disabled': !this.choosable
	      }],
	      "on": {
	        "click": this.onSelect
	      }
	    }, [imgUrl && h("img", {
	      "class": "van-sku-row__item-img",
	      "attrs": {
	        "src": imgUrl
	      }
	    }), h("span", {
	      "class": "van-sku-row__item-name"
	    }, [this.skuValue.name])]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _createNamespace = (0, _utils.createNamespace)('sku-row-prop-item'),
	    createComponent = _createNamespace[0];
	
	var _default = createComponent({
	  props: {
	    skuValue: Object,
	    skuKeyStr: String,
	    skuEventBus: Object,
	    selectedProp: Object,
	    multiple: Boolean
	  },
	  computed: {
	    choosed: function choosed() {
	      var selectedProp = this.selectedProp,
	          skuKeyStr = this.skuKeyStr,
	          skuValue = this.skuValue;
	
	      if (selectedProp && selectedProp[skuKeyStr]) {
	        return selectedProp[skuKeyStr].indexOf(skuValue.id) > -1;
	      }
	
	      return false;
	    }
	  },
	  methods: {
	    onSelect: function onSelect() {
	      this.skuEventBus.$emit('sku:propSelect', (0, _extends2.default)({}, this.skuValue, {
	        skuKeyStr: this.skuKeyStr,
	        multiple: this.multiple
	      }));
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("span", {
	      "class": ['van-sku-row__item', {
	        'van-sku-row__item--active': this.choosed
	      }],
	      "on": {
	        "click": this.onSelect
	      }
	    }, [h("span", {
	      "class": "van-sku-row__item-name"
	    }, [this.skuValue.name])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _constants = __webpack_require__(62);
	
	var _stepper = _interopRequireDefault(__webpack_require__(161));
	
	var namespace = (0, _utils.createNamespace)('sku-stepper');
	var createComponent = namespace[0];
	var t = namespace[2];
	var QUOTA_LIMIT = _constants.LIMIT_TYPE.QUOTA_LIMIT,
	    STOCK_LIMIT = _constants.LIMIT_TYPE.STOCK_LIMIT;
	
	var _default = createComponent({
	  props: {
	    stock: Number,
	    skuEventBus: Object,
	    skuStockNum: Number,
	    selectedNum: Number,
	    stepperTitle: String,
	    disableStepperInput: Boolean,
	    customStepperConfig: Object,
	    hideQuotaText: Boolean,
	    quota: {
	      type: Number,
	      default: 0
	    },
	    quotaUsed: {
	      type: Number,
	      default: 0
	    },
	    startSaleNum: {
	      type: Number,
	      default: 1
	    }
	  },
	  data: function data() {
	    return {
	      currentNum: this.selectedNum,
	      // 购买限制类型: 限购/库存
	      limitType: STOCK_LIMIT
	    };
	  },
	  watch: {
	    currentNum: function currentNum(num) {
	      var intValue = parseInt(num, 10);
	
	      if (intValue >= this.stepperMinLimit && intValue <= this.stepperLimit) {
	        this.skuEventBus.$emit('sku:numChange', intValue);
	      }
	    },
	    stepperLimit: function stepperLimit(limit) {
	      if (limit < this.currentNum && this.stepperMinLimit <= limit) {
	        this.currentNum = limit;
	      }
	
	      this.checkState(this.stepperMinLimit, limit);
	    },
	    stepperMinLimit: function stepperMinLimit(start) {
	      if (start > this.currentNum || start > this.stepperLimit) {
	        this.currentNum = start;
	      }
	
	      this.checkState(start, this.stepperLimit);
	    }
	  },
	  computed: {
	    stepperLimit: function stepperLimit() {
	      var quotaLimit = this.quota - this.quotaUsed;
	      var limit; // 无限购时直接取库存，有限购时取限购数和库存数中小的那个
	
	      if (this.quota > 0 && quotaLimit <= this.stock) {
	        // 修正负的limit
	        limit = quotaLimit < 0 ? 0 : quotaLimit;
	        this.limitType = QUOTA_LIMIT;
	      } else {
	        limit = this.stock;
	        this.limitType = STOCK_LIMIT;
	      }
	
	      return limit;
	    },
	    stepperMinLimit: function stepperMinLimit() {
	      return this.startSaleNum < 1 ? 1 : this.startSaleNum;
	    },
	    quotaText: function quotaText() {
	      var _this$customStepperCo = this.customStepperConfig,
	          quotaText = _this$customStepperCo.quotaText,
	          hideQuotaText = _this$customStepperCo.hideQuotaText;
	      if (hideQuotaText) return '';
	      var text = '';
	
	      if (quotaText) {
	        text = quotaText;
	      } else {
	        var textArr = [];
	
	        if (this.startSaleNum > 1) {
	          textArr.push(t('quotaStart', this.startSaleNum));
	        }
	
	        if (this.quota > 0) {
	          textArr.push(t('quotaLimit', this.quota));
	        }
	
	        text = textArr.join(t('comma'));
	      }
	
	      return text;
	    }
	  },
	  created: function created() {
	    this.checkState(this.stepperMinLimit, this.stepperLimit);
	  },
	  methods: {
	    setCurrentNum: function setCurrentNum(num) {
	      this.currentNum = num;
	      this.checkState(this.stepperMinLimit, this.stepperLimit);
	    },
	    onOverLimit: function onOverLimit(action) {
	      this.skuEventBus.$emit('sku:overLimit', {
	        action: action,
	        limitType: this.limitType,
	        quota: this.quota,
	        quotaUsed: this.quotaUsed,
	        startSaleNum: this.startSaleNum
	      });
	    },
	    onChange: function onChange(currentValue) {
	      var intValue = parseInt(currentValue, 10);
	      var handleStepperChange = this.customStepperConfig.handleStepperChange;
	      handleStepperChange && handleStepperChange(intValue);
	      this.$emit('change', intValue);
	    },
	    checkState: function checkState(min, max) {
	      // 如果选择小于起售，则强制变为起售
	      if (this.currentNum < min || min > max) {
	        this.currentNum = min;
	      } else if (this.currentNum > max) {
	        // 当前选择数量大于最大可选时，需要重置已选数量
	        this.currentNum = max;
	      }
	
	      this.skuEventBus.$emit('sku:stepperState', {
	        valid: min <= max,
	        min: min,
	        max: max,
	        limitType: this.limitType,
	        quota: this.quota,
	        quotaUsed: this.quotaUsed,
	        startSaleNum: this.startSaleNum
	      });
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var h = arguments[0];
	    return h("div", {
	      "class": "van-sku-stepper-stock"
	    }, [h("div", {
	      "class": "van-sku-stepper-container"
	    }, [h("div", {
	      "class": "van-sku__stepper-title"
	    }, [this.stepperTitle || t('num')]), h(_stepper.default, {
	      "class": "van-sku__stepper",
	      "attrs": {
	        "min": this.stepperMinLimit,
	        "max": this.stepperLimit,
	        "disableInput": this.disableStepperInput,
	        "integer": true
	      },
	      "on": {
	        "overlimit": this.onOverLimit,
	        "change": this.onChange
	      },
	      "model": {
	        value: _this.currentNum,
	        callback: function callback($$v) {
	          _this.currentNum = $$v;
	        }
	      }
	    }), !this.hideQuotaText && this.quotaText && h("span", {
	      "class": "van-sku__stepper-quota"
	    }, ["(", this.quotaText, ")"])])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _resetScroll = __webpack_require__(172);
	
	var _event = __webpack_require__(10);
	
	var _field = __webpack_require__(27);
	
	var _utils2 = __webpack_require__(145);
	
	var _createNamespace = (0, _utils.createNamespace)('stepper'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var LONG_PRESS_START_TIME = 600;
	var LONG_PRESS_INTERVAL = 200;
	
	function equal(value1, value2) {
	  return String(value1) === String(value2);
	} // add num and avoid float number
	
	
	function add(num1, num2) {
	  var cardinal = Math.pow(10, 10);
	  return Math.round((num1 + num2) * cardinal) / cardinal;
	}
	
	var _default = createComponent({
	  mixins: [_field.FieldMixin],
	  props: {
	    value: null,
	    integer: Boolean,
	    disabled: Boolean,
	    inputWidth: [Number, String],
	    buttonSize: [Number, String],
	    asyncChange: Boolean,
	    disablePlus: Boolean,
	    disableMinus: Boolean,
	    disableInput: Boolean,
	    decimalLength: [Number, String],
	    name: {
	      type: [Number, String],
	      default: ''
	    },
	    min: {
	      type: [Number, String],
	      default: 1
	    },
	    max: {
	      type: [Number, String],
	      default: Infinity
	    },
	    step: {
	      type: [Number, String],
	      default: 1
	    },
	    defaultValue: {
	      type: [Number, String],
	      default: 1
	    },
	    showPlus: {
	      type: Boolean,
	      default: true
	    },
	    showMinus: {
	      type: Boolean,
	      default: true
	    },
	    longPress: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    var defaultValue = (0, _utils.isDef)(this.value) ? this.value : this.defaultValue;
	    var value = this.format(defaultValue);
	
	    if (!equal(value, this.value)) {
	      this.$emit('input', value);
	    }
	
	    return {
	      currentValue: value
	    };
	  },
	  computed: {
	    minusDisabled: function minusDisabled() {
	      return this.disabled || this.disableMinus || this.currentValue <= this.min;
	    },
	    plusDisabled: function plusDisabled() {
	      return this.disabled || this.disablePlus || this.currentValue >= this.max;
	    },
	    inputStyle: function inputStyle() {
	      var style = {};
	
	      if (this.inputWidth) {
	        style.width = (0, _utils.addUnit)(this.inputWidth);
	      }
	
	      if (this.buttonSize) {
	        style.height = (0, _utils.addUnit)(this.buttonSize);
	      }
	
	      return style;
	    },
	    buttonStyle: function buttonStyle() {
	      if (this.buttonSize) {
	        var size = (0, _utils.addUnit)(this.buttonSize);
	        return {
	          width: size,
	          height: size
	        };
	      }
	    }
	  },
	  watch: {
	    max: 'check',
	    min: 'check',
	    integer: 'check',
	    decimalLength: 'check',
	    value: function value(val) {
	      if (!equal(val, this.currentValue)) {
	        this.currentValue = this.format(val);
	      }
	    },
	    currentValue: function currentValue(val) {
	      this.$emit('input', val);
	      this.$emit('change', val, {
	        name: this.name
	      });
	    }
	  },
	  methods: {
	    check: function check() {
	      var val = this.format(this.currentValue);
	
	      if (!equal(val, this.currentValue)) {
	        this.currentValue = val;
	      }
	    },
	    // formatNumber illegal characters
	    formatNumber: function formatNumber(value) {
	      return (0, _utils2.formatNumber)(String(value), !this.integer);
	    },
	    format: function format(value) {
	      value = this.formatNumber(value); // format range
	
	      value = value === '' ? 0 : +value;
	      value = Math.max(Math.min(this.max, value), this.min); // format decimal
	
	      if ((0, _utils.isDef)(this.decimalLength)) {
	        value = value.toFixed(this.decimalLength);
	      }
	
	      return value;
	    },
	    onInput: function onInput(event) {
	      var value = event.target.value;
	      var formatted = this.formatNumber(value); // limit max decimal length
	
	      if ((0, _utils.isDef)(this.decimalLength) && formatted.indexOf('.') !== -1) {
	        var pair = formatted.split('.');
	        formatted = pair[0] + "." + pair[1].slice(0, this.decimalLength);
	      }
	
	      if (!equal(value, formatted)) {
	        event.target.value = formatted;
	      }
	
	      this.emitChange(formatted);
	    },
	    emitChange: function emitChange(value) {
	      if (this.asyncChange) {
	        this.$emit('input', value);
	        this.$emit('change', value, {
	          name: this.name
	        });
	      } else {
	        this.currentValue = value;
	      }
	    },
	    onChange: function onChange() {
	      var type = this.type;
	
	      if (this[type + "Disabled"]) {
	        this.$emit('overlimit', type);
	        return;
	      }
	
	      var diff = type === 'minus' ? -this.step : +this.step;
	      var value = this.format(add(+this.currentValue, diff));
	      this.emitChange(value);
	      this.$emit(type);
	    },
	    onFocus: function onFocus(event) {
	      this.$emit('focus', event);
	    },
	    onBlur: function onBlur(event) {
	      var value = this.format(event.target.value);
	      event.target.value = value;
	      this.currentValue = value;
	      this.$emit('blur', event);
	      (0, _resetScroll.resetScroll)();
	    },
	    longPressStep: function longPressStep() {
	      var _this = this;
	
	      this.longPressTimer = setTimeout(function () {
	        _this.onChange();
	
	        _this.longPressStep(_this.type);
	      }, LONG_PRESS_INTERVAL);
	    },
	    onTouchStart: function onTouchStart() {
	      var _this2 = this;
	
	      if (!this.longPress) {
	        return;
	      }
	
	      clearTimeout(this.longPressTimer);
	      this.isLongPress = false;
	      this.longPressTimer = setTimeout(function () {
	        _this2.isLongPress = true;
	
	        _this2.onChange();
	
	        _this2.longPressStep();
	      }, LONG_PRESS_START_TIME);
	    },
	    onTouchEnd: function onTouchEnd(event) {
	      if (!this.longPress) {
	        return;
	      }
	
	      clearTimeout(this.longPressTimer);
	
	      if (this.isLongPress) {
	        (0, _event.preventDefault)(event);
	      }
	    }
	  },
	  render: function render() {
	    var _this3 = this;
	
	    var h = arguments[0];
	
	    var createListeners = function createListeners(type) {
	      return {
	        on: {
	          click: function click() {
	            _this3.type = type;
	
	            _this3.onChange();
	          },
	          touchstart: function touchstart() {
	            _this3.type = type;
	
	            _this3.onTouchStart();
	          },
	          touchend: _this3.onTouchEnd,
	          touchcancel: _this3.onTouchEnd
	        }
	      };
	    };
	
	    return h("div", {
	      "class": bem()
	    }, [h("button", (0, _babelHelperVueJsxMergeProps.default)([{
	      "directives": [{
	        name: "show",
	        value: this.showMinus
	      }],
	      "attrs": {
	        "type": "button"
	      },
	      "style": this.buttonStyle,
	      "class": bem('minus', {
	        disabled: this.minusDisabled
	      })
	    }, createListeners('minus')])), h("input", {
	      "attrs": {
	        "type": this.integer ? 'tel' : 'text',
	        "role": "spinbutton",
	        "disabled": this.disabled,
	        "readonly": this.disableInput,
	        "inputmode": this.integer ? 'numeric' : 'decimal',
	        "aria-valuemax": this.max,
	        "aria-valuemin": this.min,
	        "aria-valuenow": this.currentValue
	      },
	      "class": bem('input'),
	      "domProps": {
	        "value": this.currentValue
	      },
	      "style": this.inputStyle,
	      "on": {
	        "input": this.onInput,
	        "focus": this.onFocus,
	        "blur": this.onBlur
	      }
	    }), h("button", (0, _babelHelperVueJsxMergeProps.default)([{
	      "directives": [{
	        name: "show",
	        value: this.showPlus
	      }],
	      "attrs": {
	        "type": "button"
	      },
	      "style": this.buttonStyle,
	      "class": bem('plus', {
	        disabled: this.plusDisabled
	      })
	    }, createListeners('plus')]))]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _style = __webpack_require__(46);
	
	var _utils = __webpack_require__(1);
	
	var _scroll = __webpack_require__(22);
	
	var _bindEvent = __webpack_require__(36);
	
	var _createNamespace = (0, _utils.createNamespace)('sticky'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _bindEvent.BindEventMixin)(function (bind) {
	    if (!this.scroller) {
	      this.scroller = (0, _scroll.getScroller)(this.$el);
	    }
	
	    bind(this.scroller, 'scroll', this.onScroll, true);
	    this.onScroll();
	  })],
	  props: {
	    zIndex: [Number, String],
	    container: null,
	    offsetTop: {
	      type: [Number, String],
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      fixed: false,
	      height: 0,
	      transform: 0
	    };
	  },
	  computed: {
	    style: function style() {
	      if (!this.fixed) {
	        return;
	      }
	
	      var style = {};
	
	      if ((0, _utils.isDef)(this.zIndex)) {
	        style.zIndex = this.zIndex;
	      }
	
	      if (this.offsetTop && this.fixed) {
	        style.top = this.offsetTop + "px";
	      }
	
	      if (this.transform) {
	        style.transform = "translate3d(0, " + this.transform + "px, 0)";
	      }
	
	      return style;
	    }
	  },
	  methods: {
	    onScroll: function onScroll() {
	      var _this = this;
	
	      if ((0, _style.isHidden)(this.$el)) {
	        return;
	      }
	
	      this.height = this.$el.offsetHeight;
	      var container = this.container;
	      var offsetTop = +this.offsetTop;
	      var scrollTop = (0, _scroll.getScrollTop)(window);
	      var topToPageTop = (0, _scroll.getElementTop)(this.$el);
	
	      var emitScrollEvent = function emitScrollEvent() {
	        _this.$emit('scroll', {
	          scrollTop: scrollTop,
	          isFixed: _this.fixed
	        });
	      }; // The sticky component should be kept inside the container element
	
	
	      if (container) {
	        var bottomToPageTop = topToPageTop + container.offsetHeight;
	
	        if (scrollTop + offsetTop + this.height > bottomToPageTop) {
	          var distanceToBottom = this.height + scrollTop - bottomToPageTop;
	
	          if (distanceToBottom < this.height) {
	            this.fixed = true;
	            this.transform = -(distanceToBottom + offsetTop);
	          } else {
	            this.fixed = false;
	          }
	
	          emitScrollEvent();
	          return;
	        }
	      }
	
	      if (scrollTop + offsetTop > topToPageTop) {
	        this.fixed = true;
	        this.transform = 0;
	      } else {
	        this.fixed = false;
	      }
	
	      emitScrollEvent();
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    var fixed = this.fixed;
	    var style = {
	      height: fixed ? this.height + "px" : null
	    };
	    return h("div", {
	      "style": style
	    }, [h("div", {
	      "class": bem({
	        fixed: fixed
	      }),
	      "style": this.style
	    }, [this.slots()])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _createNamespace = (0, _utils.createNamespace)('swipe-item'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  data: function data() {
	    return {
	      offset: 0
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    this.$parent.swipes.push(this);
	  },
	  destroyed: function destroyed() {
	    this.$parent.swipes.splice(this.$parent.swipes.indexOf(this), 1);
	  },
	  render: function render() {
	    var h = arguments[0];
	    var _this$$parent = this.$parent,
	        vertical = _this$$parent.vertical,
	        computedWidth = _this$$parent.computedWidth,
	        computedHeight = _this$$parent.computedHeight;
	    var style = {
	      width: computedWidth + 'px',
	      height: vertical ? computedHeight + 'px' : '100%',
	      transform: "translate" + (vertical ? 'Y' : 'X') + "(" + this.offset + "px)"
	    };
	    return h("div", {
	      "class": bem(),
	      "style": style,
	      "on": (0, _extends2.default)({}, this.$listeners)
	    }, [this.slots()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _style = __webpack_require__(46);
	
	var _event = __webpack_require__(10);
	
	var _raf = __webpack_require__(45);
	
	var _number = __webpack_require__(47);
	
	var _touch = __webpack_require__(19);
	
	var _bindEvent = __webpack_require__(36);
	
	// Utils
	// Mixins
	var _createNamespace = (0, _utils.createNamespace)('swipe'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [_touch.TouchMixin, (0, _bindEvent.BindEventMixin)(function (bind, isBind) {
	    bind(window, 'resize', this.resize, true);
	    bind(window, 'visibilitychange', this.onVisibilityChange);
	
	    if (isBind) {
	      this.initialize();
	    } else {
	      this.clear();
	    }
	  })],
	  props: {
	    width: [Number, String],
	    height: [Number, String],
	    autoplay: [Number, String],
	    vertical: Boolean,
	    indicatorColor: String,
	    loop: {
	      type: Boolean,
	      default: true
	    },
	    duration: {
	      type: [Number, String],
	      default: 500
	    },
	    touchable: {
	      type: Boolean,
	      default: true
	    },
	    initialSwipe: {
	      type: [Number, String],
	      default: 0
	    },
	    showIndicators: {
	      type: Boolean,
	      default: true
	    },
	    stopPropagation: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      computedWidth: 0,
	      computedHeight: 0,
	      offset: 0,
	      active: 0,
	      deltaX: 0,
	      deltaY: 0,
	      swipes: [],
	      swiping: false
	    };
	  },
	  watch: {
	    swipes: function swipes() {
	      this.initialize();
	    },
	    initialSwipe: function initialSwipe() {
	      this.initialize();
	    },
	    autoplay: function autoplay(_autoplay) {
	      if (_autoplay > 0) {
	        this.autoPlay();
	      } else {
	        this.clear();
	      }
	    }
	  },
	  computed: {
	    count: function count() {
	      return this.swipes.length;
	    },
	    delta: function delta() {
	      return this.vertical ? this.deltaY : this.deltaX;
	    },
	    size: function size() {
	      return this[this.vertical ? 'computedHeight' : 'computedWidth'];
	    },
	    trackSize: function trackSize() {
	      return this.count * this.size;
	    },
	    activeIndicator: function activeIndicator() {
	      return (this.active + this.count) % this.count;
	    },
	    isCorrectDirection: function isCorrectDirection() {
	      var expect = this.vertical ? 'vertical' : 'horizontal';
	      return this.direction === expect;
	    },
	    trackStyle: function trackStyle() {
	      var _ref;
	
	      var mainAxis = this.vertical ? 'height' : 'width';
	      var crossAxis = this.vertical ? 'width' : 'height';
	      return _ref = {}, _ref[mainAxis] = this.trackSize + "px", _ref[crossAxis] = this[crossAxis] ? this[crossAxis] + "px" : '', _ref.transitionDuration = (this.swiping ? 0 : this.duration) + "ms", _ref.transform = "translate" + (this.vertical ? 'Y' : 'X') + "(" + this.offset + "px)", _ref;
	    },
	    indicatorStyle: function indicatorStyle() {
	      return {
	        backgroundColor: this.indicatorColor
	      };
	    },
	    minOffset: function minOffset() {
	      var rect = this.$el.getBoundingClientRect();
	      return (this.vertical ? rect.height : rect.width) - this.size * this.count;
	    }
	  },
	  mounted: function mounted() {
	    this.bindTouchEvent(this.$refs.track);
	  },
	  methods: {
	    // initialize swipe position
	    initialize: function initialize(active) {
	      if (active === void 0) {
	        active = +this.initialSwipe;
	      }
	
	      clearTimeout(this.timer);
	
	      if (this.$el && !(0, _style.isHidden)(this.$el)) {
	        var rect = this.$el.getBoundingClientRect();
	        this.computedWidth = Math.round(+this.width || rect.width);
	        this.computedHeight = Math.round(+this.height || rect.height);
	      }
	
	      this.swiping = true;
	      this.active = active;
	      this.offset = this.count > 1 ? -this.size * this.active : 0;
	      this.swipes.forEach(function (swipe) {
	        swipe.offset = 0;
	      });
	      this.autoPlay();
	    },
	    // @exposed-api
	    resize: function resize() {
	      this.initialize(this.activeIndicator);
	    },
	    onVisibilityChange: function onVisibilityChange() {
	      if (document.hidden) {
	        this.clear();
	      } else {
	        this.autoPlay();
	      }
	    },
	    onTouchStart: function onTouchStart(event) {
	      if (!this.touchable) return;
	      this.clear();
	      this.touchStart(event);
	      this.correctPosition();
	    },
	    onTouchMove: function onTouchMove(event) {
	      if (!this.touchable || !this.swiping) return;
	      this.touchMove(event);
	
	      if (this.isCorrectDirection) {
	        (0, _event.preventDefault)(event, this.stopPropagation);
	        this.move({
	          offset: this.delta
	        });
	      }
	    },
	    onTouchEnd: function onTouchEnd() {
	      if (!this.touchable || !this.swiping) return;
	
	      if (this.delta && this.isCorrectDirection) {
	        var offset = this.vertical ? this.offsetY : this.offsetX;
	        this.move({
	          pace: offset > 0 ? this.delta > 0 ? -1 : 1 : 0,
	          emitChange: true
	        });
	      }
	
	      this.swiping = false;
	      this.autoPlay();
	    },
	    getTargetActive: function getTargetActive(pace) {
	      var active = this.active,
	          count = this.count;
	
	      if (pace) {
	        if (this.loop) {
	          return (0, _number.range)(active + pace, -1, count);
	        }
	
	        return (0, _number.range)(active + pace, 0, count - 1);
	      }
	
	      return active;
	    },
	    getTargetOffset: function getTargetOffset(targetActive, offset) {
	      var currentPosition = targetActive * this.size;
	
	      if (!this.loop) {
	        currentPosition = Math.min(currentPosition, -this.minOffset);
	      }
	
	      var targetOffset = Math.round(offset - currentPosition);
	
	      if (!this.loop) {
	        targetOffset = (0, _number.range)(targetOffset, this.minOffset, 0);
	      }
	
	      return targetOffset;
	    },
	    move: function move(_ref2) {
	      var _ref2$pace = _ref2.pace,
	          pace = _ref2$pace === void 0 ? 0 : _ref2$pace,
	          _ref2$offset = _ref2.offset,
	          offset = _ref2$offset === void 0 ? 0 : _ref2$offset,
	          emitChange = _ref2.emitChange;
	      var loop = this.loop,
	          count = this.count,
	          active = this.active,
	          swipes = this.swipes,
	          trackSize = this.trackSize,
	          minOffset = this.minOffset;
	
	      if (count <= 1) {
	        return;
	      }
	
	      var targetActive = this.getTargetActive(pace);
	      var targetOffset = this.getTargetOffset(targetActive, offset); // auto move first and last swipe in loop mode
	
	      if (loop) {
	        if (swipes[0]) {
	          var outRightBound = targetOffset < minOffset;
	          swipes[0].offset = outRightBound ? trackSize : 0;
	        }
	
	        if (swipes[count - 1]) {
	          var outLeftBound = targetOffset > 0;
	          swipes[count - 1].offset = outLeftBound ? -trackSize : 0;
	        }
	      }
	
	      this.active = targetActive;
	      this.offset = targetOffset;
	
	      if (emitChange && targetActive !== active) {
	        this.$emit('change', this.activeIndicator);
	      }
	    },
	    // @exposed-api
	    prev: function prev() {
	      var _this = this;
	
	      this.correctPosition();
	      this.resetTouchStatus();
	      (0, _raf.doubleRaf)(function () {
	        _this.swiping = false;
	
	        _this.move({
	          pace: -1,
	          emitChange: true
	        });
	      });
	    },
	    // @exposed-api
	    next: function next() {
	      var _this2 = this;
	
	      this.correctPosition();
	      this.resetTouchStatus();
	      (0, _raf.doubleRaf)(function () {
	        _this2.swiping = false;
	
	        _this2.move({
	          pace: 1,
	          emitChange: true
	        });
	      });
	    },
	    // @exposed-api
	    swipeTo: function swipeTo(index, options) {
	      var _this3 = this;
	
	      if (options === void 0) {
	        options = {};
	      }
	
	      this.correctPosition();
	      this.resetTouchStatus();
	      (0, _raf.doubleRaf)(function () {
	        var targetIndex;
	
	        if (_this3.loop && index === _this3.count) {
	          targetIndex = _this3.active === 0 ? 0 : index;
	        } else {
	          targetIndex = index % _this3.count;
	        }
	
	        if (options.immediate) {
	          (0, _raf.doubleRaf)(function () {
	            _this3.swiping = false;
	          });
	        } else {
	          _this3.swiping = false;
	        }
	
	        _this3.move({
	          pace: targetIndex - _this3.active,
	          emitChange: true
	        });
	      });
	    },
	    correctPosition: function correctPosition() {
	      this.swiping = true;
	
	      if (this.active <= -1) {
	        this.move({
	          pace: this.count
	        });
	      }
	
	      if (this.active >= this.count) {
	        this.move({
	          pace: -this.count
	        });
	      }
	    },
	    clear: function clear() {
	      clearTimeout(this.timer);
	    },
	    autoPlay: function autoPlay() {
	      var _this4 = this;
	
	      var autoplay = this.autoplay;
	
	      if (autoplay > 0 && this.count > 1) {
	        this.clear();
	        this.timer = setTimeout(function () {
	          _this4.next();
	
	          _this4.autoPlay();
	        }, autoplay);
	      }
	    },
	    genIndicator: function genIndicator() {
	      var _this5 = this;
	
	      var h = this.$createElement;
	      var count = this.count,
	          activeIndicator = this.activeIndicator;
	      var slot = this.slots('indicator');
	
	      if (slot) {
	        return slot;
	      }
	
	      if (this.showIndicators && count > 1) {
	        return h("div", {
	          "class": bem('indicators', {
	            vertical: this.vertical
	          })
	        }, [Array.apply(void 0, Array(count)).map(function (empty, index) {
	          return h("i", {
	            "class": bem('indicator', {
	              active: index === activeIndicator
	            }),
	            "style": index === activeIndicator ? _this5.indicatorStyle : null
	          });
	        })]);
	      }
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "class": bem()
	    }, [h("div", {
	      "ref": "track",
	      "style": this.trackStyle,
	      "class": bem('track')
	    }, [this.slots()]), this.genIndicator()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _cell = _interopRequireDefault(__webpack_require__(15));
	
	var _switch = _interopRequireDefault(__webpack_require__(101));
	
	var _shared = __webpack_require__(166);
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('switch-cell'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function SwitchCell(h, props, slots, ctx) {
	  return h(_cell.default, (0, _babelHelperVueJsxMergeProps.default)([{
	    "attrs": {
	      "center": true,
	      "size": props.cellSize,
	      "title": props.title,
	      "border": props.border
	    },
	    "class": bem([props.cellSize])
	  }, (0, _functional.inherit)(ctx)]), [h(_switch.default, {
	    "props": (0, _extends2.default)({}, props),
	    "on": (0, _extends2.default)({}, ctx.listeners)
	  })]);
	}
	
	SwitchCell.props = (0, _extends2.default)({}, _shared.switchProps, {
	  title: String,
	  cellSize: String,
	  border: {
	    type: Boolean,
	    default: true
	  },
	  size: {
	    type: String,
	    default: '24px'
	  }
	});
	
	var _default = createComponent(SwitchCell);
	
	exports.default = _default;

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.switchProps = void 0;
	
	/**
	 * Common Switch Props
	 */
	var switchProps = {
	  size: [Number, String],
	  value: null,
	  loading: Boolean,
	  disabled: Boolean,
	  activeColor: String,
	  inactiveColor: String,
	  activeValue: {
	    type: null,
	    default: true
	  },
	  inactiveValue: {
	    type: null,
	    default: false
	  }
	};
	exports.switchProps = switchProps;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _relation = __webpack_require__(9);
	
	var _router = __webpack_require__(24);
	
	var _createNamespace = (0, _utils.createNamespace)('tab'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ChildrenMixin)('vanTabs')],
	  props: (0, _extends2.default)({}, _router.routeProps, {
	    dot: Boolean,
	    info: [Number, String],
	    name: [Number, String],
	    title: String,
	    titleStyle: null,
	    disabled: Boolean
	  }),
	  data: function data() {
	    return {
	      inited: false
	    };
	  },
	  computed: {
	    computedName: function computedName() {
	      return (0, _utils.isDef)(this.name) ? this.name : this.index;
	    },
	    isActive: function isActive() {
	      return this.computedName === this.parent.currentName;
	    }
	  },
	  watch: {
	    // eslint-disable-next-line object-shorthand
	    'parent.currentIndex': function parentCurrentIndex() {
	      this.inited = this.inited || this.isActive;
	    },
	    title: function title() {
	      this.parent.setLine();
	    },
	    inited: function inited(val) {
	      var _this = this;
	
	      if (this.parent.lazyRender && val) {
	        this.$nextTick(function () {
	          _this.parent.$emit('rendered', _this.computedName, _this.title);
	        });
	      }
	    }
	  },
	  render: function render(h) {
	    var slots = this.slots,
	        parent = this.parent,
	        isActive = this.isActive;
	    var shouldRender = this.inited || parent.scrollspy || !parent.lazyRender;
	    var show = parent.scrollspy || isActive;
	    var Content = shouldRender ? slots() : h();
	
	    if (parent.animated) {
	      return h("div", {
	        "attrs": {
	          "role": "tabpanel",
	          "aria-hidden": !isActive
	        },
	        "class": bem('pane-wrapper', {
	          inactive: !isActive
	        })
	      }, [h("div", {
	        "class": bem('pane')
	      }, [Content])]);
	    }
	
	    return h("div", {
	      "directives": [{
	        name: "show",
	        value: show
	      }],
	      "attrs": {
	        "role": "tabpanel"
	      },
	      "class": bem('pane')
	    }, [Content]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _utils2 = __webpack_require__(385);
	
	var _router = __webpack_require__(24);
	
	var _style = __webpack_require__(46);
	
	var _event = __webpack_require__(10);
	
	var _constant = __webpack_require__(7);
	
	var _scroll = __webpack_require__(22);
	
	var _relation = __webpack_require__(9);
	
	var _bindEvent = __webpack_require__(36);
	
	var _Title = _interopRequireDefault(__webpack_require__(384));
	
	var _sticky = _interopRequireDefault(__webpack_require__(162));
	
	var _Content = _interopRequireDefault(__webpack_require__(383));
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('tabs'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default2 = createComponent({
	  mixins: [(0, _relation.ParentMixin)('vanTabs'), (0, _bindEvent.BindEventMixin)(function (bind) {
	    if (!this.scroller) {
	      this.scroller = (0, _scroll.getScroller)(this.$el);
	    }
	
	    bind(window, 'resize', this.resize, true);
	
	    if (this.scrollspy) {
	      bind(this.scroller, 'scroll', this.onScroll, true);
	    }
	  })],
	  model: {
	    prop: 'active'
	  },
	  props: {
	    color: String,
	    sticky: Boolean,
	    animated: Boolean,
	    swipeable: Boolean,
	    scrollspy: Boolean,
	    background: String,
	    lineWidth: [Number, String],
	    lineHeight: [Number, String],
	    titleActiveColor: String,
	    titleInactiveColor: String,
	    type: {
	      type: String,
	      default: 'line'
	    },
	    active: {
	      type: [Number, String],
	      default: 0
	    },
	    border: {
	      type: Boolean,
	      default: true
	    },
	    ellipsis: {
	      type: Boolean,
	      default: true
	    },
	    duration: {
	      type: [Number, String],
	      default: 0.3
	    },
	    offsetTop: {
	      type: [Number, String],
	      default: 0
	    },
	    lazyRender: {
	      type: Boolean,
	      default: true
	    },
	    swipeThreshold: {
	      type: [Number, String],
	      default: 4
	    }
	  },
	  data: function data() {
	    return {
	      position: '',
	      currentIndex: null,
	      lineStyle: {
	        backgroundColor: this.color
	      }
	    };
	  },
	  computed: {
	    // whether the nav is scrollable
	    scrollable: function scrollable() {
	      return this.children.length > this.swipeThreshold || !this.ellipsis;
	    },
	    navStyle: function navStyle() {
	      return {
	        borderColor: this.color,
	        background: this.background
	      };
	    },
	    currentName: function currentName() {
	      var activeTab = this.children[this.currentIndex];
	
	      if (activeTab) {
	        return activeTab.computedName;
	      }
	    },
	    scrollOffset: function scrollOffset() {
	      if (this.sticky) {
	        return +this.offsetTop + this.tabHeight;
	      }
	
	      return 0;
	    }
	  },
	  watch: {
	    color: 'setLine',
	    active: function active(name) {
	      if (name !== this.currentName) {
	        this.setCurrentIndexByName(name);
	      }
	    },
	    children: function children() {
	      var _this = this;
	
	      this.setCurrentIndexByName(this.currentName || this.active);
	      this.setLine();
	      this.$nextTick(function () {
	        _this.scrollIntoView(true);
	      });
	    },
	    currentIndex: function currentIndex() {
	      this.scrollIntoView();
	      this.setLine(); // scroll to correct position
	
	      if (this.stickyFixed && !this.scrollspy) {
	        (0, _scroll.setRootScrollTop)(Math.ceil((0, _scroll.getElementTop)(this.$el) - this.offsetTop));
	      }
	    },
	    scrollspy: function scrollspy(val) {
	      if (val) {
	        (0, _event.on)(this.scroller, 'scroll', this.onScroll, true);
	      } else {
	        (0, _event.off)(this.scroller, 'scroll', this.onScroll);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.onShow();
	  },
	  activated: function activated() {
	    this.onShow();
	    this.setLine();
	  },
	  methods: {
	    // @exposed-api
	    resize: function resize() {
	      this.setLine();
	    },
	    onShow: function onShow() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        _this2.inited = true;
	        _this2.tabHeight = (0, _scroll.getVisibleHeight)(_this2.$refs.wrap);
	
	        _this2.scrollIntoView(true);
	      });
	    },
	    // update nav bar style
	    setLine: function setLine() {
	      var _this3 = this;
	
	      var shouldAnimate = this.inited;
	      this.$nextTick(function () {
	        var titles = _this3.$refs.titles;
	
	        if (!titles || !titles[_this3.currentIndex] || _this3.type !== 'line' || (0, _style.isHidden)(_this3.$el)) {
	          return;
	        }
	
	        var title = titles[_this3.currentIndex].$el;
	        var lineWidth = _this3.lineWidth,
	            lineHeight = _this3.lineHeight;
	        var width = (0, _utils.isDef)(lineWidth) ? lineWidth : title.offsetWidth / 2;
	        var left = title.offsetLeft + title.offsetWidth / 2;
	        var lineStyle = {
	          width: (0, _utils.addUnit)(width),
	          backgroundColor: _this3.color,
	          transform: "translateX(" + left + "px) translateX(-50%)"
	        };
	
	        if (shouldAnimate) {
	          lineStyle.transitionDuration = _this3.duration + "s";
	        }
	
	        if ((0, _utils.isDef)(lineHeight)) {
	          var height = (0, _utils.addUnit)(lineHeight);
	          lineStyle.height = height;
	          lineStyle.borderRadius = height;
	        }
	
	        _this3.lineStyle = lineStyle;
	      });
	    },
	    // correct the index of active tab
	    setCurrentIndexByName: function setCurrentIndexByName(name) {
	      var matched = this.children.filter(function (tab) {
	        return tab.computedName === name;
	      });
	      var defaultIndex = (this.children[0] || {}).index || 0;
	      this.setCurrentIndex(matched.length ? matched[0].index : defaultIndex);
	    },
	    setCurrentIndex: function setCurrentIndex(currentIndex) {
	      currentIndex = this.findAvailableTab(currentIndex);
	
	      if ((0, _utils.isDef)(currentIndex) && currentIndex !== this.currentIndex) {
	        var shouldEmitChange = this.currentIndex !== null;
	        this.currentIndex = currentIndex;
	        this.$emit('input', this.currentName);
	
	        if (shouldEmitChange) {
	          this.$emit('change', this.currentName, this.children[currentIndex].title);
	        }
	      }
	    },
	    findAvailableTab: function findAvailableTab(index) {
	      var diff = index < this.currentIndex ? -1 : 1;
	
	      while (index >= 0 && index < this.children.length) {
	        if (!this.children[index].disabled) {
	          return index;
	        }
	
	        index += diff;
	      }
	    },
	    // emit event when clicked
	    onClick: function onClick(index) {
	      var _this$children$index = this.children[index],
	          title = _this$children$index.title,
	          disabled = _this$children$index.disabled,
	          computedName = _this$children$index.computedName;
	
	      if (disabled) {
	        this.$emit('disabled', computedName, title);
	      } else {
	        this.setCurrentIndex(index);
	        this.scrollToCurrentContent();
	        this.$emit('click', computedName, title);
	      }
	    },
	    // scroll active tab into view
	    scrollIntoView: function scrollIntoView(immediate) {
	      var titles = this.$refs.titles;
	
	      if (!this.scrollable || !titles || !titles[this.currentIndex]) {
	        return;
	      }
	
	      var nav = this.$refs.nav;
	      var title = titles[this.currentIndex].$el;
	      var to = title.offsetLeft - (nav.offsetWidth - title.offsetWidth) / 2;
	      (0, _utils2.scrollLeftTo)(nav, to, immediate ? 0 : +this.duration);
	    },
	    onSticktScroll: function onSticktScroll(params) {
	      this.stickyFixed = params.isFixed;
	      this.$emit('scroll', params);
	    },
	    scrollToCurrentContent: function scrollToCurrentContent() {
	      var _this4 = this;
	
	      if (this.scrollspy) {
	        var target = this.children[this.currentIndex];
	        var el = target == null ? void 0 : target.$el;
	
	        if (el) {
	          var to = (0, _scroll.getElementTop)(el, this.scroller) - this.scrollOffset;
	          this.lockScroll = true;
	          (0, _utils2.scrollTopTo)(this.scroller, to, +this.duration, function () {
	            _this4.lockScroll = false;
	          });
	        }
	      }
	    },
	    onScroll: function onScroll() {
	      if (this.scrollspy && !this.lockScroll) {
	        var index = this.getCurrentIndexOnScroll();
	        this.setCurrentIndex(index);
	      }
	    },
	    getCurrentIndexOnScroll: function getCurrentIndexOnScroll() {
	      var children = this.children;
	
	      for (var index = 0; index < children.length; index++) {
	        var top = (0, _scroll.getVisibleTop)(children[index].$el);
	
	        if (top > this.scrollOffset) {
	          return index === 0 ? 0 : index - 1;
	        }
	      }
	
	      return children.length - 1;
	    }
	  },
	  render: function render() {
	    var _this5 = this,
	        _ref;
	
	    var h = arguments[0];
	    var type = this.type,
	        ellipsis = this.ellipsis,
	        animated = this.animated,
	        scrollable = this.scrollable;
	    var Nav = this.children.map(function (item, index) {
	      return h(_Title.default, {
	        "ref": "titles",
	        "refInFor": true,
	        "attrs": {
	          "type": type,
	          "dot": item.dot,
	          "info": item.info,
	          "title": item.title,
	          "color": _this5.color,
	          "isActive": index === _this5.currentIndex,
	          "ellipsis": ellipsis,
	          "disabled": item.disabled,
	          "scrollable": scrollable,
	          "activeColor": _this5.titleActiveColor,
	          "inactiveColor": _this5.titleInactiveColor,
	          "swipeThreshold": _this5.swipeThreshold
	        },
	        "style": item.titleStyle,
	        "scopedSlots": {
	          default: function _default() {
	            return item.slots('title');
	          }
	        },
	        "on": {
	          "click": function click() {
	            _this5.onClick(index);
	
	            (0, _router.route)(item.$router, item);
	          }
	        }
	      });
	    });
	    var Wrap = h("div", {
	      "ref": "wrap",
	      "class": [bem('wrap', {
	        scrollable: scrollable
	      }), (_ref = {}, _ref[_constant.BORDER_TOP_BOTTOM] = type === 'line' && this.border, _ref)]
	    }, [h("div", {
	      "ref": "nav",
	      "attrs": {
	        "role": "tablist"
	      },
	      "class": bem('nav', [type]),
	      "style": this.navStyle
	    }, [this.slots('nav-left'), Nav, type === 'line' && h("div", {
	      "class": bem('line'),
	      "style": this.lineStyle
	    }), this.slots('nav-right')])]);
	    return h("div", {
	      "class": bem([type])
	    }, [this.sticky ? h(_sticky.default, {
	      "attrs": {
	        "container": this.$el,
	        "offsetTop": this.offsetTop
	      },
	      "on": {
	        "scroll": this.onSticktScroll
	      }
	    }, [Wrap]) : Wrap, h(_Content.default, {
	      "attrs": {
	        "count": this.children.length,
	        "animated": animated,
	        "duration": this.duration,
	        "swipeable": this.swipeable,
	        "currentIndex": this.currentIndex
	      },
	      "on": {
	        "change": this.setCurrentIndex
	      }
	    }, [this.slots()])]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _utils2 = __webpack_require__(389);
	
	var _field = __webpack_require__(27);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _image = _interopRequireDefault(__webpack_require__(60));
	
	var _loading = _interopRequireDefault(__webpack_require__(18));
	
	var _imagePreview = _interopRequireDefault(__webpack_require__(95));
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('uploader'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default2 = createComponent({
	  inheritAttrs: false,
	  mixins: [_field.FieldMixin],
	  model: {
	    prop: 'fileList'
	  },
	  props: {
	    disabled: Boolean,
	    uploadText: String,
	    afterRead: Function,
	    beforeRead: Function,
	    beforeDelete: Function,
	    previewSize: [Number, String],
	    name: {
	      type: [Number, String],
	      default: ''
	    },
	    accept: {
	      type: String,
	      default: 'image/*'
	    },
	    fileList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    maxSize: {
	      type: [Number, String],
	      default: Number.MAX_VALUE
	    },
	    maxCount: {
	      type: [Number, String],
	      default: Number.MAX_VALUE
	    },
	    deletable: {
	      type: Boolean,
	      default: true
	    },
	    previewImage: {
	      type: Boolean,
	      default: true
	    },
	    previewFullImage: {
	      type: Boolean,
	      default: true
	    },
	    imageFit: {
	      type: String,
	      default: 'cover'
	    },
	    resultType: {
	      type: String,
	      default: 'dataUrl'
	    },
	    uploadIcon: {
	      type: String,
	      default: 'photograph'
	    }
	  },
	  computed: {
	    previewSizeWithUnit: function previewSizeWithUnit() {
	      return (0, _utils.addUnit)(this.previewSize);
	    },
	    // for form
	    value: function value() {
	      return this.fileList;
	    }
	  },
	  methods: {
	    getDetail: function getDetail(index) {
	      if (index === void 0) {
	        index = this.fileList.length;
	      }
	
	      return {
	        name: this.name,
	        index: index
	      };
	    },
	    onChange: function onChange(event) {
	      var _this = this;
	
	      var files = event.target.files;
	
	      if (this.disabled || !files.length) {
	        return;
	      }
	
	      files = files.length === 1 ? files[0] : [].slice.call(files);
	
	      if (this.beforeRead) {
	        var response = this.beforeRead(files, this.getDetail());
	
	        if (!response) {
	          this.resetInput();
	          return;
	        }
	
	        if ((0, _utils.isPromise)(response)) {
	          response.then(function () {
	            _this.readFile(files);
	          }).catch(this.resetInput);
	          return;
	        }
	      }
	
	      this.readFile(files);
	    },
	    readFile: function readFile(files) {
	      var _this2 = this;
	
	      var oversize = (0, _utils2.isOversize)(files, this.maxSize);
	
	      if (Array.isArray(files)) {
	        var maxCount = this.maxCount - this.fileList.length;
	
	        if (files.length > maxCount) {
	          files = files.slice(0, maxCount);
	        }
	
	        Promise.all(files.map(function (file) {
	          return (0, _utils2.readFile)(file, _this2.resultType);
	        })).then(function (contents) {
	          var fileList = files.map(function (file, index) {
	            var result = {
	              file: file,
	              status: ''
	            };
	
	            if (contents[index]) {
	              result.content = contents[index];
	            }
	
	            return result;
	          });
	
	          _this2.onAfterRead(fileList, oversize);
	        });
	      } else {
	        (0, _utils2.readFile)(files, this.resultType).then(function (content) {
	          var result = {
	            file: files,
	            status: ''
	          };
	
	          if (content) {
	            result.content = content;
	          }
	
	          _this2.onAfterRead(result, oversize);
	        });
	      }
	    },
	    onAfterRead: function onAfterRead(files, oversize) {
	      this.resetInput();
	
	      if (oversize) {
	        this.$emit('oversize', files, this.getDetail());
	        return;
	      }
	
	      this.$emit('input', [].concat(this.fileList, (0, _utils2.toArray)(files)));
	
	      if (this.afterRead) {
	        this.afterRead(files, this.getDetail());
	      }
	    },
	    onDelete: function onDelete(file, index) {
	      var _this3 = this;
	
	      if (this.beforeDelete) {
	        var response = this.beforeDelete(file, this.getDetail(index));
	
	        if (!response) {
	          return;
	        }
	
	        if ((0, _utils.isPromise)(response)) {
	          response.then(function () {
	            _this3.deleteFile(file, index);
	          }).catch(_utils.noop);
	          return;
	        }
	      }
	
	      this.deleteFile(file, index);
	    },
	    deleteFile: function deleteFile(file, index) {
	      var fileList = this.fileList.slice(0);
	      fileList.splice(index, 1);
	      this.$emit('input', fileList);
	      this.$emit('delete', file, this.getDetail(index));
	    },
	    resetInput: function resetInput() {
	      /* istanbul ignore else */
	      if (this.$refs.input) {
	        this.$refs.input.value = '';
	      }
	    },
	    onPreviewImage: function onPreviewImage(item) {
	      var _this4 = this;
	
	      if (!this.previewFullImage) {
	        return;
	      }
	
	      var imageFiles = this.fileList.filter(function (item) {
	        return (0, _utils2.isImageFile)(item);
	      });
	      var imageContents = imageFiles.map(function (item) {
	        return item.content || item.url;
	      });
	      this.imagePreview = (0, _imagePreview.default)({
	        images: imageContents,
	        closeOnPopstate: true,
	        startPosition: imageFiles.indexOf(item),
	        onClose: function onClose() {
	          _this4.$emit('close-preview');
	        }
	      });
	    },
	    // @exposed-api
	    closeImagePreview: function closeImagePreview() {
	      if (this.imagePreview) {
	        this.imagePreview.close();
	      }
	    },
	    genPreviewMask: function genPreviewMask(item) {
	      var h = this.$createElement;
	      var status = item.status;
	
	      if (status === 'uploading' || status === 'failed') {
	        var MaskIcon = status === 'failed' ? h(_icon.default, {
	          "attrs": {
	            "name": "warning-o"
	          },
	          "class": bem('mask-icon')
	        }) : h(_loading.default, {
	          "class": bem('loading')
	        });
	        return h("div", {
	          "class": bem('mask')
	        }, [MaskIcon, item.message && h("div", {
	          "class": bem('mask-message')
	        }, [item.message])]);
	      }
	    },
	    genPreviewItem: function genPreviewItem(item, index) {
	      var _this5 = this;
	
	      var h = this.$createElement;
	      var showDelete = item.status !== 'uploading' && this.deletable;
	      var DeleteIcon = showDelete && h(_icon.default, {
	        "attrs": {
	          "name": "clear"
	        },
	        "class": bem('preview-delete'),
	        "on": {
	          "click": function click(event) {
	            event.stopPropagation();
	
	            _this5.onDelete(item, index);
	          }
	        }
	      });
	      var Preview = (0, _utils2.isImageFile)(item) ? h(_image.default, {
	        "attrs": {
	          "fit": this.imageFit,
	          "src": item.content || item.url,
	          "width": this.previewSize,
	          "height": this.previewSize
	        },
	        "class": bem('preview-image'),
	        "on": {
	          "click": function click() {
	            _this5.onPreviewImage(item);
	          }
	        }
	      }) : h("div", {
	        "class": bem('file'),
	        "style": {
	          width: this.previewSizeWithUnit,
	          height: this.previewSizeWithUnit
	        }
	      }, [h(_icon.default, {
	        "class": bem('file-icon'),
	        "attrs": {
	          "name": "description"
	        }
	      }), h("div", {
	        "class": [bem('file-name'), 'van-ellipsis']
	      }, [item.file ? item.file.name : item.url])]);
	      return h("div", {
	        "class": bem('preview'),
	        "on": {
	          "click": function click() {
	            _this5.$emit('click-preview', item, _this5.getDetail(index));
	          }
	        }
	      }, [Preview, this.genPreviewMask(item), DeleteIcon]);
	    },
	    genPreviewList: function genPreviewList() {
	      if (this.previewImage) {
	        return this.fileList.map(this.genPreviewItem);
	      }
	    },
	    genUpload: function genUpload() {
	      var h = this.$createElement;
	
	      if (this.fileList.length >= this.maxCount) {
	        return;
	      }
	
	      var slot = this.slots();
	      var Input = h("input", {
	        "attrs": (0, _extends2.default)({}, this.$attrs, {
	          "type": "file",
	          "accept": this.accept,
	          "disabled": this.disabled
	        }),
	        "ref": "input",
	        "class": bem('input'),
	        "on": {
	          "change": this.onChange
	        }
	      });
	
	      if (slot) {
	        return h("div", {
	          "class": bem('input-wrapper')
	        }, [slot, Input]);
	      }
	
	      var style;
	
	      if (this.previewSize) {
	        var size = this.previewSizeWithUnit;
	        style = {
	          width: size,
	          height: size
	        };
	      }
	
	      return h("div", {
	        "class": bem('upload'),
	        "style": style
	      }, [h(_icon.default, {
	        "attrs": {
	          "name": this.uploadIcon
	        },
	        "class": bem('upload-icon')
	      }), this.uploadText && h("span", {
	        "class": bem('upload-text')
	      }, [this.uploadText]), Input]);
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "class": bem()
	    }, [h("div", {
	      "class": bem('wrapper', {
	        disabled: this.disabled
	      })
	    }, [this.genPreviewList(), this.genUpload()])]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.deepAssign = deepAssign;
	
	var _ = __webpack_require__(1);
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function assignKey(to, from, key) {
	  var val = from[key];
	
	  if (!(0, _.isDef)(val)) {
	    return;
	  }
	
	  if (!hasOwnProperty.call(to, key) || !(0, _.isObject)(val)) {
	    to[key] = val;
	  } else {
	    // eslint-disable-next-line no-use-before-define
	    to[key] = deepAssign(Object(to[key]), from[key]);
	  }
	}
	
	function deepAssign(to, from) {
	  Object.keys(from).forEach(function (key) {
	    assignKey(to, from, key);
	  });
	  return to;
	}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.removeNode = removeNode;
	
	function removeNode(el) {
	  var parent = el.parentNode;
	
	  if (parent) {
	    parent.removeChild(el);
	  }
	}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.resetScroll = resetScroll;
	
	var _system = __webpack_require__(175);
	
	var _scroll = __webpack_require__(22);
	
	/**
	 * Hack for iOS12 page scroll
	 * https://developers.weixin.qq.com/community/develop/doc/00044ae90742f8c82fb78fcae56800
	 */
	var isIOS = (0, _system.isIOS)();
	/* istanbul ignore next */
	
	function resetScroll() {
	  if (isIOS) {
	    (0, _scroll.setRootScrollTop)((0, _scroll.getRootScrollTop)());
	  }
	}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.isDate = isDate;
	
	var _number = __webpack_require__(65);
	
	function isDate(val) {
	  return Object.prototype.toString.call(val) === '[object Date]' && !(0, _number.isNaN)(val.getTime());
	}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isMobile = isMobile;
	
	function isMobile(value) {
	  value = value.replace(/[^-|\d]/g, '');
	  return /^((\+86)|(86))?(1)\d{10}$/.test(value) || /^0[0-9-]{10,13}$/.test(value);
	}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.isAndroid = isAndroid;
	exports.isIOS = isIOS;
	
	var _ = __webpack_require__(1);
	
	function isAndroid() {
	  /* istanbul ignore next */
	  return _.isServer ? false : /android/.test(navigator.userAgent.toLowerCase());
	}
	
	function isIOS() {
	  /* istanbul ignore next */
	  return _.isServer ? false : /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
	}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	  * vue-router v2.8.1
	  * (c) 2017 Evan You
	  * @license MIT
	  */
	'use strict';
	
	/*  */
	
	function assert (condition, message) {
	  if (!condition) {
	    throw new Error(("[vue-router] " + message))
	  }
	}
	
	function warn (condition, message) {
	  if (false) {
	    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
	  }
	}
	
	function isError (err) {
	  return Object.prototype.toString.call(err).indexOf('Error') > -1
	}
	
	var View = {
	  name: 'router-view',
	  functional: true,
	  props: {
	    name: {
	      type: String,
	      default: 'default'
	    }
	  },
	  render: function render (_, ref) {
	    var props = ref.props;
	    var children = ref.children;
	    var parent = ref.parent;
	    var data = ref.data;
	
	    data.routerView = true;
	
	    // directly use parent context's createElement() function
	    // so that components rendered by router-view can resolve named slots
	    var h = parent.$createElement;
	    var name = props.name;
	    var route = parent.$route;
	    var cache = parent._routerViewCache || (parent._routerViewCache = {});
	
	    // determine current view depth, also check to see if the tree
	    // has been toggled inactive but kept-alive.
	    var depth = 0;
	    var inactive = false;
	    while (parent && parent._routerRoot !== parent) {
	      if (parent.$vnode && parent.$vnode.data.routerView) {
	        depth++;
	      }
	      if (parent._inactive) {
	        inactive = true;
	      }
	      parent = parent.$parent;
	    }
	    data.routerViewDepth = depth;
	
	    // render previous view if the tree is inactive and kept-alive
	    if (inactive) {
	      return h(cache[name], data, children)
	    }
	
	    var matched = route.matched[depth];
	    // render empty node if no matched route
	    if (!matched) {
	      cache[name] = null;
	      return h()
	    }
	
	    var component = cache[name] = matched.components[name];
	
	    // attach instance registration hook
	    // this will be called in the instance's injected lifecycle hooks
	    data.registerRouteInstance = function (vm, val) {
	      // val could be undefined for unregistration
	      var current = matched.instances[name];
	      if (
	        (val && current !== vm) ||
	        (!val && current === vm)
	      ) {
	        matched.instances[name] = val;
	      }
	    }
	
	    // also register instance in prepatch hook
	    // in case the same component instance is reused across different routes
	    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
	      matched.instances[name] = vnode.componentInstance;
	    };
	
	    // resolve props
	    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
	    if (propsToPass) {
	      // clone to prevent mutation
	      propsToPass = data.props = extend({}, propsToPass);
	      // pass non-declared props as attrs
	      var attrs = data.attrs = data.attrs || {};
	      for (var key in propsToPass) {
	        if (!component.props || !(key in component.props)) {
	          attrs[key] = propsToPass[key];
	          delete propsToPass[key];
	        }
	      }
	    }
	
	    return h(component, data, children)
	  }
	};
	
	function resolveProps (route, config) {
	  switch (typeof config) {
	    case 'undefined':
	      return
	    case 'object':
	      return config
	    case 'function':
	      return config(route)
	    case 'boolean':
	      return config ? route.params : undefined
	    default:
	      if (false) {
	        warn(
	          false,
	          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
	          "expecting an object, function or boolean."
	        );
	      }
	  }
	}
	
	function extend (to, from) {
	  for (var key in from) {
	    to[key] = from[key];
	  }
	  return to
	}
	
	/*  */
	
	var encodeReserveRE = /[!'()*]/g;
	var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
	var commaRE = /%2C/g;
	
	// fixed encodeURIComponent which is more conformant to RFC3986:
	// - escapes [!'()*]
	// - preserve commas
	var encode = function (str) { return encodeURIComponent(str)
	  .replace(encodeReserveRE, encodeReserveReplacer)
	  .replace(commaRE, ','); };
	
	var decode = decodeURIComponent;
	
	function resolveQuery (
	  query,
	  extraQuery,
	  _parseQuery
	) {
	  if ( extraQuery === void 0 ) extraQuery = {};
	
	  var parse = _parseQuery || parseQuery;
	  var parsedQuery;
	  try {
	    parsedQuery = parse(query || '');
	  } catch (e) {
	    ("production") !== 'production' && warn(false, e.message);
	    parsedQuery = {};
	  }
	  for (var key in extraQuery) {
	    parsedQuery[key] = extraQuery[key];
	  }
	  return parsedQuery
	}
	
	function parseQuery (query) {
	  var res = {};
	
	  query = query.trim().replace(/^(\?|#|&)/, '');
	
	  if (!query) {
	    return res
	  }
	
	  query.split('&').forEach(function (param) {
	    var parts = param.replace(/\+/g, ' ').split('=');
	    var key = decode(parts.shift());
	    var val = parts.length > 0
	      ? decode(parts.join('='))
	      : null;
	
	    if (res[key] === undefined) {
	      res[key] = val;
	    } else if (Array.isArray(res[key])) {
	      res[key].push(val);
	    } else {
	      res[key] = [res[key], val];
	    }
	  });
	
	  return res
	}
	
	function stringifyQuery (obj) {
	  var res = obj ? Object.keys(obj).map(function (key) {
	    var val = obj[key];
	
	    if (val === undefined) {
	      return ''
	    }
	
	    if (val === null) {
	      return encode(key)
	    }
	
	    if (Array.isArray(val)) {
	      var result = [];
	      val.forEach(function (val2) {
	        if (val2 === undefined) {
	          return
	        }
	        if (val2 === null) {
	          result.push(encode(key));
	        } else {
	          result.push(encode(key) + '=' + encode(val2));
	        }
	      });
	      return result.join('&')
	    }
	
	    return encode(key) + '=' + encode(val)
	  }).filter(function (x) { return x.length > 0; }).join('&') : null;
	  return res ? ("?" + res) : ''
	}
	
	/*  */
	
	
	var trailingSlashRE = /\/?$/;
	
	function createRoute (
	  record,
	  location,
	  redirectedFrom,
	  router
	) {
	  var stringifyQuery$$1 = router && router.options.stringifyQuery;
	
	  var query = location.query || {};
	  try {
	    query = clone(query);
	  } catch (e) {}
	
	  var route = {
	    name: location.name || (record && record.name),
	    meta: (record && record.meta) || {},
	    path: location.path || '/',
	    hash: location.hash || '',
	    query: query,
	    params: location.params || {},
	    fullPath: getFullPath(location, stringifyQuery$$1),
	    matched: record ? formatMatch(record) : []
	  };
	  if (redirectedFrom) {
	    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
	  }
	  return Object.freeze(route)
	}
	
	function clone (value) {
	  if (Array.isArray(value)) {
	    return value.map(clone)
	  } else if (value && typeof value === 'object') {
	    var res = {};
	    for (var key in value) {
	      res[key] = clone(value[key]);
	    }
	    return res
	  } else {
	    return value
	  }
	}
	
	// the starting route that represents the initial state
	var START = createRoute(null, {
	  path: '/'
	});
	
	function formatMatch (record) {
	  var res = [];
	  while (record) {
	    res.unshift(record);
	    record = record.parent;
	  }
	  return res
	}
	
	function getFullPath (
	  ref,
	  _stringifyQuery
	) {
	  var path = ref.path;
	  var query = ref.query; if ( query === void 0 ) query = {};
	  var hash = ref.hash; if ( hash === void 0 ) hash = '';
	
	  var stringify = _stringifyQuery || stringifyQuery;
	  return (path || '/') + stringify(query) + hash
	}
	
	function isSameRoute (a, b) {
	  if (b === START) {
	    return a === b
	  } else if (!b) {
	    return false
	  } else if (a.path && b.path) {
	    return (
	      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query)
	    )
	  } else if (a.name && b.name) {
	    return (
	      a.name === b.name &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query) &&
	      isObjectEqual(a.params, b.params)
	    )
	  } else {
	    return false
	  }
	}
	
	function isObjectEqual (a, b) {
	  if ( a === void 0 ) a = {};
	  if ( b === void 0 ) b = {};
	
	  // handle null value #1566
	  if (!a || !b) { return a === b }
	  var aKeys = Object.keys(a);
	  var bKeys = Object.keys(b);
	  if (aKeys.length !== bKeys.length) {
	    return false
	  }
	  return aKeys.every(function (key) {
	    var aVal = a[key];
	    var bVal = b[key];
	    // check nested equality
	    if (typeof aVal === 'object' && typeof bVal === 'object') {
	      return isObjectEqual(aVal, bVal)
	    }
	    return String(aVal) === String(bVal)
	  })
	}
	
	function isIncludedRoute (current, target) {
	  return (
	    current.path.replace(trailingSlashRE, '/').indexOf(
	      target.path.replace(trailingSlashRE, '/')
	    ) === 0 &&
	    (!target.hash || current.hash === target.hash) &&
	    queryIncludes(current.query, target.query)
	  )
	}
	
	function queryIncludes (current, target) {
	  for (var key in target) {
	    if (!(key in current)) {
	      return false
	    }
	  }
	  return true
	}
	
	/*  */
	
	// work around weird flow bug
	var toTypes = [String, Object];
	var eventTypes = [String, Array];
	
	var Link = {
	  name: 'router-link',
	  props: {
	    to: {
	      type: toTypes,
	      required: true
	    },
	    tag: {
	      type: String,
	      default: 'a'
	    },
	    exact: Boolean,
	    append: Boolean,
	    replace: Boolean,
	    activeClass: String,
	    exactActiveClass: String,
	    event: {
	      type: eventTypes,
	      default: 'click'
	    }
	  },
	  render: function render (h) {
	    var this$1 = this;
	
	    var router = this.$router;
	    var current = this.$route;
	    var ref = router.resolve(this.to, current, this.append);
	    var location = ref.location;
	    var route = ref.route;
	    var href = ref.href;
	
	    var classes = {};
	    var globalActiveClass = router.options.linkActiveClass;
	    var globalExactActiveClass = router.options.linkExactActiveClass;
	    // Support global empty active class
	    var activeClassFallback = globalActiveClass == null
	            ? 'router-link-active'
	            : globalActiveClass;
	    var exactActiveClassFallback = globalExactActiveClass == null
	            ? 'router-link-exact-active'
	            : globalExactActiveClass;
	    var activeClass = this.activeClass == null
	            ? activeClassFallback
	            : this.activeClass;
	    var exactActiveClass = this.exactActiveClass == null
	            ? exactActiveClassFallback
	            : this.exactActiveClass;
	    var compareTarget = location.path
	      ? createRoute(null, location, null, router)
	      : route;
	
	    classes[exactActiveClass] = isSameRoute(current, compareTarget);
	    classes[activeClass] = this.exact
	      ? classes[exactActiveClass]
	      : isIncludedRoute(current, compareTarget);
	
	    var handler = function (e) {
	      if (guardEvent(e)) {
	        if (this$1.replace) {
	          router.replace(location);
	        } else {
	          router.push(location);
	        }
	      }
	    };
	
	    var on = { click: guardEvent };
	    if (Array.isArray(this.event)) {
	      this.event.forEach(function (e) { on[e] = handler; });
	    } else {
	      on[this.event] = handler;
	    }
	
	    var data = {
	      class: classes
	    };
	
	    if (this.tag === 'a') {
	      data.on = on;
	      data.attrs = { href: href };
	    } else {
	      // find the first <a> child and apply listener and href
	      var a = findAnchor(this.$slots.default);
	      if (a) {
	        // in case the <a> is a static node
	        a.isStatic = false;
	        var extend = _Vue.util.extend;
	        var aData = a.data = extend({}, a.data);
	        aData.on = on;
	        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
	        aAttrs.href = href;
	      } else {
	        // doesn't have <a> child, apply listener to self
	        data.on = on;
	      }
	    }
	
	    return h(this.tag, data, this.$slots.default)
	  }
	};
	
	function guardEvent (e) {
	  // don't redirect with control keys
	  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
	  // don't redirect when preventDefault called
	  if (e.defaultPrevented) { return }
	  // don't redirect on right click
	  if (e.button !== undefined && e.button !== 0) { return }
	  // don't redirect if `target="_blank"`
	  if (e.currentTarget && e.currentTarget.getAttribute) {
	    var target = e.currentTarget.getAttribute('target');
	    if (/\b_blank\b/i.test(target)) { return }
	  }
	  // this may be a Weex event which doesn't have this method
	  if (e.preventDefault) {
	    e.preventDefault();
	  }
	  return true
	}
	
	function findAnchor (children) {
	  if (children) {
	    var child;
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      if (child.tag === 'a') {
	        return child
	      }
	      if (child.children && (child = findAnchor(child.children))) {
	        return child
	      }
	    }
	  }
	}
	
	var _Vue;
	
	function install (Vue) {
	  if (install.installed && _Vue === Vue) { return }
	  install.installed = true;
	
	  _Vue = Vue;
	
	  var isDef = function (v) { return v !== undefined; };
	
	  var registerInstance = function (vm, callVal) {
	    var i = vm.$options._parentVnode;
	    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
	      i(vm, callVal);
	    }
	  };
	
	  Vue.mixin({
	    beforeCreate: function beforeCreate () {
	      if (isDef(this.$options.router)) {
	        this._routerRoot = this;
	        this._router = this.$options.router;
	        this._router.init(this);
	        Vue.util.defineReactive(this, '_route', this._router.history.current);
	      } else {
	        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
	      }
	      registerInstance(this, this);
	    },
	    destroyed: function destroyed () {
	      registerInstance(this);
	    }
	  });
	
	  Object.defineProperty(Vue.prototype, '$router', {
	    get: function get () { return this._routerRoot._router }
	  });
	
	  Object.defineProperty(Vue.prototype, '$route', {
	    get: function get () { return this._routerRoot._route }
	  });
	
	  Vue.component('router-view', View);
	  Vue.component('router-link', Link);
	
	  var strats = Vue.config.optionMergeStrategies;
	  // use the same hook merging strategy for route hooks
	  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
	}
	
	/*  */
	
	var inBrowser = typeof window !== 'undefined';
	
	/*  */
	
	function resolvePath (
	  relative,
	  base,
	  append
	) {
	  var firstChar = relative.charAt(0);
	  if (firstChar === '/') {
	    return relative
	  }
	
	  if (firstChar === '?' || firstChar === '#') {
	    return base + relative
	  }
	
	  var stack = base.split('/');
	
	  // remove trailing segment if:
	  // - not appending
	  // - appending to trailing slash (last segment is empty)
	  if (!append || !stack[stack.length - 1]) {
	    stack.pop();
	  }
	
	  // resolve relative path
	  var segments = relative.replace(/^\//, '').split('/');
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i];
	    if (segment === '..') {
	      stack.pop();
	    } else if (segment !== '.') {
	      stack.push(segment);
	    }
	  }
	
	  // ensure leading slash
	  if (stack[0] !== '') {
	    stack.unshift('');
	  }
	
	  return stack.join('/')
	}
	
	function parsePath (path) {
	  var hash = '';
	  var query = '';
	
	  var hashIndex = path.indexOf('#');
	  if (hashIndex >= 0) {
	    hash = path.slice(hashIndex);
	    path = path.slice(0, hashIndex);
	  }
	
	  var queryIndex = path.indexOf('?');
	  if (queryIndex >= 0) {
	    query = path.slice(queryIndex + 1);
	    path = path.slice(0, queryIndex);
	  }
	
	  return {
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function cleanPath (path) {
	  return path.replace(/\/\//g, '/')
	}
	
	var isarray = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};
	
	/**
	 * Expose `pathToRegexp`.
	 */
	var pathToRegexp_1 = pathToRegexp;
	var parse_1 = parse;
	var compile_1 = compile;
	var tokensToFunction_1 = tokensToFunction;
	var tokensToRegExp_1 = tokensToRegExp;
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g');
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = [];
	  var key = 0;
	  var index = 0;
	  var path = '';
	  var defaultDelimiter = options && options.delimiter || '/';
	  var res;
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0];
	    var escaped = res[1];
	    var offset = res.index;
	    path += str.slice(index, offset);
	    index = offset + m.length;
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1];
	      continue
	    }
	
	    var next = str[index];
	    var prefix = res[2];
	    var name = res[3];
	    var capture = res[4];
	    var group = res[5];
	    var modifier = res[6];
	    var asterisk = res[7];
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path);
	      path = '';
	    }
	
	    var partial = prefix != null && next != null && next !== prefix;
	    var repeat = modifier === '+' || modifier === '*';
	    var optional = modifier === '?' || modifier === '*';
	    var delimiter = res[2] || defaultDelimiter;
	    var pattern = capture || group;
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    });
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index);
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path);
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length);
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
	    }
	  }
	
	  return function (obj, opts) {
	    var path = '';
	    var data = obj || {};
	    var options = opts || {};
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i];
	
	      if (typeof token === 'string') {
	        path += token;
	
	        continue
	      }
	
	      var value = data[token.name];
	      var segment;
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix;
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j]);
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment;
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value);
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment;
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys;
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g);
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      });
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = [];
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source);
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  var strict = options.strict;
	  var end = options.end !== false;
	  var route = '';
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (typeof token === 'string') {
	      route += escapeString(token);
	    } else {
	      var prefix = escapeString(token.prefix);
	      var capture = '(?:' + token.pattern + ')';
	
	      keys.push(token);
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*';
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?';
	        } else {
	          capture = prefix + '(' + capture + ')?';
	        }
	      } else {
	        capture = prefix + '(' + capture + ')';
	      }
	
	      route += capture;
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/');
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
	  }
	
	  if (end) {
	    route += '$';
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}
	
	pathToRegexp_1.parse = parse_1;
	pathToRegexp_1.compile = compile_1;
	pathToRegexp_1.tokensToFunction = tokensToFunction_1;
	pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;
	
	/*  */
	
	// $flow-disable-line
	var regexpCompileCache = Object.create(null);
	
	function fillParams (
	  path,
	  params,
	  routeMsg
	) {
	  try {
	    var filler =
	      regexpCompileCache[path] ||
	      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
	    return filler(params || {}, { pretty: true })
	  } catch (e) {
	    if (false) {
	      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
	    }
	    return ''
	  }
	}
	
	/*  */
	
	function createRouteMap (
	  routes,
	  oldPathList,
	  oldPathMap,
	  oldNameMap
	) {
	  // the path list is used to control path matching priority
	  var pathList = oldPathList || [];
	  // $flow-disable-line
	  var pathMap = oldPathMap || Object.create(null);
	  // $flow-disable-line
	  var nameMap = oldNameMap || Object.create(null);
	
	  routes.forEach(function (route) {
	    addRouteRecord(pathList, pathMap, nameMap, route);
	  });
	
	  // ensure wildcard routes are always at the end
	  for (var i = 0, l = pathList.length; i < l; i++) {
	    if (pathList[i] === '*') {
	      pathList.push(pathList.splice(i, 1)[0]);
	      l--;
	      i--;
	    }
	  }
	
	  return {
	    pathList: pathList,
	    pathMap: pathMap,
	    nameMap: nameMap
	  }
	}
	
	function addRouteRecord (
	  pathList,
	  pathMap,
	  nameMap,
	  route,
	  parent,
	  matchAs
	) {
	  var path = route.path;
	  var name = route.name;
	  if (false) {
	    assert(path != null, "\"path\" is required in a route configuration.");
	    assert(
	      typeof route.component !== 'string',
	      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
	      "string id. Use an actual component instead."
	    );
	  }
	
	  var pathToRegexpOptions = route.pathToRegexpOptions || {};
	  var normalizedPath = normalizePath(
	    path,
	    parent,
	    pathToRegexpOptions.strict
	  );
	
	  if (typeof route.caseSensitive === 'boolean') {
	    pathToRegexpOptions.sensitive = route.caseSensitive;
	  }
	
	  var record = {
	    path: normalizedPath,
	    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
	    components: route.components || { default: route.component },
	    instances: {},
	    name: name,
	    parent: parent,
	    matchAs: matchAs,
	    redirect: route.redirect,
	    beforeEnter: route.beforeEnter,
	    meta: route.meta || {},
	    props: route.props == null
	      ? {}
	      : route.components
	        ? route.props
	        : { default: route.props }
	  };
	
	  if (route.children) {
	    // Warn if route is named, does not redirect and has a default child route.
	    // If users navigate to this route by name, the default child will
	    // not be rendered (GH Issue #629)
	    if (false) {
	      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
	        warn(
	          false,
	          "Named Route '" + (route.name) + "' has a default child route. " +
	          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
	          "the default child route will not be rendered. Remove the name from " +
	          "this route and use the name of the default child route for named " +
	          "links instead."
	        );
	      }
	    }
	    route.children.forEach(function (child) {
	      var childMatchAs = matchAs
	        ? cleanPath((matchAs + "/" + (child.path)))
	        : undefined;
	      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
	    });
	  }
	
	  if (route.alias !== undefined) {
	    var aliases = Array.isArray(route.alias)
	      ? route.alias
	      : [route.alias];
	
	    aliases.forEach(function (alias) {
	      var aliasRoute = {
	        path: alias,
	        children: route.children
	      };
	      addRouteRecord(
	        pathList,
	        pathMap,
	        nameMap,
	        aliasRoute,
	        parent,
	        record.path || '/' // matchAs
	      );
	    });
	  }
	
	  if (!pathMap[record.path]) {
	    pathList.push(record.path);
	    pathMap[record.path] = record;
	  }
	
	  if (name) {
	    if (!nameMap[name]) {
	      nameMap[name] = record;
	    } else if (false) {
	      warn(
	        false,
	        "Duplicate named routes definition: " +
	        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
	      );
	    }
	  }
	}
	
	function compileRouteRegex (path, pathToRegexpOptions) {
	  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
	  if (false) {
	    var keys = Object.create(null);
	    regex.keys.forEach(function (key) {
	      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
	      keys[key.name] = true;
	    });
	  }
	  return regex
	}
	
	function normalizePath (path, parent, strict) {
	  if (!strict) { path = path.replace(/\/$/, ''); }
	  if (path[0] === '/') { return path }
	  if (parent == null) { return path }
	  return cleanPath(((parent.path) + "/" + path))
	}
	
	/*  */
	
	
	function normalizeLocation (
	  raw,
	  current,
	  append,
	  router
	) {
	  var next = typeof raw === 'string' ? { path: raw } : raw;
	  // named target
	  if (next.name || next._normalized) {
	    return next
	  }
	
	  // relative params
	  if (!next.path && next.params && current) {
	    next = assign({}, next);
	    next._normalized = true;
	    var params = assign(assign({}, current.params), next.params);
	    if (current.name) {
	      next.name = current.name;
	      next.params = params;
	    } else if (current.matched.length) {
	      var rawPath = current.matched[current.matched.length - 1].path;
	      next.path = fillParams(rawPath, params, ("path " + (current.path)));
	    } else if (false) {
	      warn(false, "relative params navigation requires a current route.");
	    }
	    return next
	  }
	
	  var parsedPath = parsePath(next.path || '');
	  var basePath = (current && current.path) || '/';
	  var path = parsedPath.path
	    ? resolvePath(parsedPath.path, basePath, append || next.append)
	    : basePath;
	
	  var query = resolveQuery(
	    parsedPath.query,
	    next.query,
	    router && router.options.parseQuery
	  );
	
	  var hash = next.hash || parsedPath.hash;
	  if (hash && hash.charAt(0) !== '#') {
	    hash = "#" + hash;
	  }
	
	  return {
	    _normalized: true,
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function assign (a, b) {
	  for (var key in b) {
	    a[key] = b[key];
	  }
	  return a
	}
	
	/*  */
	
	
	function createMatcher (
	  routes,
	  router
	) {
	  var ref = createRouteMap(routes);
	  var pathList = ref.pathList;
	  var pathMap = ref.pathMap;
	  var nameMap = ref.nameMap;
	
	  function addRoutes (routes) {
	    createRouteMap(routes, pathList, pathMap, nameMap);
	  }
	
	  function match (
	    raw,
	    currentRoute,
	    redirectedFrom
	  ) {
	    var location = normalizeLocation(raw, currentRoute, false, router);
	    var name = location.name;
	
	    if (name) {
	      var record = nameMap[name];
	      if (false) {
	        warn(record, ("Route with name '" + name + "' does not exist"));
	      }
	      if (!record) { return _createRoute(null, location) }
	      var paramNames = record.regex.keys
	        .filter(function (key) { return !key.optional; })
	        .map(function (key) { return key.name; });
	
	      if (typeof location.params !== 'object') {
	        location.params = {};
	      }
	
	      if (currentRoute && typeof currentRoute.params === 'object') {
	        for (var key in currentRoute.params) {
	          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
	            location.params[key] = currentRoute.params[key];
	          }
	        }
	      }
	
	      if (record) {
	        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
	        return _createRoute(record, location, redirectedFrom)
	      }
	    } else if (location.path) {
	      location.params = {};
	      for (var i = 0; i < pathList.length; i++) {
	        var path = pathList[i];
	        var record$1 = pathMap[path];
	        if (matchRoute(record$1.regex, location.path, location.params)) {
	          return _createRoute(record$1, location, redirectedFrom)
	        }
	      }
	    }
	    // no match
	    return _createRoute(null, location)
	  }
	
	  function redirect (
	    record,
	    location
	  ) {
	    var originalRedirect = record.redirect;
	    var redirect = typeof originalRedirect === 'function'
	        ? originalRedirect(createRoute(record, location, null, router))
	        : originalRedirect;
	
	    if (typeof redirect === 'string') {
	      redirect = { path: redirect };
	    }
	
	    if (!redirect || typeof redirect !== 'object') {
	      if (false) {
	        warn(
	          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
	        );
	      }
	      return _createRoute(null, location)
	    }
	
	    var re = redirect;
	    var name = re.name;
	    var path = re.path;
	    var query = location.query;
	    var hash = location.hash;
	    var params = location.params;
	    query = re.hasOwnProperty('query') ? re.query : query;
	    hash = re.hasOwnProperty('hash') ? re.hash : hash;
	    params = re.hasOwnProperty('params') ? re.params : params;
	
	    if (name) {
	      // resolved named direct
	      var targetRecord = nameMap[name];
	      if (false) {
	        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
	      }
	      return match({
	        _normalized: true,
	        name: name,
	        query: query,
	        hash: hash,
	        params: params
	      }, undefined, location)
	    } else if (path) {
	      // 1. resolve relative redirect
	      var rawPath = resolveRecordPath(path, record);
	      // 2. resolve params
	      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
	      // 3. rematch with existing query and hash
	      return match({
	        _normalized: true,
	        path: resolvedPath,
	        query: query,
	        hash: hash
	      }, undefined, location)
	    } else {
	      if (false) {
	        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
	      }
	      return _createRoute(null, location)
	    }
	  }
	
	  function alias (
	    record,
	    location,
	    matchAs
	  ) {
	    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
	    var aliasedMatch = match({
	      _normalized: true,
	      path: aliasedPath
	    });
	    if (aliasedMatch) {
	      var matched = aliasedMatch.matched;
	      var aliasedRecord = matched[matched.length - 1];
	      location.params = aliasedMatch.params;
	      return _createRoute(aliasedRecord, location)
	    }
	    return _createRoute(null, location)
	  }
	
	  function _createRoute (
	    record,
	    location,
	    redirectedFrom
	  ) {
	    if (record && record.redirect) {
	      return redirect(record, redirectedFrom || location)
	    }
	    if (record && record.matchAs) {
	      return alias(record, location, record.matchAs)
	    }
	    return createRoute(record, location, redirectedFrom, router)
	  }
	
	  return {
	    match: match,
	    addRoutes: addRoutes
	  }
	}
	
	function matchRoute (
	  regex,
	  path,
	  params
	) {
	  var m = path.match(regex);
	
	  if (!m) {
	    return false
	  } else if (!params) {
	    return true
	  }
	
	  for (var i = 1, len = m.length; i < len; ++i) {
	    var key = regex.keys[i - 1];
	    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
	    if (key) {
	      params[key.name] = val;
	    }
	  }
	
	  return true
	}
	
	function resolveRecordPath (path, record) {
	  return resolvePath(path, record.parent ? record.parent.path : '/', true)
	}
	
	/*  */
	
	
	var positionStore = Object.create(null);
	
	function setupScroll () {
	  // Fix for #1585 for Firefox
	  window.history.replaceState({ key: getStateKey() }, '');
	  window.addEventListener('popstate', function (e) {
	    saveScrollPosition();
	    if (e.state && e.state.key) {
	      setStateKey(e.state.key);
	    }
	  });
	}
	
	function handleScroll (
	  router,
	  to,
	  from,
	  isPop
	) {
	  if (!router.app) {
	    return
	  }
	
	  var behavior = router.options.scrollBehavior;
	  if (!behavior) {
	    return
	  }
	
	  if (false) {
	    assert(typeof behavior === 'function', "scrollBehavior must be a function");
	  }
	
	  // wait until re-render finishes before scrolling
	  router.app.$nextTick(function () {
	    var position = getScrollPosition();
	    var shouldScroll = behavior(to, from, isPop ? position : null);
	
	    if (!shouldScroll) {
	      return
	    }
	
	    if (typeof shouldScroll.then === 'function') {
	      shouldScroll.then(function (shouldScroll) {
	        scrollToPosition((shouldScroll), position);
	      }).catch(function (err) {
	        if (false) {
	          assert(false, err.toString());
	        }
	      });
	    } else {
	      scrollToPosition(shouldScroll, position);
	    }
	  });
	}
	
	function saveScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    positionStore[key] = {
	      x: window.pageXOffset,
	      y: window.pageYOffset
	    };
	  }
	}
	
	function getScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    return positionStore[key]
	  }
	}
	
	function getElementPosition (el, offset) {
	  var docEl = document.documentElement;
	  var docRect = docEl.getBoundingClientRect();
	  var elRect = el.getBoundingClientRect();
	  return {
	    x: elRect.left - docRect.left - offset.x,
	    y: elRect.top - docRect.top - offset.y
	  }
	}
	
	function isValidPosition (obj) {
	  return isNumber(obj.x) || isNumber(obj.y)
	}
	
	function normalizePosition (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
	    y: isNumber(obj.y) ? obj.y : window.pageYOffset
	  }
	}
	
	function normalizeOffset (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : 0,
	    y: isNumber(obj.y) ? obj.y : 0
	  }
	}
	
	function isNumber (v) {
	  return typeof v === 'number'
	}
	
	function scrollToPosition (shouldScroll, position) {
	  var isObject = typeof shouldScroll === 'object';
	  if (isObject && typeof shouldScroll.selector === 'string') {
	    var el = document.querySelector(shouldScroll.selector);
	    if (el) {
	      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
	      offset = normalizeOffset(offset);
	      position = getElementPosition(el, offset);
	    } else if (isValidPosition(shouldScroll)) {
	      position = normalizePosition(shouldScroll);
	    }
	  } else if (isObject && isValidPosition(shouldScroll)) {
	    position = normalizePosition(shouldScroll);
	  }
	
	  if (position) {
	    window.scrollTo(position.x, position.y);
	  }
	}
	
	/*  */
	
	var supportsPushState = inBrowser && (function () {
	  var ua = window.navigator.userAgent;
	
	  if (
	    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
	    ua.indexOf('Mobile Safari') !== -1 &&
	    ua.indexOf('Chrome') === -1 &&
	    ua.indexOf('Windows Phone') === -1
	  ) {
	    return false
	  }
	
	  return window.history && 'pushState' in window.history
	})();
	
	// use User Timing api (if present) for more accurate key precision
	var Time = inBrowser && window.performance && window.performance.now
	  ? window.performance
	  : Date;
	
	var _key = genKey();
	
	function genKey () {
	  return Time.now().toFixed(3)
	}
	
	function getStateKey () {
	  return _key
	}
	
	function setStateKey (key) {
	  _key = key;
	}
	
	function pushState (url, replace) {
	  saveScrollPosition();
	  // try...catch the pushState call to get around Safari
	  // DOM Exception 18 where it limits to 100 pushState calls
	  var history = window.history;
	  try {
	    if (replace) {
	      history.replaceState({ key: _key }, '', url);
	    } else {
	      _key = genKey();
	      history.pushState({ key: _key }, '', url);
	    }
	  } catch (e) {
	    window.location[replace ? 'replace' : 'assign'](url);
	  }
	}
	
	function replaceState (url) {
	  pushState(url, true);
	}
	
	/*  */
	
	function runQueue (queue, fn, cb) {
	  var step = function (index) {
	    if (index >= queue.length) {
	      cb();
	    } else {
	      if (queue[index]) {
	        fn(queue[index], function () {
	          step(index + 1);
	        });
	      } else {
	        step(index + 1);
	      }
	    }
	  };
	  step(0);
	}
	
	/*  */
	
	function resolveAsyncComponents (matched) {
	  return function (to, from, next) {
	    var hasAsync = false;
	    var pending = 0;
	    var error = null;
	
	    flatMapComponents(matched, function (def, _, match, key) {
	      // if it's a function and doesn't have cid attached,
	      // assume it's an async component resolve function.
	      // we are not using Vue's default async resolving mechanism because
	      // we want to halt the navigation until the incoming component has been
	      // resolved.
	      if (typeof def === 'function' && def.cid === undefined) {
	        hasAsync = true;
	        pending++;
	
	        var resolve = once(function (resolvedDef) {
	          if (isESModule(resolvedDef)) {
	            resolvedDef = resolvedDef.default;
	          }
	          // save resolved on async factory in case it's used elsewhere
	          def.resolved = typeof resolvedDef === 'function'
	            ? resolvedDef
	            : _Vue.extend(resolvedDef);
	          match.components[key] = resolvedDef;
	          pending--;
	          if (pending <= 0) {
	            next();
	          }
	        });
	
	        var reject = once(function (reason) {
	          var msg = "Failed to resolve async component " + key + ": " + reason;
	          ("production") !== 'production' && warn(false, msg);
	          if (!error) {
	            error = isError(reason)
	              ? reason
	              : new Error(msg);
	            next(error);
	          }
	        });
	
	        var res;
	        try {
	          res = def(resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        if (res) {
	          if (typeof res.then === 'function') {
	            res.then(resolve, reject);
	          } else {
	            // new syntax in Vue 2.3
	            var comp = res.component;
	            if (comp && typeof comp.then === 'function') {
	              comp.then(resolve, reject);
	            }
	          }
	        }
	      }
	    });
	
	    if (!hasAsync) { next(); }
	  }
	}
	
	function flatMapComponents (
	  matched,
	  fn
	) {
	  return flatten(matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) { return fn(
	      m.components[key],
	      m.instances[key],
	      m, key
	    ); })
	  }))
	}
	
	function flatten (arr) {
	  return Array.prototype.concat.apply([], arr)
	}
	
	var hasSymbol =
	  typeof Symbol === 'function' &&
	  typeof Symbol.toStringTag === 'symbol';
	
	function isESModule (obj) {
	  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
	}
	
	// in Webpack 2, require.ensure now also returns a Promise
	// so the resolve/reject functions may get called an extra time
	// if the user uses an arrow function shorthand that happens to
	// return that Promise.
	function once (fn) {
	  var called = false;
	  return function () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    if (called) { return }
	    called = true;
	    return fn.apply(this, args)
	  }
	}
	
	/*  */
	
	var History = function History (router, base) {
	  this.router = router;
	  this.base = normalizeBase(base);
	  // start with a route object that stands for "nowhere"
	  this.current = START;
	  this.pending = null;
	  this.ready = false;
	  this.readyCbs = [];
	  this.readyErrorCbs = [];
	  this.errorCbs = [];
	};
	
	History.prototype.listen = function listen (cb) {
	  this.cb = cb;
	};
	
	History.prototype.onReady = function onReady (cb, errorCb) {
	  if (this.ready) {
	    cb();
	  } else {
	    this.readyCbs.push(cb);
	    if (errorCb) {
	      this.readyErrorCbs.push(errorCb);
	    }
	  }
	};
	
	History.prototype.onError = function onError (errorCb) {
	  this.errorCbs.push(errorCb);
	};
	
	History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
	    var this$1 = this;
	
	  var route = this.router.match(location, this.current);
	  this.confirmTransition(route, function () {
	    this$1.updateRoute(route);
	    onComplete && onComplete(route);
	    this$1.ensureURL();
	
	    // fire ready cbs once
	    if (!this$1.ready) {
	      this$1.ready = true;
	      this$1.readyCbs.forEach(function (cb) { cb(route); });
	    }
	  }, function (err) {
	    if (onAbort) {
	      onAbort(err);
	    }
	    if (err && !this$1.ready) {
	      this$1.ready = true;
	      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
	    }
	  });
	};
	
	History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
	    var this$1 = this;
	
	  var current = this.current;
	  var abort = function (err) {
	    if (isError(err)) {
	      if (this$1.errorCbs.length) {
	        this$1.errorCbs.forEach(function (cb) { cb(err); });
	      } else {
	        warn(false, 'uncaught error during route navigation:');
	        console.error(err);
	      }
	    }
	    onAbort && onAbort(err);
	  };
	  if (
	    isSameRoute(route, current) &&
	    // in the case the route map has been dynamically appended to
	    route.matched.length === current.matched.length
	  ) {
	    this.ensureURL();
	    return abort()
	  }
	
	  var ref = resolveQueue(this.current.matched, route.matched);
	    var updated = ref.updated;
	    var deactivated = ref.deactivated;
	    var activated = ref.activated;
	
	  var queue = [].concat(
	    // in-component leave guards
	    extractLeaveGuards(deactivated),
	    // global before hooks
	    this.router.beforeHooks,
	    // in-component update hooks
	    extractUpdateHooks(updated),
	    // in-config enter guards
	    activated.map(function (m) { return m.beforeEnter; }),
	    // async components
	    resolveAsyncComponents(activated)
	  );
	
	  this.pending = route;
	  var iterator = function (hook, next) {
	    if (this$1.pending !== route) {
	      return abort()
	    }
	    try {
	      hook(route, current, function (to) {
	        if (to === false || isError(to)) {
	          // next(false) -> abort navigation, ensure current URL
	          this$1.ensureURL(true);
	          abort(to);
	        } else if (
	          typeof to === 'string' ||
	          (typeof to === 'object' && (
	            typeof to.path === 'string' ||
	            typeof to.name === 'string'
	          ))
	        ) {
	          // next('/') or next({ path: '/' }) -> redirect
	          abort();
	          if (typeof to === 'object' && to.replace) {
	            this$1.replace(to);
	          } else {
	            this$1.push(to);
	          }
	        } else {
	          // confirm transition and pass on the value
	          next(to);
	        }
	      });
	    } catch (e) {
	      abort(e);
	    }
	  };
	
	  runQueue(queue, iterator, function () {
	    var postEnterCbs = [];
	    var isValid = function () { return this$1.current === route; };
	    // wait until async components are resolved before
	    // extracting in-component enter guards
	    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
	    var queue = enterGuards.concat(this$1.router.resolveHooks);
	    runQueue(queue, iterator, function () {
	      if (this$1.pending !== route) {
	        return abort()
	      }
	      this$1.pending = null;
	      onComplete(route);
	      if (this$1.router.app) {
	        this$1.router.app.$nextTick(function () {
	          postEnterCbs.forEach(function (cb) { cb(); });
	        });
	      }
	    });
	  });
	};
	
	History.prototype.updateRoute = function updateRoute (route) {
	  var prev = this.current;
	  this.current = route;
	  this.cb && this.cb(route);
	  this.router.afterHooks.forEach(function (hook) {
	    hook && hook(route, prev);
	  });
	};
	
	function normalizeBase (base) {
	  if (!base) {
	    if (inBrowser) {
	      // respect <base> tag
	      var baseEl = document.querySelector('base');
	      base = (baseEl && baseEl.getAttribute('href')) || '/';
	      // strip full URL origin
	      base = base.replace(/^https?:\/\/[^\/]+/, '');
	    } else {
	      base = '/';
	    }
	  }
	  // make sure there's the starting slash
	  if (base.charAt(0) !== '/') {
	    base = '/' + base;
	  }
	  // remove trailing slash
	  return base.replace(/\/$/, '')
	}
	
	function resolveQueue (
	  current,
	  next
	) {
	  var i;
	  var max = Math.max(current.length, next.length);
	  for (i = 0; i < max; i++) {
	    if (current[i] !== next[i]) {
	      break
	    }
	  }
	  return {
	    updated: next.slice(0, i),
	    activated: next.slice(i),
	    deactivated: current.slice(i)
	  }
	}
	
	function extractGuards (
	  records,
	  name,
	  bind,
	  reverse
	) {
	  var guards = flatMapComponents(records, function (def, instance, match, key) {
	    var guard = extractGuard(def, name);
	    if (guard) {
	      return Array.isArray(guard)
	        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
	        : bind(guard, instance, match, key)
	    }
	  });
	  return flatten(reverse ? guards.reverse() : guards)
	}
	
	function extractGuard (
	  def,
	  key
	) {
	  if (typeof def !== 'function') {
	    // extend now so that global mixins are applied.
	    def = _Vue.extend(def);
	  }
	  return def.options[key]
	}
	
	function extractLeaveGuards (deactivated) {
	  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
	}
	
	function extractUpdateHooks (updated) {
	  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
	}
	
	function bindGuard (guard, instance) {
	  if (instance) {
	    return function boundRouteGuard () {
	      return guard.apply(instance, arguments)
	    }
	  }
	}
	
	function extractEnterGuards (
	  activated,
	  cbs,
	  isValid
	) {
	  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
	    return bindEnterGuard(guard, match, key, cbs, isValid)
	  })
	}
	
	function bindEnterGuard (
	  guard,
	  match,
	  key,
	  cbs,
	  isValid
	) {
	  return function routeEnterGuard (to, from, next) {
	    return guard(to, from, function (cb) {
	      next(cb);
	      if (typeof cb === 'function') {
	        cbs.push(function () {
	          // #750
	          // if a router-view is wrapped with an out-in transition,
	          // the instance may not have been registered at this time.
	          // we will need to poll for registration until current route
	          // is no longer valid.
	          poll(cb, match.instances, key, isValid);
	        });
	      }
	    })
	  }
	}
	
	function poll (
	  cb, // somehow flow cannot infer this is a function
	  instances,
	  key,
	  isValid
	) {
	  if (instances[key]) {
	    cb(instances[key]);
	  } else if (isValid()) {
	    setTimeout(function () {
	      poll(cb, instances, key, isValid);
	    }, 16);
	  }
	}
	
	/*  */
	
	
	var HTML5History = (function (History$$1) {
	  function HTML5History (router, base) {
	    var this$1 = this;
	
	    History$$1.call(this, router, base);
	
	    var expectScroll = router.options.scrollBehavior;
	
	    if (expectScroll) {
	      setupScroll();
	    }
	
	    var initLocation = getLocation(this.base);
	    window.addEventListener('popstate', function (e) {
	      var current = this$1.current;
	
	      // Avoiding first `popstate` event dispatched in some browsers but first
	      // history route not updated since async guard at the same time.
	      var location = getLocation(this$1.base);
	      if (this$1.current === START && location === initLocation) {
	        return
	      }
	
	      this$1.transitionTo(location, function (route) {
	        if (expectScroll) {
	          handleScroll(router, route, current, true);
	        }
	      });
	    });
	  }
	
	  if ( History$$1 ) HTML5History.__proto__ = History$$1;
	  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
	  HTML5History.prototype.constructor = HTML5History;
	
	  HTML5History.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.ensureURL = function ensureURL (push) {
	    if (getLocation(this.base) !== this.current.fullPath) {
	      var current = cleanPath(this.base + this.current.fullPath);
	      push ? pushState(current) : replaceState(current);
	    }
	  };
	
	  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getLocation(this.base)
	  };
	
	  return HTML5History;
	}(History));
	
	function getLocation (base) {
	  var path = window.location.pathname;
	  if (base && path.indexOf(base) === 0) {
	    path = path.slice(base.length);
	  }
	  return (path || '/') + window.location.search + window.location.hash
	}
	
	/*  */
	
	
	var HashHistory = (function (History$$1) {
	  function HashHistory (router, base, fallback) {
	    History$$1.call(this, router, base);
	    // check history fallback deeplinking
	    if (fallback && checkFallback(this.base)) {
	      return
	    }
	    ensureSlash();
	  }
	
	  if ( History$$1 ) HashHistory.__proto__ = History$$1;
	  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  HashHistory.prototype.constructor = HashHistory;
	
	  // this is delayed until the app mounts
	  // to avoid the hashchange listener being fired too early
	  HashHistory.prototype.setupListeners = function setupListeners () {
	    var this$1 = this;
	
	    var router = this.router;
	    var expectScroll = router.options.scrollBehavior;
	    var supportsScroll = supportsPushState && expectScroll;
	
	    if (supportsScroll) {
	      setupScroll();
	    }
	
	    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
	      var current = this$1.current;
	      if (!ensureSlash()) {
	        return
	      }
	      this$1.transitionTo(getHash(), function (route) {
	        if (supportsScroll) {
	          handleScroll(this$1.router, route, current, true);
	        }
	        if (!supportsPushState) {
	          replaceHash(route.fullPath);
	        }
	      });
	    });
	  };
	
	  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HashHistory.prototype.ensureURL = function ensureURL (push) {
	    var current = this.current.fullPath;
	    if (getHash() !== current) {
	      push ? pushHash(current) : replaceHash(current);
	    }
	  };
	
	  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getHash()
	  };
	
	  return HashHistory;
	}(History));
	
	function checkFallback (base) {
	  var location = getLocation(base);
	  if (!/^\/#/.test(location)) {
	    window.location.replace(
	      cleanPath(base + '/#' + location)
	    );
	    return true
	  }
	}
	
	function ensureSlash () {
	  var path = getHash();
	  if (path.charAt(0) === '/') {
	    return true
	  }
	  replaceHash('/' + path);
	  return false
	}
	
	function getHash () {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var index = href.indexOf('#');
	  return index === -1 ? '' : href.slice(index + 1)
	}
	
	function getUrl (path) {
	  var href = window.location.href;
	  var i = href.indexOf('#');
	  var base = i >= 0 ? href.slice(0, i) : href;
	  return (base + "#" + path)
	}
	
	function pushHash (path) {
	  if (supportsPushState) {
	    pushState(getUrl(path));
	  } else {
	    window.location.hash = path;
	  }
	}
	
	function replaceHash (path) {
	  if (supportsPushState) {
	    replaceState(getUrl(path));
	  } else {
	    window.location.replace(getUrl(path));
	  }
	}
	
	/*  */
	
	
	var AbstractHistory = (function (History$$1) {
	  function AbstractHistory (router, base) {
	    History$$1.call(this, router, base);
	    this.stack = [];
	    this.index = -1;
	  }
	
	  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
	  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  AbstractHistory.prototype.constructor = AbstractHistory;
	
	  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
	      this$1.index++;
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.go = function go (n) {
	    var this$1 = this;
	
	    var targetIndex = this.index + n;
	    if (targetIndex < 0 || targetIndex >= this.stack.length) {
	      return
	    }
	    var route = this.stack[targetIndex];
	    this.confirmTransition(route, function () {
	      this$1.index = targetIndex;
	      this$1.updateRoute(route);
	    });
	  };
	
	  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    var current = this.stack[this.stack.length - 1];
	    return current ? current.fullPath : '/'
	  };
	
	  AbstractHistory.prototype.ensureURL = function ensureURL () {
	    // noop
	  };
	
	  return AbstractHistory;
	}(History));
	
	/*  */
	
	var VueRouter = function VueRouter (options) {
	  if ( options === void 0 ) options = {};
	
	  this.app = null;
	  this.apps = [];
	  this.options = options;
	  this.beforeHooks = [];
	  this.resolveHooks = [];
	  this.afterHooks = [];
	  this.matcher = createMatcher(options.routes || [], this);
	
	  var mode = options.mode || 'hash';
	  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
	  if (this.fallback) {
	    mode = 'hash';
	  }
	  if (!inBrowser) {
	    mode = 'abstract';
	  }
	  this.mode = mode;
	
	  switch (mode) {
	    case 'history':
	      this.history = new HTML5History(this, options.base);
	      break
	    case 'hash':
	      this.history = new HashHistory(this, options.base, this.fallback);
	      break
	    case 'abstract':
	      this.history = new AbstractHistory(this, options.base);
	      break
	    default:
	      if (false) {
	        assert(false, ("invalid mode: " + mode));
	      }
	  }
	};
	
	var prototypeAccessors = { currentRoute: { configurable: true } };
	
	VueRouter.prototype.match = function match (
	  raw,
	  current,
	  redirectedFrom
	) {
	  return this.matcher.match(raw, current, redirectedFrom)
	};
	
	prototypeAccessors.currentRoute.get = function () {
	  return this.history && this.history.current
	};
	
	VueRouter.prototype.init = function init (app /* Vue component instance */) {
	    var this$1 = this;
	
	  ("production") !== 'production' && assert(
	    install.installed,
	    "not installed. Make sure to call `Vue.use(VueRouter)` " +
	    "before creating root instance."
	  );
	
	  this.apps.push(app);
	
	  // main app already initialized.
	  if (this.app) {
	    return
	  }
	
	  this.app = app;
	
	  var history = this.history;
	
	  if (history instanceof HTML5History) {
	    history.transitionTo(history.getCurrentLocation());
	  } else if (history instanceof HashHistory) {
	    var setupHashListener = function () {
	      history.setupListeners();
	    };
	    history.transitionTo(
	      history.getCurrentLocation(),
	      setupHashListener,
	      setupHashListener
	    );
	  }
	
	  history.listen(function (route) {
	    this$1.apps.forEach(function (app) {
	      app._route = route;
	    });
	  });
	};
	
	VueRouter.prototype.beforeEach = function beforeEach (fn) {
	  return registerHook(this.beforeHooks, fn)
	};
	
	VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
	  return registerHook(this.resolveHooks, fn)
	};
	
	VueRouter.prototype.afterEach = function afterEach (fn) {
	  return registerHook(this.afterHooks, fn)
	};
	
	VueRouter.prototype.onReady = function onReady (cb, errorCb) {
	  this.history.onReady(cb, errorCb);
	};
	
	VueRouter.prototype.onError = function onError (errorCb) {
	  this.history.onError(errorCb);
	};
	
	VueRouter.prototype.push = function push (location, onComplete, onAbort) {
	  this.history.push(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
	  this.history.replace(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.go = function go (n) {
	  this.history.go(n);
	};
	
	VueRouter.prototype.back = function back () {
	  this.go(-1);
	};
	
	VueRouter.prototype.forward = function forward () {
	  this.go(1);
	};
	
	VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
	  var route = to
	    ? to.matched
	      ? to
	      : this.resolve(to).route
	    : this.currentRoute;
	  if (!route) {
	    return []
	  }
	  return [].concat.apply([], route.matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) {
	      return m.components[key]
	    })
	  }))
	};
	
	VueRouter.prototype.resolve = function resolve (
	  to,
	  current,
	  append
	) {
	  var location = normalizeLocation(
	    to,
	    current || this.history.current,
	    append,
	    this
	  );
	  var route = this.match(location, current);
	  var fullPath = route.redirectedFrom || route.fullPath;
	  var base = this.history.base;
	  var href = createHref(base, fullPath, this.mode);
	  return {
	    location: location,
	    route: route,
	    href: href,
	    // for backwards compat
	    normalizedTo: location,
	    resolved: route
	  }
	};
	
	VueRouter.prototype.addRoutes = function addRoutes (routes) {
	  this.matcher.addRoutes(routes);
	  if (this.history.current !== START) {
	    this.history.transitionTo(this.history.getCurrentLocation());
	  }
	};
	
	Object.defineProperties( VueRouter.prototype, prototypeAccessors );
	
	function registerHook (list, fn) {
	  list.push(fn);
	  return function () {
	    var i = list.indexOf(fn);
	    if (i > -1) { list.splice(i, 1); }
	  }
	}
	
	function createHref (base, fullPath, mode) {
	  var path = mode === 'hash' ? '#' + fullPath : fullPath;
	  return base ? cleanPath(base + '/' + path) : path
	}
	
	VueRouter.install = install;
	VueRouter.version = '2.8.1';
	
	if (inBrowser && window.Vue) {
	  window.Vue.use(VueRouter);
	}
	
	module.exports = VueRouter;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Vuex v1.0.1
	 * (c) 2017 Evan You
	 * Released under the MIT License.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Vuex = factory());
	}(this, (function () { 'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	/**
	 * Merge an array of objects into one.
	 *
	 * @param {Array<Object>} arr
	 * @return {Object}
	 */
	
	function mergeObjects(arr) {
	  return arr.reduce(function (prev, obj) {
	    Object.keys(obj).forEach(function (key) {
	      var existing = prev[key];
	      if (existing) {
	        // allow multiple mutation objects to contain duplicate
	        // handlers for the same mutation type
	        if (Array.isArray(existing)) {
	          prev[key] = existing.concat(obj[key]);
	        } else {
	          prev[key] = [existing].concat(obj[key]);
	        }
	      } else {
	        prev[key] = obj[key];
	      }
	    });
	    return prev;
	  }, {});
	}
	
	/**
	 * Deep copy the given object considering circular structure.
	 * This function caches all nested objects and its copies.
	 * If it detects circular structure, use cached copy to avoid infinite loop.
	 *
	 * @param {*} obj
	 * @param {Array<Object>} cache
	 * @return {*}
	 */
	
	
	/**
	 * Check whether the given value is Object or not
	 *
	 * @param {*} obj
	 * @return {Boolean}
	 */
	
	function isObject(obj) {
	  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	}
	
	/**
	 * Get state sub tree by given keys.
	 *
	 * @param {Object} state
	 * @param {Array<String>} nestedKeys
	 * @return {Object}
	 */
	function getNestedState(state, nestedKeys) {
	  return nestedKeys.reduce(function (state, key) {
	    return state[key];
	  }, state);
	}
	
	/**
	 * Hacks to get access to Vue internals.
	 * Maybe we should expose these...
	 */
	
	var Watcher = void 0;
	function getWatcher(vm) {
	  if (!Watcher) {
	    var noop = function noop() {};
	    var unwatch = vm.$watch(noop, noop);
	    Watcher = vm._watchers[0].constructor;
	    unwatch();
	  }
	  return Watcher;
	}
	
	var Dep = void 0;
	function getDep(vm) {
	  if (!Dep) {
	    Dep = vm._data.__ob__.dep.constructor;
	  }
	  return Dep;
	}
	
	var hook = typeof window !== 'undefined' && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	function devtoolPlugin(store) {
	  if (!hook) return;
	
	  hook.emit('vuex:init', store);
	
	  hook.on('vuex:travel-to-state', function (targetState) {
	    store.replaceState(targetState);
	  });
	
	  store.subscribe(function (mutation, state) {
	    hook.emit('vuex:mutation', mutation, state);
	  });
	}
	
	var override = function (Vue) {
	  var version = Number(Vue.version.split('.')[0]);
	
	  if (version >= 2) {
	    var usesInit = Vue.config._lifecycleHooks.indexOf('init') > -1;
	    Vue.mixin(usesInit ? { init: vuexInit } : { beforeCreate: vuexInit });
	  } else {
	    (function () {
	      // override init and inject vuex init procedure
	      // for 1.x backwards compatibility.
	      var _init = Vue.prototype._init;
	      Vue.prototype._init = function () {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        options.init = options.init ? [vuexInit].concat(options.init) : vuexInit;
	        _init.call(this, options);
	      };
	    })();
	  }
	
	  /**
	   * Vuex init hook, injected into each instances init hooks list.
	   */
	
	  function vuexInit() {
	    var options = this.$options;
	    var store = options.store,
	        vuex = options.vuex;
	    // store injection
	
	    if (store) {
	      this.$store = store;
	    } else if (options.parent && options.parent.$store) {
	      this.$store = options.parent.$store;
	    }
	    // vuex option handling
	    if (vuex) {
	      if (!this.$store) {
	        console.warn('[vuex] store not injected. make sure to ' + 'provide the store option in your root component.');
	      }
	      var state = vuex.state,
	          actions = vuex.actions;
	      var getters = vuex.getters;
	      // handle deprecated state option
	
	      if (state && !getters) {
	        console.warn('[vuex] vuex.state option will been deprecated in 1.0. ' + 'Use vuex.getters instead.');
	        getters = state;
	      }
	      // getters
	      if (getters) {
	        options.computed = options.computed || {};
	        for (var key in getters) {
	          defineVuexGetter(this, key, getters[key]);
	        }
	      }
	      // actions
	      if (actions) {
	        options.methods = options.methods || {};
	        for (var _key in actions) {
	          options.methods[_key] = makeBoundAction(this.$store, actions[_key], _key);
	        }
	      }
	    }
	  }
	
	  /**
	   * Setter for all getter properties.
	   */
	
	  function setter() {
	    throw new Error('vuex getter properties are read-only.');
	  }
	
	  /**
	   * Define a Vuex getter on an instance.
	   *
	   * @param {Vue} vm
	   * @param {String} key
	   * @param {Function} getter
	   */
	
	  function defineVuexGetter(vm, key, getter) {
	    if (typeof getter !== 'function') {
	      console.warn('[vuex] Getter bound to key \'vuex.getters.' + key + '\' is not a function.');
	    } else {
	      Object.defineProperty(vm, key, {
	        enumerable: true,
	        configurable: true,
	        get: makeComputedGetter(vm.$store, getter),
	        set: setter
	      });
	    }
	  }
	
	  /**
	   * Make a computed getter, using the same caching mechanism of computed
	   * properties. In addition, it is cached on the raw getter function using
	   * the store's unique cache id. This makes the same getter shared
	   * across all components use the same underlying watcher, and makes
	   * the getter evaluated only once during every flush.
	   *
	   * @param {Store} store
	   * @param {Function} getter
	   */
	
	  function makeComputedGetter(store, getter) {
	    var id = store._getterCacheId;
	
	    // cached
	    if (getter[id]) {
	      return getter[id];
	    }
	    var vm = store._vm;
	    var Watcher = getWatcher(vm);
	    var Dep = getDep(vm);
	    var watcher = new Watcher(vm, function (vm) {
	      return getter(vm.state);
	    }, null, { lazy: true });
	    var computedGetter = function computedGetter() {
	      if (watcher.dirty) {
	        watcher.evaluate();
	      }
	      if (Dep.target) {
	        watcher.depend();
	      }
	      return watcher.value;
	    };
	    getter[id] = computedGetter;
	    return computedGetter;
	  }
	
	  /**
	   * Make a bound-to-store version of a raw action function.
	   *
	   * @param {Store} store
	   * @param {Function} action
	   * @param {String} key
	   */
	
	  function makeBoundAction(store, action, key) {
	    if (typeof action !== 'function') {
	      console.warn('[vuex] Action bound to key \'vuex.actions.' + key + '\' is not a function.');
	    }
	    return function vuexBoundAction() {
	      for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return action.call.apply(action, [this, store].concat(args));
	    };
	  }
	
	  // option merging
	  var merge = Vue.config.optionMergeStrategies.computed;
	  Vue.config.optionMergeStrategies.vuex = function (toVal, fromVal) {
	    if (!toVal) return fromVal;
	    if (!fromVal) return toVal;
	    return {
	      getters: merge(toVal.getters, fromVal.getters),
	      state: merge(toVal.state, fromVal.state),
	      actions: merge(toVal.actions, fromVal.actions)
	    };
	  };
	};
	
	var Vue = void 0;
	var uid = 0;
	
	var Store = function () {
	
	  /**
	   * @param {Object} options
	   *        - {Object} state
	   *        - {Object} actions
	   *        - {Object} mutations
	   *        - {Array} plugins
	   *        - {Boolean} strict
	   */
	
	  function Store() {
	    var _this = this;
	
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$state = _ref.state,
	        state = _ref$state === undefined ? {} : _ref$state,
	        _ref$mutations = _ref.mutations,
	        mutations = _ref$mutations === undefined ? {} : _ref$mutations,
	        _ref$modules = _ref.modules,
	        modules = _ref$modules === undefined ? {} : _ref$modules,
	        _ref$plugins = _ref.plugins,
	        plugins = _ref$plugins === undefined ? [] : _ref$plugins,
	        _ref$strict = _ref.strict,
	        strict = _ref$strict === undefined ? false : _ref$strict;
	
	    classCallCheck(this, Store);
	
	    this._getterCacheId = 'vuex_store_' + uid++;
	    this._dispatching = false;
	    this._rootMutations = this._mutations = mutations;
	    this._modules = modules;
	    this._subscribers = [];
	    // bind dispatch to self
	    var dispatch = this.dispatch;
	    this.dispatch = function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      dispatch.apply(_this, args);
	    };
	    // use a Vue instance to store the state tree
	    // suppress warnings just in case the user has added
	    // some funky global mixins
	    if (!Vue) {
	      throw new Error('[vuex] must call Vue.use(Vuex) before creating a store instance.');
	    }
	    var silent = Vue.config.silent;
	    Vue.config.silent = true;
	    this._vm = new Vue({
	      data: {
	        state: state
	      }
	    });
	    Vue.config.silent = silent;
	    this._setupModuleState(state, modules);
	    this._setupModuleMutations(modules);
	    // add extra warnings in strict mode
	    if (strict) {
	      this._setupMutationCheck();
	    }
	    // apply plugins
	    devtoolPlugin(this);
	    plugins.forEach(function (plugin) {
	      return plugin(_this);
	    });
	  }
	
	  /**
	   * Getter for the entire state tree.
	   * Read only.
	   *
	   * @return {Object}
	   */
	
	  createClass(Store, [{
	    key: 'replaceState',
	
	
	    /**
	     * Replace root state.
	     *
	     * @param {Object} state
	     */
	
	    value: function replaceState(state) {
	      this._dispatching = true;
	      this._vm.state = state;
	      this._dispatching = false;
	    }
	
	    /**
	     * Dispatch an action.
	     *
	     * @param {String} type
	     */
	
	  }, {
	    key: 'dispatch',
	    value: function dispatch(type) {
	      var _this2 = this;
	
	      for (var _len2 = arguments.length, payload = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        payload[_key2 - 1] = arguments[_key2];
	      }
	
	      var silent = false;
	      var isObjectStyleDispatch = false;
	      // compatibility for object actions, e.g. FSA
	      if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object' && type.type && arguments.length === 1) {
	        isObjectStyleDispatch = true;
	        payload = type;
	        if (type.silent) silent = true;
	        type = type.type;
	      }
	      var handler = this._mutations[type];
	      var state = this.state;
	      if (handler) {
	        this._dispatching = true;
	        // apply the mutation
	        if (Array.isArray(handler)) {
	          handler.forEach(function (h) {
	            isObjectStyleDispatch ? h(state, payload) : h.apply(undefined, [state].concat(toConsumableArray(payload)));
	          });
	        } else {
	          isObjectStyleDispatch ? handler(state, payload) : handler.apply(undefined, [state].concat(toConsumableArray(payload)));
	        }
	        this._dispatching = false;
	        if (!silent) {
	          (function () {
	            var mutation = isObjectStyleDispatch ? payload : { type: type, payload: payload };
	            _this2._subscribers.forEach(function (sub) {
	              return sub(mutation, state);
	            });
	          })();
	        }
	      } else {
	        console.warn('[vuex] Unknown mutation: ' + type);
	      }
	    }
	
	    /**
	     * Watch state changes on the store.
	     * Same API as Vue's $watch, except when watching a function,
	     * the function gets the state as the first argument.
	     *
	     * @param {Function} fn
	     * @param {Function} cb
	     * @param {Object} [options]
	     */
	
	  }, {
	    key: 'watch',
	    value: function watch(fn, cb, options) {
	      var _this3 = this;
	
	      if (typeof fn !== 'function') {
	        console.error('Vuex store.watch only accepts function.');
	        return;
	      }
	      return this._vm.$watch(function () {
	        return fn(_this3.state);
	      }, cb, options);
	    }
	
	    /**
	     * Subscribe to state changes. Fires after every mutation.
	     */
	
	  }, {
	    key: 'subscribe',
	    value: function subscribe(fn) {
	      var subs = this._subscribers;
	      if (subs.indexOf(fn) < 0) {
	        subs.push(fn);
	      }
	      return function () {
	        var i = subs.indexOf(fn);
	        if (i > -1) {
	          subs.splice(i, 1);
	        }
	      };
	    }
	
	    /**
	     * Hot update mutations & modules.
	     *
	     * @param {Object} options
	     *        - {Object} [mutations]
	     *        - {Object} [modules]
	     */
	
	  }, {
	    key: 'hotUpdate',
	    value: function hotUpdate() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          mutations = _ref2.mutations,
	          modules = _ref2.modules;
	
	      this._rootMutations = this._mutations = mutations || this._rootMutations;
	      this._setupModuleMutations(modules || this._modules);
	    }
	
	    /**
	     * Attach sub state tree of each module to the root tree.
	     *
	     * @param {Object} state
	     * @param {Object} modules
	     */
	
	  }, {
	    key: '_setupModuleState',
	    value: function _setupModuleState(state, modules) {
	      var _this4 = this;
	
	      if (!isObject(modules)) return;
	
	      Object.keys(modules).forEach(function (key) {
	        var module = modules[key];
	
	        // set this module's state
	        Vue.set(state, key, module.state || {});
	
	        // retrieve nested modules
	        _this4._setupModuleState(state[key], module.modules);
	      });
	    }
	
	    /**
	     * Bind mutations for each module to its sub tree and
	     * merge them all into one final mutations map.
	     *
	     * @param {Object} updatedModules
	     */
	
	  }, {
	    key: '_setupModuleMutations',
	    value: function _setupModuleMutations(updatedModules) {
	      var modules = this._modules;
	      Object.keys(updatedModules).forEach(function (key) {
	        modules[key] = updatedModules[key];
	      });
	      var updatedMutations = this._createModuleMutations(modules, []);
	      this._mutations = mergeObjects([this._rootMutations].concat(toConsumableArray(updatedMutations)));
	    }
	
	    /**
	     * Helper method for _setupModuleMutations.
	     * The method retrieve nested sub modules and
	     * bind each mutations to its sub tree recursively.
	     *
	     * @param {Object} modules
	     * @param {Array<String>} nestedKeys
	     * @return {Array<Object>}
	     */
	
	  }, {
	    key: '_createModuleMutations',
	    value: function _createModuleMutations(modules, nestedKeys) {
	      var _this5 = this;
	
	      if (!isObject(modules)) return [];
	
	      return Object.keys(modules).map(function (key) {
	        var module = modules[key];
	        var newNestedKeys = nestedKeys.concat(key);
	
	        // retrieve nested modules
	        var nestedMutations = _this5._createModuleMutations(module.modules, newNestedKeys);
	
	        if (!module || !module.mutations) {
	          return mergeObjects(nestedMutations);
	        }
	
	        // bind mutations to sub state tree
	        var mutations = {};
	        Object.keys(module.mutations).forEach(function (name) {
	          var original = module.mutations[name];
	          mutations[name] = function (state) {
	            for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	              args[_key3 - 1] = arguments[_key3];
	            }
	
	            original.apply(undefined, [getNestedState(state, newNestedKeys)].concat(args));
	          };
	        });
	
	        // merge mutations of this module and nested modules
	        return mergeObjects([mutations].concat(toConsumableArray(nestedMutations)));
	      });
	    }
	
	    /**
	     * Setup mutation check: if the Vuex instance's state is mutated
	     * outside of a mutation handler, we throw en error. This effectively
	     * enforces all mutations to the state to be trackable and hot-reloadable.
	     * However, this comes at a run time cost since we are doing a deep
	     * watch on the entire state tree, so it is only enabled if the
	     * strict option is set to true.
	     */
	
	  }, {
	    key: '_setupMutationCheck',
	    value: function _setupMutationCheck() {
	      var _this6 = this;
	
	      var Watcher = getWatcher(this._vm);
	      /* eslint-disable no-new */
	      new Watcher(this._vm, 'state', function () {
	        if (!_this6._dispatching) {
	          throw new Error('[vuex] Do not mutate vuex store state outside mutation handlers.');
	        }
	      }, { deep: true, sync: true });
	      /* eslint-enable no-new */
	    }
	  }, {
	    key: 'state',
	    get: function get$$1() {
	      return this._vm.state;
	    },
	    set: function set$$1(v) {
	      throw new Error('[vuex] Use store.replaceState() to explicit replace store state.');
	    }
	  }]);
	  return Store;
	}();
	
	function install(_Vue) {
	  if (Vue) {
	    console.warn('[vuex] already installed. Vue.use(Vuex) should be called only once.');
	    return;
	  }
	  Vue = _Vue;
	  override(Vue);
	}
	
	// auto install in dist mode
	if (typeof window !== 'undefined' && window.Vue) {
	  install(window.Vue);
	}
	
	var index = {
	  Store: Store,
	  install: install
	};
	
	return index;
	
	})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(67);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _util = __webpack_require__(11);
	
	var _validator = __webpack_require__(190);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _messages2 = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Encapsulates a validation schema.
	 *
	 *  @param descriptor An object declaring validation rules
	 *  for this schema.
	 */
	function Schema(descriptor) {
	  this.rules = null;
	  this._messages = _messages2.messages;
	  this.define(descriptor);
	}
	
	Schema.prototype = {
	  messages: function messages(_messages) {
	    if (_messages) {
	      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
	    }
	    return this._messages;
	  },
	  define: function define(rules) {
	    if (!rules) {
	      throw new Error('Cannot configure a schema with no rules');
	    }
	    if ((typeof rules === 'undefined' ? 'undefined' : (0, _typeof3['default'])(rules)) !== 'object' || Array.isArray(rules)) {
	      throw new Error('Rules must be an object');
	    }
	    this.rules = {};
	    var z = void 0;
	    var item = void 0;
	    for (z in rules) {
	      if (rules.hasOwnProperty(z)) {
	        item = rules[z];
	        this.rules[z] = Array.isArray(item) ? item : [item];
	      }
	    }
	  },
	  validate: function validate(source_) {
	    var _this = this;
	
	    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var oc = arguments[2];
	
	    var source = source_;
	    var options = o;
	    var callback = oc;
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    if (!this.rules || Object.keys(this.rules).length === 0) {
	      if (callback) {
	        callback();
	      }
	      return;
	    }
	    function complete(results) {
	      var i = void 0;
	      var field = void 0;
	      var errors = [];
	      var fields = {};
	
	      function add(e) {
	        if (Array.isArray(e)) {
	          errors = errors.concat.apply(errors, e);
	        } else {
	          errors.push(e);
	        }
	      }
	
	      for (i = 0; i < results.length; i++) {
	        add(results[i]);
	      }
	      if (!errors.length) {
	        errors = null;
	        fields = null;
	      } else {
	        for (i = 0; i < errors.length; i++) {
	          field = errors[i].field;
	          fields[field] = fields[field] || [];
	          fields[field].push(errors[i]);
	        }
	      }
	      callback(errors, fields);
	    }
	
	    if (options.messages) {
	      var messages = this.messages();
	      if (messages === _messages2.messages) {
	        messages = (0, _messages2.newMessages)();
	      }
	      (0, _util.deepMerge)(messages, options.messages);
	      options.messages = messages;
	    } else {
	      options.messages = this.messages();
	    }
	    var arr = void 0;
	    var value = void 0;
	    var series = {};
	    var keys = options.keys || Object.keys(this.rules);
	    keys.forEach(function (z) {
	      arr = _this.rules[z];
	      value = source[z];
	      arr.forEach(function (r) {
	        var rule = r;
	        if (typeof rule.transform === 'function') {
	          if (source === source_) {
	            source = (0, _extends3['default'])({}, source);
	          }
	          value = source[z] = rule.transform(value);
	        }
	        if (typeof rule === 'function') {
	          rule = {
	            validator: rule
	          };
	        } else {
	          rule = (0, _extends3['default'])({}, rule);
	        }
	        rule.validator = _this.getValidationMethod(rule);
	        rule.field = z;
	        rule.fullField = rule.fullField || z;
	        rule.type = _this.getType(rule);
	        if (!rule.validator) {
	          return;
	        }
	        series[z] = series[z] || [];
	        series[z].push({
	          rule: rule,
	          value: value,
	          source: source,
	          field: z
	        });
	      });
	    });
	    var errorFields = {};
	    (0, _util.asyncMap)(series, options, function (data, doIt) {
	      var rule = data.rule;
	      var deep = (rule.type === 'object' || rule.type === 'array') && ((0, _typeof3['default'])(rule.fields) === 'object' || (0, _typeof3['default'])(rule.defaultField) === 'object');
	      deep = deep && (rule.required || !rule.required && data.value);
	      rule.field = data.field;
	      function addFullfield(key, schema) {
	        return (0, _extends3['default'])({}, schema, {
	          fullField: rule.fullField + '.' + key
	        });
	      }
	
	      function cb() {
	        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        var errors = e;
	        if (!Array.isArray(errors)) {
	          errors = [errors];
	        }
	        if (errors.length) {
	          (0, _util.warning)('async-validator:', errors);
	        }
	        if (errors.length && rule.message) {
	          errors = [].concat(rule.message);
	        }
	
	        errors = errors.map((0, _util.complementError)(rule));
	
	        if (options.first && errors.length) {
	          errorFields[rule.field] = 1;
	          return doIt(errors);
	        }
	        if (!deep) {
	          doIt(errors);
	        } else {
	          // if rule is required but the target object
	          // does not exist fail at the rule level and don't
	          // go deeper
	          if (rule.required && !data.value) {
	            if (rule.message) {
	              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
	            } else if (options.error) {
	              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
	            } else {
	              errors = [];
	            }
	            return doIt(errors);
	          }
	
	          var fieldsSchema = {};
	          if (rule.defaultField) {
	            for (var k in data.value) {
	              if (data.value.hasOwnProperty(k)) {
	                fieldsSchema[k] = rule.defaultField;
	              }
	            }
	          }
	          fieldsSchema = (0, _extends3['default'])({}, fieldsSchema, data.rule.fields);
	          for (var f in fieldsSchema) {
	            if (fieldsSchema.hasOwnProperty(f)) {
	              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
	              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
	            }
	          }
	          var schema = new Schema(fieldsSchema);
	          schema.messages(options.messages);
	          if (data.rule.options) {
	            data.rule.options.messages = options.messages;
	            data.rule.options.error = options.error;
	          }
	          schema.validate(data.value, data.rule.options || options, function (errs) {
	            doIt(errs && errs.length ? errors.concat(errs) : errs);
	          });
	        }
	      }
	
	      var res = rule.validator(rule, data.value, cb, data.source, options);
	      if (res && res.then) {
	        res.then(function () {
	          return cb();
	        }, function (e) {
	          return cb(e);
	        });
	      }
	    }, function (results) {
	      complete(results);
	    });
	  },
	  getType: function getType(rule) {
	    if (rule.type === undefined && rule.pattern instanceof RegExp) {
	      rule.type = 'pattern';
	    }
	    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
	      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
	    }
	    return rule.type || 'string';
	  },
	  getValidationMethod: function getValidationMethod(rule) {
	    if (typeof rule.validator === 'function') {
	      return rule.validator;
	    }
	    var keys = Object.keys(rule);
	    var messageIndex = keys.indexOf('message');
	    if (messageIndex !== -1) {
	      keys.splice(messageIndex, 1);
	    }
	    if (keys.length === 1 && keys[0] === 'required') {
	      return _validator2['default'].required;
	    }
	    return _validator2['default'][this.getType(rule)] || false;
	  }
	};
	
	Schema.register = function register(type, validator) {
	  if (typeof validator !== 'function') {
	    throw new Error('Cannot register a validator by type, validator is not a function');
	  }
	  _validator2['default'][type] = validator;
	};
	
	Schema.messages = _messages2.messages;
	
	exports['default'] = Schema;
	module.exports = exports['default'];

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.newMessages = newMessages;
	function newMessages() {
	  return {
	    'default': 'Validation error on field %s',
	    required: '%s is required',
	    'enum': '%s must be one of %s',
	    whitespace: '%s cannot be empty',
	    date: {
	      format: '%s date %s is invalid for format %s',
	      parse: '%s date could not be parsed, %s is invalid ',
	      invalid: '%s date %s is invalid'
	    },
	    types: {
	      string: '%s is not a %s',
	      method: '%s is not a %s (function)',
	      array: '%s is not an %s',
	      object: '%s is not an %s',
	      number: '%s is not a %s',
	      date: '%s is not a %s',
	      boolean: '%s is not a %s',
	      integer: '%s is not an %s',
	      float: '%s is not a %s',
	      regexp: '%s is not a valid %s',
	      email: '%s is not a valid %s',
	      url: '%s is not a valid %s',
	      hex: '%s is not a valid %s'
	    },
	    string: {
	      len: '%s must be exactly %s characters',
	      min: '%s must be at least %s characters',
	      max: '%s cannot be longer than %s characters',
	      range: '%s must be between %s and %s characters'
	    },
	    number: {
	      len: '%s must equal %s',
	      min: '%s cannot be less than %s',
	      max: '%s cannot be greater than %s',
	      range: '%s must be between %s and %s'
	    },
	    array: {
	      len: '%s must be exactly %s in length',
	      min: '%s cannot be less than %s in length',
	      max: '%s cannot be greater than %s in length',
	      range: '%s must be between %s and %s in length'
	    },
	    pattern: {
	      mismatch: '%s value %s does not match pattern %s'
	    },
	    clone: function clone() {
	      var cloned = JSON.parse(JSON.stringify(this));
	      cloned.clone = this.clone;
	      return cloned;
	    }
	  };
	}
	
	var messages = exports.messages = newMessages();

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(11);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var ENUM = 'enum';
	
	/**
	 *  Rule for validating a value exists in an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, source, errors, options) {
	  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
	  if (rule[ENUM].indexOf(value) === -1) {
	    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
	  }
	}
	
	exports['default'] = enumerable;
	module.exports = exports['default'];

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(11);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating a regular expression pattern.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, source, errors, options) {
	  if (rule.pattern) {
	    if (rule.pattern instanceof RegExp) {
	      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
	      // flag is accidentally set to `true`, which in a validation scenario
	      // is not necessary and the result might be misleading
	      rule.pattern.lastIndex = 0;
	      if (!rule.pattern.test(value)) {
	        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
	      }
	    } else if (typeof rule.pattern === 'string') {
	      var _pattern = new RegExp(rule.pattern);
	      if (!_pattern.test(value)) {
	        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
	      }
	    }
	  }
	}
	
	exports['default'] = pattern;
	module.exports = exports['default'];

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(11);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating minimum and maximum allowed values.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function range(rule, value, source, errors, options) {
	  var len = typeof rule.len === 'number';
	  var min = typeof rule.min === 'number';
	  var max = typeof rule.max === 'number';
	  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
	  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	  var val = value;
	  var key = null;
	  var num = typeof value === 'number';
	  var str = typeof value === 'string';
	  var arr = Array.isArray(value);
	  if (num) {
	    key = 'number';
	  } else if (str) {
	    key = 'string';
	  } else if (arr) {
	    key = 'array';
	  }
	  // if the value is not of a supported type for range validation
	  // the validation rule rule should use the
	  // type property to also test for a particular type
	  if (!key) {
	    return false;
	  }
	  if (arr) {
	    val = value.length;
	  }
	  if (str) {
	    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
	    val = value.replace(spRegexp, '_').length;
	  }
	  if (len) {
	    if (val !== rule.len) {
	      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
	    }
	  } else if (min && !max && val < rule.min) {
	    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
	  } else if (max && !min && val > rule.max) {
	    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
	  } else if (min && max && (val < rule.min || val > rule.max)) {
	    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
	  }
	}
	
	exports['default'] = range;
	module.exports = exports['default'];

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _util = __webpack_require__(11);
	
	var util = _interopRequireWildcard(_util);
	
	var _required = __webpack_require__(102);
	
	var _required2 = _interopRequireDefault(_required);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint max-len:0 */
	
	var pattern = {
	  // http://emailregex.com/
	  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
	  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
	};
	
	var types = {
	  integer: function integer(value) {
	    return types.number(value) && parseInt(value, 10) === value;
	  },
	  float: function float(value) {
	    return types.number(value) && !types.integer(value);
	  },
	  array: function array(value) {
	    return Array.isArray(value);
	  },
	  regexp: function regexp(value) {
	    if (value instanceof RegExp) {
	      return true;
	    }
	    try {
	      return !!new RegExp(value);
	    } catch (e) {
	      return false;
	    }
	  },
	  date: function date(value) {
	    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
	  },
	  number: function number(value) {
	    if (isNaN(value)) {
	      return false;
	    }
	    return typeof value === 'number';
	  },
	  object: function object(value) {
	    return (typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) === 'object' && !types.array(value);
	  },
	  method: function method(value) {
	    return typeof value === 'function';
	  },
	  email: function email(value) {
	    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
	  },
	  url: function url(value) {
	    return typeof value === 'string' && !!value.match(pattern.url);
	  },
	  hex: function hex(value) {
	    return typeof value === 'string' && !!value.match(pattern.hex);
	  }
	};
	
	/**
	 *  Rule for validating the type of a value.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function type(rule, value, source, errors, options) {
	  if (rule.required && value === undefined) {
	    (0, _required2['default'])(rule, value, source, errors, options);
	    return;
	  }
	  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
	  var ruleType = rule.type;
	  if (custom.indexOf(ruleType) > -1) {
	    if (!types[ruleType](value)) {
	      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	    }
	    // straight typeof check
	  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) !== rule.type) {
	    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	  }
	}
	
	exports['default'] = type;
	module.exports = exports['default'];

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(11);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating whitespace.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function whitespace(rule, value, source, errors, options) {
	  if (/^\s+$/.test(value) || value === '') {
	    errors.push(util.format(options.messages.whitespace, rule.fullField));
	  }
	}
	
	exports['default'] = whitespace;
	module.exports = exports['default'];

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates an array.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function array(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, 'array');
	    if (!(0, _util.isEmptyValue)(value, 'array')) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = array;
	module.exports = exports['default'];

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(11);
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a boolean.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function boolean(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = boolean;
	module.exports = exports['default'];

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function date(rule, value, callback, source, options) {
	  // console.log('integer rule called %j', rule);
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  // console.log('validate on %s value', value);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      var dateObject = void 0;
	
	      if (typeof value === 'number') {
	        dateObject = new Date(value);
	      } else {
	        dateObject = value;
	      }
	
	      _rule2['default'].type(rule, dateObject, source, errors, options);
	      if (dateObject) {
	        _rule2['default'].range(rule, dateObject.getTime(), source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = date;
	module.exports = exports['default'];

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ENUM = 'enum';
	
	/**
	 *  Validates an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value) {
	      _rule2['default'][ENUM](rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = enumerable;
	module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number is a floating point number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function floatFn(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = floatFn;
	module.exports = exports['default'];

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _string = __webpack_require__(198);
	
	var _string2 = _interopRequireDefault(_string);
	
	var _method = __webpack_require__(192);
	
	var _method2 = _interopRequireDefault(_method);
	
	var _number = __webpack_require__(193);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _boolean = __webpack_require__(186);
	
	var _boolean2 = _interopRequireDefault(_boolean);
	
	var _regexp = __webpack_require__(196);
	
	var _regexp2 = _interopRequireDefault(_regexp);
	
	var _integer = __webpack_require__(191);
	
	var _integer2 = _interopRequireDefault(_integer);
	
	var _float = __webpack_require__(189);
	
	var _float2 = _interopRequireDefault(_float);
	
	var _array = __webpack_require__(185);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _object = __webpack_require__(194);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _enum = __webpack_require__(188);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	var _pattern = __webpack_require__(195);
	
	var _pattern2 = _interopRequireDefault(_pattern);
	
	var _date = __webpack_require__(187);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _required = __webpack_require__(197);
	
	var _required2 = _interopRequireDefault(_required);
	
	var _type = __webpack_require__(199);
	
	var _type2 = _interopRequireDefault(_type);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  string: _string2['default'],
	  method: _method2['default'],
	  number: _number2['default'],
	  boolean: _boolean2['default'],
	  regexp: _regexp2['default'],
	  integer: _integer2['default'],
	  float: _float2['default'],
	  array: _array2['default'],
	  object: _object2['default'],
	  'enum': _enum2['default'],
	  pattern: _pattern2['default'],
	  date: _date2['default'],
	  url: _type2['default'],
	  hex: _type2['default'],
	  email: _type2['default'],
	  required: _required2['default']
	};
	module.exports = exports['default'];

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number is an integer.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function integer(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = integer;
	module.exports = exports['default'];

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a function.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function method(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = method;
	module.exports = exports['default'];

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function number(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = number;
	module.exports = exports['default'];

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates an object.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function object(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = object;
	module.exports = exports['default'];

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a regular expression pattern.
	 *
	 *  Performs validation when a rule only contains
	 *  a pattern property but is not declared as a string type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2['default'].pattern(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = pattern;
	module.exports = exports['default'];

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates the regular expression type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function regexp(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = regexp;
	module.exports = exports['default'];

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function required(rule, value, callback, source, options) {
	  var errors = [];
	  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value);
	  _rule2['default'].required(rule, value, source, errors, options, type);
	  callback(errors);
	}
	
	exports['default'] = required;
	module.exports = exports['default'];

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Performs validation for string types.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function string(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, 'string');
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	      _rule2['default'].pattern(rule, value, source, errors, options);
	      if (rule.whitespace === true) {
	        _rule2['default'].whitespace(rule, value, source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = string;
	module.exports = exports['default'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(12);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function type(rule, value, callback, source, options) {
	  var ruleType = rule.type;
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, ruleType);
	    if (!(0, _util.isEmptyValue)(value, ruleType)) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = type;
	module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(201);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	var bind = __webpack_require__(107);
	var Axios = __webpack_require__(203);
	var defaults = __webpack_require__(66);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(104);
	axios.CancelToken = __webpack_require__(202);
	axios.isCancel = __webpack_require__(105);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(217);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(104);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(66);
	var utils = __webpack_require__(16);
	var InterceptorManager = __webpack_require__(204);
	var dispatchRequest = __webpack_require__(205);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	var transformData = __webpack_require__(208);
	var isCancel = __webpack_require__(105);
	var defaults = __webpack_require__(66);
	var isAbsoluteURL = __webpack_require__(213);
	var combineURLs = __webpack_require__(211);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(106);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 209 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 211 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 213 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var objectAssign = __webpack_require__(403);
	
	function getTarget(node) {
	  if (node === void 0) {
	    return document.body;
	  }
	
	  if (typeof node === 'string' && node.indexOf('?') === 0) {
	    return document.body;
	  } else if (typeof node === 'string' && node.indexOf('?') > 0) {
	    node = node.split('?')[0];
	  }
	
	  if (node === 'body' || node === true) {
	    return document.body;
	  }
	
	  return node instanceof window.Node ? node : document.querySelector(node);
	}
	
	function getShouldUpdate(node) {
	  if (!node) {
	    return false;
	  }
	  if (typeof node === 'string' && node.indexOf('?') > 0) {
	    try {
	      var config = JSON.parse(node.split('?')[1]);
	      return config.autoUpdate || false;
	    } catch (e) {
	      return false;
	    }
	  }
	  return false;
	}
	
	var directive = {
	  inserted: function inserted(el, _ref, vnode) {
	    var value = _ref.value;
	
	    el.className = el.className ? el.className + ' v-transfer-dom' : 'v-transfer-dom';
	    var parentNode = el.parentNode;
	    var home = document.createComment('');
	    var hasMovedOut = false;
	
	    if (value !== false) {
	      parentNode.replaceChild(home, el);
	      getTarget(value).appendChild(el);
	      hasMovedOut = true;
	    }
	    if (!el.__transferDomData) {
	      el.__transferDomData = {
	        parentNode: parentNode,
	        home: home,
	        target: getTarget(value),
	        hasMovedOut: hasMovedOut
	      };
	    }
	  },
	  componentUpdated: function componentUpdated(el, _ref2) {
	    var value = _ref2.value;
	
	    var shouldUpdate = getShouldUpdate(value);
	    if (!shouldUpdate) {
	      return;
	    }
	
	    var ref$1 = el.__transferDomData;
	
	    var parentNode = ref$1.parentNode;
	    var home = ref$1.home;
	    var hasMovedOut = ref$1.hasMovedOut;
	
	    if (!hasMovedOut && value) {
	      parentNode.replaceChild(home, el);
	
	      getTarget(value).appendChild(el);
	      el.__transferDomData = objectAssign({}, el.__transferDomData, { hasMovedOut: true, target: getTarget(value) });
	    } else if (hasMovedOut && value === false) {
	      parentNode.replaceChild(el, home);
	      el.__transferDomData = objectAssign({}, el.__transferDomData, { hasMovedOut: false, target: getTarget(value) });
	    } else if (value) {
	      getTarget(value).appendChild(el);
	    }
	  },
	
	  unbind: function unbind(el, binding) {
	    el.className = el.className.replace('v-transfer-dom', '');
	    if (el.__transferDomData && el.__transferDomData.hasMovedOut === true) {
	      el.__transferDomData.parentNode && el.__transferDomData.parentNode.appendChild(el);
	    }
	    el.__transferDomData = null;
	  }
	};
	
	exports.default = directive;
	module.exports = exports['default'];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(230), __esModule: true };

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(231), __esModule: true };

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(232), __esModule: true };

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(233), __esModule: true };

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(234), __esModule: true };

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(225);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(261);
	module.exports = __webpack_require__(20).Object.assign;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(262);
	var $Object = __webpack_require__(20).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(127);
	__webpack_require__(128);
	__webpack_require__(129);
	__webpack_require__(263);
	__webpack_require__(265);
	__webpack_require__(266);
	module.exports = __webpack_require__(20).Promise;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(264);
	__webpack_require__(127);
	__webpack_require__(267);
	__webpack_require__(268);
	module.exports = __webpack_require__(20).Symbol;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(128);
	__webpack_require__(129);
	module.exports = __webpack_require__(78).f('iterator');


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 236 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(32);
	var toLength = __webpack_require__(125);
	var toAbsoluteIndex = __webpack_require__(258);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(44);
	var gOPS = __webpack_require__(72);
	var pIE = __webpack_require__(52);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(50);
	var call = __webpack_require__(243);
	var isArrayIter = __webpack_require__(241);
	var anObject = __webpack_require__(28);
	var toLength = __webpack_require__(125);
	var getIterFn = __webpack_require__(259);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 240 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(43);
	var ITERATOR = __webpack_require__(14)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(40);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(28);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(117);
	var descriptor = __webpack_require__(53);
	var setToStringTag = __webpack_require__(54);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(31)(IteratorPrototype, __webpack_require__(14)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(14)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 246 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(44);
	var toIObject = __webpack_require__(32);
	module.exports = function (object, el) {
	  var O = toIObject(object);
	  var keys = getKeys(O);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) if (O[key = keys[index++]] === el) return key;
	};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(55)('meta');
	var isObject = __webpack_require__(42);
	var has = __webpack_require__(30);
	var setDesc = __webpack_require__(26).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(41)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var macrotask = __webpack_require__(124).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(40)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if (Observer) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(44);
	var gOPS = __webpack_require__(72);
	var pIE = __webpack_require__(52);
	var toObject = __webpack_require__(126);
	var IObject = __webpack_require__(115);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(41)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(26);
	var anObject = __webpack_require__(28);
	var getKeys = __webpack_require__(44);
	
	module.exports = __webpack_require__(25) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(52);
	var createDesc = __webpack_require__(53);
	var toIObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(76);
	var has = __webpack_require__(30);
	var IE8_DOM_DEFINE = __webpack_require__(114);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(25) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(32);
	var gOPN = __webpack_require__(118).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(30);
	var toObject = __webpack_require__(126);
	var IE_PROTO = __webpack_require__(73)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(31);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(13);
	var core = __webpack_require__(20);
	var dP = __webpack_require__(26);
	var DESCRIPTORS = __webpack_require__(25);
	var SPECIES = __webpack_require__(14)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(75);
	var defined = __webpack_require__(68);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(75);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(112);
	var ITERATOR = __webpack_require__(14)('iterator');
	var Iterators = __webpack_require__(43);
	module.exports = __webpack_require__(20).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(235);
	var step = __webpack_require__(246);
	var Iterators = __webpack_require__(43);
	var toIObject = __webpack_require__(32);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(116)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(29);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(250) });


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(29);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(25), 'Object', { defineProperty: __webpack_require__(26).f });


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(51);
	var global = __webpack_require__(13);
	var ctx = __webpack_require__(50);
	var classof = __webpack_require__(112);
	var $export = __webpack_require__(29);
	var isObject = __webpack_require__(42);
	var aFunction = __webpack_require__(49);
	var anInstance = __webpack_require__(236);
	var forOf = __webpack_require__(239);
	var speciesConstructor = __webpack_require__(123);
	var task = __webpack_require__(124).set;
	var microtask = __webpack_require__(249)();
	var newPromiseCapabilityModule = __webpack_require__(71);
	var perform = __webpack_require__(120);
	var promiseResolve = __webpack_require__(121);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(14)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var sameConstructor = LIBRARY ? function (a, b) {
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	} : function (a, b) {
	  return a === b;
	};
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  if (promise._h == 1) return false;
	  var chain = promise._a || promise._c;
	  var i = 0;
	  var reaction;
	  while (chain.length > i) {
	    reaction = chain[i++];
	    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
	  } return true;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(255)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return sameConstructor($Promise, C)
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(54)($Promise, PROMISE);
	__webpack_require__(256)(PROMISE);
	Wrapper = __webpack_require__(20)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if (x instanceof $Promise && sameConstructor(x.constructor, this)) return x;
	    return promiseResolve(this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(245)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(13);
	var has = __webpack_require__(30);
	var DESCRIPTORS = __webpack_require__(25);
	var $export = __webpack_require__(29);
	var redefine = __webpack_require__(122);
	var META = __webpack_require__(248).KEY;
	var $fails = __webpack_require__(41);
	var shared = __webpack_require__(74);
	var setToStringTag = __webpack_require__(54);
	var uid = __webpack_require__(55);
	var wks = __webpack_require__(14);
	var wksExt = __webpack_require__(78);
	var wksDefine = __webpack_require__(77);
	var keyOf = __webpack_require__(247);
	var enumKeys = __webpack_require__(238);
	var isArray = __webpack_require__(242);
	var anObject = __webpack_require__(28);
	var toIObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(76);
	var createDesc = __webpack_require__(53);
	var _create = __webpack_require__(117);
	var gOPNExt = __webpack_require__(253);
	var $GOPD = __webpack_require__(252);
	var $DP = __webpack_require__(26);
	var $keys = __webpack_require__(44);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(118).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(52).f = $propertyIsEnumerable;
	  __webpack_require__(72).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(51)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key) {
	    if (isSymbol(key)) return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(31)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(29);
	var core = __webpack_require__(20);
	var global = __webpack_require__(13);
	var speciesConstructor = __webpack_require__(123);
	var promiseResolve = __webpack_require__(121);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(29);
	var newPromiseCapability = __webpack_require__(71);
	var perform = __webpack_require__(120);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(77)('asyncIterator');


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(77)('observable');


/***/ }),
/* 269 */
/***/ (function(module, exports) {

	'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function(key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function(key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var sourceIsArray = Array.isArray(source);
	    var targetIsArray = Array.isArray(target);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
	    if (!sourceAndTargetTypesMatch) {
	        return cloneIfNecessary(source, optionsArgument)
	    } else if (sourceIsArray) {
	        var arrayMerge = options.arrayMerge || defaultArrayMerge;
	        return arrayMerge(target, source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	var deepmerge_1 = deepmerge;
	
	module.exports = deepmerge_1;


/***/ }),
/* 270 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 99);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 99:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-button-group" }, [_vm._t("default")], 2)
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var button_groupvue_type_script_lang_js_ = ({
	  name: 'ElButtonGroup'
	});
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_button_groupvue_type_script_lang_js_ = (button_groupvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_button_groupvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/button/src/button-group.vue"
	/* harmony default export */ var button_group = (component.exports);
	// CONCATENATED MODULE: ./packages/button-group/index.js
	
	
	/* istanbul ignore next */
	button_group.install = function (Vue) {
	  Vue.component(button_group.name, button_group);
	};
	
	/* harmony default export */ var packages_button_group = __webpack_exports__["default"] = (button_group);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 97);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 97:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "button",
	    {
	      staticClass: "el-button",
	      class: [
	        _vm.type ? "el-button--" + _vm.type : "",
	        _vm.buttonSize ? "el-button--" + _vm.buttonSize : "",
	        {
	          "is-disabled": _vm.buttonDisabled,
	          "is-loading": _vm.loading,
	          "is-plain": _vm.plain,
	          "is-round": _vm.round,
	          "is-circle": _vm.circle
	        }
	      ],
	      attrs: {
	        disabled: _vm.buttonDisabled || _vm.loading,
	        autofocus: _vm.autofocus,
	        type: _vm.nativeType
	      },
	      on: { click: _vm.handleClick }
	    },
	    [
	      _vm.loading ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(),
	      _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(),
	      _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
	  name: 'ElButton',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    size: String,
	    icon: {
	      type: String,
	      default: ''
	    },
	    nativeType: {
	      type: String,
	      default: 'button'
	    },
	    loading: Boolean,
	    disabled: Boolean,
	    plain: Boolean,
	    autofocus: Boolean,
	    round: Boolean,
	    circle: Boolean
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    buttonSize: function buttonSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    buttonDisabled: function buttonDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(evt) {
	      this.$emit('click', evt);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/button/src/button.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_buttonvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/button/src/button.vue"
	/* harmony default export */ var src_button = (component.exports);
	// CONCATENATED MODULE: ./packages/button/index.js
	
	
	/* istanbul ignore next */
	src_button.install = function (Vue) {
	  Vue.component(src_button.name, src_button);
	};
	
	/* harmony default export */ var packages_button = __webpack_exports__["default"] = (src_button);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 59);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 14:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(83);
	
	/***/ }),
	
	/***/ 18:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(130);
	
	/***/ }),
	
	/***/ 21:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(57);
	
	/***/ }),
	
	/***/ 26:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(108);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(21);
	
	/***/ }),
	
	/***/ 31:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(86);
	
	/***/ }),
	
	/***/ 40:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(84);
	
	/***/ }),
	
	/***/ 51:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(132);
	
	/***/ }),
	
	/***/ 59:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	var cascader_panelvue_type_template_id_34932346_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: ["el-cascader-panel", _vm.border && "is-bordered"],
	      on: { keydown: _vm.handleKeyDown }
	    },
	    _vm._l(_vm.menus, function(menu, index) {
	      return _c("cascader-menu", {
	        key: index,
	        ref: "menu",
	        refInFor: true,
	        attrs: { index: index, nodes: menu }
	      })
	    }),
	    1
	  )
	}
	var staticRenderFns = []
	cascader_panelvue_type_template_id_34932346_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	
	// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
	var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(26);
	var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);
	
	// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
	var scrollbar_ = __webpack_require__(14);
	var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);
	
	// EXTERNAL MODULE: external "element-ui/lib/checkbox"
	var checkbox_ = __webpack_require__(18);
	var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);
	
	// EXTERNAL MODULE: external "element-ui/lib/radio"
	var radio_ = __webpack_require__(51);
	var radio_default = /*#__PURE__*/__webpack_require__.n(radio_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	
	/* harmony default export */ var cascader_nodevue_type_script_lang_js_ = ({
	  inject: ['panel'],
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElRadio: radio_default.a
	  },
	
	  props: {
	    node: {
	      required: true
	    },
	    nodeId: String
	  },
	
	  computed: {
	    config: function config() {
	      return this.panel.config;
	    },
	    isLeaf: function isLeaf() {
	      return this.node.isLeaf;
	    },
	    isDisabled: function isDisabled() {
	      return this.node.isDisabled;
	    },
	    checkedValue: function checkedValue() {
	      return this.panel.checkedValue;
	    },
	    isChecked: function isChecked() {
	      return this.node.isSameNode(this.checkedValue);
	    },
	    inActivePath: function inActivePath() {
	      return this.isInPath(this.panel.activePath);
	    },
	    inCheckedPath: function inCheckedPath() {
	      var _this = this;
	
	      if (!this.config.checkStrictly) return false;
	
	      return this.panel.checkedNodePaths.some(function (checkedPath) {
	        return _this.isInPath(checkedPath);
	      });
	    },
	    value: function value() {
	      return this.node.getValueByOption();
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand() {
	      var _this2 = this;
	
	      var panel = this.panel,
	          node = this.node,
	          isDisabled = this.isDisabled,
	          config = this.config;
	      var multiple = config.multiple,
	          checkStrictly = config.checkStrictly;
	
	
	      if (!checkStrictly && isDisabled || node.loading) return;
	
	      if (config.lazy && !node.loaded) {
	        panel.lazyLoad(node, function () {
	          // do not use cached leaf value here, invoke this.isLeaf to get new value.
	          var isLeaf = _this2.isLeaf;
	
	
	          if (!isLeaf) _this2.handleExpand();
	          if (multiple) {
	            // if leaf sync checked state, else clear checked state
	            var checked = isLeaf ? node.checked : false;
	            _this2.handleMultiCheckChange(checked);
	          }
	        });
	      } else {
	        panel.handleExpand(node);
	      }
	    },
	    handleCheckChange: function handleCheckChange() {
	      var panel = this.panel,
	          value = this.value,
	          node = this.node;
	
	      panel.handleCheckChange(value);
	      panel.handleExpand(node);
	    },
	    handleMultiCheckChange: function handleMultiCheckChange(checked) {
	      this.node.doCheck(checked);
	      this.panel.calculateMultiCheckedValue();
	    },
	    isInPath: function isInPath(pathNodes) {
	      var node = this.node;
	
	      var selectedPathNode = pathNodes[node.level - 1] || {};
	      return selectedPathNode.uid === node.uid;
	    },
	    renderPrefix: function renderPrefix(h) {
	      var isLeaf = this.isLeaf,
	          isChecked = this.isChecked,
	          config = this.config;
	      var checkStrictly = config.checkStrictly,
	          multiple = config.multiple;
	
	
	      if (multiple) {
	        return this.renderCheckbox(h);
	      } else if (checkStrictly) {
	        return this.renderRadio(h);
	      } else if (isLeaf && isChecked) {
	        return this.renderCheckIcon(h);
	      }
	
	      return null;
	    },
	    renderPostfix: function renderPostfix(h) {
	      var node = this.node,
	          isLeaf = this.isLeaf;
	
	
	      if (node.loading) {
	        return this.renderLoadingIcon(h);
	      } else if (!isLeaf) {
	        return this.renderExpandIcon(h);
	      }
	
	      return null;
	    },
	    renderCheckbox: function renderCheckbox(h) {
	      var node = this.node,
	          config = this.config,
	          isDisabled = this.isDisabled;
	
	      var events = {
	        on: { change: this.handleMultiCheckChange },
	        nativeOn: {}
	      };
	
	      if (config.checkStrictly) {
	        // when every node is selectable, click event should not trigger expand event.
	        events.nativeOn.click = stopPropagation;
	      }
	
	      return h('el-checkbox', external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          value: node.checked,
	          indeterminate: node.indeterminate,
	          disabled: isDisabled
	        }
	      }, events]));
	    },
	    renderRadio: function renderRadio(h) {
	      var checkedValue = this.checkedValue,
	          value = this.value,
	          isDisabled = this.isDisabled;
	
	      // to keep same reference if value cause radio's checked state is calculated by reference comparision;
	
	      if (Object(util_["isEqual"])(value, checkedValue)) {
	        value = checkedValue;
	      }
	
	      return h(
	        'el-radio',
	        {
	          attrs: {
	            value: checkedValue,
	            label: value,
	            disabled: isDisabled
	          },
	          on: {
	            'change': this.handleCheckChange
	          },
	          nativeOn: {
	            'click': stopPropagation
	          }
	        },
	        [h('span')]
	      );
	    },
	    renderCheckIcon: function renderCheckIcon(h) {
	      return h('i', { 'class': 'el-icon-check el-cascader-node__prefix' });
	    },
	    renderLoadingIcon: function renderLoadingIcon(h) {
	      return h('i', { 'class': 'el-icon-loading el-cascader-node__postfix' });
	    },
	    renderExpandIcon: function renderExpandIcon(h) {
	      return h('i', { 'class': 'el-icon-arrow-right el-cascader-node__postfix' });
	    },
	    renderContent: function renderContent(h) {
	      var panel = this.panel,
	          node = this.node;
	
	      var render = panel.renderLabelFn;
	      var vnode = render ? render({ node: node, data: node.data }) : null;
	
	      return h(
	        'span',
	        { 'class': 'el-cascader-node__label' },
	        [vnode || node.label]
	      );
	    }
	  },
	
	  render: function render(h) {
	    var _this3 = this;
	
	    var inActivePath = this.inActivePath,
	        inCheckedPath = this.inCheckedPath,
	        isChecked = this.isChecked,
	        isLeaf = this.isLeaf,
	        isDisabled = this.isDisabled,
	        config = this.config,
	        nodeId = this.nodeId;
	    var expandTrigger = config.expandTrigger,
	        checkStrictly = config.checkStrictly,
	        multiple = config.multiple;
	
	    var disabled = !checkStrictly && isDisabled;
	    var events = { on: {} };
	
	    if (expandTrigger === 'click') {
	      events.on.click = this.handleExpand;
	    } else {
	      events.on.mouseenter = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	      events.on.focus = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	    }
	    if (isLeaf && !isDisabled && !checkStrictly && !multiple) {
	      events.on.click = this.handleCheckChange;
	    }
	
	    return h(
	      'li',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          role: 'menuitem',
	          id: nodeId,
	          'aria-expanded': inActivePath,
	          tabindex: disabled ? null : -1
	        },
	        'class': {
	          'el-cascader-node': true,
	          'is-selectable': checkStrictly,
	          'in-active-path': inActivePath,
	          'in-checked-path': inCheckedPath,
	          'is-active': isChecked,
	          'is-disabled': disabled
	        }
	      }, events]),
	      [this.renderPrefix(h), this.renderContent(h), this.renderPostfix(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_nodevue_type_script_lang_js_ = (cascader_nodevue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
	var cascader_node_render, cascader_node_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_cascader_nodevue_type_script_lang_js_,
	  cascader_node_render,
	  cascader_node_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/cascader-panel/src/cascader-node.vue"
	/* harmony default export */ var cascader_node = (component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
	var locale_ = __webpack_require__(6);
	var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	
	/* harmony default export */ var cascader_menuvue_type_script_lang_js_ = ({
	  name: 'ElCascaderMenu',
	
	  mixins: [locale_default.a],
	
	  inject: ['panel'],
	
	  components: {
	    ElScrollbar: scrollbar_default.a,
	    CascaderNode: cascader_node
	  },
	
	  props: {
	    nodes: {
	      type: Array,
	      required: true
	    },
	    index: Number
	  },
	
	  data: function data() {
	    return {
	      activeNode: null,
	      hoverTimer: null,
	      id: Object(util_["generateId"])()
	    };
	  },
	
	
	  computed: {
	    isEmpty: function isEmpty() {
	      return !this.nodes.length;
	    },
	    menuId: function menuId() {
	      return 'cascader-menu-' + this.id + '-' + this.index;
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand(e) {
	      this.activeNode = e.target;
	    },
	    handleMouseMove: function handleMouseMove(e) {
	      var activeNode = this.activeNode,
	          hoverTimer = this.hoverTimer;
	      var hoverZone = this.$refs.hoverZone;
	
	
	      if (!activeNode || !hoverZone) return;
	
	      if (activeNode.contains(e.target)) {
	        clearTimeout(hoverTimer);
	
	        var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
	            left = _$el$getBoundingClien.left;
	
	        var startX = e.clientX - left;
	        var _$el = this.$el,
	            offsetWidth = _$el.offsetWidth,
	            offsetHeight = _$el.offsetHeight;
	
	        var top = activeNode.offsetTop;
	        var bottom = top + activeNode.offsetHeight;
	
	        hoverZone.innerHTML = '\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + top + ' L' + offsetWidth + ' 0 V' + top + ' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + bottom + ' L' + offsetWidth + ' ' + offsetHeight + ' V' + bottom + ' Z" />\n        ';
	      } else if (!hoverTimer) {
	        this.hoverTimer = setTimeout(this.clearHoverZone, this.panel.config.hoverThreshold);
	      }
	    },
	    clearHoverZone: function clearHoverZone() {
	      var hoverZone = this.$refs.hoverZone;
	
	      if (!hoverZone) return;
	      hoverZone.innerHTML = '';
	    },
	    renderEmptyText: function renderEmptyText(h) {
	      return h(
	        'div',
	        { 'class': 'el-cascader-menu__empty-text' },
	        [this.t('el.cascader.noData')]
	      );
	    },
	    renderNodeList: function renderNodeList(h) {
	      var menuId = this.menuId;
	      var isHoverMenu = this.panel.isHoverMenu;
	
	      var events = { on: {} };
	
	      if (isHoverMenu) {
	        events.on.expand = this.handleExpand;
	      }
	
	      var nodes = this.nodes.map(function (node, index) {
	        var hasChildren = node.hasChildren;
	
	        return h('cascader-node', external_babel_helper_vue_jsx_merge_props_default()([{
	          key: node.uid,
	          attrs: { node: node,
	            'node-id': menuId + '-' + index,
	            'aria-haspopup': hasChildren,
	            'aria-owns': hasChildren ? menuId : null
	          }
	        }, events]));
	      });
	
	      return [].concat(nodes, [isHoverMenu ? h('svg', { ref: 'hoverZone', 'class': 'el-cascader-menu__hover-zone' }) : null]);
	    }
	  },
	
	  render: function render(h) {
	    var isEmpty = this.isEmpty,
	        menuId = this.menuId;
	
	    var events = { nativeOn: {} };
	
	    // optimize hover to expand experience (#8010)
	    if (this.panel.isHoverMenu) {
	      events.nativeOn.mousemove = this.handleMouseMove;
	      // events.nativeOn.mouseleave = this.clearHoverZone;
	    }
	
	    return h(
	      'el-scrollbar',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          tag: 'ul',
	          role: 'menu',
	          id: menuId,
	
	          'wrap-class': 'el-cascader-menu__wrap',
	          'view-class': {
	            'el-cascader-menu__list': true,
	            'is-empty': isEmpty
	          }
	        },
	        'class': 'el-cascader-menu' }, events]),
	      [isEmpty ? this.renderEmptyText(h) : this.renderNodeList(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_menuvue_type_script_lang_js_ = (cascader_menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
	var cascader_menu_render, cascader_menu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var cascader_menu_component = Object(componentNormalizer["a" /* default */])(
	  src_cascader_menuvue_type_script_lang_js_,
	  cascader_menu_render,
	  cascader_menu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_menu_api; }
	cascader_menu_component.options.__file = "packages/cascader-panel/src/cascader-menu.vue"
	/* harmony default export */ var cascader_menu = (cascader_menu_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(21);
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var uid = 0;
	
	var node_Node = function () {
	  function Node(data, config, parentNode) {
	    _classCallCheck(this, Node);
	
	    this.data = data;
	    this.config = config;
	    this.parent = parentNode || null;
	    this.level = !this.parent ? 1 : this.parent.level + 1;
	    this.uid = uid++;
	
	    this.initState();
	    this.initChildren();
	  }
	
	  Node.prototype.initState = function initState() {
	    var _config = this.config,
	        valueKey = _config.value,
	        labelKey = _config.label;
	
	
	    this.value = this.data[valueKey];
	    this.label = this.data[labelKey];
	    this.pathNodes = this.calculatePathNodes();
	    this.path = this.pathNodes.map(function (node) {
	      return node.value;
	    });
	    this.pathLabels = this.pathNodes.map(function (node) {
	      return node.label;
	    });
	
	    // lazy load
	    this.loading = false;
	    this.loaded = false;
	  };
	
	  Node.prototype.initChildren = function initChildren() {
	    var _this = this;
	
	    var config = this.config;
	
	    var childrenKey = config.children;
	    var childrenData = this.data[childrenKey];
	    this.hasChildren = Array.isArray(childrenData);
	    this.children = (childrenData || []).map(function (child) {
	      return new Node(child, config, _this);
	    });
	  };
	
	  Node.prototype.calculatePathNodes = function calculatePathNodes() {
	    var nodes = [this];
	    var parent = this.parent;
	
	    while (parent) {
	      nodes.unshift(parent);
	      parent = parent.parent;
	    }
	
	    return nodes;
	  };
	
	  Node.prototype.getPath = function getPath() {
	    return this.path;
	  };
	
	  Node.prototype.getValue = function getValue() {
	    return this.value;
	  };
	
	  Node.prototype.getValueByOption = function getValueByOption() {
	    return this.config.emitPath ? this.getPath() : this.getValue();
	  };
	
	  Node.prototype.getText = function getText(allLevels, separator) {
	    return allLevels ? this.pathLabels.join(separator) : this.label;
	  };
	
	  Node.prototype.isSameNode = function isSameNode(checkedValue) {
	    var value = this.getValueByOption();
	    return this.config.multiple && Array.isArray(checkedValue) ? checkedValue.some(function (val) {
	      return Object(util_["isEqual"])(val, value);
	    }) : Object(util_["isEqual"])(checkedValue, value);
	  };
	
	  Node.prototype.broadcast = function broadcast(event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var handlerName = 'onParent' + Object(util_["capitalize"])(event);
	
	    this.children.forEach(function (child) {
	      if (child) {
	        // bottom up
	        child.broadcast.apply(child, [event].concat(args));
	        child[handlerName] && child[handlerName].apply(child, args);
	      }
	    });
	  };
	
	  Node.prototype.emit = function emit(event) {
	    var parent = this.parent;
	
	    var handlerName = 'onChild' + Object(util_["capitalize"])(event);
	    if (parent) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      parent[handlerName] && parent[handlerName].apply(parent, args);
	      parent.emit.apply(parent, [event].concat(args));
	    }
	  };
	
	  Node.prototype.onParentCheck = function onParentCheck(checked) {
	    if (!this.isDisabled) {
	      this.setCheckState(checked);
	    }
	  };
	
	  Node.prototype.onChildCheck = function onChildCheck() {
	    var children = this.children;
	
	    var validChildren = children.filter(function (child) {
	      return !child.isDisabled;
	    });
	    var checked = validChildren.length ? validChildren.every(function (child) {
	      return child.checked;
	    }) : false;
	
	    this.setCheckState(checked);
	  };
	
	  Node.prototype.setCheckState = function setCheckState(checked) {
	    var totalNum = this.children.length;
	    var checkedNum = this.children.reduce(function (c, p) {
	      var num = p.checked ? 1 : p.indeterminate ? 0.5 : 0;
	      return c + num;
	    }, 0);
	
	    this.checked = checked;
	    this.indeterminate = checkedNum !== totalNum && checkedNum > 0;
	  };
	
	  Node.prototype.syncCheckState = function syncCheckState(checkedValue) {
	    var value = this.getValueByOption();
	    var checked = this.isSameNode(checkedValue, value);
	
	    this.doCheck(checked);
	  };
	
	  Node.prototype.doCheck = function doCheck(checked) {
	    if (this.checked !== checked) {
	      if (this.config.checkStrictly) {
	        this.checked = checked;
	      } else {
	        // bottom up to unify the calculation of the indeterminate state
	        this.broadcast('check', checked);
	        this.setCheckState(checked);
	        this.emit('check');
	      }
	    }
	  };
	
	  _createClass(Node, [{
	    key: 'isDisabled',
	    get: function get() {
	      var data = this.data,
	          parent = this.parent,
	          config = this.config;
	
	      var disabledKey = config.disabled;
	      var checkStrictly = config.checkStrictly;
	
	      return data[disabledKey] || !checkStrictly && parent && parent.isDisabled;
	    }
	  }, {
	    key: 'isLeaf',
	    get: function get() {
	      var data = this.data,
	          loaded = this.loaded,
	          hasChildren = this.hasChildren,
	          children = this.children;
	      var _config2 = this.config,
	          lazy = _config2.lazy,
	          leafKey = _config2.leaf;
	
	      if (lazy) {
	        var isLeaf = Object(shared_["isDef"])(data[leafKey]) ? data[leafKey] : loaded ? !children.length : false;
	        this.hasChildren = !isLeaf;
	        return isLeaf;
	      }
	      return !hasChildren;
	    }
	  }]);
	
	  return Node;
	}();
	
	/* harmony default export */ var src_node = (node_Node);
	// CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
	function store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var flatNodes = function flatNodes(data, leafOnly) {
	  return data.reduce(function (res, node) {
	    if (node.isLeaf) {
	      res.push(node);
	    } else {
	      !leafOnly && res.push(node);
	      res = res.concat(flatNodes(node.children, leafOnly));
	    }
	    return res;
	  }, []);
	};
	
	var store_Store = function () {
	  function Store(data, config) {
	    store_classCallCheck(this, Store);
	
	    this.config = config;
	    this.initNodes(data);
	  }
	
	  Store.prototype.initNodes = function initNodes(data) {
	    var _this = this;
	
	    data = Object(util_["coerceTruthyValueToArray"])(data);
	    this.nodes = data.map(function (nodeData) {
	      return new src_node(nodeData, _this.config);
	    });
	    this.flattedNodes = this.getFlattedNodes(false, false);
	    this.leafNodes = this.getFlattedNodes(true, false);
	  };
	
	  Store.prototype.appendNode = function appendNode(nodeData, parentNode) {
	    var node = new src_node(nodeData, this.config, parentNode);
	    var children = parentNode ? parentNode.children : this.nodes;
	
	    children.push(node);
	  };
	
	  Store.prototype.appendNodes = function appendNodes(nodeDataList, parentNode) {
	    var _this2 = this;
	
	    nodeDataList = Object(util_["coerceTruthyValueToArray"])(nodeDataList);
	    nodeDataList.forEach(function (nodeData) {
	      return _this2.appendNode(nodeData, parentNode);
	    });
	  };
	
	  Store.prototype.getNodes = function getNodes() {
	    return this.nodes;
	  };
	
	  Store.prototype.getFlattedNodes = function getFlattedNodes(leafOnly) {
	    var cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var cachedNodes = leafOnly ? this.leafNodes : this.flattedNodes;
	    return cached ? cachedNodes : flatNodes(this.nodes, leafOnly);
	  };
	
	  Store.prototype.getNodeByValue = function getNodeByValue(value) {
	    if (value) {
	      var nodes = this.getFlattedNodes(false, !this.config.lazy).filter(function (node) {
	        return Object(util_["valueEquals"])(node.path, value) || node.value === value;
	      });
	      return nodes && nodes.length ? nodes[0] : null;
	    }
	    return null;
	  };
	
	  return Store;
	}();
	
	/* harmony default export */ var src_store = (store_Store);
	// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
	var merge_ = __webpack_require__(9);
	var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
	var aria_utils_ = __webpack_require__(40);
	var aria_utils_default = /*#__PURE__*/__webpack_require__.n(aria_utils_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
	var scroll_into_view_ = __webpack_require__(31);
	var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var KeyCode = aria_utils_default.a.keys;
	
	var DefaultProps = {
	  expandTrigger: 'click', // or hover
	  multiple: false,
	  checkStrictly: false, // whether all nodes can be selected
	  emitPath: true, // wether to emit an array of all levels value in which node is located
	  lazy: false,
	  lazyLoad: util_["noop"],
	  value: 'value',
	  label: 'label',
	  children: 'children',
	  leaf: 'leaf',
	  disabled: 'disabled',
	  hoverThreshold: 500
	};
	
	var cascader_panelvue_type_script_lang_js_isLeaf = function isLeaf(el) {
	  return !el.getAttribute('aria-owns');
	};
	
	var getSibling = function getSibling(el, distance) {
	  var parentNode = el.parentNode;
	
	  if (parentNode) {
	    var siblings = parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');
	    var index = Array.prototype.indexOf.call(siblings, el);
	    return siblings[index + distance] || null;
	  }
	  return null;
	};
	
	var getMenuIndex = function getMenuIndex(el, distance) {
	  if (!el) return;
	  var pieces = el.id.split('-');
	  return Number(pieces[pieces.length - 2]);
	};
	
	var focusNode = function focusNode(el) {
	  if (!el) return;
	  el.focus();
	  !cascader_panelvue_type_script_lang_js_isLeaf(el) && el.click();
	};
	
	var checkNode = function checkNode(el) {
	  if (!el) return;
	
	  var input = el.querySelector('input');
	  if (input) {
	    input.click();
	  } else if (cascader_panelvue_type_script_lang_js_isLeaf(el)) {
	    el.click();
	  }
	};
	
	/* harmony default export */ var cascader_panelvue_type_script_lang_js_ = ({
	  name: 'ElCascaderPanel',
	
	  components: {
	    CascaderMenu: cascader_menu
	  },
	
	  props: {
	    value: {},
	    options: Array,
	    props: Object,
	    border: {
	      type: Boolean,
	      default: true
	    },
	    renderLabel: Function
	  },
	
	  provide: function provide() {
	    return {
	      panel: this
	    };
	  },
	  data: function data() {
	    return {
	      checkedValue: null,
	      checkedNodePaths: [],
	      store: [],
	      menus: [],
	      activePath: [],
	      loadCount: 0
	    };
	  },
	
	
	  computed: {
	    config: function config() {
	      return merge_default()(_extends({}, DefaultProps), this.props || {});
	    },
	    multiple: function multiple() {
	      return this.config.multiple;
	    },
	    checkStrictly: function checkStrictly() {
	      return this.config.checkStrictly;
	    },
	    leafOnly: function leafOnly() {
	      return !this.checkStrictly;
	    },
	    isHoverMenu: function isHoverMenu() {
	      return this.config.expandTrigger === 'hover';
	    },
	    renderLabelFn: function renderLabelFn() {
	      return this.renderLabel || this.$scopedSlots.default;
	    }
	  },
	
	  watch: {
	    options: {
	      handler: function handler() {
	        this.initStore();
	      },
	      immediate: true,
	      deep: true
	    },
	    value: function value() {
	      this.syncCheckedValue();
	      this.checkStrictly && this.calculateCheckedNodePaths();
	    },
	    checkedValue: function checkedValue(val) {
	      if (!Object(util_["isEqual"])(val, this.value)) {
	        this.checkStrictly && this.calculateCheckedNodePaths();
	        this.$emit('input', val);
	        this.$emit('change', val);
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    if (!Object(util_["isEmpty"])(this.value)) {
	      this.syncCheckedValue();
	    }
	  },
	
	
	  methods: {
	    initStore: function initStore() {
	      var config = this.config,
	          options = this.options;
	
	      if (config.lazy && Object(util_["isEmpty"])(options)) {
	        this.lazyLoad();
	      } else {
	        this.store = new src_store(options, config);
	        this.menus = [this.store.getNodes()];
	        this.syncMenuState();
	      }
	    },
	    syncCheckedValue: function syncCheckedValue() {
	      var value = this.value,
	          checkedValue = this.checkedValue;
	
	      if (!Object(util_["isEqual"])(value, checkedValue)) {
	        this.checkedValue = value;
	        this.syncMenuState();
	      }
	    },
	    syncMenuState: function syncMenuState() {
	      var multiple = this.multiple,
	          checkStrictly = this.checkStrictly;
	
	      this.syncActivePath();
	      multiple && this.syncMultiCheckState();
	      checkStrictly && this.calculateCheckedNodePaths();
	      this.$nextTick(this.scrollIntoView);
	    },
	    syncMultiCheckState: function syncMultiCheckState() {
	      var _this = this;
	
	      var nodes = this.getFlattedNodes(this.leafOnly);
	
	      nodes.forEach(function (node) {
	        node.syncCheckState(_this.checkedValue);
	      });
	    },
	    syncActivePath: function syncActivePath() {
	      var _this2 = this;
	
	      var store = this.store,
	          multiple = this.multiple,
	          activePath = this.activePath,
	          checkedValue = this.checkedValue;
	
	
	      if (!Object(util_["isEmpty"])(activePath)) {
	        var nodes = activePath.map(function (node) {
	          return _this2.getNodeByValue(node.getValue());
	        });
	        this.expandNodes(nodes);
	      } else if (!Object(util_["isEmpty"])(checkedValue)) {
	        var value = multiple ? checkedValue[0] : checkedValue;
	        var checkedNode = this.getNodeByValue(value) || {};
	        var _nodes = (checkedNode.pathNodes || []).slice(0, -1);
	        this.expandNodes(_nodes);
	      } else {
	        this.activePath = [];
	        this.menus = [store.getNodes()];
	      }
	    },
	    expandNodes: function expandNodes(nodes) {
	      var _this3 = this;
	
	      nodes.forEach(function (node) {
	        return _this3.handleExpand(node, true /* silent */);
	      });
	    },
	    calculateCheckedNodePaths: function calculateCheckedNodePaths() {
	      var _this4 = this;
	
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      var checkedValues = multiple ? Object(util_["coerceTruthyValueToArray"])(checkedValue) : [checkedValue];
	      this.checkedNodePaths = checkedValues.map(function (v) {
	        var checkedNode = _this4.getNodeByValue(v);
	        return checkedNode ? checkedNode.pathNodes : [];
	      });
	    },
	    handleKeyDown: function handleKeyDown(e) {
	      var target = e.target,
	          keyCode = e.keyCode;
	
	
	      switch (keyCode) {
	        case KeyCode.up:
	          var prev = getSibling(target, -1);
	          focusNode(prev);
	          break;
	        case KeyCode.down:
	          var next = getSibling(target, 1);
	          focusNode(next);
	          break;
	        case KeyCode.left:
	          var preMenu = this.$refs.menu[getMenuIndex(target) - 1];
	          if (preMenu) {
	            var expandedNode = preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');
	            focusNode(expandedNode);
	          }
	          break;
	        case KeyCode.right:
	          var nextMenu = this.$refs.menu[getMenuIndex(target) + 1];
	          if (nextMenu) {
	            var firstNode = nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');
	            focusNode(firstNode);
	          }
	          break;
	        case KeyCode.enter:
	          checkNode(target);
	          break;
	        case KeyCode.esc:
	        case KeyCode.tab:
	          this.$emit('close');
	          break;
	        default:
	          return;
	      }
	    },
	    handleExpand: function handleExpand(node, silent) {
	      var activePath = this.activePath;
	      var level = node.level;
	
	      var path = activePath.slice(0, level - 1);
	      var menus = this.menus.slice(0, level);
	
	      if (!node.isLeaf) {
	        path.push(node);
	        menus.push(node.children);
	      }
	
	      this.activePath = path;
	      this.menus = menus;
	
	      if (!silent) {
	        var pathValues = path.map(function (node) {
	          return node.getValue();
	        });
	        var activePathValues = activePath.map(function (node) {
	          return node.getValue();
	        });
	        if (!Object(util_["valueEquals"])(pathValues, activePathValues)) {
	          this.$emit('active-item-change', pathValues); // Deprecated
	          this.$emit('expand-change', pathValues);
	        }
	      }
	    },
	    handleCheckChange: function handleCheckChange(value) {
	      this.checkedValue = value;
	    },
	    lazyLoad: function lazyLoad(node, onFullfiled) {
	      var _this5 = this;
	
	      var config = this.config;
	
	      if (!node) {
	        node = node || { root: true, level: 0 };
	        this.store = new src_store([], config);
	        this.menus = [this.store.getNodes()];
	      }
	      node.loading = true;
	      var resolve = function resolve(dataList) {
	        var parent = node.root ? null : node;
	        dataList && dataList.length && _this5.store.appendNodes(dataList, parent);
	        node.loading = false;
	        node.loaded = true;
	
	        // dispose default value on lazy load mode
	        if (Array.isArray(_this5.checkedValue)) {
	          var nodeValue = _this5.checkedValue[_this5.loadCount++];
	          var valueKey = _this5.config.value;
	          var leafKey = _this5.config.leaf;
	
	          if (Array.isArray(dataList) && dataList.filter(function (item) {
	            return item[valueKey] === nodeValue;
	          }).length > 0) {
	            var checkedNode = _this5.store.getNodeByValue(nodeValue);
	
	            if (!checkedNode.data[leafKey]) {
	              _this5.lazyLoad(checkedNode, function () {
	                _this5.handleExpand(checkedNode);
	              });
	            }
	
	            if (_this5.loadCount === _this5.checkedValue.length) {
	              _this5.$parent.computePresentText();
	            }
	          }
	        }
	
	        onFullfiled && onFullfiled(dataList);
	      };
	      config.lazyLoad(node, resolve);
	    },
	
	
	    /**
	     * public methods
	    */
	    calculateMultiCheckedValue: function calculateMultiCheckedValue() {
	      this.checkedValue = this.getCheckedNodes(this.leafOnly).map(function (node) {
	        return node.getValueByOption();
	      });
	    },
	    scrollIntoView: function scrollIntoView() {
	      if (this.$isServer) return;
	
	      var menus = this.$refs.menu || [];
	      menus.forEach(function (menu) {
	        var menuElement = menu.$el;
	        if (menuElement) {
	          var container = menuElement.querySelector('.el-scrollbar__wrap');
	          var activeNode = menuElement.querySelector('.el-cascader-node.is-active') || menuElement.querySelector('.el-cascader-node.in-active-path');
	          scroll_into_view_default()(container, activeNode);
	        }
	      });
	    },
	    getNodeByValue: function getNodeByValue(val) {
	      return this.store.getNodeByValue(val);
	    },
	    getFlattedNodes: function getFlattedNodes(leafOnly) {
	      var cached = !this.config.lazy;
	      return this.store.getFlattedNodes(leafOnly, cached);
	    },
	    getCheckedNodes: function getCheckedNodes(leafOnly) {
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      if (multiple) {
	        var nodes = this.getFlattedNodes(leafOnly);
	        return nodes.filter(function (node) {
	          return node.checked;
	        });
	      } else {
	        return Object(util_["isEmpty"])(checkedValue) ? [] : [this.getNodeByValue(checkedValue)];
	      }
	    },
	    clearCheckedNodes: function clearCheckedNodes() {
	      var config = this.config,
	          leafOnly = this.leafOnly;
	      var multiple = config.multiple,
	          emitPath = config.emitPath;
	
	      if (multiple) {
	        this.getCheckedNodes(leafOnly).filter(function (node) {
	          return !node.isDisabled;
	        }).forEach(function (node) {
	          return node.doCheck(false);
	        });
	        this.calculateMultiCheckedValue();
	      } else {
	        this.checkedValue = emitPath ? [] : null;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_panelvue_type_script_lang_js_ = (cascader_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var cascader_panel_component = Object(componentNormalizer["a" /* default */])(
	  src_cascader_panelvue_type_script_lang_js_,
	  cascader_panelvue_type_template_id_34932346_render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_panel_api; }
	cascader_panel_component.options.__file = "packages/cascader-panel/src/cascader-panel.vue"
	/* harmony default export */ var cascader_panel = (cascader_panel_component.exports);
	// CONCATENATED MODULE: ./packages/cascader-panel/index.js
	
	
	/* istanbul ignore next */
	cascader_panel.install = function (Vue) {
	  Vue.component(cascader_panel.name, cascader_panel);
	};
	
	/* harmony default export */ var packages_cascader_panel = __webpack_exports__["default"] = (cascader_panel);
	
	/***/ }),
	
	/***/ 6:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(82);
	
	/***/ }),
	
	/***/ 9:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(56);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 86);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(33);
	
	/***/ }),
	
	/***/ 86:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-checkbox-group",
	      attrs: { role: "group", "aria-label": "checkbox-group" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	
	
	
	/* harmony default export */ var checkbox_groupvue_type_script_lang_js_ = ({
	  name: 'ElCheckboxGroup',
	
	  componentName: 'ElCheckboxGroup',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    value: {},
	    disabled: Boolean,
	    min: Number,
	    max: Number,
	    size: String,
	    fill: String,
	    textColor: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxGroupSize: function checkboxGroupSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', [_value]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkbox_groupvue_type_script_lang_js_ = (checkbox_groupvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_checkbox_groupvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/checkbox/src/checkbox-group.vue"
	/* harmony default export */ var checkbox_group = (component.exports);
	// CONCATENATED MODULE: ./packages/checkbox-group/index.js
	
	
	/* istanbul ignore next */
	checkbox_group.install = function (Vue) {
	  Vue.component(checkbox_group.name, checkbox_group);
	};
	
	/* harmony default export */ var packages_checkbox_group = __webpack_exports__["default"] = (checkbox_group);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 45);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(286);
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(23);
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(21);
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(33);
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(82);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(58);
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(6);
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(56);
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(79);
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(131);
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(134);
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(271);
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(85);
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(136);
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(59);
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(80);
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(130);
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(83);
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(137);
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(57);
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(135);
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(283);
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(81);
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(289);
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(108);
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(89);
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(282);
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(86);
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(270);
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(133);
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(87);
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(273);
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(284);
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(280);
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(84);
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(306);
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(281);
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(278);
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(296);
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(285);
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(178);
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(275);
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(272);
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(132);
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(279);
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(46);
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&
	var pagervue_type_template_id_7274f267_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "ul",
	    { staticClass: "el-pager", on: { click: _vm.onPagerClick } },
	    [
	      _vm.pageCount > 0
	        ? _c(
	            "li",
	            {
	              staticClass: "number",
	              class: { active: _vm.currentPage === 1, disabled: _vm.disabled }
	            },
	            [_vm._v("1")]
	          )
	        : _vm._e(),
	      _vm.showPrevMore
	        ? _c("li", {
	            staticClass: "el-icon more btn-quickprev",
	            class: [_vm.quickprevIconClass, { disabled: _vm.disabled }],
	            on: {
	              mouseenter: function($event) {
	                _vm.onMouseenter("left")
	              },
	              mouseleave: function($event) {
	                _vm.quickprevIconClass = "el-icon-more"
	              }
	            }
	          })
	        : _vm._e(),
	      _vm._l(_vm.pagers, function(pager) {
	        return _c(
	          "li",
	          {
	            key: pager,
	            staticClass: "number",
	            class: { active: _vm.currentPage === pager, disabled: _vm.disabled }
	          },
	          [_vm._v(_vm._s(pager))]
	        )
	      }),
	      _vm.showNextMore
	        ? _c("li", {
	            staticClass: "el-icon more btn-quicknext",
	            class: [_vm.quicknextIconClass, { disabled: _vm.disabled }],
	            on: {
	              mouseenter: function($event) {
	                _vm.onMouseenter("right")
	              },
	              mouseleave: function($event) {
	                _vm.quicknextIconClass = "el-icon-more"
	              }
	            }
	          })
	        : _vm._e(),
	      _vm.pageCount > 1
	        ? _c(
	            "li",
	            {
	              staticClass: "number",
	              class: {
	                active: _vm.currentPage === _vm.pageCount,
	                disabled: _vm.disabled
	              }
	            },
	            [_vm._v(_vm._s(_vm.pageCount))]
	          )
	        : _vm._e()
	    ],
	    2
	  )
	}
	var staticRenderFns = []
	pagervue_type_template_id_7274f267_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var pagervue_type_script_lang_js_ = ({
	  name: 'ElPager',
	
	  props: {
	    currentPage: Number,
	
	    pageCount: Number,
	
	    pagerCount: Number,
	
	    disabled: Boolean
	  },
	
	  watch: {
	    showPrevMore: function showPrevMore(val) {
	      if (!val) this.quickprevIconClass = 'el-icon-more';
	    },
	    showNextMore: function showNextMore(val) {
	      if (!val) this.quicknextIconClass = 'el-icon-more';
	    }
	  },
	
	  methods: {
	    onPagerClick: function onPagerClick(event) {
	      var target = event.target;
	      if (target.tagName === 'UL' || this.disabled) {
	        return;
	      }
	
	      var newPage = Number(event.target.textContent);
	      var pageCount = this.pageCount;
	      var currentPage = this.currentPage;
	      var pagerCountOffset = this.pagerCount - 2;
	
	      if (target.className.indexOf('more') !== -1) {
	        if (target.className.indexOf('quickprev') !== -1) {
	          newPage = currentPage - pagerCountOffset;
	        } else if (target.className.indexOf('quicknext') !== -1) {
	          newPage = currentPage + pagerCountOffset;
	        }
	      }
	
	      /* istanbul ignore if */
	      if (!isNaN(newPage)) {
	        if (newPage < 1) {
	          newPage = 1;
	        }
	
	        if (newPage > pageCount) {
	          newPage = pageCount;
	        }
	      }
	
	      if (newPage !== currentPage) {
	        this.$emit('change', newPage);
	      }
	    },
	    onMouseenter: function onMouseenter(direction) {
	      if (this.disabled) return;
	      if (direction === 'left') {
	        this.quickprevIconClass = 'el-icon-d-arrow-left';
	      } else {
	        this.quicknextIconClass = 'el-icon-d-arrow-right';
	      }
	    }
	  },
	
	  computed: {
	    pagers: function pagers() {
	      var pagerCount = this.pagerCount;
	      var halfPagerCount = (pagerCount - 1) / 2;
	
	      var currentPage = Number(this.currentPage);
	      var pageCount = Number(this.pageCount);
	
	      var showPrevMore = false;
	      var showNextMore = false;
	
	      if (pageCount > pagerCount) {
	        if (currentPage > pagerCount - halfPagerCount) {
	          showPrevMore = true;
	        }
	
	        if (currentPage < pageCount - halfPagerCount) {
	          showNextMore = true;
	        }
	      }
	
	      var array = [];
	
	      if (showPrevMore && !showNextMore) {
	        var startPage = pageCount - (pagerCount - 2);
	        for (var i = startPage; i < pageCount; i++) {
	          array.push(i);
	        }
	      } else if (!showPrevMore && showNextMore) {
	        for (var _i = 2; _i < pagerCount; _i++) {
	          array.push(_i);
	        }
	      } else if (showPrevMore && showNextMore) {
	        var offset = Math.floor(pagerCount / 2) - 1;
	        for (var _i2 = currentPage - offset; _i2 <= currentPage + offset; _i2++) {
	          array.push(_i2);
	        }
	      } else {
	        for (var _i3 = 2; _i3 < pageCount; _i3++) {
	          array.push(_i3);
	        }
	      }
	
	      this.showPrevMore = showPrevMore;
	      this.showNextMore = showNextMore;
	
	      return array;
	    }
	  },
	
	  data: function data() {
	    return {
	      current: null,
	      showPrevMore: false,
	      showNextMore: false,
	      quicknextIconClass: 'el-icon-more',
	      quickprevIconClass: 'el-icon-more'
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_pagervue_type_script_lang_js_ = (pagervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	// CONCATENATED MODULE: ./packages/pagination/src/pager.vue
	
	
	
	
	
	/* normalize component */
	
	var component = normalizeComponent(
	  src_pagervue_type_script_lang_js_,
	  pagervue_type_template_id_7274f267_render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/pagination/src/pager.vue"
	/* harmony default export */ var pager = (component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/select"
	var select_ = __webpack_require__(36);
	var select_default = /*#__PURE__*/__webpack_require__.n(select_);
	
	// EXTERNAL MODULE: external "element-ui/lib/option"
	var option_ = __webpack_require__(37);
	var option_default = /*#__PURE__*/__webpack_require__.n(option_);
	
	// EXTERNAL MODULE: external "element-ui/lib/input"
	var input_ = __webpack_require__(8);
	var input_default = /*#__PURE__*/__webpack_require__.n(input_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
	var locale_ = __webpack_require__(4);
	var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(2);
	
	// CONCATENATED MODULE: ./packages/pagination/src/pagination.js
	
	
	
	
	
	
	
	/* harmony default export */ var pagination = ({
	  name: 'ElPagination',
	
	  props: {
	    pageSize: {
	      type: Number,
	      default: 10
	    },
	
	    small: Boolean,
	
	    total: Number,
	
	    pageCount: Number,
	
	    pagerCount: {
	      type: Number,
	      validator: function validator(value) {
	        return (value | 0) === value && value > 4 && value < 22 && value % 2 === 1;
	      },
	
	      default: 7
	    },
	
	    currentPage: {
	      type: Number,
	      default: 1
	    },
	
	    layout: {
	      default: 'prev, pager, next, jumper, ->, total'
	    },
	
	    pageSizes: {
	      type: Array,
	      default: function _default() {
	        return [10, 20, 30, 40, 50, 100];
	      }
	    },
	
	    popperClass: String,
	
	    prevText: String,
	
	    nextText: String,
	
	    background: Boolean,
	
	    disabled: Boolean,
	
	    hideOnSinglePage: Boolean
	  },
	
	  data: function data() {
	    return {
	      internalCurrentPage: 1,
	      internalPageSize: 0,
	      lastEmittedPage: -1,
	      userChangePageSize: false
	    };
	  },
	  render: function render(h) {
	    var layout = this.layout;
	    if (!layout) return null;
	    if (this.hideOnSinglePage && (!this.internalPageCount || this.internalPageCount === 1)) return null;
	
	    var template = h('div', { 'class': ['el-pagination', {
	        'is-background': this.background,
	        'el-pagination--small': this.small
	      }] });
	    var TEMPLATE_MAP = {
	      prev: h('prev'),
	      jumper: h('jumper'),
	      pager: h('pager', {
	        attrs: { currentPage: this.internalCurrentPage, pageCount: this.internalPageCount, pagerCount: this.pagerCount, disabled: this.disabled },
	        on: {
	          'change': this.handleCurrentChange
	        }
	      }),
	      next: h('next'),
	      sizes: h('sizes', {
	        attrs: { pageSizes: this.pageSizes }
	      }),
	      slot: h('slot', [this.$slots.default ? this.$slots.default : '']),
	      total: h('total')
	    };
	    var components = layout.split(',').map(function (item) {
	      return item.trim();
	    });
	    var rightWrapper = h('div', { 'class': 'el-pagination__rightwrapper' });
	    var haveRightWrapper = false;
	
	    template.children = template.children || [];
	    rightWrapper.children = rightWrapper.children || [];
	    components.forEach(function (compo) {
	      if (compo === '->') {
	        haveRightWrapper = true;
	        return;
	      }
	
	      if (!haveRightWrapper) {
	        template.children.push(TEMPLATE_MAP[compo]);
	      } else {
	        rightWrapper.children.push(TEMPLATE_MAP[compo]);
	      }
	    });
	
	    if (haveRightWrapper) {
	      template.children.unshift(rightWrapper);
	    }
	
	    return template;
	  },
	
	
	  components: {
	    Prev: {
	      render: function render(h) {
	        return h(
	          'button',
	          {
	            attrs: {
	              type: 'button',
	
	              disabled: this.$parent.disabled || this.$parent.internalCurrentPage <= 1
	            },
	            'class': 'btn-prev', on: {
	              'click': this.$parent.prev
	            }
	          },
	          [this.$parent.prevText ? h('span', [this.$parent.prevText]) : h('i', { 'class': 'el-icon el-icon-arrow-left' })]
	        );
	      }
	    },
	
	    Next: {
	      render: function render(h) {
	        return h(
	          'button',
	          {
	            attrs: {
	              type: 'button',
	
	              disabled: this.$parent.disabled || this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0
	            },
	            'class': 'btn-next', on: {
	              'click': this.$parent.next
	            }
	          },
	          [this.$parent.nextText ? h('span', [this.$parent.nextText]) : h('i', { 'class': 'el-icon el-icon-arrow-right' })]
	        );
	      }
	    },
	
	    Sizes: {
	      mixins: [locale_default.a],
	
	      props: {
	        pageSizes: Array
	      },
	
	      watch: {
	        pageSizes: {
	          immediate: true,
	          handler: function handler(newVal, oldVal) {
	            if (Object(util_["valueEquals"])(newVal, oldVal)) return;
	            if (Array.isArray(newVal)) {
	              this.$parent.internalPageSize = newVal.indexOf(this.$parent.pageSize) > -1 ? this.$parent.pageSize : this.pageSizes[0];
	            }
	          }
	        }
	      },
	
	      render: function render(h) {
	        var _this = this;
	
	        return h(
	          'span',
	          { 'class': 'el-pagination__sizes' },
	          [h(
	            'el-select',
	            {
	              attrs: {
	                value: this.$parent.internalPageSize,
	                popperClass: this.$parent.popperClass || '',
	                size: 'mini',
	
	                disabled: this.$parent.disabled },
	              on: {
	                'input': this.handleChange
	              }
	            },
	            [this.pageSizes.map(function (item) {
	              return h('el-option', {
	                attrs: {
	                  value: item,
	                  label: item + _this.t('el.pagination.pagesize') }
	              });
	            })]
	          )]
	        );
	      },
	
	
	      components: {
	        ElSelect: select_default.a,
	        ElOption: option_default.a
	      },
	
	      methods: {
	        handleChange: function handleChange(val) {
	          if (val !== this.$parent.internalPageSize) {
	            this.$parent.internalPageSize = val = parseInt(val, 10);
	            this.$parent.userChangePageSize = true;
	            this.$parent.$emit('update:pageSize', val);
	            this.$parent.$emit('size-change', val);
	          }
	        }
	      }
	    },
	
	    Jumper: {
	      mixins: [locale_default.a],
	
	      components: { ElInput: input_default.a },
	
	      data: function data() {
	        return {
	          userInput: null
	        };
	      },
	
	
	      watch: {
	        '$parent.internalCurrentPage': function $parentInternalCurrentPage() {
	          this.userInput = null;
	        }
	      },
	
	      methods: {
	        handleKeyup: function handleKeyup(_ref) {
	          var keyCode = _ref.keyCode,
	              target = _ref.target;
	
	          // Chrome, Safari, Firefox triggers change event on Enter
	          // Hack for IE: https://github.com/ElemeFE/element/issues/11710
	          // Drop this method when we no longer supports IE
	          if (keyCode === 13) {
	            this.handleChange(target.value);
	          }
	        },
	        handleInput: function handleInput(value) {
	          this.userInput = value;
	        },
	        handleChange: function handleChange(value) {
	          this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(value);
	          this.$parent.emitChange();
	          this.userInput = null;
	        }
	      },
	
	      render: function render(h) {
	        return h(
	          'span',
	          { 'class': 'el-pagination__jump' },
	          [this.t('el.pagination.goto'), h('el-input', {
	            'class': 'el-pagination__editor is-in-pagination',
	            attrs: { min: 1,
	              max: this.$parent.internalPageCount,
	              value: this.userInput !== null ? this.userInput : this.$parent.internalCurrentPage,
	              type: 'number',
	              disabled: this.$parent.disabled
	            },
	            nativeOn: {
	              'keyup': this.handleKeyup
	            },
	            on: {
	              'input': this.handleInput,
	              'change': this.handleChange
	            }
	          }), this.t('el.pagination.pageClassifier')]
	        );
	      }
	    },
	
	    Total: {
	      mixins: [locale_default.a],
	
	      render: function render(h) {
	        return typeof this.$parent.total === 'number' ? h(
	          'span',
	          { 'class': 'el-pagination__total' },
	          [this.t('el.pagination.total', { total: this.$parent.total })]
	        ) : '';
	      }
	    },
	
	    Pager: pager
	  },
	
	  methods: {
	    handleCurrentChange: function handleCurrentChange(val) {
	      this.internalCurrentPage = this.getValidCurrentPage(val);
	      this.userChangePageSize = true;
	      this.emitChange();
	    },
	    prev: function prev() {
	      if (this.disabled) return;
	      var newVal = this.internalCurrentPage - 1;
	      this.internalCurrentPage = this.getValidCurrentPage(newVal);
	      this.$emit('prev-click', this.internalCurrentPage);
	      this.emitChange();
	    },
	    next: function next() {
	      if (this.disabled) return;
	      var newVal = this.internalCurrentPage + 1;
	      this.internalCurrentPage = this.getValidCurrentPage(newVal);
	      this.$emit('next-click', this.internalCurrentPage);
	      this.emitChange();
	    },
	    getValidCurrentPage: function getValidCurrentPage(value) {
	      value = parseInt(value, 10);
	
	      var havePageCount = typeof this.internalPageCount === 'number';
	
	      var resetValue = void 0;
	      if (!havePageCount) {
	        if (isNaN(value) || value < 1) resetValue = 1;
	      } else {
	        if (value < 1) {
	          resetValue = 1;
	        } else if (value > this.internalPageCount) {
	          resetValue = this.internalPageCount;
	        }
	      }
	
	      if (resetValue === undefined && isNaN(value)) {
	        resetValue = 1;
	      } else if (resetValue === 0) {
	        resetValue = 1;
	      }
	
	      return resetValue === undefined ? value : resetValue;
	    },
	    emitChange: function emitChange() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        if (_this2.internalCurrentPage !== _this2.lastEmittedPage || _this2.userChangePageSize) {
	          _this2.$emit('current-change', _this2.internalCurrentPage);
	          _this2.lastEmittedPage = _this2.internalCurrentPage;
	          _this2.userChangePageSize = false;
	        }
	      });
	    }
	  },
	
	  computed: {
	    internalPageCount: function internalPageCount() {
	      if (typeof this.total === 'number') {
	        return Math.max(1, Math.ceil(this.total / this.internalPageSize));
	      } else if (typeof this.pageCount === 'number') {
	        return Math.max(1, this.pageCount);
	      }
	      return null;
	    }
	  },
	
	  watch: {
	    currentPage: {
	      immediate: true,
	      handler: function handler(val) {
	        this.internalCurrentPage = this.getValidCurrentPage(val);
	      }
	    },
	
	    pageSize: {
	      immediate: true,
	      handler: function handler(val) {
	        this.internalPageSize = isNaN(val) ? 10 : val;
	      }
	    },
	
	    internalCurrentPage: {
	      immediate: true,
	      handler: function handler(newVal) {
	        this.$emit('update:currentPage', newVal);
	        this.lastEmittedPage = -1;
	      }
	    },
	
	    internalPageCount: function internalPageCount(newVal) {
	      /* istanbul ignore if */
	      var oldPage = this.internalCurrentPage;
	      if (newVal > 0 && oldPage === 0) {
	        this.internalCurrentPage = 1;
	      } else if (oldPage > newVal) {
	        this.internalCurrentPage = newVal === 0 ? 1 : newVal;
	        this.userChangePageSize && this.emitChange();
	      }
	      this.userChangePageSize = false;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/pagination/index.js
	
	
	/* istanbul ignore next */
	pagination.install = function (Vue) {
	  Vue.component(pagination.name, pagination);
	};
	
	/* harmony default export */ var packages_pagination = (pagination);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
	var componentvue_type_template_id_60140e62_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "dialog-fade" },
	      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-dialog__wrapper",
	          on: {
	            click: function($event) {
	              if ($event.target !== $event.currentTarget) {
	                return null
	              }
	              return _vm.handleWrapperClick($event)
	            }
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              key: _vm.key,
	              ref: "dialog",
	              class: [
	                "el-dialog",
	                {
	                  "is-fullscreen": _vm.fullscreen,
	                  "el-dialog--center": _vm.center
	                },
	                _vm.customClass
	              ],
	              style: _vm.style,
	              attrs: {
	                role: "dialog",
	                "aria-modal": "true",
	                "aria-label": _vm.title || "dialog"
	              }
	            },
	            [
	              _c(
	                "div",
	                { staticClass: "el-dialog__header" },
	                [
	                  _vm._t("title", [
	                    _c("span", { staticClass: "el-dialog__title" }, [
	                      _vm._v(_vm._s(_vm.title))
	                    ])
	                  ]),
	                  _vm.showClose
	                    ? _c(
	                        "button",
	                        {
	                          staticClass: "el-dialog__headerbtn",
	                          attrs: { type: "button", "aria-label": "Close" },
	                          on: { click: _vm.handleClose }
	                        },
	                        [
	                          _c("i", {
	                            staticClass:
	                              "el-dialog__close el-icon el-icon-close"
	                          })
	                        ]
	                      )
	                    : _vm._e()
	                ],
	                2
	              ),
	              _vm.rendered
	                ? _c(
	                    "div",
	                    { staticClass: "el-dialog__body" },
	                    [_vm._t("default")],
	                    2
	                  )
	                : _vm._e(),
	              _vm.$slots.footer
	                ? _c(
	                    "div",
	                    { staticClass: "el-dialog__footer" },
	                    [_vm._t("footer")],
	                    2
	                  )
	                : _vm._e()
	            ]
	          )
	        ]
	      )
	    ]
	  )
	}
	var componentvue_type_template_id_60140e62_staticRenderFns = []
	componentvue_type_template_id_60140e62_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/popup"
	var popup_ = __webpack_require__(13);
	var popup_default = /*#__PURE__*/__webpack_require__.n(popup_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
	var migrating_ = __webpack_require__(9);
	var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(3);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var componentvue_type_script_lang_js_ = ({
	  name: 'ElDialog',
	
	  mixins: [popup_default.a, emitter_default.a, migrating_default.a],
	
	  props: {
	    title: {
	      type: String,
	      default: ''
	    },
	
	    modal: {
	      type: Boolean,
	      default: true
	    },
	
	    modalAppendToBody: {
	      type: Boolean,
	      default: true
	    },
	
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	
	    lockScroll: {
	      type: Boolean,
	      default: true
	    },
	
	    closeOnClickModal: {
	      type: Boolean,
	      default: true
	    },
	
	    closeOnPressEscape: {
	      type: Boolean,
	      default: true
	    },
	
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	
	    width: String,
	
	    fullscreen: Boolean,
	
	    customClass: {
	      type: String,
	      default: ''
	    },
	
	    top: {
	      type: String,
	      default: '15vh'
	    },
	    beforeClose: Function,
	    center: {
	      type: Boolean,
	      default: false
	    },
	
	    destroyOnClose: Boolean
	  },
	
	  data: function data() {
	    return {
	      closed: false,
	      key: 0
	    };
	  },
	
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.closed = false;
	        this.$emit('open');
	        this.$el.addEventListener('scroll', this.updatePopper);
	        this.$nextTick(function () {
	          _this.$refs.dialog.scrollTop = 0;
	        });
	        if (this.appendToBody) {
	          document.body.appendChild(this.$el);
	        }
	      } else {
	        this.$el.removeEventListener('scroll', this.updatePopper);
	        if (!this.closed) this.$emit('close');
	        if (this.destroyOnClose) {
	          this.$nextTick(function () {
	            _this.key++;
	          });
	        }
	      }
	    }
	  },
	
	  computed: {
	    style: function style() {
	      var style = {};
	      if (!this.fullscreen) {
	        style.marginTop = this.top;
	        if (this.width) {
	          style.width = this.width;
	        }
	      }
	      return style;
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'size': 'size is removed.'
	        }
	      };
	    },
	    handleWrapperClick: function handleWrapperClick() {
	      if (!this.closeOnClickModal) return;
	      this.handleClose();
	    },
	    handleClose: function handleClose() {
	      if (typeof this.beforeClose === 'function') {
	        this.beforeClose(this.hide);
	      } else {
	        this.hide();
	      }
	    },
	    hide: function hide(cancel) {
	      if (cancel !== false) {
	        this.$emit('update:visible', false);
	        this.$emit('close');
	        this.closed = true;
	      }
	    },
	    updatePopper: function updatePopper() {
	      this.broadcast('ElSelectDropdown', 'updatePopper');
	      this.broadcast('ElDropdownMenu', 'updatePopper');
	    },
	    afterEnter: function afterEnter() {
	      this.$emit('opened');
	    },
	    afterLeave: function afterLeave() {
	      this.$emit('closed');
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.visible) {
	      this.rendered = true;
	      this.open();
	      if (this.appendToBody) {
	        document.body.appendChild(this.$el);
	      }
	    }
	  },
	  destroyed: function destroyed() {
	    // if appendToBody is true, remove DOM node after destroy
	    if (this.appendToBody && this.$el && this.$el.parentNode) {
	      this.$el.parentNode.removeChild(this.$el);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_componentvue_type_script_lang_js_ = (componentvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dialog/src/component.vue
	
	
	
	
	
	/* normalize component */
	
	var component_component = normalizeComponent(
	  src_componentvue_type_script_lang_js_,
	  componentvue_type_template_id_60140e62_render,
	  componentvue_type_template_id_60140e62_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var component_api; }
	component_component.options.__file = "packages/dialog/src/component.vue"
	/* harmony default export */ var src_component = (component_component.exports);
	// CONCATENATED MODULE: ./packages/dialog/index.js
	
	
	/* istanbul ignore next */
	src_component.install = function (Vue) {
	  Vue.component(src_component.name, src_component);
	};
	
	/* harmony default export */ var dialog = (src_component);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&
	var autocompletevue_type_template_id_152f2ee6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.close,
	          expression: "close"
	        }
	      ],
	      staticClass: "el-autocomplete",
	      attrs: {
	        "aria-haspopup": "listbox",
	        role: "combobox",
	        "aria-expanded": _vm.suggestionVisible,
	        "aria-owns": _vm.id
	      }
	    },
	    [
	      _c(
	        "el-input",
	        _vm._b(
	          {
	            ref: "input",
	            on: {
	              input: _vm.handleInput,
	              change: _vm.handleChange,
	              focus: _vm.handleFocus,
	              blur: _vm.handleBlur,
	              clear: _vm.handleClear
	            },
	            nativeOn: {
	              keydown: [
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "up", 38, $event.key, [
	                      "Up",
	                      "ArrowUp"
	                    ])
	                  ) {
	                    return null
	                  }
	                  $event.preventDefault()
	                  _vm.highlight(_vm.highlightedIndex - 1)
	                },
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "down", 40, $event.key, [
	                      "Down",
	                      "ArrowDown"
	                    ])
	                  ) {
	                    return null
	                  }
	                  $event.preventDefault()
	                  _vm.highlight(_vm.highlightedIndex + 1)
	                },
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.handleKeyEnter($event)
	                },
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                  ) {
	                    return null
	                  }
	                  return _vm.close($event)
	                }
	              ]
	            }
	          },
	          "el-input",
	          [_vm.$props, _vm.$attrs],
	          false
	        ),
	        [
	          _vm.$slots.prepend
	            ? _c("template", { slot: "prepend" }, [_vm._t("prepend")], 2)
	            : _vm._e(),
	          _vm.$slots.append
	            ? _c("template", { slot: "append" }, [_vm._t("append")], 2)
	            : _vm._e(),
	          _vm.$slots.prefix
	            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
	            : _vm._e(),
	          _vm.$slots.suffix
	            ? _c("template", { slot: "suffix" }, [_vm._t("suffix")], 2)
	            : _vm._e()
	        ],
	        2
	      ),
	      _c(
	        "el-autocomplete-suggestions",
	        {
	          ref: "suggestions",
	          class: [_vm.popperClass ? _vm.popperClass : ""],
	          attrs: {
	            "visible-arrow": "",
	            "popper-options": _vm.popperOptions,
	            "append-to-body": _vm.popperAppendToBody,
	            placement: _vm.placement,
	            id: _vm.id
	          }
	        },
	        _vm._l(_vm.suggestions, function(item, index) {
	          return _c(
	            "li",
	            {
	              key: index,
	              class: { highlighted: _vm.highlightedIndex === index },
	              attrs: {
	                id: _vm.id + "-item-" + index,
	                role: "option",
	                "aria-selected": _vm.highlightedIndex === index
	              },
	              on: {
	                click: function($event) {
	                  _vm.select(item)
	                }
	              }
	            },
	            [
	              _vm._t(
	                "default",
	                [
	                  _vm._v("\n        " + _vm._s(item[_vm.valueKey]) + "\n      ")
	                ],
	                { item: item }
	              )
	            ],
	            2
	          )
	        }),
	        0
	      )
	    ],
	    1
	  )
	}
	var autocompletevue_type_template_id_152f2ee6_staticRenderFns = []
	autocompletevue_type_template_id_152f2ee6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&
	
	// EXTERNAL MODULE: external "throttle-debounce/debounce"
	var debounce_ = __webpack_require__(14);
	var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
	var clickoutside_ = __webpack_require__(10);
	var clickoutside_default = /*#__PURE__*/__webpack_require__.n(clickoutside_);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&
	var autocomplete_suggestionsvue_type_template_id_cd10dcf0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.showPopper,
	              expression: "showPopper"
	            }
	          ],
	          staticClass: "el-autocomplete-suggestion el-popper",
	          class: {
	            "is-loading": !_vm.parent.hideLoading && _vm.parent.loading
	          },
	          style: { width: _vm.dropdownWidth },
	          attrs: { role: "region" }
	        },
	        [
	          _c(
	            "el-scrollbar",
	            {
	              attrs: {
	                tag: "ul",
	                "wrap-class": "el-autocomplete-suggestion__wrap",
	                "view-class": "el-autocomplete-suggestion__list"
	              }
	            },
	            [
	              !_vm.parent.hideLoading && _vm.parent.loading
	                ? _c("li", [_c("i", { staticClass: "el-icon-loading" })])
	                : _vm._t("default")
	            ],
	            2
	          )
	        ],
	        1
	      )
	    ]
	  )
	}
	var autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns = []
	autocomplete_suggestionsvue_type_template_id_cd10dcf0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
	var scrollbar_ = __webpack_require__(17);
	var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var autocomplete_suggestionsvue_type_script_lang_js_ = ({
	  components: { ElScrollbar: scrollbar_default.a },
	  mixins: [vue_popper_default.a, emitter_default.a],
	
	  componentName: 'ElAutocompleteSuggestions',
	
	  data: function data() {
	    return {
	      parent: this.$parent,
	      dropdownWidth: ''
	    };
	  },
	
	
	  props: {
	    options: {
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    },
	    id: String
	  },
	
	  methods: {
	    select: function select(item) {
	      this.dispatch('ElAutocomplete', 'item-click', item);
	    }
	  },
	
	  updated: function updated() {
	    var _this = this;
	
	    this.$nextTick(function (_) {
	      _this.popperJS && _this.updatePopper();
	    });
	  },
	  mounted: function mounted() {
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.referenceElm = this.$parent.$refs.input.$refs.input || this.$parent.$refs.input.$refs.textarea;
	    this.referenceList = this.$el.querySelector('.el-autocomplete-suggestion__list');
	    this.referenceList.setAttribute('role', 'listbox');
	    this.referenceList.setAttribute('id', this.id);
	  },
	  created: function created() {
	    var _this2 = this;
	
	    this.$on('visible', function (val, inputWidth) {
	      _this2.dropdownWidth = inputWidth + 'px';
	      _this2.showPopper = val;
	    });
	  }
	});
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_autocomplete_suggestionsvue_type_script_lang_js_ = (autocomplete_suggestionsvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue
	
	
	
	
	
	/* normalize component */
	
	var autocomplete_suggestions_component = normalizeComponent(
	  src_autocomplete_suggestionsvue_type_script_lang_js_,
	  autocomplete_suggestionsvue_type_template_id_cd10dcf0_render,
	  autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var autocomplete_suggestions_api; }
	autocomplete_suggestions_component.options.__file = "packages/autocomplete/src/autocomplete-suggestions.vue"
	/* harmony default export */ var autocomplete_suggestions = (autocomplete_suggestions_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
	var focus_ = __webpack_require__(22);
	var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var autocompletevue_type_script_lang_js_ = ({
	  name: 'ElAutocomplete',
	
	  mixins: [emitter_default.a, focus_default()('input'), migrating_default.a],
	
	  inheritAttrs: false,
	
	  componentName: 'ElAutocomplete',
	
	  components: {
	    ElInput: input_default.a,
	    ElAutocompleteSuggestions: autocomplete_suggestions
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  props: {
	    valueKey: {
	      type: String,
	      default: 'value'
	    },
	    popperClass: String,
	    popperOptions: Object,
	    placeholder: String,
	    clearable: {
	      type: Boolean,
	      default: false
	    },
	    disabled: Boolean,
	    name: String,
	    size: String,
	    value: String,
	    maxlength: Number,
	    minlength: Number,
	    autofocus: Boolean,
	    fetchSuggestions: Function,
	    triggerOnFocus: {
	      type: Boolean,
	      default: true
	    },
	    customItem: String,
	    selectWhenUnmatched: {
	      type: Boolean,
	      default: false
	    },
	    prefixIcon: String,
	    suffixIcon: String,
	    label: String,
	    debounce: {
	      type: Number,
	      default: 300
	    },
	    placement: {
	      type: String,
	      default: 'bottom-start'
	    },
	    hideLoading: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: true
	    },
	    highlightFirstItem: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      activated: false,
	      suggestions: [],
	      loading: false,
	      highlightedIndex: -1,
	      suggestionDisabled: false
	    };
	  },
	
	  computed: {
	    suggestionVisible: function suggestionVisible() {
	      var suggestions = this.suggestions;
	      var isValidData = Array.isArray(suggestions) && suggestions.length > 0;
	      return (isValidData || this.loading) && this.activated;
	    },
	    id: function id() {
	      return 'el-autocomplete-' + Object(util_["generateId"])();
	    }
	  },
	  watch: {
	    suggestionVisible: function suggestionVisible(val) {
	      var $input = this.getInput();
	      if ($input) {
	        this.broadcast('ElAutocompleteSuggestions', 'visible', [val, $input.offsetWidth]);
	      }
	    }
	  },
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'custom-item': 'custom-item is removed, use scoped slot instead.',
	          'props': 'props is removed, use value-key instead.'
	        }
	      };
	    },
	    getData: function getData(queryString) {
	      var _this = this;
	
	      if (this.suggestionDisabled) {
	        return;
	      }
	      this.loading = true;
	      this.fetchSuggestions(queryString, function (suggestions) {
	        _this.loading = false;
	        if (_this.suggestionDisabled) {
	          return;
	        }
	        if (Array.isArray(suggestions)) {
	          _this.suggestions = suggestions;
	          _this.highlightedIndex = _this.highlightFirstItem ? 0 : -1;
	        } else {
	          console.error('[Element Error][Autocomplete]autocomplete suggestions must be an array');
	        }
	      });
	    },
	    handleInput: function handleInput(value) {
	      this.$emit('input', value);
	      this.suggestionDisabled = false;
	      if (!this.triggerOnFocus && !value) {
	        this.suggestionDisabled = true;
	        this.suggestions = [];
	        return;
	      }
	      this.debouncedGetData(value);
	    },
	    handleChange: function handleChange(value) {
	      this.$emit('change', value);
	    },
	    handleFocus: function handleFocus(event) {
	      this.activated = true;
	      this.$emit('focus', event);
	      if (this.triggerOnFocus) {
	        this.debouncedGetData(this.value);
	      }
	    },
	    handleBlur: function handleBlur(event) {
	      this.$emit('blur', event);
	    },
	    handleClear: function handleClear() {
	      this.activated = false;
	      this.$emit('clear');
	    },
	    close: function close(e) {
	      this.activated = false;
	    },
	    handleKeyEnter: function handleKeyEnter(e) {
	      var _this2 = this;
	
	      if (this.suggestionVisible && this.highlightedIndex >= 0 && this.highlightedIndex < this.suggestions.length) {
	        e.preventDefault();
	        this.select(this.suggestions[this.highlightedIndex]);
	      } else if (this.selectWhenUnmatched) {
	        this.$emit('select', { value: this.value });
	        this.$nextTick(function (_) {
	          _this2.suggestions = [];
	          _this2.highlightedIndex = -1;
	        });
	      }
	    },
	    select: function select(item) {
	      var _this3 = this;
	
	      this.$emit('input', item[this.valueKey]);
	      this.$emit('select', item);
	      this.$nextTick(function (_) {
	        _this3.suggestions = [];
	        _this3.highlightedIndex = -1;
	      });
	    },
	    highlight: function highlight(index) {
	      if (!this.suggestionVisible || this.loading) {
	        return;
	      }
	      if (index < 0) {
	        this.highlightedIndex = -1;
	        return;
	      }
	      if (index >= this.suggestions.length) {
	        index = this.suggestions.length - 1;
	      }
	      var suggestion = this.$refs.suggestions.$el.querySelector('.el-autocomplete-suggestion__wrap');
	      var suggestionList = suggestion.querySelectorAll('.el-autocomplete-suggestion__list li');
	
	      var highlightItem = suggestionList[index];
	      var scrollTop = suggestion.scrollTop;
	      var offsetTop = highlightItem.offsetTop;
	
	      if (offsetTop + highlightItem.scrollHeight > scrollTop + suggestion.clientHeight) {
	        suggestion.scrollTop += highlightItem.scrollHeight;
	      }
	      if (offsetTop < scrollTop) {
	        suggestion.scrollTop -= highlightItem.scrollHeight;
	      }
	      this.highlightedIndex = index;
	      var $input = this.getInput();
	      $input.setAttribute('aria-activedescendant', this.id + '-item-' + this.highlightedIndex);
	    },
	    getInput: function getInput() {
	      return this.$refs.input.getInput();
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.debouncedGetData = debounce_default()(this.debounce, this.getData);
	    this.$on('item-click', function (item) {
	      _this4.select(item);
	    });
	    var $input = this.getInput();
	    $input.setAttribute('role', 'textbox');
	    $input.setAttribute('aria-autocomplete', 'list');
	    $input.setAttribute('aria-controls', 'id');
	    $input.setAttribute('aria-activedescendant', this.id + '-item-' + this.highlightedIndex);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.$refs.suggestions.$destroy();
	  }
	});
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_autocompletevue_type_script_lang_js_ = (autocompletevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue
	
	
	
	
	
	/* normalize component */
	
	var autocomplete_component = normalizeComponent(
	  src_autocompletevue_type_script_lang_js_,
	  autocompletevue_type_template_id_152f2ee6_render,
	  autocompletevue_type_template_id_152f2ee6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var autocomplete_api; }
	autocomplete_component.options.__file = "packages/autocomplete/src/autocomplete.vue"
	/* harmony default export */ var autocomplete = (autocomplete_component.exports);
	// CONCATENATED MODULE: ./packages/autocomplete/index.js
	
	
	/* istanbul ignore next */
	autocomplete.install = function (Vue) {
	  Vue.component(autocomplete.name, autocomplete);
	};
	
	/* harmony default export */ var packages_autocomplete = (autocomplete);
	// EXTERNAL MODULE: external "element-ui/lib/button"
	var button_ = __webpack_require__(11);
	var button_default = /*#__PURE__*/__webpack_require__.n(button_);
	
	// EXTERNAL MODULE: external "element-ui/lib/button-group"
	var button_group_ = __webpack_require__(28);
	var button_group_default = /*#__PURE__*/__webpack_require__.n(button_group_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	
	
	/* harmony default export */ var dropdownvue_type_script_lang_js_ = ({
	  name: 'ElDropdown',
	
	  componentName: 'ElDropdown',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  components: {
	    ElButton: button_default.a,
	    ElButtonGroup: button_group_default.a
	  },
	
	  provide: function provide() {
	    return {
	      dropdown: this
	    };
	  },
	
	
	  props: {
	    trigger: {
	      type: String,
	      default: 'hover'
	    },
	    type: String,
	    size: {
	      type: String,
	      default: ''
	    },
	    splitButton: Boolean,
	    hideOnClick: {
	      type: Boolean,
	      default: true
	    },
	    placement: {
	      type: String,
	      default: 'bottom-end'
	    },
	    visibleArrow: {
	      default: true
	    },
	    showTimeout: {
	      type: Number,
	      default: 250
	    },
	    hideTimeout: {
	      type: Number,
	      default: 150
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      timeout: null,
	      visible: false,
	      triggerElm: null,
	      menuItems: null,
	      menuItemsArray: null,
	      dropdownElm: null,
	      focusing: false,
	      listId: 'dropdown-menu-' + Object(util_["generateId"])()
	    };
	  },
	
	
	  computed: {
	    dropdownSize: function dropdownSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  mounted: function mounted() {
	    this.$on('menu-item-click', this.handleMenuItemClick);
	  },
	
	
	  watch: {
	    visible: function visible(val) {
	      this.broadcast('ElDropdownMenu', 'visible', val);
	      this.$emit('visible-change', val);
	    },
	    focusing: function focusing(val) {
	      var selfDefine = this.$el.querySelector('.el-dropdown-selfdefine');
	      if (selfDefine) {
	        // 自定义
	        if (val) {
	          selfDefine.className += ' focusing';
	        } else {
	          selfDefine.className = selfDefine.className.replace('focusing', '');
	        }
	      }
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'menu-align': 'menu-align is renamed to placement.'
	        }
	      };
	    },
	    show: function show() {
	      var _this = this;
	
	      if (this.triggerElm.disabled) return;
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this.visible = true;
	      }, this.trigger === 'click' ? 0 : this.showTimeout);
	    },
	    hide: function hide() {
	      var _this2 = this;
	
	      if (this.triggerElm.disabled) return;
	      this.removeTabindex();
	      if (this.tabindex >= 0) {
	        this.resetTabindex(this.triggerElm);
	      }
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this2.visible = false;
	      }, this.trigger === 'click' ? 0 : this.hideTimeout);
	    },
	    handleClick: function handleClick() {
	      if (this.triggerElm.disabled) return;
	      if (this.visible) {
	        this.hide();
	      } else {
	        this.show();
	      }
	    },
	    handleTriggerKeyDown: function handleTriggerKeyDown(ev) {
	      var keyCode = ev.keyCode;
	      if ([38, 40].indexOf(keyCode) > -1) {
	        // up/down
	        this.removeTabindex();
	        this.resetTabindex(this.menuItems[0]);
	        this.menuItems[0].focus();
	        ev.preventDefault();
	        ev.stopPropagation();
	      } else if (keyCode === 13) {
	        // space enter选中
	        this.handleClick();
	      } else if ([9, 27].indexOf(keyCode) > -1) {
	        // tab || esc
	        this.hide();
	      }
	    },
	    handleItemKeyDown: function handleItemKeyDown(ev) {
	      var keyCode = ev.keyCode;
	      var target = ev.target;
	      var currentIndex = this.menuItemsArray.indexOf(target);
	      var max = this.menuItemsArray.length - 1;
	      var nextIndex = void 0;
	      if ([38, 40].indexOf(keyCode) > -1) {
	        // up/down
	        if (keyCode === 38) {
	          // up
	          nextIndex = currentIndex !== 0 ? currentIndex - 1 : 0;
	        } else {
	          // down
	          nextIndex = currentIndex < max ? currentIndex + 1 : max;
	        }
	        this.removeTabindex();
	        this.resetTabindex(this.menuItems[nextIndex]);
	        this.menuItems[nextIndex].focus();
	        ev.preventDefault();
	        ev.stopPropagation();
	      } else if (keyCode === 13) {
	        // enter选中
	        this.triggerElmFocus();
	        target.click();
	        if (this.hideOnClick) {
	          // click关闭
	          this.visible = false;
	        }
	      } else if ([9, 27].indexOf(keyCode) > -1) {
	        // tab // esc
	        this.hide();
	        this.triggerElmFocus();
	      }
	    },
	    resetTabindex: function resetTabindex(ele) {
	      // 下次tab时组件聚焦元素
	      this.removeTabindex();
	      ele.setAttribute('tabindex', '0'); // 下次期望的聚焦元素
	    },
	    removeTabindex: function removeTabindex() {
	      this.triggerElm.setAttribute('tabindex', '-1');
	      this.menuItemsArray.forEach(function (item) {
	        item.setAttribute('tabindex', '-1');
	      });
	    },
	    initAria: function initAria() {
	      this.dropdownElm.setAttribute('id', this.listId);
	      this.triggerElm.setAttribute('aria-haspopup', 'list');
	      this.triggerElm.setAttribute('aria-controls', this.listId);
	
	      if (!this.splitButton) {
	        // 自定义
	        this.triggerElm.setAttribute('role', 'button');
	        this.triggerElm.setAttribute('tabindex', this.tabindex);
	        this.triggerElm.setAttribute('class', (this.triggerElm.getAttribute('class') || '') + ' el-dropdown-selfdefine'); // 控制
	      }
	    },
	    initEvent: function initEvent() {
	      var _this3 = this;
	
	      var trigger = this.trigger,
	          show = this.show,
	          hide = this.hide,
	          handleClick = this.handleClick,
	          splitButton = this.splitButton,
	          handleTriggerKeyDown = this.handleTriggerKeyDown,
	          handleItemKeyDown = this.handleItemKeyDown;
	
	      this.triggerElm = splitButton ? this.$refs.trigger.$el : this.$slots.default[0].elm;
	
	      var dropdownElm = this.dropdownElm;
	
	      this.triggerElm.addEventListener('keydown', handleTriggerKeyDown); // triggerElm keydown
	      dropdownElm.addEventListener('keydown', handleItemKeyDown, true); // item keydown
	      // 控制自定义元素的样式
	      if (!splitButton) {
	        this.triggerElm.addEventListener('focus', function () {
	          _this3.focusing = true;
	        });
	        this.triggerElm.addEventListener('blur', function () {
	          _this3.focusing = false;
	        });
	        this.triggerElm.addEventListener('click', function () {
	          _this3.focusing = false;
	        });
	      }
	      if (trigger === 'hover') {
	        this.triggerElm.addEventListener('mouseenter', show);
	        this.triggerElm.addEventListener('mouseleave', hide);
	        dropdownElm.addEventListener('mouseenter', show);
	        dropdownElm.addEventListener('mouseleave', hide);
	      } else if (trigger === 'click') {
	        this.triggerElm.addEventListener('click', handleClick);
	      }
	    },
	    handleMenuItemClick: function handleMenuItemClick(command, instance) {
	      if (this.hideOnClick) {
	        this.visible = false;
	      }
	      this.$emit('command', command, instance);
	    },
	    triggerElmFocus: function triggerElmFocus() {
	      this.triggerElm.focus && this.triggerElm.focus();
	    },
	    initDomOperation: function initDomOperation() {
	      this.dropdownElm = this.popperElm;
	      this.menuItems = this.dropdownElm.querySelectorAll("[tabindex='-1']");
	      this.menuItemsArray = [].slice.call(this.menuItems);
	
	      this.initEvent();
	      this.initAria();
	    }
	  },
	
	  render: function render(h) {
	    var _this4 = this;
	
	    var hide = this.hide,
	        splitButton = this.splitButton,
	        type = this.type,
	        dropdownSize = this.dropdownSize;
	
	
	    var handleMainButtonClick = function handleMainButtonClick(event) {
	      _this4.$emit('click', event);
	      hide();
	    };
	
	    var triggerElm = !splitButton ? this.$slots.default : h('el-button-group', [h(
	      'el-button',
	      {
	        attrs: { type: type, size: dropdownSize },
	        nativeOn: {
	          'click': handleMainButtonClick
	        }
	      },
	      [this.$slots.default]
	    ), h(
	      'el-button',
	      { ref: 'trigger', attrs: { type: type, size: dropdownSize },
	        'class': 'el-dropdown__caret-button' },
	      [h('i', { 'class': 'el-dropdown__icon el-icon-arrow-down' })]
	    )]);
	
	    return h(
	      'div',
	      { 'class': 'el-dropdown', directives: [{
	          name: 'clickoutside',
	          value: hide
	        }]
	      },
	      [triggerElm, this.$slots.dropdown]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_dropdownvue_type_script_lang_js_ = (dropdownvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue
	var dropdown_render, dropdown_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var dropdown_component = normalizeComponent(
	  src_dropdownvue_type_script_lang_js_,
	  dropdown_render,
	  dropdown_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var dropdown_api; }
	dropdown_component.options.__file = "packages/dropdown/src/dropdown.vue"
	/* harmony default export */ var dropdown = (dropdown_component.exports);
	// CONCATENATED MODULE: ./packages/dropdown/index.js
	
	
	/* istanbul ignore next */
	dropdown.install = function (Vue) {
	  Vue.component(dropdown.name, dropdown);
	};
	
	/* harmony default export */ var packages_dropdown = (dropdown);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&
	var dropdown_menuvue_type_template_id_0da6b714_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
	    [
	      _c(
	        "ul",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.showPopper,
	              expression: "showPopper"
	            }
	          ],
	          staticClass: "el-dropdown-menu el-popper",
	          class: [_vm.size && "el-dropdown-menu--" + _vm.size]
	        },
	        [_vm._t("default")],
	        2
	      )
	    ]
	  )
	}
	var dropdown_menuvue_type_template_id_0da6b714_staticRenderFns = []
	dropdown_menuvue_type_template_id_0da6b714_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var dropdown_menuvue_type_script_lang_js_ = ({
	  name: 'ElDropdownMenu',
	
	  componentName: 'ElDropdownMenu',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    visibleArrow: {
	      type: Boolean,
	      default: true
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      size: this.dropdown.dropdownSize
	    };
	  },
	
	
	  inject: ['dropdown'],
	
	  created: function created() {
	    var _this = this;
	
	    this.$on('updatePopper', function () {
	      if (_this.showPopper) _this.updatePopper();
	    });
	    this.$on('visible', function (val) {
	      _this.showPopper = val;
	    });
	  },
	  mounted: function mounted() {
	    this.dropdown.popperElm = this.popperElm = this.$el;
	    this.referenceElm = this.dropdown.$el;
	    // compatible with 2.6 new v-slot syntax
	    // issue link https://github.com/ElemeFE/element/issues/14345
	    this.dropdown.initDomOperation();
	  },
	
	
	  watch: {
	    'dropdown.placement': {
	      immediate: true,
	      handler: function handler(val) {
	        this.currentPlacement = val;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_dropdown_menuvue_type_script_lang_js_ = (dropdown_menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue
	
	
	
	
	
	/* normalize component */
	
	var dropdown_menu_component = normalizeComponent(
	  src_dropdown_menuvue_type_script_lang_js_,
	  dropdown_menuvue_type_template_id_0da6b714_render,
	  dropdown_menuvue_type_template_id_0da6b714_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var dropdown_menu_api; }
	dropdown_menu_component.options.__file = "packages/dropdown/src/dropdown-menu.vue"
	/* harmony default export */ var dropdown_menu = (dropdown_menu_component.exports);
	// CONCATENATED MODULE: ./packages/dropdown-menu/index.js
	
	
	/* istanbul ignore next */
	dropdown_menu.install = function (Vue) {
	  Vue.component(dropdown_menu.name, dropdown_menu);
	};
	
	/* harmony default export */ var packages_dropdown_menu = (dropdown_menu);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&
	var dropdown_itemvue_type_template_id_6359102a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      staticClass: "el-dropdown-menu__item",
	      class: {
	        "is-disabled": _vm.disabled,
	        "el-dropdown-menu__item--divided": _vm.divided
	      },
	      attrs: {
	        "aria-disabled": _vm.disabled,
	        tabindex: _vm.disabled ? null : -1
	      },
	      on: { click: _vm.handleClick }
	    },
	    [_vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(), _vm._t("default")],
	    2
	  )
	}
	var dropdown_itemvue_type_template_id_6359102a_staticRenderFns = []
	dropdown_itemvue_type_template_id_6359102a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var dropdown_itemvue_type_script_lang_js_ = ({
	  name: 'ElDropdownItem',
	
	  mixins: [emitter_default.a],
	
	  props: {
	    command: {},
	    disabled: Boolean,
	    divided: Boolean,
	    icon: String
	  },
	
	  methods: {
	    handleClick: function handleClick(e) {
	      this.dispatch('ElDropdown', 'menu-item-click', [this.command, this]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_dropdown_itemvue_type_script_lang_js_ = (dropdown_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue
	
	
	
	
	
	/* normalize component */
	
	var dropdown_item_component = normalizeComponent(
	  src_dropdown_itemvue_type_script_lang_js_,
	  dropdown_itemvue_type_template_id_6359102a_render,
	  dropdown_itemvue_type_template_id_6359102a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var dropdown_item_api; }
	dropdown_item_component.options.__file = "packages/dropdown/src/dropdown-item.vue"
	/* harmony default export */ var dropdown_item = (dropdown_item_component.exports);
	// CONCATENATED MODULE: ./packages/dropdown-item/index.js
	
	
	/* istanbul ignore next */
	dropdown_item.install = function (Vue) {
	  Vue.component(dropdown_item.name, dropdown_item);
	};
	
	/* harmony default export */ var packages_dropdown_item = (dropdown_item);
	// CONCATENATED MODULE: ./src/utils/aria-utils.js
	var aria = aria || {};
	
	aria.Utils = aria.Utils || {};
	
	/**
	 * @desc Set focus on descendant nodes until the first focusable element is
	 *       found.
	 * @param element
	 *          DOM node for which to find the first focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	aria.Utils.focusFirstDescendant = function (element) {
	  for (var i = 0; i < element.childNodes.length; i++) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Find the last descendant node that is focusable.
	 * @param element
	 *          DOM node for which to find the last focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	
	aria.Utils.focusLastDescendant = function (element) {
	  for (var i = element.childNodes.length - 1; i >= 0; i--) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Set Attempt to set focus on the current node.
	 * @param element
	 *          The node to attempt to focus on.
	 * @returns
	 *  true if element is focused.
	 */
	aria.Utils.attemptFocus = function (element) {
	  if (!aria.Utils.isFocusable(element)) {
	    return false;
	  }
	  aria.Utils.IgnoreUtilFocusChanges = true;
	  try {
	    element.focus();
	  } catch (e) {}
	  aria.Utils.IgnoreUtilFocusChanges = false;
	  return document.activeElement === element;
	};
	
	aria.Utils.isFocusable = function (element) {
	  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
	    return true;
	  }
	
	  if (element.disabled) {
	    return false;
	  }
	
	  switch (element.nodeName) {
	    case 'A':
	      return !!element.href && element.rel !== 'ignore';
	    case 'INPUT':
	      return element.type !== 'hidden' && element.type !== 'file';
	    case 'BUTTON':
	    case 'SELECT':
	    case 'TEXTAREA':
	      return true;
	    default:
	      return false;
	  }
	};
	
	/**
	 * 触发一个事件
	 * mouseenter, mouseleave, mouseover, keyup, change, click 等
	 * @param  {Element} elm
	 * @param  {String} name
	 * @param  {*} opts
	 */
	aria.Utils.triggerEvent = function (elm, name) {
	  var eventName = void 0;
	
	  if (/^mouse|click/.test(name)) {
	    eventName = 'MouseEvents';
	  } else if (/^key/.test(name)) {
	    eventName = 'KeyboardEvent';
	  } else {
	    eventName = 'HTMLEvents';
	  }
	  var evt = document.createEvent(eventName);
	
	  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    opts[_key - 2] = arguments[_key];
	  }
	
	  evt.initEvent.apply(evt, [name].concat(opts));
	  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);
	
	  return elm;
	};
	
	aria.Utils.keys = {
	  tab: 9,
	  enter: 13,
	  space: 32,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  esc: 27
	};
	
	/* harmony default export */ var aria_utils = (aria.Utils);
	// CONCATENATED MODULE: ./src/utils/menu/aria-submenu.js
	
	
	var SubMenu = function SubMenu(parent, domNode) {
	  this.domNode = domNode;
	  this.parent = parent;
	  this.subMenuItems = [];
	  this.subIndex = 0;
	  this.init();
	};
	
	SubMenu.prototype.init = function () {
	  this.subMenuItems = this.domNode.querySelectorAll('li');
	  this.addListeners();
	};
	
	SubMenu.prototype.gotoSubIndex = function (idx) {
	  if (idx === this.subMenuItems.length) {
	    idx = 0;
	  } else if (idx < 0) {
	    idx = this.subMenuItems.length - 1;
	  }
	  this.subMenuItems[idx].focus();
	  this.subIndex = idx;
	};
	
	SubMenu.prototype.addListeners = function () {
	  var _this = this;
	
	  var keys = aria_utils.keys;
	  var parentNode = this.parent.domNode;
	  Array.prototype.forEach.call(this.subMenuItems, function (el) {
	    el.addEventListener('keydown', function (event) {
	      var prevDef = false;
	      switch (event.keyCode) {
	        case keys.down:
	          _this.gotoSubIndex(_this.subIndex + 1);
	          prevDef = true;
	          break;
	        case keys.up:
	          _this.gotoSubIndex(_this.subIndex - 1);
	          prevDef = true;
	          break;
	        case keys.tab:
	          aria_utils.triggerEvent(parentNode, 'mouseleave');
	          break;
	        case keys.enter:
	        case keys.space:
	          prevDef = true;
	          event.currentTarget.click();
	          break;
	      }
	      if (prevDef) {
	        event.preventDefault();
	        event.stopPropagation();
	      }
	      return false;
	    });
	  });
	};
	
	/* harmony default export */ var aria_submenu = (SubMenu);
	// CONCATENATED MODULE: ./src/utils/menu/aria-menuitem.js
	
	
	
	var MenuItem = function MenuItem(domNode) {
	  this.domNode = domNode;
	  this.submenu = null;
	  this.init();
	};
	
	MenuItem.prototype.init = function () {
	  this.domNode.setAttribute('tabindex', '0');
	  var menuChild = this.domNode.querySelector('.el-menu');
	  if (menuChild) {
	    this.submenu = new aria_submenu(this, menuChild);
	  }
	  this.addListeners();
	};
	
	MenuItem.prototype.addListeners = function () {
	  var _this = this;
	
	  var keys = aria_utils.keys;
	  this.domNode.addEventListener('keydown', function (event) {
	    var prevDef = false;
	    switch (event.keyCode) {
	      case keys.down:
	        aria_utils.triggerEvent(event.currentTarget, 'mouseenter');
	        _this.submenu && _this.submenu.gotoSubIndex(0);
	        prevDef = true;
	        break;
	      case keys.up:
	        aria_utils.triggerEvent(event.currentTarget, 'mouseenter');
	        _this.submenu && _this.submenu.gotoSubIndex(_this.submenu.subMenuItems.length - 1);
	        prevDef = true;
	        break;
	      case keys.tab:
	        aria_utils.triggerEvent(event.currentTarget, 'mouseleave');
	        break;
	      case keys.enter:
	      case keys.space:
	        prevDef = true;
	        event.currentTarget.click();
	        break;
	    }
	    if (prevDef) {
	      event.preventDefault();
	    }
	  });
	};
	
	/* harmony default export */ var aria_menuitem = (MenuItem);
	// CONCATENATED MODULE: ./src/utils/menu/aria-menubar.js
	
	
	var Menu = function Menu(domNode) {
	  this.domNode = domNode;
	  this.init();
	};
	
	Menu.prototype.init = function () {
	  var menuChildren = this.domNode.childNodes;
	  [].filter.call(menuChildren, function (child) {
	    return child.nodeType === 1;
	  }).forEach(function (child) {
	    new aria_menuitem(child); // eslint-disable-line
	  });
	};
	/* harmony default export */ var aria_menubar = (Menu);
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(1);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	/* harmony default export */ var menuvue_type_script_lang_js_ = ({
	  name: 'ElMenu',
	
	  render: function render(h) {
	    var component = h(
	      'ul',
	      {
	        attrs: {
	          role: 'menubar'
	        },
	        key: +this.collapse,
	        style: { backgroundColor: this.backgroundColor || '' },
	        'class': {
	          'el-menu--horizontal': this.mode === 'horizontal',
	          'el-menu--collapse': this.collapse,
	          "el-menu": true
	        }
	      },
	      [this.$slots.default]
	    );
	
	    if (this.collapseTransition) {
	      return h('el-menu-collapse-transition', [component]);
	    } else {
	      return component;
	    }
	  },
	
	
	  componentName: 'ElMenu',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  provide: function provide() {
	    return {
	      rootMenu: this
	    };
	  },
	
	
	  components: {
	    'el-menu-collapse-transition': {
	      functional: true,
	      render: function render(createElement, context) {
	        var data = {
	          props: {
	            mode: 'out-in'
	          },
	          on: {
	            beforeEnter: function beforeEnter(el) {
	              el.style.opacity = 0.2;
	            },
	            enter: function enter(el) {
	              Object(dom_["addClass"])(el, 'el-opacity-transition');
	              el.style.opacity = 1;
	            },
	            afterEnter: function afterEnter(el) {
	              Object(dom_["removeClass"])(el, 'el-opacity-transition');
	              el.style.opacity = '';
	            },
	            beforeLeave: function beforeLeave(el) {
	              if (!el.dataset) el.dataset = {};
	
	              if (Object(dom_["hasClass"])(el, 'el-menu--collapse')) {
	                Object(dom_["removeClass"])(el, 'el-menu--collapse');
	                el.dataset.oldOverflow = el.style.overflow;
	                el.dataset.scrollWidth = el.clientWidth;
	                Object(dom_["addClass"])(el, 'el-menu--collapse');
	              } else {
	                Object(dom_["addClass"])(el, 'el-menu--collapse');
	                el.dataset.oldOverflow = el.style.overflow;
	                el.dataset.scrollWidth = el.clientWidth;
	                Object(dom_["removeClass"])(el, 'el-menu--collapse');
	              }
	
	              el.style.width = el.scrollWidth + 'px';
	              el.style.overflow = 'hidden';
	            },
	            leave: function leave(el) {
	              Object(dom_["addClass"])(el, 'horizontal-collapse-transition');
	              el.style.width = el.dataset.scrollWidth + 'px';
	            }
	          }
	        };
	        return createElement('transition', data, context.children);
	      }
	    }
	  },
	
	  props: {
	    mode: {
	      type: String,
	      default: 'vertical'
	    },
	    defaultActive: {
	      type: String,
	      default: ''
	    },
	    defaultOpeneds: Array,
	    uniqueOpened: Boolean,
	    router: Boolean,
	    menuTrigger: {
	      type: String,
	      default: 'hover'
	    },
	    collapse: Boolean,
	    backgroundColor: String,
	    textColor: String,
	    activeTextColor: String,
	    collapseTransition: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      activeIndex: this.defaultActive,
	      openedMenus: this.defaultOpeneds && !this.collapse ? this.defaultOpeneds.slice(0) : [],
	      items: {},
	      submenus: {}
	    };
	  },
	
	  computed: {
	    hoverBackground: function hoverBackground() {
	      return this.backgroundColor ? this.mixColor(this.backgroundColor, 0.2) : '';
	    },
	    isMenuPopup: function isMenuPopup() {
	      return this.mode === 'horizontal' || this.mode === 'vertical' && this.collapse;
	    }
	  },
	  watch: {
	    defaultActive: function defaultActive(value) {
	      if (!this.items[value]) {
	        this.activeIndex = null;
	      }
	      this.updateActiveIndex(value);
	    },
	    defaultOpeneds: function defaultOpeneds(value) {
	      if (!this.collapse) {
	        this.openedMenus = value;
	      }
	    },
	    collapse: function collapse(value) {
	      if (value) this.openedMenus = [];
	      this.broadcast('ElSubmenu', 'toggle-collapse', value);
	    }
	  },
	  methods: {
	    updateActiveIndex: function updateActiveIndex(val) {
	      var item = this.items[val] || this.items[this.activeIndex] || this.items[this.defaultActive];
	      if (item) {
	        this.activeIndex = item.index;
	        this.initOpenedMenu();
	      } else {
	        this.activeIndex = null;
	      }
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'theme': 'theme is removed.'
	        }
	      };
	    },
	    getColorChannels: function getColorChannels(color) {
	      color = color.replace('#', '');
	      if (/^[0-9a-fA-F]{3}$/.test(color)) {
	        color = color.split('');
	        for (var i = 2; i >= 0; i--) {
	          color.splice(i, 0, color[i]);
	        }
	        color = color.join('');
	      }
	      if (/^[0-9a-fA-F]{6}$/.test(color)) {
	        return {
	          red: parseInt(color.slice(0, 2), 16),
	          green: parseInt(color.slice(2, 4), 16),
	          blue: parseInt(color.slice(4, 6), 16)
	        };
	      } else {
	        return {
	          red: 255,
	          green: 255,
	          blue: 255
	        };
	      }
	    },
	    mixColor: function mixColor(color, percent) {
	      var _getColorChannels = this.getColorChannels(color),
	          red = _getColorChannels.red,
	          green = _getColorChannels.green,
	          blue = _getColorChannels.blue;
	
	      if (percent > 0) {
	        // shade given color
	        red *= 1 - percent;
	        green *= 1 - percent;
	        blue *= 1 - percent;
	      } else {
	        // tint given color
	        red += (255 - red) * percent;
	        green += (255 - green) * percent;
	        blue += (255 - blue) * percent;
	      }
	      return 'rgb(' + Math.round(red) + ', ' + Math.round(green) + ', ' + Math.round(blue) + ')';
	    },
	    addItem: function addItem(item) {
	      this.$set(this.items, item.index, item);
	    },
	    removeItem: function removeItem(item) {
	      delete this.items[item.index];
	    },
	    addSubmenu: function addSubmenu(item) {
	      this.$set(this.submenus, item.index, item);
	    },
	    removeSubmenu: function removeSubmenu(item) {
	      delete this.submenus[item.index];
	    },
	    openMenu: function openMenu(index, indexPath) {
	      var openedMenus = this.openedMenus;
	      if (openedMenus.indexOf(index) !== -1) return;
	      // 将不在该菜单路径下的其余菜单收起
	      // collapse all menu that are not under current menu item
	      if (this.uniqueOpened) {
	        this.openedMenus = openedMenus.filter(function (index) {
	          return indexPath.indexOf(index) !== -1;
	        });
	      }
	      this.openedMenus.push(index);
	    },
	    closeMenu: function closeMenu(index) {
	      var i = this.openedMenus.indexOf(index);
	      if (i !== -1) {
	        this.openedMenus.splice(i, 1);
	      }
	    },
	    handleSubmenuClick: function handleSubmenuClick(submenu) {
	      var index = submenu.index,
	          indexPath = submenu.indexPath;
	
	      var isOpened = this.openedMenus.indexOf(index) !== -1;
	
	      if (isOpened) {
	        this.closeMenu(index);
	        this.$emit('close', index, indexPath);
	      } else {
	        this.openMenu(index, indexPath);
	        this.$emit('open', index, indexPath);
	      }
	    },
	    handleItemClick: function handleItemClick(item) {
	      var _this = this;
	
	      var index = item.index,
	          indexPath = item.indexPath;
	
	      var oldActiveIndex = this.activeIndex;
	      var hasIndex = item.index !== null;
	
	      if (hasIndex) {
	        this.activeIndex = item.index;
	      }
	
	      this.$emit('select', index, indexPath, item);
	
	      if (this.mode === 'horizontal' || this.collapse) {
	        this.openedMenus = [];
	      }
	
	      if (this.router && hasIndex) {
	        this.routeToItem(item, function (error) {
	          _this.activeIndex = oldActiveIndex;
	          if (error) {
	            // vue-router 3.1.0+ push/replace cause NavigationDuplicated error 
	            // https://github.com/ElemeFE/element/issues/17044
	            if (error.name === 'NavigationDuplicated') return;
	            console.error(error);
	          }
	        });
	      }
	    },
	
	    // 初始化展开菜单
	    // initialize opened menu
	    initOpenedMenu: function initOpenedMenu() {
	      var _this2 = this;
	
	      var index = this.activeIndex;
	      var activeItem = this.items[index];
	      if (!activeItem || this.mode === 'horizontal' || this.collapse) return;
	
	      var indexPath = activeItem.indexPath;
	
	      // 展开该菜单项的路径上所有子菜单
	      // expand all submenus of the menu item
	      indexPath.forEach(function (index) {
	        var submenu = _this2.submenus[index];
	        submenu && _this2.openMenu(index, submenu.indexPath);
	      });
	    },
	    routeToItem: function routeToItem(item, onError) {
	      var route = item.route || item.index;
	      try {
	        this.$router.push(route, function () {}, onError);
	      } catch (e) {
	        console.error(e);
	      }
	    },
	    open: function open(index) {
	      var _this3 = this;
	
	      var indexPath = this.submenus[index.toString()].indexPath;
	
	      indexPath.forEach(function (i) {
	        return _this3.openMenu(i, indexPath);
	      });
	    },
	    close: function close(index) {
	      this.closeMenu(index);
	    }
	  },
	  mounted: function mounted() {
	    this.initOpenedMenu();
	    this.$on('item-click', this.handleItemClick);
	    this.$on('submenu-click', this.handleSubmenuClick);
	    if (this.mode === 'horizontal') {
	      new aria_menubar(this.$el); // eslint-disable-line
	    }
	    this.$watch('items', this.updateActiveIndex);
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_menuvue_type_script_lang_js_ = (menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/menu.vue
	var menu_render, menu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var menu_component = normalizeComponent(
	  src_menuvue_type_script_lang_js_,
	  menu_render,
	  menu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var menu_api; }
	menu_component.options.__file = "packages/menu/src/menu.vue"
	/* harmony default export */ var src_menu = (menu_component.exports);
	// CONCATENATED MODULE: ./packages/menu/index.js
	
	
	/* istanbul ignore next */
	src_menu.install = function (Vue) {
	  Vue.component(src_menu.name, src_menu);
	};
	
	/* harmony default export */ var packages_menu = (src_menu);
	// EXTERNAL MODULE: external "element-ui/lib/transitions/collapse-transition"
	var collapse_transition_ = __webpack_require__(21);
	var collapse_transition_default = /*#__PURE__*/__webpack_require__.n(collapse_transition_);
	
	// CONCATENATED MODULE: ./packages/menu/src/menu-mixin.js
	/* harmony default export */ var menu_mixin = ({
	  inject: ['rootMenu'],
	  computed: {
	    indexPath: function indexPath() {
	      var path = [this.index];
	      var parent = this.$parent;
	      while (parent.$options.componentName !== 'ElMenu') {
	        if (parent.index) {
	          path.unshift(parent.index);
	        }
	        parent = parent.$parent;
	      }
	      return path;
	    },
	    parentMenu: function parentMenu() {
	      var parent = this.$parent;
	      while (parent && ['ElMenu', 'ElSubmenu'].indexOf(parent.$options.componentName) === -1) {
	        parent = parent.$parent;
	      }
	      return parent;
	    },
	    paddingStyle: function paddingStyle() {
	      if (this.rootMenu.mode !== 'vertical') return {};
	
	      var padding = 20;
	      var parent = this.$parent;
	
	      if (this.rootMenu.collapse) {
	        padding = 20;
	      } else {
	        while (parent && parent.$options.componentName !== 'ElMenu') {
	          if (parent.$options.componentName === 'ElSubmenu') {
	            padding += 20;
	          }
	          parent = parent.$parent;
	        }
	      }
	      return { paddingLeft: padding + 'px' };
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/submenu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	var poperMixins = {
	  props: {
	    transformOrigin: {
	      type: [Boolean, String],
	      default: false
	    },
	    offset: vue_popper_default.a.props.offset,
	    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
	    popperOptions: vue_popper_default.a.props.popperOptions
	  },
	  data: vue_popper_default.a.data,
	  methods: vue_popper_default.a.methods,
	  beforeDestroy: vue_popper_default.a.beforeDestroy,
	  deactivated: vue_popper_default.a.deactivated
	};
	
	/* harmony default export */ var submenuvue_type_script_lang_js_ = ({
	  name: 'ElSubmenu',
	
	  componentName: 'ElSubmenu',
	
	  mixins: [menu_mixin, emitter_default.a, poperMixins],
	
	  components: { ElCollapseTransition: collapse_transition_default.a },
	
	  props: {
	    index: {
	      type: String,
	      required: true
	    },
	    showTimeout: {
	      type: Number,
	      default: 300
	    },
	    hideTimeout: {
	      type: Number,
	      default: 300
	    },
	    popperClass: String,
	    disabled: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: undefined
	    }
	  },
	
	  data: function data() {
	    return {
	      popperJS: null,
	      timeout: null,
	      items: {},
	      submenus: {},
	      mouseInChild: false
	    };
	  },
	
	  watch: {
	    opened: function opened(val) {
	      var _this = this;
	
	      if (this.isMenuPopup) {
	        this.$nextTick(function (_) {
	          _this.updatePopper();
	        });
	      }
	    }
	  },
	  computed: {
	    // popper option
	    appendToBody: function appendToBody() {
	      return this.popperAppendToBody === undefined ? this.isFirstLevel : this.popperAppendToBody;
	    },
	    menuTransitionName: function menuTransitionName() {
	      return this.rootMenu.collapse ? 'el-zoom-in-left' : 'el-zoom-in-top';
	    },
	    opened: function opened() {
	      return this.rootMenu.openedMenus.indexOf(this.index) > -1;
	    },
	    active: function active() {
	      var isActive = false;
	      var submenus = this.submenus;
	      var items = this.items;
	
	      Object.keys(items).forEach(function (index) {
	        if (items[index].active) {
	          isActive = true;
	        }
	      });
	
	      Object.keys(submenus).forEach(function (index) {
	        if (submenus[index].active) {
	          isActive = true;
	        }
	      });
	
	      return isActive;
	    },
	    hoverBackground: function hoverBackground() {
	      return this.rootMenu.hoverBackground;
	    },
	    backgroundColor: function backgroundColor() {
	      return this.rootMenu.backgroundColor || '';
	    },
	    activeTextColor: function activeTextColor() {
	      return this.rootMenu.activeTextColor || '';
	    },
	    textColor: function textColor() {
	      return this.rootMenu.textColor || '';
	    },
	    mode: function mode() {
	      return this.rootMenu.mode;
	    },
	    isMenuPopup: function isMenuPopup() {
	      return this.rootMenu.isMenuPopup;
	    },
	    titleStyle: function titleStyle() {
	      if (this.mode !== 'horizontal') {
	        return {
	          color: this.textColor
	        };
	      }
	      return {
	        borderBottomColor: this.active ? this.rootMenu.activeTextColor ? this.activeTextColor : '' : 'transparent',
	        color: this.active ? this.activeTextColor : this.textColor
	      };
	    },
	    isFirstLevel: function isFirstLevel() {
	      var isFirstLevel = true;
	      var parent = this.$parent;
	      while (parent && parent !== this.rootMenu) {
	        if (['ElSubmenu', 'ElMenuItemGroup'].indexOf(parent.$options.componentName) > -1) {
	          isFirstLevel = false;
	          break;
	        } else {
	          parent = parent.$parent;
	        }
	      }
	      return isFirstLevel;
	    }
	  },
	  methods: {
	    handleCollapseToggle: function handleCollapseToggle(value) {
	      if (value) {
	        this.initPopper();
	      } else {
	        this.doDestroy();
	      }
	    },
	    addItem: function addItem(item) {
	      this.$set(this.items, item.index, item);
	    },
	    removeItem: function removeItem(item) {
	      delete this.items[item.index];
	    },
	    addSubmenu: function addSubmenu(item) {
	      this.$set(this.submenus, item.index, item);
	    },
	    removeSubmenu: function removeSubmenu(item) {
	      delete this.submenus[item.index];
	    },
	    handleClick: function handleClick() {
	      var rootMenu = this.rootMenu,
	          disabled = this.disabled;
	
	      if (rootMenu.menuTrigger === 'hover' && rootMenu.mode === 'horizontal' || rootMenu.collapse && rootMenu.mode === 'vertical' || disabled) {
	        return;
	      }
	      this.dispatch('ElMenu', 'submenu-click', this);
	    },
	    handleMouseenter: function handleMouseenter(event) {
	      var _this2 = this;
	
	      var showTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.showTimeout;
	
	
	      if (!('ActiveXObject' in window) && event.type === 'focus' && !event.relatedTarget) {
	        return;
	      }
	      var rootMenu = this.rootMenu,
	          disabled = this.disabled;
	
	      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical' || disabled) {
	        return;
	      }
	      this.dispatch('ElSubmenu', 'mouse-enter-child');
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this2.rootMenu.openMenu(_this2.index, _this2.indexPath);
	      }, showTimeout);
	
	      if (this.appendToBody) {
	        this.$parent.$el.dispatchEvent(new MouseEvent('mouseenter'));
	      }
	    },
	    handleMouseleave: function handleMouseleave() {
	      var _this3 = this;
	
	      var deepDispatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var rootMenu = this.rootMenu;
	
	      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical') {
	        return;
	      }
	      this.dispatch('ElSubmenu', 'mouse-leave-child');
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        !_this3.mouseInChild && _this3.rootMenu.closeMenu(_this3.index);
	      }, this.hideTimeout);
	
	      if (this.appendToBody && deepDispatch) {
	        if (this.$parent.$options.name === 'ElSubmenu') {
	          this.$parent.handleMouseleave(true);
	        }
	      }
	    },
	    handleTitleMouseenter: function handleTitleMouseenter() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      var title = this.$refs['submenu-title'];
	      title && (title.style.backgroundColor = this.rootMenu.hoverBackground);
	    },
	    handleTitleMouseleave: function handleTitleMouseleave() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      var title = this.$refs['submenu-title'];
	      title && (title.style.backgroundColor = this.rootMenu.backgroundColor || '');
	    },
	    updatePlacement: function updatePlacement() {
	      this.currentPlacement = this.mode === 'horizontal' && this.isFirstLevel ? 'bottom-start' : 'right-start';
	    },
	    initPopper: function initPopper() {
	      this.referenceElm = this.$el;
	      this.popperElm = this.$refs.menu;
	      this.updatePlacement();
	    }
	  },
	  created: function created() {
	    var _this4 = this;
	
	    this.$on('toggle-collapse', this.handleCollapseToggle);
	    this.$on('mouse-enter-child', function () {
	      _this4.mouseInChild = true;
	      clearTimeout(_this4.timeout);
	    });
	    this.$on('mouse-leave-child', function () {
	      _this4.mouseInChild = false;
	      clearTimeout(_this4.timeout);
	    });
	  },
	  mounted: function mounted() {
	    this.parentMenu.addSubmenu(this);
	    this.rootMenu.addSubmenu(this);
	    this.initPopper();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.parentMenu.removeSubmenu(this);
	    this.rootMenu.removeSubmenu(this);
	  },
	  render: function render(h) {
	    var _this5 = this;
	
	    var active = this.active,
	        opened = this.opened,
	        paddingStyle = this.paddingStyle,
	        titleStyle = this.titleStyle,
	        backgroundColor = this.backgroundColor,
	        rootMenu = this.rootMenu,
	        currentPlacement = this.currentPlacement,
	        menuTransitionName = this.menuTransitionName,
	        mode = this.mode,
	        disabled = this.disabled,
	        popperClass = this.popperClass,
	        $slots = this.$slots,
	        isFirstLevel = this.isFirstLevel;
	
	
	    var popupMenu = h(
	      'transition',
	      {
	        attrs: { name: menuTransitionName }
	      },
	      [h(
	        'div',
	        {
	          ref: 'menu',
	          directives: [{
	            name: 'show',
	            value: opened
	          }],
	
	          'class': ['el-menu--' + mode, popperClass],
	          on: {
	            'mouseenter': function mouseenter($event) {
	              return _this5.handleMouseenter($event, 100);
	            },
	            'mouseleave': function mouseleave() {
	              return _this5.handleMouseleave(true);
	            },
	            'focus': function focus($event) {
	              return _this5.handleMouseenter($event, 100);
	            }
	          }
	        },
	        [h(
	          'ul',
	          {
	            attrs: {
	              role: 'menu'
	            },
	            'class': ['el-menu el-menu--popup', 'el-menu--popup-' + currentPlacement],
	            style: { backgroundColor: rootMenu.backgroundColor || '' } },
	          [$slots.default]
	        )]
	      )]
	    );
	
	    var inlineMenu = h('el-collapse-transition', [h(
	      'ul',
	      {
	        attrs: {
	          role: 'menu'
	        },
	        'class': 'el-menu el-menu--inline',
	        directives: [{
	          name: 'show',
	          value: opened
	        }],
	
	        style: { backgroundColor: rootMenu.backgroundColor || '' } },
	      [$slots.default]
	    )]);
	
	    var submenuTitleIcon = rootMenu.mode === 'horizontal' && isFirstLevel || rootMenu.mode === 'vertical' && !rootMenu.collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-right';
	
	    return h(
	      'li',
	      {
	        'class': {
	          'el-submenu': true,
	          'is-active': active,
	          'is-opened': opened,
	          'is-disabled': disabled
	        },
	        attrs: { role: 'menuitem',
	          'aria-haspopup': 'true',
	          'aria-expanded': opened
	        },
	        on: {
	          'mouseenter': this.handleMouseenter,
	          'mouseleave': function mouseleave() {
	            return _this5.handleMouseleave(false);
	          },
	          'focus': this.handleMouseenter
	        }
	      },
	      [h(
	        'div',
	        {
	          'class': 'el-submenu__title',
	          ref: 'submenu-title',
	          on: {
	            'click': this.handleClick,
	            'mouseenter': this.handleTitleMouseenter,
	            'mouseleave': this.handleTitleMouseleave
	          },
	
	          style: [paddingStyle, titleStyle, { backgroundColor: backgroundColor }]
	        },
	        [$slots.title, h('i', { 'class': ['el-submenu__icon-arrow', submenuTitleIcon] })]
	      ), this.isMenuPopup ? popupMenu : inlineMenu]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/submenu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_submenuvue_type_script_lang_js_ = (submenuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/submenu.vue
	var submenu_render, submenu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var submenu_component = normalizeComponent(
	  src_submenuvue_type_script_lang_js_,
	  submenu_render,
	  submenu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var submenu_api; }
	submenu_component.options.__file = "packages/menu/src/submenu.vue"
	/* harmony default export */ var submenu = (submenu_component.exports);
	// CONCATENATED MODULE: ./packages/submenu/index.js
	
	
	/* istanbul ignore next */
	submenu.install = function (Vue) {
	  Vue.component(submenu.name, submenu);
	};
	
	/* harmony default export */ var packages_submenu = (submenu);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
	var menu_itemvue_type_template_id_2a5dbfea_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      staticClass: "el-menu-item",
	      class: {
	        "is-active": _vm.active,
	        "is-disabled": _vm.disabled
	      },
	      style: [
	        _vm.paddingStyle,
	        _vm.itemStyle,
	        { backgroundColor: _vm.backgroundColor }
	      ],
	      attrs: { role: "menuitem", tabindex: "-1" },
	      on: {
	        click: _vm.handleClick,
	        mouseenter: _vm.onMouseEnter,
	        focus: _vm.onMouseEnter,
	        blur: _vm.onMouseLeave,
	        mouseleave: _vm.onMouseLeave
	      }
	    },
	    [
	      _vm.parentMenu.$options.componentName === "ElMenu" &&
	      _vm.rootMenu.collapse &&
	      _vm.$slots.title
	        ? _c("el-tooltip", { attrs: { effect: "dark", placement: "right" } }, [
	            _c(
	              "div",
	              { attrs: { slot: "content" }, slot: "content" },
	              [_vm._t("title")],
	              2
	            ),
	            _c(
	              "div",
	              {
	                staticStyle: {
	                  position: "absolute",
	                  left: "0",
	                  top: "0",
	                  height: "100%",
	                  width: "100%",
	                  display: "inline-block",
	                  "box-sizing": "border-box",
	                  padding: "0 20px"
	                }
	              },
	              [_vm._t("default")],
	              2
	            )
	          ])
	        : [_vm._t("default"), _vm._t("title")]
	    ],
	    2
	  )
	}
	var menu_itemvue_type_template_id_2a5dbfea_staticRenderFns = []
	menu_itemvue_type_template_id_2a5dbfea_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
	
	// EXTERNAL MODULE: external "element-ui/lib/tooltip"
	var tooltip_ = __webpack_require__(26);
	var tooltip_default = /*#__PURE__*/__webpack_require__.n(tooltip_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var menu_itemvue_type_script_lang_js_ = ({
	  name: 'ElMenuItem',
	
	  componentName: 'ElMenuItem',
	
	  mixins: [menu_mixin, emitter_default.a],
	
	  components: { ElTooltip: tooltip_default.a },
	
	  props: {
	    index: {
	      default: null,
	      validator: function validator(val) {
	        return typeof val === 'string' || val === null;
	      }
	    },
	    route: [String, Object],
	    disabled: Boolean
	  },
	  computed: {
	    active: function active() {
	      return this.index === this.rootMenu.activeIndex;
	    },
	    hoverBackground: function hoverBackground() {
	      return this.rootMenu.hoverBackground;
	    },
	    backgroundColor: function backgroundColor() {
	      return this.rootMenu.backgroundColor || '';
	    },
	    activeTextColor: function activeTextColor() {
	      return this.rootMenu.activeTextColor || '';
	    },
	    textColor: function textColor() {
	      return this.rootMenu.textColor || '';
	    },
	    mode: function mode() {
	      return this.rootMenu.mode;
	    },
	    itemStyle: function itemStyle() {
	      var style = {
	        color: this.active ? this.activeTextColor : this.textColor
	      };
	      if (this.mode === 'horizontal' && !this.isNested) {
	        style.borderBottomColor = this.active ? this.rootMenu.activeTextColor ? this.activeTextColor : '' : 'transparent';
	      }
	      return style;
	    },
	    isNested: function isNested() {
	      return this.parentMenu !== this.rootMenu;
	    }
	  },
	  methods: {
	    onMouseEnter: function onMouseEnter() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      this.$el.style.backgroundColor = this.hoverBackground;
	    },
	    onMouseLeave: function onMouseLeave() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      this.$el.style.backgroundColor = this.backgroundColor;
	    },
	    handleClick: function handleClick() {
	      if (!this.disabled) {
	        this.dispatch('ElMenu', 'item-click', this);
	        this.$emit('click', this);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.parentMenu.addItem(this);
	    this.rootMenu.addItem(this);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.parentMenu.removeItem(this);
	    this.rootMenu.removeItem(this);
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_menu_itemvue_type_script_lang_js_ = (menu_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue
	
	
	
	
	
	/* normalize component */
	
	var menu_item_component = normalizeComponent(
	  src_menu_itemvue_type_script_lang_js_,
	  menu_itemvue_type_template_id_2a5dbfea_render,
	  menu_itemvue_type_template_id_2a5dbfea_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var menu_item_api; }
	menu_item_component.options.__file = "packages/menu/src/menu-item.vue"
	/* harmony default export */ var menu_item = (menu_item_component.exports);
	// CONCATENATED MODULE: ./packages/menu-item/index.js
	
	
	/* istanbul ignore next */
	menu_item.install = function (Vue) {
	  Vue.component(menu_item.name, menu_item);
	};
	
	/* harmony default export */ var packages_menu_item = (menu_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&
	var menu_item_groupvue_type_template_id_543b7bdc_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("li", { staticClass: "el-menu-item-group" }, [
	    _c(
	      "div",
	      {
	        staticClass: "el-menu-item-group__title",
	        style: { paddingLeft: _vm.levelPadding + "px" }
	      },
	      [!_vm.$slots.title ? [_vm._v(_vm._s(_vm.title))] : _vm._t("title")],
	      2
	    ),
	    _c("ul", [_vm._t("default")], 2)
	  ])
	}
	var menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns = []
	menu_item_groupvue_type_template_id_543b7bdc_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var menu_item_groupvue_type_script_lang_js_ = ({
	  name: 'ElMenuItemGroup',
	
	  componentName: 'ElMenuItemGroup',
	
	  inject: ['rootMenu'],
	  props: {
	    title: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {
	      paddingLeft: 20
	    };
	  },
	
	  computed: {
	    levelPadding: function levelPadding() {
	      var padding = 20;
	      var parent = this.$parent;
	      if (this.rootMenu.collapse) return 20;
	      while (parent && parent.$options.componentName !== 'ElMenu') {
	        if (parent.$options.componentName === 'ElSubmenu') {
	          padding += 20;
	        }
	        parent = parent.$parent;
	      }
	      return padding;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_menu_item_groupvue_type_script_lang_js_ = (menu_item_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue
	
	
	
	
	
	/* normalize component */
	
	var menu_item_group_component = normalizeComponent(
	  src_menu_item_groupvue_type_script_lang_js_,
	  menu_item_groupvue_type_template_id_543b7bdc_render,
	  menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var menu_item_group_api; }
	menu_item_group_component.options.__file = "packages/menu/src/menu-item-group.vue"
	/* harmony default export */ var menu_item_group = (menu_item_group_component.exports);
	// CONCATENATED MODULE: ./packages/menu-item-group/index.js
	
	
	/* istanbul ignore next */
	menu_item_group.install = function (Vue) {
	  Vue.component(menu_item_group.name, menu_item_group);
	};
	
	/* harmony default export */ var packages_menu_item_group = (menu_item_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
	var inputvue_type_template_id_343dd774_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        _vm.type === "textarea" ? "el-textarea" : "el-input",
	        _vm.inputSize ? "el-input--" + _vm.inputSize : "",
	        {
	          "is-disabled": _vm.inputDisabled,
	          "is-exceed": _vm.inputExceed,
	          "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
	          "el-input-group--append": _vm.$slots.append,
	          "el-input-group--prepend": _vm.$slots.prepend,
	          "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
	          "el-input--suffix":
	            _vm.$slots.suffix ||
	            _vm.suffixIcon ||
	            _vm.clearable ||
	            _vm.showPassword
	        }
	      ],
	      on: {
	        mouseenter: function($event) {
	          _vm.hovering = true
	        },
	        mouseleave: function($event) {
	          _vm.hovering = false
	        }
	      }
	    },
	    [
	      _vm.type !== "textarea"
	        ? [
	            _vm.$slots.prepend
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__prepend" },
	                  [_vm._t("prepend")],
	                  2
	                )
	              : _vm._e(),
	            _vm.type !== "textarea"
	              ? _c(
	                  "input",
	                  _vm._b(
	                    {
	                      ref: "input",
	                      staticClass: "el-input__inner",
	                      attrs: {
	                        tabindex: _vm.tabindex,
	                        type: _vm.showPassword
	                          ? _vm.passwordVisible
	                            ? "text"
	                            : "password"
	                          : _vm.type,
	                        disabled: _vm.inputDisabled,
	                        readonly: _vm.readonly,
	                        autocomplete: _vm.autoComplete || _vm.autocomplete,
	                        "aria-label": _vm.label
	                      },
	                      on: {
	                        compositionstart: _vm.handleCompositionStart,
	                        compositionupdate: _vm.handleCompositionUpdate,
	                        compositionend: _vm.handleCompositionEnd,
	                        input: _vm.handleInput,
	                        focus: _vm.handleFocus,
	                        blur: _vm.handleBlur,
	                        change: _vm.handleChange
	                      }
	                    },
	                    "input",
	                    _vm.$attrs,
	                    false
	                  )
	                )
	              : _vm._e(),
	            _vm.$slots.prefix || _vm.prefixIcon
	              ? _c(
	                  "span",
	                  { staticClass: "el-input__prefix" },
	                  [
	                    _vm._t("prefix"),
	                    _vm.prefixIcon
	                      ? _c("i", {
	                          staticClass: "el-input__icon",
	                          class: _vm.prefixIcon
	                        })
	                      : _vm._e()
	                  ],
	                  2
	                )
	              : _vm._e(),
	            _vm.getSuffixVisible()
	              ? _c("span", { staticClass: "el-input__suffix" }, [
	                  _c(
	                    "span",
	                    { staticClass: "el-input__suffix-inner" },
	                    [
	                      !_vm.showClear ||
	                      !_vm.showPwdVisible ||
	                      !_vm.isWordLimitVisible
	                        ? [
	                            _vm._t("suffix"),
	                            _vm.suffixIcon
	                              ? _c("i", {
	                                  staticClass: "el-input__icon",
	                                  class: _vm.suffixIcon
	                                })
	                              : _vm._e()
	                          ]
	                        : _vm._e(),
	                      _vm.showClear
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-circle-close el-input__clear",
	                            on: {
	                              mousedown: function($event) {
	                                $event.preventDefault()
	                              },
	                              click: _vm.clear
	                            }
	                          })
	                        : _vm._e(),
	                      _vm.showPwdVisible
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-view el-input__clear",
	                            on: { click: _vm.handlePasswordVisible }
	                          })
	                        : _vm._e(),
	                      _vm.isWordLimitVisible
	                        ? _c("span", { staticClass: "el-input__count" }, [
	                            _c(
	                              "span",
	                              { staticClass: "el-input__count-inner" },
	                              [
	                                _vm._v(
	                                  "\n            " +
	                                    _vm._s(_vm.textLength) +
	                                    "/" +
	                                    _vm._s(_vm.upperLimit) +
	                                    "\n          "
	                                )
	                              ]
	                            )
	                          ])
	                        : _vm._e()
	                    ],
	                    2
	                  ),
	                  _vm.validateState
	                    ? _c("i", {
	                        staticClass: "el-input__icon",
	                        class: ["el-input__validateIcon", _vm.validateIcon]
	                      })
	                    : _vm._e()
	                ])
	              : _vm._e(),
	            _vm.$slots.append
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__append" },
	                  [_vm._t("append")],
	                  2
	                )
	              : _vm._e()
	          ]
	        : _c(
	            "textarea",
	            _vm._b(
	              {
	                ref: "textarea",
	                staticClass: "el-textarea__inner",
	                style: _vm.textareaStyle,
	                attrs: {
	                  tabindex: _vm.tabindex,
	                  disabled: _vm.inputDisabled,
	                  readonly: _vm.readonly,
	                  autocomplete: _vm.autoComplete || _vm.autocomplete,
	                  "aria-label": _vm.label
	                },
	                on: {
	                  compositionstart: _vm.handleCompositionStart,
	                  compositionupdate: _vm.handleCompositionUpdate,
	                  compositionend: _vm.handleCompositionEnd,
	                  input: _vm.handleInput,
	                  focus: _vm.handleFocus,
	                  blur: _vm.handleBlur,
	                  change: _vm.handleChange
	                }
	              },
	              "textarea",
	              _vm.$attrs,
	              false
	            )
	          ),
	      _vm.isWordLimitVisible && _vm.type === "textarea"
	        ? _c("span", { staticClass: "el-input__count" }, [
	            _vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))
	          ])
	        : _vm._e()
	    ],
	    2
	  )
	}
	var inputvue_type_template_id_343dd774_staticRenderFns = []
	inputvue_type_template_id_343dd774_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&
	
	// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
	var hiddenTextarea = void 0;
	
	var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
	
	var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	
	function calculateNodeStyling(targetElement) {
	  var style = window.getComputedStyle(targetElement);
	
	  var boxSizing = style.getPropertyValue('box-sizing');
	
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	
	  var contextStyle = CONTEXT_STYLE.map(function (name) {
	    return name + ':' + style.getPropertyValue(name);
	  }).join(';');
	
	  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
	}
	
	function calcTextareaHeight(targetElement) {
	  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  }
	
	  var _calculateNodeStyling = calculateNodeStyling(targetElement),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      contextStyle = _calculateNodeStyling.contextStyle;
	
	  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
	  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';
	
	  var height = hiddenTextarea.scrollHeight;
	  var result = {};
	
	  if (boxSizing === 'border-box') {
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    height = height - paddingSize;
	  }
	
	  hiddenTextarea.value = '';
	  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	  if (minRows !== null) {
	    var minHeight = singleRowHeight * minRows;
	    if (boxSizing === 'border-box') {
	      minHeight = minHeight + paddingSize + borderSize;
	    }
	    height = Math.max(minHeight, height);
	    result.minHeight = minHeight + 'px';
	  }
	  if (maxRows !== null) {
	    var maxHeight = singleRowHeight * maxRows;
	    if (boxSizing === 'border-box') {
	      maxHeight = maxHeight + paddingSize + borderSize;
	    }
	    height = Math.min(maxHeight, height);
	  }
	  result.height = height + 'px';
	  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
	  hiddenTextarea = null;
	  return result;
	};
	// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
	var merge_ = __webpack_require__(7);
	var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(19);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	/* harmony default export */ var inputvue_type_script_lang_js_ = ({
	  name: 'ElInput',
	
	  componentName: 'ElInput',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  inheritAttrs: false,
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      textareaCalcStyle: {},
	      hovering: false,
	      focused: false,
	      isComposing: false,
	      passwordVisible: false
	    };
	  },
	
	
	  props: {
	    value: [String, Number],
	    size: String,
	    resize: String,
	    form: String,
	    disabled: Boolean,
	    readonly: Boolean,
	    type: {
	      type: String,
	      default: 'text'
	    },
	    autosize: {
	      type: [Boolean, Object],
	      default: false
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    validateEvent: {
	      type: Boolean,
	      default: true
	    },
	    suffixIcon: String,
	    prefixIcon: String,
	    label: String,
	    clearable: {
	      type: Boolean,
	      default: false
	    },
	    showPassword: {
	      type: Boolean,
	      default: false
	    },
	    showWordLimit: {
	      type: Boolean,
	      default: false
	    },
	    tabindex: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    validateState: function validateState() {
	      return this.elFormItem ? this.elFormItem.validateState : '';
	    },
	    needStatusIcon: function needStatusIcon() {
	      return this.elForm ? this.elForm.statusIcon : false;
	    },
	    validateIcon: function validateIcon() {
	      return {
	        validating: 'el-icon-loading',
	        success: 'el-icon-circle-check',
	        error: 'el-icon-circle-close'
	      }[this.validateState];
	    },
	    textareaStyle: function textareaStyle() {
	      return merge_default()({}, this.textareaCalcStyle, { resize: this.resize });
	    },
	    inputSize: function inputSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputDisabled: function inputDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    nativeInputValue: function nativeInputValue() {
	      return this.value === null || this.value === undefined ? '' : String(this.value);
	    },
	    showClear: function showClear() {
	      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
	    },
	    showPwdVisible: function showPwdVisible() {
	      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
	    },
	    isWordLimitVisible: function isWordLimitVisible() {
	      return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
	    },
	    upperLimit: function upperLimit() {
	      return this.$attrs.maxlength;
	    },
	    textLength: function textLength() {
	      if (typeof this.value === 'number') {
	        return String(this.value).length;
	      }
	
	      return (this.value || '').length;
	    },
	    inputExceed: function inputExceed() {
	      // show exceed style if length of initial value greater then maxlength
	      return this.isWordLimitVisible && this.textLength > this.upperLimit;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.$nextTick(this.resizeTextarea);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', [val]);
	      }
	    },
	
	    // native input value is set explicitly
	    // do not use v-model / :value in template
	    // see: https://github.com/ElemeFE/element/issues/14521
	    nativeInputValue: function nativeInputValue() {
	      this.setNativeInputValue();
	    },
	
	    // when change between <input> and <textarea>,
	    // update DOM dependent value and styles
	    // https://github.com/ElemeFE/element/issues/14857
	    type: function type() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.setNativeInputValue();
	        _this.resizeTextarea();
	        _this.updateIconOffset();
	      });
	    }
	  },
	
	  methods: {
	    focus: function focus() {
	      this.getInput().focus();
	    },
	    blur: function blur() {
	      this.getInput().blur();
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
	          'on-icon-click': 'on-icon-click is removed.'
	        },
	        events: {
	          'click': 'click is removed.'
	        }
	      };
	    },
	    handleBlur: function handleBlur(event) {
	      this.focused = false;
	      this.$emit('blur', event);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
	      }
	    },
	    select: function select() {
	      this.getInput().select();
	    },
	    resizeTextarea: function resizeTextarea() {
	      if (this.$isServer) return;
	      var autosize = this.autosize,
	          type = this.type;
	
	      if (type !== 'textarea') return;
	      if (!autosize) {
	        this.textareaCalcStyle = {
	          minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
	        };
	        return;
	      }
	      var minRows = autosize.minRows;
	      var maxRows = autosize.maxRows;
	
	      this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
	    },
	    setNativeInputValue: function setNativeInputValue() {
	      var input = this.getInput();
	      if (!input) return;
	      if (input.value === this.nativeInputValue) return;
	      input.value = this.nativeInputValue;
	    },
	    handleFocus: function handleFocus(event) {
	      this.focused = true;
	      this.$emit('focus', event);
	    },
	    handleCompositionStart: function handleCompositionStart() {
	      this.isComposing = true;
	    },
	    handleCompositionUpdate: function handleCompositionUpdate(event) {
	      var text = event.target.value;
	      var lastCharacter = text[text.length - 1] || '';
	      this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
	    },
	    handleCompositionEnd: function handleCompositionEnd(event) {
	      if (this.isComposing) {
	        this.isComposing = false;
	        this.handleInput(event);
	      }
	    },
	    handleInput: function handleInput(event) {
	      // should not emit input during composition
	      // see: https://github.com/ElemeFE/element/issues/10516
	      if (this.isComposing) return;
	
	      // hack for https://github.com/ElemeFE/element/issues/8548
	      // should remove the following line when we don't support IE
	      if (event.target.value === this.nativeInputValue) return;
	
	      this.$emit('input', event.target.value);
	
	      // ensure native input value is controlled
	      // see: https://github.com/ElemeFE/element/issues/12850
	      this.$nextTick(this.setNativeInputValue);
	    },
	    handleChange: function handleChange(event) {
	      this.$emit('change', event.target.value);
	    },
	    calcIconOffset: function calcIconOffset(place) {
	      var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
	      if (!elList.length) return;
	      var el = null;
	      for (var i = 0; i < elList.length; i++) {
	        if (elList[i].parentNode === this.$el) {
	          el = elList[i];
	          break;
	        }
	      }
	      if (!el) return;
	      var pendantMap = {
	        suffix: 'append',
	        prefix: 'prepend'
	      };
	
	      var pendant = pendantMap[place];
	      if (this.$slots[pendant]) {
	        el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
	      } else {
	        el.removeAttribute('style');
	      }
	    },
	    updateIconOffset: function updateIconOffset() {
	      this.calcIconOffset('prefix');
	      this.calcIconOffset('suffix');
	    },
	    clear: function clear() {
	      this.$emit('input', '');
	      this.$emit('change', '');
	      this.$emit('clear');
	    },
	    handlePasswordVisible: function handlePasswordVisible() {
	      this.passwordVisible = !this.passwordVisible;
	      this.focus();
	    },
	    getInput: function getInput() {
	      return this.$refs.input || this.$refs.textarea;
	    },
	    getSuffixVisible: function getSuffixVisible() {
	      return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
	    }
	  },
	
	  created: function created() {
	    this.$on('inputSelect', this.select);
	  },
	  mounted: function mounted() {
	    this.setNativeInputValue();
	    this.resizeTextarea();
	    this.updateIconOffset();
	  },
	  updated: function updated() {
	    this.$nextTick(this.updateIconOffset);
	  }
	});
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/input/src/input.vue
	
	
	
	
	
	/* normalize component */
	
	var input_component = normalizeComponent(
	  src_inputvue_type_script_lang_js_,
	  inputvue_type_template_id_343dd774_render,
	  inputvue_type_template_id_343dd774_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var input_api; }
	input_component.options.__file = "packages/input/src/input.vue"
	/* harmony default export */ var src_input = (input_component.exports);
	// CONCATENATED MODULE: ./packages/input/index.js
	
	
	/* istanbul ignore next */
	src_input.install = function (Vue) {
	  Vue.component(src_input.name, src_input);
	};
	
	/* harmony default export */ var packages_input = (src_input);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	var input_numbervue_type_template_id_42f8cf66_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        "el-input-number",
	        _vm.inputNumberSize ? "el-input-number--" + _vm.inputNumberSize : "",
	        { "is-disabled": _vm.inputNumberDisabled },
	        { "is-without-controls": !_vm.controls },
	        { "is-controls-right": _vm.controlsAtRight }
	      ],
	      on: {
	        dragstart: function($event) {
	          $event.preventDefault()
	        }
	      }
	    },
	    [
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.decrease,
	                  expression: "decrease"
	                }
	              ],
	              staticClass: "el-input-number__decrease",
	              class: { "is-disabled": _vm.minDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.decrease($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class:
	                  "el-icon-" + (_vm.controlsAtRight ? "arrow-down" : "minus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.increase,
	                  expression: "increase"
	                }
	              ],
	              staticClass: "el-input-number__increase",
	              class: { "is-disabled": _vm.maxDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.increase($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class: "el-icon-" + (_vm.controlsAtRight ? "arrow-up" : "plus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _c("el-input", {
	        ref: "input",
	        attrs: {
	          value: _vm.displayValue,
	          placeholder: _vm.placeholder,
	          disabled: _vm.inputNumberDisabled,
	          size: _vm.inputNumberSize,
	          max: _vm.max,
	          min: _vm.min,
	          name: _vm.name,
	          label: _vm.label
	        },
	        on: {
	          blur: _vm.handleBlur,
	          focus: _vm.handleFocus,
	          input: _vm.handleInput,
	          change: _vm.handleInputChange
	        },
	        nativeOn: {
	          keydown: [
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.increase($event)
	            },
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "down", 40, $event.key, [
	                  "Down",
	                  "ArrowDown"
	                ])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.decrease($event)
	            }
	          ]
	        }
	      })
	    ],
	    1
	  )
	}
	var input_numbervue_type_template_id_42f8cf66_staticRenderFns = []
	input_numbervue_type_template_id_42f8cf66_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	
	// CONCATENATED MODULE: ./src/directives/repeat-click.js
	
	
	/* harmony default export */ var repeat_click = ({
	  bind: function bind(el, binding, vnode) {
	    var interval = null;
	    var startTime = void 0;
	    var handler = function handler() {
	      return vnode.context[binding.expression].apply();
	    };
	    var clear = function clear() {
	      if (Date.now() - startTime < 100) {
	        handler();
	      }
	      clearInterval(interval);
	      interval = null;
	    };
	
	    Object(dom_["on"])(el, 'mousedown', function (e) {
	      if (e.button !== 0) return;
	      startTime = Date.now();
	      Object(dom_["once"])(document, 'mouseup', clear);
	      clearInterval(interval);
	      interval = setInterval(handler, 100);
	    });
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var input_numbervue_type_script_lang_js_ = ({
	  name: 'ElInputNumber',
	  mixins: [focus_default()('input')],
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	  directives: {
	    repeatClick: repeat_click
	  },
	  components: {
	    ElInput: input_default.a
	  },
	  props: {
	    step: {
	      type: Number,
	      default: 1
	    },
	    stepStrictly: {
	      type: Boolean,
	      default: false
	    },
	    max: {
	      type: Number,
	      default: Infinity
	    },
	    min: {
	      type: Number,
	      default: -Infinity
	    },
	    value: {},
	    disabled: Boolean,
	    size: String,
	    controls: {
	      type: Boolean,
	      default: true
	    },
	    controlsPosition: {
	      type: String,
	      default: ''
	    },
	    name: String,
	    label: String,
	    placeholder: String,
	    precision: {
	      type: Number,
	      validator: function validator(val) {
	        return val >= 0 && val === parseInt(val, 10);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: 0,
	      userInput: null
	    };
	  },
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(value) {
	        var newVal = value === undefined ? value : Number(value);
	        if (newVal !== undefined) {
	          if (isNaN(newVal)) {
	            return;
	          }
	
	          if (this.stepStrictly) {
	            var stepPrecision = this.getPrecision(this.step);
	            var precisionFactor = Math.pow(10, stepPrecision);
	            newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
	          }
	
	          if (this.precision !== undefined) {
	            newVal = this.toPrecision(newVal, this.precision);
	          }
	        }
	        if (newVal >= this.max) newVal = this.max;
	        if (newVal <= this.min) newVal = this.min;
	        this.currentValue = newVal;
	        this.userInput = null;
	        this.$emit('input', newVal);
	      }
	    }
	  },
	  computed: {
	    minDisabled: function minDisabled() {
	      return this._decrease(this.value, this.step) < this.min;
	    },
	    maxDisabled: function maxDisabled() {
	      return this._increase(this.value, this.step) > this.max;
	    },
	    numPrecision: function numPrecision() {
	      var value = this.value,
	          step = this.step,
	          getPrecision = this.getPrecision,
	          precision = this.precision;
	
	      var stepPrecision = getPrecision(step);
	      if (precision !== undefined) {
	        if (stepPrecision > precision) {
	          console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
	        }
	        return precision;
	      } else {
	        return Math.max(getPrecision(value), stepPrecision);
	      }
	    },
	    controlsAtRight: function controlsAtRight() {
	      return this.controls && this.controlsPosition === 'right';
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    inputNumberSize: function inputNumberSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputNumberDisabled: function inputNumberDisabled() {
	      return this.disabled || !!(this.elForm || {}).disabled;
	    },
	    displayValue: function displayValue() {
	      if (this.userInput !== null) {
	        return this.userInput;
	      }
	
	      var currentValue = this.currentValue;
	
	      if (typeof currentValue === 'number') {
	        if (this.stepStrictly) {
	          var stepPrecision = this.getPrecision(this.step);
	          var precisionFactor = Math.pow(10, stepPrecision);
	          currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
	        }
	
	        if (this.precision !== undefined) {
	          currentValue = currentValue.toFixed(this.precision);
	        }
	      }
	
	      return currentValue;
	    }
	  },
	  methods: {
	    toPrecision: function toPrecision(num, precision) {
	      if (precision === undefined) precision = this.numPrecision;
	      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
	    },
	    getPrecision: function getPrecision(value) {
	      if (value === undefined) return 0;
	      var valueString = value.toString();
	      var dotPosition = valueString.indexOf('.');
	      var precision = 0;
	      if (dotPosition !== -1) {
	        precision = valueString.length - dotPosition - 1;
	      }
	      return precision;
	    },
	    _increase: function _increase(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
	      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
	    },
	    _decrease: function _decrease(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	
	      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
	    },
	    increase: function increase() {
	      if (this.inputNumberDisabled || this.maxDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._increase(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    decrease: function decrease() {
	      if (this.inputNumberDisabled || this.minDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._decrease(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    handleBlur: function handleBlur(event) {
	      this.$emit('blur', event);
	    },
	    handleFocus: function handleFocus(event) {
	      this.$emit('focus', event);
	    },
	    setCurrentValue: function setCurrentValue(newVal) {
	      var oldVal = this.currentValue;
	      if (typeof newVal === 'number' && this.precision !== undefined) {
	        newVal = this.toPrecision(newVal, this.precision);
	      }
	      if (newVal >= this.max) newVal = this.max;
	      if (newVal <= this.min) newVal = this.min;
	      if (oldVal === newVal) return;
	      this.userInput = null;
	      this.$emit('input', newVal);
	      this.$emit('change', newVal, oldVal);
	      this.currentValue = newVal;
	    },
	    handleInput: function handleInput(value) {
	      this.userInput = value;
	    },
	    handleInputChange: function handleInputChange(value) {
	      var newVal = value === '' ? undefined : Number(value);
	      if (!isNaN(newVal) || value === '') {
	        this.setCurrentValue(newVal);
	      }
	      this.userInput = null;
	    },
	    select: function select() {
	      this.$refs.input.select();
	    }
	  },
	  mounted: function mounted() {
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('role', 'spinbutton');
	    innerInput.setAttribute('aria-valuemax', this.max);
	    innerInput.setAttribute('aria-valuemin', this.min);
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
	  },
	  updated: function updated() {
	    if (!this.$refs || !this.$refs.input) return;
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	  }
	});
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_input_numbervue_type_script_lang_js_ = (input_numbervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue
	
	
	
	
	
	/* normalize component */
	
	var input_number_component = normalizeComponent(
	  src_input_numbervue_type_script_lang_js_,
	  input_numbervue_type_template_id_42f8cf66_render,
	  input_numbervue_type_template_id_42f8cf66_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var input_number_api; }
	input_number_component.options.__file = "packages/input-number/src/input-number.vue"
	/* harmony default export */ var input_number = (input_number_component.exports);
	// CONCATENATED MODULE: ./packages/input-number/index.js
	
	
	/* istanbul ignore next */
	input_number.install = function (Vue) {
	  Vue.component(input_number.name, input_number);
	};
	
	/* harmony default export */ var packages_input_number = (input_number);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	var radiovue_type_template_id_69cd6268_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-radio",
	      class: [
	        _vm.border && _vm.radioSize ? "el-radio--" + _vm.radioSize : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-focus": _vm.focus },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.model === _vm.label }
	      ],
	      attrs: {
	        role: "radio",
	        "aria-checked": _vm.model === _vm.label,
	        "aria-disabled": _vm.isDisabled,
	        tabindex: _vm.tabIndex
	      },
	      on: {
	        keydown: function($event) {
	          if (
	            !("button" in $event) &&
	            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
	          ) {
	            return null
	          }
	          $event.stopPropagation()
	          $event.preventDefault()
	          _vm.model = _vm.isDisabled ? _vm.model : _vm.label
	        }
	      }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.model === _vm.label
	          }
	        },
	        [
	          _c("span", { staticClass: "el-radio__inner" }),
	          _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            ref: "radio",
	            staticClass: "el-radio__original",
	            attrs: {
	              type: "radio",
	              "aria-hidden": "true",
	              name: _vm.name,
	              disabled: _vm.isDisabled,
	              tabindex: "-1"
	            },
	            domProps: {
	              value: _vm.label,
	              checked: _vm._q(_vm.model, _vm.label)
	            },
	            on: {
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              },
	              change: [
	                function($event) {
	                  _vm.model = _vm.label
	                },
	                _vm.handleChange
	              ]
	            }
	          })
	        ]
	      ),
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__label",
	          on: {
	            keydown: function($event) {
	              $event.stopPropagation()
	            }
	          }
	        },
	        [
	          _vm._t("default"),
	          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var radiovue_type_template_id_69cd6268_staticRenderFns = []
	radiovue_type_template_id_69cd6268_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var radiovue_type_script_lang_js_ = ({
	  name: 'ElRadio',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElRadio',
	
	  props: {
	    value: {},
	    label: {},
	    disabled: Boolean,
	    name: String,
	    border: Boolean,
	    size: String
	  },
	
	  data: function data() {
	    return {
	      focus: false
	    };
	  },
	
	  computed: {
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElRadioGroup') {
	          parent = parent.$parent;
	        } else {
	          this._radioGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	
	    model: {
	      get: function get() {
	        return this.isGroup ? this._radioGroup.value : this.value;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.dispatch('ElRadioGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	        }
	        this.$refs.radio && (this.$refs.radio.checked = this.model === this.label);
	      }
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    radioSize: function radioSize() {
	      var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    tabIndex: function tabIndex() {
	      return this.isDisabled || this.isGroup && this.model !== this.label ? -1 : 0;
	    }
	  },
	
	  methods: {
	    handleChange: function handleChange() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.$emit('change', _this.model);
	        _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radiovue_type_script_lang_js_ = (radiovue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue
	
	
	
	
	
	/* normalize component */
	
	var radio_component = normalizeComponent(
	  src_radiovue_type_script_lang_js_,
	  radiovue_type_template_id_69cd6268_render,
	  radiovue_type_template_id_69cd6268_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var radio_api; }
	radio_component.options.__file = "packages/radio/src/radio.vue"
	/* harmony default export */ var src_radio = (radio_component.exports);
	// CONCATENATED MODULE: ./packages/radio/index.js
	
	
	/* istanbul ignore next */
	src_radio.install = function (Vue) {
	  Vue.component(src_radio.name, src_radio);
	};
	
	/* harmony default export */ var packages_radio = (src_radio);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&
	var radio_groupvue_type_template_id_818a704c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    _vm._elTag,
	    {
	      tag: "component",
	      staticClass: "el-radio-group",
	      attrs: { role: "radiogroup" },
	      on: { keydown: _vm.handleKeydown }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var radio_groupvue_type_template_id_818a704c_staticRenderFns = []
	radio_groupvue_type_template_id_818a704c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	var keyCode = Object.freeze({
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40
	});
	/* harmony default export */ var radio_groupvue_type_script_lang_js_ = ({
	  name: 'ElRadioGroup',
	
	  componentName: 'ElRadioGroup',
	
	  inject: {
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  mixins: [emitter_default.a],
	
	  props: {
	    value: {},
	    size: String,
	    fill: String,
	    textColor: String,
	    disabled: Boolean
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    _elTag: function _elTag() {
	      return (this.$vnode.data || {}).tag || 'div';
	    },
	    radioGroupSize: function radioGroupSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.$on('handleChange', function (value) {
	      _this.$emit('change', value);
	    });
	  },
	  mounted: function mounted() {
	    // 当radioGroup没有默认选项时，第一个可以选中Tab导航
	    var radios = this.$el.querySelectorAll('[type=radio]');
	    var firstLabel = this.$el.querySelectorAll('[role=radio]')[0];
	    if (![].some.call(radios, function (radio) {
	      return radio.checked;
	    }) && firstLabel) {
	      firstLabel.tabIndex = 0;
	    }
	  },
	
	  methods: {
	    handleKeydown: function handleKeydown(e) {
	      // 左右上下按键 可以在radio组内切换不同选项
	      var target = e.target;
	      var className = target.nodeName === 'INPUT' ? '[type=radio]' : '[role=radio]';
	      var radios = this.$el.querySelectorAll(className);
	      var length = radios.length;
	      var index = [].indexOf.call(radios, target);
	      var roleRadios = this.$el.querySelectorAll('[role=radio]');
	      switch (e.keyCode) {
	        case keyCode.LEFT:
	        case keyCode.UP:
	          e.stopPropagation();
	          e.preventDefault();
	          if (index === 0) {
	            roleRadios[length - 1].click();
	            roleRadios[length - 1].focus();
	          } else {
	            roleRadios[index - 1].click();
	            roleRadios[index - 1].focus();
	          }
	          break;
	        case keyCode.RIGHT:
	        case keyCode.DOWN:
	          if (index === length - 1) {
	            e.stopPropagation();
	            e.preventDefault();
	            roleRadios[0].click();
	            roleRadios[0].focus();
	          } else {
	            roleRadios[index + 1].click();
	            roleRadios[index + 1].focus();
	          }
	          break;
	        default:
	          break;
	      }
	    }
	  },
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', [this.value]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radio_groupvue_type_script_lang_js_ = (radio_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue
	
	
	
	
	
	/* normalize component */
	
	var radio_group_component = normalizeComponent(
	  src_radio_groupvue_type_script_lang_js_,
	  radio_groupvue_type_template_id_818a704c_render,
	  radio_groupvue_type_template_id_818a704c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var radio_group_api; }
	radio_group_component.options.__file = "packages/radio/src/radio-group.vue"
	/* harmony default export */ var radio_group = (radio_group_component.exports);
	// CONCATENATED MODULE: ./packages/radio-group/index.js
	
	
	/* istanbul ignore next */
	radio_group.install = function (Vue) {
	  Vue.component(radio_group.name, radio_group);
	};
	
	/* harmony default export */ var packages_radio_group = (radio_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&
	var radio_buttonvue_type_template_id_18a77a32_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-radio-button",
	      class: [
	        _vm.size ? "el-radio-button--" + _vm.size : "",
	        { "is-active": _vm.value === _vm.label },
	        { "is-disabled": _vm.isDisabled },
	        { "is-focus": _vm.focus }
	      ],
	      attrs: {
	        role: "radio",
	        "aria-checked": _vm.value === _vm.label,
	        "aria-disabled": _vm.isDisabled,
	        tabindex: _vm.tabIndex
	      },
	      on: {
	        keydown: function($event) {
	          if (
	            !("button" in $event) &&
	            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
	          ) {
	            return null
	          }
	          $event.stopPropagation()
	          $event.preventDefault()
	          _vm.value = _vm.isDisabled ? _vm.value : _vm.label
	        }
	      }
	    },
	    [
	      _c("input", {
	        directives: [
	          {
	            name: "model",
	            rawName: "v-model",
	            value: _vm.value,
	            expression: "value"
	          }
	        ],
	        staticClass: "el-radio-button__orig-radio",
	        attrs: {
	          type: "radio",
	          name: _vm.name,
	          disabled: _vm.isDisabled,
	          tabindex: "-1"
	        },
	        domProps: { value: _vm.label, checked: _vm._q(_vm.value, _vm.label) },
	        on: {
	          change: [
	            function($event) {
	              _vm.value = _vm.label
	            },
	            _vm.handleChange
	          ],
	          focus: function($event) {
	            _vm.focus = true
	          },
	          blur: function($event) {
	            _vm.focus = false
	          }
	        }
	      }),
	      _c(
	        "span",
	        {
	          staticClass: "el-radio-button__inner",
	          style: _vm.value === _vm.label ? _vm.activeStyle : null,
	          on: {
	            keydown: function($event) {
	              $event.stopPropagation()
	            }
	          }
	        },
	        [
	          _vm._t("default"),
	          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var radio_buttonvue_type_template_id_18a77a32_staticRenderFns = []
	radio_buttonvue_type_template_id_18a77a32_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var radio_buttonvue_type_script_lang_js_ = ({
	  name: 'ElRadioButton',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    label: {},
	    disabled: Boolean,
	    name: String
	  },
	  data: function data() {
	    return {
	      focus: false
	    };
	  },
	
	  computed: {
	    value: {
	      get: function get() {
	        return this._radioGroup.value;
	      },
	      set: function set(value) {
	        this._radioGroup.$emit('input', value);
	      }
	    },
	    _radioGroup: function _radioGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElRadioGroup') {
	          parent = parent.$parent;
	        } else {
	          return parent;
	        }
	      }
	      return false;
	    },
	    activeStyle: function activeStyle() {
	      return {
	        backgroundColor: this._radioGroup.fill || '',
	        borderColor: this._radioGroup.fill || '',
	        boxShadow: this._radioGroup.fill ? '-1px 0 0 0 ' + this._radioGroup.fill : '',
	        color: this._radioGroup.textColor || ''
	      };
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    size: function size() {
	      return this._radioGroup.radioGroupSize || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    isDisabled: function isDisabled() {
	      return this.disabled || this._radioGroup.disabled || (this.elForm || {}).disabled;
	    },
	    tabIndex: function tabIndex() {
	      return this.isDisabled || this._radioGroup && this.value !== this.label ? -1 : 0;
	    }
	  },
	
	  methods: {
	    handleChange: function handleChange() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.dispatch('ElRadioGroup', 'handleChange', _this.value);
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radio_buttonvue_type_script_lang_js_ = (radio_buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue
	
	
	
	
	
	/* normalize component */
	
	var radio_button_component = normalizeComponent(
	  src_radio_buttonvue_type_script_lang_js_,
	  radio_buttonvue_type_template_id_18a77a32_render,
	  radio_buttonvue_type_template_id_18a77a32_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var radio_button_api; }
	radio_button_component.options.__file = "packages/radio/src/radio-button.vue"
	/* harmony default export */ var radio_button = (radio_button_component.exports);
	// CONCATENATED MODULE: ./packages/radio-button/index.js
	
	
	/* istanbul ignore next */
	radio_button.install = function (Vue) {
	  Vue.component(radio_button.name, radio_button);
	};
	
	/* harmony default export */ var packages_radio_button = (radio_button);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	var checkboxvue_type_template_id_d0387074_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-checkbox",
	      class: [
	        _vm.border && _vm.checkboxSize
	          ? "el-checkbox--" + _vm.checkboxSize
	          : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.isChecked }
	      ],
	      attrs: { id: _vm.id }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-checkbox__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.isChecked,
	            "is-indeterminate": _vm.indeterminate,
	            "is-focus": _vm.focus
	          },
	          attrs: {
	            tabindex: _vm.indeterminate ? 0 : false,
	            role: _vm.indeterminate ? "checkbox" : false,
	            "aria-checked": _vm.indeterminate ? "mixed" : false
	          }
	        },
	        [
	          _c("span", { staticClass: "el-checkbox__inner" }),
	          _vm.trueLabel || _vm.falseLabel
	            ? _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  name: _vm.name,
	                  disabled: _vm.isDisabled,
	                  "true-value": _vm.trueLabel,
	                  "false-value": _vm.falseLabel
	                },
	                domProps: {
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, null) > -1
	                    : _vm._q(_vm.model, _vm.trueLabel)
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
	                      if (Array.isArray($$a)) {
	                        var $$v = null,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	            : _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  disabled: _vm.isDisabled,
	                  name: _vm.name
	                },
	                domProps: {
	                  value: _vm.label,
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, _vm.label) > -1
	                    : _vm.model
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? true : false
	                      if (Array.isArray($$a)) {
	                        var $$v = _vm.label,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	        ]
	      ),
	      _vm.$slots.default || _vm.label
	        ? _c(
	            "span",
	            { staticClass: "el-checkbox__label" },
	            [
	              _vm._t("default"),
	              !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var checkboxvue_type_template_id_d0387074_staticRenderFns = []
	checkboxvue_type_template_id_d0387074_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
	  name: 'ElCheckbox',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElCheckbox',
	
	  data: function data() {
	    return {
	      selfModel: false,
	      focus: false,
	      isLimitExceeded: false
	    };
	  },
	
	
	  computed: {
	    model: {
	      get: function get() {
	        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.isLimitExceeded = false;
	          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
	
	          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
	
	          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	          this.selfModel = val;
	        }
	      }
	    },
	
	    isChecked: function isChecked() {
	      if ({}.toString.call(this.model) === '[object Boolean]') {
	        return this.model;
	      } else if (Array.isArray(this.model)) {
	        return this.model.indexOf(this.label) > -1;
	      } else if (this.model !== null && this.model !== undefined) {
	        return this.model === this.trueLabel;
	      }
	    },
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElCheckboxGroup') {
	          parent = parent.$parent;
	        } else {
	          this._checkboxGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	    store: function store() {
	      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
	    },
	
	
	    /* used to make the isDisabled judgment under max/min props */
	    isLimitDisabled: function isLimitDisabled() {
	      var _checkboxGroup = this._checkboxGroup,
	          max = _checkboxGroup.max,
	          min = _checkboxGroup.min;
	
	      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxSize: function checkboxSize() {
	      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
	    }
	  },
	
	  props: {
	    value: {},
	    label: {},
	    indeterminate: Boolean,
	    disabled: Boolean,
	    checked: Boolean,
	    name: String,
	    trueLabel: [String, Number],
	    falseLabel: [String, Number],
	    id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    border: Boolean,
	    size: String
	  },
	
	  methods: {
	    addToStore: function addToStore() {
	      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
	        this.model.push(this.label);
	      } else {
	        this.model = this.trueLabel || true;
	      }
	    },
	    handleChange: function handleChange(ev) {
	      var _this = this;
	
	      if (this.isLimitExceeded) return;
	      var value = void 0;
	      if (ev.target.checked) {
	        value = this.trueLabel === undefined ? true : this.trueLabel;
	      } else {
	        value = this.falseLabel === undefined ? false : this.falseLabel;
	      }
	      this.$emit('change', value, ev);
	      this.$nextTick(function () {
	        if (_this.isGroup) {
	          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
	        }
	      });
	    }
	  },
	
	  created: function created() {
	    this.checked && this.addToStore();
	  },
	  mounted: function mounted() {
	    // 为indeterminate元素 添加aria-controls 属性
	    if (this.indeterminate) {
	      this.$el.setAttribute('aria-controls', this.controls);
	    }
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', _value);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue
	
	
	
	
	
	/* normalize component */
	
	var checkbox_component = normalizeComponent(
	  src_checkboxvue_type_script_lang_js_,
	  checkboxvue_type_template_id_d0387074_render,
	  checkboxvue_type_template_id_d0387074_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var checkbox_api; }
	checkbox_component.options.__file = "packages/checkbox/src/checkbox.vue"
	/* harmony default export */ var src_checkbox = (checkbox_component.exports);
	// CONCATENATED MODULE: ./packages/checkbox/index.js
	
	
	/* istanbul ignore next */
	src_checkbox.install = function (Vue) {
	  Vue.component(src_checkbox.name, src_checkbox);
	};
	
	/* harmony default export */ var packages_checkbox = (src_checkbox);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&
	var checkbox_buttonvue_type_template_id_478e906e_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-checkbox-button",
	      class: [
	        _vm.size ? "el-checkbox-button--" + _vm.size : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-checked": _vm.isChecked },
	        { "is-focus": _vm.focus }
	      ],
	      attrs: {
	        role: "checkbox",
	        "aria-checked": _vm.isChecked,
	        "aria-disabled": _vm.isDisabled
	      }
	    },
	    [
	      _vm.trueLabel || _vm.falseLabel
	        ? _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            staticClass: "el-checkbox-button__original",
	            attrs: {
	              type: "checkbox",
	              name: _vm.name,
	              disabled: _vm.isDisabled,
	              "true-value": _vm.trueLabel,
	              "false-value": _vm.falseLabel
	            },
	            domProps: {
	              checked: Array.isArray(_vm.model)
	                ? _vm._i(_vm.model, null) > -1
	                : _vm._q(_vm.model, _vm.trueLabel)
	            },
	            on: {
	              change: [
	                function($event) {
	                  var $$a = _vm.model,
	                    $$el = $event.target,
	                    $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
	                  if (Array.isArray($$a)) {
	                    var $$v = null,
	                      $$i = _vm._i($$a, $$v)
	                    if ($$el.checked) {
	                      $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                    } else {
	                      $$i > -1 &&
	                        (_vm.model = $$a
	                          .slice(0, $$i)
	                          .concat($$a.slice($$i + 1)))
	                    }
	                  } else {
	                    _vm.model = $$c
	                  }
	                },
	                _vm.handleChange
	              ],
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              }
	            }
	          })
	        : _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            staticClass: "el-checkbox-button__original",
	            attrs: {
	              type: "checkbox",
	              name: _vm.name,
	              disabled: _vm.isDisabled
	            },
	            domProps: {
	              value: _vm.label,
	              checked: Array.isArray(_vm.model)
	                ? _vm._i(_vm.model, _vm.label) > -1
	                : _vm.model
	            },
	            on: {
	              change: [
	                function($event) {
	                  var $$a = _vm.model,
	                    $$el = $event.target,
	                    $$c = $$el.checked ? true : false
	                  if (Array.isArray($$a)) {
	                    var $$v = _vm.label,
	                      $$i = _vm._i($$a, $$v)
	                    if ($$el.checked) {
	                      $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                    } else {
	                      $$i > -1 &&
	                        (_vm.model = $$a
	                          .slice(0, $$i)
	                          .concat($$a.slice($$i + 1)))
	                    }
	                  } else {
	                    _vm.model = $$c
	                  }
	                },
	                _vm.handleChange
	              ],
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              }
	            }
	          }),
	      _vm.$slots.default || _vm.label
	        ? _c(
	            "span",
	            {
	              staticClass: "el-checkbox-button__inner",
	              style: _vm.isChecked ? _vm.activeStyle : null
	            },
	            [_vm._t("default", [_vm._v(_vm._s(_vm.label))])],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var checkbox_buttonvue_type_template_id_478e906e_staticRenderFns = []
	checkbox_buttonvue_type_template_id_478e906e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var checkbox_buttonvue_type_script_lang_js_ = ({
	  name: 'ElCheckboxButton',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      selfModel: false,
	      focus: false,
	      isLimitExceeded: false
	    };
	  },
	
	
	  props: {
	    value: {},
	    label: {},
	    disabled: Boolean,
	    checked: Boolean,
	    name: String,
	    trueLabel: [String, Number],
	    falseLabel: [String, Number]
	  },
	  computed: {
	    model: {
	      get: function get() {
	        return this._checkboxGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
	      },
	      set: function set(val) {
	        if (this._checkboxGroup) {
	          this.isLimitExceeded = false;
	          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
	
	          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
	
	          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
	        } else if (this.value !== undefined) {
	          this.$emit('input', val);
	        } else {
	          this.selfModel = val;
	        }
	      }
	    },
	
	    isChecked: function isChecked() {
	      if ({}.toString.call(this.model) === '[object Boolean]') {
	        return this.model;
	      } else if (Array.isArray(this.model)) {
	        return this.model.indexOf(this.label) > -1;
	      } else if (this.model !== null && this.model !== undefined) {
	        return this.model === this.trueLabel;
	      }
	    },
	    _checkboxGroup: function _checkboxGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElCheckboxGroup') {
	          parent = parent.$parent;
	        } else {
	          return parent;
	        }
	      }
	      return false;
	    },
	    store: function store() {
	      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
	    },
	    activeStyle: function activeStyle() {
	      return {
	        backgroundColor: this._checkboxGroup.fill || '',
	        borderColor: this._checkboxGroup.fill || '',
	        color: this._checkboxGroup.textColor || '',
	        'box-shadow': '-1px 0 0 0 ' + this._checkboxGroup.fill
	
	      };
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    size: function size() {
	      return this._checkboxGroup.checkboxGroupSize || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	
	
	    /* used to make the isDisabled judgment under max/min props */
	    isLimitDisabled: function isLimitDisabled() {
	      var _checkboxGroup2 = this._checkboxGroup,
	          max = _checkboxGroup2.max,
	          min = _checkboxGroup2.min;
	
	      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
	    },
	    isDisabled: function isDisabled() {
	      return this._checkboxGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	  methods: {
	    addToStore: function addToStore() {
	      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
	        this.model.push(this.label);
	      } else {
	        this.model = this.trueLabel || true;
	      }
	    },
	    handleChange: function handleChange(ev) {
	      var _this = this;
	
	      if (this.isLimitExceeded) return;
	      var value = void 0;
	      if (ev.target.checked) {
	        value = this.trueLabel === undefined ? true : this.trueLabel;
	      } else {
	        value = this.falseLabel === undefined ? false : this.falseLabel;
	      }
	      this.$emit('change', value, ev);
	      this.$nextTick(function () {
	        if (_this._checkboxGroup) {
	          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
	        }
	      });
	    }
	  },
	
	  created: function created() {
	    this.checked && this.addToStore();
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkbox_buttonvue_type_script_lang_js_ = (checkbox_buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue
	
	
	
	
	
	/* normalize component */
	
	var checkbox_button_component = normalizeComponent(
	  src_checkbox_buttonvue_type_script_lang_js_,
	  checkbox_buttonvue_type_template_id_478e906e_render,
	  checkbox_buttonvue_type_template_id_478e906e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var checkbox_button_api; }
	checkbox_button_component.options.__file = "packages/checkbox/src/checkbox-button.vue"
	/* harmony default export */ var checkbox_button = (checkbox_button_component.exports);
	// CONCATENATED MODULE: ./packages/checkbox-button/index.js
	
	
	/* istanbul ignore next */
	checkbox_button.install = function (Vue) {
	  Vue.component(checkbox_button.name, checkbox_button);
	};
	
	/* harmony default export */ var packages_checkbox_button = (checkbox_button);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	var checkbox_groupvue_type_template_id_7289a290_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-checkbox-group",
	      attrs: { role: "group", "aria-label": "checkbox-group" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var checkbox_groupvue_type_template_id_7289a290_staticRenderFns = []
	checkbox_groupvue_type_template_id_7289a290_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	
	
	
	/* harmony default export */ var checkbox_groupvue_type_script_lang_js_ = ({
	  name: 'ElCheckboxGroup',
	
	  componentName: 'ElCheckboxGroup',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    value: {},
	    disabled: Boolean,
	    min: Number,
	    max: Number,
	    size: String,
	    fill: String,
	    textColor: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxGroupSize: function checkboxGroupSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', [_value]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkbox_groupvue_type_script_lang_js_ = (checkbox_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue
	
	
	
	
	
	/* normalize component */
	
	var checkbox_group_component = normalizeComponent(
	  src_checkbox_groupvue_type_script_lang_js_,
	  checkbox_groupvue_type_template_id_7289a290_render,
	  checkbox_groupvue_type_template_id_7289a290_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var checkbox_group_api; }
	checkbox_group_component.options.__file = "packages/checkbox/src/checkbox-group.vue"
	/* harmony default export */ var checkbox_group = (checkbox_group_component.exports);
	// CONCATENATED MODULE: ./packages/checkbox-group/index.js
	
	
	/* istanbul ignore next */
	checkbox_group.install = function (Vue) {
	  Vue.component(checkbox_group.name, checkbox_group);
	};
	
	/* harmony default export */ var packages_checkbox_group = (checkbox_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&
	var componentvue_type_template_id_2dcd8fbb_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-switch",
	      class: { "is-disabled": _vm.switchDisabled, "is-checked": _vm.checked },
	      attrs: {
	        role: "switch",
	        "aria-checked": _vm.checked,
	        "aria-disabled": _vm.switchDisabled
	      },
	      on: {
	        click: function($event) {
	          $event.preventDefault()
	          return _vm.switchValue($event)
	        }
	      }
	    },
	    [
	      _c("input", {
	        ref: "input",
	        staticClass: "el-switch__input",
	        attrs: {
	          type: "checkbox",
	          id: _vm.id,
	          name: _vm.name,
	          "true-value": _vm.activeValue,
	          "false-value": _vm.inactiveValue,
	          disabled: _vm.switchDisabled
	        },
	        on: {
	          change: _vm.handleChange,
	          keydown: function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	            ) {
	              return null
	            }
	            return _vm.switchValue($event)
	          }
	        }
	      }),
	      _vm.inactiveIconClass || _vm.inactiveText
	        ? _c(
	            "span",
	            {
	              class: [
	                "el-switch__label",
	                "el-switch__label--left",
	                !_vm.checked ? "is-active" : ""
	              ]
	            },
	            [
	              _vm.inactiveIconClass
	                ? _c("i", { class: [_vm.inactiveIconClass] })
	                : _vm._e(),
	              !_vm.inactiveIconClass && _vm.inactiveText
	                ? _c("span", { attrs: { "aria-hidden": _vm.checked } }, [
	                    _vm._v(_vm._s(_vm.inactiveText))
	                  ])
	                : _vm._e()
	            ]
	          )
	        : _vm._e(),
	      _c("span", {
	        ref: "core",
	        staticClass: "el-switch__core",
	        style: { width: _vm.coreWidth + "px" }
	      }),
	      _vm.activeIconClass || _vm.activeText
	        ? _c(
	            "span",
	            {
	              class: [
	                "el-switch__label",
	                "el-switch__label--right",
	                _vm.checked ? "is-active" : ""
	              ]
	            },
	            [
	              _vm.activeIconClass
	                ? _c("i", { class: [_vm.activeIconClass] })
	                : _vm._e(),
	              !_vm.activeIconClass && _vm.activeText
	                ? _c("span", { attrs: { "aria-hidden": !_vm.checked } }, [
	                    _vm._v(_vm._s(_vm.activeText))
	                  ])
	                : _vm._e()
	            ]
	          )
	        : _vm._e()
	    ]
	  )
	}
	var componentvue_type_template_id_2dcd8fbb_staticRenderFns = []
	componentvue_type_template_id_2dcd8fbb_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var switch_src_componentvue_type_script_lang_js_ = ({
	  name: 'ElSwitch',
	  mixins: [focus_default()('input'), migrating_default.a, emitter_default.a],
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	  props: {
	    value: {
	      type: [Boolean, String, Number],
	      default: false
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    width: {
	      type: Number,
	      default: 40
	    },
	    activeIconClass: {
	      type: String,
	      default: ''
	    },
	    inactiveIconClass: {
	      type: String,
	      default: ''
	    },
	    activeText: String,
	    inactiveText: String,
	    activeColor: {
	      type: String,
	      default: ''
	    },
	    inactiveColor: {
	      type: String,
	      default: ''
	    },
	    activeValue: {
	      type: [Boolean, String, Number],
	      default: true
	    },
	    inactiveValue: {
	      type: [Boolean, String, Number],
	      default: false
	    },
	    name: {
	      type: String,
	      default: ''
	    },
	    validateEvent: {
	      type: Boolean,
	      default: true
	    },
	    id: String
	  },
	  data: function data() {
	    return {
	      coreWidth: this.width
	    };
	  },
	  created: function created() {
	    if (!~[this.activeValue, this.inactiveValue].indexOf(this.value)) {
	      this.$emit('input', this.inactiveValue);
	    }
	  },
	
	  computed: {
	    checked: function checked() {
	      return this.value === this.activeValue;
	    },
	    switchDisabled: function switchDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	  watch: {
	    checked: function checked() {
	      this.$refs.input.checked = this.checked;
	      if (this.activeColor || this.inactiveColor) {
	        this.setBackgroundColor();
	      }
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', [this.value]);
	      }
	    }
	  },
	  methods: {
	    handleChange: function handleChange(event) {
	      var _this = this;
	
	      var val = this.checked ? this.inactiveValue : this.activeValue;
	      this.$emit('input', val);
	      this.$emit('change', val);
	      this.$nextTick(function () {
	        // set input's checked property
	        // in case parent refuses to change component's value
	        _this.$refs.input.checked = _this.checked;
	      });
	    },
	    setBackgroundColor: function setBackgroundColor() {
	      var newColor = this.checked ? this.activeColor : this.inactiveColor;
	      this.$refs.core.style.borderColor = newColor;
	      this.$refs.core.style.backgroundColor = newColor;
	    },
	    switchValue: function switchValue() {
	      !this.switchDisabled && this.handleChange();
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'on-color': 'on-color is renamed to active-color.',
	          'off-color': 'off-color is renamed to inactive-color.',
	          'on-text': 'on-text is renamed to active-text.',
	          'off-text': 'off-text is renamed to inactive-text.',
	          'on-value': 'on-value is renamed to active-value.',
	          'off-value': 'off-value is renamed to inactive-value.',
	          'on-icon-class': 'on-icon-class is renamed to active-icon-class.',
	          'off-icon-class': 'off-icon-class is renamed to inactive-icon-class.'
	        }
	      };
	    }
	  },
	  mounted: function mounted() {
	    /* istanbul ignore if */
	    this.coreWidth = this.width || 40;
	    if (this.activeColor || this.inactiveColor) {
	      this.setBackgroundColor();
	    }
	    this.$refs.input.checked = this.checked;
	  }
	});
	// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_switch_src_componentvue_type_script_lang_js_ = (switch_src_componentvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/switch/src/component.vue
	
	
	
	
	
	/* normalize component */
	
	var src_component_component = normalizeComponent(
	  packages_switch_src_componentvue_type_script_lang_js_,
	  componentvue_type_template_id_2dcd8fbb_render,
	  componentvue_type_template_id_2dcd8fbb_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_component_api; }
	src_component_component.options.__file = "packages/switch/src/component.vue"
	/* harmony default export */ var switch_src_component = (src_component_component.exports);
	// CONCATENATED MODULE: ./packages/switch/index.js
	
	
	/* istanbul ignore next */
	switch_src_component.install = function (Vue) {
	  Vue.component(switch_src_component.name, switch_src_component);
	};
	
	/* harmony default export */ var packages_switch = (switch_src_component);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	var selectvue_type_template_id_0e4aade6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.handleClose,
	          expression: "handleClose"
	        }
	      ],
	      staticClass: "el-select",
	      class: [_vm.selectSize ? "el-select--" + _vm.selectSize : ""],
	      on: {
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.toggleMenu($event)
	        }
	      }
	    },
	    [
	      _vm.multiple
	        ? _c(
	            "div",
	            {
	              ref: "tags",
	              staticClass: "el-select__tags",
	              style: { "max-width": _vm.inputWidth - 32 + "px", width: "100%" }
	            },
	            [
	              _vm.collapseTags && _vm.selected.length
	                ? _c(
	                    "span",
	                    [
	                      _c(
	                        "el-tag",
	                        {
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: _vm.selected[0].hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, _vm.selected[0])
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(_vm.selected[0].currentLabel))
	                          ])
	                        ]
	                      ),
	                      _vm.selected.length > 1
	                        ? _c(
	                            "el-tag",
	                            {
	                              attrs: {
	                                closable: false,
	                                size: _vm.collapseTagSize,
	                                type: "info",
	                                "disable-transitions": ""
	                              }
	                            },
	                            [
	                              _c(
	                                "span",
	                                { staticClass: "el-select__tags-text" },
	                                [_vm._v("+ " + _vm._s(_vm.selected.length - 1))]
	                              )
	                            ]
	                          )
	                        : _vm._e()
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              !_vm.collapseTags
	                ? _c(
	                    "transition-group",
	                    { on: { "after-leave": _vm.resetInputHeight } },
	                    _vm._l(_vm.selected, function(item) {
	                      return _c(
	                        "el-tag",
	                        {
	                          key: _vm.getValueKey(item),
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: item.hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, item)
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(item.currentLabel))
	                          ])
	                        ]
	                      )
	                    }),
	                    1
	                  )
	                : _vm._e(),
	              _vm.filterable
	                ? _c("input", {
	                    directives: [
	                      {
	                        name: "model",
	                        rawName: "v-model",
	                        value: _vm.query,
	                        expression: "query"
	                      }
	                    ],
	                    ref: "input",
	                    staticClass: "el-select__input",
	                    class: [_vm.selectSize ? "is-" + _vm.selectSize : ""],
	                    style: {
	                      "flex-grow": "1",
	                      width: _vm.inputLength / (_vm.inputWidth - 32) + "%",
	                      "max-width": _vm.inputWidth - 42 + "px"
	                    },
	                    attrs: {
	                      type: "text",
	                      disabled: _vm.selectDisabled,
	                      autocomplete: _vm.autoComplete || _vm.autocomplete
	                    },
	                    domProps: { value: _vm.query },
	                    on: {
	                      focus: _vm.handleFocus,
	                      blur: function($event) {
	                        _vm.softFocus = false
	                      },
	                      keyup: _vm.managePlaceholder,
	                      keydown: [
	                        _vm.resetInputState,
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "down", 40, $event.key, [
	                              "Down",
	                              "ArrowDown"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("next")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "up", 38, $event.key, [
	                              "Up",
	                              "ArrowUp"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("prev")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "enter",
	                              13,
	                              $event.key,
	                              "Enter"
	                            )
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          return _vm.selectOption($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "esc", 27, $event.key, [
	                              "Esc",
	                              "Escape"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.stopPropagation()
	                          $event.preventDefault()
	                          _vm.visible = false
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "delete",
	                              [8, 46],
	                              $event.key,
	                              ["Backspace", "Delete", "Del"]
	                            )
	                          ) {
	                            return null
	                          }
	                          return _vm.deletePrevTag($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                          ) {
	                            return null
	                          }
	                          _vm.visible = false
	                        }
	                      ],
	                      compositionstart: _vm.handleComposition,
	                      compositionupdate: _vm.handleComposition,
	                      compositionend: _vm.handleComposition,
	                      input: [
	                        function($event) {
	                          if ($event.target.composing) {
	                            return
	                          }
	                          _vm.query = $event.target.value
	                        },
	                        _vm.debouncedQueryChange
	                      ]
	                    }
	                  })
	                : _vm._e()
	            ],
	            1
	          )
	        : _vm._e(),
	      _c(
	        "el-input",
	        {
	          ref: "reference",
	          class: { "is-focus": _vm.visible },
	          attrs: {
	            type: "text",
	            placeholder: _vm.currentPlaceholder,
	            name: _vm.name,
	            id: _vm.id,
	            autocomplete: _vm.autoComplete || _vm.autocomplete,
	            size: _vm.selectSize,
	            disabled: _vm.selectDisabled,
	            readonly: _vm.readonly,
	            "validate-event": false,
	            tabindex: _vm.multiple && _vm.filterable ? "-1" : null
	          },
	          on: { focus: _vm.handleFocus, blur: _vm.handleBlur },
	          nativeOn: {
	            keyup: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            keydown: [
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "down", 40, $event.key, [
	                    "Down",
	                    "ArrowDown"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("next")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "up", 38, $event.key, [
	                    "Up",
	                    "ArrowUp"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("prev")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                ) {
	                  return null
	                }
	                $event.preventDefault()
	                return _vm.selectOption($event)
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "esc", 27, $event.key, [
	                    "Esc",
	                    "Escape"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.visible = false
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                ) {
	                  return null
	                }
	                _vm.visible = false
	              }
	            ],
	            paste: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            mouseenter: function($event) {
	              _vm.inputHovering = true
	            },
	            mouseleave: function($event) {
	              _vm.inputHovering = false
	            }
	          },
	          model: {
	            value: _vm.selectedLabel,
	            callback: function($$v) {
	              _vm.selectedLabel = $$v
	            },
	            expression: "selectedLabel"
	          }
	        },
	        [
	          _vm.$slots.prefix
	            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
	            : _vm._e(),
	          _c("template", { slot: "suffix" }, [
	            _c("i", {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.showClose,
	                  expression: "!showClose"
	                }
	              ],
	              class: [
	                "el-select__caret",
	                "el-input__icon",
	                "el-icon-" + _vm.iconClass
	              ]
	            }),
	            _vm.showClose
	              ? _c("i", {
	                  staticClass:
	                    "el-select__caret el-input__icon el-icon-circle-close",
	                  on: { click: _vm.handleClearClick }
	                })
	              : _vm._e()
	          ])
	        ],
	        2
	      ),
	      _c(
	        "transition",
	        {
	          attrs: { name: "el-zoom-in-top" },
	          on: {
	            "before-enter": _vm.handleMenuEnter,
	            "after-leave": _vm.doDestroy
	          }
	        },
	        [
	          _c(
	            "el-select-menu",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.visible && _vm.emptyText !== false,
	                  expression: "visible && emptyText !== false"
	                }
	              ],
	              ref: "popper",
	              attrs: { "append-to-body": _vm.popperAppendToBody }
	            },
	            [
	              _c(
	                "el-scrollbar",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.options.length > 0 && !_vm.loading,
	                      expression: "options.length > 0 && !loading"
	                    }
	                  ],
	                  ref: "scrollbar",
	                  class: {
	                    "is-empty":
	                      !_vm.allowCreate &&
	                      _vm.query &&
	                      _vm.filteredOptionsCount === 0
	                  },
	                  attrs: {
	                    tag: "ul",
	                    "wrap-class": "el-select-dropdown__wrap",
	                    "view-class": "el-select-dropdown__list"
	                  }
	                },
	                [
	                  _vm.showNewOption
	                    ? _c("el-option", {
	                        attrs: { value: _vm.query, created: "" }
	                      })
	                    : _vm._e(),
	                  _vm._t("default")
	                ],
	                2
	              ),
	              _vm.emptyText &&
	              (!_vm.allowCreate ||
	                _vm.loading ||
	                (_vm.allowCreate && _vm.options.length === 0))
	                ? [
	                    _vm.$slots.empty
	                      ? _vm._t("empty")
	                      : _c("p", { staticClass: "el-select-dropdown__empty" }, [
	                          _vm._v(
	                            "\n          " +
	                              _vm._s(_vm.emptyText) +
	                              "\n        "
	                          )
	                        ])
	                  ]
	                : _vm._e()
	            ],
	            2
	          )
	        ],
	        1
	      )
	    ],
	    1
	  )
	}
	var selectvue_type_template_id_0e4aade6_staticRenderFns = []
	selectvue_type_template_id_0e4aade6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	var select_dropdownvue_type_template_id_06828748_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-select-dropdown el-popper",
	      class: [{ "is-multiple": _vm.$parent.multiple }, _vm.popperClass],
	      style: { minWidth: _vm.minWidth }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var select_dropdownvue_type_template_id_06828748_staticRenderFns = []
	select_dropdownvue_type_template_id_06828748_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var select_dropdownvue_type_script_lang_js_ = ({
	  name: 'ElSelectDropdown',
	
	  componentName: 'ElSelectDropdown',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    placement: {
	      default: 'bottom-start'
	    },
	
	    boundariesPadding: {
	      default: 0
	    },
	
	    popperOptions: {
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    },
	
	    visibleArrow: {
	      default: true
	    },
	
	    appendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      minWidth: ''
	    };
	  },
	
	
	  computed: {
	    popperClass: function popperClass() {
	      return this.$parent.popperClass;
	    }
	  },
	
	  watch: {
	    '$parent.inputWidth': function $parentInputWidth() {
	      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.referenceElm = this.$parent.$refs.reference.$el;
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.$on('updatePopper', function () {
	      if (_this.$parent.visible) _this.updatePopper();
	    });
	    this.$on('destroyPopper', this.destroyPopper);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_select_dropdownvue_type_script_lang_js_ = (select_dropdownvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue
	
	
	
	
	
	/* normalize component */
	
	var select_dropdown_component = normalizeComponent(
	  src_select_dropdownvue_type_script_lang_js_,
	  select_dropdownvue_type_template_id_06828748_render,
	  select_dropdownvue_type_template_id_06828748_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var select_dropdown_api; }
	select_dropdown_component.options.__file = "packages/select/src/select-dropdown.vue"
	/* harmony default export */ var select_dropdown = (select_dropdown_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	var optionvue_type_template_id_7a44c642_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-dropdown__item",
	      class: {
	        selected: _vm.itemSelected,
	        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
	        hover: _vm.hover
	      },
	      on: {
	        mouseenter: _vm.hoverItem,
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.selectOptionClick($event)
	        }
	      }
	    },
	    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
	    2
	  )
	}
	var optionvue_type_template_id_7a44c642_staticRenderFns = []
	optionvue_type_template_id_7a44c642_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var optionvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOption',
	
	  componentName: 'ElOption',
	
	  inject: ['select'],
	
	  props: {
	    value: {
	      required: true
	    },
	    label: [String, Number],
	    created: Boolean,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      groupDisabled: false,
	      visible: true,
	      hitState: false,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    isObject: function isObject() {
	      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
	    },
	    currentLabel: function currentLabel() {
	      return this.label || (this.isObject ? '' : this.value);
	    },
	    currentValue: function currentValue() {
	      return this.value || this.label || '';
	    },
	    itemSelected: function itemSelected() {
	      if (!this.select.multiple) {
	        return this.isEqual(this.value, this.select.value);
	      } else {
	        return this.contains(this.select.value, this.value);
	      }
	    },
	    limitReached: function limitReached() {
	      if (this.select.multiple) {
	        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
	      } else {
	        return false;
	      }
	    }
	  },
	
	  watch: {
	    currentLabel: function currentLabel() {
	      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
	    },
	    value: function value(val, oldVal) {
	      var _select = this.select,
	          remote = _select.remote,
	          valueKey = _select.valueKey;
	
	      if (!this.created && !remote) {
	        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
	          return;
	        }
	        this.dispatch('ElSelect', 'setSelected');
	      }
	    }
	  },
	
	  methods: {
	    isEqual: function isEqual(a, b) {
	      if (!this.isObject) {
	        return a === b;
	      } else {
	        var valueKey = this.select.valueKey;
	        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
	      }
	    },
	    contains: function contains() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var target = arguments[1];
	
	      if (!this.isObject) {
	        return arr && arr.indexOf(target) > -1;
	      } else {
	        var valueKey = this.select.valueKey;
	        return arr && arr.some(function (item) {
	          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
	        });
	      }
	    },
	    handleGroupDisabled: function handleGroupDisabled(val) {
	      this.groupDisabled = val;
	    },
	    hoverItem: function hoverItem() {
	      if (!this.disabled && !this.groupDisabled) {
	        this.select.hoverIndex = this.select.options.indexOf(this);
	      }
	    },
	    selectOptionClick: function selectOptionClick() {
	      if (this.disabled !== true && this.groupDisabled !== true) {
	        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
	      }
	    },
	    queryChange: function queryChange(query) {
	      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
	      if (!this.visible) {
	        this.select.filteredOptionsCount--;
	      }
	    }
	  },
	
	  created: function created() {
	    this.select.options.push(this);
	    this.select.cachedOptions.push(this);
	    this.select.optionsCount++;
	    this.select.filteredOptionsCount++;
	
	    this.$on('queryChange', this.queryChange);
	    this.$on('handleGroupDisabled', this.handleGroupDisabled);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _select2 = this.select,
	        selected = _select2.selected,
	        multiple = _select2.multiple;
	
	    var selectedOptions = multiple ? selected : [selected];
	    var index = this.select.cachedOptions.indexOf(this);
	    var selectedIndex = selectedOptions.indexOf(this);
	
	    // if option is not selected, remove it from cache
	    if (index > -1 && selectedIndex < 0) {
	      this.select.cachedOptions.splice(index, 1);
	    }
	    this.select.onOptionDestroy(this.select.options.indexOf(this));
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/option.vue
	
	
	
	
	
	/* normalize component */
	
	var option_component = normalizeComponent(
	  src_optionvue_type_script_lang_js_,
	  optionvue_type_template_id_7a44c642_render,
	  optionvue_type_template_id_7a44c642_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var option_api; }
	option_component.options.__file = "packages/select/src/option.vue"
	/* harmony default export */ var src_option = (option_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/tag"
	var tag_ = __webpack_require__(29);
	var tag_default = /*#__PURE__*/__webpack_require__.n(tag_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
	var resize_event_ = __webpack_require__(12);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
	var scroll_into_view_ = __webpack_require__(27);
	var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);
	
	// CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
	/* harmony default export */ var navigation_mixin = ({
	  data: function data() {
	    return {
	      hoverOption: -1
	    };
	  },
	
	
	  computed: {
	    optionsAllDisabled: function optionsAllDisabled() {
	      return this.options.filter(function (option) {
	        return option.visible;
	      }).every(function (option) {
	        return option.disabled;
	      });
	    }
	  },
	
	  watch: {
	    hoverIndex: function hoverIndex(val) {
	      var _this = this;
	
	      if (typeof val === 'number' && val > -1) {
	        this.hoverOption = this.options[val] || {};
	      }
	      this.options.forEach(function (option) {
	        option.hover = _this.hoverOption === option;
	      });
	    }
	  },
	
	  methods: {
	    navigateOptions: function navigateOptions(direction) {
	      var _this2 = this;
	
	      if (!this.visible) {
	        this.visible = true;
	        return;
	      }
	      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
	      if (!this.optionsAllDisabled) {
	        if (direction === 'next') {
	          this.hoverIndex++;
	          if (this.hoverIndex === this.options.length) {
	            this.hoverIndex = 0;
	          }
	        } else if (direction === 'prev') {
	          this.hoverIndex--;
	          if (this.hoverIndex < 0) {
	            this.hoverIndex = this.options.length - 1;
	          }
	        }
	        var option = this.options[this.hoverIndex];
	        if (option.disabled === true || option.groupDisabled === true || !option.visible) {
	          this.navigateOptions(direction);
	        }
	        this.$nextTick(function () {
	          return _this2.scrollToOption(_this2.hoverOption);
	        });
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var selectvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a, locale_default.a, focus_default()('reference'), navigation_mixin],
	
	  name: 'ElSelect',
	
	  componentName: 'ElSelect',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  provide: function provide() {
	    return {
	      'select': this
	    };
	  },
	
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    readonly: function readonly() {
	      return !this.filterable || this.multiple || !Object(util_["isIE"])() && !Object(util_["isEdge"])() && !this.visible;
	    },
	    showClose: function showClose() {
	      var hasValue = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== undefined && this.value !== null && this.value !== '';
	      var criteria = this.clearable && !this.selectDisabled && this.inputHovering && hasValue;
	      return criteria;
	    },
	    iconClass: function iconClass() {
	      return this.remote && this.filterable ? '' : this.visible ? 'arrow-up is-reverse' : 'arrow-up';
	    },
	    debounce: function debounce() {
	      return this.remote ? 300 : 0;
	    },
	    emptyText: function emptyText() {
	      if (this.loading) {
	        return this.loadingText || this.t('el.select.loading');
	      } else {
	        if (this.remote && this.query === '' && this.options.length === 0) return false;
	        if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
	          return this.noMatchText || this.t('el.select.noMatch');
	        }
	        if (this.options.length === 0) {
	          return this.noDataText || this.t('el.select.noData');
	        }
	      }
	      return null;
	    },
	    showNewOption: function showNewOption() {
	      var _this = this;
	
	      var hasExistingOption = this.options.filter(function (option) {
	        return !option.created;
	      }).some(function (option) {
	        return option.currentLabel === _this.query;
	      });
	      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
	    },
	    selectSize: function selectSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    selectDisabled: function selectDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    collapseTagSize: function collapseTagSize() {
	      return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
	    },
	    propPlaceholder: function propPlaceholder() {
	      return typeof this.placeholder !== 'undefined' ? this.placeholder : this.t('el.select.placeholder');
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElSelectMenu: select_dropdown,
	    ElOption: src_option,
	    ElTag: tag_default.a,
	    ElScrollbar: scrollbar_default.a
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  props: {
	    name: String,
	    id: String,
	    value: {
	      required: true
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    automaticDropdown: Boolean,
	    size: String,
	    disabled: Boolean,
	    clearable: Boolean,
	    filterable: Boolean,
	    allowCreate: Boolean,
	    loading: Boolean,
	    popperClass: String,
	    remote: Boolean,
	    loadingText: String,
	    noMatchText: String,
	    noDataText: String,
	    remoteMethod: Function,
	    filterMethod: Function,
	    multiple: Boolean,
	    multipleLimit: {
	      type: Number,
	      default: 0
	    },
	    placeholder: {
	      type: String,
	      required: false
	    },
	    defaultFirstOption: Boolean,
	    reserveKeyword: Boolean,
	    valueKey: {
	      type: String,
	      default: 'value'
	    },
	    collapseTags: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      options: [],
	      cachedOptions: [],
	      createdLabel: null,
	      createdSelected: false,
	      selected: this.multiple ? [] : {},
	      inputLength: 20,
	      inputWidth: 0,
	      initialInputHeight: 0,
	      cachedPlaceHolder: '',
	      optionsCount: 0,
	      filteredOptionsCount: 0,
	      visible: false,
	      softFocus: false,
	      selectedLabel: '',
	      hoverIndex: -1,
	      query: '',
	      previousQuery: null,
	      inputHovering: false,
	      currentPlaceholder: '',
	      menuVisibleOnFocus: false,
	      isOnComposition: false,
	      isSilentBlur: false
	    };
	  },
	
	
	  watch: {
	    selectDisabled: function selectDisabled() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        _this2.resetInputHeight();
	      });
	    },
	    propPlaceholder: function propPlaceholder(val) {
	      this.cachedPlaceHolder = this.currentPlaceholder = val;
	    },
	    value: function value(val, oldVal) {
	      if (this.multiple) {
	        this.resetInputHeight();
	        if (val && val.length > 0 || this.$refs.input && this.query !== '') {
	          this.currentPlaceholder = '';
	        } else {
	          this.currentPlaceholder = this.cachedPlaceHolder;
	        }
	        if (this.filterable && !this.reserveKeyword) {
	          this.query = '';
	          this.handleQueryChange(this.query);
	        }
	      }
	      this.setSelected();
	      if (this.filterable && !this.multiple) {
	        this.inputLength = 20;
	      }
	      if (!Object(util_["valueEquals"])(val, oldVal)) {
	        this.dispatch('ElFormItem', 'el.form.change', val);
	      }
	    },
	    visible: function visible(val) {
	      var _this3 = this;
	
	      if (!val) {
	        this.broadcast('ElSelectDropdown', 'destroyPopper');
	        if (this.$refs.input) {
	          this.$refs.input.blur();
	        }
	        this.query = '';
	        this.previousQuery = null;
	        this.selectedLabel = '';
	        this.inputLength = 20;
	        this.menuVisibleOnFocus = false;
	        this.resetHoverIndex();
	        this.$nextTick(function () {
	          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
	            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
	          }
	        });
	        if (!this.multiple) {
	          if (this.selected) {
	            if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
	              this.selectedLabel = this.createdLabel;
	            } else {
	              this.selectedLabel = this.selected.currentLabel;
	            }
	            if (this.filterable) this.query = this.selectedLabel;
	          }
	
	          if (this.filterable) {
	            this.currentPlaceholder = this.cachedPlaceHolder;
	          }
	        }
	      } else {
	        this.broadcast('ElSelectDropdown', 'updatePopper');
	        if (this.filterable) {
	          this.query = this.remote ? '' : this.selectedLabel;
	          this.handleQueryChange(this.query);
	          if (this.multiple) {
	            this.$refs.input.focus();
	          } else {
	            if (!this.remote) {
	              this.broadcast('ElOption', 'queryChange', '');
	              this.broadcast('ElOptionGroup', 'queryChange');
	            }
	
	            if (this.selectedLabel) {
	              this.currentPlaceholder = this.selectedLabel;
	              this.selectedLabel = '';
	            }
	          }
	        }
	      }
	      this.$emit('visible-change', val);
	    },
	    options: function options() {
	      var _this4 = this;
	
	      if (this.$isServer) return;
	      this.$nextTick(function () {
	        _this4.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      if (this.multiple) {
	        this.resetInputHeight();
	      }
	      var inputs = this.$el.querySelectorAll('input');
	      if ([].indexOf.call(inputs, document.activeElement) === -1) {
	        this.setSelected();
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    }
	  },
	
	  methods: {
	    handleComposition: function handleComposition(event) {
	      var _this5 = this;
	
	      var text = event.target.value;
	      if (event.type === 'compositionend') {
	        this.isOnComposition = false;
	        this.$nextTick(function (_) {
	          return _this5.handleQueryChange(text);
	        });
	      } else {
	        var lastCharacter = text[text.length - 1] || '';
	        this.isOnComposition = !Object(shared_["isKorean"])(lastCharacter);
	      }
	    },
	    handleQueryChange: function handleQueryChange(val) {
	      var _this6 = this;
	
	      if (this.previousQuery === val || this.isOnComposition) return;
	      if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
	        this.previousQuery = val;
	        return;
	      }
	      this.previousQuery = val;
	      this.$nextTick(function () {
	        if (_this6.visible) _this6.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      this.hoverIndex = -1;
	      if (this.multiple && this.filterable) {
	        this.$nextTick(function () {
	          var length = _this6.$refs.input.value.length * 15 + 20;
	          _this6.inputLength = _this6.collapseTags ? Math.min(50, length) : length;
	          _this6.managePlaceholder();
	          _this6.resetInputHeight();
	        });
	      }
	      if (this.remote && typeof this.remoteMethod === 'function') {
	        this.hoverIndex = -1;
	        this.remoteMethod(val);
	      } else if (typeof this.filterMethod === 'function') {
	        this.filterMethod(val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      } else {
	        this.filteredOptionsCount = this.optionsCount;
	        this.broadcast('ElOption', 'queryChange', val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    },
	    scrollToOption: function scrollToOption(option) {
	      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
	      if (this.$refs.popper && target) {
	        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
	        scroll_into_view_default()(menu, target);
	      }
	      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
	    },
	    handleMenuEnter: function handleMenuEnter() {
	      var _this7 = this;
	
	      this.$nextTick(function () {
	        return _this7.scrollToOption(_this7.selected);
	      });
	    },
	    emitChange: function emitChange(val) {
	      if (!Object(util_["valueEquals"])(this.value, val)) {
	        this.$emit('change', val);
	      }
	    },
	    getOption: function getOption(value) {
	      var option = void 0;
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
	      var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';
	
	      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
	        var cachedOption = this.cachedOptions[i];
	        var isEqual = isObject ? Object(util_["getValueByPath"])(cachedOption.value, this.valueKey) === Object(util_["getValueByPath"])(value, this.valueKey) : cachedOption.value === value;
	        if (isEqual) {
	          option = cachedOption;
	          break;
	        }
	      }
	      if (option) return option;
	      var label = !isObject && !isNull && !isUndefined ? value : '';
	      var newOption = {
	        value: value,
	        currentLabel: label
	      };
	      if (this.multiple) {
	        newOption.hitState = false;
	      }
	      return newOption;
	    },
	    setSelected: function setSelected() {
	      var _this8 = this;
	
	      if (!this.multiple) {
	        var option = this.getOption(this.value);
	        if (option.created) {
	          this.createdLabel = option.currentLabel;
	          this.createdSelected = true;
	        } else {
	          this.createdSelected = false;
	        }
	        this.selectedLabel = option.currentLabel;
	        this.selected = option;
	        if (this.filterable) this.query = this.selectedLabel;
	        return;
	      }
	      var result = [];
	      if (Array.isArray(this.value)) {
	        this.value.forEach(function (value) {
	          result.push(_this8.getOption(value));
	        });
	      }
	      this.selected = result;
	      this.$nextTick(function () {
	        _this8.resetInputHeight();
	      });
	    },
	    handleFocus: function handleFocus(event) {
	      if (!this.softFocus) {
	        if (this.automaticDropdown || this.filterable) {
	          this.visible = true;
	          if (this.filterable) {
	            this.menuVisibleOnFocus = true;
	          }
	        }
	        this.$emit('focus', event);
	      } else {
	        this.softFocus = false;
	      }
	    },
	    blur: function blur() {
	      this.visible = false;
	      this.$refs.reference.blur();
	    },
	    handleBlur: function handleBlur(event) {
	      var _this9 = this;
	
	      setTimeout(function () {
	        if (_this9.isSilentBlur) {
	          _this9.isSilentBlur = false;
	        } else {
	          _this9.$emit('blur', event);
	        }
	      }, 50);
	      this.softFocus = false;
	    },
	    handleClearClick: function handleClearClick(event) {
	      this.deleteSelected(event);
	    },
	    doDestroy: function doDestroy() {
	      this.$refs.popper && this.$refs.popper.doDestroy();
	    },
	    handleClose: function handleClose() {
	      this.visible = false;
	    },
	    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
	      if (!Array.isArray(this.selected)) return;
	      var option = this.selected[this.selected.length - 1];
	      if (!option) return;
	
	      if (hit === true || hit === false) {
	        option.hitState = hit;
	        return hit;
	      }
	
	      option.hitState = !option.hitState;
	      return option.hitState;
	    },
	    deletePrevTag: function deletePrevTag(e) {
	      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
	        var value = this.value.slice();
	        value.pop();
	        this.$emit('input', value);
	        this.emitChange(value);
	      }
	    },
	    managePlaceholder: function managePlaceholder() {
	      if (this.currentPlaceholder !== '') {
	        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
	      }
	    },
	    resetInputState: function resetInputState(e) {
	      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
	      this.inputLength = this.$refs.input.value.length * 15 + 20;
	      this.resetInputHeight();
	    },
	    resetInputHeight: function resetInputHeight() {
	      var _this10 = this;
	
	      if (this.collapseTags && !this.filterable) return;
	      this.$nextTick(function () {
	        if (!_this10.$refs.reference) return;
	        var inputChildNodes = _this10.$refs.reference.$el.childNodes;
	        var input = [].filter.call(inputChildNodes, function (item) {
	          return item.tagName === 'INPUT';
	        })[0];
	        var tags = _this10.$refs.tags;
	        var sizeInMap = _this10.initialInputHeight || 40;
	        input.style.height = _this10.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
	        if (_this10.visible && _this10.emptyText !== false) {
	          _this10.broadcast('ElSelectDropdown', 'updatePopper');
	        }
	      });
	    },
	    resetHoverIndex: function resetHoverIndex() {
	      var _this11 = this;
	
	      setTimeout(function () {
	        if (!_this11.multiple) {
	          _this11.hoverIndex = _this11.options.indexOf(_this11.selected);
	        } else {
	          if (_this11.selected.length > 0) {
	            _this11.hoverIndex = Math.min.apply(null, _this11.selected.map(function (item) {
	              return _this11.options.indexOf(item);
	            }));
	          } else {
	            _this11.hoverIndex = -1;
	          }
	        }
	      }, 300);
	    },
	    handleOptionSelect: function handleOptionSelect(option, byClick) {
	      var _this12 = this;
	
	      if (this.multiple) {
	        var value = (this.value || []).slice();
	        var optionIndex = this.getValueIndex(value, option.value);
	        if (optionIndex > -1) {
	          value.splice(optionIndex, 1);
	        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
	          value.push(option.value);
	        }
	        this.$emit('input', value);
	        this.emitChange(value);
	        if (option.created) {
	          this.query = '';
	          this.handleQueryChange('');
	          this.inputLength = 20;
	        }
	        if (this.filterable) this.$refs.input.focus();
	      } else {
	        this.$emit('input', option.value);
	        this.emitChange(option.value);
	        this.visible = false;
	      }
	      this.isSilentBlur = byClick;
	      this.setSoftFocus();
	      if (this.visible) return;
	      this.$nextTick(function () {
	        _this12.scrollToOption(option);
	      });
	    },
	    setSoftFocus: function setSoftFocus() {
	      this.softFocus = true;
	      var input = this.$refs.input || this.$refs.reference;
	      if (input) {
	        input.focus();
	      }
	    },
	    getValueIndex: function getValueIndex() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var value = arguments[1];
	
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      if (!isObject) {
	        return arr.indexOf(value);
	      } else {
	        var valueKey = this.valueKey;
	        var index = -1;
	        arr.some(function (item, i) {
	          if (Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(value, valueKey)) {
	            index = i;
	            return true;
	          }
	          return false;
	        });
	        return index;
	      }
	    },
	    toggleMenu: function toggleMenu() {
	      if (!this.selectDisabled) {
	        if (this.menuVisibleOnFocus) {
	          this.menuVisibleOnFocus = false;
	        } else {
	          this.visible = !this.visible;
	        }
	        if (this.visible) {
	          (this.$refs.input || this.$refs.reference).focus();
	        }
	      }
	    },
	    selectOption: function selectOption() {
	      if (!this.visible) {
	        this.toggleMenu();
	      } else {
	        if (this.options[this.hoverIndex]) {
	          this.handleOptionSelect(this.options[this.hoverIndex]);
	        }
	      }
	    },
	    deleteSelected: function deleteSelected(event) {
	      event.stopPropagation();
	      var value = this.multiple ? [] : '';
	      this.$emit('input', value);
	      this.emitChange(value);
	      this.visible = false;
	      this.$emit('clear');
	    },
	    deleteTag: function deleteTag(event, tag) {
	      var index = this.selected.indexOf(tag);
	      if (index > -1 && !this.selectDisabled) {
	        var value = this.value.slice();
	        value.splice(index, 1);
	        this.$emit('input', value);
	        this.emitChange(value);
	        this.$emit('remove-tag', tag.value);
	      }
	      event.stopPropagation();
	    },
	    onInputChange: function onInputChange() {
	      if (this.filterable && this.query !== this.selectedLabel) {
	        this.query = this.selectedLabel;
	        this.handleQueryChange(this.query);
	      }
	    },
	    onOptionDestroy: function onOptionDestroy(index) {
	      if (index > -1) {
	        this.optionsCount--;
	        this.filteredOptionsCount--;
	        this.options.splice(index, 1);
	      }
	    },
	    resetInputWidth: function resetInputWidth() {
	      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
	    },
	    handleResize: function handleResize() {
	      this.resetInputWidth();
	      if (this.multiple) this.resetInputHeight();
	    },
	    checkDefaultFirstOption: function checkDefaultFirstOption() {
	      this.hoverIndex = -1;
	      // highlight the created option
	      var hasCreated = false;
	      for (var i = this.options.length - 1; i >= 0; i--) {
	        if (this.options[i].created) {
	          hasCreated = true;
	          this.hoverIndex = i;
	          break;
	        }
	      }
	      if (hasCreated) return;
	      for (var _i = 0; _i !== this.options.length; ++_i) {
	        var option = this.options[_i];
	        if (this.query) {
	          // highlight first options that passes the filter
	          if (!option.disabled && !option.groupDisabled && option.visible) {
	            this.hoverIndex = _i;
	            break;
	          }
	        } else {
	          // highlight currently selected option
	          if (option.itemSelected) {
	            this.hoverIndex = _i;
	            break;
	          }
	        }
	      }
	    },
	    getValueKey: function getValueKey(item) {
	      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
	        return item.value;
	      } else {
	        return Object(util_["getValueByPath"])(item.value, this.valueKey);
	      }
	    }
	  },
	
	  created: function created() {
	    var _this13 = this;
	
	    this.cachedPlaceHolder = this.currentPlaceholder = this.propPlaceholder;
	    if (this.multiple && !Array.isArray(this.value)) {
	      this.$emit('input', []);
	    }
	    if (!this.multiple && Array.isArray(this.value)) {
	      this.$emit('input', '');
	    }
	
	    this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
	      _this13.onInputChange();
	    });
	
	    this.debouncedQueryChange = debounce_default()(this.debounce, function (e) {
	      _this13.handleQueryChange(e.target.value);
	    });
	
	    this.$on('handleOptionClick', this.handleOptionSelect);
	    this.$on('setSelected', this.setSelected);
	  },
	  mounted: function mounted() {
	    var _this14 = this;
	
	    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
	      this.currentPlaceholder = '';
	    }
	    Object(resize_event_["addResizeListener"])(this.$el, this.handleResize);
	
	    var reference = this.$refs.reference;
	    if (reference && reference.$el) {
	      var sizeMap = {
	        medium: 36,
	        small: 32,
	        mini: 28
	      };
	      var input = reference.$el.querySelector('input');
	      this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.selectSize];
	    }
	    if (this.remote && this.multiple) {
	      this.resetInputHeight();
	    }
	    this.$nextTick(function () {
	      if (reference && reference.$el) {
	        _this14.inputWidth = reference.$el.getBoundingClientRect().width;
	      }
	    });
	    this.setSelected();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el && this.handleResize) Object(resize_event_["removeResizeListener"])(this.$el, this.handleResize);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_selectvue_type_script_lang_js_ = (selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/select.vue
	
	
	
	
	
	/* normalize component */
	
	var select_component = normalizeComponent(
	  src_selectvue_type_script_lang_js_,
	  selectvue_type_template_id_0e4aade6_render,
	  selectvue_type_template_id_0e4aade6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var select_api; }
	select_component.options.__file = "packages/select/src/select.vue"
	/* harmony default export */ var src_select = (select_component.exports);
	// CONCATENATED MODULE: ./packages/select/index.js
	
	
	/* istanbul ignore next */
	src_select.install = function (Vue) {
	  Vue.component(src_select.name, src_select);
	};
	
	/* harmony default export */ var packages_select = (src_select);
	// CONCATENATED MODULE: ./packages/option/index.js
	
	
	/* istanbul ignore next */
	src_option.install = function (Vue) {
	  Vue.component(src_option.name, src_option);
	};
	
	/* harmony default export */ var packages_option = (src_option);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&
	var option_groupvue_type_template_id_6685e5de_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "ul",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-group__wrap"
	    },
	    [
	      _c("li", { staticClass: "el-select-group__title" }, [
	        _vm._v(_vm._s(_vm.label))
	      ]),
	      _c("li", [
	        _c("ul", { staticClass: "el-select-group" }, [_vm._t("default")], 2)
	      ])
	    ]
	  )
	}
	var option_groupvue_type_template_id_6685e5de_staticRenderFns = []
	option_groupvue_type_template_id_6685e5de_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var option_groupvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOptionGroup',
	
	  componentName: 'ElOptionGroup',
	
	  props: {
	    label: String,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      visible: true
	    };
	  },
	
	
	  watch: {
	    disabled: function disabled(val) {
	      this.broadcast('ElOption', 'handleGroupDisabled', val);
	    }
	  },
	
	  methods: {
	    queryChange: function queryChange() {
	      this.visible = this.$children && Array.isArray(this.$children) && this.$children.some(function (option) {
	        return option.visible === true;
	      });
	    }
	  },
	
	  created: function created() {
	    this.$on('queryChange', this.queryChange);
	  },
	  mounted: function mounted() {
	    if (this.disabled) {
	      this.broadcast('ElOption', 'handleGroupDisabled', this.disabled);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_option_groupvue_type_script_lang_js_ = (option_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/option-group.vue
	
	
	
	
	
	/* normalize component */
	
	var option_group_component = normalizeComponent(
	  src_option_groupvue_type_script_lang_js_,
	  option_groupvue_type_template_id_6685e5de_render,
	  option_groupvue_type_template_id_6685e5de_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var option_group_api; }
	option_group_component.options.__file = "packages/select/src/option-group.vue"
	/* harmony default export */ var option_group = (option_group_component.exports);
	// CONCATENATED MODULE: ./packages/option-group/index.js
	
	
	/* istanbul ignore next */
	option_group.install = function (Vue) {
	  Vue.component(option_group.name, option_group);
	};
	
	/* harmony default export */ var packages_option_group = (option_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	var buttonvue_type_template_id_ca859fb4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "button",
	    {
	      staticClass: "el-button",
	      class: [
	        _vm.type ? "el-button--" + _vm.type : "",
	        _vm.buttonSize ? "el-button--" + _vm.buttonSize : "",
	        {
	          "is-disabled": _vm.buttonDisabled,
	          "is-loading": _vm.loading,
	          "is-plain": _vm.plain,
	          "is-round": _vm.round,
	          "is-circle": _vm.circle
	        }
	      ],
	      attrs: {
	        disabled: _vm.buttonDisabled || _vm.loading,
	        autofocus: _vm.autofocus,
	        type: _vm.nativeType
	      },
	      on: { click: _vm.handleClick }
	    },
	    [
	      _vm.loading ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(),
	      _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(),
	      _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()
	    ]
	  )
	}
	var buttonvue_type_template_id_ca859fb4_staticRenderFns = []
	buttonvue_type_template_id_ca859fb4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
	  name: 'ElButton',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    size: String,
	    icon: {
	      type: String,
	      default: ''
	    },
	    nativeType: {
	      type: String,
	      default: 'button'
	    },
	    loading: Boolean,
	    disabled: Boolean,
	    plain: Boolean,
	    autofocus: Boolean,
	    round: Boolean,
	    circle: Boolean
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    buttonSize: function buttonSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    buttonDisabled: function buttonDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(evt) {
	      this.$emit('click', evt);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/button/src/button.vue
	
	
	
	
	
	/* normalize component */
	
	var button_component = normalizeComponent(
	  src_buttonvue_type_script_lang_js_,
	  buttonvue_type_template_id_ca859fb4_render,
	  buttonvue_type_template_id_ca859fb4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var button_api; }
	button_component.options.__file = "packages/button/src/button.vue"
	/* harmony default export */ var src_button = (button_component.exports);
	// CONCATENATED MODULE: ./packages/button/index.js
	
	
	/* istanbul ignore next */
	src_button.install = function (Vue) {
	  Vue.component(src_button.name, src_button);
	};
	
	/* harmony default export */ var packages_button = (src_button);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	var button_groupvue_type_template_id_3d8661d0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-button-group" }, [_vm._t("default")], 2)
	}
	var button_groupvue_type_template_id_3d8661d0_staticRenderFns = []
	button_groupvue_type_template_id_3d8661d0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var button_groupvue_type_script_lang_js_ = ({
	  name: 'ElButtonGroup'
	});
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_button_groupvue_type_script_lang_js_ = (button_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue
	
	
	
	
	
	/* normalize component */
	
	var button_group_component = normalizeComponent(
	  src_button_groupvue_type_script_lang_js_,
	  button_groupvue_type_template_id_3d8661d0_render,
	  button_groupvue_type_template_id_3d8661d0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var button_group_api; }
	button_group_component.options.__file = "packages/button/src/button-group.vue"
	/* harmony default export */ var button_group = (button_group_component.exports);
	// CONCATENATED MODULE: ./packages/button-group/index.js
	
	
	/* istanbul ignore next */
	button_group.install = function (Vue) {
	  Vue.component(button_group.name, button_group);
	};
	
	/* harmony default export */ var packages_button_group = (button_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=template&id=493fe34e&
	var tablevue_type_template_id_493fe34e_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-table",
	      class: [
	        {
	          "el-table--fit": _vm.fit,
	          "el-table--striped": _vm.stripe,
	          "el-table--border": _vm.border || _vm.isGroup,
	          "el-table--hidden": _vm.isHidden,
	          "el-table--group": _vm.isGroup,
	          "el-table--fluid-height": _vm.maxHeight,
	          "el-table--scrollable-x": _vm.layout.scrollX,
	          "el-table--scrollable-y": _vm.layout.scrollY,
	          "el-table--enable-row-hover": !_vm.store.states.isComplex,
	          "el-table--enable-row-transition":
	            (_vm.store.states.data || []).length !== 0 &&
	            (_vm.store.states.data || []).length < 100
	        },
	        _vm.tableSize ? "el-table--" + _vm.tableSize : ""
	      ],
	      on: {
	        mouseleave: function($event) {
	          _vm.handleMouseLeave($event)
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        { ref: "hiddenColumns", staticClass: "hidden-columns" },
	        [_vm._t("default")],
	        2
	      ),
	      _vm.showHeader
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleHeaderFooterMousewheel,
	                  expression: "handleHeaderFooterMousewheel"
	                }
	              ],
	              ref: "headerWrapper",
	              staticClass: "el-table__header-wrapper"
	            },
	            [
	              _c("table-header", {
	                ref: "tableHeader",
	                style: {
	                  width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + "px" : ""
	                },
	                attrs: {
	                  store: _vm.store,
	                  border: _vm.border,
	                  "default-sort": _vm.defaultSort
	                }
	              })
	            ],
	            1
	          )
	        : _vm._e(),
	      _c(
	        "div",
	        {
	          ref: "bodyWrapper",
	          staticClass: "el-table__body-wrapper",
	          class: [
	            _vm.layout.scrollX
	              ? "is-scrolling-" + _vm.scrollPosition
	              : "is-scrolling-none"
	          ],
	          style: [_vm.bodyHeight]
	        },
	        [
	          _c("table-body", {
	            style: {
	              width: _vm.bodyWidth
	            },
	            attrs: {
	              context: _vm.context,
	              store: _vm.store,
	              stripe: _vm.stripe,
	              "row-class-name": _vm.rowClassName,
	              "row-style": _vm.rowStyle,
	              highlight: _vm.highlightCurrentRow
	            }
	          }),
	          !_vm.data || _vm.data.length === 0
	            ? _c(
	                "div",
	                {
	                  ref: "emptyBlock",
	                  staticClass: "el-table__empty-block",
	                  style: _vm.emptyBlockStyle
	                },
	                [
	                  _c(
	                    "span",
	                    { staticClass: "el-table__empty-text" },
	                    [
	                      _vm._t("empty", [
	                        _vm._v(
	                          _vm._s(_vm.emptyText || _vm.t("el.table.emptyText"))
	                        )
	                      ])
	                    ],
	                    2
	                  )
	                ]
	              )
	            : _vm._e(),
	          _vm.$slots.append
	            ? _c(
	                "div",
	                {
	                  ref: "appendWrapper",
	                  staticClass: "el-table__append-wrapper"
	                },
	                [_vm._t("append")],
	                2
	              )
	            : _vm._e()
	        ],
	        1
	      ),
	      _vm.showSummary
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.data && _vm.data.length > 0,
	                  expression: "data && data.length > 0"
	                },
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleHeaderFooterMousewheel,
	                  expression: "handleHeaderFooterMousewheel"
	                }
	              ],
	              ref: "footerWrapper",
	              staticClass: "el-table__footer-wrapper"
	            },
	            [
	              _c("table-footer", {
	                style: {
	                  width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + "px" : ""
	                },
	                attrs: {
	                  store: _vm.store,
	                  border: _vm.border,
	                  "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
	                  "summary-method": _vm.summaryMethod,
	                  "default-sort": _vm.defaultSort
	                }
	              })
	            ],
	            1
	          )
	        : _vm._e(),
	      _vm.fixedColumns.length > 0
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleFixedMousewheel,
	                  expression: "handleFixedMousewheel"
	                }
	              ],
	              ref: "fixedWrapper",
	              staticClass: "el-table__fixed",
	              style: [
	                {
	                  width: _vm.layout.fixedWidth
	                    ? _vm.layout.fixedWidth + "px"
	                    : ""
	                },
	                _vm.fixedHeight
	              ]
	            },
	            [
	              _vm.showHeader
	                ? _c(
	                    "div",
	                    {
	                      ref: "fixedHeaderWrapper",
	                      staticClass: "el-table__fixed-header-wrapper"
	                    },
	                    [
	                      _c("table-header", {
	                        ref: "fixedTableHeader",
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "left",
	                          border: _vm.border,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              _c(
	                "div",
	                {
	                  ref: "fixedBodyWrapper",
	                  staticClass: "el-table__fixed-body-wrapper",
	                  style: [
	                    {
	                      top: _vm.layout.headerHeight + "px"
	                    },
	                    _vm.fixedBodyHeight
	                  ]
	                },
	                [
	                  _c("table-body", {
	                    style: {
	                      width: _vm.bodyWidth
	                    },
	                    attrs: {
	                      fixed: "left",
	                      store: _vm.store,
	                      stripe: _vm.stripe,
	                      highlight: _vm.highlightCurrentRow,
	                      "row-class-name": _vm.rowClassName,
	                      "row-style": _vm.rowStyle
	                    }
	                  }),
	                  _vm.$slots.append
	                    ? _c("div", {
	                        staticClass: "el-table__append-gutter",
	                        style: { height: _vm.layout.appendHeight + "px" }
	                      })
	                    : _vm._e()
	                ],
	                1
	              ),
	              _vm.showSummary
	                ? _c(
	                    "div",
	                    {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.data && _vm.data.length > 0,
	                          expression: "data && data.length > 0"
	                        }
	                      ],
	                      ref: "fixedFooterWrapper",
	                      staticClass: "el-table__fixed-footer-wrapper"
	                    },
	                    [
	                      _c("table-footer", {
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "left",
	                          border: _vm.border,
	                          "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
	                          "summary-method": _vm.summaryMethod,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e()
	            ]
	          )
	        : _vm._e(),
	      _vm.rightFixedColumns.length > 0
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleFixedMousewheel,
	                  expression: "handleFixedMousewheel"
	                }
	              ],
	              ref: "rightFixedWrapper",
	              staticClass: "el-table__fixed-right",
	              style: [
	                {
	                  width: _vm.layout.rightFixedWidth
	                    ? _vm.layout.rightFixedWidth + "px"
	                    : "",
	                  right: _vm.layout.scrollY
	                    ? (_vm.border
	                        ? _vm.layout.gutterWidth
	                        : _vm.layout.gutterWidth || 0) + "px"
	                    : ""
	                },
	                _vm.fixedHeight
	              ]
	            },
	            [
	              _vm.showHeader
	                ? _c(
	                    "div",
	                    {
	                      ref: "rightFixedHeaderWrapper",
	                      staticClass: "el-table__fixed-header-wrapper"
	                    },
	                    [
	                      _c("table-header", {
	                        ref: "rightFixedTableHeader",
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "right",
	                          border: _vm.border,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              _c(
	                "div",
	                {
	                  ref: "rightFixedBodyWrapper",
	                  staticClass: "el-table__fixed-body-wrapper",
	                  style: [
	                    {
	                      top: _vm.layout.headerHeight + "px"
	                    },
	                    _vm.fixedBodyHeight
	                  ]
	                },
	                [
	                  _c("table-body", {
	                    style: {
	                      width: _vm.bodyWidth
	                    },
	                    attrs: {
	                      fixed: "right",
	                      store: _vm.store,
	                      stripe: _vm.stripe,
	                      "row-class-name": _vm.rowClassName,
	                      "row-style": _vm.rowStyle,
	                      highlight: _vm.highlightCurrentRow
	                    }
	                  }),
	                  _vm.$slots.append
	                    ? _c("div", {
	                        staticClass: "el-table__append-gutter",
	                        style: { height: _vm.layout.appendHeight + "px" }
	                      })
	                    : _vm._e()
	                ],
	                1
	              ),
	              _vm.showSummary
	                ? _c(
	                    "div",
	                    {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.data && _vm.data.length > 0,
	                          expression: "data && data.length > 0"
	                        }
	                      ],
	                      ref: "rightFixedFooterWrapper",
	                      staticClass: "el-table__fixed-footer-wrapper"
	                    },
	                    [
	                      _c("table-footer", {
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "right",
	                          border: _vm.border,
	                          "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
	                          "summary-method": _vm.summaryMethod,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e()
	            ]
	          )
	        : _vm._e(),
	      _vm.rightFixedColumns.length > 0
	        ? _c("div", {
	            ref: "rightFixedPatch",
	            staticClass: "el-table__fixed-right-patch",
	            style: {
	              width: _vm.layout.scrollY ? _vm.layout.gutterWidth + "px" : "0",
	              height: _vm.layout.headerHeight + "px"
	            }
	          })
	        : _vm._e(),
	      _c("div", {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.resizeProxyVisible,
	            expression: "resizeProxyVisible"
	          }
	        ],
	        ref: "resizeProxy",
	        staticClass: "el-table__column-resize-proxy"
	      })
	    ]
	  )
	}
	var tablevue_type_template_id_493fe34e_staticRenderFns = []
	tablevue_type_template_id_493fe34e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=template&id=493fe34e&
	
	// EXTERNAL MODULE: external "element-ui/lib/checkbox"
	var checkbox_ = __webpack_require__(16);
	var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);
	
	// EXTERNAL MODULE: external "throttle-debounce"
	var external_throttle_debounce_ = __webpack_require__(35);
	
	// EXTERNAL MODULE: external "normalize-wheel"
	var external_normalize_wheel_ = __webpack_require__(38);
	var external_normalize_wheel_default = /*#__PURE__*/__webpack_require__.n(external_normalize_wheel_);
	
	// CONCATENATED MODULE: ./src/directives/mousewheel.js
	
	
	var isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	
	var mousewheel_mousewheel = function mousewheel(element, callback) {
	  if (element && element.addEventListener) {
	    element.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', function (event) {
	      var normalized = external_normalize_wheel_default()(event);
	      callback && callback.apply(this, [event, normalized]);
	    });
	  }
	};
	
	/* harmony default export */ var directives_mousewheel = ({
	  bind: function bind(el, binding) {
	    mousewheel_mousewheel(el, binding.value);
	  }
	});
	// EXTERNAL MODULE: external "vue"
	var external_vue_ = __webpack_require__(6);
	var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
	
	// CONCATENATED MODULE: ./packages/table/src/util.js
	var util_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	
	
	var getCell = function getCell(event) {
	  var cell = event.target;
	
	  while (cell && cell.tagName.toUpperCase() !== 'HTML') {
	    if (cell.tagName.toUpperCase() === 'TD') {
	      return cell;
	    }
	    cell = cell.parentNode;
	  }
	
	  return null;
	};
	
	var util_isObject = function isObject(obj) {
	  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : util_typeof(obj)) === 'object';
	};
	
	var util_orderBy = function orderBy(array, sortKey, reverse, sortMethod, sortBy) {
	  if (!sortKey && !sortMethod && (!sortBy || Array.isArray(sortBy) && !sortBy.length)) {
	    return array;
	  }
	  if (typeof reverse === 'string') {
	    reverse = reverse === 'descending' ? -1 : 1;
	  } else {
	    reverse = reverse && reverse < 0 ? -1 : 1;
	  }
	  var getKey = sortMethod ? null : function (value, index) {
	    if (sortBy) {
	      if (!Array.isArray(sortBy)) {
	        sortBy = [sortBy];
	      }
	      return sortBy.map(function (by) {
	        if (typeof by === 'string') {
	          return Object(util_["getValueByPath"])(value, by);
	        } else {
	          return by(value, index, array);
	        }
	      });
	    }
	    if (sortKey !== '$key') {
	      if (util_isObject(value) && '$value' in value) value = value.$value;
	    }
	    return [util_isObject(value) ? Object(util_["getValueByPath"])(value, sortKey) : value];
	  };
	  var compare = function compare(a, b) {
	    if (sortMethod) {
	      return sortMethod(a.value, b.value);
	    }
	    for (var i = 0, len = a.key.length; i < len; i++) {
	      if (a.key[i] < b.key[i]) {
	        return -1;
	      }
	      if (a.key[i] > b.key[i]) {
	        return 1;
	      }
	    }
	    return 0;
	  };
	  return array.map(function (value, index) {
	    return {
	      value: value,
	      index: index,
	      key: getKey ? getKey(value, index) : null
	    };
	  }).sort(function (a, b) {
	    var order = compare(a, b);
	    if (!order) {
	      // make stable https://en.wikipedia.org/wiki/Sorting_algorithm#Stability
	      order = a.index - b.index;
	    }
	    return order * reverse;
	  }).map(function (item) {
	    return item.value;
	  });
	};
	
	var getColumnById = function getColumnById(table, columnId) {
	  var column = null;
	  table.columns.forEach(function (item) {
	    if (item.id === columnId) {
	      column = item;
	    }
	  });
	  return column;
	};
	
	var getColumnByKey = function getColumnByKey(table, columnKey) {
	  var column = null;
	  for (var i = 0; i < table.columns.length; i++) {
	    var item = table.columns[i];
	    if (item.columnKey === columnKey) {
	      column = item;
	      break;
	    }
	  }
	  return column;
	};
	
	var getColumnByCell = function getColumnByCell(table, cell) {
	  var matches = (cell.className || '').match(/el-table_[^\s]+/gm);
	  if (matches) {
	    return getColumnById(table, matches[0]);
	  }
	  return null;
	};
	
	var getRowIdentity = function getRowIdentity(row, rowKey) {
	  if (!row) throw new Error('row is required when get row identity');
	  if (typeof rowKey === 'string') {
	    if (rowKey.indexOf('.') < 0) {
	      return row[rowKey];
	    }
	    var key = rowKey.split('.');
	    var current = row;
	    for (var i = 0; i < key.length; i++) {
	      current = current[key[i]];
	    }
	    return current;
	  } else if (typeof rowKey === 'function') {
	    return rowKey.call(null, row);
	  }
	};
	
	var getKeysMap = function getKeysMap(array, rowKey) {
	  var arrayMap = {};
	  (array || []).forEach(function (row, index) {
	    arrayMap[getRowIdentity(row, rowKey)] = { row: row, index: index };
	  });
	  return arrayMap;
	};
	
	function hasOwn(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	function mergeOptions(defaults, config) {
	  var options = {};
	  var key = void 0;
	  for (key in defaults) {
	    options[key] = defaults[key];
	  }
	  for (key in config) {
	    if (hasOwn(config, key)) {
	      var value = config[key];
	      if (typeof value !== 'undefined') {
	        options[key] = value;
	      }
	    }
	  }
	  return options;
	}
	
	function parseWidth(width) {
	  if (width !== undefined) {
	    width = parseInt(width, 10);
	    if (isNaN(width)) {
	      width = null;
	    }
	  }
	  return width;
	}
	
	function parseMinWidth(minWidth) {
	  if (typeof minWidth !== 'undefined') {
	    minWidth = parseWidth(minWidth);
	    if (isNaN(minWidth)) {
	      minWidth = 80;
	    }
	  }
	  return minWidth;
	};
	
	function parseHeight(height) {
	  if (typeof height === 'number') {
	    return height;
	  }
	  if (typeof height === 'string') {
	    if (/^\d+(?:px)?$/.test(height)) {
	      return parseInt(height, 10);
	    } else {
	      return height;
	    }
	  }
	  return null;
	}
	
	// https://github.com/reduxjs/redux/blob/master/src/compose.js
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}
	
	function toggleRowStatus(statusArr, row, newVal) {
	  var changed = false;
	  var index = statusArr.indexOf(row);
	  var included = index !== -1;
	
	  var addRow = function addRow() {
	    statusArr.push(row);
	    changed = true;
	  };
	  var removeRow = function removeRow() {
	    statusArr.splice(index, 1);
	    changed = true;
	  };
	
	  if (typeof newVal === 'boolean') {
	    if (newVal && !included) {
	      addRow();
	    } else if (!newVal && included) {
	      removeRow();
	    }
	  } else {
	    if (included) {
	      removeRow();
	    } else {
	      addRow();
	    }
	  }
	  return changed;
	}
	
	function walkTreeNode(root, cb) {
	  var childrenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
	  var lazyKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'hasChildren';
	
	  var isNil = function isNil(array) {
	    return !(Array.isArray(array) && array.length);
	  };
	
	  function _walker(parent, children, level) {
	    cb(parent, children, level);
	    children.forEach(function (item) {
	      if (item[lazyKey]) {
	        cb(item, null, level + 1);
	        return;
	      }
	      var children = item[childrenKey];
	      if (!isNil(children)) {
	        _walker(item, children, level + 1);
	      }
	    });
	  }
	
	  root.forEach(function (item) {
	    if (item[lazyKey]) {
	      cb(item, null, 0);
	      return;
	    }
	    var children = item[childrenKey];
	    if (!isNil(children)) {
	      _walker(item, children, 0);
	    }
	  });
	}
	// CONCATENATED MODULE: ./packages/table/src/store/expand.js
	
	
	/* harmony default export */ var expand = ({
	  data: function data() {
	    return {
	      states: {
	        defaultExpandAll: false,
	        expandRows: []
	      }
	    };
	  },
	
	
	  methods: {
	    updateExpandRows: function updateExpandRows() {
	      var _states = this.states,
	          _states$data = _states.data,
	          data = _states$data === undefined ? [] : _states$data,
	          rowKey = _states.rowKey,
	          defaultExpandAll = _states.defaultExpandAll,
	          expandRows = _states.expandRows;
	
	      if (defaultExpandAll) {
	        this.states.expandRows = data.slice();
	      } else if (rowKey) {
	        // TODO：这里的代码可以优化
	        var expandRowsMap = getKeysMap(expandRows, rowKey);
	        this.states.expandRows = data.reduce(function (prev, row) {
	          var rowId = getRowIdentity(row, rowKey);
	          var rowInfo = expandRowsMap[rowId];
	          if (rowInfo) {
	            prev.push(row);
	          }
	          return prev;
	        }, []);
	      } else {
	        this.states.expandRows = [];
	      }
	    },
	    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
	      var changed = toggleRowStatus(this.states.expandRows, row, expanded);
	      if (changed) {
	        this.table.$emit('expand-change', row, this.states.expandRows.slice());
	        this.scheduleLayout();
	      }
	    },
	    setExpandRowKeys: function setExpandRowKeys(rowKeys) {
	      this.assertRowKey();
	      // TODO：这里的代码可以优化
	      var _states2 = this.states,
	          data = _states2.data,
	          rowKey = _states2.rowKey;
	
	      var keysMap = getKeysMap(data, rowKey);
	      this.states.expandRows = rowKeys.reduce(function (prev, cur) {
	        var info = keysMap[cur];
	        if (info) {
	          prev.push(info.row);
	        }
	        return prev;
	      }, []);
	    },
	    isRowExpanded: function isRowExpanded(row) {
	      var _states3 = this.states,
	          _states3$expandRows = _states3.expandRows,
	          expandRows = _states3$expandRows === undefined ? [] : _states3$expandRows,
	          rowKey = _states3.rowKey;
	
	      if (rowKey) {
	        var expandMap = getKeysMap(expandRows, rowKey);
	        return !!expandMap[getRowIdentity(row, rowKey)];
	      }
	      return expandRows.indexOf(row) !== -1;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/store/current.js
	
	
	
	/* harmony default export */ var current = ({
	  data: function data() {
	    return {
	      states: {
	        // 不可响应的，设置 currentRowKey 时，data 不一定存在，也许无法算出正确的 currentRow
	        // 把该值缓存一下，当用户点击修改 currentRow 时，把该值重置为 null
	        _currentRowKey: null,
	        currentRow: null
	      }
	    };
	  },
	
	
	  methods: {
	    setCurrentRowKey: function setCurrentRowKey(key) {
	      this.assertRowKey();
	      this.states._currentRowKey = key;
	      this.setCurrentRowByKey(key);
	    },
	    restoreCurrentRowKey: function restoreCurrentRowKey() {
	      this.states._currentRowKey = null;
	    },
	    setCurrentRowByKey: function setCurrentRowByKey(key) {
	      var states = this.states;
	      var _states$data = states.data,
	          data = _states$data === undefined ? [] : _states$data,
	          rowKey = states.rowKey;
	
	      var currentRow = null;
	      if (rowKey) {
	        currentRow = Object(util_["arrayFind"])(data, function (item) {
	          return getRowIdentity(item, rowKey) === key;
	        });
	      }
	      states.currentRow = currentRow;
	    },
	    updateCurrentRow: function updateCurrentRow(currentRow) {
	      var states = this.states,
	          table = this.table;
	
	      var oldCurrentRow = states.currentRow;
	      if (currentRow && currentRow !== oldCurrentRow) {
	        states.currentRow = currentRow;
	        table.$emit('current-change', currentRow, oldCurrentRow);
	        return;
	      }
	      if (!currentRow && oldCurrentRow) {
	        states.currentRow = null;
	        table.$emit('current-change', null, oldCurrentRow);
	      }
	    },
	    updateCurrentRowData: function updateCurrentRowData() {
	      var states = this.states,
	          table = this.table;
	      var rowKey = states.rowKey,
	          _currentRowKey = states._currentRowKey;
	      // data 为 null 时，解构时的默认值会被忽略
	
	      var data = states.data || [];
	      var oldCurrentRow = states.currentRow;
	
	      // 当 currentRow 不在 data 中时尝试更新数据
	      if (data.indexOf(oldCurrentRow) === -1 && oldCurrentRow) {
	        if (rowKey) {
	          var currentRowKey = getRowIdentity(oldCurrentRow, rowKey);
	          this.setCurrentRowByKey(currentRowKey);
	        } else {
	          states.currentRow = null;
	        }
	        if (states.currentRow === null) {
	          table.$emit('current-change', null, oldCurrentRow);
	        }
	      } else if (_currentRowKey) {
	        // 把初始时下设置的 rowKey 转化成 rowData
	        this.setCurrentRowByKey(_currentRowKey);
	        this.restoreCurrentRowKey();
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/store/tree.js
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	/* harmony default export */ var tree = ({
	  data: function data() {
	    return {
	      states: {
	        // defaultExpandAll 存在于 expand.js 中，这里不重复添加
	        // 在展开行中，expandRowKeys 会被转化成 expandRows，expandRowKeys 这个属性只是记录了 TreeTable 行的展开
	        // TODO: 拆分为独立的 TreeTable，统一用法
	        expandRowKeys: [],
	        treeData: {},
	        indent: 16,
	        lazy: false,
	        lazyTreeNodeMap: {},
	        lazyColumnIdentifier: 'hasChildren',
	        childrenColumnName: 'children'
	      }
	    };
	  },
	
	
	  computed: {
	    // 嵌入型的数据，watch 无法是检测到变化 https://github.com/ElemeFE/element/issues/14998
	    // TODO: 使用 computed 解决该问题，是否会造成性能问题？
	    // @return { id: { level, children } }
	    normalizedData: function normalizedData() {
	      if (!this.states.rowKey) return {};
	      var data = this.states.data || [];
	      return this.normalize(data);
	    },
	
	    // @return { id: { children } }
	    // 针对懒加载的情形，不处理嵌套数据
	    normalizedLazyNode: function normalizedLazyNode() {
	      var _states = this.states,
	          rowKey = _states.rowKey,
	          lazyTreeNodeMap = _states.lazyTreeNodeMap,
	          lazyColumnIdentifier = _states.lazyColumnIdentifier;
	
	      var keys = Object.keys(lazyTreeNodeMap);
	      var res = {};
	      if (!keys.length) return res;
	      keys.forEach(function (key) {
	        if (lazyTreeNodeMap[key].length) {
	          var item = { children: [] };
	          lazyTreeNodeMap[key].forEach(function (row) {
	            var currentRowKey = getRowIdentity(row, rowKey);
	            item.children.push(currentRowKey);
	            if (row[lazyColumnIdentifier] && !res[currentRowKey]) {
	              res[currentRowKey] = { children: [] };
	            }
	          });
	          res[key] = item;
	        }
	      });
	      return res;
	    }
	  },
	
	  watch: {
	    normalizedData: 'updateTreeData',
	    normalizedLazyNode: 'updateTreeData'
	  },
	
	  methods: {
	    normalize: function normalize(data) {
	      var _states2 = this.states,
	          childrenColumnName = _states2.childrenColumnName,
	          lazyColumnIdentifier = _states2.lazyColumnIdentifier,
	          rowKey = _states2.rowKey,
	          lazy = _states2.lazy;
	
	      var res = {};
	      walkTreeNode(data, function (parent, children, level) {
	        var parentId = getRowIdentity(parent, rowKey);
	        if (Array.isArray(children)) {
	          res[parentId] = {
	            children: children.map(function (row) {
	              return getRowIdentity(row, rowKey);
	            }),
	            level: level
	          };
	        } else if (lazy) {
	          // 当 children 不存在且 lazy 为 true，该节点即为懒加载的节点
	          res[parentId] = {
	            children: [],
	            lazy: true,
	            level: level
	          };
	        }
	      }, childrenColumnName, lazyColumnIdentifier);
	      return res;
	    },
	    updateTreeData: function updateTreeData() {
	      var nested = this.normalizedData;
	      var normalizedLazyNode = this.normalizedLazyNode;
	      var keys = Object.keys(nested);
	      var newTreeData = {};
	      if (keys.length) {
	        var _states3 = this.states,
	            oldTreeData = _states3.treeData,
	            defaultExpandAll = _states3.defaultExpandAll,
	            expandRowKeys = _states3.expandRowKeys,
	            lazy = _states3.lazy;
	
	        var rootLazyRowKeys = [];
	        var getExpanded = function getExpanded(oldValue, key) {
	          var included = defaultExpandAll || expandRowKeys && expandRowKeys.indexOf(key) !== -1;
	          return !!(oldValue && oldValue.expanded || included);
	        };
	        // 合并 expanded 与 display，确保数据刷新后，状态不变
	        keys.forEach(function (key) {
	          var oldValue = oldTreeData[key];
	          var newValue = _extends({}, nested[key]);
	          newValue.expanded = getExpanded(oldValue, key);
	          if (newValue.lazy) {
	            var _ref = oldValue || {},
	                _ref$loaded = _ref.loaded,
	                loaded = _ref$loaded === undefined ? false : _ref$loaded,
	                _ref$loading = _ref.loading,
	                loading = _ref$loading === undefined ? false : _ref$loading;
	
	            newValue.loaded = !!loaded;
	            newValue.loading = !!loading;
	            rootLazyRowKeys.push(key);
	          }
	          newTreeData[key] = newValue;
	        });
	        // 根据懒加载数据更新 treeData
	        var lazyKeys = Object.keys(normalizedLazyNode);
	        if (lazy && lazyKeys.length && rootLazyRowKeys.length) {
	          lazyKeys.forEach(function (key) {
	            var oldValue = oldTreeData[key];
	            var lazyNodeChildren = normalizedLazyNode[key].children;
	            if (rootLazyRowKeys.indexOf(key) !== -1) {
	              // 懒加载的 root 节点，更新一下原有的数据，原来的 children 一定是空数组
	              if (newTreeData[key].children.length !== 0) {
	                throw new Error('[ElTable]children must be an empty array.');
	              }
	              newTreeData[key].children = lazyNodeChildren;
	            } else {
	              var _ref2 = oldValue || {},
	                  _ref2$loaded = _ref2.loaded,
	                  loaded = _ref2$loaded === undefined ? false : _ref2$loaded,
	                  _ref2$loading = _ref2.loading,
	                  loading = _ref2$loading === undefined ? false : _ref2$loading;
	
	              newTreeData[key] = {
	                lazy: true,
	                loaded: !!loaded,
	                loading: !!loading,
	                expanded: getExpanded(oldValue, key),
	                children: lazyNodeChildren,
	                level: ''
	              };
	            }
	          });
	        }
	      }
	      this.states.treeData = newTreeData;
	      this.updateTableScrollY();
	    },
	    updateTreeExpandKeys: function updateTreeExpandKeys(value) {
	      this.states.expandRowKeys = value;
	      this.updateTreeData();
	    },
	    toggleTreeExpansion: function toggleTreeExpansion(row, expanded) {
	      this.assertRowKey();
	
	      var _states4 = this.states,
	          rowKey = _states4.rowKey,
	          treeData = _states4.treeData;
	
	      var id = getRowIdentity(row, rowKey);
	      var data = id && treeData[id];
	      if (id && data && 'expanded' in data) {
	        var oldExpanded = data.expanded;
	        expanded = typeof expanded === 'undefined' ? !data.expanded : expanded;
	        treeData[id].expanded = expanded;
	        if (oldExpanded !== expanded) {
	          this.table.$emit('expand-change', row, expanded);
	        }
	        this.updateTableScrollY();
	      }
	    },
	    loadOrToggle: function loadOrToggle(row) {
	      this.assertRowKey();
	      var _states5 = this.states,
	          lazy = _states5.lazy,
	          treeData = _states5.treeData,
	          rowKey = _states5.rowKey;
	
	      var id = getRowIdentity(row, rowKey);
	      var data = treeData[id];
	      if (lazy && data && 'loaded' in data && !data.loaded) {
	        this.loadData(row, id, data);
	      } else {
	        this.toggleTreeExpansion(row);
	      }
	    },
	    loadData: function loadData(row, key, treeNode) {
	      var _this = this;
	
	      var load = this.table.load;
	      var _states6 = this.states,
	          lazyTreeNodeMap = _states6.lazyTreeNodeMap,
	          treeData = _states6.treeData;
	
	      if (load && !treeData[key].loaded) {
	        treeData[key].loading = true;
	        load(row, treeNode, function (data) {
	          if (!Array.isArray(data)) {
	            throw new Error('[ElTable] data must be an array');
	          }
	          treeData[key].loading = false;
	          treeData[key].loaded = true;
	          treeData[key].expanded = true;
	          if (data.length) {
	            _this.$set(lazyTreeNodeMap, key, data);
	          }
	          _this.table.$emit('expand-change', row, true);
	        });
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/store/watcher.js
	
	
	
	
	
	
	
	var watcher_sortData = function sortData(data, states) {
	  var sortingColumn = states.sortingColumn;
	  if (!sortingColumn || typeof sortingColumn.sortable === 'string') {
	    return data;
	  }
	  return util_orderBy(data, states.sortProp, states.sortOrder, sortingColumn.sortMethod, sortingColumn.sortBy);
	};
	
	var doFlattenColumns = function doFlattenColumns(columns) {
	  var result = [];
	  columns.forEach(function (column) {
	    if (column.children) {
	      result.push.apply(result, doFlattenColumns(column.children));
	    } else {
	      result.push(column);
	    }
	  });
	  return result;
	};
	
	/* harmony default export */ var watcher = (external_vue_default.a.extend({
	  data: function data() {
	    return {
	      states: {
	        // 3.0 版本后要求必须设置该属性
	        rowKey: null,
	
	        // 渲染的数据来源，是对 table 中的 data 过滤排序后的结果
	        data: [],
	
	        // 是否包含固定列
	        isComplex: false,
	
	        // 列
	        _columns: [], // 不可响应的
	        originColumns: [],
	        columns: [],
	        fixedColumns: [],
	        rightFixedColumns: [],
	        leafColumns: [],
	        fixedLeafColumns: [],
	        rightFixedLeafColumns: [],
	        leafColumnsLength: 0,
	        fixedLeafColumnsLength: 0,
	        rightFixedLeafColumnsLength: 0,
	
	        // 选择
	        isAllSelected: false,
	        selection: [],
	        reserveSelection: false,
	        selectOnIndeterminate: false,
	        selectable: null,
	
	        // 过滤
	        filters: {}, // 不可响应的
	        filteredData: null,
	
	        // 排序
	        sortingColumn: null,
	        sortProp: null,
	        sortOrder: null,
	
	        hoverRow: null
	      }
	    };
	  },
	
	
	  mixins: [expand, current, tree],
	
	  methods: {
	    // 检查 rowKey 是否存在
	    assertRowKey: function assertRowKey() {
	      var rowKey = this.states.rowKey;
	      if (!rowKey) throw new Error('[ElTable] prop row-key is required');
	    },
	
	
	    // 更新列
	    updateColumns: function updateColumns() {
	      var states = this.states;
	      var _columns = states._columns || [];
	      states.fixedColumns = _columns.filter(function (column) {
	        return column.fixed === true || column.fixed === 'left';
	      });
	      states.rightFixedColumns = _columns.filter(function (column) {
	        return column.fixed === 'right';
	      });
	
	      if (states.fixedColumns.length > 0 && _columns[0] && _columns[0].type === 'selection' && !_columns[0].fixed) {
	        _columns[0].fixed = true;
	        states.fixedColumns.unshift(_columns[0]);
	      }
	
	      var notFixedColumns = _columns.filter(function (column) {
	        return !column.fixed;
	      });
	      states.originColumns = [].concat(states.fixedColumns).concat(notFixedColumns).concat(states.rightFixedColumns);
	
	      var leafColumns = doFlattenColumns(notFixedColumns);
	      var fixedLeafColumns = doFlattenColumns(states.fixedColumns);
	      var rightFixedLeafColumns = doFlattenColumns(states.rightFixedColumns);
	
	      states.leafColumnsLength = leafColumns.length;
	      states.fixedLeafColumnsLength = fixedLeafColumns.length;
	      states.rightFixedLeafColumnsLength = rightFixedLeafColumns.length;
	
	      states.columns = [].concat(fixedLeafColumns).concat(leafColumns).concat(rightFixedLeafColumns);
	      states.isComplex = states.fixedColumns.length > 0 || states.rightFixedColumns.length > 0;
	    },
	
	
	    // 更新 DOM
	    scheduleLayout: function scheduleLayout(needUpdateColumns) {
	      if (needUpdateColumns) {
	        this.updateColumns();
	      }
	      this.table.debouncedUpdateLayout();
	    },
	
	
	    // 选择
	    isSelected: function isSelected(row) {
	      var _states$selection = this.states.selection,
	          selection = _states$selection === undefined ? [] : _states$selection;
	
	      return selection.indexOf(row) > -1;
	    },
	    clearSelection: function clearSelection() {
	      var states = this.states;
	      states.isAllSelected = false;
	      var oldSelection = states.selection;
	      if (oldSelection.length) {
	        states.selection = [];
	        this.table.$emit('selection-change', []);
	      }
	    },
	    cleanSelection: function cleanSelection() {
	      var states = this.states;
	      var data = states.data,
	          rowKey = states.rowKey,
	          selection = states.selection;
	
	      var deleted = void 0;
	      if (rowKey) {
	        deleted = [];
	        var selectedMap = getKeysMap(selection, rowKey);
	        var dataMap = getKeysMap(data, rowKey);
	        for (var key in selectedMap) {
	          if (selectedMap.hasOwnProperty(key) && !dataMap[key]) {
	            deleted.push(selectedMap[key].row);
	          }
	        }
	      } else {
	        deleted = selection.filter(function (item) {
	          return data.indexOf(item) === -1;
	        });
	      }
	      if (deleted.length) {
	        var newSelection = selection.filter(function (item) {
	          return deleted.indexOf(item) === -1;
	        });
	        states.selection = newSelection;
	        this.table.$emit('selection-change', newSelection.slice());
	      }
	    },
	    toggleRowSelection: function toggleRowSelection(row, selected) {
	      var emitChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      var changed = toggleRowStatus(this.states.selection, row, selected);
	      if (changed) {
	        var newSelection = (this.states.selection || []).slice();
	        // 调用 API 修改选中值，不触发 select 事件
	        if (emitChange) {
	          this.table.$emit('select', newSelection, row);
	        }
	        this.table.$emit('selection-change', newSelection);
	      }
	    },
	    _toggleAllSelection: function _toggleAllSelection() {
	      var states = this.states;
	      var _states$data = states.data,
	          data = _states$data === undefined ? [] : _states$data,
	          selection = states.selection;
	      // when only some rows are selected (but not all), select or deselect all of them
	      // depending on the value of selectOnIndeterminate
	
	      var value = states.selectOnIndeterminate ? !states.isAllSelected : !(states.isAllSelected || selection.length);
	      states.isAllSelected = value;
	
	      var selectionChanged = false;
	      data.forEach(function (row, index) {
	        if (states.selectable) {
	          if (states.selectable.call(null, row, index) && toggleRowStatus(selection, row, value)) {
	            selectionChanged = true;
	          }
	        } else {
	          if (toggleRowStatus(selection, row, value)) {
	            selectionChanged = true;
	          }
	        }
	      });
	
	      if (selectionChanged) {
	        this.table.$emit('selection-change', selection ? selection.slice() : []);
	      }
	      this.table.$emit('select-all', selection);
	    },
	    updateSelectionByRowKey: function updateSelectionByRowKey() {
	      var states = this.states;
	      var selection = states.selection,
	          rowKey = states.rowKey,
	          data = states.data;
	
	      var selectedMap = getKeysMap(selection, rowKey);
	      data.forEach(function (row) {
	        var rowId = getRowIdentity(row, rowKey);
	        var rowInfo = selectedMap[rowId];
	        if (rowInfo) {
	          selection[rowInfo.index] = row;
	        }
	      });
	    },
	    updateAllSelected: function updateAllSelected() {
	      var states = this.states;
	      var selection = states.selection,
	          rowKey = states.rowKey,
	          selectable = states.selectable;
	      // data 为 null 时，解构时的默认值会被忽略
	
	      var data = states.data || [];
	      if (data.length === 0) {
	        states.isAllSelected = false;
	        return;
	      }
	
	      var selectedMap = void 0;
	      if (rowKey) {
	        selectedMap = getKeysMap(selection, rowKey);
	      }
	      var isSelected = function isSelected(row) {
	        if (selectedMap) {
	          return !!selectedMap[getRowIdentity(row, rowKey)];
	        } else {
	          return selection.indexOf(row) !== -1;
	        }
	      };
	      var isAllSelected = true;
	      var selectedCount = 0;
	      for (var i = 0, j = data.length; i < j; i++) {
	        var item = data[i];
	        var isRowSelectable = selectable && selectable.call(null, item, i);
	        if (!isSelected(item)) {
	          if (!selectable || isRowSelectable) {
	            isAllSelected = false;
	            break;
	          }
	        } else {
	          selectedCount++;
	        }
	      }
	
	      if (selectedCount === 0) isAllSelected = false;
	      states.isAllSelected = isAllSelected;
	    },
	
	
	    // 过滤与排序
	    updateFilters: function updateFilters(columns, values) {
	      if (!Array.isArray(columns)) {
	        columns = [columns];
	      }
	      var states = this.states;
	      var filters = {};
	      columns.forEach(function (col) {
	        states.filters[col.id] = values;
	        filters[col.columnKey || col.id] = values;
	      });
	
	      return filters;
	    },
	    updateSort: function updateSort(column, prop, order) {
	      if (this.states.sortingColumn && this.states.sortingColumn !== column) {
	        this.states.sortingColumn.order = null;
	      }
	      this.states.sortingColumn = column;
	      this.states.sortProp = prop;
	      this.states.sortOrder = order;
	    },
	    execFilter: function execFilter() {
	      var _this = this;
	
	      var states = this.states;
	      var _data = states._data,
	          filters = states.filters;
	
	      var data = _data;
	
	      Object.keys(filters).forEach(function (columnId) {
	        var values = states.filters[columnId];
	        if (!values || values.length === 0) return;
	        var column = getColumnById(_this.states, columnId);
	        if (column && column.filterMethod) {
	          data = data.filter(function (row) {
	            return values.some(function (value) {
	              return column.filterMethod.call(null, value, row, column);
	            });
	          });
	        }
	      });
	
	      states.filteredData = data;
	    },
	    execSort: function execSort() {
	      var states = this.states;
	      states.data = watcher_sortData(states.filteredData, states);
	    },
	
	
	    // 根据 filters 与 sort 去过滤 data
	    execQuery: function execQuery(ignore) {
	      if (!(ignore && ignore.filter)) {
	        this.execFilter();
	      }
	      this.execSort();
	    },
	    clearFilter: function clearFilter(columnKeys) {
	      var states = this.states;
	      var _table$$refs = this.table.$refs,
	          tableHeader = _table$$refs.tableHeader,
	          fixedTableHeader = _table$$refs.fixedTableHeader,
	          rightFixedTableHeader = _table$$refs.rightFixedTableHeader;
	
	
	      var panels = {};
	      if (tableHeader) panels = merge_default()(panels, tableHeader.filterPanels);
	      if (fixedTableHeader) panels = merge_default()(panels, fixedTableHeader.filterPanels);
	      if (rightFixedTableHeader) panels = merge_default()(panels, rightFixedTableHeader.filterPanels);
	
	      var keys = Object.keys(panels);
	      if (!keys.length) return;
	
	      if (typeof columnKeys === 'string') {
	        columnKeys = [columnKeys];
	      }
	
	      if (Array.isArray(columnKeys)) {
	        var columns = columnKeys.map(function (key) {
	          return getColumnByKey(states, key);
	        });
	        keys.forEach(function (key) {
	          var column = columns.find(function (col) {
	            return col.id === key;
	          });
	          if (column) {
	            // TODO: 优化这里的代码
	            panels[key].filteredValue = [];
	          }
	        });
	        this.commit('filterChange', {
	          column: columns,
	          values: [],
	          silent: true,
	          multi: true
	        });
	      } else {
	        keys.forEach(function (key) {
	          // TODO: 优化这里的代码
	          panels[key].filteredValue = [];
	        });
	
	        states.filters = {};
	        this.commit('filterChange', {
	          column: {},
	          values: [],
	          silent: true
	        });
	      }
	    },
	    clearSort: function clearSort() {
	      var states = this.states;
	      if (!states.sortingColumn) return;
	
	      this.updateSort(null, null, null);
	      this.commit('changeSortCondition', {
	        silent: true
	      });
	    },
	
	
	    // 适配层，expand-row-keys 在 Expand 与 TreeTable 中都有使用
	    setExpandRowKeysAdapter: function setExpandRowKeysAdapter(val) {
	      // 这里会触发额外的计算，但为了兼容性，暂时这么做
	      this.setExpandRowKeys(val);
	      this.updateTreeExpandKeys(val);
	    },
	
	
	    // 展开行与 TreeTable 都要使用
	    toggleRowExpansionAdapter: function toggleRowExpansionAdapter(row, expanded) {
	      var hasExpandColumn = this.states.columns.some(function (_ref) {
	        var type = _ref.type;
	        return type === 'expand';
	      });
	      if (hasExpandColumn) {
	        this.toggleRowExpansion(row, expanded);
	      } else {
	        this.toggleTreeExpansion(row, expanded);
	      }
	    }
	  }
	}));
	// CONCATENATED MODULE: ./packages/table/src/store/index.js
	
	
	
	
	watcher.prototype.mutations = {
	  setData: function setData(states, data) {
	    var dataInstanceChanged = states._data !== data;
	    states._data = data;
	
	    this.execQuery();
	    // 数据变化，更新部分数据。
	    // 没有使用 computed，而是手动更新部分数据 https://github.com/vuejs/vue/issues/6660#issuecomment-331417140
	    this.updateCurrentRowData();
	    this.updateExpandRows();
	    if (states.reserveSelection) {
	      this.assertRowKey();
	      this.updateSelectionByRowKey();
	    } else {
	      if (dataInstanceChanged) {
	        this.clearSelection();
	      } else {
	        this.cleanSelection();
	      }
	    }
	    this.updateAllSelected();
	
	    this.updateTableScrollY();
	  },
	  insertColumn: function insertColumn(states, column, index, parent) {
	    var array = states._columns;
	    if (parent) {
	      array = parent.children;
	      if (!array) array = parent.children = [];
	    }
	
	    if (typeof index !== 'undefined') {
	      array.splice(index, 0, column);
	    } else {
	      array.push(column);
	    }
	
	    if (column.type === 'selection') {
	      states.selectable = column.selectable;
	      states.reserveSelection = column.reserveSelection;
	    }
	
	    if (this.table.$ready) {
	      this.updateColumns(); // hack for dynamics insert column
	      this.scheduleLayout();
	    }
	  },
	  removeColumn: function removeColumn(states, column, parent) {
	    var array = states._columns;
	    if (parent) {
	      array = parent.children;
	      if (!array) array = parent.children = [];
	    }
	    if (array) {
	      array.splice(array.indexOf(column), 1);
	    }
	
	    if (this.table.$ready) {
	      this.updateColumns(); // hack for dynamics remove column
	      this.scheduleLayout();
	    }
	  },
	  sort: function sort(states, options) {
	    var prop = options.prop,
	        order = options.order,
	        init = options.init;
	
	    if (prop) {
	      var column = Object(util_["arrayFind"])(states.columns, function (column) {
	        return column.property === prop;
	      });
	      if (column) {
	        column.order = order;
	        this.updateSort(column, prop, order);
	        this.commit('changeSortCondition', { init: init });
	      }
	    }
	  },
	  changeSortCondition: function changeSortCondition(states, options) {
	    // 修复 pr https://github.com/ElemeFE/element/pull/15012 导致的 bug
	    var column = states.sortingColumn,
	        prop = states.sortProp,
	        order = states.sortOrder;
	
	    if (order === null) {
	      states.sortingColumn = null;
	      states.sortProp = null;
	    }
	    var ingore = { filter: true };
	    this.execQuery(ingore);
	
	    if (!options || !(options.silent || options.init)) {
	      this.table.$emit('sort-change', {
	        column: column,
	        prop: prop,
	        order: order
	      });
	    }
	
	    this.updateTableScrollY();
	  },
	  filterChange: function filterChange(states, options) {
	    var column = options.column,
	        values = options.values,
	        silent = options.silent;
	
	    var newFilters = this.updateFilters(column, values);
	
	    this.execQuery();
	
	    if (!silent) {
	      this.table.$emit('filter-change', newFilters);
	    }
	
	    this.updateTableScrollY();
	  },
	  toggleAllSelection: function toggleAllSelection() {
	    this.toggleAllSelection();
	  },
	  rowSelectedChanged: function rowSelectedChanged(states, row) {
	    this.toggleRowSelection(row);
	    this.updateAllSelected();
	  },
	  setHoverRow: function setHoverRow(states, row) {
	    states.hoverRow = row;
	  },
	  setCurrentRow: function setCurrentRow(states, row) {
	    this.updateCurrentRow(row);
	  }
	};
	
	watcher.prototype.commit = function (name) {
	  var mutations = this.mutations;
	  if (mutations[name]) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    mutations[name].apply(this, [this.states].concat(args));
	  } else {
	    throw new Error('Action not found: ' + name);
	  }
	};
	
	watcher.prototype.updateTableScrollY = function () {
	  external_vue_default.a.nextTick(this.table.updateScrollY);
	};
	
	/* harmony default export */ var src_store = (watcher);
	// CONCATENATED MODULE: ./packages/table/src/store/helper.js
	
	
	
	function createStore(table) {
	  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (!table) {
	    throw new Error('Table is required.');
	  }
	
	  var store = new src_store();
	  store.table = table;
	  // fix https://github.com/ElemeFE/element/issues/14075
	  // related pr https://github.com/ElemeFE/element/pull/14146
	  store.toggleAllSelection = debounce_default()(10, store._toggleAllSelection);
	  Object.keys(initialState).forEach(function (key) {
	    store.states[key] = initialState[key];
	  });
	  return store;
	}
	
	function mapStates(mapper) {
	  var res = {};
	  Object.keys(mapper).forEach(function (key) {
	    var value = mapper[key];
	    var fn = void 0;
	    if (typeof value === 'string') {
	      fn = function fn() {
	        return this.store.states[value];
	      };
	    } else if (typeof value === 'function') {
	      fn = function fn() {
	        return value.call(this, this.store.states);
	      };
	    } else {
	      console.error('invalid value type');
	    }
	    if (fn) {
	      res[key] = fn;
	    }
	  });
	  return res;
	};
	// EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
	var scrollbar_width_ = __webpack_require__(30);
	var scrollbar_width_default = /*#__PURE__*/__webpack_require__.n(scrollbar_width_);
	
	// CONCATENATED MODULE: ./packages/table/src/table-layout.js
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	
	var table_layout_TableLayout = function () {
	  function TableLayout(options) {
	    _classCallCheck(this, TableLayout);
	
	    this.observers = [];
	    this.table = null;
	    this.store = null;
	    this.columns = null;
	    this.fit = true;
	    this.showHeader = true;
	
	    this.height = null;
	    this.scrollX = false;
	    this.scrollY = false;
	    this.bodyWidth = null;
	    this.fixedWidth = null;
	    this.rightFixedWidth = null;
	    this.tableHeight = null;
	    this.headerHeight = 44; // Table Header Height
	    this.appendHeight = 0; // Append Slot Height
	    this.footerHeight = 44; // Table Footer Height
	    this.viewportHeight = null; // Table Height - Scroll Bar Height
	    this.bodyHeight = null; // Table Height - Table Header Height
	    this.fixedBodyHeight = null; // Table Height - Table Header Height - Scroll Bar Height
	    this.gutterWidth = scrollbar_width_default()();
	
	    for (var name in options) {
	      if (options.hasOwnProperty(name)) {
	        this[name] = options[name];
	      }
	    }
	
	    if (!this.table) {
	      throw new Error('table is required for Table Layout');
	    }
	    if (!this.store) {
	      throw new Error('store is required for Table Layout');
	    }
	  }
	
	  TableLayout.prototype.updateScrollY = function updateScrollY() {
	    var height = this.height;
	    if (height === null) return false;
	    var bodyWrapper = this.table.bodyWrapper;
	    if (this.table.$el && bodyWrapper) {
	      var body = bodyWrapper.querySelector('.el-table__body');
	      var prevScrollY = this.scrollY;
	      var scrollY = body.offsetHeight > this.bodyHeight;
	      this.scrollY = scrollY;
	      return prevScrollY !== scrollY;
	    }
	    return false;
	  };
	
	  TableLayout.prototype.setHeight = function setHeight(value) {
	    var _this = this;
	
	    var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'height';
	
	    if (external_vue_default.a.prototype.$isServer) return;
	    var el = this.table.$el;
	    value = parseHeight(value);
	    this.height = value;
	
	    if (!el && (value || value === 0)) return external_vue_default.a.nextTick(function () {
	      return _this.setHeight(value, prop);
	    });
	
	    if (typeof value === 'number') {
	      el.style[prop] = value + 'px';
	      this.updateElsHeight();
	    } else if (typeof value === 'string') {
	      el.style[prop] = value;
	      this.updateElsHeight();
	    }
	  };
	
	  TableLayout.prototype.setMaxHeight = function setMaxHeight(value) {
	    this.setHeight(value, 'max-height');
	  };
	
	  TableLayout.prototype.getFlattenColumns = function getFlattenColumns() {
	    var flattenColumns = [];
	    var columns = this.table.columns;
	    columns.forEach(function (column) {
	      if (column.isColumnGroup) {
	        flattenColumns.push.apply(flattenColumns, column.columns);
	      } else {
	        flattenColumns.push(column);
	      }
	    });
	
	    return flattenColumns;
	  };
	
	  TableLayout.prototype.updateElsHeight = function updateElsHeight() {
	    var _this2 = this;
	
	    if (!this.table.$ready) return external_vue_default.a.nextTick(function () {
	      return _this2.updateElsHeight();
	    });
	    var _table$$refs = this.table.$refs,
	        headerWrapper = _table$$refs.headerWrapper,
	        appendWrapper = _table$$refs.appendWrapper,
	        footerWrapper = _table$$refs.footerWrapper;
	
	    this.appendHeight = appendWrapper ? appendWrapper.offsetHeight : 0;
	
	    if (this.showHeader && !headerWrapper) return;
	
	    // fix issue (https://github.com/ElemeFE/element/pull/16956)
	    var headerTrElm = headerWrapper ? headerWrapper.querySelector('.el-table__header tr') : null;
	    var noneHeader = this.headerDisplayNone(headerTrElm);
	
	    var headerHeight = this.headerHeight = !this.showHeader ? 0 : headerWrapper.offsetHeight;
	    if (this.showHeader && !noneHeader && headerWrapper.offsetWidth > 0 && (this.table.columns || []).length > 0 && headerHeight < 2) {
	      return external_vue_default.a.nextTick(function () {
	        return _this2.updateElsHeight();
	      });
	    }
	    var tableHeight = this.tableHeight = this.table.$el.clientHeight;
	    var footerHeight = this.footerHeight = footerWrapper ? footerWrapper.offsetHeight : 0;
	    if (this.height !== null) {
	      this.bodyHeight = tableHeight - headerHeight - footerHeight + (footerWrapper ? 1 : 0);
	    }
	    this.fixedBodyHeight = this.scrollX ? this.bodyHeight - this.gutterWidth : this.bodyHeight;
	
	    var noData = !(this.store.states.data && this.store.states.data.length);
	    this.viewportHeight = this.scrollX ? tableHeight - (noData ? 0 : this.gutterWidth) : tableHeight;
	
	    this.updateScrollY();
	    this.notifyObservers('scrollable');
	  };
	
	  TableLayout.prototype.headerDisplayNone = function headerDisplayNone(elm) {
	    if (!elm) return true;
	    var headerChild = elm;
	    while (headerChild.tagName !== 'DIV') {
	      if (getComputedStyle(headerChild).display === 'none') {
	        return true;
	      }
	      headerChild = headerChild.parentElement;
	    }
	    return false;
	  };
	
	  TableLayout.prototype.updateColumnsWidth = function updateColumnsWidth() {
	    if (external_vue_default.a.prototype.$isServer) return;
	    var fit = this.fit;
	    var bodyWidth = this.table.$el.clientWidth;
	    var bodyMinWidth = 0;
	
	    var flattenColumns = this.getFlattenColumns();
	    var flexColumns = flattenColumns.filter(function (column) {
	      return typeof column.width !== 'number';
	    });
	
	    flattenColumns.forEach(function (column) {
	      // Clean those columns whose width changed from flex to unflex
	      if (typeof column.width === 'number' && column.realWidth) column.realWidth = null;
	    });
	
	    if (flexColumns.length > 0 && fit) {
	      flattenColumns.forEach(function (column) {
	        bodyMinWidth += column.width || column.minWidth || 80;
	      });
	
	      var scrollYWidth = this.scrollY ? this.gutterWidth : 0;
	
	      if (bodyMinWidth <= bodyWidth - scrollYWidth) {
	        // DON'T HAVE SCROLL BAR
	        this.scrollX = false;
	
	        var totalFlexWidth = bodyWidth - scrollYWidth - bodyMinWidth;
	
	        if (flexColumns.length === 1) {
	          flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth;
	        } else {
	          var allColumnsWidth = flexColumns.reduce(function (prev, column) {
	            return prev + (column.minWidth || 80);
	          }, 0);
	          var flexWidthPerPixel = totalFlexWidth / allColumnsWidth;
	          var noneFirstWidth = 0;
	
	          flexColumns.forEach(function (column, index) {
	            if (index === 0) return;
	            var flexWidth = Math.floor((column.minWidth || 80) * flexWidthPerPixel);
	            noneFirstWidth += flexWidth;
	            column.realWidth = (column.minWidth || 80) + flexWidth;
	          });
	
	          flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth - noneFirstWidth;
	        }
	      } else {
	        // HAVE HORIZONTAL SCROLL BAR
	        this.scrollX = true;
	        flexColumns.forEach(function (column) {
	          column.realWidth = column.minWidth;
	        });
	      }
	
	      this.bodyWidth = Math.max(bodyMinWidth, bodyWidth);
	      this.table.resizeState.width = this.bodyWidth;
	    } else {
	      flattenColumns.forEach(function (column) {
	        if (!column.width && !column.minWidth) {
	          column.realWidth = 80;
	        } else {
	          column.realWidth = column.width || column.minWidth;
	        }
	
	        bodyMinWidth += column.realWidth;
	      });
	      this.scrollX = bodyMinWidth > bodyWidth;
	
	      this.bodyWidth = bodyMinWidth;
	    }
	
	    var fixedColumns = this.store.states.fixedColumns;
	
	    if (fixedColumns.length > 0) {
	      var fixedWidth = 0;
	      fixedColumns.forEach(function (column) {
	        fixedWidth += column.realWidth || column.width;
	      });
	
	      this.fixedWidth = fixedWidth;
	    }
	
	    var rightFixedColumns = this.store.states.rightFixedColumns;
	    if (rightFixedColumns.length > 0) {
	      var rightFixedWidth = 0;
	      rightFixedColumns.forEach(function (column) {
	        rightFixedWidth += column.realWidth || column.width;
	      });
	
	      this.rightFixedWidth = rightFixedWidth;
	    }
	
	    this.notifyObservers('columns');
	  };
	
	  TableLayout.prototype.addObserver = function addObserver(observer) {
	    this.observers.push(observer);
	  };
	
	  TableLayout.prototype.removeObserver = function removeObserver(observer) {
	    var index = this.observers.indexOf(observer);
	    if (index !== -1) {
	      this.observers.splice(index, 1);
	    }
	  };
	
	  TableLayout.prototype.notifyObservers = function notifyObservers(event) {
	    var _this3 = this;
	
	    var observers = this.observers;
	    observers.forEach(function (observer) {
	      switch (event) {
	        case 'columns':
	          observer.onColumnsChange(_this3);
	          break;
	        case 'scrollable':
	          observer.onScrollableChange(_this3);
	          break;
	        default:
	          throw new Error('Table Layout don\'t have event ' + event + '.');
	      }
	    });
	  };
	
	  return TableLayout;
	}();
	
	/* harmony default export */ var table_layout = (table_layout_TableLayout);
	// CONCATENATED MODULE: ./packages/table/src/layout-observer.js
	/* harmony default export */ var layout_observer = ({
	  created: function created() {
	    this.tableLayout.addObserver(this);
	  },
	  destroyed: function destroyed() {
	    this.tableLayout.removeObserver(this);
	  },
	
	
	  computed: {
	    tableLayout: function tableLayout() {
	      var layout = this.layout;
	      if (!layout && this.table) {
	        layout = this.table.layout;
	      }
	      if (!layout) {
	        throw new Error('Can not find table layout.');
	      }
	      return layout;
	    }
	  },
	
	  mounted: function mounted() {
	    this.onColumnsChange(this.tableLayout);
	    this.onScrollableChange(this.tableLayout);
	  },
	  updated: function updated() {
	    if (this.__updated__) return;
	    this.onColumnsChange(this.tableLayout);
	    this.onScrollableChange(this.tableLayout);
	    this.__updated__ = true;
	  },
	
	
	  methods: {
	    onColumnsChange: function onColumnsChange(layout) {
	      var cols = this.$el.querySelectorAll('colgroup > col');
	      if (!cols.length) return;
	      var flattenColumns = layout.getFlattenColumns();
	      var columnsMap = {};
	      flattenColumns.forEach(function (column) {
	        columnsMap[column.id] = column;
	      });
	      for (var i = 0, j = cols.length; i < j; i++) {
	        var col = cols[i];
	        var name = col.getAttribute('name');
	        var column = columnsMap[name];
	        if (column) {
	          col.setAttribute('width', column.realWidth || column.width);
	        }
	      }
	    },
	    onScrollableChange: function onScrollableChange(layout) {
	      var cols = this.$el.querySelectorAll('colgroup > col[name=gutter]');
	      for (var i = 0, j = cols.length; i < j; i++) {
	        var col = cols[i];
	        col.setAttribute('width', layout.scrollY ? layout.gutterWidth : '0');
	      }
	      var ths = this.$el.querySelectorAll('th.gutter');
	      for (var _i = 0, _j = ths.length; _i < _j; _i++) {
	        var th = ths[_i];
	        th.style.width = layout.scrollY ? layout.gutterWidth + 'px' : '0';
	        th.style.display = layout.scrollY ? '' : 'none';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/table-body.js
	var table_body_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var table_body_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var table_body = ({
	  name: 'ElTableBody',
	
	  mixins: [layout_observer],
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElTooltip: tooltip_default.a
	  },
	
	  props: {
	    store: {
	      required: true
	    },
	    stripe: Boolean,
	    context: {},
	    rowClassName: [String, Function],
	    rowStyle: [Object, Function],
	    fixed: String,
	    highlight: Boolean
	  },
	
	  render: function render(h) {
	    var _this = this;
	
	    var data = this.data || [];
	    return h(
	      'table',
	      {
	        'class': 'el-table__body',
	        attrs: { cellspacing: '0',
	          cellpadding: '0',
	          border: '0' }
	      },
	      [h('colgroup', [this.columns.map(function (column) {
	        return h('col', {
	          attrs: { name: column.id },
	          key: column.id });
	      })]), h('tbody', [data.reduce(function (acc, row) {
	        return acc.concat(_this.wrappedRowRender(row, acc.length));
	      }, []), h('el-tooltip', {
	        attrs: { effect: this.table.tooltipEffect, placement: 'top', content: this.tooltipContent },
	        ref: 'tooltip' })])]
	    );
	  },
	
	
	  computed: table_body_extends({
	    table: function table() {
	      return this.$parent;
	    }
	  }, mapStates({
	    data: 'data',
	    columns: 'columns',
	    treeIndent: 'indent',
	    leftFixedLeafCount: 'fixedLeafColumnsLength',
	    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
	    columnsCount: function columnsCount(states) {
	      return states.columns.length;
	    },
	    leftFixedCount: function leftFixedCount(states) {
	      return states.fixedColumns.length;
	    },
	    rightFixedCount: function rightFixedCount(states) {
	      return states.rightFixedColumns.length;
	    },
	    hasExpandColumn: function hasExpandColumn(states) {
	      return states.columns.some(function (_ref) {
	        var type = _ref.type;
	        return type === 'expand';
	      });
	    }
	  }), {
	    firstDefaultColumnIndex: function firstDefaultColumnIndex() {
	      return Object(util_["arrayFindIndex"])(this.columns, function (_ref2) {
	        var type = _ref2.type;
	        return type === 'default';
	      });
	    }
	  }),
	
	  watch: {
	    // don't trigger getter of currentRow in getCellClass. see https://jsfiddle.net/oe2b4hqt/
	    // update DOM manually. see https://github.com/ElemeFE/element/pull/13954/files#diff-9b450c00d0a9dec0ffad5a3176972e40
	    'store.states.hoverRow': function storeStatesHoverRow(newVal, oldVal) {
	      var _this2 = this;
	
	      if (!this.store.states.isComplex || this.$isServer) return;
	      var raf = window.requestAnimationFrame;
	      if (!raf) {
	        raf = function raf(fn) {
	          return setTimeout(fn, 16);
	        };
	      }
	      raf(function () {
	        var rows = _this2.$el.querySelectorAll('.el-table__row');
	        var oldRow = rows[oldVal];
	        var newRow = rows[newVal];
	        if (oldRow) {
	          Object(dom_["removeClass"])(oldRow, 'hover-row');
	        }
	        if (newRow) {
	          Object(dom_["addClass"])(newRow, 'hover-row');
	        }
	      });
	    }
	  },
	
	  data: function data() {
	    return {
	      tooltipContent: ''
	    };
	  },
	  created: function created() {
	    this.activateTooltip = debounce_default()(50, function (tooltip) {
	      return tooltip.handleShowPopper();
	    });
	  },
	
	
	  methods: {
	    getKeyOfRow: function getKeyOfRow(row, index) {
	      var rowKey = this.table.rowKey;
	      if (rowKey) {
	        return getRowIdentity(row, rowKey);
	      }
	      return index;
	    },
	    isColumnHidden: function isColumnHidden(index) {
	      if (this.fixed === true || this.fixed === 'left') {
	        return index >= this.leftFixedLeafCount;
	      } else if (this.fixed === 'right') {
	        return index < this.columnsCount - this.rightFixedLeafCount;
	      } else {
	        return index < this.leftFixedLeafCount || index >= this.columnsCount - this.rightFixedLeafCount;
	      }
	    },
	    getSpan: function getSpan(row, column, rowIndex, columnIndex) {
	      var rowspan = 1;
	      var colspan = 1;
	      var fn = this.table.spanMethod;
	      if (typeof fn === 'function') {
	        var result = fn({
	          row: row,
	          column: column,
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	        if (Array.isArray(result)) {
	          rowspan = result[0];
	          colspan = result[1];
	        } else if ((typeof result === 'undefined' ? 'undefined' : table_body_typeof(result)) === 'object') {
	          rowspan = result.rowspan;
	          colspan = result.colspan;
	        }
	      }
	      return { rowspan: rowspan, colspan: colspan };
	    },
	    getRowStyle: function getRowStyle(row, rowIndex) {
	      var rowStyle = this.table.rowStyle;
	      if (typeof rowStyle === 'function') {
	        return rowStyle.call(null, {
	          row: row,
	          rowIndex: rowIndex
	        });
	      }
	      return rowStyle || null;
	    },
	    getRowClass: function getRowClass(row, rowIndex) {
	      var classes = ['el-table__row'];
	      if (this.table.highlightCurrentRow && row === this.store.states.currentRow) {
	        classes.push('current-row');
	      }
	
	      if (this.stripe && rowIndex % 2 === 1) {
	        classes.push('el-table__row--striped');
	      }
	      var rowClassName = this.table.rowClassName;
	      if (typeof rowClassName === 'string') {
	        classes.push(rowClassName);
	      } else if (typeof rowClassName === 'function') {
	        classes.push(rowClassName.call(null, {
	          row: row,
	          rowIndex: rowIndex
	        }));
	      }
	
	      if (this.store.states.expandRows.indexOf(row) > -1) {
	        classes.push('expanded');
	      }
	
	      return classes;
	    },
	    getCellStyle: function getCellStyle(rowIndex, columnIndex, row, column) {
	      var cellStyle = this.table.cellStyle;
	      if (typeof cellStyle === 'function') {
	        return cellStyle.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        });
	      }
	      return cellStyle;
	    },
	    getCellClass: function getCellClass(rowIndex, columnIndex, row, column) {
	      var classes = [column.id, column.align, column.className];
	
	      if (this.isColumnHidden(columnIndex)) {
	        classes.push('is-hidden');
	      }
	
	      var cellClassName = this.table.cellClassName;
	      if (typeof cellClassName === 'string') {
	        classes.push(cellClassName);
	      } else if (typeof cellClassName === 'function') {
	        classes.push(cellClassName.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        }));
	      }
	
	      return classes.join(' ');
	    },
	    getColspanRealWidth: function getColspanRealWidth(columns, colspan, index) {
	      if (colspan < 1) {
	        return columns[index].realWidth;
	      }
	      var widthArr = columns.map(function (_ref3) {
	        var realWidth = _ref3.realWidth;
	        return realWidth;
	      }).slice(index, index + colspan);
	      return widthArr.reduce(function (acc, width) {
	        return acc + width;
	      }, -1);
	    },
	    handleCellMouseEnter: function handleCellMouseEnter(event, row) {
	      var table = this.table;
	      var cell = getCell(event);
	
	      if (cell) {
	        var column = getColumnByCell(table, cell);
	        var hoverState = table.hoverState = { cell: cell, column: column, row: row };
	        table.$emit('cell-mouse-enter', hoverState.row, hoverState.column, hoverState.cell, event);
	      }
	
	      // 判断是否text-overflow, 如果是就显示tooltip
	      var cellChild = event.target.querySelector('.cell');
	      if (!(Object(dom_["hasClass"])(cellChild, 'el-tooltip') && cellChild.childNodes.length)) {
	        return;
	      }
	      // use range width instead of scrollWidth to determine whether the text is overflowing
	      // to address a potential FireFox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1074543#c3
	      var range = document.createRange();
	      range.setStart(cellChild, 0);
	      range.setEnd(cellChild, cellChild.childNodes.length);
	      var rangeWidth = range.getBoundingClientRect().width;
	      var padding = (parseInt(Object(dom_["getStyle"])(cellChild, 'paddingLeft'), 10) || 0) + (parseInt(Object(dom_["getStyle"])(cellChild, 'paddingRight'), 10) || 0);
	      if ((rangeWidth + padding > cellChild.offsetWidth || cellChild.scrollWidth > cellChild.offsetWidth) && this.$refs.tooltip) {
	        var tooltip = this.$refs.tooltip;
	        // TODO 会引起整个 Table 的重新渲染，需要优化
	        this.tooltipContent = cell.innerText || cell.textContent;
	        tooltip.referenceElm = cell;
	        tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
	        tooltip.doDestroy();
	        tooltip.setExpectedState(true);
	        this.activateTooltip(tooltip);
	      }
	    },
	    handleCellMouseLeave: function handleCellMouseLeave(event) {
	      var tooltip = this.$refs.tooltip;
	      if (tooltip) {
	        tooltip.setExpectedState(false);
	        tooltip.handleClosePopper();
	      }
	      var cell = getCell(event);
	      if (!cell) return;
	
	      var oldHoverState = this.table.hoverState || {};
	      this.table.$emit('cell-mouse-leave', oldHoverState.row, oldHoverState.column, oldHoverState.cell, event);
	    },
	
	
	    handleMouseEnter: debounce_default()(30, function (index) {
	      this.store.commit('setHoverRow', index);
	    }),
	
	    handleMouseLeave: debounce_default()(30, function () {
	      this.store.commit('setHoverRow', null);
	    }),
	
	    handleContextMenu: function handleContextMenu(event, row) {
	      this.handleEvent(event, row, 'contextmenu');
	    },
	    handleDoubleClick: function handleDoubleClick(event, row) {
	      this.handleEvent(event, row, 'dblclick');
	    },
	    handleClick: function handleClick(event, row) {
	      this.store.commit('setCurrentRow', row);
	      this.handleEvent(event, row, 'click');
	    },
	    handleEvent: function handleEvent(event, row, name) {
	      var table = this.table;
	      var cell = getCell(event);
	      var column = void 0;
	      if (cell) {
	        column = getColumnByCell(table, cell);
	        if (column) {
	          table.$emit('cell-' + name, row, column, cell, event);
	        }
	      }
	      table.$emit('row-' + name, row, column, event);
	    },
	    rowRender: function rowRender(row, $index, treeRowData) {
	      var _this3 = this;
	
	      var h = this.$createElement;
	      var treeIndent = this.treeIndent,
	          columns = this.columns,
	          firstDefaultColumnIndex = this.firstDefaultColumnIndex;
	
	      var columnsHidden = columns.map(function (column, index) {
	        return _this3.isColumnHidden(index);
	      });
	      var rowClasses = this.getRowClass(row, $index);
	      var display = true;
	      if (treeRowData) {
	        rowClasses.push('el-table__row--level-' + treeRowData.level);
	        display = treeRowData.display;
	      }
	      // 指令 v-show 会覆盖 row-style 中 display
	      // 使用 :style 代替 v-show https://github.com/ElemeFE/element/issues/16995
	      var displayStyle = display ? null : {
	        display: 'none'
	      };
	      return h(
	        'tr',
	        {
	          style: [displayStyle, this.getRowStyle(row, $index)],
	          'class': rowClasses,
	          key: this.getKeyOfRow(row, $index),
	          on: {
	            'dblclick': function dblclick($event) {
	              return _this3.handleDoubleClick($event, row);
	            },
	            'click': function click($event) {
	              return _this3.handleClick($event, row);
	            },
	            'contextmenu': function contextmenu($event) {
	              return _this3.handleContextMenu($event, row);
	            },
	            'mouseenter': function mouseenter(_) {
	              return _this3.handleMouseEnter($index);
	            },
	            'mouseleave': this.handleMouseLeave
	          }
	        },
	        [columns.map(function (column, cellIndex) {
	          var _getSpan = _this3.getSpan(row, column, $index, cellIndex),
	              rowspan = _getSpan.rowspan,
	              colspan = _getSpan.colspan;
	
	          if (!rowspan || !colspan) {
	            return null;
	          }
	          var columnData = table_body_extends({}, column);
	          columnData.realWidth = _this3.getColspanRealWidth(columns, colspan, cellIndex);
	          var data = {
	            store: _this3.store,
	            _self: _this3.context || _this3.table.$vnode.context,
	            column: columnData,
	            row: row,
	            $index: $index
	          };
	          if (cellIndex === firstDefaultColumnIndex && treeRowData) {
	            data.treeNode = {
	              indent: treeRowData.level * treeIndent,
	              level: treeRowData.level
	            };
	            if (typeof treeRowData.expanded === 'boolean') {
	              data.treeNode.expanded = treeRowData.expanded;
	              // 表明是懒加载
	              if ('loading' in treeRowData) {
	                data.treeNode.loading = treeRowData.loading;
	              }
	              if ('noLazyChildren' in treeRowData) {
	                data.treeNode.noLazyChildren = treeRowData.noLazyChildren;
	              }
	            }
	          }
	          return h(
	            'td',
	            {
	              style: _this3.getCellStyle($index, cellIndex, row, column),
	              'class': _this3.getCellClass($index, cellIndex, row, column),
	              attrs: { rowspan: rowspan,
	                colspan: colspan
	              },
	              on: {
	                'mouseenter': function mouseenter($event) {
	                  return _this3.handleCellMouseEnter($event, row);
	                },
	                'mouseleave': _this3.handleCellMouseLeave
	              }
	            },
	            [column.renderCell.call(_this3._renderProxy, _this3.$createElement, data, columnsHidden[cellIndex])]
	          );
	        })]
	      );
	    },
	    wrappedRowRender: function wrappedRowRender(row, $index) {
	      var _this4 = this;
	
	      var h = this.$createElement;
	
	      var store = this.store;
	      var isRowExpanded = store.isRowExpanded,
	          assertRowKey = store.assertRowKey;
	      var _store$states = store.states,
	          treeData = _store$states.treeData,
	          lazyTreeNodeMap = _store$states.lazyTreeNodeMap,
	          childrenColumnName = _store$states.childrenColumnName,
	          rowKey = _store$states.rowKey;
	
	      if (this.hasExpandColumn && isRowExpanded(row)) {
	        var renderExpanded = this.table.renderExpanded;
	        var tr = this.rowRender(row, $index);
	        if (!renderExpanded) {
	          console.error('[Element Error]renderExpanded is required.');
	          return tr;
	        }
	        // 使用二维数组，避免修改 $index
	        return [[tr, h(
	          'tr',
	          { key: 'expanded-row__' + tr.key },
	          [h(
	            'td',
	            {
	              attrs: { colspan: this.columnsCount },
	              'class': 'el-table__expanded-cell' },
	            [renderExpanded(this.$createElement, { row: row, $index: $index, store: this.store })]
	          )]
	        )]];
	      } else if (Object.keys(treeData).length) {
	        assertRowKey();
	        // TreeTable 时，rowKey 必须由用户设定，不使用 getKeyOfRow 计算
	        // 在调用 rowRender 函数时，仍然会计算 rowKey，不太好的操作
	        var key = getRowIdentity(row, rowKey);
	        var cur = treeData[key];
	        var treeRowData = null;
	        if (cur) {
	          treeRowData = {
	            expanded: cur.expanded,
	            level: cur.level,
	            display: true
	          };
	          if (typeof cur.lazy === 'boolean') {
	            if (typeof cur.loaded === 'boolean' && cur.loaded) {
	              treeRowData.noLazyChildren = !(cur.children && cur.children.length);
	            }
	            treeRowData.loading = cur.loading;
	          }
	        }
	        var tmp = [this.rowRender(row, $index, treeRowData)];
	        // 渲染嵌套数据
	        if (cur) {
	          // currentRow 记录的是 index，所以还需主动增加 TreeTable 的 index
	          var i = 0;
	          var traverse = function traverse(children, parent) {
	            if (!(children && children.length && parent)) return;
	            children.forEach(function (node) {
	              // 父节点的 display 状态影响子节点的显示状态
	              var innerTreeRowData = {
	                display: parent.display && parent.expanded,
	                level: parent.level + 1
	              };
	              var childKey = getRowIdentity(node, rowKey);
	              if (childKey === undefined || childKey === null) {
	                throw new Error('for nested data item, row-key is required.');
	              }
	              cur = table_body_extends({}, treeData[childKey]);
	              // 对于当前节点，分成有无子节点两种情况。
	              // 如果包含子节点的，设置 expanded 属性。
	              // 对于它子节点的 display 属性由它本身的 expanded 与 display 共同决定。
	              if (cur) {
	                innerTreeRowData.expanded = cur.expanded;
	                // 懒加载的某些节点，level 未知
	                cur.level = cur.level || innerTreeRowData.level;
	                cur.display = !!(cur.expanded && innerTreeRowData.display);
	                if (typeof cur.lazy === 'boolean') {
	                  if (typeof cur.loaded === 'boolean' && cur.loaded) {
	                    innerTreeRowData.noLazyChildren = !(cur.children && cur.children.length);
	                  }
	                  innerTreeRowData.loading = cur.loading;
	                }
	              }
	              i++;
	              tmp.push(_this4.rowRender(node, $index + i, innerTreeRowData));
	              if (cur) {
	                var _nodes = lazyTreeNodeMap[childKey] || node[childrenColumnName];
	                traverse(_nodes, cur);
	              }
	            });
	          };
	          // 对于 root 节点，display 一定为 true
	          cur.display = true;
	          var nodes = lazyTreeNodeMap[key] || row[childrenColumnName];
	          traverse(nodes, cur);
	        }
	        return tmp;
	      } else {
	        return this.rowRender(row, $index);
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&
	var filter_panelvue_type_template_id_7f2c919f_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
	    _vm.multiple
	      ? _c(
	          "div",
	          {
	            directives: [
	              {
	                name: "clickoutside",
	                rawName: "v-clickoutside",
	                value: _vm.handleOutsideClick,
	                expression: "handleOutsideClick"
	              },
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.showPopper,
	                expression: "showPopper"
	              }
	            ],
	            staticClass: "el-table-filter"
	          },
	          [
	            _c(
	              "div",
	              { staticClass: "el-table-filter__content" },
	              [
	                _c(
	                  "el-scrollbar",
	                  { attrs: { "wrap-class": "el-table-filter__wrap" } },
	                  [
	                    _c(
	                      "el-checkbox-group",
	                      {
	                        staticClass: "el-table-filter__checkbox-group",
	                        model: {
	                          value: _vm.filteredValue,
	                          callback: function($$v) {
	                            _vm.filteredValue = $$v
	                          },
	                          expression: "filteredValue"
	                        }
	                      },
	                      _vm._l(_vm.filters, function(filter) {
	                        return _c(
	                          "el-checkbox",
	                          { key: filter.value, attrs: { label: filter.value } },
	                          [_vm._v(_vm._s(filter.text))]
	                        )
	                      }),
	                      1
	                    )
	                  ],
	                  1
	                )
	              ],
	              1
	            ),
	            _c("div", { staticClass: "el-table-filter__bottom" }, [
	              _c(
	                "button",
	                {
	                  class: { "is-disabled": _vm.filteredValue.length === 0 },
	                  attrs: { disabled: _vm.filteredValue.length === 0 },
	                  on: { click: _vm.handleConfirm }
	                },
	                [_vm._v(_vm._s(_vm.t("el.table.confirmFilter")))]
	              ),
	              _c("button", { on: { click: _vm.handleReset } }, [
	                _vm._v(_vm._s(_vm.t("el.table.resetFilter")))
	              ])
	            ])
	          ]
	        )
	      : _c(
	          "div",
	          {
	            directives: [
	              {
	                name: "clickoutside",
	                rawName: "v-clickoutside",
	                value: _vm.handleOutsideClick,
	                expression: "handleOutsideClick"
	              },
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.showPopper,
	                expression: "showPopper"
	              }
	            ],
	            staticClass: "el-table-filter"
	          },
	          [
	            _c(
	              "ul",
	              { staticClass: "el-table-filter__list" },
	              [
	                _c(
	                  "li",
	                  {
	                    staticClass: "el-table-filter__list-item",
	                    class: {
	                      "is-active":
	                        _vm.filterValue === undefined ||
	                        _vm.filterValue === null
	                    },
	                    on: {
	                      click: function($event) {
	                        _vm.handleSelect(null)
	                      }
	                    }
	                  },
	                  [_vm._v(_vm._s(_vm.t("el.table.clearFilter")))]
	                ),
	                _vm._l(_vm.filters, function(filter) {
	                  return _c(
	                    "li",
	                    {
	                      key: filter.value,
	                      staticClass: "el-table-filter__list-item",
	                      class: { "is-active": _vm.isActive(filter) },
	                      attrs: { label: filter.value },
	                      on: {
	                        click: function($event) {
	                          _vm.handleSelect(filter.value)
	                        }
	                      }
	                    },
	                    [_vm._v(_vm._s(filter.text))]
	                  )
	                })
	              ],
	              2
	            )
	          ]
	        )
	  ])
	}
	var filter_panelvue_type_template_id_7f2c919f_staticRenderFns = []
	filter_panelvue_type_template_id_7f2c919f_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&
	
	// CONCATENATED MODULE: ./packages/table/src/dropdown.js
	
	var dropdowns = [];
	
	!external_vue_default.a.prototype.$isServer && document.addEventListener('click', function (event) {
	  dropdowns.forEach(function (dropdown) {
	    var target = event.target;
	    if (!dropdown || !dropdown.$el) return;
	    if (target === dropdown.$el || dropdown.$el.contains(target)) {
	      return;
	    }
	    dropdown.handleOutsideClick && dropdown.handleOutsideClick(event);
	  });
	});
	
	/* harmony default export */ var src_dropdown = ({
	  open: function open(instance) {
	    if (instance) {
	      dropdowns.push(instance);
	    }
	  },
	  close: function close(instance) {
	    var index = dropdowns.indexOf(instance);
	    if (index !== -1) {
	      dropdowns.splice(instance, 1);
	    }
	  }
	});
	// EXTERNAL MODULE: external "element-ui/lib/checkbox-group"
	var checkbox_group_ = __webpack_require__(31);
	var checkbox_group_default = /*#__PURE__*/__webpack_require__.n(checkbox_group_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var filter_panelvue_type_script_lang_js_ = ({
	  name: 'ElTableFilterPanel',
	
	  mixins: [vue_popper_default.a, locale_default.a],
	
	  directives: {
	    Clickoutside: clickoutside_default.a
	  },
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElCheckboxGroup: checkbox_group_default.a,
	    ElScrollbar: scrollbar_default.a
	  },
	
	  props: {
	    placement: {
	      type: String,
	      default: 'bottom-end'
	    }
	  },
	
	  methods: {
	    isActive: function isActive(filter) {
	      return filter.value === this.filterValue;
	    },
	    handleOutsideClick: function handleOutsideClick() {
	      var _this = this;
	
	      setTimeout(function () {
	        _this.showPopper = false;
	      }, 16);
	    },
	    handleConfirm: function handleConfirm() {
	      this.confirmFilter(this.filteredValue);
	      this.handleOutsideClick();
	    },
	    handleReset: function handleReset() {
	      this.filteredValue = [];
	      this.confirmFilter(this.filteredValue);
	      this.handleOutsideClick();
	    },
	    handleSelect: function handleSelect(filterValue) {
	      this.filterValue = filterValue;
	
	      if (typeof filterValue !== 'undefined' && filterValue !== null) {
	        this.confirmFilter(this.filteredValue);
	      } else {
	        this.confirmFilter([]);
	      }
	
	      this.handleOutsideClick();
	    },
	    confirmFilter: function confirmFilter(filteredValue) {
	      this.table.store.commit('filterChange', {
	        column: this.column,
	        values: filteredValue
	      });
	      this.table.store.updateAllSelected();
	    }
	  },
	
	  data: function data() {
	    return {
	      table: null,
	      cell: null,
	      column: null
	    };
	  },
	
	
	  computed: {
	    filters: function filters() {
	      return this.column && this.column.filters;
	    },
	
	
	    filterValue: {
	      get: function get() {
	        return (this.column.filteredValue || [])[0];
	      },
	      set: function set(value) {
	        if (this.filteredValue) {
	          if (typeof value !== 'undefined' && value !== null) {
	            this.filteredValue.splice(0, 1, value);
	          } else {
	            this.filteredValue.splice(0, 1);
	          }
	        }
	      }
	    },
	
	    filteredValue: {
	      get: function get() {
	        if (this.column) {
	          return this.column.filteredValue || [];
	        }
	        return [];
	      },
	      set: function set(value) {
	        if (this.column) {
	          this.column.filteredValue = value;
	        }
	      }
	    },
	
	    multiple: function multiple() {
	      if (this.column) {
	        return this.column.filterMultiple;
	      }
	      return true;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.popperElm = this.$el;
	    this.referenceElm = this.cell;
	    this.table.bodyWrapper.addEventListener('scroll', function () {
	      _this2.updatePopper();
	    });
	
	    this.$watch('showPopper', function (value) {
	      if (_this2.column) _this2.column.filterOpened = value;
	      if (value) {
	        src_dropdown.open(_this2);
	      } else {
	        src_dropdown.close(_this2);
	      }
	    });
	  },
	
	  watch: {
	    showPopper: function showPopper(val) {
	      if (val === true && parseInt(this.popperJS._popper.style.zIndex, 10) < popup_["PopupManager"].zIndex) {
	        this.popperJS._popper.style.zIndex = popup_["PopupManager"].nextZIndex();
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_filter_panelvue_type_script_lang_js_ = (filter_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var filter_panel_component = normalizeComponent(
	  src_filter_panelvue_type_script_lang_js_,
	  filter_panelvue_type_template_id_7f2c919f_render,
	  filter_panelvue_type_template_id_7f2c919f_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var filter_panel_api; }
	filter_panel_component.options.__file = "packages/table/src/filter-panel.vue"
	/* harmony default export */ var filter_panel = (filter_panel_component.exports);
	// CONCATENATED MODULE: ./packages/table/src/table-header.js
	var table_header_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	
	
	
	
	var getAllColumns = function getAllColumns(columns) {
	  var result = [];
	  columns.forEach(function (column) {
	    if (column.children) {
	      result.push(column);
	      result.push.apply(result, getAllColumns(column.children));
	    } else {
	      result.push(column);
	    }
	  });
	  return result;
	};
	
	var convertToRows = function convertToRows(originColumns) {
	  var maxLevel = 1;
	  var traverse = function traverse(column, parent) {
	    if (parent) {
	      column.level = parent.level + 1;
	      if (maxLevel < column.level) {
	        maxLevel = column.level;
	      }
	    }
	    if (column.children) {
	      var colSpan = 0;
	      column.children.forEach(function (subColumn) {
	        traverse(subColumn, column);
	        colSpan += subColumn.colSpan;
	      });
	      column.colSpan = colSpan;
	    } else {
	      column.colSpan = 1;
	    }
	  };
	
	  originColumns.forEach(function (column) {
	    column.level = 1;
	    traverse(column);
	  });
	
	  var rows = [];
	  for (var i = 0; i < maxLevel; i++) {
	    rows.push([]);
	  }
	
	  var allColumns = getAllColumns(originColumns);
	
	  allColumns.forEach(function (column) {
	    if (!column.children) {
	      column.rowSpan = maxLevel - column.level + 1;
	    } else {
	      column.rowSpan = 1;
	    }
	    rows[column.level - 1].push(column);
	  });
	
	  return rows;
	};
	
	/* harmony default export */ var table_header = ({
	  name: 'ElTableHeader',
	
	  mixins: [layout_observer],
	
	  render: function render(h) {
	    var _this = this;
	
	    var originColumns = this.store.states.originColumns;
	    var columnRows = convertToRows(originColumns, this.columns);
	    // 是否拥有多级表头
	    var isGroup = columnRows.length > 1;
	    if (isGroup) this.$parent.isGroup = true;
	    return h(
	      'table',
	      {
	        'class': 'el-table__header',
	        attrs: { cellspacing: '0',
	          cellpadding: '0',
	          border: '0' }
	      },
	      [h('colgroup', [this.columns.map(function (column) {
	        return h('col', {
	          attrs: { name: column.id },
	          key: column.id });
	      }), this.hasGutter ? h('col', {
	        attrs: { name: 'gutter' }
	      }) : '']), h(
	        'thead',
	        { 'class': [{ 'is-group': isGroup, 'has-gutter': this.hasGutter }] },
	        [this._l(columnRows, function (columns, rowIndex) {
	          return h(
	            'tr',
	            {
	              style: _this.getHeaderRowStyle(rowIndex),
	              'class': _this.getHeaderRowClass(rowIndex)
	            },
	            [columns.map(function (column, cellIndex) {
	              return h(
	                'th',
	                {
	                  attrs: {
	                    colspan: column.colSpan,
	                    rowspan: column.rowSpan
	                  },
	                  on: {
	                    'mousemove': function mousemove($event) {
	                      return _this.handleMouseMove($event, column);
	                    },
	                    'mouseout': _this.handleMouseOut,
	                    'mousedown': function mousedown($event) {
	                      return _this.handleMouseDown($event, column);
	                    },
	                    'click': function click($event) {
	                      return _this.handleHeaderClick($event, column);
	                    },
	                    'contextmenu': function contextmenu($event) {
	                      return _this.handleHeaderContextMenu($event, column);
	                    }
	                  },
	
	                  style: _this.getHeaderCellStyle(rowIndex, cellIndex, columns, column),
	                  'class': _this.getHeaderCellClass(rowIndex, cellIndex, columns, column),
	                  key: column.id },
	                [h(
	                  'div',
	                  { 'class': ['cell', column.filteredValue && column.filteredValue.length > 0 ? 'highlight' : '', column.labelClassName] },
	                  [column.renderHeader ? column.renderHeader.call(_this._renderProxy, h, { column: column, $index: cellIndex, store: _this.store, _self: _this.$parent.$vnode.context }) : column.label, column.sortable ? h(
	                    'span',
	                    {
	                      'class': 'caret-wrapper',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleSortClick($event, column);
	                        }
	                      }
	                    },
	                    [h('i', { 'class': 'sort-caret ascending',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleSortClick($event, column, 'ascending');
	                        }
	                      }
	                    }), h('i', { 'class': 'sort-caret descending',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleSortClick($event, column, 'descending');
	                        }
	                      }
	                    })]
	                  ) : '', column.filterable ? h(
	                    'span',
	                    {
	                      'class': 'el-table__column-filter-trigger',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleFilterClick($event, column);
	                        }
	                      }
	                    },
	                    [h('i', { 'class': ['el-icon-arrow-down', column.filterOpened ? 'el-icon-arrow-up' : ''] })]
	                  ) : '']
	                )]
	              );
	            }), _this.hasGutter ? h('th', { 'class': 'gutter' }) : '']
	          );
	        })]
	      )]
	    );
	  },
	
	
	  props: {
	    fixed: String,
	    store: {
	      required: true
	    },
	    border: Boolean,
	    defaultSort: {
	      type: Object,
	      default: function _default() {
	        return {
	          prop: '',
	          order: ''
	        };
	      }
	    }
	  },
	
	  components: {
	    ElCheckbox: checkbox_default.a
	  },
	
	  computed: table_header_extends({
	    table: function table() {
	      return this.$parent;
	    },
	    hasGutter: function hasGutter() {
	      return !this.fixed && this.tableLayout.gutterWidth;
	    }
	  }, mapStates({
	    columns: 'columns',
	    isAllSelected: 'isAllSelected',
	    leftFixedLeafCount: 'fixedLeafColumnsLength',
	    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
	    columnsCount: function columnsCount(states) {
	      return states.columns.length;
	    },
	    leftFixedCount: function leftFixedCount(states) {
	      return states.fixedColumns.length;
	    },
	    rightFixedCount: function rightFixedCount(states) {
	      return states.rightFixedColumns.length;
	    }
	  })),
	
	  created: function created() {
	    this.filterPanels = {};
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    // nextTick 是有必要的 https://github.com/ElemeFE/element/pull/11311
	    this.$nextTick(function () {
	      var _defaultSort = _this2.defaultSort,
	          prop = _defaultSort.prop,
	          order = _defaultSort.order;
	
	      var init = true;
	      _this2.store.commit('sort', { prop: prop, order: order, init: init });
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var panels = this.filterPanels;
	    for (var prop in panels) {
	      if (panels.hasOwnProperty(prop) && panels[prop]) {
	        panels[prop].$destroy(true);
	      }
	    }
	  },
	
	
	  methods: {
	    isCellHidden: function isCellHidden(index, columns) {
	      var start = 0;
	      for (var i = 0; i < index; i++) {
	        start += columns[i].colSpan;
	      }
	      var after = start + columns[index].colSpan - 1;
	      if (this.fixed === true || this.fixed === 'left') {
	        return after >= this.leftFixedLeafCount;
	      } else if (this.fixed === 'right') {
	        return start < this.columnsCount - this.rightFixedLeafCount;
	      } else {
	        return after < this.leftFixedLeafCount || start >= this.columnsCount - this.rightFixedLeafCount;
	      }
	    },
	    getHeaderRowStyle: function getHeaderRowStyle(rowIndex) {
	      var headerRowStyle = this.table.headerRowStyle;
	      if (typeof headerRowStyle === 'function') {
	        return headerRowStyle.call(null, { rowIndex: rowIndex });
	      }
	      return headerRowStyle;
	    },
	    getHeaderRowClass: function getHeaderRowClass(rowIndex) {
	      var classes = [];
	
	      var headerRowClassName = this.table.headerRowClassName;
	      if (typeof headerRowClassName === 'string') {
	        classes.push(headerRowClassName);
	      } else if (typeof headerRowClassName === 'function') {
	        classes.push(headerRowClassName.call(null, { rowIndex: rowIndex }));
	      }
	
	      return classes.join(' ');
	    },
	    getHeaderCellStyle: function getHeaderCellStyle(rowIndex, columnIndex, row, column) {
	      var headerCellStyle = this.table.headerCellStyle;
	      if (typeof headerCellStyle === 'function') {
	        return headerCellStyle.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        });
	      }
	      return headerCellStyle;
	    },
	    getHeaderCellClass: function getHeaderCellClass(rowIndex, columnIndex, row, column) {
	      var classes = [column.id, column.order, column.headerAlign, column.className, column.labelClassName];
	
	      if (rowIndex === 0 && this.isCellHidden(columnIndex, row)) {
	        classes.push('is-hidden');
	      }
	
	      if (!column.children) {
	        classes.push('is-leaf');
	      }
	
	      if (column.sortable) {
	        classes.push('is-sortable');
	      }
	
	      var headerCellClassName = this.table.headerCellClassName;
	      if (typeof headerCellClassName === 'string') {
	        classes.push(headerCellClassName);
	      } else if (typeof headerCellClassName === 'function') {
	        classes.push(headerCellClassName.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        }));
	      }
	
	      return classes.join(' ');
	    },
	    toggleAllSelection: function toggleAllSelection(event) {
	      event.stopPropagation();
	      this.store.commit('toggleAllSelection');
	    },
	    handleFilterClick: function handleFilterClick(event, column) {
	      event.stopPropagation();
	      var target = event.target;
	      var cell = target.tagName === 'TH' ? target : target.parentNode;
	      if (Object(dom_["hasClass"])(cell, 'noclick')) return;
	      cell = cell.querySelector('.el-table__column-filter-trigger') || cell;
	      var table = this.$parent;
	
	      var filterPanel = this.filterPanels[column.id];
	
	      if (filterPanel && column.filterOpened) {
	        filterPanel.showPopper = false;
	        return;
	      }
	
	      if (!filterPanel) {
	        filterPanel = new external_vue_default.a(filter_panel);
	        this.filterPanels[column.id] = filterPanel;
	        if (column.filterPlacement) {
	          filterPanel.placement = column.filterPlacement;
	        }
	        filterPanel.table = table;
	        filterPanel.cell = cell;
	        filterPanel.column = column;
	        !this.$isServer && filterPanel.$mount(document.createElement('div'));
	      }
	
	      setTimeout(function () {
	        filterPanel.showPopper = true;
	      }, 16);
	    },
	    handleHeaderClick: function handleHeaderClick(event, column) {
	      if (!column.filters && column.sortable) {
	        this.handleSortClick(event, column);
	      } else if (column.filterable && !column.sortable) {
	        this.handleFilterClick(event, column);
	      }
	
	      this.$parent.$emit('header-click', column, event);
	    },
	    handleHeaderContextMenu: function handleHeaderContextMenu(event, column) {
	      this.$parent.$emit('header-contextmenu', column, event);
	    },
	    handleMouseDown: function handleMouseDown(event, column) {
	      var _this3 = this;
	
	      if (this.$isServer) return;
	      if (column.children && column.children.length > 0) return;
	      /* istanbul ignore if */
	      if (this.draggingColumn && this.border) {
	        this.dragging = true;
	
	        this.$parent.resizeProxyVisible = true;
	
	        var table = this.$parent;
	        var tableEl = table.$el;
	        var tableLeft = tableEl.getBoundingClientRect().left;
	        var columnEl = this.$el.querySelector('th.' + column.id);
	        var columnRect = columnEl.getBoundingClientRect();
	        var minLeft = columnRect.left - tableLeft + 30;
	
	        Object(dom_["addClass"])(columnEl, 'noclick');
	
	        this.dragState = {
	          startMouseLeft: event.clientX,
	          startLeft: columnRect.right - tableLeft,
	          startColumnLeft: columnRect.left - tableLeft,
	          tableLeft: tableLeft
	        };
	
	        var resizeProxy = table.$refs.resizeProxy;
	        resizeProxy.style.left = this.dragState.startLeft + 'px';
	
	        document.onselectstart = function () {
	          return false;
	        };
	        document.ondragstart = function () {
	          return false;
	        };
	
	        var handleMouseMove = function handleMouseMove(event) {
	          var deltaLeft = event.clientX - _this3.dragState.startMouseLeft;
	          var proxyLeft = _this3.dragState.startLeft + deltaLeft;
	
	          resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px';
	        };
	
	        var handleMouseUp = function handleMouseUp() {
	          if (_this3.dragging) {
	            var _dragState = _this3.dragState,
	                startColumnLeft = _dragState.startColumnLeft,
	                startLeft = _dragState.startLeft;
	
	            var finalLeft = parseInt(resizeProxy.style.left, 10);
	            var columnWidth = finalLeft - startColumnLeft;
	            column.width = column.realWidth = columnWidth;
	            table.$emit('header-dragend', column.width, startLeft - startColumnLeft, column, event);
	
	            _this3.store.scheduleLayout();
	
	            document.body.style.cursor = '';
	            _this3.dragging = false;
	            _this3.draggingColumn = null;
	            _this3.dragState = {};
	
	            table.resizeProxyVisible = false;
	          }
	
	          document.removeEventListener('mousemove', handleMouseMove);
	          document.removeEventListener('mouseup', handleMouseUp);
	          document.onselectstart = null;
	          document.ondragstart = null;
	
	          setTimeout(function () {
	            Object(dom_["removeClass"])(columnEl, 'noclick');
	          }, 0);
	        };
	
	        document.addEventListener('mousemove', handleMouseMove);
	        document.addEventListener('mouseup', handleMouseUp);
	      }
	    },
	    handleMouseMove: function handleMouseMove(event, column) {
	      if (column.children && column.children.length > 0) return;
	      var target = event.target;
	      while (target && target.tagName !== 'TH') {
	        target = target.parentNode;
	      }
	
	      if (!column || !column.resizable) return;
	
	      if (!this.dragging && this.border) {
	        var rect = target.getBoundingClientRect();
	
	        var bodyStyle = document.body.style;
	        if (rect.width > 12 && rect.right - event.pageX < 8) {
	          bodyStyle.cursor = 'col-resize';
	          if (Object(dom_["hasClass"])(target, 'is-sortable')) {
	            target.style.cursor = 'col-resize';
	          }
	          this.draggingColumn = column;
	        } else if (!this.dragging) {
	          bodyStyle.cursor = '';
	          if (Object(dom_["hasClass"])(target, 'is-sortable')) {
	            target.style.cursor = 'pointer';
	          }
	          this.draggingColumn = null;
	        }
	      }
	    },
	    handleMouseOut: function handleMouseOut() {
	      if (this.$isServer) return;
	      document.body.style.cursor = '';
	    },
	    toggleOrder: function toggleOrder(_ref) {
	      var order = _ref.order,
	          sortOrders = _ref.sortOrders;
	
	      if (order === '') return sortOrders[0];
	      var index = sortOrders.indexOf(order || null);
	      return sortOrders[index > sortOrders.length - 2 ? 0 : index + 1];
	    },
	    handleSortClick: function handleSortClick(event, column, givenOrder) {
	      event.stopPropagation();
	      var order = column.order === givenOrder ? null : givenOrder || this.toggleOrder(column);
	
	      var target = event.target;
	      while (target && target.tagName !== 'TH') {
	        target = target.parentNode;
	      }
	
	      if (target && target.tagName === 'TH') {
	        if (Object(dom_["hasClass"])(target, 'noclick')) {
	          Object(dom_["removeClass"])(target, 'noclick');
	          return;
	        }
	      }
	
	      if (!column.sortable) return;
	
	      var states = this.store.states;
	      var sortProp = states.sortProp;
	      var sortOrder = void 0;
	      var sortingColumn = states.sortingColumn;
	
	      if (sortingColumn !== column || sortingColumn === column && sortingColumn.order === null) {
	        if (sortingColumn) {
	          sortingColumn.order = null;
	        }
	        states.sortingColumn = column;
	        sortProp = column.property;
	      }
	
	      if (!order) {
	        sortOrder = column.order = null;
	      } else {
	        sortOrder = column.order = order;
	      }
	
	      states.sortProp = sortProp;
	      states.sortOrder = sortOrder;
	
	      this.store.commit('changeSortCondition');
	    }
	  },
	
	  data: function data() {
	    return {
	      draggingColumn: null,
	      dragging: false,
	      dragState: {}
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/table-footer.js
	var table_footer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	/* harmony default export */ var table_footer = ({
	  name: 'ElTableFooter',
	
	  mixins: [layout_observer],
	
	  render: function render(h) {
	    var _this = this;
	
	    var sums = [];
	    if (this.summaryMethod) {
	      sums = this.summaryMethod({ columns: this.columns, data: this.store.states.data });
	    } else {
	      this.columns.forEach(function (column, index) {
	        if (index === 0) {
	          sums[index] = _this.sumText;
	          return;
	        }
	        var values = _this.store.states.data.map(function (item) {
	          return Number(item[column.property]);
	        });
	        var precisions = [];
	        var notNumber = true;
	        values.forEach(function (value) {
	          if (!isNaN(value)) {
	            notNumber = false;
	            var decimal = ('' + value).split('.')[1];
	            precisions.push(decimal ? decimal.length : 0);
	          }
	        });
	        var precision = Math.max.apply(null, precisions);
	        if (!notNumber) {
	          sums[index] = values.reduce(function (prev, curr) {
	            var value = Number(curr);
	            if (!isNaN(value)) {
	              return parseFloat((prev + curr).toFixed(Math.min(precision, 20)));
	            } else {
	              return prev;
	            }
	          }, 0);
	        } else {
	          sums[index] = '';
	        }
	      });
	    }
	
	    return h(
	      'table',
	      {
	        'class': 'el-table__footer',
	        attrs: { cellspacing: '0',
	          cellpadding: '0',
	          border: '0' }
	      },
	      [h('colgroup', [this.columns.map(function (column) {
	        return h('col', {
	          attrs: { name: column.id },
	          key: column.id });
	      }), this.hasGutter ? h('col', {
	        attrs: { name: 'gutter' }
	      }) : '']), h(
	        'tbody',
	        { 'class': [{ 'has-gutter': this.hasGutter }] },
	        [h('tr', [this.columns.map(function (column, cellIndex) {
	          return h(
	            'td',
	            {
	              key: cellIndex,
	              attrs: { colspan: column.colSpan,
	                rowspan: column.rowSpan
	              },
	              'class': _this.getRowClasses(column, cellIndex) },
	            [h(
	              'div',
	              { 'class': ['cell', column.labelClassName] },
	              [sums[cellIndex]]
	            )]
	          );
	        }), this.hasGutter ? h('th', { 'class': 'gutter' }) : ''])]
	      )]
	    );
	  },
	
	
	  props: {
	    fixed: String,
	    store: {
	      required: true
	    },
	    summaryMethod: Function,
	    sumText: String,
	    border: Boolean,
	    defaultSort: {
	      type: Object,
	      default: function _default() {
	        return {
	          prop: '',
	          order: ''
	        };
	      }
	    }
	  },
	
	  computed: table_footer_extends({
	    table: function table() {
	      return this.$parent;
	    },
	    hasGutter: function hasGutter() {
	      return !this.fixed && this.tableLayout.gutterWidth;
	    }
	  }, mapStates({
	    columns: 'columns',
	    isAllSelected: 'isAllSelected',
	    leftFixedLeafCount: 'fixedLeafColumnsLength',
	    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
	    columnsCount: function columnsCount(states) {
	      return states.columns.length;
	    },
	    leftFixedCount: function leftFixedCount(states) {
	      return states.fixedColumns.length;
	    },
	    rightFixedCount: function rightFixedCount(states) {
	      return states.rightFixedColumns.length;
	    }
	  })),
	
	  methods: {
	    isCellHidden: function isCellHidden(index, columns, column) {
	      if (this.fixed === true || this.fixed === 'left') {
	        return index >= this.leftFixedLeafCount;
	      } else if (this.fixed === 'right') {
	        var before = 0;
	        for (var i = 0; i < index; i++) {
	          before += columns[i].colSpan;
	        }
	        return before < this.columnsCount - this.rightFixedLeafCount;
	      } else if (!this.fixed && column.fixed) {
	        // hide cell when footer instance is not fixed and column is fixed
	        return true;
	      } else {
	        return index < this.leftFixedCount || index >= this.columnsCount - this.rightFixedCount;
	      }
	    },
	    getRowClasses: function getRowClasses(column, cellIndex) {
	      var classes = [column.id, column.align, column.labelClassName];
	      if (column.className) {
	        classes.push(column.className);
	      }
	      if (this.isCellHidden(cellIndex, this.columns, column)) {
	        classes.push('is-hidden');
	      }
	      if (!column.children) {
	        classes.push('is-leaf');
	      }
	      return classes;
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=script&lang=js&
	var tablevue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var tableIdSeed = 1;
	
	/* harmony default export */ var tablevue_type_script_lang_js_ = ({
	  name: 'ElTable',
	
	  mixins: [locale_default.a, migrating_default.a],
	
	  directives: {
	    Mousewheel: directives_mousewheel
	  },
	
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    size: String,
	
	    width: [String, Number],
	
	    height: [String, Number],
	
	    maxHeight: [String, Number],
	
	    fit: {
	      type: Boolean,
	      default: true
	    },
	
	    stripe: Boolean,
	
	    border: Boolean,
	
	    rowKey: [String, Function],
	
	    context: {},
	
	    showHeader: {
	      type: Boolean,
	      default: true
	    },
	
	    showSummary: Boolean,
	
	    sumText: String,
	
	    summaryMethod: Function,
	
	    rowClassName: [String, Function],
	
	    rowStyle: [Object, Function],
	
	    cellClassName: [String, Function],
	
	    cellStyle: [Object, Function],
	
	    headerRowClassName: [String, Function],
	
	    headerRowStyle: [Object, Function],
	
	    headerCellClassName: [String, Function],
	
	    headerCellStyle: [Object, Function],
	
	    highlightCurrentRow: Boolean,
	
	    currentRowKey: [String, Number],
	
	    emptyText: String,
	
	    expandRowKeys: Array,
	
	    defaultExpandAll: Boolean,
	
	    defaultSort: Object,
	
	    tooltipEffect: String,
	
	    spanMethod: Function,
	
	    selectOnIndeterminate: {
	      type: Boolean,
	      default: true
	    },
	
	    indent: {
	      type: Number,
	      default: 16
	    },
	
	    treeProps: {
	      type: Object,
	      default: function _default() {
	        return {
	          hasChildren: 'hasChildren',
	          children: 'children'
	        };
	      }
	    },
	
	    lazy: Boolean,
	
	    load: Function
	  },
	
	  components: {
	    TableHeader: table_header,
	    TableFooter: table_footer,
	    TableBody: table_body,
	    ElCheckbox: checkbox_default.a
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        events: {
	          expand: 'expand is renamed to expand-change'
	        }
	      };
	    },
	    setCurrentRow: function setCurrentRow(row) {
	      this.store.commit('setCurrentRow', row);
	    },
	    toggleRowSelection: function toggleRowSelection(row, selected) {
	      this.store.toggleRowSelection(row, selected, false);
	      this.store.updateAllSelected();
	    },
	    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
	      this.store.toggleRowExpansionAdapter(row, expanded);
	    },
	    clearSelection: function clearSelection() {
	      this.store.clearSelection();
	    },
	    clearFilter: function clearFilter(columnKeys) {
	      this.store.clearFilter(columnKeys);
	    },
	    clearSort: function clearSort() {
	      this.store.clearSort();
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      this.store.commit('setHoverRow', null);
	      if (this.hoverState) this.hoverState = null;
	    },
	    updateScrollY: function updateScrollY() {
	      var changed = this.layout.updateScrollY();
	      if (changed) {
	        this.layout.notifyObservers('scrollable');
	        this.layout.updateColumnsWidth();
	      }
	    },
	    handleFixedMousewheel: function handleFixedMousewheel(event, data) {
	      var bodyWrapper = this.bodyWrapper;
	      if (Math.abs(data.spinY) > 0) {
	        var currentScrollTop = bodyWrapper.scrollTop;
	        if (data.pixelY < 0 && currentScrollTop !== 0) {
	          event.preventDefault();
	        }
	        if (data.pixelY > 0 && bodyWrapper.scrollHeight - bodyWrapper.clientHeight > currentScrollTop) {
	          event.preventDefault();
	        }
	        bodyWrapper.scrollTop += Math.ceil(data.pixelY / 5);
	      } else {
	        bodyWrapper.scrollLeft += Math.ceil(data.pixelX / 5);
	      }
	    },
	    handleHeaderFooterMousewheel: function handleHeaderFooterMousewheel(event, data) {
	      var pixelX = data.pixelX,
	          pixelY = data.pixelY;
	
	      if (Math.abs(pixelX) >= Math.abs(pixelY)) {
	        this.bodyWrapper.scrollLeft += data.pixelX / 5;
	      }
	    },
	
	
	    // TODO 使用 CSS transform
	    syncPostion: Object(external_throttle_debounce_["throttle"])(20, function () {
	      var _bodyWrapper = this.bodyWrapper,
	          scrollLeft = _bodyWrapper.scrollLeft,
	          scrollTop = _bodyWrapper.scrollTop,
	          offsetWidth = _bodyWrapper.offsetWidth,
	          scrollWidth = _bodyWrapper.scrollWidth;
	      var _$refs = this.$refs,
	          headerWrapper = _$refs.headerWrapper,
	          footerWrapper = _$refs.footerWrapper,
	          fixedBodyWrapper = _$refs.fixedBodyWrapper,
	          rightFixedBodyWrapper = _$refs.rightFixedBodyWrapper;
	
	      if (headerWrapper) headerWrapper.scrollLeft = scrollLeft;
	      if (footerWrapper) footerWrapper.scrollLeft = scrollLeft;
	      if (fixedBodyWrapper) fixedBodyWrapper.scrollTop = scrollTop;
	      if (rightFixedBodyWrapper) rightFixedBodyWrapper.scrollTop = scrollTop;
	      var maxScrollLeftPosition = scrollWidth - offsetWidth - 1;
	      if (scrollLeft >= maxScrollLeftPosition) {
	        this.scrollPosition = 'right';
	      } else if (scrollLeft === 0) {
	        this.scrollPosition = 'left';
	      } else {
	        this.scrollPosition = 'middle';
	      }
	    }),
	
	    bindEvents: function bindEvents() {
	      this.bodyWrapper.addEventListener('scroll', this.syncPostion, { passive: true });
	      if (this.fit) {
	        Object(resize_event_["addResizeListener"])(this.$el, this.resizeListener);
	      }
	    },
	    unbindEvents: function unbindEvents() {
	      this.bodyWrapper.removeEventListener('scroll', this.syncPostion, { passive: true });
	      if (this.fit) {
	        Object(resize_event_["removeResizeListener"])(this.$el, this.resizeListener);
	      }
	    },
	    resizeListener: function resizeListener() {
	      if (!this.$ready) return;
	      var shouldUpdateLayout = false;
	      var el = this.$el;
	      var _resizeState = this.resizeState,
	          oldWidth = _resizeState.width,
	          oldHeight = _resizeState.height;
	
	
	      var width = el.offsetWidth;
	      if (oldWidth !== width) {
	        shouldUpdateLayout = true;
	      }
	
	      var height = el.offsetHeight;
	      if ((this.height || this.shouldUpdateHeight) && oldHeight !== height) {
	        shouldUpdateLayout = true;
	      }
	
	      if (shouldUpdateLayout) {
	        this.resizeState.width = width;
	        this.resizeState.height = height;
	        this.doLayout();
	      }
	    },
	    doLayout: function doLayout() {
	      if (this.shouldUpdateHeight) {
	        this.layout.updateElsHeight();
	      }
	      this.layout.updateColumnsWidth();
	    },
	    sort: function sort(prop, order) {
	      this.store.commit('sort', { prop: prop, order: order });
	    },
	    toggleAllSelection: function toggleAllSelection() {
	      this.store.commit('toggleAllSelection');
	    }
	  },
	
	  computed: tablevue_type_script_lang_js_extends({
	    tableSize: function tableSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    },
	    bodyWrapper: function bodyWrapper() {
	      return this.$refs.bodyWrapper;
	    },
	    shouldUpdateHeight: function shouldUpdateHeight() {
	      return this.height || this.maxHeight || this.fixedColumns.length > 0 || this.rightFixedColumns.length > 0;
	    },
	    bodyWidth: function bodyWidth() {
	      var _layout = this.layout,
	          bodyWidth = _layout.bodyWidth,
	          scrollY = _layout.scrollY,
	          gutterWidth = _layout.gutterWidth;
	
	      return bodyWidth ? bodyWidth - (scrollY ? gutterWidth : 0) + 'px' : '';
	    },
	    bodyHeight: function bodyHeight() {
	      var _layout2 = this.layout,
	          _layout2$headerHeight = _layout2.headerHeight,
	          headerHeight = _layout2$headerHeight === undefined ? 0 : _layout2$headerHeight,
	          bodyHeight = _layout2.bodyHeight,
	          _layout2$footerHeight = _layout2.footerHeight,
	          footerHeight = _layout2$footerHeight === undefined ? 0 : _layout2$footerHeight;
	
	      if (this.height) {
	        return {
	          height: bodyHeight ? bodyHeight + 'px' : ''
	        };
	      } else if (this.maxHeight) {
	        var maxHeight = parseHeight(this.maxHeight);
	        if (typeof maxHeight === 'number') {
	          return {
	            'max-height': maxHeight - footerHeight - (this.showHeader ? headerHeight : 0) + 'px'
	          };
	        }
	      }
	      return {};
	    },
	    fixedBodyHeight: function fixedBodyHeight() {
	      if (this.height) {
	        return {
	          height: this.layout.fixedBodyHeight ? this.layout.fixedBodyHeight + 'px' : ''
	        };
	      } else if (this.maxHeight) {
	        var maxHeight = parseHeight(this.maxHeight);
	        if (typeof maxHeight === 'number') {
	          maxHeight = this.layout.scrollX ? maxHeight - this.layout.gutterWidth : maxHeight;
	          if (this.showHeader) {
	            maxHeight -= this.layout.headerHeight;
	          }
	          maxHeight -= this.layout.footerHeight;
	          return {
	            'max-height': maxHeight + 'px'
	          };
	        }
	      }
	      return {};
	    },
	    fixedHeight: function fixedHeight() {
	      if (this.maxHeight) {
	        if (this.showSummary) {
	          return {
	            bottom: 0
	          };
	        }
	        return {
	          bottom: this.layout.scrollX && this.data.length ? this.layout.gutterWidth + 'px' : ''
	        };
	      } else {
	        if (this.showSummary) {
	          return {
	            height: this.layout.tableHeight ? this.layout.tableHeight + 'px' : ''
	          };
	        }
	        return {
	          height: this.layout.viewportHeight ? this.layout.viewportHeight + 'px' : ''
	        };
	      }
	    },
	    emptyBlockStyle: function emptyBlockStyle() {
	      if (this.data && this.data.length) return null;
	      var height = '100%';
	      if (this.layout.appendHeight) {
	        height = 'calc(100% - ' + this.layout.appendHeight + 'px)';
	      }
	      return {
	        width: this.bodyWidth,
	        height: height
	      };
	    }
	  }, mapStates({
	    selection: 'selection',
	    columns: 'columns',
	    tableData: 'data',
	    fixedColumns: 'fixedColumns',
	    rightFixedColumns: 'rightFixedColumns'
	  })),
	
	  watch: {
	    height: {
	      immediate: true,
	      handler: function handler(value) {
	        this.layout.setHeight(value);
	      }
	    },
	
	    maxHeight: {
	      immediate: true,
	      handler: function handler(value) {
	        this.layout.setMaxHeight(value);
	      }
	    },
	
	    currentRowKey: {
	      immediate: true,
	      handler: function handler(value) {
	        if (!this.rowKey) return;
	        this.store.setCurrentRowKey(value);
	      }
	    },
	
	    data: {
	      immediate: true,
	      handler: function handler(value) {
	        this.store.commit('setData', value);
	      }
	    },
	
	    expandRowKeys: {
	      immediate: true,
	      handler: function handler(newVal) {
	        if (newVal) {
	          this.store.setExpandRowKeysAdapter(newVal);
	        }
	      }
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.tableId = 'el-table_' + tableIdSeed++;
	    this.debouncedUpdateLayout = Object(external_throttle_debounce_["debounce"])(50, function () {
	      return _this.doLayout();
	    });
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.bindEvents();
	    this.store.updateColumns();
	    this.doLayout();
	
	    this.resizeState = {
	      width: this.$el.offsetWidth,
	      height: this.$el.offsetHeight
	    };
	
	    // init filters
	    this.store.states.columns.forEach(function (column) {
	      if (column.filteredValue && column.filteredValue.length) {
	        _this2.store.commit('filterChange', {
	          column: column,
	          values: column.filteredValue,
	          silent: true
	        });
	      }
	    });
	
	    this.$ready = true;
	  },
	  destroyed: function destroyed() {
	    this.unbindEvents();
	  },
	  data: function data() {
	    var _treeProps = this.treeProps,
	        _treeProps$hasChildre = _treeProps.hasChildren,
	        hasChildren = _treeProps$hasChildre === undefined ? 'hasChildren' : _treeProps$hasChildre,
	        _treeProps$children = _treeProps.children,
	        children = _treeProps$children === undefined ? 'children' : _treeProps$children;
	
	    this.store = createStore(this, {
	      rowKey: this.rowKey,
	      defaultExpandAll: this.defaultExpandAll,
	      selectOnIndeterminate: this.selectOnIndeterminate,
	      // TreeTable 的相关配置
	      indent: this.indent,
	      lazy: this.lazy,
	      lazyColumnIdentifier: hasChildren,
	      childrenColumnName: children
	    });
	    var layout = new table_layout({
	      store: this.store,
	      table: this,
	      fit: this.fit,
	      showHeader: this.showHeader
	    });
	    return {
	      layout: layout,
	      isHidden: false,
	      renderExpanded: null,
	      resizeProxyVisible: false,
	      resizeState: {
	        width: null,
	        height: null
	      },
	      // 是否拥有多级表头
	      isGroup: false,
	      scrollPosition: 'left'
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tablevue_type_script_lang_js_ = (tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/table/src/table.vue
	
	
	
	
	
	/* normalize component */
	
	var table_component = normalizeComponent(
	  src_tablevue_type_script_lang_js_,
	  tablevue_type_template_id_493fe34e_render,
	  tablevue_type_template_id_493fe34e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var table_api; }
	table_component.options.__file = "packages/table/src/table.vue"
	/* harmony default export */ var src_table = (table_component.exports);
	// CONCATENATED MODULE: ./packages/table/index.js
	
	
	/* istanbul ignore next */
	src_table.install = function (Vue) {
	  Vue.component(src_table.name, src_table);
	};
	
	/* harmony default export */ var packages_table = (src_table);
	// CONCATENATED MODULE: ./packages/table/src/config.js
	
	
	var cellStarts = {
	  default: {
	    order: ''
	  },
	  selection: {
	    width: 48,
	    minWidth: 48,
	    realWidth: 48,
	    order: '',
	    className: 'el-table-column--selection'
	  },
	  expand: {
	    width: 48,
	    minWidth: 48,
	    realWidth: 48,
	    order: ''
	  },
	  index: {
	    width: 48,
	    minWidth: 48,
	    realWidth: 48,
	    order: ''
	  }
	};
	
	// 这些选项不应该被覆盖
	var cellForced = {
	  selection: {
	    renderHeader: function renderHeader(h, _ref) {
	      var store = _ref.store;
	
	      return h('el-checkbox', {
	        attrs: {
	          disabled: store.states.data && store.states.data.length === 0,
	          indeterminate: store.states.selection.length > 0 && !this.isAllSelected,
	
	          value: this.isAllSelected },
	        nativeOn: {
	          'click': this.toggleAllSelection
	        }
	      });
	    },
	    renderCell: function renderCell(h, _ref2) {
	      var row = _ref2.row,
	          column = _ref2.column,
	          store = _ref2.store,
	          $index = _ref2.$index;
	
	      return h('el-checkbox', {
	        nativeOn: {
	          'click': function click(event) {
	            return event.stopPropagation();
	          }
	        },
	        attrs: {
	          value: store.isSelected(row),
	          disabled: column.selectable ? !column.selectable.call(null, row, $index) : false
	        },
	        on: {
	          'input': function input() {
	            store.commit('rowSelectedChanged', row);
	          }
	        }
	      });
	    },
	    sortable: false,
	    resizable: false
	  },
	  index: {
	    renderHeader: function renderHeader(h, _ref3) {
	      var column = _ref3.column;
	
	      return column.label || '#';
	    },
	    renderCell: function renderCell(h, _ref4) {
	      var $index = _ref4.$index,
	          column = _ref4.column;
	
	      var i = $index + 1;
	      var index = column.index;
	
	      if (typeof index === 'number') {
	        i = $index + index;
	      } else if (typeof index === 'function') {
	        i = index($index);
	      }
	
	      return h('div', [i]);
	    },
	    sortable: false
	  },
	  expand: {
	    renderHeader: function renderHeader(h, _ref5) {
	      var column = _ref5.column;
	
	      return column.label || '';
	    },
	    renderCell: function renderCell(h, _ref6) {
	      var row = _ref6.row,
	          store = _ref6.store;
	
	      var classes = ['el-table__expand-icon'];
	      if (store.states.expandRows.indexOf(row) > -1) {
	        classes.push('el-table__expand-icon--expanded');
	      }
	      var callback = function callback(e) {
	        e.stopPropagation();
	        store.toggleRowExpansion(row);
	      };
	      return h(
	        'div',
	        { 'class': classes,
	          on: {
	            'click': callback
	          }
	        },
	        [h('i', { 'class': 'el-icon el-icon-arrow-right' })]
	      );
	    },
	    sortable: false,
	    resizable: false,
	    className: 'el-table__expand-column'
	  }
	};
	
	function defaultRenderCell(h, _ref7) {
	  var row = _ref7.row,
	      column = _ref7.column,
	      $index = _ref7.$index;
	
	  var property = column.property;
	  var value = property && Object(util_["getPropByPath"])(row, property).v;
	  if (column && column.formatter) {
	    return column.formatter(row, column, value, $index);
	  }
	  return value;
	}
	
	function treeCellPrefix(h, _ref8) {
	  var row = _ref8.row,
	      treeNode = _ref8.treeNode,
	      store = _ref8.store;
	
	  if (!treeNode) return null;
	  var ele = [];
	  var callback = function callback(e) {
	    e.stopPropagation();
	    store.loadOrToggle(row);
	  };
	  if (treeNode.indent) {
	    ele.push(h('span', { 'class': 'el-table__indent', style: { 'padding-left': treeNode.indent + 'px' } }));
	  }
	  if (typeof treeNode.expanded === 'boolean' && !treeNode.noLazyChildren) {
	    var expandClasses = ['el-table__expand-icon', treeNode.expanded ? 'el-table__expand-icon--expanded' : ''];
	    var iconClasses = ['el-icon-arrow-right'];
	    if (treeNode.loading) {
	      iconClasses = ['el-icon-loading'];
	    }
	    ele.push(h(
	      'div',
	      { 'class': expandClasses,
	        on: {
	          'click': callback
	        }
	      },
	      [h('i', { 'class': iconClasses })]
	    ));
	  } else {
	    ele.push(h('span', { 'class': 'el-table__placeholder' }));
	  }
	  return ele;
	}
	// CONCATENATED MODULE: ./packages/table/src/table-column.js
	var table_column_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	
	var columnIdSeed = 1;
	
	/* harmony default export */ var table_column = ({
	  name: 'ElTableColumn',
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    label: String,
	    className: String,
	    labelClassName: String,
	    property: String,
	    prop: String,
	    width: {},
	    minWidth: {},
	    renderHeader: Function,
	    sortable: {
	      type: [Boolean, String],
	      default: false
	    },
	    sortMethod: Function,
	    sortBy: [String, Function, Array],
	    resizable: {
	      type: Boolean,
	      default: true
	    },
	    columnKey: String,
	    align: String,
	    headerAlign: String,
	    showTooltipWhenOverflow: Boolean,
	    showOverflowTooltip: Boolean,
	    fixed: [Boolean, String],
	    formatter: Function,
	    selectable: Function,
	    reserveSelection: Boolean,
	    filterMethod: Function,
	    filteredValue: Array,
	    filters: Array,
	    filterPlacement: String,
	    filterMultiple: {
	      type: Boolean,
	      default: true
	    },
	    index: [Number, Function],
	    sortOrders: {
	      type: Array,
	      default: function _default() {
	        return ['ascending', 'descending', null];
	      },
	      validator: function validator(val) {
	        return val.every(function (order) {
	          return ['ascending', 'descending', null].indexOf(order) > -1;
	        });
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      isSubColumn: false,
	      columns: []
	    };
	  },
	
	
	  computed: {
	    owner: function owner() {
	      var parent = this.$parent;
	      while (parent && !parent.tableId) {
	        parent = parent.$parent;
	      }
	      return parent;
	    },
	    columnOrTableParent: function columnOrTableParent() {
	      var parent = this.$parent;
	      while (parent && !parent.tableId && !parent.columnId) {
	        parent = parent.$parent;
	      }
	      return parent;
	    },
	    realWidth: function realWidth() {
	      return parseWidth(this.width);
	    },
	    realMinWidth: function realMinWidth() {
	      return parseMinWidth(this.minWidth);
	    },
	    realAlign: function realAlign() {
	      return this.align ? 'is-' + this.align : null;
	    },
	    realHeaderAlign: function realHeaderAlign() {
	      return this.headerAlign ? 'is-' + this.headerAlign : this.realAlign;
	    }
	  },
	
	  methods: {
	    getPropsData: function getPropsData() {
	      var _this = this;
	
	      for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
	        props[_key] = arguments[_key];
	      }
	
	      return props.reduce(function (prev, cur) {
	        if (Array.isArray(cur)) {
	          cur.forEach(function (key) {
	            prev[key] = _this[key];
	          });
	        }
	        return prev;
	      }, {});
	    },
	    getColumnElIndex: function getColumnElIndex(children, child) {
	      return [].indexOf.call(children, child);
	    },
	    setColumnWidth: function setColumnWidth(column) {
	      if (this.realWidth) {
	        column.width = this.realWidth;
	      }
	      if (this.realMinWidth) {
	        column.minWidth = this.realMinWidth;
	      }
	      if (!column.minWidth) {
	        column.minWidth = 80;
	      }
	      column.realWidth = column.width === undefined ? column.minWidth : column.width;
	      return column;
	    },
	    setColumnForcedProps: function setColumnForcedProps(column) {
	      // 对于特定类型的 column，某些属性不允许设置
	      var type = column.type;
	      var source = cellForced[type] || {};
	      Object.keys(source).forEach(function (prop) {
	        var value = source[prop];
	        if (value !== undefined) {
	          column[prop] = prop === 'className' ? column[prop] + ' ' + value : value;
	        }
	      });
	      return column;
	    },
	    setColumnRenders: function setColumnRenders(column) {
	      var _this2 = this;
	
	      var h = this.$createElement;
	
	      // renderHeader 属性不推荐使用。
	      if (this.renderHeader) {
	        console.warn('[Element Warn][TableColumn]Comparing to render-header, scoped-slot header is easier to use. We recommend users to use scoped-slot header.');
	      } else if (column.type !== 'selection') {
	        column.renderHeader = function (h, scope) {
	          var renderHeader = _this2.$scopedSlots.header;
	          return renderHeader ? renderHeader(scope) : column.label;
	        };
	      }
	
	      var originRenderCell = column.renderCell;
	      // TODO: 这里的实现调整
	      if (column.type === 'expand') {
	        // 对于展开行，renderCell 不允许配置的。在上一步中已经设置过，这里需要简单封装一下。
	        column.renderCell = function (h, data) {
	          return h(
	            'div',
	            { 'class': 'cell' },
	            [originRenderCell(h, data)]
	          );
	        };
	        this.owner.renderExpanded = function (h, data) {
	          return _this2.$scopedSlots.default ? _this2.$scopedSlots.default(data) : _this2.$slots.default;
	        };
	      } else {
	        originRenderCell = originRenderCell || defaultRenderCell;
	        // 对 renderCell 进行包装
	        column.renderCell = function (h, data) {
	          var children = null;
	          if (_this2.$scopedSlots.default) {
	            children = _this2.$scopedSlots.default(data);
	          } else {
	            children = originRenderCell(h, data);
	          }
	          var prefix = treeCellPrefix(h, data);
	          var props = {
	            class: 'cell',
	            style: {}
	          };
	          if (column.showOverflowTooltip) {
	            props.class += ' el-tooltip';
	            props.style = { width: (data.column.realWidth || data.column.width) - 1 + 'px' };
	          }
	          return h(
	            'div',
	            props,
	            [prefix, children]
	          );
	        };
	      }
	      return column;
	    },
	    registerNormalWatchers: function registerNormalWatchers() {
	      var _this3 = this;
	
	      var props = ['label', 'property', 'filters', 'filterMultiple', 'sortable', 'index', 'formatter', 'className', 'labelClassName', 'showOverflowTooltip'];
	      // 一些属性具有别名
	      var aliases = {
	        prop: 'property',
	        realAlign: 'align',
	        realHeaderAlign: 'headerAlign',
	        realWidth: 'width'
	      };
	      var allAliases = props.reduce(function (prev, cur) {
	        prev[cur] = cur;
	        return prev;
	      }, aliases);
	
	      Object.keys(allAliases).forEach(function (key) {
	        var columnKey = aliases[key];
	
	        _this3.$watch(key, function (newVal) {
	          _this3.columnConfig[columnKey] = newVal;
	        });
	      });
	    },
	    registerComplexWatchers: function registerComplexWatchers() {
	      var _this4 = this;
	
	      var props = ['fixed'];
	      var aliases = {
	        realWidth: 'width',
	        realMinWidth: 'minWidth'
	      };
	      var allAliases = props.reduce(function (prev, cur) {
	        prev[cur] = cur;
	        return prev;
	      }, aliases);
	
	      Object.keys(allAliases).forEach(function (key) {
	        var columnKey = aliases[key];
	
	        _this4.$watch(key, function (newVal) {
	          _this4.columnConfig[columnKey] = newVal;
	          var updateColumns = columnKey === 'fixed';
	          _this4.owner.store.scheduleLayout(updateColumns);
	        });
	      });
	    }
	  },
	
	  components: {
	    ElCheckbox: checkbox_default.a
	  },
	
	  beforeCreate: function beforeCreate() {
	    this.row = {};
	    this.column = {};
	    this.$index = 0;
	    this.columnId = '';
	  },
	  created: function created() {
	    var parent = this.columnOrTableParent;
	    this.isSubColumn = this.owner !== parent;
	    this.columnId = (parent.tableId || parent.columnId) + '_column_' + columnIdSeed++;
	
	    var type = this.type || 'default';
	    var sortable = this.sortable === '' ? true : this.sortable;
	    var defaults = table_column_extends({}, cellStarts[type], {
	      id: this.columnId,
	      type: type,
	      property: this.prop || this.property,
	      align: this.realAlign,
	      headerAlign: this.realHeaderAlign,
	      showOverflowTooltip: this.showOverflowTooltip || this.showTooltipWhenOverflow,
	      // filter 相关属性
	      filterable: this.filters || this.filterMethod,
	      filteredValue: [],
	      filterPlacement: '',
	      isColumnGroup: false,
	      filterOpened: false,
	      // sort 相关属性
	      sortable: sortable,
	      // index 列
	      index: this.index
	    });
	
	    var basicProps = ['columnKey', 'label', 'className', 'labelClassName', 'type', 'renderHeader', 'formatter', 'fixed', 'resizable'];
	    var sortProps = ['sortMethod', 'sortBy', 'sortOrders'];
	    var selectProps = ['selectable', 'reserveSelection'];
	    var filterProps = ['filterMethod', 'filters', 'filterMultiple', 'filterOpened', 'filteredValue', 'filterPlacement'];
	
	    var column = this.getPropsData(basicProps, sortProps, selectProps, filterProps);
	    column = mergeOptions(defaults, column);
	
	    // 注意 compose 中函数执行的顺序是从右到左
	    var chains = compose(this.setColumnRenders, this.setColumnWidth, this.setColumnForcedProps);
	    column = chains(column);
	
	    this.columnConfig = column;
	
	    // 注册 watcher
	    this.registerNormalWatchers();
	    this.registerComplexWatchers();
	  },
	  mounted: function mounted() {
	    var owner = this.owner;
	    var parent = this.columnOrTableParent;
	    var children = this.isSubColumn ? parent.$el.children : parent.$refs.hiddenColumns.children;
	    var columnIndex = this.getColumnElIndex(children, this.$el);
	
	    owner.store.commit('insertColumn', this.columnConfig, columnIndex, this.isSubColumn ? parent.columnConfig : null);
	  },
	  destroyed: function destroyed() {
	    if (!this.$parent) return;
	    var parent = this.$parent;
	    this.owner.store.commit('removeColumn', this.columnConfig, this.isSubColumn ? parent.columnConfig : null);
	  },
	  render: function render(h) {
	    // slots 也要渲染，需要计算合并表头
	    return h('div', this.$slots.default);
	  }
	});
	// CONCATENATED MODULE: ./packages/table-column/index.js
	
	
	/* istanbul ignore next */
	table_column.install = function (Vue) {
	  Vue.component(table_column.name, table_column);
	};
	
	/* harmony default export */ var packages_table_column = (table_column);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&
	var pickervue_type_template_id_79ae069f_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return !_vm.ranged
	    ? _c(
	        "el-input",
	        _vm._b(
	          {
	            directives: [
	              {
	                name: "clickoutside",
	                rawName: "v-clickoutside",
	                value: _vm.handleClose,
	                expression: "handleClose"
	              }
	            ],
	            ref: "reference",
	            staticClass: "el-date-editor",
	            class: "el-date-editor--" + _vm.type,
	            attrs: {
	              readonly:
	                !_vm.editable ||
	                _vm.readonly ||
	                _vm.type === "dates" ||
	                _vm.type === "week",
	              disabled: _vm.pickerDisabled,
	              size: _vm.pickerSize,
	              name: _vm.name,
	              placeholder: _vm.placeholder,
	              value: _vm.displayValue,
	              validateEvent: false
	            },
	            on: {
	              focus: _vm.handleFocus,
	              input: function(value) {
	                return (_vm.userInput = value)
	              },
	              change: _vm.handleChange
	            },
	            nativeOn: {
	              keydown: function($event) {
	                return _vm.handleKeydown($event)
	              },
	              mouseenter: function($event) {
	                return _vm.handleMouseEnter($event)
	              },
	              mouseleave: function($event) {
	                _vm.showClose = false
	              }
	            }
	          },
	          "el-input",
	          _vm.firstInputId,
	          false
	        ),
	        [
	          _c("i", {
	            staticClass: "el-input__icon",
	            class: _vm.triggerClass,
	            attrs: { slot: "prefix" },
	            on: { click: _vm.handleFocus },
	            slot: "prefix"
	          }),
	          _vm.haveTrigger
	            ? _c("i", {
	                staticClass: "el-input__icon",
	                class: [_vm.showClose ? "" + _vm.clearIcon : ""],
	                attrs: { slot: "suffix" },
	                on: { click: _vm.handleClickIcon },
	                slot: "suffix"
	              })
	            : _vm._e()
	        ]
	      )
	    : _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "clickoutside",
	              rawName: "v-clickoutside",
	              value: _vm.handleClose,
	              expression: "handleClose"
	            }
	          ],
	          ref: "reference",
	          staticClass: "el-date-editor el-range-editor el-input__inner",
	          class: [
	            "el-date-editor--" + _vm.type,
	            _vm.pickerSize ? "el-range-editor--" + _vm.pickerSize : "",
	            _vm.pickerDisabled ? "is-disabled" : "",
	            _vm.pickerVisible ? "is-active" : ""
	          ],
	          on: {
	            click: _vm.handleRangeClick,
	            mouseenter: _vm.handleMouseEnter,
	            mouseleave: function($event) {
	              _vm.showClose = false
	            },
	            keydown: _vm.handleKeydown
	          }
	        },
	        [
	          _c("i", {
	            class: ["el-input__icon", "el-range__icon", _vm.triggerClass]
	          }),
	          _c(
	            "input",
	            _vm._b(
	              {
	                staticClass: "el-range-input",
	                attrs: {
	                  autocomplete: "off",
	                  placeholder: _vm.startPlaceholder,
	                  disabled: _vm.pickerDisabled,
	                  readonly: !_vm.editable || _vm.readonly,
	                  name: _vm.name && _vm.name[0]
	                },
	                domProps: { value: _vm.displayValue && _vm.displayValue[0] },
	                on: {
	                  input: _vm.handleStartInput,
	                  change: _vm.handleStartChange,
	                  focus: _vm.handleFocus
	                }
	              },
	              "input",
	              _vm.firstInputId,
	              false
	            )
	          ),
	          _vm._t("range-separator", [
	            _c("span", { staticClass: "el-range-separator" }, [
	              _vm._v(_vm._s(_vm.rangeSeparator))
	            ])
	          ]),
	          _c(
	            "input",
	            _vm._b(
	              {
	                staticClass: "el-range-input",
	                attrs: {
	                  autocomplete: "off",
	                  placeholder: _vm.endPlaceholder,
	                  disabled: _vm.pickerDisabled,
	                  readonly: !_vm.editable || _vm.readonly,
	                  name: _vm.name && _vm.name[1]
	                },
	                domProps: { value: _vm.displayValue && _vm.displayValue[1] },
	                on: {
	                  input: _vm.handleEndInput,
	                  change: _vm.handleEndChange,
	                  focus: _vm.handleFocus
	                }
	              },
	              "input",
	              _vm.secondInputId,
	              false
	            )
	          ),
	          _vm.haveTrigger
	            ? _c("i", {
	                staticClass: "el-input__icon el-range__close-icon",
	                class: [_vm.showClose ? "" + _vm.clearIcon : ""],
	                on: { click: _vm.handleClickIcon }
	              })
	            : _vm._e()
	        ],
	        2
	      )
	}
	var pickervue_type_template_id_79ae069f_staticRenderFns = []
	pickervue_type_template_id_79ae069f_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/date-util"
	var date_util_ = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	var NewPopper = {
	  props: {
	    appendToBody: vue_popper_default.a.props.appendToBody,
	    offset: vue_popper_default.a.props.offset,
	    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
	    arrowOffset: vue_popper_default.a.props.arrowOffset
	  },
	  methods: vue_popper_default.a.methods,
	  data: function data() {
	    return merge_default()({ visibleArrow: true }, vue_popper_default.a.data);
	  },
	
	  beforeDestroy: vue_popper_default.a.beforeDestroy
	};
	
	var DEFAULT_FORMATS = {
	  date: 'yyyy-MM-dd',
	  month: 'yyyy-MM',
	  datetime: 'yyyy-MM-dd HH:mm:ss',
	  time: 'HH:mm:ss',
	  week: 'yyyywWW',
	  timerange: 'HH:mm:ss',
	  daterange: 'yyyy-MM-dd',
	  monthrange: 'yyyy-MM',
	  datetimerange: 'yyyy-MM-dd HH:mm:ss',
	  year: 'yyyy'
	};
	var HAVE_TRIGGER_TYPES = ['date', 'datetime', 'time', 'time-select', 'week', 'month', 'year', 'daterange', 'monthrange', 'timerange', 'datetimerange', 'dates'];
	var pickervue_type_script_lang_js_DATE_FORMATTER = function DATE_FORMATTER(value, format) {
	  if (format === 'timestamp') return value.getTime();
	  return Object(date_util_["formatDate"])(value, format);
	};
	var pickervue_type_script_lang_js_DATE_PARSER = function DATE_PARSER(text, format) {
	  if (format === 'timestamp') return new Date(Number(text));
	  return Object(date_util_["parseDate"])(text, format);
	};
	var RANGE_FORMATTER = function RANGE_FORMATTER(value, format) {
	  if (Array.isArray(value) && value.length === 2) {
	    var start = value[0];
	    var end = value[1];
	
	    if (start && end) {
	      return [pickervue_type_script_lang_js_DATE_FORMATTER(start, format), pickervue_type_script_lang_js_DATE_FORMATTER(end, format)];
	    }
	  }
	  return '';
	};
	var RANGE_PARSER = function RANGE_PARSER(array, format, separator) {
	  if (!Array.isArray(array)) {
	    array = array.split(separator);
	  }
	  if (array.length === 2) {
	    var range1 = array[0];
	    var range2 = array[1];
	
	    return [pickervue_type_script_lang_js_DATE_PARSER(range1, format), pickervue_type_script_lang_js_DATE_PARSER(range2, format)];
	  }
	  return [];
	};
	var TYPE_VALUE_RESOLVER_MAP = {
	  default: {
	    formatter: function formatter(value) {
	      if (!value) return '';
	      return '' + value;
	    },
	    parser: function parser(text) {
	      if (text === undefined || text === '') return null;
	      return text;
	    }
	  },
	  week: {
	    formatter: function formatter(value, format) {
	      var week = Object(date_util_["getWeekNumber"])(value);
	      var month = value.getMonth();
	      var trueDate = new Date(value);
	      if (week === 1 && month === 11) {
	        trueDate.setHours(0, 0, 0, 0);
	        trueDate.setDate(trueDate.getDate() + 3 - (trueDate.getDay() + 6) % 7);
	      }
	      var date = Object(date_util_["formatDate"])(trueDate, format);
	
	      date = /WW/.test(date) ? date.replace(/WW/, week < 10 ? '0' + week : week) : date.replace(/W/, week);
	      return date;
	    },
	    parser: function parser(text, format) {
	      // parse as if a normal date
	      return TYPE_VALUE_RESOLVER_MAP.date.parser(text, format);
	    }
	  },
	  date: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  datetime: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  daterange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  monthrange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  datetimerange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  timerange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  time: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  month: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  year: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  number: {
	    formatter: function formatter(value) {
	      if (!value) return '';
	      return '' + value;
	    },
	    parser: function parser(text) {
	      var result = Number(text);
	
	      if (!isNaN(text)) {
	        return result;
	      } else {
	        return null;
	      }
	    }
	  },
	  dates: {
	    formatter: function formatter(value, format) {
	      return value.map(function (date) {
	        return pickervue_type_script_lang_js_DATE_FORMATTER(date, format);
	      });
	    },
	    parser: function parser(value, format) {
	      return (typeof value === 'string' ? value.split(', ') : value).map(function (date) {
	        return date instanceof Date ? date : pickervue_type_script_lang_js_DATE_PARSER(date, format);
	      });
	    }
	  }
	};
	var PLACEMENT_MAP = {
	  left: 'bottom-start',
	  center: 'bottom',
	  right: 'bottom-end'
	};
	
	var parseAsFormatAndType = function parseAsFormatAndType(value, customFormat, type) {
	  var rangeSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '-';
	
	  if (!value) return null;
	  var parser = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).parser;
	  var format = customFormat || DEFAULT_FORMATS[type];
	  return parser(value, format, rangeSeparator);
	};
	
	var formatAsFormatAndType = function formatAsFormatAndType(value, customFormat, type) {
	  if (!value) return null;
	  var formatter = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).formatter;
	  var format = customFormat || DEFAULT_FORMATS[type];
	  return formatter(value, format);
	};
	
	/*
	 * Considers:
	 *   1. Date object
	 *   2. date string
	 *   3. array of 1 or 2
	 */
	var valueEquals = function valueEquals(a, b) {
	  // considers Date object and string
	  var dateEquals = function dateEquals(a, b) {
	    var aIsDate = a instanceof Date;
	    var bIsDate = b instanceof Date;
	    if (aIsDate && bIsDate) {
	      return a.getTime() === b.getTime();
	    }
	    if (!aIsDate && !bIsDate) {
	      return a === b;
	    }
	    return false;
	  };
	
	  var aIsArray = a instanceof Array;
	  var bIsArray = b instanceof Array;
	  if (aIsArray && bIsArray) {
	    if (a.length !== b.length) {
	      return false;
	    }
	    return a.every(function (item, index) {
	      return dateEquals(item, b[index]);
	    });
	  }
	  if (!aIsArray && !bIsArray) {
	    return dateEquals(a, b);
	  }
	  return false;
	};
	
	var isString = function isString(val) {
	  return typeof val === 'string' || val instanceof String;
	};
	
	var pickervue_type_script_lang_js_validator = function validator(val) {
	  // either: String, Array of String, null / undefined
	  return val === null || val === undefined || isString(val) || Array.isArray(val) && val.length === 2 && val.every(isString);
	};
	
	/* harmony default export */ var pickervue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a, NewPopper],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    size: String,
	    format: String,
	    valueFormat: String,
	    readonly: Boolean,
	    placeholder: String,
	    startPlaceholder: String,
	    endPlaceholder: String,
	    prefixIcon: String,
	    clearIcon: {
	      type: String,
	      default: 'el-icon-circle-close'
	    },
	    name: {
	      default: '',
	      validator: pickervue_type_script_lang_js_validator
	    },
	    disabled: Boolean,
	    clearable: {
	      type: Boolean,
	      default: true
	    },
	    id: {
	      default: '',
	      validator: pickervue_type_script_lang_js_validator
	    },
	    popperClass: String,
	    editable: {
	      type: Boolean,
	      default: true
	    },
	    align: {
	      type: String,
	      default: 'left'
	    },
	    value: {},
	    defaultValue: {},
	    defaultTime: {},
	    rangeSeparator: {
	      default: '-'
	    },
	    pickerOptions: {},
	    unlinkPanels: Boolean,
	    validateEvent: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  components: { ElInput: input_default.a },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  data: function data() {
	    return {
	      pickerVisible: false,
	      showClose: false,
	      userInput: null,
	      valueOnOpen: null, // value when picker opens, used to determine whether to emit change
	      unwatchPickerOptions: null
	    };
	  },
	
	
	  watch: {
	    pickerVisible: function pickerVisible(val) {
	      if (this.readonly || this.pickerDisabled) return;
	      if (val) {
	        this.showPicker();
	        this.valueOnOpen = Array.isArray(this.value) ? [].concat(this.value) : this.value;
	      } else {
	        this.hidePicker();
	        this.emitChange(this.value);
	        this.userInput = null;
	        if (this.validateEvent) {
	          this.dispatch('ElFormItem', 'el.form.blur');
	        }
	        this.$emit('blur', this);
	        this.blur();
	      }
	    },
	
	    parsedValue: {
	      immediate: true,
	      handler: function handler(val) {
	        if (this.picker) {
	          this.picker.value = val;
	        }
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      // NOTE: should eventually move to jsx style picker + panel ?
	      if (this.picker) {
	        this.picker.defaultValue = val;
	      }
	    },
	    value: function value(val, oldVal) {
	      if (!valueEquals(val, oldVal) && !this.pickerVisible && this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', val);
	      }
	    }
	  },
	
	  computed: {
	    ranged: function ranged() {
	      return this.type.indexOf('range') > -1;
	    },
	    reference: function reference() {
	      var reference = this.$refs.reference;
	      return reference.$el || reference;
	    },
	    refInput: function refInput() {
	      if (this.reference) {
	        return [].slice.call(this.reference.querySelectorAll('input'));
	      }
	      return [];
	    },
	    valueIsEmpty: function valueIsEmpty() {
	      var val = this.value;
	      if (Array.isArray(val)) {
	        for (var i = 0, len = val.length; i < len; i++) {
	          if (val[i]) {
	            return false;
	          }
	        }
	      } else {
	        if (val) {
	          return false;
	        }
	      }
	      return true;
	    },
	    triggerClass: function triggerClass() {
	      return this.prefixIcon || (this.type.indexOf('time') !== -1 ? 'el-icon-time' : 'el-icon-date');
	    },
	    selectionMode: function selectionMode() {
	      if (this.type === 'week') {
	        return 'week';
	      } else if (this.type === 'month') {
	        return 'month';
	      } else if (this.type === 'year') {
	        return 'year';
	      } else if (this.type === 'dates') {
	        return 'dates';
	      }
	
	      return 'day';
	    },
	    haveTrigger: function haveTrigger() {
	      if (typeof this.showTrigger !== 'undefined') {
	        return this.showTrigger;
	      }
	      return HAVE_TRIGGER_TYPES.indexOf(this.type) !== -1;
	    },
	    displayValue: function displayValue() {
	      var formattedValue = formatAsFormatAndType(this.parsedValue, this.format, this.type, this.rangeSeparator);
	      if (Array.isArray(this.userInput)) {
	        return [this.userInput[0] || formattedValue && formattedValue[0] || '', this.userInput[1] || formattedValue && formattedValue[1] || ''];
	      } else if (this.userInput !== null) {
	        return this.userInput;
	      } else if (formattedValue) {
	        return this.type === 'dates' ? formattedValue.join(', ') : formattedValue;
	      } else {
	        return '';
	      }
	    },
	    parsedValue: function parsedValue() {
	      if (!this.value) return this.value; // component value is not set
	      if (this.type === 'time-select') return this.value; // time-select does not require parsing, this might change in next major version
	
	      var valueIsDateObject = Object(date_util_["isDateObject"])(this.value) || Array.isArray(this.value) && this.value.every(date_util_["isDateObject"]);
	      if (valueIsDateObject) {
	        return this.value;
	      }
	
	      if (this.valueFormat) {
	        return parseAsFormatAndType(this.value, this.valueFormat, this.type, this.rangeSeparator) || this.value;
	      }
	
	      // NOTE: deal with common but incorrect usage, should remove in next major version
	      // user might provide string / timestamp without value-format, coerce them into date (or array of date)
	      return Array.isArray(this.value) ? this.value.map(function (val) {
	        return new Date(val);
	      }) : new Date(this.value);
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    pickerSize: function pickerSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    pickerDisabled: function pickerDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    firstInputId: function firstInputId() {
	      var obj = {};
	      var id = void 0;
	      if (this.ranged) {
	        id = this.id && this.id[0];
	      } else {
	        id = this.id;
	      }
	      if (id) obj.id = id;
	      return obj;
	    },
	    secondInputId: function secondInputId() {
	      var obj = {};
	      var id = void 0;
	      if (this.ranged) {
	        id = this.id && this.id[1];
	      }
	      if (id) obj.id = id;
	      return obj;
	    }
	  },
	
	  created: function created() {
	    // vue-popper
	    this.popperOptions = {
	      boundariesPadding: 0,
	      gpuAcceleration: false
	    };
	    this.placement = PLACEMENT_MAP[this.align] || PLACEMENT_MAP.left;
	
	    this.$on('fieldReset', this.handleFieldReset);
	  },
	
	
	  methods: {
	    focus: function focus() {
	      if (!this.ranged) {
	        this.$refs.reference.focus();
	      } else {
	        this.handleFocus();
	      }
	    },
	    blur: function blur() {
	      this.refInput.forEach(function (input) {
	        return input.blur();
	      });
	    },
	
	
	    // {parse, formatTo} Value deals maps component value with internal Date
	    parseValue: function parseValue(value) {
	      var isParsed = Object(date_util_["isDateObject"])(value) || Array.isArray(value) && value.every(date_util_["isDateObject"]);
	      if (this.valueFormat && !isParsed) {
	        return parseAsFormatAndType(value, this.valueFormat, this.type, this.rangeSeparator) || value;
	      } else {
	        return value;
	      }
	    },
	    formatToValue: function formatToValue(date) {
	      var isFormattable = Object(date_util_["isDateObject"])(date) || Array.isArray(date) && date.every(date_util_["isDateObject"]);
	      if (this.valueFormat && isFormattable) {
	        return formatAsFormatAndType(date, this.valueFormat, this.type, this.rangeSeparator);
	      } else {
	        return date;
	      }
	    },
	
	
	    // {parse, formatTo} String deals with user input
	    parseString: function parseString(value) {
	      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
	      return parseAsFormatAndType(value, this.format, type);
	    },
	    formatToString: function formatToString(value) {
	      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
	      return formatAsFormatAndType(value, this.format, type);
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      if (this.readonly || this.pickerDisabled) return;
	      if (!this.valueIsEmpty && this.clearable) {
	        this.showClose = true;
	      }
	    },
	    handleChange: function handleChange() {
	      if (this.userInput) {
	        var value = this.parseString(this.displayValue);
	        if (value) {
	          this.picker.value = value;
	          if (this.isValidValue(value)) {
	            this.emitInput(value);
	            this.userInput = null;
	          }
	        }
	      }
	      if (this.userInput === '') {
	        this.emitInput(null);
	        this.emitChange(null);
	        this.userInput = null;
	      }
	    },
	    handleStartInput: function handleStartInput(event) {
	      if (this.userInput) {
	        this.userInput = [event.target.value, this.userInput[1]];
	      } else {
	        this.userInput = [event.target.value, null];
	      }
	    },
	    handleEndInput: function handleEndInput(event) {
	      if (this.userInput) {
	        this.userInput = [this.userInput[0], event.target.value];
	      } else {
	        this.userInput = [null, event.target.value];
	      }
	    },
	    handleStartChange: function handleStartChange(event) {
	      var value = this.parseString(this.userInput && this.userInput[0]);
	      if (value) {
	        this.userInput = [this.formatToString(value), this.displayValue[1]];
	        var newValue = [value, this.picker.value && this.picker.value[1]];
	        this.picker.value = newValue;
	        if (this.isValidValue(newValue)) {
	          this.emitInput(newValue);
	          this.userInput = null;
	        }
	      }
	    },
	    handleEndChange: function handleEndChange(event) {
	      var value = this.parseString(this.userInput && this.userInput[1]);
	      if (value) {
	        this.userInput = [this.displayValue[0], this.formatToString(value)];
	        var newValue = [this.picker.value && this.picker.value[0], value];
	        this.picker.value = newValue;
	        if (this.isValidValue(newValue)) {
	          this.emitInput(newValue);
	          this.userInput = null;
	        }
	      }
	    },
	    handleClickIcon: function handleClickIcon(event) {
	      if (this.readonly || this.pickerDisabled) return;
	      if (this.showClose) {
	        this.valueOnOpen = this.value;
	        event.stopPropagation();
	        this.emitInput(null);
	        this.emitChange(null);
	        this.showClose = false;
	        if (this.picker && typeof this.picker.handleClear === 'function') {
	          this.picker.handleClear();
	        }
	      } else {
	        this.pickerVisible = !this.pickerVisible;
	      }
	    },
	    handleClose: function handleClose() {
	      if (!this.pickerVisible) return;
	      this.pickerVisible = false;
	
	      if (this.type === 'dates') {
	        // restore to former value
	        var oldValue = parseAsFormatAndType(this.valueOnOpen, this.valueFormat, this.type, this.rangeSeparator) || this.valueOnOpen;
	        this.emitInput(oldValue);
	      }
	    },
	    handleFieldReset: function handleFieldReset(initialValue) {
	      this.userInput = initialValue === '' ? null : initialValue;
	    },
	    handleFocus: function handleFocus() {
	      var type = this.type;
	
	      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
	        this.pickerVisible = true;
	      }
	      this.$emit('focus', this);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var _this = this;
	
	      var keyCode = event.keyCode;
	
	      // ESC
	      if (keyCode === 27) {
	        this.pickerVisible = false;
	        event.stopPropagation();
	        return;
	      }
	
	      // Tab
	      if (keyCode === 9) {
	        if (!this.ranged) {
	          this.handleChange();
	          this.pickerVisible = this.picker.visible = false;
	          this.blur();
	          event.stopPropagation();
	        } else {
	          // user may change focus between two input
	          setTimeout(function () {
	            if (_this.refInput.indexOf(document.activeElement) === -1) {
	              _this.pickerVisible = false;
	              _this.blur();
	              event.stopPropagation();
	            }
	          }, 0);
	        }
	        return;
	      }
	
	      // Enter
	      if (keyCode === 13) {
	        if (this.userInput === '' || this.isValidValue(this.parseString(this.displayValue))) {
	          this.handleChange();
	          this.pickerVisible = this.picker.visible = false;
	          this.blur();
	        }
	        event.stopPropagation();
	        return;
	      }
	
	      // if user is typing, do not let picker handle key input
	      if (this.userInput) {
	        event.stopPropagation();
	        return;
	      }
	
	      // delegate other keys to panel
	      if (this.picker && this.picker.handleKeydown) {
	        this.picker.handleKeydown(event);
	      }
	    },
	    handleRangeClick: function handleRangeClick() {
	      var type = this.type;
	
	      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
	        this.pickerVisible = true;
	      }
	      this.$emit('focus', this);
	    },
	    hidePicker: function hidePicker() {
	      if (this.picker) {
	        this.picker.resetView && this.picker.resetView();
	        this.pickerVisible = this.picker.visible = false;
	        this.destroyPopper();
	      }
	    },
	    showPicker: function showPicker() {
	      var _this2 = this;
	
	      if (this.$isServer) return;
	      if (!this.picker) {
	        this.mountPicker();
	      }
	      this.pickerVisible = this.picker.visible = true;
	
	      this.updatePopper();
	
	      this.picker.value = this.parsedValue;
	      this.picker.resetView && this.picker.resetView();
	
	      this.$nextTick(function () {
	        _this2.picker.adjustSpinners && _this2.picker.adjustSpinners();
	      });
	    },
	    mountPicker: function mountPicker() {
	      var _this3 = this;
	
	      this.picker = new external_vue_default.a(this.panel).$mount();
	      this.picker.defaultValue = this.defaultValue;
	      this.picker.defaultTime = this.defaultTime;
	      this.picker.popperClass = this.popperClass;
	      this.popperElm = this.picker.$el;
	      this.picker.width = this.reference.getBoundingClientRect().width;
	      this.picker.showTime = this.type === 'datetime' || this.type === 'datetimerange';
	      this.picker.selectionMode = this.selectionMode;
	      this.picker.unlinkPanels = this.unlinkPanels;
	      this.picker.arrowControl = this.arrowControl || this.timeArrowControl || false;
	      this.$watch('format', function (format) {
	        _this3.picker.format = format;
	      });
	
	      var updateOptions = function updateOptions() {
	        var options = _this3.pickerOptions;
	
	        if (options && options.selectableRange) {
	          var ranges = options.selectableRange;
	          var parser = TYPE_VALUE_RESOLVER_MAP.datetimerange.parser;
	          var format = DEFAULT_FORMATS.timerange;
	
	          ranges = Array.isArray(ranges) ? ranges : [ranges];
	          _this3.picker.selectableRange = ranges.map(function (range) {
	            return parser(range, format, _this3.rangeSeparator);
	          });
	        }
	
	        for (var option in options) {
	          if (options.hasOwnProperty(option) &&
	          // 忽略 time-picker 的该配置项
	          option !== 'selectableRange') {
	            _this3.picker[option] = options[option];
	          }
	        }
	
	        // main format must prevail over undocumented pickerOptions.format
	        if (_this3.format) {
	          _this3.picker.format = _this3.format;
	        }
	      };
	      updateOptions();
	      this.unwatchPickerOptions = this.$watch('pickerOptions', function () {
	        return updateOptions();
	      }, { deep: true });
	      this.$el.appendChild(this.picker.$el);
	      this.picker.resetView && this.picker.resetView();
	
	      this.picker.$on('dodestroy', this.doDestroy);
	      this.picker.$on('pick', function () {
	        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        _this3.userInput = null;
	        _this3.pickerVisible = _this3.picker.visible = visible;
	        _this3.emitInput(date);
	        _this3.picker.resetView && _this3.picker.resetView();
	      });
	
	      this.picker.$on('select-range', function (start, end, pos) {
	        if (_this3.refInput.length === 0) return;
	        if (!pos || pos === 'min') {
	          _this3.refInput[0].setSelectionRange(start, end);
	          _this3.refInput[0].focus();
	        } else if (pos === 'max') {
	          _this3.refInput[1].setSelectionRange(start, end);
	          _this3.refInput[1].focus();
	        }
	      });
	    },
	    unmountPicker: function unmountPicker() {
	      if (this.picker) {
	        this.picker.$destroy();
	        this.picker.$off();
	        if (typeof this.unwatchPickerOptions === 'function') {
	          this.unwatchPickerOptions();
	        }
	        this.picker.$el.parentNode.removeChild(this.picker.$el);
	      }
	    },
	    emitChange: function emitChange(val) {
	      // determine user real change only
	      if (!valueEquals(val, this.valueOnOpen)) {
	        this.$emit('change', val);
	        this.valueOnOpen = val;
	        if (this.validateEvent) {
	          this.dispatch('ElFormItem', 'el.form.change', val);
	        }
	      }
	    },
	    emitInput: function emitInput(val) {
	      var formatted = this.formatToValue(val);
	      if (!valueEquals(this.value, formatted)) {
	        this.$emit('input', formatted);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      if (!this.picker) {
	        this.mountPicker();
	      }
	      if (this.picker.isValidValue) {
	        return value && this.picker.isValidValue(value);
	      } else {
	        return true;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_pickervue_type_script_lang_js_ = (pickervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue
	
	
	
	
	
	/* normalize component */
	
	var picker_component = normalizeComponent(
	  src_pickervue_type_script_lang_js_,
	  pickervue_type_template_id_79ae069f_render,
	  pickervue_type_template_id_79ae069f_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var picker_api; }
	picker_component.options.__file = "packages/date-picker/src/picker.vue"
	/* harmony default export */ var picker = (picker_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&
	var datevue_type_template_id_2440d4ea_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: { "after-enter": _vm.handleEnter, "after-leave": _vm.handleLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-picker-panel el-date-picker el-popper",
	          class: [
	            {
	              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts,
	              "has-time": _vm.showTime
	            },
	            _vm.popperClass
	          ]
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-picker-panel__body-wrapper" },
	            [
	              _vm._t("sidebar"),
	              _vm.shortcuts
	                ? _c(
	                    "div",
	                    { staticClass: "el-picker-panel__sidebar" },
	                    _vm._l(_vm.shortcuts, function(shortcut, key) {
	                      return _c(
	                        "button",
	                        {
	                          key: key,
	                          staticClass: "el-picker-panel__shortcut",
	                          attrs: { type: "button" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleShortcutClick(shortcut)
	                            }
	                          }
	                        },
	                        [_vm._v(_vm._s(shortcut.text))]
	                      )
	                    }),
	                    0
	                  )
	                : _vm._e(),
	              _c("div", { staticClass: "el-picker-panel__body" }, [
	                _vm.showTime
	                  ? _c("div", { staticClass: "el-date-picker__time-header" }, [
	                      _c(
	                        "span",
	                        { staticClass: "el-date-picker__editor-wrap" },
	                        [
	                          _c("el-input", {
	                            attrs: {
	                              placeholder: _vm.t("el.datepicker.selectDate"),
	                              value: _vm.visibleDate,
	                              size: "small"
	                            },
	                            on: {
	                              input: function(val) {
	                                return (_vm.userInputDate = val)
	                              },
	                              change: _vm.handleVisibleDateChange
	                            }
	                          })
	                        ],
	                        1
	                      ),
	                      _c(
	                        "span",
	                        {
	                          directives: [
	                            {
	                              name: "clickoutside",
	                              rawName: "v-clickoutside",
	                              value: _vm.handleTimePickClose,
	                              expression: "handleTimePickClose"
	                            }
	                          ],
	                          staticClass: "el-date-picker__editor-wrap"
	                        },
	                        [
	                          _c("el-input", {
	                            ref: "input",
	                            attrs: {
	                              placeholder: _vm.t("el.datepicker.selectTime"),
	                              value: _vm.visibleTime,
	                              size: "small"
	                            },
	                            on: {
	                              focus: function($event) {
	                                _vm.timePickerVisible = true
	                              },
	                              input: function(val) {
	                                return (_vm.userInputTime = val)
	                              },
	                              change: _vm.handleVisibleTimeChange
	                            }
	                          }),
	                          _c("time-picker", {
	                            ref: "timepicker",
	                            attrs: {
	                              "time-arrow-control": _vm.arrowControl,
	                              visible: _vm.timePickerVisible
	                            },
	                            on: {
	                              pick: _vm.handleTimePick,
	                              mounted: _vm.proxyTimePickerDataProperties
	                            }
	                          })
	                        ],
	                        1
	                      )
	                    ])
	                  : _vm._e(),
	                _c(
	                  "div",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value: _vm.currentView !== "time",
	                        expression: "currentView !== 'time'"
	                      }
	                    ],
	                    staticClass: "el-date-picker__header",
	                    class: {
	                      "el-date-picker__header--bordered":
	                        _vm.currentView === "year" ||
	                        _vm.currentView === "month"
	                    }
	                  },
	                  [
	                    _c("button", {
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.prevYear")
	                      },
	                      on: { click: _vm.prevYear }
	                    }),
	                    _c("button", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "date",
	                          expression: "currentView === 'date'"
	                        }
	                      ],
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.prevMonth")
	                      },
	                      on: { click: _vm.prevMonth }
	                    }),
	                    _c(
	                      "span",
	                      {
	                        staticClass: "el-date-picker__header-label",
	                        attrs: { role: "button" },
	                        on: { click: _vm.showYearPicker }
	                      },
	                      [_vm._v(_vm._s(_vm.yearLabel))]
	                    ),
	                    _c(
	                      "span",
	                      {
	                        directives: [
	                          {
	                            name: "show",
	                            rawName: "v-show",
	                            value: _vm.currentView === "date",
	                            expression: "currentView === 'date'"
	                          }
	                        ],
	                        staticClass: "el-date-picker__header-label",
	                        class: { active: _vm.currentView === "month" },
	                        attrs: { role: "button" },
	                        on: { click: _vm.showMonthPicker }
	                      },
	                      [
	                        _vm._v(
	                          _vm._s(_vm.t("el.datepicker.month" + (_vm.month + 1)))
	                        )
	                      ]
	                    ),
	                    _c("button", {
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.nextYear")
	                      },
	                      on: { click: _vm.nextYear }
	                    }),
	                    _c("button", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "date",
	                          expression: "currentView === 'date'"
	                        }
	                      ],
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.nextMonth")
	                      },
	                      on: { click: _vm.nextMonth }
	                    })
	                  ]
	                ),
	                _c(
	                  "div",
	                  { staticClass: "el-picker-panel__content" },
	                  [
	                    _c("date-table", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "date",
	                          expression: "currentView === 'date'"
	                        }
	                      ],
	                      attrs: {
	                        "selection-mode": _vm.selectionMode,
	                        "first-day-of-week": _vm.firstDayOfWeek,
	                        value: _vm.value,
	                        "default-value": _vm.defaultValue
	                          ? new Date(_vm.defaultValue)
	                          : null,
	                        date: _vm.date,
	                        "cell-class-name": _vm.cellClassName,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: { pick: _vm.handleDatePick }
	                    }),
	                    _c("year-table", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "year",
	                          expression: "currentView === 'year'"
	                        }
	                      ],
	                      attrs: {
	                        value: _vm.value,
	                        "default-value": _vm.defaultValue
	                          ? new Date(_vm.defaultValue)
	                          : null,
	                        date: _vm.date,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: { pick: _vm.handleYearPick }
	                    }),
	                    _c("month-table", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "month",
	                          expression: "currentView === 'month'"
	                        }
	                      ],
	                      attrs: {
	                        value: _vm.value,
	                        "default-value": _vm.defaultValue
	                          ? new Date(_vm.defaultValue)
	                          : null,
	                        date: _vm.date,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: { pick: _vm.handleMonthPick }
	                    })
	                  ],
	                  1
	                )
	              ])
	            ],
	            2
	          ),
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.footerVisible && _vm.currentView === "date",
	                  expression: "footerVisible && currentView === 'date'"
	                }
	              ],
	              staticClass: "el-picker-panel__footer"
	            },
	            [
	              _c(
	                "el-button",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.selectionMode !== "dates",
	                      expression: "selectionMode !== 'dates'"
	                    }
	                  ],
	                  staticClass: "el-picker-panel__link-btn",
	                  attrs: { size: "mini", type: "text" },
	                  on: { click: _vm.changeToNow }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.datepicker.now")) +
	                      "\n      "
	                  )
	                ]
	              ),
	              _c(
	                "el-button",
	                {
	                  staticClass: "el-picker-panel__link-btn",
	                  attrs: { plain: "", size: "mini" },
	                  on: { click: _vm.confirm }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.datepicker.confirm")) +
	                      "\n      "
	                  )
	                ]
	              )
	            ],
	            1
	          )
	        ]
	      )
	    ]
	  )
	}
	var datevue_type_template_id_2440d4ea_staticRenderFns = []
	datevue_type_template_id_2440d4ea_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&
	var timevue_type_template_id_3d939089_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-time-panel el-popper",
	          class: _vm.popperClass
	        },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-time-panel__content",
	              class: { "has-seconds": _vm.showSeconds }
	            },
	            [
	              _c("time-spinner", {
	                ref: "spinner",
	                attrs: {
	                  "arrow-control": _vm.useArrow,
	                  "show-seconds": _vm.showSeconds,
	                  "am-pm-mode": _vm.amPmMode,
	                  date: _vm.date
	                },
	                on: {
	                  change: _vm.handleChange,
	                  "select-range": _vm.setSelectionRange
	                }
	              })
	            ],
	            1
	          ),
	          _c("div", { staticClass: "el-time-panel__footer" }, [
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn cancel",
	                attrs: { type: "button" },
	                on: { click: _vm.handleCancel }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]
	            ),
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn",
	                class: { confirm: !_vm.disabled },
	                attrs: { type: "button" },
	                on: {
	                  click: function($event) {
	                    _vm.handleConfirm()
	                  }
	                }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))]
	            )
	          ])
	        ]
	      )
	    ]
	  )
	}
	var timevue_type_template_id_3d939089_staticRenderFns = []
	timevue_type_template_id_3d939089_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&
	var time_spinnervue_type_template_id_1facadeb_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-time-spinner",
	      class: { "has-seconds": _vm.showSeconds }
	    },
	    [
	      !_vm.arrowControl
	        ? [
	            _c(
	              "el-scrollbar",
	              {
	                ref: "hours",
	                staticClass: "el-time-spinner__wrapper",
	                attrs: {
	                  "wrap-style": "max-height: inherit;",
	                  "view-class": "el-time-spinner__list",
	                  noresize: "",
	                  tag: "ul"
	                },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("hours")
	                  },
	                  mousemove: function($event) {
	                    _vm.adjustCurrentSpinner("hours")
	                  }
	                }
	              },
	              _vm._l(_vm.hoursList, function(disabled, hour) {
	                return _c(
	                  "li",
	                  {
	                    key: hour,
	                    staticClass: "el-time-spinner__item",
	                    class: { active: hour === _vm.hours, disabled: disabled },
	                    on: {
	                      click: function($event) {
	                        _vm.handleClick("hours", {
	                          value: hour,
	                          disabled: disabled
	                        })
	                      }
	                    }
	                  },
	                  [
	                    _vm._v(
	                      _vm._s(
	                        ("0" + (_vm.amPmMode ? hour % 12 || 12 : hour)).slice(
	                          -2
	                        )
	                      ) + _vm._s(_vm.amPm(hour))
	                    )
	                  ]
	                )
	              }),
	              0
	            ),
	            _c(
	              "el-scrollbar",
	              {
	                ref: "minutes",
	                staticClass: "el-time-spinner__wrapper",
	                attrs: {
	                  "wrap-style": "max-height: inherit;",
	                  "view-class": "el-time-spinner__list",
	                  noresize: "",
	                  tag: "ul"
	                },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("minutes")
	                  },
	                  mousemove: function($event) {
	                    _vm.adjustCurrentSpinner("minutes")
	                  }
	                }
	              },
	              _vm._l(_vm.minutesList, function(enabled, key) {
	                return _c(
	                  "li",
	                  {
	                    key: key,
	                    staticClass: "el-time-spinner__item",
	                    class: { active: key === _vm.minutes, disabled: !enabled },
	                    on: {
	                      click: function($event) {
	                        _vm.handleClick("minutes", {
	                          value: key,
	                          disabled: false
	                        })
	                      }
	                    }
	                  },
	                  [_vm._v(_vm._s(("0" + key).slice(-2)))]
	                )
	              }),
	              0
	            ),
	            _c(
	              "el-scrollbar",
	              {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: _vm.showSeconds,
	                    expression: "showSeconds"
	                  }
	                ],
	                ref: "seconds",
	                staticClass: "el-time-spinner__wrapper",
	                attrs: {
	                  "wrap-style": "max-height: inherit;",
	                  "view-class": "el-time-spinner__list",
	                  noresize: "",
	                  tag: "ul"
	                },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("seconds")
	                  },
	                  mousemove: function($event) {
	                    _vm.adjustCurrentSpinner("seconds")
	                  }
	                }
	              },
	              _vm._l(60, function(second, key) {
	                return _c(
	                  "li",
	                  {
	                    key: key,
	                    staticClass: "el-time-spinner__item",
	                    class: { active: key === _vm.seconds },
	                    on: {
	                      click: function($event) {
	                        _vm.handleClick("seconds", {
	                          value: key,
	                          disabled: false
	                        })
	                      }
	                    }
	                  },
	                  [_vm._v(_vm._s(("0" + key).slice(-2)))]
	                )
	              }),
	              0
	            )
	          ]
	        : _vm._e(),
	      _vm.arrowControl
	        ? [
	            _c(
	              "div",
	              {
	                staticClass: "el-time-spinner__wrapper is-arrow",
	                on: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("hours")
	                  }
	                }
	              },
	              [
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.decrease,
	                      expression: "decrease"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-up"
	                }),
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.increase,
	                      expression: "increase"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-down"
	                }),
	                _c(
	                  "ul",
	                  { ref: "hours", staticClass: "el-time-spinner__list" },
	                  _vm._l(_vm.arrowHourList, function(hour, key) {
	                    return _c(
	                      "li",
	                      {
	                        key: key,
	                        staticClass: "el-time-spinner__item",
	                        class: {
	                          active: hour === _vm.hours,
	                          disabled: _vm.hoursList[hour]
	                        }
	                      },
	                      [
	                        _vm._v(
	                          _vm._s(
	                            hour === undefined
	                              ? ""
	                              : (
	                                  "0" + (_vm.amPmMode ? hour % 12 || 12 : hour)
	                                ).slice(-2) + _vm.amPm(hour)
	                          )
	                        )
	                      ]
	                    )
	                  }),
	                  0
	                )
	              ]
	            ),
	            _c(
	              "div",
	              {
	                staticClass: "el-time-spinner__wrapper is-arrow",
	                on: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("minutes")
	                  }
	                }
	              },
	              [
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.decrease,
	                      expression: "decrease"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-up"
	                }),
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.increase,
	                      expression: "increase"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-down"
	                }),
	                _c(
	                  "ul",
	                  { ref: "minutes", staticClass: "el-time-spinner__list" },
	                  _vm._l(_vm.arrowMinuteList, function(minute, key) {
	                    return _c(
	                      "li",
	                      {
	                        key: key,
	                        staticClass: "el-time-spinner__item",
	                        class: { active: minute === _vm.minutes }
	                      },
	                      [
	                        _vm._v(
	                          "\n          " +
	                            _vm._s(
	                              minute === undefined
	                                ? ""
	                                : ("0" + minute).slice(-2)
	                            ) +
	                            "\n        "
	                        )
	                      ]
	                    )
	                  }),
	                  0
	                )
	              ]
	            ),
	            _vm.showSeconds
	              ? _c(
	                  "div",
	                  {
	                    staticClass: "el-time-spinner__wrapper is-arrow",
	                    on: {
	                      mouseenter: function($event) {
	                        _vm.emitSelectRange("seconds")
	                      }
	                    }
	                  },
	                  [
	                    _c("i", {
	                      directives: [
	                        {
	                          name: "repeat-click",
	                          rawName: "v-repeat-click",
	                          value: _vm.decrease,
	                          expression: "decrease"
	                        }
	                      ],
	                      staticClass: "el-time-spinner__arrow el-icon-arrow-up"
	                    }),
	                    _c("i", {
	                      directives: [
	                        {
	                          name: "repeat-click",
	                          rawName: "v-repeat-click",
	                          value: _vm.increase,
	                          expression: "increase"
	                        }
	                      ],
	                      staticClass: "el-time-spinner__arrow el-icon-arrow-down"
	                    }),
	                    _c(
	                      "ul",
	                      { ref: "seconds", staticClass: "el-time-spinner__list" },
	                      _vm._l(_vm.arrowSecondList, function(second, key) {
	                        return _c(
	                          "li",
	                          {
	                            key: key,
	                            staticClass: "el-time-spinner__item",
	                            class: { active: second === _vm.seconds }
	                          },
	                          [
	                            _vm._v(
	                              "\n          " +
	                                _vm._s(
	                                  second === undefined
	                                    ? ""
	                                    : ("0" + second).slice(-2)
	                                ) +
	                                "\n        "
	                            )
	                          ]
	                        )
	                      }),
	                      0
	                    )
	                  ]
	                )
	              : _vm._e()
	          ]
	        : _vm._e()
	    ],
	    2
	  )
	}
	var time_spinnervue_type_template_id_1facadeb_staticRenderFns = []
	time_spinnervue_type_template_id_1facadeb_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var time_spinnervue_type_script_lang_js_ = ({
	  components: { ElScrollbar: scrollbar_default.a },
	
	  directives: {
	    repeatClick: repeat_click
	  },
	
	  props: {
	    date: {},
	    defaultValue: {}, // reserved for future use
	    showSeconds: {
	      type: Boolean,
	      default: true
	    },
	    arrowControl: Boolean,
	    amPmMode: {
	      type: String,
	      default: '' // 'a': am/pm; 'A': AM/PM
	    }
	  },
	
	  computed: {
	    hours: function hours() {
	      return this.date.getHours();
	    },
	    minutes: function minutes() {
	      return this.date.getMinutes();
	    },
	    seconds: function seconds() {
	      return this.date.getSeconds();
	    },
	    hoursList: function hoursList() {
	      return Object(date_util_["getRangeHours"])(this.selectableRange);
	    },
	    minutesList: function minutesList() {
	      return Object(date_util_["getRangeMinutes"])(this.selectableRange, this.hours);
	    },
	    arrowHourList: function arrowHourList() {
	      var hours = this.hours;
	      return [hours > 0 ? hours - 1 : undefined, hours, hours < 23 ? hours + 1 : undefined];
	    },
	    arrowMinuteList: function arrowMinuteList() {
	      var minutes = this.minutes;
	      return [minutes > 0 ? minutes - 1 : undefined, minutes, minutes < 59 ? minutes + 1 : undefined];
	    },
	    arrowSecondList: function arrowSecondList() {
	      var seconds = this.seconds;
	      return [seconds > 0 ? seconds - 1 : undefined, seconds, seconds < 59 ? seconds + 1 : undefined];
	    }
	  },
	
	  data: function data() {
	    return {
	      selectableRange: [],
	      currentScrollbar: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      !_this.arrowControl && _this.bindScrollEvent();
	    });
	  },
	
	
	  methods: {
	    increase: function increase() {
	      this.scrollDown(1);
	    },
	    decrease: function decrease() {
	      this.scrollDown(-1);
	    },
	    modifyDateField: function modifyDateField(type, value) {
	      switch (type) {
	        case 'hours':
	          this.$emit('change', Object(date_util_["modifyTime"])(this.date, value, this.minutes, this.seconds));break;
	        case 'minutes':
	          this.$emit('change', Object(date_util_["modifyTime"])(this.date, this.hours, value, this.seconds));break;
	        case 'seconds':
	          this.$emit('change', Object(date_util_["modifyTime"])(this.date, this.hours, this.minutes, value));break;
	      }
	    },
	    handleClick: function handleClick(type, _ref) {
	      var value = _ref.value,
	          disabled = _ref.disabled;
	
	      if (!disabled) {
	        this.modifyDateField(type, value);
	        this.emitSelectRange(type);
	        this.adjustSpinner(type, value);
	      }
	    },
	    emitSelectRange: function emitSelectRange(type) {
	      if (type === 'hours') {
	        this.$emit('select-range', 0, 2);
	      } else if (type === 'minutes') {
	        this.$emit('select-range', 3, 5);
	      } else if (type === 'seconds') {
	        this.$emit('select-range', 6, 8);
	      }
	      this.currentScrollbar = type;
	    },
	    bindScrollEvent: function bindScrollEvent() {
	      var _this2 = this;
	
	      var bindFuntion = function bindFuntion(type) {
	        _this2.$refs[type].wrap.onscroll = function (e) {
	          // TODO: scroll is emitted when set scrollTop programatically
	          // should find better solutions in the future!
	          _this2.handleScroll(type, e);
	        };
	      };
	      bindFuntion('hours');
	      bindFuntion('minutes');
	      bindFuntion('seconds');
	    },
	    handleScroll: function handleScroll(type) {
	      var value = Math.min(Math.round((this.$refs[type].wrap.scrollTop - (this.scrollBarHeight(type) * 0.5 - 10) / this.typeItemHeight(type) + 3) / this.typeItemHeight(type)), type === 'hours' ? 23 : 59);
	      this.modifyDateField(type, value);
	    },
	
	
	    // NOTE: used by datetime / date-range panel
	    //       renamed from adjustScrollTop
	    //       should try to refactory it
	    adjustSpinners: function adjustSpinners() {
	      this.adjustSpinner('hours', this.hours);
	      this.adjustSpinner('minutes', this.minutes);
	      this.adjustSpinner('seconds', this.seconds);
	    },
	    adjustCurrentSpinner: function adjustCurrentSpinner(type) {
	      this.adjustSpinner(type, this[type]);
	    },
	    adjustSpinner: function adjustSpinner(type, value) {
	      if (this.arrowControl) return;
	      var el = this.$refs[type].wrap;
	      if (el) {
	        el.scrollTop = Math.max(0, value * this.typeItemHeight(type));
	      }
	    },
	    scrollDown: function scrollDown(step) {
	      var _this3 = this;
	
	      if (!this.currentScrollbar) {
	        this.emitSelectRange('hours');
	      }
	
	      var label = this.currentScrollbar;
	      var hoursList = this.hoursList;
	      var now = this[label];
	
	      if (this.currentScrollbar === 'hours') {
	        var total = Math.abs(step);
	        step = step > 0 ? 1 : -1;
	        var length = hoursList.length;
	        while (length-- && total) {
	          now = (now + step + hoursList.length) % hoursList.length;
	          if (hoursList[now]) {
	            continue;
	          }
	          total--;
	        }
	        if (hoursList[now]) return;
	      } else {
	        now = (now + step + 60) % 60;
	      }
	
	      this.modifyDateField(label, now);
	      this.adjustSpinner(label, now);
	      this.$nextTick(function () {
	        return _this3.emitSelectRange(_this3.currentScrollbar);
	      });
	    },
	    amPm: function amPm(hour) {
	      var shouldShowAmPm = this.amPmMode.toLowerCase() === 'a';
	      if (!shouldShowAmPm) return '';
	      var isCapital = this.amPmMode === 'A';
	      var content = hour < 12 ? ' am' : ' pm';
	      if (isCapital) content = content.toUpperCase();
	      return content;
	    },
	    typeItemHeight: function typeItemHeight(type) {
	      return this.$refs[type].$el.querySelector('li').offsetHeight;
	    },
	    scrollBarHeight: function scrollBarHeight(type) {
	      return this.$refs[type].$el.offsetHeight;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_time_spinnervue_type_script_lang_js_ = (time_spinnervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue
	
	
	
	
	
	/* normalize component */
	
	var time_spinner_component = normalizeComponent(
	  basic_time_spinnervue_type_script_lang_js_,
	  time_spinnervue_type_template_id_1facadeb_render,
	  time_spinnervue_type_template_id_1facadeb_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_spinner_api; }
	time_spinner_component.options.__file = "packages/date-picker/src/basic/time-spinner.vue"
	/* harmony default export */ var time_spinner = (time_spinner_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var timevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  components: {
	    TimeSpinner: time_spinner
	  },
	
	  props: {
	    visible: Boolean,
	    timeArrowControl: Boolean
	  },
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.oldValue = this.value;
	        this.$nextTick(function () {
	          return _this.$refs.spinner.emitSelectRange('hours');
	        });
	      } else {
	        this.needInitAdjust = true;
	      }
	    },
	    value: function value(newVal) {
	      var _this2 = this;
	
	      var date = void 0;
	      if (newVal instanceof Date) {
	        date = Object(date_util_["limitTimeRange"])(newVal, this.selectableRange, this.format);
	      } else if (!newVal) {
	        date = this.defaultValue ? new Date(this.defaultValue) : new Date();
	      }
	
	      this.date = date;
	      if (this.visible && this.needInitAdjust) {
	        this.$nextTick(function (_) {
	          return _this2.adjustSpinners();
	        });
	        this.needInitAdjust = false;
	      }
	    },
	    selectableRange: function selectableRange(val) {
	      this.$refs.spinner.selectableRange = val;
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Object(date_util_["isDate"])(this.value)) {
	        this.date = val ? new Date(val) : new Date();
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      format: 'HH:mm:ss',
	      value: '',
	      defaultValue: null,
	      date: new Date(),
	      oldValue: new Date(),
	      selectableRange: [],
	      selectionRange: [0, 2],
	      disabled: false,
	      arrowControl: false,
	      needInitAdjust: true
	    };
	  },
	
	
	  computed: {
	    showSeconds: function showSeconds() {
	      return (this.format || '').indexOf('ss') !== -1;
	    },
	    useArrow: function useArrow() {
	      return this.arrowControl || this.timeArrowControl || false;
	    },
	    amPmMode: function amPmMode() {
	      if ((this.format || '').indexOf('A') !== -1) return 'A';
	      if ((this.format || '').indexOf('a') !== -1) return 'a';
	      return '';
	    }
	  },
	
	  methods: {
	    handleCancel: function handleCancel() {
	      this.$emit('pick', this.oldValue, false);
	    },
	    handleChange: function handleChange(date) {
	      // this.visible avoids edge cases, when use scrolls during panel closing animation
	      if (this.visible) {
	        this.date = Object(date_util_["clearMilliseconds"])(date);
	        // if date is out of range, do not emit
	        if (this.isValidValue(this.date)) {
	          this.$emit('pick', this.date, true);
	        }
	      }
	    },
	    setSelectionRange: function setSelectionRange(start, end) {
	      this.$emit('select-range', start, end);
	      this.selectionRange = [start, end];
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var first = arguments[1];
	
	      if (first) return;
	      var date = Object(date_util_["clearMilliseconds"])(Object(date_util_["limitTimeRange"])(this.date, this.selectableRange, this.format));
	      this.$emit('pick', date, visible, first);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      var mapping = { 38: -1, 40: 1, 37: -1, 39: 1 };
	
	      // Left or Right
	      if (keyCode === 37 || keyCode === 39) {
	        var step = mapping[keyCode];
	        this.changeSelectionRange(step);
	        event.preventDefault();
	        return;
	      }
	
	      // Up or Down
	      if (keyCode === 38 || keyCode === 40) {
	        var _step = mapping[keyCode];
	        this.$refs.spinner.scrollDown(_step);
	        event.preventDefault();
	        return;
	      }
	    },
	    isValidValue: function isValidValue(date) {
	      return Object(date_util_["timeWithinRange"])(date, this.selectableRange, this.format);
	    },
	    adjustSpinners: function adjustSpinners() {
	      return this.$refs.spinner.adjustSpinners();
	    },
	    changeSelectionRange: function changeSelectionRange(step) {
	      var list = [0, 3].concat(this.showSeconds ? [6] : []);
	      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
	      var index = list.indexOf(this.selectionRange[0]);
	      var next = (index + step + list.length) % list.length;
	      this.$refs.spinner.emitSelectRange(mapping[next]);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.$nextTick(function () {
	      return _this3.handleConfirm(true, true);
	    });
	    this.$emit('mounted');
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_timevue_type_script_lang_js_ = (timevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue
	
	
	
	
	
	/* normalize component */
	
	var time_component = normalizeComponent(
	  panel_timevue_type_script_lang_js_,
	  timevue_type_template_id_3d939089_render,
	  timevue_type_template_id_3d939089_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_api; }
	time_component.options.__file = "packages/date-picker/src/panel/time.vue"
	/* harmony default export */ var panel_time = (time_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&
	var year_tablevue_type_template_id_c86ab5e0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "table",
	    { staticClass: "el-year-table", on: { click: _vm.handleYearTableClick } },
	    [
	      _c("tbody", [
	        _c("tr", [
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 0)
	            },
	            [_c("a", { staticClass: "cell" }, [_vm._v(_vm._s(_vm.startYear))])]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 1)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 1))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 2)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 2))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 3)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 3))
	              ])
	            ]
	          )
	        ]),
	        _c("tr", [
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 4)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 4))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 5)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 5))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 6)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 6))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 7)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 7))
	              ])
	            ]
	          )
	        ]),
	        _c("tr", [
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 8)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 8))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 9)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 9))
	              ])
	            ]
	          ),
	          _c("td"),
	          _c("td")
	        ])
	      ])
	    ]
	  )
	}
	var year_tablevue_type_template_id_c86ab5e0_staticRenderFns = []
	year_tablevue_type_template_id_c86ab5e0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	var year_tablevue_type_script_lang_js_datesInYear = function datesInYear(year) {
	  var numOfDays = Object(date_util_["getDayCountOfYear"])(year);
	  var firstDay = new Date(year, 0, 1);
	  return Object(date_util_["range"])(numOfDays).map(function (n) {
	    return Object(date_util_["nextDate"])(firstDay, n);
	  });
	};
	
	/* harmony default export */ var year_tablevue_type_script_lang_js_ = ({
	  props: {
	    disabledDate: {},
	    value: {},
	    defaultValue: {
	      validator: function validator(val) {
	        // null or valid Date Object
	        return val === null || val instanceof Date && Object(date_util_["isDate"])(val);
	      }
	    },
	    date: {}
	  },
	
	  computed: {
	    startYear: function startYear() {
	      return Math.floor(this.date.getFullYear() / 10) * 10;
	    }
	  },
	
	  methods: {
	    getCellStyle: function getCellStyle(year) {
	      var style = {};
	      var today = new Date();
	
	      style.disabled = typeof this.disabledDate === 'function' ? year_tablevue_type_script_lang_js_datesInYear(year).every(this.disabledDate) : false;
	      style.current = Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value), function (date) {
	        return date.getFullYear() === year;
	      }) >= 0;
	      style.today = today.getFullYear() === year;
	      style.default = this.defaultValue && this.defaultValue.getFullYear() === year;
	
	      return style;
	    },
	    handleYearTableClick: function handleYearTableClick(event) {
	      var target = event.target;
	      if (target.tagName === 'A') {
	        if (Object(dom_["hasClass"])(target.parentNode, 'disabled')) return;
	        var year = target.textContent || target.innerText;
	        this.$emit('pick', Number(year));
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_year_tablevue_type_script_lang_js_ = (year_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue
	
	
	
	
	
	/* normalize component */
	
	var year_table_component = normalizeComponent(
	  basic_year_tablevue_type_script_lang_js_,
	  year_tablevue_type_template_id_c86ab5e0_render,
	  year_tablevue_type_template_id_c86ab5e0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var year_table_api; }
	year_table_component.options.__file = "packages/date-picker/src/basic/year-table.vue"
	/* harmony default export */ var year_table = (year_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&
	var month_tablevue_type_template_id_654d4f42_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "table",
	    {
	      staticClass: "el-month-table",
	      on: { click: _vm.handleMonthTableClick, mousemove: _vm.handleMouseMove }
	    },
	    [
	      _c(
	        "tbody",
	        _vm._l(_vm.rows, function(row, key) {
	          return _c(
	            "tr",
	            { key: key },
	            _vm._l(row, function(cell, key) {
	              return _c("td", { key: key, class: _vm.getCellStyle(cell) }, [
	                _c("div", [
	                  _c("a", { staticClass: "cell" }, [
	                    _vm._v(
	                      _vm._s(
	                        _vm.t("el.datepicker.months." + _vm.months[cell.text])
	                      )
	                    )
	                  ])
	                ])
	              ])
	            }),
	            0
	          )
	        }),
	        0
	      )
	    ]
	  )
	}
	var month_tablevue_type_template_id_654d4f42_staticRenderFns = []
	month_tablevue_type_template_id_654d4f42_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	var month_tablevue_type_script_lang_js_datesInMonth = function datesInMonth(year, month) {
	  var numOfDays = Object(date_util_["getDayCountOfMonth"])(year, month);
	  var firstDay = new Date(year, month, 1);
	  return Object(date_util_["range"])(numOfDays).map(function (n) {
	    return Object(date_util_["nextDate"])(firstDay, n);
	  });
	};
	
	var clearDate = function clearDate(date) {
	  return new Date(date.getFullYear(), date.getMonth());
	};
	
	var getMonthTimestamp = function getMonthTimestamp(time) {
	  if (typeof time === 'number' || typeof time === 'string') {
	    return clearDate(new Date(time)).getTime();
	  } else if (time instanceof Date) {
	    return clearDate(time).getTime();
	  } else {
	    return NaN;
	  }
	};
	/* harmony default export */ var month_tablevue_type_script_lang_js_ = ({
	  props: {
	    disabledDate: {},
	    value: {},
	    selectionMode: {
	      default: 'month'
	    },
	    minDate: {},
	
	    maxDate: {},
	    defaultValue: {
	      validator: function validator(val) {
	        // null or valid Date Object
	        return val === null || Object(date_util_["isDate"])(val) || Array.isArray(val) && val.every(date_util_["isDate"]);
	      }
	    },
	    date: {},
	    rangeState: {
	      default: function _default() {
	        return {
	          endDate: null,
	          selecting: false
	        };
	      }
	    }
	  },
	
	  mixins: [locale_default.a],
	
	  watch: {
	    'rangeState.endDate': function rangeStateEndDate(newVal) {
	      this.markRange(this.minDate, newVal);
	    },
	    minDate: function minDate(newVal, oldVal) {
	      if (getMonthTimestamp(newVal) !== getMonthTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    },
	    maxDate: function maxDate(newVal, oldVal) {
	      if (getMonthTimestamp(newVal) !== getMonthTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      months: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
	      tableRows: [[], [], []],
	      lastRow: null,
	      lastColumn: null
	    };
	  },
	
	
	  methods: {
	    cellMatchesDate: function cellMatchesDate(cell, date) {
	      var value = new Date(date);
	      return this.date.getFullYear() === value.getFullYear() && Number(cell.text) === value.getMonth();
	    },
	    getCellStyle: function getCellStyle(cell) {
	      var _this = this;
	
	      var style = {};
	      var year = this.date.getFullYear();
	      var today = new Date();
	      var month = cell.text;
	      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];
	      style.disabled = typeof this.disabledDate === 'function' ? month_tablevue_type_script_lang_js_datesInMonth(year, month).every(this.disabledDate) : false;
	      style.current = Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value), function (date) {
	        return date.getFullYear() === year && date.getMonth() === month;
	      }) >= 0;
	      style.today = today.getFullYear() === year && today.getMonth() === month;
	      style.default = defaultValue.some(function (date) {
	        return _this.cellMatchesDate(cell, date);
	      });
	
	      if (cell.inRange) {
	        style['in-range'] = true;
	
	        if (cell.start) {
	          style['start-date'] = true;
	        }
	
	        if (cell.end) {
	          style['end-date'] = true;
	        }
	      }
	      return style;
	    },
	    getMonthOfCell: function getMonthOfCell(month) {
	      var year = this.date.getFullYear();
	      return new Date(year, month, 1);
	    },
	    markRange: function markRange(minDate, maxDate) {
	      minDate = getMonthTimestamp(minDate);
	      maxDate = getMonthTimestamp(maxDate) || minDate;
	      var _ref = [Math.min(minDate, maxDate), Math.max(minDate, maxDate)];
	      minDate = _ref[0];
	      maxDate = _ref[1];
	
	      var rows = this.rows;
	      for (var i = 0, k = rows.length; i < k; i++) {
	        var row = rows[i];
	        for (var j = 0, l = row.length; j < l; j++) {
	
	          var cell = row[j];
	          var index = i * 4 + j;
	          var time = new Date(this.date.getFullYear(), index).getTime();
	
	          cell.inRange = minDate && time >= minDate && time <= maxDate;
	          cell.start = minDate && time === minDate;
	          cell.end = maxDate && time === maxDate;
	        }
	      }
	    },
	    handleMouseMove: function handleMouseMove(event) {
	      if (!this.rangeState.selecting) return;
	
	      var target = event.target;
	      if (target.tagName === 'A') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	      if (target.tagName !== 'TD') return;
	
	      var row = target.parentNode.rowIndex;
	      var column = target.cellIndex;
	      // can not select disabled date
	      if (this.rows[row][column].disabled) return;
	
	      // only update rangeState when mouse moves to a new cell
	      // this avoids frequent Date object creation and improves performance
	      if (row !== this.lastRow || column !== this.lastColumn) {
	        this.lastRow = row;
	        this.lastColumn = column;
	        this.$emit('changerange', {
	          minDate: this.minDate,
	          maxDate: this.maxDate,
	          rangeState: {
	            selecting: true,
	            endDate: this.getMonthOfCell(row * 4 + column)
	          }
	        });
	      }
	    },
	    handleMonthTableClick: function handleMonthTableClick(event) {
	      var target = event.target;
	      if (target.tagName === 'A') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	      if (target.tagName !== 'TD') return;
	      if (Object(dom_["hasClass"])(target, 'disabled')) return;
	      var column = target.cellIndex;
	      var row = target.parentNode.rowIndex;
	      var month = row * 4 + column;
	      var newDate = this.getMonthOfCell(month);
	      if (this.selectionMode === 'range') {
	        if (!this.rangeState.selecting) {
	          this.$emit('pick', { minDate: newDate, maxDate: null });
	          this.rangeState.selecting = true;
	        } else {
	          if (newDate >= this.minDate) {
	            this.$emit('pick', { minDate: this.minDate, maxDate: newDate });
	          } else {
	            this.$emit('pick', { minDate: newDate, maxDate: this.minDate });
	          }
	          this.rangeState.selecting = false;
	        }
	      } else {
	        this.$emit('pick', month);
	      }
	    }
	  },
	
	  computed: {
	    rows: function rows() {
	      var _this2 = this;
	
	      // TODO: refactory rows / getCellClasses
	      var rows = this.tableRows;
	      var disabledDate = this.disabledDate;
	      var selectedDate = [];
	      var now = getMonthTimestamp(new Date());
	
	      for (var i = 0; i < 3; i++) {
	        var row = rows[i];
	
	        var _loop = function _loop(j) {
	          var cell = row[j];
	          if (!cell) {
	            cell = { row: i, column: j, type: 'normal', inRange: false, start: false, end: false };
	          }
	
	          cell.type = 'normal';
	
	          var index = i * 4 + j;
	          var time = new Date(_this2.date.getFullYear(), index).getTime();
	          cell.inRange = time >= getMonthTimestamp(_this2.minDate) && time <= getMonthTimestamp(_this2.maxDate);
	          cell.start = _this2.minDate && time === getMonthTimestamp(_this2.minDate);
	          cell.end = _this2.maxDate && time === getMonthTimestamp(_this2.maxDate);
	          var isToday = time === now;
	
	          if (isToday) {
	            cell.type = 'today';
	          }
	          cell.text = index;
	          var cellDate = new Date(time);
	          cell.disabled = typeof disabledDate === 'function' && disabledDate(cellDate);
	          cell.selected = Object(util_["arrayFind"])(selectedDate, function (date) {
	            return date.getTime() === cellDate.getTime();
	          });
	
	          _this2.$set(row, j, cell);
	        };
	
	        for (var j = 0; j < 4; j++) {
	          _loop(j);
	        }
	      }
	      return rows;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_month_tablevue_type_script_lang_js_ = (month_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue
	
	
	
	
	
	/* normalize component */
	
	var month_table_component = normalizeComponent(
	  basic_month_tablevue_type_script_lang_js_,
	  month_tablevue_type_template_id_654d4f42_render,
	  month_tablevue_type_template_id_654d4f42_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var month_table_api; }
	month_table_component.options.__file = "packages/date-picker/src/basic/month-table.vue"
	/* harmony default export */ var month_table = (month_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&
	var date_tablevue_type_template_id_5d1f3341_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "table",
	    {
	      staticClass: "el-date-table",
	      class: { "is-week-mode": _vm.selectionMode === "week" },
	      attrs: { cellspacing: "0", cellpadding: "0" },
	      on: { click: _vm.handleClick, mousemove: _vm.handleMouseMove }
	    },
	    [
	      _c(
	        "tbody",
	        [
	          _c(
	            "tr",
	            [
	              _vm.showWeekNumber
	                ? _c("th", [_vm._v(_vm._s(_vm.t("el.datepicker.week")))])
	                : _vm._e(),
	              _vm._l(_vm.WEEKS, function(week, key) {
	                return _c("th", { key: key }, [
	                  _vm._v(_vm._s(_vm.t("el.datepicker.weeks." + week)))
	                ])
	              })
	            ],
	            2
	          ),
	          _vm._l(_vm.rows, function(row, key) {
	            return _c(
	              "tr",
	              {
	                key: key,
	                staticClass: "el-date-table__row",
	                class: { current: _vm.isWeekActive(row[1]) }
	              },
	              _vm._l(row, function(cell, key) {
	                return _c("td", { key: key, class: _vm.getCellClasses(cell) }, [
	                  _c("div", [
	                    _c("span", [
	                      _vm._v("\n          " + _vm._s(cell.text) + "\n        ")
	                    ])
	                  ])
	                ])
	              }),
	              0
	            )
	          })
	        ],
	        2
	      )
	    ]
	  )
	}
	var date_tablevue_type_template_id_5d1f3341_staticRenderFns = []
	date_tablevue_type_template_id_5d1f3341_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	var _WEEKS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
	var date_tablevue_type_script_lang_js_getDateTimestamp = function getDateTimestamp(time) {
	  if (typeof time === 'number' || typeof time === 'string') {
	    return Object(date_util_["clearTime"])(new Date(time)).getTime();
	  } else if (time instanceof Date) {
	    return Object(date_util_["clearTime"])(time).getTime();
	  } else {
	    return NaN;
	  }
	};
	
	// remove the first element that satisfies `pred` from arr
	// return a new array if modification occurs
	// return the original array otherwise
	var date_tablevue_type_script_lang_js_removeFromArray = function removeFromArray(arr, pred) {
	  var idx = typeof pred === 'function' ? Object(util_["arrayFindIndex"])(arr, pred) : arr.indexOf(pred);
	  return idx >= 0 ? [].concat(arr.slice(0, idx), arr.slice(idx + 1)) : arr;
	};
	
	/* harmony default export */ var date_tablevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  props: {
	    firstDayOfWeek: {
	      default: 7,
	      type: Number,
	      validator: function validator(val) {
	        return val >= 1 && val <= 7;
	      }
	    },
	
	    value: {},
	
	    defaultValue: {
	      validator: function validator(val) {
	        // either: null, valid Date object, Array of valid Date objects
	        return val === null || Object(date_util_["isDate"])(val) || Array.isArray(val) && val.every(date_util_["isDate"]);
	      }
	    },
	
	    date: {},
	
	    selectionMode: {
	      default: 'day'
	    },
	
	    showWeekNumber: {
	      type: Boolean,
	      default: false
	    },
	
	    disabledDate: {},
	
	    cellClassName: {},
	
	    minDate: {},
	
	    maxDate: {},
	
	    rangeState: {
	      default: function _default() {
	        return {
	          endDate: null,
	          selecting: false
	        };
	      }
	    }
	  },
	
	  computed: {
	    offsetDay: function offsetDay() {
	      var week = this.firstDayOfWeek;
	      // 周日为界限，左右偏移的天数，3217654 例如周一就是 -1，目的是调整前两行日期的位置
	      return week > 3 ? 7 - week : -week;
	    },
	    WEEKS: function WEEKS() {
	      var week = this.firstDayOfWeek;
	      return _WEEKS.concat(_WEEKS).slice(week, week + 7);
	    },
	    year: function year() {
	      return this.date.getFullYear();
	    },
	    month: function month() {
	      return this.date.getMonth();
	    },
	    startDate: function startDate() {
	      return Object(date_util_["getStartDateOfMonth"])(this.year, this.month);
	    },
	    rows: function rows() {
	      var _this = this;
	
	      // TODO: refactory rows / getCellClasses
	      var date = new Date(this.year, this.month, 1);
	      var day = Object(date_util_["getFirstDayOfMonth"])(date); // day of first day
	      var dateCountOfMonth = Object(date_util_["getDayCountOfMonth"])(date.getFullYear(), date.getMonth());
	      var dateCountOfLastMonth = Object(date_util_["getDayCountOfMonth"])(date.getFullYear(), date.getMonth() === 0 ? 11 : date.getMonth() - 1);
	
	      day = day === 0 ? 7 : day;
	
	      var offset = this.offsetDay;
	      var rows = this.tableRows;
	      var count = 1;
	
	      var startDate = this.startDate;
	      var disabledDate = this.disabledDate;
	      var cellClassName = this.cellClassName;
	      var selectedDate = this.selectionMode === 'dates' ? Object(util_["coerceTruthyValueToArray"])(this.value) : [];
	      var now = date_tablevue_type_script_lang_js_getDateTimestamp(new Date());
	
	      for (var i = 0; i < 6; i++) {
	        var row = rows[i];
	
	        if (this.showWeekNumber) {
	          if (!row[0]) {
	            row[0] = { type: 'week', text: Object(date_util_["getWeekNumber"])(Object(date_util_["nextDate"])(startDate, i * 7 + 1)) };
	          }
	        }
	
	        var _loop = function _loop(j) {
	          var cell = row[_this.showWeekNumber ? j + 1 : j];
	          if (!cell) {
	            cell = { row: i, column: j, type: 'normal', inRange: false, start: false, end: false };
	          }
	
	          cell.type = 'normal';
	
	          var index = i * 7 + j;
	          var time = Object(date_util_["nextDate"])(startDate, index - offset).getTime();
	          cell.inRange = time >= date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate) && time <= date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);
	          cell.start = _this.minDate && time === date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate);
	          cell.end = _this.maxDate && time === date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);
	          var isToday = time === now;
	
	          if (isToday) {
	            cell.type = 'today';
	          }
	
	          if (i >= 0 && i <= 1) {
	            var numberOfDaysFromPreviousMonth = day + offset < 0 ? 7 + day + offset : day + offset;
	
	            if (j + i * 7 >= numberOfDaysFromPreviousMonth) {
	              cell.text = count++;
	            } else {
	              cell.text = dateCountOfLastMonth - (numberOfDaysFromPreviousMonth - j % 7) + 1 + i * 7;
	              cell.type = 'prev-month';
	            }
	          } else {
	            if (count <= dateCountOfMonth) {
	              cell.text = count++;
	            } else {
	              cell.text = count++ - dateCountOfMonth;
	              cell.type = 'next-month';
	            }
	          }
	
	          var cellDate = new Date(time);
	          cell.disabled = typeof disabledDate === 'function' && disabledDate(cellDate);
	          cell.selected = Object(util_["arrayFind"])(selectedDate, function (date) {
	            return date.getTime() === cellDate.getTime();
	          });
	          cell.customClass = typeof cellClassName === 'function' && cellClassName(cellDate);
	          _this.$set(row, _this.showWeekNumber ? j + 1 : j, cell);
	        };
	
	        for (var j = 0; j < 7; j++) {
	          _loop(j);
	        }
	
	        if (this.selectionMode === 'week') {
	          var start = this.showWeekNumber ? 1 : 0;
	          var end = this.showWeekNumber ? 7 : 6;
	          var isWeekActive = this.isWeekActive(row[start + 1]);
	
	          row[start].inRange = isWeekActive;
	          row[start].start = isWeekActive;
	          row[end].inRange = isWeekActive;
	          row[end].end = isWeekActive;
	        }
	      }
	
	      return rows;
	    }
	  },
	
	  watch: {
	    'rangeState.endDate': function rangeStateEndDate(newVal) {
	      this.markRange(this.minDate, newVal);
	    },
	    minDate: function minDate(newVal, oldVal) {
	      if (date_tablevue_type_script_lang_js_getDateTimestamp(newVal) !== date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    },
	    maxDate: function maxDate(newVal, oldVal) {
	      if (date_tablevue_type_script_lang_js_getDateTimestamp(newVal) !== date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      tableRows: [[], [], [], [], [], []],
	      lastRow: null,
	      lastColumn: null
	    };
	  },
	
	
	  methods: {
	    cellMatchesDate: function cellMatchesDate(cell, date) {
	      var value = new Date(date);
	      return this.year === value.getFullYear() && this.month === value.getMonth() && Number(cell.text) === value.getDate();
	    },
	    getCellClasses: function getCellClasses(cell) {
	      var _this2 = this;
	
	      var selectionMode = this.selectionMode;
	      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];
	
	      var classes = [];
	      if ((cell.type === 'normal' || cell.type === 'today') && !cell.disabled) {
	        classes.push('available');
	        if (cell.type === 'today') {
	          classes.push('today');
	        }
	      } else {
	        classes.push(cell.type);
	      }
	
	      if (cell.type === 'normal' && defaultValue.some(function (date) {
	        return _this2.cellMatchesDate(cell, date);
	      })) {
	        classes.push('default');
	      }
	
	      if (selectionMode === 'day' && (cell.type === 'normal' || cell.type === 'today') && this.cellMatchesDate(cell, this.value)) {
	        classes.push('current');
	      }
	
	      if (cell.inRange && (cell.type === 'normal' || cell.type === 'today' || this.selectionMode === 'week')) {
	        classes.push('in-range');
	
	        if (cell.start) {
	          classes.push('start-date');
	        }
	
	        if (cell.end) {
	          classes.push('end-date');
	        }
	      }
	
	      if (cell.disabled) {
	        classes.push('disabled');
	      }
	
	      if (cell.selected) {
	        classes.push('selected');
	      }
	
	      if (cell.customClass) {
	        classes.push(cell.customClass);
	      }
	
	      return classes.join(' ');
	    },
	    getDateOfCell: function getDateOfCell(row, column) {
	      var offsetFromStart = row * 7 + (column - (this.showWeekNumber ? 1 : 0)) - this.offsetDay;
	      return Object(date_util_["nextDate"])(this.startDate, offsetFromStart);
	    },
	    isWeekActive: function isWeekActive(cell) {
	      if (this.selectionMode !== 'week') return false;
	      var newDate = new Date(this.year, this.month, 1);
	      var year = newDate.getFullYear();
	      var month = newDate.getMonth();
	
	      if (cell.type === 'prev-month') {
	        newDate.setMonth(month === 0 ? 11 : month - 1);
	        newDate.setFullYear(month === 0 ? year - 1 : year);
	      }
	
	      if (cell.type === 'next-month') {
	        newDate.setMonth(month === 11 ? 0 : month + 1);
	        newDate.setFullYear(month === 11 ? year + 1 : year);
	      }
	
	      newDate.setDate(parseInt(cell.text, 10));
	
	      if (Object(date_util_["isDate"])(this.value)) {
	        var dayOffset = (this.value.getDay() - this.firstDayOfWeek + 7) % 7 - 1;
	        var weekDate = Object(date_util_["prevDate"])(this.value, dayOffset);
	        return weekDate.getTime() === newDate.getTime();
	      }
	      return false;
	    },
	    markRange: function markRange(minDate, maxDate) {
	      minDate = date_tablevue_type_script_lang_js_getDateTimestamp(minDate);
	      maxDate = date_tablevue_type_script_lang_js_getDateTimestamp(maxDate) || minDate;
	      var _ref = [Math.min(minDate, maxDate), Math.max(minDate, maxDate)];
	      minDate = _ref[0];
	      maxDate = _ref[1];
	
	
	      var startDate = this.startDate;
	      var rows = this.rows;
	      for (var i = 0, k = rows.length; i < k; i++) {
	        var row = rows[i];
	        for (var j = 0, l = row.length; j < l; j++) {
	          if (this.showWeekNumber && j === 0) continue;
	
	          var _cell = row[j];
	          var index = i * 7 + j + (this.showWeekNumber ? -1 : 0);
	          var time = Object(date_util_["nextDate"])(startDate, index - this.offsetDay).getTime();
	
	          _cell.inRange = minDate && time >= minDate && time <= maxDate;
	          _cell.start = minDate && time === minDate;
	          _cell.end = maxDate && time === maxDate;
	        }
	      }
	    },
	    handleMouseMove: function handleMouseMove(event) {
	      if (!this.rangeState.selecting) return;
	
	      var target = event.target;
	      if (target.tagName === 'SPAN') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	      if (target.tagName !== 'TD') return;
	
	      var row = target.parentNode.rowIndex - 1;
	      var column = target.cellIndex;
	
	      // can not select disabled date
	      if (this.rows[row][column].disabled) return;
	
	      // only update rangeState when mouse moves to a new cell
	      // this avoids frequent Date object creation and improves performance
	      if (row !== this.lastRow || column !== this.lastColumn) {
	        this.lastRow = row;
	        this.lastColumn = column;
	        this.$emit('changerange', {
	          minDate: this.minDate,
	          maxDate: this.maxDate,
	          rangeState: {
	            selecting: true,
	            endDate: this.getDateOfCell(row, column)
	          }
	        });
	      }
	    },
	    handleClick: function handleClick(event) {
	      var target = event.target;
	      if (target.tagName === 'SPAN') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	
	      if (target.tagName !== 'TD') return;
	
	      var row = target.parentNode.rowIndex - 1;
	      var column = this.selectionMode === 'week' ? 1 : target.cellIndex;
	      var cell = this.rows[row][column];
	
	      if (cell.disabled || cell.type === 'week') return;
	
	      var newDate = this.getDateOfCell(row, column);
	
	      if (this.selectionMode === 'range') {
	        if (!this.rangeState.selecting) {
	          this.$emit('pick', { minDate: newDate, maxDate: null });
	          this.rangeState.selecting = true;
	        } else {
	          if (newDate >= this.minDate) {
	            this.$emit('pick', { minDate: this.minDate, maxDate: newDate });
	          } else {
	            this.$emit('pick', { minDate: newDate, maxDate: this.minDate });
	          }
	          this.rangeState.selecting = false;
	        }
	      } else if (this.selectionMode === 'day') {
	        this.$emit('pick', newDate);
	      } else if (this.selectionMode === 'week') {
	        var weekNumber = Object(date_util_["getWeekNumber"])(newDate);
	        var value = newDate.getFullYear() + 'w' + weekNumber;
	        this.$emit('pick', {
	          year: newDate.getFullYear(),
	          week: weekNumber,
	          value: value,
	          date: newDate
	        });
	      } else if (this.selectionMode === 'dates') {
	        var _value = this.value || [];
	        var newValue = cell.selected ? date_tablevue_type_script_lang_js_removeFromArray(_value, function (date) {
	          return date.getTime() === newDate.getTime();
	        }) : [].concat(_value, [newDate]);
	        this.$emit('pick', newValue);
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_date_tablevue_type_script_lang_js_ = (date_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue
	
	
	
	
	
	/* normalize component */
	
	var date_table_component = normalizeComponent(
	  basic_date_tablevue_type_script_lang_js_,
	  date_tablevue_type_template_id_5d1f3341_render,
	  date_tablevue_type_template_id_5d1f3341_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var date_table_api; }
	date_table_component.options.__file = "packages/date-picker/src/basic/date-table.vue"
	/* harmony default export */ var date_table = (date_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var datevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  watch: {
	    showTime: function showTime(val) {
	      var _this = this;
	
	      /* istanbul ignore if */
	      if (!val) return;
	      this.$nextTick(function (_) {
	        var inputElm = _this.$refs.input.$el;
	        if (inputElm) {
	          _this.pickerWidth = inputElm.getBoundingClientRect().width + 10;
	        }
	      });
	    },
	    value: function value(val) {
	      if (this.selectionMode === 'dates' && this.value) return;
	      if (Object(date_util_["isDate"])(val)) {
	        this.date = new Date(val);
	      } else {
	        this.date = this.getDefaultValue();
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Object(date_util_["isDate"])(this.value)) {
	        this.date = val ? new Date(val) : new Date();
	      }
	    },
	    timePickerVisible: function timePickerVisible(val) {
	      var _this2 = this;
	
	      if (val) this.$nextTick(function () {
	        return _this2.$refs.timepicker.adjustSpinners();
	      });
	    },
	    selectionMode: function selectionMode(newVal) {
	      if (newVal === 'month') {
	        /* istanbul ignore next */
	        if (this.currentView !== 'year' || this.currentView !== 'month') {
	          this.currentView = 'month';
	        }
	      } else if (newVal === 'dates') {
	        this.currentView = 'date';
	      }
	    }
	  },
	
	  methods: {
	    proxyTimePickerDataProperties: function proxyTimePickerDataProperties() {
	      var _this3 = this;
	
	      var format = function format(timeFormat) {
	        _this3.$refs.timepicker.format = timeFormat;
	      };
	      var value = function value(_value) {
	        _this3.$refs.timepicker.value = _value;
	      };
	      var date = function date(_date) {
	        _this3.$refs.timepicker.date = _date;
	      };
	      var selectableRange = function selectableRange(_selectableRange) {
	        _this3.$refs.timepicker.selectableRange = _selectableRange;
	      };
	
	      this.$watch('value', value);
	      this.$watch('date', date);
	      this.$watch('selectableRange', selectableRange);
	
	      format(this.timeFormat);
	      value(this.value);
	      date(this.date);
	      selectableRange(this.selectableRange);
	    },
	    handleClear: function handleClear() {
	      this.date = this.getDefaultValue();
	      this.$emit('pick', null);
	    },
	    emit: function emit(value) {
	      var _this4 = this;
	
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      if (!value) {
	        this.$emit.apply(this, ['pick', value].concat(args));
	      } else if (Array.isArray(value)) {
	        var dates = value.map(function (date) {
	          return _this4.showTime ? Object(date_util_["clearMilliseconds"])(date) : Object(date_util_["clearTime"])(date);
	        });
	        this.$emit.apply(this, ['pick', dates].concat(args));
	      } else {
	        this.$emit.apply(this, ['pick', this.showTime ? Object(date_util_["clearMilliseconds"])(value) : Object(date_util_["clearTime"])(value)].concat(args));
	      }
	      this.userInputDate = null;
	      this.userInputTime = null;
	    },
	
	
	    // resetDate() {
	    //   this.date = new Date(this.date);
	    // },
	
	    showMonthPicker: function showMonthPicker() {
	      this.currentView = 'month';
	    },
	    showYearPicker: function showYearPicker() {
	      this.currentView = 'year';
	    },
	
	
	    // XXX: 没用到
	    // handleLabelClick() {
	    //   if (this.currentView === 'date') {
	    //     this.showMonthPicker();
	    //   } else if (this.currentView === 'month') {
	    //     this.showYearPicker();
	    //   }
	    // },
	
	    prevMonth: function prevMonth() {
	      this.date = Object(date_util_["prevMonth"])(this.date);
	    },
	    nextMonth: function nextMonth() {
	      this.date = Object(date_util_["nextMonth"])(this.date);
	    },
	    prevYear: function prevYear() {
	      if (this.currentView === 'year') {
	        this.date = Object(date_util_["prevYear"])(this.date, 10);
	      } else {
	        this.date = Object(date_util_["prevYear"])(this.date);
	      }
	    },
	    nextYear: function nextYear() {
	      if (this.currentView === 'year') {
	        this.date = Object(date_util_["nextYear"])(this.date, 10);
	      } else {
	        this.date = Object(date_util_["nextYear"])(this.date);
	      }
	    },
	    handleShortcutClick: function handleShortcutClick(shortcut) {
	      if (shortcut.onClick) {
	        shortcut.onClick(this);
	      }
	    },
	    handleTimePick: function handleTimePick(value, visible, first) {
	      if (Object(date_util_["isDate"])(value)) {
	        var newDate = this.value ? Object(date_util_["modifyTime"])(this.value, value.getHours(), value.getMinutes(), value.getSeconds()) : Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(), this.defaultTime);
	        this.date = newDate;
	        this.emit(this.date, true);
	      } else {
	        this.emit(value, true);
	      }
	      if (!first) {
	        this.timePickerVisible = visible;
	      }
	    },
	    handleTimePickClose: function handleTimePickClose() {
	      this.timePickerVisible = false;
	    },
	    handleMonthPick: function handleMonthPick(month) {
	      if (this.selectionMode === 'month') {
	        this.date = Object(date_util_["modifyDate"])(this.date, this.year, month, 1);
	        this.emit(this.date);
	      } else {
	        this.date = Object(date_util_["changeYearMonthAndClampDate"])(this.date, this.year, month);
	        // TODO: should emit intermediate value ??
	        // this.emit(this.date);
	        this.currentView = 'date';
	      }
	    },
	    handleDatePick: function handleDatePick(value) {
	      if (this.selectionMode === 'day') {
	        var newDate = this.value ? Object(date_util_["modifyDate"])(this.value, value.getFullYear(), value.getMonth(), value.getDate()) : Object(date_util_["modifyWithTimeString"])(value, this.defaultTime);
	        // change default time while out of selectableRange
	        if (!this.checkDateWithinRange(newDate)) {
	          newDate = Object(date_util_["modifyDate"])(this.selectableRange[0][0], value.getFullYear(), value.getMonth(), value.getDate());
	        }
	        this.date = newDate;
	        this.emit(this.date, this.showTime);
	      } else if (this.selectionMode === 'week') {
	        this.emit(value.date);
	      } else if (this.selectionMode === 'dates') {
	        this.emit(value, true); // set false to keep panel open
	      }
	    },
	    handleYearPick: function handleYearPick(year) {
	      if (this.selectionMode === 'year') {
	        this.date = Object(date_util_["modifyDate"])(this.date, year, 0, 1);
	        this.emit(this.date);
	      } else {
	        this.date = Object(date_util_["changeYearMonthAndClampDate"])(this.date, year, this.month);
	        // TODO: should emit intermediate value ??
	        // this.emit(this.date, true);
	        this.currentView = 'month';
	      }
	    },
	    changeToNow: function changeToNow() {
	      // NOTE: not a permanent solution
	      //       consider disable "now" button in the future
	      if ((!this.disabledDate || !this.disabledDate(new Date())) && this.checkDateWithinRange(new Date())) {
	        this.date = new Date();
	        this.emit(this.date);
	      }
	    },
	    confirm: function confirm() {
	      if (this.selectionMode === 'dates') {
	        this.emit(this.value);
	      } else {
	        // value were emitted in handle{Date,Time}Pick, nothing to update here
	        // deal with the scenario where: user opens the picker, then confirm without doing anything
	        var value = this.value ? this.value : Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(), this.defaultTime);
	        this.date = new Date(value); // refresh date
	        this.emit(value);
	      }
	    },
	    resetView: function resetView() {
	      if (this.selectionMode === 'month') {
	        this.currentView = 'month';
	      } else if (this.selectionMode === 'year') {
	        this.currentView = 'year';
	      } else {
	        this.currentView = 'date';
	      }
	    },
	    handleEnter: function handleEnter() {
	      document.body.addEventListener('keydown', this.handleKeydown);
	    },
	    handleLeave: function handleLeave() {
	      this.$emit('dodestroy');
	      document.body.removeEventListener('keydown', this.handleKeydown);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      var list = [38, 40, 37, 39];
	      if (this.visible && !this.timePickerVisible) {
	        if (list.indexOf(keyCode) !== -1) {
	          this.handleKeyControl(keyCode);
	          event.stopPropagation();
	          event.preventDefault();
	        }
	        if (keyCode === 13 && this.userInputDate === null && this.userInputTime === null) {
	          // Enter
	          this.emit(this.date, false);
	        }
	      }
	    },
	    handleKeyControl: function handleKeyControl(keyCode) {
	      var mapping = {
	        'year': {
	          38: -4, 40: 4, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setFullYear(date.getFullYear() + step);
	          }
	        },
	        'month': {
	          38: -4, 40: 4, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setMonth(date.getMonth() + step);
	          }
	        },
	        'week': {
	          38: -1, 40: 1, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setDate(date.getDate() + step * 7);
	          }
	        },
	        'day': {
	          38: -7, 40: 7, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setDate(date.getDate() + step);
	          }
	        }
	      };
	      var mode = this.selectionMode;
	      var year = 3.1536e10;
	      var now = this.date.getTime();
	      var newDate = new Date(this.date.getTime());
	      while (Math.abs(now - newDate.getTime()) <= year) {
	        var map = mapping[mode];
	        map.offset(newDate, map[keyCode]);
	        if (typeof this.disabledDate === 'function' && this.disabledDate(newDate)) {
	          continue;
	        }
	        this.date = newDate;
	        this.$emit('pick', newDate, true);
	        break;
	      }
	    },
	    handleVisibleTimeChange: function handleVisibleTimeChange(value) {
	      var time = Object(date_util_["parseDate"])(value, this.timeFormat);
	      if (time && this.checkDateWithinRange(time)) {
	        this.date = Object(date_util_["modifyDate"])(time, this.year, this.month, this.monthDate);
	        this.userInputTime = null;
	        this.$refs.timepicker.value = this.date;
	        this.timePickerVisible = false;
	        this.emit(this.date, true);
	      }
	    },
	    handleVisibleDateChange: function handleVisibleDateChange(value) {
	      var date = Object(date_util_["parseDate"])(value, this.dateFormat);
	      if (date) {
	        if (typeof this.disabledDate === 'function' && this.disabledDate(date)) {
	          return;
	        }
	        this.date = Object(date_util_["modifyTime"])(date, this.date.getHours(), this.date.getMinutes(), this.date.getSeconds());
	        this.userInputDate = null;
	        this.resetView();
	        this.emit(this.date, true);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      return value && !isNaN(value) && (typeof this.disabledDate === 'function' ? !this.disabledDate(value) : true) && this.checkDateWithinRange(value);
	    },
	    getDefaultValue: function getDefaultValue() {
	      // if default-value is set, return it
	      // otherwise, return now (the moment this method gets called)
	      return this.defaultValue ? new Date(this.defaultValue) : new Date();
	    },
	    checkDateWithinRange: function checkDateWithinRange(date) {
	      return this.selectableRange.length > 0 ? Object(date_util_["timeWithinRange"])(date, this.selectableRange, this.format || 'HH:mm:ss') : true;
	    }
	  },
	
	  components: {
	    TimePicker: panel_time, YearTable: year_table, MonthTable: month_table, DateTable: date_table, ElInput: input_default.a, ElButton: button_default.a
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      date: new Date(),
	      value: '',
	      defaultValue: null, // use getDefaultValue() for time computation
	      defaultTime: null,
	      showTime: false,
	      selectionMode: 'day',
	      shortcuts: '',
	      visible: false,
	      currentView: 'date',
	      disabledDate: '',
	      cellClassName: '',
	      selectableRange: [],
	      firstDayOfWeek: 7,
	      showWeekNumber: false,
	      timePickerVisible: false,
	      format: '',
	      arrowControl: false,
	      userInputDate: null,
	      userInputTime: null
	    };
	  },
	
	
	  computed: {
	    year: function year() {
	      return this.date.getFullYear();
	    },
	    month: function month() {
	      return this.date.getMonth();
	    },
	    week: function week() {
	      return Object(date_util_["getWeekNumber"])(this.date);
	    },
	    monthDate: function monthDate() {
	      return this.date.getDate();
	    },
	    footerVisible: function footerVisible() {
	      return this.showTime || this.selectionMode === 'dates';
	    },
	    visibleTime: function visibleTime() {
	      if (this.userInputTime !== null) {
	        return this.userInputTime;
	      } else {
	        return Object(date_util_["formatDate"])(this.value || this.defaultValue, this.timeFormat);
	      }
	    },
	    visibleDate: function visibleDate() {
	      if (this.userInputDate !== null) {
	        return this.userInputDate;
	      } else {
	        return Object(date_util_["formatDate"])(this.value || this.defaultValue, this.dateFormat);
	      }
	    },
	    yearLabel: function yearLabel() {
	      var yearTranslation = this.t('el.datepicker.year');
	      if (this.currentView === 'year') {
	        var startYear = Math.floor(this.year / 10) * 10;
	        if (yearTranslation) {
	          return startYear + ' ' + yearTranslation + ' - ' + (startYear + 9) + ' ' + yearTranslation;
	        }
	        return startYear + ' - ' + (startYear + 9);
	      }
	      return this.year + ' ' + yearTranslation;
	    },
	    timeFormat: function timeFormat() {
	      if (this.format) {
	        return Object(date_util_["extractTimeFormat"])(this.format);
	      } else {
	        return 'HH:mm:ss';
	      }
	    },
	    dateFormat: function dateFormat() {
	      if (this.format) {
	        return Object(date_util_["extractDateFormat"])(this.format);
	      } else {
	        return 'yyyy-MM-dd';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_datevue_type_script_lang_js_ = (datevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue
	
	
	
	
	
	/* normalize component */
	
	var date_component = normalizeComponent(
	  panel_datevue_type_script_lang_js_,
	  datevue_type_template_id_2440d4ea_render,
	  datevue_type_template_id_2440d4ea_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var date_api; }
	date_component.options.__file = "packages/date-picker/src/panel/date.vue"
	/* harmony default export */ var panel_date = (date_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&
	var date_rangevue_type_template_id_2652849a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-picker-panel el-date-range-picker el-popper",
	          class: [
	            {
	              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts,
	              "has-time": _vm.showTime
	            },
	            _vm.popperClass
	          ]
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-picker-panel__body-wrapper" },
	            [
	              _vm._t("sidebar"),
	              _vm.shortcuts
	                ? _c(
	                    "div",
	                    { staticClass: "el-picker-panel__sidebar" },
	                    _vm._l(_vm.shortcuts, function(shortcut, key) {
	                      return _c(
	                        "button",
	                        {
	                          key: key,
	                          staticClass: "el-picker-panel__shortcut",
	                          attrs: { type: "button" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleShortcutClick(shortcut)
	                            }
	                          }
	                        },
	                        [_vm._v(_vm._s(shortcut.text))]
	                      )
	                    }),
	                    0
	                  )
	                : _vm._e(),
	              _c("div", { staticClass: "el-picker-panel__body" }, [
	                _vm.showTime
	                  ? _c(
	                      "div",
	                      { staticClass: "el-date-range-picker__time-header" },
	                      [
	                        _c(
	                          "span",
	                          { staticClass: "el-date-range-picker__editors-wrap" },
	                          [
	                            _c(
	                              "span",
	                              {
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  ref: "minInput",
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t(
	                                      "el.datepicker.startDate"
	                                    ),
	                                    value: _vm.minVisibleDate
	                                  },
	                                  on: {
	                                    input: function(val) {
	                                      return _vm.handleDateInput(val, "min")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleDateChange(val, "min")
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            ),
	                            _c(
	                              "span",
	                              {
	                                directives: [
	                                  {
	                                    name: "clickoutside",
	                                    rawName: "v-clickoutside",
	                                    value: _vm.handleMinTimeClose,
	                                    expression: "handleMinTimeClose"
	                                  }
	                                ],
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t(
	                                      "el.datepicker.startTime"
	                                    ),
	                                    value: _vm.minVisibleTime
	                                  },
	                                  on: {
	                                    focus: function($event) {
	                                      _vm.minTimePickerVisible = true
	                                    },
	                                    input: function(val) {
	                                      return _vm.handleTimeInput(val, "min")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleTimeChange(val, "min")
	                                    }
	                                  }
	                                }),
	                                _c("time-picker", {
	                                  ref: "minTimePicker",
	                                  attrs: {
	                                    "time-arrow-control": _vm.arrowControl,
	                                    visible: _vm.minTimePickerVisible
	                                  },
	                                  on: {
	                                    pick: _vm.handleMinTimePick,
	                                    mounted: function($event) {
	                                      _vm.$refs.minTimePicker.format =
	                                        _vm.timeFormat
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            )
	                          ]
	                        ),
	                        _c("span", { staticClass: "el-icon-arrow-right" }),
	                        _c(
	                          "span",
	                          {
	                            staticClass:
	                              "el-date-range-picker__editors-wrap is-right"
	                          },
	                          [
	                            _c(
	                              "span",
	                              {
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t("el.datepicker.endDate"),
	                                    value: _vm.maxVisibleDate,
	                                    readonly: !_vm.minDate
	                                  },
	                                  on: {
	                                    input: function(val) {
	                                      return _vm.handleDateInput(val, "max")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleDateChange(val, "max")
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            ),
	                            _c(
	                              "span",
	                              {
	                                directives: [
	                                  {
	                                    name: "clickoutside",
	                                    rawName: "v-clickoutside",
	                                    value: _vm.handleMaxTimeClose,
	                                    expression: "handleMaxTimeClose"
	                                  }
	                                ],
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t("el.datepicker.endTime"),
	                                    value: _vm.maxVisibleTime,
	                                    readonly: !_vm.minDate
	                                  },
	                                  on: {
	                                    focus: function($event) {
	                                      _vm.minDate &&
	                                        (_vm.maxTimePickerVisible = true)
	                                    },
	                                    input: function(val) {
	                                      return _vm.handleTimeInput(val, "max")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleTimeChange(val, "max")
	                                    }
	                                  }
	                                }),
	                                _c("time-picker", {
	                                  ref: "maxTimePicker",
	                                  attrs: {
	                                    "time-arrow-control": _vm.arrowControl,
	                                    visible: _vm.maxTimePickerVisible
	                                  },
	                                  on: {
	                                    pick: _vm.handleMaxTimePick,
	                                    mounted: function($event) {
	                                      _vm.$refs.maxTimePicker.format =
	                                        _vm.timeFormat
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            )
	                          ]
	                        )
	                      ]
	                    )
	                  : _vm._e(),
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-left"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                        attrs: { type: "button" },
	                        on: { click: _vm.leftPrevYear }
	                      }),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-arrow-left",
	                        attrs: { type: "button" },
	                        on: { click: _vm.leftPrevMonth }
	                      }),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.leftNextYear }
	                          })
	                        : _vm._e(),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-arrow-right",
	                            class: { "is-disabled": !_vm.enableMonthArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableMonthArrow
	                            },
	                            on: { click: _vm.leftNextMonth }
	                          })
	                        : _vm._e(),
	                      _c("div", [_vm._v(_vm._s(_vm.leftLabel))])
	                    ]),
	                    _c("date-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.leftDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate,
	                        "cell-class-name": _vm.cellClassName,
	                        "first-day-of-week": _vm.firstDayOfWeek
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                ),
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-right"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.rightPrevYear }
	                          })
	                        : _vm._e(),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-arrow-left",
	                            class: { "is-disabled": !_vm.enableMonthArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableMonthArrow
	                            },
	                            on: { click: _vm.rightPrevMonth }
	                          })
	                        : _vm._e(),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                        attrs: { type: "button" },
	                        on: { click: _vm.rightNextYear }
	                      }),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-arrow-right",
	                        attrs: { type: "button" },
	                        on: { click: _vm.rightNextMonth }
	                      }),
	                      _c("div", [_vm._v(_vm._s(_vm.rightLabel))])
	                    ]),
	                    _c("date-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.rightDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate,
	                        "cell-class-name": _vm.cellClassName,
	                        "first-day-of-week": _vm.firstDayOfWeek
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                )
	              ])
	            ],
	            2
	          ),
	          _vm.showTime
	            ? _c(
	                "div",
	                { staticClass: "el-picker-panel__footer" },
	                [
	                  _c(
	                    "el-button",
	                    {
	                      staticClass: "el-picker-panel__link-btn",
	                      attrs: { size: "mini", type: "text" },
	                      on: { click: _vm.handleClear }
	                    },
	                    [
	                      _vm._v(
	                        "\n        " +
	                          _vm._s(_vm.t("el.datepicker.clear")) +
	                          "\n      "
	                      )
	                    ]
	                  ),
	                  _c(
	                    "el-button",
	                    {
	                      staticClass: "el-picker-panel__link-btn",
	                      attrs: {
	                        plain: "",
	                        size: "mini",
	                        disabled: _vm.btnDisabled
	                      },
	                      on: {
	                        click: function($event) {
	                          _vm.handleConfirm(false)
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n        " +
	                          _vm._s(_vm.t("el.datepicker.confirm")) +
	                          "\n      "
	                      )
	                    ]
	                  )
	                ],
	                1
	              )
	            : _vm._e()
	        ]
	      )
	    ]
	  )
	}
	var date_rangevue_type_template_id_2652849a_staticRenderFns = []
	date_rangevue_type_template_id_2652849a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	var date_rangevue_type_script_lang_js_calcDefaultValue = function calcDefaultValue(defaultValue) {
	  if (Array.isArray(defaultValue)) {
	    return [new Date(defaultValue[0]), new Date(defaultValue[1])];
	  } else if (defaultValue) {
	    return [new Date(defaultValue), Object(date_util_["nextDate"])(new Date(defaultValue), 1)];
	  } else {
	    return [new Date(), Object(date_util_["nextDate"])(new Date(), 1)];
	  }
	};
	
	/* harmony default export */ var date_rangevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  computed: {
	    btnDisabled: function btnDisabled() {
	      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]));
	    },
	    leftLabel: function leftLabel() {
	      return this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.leftDate.getMonth() + 1));
	    },
	    rightLabel: function rightLabel() {
	      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.rightDate.getMonth() + 1));
	    },
	    leftYear: function leftYear() {
	      return this.leftDate.getFullYear();
	    },
	    leftMonth: function leftMonth() {
	      return this.leftDate.getMonth();
	    },
	    leftMonthDate: function leftMonthDate() {
	      return this.leftDate.getDate();
	    },
	    rightYear: function rightYear() {
	      return this.rightDate.getFullYear();
	    },
	    rightMonth: function rightMonth() {
	      return this.rightDate.getMonth();
	    },
	    rightMonthDate: function rightMonthDate() {
	      return this.rightDate.getDate();
	    },
	    minVisibleDate: function minVisibleDate() {
	      if (this.dateUserInput.min !== null) return this.dateUserInput.min;
	      if (this.minDate) return Object(date_util_["formatDate"])(this.minDate, this.dateFormat);
	      return '';
	    },
	    maxVisibleDate: function maxVisibleDate() {
	      if (this.dateUserInput.max !== null) return this.dateUserInput.max;
	      if (this.maxDate || this.minDate) return Object(date_util_["formatDate"])(this.maxDate || this.minDate, this.dateFormat);
	      return '';
	    },
	    minVisibleTime: function minVisibleTime() {
	      if (this.timeUserInput.min !== null) return this.timeUserInput.min;
	      if (this.minDate) return Object(date_util_["formatDate"])(this.minDate, this.timeFormat);
	      return '';
	    },
	    maxVisibleTime: function maxVisibleTime() {
	      if (this.timeUserInput.max !== null) return this.timeUserInput.max;
	      if (this.maxDate || this.minDate) return Object(date_util_["formatDate"])(this.maxDate || this.minDate, this.timeFormat);
	      return '';
	    },
	    timeFormat: function timeFormat() {
	      if (this.format) {
	        return Object(date_util_["extractTimeFormat"])(this.format);
	      } else {
	        return 'HH:mm:ss';
	      }
	    },
	    dateFormat: function dateFormat() {
	      if (this.format) {
	        return Object(date_util_["extractDateFormat"])(this.format);
	      } else {
	        return 'yyyy-MM-dd';
	      }
	    },
	    enableMonthArrow: function enableMonthArrow() {
	      var nextMonth = (this.leftMonth + 1) % 12;
	      var yearOffset = this.leftMonth + 1 >= 12 ? 1 : 0;
	      return this.unlinkPanels && new Date(this.leftYear + yearOffset, nextMonth) < new Date(this.rightYear, this.rightMonth);
	    },
	    enableYearArrow: function enableYearArrow() {
	      return this.unlinkPanels && this.rightYear * 12 + this.rightMonth - (this.leftYear * 12 + this.leftMonth + 1) >= 12;
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      value: [],
	      defaultValue: null,
	      defaultTime: null,
	      minDate: '',
	      maxDate: '',
	      leftDate: new Date(),
	      rightDate: Object(date_util_["nextMonth"])(new Date()),
	      rangeState: {
	        endDate: null,
	        selecting: false,
	        row: null,
	        column: null
	      },
	      showTime: false,
	      shortcuts: '',
	      visible: '',
	      disabledDate: '',
	      cellClassName: '',
	      firstDayOfWeek: 7,
	      minTimePickerVisible: false,
	      maxTimePickerVisible: false,
	      format: '',
	      arrowControl: false,
	      unlinkPanels: false,
	      dateUserInput: {
	        min: null,
	        max: null
	      },
	      timeUserInput: {
	        min: null,
	        max: null
	      }
	    };
	  },
	
	
	  watch: {
	    minDate: function minDate(val) {
	      var _this = this;
	
	      this.dateUserInput.min = null;
	      this.timeUserInput.min = null;
	      this.$nextTick(function () {
	        if (_this.$refs.maxTimePicker && _this.maxDate && _this.maxDate < _this.minDate) {
	          var format = 'HH:mm:ss';
	          _this.$refs.maxTimePicker.selectableRange = [[Object(date_util_["parseDate"])(Object(date_util_["formatDate"])(_this.minDate, format), format), Object(date_util_["parseDate"])('23:59:59', format)]];
	        }
	      });
	      if (val && this.$refs.minTimePicker) {
	        this.$refs.minTimePicker.date = val;
	        this.$refs.minTimePicker.value = val;
	      }
	    },
	    maxDate: function maxDate(val) {
	      this.dateUserInput.max = null;
	      this.timeUserInput.max = null;
	      if (val && this.$refs.maxTimePicker) {
	        this.$refs.maxTimePicker.date = val;
	        this.$refs.maxTimePicker.value = val;
	      }
	    },
	    minTimePickerVisible: function minTimePickerVisible(val) {
	      var _this2 = this;
	
	      if (val) {
	        this.$nextTick(function () {
	          _this2.$refs.minTimePicker.date = _this2.minDate;
	          _this2.$refs.minTimePicker.value = _this2.minDate;
	          _this2.$refs.minTimePicker.adjustSpinners();
	        });
	      }
	    },
	    maxTimePickerVisible: function maxTimePickerVisible(val) {
	      var _this3 = this;
	
	      if (val) {
	        this.$nextTick(function () {
	          _this3.$refs.maxTimePicker.date = _this3.maxDate;
	          _this3.$refs.maxTimePicker.value = _this3.maxDate;
	          _this3.$refs.maxTimePicker.adjustSpinners();
	        });
	      }
	    },
	    value: function value(newVal) {
	      if (!newVal) {
	        this.minDate = null;
	        this.maxDate = null;
	      } else if (Array.isArray(newVal)) {
	        this.minDate = Object(date_util_["isDate"])(newVal[0]) ? new Date(newVal[0]) : null;
	        this.maxDate = Object(date_util_["isDate"])(newVal[1]) ? new Date(newVal[1]) : null;
	        if (this.minDate) {
	          this.leftDate = this.minDate;
	          if (this.unlinkPanels && this.maxDate) {
	            var minDateYear = this.minDate.getFullYear();
	            var minDateMonth = this.minDate.getMonth();
	            var maxDateYear = this.maxDate.getFullYear();
	            var maxDateMonth = this.maxDate.getMonth();
	            this.rightDate = minDateYear === maxDateYear && minDateMonth === maxDateMonth ? Object(date_util_["nextMonth"])(this.maxDate) : this.maxDate;
	          } else {
	            this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	          }
	        } else {
	          this.leftDate = date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	          this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	        }
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Array.isArray(this.value)) {
	        var _calcDefaultValue = date_rangevue_type_script_lang_js_calcDefaultValue(val),
	            left = _calcDefaultValue[0],
	            right = _calcDefaultValue[1];
	
	        this.leftDate = left;
	        this.rightDate = val && val[1] && this.unlinkPanels ? right : Object(date_util_["nextMonth"])(this.leftDate);
	      }
	    }
	  },
	
	  methods: {
	    handleClear: function handleClear() {
	      this.minDate = null;
	      this.maxDate = null;
	      this.leftDate = date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	      this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      this.$emit('pick', null);
	    },
	    handleChangeRange: function handleChangeRange(val) {
	      this.minDate = val.minDate;
	      this.maxDate = val.maxDate;
	      this.rangeState = val.rangeState;
	    },
	    handleDateInput: function handleDateInput(value, type) {
	      this.dateUserInput[type] = value;
	      if (value.length !== this.dateFormat.length) return;
	      var parsedValue = Object(date_util_["parseDate"])(value, this.dateFormat);
	
	      if (parsedValue) {
	        if (typeof this.disabledDate === 'function' && this.disabledDate(new Date(parsedValue))) {
	          return;
	        }
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyDate"])(this.minDate || new Date(), parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          this.leftDate = new Date(parsedValue);
	          if (!this.unlinkPanels) {
	            this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	          }
	        } else {
	          this.maxDate = Object(date_util_["modifyDate"])(this.maxDate || new Date(), parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          this.rightDate = new Date(parsedValue);
	          if (!this.unlinkPanels) {
	            this.leftDate = Object(date_util_["prevMonth"])(parsedValue);
	          }
	        }
	      }
	    },
	    handleDateChange: function handleDateChange(value, type) {
	      var parsedValue = Object(date_util_["parseDate"])(value, this.dateFormat);
	      if (parsedValue) {
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyDate"])(this.minDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          if (this.minDate > this.maxDate) {
	            this.maxDate = this.minDate;
	          }
	        } else {
	          this.maxDate = Object(date_util_["modifyDate"])(this.maxDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          if (this.maxDate < this.minDate) {
	            this.minDate = this.maxDate;
	          }
	        }
	      }
	    },
	    handleTimeInput: function handleTimeInput(value, type) {
	      var _this4 = this;
	
	      this.timeUserInput[type] = value;
	      if (value.length !== this.timeFormat.length) return;
	      var parsedValue = Object(date_util_["parseDate"])(value, this.timeFormat);
	
	      if (parsedValue) {
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyTime"])(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          this.$nextTick(function (_) {
	            return _this4.$refs.minTimePicker.adjustSpinners();
	          });
	        } else {
	          this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          this.$nextTick(function (_) {
	            return _this4.$refs.maxTimePicker.adjustSpinners();
	          });
	        }
	      }
	    },
	    handleTimeChange: function handleTimeChange(value, type) {
	      var parsedValue = Object(date_util_["parseDate"])(value, this.timeFormat);
	      if (parsedValue) {
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyTime"])(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          if (this.minDate > this.maxDate) {
	            this.maxDate = this.minDate;
	          }
	          this.$refs.minTimePicker.value = this.minDate;
	          this.minTimePickerVisible = false;
	        } else {
	          this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          if (this.maxDate < this.minDate) {
	            this.minDate = this.maxDate;
	          }
	          this.$refs.maxTimePicker.value = this.minDate;
	          this.maxTimePickerVisible = false;
	        }
	      }
	    },
	    handleRangePick: function handleRangePick(val) {
	      var _this5 = this;
	
	      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var defaultTime = this.defaultTime || [];
	      var minDate = Object(date_util_["modifyWithTimeString"])(val.minDate, defaultTime[0]);
	      var maxDate = Object(date_util_["modifyWithTimeString"])(val.maxDate, defaultTime[1]);
	
	      if (this.maxDate === maxDate && this.minDate === minDate) {
	        return;
	      }
	      this.onPick && this.onPick(val);
	      this.maxDate = maxDate;
	      this.minDate = minDate;
	
	      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
	      setTimeout(function () {
	        _this5.maxDate = maxDate;
	        _this5.minDate = minDate;
	      }, 10);
	      if (!close || this.showTime) return;
	      this.handleConfirm();
	    },
	    handleShortcutClick: function handleShortcutClick(shortcut) {
	      if (shortcut.onClick) {
	        shortcut.onClick(this);
	      }
	    },
	    handleMinTimePick: function handleMinTimePick(value, visible, first) {
	      this.minDate = this.minDate || new Date();
	      if (value) {
	        this.minDate = Object(date_util_["modifyTime"])(this.minDate, value.getHours(), value.getMinutes(), value.getSeconds());
	      }
	
	      if (!first) {
	        this.minTimePickerVisible = visible;
	      }
	
	      if (!this.maxDate || this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
	        this.maxDate = new Date(this.minDate);
	      }
	    },
	    handleMinTimeClose: function handleMinTimeClose() {
	      this.minTimePickerVisible = false;
	    },
	    handleMaxTimePick: function handleMaxTimePick(value, visible, first) {
	      if (this.maxDate && value) {
	        this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, value.getHours(), value.getMinutes(), value.getSeconds());
	      }
	
	      if (!first) {
	        this.maxTimePickerVisible = visible;
	      }
	
	      if (this.maxDate && this.minDate && this.minDate.getTime() > this.maxDate.getTime()) {
	        this.minDate = new Date(this.maxDate);
	      }
	    },
	    handleMaxTimeClose: function handleMaxTimeClose() {
	      this.maxTimePickerVisible = false;
	    },
	
	
	    // leftPrev*, rightNext* need to take care of `unlinkPanels`
	    leftPrevYear: function leftPrevYear() {
	      this.leftDate = Object(date_util_["prevYear"])(this.leftDate);
	      if (!this.unlinkPanels) {
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      }
	    },
	    leftPrevMonth: function leftPrevMonth() {
	      this.leftDate = Object(date_util_["prevMonth"])(this.leftDate);
	      if (!this.unlinkPanels) {
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      }
	    },
	    rightNextYear: function rightNextYear() {
	      if (!this.unlinkPanels) {
	        this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      } else {
	        this.rightDate = Object(date_util_["nextYear"])(this.rightDate);
	      }
	    },
	    rightNextMonth: function rightNextMonth() {
	      if (!this.unlinkPanels) {
	        this.leftDate = Object(date_util_["nextMonth"])(this.leftDate);
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      } else {
	        this.rightDate = Object(date_util_["nextMonth"])(this.rightDate);
	      }
	    },
	
	
	    // leftNext*, rightPrev* are called when `unlinkPanels` is true
	    leftNextYear: function leftNextYear() {
	      this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	    },
	    leftNextMonth: function leftNextMonth() {
	      this.leftDate = Object(date_util_["nextMonth"])(this.leftDate);
	    },
	    rightPrevYear: function rightPrevYear() {
	      this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
	    },
	    rightPrevMonth: function rightPrevMonth() {
	      this.rightDate = Object(date_util_["prevMonth"])(this.rightDate);
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.isValidValue([this.minDate, this.maxDate])) {
	        this.$emit('pick', [this.minDate, this.maxDate], visible);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      return Array.isArray(value) && value && value[0] && value[1] && Object(date_util_["isDate"])(value[0]) && Object(date_util_["isDate"])(value[1]) && value[0].getTime() <= value[1].getTime() && (typeof this.disabledDate === 'function' ? !this.disabledDate(value[0]) && !this.disabledDate(value[1]) : true);
	    },
	    resetView: function resetView() {
	      // NOTE: this is a hack to reset {min, max}Date on picker open.
	      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
	      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
	      if (this.minDate && this.maxDate == null) this.rangeState.selecting = false;
	      this.minDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[0]) : null;
	      this.maxDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[1]) : null;
	    }
	  },
	
	  components: { TimePicker: panel_time, DateTable: date_table, ElInput: input_default.a, ElButton: button_default.a }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_date_rangevue_type_script_lang_js_ = (date_rangevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue
	
	
	
	
	
	/* normalize component */
	
	var date_range_component = normalizeComponent(
	  panel_date_rangevue_type_script_lang_js_,
	  date_rangevue_type_template_id_2652849a_render,
	  date_rangevue_type_template_id_2652849a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var date_range_api; }
	date_range_component.options.__file = "packages/date-picker/src/panel/date-range.vue"
	/* harmony default export */ var date_range = (date_range_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&
	var month_rangevue_type_template_id_f2645fb8_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-picker-panel el-date-range-picker el-popper",
	          class: [
	            {
	              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts
	            },
	            _vm.popperClass
	          ]
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-picker-panel__body-wrapper" },
	            [
	              _vm._t("sidebar"),
	              _vm.shortcuts
	                ? _c(
	                    "div",
	                    { staticClass: "el-picker-panel__sidebar" },
	                    _vm._l(_vm.shortcuts, function(shortcut, key) {
	                      return _c(
	                        "button",
	                        {
	                          key: key,
	                          staticClass: "el-picker-panel__shortcut",
	                          attrs: { type: "button" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleShortcutClick(shortcut)
	                            }
	                          }
	                        },
	                        [_vm._v(_vm._s(shortcut.text))]
	                      )
	                    }),
	                    0
	                  )
	                : _vm._e(),
	              _c("div", { staticClass: "el-picker-panel__body" }, [
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-left"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                        attrs: { type: "button" },
	                        on: { click: _vm.leftPrevYear }
	                      }),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.leftNextYear }
	                          })
	                        : _vm._e(),
	                      _c("div", [_vm._v(_vm._s(_vm.leftLabel))])
	                    ]),
	                    _c("month-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.leftDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                ),
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-right"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.rightPrevYear }
	                          })
	                        : _vm._e(),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                        attrs: { type: "button" },
	                        on: { click: _vm.rightNextYear }
	                      }),
	                      _c("div", [_vm._v(_vm._s(_vm.rightLabel))])
	                    ]),
	                    _c("month-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.rightDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                )
	              ])
	            ],
	            2
	          )
	        ]
	      )
	    ]
	  )
	}
	var month_rangevue_type_template_id_f2645fb8_staticRenderFns = []
	month_rangevue_type_template_id_f2645fb8_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var month_rangevue_type_script_lang_js_calcDefaultValue = function calcDefaultValue(defaultValue) {
	  if (Array.isArray(defaultValue)) {
	    return [new Date(defaultValue[0]), new Date(defaultValue[1])];
	  } else if (defaultValue) {
	    return [new Date(defaultValue), Object(date_util_["nextMonth"])(new Date(defaultValue))];
	  } else {
	    return [new Date(), Object(date_util_["nextMonth"])(new Date())];
	  }
	};
	/* harmony default export */ var month_rangevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  computed: {
	    btnDisabled: function btnDisabled() {
	      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]));
	    },
	    leftLabel: function leftLabel() {
	      return this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year');
	    },
	    rightLabel: function rightLabel() {
	      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year');
	    },
	    leftYear: function leftYear() {
	      return this.leftDate.getFullYear();
	    },
	    rightYear: function rightYear() {
	      return this.rightDate.getFullYear() === this.leftDate.getFullYear() ? this.leftDate.getFullYear() + 1 : this.rightDate.getFullYear();
	    },
	    enableYearArrow: function enableYearArrow() {
	      return this.unlinkPanels && this.rightYear > this.leftYear + 1;
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      value: [],
	      defaultValue: null,
	      defaultTime: null,
	      minDate: '',
	      maxDate: '',
	      leftDate: new Date(),
	      rightDate: Object(date_util_["nextYear"])(new Date()),
	      rangeState: {
	        endDate: null,
	        selecting: false,
	        row: null,
	        column: null
	      },
	      shortcuts: '',
	      visible: '',
	      disabledDate: '',
	      format: '',
	      arrowControl: false,
	      unlinkPanels: false
	    };
	  },
	
	
	  watch: {
	    value: function value(newVal) {
	      if (!newVal) {
	        this.minDate = null;
	        this.maxDate = null;
	      } else if (Array.isArray(newVal)) {
	        this.minDate = Object(date_util_["isDate"])(newVal[0]) ? new Date(newVal[0]) : null;
	        this.maxDate = Object(date_util_["isDate"])(newVal[1]) ? new Date(newVal[1]) : null;
	        if (this.minDate) {
	          this.leftDate = this.minDate;
	          if (this.unlinkPanels && this.maxDate) {
	            var minDateYear = this.minDate.getFullYear();
	            var maxDateYear = this.maxDate.getFullYear();
	            this.rightDate = minDateYear === maxDateYear ? Object(date_util_["nextYear"])(this.maxDate) : this.maxDate;
	          } else {
	            this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
	          }
	        } else {
	          this.leftDate = month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	          this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
	        }
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Array.isArray(this.value)) {
	        var _calcDefaultValue = month_rangevue_type_script_lang_js_calcDefaultValue(val),
	            left = _calcDefaultValue[0],
	            right = _calcDefaultValue[1];
	
	        this.leftDate = left;
	        this.rightDate = val && val[1] && left.getFullYear() !== right.getFullYear() && this.unlinkPanels ? right : Object(date_util_["nextYear"])(this.leftDate);
	      }
	    }
	  },
	
	  methods: {
	    handleClear: function handleClear() {
	      this.minDate = null;
	      this.maxDate = null;
	      this.leftDate = month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	      this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
	      this.$emit('pick', null);
	    },
	    handleChangeRange: function handleChangeRange(val) {
	      this.minDate = val.minDate;
	      this.maxDate = val.maxDate;
	      this.rangeState = val.rangeState;
	    },
	    handleRangePick: function handleRangePick(val) {
	      var _this = this;
	
	      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var defaultTime = this.defaultTime || [];
	      var minDate = Object(date_util_["modifyWithTimeString"])(val.minDate, defaultTime[0]);
	      var maxDate = Object(date_util_["modifyWithTimeString"])(val.maxDate, defaultTime[1]);
	      if (this.maxDate === maxDate && this.minDate === minDate) {
	        return;
	      }
	      this.onPick && this.onPick(val);
	      this.maxDate = maxDate;
	      this.minDate = minDate;
	
	      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
	      setTimeout(function () {
	        _this.maxDate = maxDate;
	        _this.minDate = minDate;
	      }, 10);
	      if (!close) return;
	      this.handleConfirm();
	    },
	    handleShortcutClick: function handleShortcutClick(shortcut) {
	      if (shortcut.onClick) {
	        shortcut.onClick(this);
	      }
	    },
	
	
	    // leftPrev*, rightNext* need to take care of `unlinkPanels`
	    leftPrevYear: function leftPrevYear() {
	      this.leftDate = Object(date_util_["prevYear"])(this.leftDate);
	      if (!this.unlinkPanels) {
	        this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
	      }
	    },
	    rightNextYear: function rightNextYear() {
	      if (!this.unlinkPanels) {
	        this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	      }
	      this.rightDate = Object(date_util_["nextYear"])(this.rightDate);
	    },
	
	
	    // leftNext*, rightPrev* are called when `unlinkPanels` is true
	    leftNextYear: function leftNextYear() {
	      this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	    },
	    rightPrevYear: function rightPrevYear() {
	      this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.isValidValue([this.minDate, this.maxDate])) {
	        this.$emit('pick', [this.minDate, this.maxDate], visible);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      return Array.isArray(value) && value && value[0] && value[1] && Object(date_util_["isDate"])(value[0]) && Object(date_util_["isDate"])(value[1]) && value[0].getTime() <= value[1].getTime() && (typeof this.disabledDate === 'function' ? !this.disabledDate(value[0]) && !this.disabledDate(value[1]) : true);
	    },
	    resetView: function resetView() {
	      // NOTE: this is a hack to reset {min, max}Date on picker open.
	      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
	      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
	      this.minDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[0]) : null;
	      this.maxDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[1]) : null;
	    }
	  },
	
	  components: { MonthTable: month_table, ElInput: input_default.a, ElButton: button_default.a }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_month_rangevue_type_script_lang_js_ = (month_rangevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue
	
	
	
	
	
	/* normalize component */
	
	var month_range_component = normalizeComponent(
	  panel_month_rangevue_type_script_lang_js_,
	  month_rangevue_type_template_id_f2645fb8_render,
	  month_rangevue_type_template_id_f2645fb8_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var month_range_api; }
	month_range_component.options.__file = "packages/date-picker/src/panel/month-range.vue"
	/* harmony default export */ var month_range = (month_range_component.exports);
	// CONCATENATED MODULE: ./packages/date-picker/src/picker/date-picker.js
	
	
	
	
	
	var date_picker_getPanel = function getPanel(type) {
	  if (type === 'daterange' || type === 'datetimerange') {
	    return date_range;
	  } else if (type === 'monthrange') {
	    return month_range;
	  }
	  return panel_date;
	};
	
	/* harmony default export */ var date_picker = ({
	  mixins: [picker],
	
	  name: 'ElDatePicker',
	
	  props: {
	    type: {
	      type: String,
	      default: 'date'
	    },
	    timeArrowControl: Boolean
	  },
	
	  watch: {
	    type: function type(_type) {
	      if (this.picker) {
	        this.unmountPicker();
	        this.panel = date_picker_getPanel(_type);
	        this.mountPicker();
	      } else {
	        this.panel = date_picker_getPanel(_type);
	      }
	    }
	  },
	
	  created: function created() {
	    this.panel = date_picker_getPanel(this.type);
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/index.js
	
	
	/* istanbul ignore next */
	date_picker.install = function install(Vue) {
	  Vue.component(date_picker.name, date_picker);
	};
	
	/* harmony default export */ var packages_date_picker = (date_picker);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&
	var time_selectvue_type_template_id_51ab9320_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "before-enter": _vm.handleMenuEnter,
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          ref: "popper",
	          staticClass: "el-picker-panel time-select el-popper",
	          class: _vm.popperClass,
	          style: { width: _vm.width + "px" }
	        },
	        [
	          _c(
	            "el-scrollbar",
	            {
	              attrs: { noresize: "", "wrap-class": "el-picker-panel__content" }
	            },
	            _vm._l(_vm.items, function(item) {
	              return _c(
	                "div",
	                {
	                  key: item.value,
	                  staticClass: "time-select-item",
	                  class: {
	                    selected: _vm.value === item.value,
	                    disabled: item.disabled,
	                    default: item.value === _vm.defaultValue
	                  },
	                  attrs: { disabled: item.disabled },
	                  on: {
	                    click: function($event) {
	                      _vm.handleClick(item)
	                    }
	                  }
	                },
	                [_vm._v(_vm._s(item.value))]
	              )
	            }),
	            0
	          )
	        ],
	        1
	      )
	    ]
	  )
	}
	var time_selectvue_type_template_id_51ab9320_staticRenderFns = []
	time_selectvue_type_template_id_51ab9320_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	var parseTime = function parseTime(time) {
	  var values = (time || '').split(':');
	  if (values.length >= 2) {
	    var hours = parseInt(values[0], 10);
	    var minutes = parseInt(values[1], 10);
	
	    return {
	      hours: hours,
	      minutes: minutes
	    };
	  }
	  /* istanbul ignore next */
	  return null;
	};
	
	var compareTime = function compareTime(time1, time2) {
	  var value1 = parseTime(time1);
	  var value2 = parseTime(time2);
	
	  var minutes1 = value1.minutes + value1.hours * 60;
	  var minutes2 = value2.minutes + value2.hours * 60;
	
	  if (minutes1 === minutes2) {
	    return 0;
	  }
	
	  return minutes1 > minutes2 ? 1 : -1;
	};
	
	var formatTime = function formatTime(time) {
	  return (time.hours < 10 ? '0' + time.hours : time.hours) + ':' + (time.minutes < 10 ? '0' + time.minutes : time.minutes);
	};
	
	var nextTime = function nextTime(time, step) {
	  var timeValue = parseTime(time);
	  var stepValue = parseTime(step);
	
	  var next = {
	    hours: timeValue.hours,
	    minutes: timeValue.minutes
	  };
	
	  next.minutes += stepValue.minutes;
	  next.hours += stepValue.hours;
	
	  next.hours += Math.floor(next.minutes / 60);
	  next.minutes = next.minutes % 60;
	
	  return formatTime(next);
	};
	
	/* harmony default export */ var time_selectvue_type_script_lang_js_ = ({
	  components: { ElScrollbar: scrollbar_default.a },
	
	  watch: {
	    value: function value(val) {
	      var _this = this;
	
	      if (!val) return;
	      this.$nextTick(function () {
	        return _this.scrollToOption();
	      });
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(item) {
	      if (!item.disabled) {
	        this.$emit('pick', item.value);
	      }
	    },
	    handleClear: function handleClear() {
	      this.$emit('pick', null);
	    },
	    scrollToOption: function scrollToOption() {
	      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.selected';
	
	      var menu = this.$refs.popper.querySelector('.el-picker-panel__content');
	      scroll_into_view_default()(menu, menu.querySelector(selector));
	    },
	    handleMenuEnter: function handleMenuEnter() {
	      var _this2 = this;
	
	      var selected = this.items.map(function (item) {
	        return item.value;
	      }).indexOf(this.value) !== -1;
	      var hasDefault = this.items.map(function (item) {
	        return item.value;
	      }).indexOf(this.defaultValue) !== -1;
	      var option = selected && '.selected' || hasDefault && '.default' || '.time-select-item:not(.disabled)';
	      this.$nextTick(function () {
	        return _this2.scrollToOption(option);
	      });
	    },
	    scrollDown: function scrollDown(step) {
	      var items = this.items;
	      var length = items.length;
	      var total = items.length;
	      var index = items.map(function (item) {
	        return item.value;
	      }).indexOf(this.value);
	      while (total--) {
	        index = (index + step + length) % length;
	        if (!items[index].disabled) {
	          this.$emit('pick', items[index].value, true);
	          return;
	        }
	      }
	    },
	    isValidValue: function isValidValue(date) {
	      return this.items.filter(function (item) {
	        return !item.disabled;
	      }).map(function (item) {
	        return item.value;
	      }).indexOf(date) !== -1;
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      if (keyCode === 38 || keyCode === 40) {
	        var mapping = { 40: 1, 38: -1 };
	        var offset = mapping[keyCode.toString()];
	        this.scrollDown(offset);
	        event.stopPropagation();
	        return;
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      start: '09:00',
	      end: '18:00',
	      step: '00:30',
	      value: '',
	      defaultValue: '',
	      visible: false,
	      minTime: '',
	      maxTime: '',
	      width: 0
	    };
	  },
	
	
	  computed: {
	    items: function items() {
	      var start = this.start;
	      var end = this.end;
	      var step = this.step;
	
	      var result = [];
	
	      if (start && end && step) {
	        var current = start;
	        while (compareTime(current, end) <= 0) {
	          result.push({
	            value: current,
	            disabled: compareTime(current, this.minTime || '-1:-1') <= 0 || compareTime(current, this.maxTime || '100:100') >= 0
	          });
	          current = nextTime(current, step);
	        }
	      }
	
	      return result;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_time_selectvue_type_script_lang_js_ = (time_selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue
	
	
	
	
	
	/* normalize component */
	
	var time_select_component = normalizeComponent(
	  panel_time_selectvue_type_script_lang_js_,
	  time_selectvue_type_template_id_51ab9320_render,
	  time_selectvue_type_template_id_51ab9320_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_select_api; }
	time_select_component.options.__file = "packages/date-picker/src/panel/time-select.vue"
	/* harmony default export */ var time_select = (time_select_component.exports);
	// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-select.js
	
	
	
	/* harmony default export */ var picker_time_select = ({
	  mixins: [picker],
	
	  name: 'ElTimeSelect',
	
	  componentName: 'ElTimeSelect',
	
	  props: {
	    type: {
	      type: String,
	      default: 'time-select'
	    }
	  },
	
	  beforeCreate: function beforeCreate() {
	    this.panel = time_select;
	  }
	});
	// CONCATENATED MODULE: ./packages/time-select/index.js
	
	
	/* istanbul ignore next */
	picker_time_select.install = function (Vue) {
	  Vue.component(picker_time_select.name, picker_time_select);
	};
	
	/* harmony default export */ var packages_time_select = (picker_time_select);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&
	var time_rangevue_type_template_id_fb28660e_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-time-range-picker el-picker-panel el-popper",
	          class: _vm.popperClass
	        },
	        [
	          _c("div", { staticClass: "el-time-range-picker__content" }, [
	            _c("div", { staticClass: "el-time-range-picker__cell" }, [
	              _c("div", { staticClass: "el-time-range-picker__header" }, [
	                _vm._v(_vm._s(_vm.t("el.datepicker.startTime")))
	              ]),
	              _c(
	                "div",
	                {
	                  staticClass:
	                    "el-time-range-picker__body el-time-panel__content",
	                  class: {
	                    "has-seconds": _vm.showSeconds,
	                    "is-arrow": _vm.arrowControl
	                  }
	                },
	                [
	                  _c("time-spinner", {
	                    ref: "minSpinner",
	                    attrs: {
	                      "show-seconds": _vm.showSeconds,
	                      "am-pm-mode": _vm.amPmMode,
	                      "arrow-control": _vm.arrowControl,
	                      date: _vm.minDate
	                    },
	                    on: {
	                      change: _vm.handleMinChange,
	                      "select-range": _vm.setMinSelectionRange
	                    }
	                  })
	                ],
	                1
	              )
	            ]),
	            _c("div", { staticClass: "el-time-range-picker__cell" }, [
	              _c("div", { staticClass: "el-time-range-picker__header" }, [
	                _vm._v(_vm._s(_vm.t("el.datepicker.endTime")))
	              ]),
	              _c(
	                "div",
	                {
	                  staticClass:
	                    "el-time-range-picker__body el-time-panel__content",
	                  class: {
	                    "has-seconds": _vm.showSeconds,
	                    "is-arrow": _vm.arrowControl
	                  }
	                },
	                [
	                  _c("time-spinner", {
	                    ref: "maxSpinner",
	                    attrs: {
	                      "show-seconds": _vm.showSeconds,
	                      "am-pm-mode": _vm.amPmMode,
	                      "arrow-control": _vm.arrowControl,
	                      date: _vm.maxDate
	                    },
	                    on: {
	                      change: _vm.handleMaxChange,
	                      "select-range": _vm.setMaxSelectionRange
	                    }
	                  })
	                ],
	                1
	              )
	            ])
	          ]),
	          _c("div", { staticClass: "el-time-panel__footer" }, [
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn cancel",
	                attrs: { type: "button" },
	                on: {
	                  click: function($event) {
	                    _vm.handleCancel()
	                  }
	                }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]
	            ),
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn confirm",
	                attrs: { type: "button", disabled: _vm.btnDisabled },
	                on: {
	                  click: function($event) {
	                    _vm.handleConfirm()
	                  }
	                }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))]
	            )
	          ])
	        ]
	      )
	    ]
	  )
	}
	var time_rangevue_type_template_id_fb28660e_staticRenderFns = []
	time_rangevue_type_template_id_fb28660e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	var MIN_TIME = Object(date_util_["parseDate"])('00:00:00', 'HH:mm:ss');
	var MAX_TIME = Object(date_util_["parseDate"])('23:59:59', 'HH:mm:ss');
	
	var time_rangevue_type_script_lang_js_minTimeOfDay = function minTimeOfDay(date) {
	  return Object(date_util_["modifyDate"])(MIN_TIME, date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	var time_rangevue_type_script_lang_js_maxTimeOfDay = function maxTimeOfDay(date) {
	  return Object(date_util_["modifyDate"])(MAX_TIME, date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	// increase time by amount of milliseconds, but within the range of day
	var advanceTime = function advanceTime(date, amount) {
	  return new Date(Math.min(date.getTime() + amount, time_rangevue_type_script_lang_js_maxTimeOfDay(date).getTime()));
	};
	
	/* harmony default export */ var time_rangevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  components: { TimeSpinner: time_spinner },
	
	  computed: {
	    showSeconds: function showSeconds() {
	      return (this.format || '').indexOf('ss') !== -1;
	    },
	    offset: function offset() {
	      return this.showSeconds ? 11 : 8;
	    },
	    spinner: function spinner() {
	      return this.selectionRange[0] < this.offset ? this.$refs.minSpinner : this.$refs.maxSpinner;
	    },
	    btnDisabled: function btnDisabled() {
	      return this.minDate.getTime() > this.maxDate.getTime();
	    },
	    amPmMode: function amPmMode() {
	      if ((this.format || '').indexOf('A') !== -1) return 'A';
	      if ((this.format || '').indexOf('a') !== -1) return 'a';
	      return '';
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      minDate: new Date(),
	      maxDate: new Date(),
	      value: [],
	      oldValue: [new Date(), new Date()],
	      defaultValue: null,
	      format: 'HH:mm:ss',
	      visible: false,
	      selectionRange: [0, 2],
	      arrowControl: false
	    };
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      if (Array.isArray(_value)) {
	        this.minDate = new Date(_value[0]);
	        this.maxDate = new Date(_value[1]);
	      } else {
	        if (Array.isArray(this.defaultValue)) {
	          this.minDate = new Date(this.defaultValue[0]);
	          this.maxDate = new Date(this.defaultValue[1]);
	        } else if (this.defaultValue) {
	          this.minDate = new Date(this.defaultValue);
	          this.maxDate = advanceTime(new Date(this.defaultValue), 60 * 60 * 1000);
	        } else {
	          this.minDate = new Date();
	          this.maxDate = advanceTime(new Date(), 60 * 60 * 1000);
	        }
	      }
	    },
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.oldValue = this.value;
	        this.$nextTick(function () {
	          return _this.$refs.minSpinner.emitSelectRange('hours');
	        });
	      }
	    }
	  },
	
	  methods: {
	    handleClear: function handleClear() {
	      this.$emit('pick', null);
	    },
	    handleCancel: function handleCancel() {
	      this.$emit('pick', this.oldValue);
	    },
	    handleMinChange: function handleMinChange(date) {
	      this.minDate = Object(date_util_["clearMilliseconds"])(date);
	      this.handleChange();
	    },
	    handleMaxChange: function handleMaxChange(date) {
	      this.maxDate = Object(date_util_["clearMilliseconds"])(date);
	      this.handleChange();
	    },
	    handleChange: function handleChange() {
	      if (this.isValidValue([this.minDate, this.maxDate])) {
	        this.$refs.minSpinner.selectableRange = [[time_rangevue_type_script_lang_js_minTimeOfDay(this.minDate), this.maxDate]];
	        this.$refs.maxSpinner.selectableRange = [[this.minDate, time_rangevue_type_script_lang_js_maxTimeOfDay(this.maxDate)]];
	        this.$emit('pick', [this.minDate, this.maxDate], true);
	      }
	    },
	    setMinSelectionRange: function setMinSelectionRange(start, end) {
	      this.$emit('select-range', start, end, 'min');
	      this.selectionRange = [start, end];
	    },
	    setMaxSelectionRange: function setMaxSelectionRange(start, end) {
	      this.$emit('select-range', start, end, 'max');
	      this.selectionRange = [start + this.offset, end + this.offset];
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var minSelectableRange = this.$refs.minSpinner.selectableRange;
	      var maxSelectableRange = this.$refs.maxSpinner.selectableRange;
	
	      this.minDate = Object(date_util_["limitTimeRange"])(this.minDate, minSelectableRange, this.format);
	      this.maxDate = Object(date_util_["limitTimeRange"])(this.maxDate, maxSelectableRange, this.format);
	
	      this.$emit('pick', [this.minDate, this.maxDate], visible);
	    },
	    adjustSpinners: function adjustSpinners() {
	      this.$refs.minSpinner.adjustSpinners();
	      this.$refs.maxSpinner.adjustSpinners();
	    },
	    changeSelectionRange: function changeSelectionRange(step) {
	      var list = this.showSeconds ? [0, 3, 6, 11, 14, 17] : [0, 3, 8, 11];
	      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
	      var index = list.indexOf(this.selectionRange[0]);
	      var next = (index + step + list.length) % list.length;
	      var half = list.length / 2;
	      if (next < half) {
	        this.$refs.minSpinner.emitSelectRange(mapping[next]);
	      } else {
	        this.$refs.maxSpinner.emitSelectRange(mapping[next - half]);
	      }
	    },
	    isValidValue: function isValidValue(date) {
	      return Array.isArray(date) && Object(date_util_["timeWithinRange"])(this.minDate, this.$refs.minSpinner.selectableRange) && Object(date_util_["timeWithinRange"])(this.maxDate, this.$refs.maxSpinner.selectableRange);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      var mapping = { 38: -1, 40: 1, 37: -1, 39: 1 };
	
	      // Left or Right
	      if (keyCode === 37 || keyCode === 39) {
	        var step = mapping[keyCode];
	        this.changeSelectionRange(step);
	        event.preventDefault();
	        return;
	      }
	
	      // Up or Down
	      if (keyCode === 38 || keyCode === 40) {
	        var _step = mapping[keyCode];
	        this.spinner.scrollDown(_step);
	        event.preventDefault();
	        return;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_time_rangevue_type_script_lang_js_ = (time_rangevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue
	
	
	
	
	
	/* normalize component */
	
	var time_range_component = normalizeComponent(
	  panel_time_rangevue_type_script_lang_js_,
	  time_rangevue_type_template_id_fb28660e_render,
	  time_rangevue_type_template_id_fb28660e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_range_api; }
	time_range_component.options.__file = "packages/date-picker/src/panel/time-range.vue"
	/* harmony default export */ var time_range = (time_range_component.exports);
	// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-picker.js
	
	
	
	
	/* harmony default export */ var time_picker = ({
	  mixins: [picker],
	
	  name: 'ElTimePicker',
	
	  props: {
	    isRange: Boolean,
	    arrowControl: Boolean
	  },
	
	  data: function data() {
	    return {
	      type: ''
	    };
	  },
	
	
	  watch: {
	    isRange: function isRange(_isRange) {
	      if (this.picker) {
	        this.unmountPicker();
	        this.type = _isRange ? 'timerange' : 'time';
	        this.panel = _isRange ? time_range : panel_time;
	        this.mountPicker();
	      } else {
	        this.type = _isRange ? 'timerange' : 'time';
	        this.panel = _isRange ? time_range : panel_time;
	      }
	    }
	  },
	
	  created: function created() {
	    this.type = this.isRange ? 'timerange' : 'time';
	    this.panel = this.isRange ? time_range : panel_time;
	  }
	});
	// CONCATENATED MODULE: ./packages/time-picker/index.js
	
	
	/* istanbul ignore next */
	time_picker.install = function (Vue) {
	  Vue.component(time_picker.name, time_picker);
	};
	
	/* harmony default export */ var packages_time_picker = (time_picker);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
	var mainvue_type_template_id_52060272_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "span",
	    [
	      _c(
	        "transition",
	        {
	          attrs: { name: _vm.transition },
	          on: {
	            "after-enter": _vm.handleAfterEnter,
	            "after-leave": _vm.handleAfterLeave
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.disabled && _vm.showPopper,
	                  expression: "!disabled && showPopper"
	                }
	              ],
	              ref: "popper",
	              staticClass: "el-popover el-popper",
	              class: [_vm.popperClass, _vm.content && "el-popover--plain"],
	              style: { width: _vm.width + "px" },
	              attrs: {
	                role: "tooltip",
	                id: _vm.tooltipId,
	                "aria-hidden":
	                  _vm.disabled || !_vm.showPopper ? "true" : "false"
	              }
	            },
	            [
	              _vm.title
	                ? _c("div", {
	                    staticClass: "el-popover__title",
	                    domProps: { textContent: _vm._s(_vm.title) }
	                  })
	                : _vm._e(),
	              _vm._t("default", [_vm._v(_vm._s(_vm.content))])
	            ],
	            2
	          )
	        ]
	      ),
	      _c(
	        "span",
	        { ref: "wrapper", staticClass: "el-popover__reference-wrapper" },
	        [_vm._t("reference")],
	        2
	      )
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_52060272_staticRenderFns = []
	mainvue_type_template_id_52060272_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var mainvue_type_script_lang_js_ = ({
	  name: 'ElPopover',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    trigger: {
	      type: String,
	      default: 'click',
	      validator: function validator(value) {
	        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
	      }
	    },
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    closeDelay: {
	      type: Number,
	      default: 200
	    },
	    title: String,
	    disabled: Boolean,
	    content: String,
	    reference: {},
	    popperClass: String,
	    width: {},
	    visibleArrow: {
	      default: true
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    transition: {
	      type: String,
	      default: 'fade-in-linear'
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  computed: {
	    tooltipId: function tooltipId() {
	      return 'el-popover-' + Object(util_["generateId"])();
	    }
	  },
	  watch: {
	    showPopper: function showPopper(val) {
	      if (this.disabled) {
	        return;
	      }
	      val ? this.$emit('show') : this.$emit('hide');
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var reference = this.referenceElm = this.reference || this.$refs.reference;
	    var popper = this.popper || this.$refs.popper;
	
	    if (!reference && this.$refs.wrapper.children) {
	      reference = this.referenceElm = this.$refs.wrapper.children[0];
	    }
	    // 可访问性
	    if (reference) {
	      Object(dom_["addClass"])(reference, 'el-popover__reference');
	      reference.setAttribute('aria-describedby', this.tooltipId);
	      reference.setAttribute('tabindex', this.tabindex); // tab序列
	      popper.setAttribute('tabindex', 0);
	
	      if (this.trigger !== 'click') {
	        Object(dom_["on"])(reference, 'focusin', function () {
	          _this.handleFocus();
	          var instance = reference.__vue__;
	          if (instance && typeof instance.focus === 'function') {
	            instance.focus();
	          }
	        });
	        Object(dom_["on"])(popper, 'focusin', this.handleFocus);
	        Object(dom_["on"])(reference, 'focusout', this.handleBlur);
	        Object(dom_["on"])(popper, 'focusout', this.handleBlur);
	      }
	      Object(dom_["on"])(reference, 'keydown', this.handleKeydown);
	      Object(dom_["on"])(reference, 'click', this.handleClick);
	    }
	    if (this.trigger === 'click') {
	      Object(dom_["on"])(reference, 'click', this.doToggle);
	      Object(dom_["on"])(document, 'click', this.handleDocumentClick);
	    } else if (this.trigger === 'hover') {
	      Object(dom_["on"])(reference, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(popper, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(reference, 'mouseleave', this.handleMouseLeave);
	      Object(dom_["on"])(popper, 'mouseleave', this.handleMouseLeave);
	    } else if (this.trigger === 'focus') {
	      if (this.tabindex < 0) {
	        console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');
	      }
	      if (reference.querySelector('input, textarea')) {
	        Object(dom_["on"])(reference, 'focusin', this.doShow);
	        Object(dom_["on"])(reference, 'focusout', this.doClose);
	      } else {
	        Object(dom_["on"])(reference, 'mousedown', this.doShow);
	        Object(dom_["on"])(reference, 'mouseup', this.doClose);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.cleanup();
	  },
	  deactivated: function deactivated() {
	    this.cleanup();
	  },
	
	
	  methods: {
	    doToggle: function doToggle() {
	      this.showPopper = !this.showPopper;
	    },
	    doShow: function doShow() {
	      this.showPopper = true;
	    },
	    doClose: function doClose() {
	      this.showPopper = false;
	    },
	    handleFocus: function handleFocus() {
	      Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = true;
	    },
	    handleClick: function handleClick() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	    },
	    handleBlur: function handleBlur() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = false;
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      var _this2 = this;
	
	      clearTimeout(this._timer);
	      if (this.openDelay) {
	        this._timer = setTimeout(function () {
	          _this2.showPopper = true;
	        }, this.openDelay);
	      } else {
	        this.showPopper = true;
	      }
	    },
	    handleKeydown: function handleKeydown(ev) {
	      if (ev.keyCode === 27 && this.trigger !== 'manual') {
	        // esc
	        this.doClose();
	      }
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      var _this3 = this;
	
	      clearTimeout(this._timer);
	      if (this.closeDelay) {
	        this._timer = setTimeout(function () {
	          _this3.showPopper = false;
	        }, this.closeDelay);
	      } else {
	        this.showPopper = false;
	      }
	    },
	    handleDocumentClick: function handleDocumentClick(e) {
	      var reference = this.reference || this.$refs.reference;
	      var popper = this.popper || this.$refs.popper;
	
	      if (!reference && this.$refs.wrapper.children) {
	        reference = this.referenceElm = this.$refs.wrapper.children[0];
	      }
	      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
	      this.showPopper = false;
	    },
	    handleAfterEnter: function handleAfterEnter() {
	      this.$emit('after-enter');
	    },
	    handleAfterLeave: function handleAfterLeave() {
	      this.$emit('after-leave');
	      this.doDestroy();
	    },
	    cleanup: function cleanup() {
	      if (this.openDelay || this.closeDelay) {
	        clearTimeout(this._timer);
	      }
	    }
	  },
	
	  destroyed: function destroyed() {
	    var reference = this.reference;
	
	    Object(dom_["off"])(reference, 'click', this.doToggle);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'focusin', this.doShow);
	    Object(dom_["off"])(reference, 'focusout', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mouseleave', this.handleMouseLeave);
	    Object(dom_["off"])(reference, 'mouseenter', this.handleMouseEnter);
	    Object(dom_["off"])(document, 'click', this.handleDocumentClick);
	  }
	});
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/popover/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var main_component = normalizeComponent(
	  src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_52060272_render,
	  mainvue_type_template_id_52060272_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var main_api; }
	main_component.options.__file = "packages/popover/src/main.vue"
	/* harmony default export */ var main = (main_component.exports);
	// CONCATENATED MODULE: ./packages/popover/src/directive.js
	var getReference = function getReference(el, binding, vnode) {
	  var _ref = binding.expression ? binding.value : binding.arg;
	  var popper = vnode.context.$refs[_ref];
	  if (popper) {
	    if (Array.isArray(popper)) {
	      popper[0].$refs.reference = el;
	    } else {
	      popper.$refs.reference = el;
	    }
	  }
	};
	
	/* harmony default export */ var directive = ({
	  bind: function bind(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  },
	  inserted: function inserted(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  }
	});
	// CONCATENATED MODULE: ./packages/popover/index.js
	
	
	
	
	external_vue_default.a.directive('popover', directive);
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.directive('popover', directive);
	  Vue.component(main.name, main);
	};
	main.directive = directive;
	
	/* harmony default export */ var popover = (main);
	// CONCATENATED MODULE: ./packages/tooltip/src/main.js
	
	
	
	
	
	
	/* harmony default export */ var src_main = ({
	  name: 'ElTooltip',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    disabled: Boolean,
	    manual: Boolean,
	    effect: {
	      type: String,
	      default: 'dark'
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    popperClass: String,
	    content: String,
	    visibleArrow: {
	      default: true
	    },
	    transition: {
	      type: String,
	      default: 'el-fade-in-linear'
	    },
	    popperOptions: {
	      default: function _default() {
	        return {
	          boundariesPadding: 10,
	          gpuAcceleration: false
	        };
	      }
	    },
	    enterable: {
	      type: Boolean,
	      default: true
	    },
	    hideAfter: {
	      type: Number,
	      default: 0
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      tooltipId: 'el-tooltip-' + Object(util_["generateId"])(),
	      timeoutPending: null,
	      focusing: false
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    if (this.$isServer) return;
	
	    this.popperVM = new external_vue_default.a({
	      data: { node: '' },
	      render: function render(h) {
	        return this.node;
	      }
	    }).$mount();
	
	    this.debounceClose = debounce_default()(200, function () {
	      return _this.handleClosePopper();
	    });
	  },
	  render: function render(h) {
	    var _this2 = this;
	
	    if (this.popperVM) {
	      this.popperVM.node = h(
	        'transition',
	        {
	          attrs: {
	            name: this.transition
	          },
	          on: {
	            'afterLeave': this.doDestroy
	          }
	        },
	        [h(
	          'div',
	          {
	            on: {
	              'mouseleave': function mouseleave() {
	                _this2.setExpectedState(false);_this2.debounceClose();
	              },
	              'mouseenter': function mouseenter() {
	                _this2.setExpectedState(true);
	              }
	            },
	
	            ref: 'popper',
	            attrs: { role: 'tooltip',
	              id: this.tooltipId,
	              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
	            },
	            directives: [{
	              name: 'show',
	              value: !this.disabled && this.showPopper
	            }],
	
	            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] },
	          [this.$slots.content || this.content]
	        )]
	      );
	    }
	
	    var firstElement = this.getFirstElement();
	    if (!firstElement) return null;
	
	    var data = firstElement.data = firstElement.data || {};
	    data.staticClass = this.addTooltipClass(data.staticClass);
	
	    return firstElement;
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.referenceElm = this.$el;
	    if (this.$el.nodeType === 1) {
	      this.$el.setAttribute('aria-describedby', this.tooltipId);
	      this.$el.setAttribute('tabindex', this.tabindex);
	      Object(dom_["on"])(this.referenceElm, 'mouseenter', this.show);
	      Object(dom_["on"])(this.referenceElm, 'mouseleave', this.hide);
	      Object(dom_["on"])(this.referenceElm, 'focus', function () {
	        if (!_this3.$slots.default || !_this3.$slots.default.length) {
	          _this3.handleFocus();
	          return;
	        }
	        var instance = _this3.$slots.default[0].componentInstance;
	        if (instance && instance.focus) {
	          instance.focus();
	        } else {
	          _this3.handleFocus();
	        }
	      });
	      Object(dom_["on"])(this.referenceElm, 'blur', this.handleBlur);
	      Object(dom_["on"])(this.referenceElm, 'click', this.removeFocusing);
	    }
	    // fix issue https://github.com/ElemeFE/element/issues/14424
	    if (this.value && this.popperVM) {
	      this.popperVM.$nextTick(function () {
	        if (_this3.value) {
	          _this3.updatePopper();
	        }
	      });
	    }
	  },
	
	  watch: {
	    focusing: function focusing(val) {
	      if (val) {
	        Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      } else {
	        Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      }
	    }
	  },
	  methods: {
	    show: function show() {
	      this.setExpectedState(true);
	      this.handleShowPopper();
	    },
	    hide: function hide() {
	      this.setExpectedState(false);
	      this.debounceClose();
	    },
	    handleFocus: function handleFocus() {
	      this.focusing = true;
	      this.show();
	    },
	    handleBlur: function handleBlur() {
	      this.focusing = false;
	      this.hide();
	    },
	    removeFocusing: function removeFocusing() {
	      this.focusing = false;
	    },
	    addTooltipClass: function addTooltipClass(prev) {
	      if (!prev) {
	        return 'el-tooltip';
	      } else {
	        return 'el-tooltip ' + prev.replace('el-tooltip', '');
	      }
	    },
	    handleShowPopper: function handleShowPopper() {
	      var _this4 = this;
	
	      if (!this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this4.showPopper = true;
	      }, this.openDelay);
	
	      if (this.hideAfter > 0) {
	        this.timeoutPending = setTimeout(function () {
	          _this4.showPopper = false;
	        }, this.hideAfter);
	      }
	    },
	    handleClosePopper: function handleClosePopper() {
	      if (this.enterable && this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	
	      if (this.timeoutPending) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.showPopper = false;
	
	      if (this.disabled) {
	        this.doDestroy();
	      }
	    },
	    setExpectedState: function setExpectedState(expectedState) {
	      if (expectedState === false) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.expectedState = expectedState;
	    },
	    getFirstElement: function getFirstElement() {
	      var slots = this.$slots.default;
	      if (!Array.isArray(slots)) return null;
	      var element = null;
	      for (var index = 0; index < slots.length; index++) {
	        if (slots[index] && slots[index].tag) {
	          element = slots[index];
	        };
	      }
	      return element;
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.popperVM && this.popperVM.$destroy();
	  },
	  destroyed: function destroyed() {
	    var reference = this.referenceElm;
	    if (reference.nodeType === 1) {
	      Object(dom_["off"])(reference, 'mouseenter', this.show);
	      Object(dom_["off"])(reference, 'mouseleave', this.hide);
	      Object(dom_["off"])(reference, 'focus', this.handleFocus);
	      Object(dom_["off"])(reference, 'blur', this.handleBlur);
	      Object(dom_["off"])(reference, 'click', this.removeFocusing);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tooltip/index.js
	
	
	/* istanbul ignore next */
	src_main.install = function (Vue) {
	  Vue.component(src_main.name, src_main);
	};
	
	/* harmony default export */ var packages_tooltip = (src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
	var mainvue_type_template_id_6b29b012_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "msgbox-fade" } }, [
	    _c(
	      "div",
	      {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.visible,
	            expression: "visible"
	          }
	        ],
	        staticClass: "el-message-box__wrapper",
	        attrs: {
	          tabindex: "-1",
	          role: "dialog",
	          "aria-modal": "true",
	          "aria-label": _vm.title || "dialog"
	        },
	        on: {
	          click: function($event) {
	            if ($event.target !== $event.currentTarget) {
	              return null
	            }
	            return _vm.handleWrapperClick($event)
	          }
	        }
	      },
	      [
	        _c(
	          "div",
	          {
	            staticClass: "el-message-box",
	            class: [_vm.customClass, _vm.center && "el-message-box--center"]
	          },
	          [
	            _vm.title !== null
	              ? _c("div", { staticClass: "el-message-box__header" }, [
	                  _c("div", { staticClass: "el-message-box__title" }, [
	                    _vm.icon && _vm.center
	                      ? _c("div", {
	                          class: ["el-message-box__status", _vm.icon]
	                        })
	                      : _vm._e(),
	                    _c("span", [_vm._v(_vm._s(_vm.title))])
	                  ]),
	                  _vm.showClose
	                    ? _c(
	                        "button",
	                        {
	                          staticClass: "el-message-box__headerbtn",
	                          attrs: { type: "button", "aria-label": "Close" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleAction(
	                                _vm.distinguishCancelAndClose
	                                  ? "close"
	                                  : "cancel"
	                              )
	                            },
	                            keydown: function($event) {
	                              if (
	                                !("button" in $event) &&
	                                _vm._k(
	                                  $event.keyCode,
	                                  "enter",
	                                  13,
	                                  $event.key,
	                                  "Enter"
	                                )
	                              ) {
	                                return null
	                              }
	                              _vm.handleAction(
	                                _vm.distinguishCancelAndClose
	                                  ? "close"
	                                  : "cancel"
	                              )
	                            }
	                          }
	                        },
	                        [
	                          _c("i", {
	                            staticClass: "el-message-box__close el-icon-close"
	                          })
	                        ]
	                      )
	                    : _vm._e()
	                ])
	              : _vm._e(),
	            _c("div", { staticClass: "el-message-box__content" }, [
	              _c("div", { staticClass: "el-message-box__container" }, [
	                _vm.icon && !_vm.center && _vm.message !== ""
	                  ? _c("div", { class: ["el-message-box__status", _vm.icon] })
	                  : _vm._e(),
	                _vm.message !== ""
	                  ? _c(
	                      "div",
	                      { staticClass: "el-message-box__message" },
	                      [
	                        _vm._t("default", [
	                          !_vm.dangerouslyUseHTMLString
	                            ? _c("p", [_vm._v(_vm._s(_vm.message))])
	                            : _c("p", {
	                                domProps: { innerHTML: _vm._s(_vm.message) }
	                              })
	                        ])
	                      ],
	                      2
	                    )
	                  : _vm._e()
	              ]),
	              _c(
	                "div",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.showInput,
	                      expression: "showInput"
	                    }
	                  ],
	                  staticClass: "el-message-box__input"
	                },
	                [
	                  _c("el-input", {
	                    ref: "input",
	                    attrs: {
	                      type: _vm.inputType,
	                      placeholder: _vm.inputPlaceholder
	                    },
	                    nativeOn: {
	                      keydown: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "enter",
	                            13,
	                            $event.key,
	                            "Enter"
	                          )
	                        ) {
	                          return null
	                        }
	                        return _vm.handleInputEnter($event)
	                      }
	                    },
	                    model: {
	                      value: _vm.inputValue,
	                      callback: function($$v) {
	                        _vm.inputValue = $$v
	                      },
	                      expression: "inputValue"
	                    }
	                  }),
	                  _c(
	                    "div",
	                    {
	                      staticClass: "el-message-box__errormsg",
	                      style: {
	                        visibility: !!_vm.editorErrorMessage
	                          ? "visible"
	                          : "hidden"
	                      }
	                    },
	                    [_vm._v(_vm._s(_vm.editorErrorMessage))]
	                  )
	                ],
	                1
	              )
	            ]),
	            _c(
	              "div",
	              { staticClass: "el-message-box__btns" },
	              [
	                _vm.showCancelButton
	                  ? _c(
	                      "el-button",
	                      {
	                        class: [_vm.cancelButtonClasses],
	                        attrs: {
	                          loading: _vm.cancelButtonLoading,
	                          round: _vm.roundButton,
	                          size: "small"
	                        },
	                        on: {
	                          keydown: function($event) {
	                            if (
	                              !("button" in $event) &&
	                              _vm._k(
	                                $event.keyCode,
	                                "enter",
	                                13,
	                                $event.key,
	                                "Enter"
	                              )
	                            ) {
	                              return null
	                            }
	                            _vm.handleAction("cancel")
	                          }
	                        },
	                        nativeOn: {
	                          click: function($event) {
	                            _vm.handleAction("cancel")
	                          }
	                        }
	                      },
	                      [
	                        _vm._v(
	                          "\n          " +
	                            _vm._s(
	                              _vm.cancelButtonText ||
	                                _vm.t("el.messagebox.cancel")
	                            ) +
	                            "\n        "
	                        )
	                      ]
	                    )
	                  : _vm._e(),
	                _c(
	                  "el-button",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value: _vm.showConfirmButton,
	                        expression: "showConfirmButton"
	                      }
	                    ],
	                    ref: "confirm",
	                    class: [_vm.confirmButtonClasses],
	                    attrs: {
	                      loading: _vm.confirmButtonLoading,
	                      round: _vm.roundButton,
	                      size: "small"
	                    },
	                    on: {
	                      keydown: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "enter",
	                            13,
	                            $event.key,
	                            "Enter"
	                          )
	                        ) {
	                          return null
	                        }
	                        _vm.handleAction("confirm")
	                      }
	                    },
	                    nativeOn: {
	                      click: function($event) {
	                        _vm.handleAction("confirm")
	                      }
	                    }
	                  },
	                  [
	                    _vm._v(
	                      "\n          " +
	                        _vm._s(
	                          _vm.confirmButtonText ||
	                            _vm.t("el.messagebox.confirm")
	                        ) +
	                        "\n        "
	                    )
	                  ]
	                )
	              ],
	              1
	            )
	          ]
	        )
	      ]
	    )
	  ])
	}
	var mainvue_type_template_id_6b29b012_staticRenderFns = []
	mainvue_type_template_id_6b29b012_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
	
	// EXTERNAL MODULE: external "element-ui/lib/locale"
	var lib_locale_ = __webpack_require__(15);
	var lib_locale_default = /*#__PURE__*/__webpack_require__.n(lib_locale_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/aria-dialog"
	var aria_dialog_ = __webpack_require__(39);
	var aria_dialog_default = /*#__PURE__*/__webpack_require__.n(aria_dialog_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	var messageBox = void 0;
	var typeMap = {
	  success: 'success',
	  info: 'info',
	  warning: 'warning',
	  error: 'error'
	};
	
	/* harmony default export */ var message_box_src_mainvue_type_script_lang_js_ = ({
	  mixins: [popup_default.a, locale_default.a],
	
	  props: {
	    modal: {
	      default: true
	    },
	    lockScroll: {
	      default: true
	    },
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	    closeOnClickModal: {
	      default: true
	    },
	    closeOnPressEscape: {
	      default: true
	    },
	    closeOnHashChange: {
	      default: true
	    },
	    center: {
	      default: false,
	      type: Boolean
	    },
	    roundButton: {
	      default: false,
	      type: Boolean
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElButton: button_default.a
	  },
	
	  computed: {
	    icon: function icon() {
	      var type = this.type,
	          iconClass = this.iconClass;
	
	      return iconClass || (type && typeMap[type] ? 'el-icon-' + typeMap[type] : '');
	    },
	    confirmButtonClasses: function confirmButtonClasses() {
	      return 'el-button--primary ' + this.confirmButtonClass;
	    },
	    cancelButtonClasses: function cancelButtonClasses() {
	      return '' + this.cancelButtonClass;
	    }
	  },
	
	  methods: {
	    getSafeClose: function getSafeClose() {
	      var _this = this;
	
	      var currentId = this.uid;
	      return function () {
	        _this.$nextTick(function () {
	          if (currentId === _this.uid) _this.doClose();
	        });
	      };
	    },
	    doClose: function doClose() {
	      var _this2 = this;
	
	      if (!this.visible) return;
	      this.visible = false;
	      this._closing = true;
	
	      this.onClose && this.onClose();
	      messageBox.closeDialog(); // 解绑
	      if (this.lockScroll) {
	        setTimeout(this.restoreBodyStyle, 200);
	      }
	      this.opened = false;
	      this.doAfterClose();
	      setTimeout(function () {
	        if (_this2.action) _this2.callback(_this2.action, _this2);
	      });
	    },
	    handleWrapperClick: function handleWrapperClick() {
	      if (this.closeOnClickModal) {
	        this.handleAction(this.distinguishCancelAndClose ? 'close' : 'cancel');
	      }
	    },
	    handleInputEnter: function handleInputEnter() {
	      if (this.inputType !== 'textarea') {
	        return this.handleAction('confirm');
	      }
	    },
	    handleAction: function handleAction(action) {
	      if (this.$type === 'prompt' && action === 'confirm' && !this.validate()) {
	        return;
	      }
	      this.action = action;
	      if (typeof this.beforeClose === 'function') {
	        this.close = this.getSafeClose();
	        this.beforeClose(action, this, this.close);
	      } else {
	        this.doClose();
	      }
	    },
	    validate: function validate() {
	      if (this.$type === 'prompt') {
	        var inputPattern = this.inputPattern;
	        if (inputPattern && !inputPattern.test(this.inputValue || '')) {
	          this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])('el.messagebox.error');
	          Object(dom_["addClass"])(this.getInputElement(), 'invalid');
	          return false;
	        }
	        var inputValidator = this.inputValidator;
	        if (typeof inputValidator === 'function') {
	          var validateResult = inputValidator(this.inputValue);
	          if (validateResult === false) {
	            this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])('el.messagebox.error');
	            Object(dom_["addClass"])(this.getInputElement(), 'invalid');
	            return false;
	          }
	          if (typeof validateResult === 'string') {
	            this.editorErrorMessage = validateResult;
	            Object(dom_["addClass"])(this.getInputElement(), 'invalid');
	            return false;
	          }
	        }
	      }
	      this.editorErrorMessage = '';
	      Object(dom_["removeClass"])(this.getInputElement(), 'invalid');
	      return true;
	    },
	    getFirstFocus: function getFirstFocus() {
	      var btn = this.$el.querySelector('.el-message-box__btns .el-button');
	      var title = this.$el.querySelector('.el-message-box__btns .el-message-box__title');
	      return btn || title;
	    },
	    getInputElement: function getInputElement() {
	      var inputRefs = this.$refs.input.$refs;
	      return inputRefs.input || inputRefs.textarea;
	    },
	    handleClose: function handleClose() {
	      this.handleAction('close');
	    }
	  },
	
	  watch: {
	    inputValue: {
	      immediate: true,
	      handler: function handler(val) {
	        var _this3 = this;
	
	        this.$nextTick(function (_) {
	          if (_this3.$type === 'prompt' && val !== null) {
	            _this3.validate();
	          }
	        });
	      }
	    },
	
	    visible: function visible(val) {
	      var _this4 = this;
	
	      if (val) {
	        this.uid++;
	        if (this.$type === 'alert' || this.$type === 'confirm') {
	          this.$nextTick(function () {
	            _this4.$refs.confirm.$el.focus();
	          });
	        }
	        this.focusAfterClosed = document.activeElement;
	        messageBox = new aria_dialog_default.a(this.$el, this.focusAfterClosed, this.getFirstFocus());
	      }
	
	      // prompt
	      if (this.$type !== 'prompt') return;
	      if (val) {
	        setTimeout(function () {
	          if (_this4.$refs.input && _this4.$refs.input.$el) {
	            _this4.getInputElement().focus();
	          }
	        }, 500);
	      } else {
	        this.editorErrorMessage = '';
	        Object(dom_["removeClass"])(this.getInputElement(), 'invalid');
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    var _this5 = this;
	
	    this.$nextTick(function () {
	      if (_this5.closeOnHashChange) {
	        window.addEventListener('hashchange', _this5.close);
	      }
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.closeOnHashChange) {
	      window.removeEventListener('hashchange', this.close);
	    }
	    setTimeout(function () {
	      messageBox.closeDialog();
	    });
	  },
	  data: function data() {
	    return {
	      uid: 1,
	      title: undefined,
	      message: '',
	      type: '',
	      iconClass: '',
	      customClass: '',
	      showInput: false,
	      inputValue: null,
	      inputPlaceholder: '',
	      inputType: 'text',
	      inputPattern: null,
	      inputValidator: null,
	      inputErrorMessage: '',
	      showConfirmButton: true,
	      showCancelButton: false,
	      action: '',
	      confirmButtonText: '',
	      cancelButtonText: '',
	      confirmButtonLoading: false,
	      cancelButtonLoading: false,
	      confirmButtonClass: '',
	      confirmButtonDisabled: false,
	      cancelButtonClass: '',
	      editorErrorMessage: null,
	      callback: null,
	      dangerouslyUseHTMLString: false,
	      focusAfterClosed: null,
	      isOnComposition: false,
	      distinguishCancelAndClose: false
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_message_box_src_mainvue_type_script_lang_js_ = (message_box_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/message-box/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var src_main_component = normalizeComponent(
	  packages_message_box_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_6b29b012_render,
	  mainvue_type_template_id_6b29b012_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_main_api; }
	src_main_component.options.__file = "packages/message-box/src/main.vue"
	/* harmony default export */ var message_box_src_main = (src_main_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/utils/vdom"
	var vdom_ = __webpack_require__(23);
	
	// CONCATENATED MODULE: ./packages/message-box/src/main.js
	var main_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var main_defaults = {
	  title: null,
	  message: '',
	  type: '',
	  iconClass: '',
	  showInput: false,
	  showClose: true,
	  modalFade: true,
	  lockScroll: true,
	  closeOnClickModal: true,
	  closeOnPressEscape: true,
	  closeOnHashChange: true,
	  inputValue: null,
	  inputPlaceholder: '',
	  inputType: 'text',
	  inputPattern: null,
	  inputValidator: null,
	  inputErrorMessage: '',
	  showConfirmButton: true,
	  showCancelButton: false,
	  confirmButtonPosition: 'right',
	  confirmButtonHighlight: false,
	  cancelButtonHighlight: false,
	  confirmButtonText: '',
	  cancelButtonText: '',
	  confirmButtonClass: '',
	  cancelButtonClass: '',
	  customClass: '',
	  beforeClose: null,
	  dangerouslyUseHTMLString: false,
	  center: false,
	  roundButton: false,
	  distinguishCancelAndClose: false
	};
	
	
	
	
	
	
	var MessageBoxConstructor = external_vue_default.a.extend(message_box_src_main);
	
	var currentMsg = void 0,
	    main_instance = void 0;
	var msgQueue = [];
	
	var defaultCallback = function defaultCallback(action) {
	  if (currentMsg) {
	    var callback = currentMsg.callback;
	    if (typeof callback === 'function') {
	      if (main_instance.showInput) {
	        callback(main_instance.inputValue, action);
	      } else {
	        callback(action);
	      }
	    }
	    if (currentMsg.resolve) {
	      if (action === 'confirm') {
	        if (main_instance.showInput) {
	          currentMsg.resolve({ value: main_instance.inputValue, action: action });
	        } else {
	          currentMsg.resolve(action);
	        }
	      } else if (currentMsg.reject && (action === 'cancel' || action === 'close')) {
	        currentMsg.reject(action);
	      }
	    }
	  }
	};
	
	var initInstance = function initInstance() {
	  main_instance = new MessageBoxConstructor({
	    el: document.createElement('div')
	  });
	
	  main_instance.callback = defaultCallback;
	};
	
	var main_showNextMsg = function showNextMsg() {
	  if (!main_instance) {
	    initInstance();
	  }
	  main_instance.action = '';
	
	  if (!main_instance.visible || main_instance.closeTimer) {
	    if (msgQueue.length > 0) {
	      currentMsg = msgQueue.shift();
	
	      var options = currentMsg.options;
	      for (var prop in options) {
	        if (options.hasOwnProperty(prop)) {
	          main_instance[prop] = options[prop];
	        }
	      }
	      if (options.callback === undefined) {
	        main_instance.callback = defaultCallback;
	      }
	
	      var oldCb = main_instance.callback;
	      main_instance.callback = function (action, instance) {
	        oldCb(action, instance);
	        showNextMsg();
	      };
	      if (Object(vdom_["isVNode"])(main_instance.message)) {
	        main_instance.$slots.default = [main_instance.message];
	        main_instance.message = null;
	      } else {
	        delete main_instance.$slots.default;
	      }
	      ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape', 'closeOnHashChange'].forEach(function (prop) {
	        if (main_instance[prop] === undefined) {
	          main_instance[prop] = true;
	        }
	      });
	      document.body.appendChild(main_instance.$el);
	
	      external_vue_default.a.nextTick(function () {
	        main_instance.visible = true;
	      });
	    }
	  }
	};
	
	var main_MessageBox = function MessageBox(options, callback) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  if (typeof options === 'string' || Object(vdom_["isVNode"])(options)) {
	    options = {
	      message: options
	    };
	    if (typeof arguments[1] === 'string') {
	      options.title = arguments[1];
	    }
	  } else if (options.callback && !callback) {
	    callback = options.callback;
	  }
	
	  if (typeof Promise !== 'undefined') {
	    return new Promise(function (resolve, reject) {
	      // eslint-disable-line
	      msgQueue.push({
	        options: merge_default()({}, main_defaults, MessageBox.defaults, options),
	        callback: callback,
	        resolve: resolve,
	        reject: reject
	      });
	
	      main_showNextMsg();
	    });
	  } else {
	    msgQueue.push({
	      options: merge_default()({}, main_defaults, MessageBox.defaults, options),
	      callback: callback
	    });
	
	    main_showNextMsg();
	  }
	};
	
	main_MessageBox.setDefaults = function (defaults) {
	  main_MessageBox.defaults = defaults;
	};
	
	main_MessageBox.alert = function (message, title, options) {
	  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
	    options = title;
	    title = '';
	  } else if (title === undefined) {
	    title = '';
	  }
	  return main_MessageBox(merge_default()({
	    title: title,
	    message: message,
	    $type: 'alert',
	    closeOnPressEscape: false,
	    closeOnClickModal: false
	  }, options));
	};
	
	main_MessageBox.confirm = function (message, title, options) {
	  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
	    options = title;
	    title = '';
	  } else if (title === undefined) {
	    title = '';
	  }
	  return main_MessageBox(merge_default()({
	    title: title,
	    message: message,
	    $type: 'confirm',
	    showCancelButton: true
	  }, options));
	};
	
	main_MessageBox.prompt = function (message, title, options) {
	  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
	    options = title;
	    title = '';
	  } else if (title === undefined) {
	    title = '';
	  }
	  return main_MessageBox(merge_default()({
	    title: title,
	    message: message,
	    showCancelButton: true,
	    showInput: true,
	    $type: 'prompt'
	  }, options));
	};
	
	main_MessageBox.close = function () {
	  main_instance.doClose();
	  main_instance.visible = false;
	  msgQueue = [];
	  currentMsg = null;
	};
	
	/* harmony default export */ var packages_message_box_src_main = (main_MessageBox);
	
	// CONCATENATED MODULE: ./packages/message-box/index.js
	
	/* harmony default export */ var message_box = (packages_message_box_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&
	var breadcrumbvue_type_template_id_4b464c06_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-breadcrumb",
	      attrs: { "aria-label": "Breadcrumb", role: "navigation" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var breadcrumbvue_type_template_id_4b464c06_staticRenderFns = []
	breadcrumbvue_type_template_id_4b464c06_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var breadcrumbvue_type_script_lang_js_ = ({
	  name: 'ElBreadcrumb',
	
	  props: {
	    separator: {
	      type: String,
	      default: '/'
	    },
	    separatorClass: {
	      type: String,
	      default: ''
	    }
	  },
	
	  provide: function provide() {
	    return {
	      elBreadcrumb: this
	    };
	  },
	  mounted: function mounted() {
	    var items = this.$el.querySelectorAll('.el-breadcrumb__item');
	    if (items.length) {
	      items[items.length - 1].setAttribute('aria-current', 'page');
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_breadcrumbvue_type_script_lang_js_ = (breadcrumbvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue
	
	
	
	
	
	/* normalize component */
	
	var breadcrumb_component = normalizeComponent(
	  src_breadcrumbvue_type_script_lang_js_,
	  breadcrumbvue_type_template_id_4b464c06_render,
	  breadcrumbvue_type_template_id_4b464c06_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var breadcrumb_api; }
	breadcrumb_component.options.__file = "packages/breadcrumb/src/breadcrumb.vue"
	/* harmony default export */ var breadcrumb = (breadcrumb_component.exports);
	// CONCATENATED MODULE: ./packages/breadcrumb/index.js
	
	
	/* istanbul ignore next */
	breadcrumb.install = function (Vue) {
	  Vue.component(breadcrumb.name, breadcrumb);
	};
	
	/* harmony default export */ var packages_breadcrumb = (breadcrumb);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&
	var breadcrumb_itemvue_type_template_id_fcf9eaac_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("span", { staticClass: "el-breadcrumb__item" }, [
	    _c(
	      "span",
	      {
	        ref: "link",
	        class: ["el-breadcrumb__inner", _vm.to ? "is-link" : ""],
	        attrs: { role: "link" }
	      },
	      [_vm._t("default")],
	      2
	    ),
	    _vm.separatorClass
	      ? _c("i", {
	          staticClass: "el-breadcrumb__separator",
	          class: _vm.separatorClass
	        })
	      : _c(
	          "span",
	          {
	            staticClass: "el-breadcrumb__separator",
	            attrs: { role: "presentation" }
	          },
	          [_vm._v(_vm._s(_vm.separator))]
	        )
	  ])
	}
	var breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns = []
	breadcrumb_itemvue_type_template_id_fcf9eaac_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var breadcrumb_itemvue_type_script_lang_js_ = ({
	  name: 'ElBreadcrumbItem',
	  props: {
	    to: {},
	    replace: Boolean
	  },
	  data: function data() {
	    return {
	      separator: '',
	      separatorClass: ''
	    };
	  },
	
	
	  inject: ['elBreadcrumb'],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.separator = this.elBreadcrumb.separator;
	    this.separatorClass = this.elBreadcrumb.separatorClass;
	    var link = this.$refs.link;
	    link.setAttribute('role', 'link');
	    link.addEventListener('click', function (_) {
	      var to = _this.to,
	          $router = _this.$router;
	
	      if (!to || !$router) return;
	      _this.replace ? $router.replace(to) : $router.push(to);
	    });
	  }
	});
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_breadcrumb_itemvue_type_script_lang_js_ = (breadcrumb_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue
	
	
	
	
	
	/* normalize component */
	
	var breadcrumb_item_component = normalizeComponent(
	  src_breadcrumb_itemvue_type_script_lang_js_,
	  breadcrumb_itemvue_type_template_id_fcf9eaac_render,
	  breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var breadcrumb_item_api; }
	breadcrumb_item_component.options.__file = "packages/breadcrumb/src/breadcrumb-item.vue"
	/* harmony default export */ var breadcrumb_item = (breadcrumb_item_component.exports);
	// CONCATENATED MODULE: ./packages/breadcrumb-item/index.js
	
	
	/* istanbul ignore next */
	breadcrumb_item.install = function (Vue) {
	  Vue.component(breadcrumb_item.name, breadcrumb_item);
	};
	
	/* harmony default export */ var packages_breadcrumb_item = (breadcrumb_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
	var formvue_type_template_id_a1b5ff34_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "form",
	    {
	      staticClass: "el-form",
	      class: [
	        _vm.labelPosition ? "el-form--label-" + _vm.labelPosition : "",
	        { "el-form--inline": _vm.inline }
	      ]
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var formvue_type_template_id_a1b5ff34_staticRenderFns = []
	formvue_type_template_id_a1b5ff34_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var formvue_type_script_lang_js_ = ({
	  name: 'ElForm',
	
	  componentName: 'ElForm',
	
	  provide: function provide() {
	    return {
	      elForm: this
	    };
	  },
	
	
	  props: {
	    model: Object,
	    rules: Object,
	    labelPosition: String,
	    labelWidth: String,
	    labelSuffix: {
	      type: String,
	      default: ''
	    },
	    inline: Boolean,
	    inlineMessage: Boolean,
	    statusIcon: Boolean,
	    showMessage: {
	      type: Boolean,
	      default: true
	    },
	    size: String,
	    disabled: Boolean,
	    validateOnRuleChange: {
	      type: Boolean,
	      default: true
	    },
	    hideRequiredAsterisk: {
	      type: Boolean,
	      default: false
	    }
	  },
	  watch: {
	    rules: function rules() {
	      // remove then add event listeners on form-item after form rules change
	      this.fields.forEach(function (field) {
	        field.removeValidateEvents();
	        field.addValidateEvents();
	      });
	
	      if (this.validateOnRuleChange) {
	        this.validate(function () {});
	      }
	    }
	  },
	  computed: {
	    autoLabelWidth: function autoLabelWidth() {
	      if (!this.potentialLabelWidthArr.length) return 0;
	      var max = Math.max.apply(Math, this.potentialLabelWidthArr);
	      return max ? max + 'px' : '';
	    }
	  },
	  data: function data() {
	    return {
	      fields: [],
	      potentialLabelWidthArr: [] // use this array to calculate auto width
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.$on('el.form.addField', function (field) {
	      if (field) {
	        _this.fields.push(field);
	      }
	    });
	    /* istanbul ignore next */
	    this.$on('el.form.removeField', function (field) {
	      if (field.prop) {
	        _this.fields.splice(_this.fields.indexOf(field), 1);
	      }
	    });
	  },
	
	  methods: {
	    resetFields: function resetFields() {
	      if (!this.model) {
	        console.warn('[Element Warn][Form]model is required for resetFields to work.');
	        return;
	      }
	      this.fields.forEach(function (field) {
	        field.resetField();
	      });
	    },
	    clearValidate: function clearValidate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var fields = props.length ? typeof props === 'string' ? this.fields.filter(function (field) {
	        return props === field.prop;
	      }) : this.fields.filter(function (field) {
	        return props.indexOf(field.prop) > -1;
	      }) : this.fields;
	      fields.forEach(function (field) {
	        field.clearValidate();
	      });
	    },
	    validate: function validate(callback) {
	      var _this2 = this;
	
	      if (!this.model) {
	        console.warn('[Element Warn][Form]model is required for validate to work!');
	        return;
	      }
	
	      var promise = void 0;
	      // if no callback, return promise
	      if (typeof callback !== 'function' && window.Promise) {
	        promise = new window.Promise(function (resolve, reject) {
	          callback = function callback(valid) {
	            valid ? resolve(valid) : reject(valid);
	          };
	        });
	      }
	
	      var valid = true;
	      var count = 0;
	      // 如果需要验证的fields为空，调用验证时立刻返回callback
	      if (this.fields.length === 0 && callback) {
	        callback(true);
	      }
	      var invalidFields = {};
	      this.fields.forEach(function (field) {
	        field.validate('', function (message, field) {
	          if (message) {
	            valid = false;
	          }
	          invalidFields = merge_default()({}, invalidFields, field);
	          if (typeof callback === 'function' && ++count === _this2.fields.length) {
	            callback(valid, invalidFields);
	          }
	        });
	      });
	
	      if (promise) {
	        return promise;
	      }
	    },
	    validateField: function validateField(props, cb) {
	      props = [].concat(props);
	      var fields = this.fields.filter(function (field) {
	        return props.indexOf(field.prop) !== -1;
	      });
	      if (!fields.length) {
	        console.warn('[Element Warn]please pass correct props!');
	        return;
	      }
	
	      fields.forEach(function (field) {
	        field.validate('', cb);
	      });
	    },
	    getLabelWidthIndex: function getLabelWidthIndex(width) {
	      var index = this.potentialLabelWidthArr.indexOf(width);
	      // it's impossible
	      if (index === -1) {
	        throw new Error('[ElementForm]unpected width ', width);
	      }
	      return index;
	    },
	    registerLabelWidth: function registerLabelWidth(val, oldVal) {
	      if (val && oldVal) {
	        var index = this.getLabelWidthIndex(oldVal);
	        this.potentialLabelWidthArr.splice(index, 1, val);
	      } else if (val) {
	        this.potentialLabelWidthArr.push(val);
	      }
	    },
	    deregisterLabelWidth: function deregisterLabelWidth(val) {
	      var index = this.getLabelWidthIndex(val);
	      this.potentialLabelWidthArr.splice(index, 1);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_formvue_type_script_lang_js_ = (formvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/form/src/form.vue
	
	
	
	
	
	/* normalize component */
	
	var form_component = normalizeComponent(
	  src_formvue_type_script_lang_js_,
	  formvue_type_template_id_a1b5ff34_render,
	  formvue_type_template_id_a1b5ff34_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var form_api; }
	form_component.options.__file = "packages/form/src/form.vue"
	/* harmony default export */ var src_form = (form_component.exports);
	// CONCATENATED MODULE: ./packages/form/index.js
	
	
	/* istanbul ignore next */
	src_form.install = function (Vue) {
	  Vue.component(src_form.name, src_form);
	};
	
	/* harmony default export */ var packages_form = (src_form);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
	var form_itemvue_type_template_id_b6f3db6c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-form-item",
	      class: [
	        {
	          "el-form-item--feedback": _vm.elForm && _vm.elForm.statusIcon,
	          "is-error": _vm.validateState === "error",
	          "is-validating": _vm.validateState === "validating",
	          "is-success": _vm.validateState === "success",
	          "is-required": _vm.isRequired || _vm.required,
	          "is-no-asterisk": _vm.elForm && _vm.elForm.hideRequiredAsterisk
	        },
	        _vm.sizeClass ? "el-form-item--" + _vm.sizeClass : ""
	      ]
	    },
	    [
	      _c(
	        "label-wrap",
	        {
	          attrs: {
	            "is-auto-width": _vm.labelStyle && _vm.labelStyle.width === "auto",
	            "update-all": _vm.form.labelWidth === "auto"
	          }
	        },
	        [
	          _vm.label || _vm.$slots.label
	            ? _c(
	                "label",
	                {
	                  staticClass: "el-form-item__label",
	                  style: _vm.labelStyle,
	                  attrs: { for: _vm.labelFor }
	                },
	                [
	                  _vm._t("label", [
	                    _vm._v(_vm._s(_vm.label + _vm.form.labelSuffix))
	                  ])
	                ],
	                2
	              )
	            : _vm._e()
	        ]
	      ),
	      _c(
	        "div",
	        { staticClass: "el-form-item__content", style: _vm.contentStyle },
	        [
	          _vm._t("default"),
	          _c(
	            "transition",
	            { attrs: { name: "el-zoom-in-top" } },
	            [
	              _vm.validateState === "error" &&
	              _vm.showMessage &&
	              _vm.form.showMessage
	                ? _vm._t(
	                    "error",
	                    [
	                      _c(
	                        "div",
	                        {
	                          staticClass: "el-form-item__error",
	                          class: {
	                            "el-form-item__error--inline":
	                              typeof _vm.inlineMessage === "boolean"
	                                ? _vm.inlineMessage
	                                : (_vm.elForm && _vm.elForm.inlineMessage) ||
	                                  false
	                          }
	                        },
	                        [
	                          _vm._v(
	                            "\n          " +
	                              _vm._s(_vm.validateMessage) +
	                              "\n        "
	                          )
	                        ]
	                      )
	                    ],
	                    { error: _vm.validateMessage }
	                  )
	                : _vm._e()
	            ],
	            2
	          )
	        ],
	        2
	      )
	    ],
	    1
	  )
	}
	var form_itemvue_type_template_id_b6f3db6c_staticRenderFns = []
	form_itemvue_type_template_id_b6f3db6c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
	
	// EXTERNAL MODULE: external "async-validator"
	var external_async_validator_ = __webpack_require__(40);
	var external_async_validator_default = /*#__PURE__*/__webpack_require__.n(external_async_validator_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
	
	
	/* harmony default export */ var label_wrapvue_type_script_lang_js_ = ({
	  props: {
	    isAutoWidth: Boolean,
	    updateAll: Boolean
	  },
	
	  inject: ['elForm', 'elFormItem'],
	
	  render: function render() {
	    var h = arguments[0];
	
	    var slots = this.$slots.default;
	    if (!slots) return null;
	    if (this.isAutoWidth) {
	      var autoLabelWidth = this.elForm.autoLabelWidth;
	      var style = {};
	      if (autoLabelWidth && autoLabelWidth !== 'auto') {
	        var marginLeft = parseInt(autoLabelWidth, 10) - this.computedWidth;
	        if (marginLeft) {
	          style.marginLeft = marginLeft + 'px';
	        }
	      }
	      return h(
	        'div',
	        { 'class': 'el-form-item__label-wrap', style: style },
	        [slots]
	      );
	    } else {
	      return slots[0];
	    }
	  },
	
	
	  methods: {
	    getLabelWidth: function getLabelWidth() {
	      if (this.$el && this.$el.firstElementChild) {
	        var computedWidth = window.getComputedStyle(this.$el.firstElementChild).width;
	        return Math.ceil(parseFloat(computedWidth));
	      } else {
	        return 0;
	      }
	    },
	    updateLabelWidth: function updateLabelWidth() {
	      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'update';
	
	      if (this.$slots.default && this.isAutoWidth && this.$el.firstElementChild) {
	        if (action === 'update') {
	          this.computedWidth = this.getLabelWidth();
	        } else if (action === 'remove') {
	          this.elForm.deregisterLabelWidth(this.computedWidth);
	        }
	      }
	    }
	  },
	
	  watch: {
	    computedWidth: function computedWidth(val, oldVal) {
	      if (this.updateAll) {
	        this.elForm.registerLabelWidth(val, oldVal);
	        this.elFormItem.updateComputedLabelWidth(val);
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      computedWidth: 0
	    };
	  },
	  mounted: function mounted() {
	    this.updateLabelWidth('update');
	  },
	  updated: function updated() {
	    this.updateLabelWidth('update');
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.updateLabelWidth('remove');
	  }
	});
	// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_label_wrapvue_type_script_lang_js_ = (label_wrapvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue
	var label_wrap_render, label_wrap_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var label_wrap_component = normalizeComponent(
	  src_label_wrapvue_type_script_lang_js_,
	  label_wrap_render,
	  label_wrap_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var label_wrap_api; }
	label_wrap_component.options.__file = "packages/form/src/label-wrap.vue"
	/* harmony default export */ var label_wrap = (label_wrap_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var form_itemvue_type_script_lang_js_ = ({
	  name: 'ElFormItem',
	
	  componentName: 'ElFormItem',
	
	  mixins: [emitter_default.a],
	
	  provide: function provide() {
	    return {
	      elFormItem: this
	    };
	  },
	
	
	  inject: ['elForm'],
	
	  props: {
	    label: String,
	    labelWidth: String,
	    prop: String,
	    required: {
	      type: Boolean,
	      default: undefined
	    },
	    rules: [Object, Array],
	    error: String,
	    validateStatus: String,
	    for: String,
	    inlineMessage: {
	      type: [String, Boolean],
	      default: ''
	    },
	    showMessage: {
	      type: Boolean,
	      default: true
	    },
	    size: String
	  },
	  components: {
	    // use this component to calculate auto width
	    LabelWrap: label_wrap
	  },
	  watch: {
	    error: {
	      immediate: true,
	      handler: function handler(value) {
	        this.validateMessage = value;
	        this.validateState = value ? 'error' : '';
	      }
	    },
	    validateStatus: function validateStatus(value) {
	      this.validateState = value;
	    }
	  },
	  computed: {
	    labelFor: function labelFor() {
	      return this.for || this.prop;
	    },
	    labelStyle: function labelStyle() {
	      var ret = {};
	      if (this.form.labelPosition === 'top') return ret;
	      var labelWidth = this.labelWidth || this.form.labelWidth;
	      if (labelWidth) {
	        ret.width = labelWidth;
	      }
	      return ret;
	    },
	    contentStyle: function contentStyle() {
	      var ret = {};
	      var label = this.label;
	      if (this.form.labelPosition === 'top' || this.form.inline) return ret;
	      if (!label && !this.labelWidth && this.isNested) return ret;
	      var labelWidth = this.labelWidth || this.form.labelWidth;
	      if (labelWidth === 'auto') {
	        if (this.labelWidth === 'auto') {
	          ret.marginLeft = this.computedLabelWidth;
	        } else if (this.form.labelWidth === 'auto') {
	          ret.marginLeft = this.elForm.autoLabelWidth;
	        }
	      } else {
	        ret.marginLeft = labelWidth;
	      }
	      return ret;
	    },
	    form: function form() {
	      var parent = this.$parent;
	      var parentName = parent.$options.componentName;
	      while (parentName !== 'ElForm') {
	        if (parentName === 'ElFormItem') {
	          this.isNested = true;
	        }
	        parent = parent.$parent;
	        parentName = parent.$options.componentName;
	      }
	      return parent;
	    },
	    fieldValue: function fieldValue() {
	      var model = this.form.model;
	      if (!model || !this.prop) {
	        return;
	      }
	
	      var path = this.prop;
	      if (path.indexOf(':') !== -1) {
	        path = path.replace(/:/, '.');
	      }
	
	      return Object(util_["getPropByPath"])(model, path, true).v;
	    },
	    isRequired: function isRequired() {
	      var rules = this.getRules();
	      var isRequired = false;
	
	      if (rules && rules.length) {
	        rules.every(function (rule) {
	          if (rule.required) {
	            isRequired = true;
	            return false;
	          }
	          return true;
	        });
	      }
	      return isRequired;
	    },
	    _formSize: function _formSize() {
	      return this.elForm.size;
	    },
	    elFormItemSize: function elFormItemSize() {
	      return this.size || this._formSize;
	    },
	    sizeClass: function sizeClass() {
	      return this.elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	  data: function data() {
	    return {
	      validateState: '',
	      validateMessage: '',
	      validateDisabled: false,
	      validator: {},
	      isNested: false,
	      computedLabelWidth: ''
	    };
	  },
	
	  methods: {
	    validate: function validate(trigger) {
	      var _this = this;
	
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : util_["noop"];
	
	      this.validateDisabled = false;
	      var rules = this.getFilteredRule(trigger);
	      if ((!rules || rules.length === 0) && this.required === undefined) {
	        callback();
	        return true;
	      }
	
	      this.validateState = 'validating';
	
	      var descriptor = {};
	      if (rules && rules.length > 0) {
	        rules.forEach(function (rule) {
	          delete rule.trigger;
	        });
	      }
	      descriptor[this.prop] = rules;
	
	      var validator = new external_async_validator_default.a(descriptor);
	      var model = {};
	
	      model[this.prop] = this.fieldValue;
	
	      validator.validate(model, { firstFields: true }, function (errors, invalidFields) {
	        _this.validateState = !errors ? 'success' : 'error';
	        _this.validateMessage = errors ? errors[0].message : '';
	
	        callback(_this.validateMessage, invalidFields);
	        _this.elForm && _this.elForm.$emit('validate', _this.prop, !errors, _this.validateMessage || null);
	      });
	    },
	    clearValidate: function clearValidate() {
	      this.validateState = '';
	      this.validateMessage = '';
	      this.validateDisabled = false;
	    },
	    resetField: function resetField() {
	      var _this2 = this;
	
	      this.validateState = '';
	      this.validateMessage = '';
	
	      var model = this.form.model;
	      var value = this.fieldValue;
	      var path = this.prop;
	      if (path.indexOf(':') !== -1) {
	        path = path.replace(/:/, '.');
	      }
	
	      var prop = Object(util_["getPropByPath"])(model, path, true);
	
	      this.validateDisabled = true;
	      if (Array.isArray(value)) {
	        prop.o[prop.k] = [].concat(this.initialValue);
	      } else {
	        prop.o[prop.k] = this.initialValue;
	      }
	
	      // reset validateDisabled after onFieldChange triggered
	      this.$nextTick(function () {
	        _this2.validateDisabled = false;
	      });
	
	      this.broadcast('ElTimeSelect', 'fieldReset', this.initialValue);
	    },
	    getRules: function getRules() {
	      var formRules = this.form.rules;
	      var selfRules = this.rules;
	      var requiredRule = this.required !== undefined ? { required: !!this.required } : [];
	
	      var prop = Object(util_["getPropByPath"])(formRules, this.prop || '');
	      formRules = formRules ? prop.o[this.prop || ''] || prop.v : [];
	
	      return [].concat(selfRules || formRules || []).concat(requiredRule);
	    },
	    getFilteredRule: function getFilteredRule(trigger) {
	      var rules = this.getRules();
	
	      return rules.filter(function (rule) {
	        if (!rule.trigger || trigger === '') return true;
	        if (Array.isArray(rule.trigger)) {
	          return rule.trigger.indexOf(trigger) > -1;
	        } else {
	          return rule.trigger === trigger;
	        }
	      }).map(function (rule) {
	        return merge_default()({}, rule);
	      });
	    },
	    onFieldBlur: function onFieldBlur() {
	      this.validate('blur');
	    },
	    onFieldChange: function onFieldChange() {
	      if (this.validateDisabled) {
	        this.validateDisabled = false;
	        return;
	      }
	
	      this.validate('change');
	    },
	    updateComputedLabelWidth: function updateComputedLabelWidth(width) {
	      this.computedLabelWidth = width ? width + 'px' : '';
	    },
	    addValidateEvents: function addValidateEvents() {
	      var rules = this.getRules();
	
	      if (rules.length || this.required !== undefined) {
	        this.$on('el.form.blur', this.onFieldBlur);
	        this.$on('el.form.change', this.onFieldChange);
	      }
	    },
	    removeValidateEvents: function removeValidateEvents() {
	      this.$off();
	    }
	  },
	  mounted: function mounted() {
	    if (this.prop) {
	      this.dispatch('ElForm', 'el.form.addField', [this]);
	
	      var initialValue = this.fieldValue;
	      if (Array.isArray(initialValue)) {
	        initialValue = [].concat(initialValue);
	      }
	      Object.defineProperty(this, 'initialValue', {
	        value: initialValue
	      });
	
	      this.addValidateEvents();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.dispatch('ElForm', 'el.form.removeField', [this]);
	  }
	});
	// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_form_itemvue_type_script_lang_js_ = (form_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/form/src/form-item.vue
	
	
	
	
	
	/* normalize component */
	
	var form_item_component = normalizeComponent(
	  src_form_itemvue_type_script_lang_js_,
	  form_itemvue_type_template_id_b6f3db6c_render,
	  form_itemvue_type_template_id_b6f3db6c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var form_item_api; }
	form_item_component.options.__file = "packages/form/src/form-item.vue"
	/* harmony default export */ var form_item = (form_item_component.exports);
	// CONCATENATED MODULE: ./packages/form-item/index.js
	
	
	/* istanbul ignore next */
	form_item.install = function (Vue) {
	  Vue.component(form_item.name, form_item);
	};
	
	/* harmony default export */ var packages_form_item = (form_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&
	var tab_barvue_type_template_id_2031f33a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", {
	    staticClass: "el-tabs__active-bar",
	    class: "is-" + _vm.rootTabs.tabPosition,
	    style: _vm.barStyle
	  })
	}
	var tab_barvue_type_template_id_2031f33a_staticRenderFns = []
	tab_barvue_type_template_id_2031f33a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
	//
	//
	//
	
	
	/* harmony default export */ var tab_barvue_type_script_lang_js_ = ({
	  name: 'TabBar',
	
	  props: {
	    tabs: Array
	  },
	
	  inject: ['rootTabs'],
	
	  computed: {
	    barStyle: {
	      get: function get() {
	        var _this = this;
	
	        var style = {};
	        var offset = 0;
	        var tabSize = 0;
	        var sizeName = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
	        var sizeDir = sizeName === 'width' ? 'x' : 'y';
	        var firstUpperCase = function firstUpperCase(str) {
	          return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
	            return L.toUpperCase();
	          });
	        };
	        this.tabs.every(function (tab, index) {
	          var $el = Object(util_["arrayFind"])(_this.$parent.$refs.tabs || [], function (t) {
	            return t.id.replace('tab-', '') === tab.paneName;
	          });
	          if (!$el) {
	            return false;
	          }
	
	          if (!tab.active) {
	            offset += $el['client' + firstUpperCase(sizeName)];
	            return true;
	          } else {
	            tabSize = $el['client' + firstUpperCase(sizeName)];
	            var tabStyles = window.getComputedStyle($el);
	            if (sizeName === 'width' && _this.tabs.length > 1) {
	              tabSize -= parseFloat(tabStyles.paddingLeft) + parseFloat(tabStyles.paddingRight);
	            }
	            if (sizeName === 'width') {
	              offset += parseFloat(tabStyles.paddingLeft);
	            }
	            return false;
	          }
	        });
	
	        var transform = 'translate' + firstUpperCase(sizeDir) + '(' + offset + 'px)';
	        style[sizeName] = tabSize + 'px';
	        style.transform = transform;
	        style.msTransform = transform;
	        style.webkitTransform = transform;
	
	        return style;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tab_barvue_type_script_lang_js_ = (tab_barvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue
	
	
	
	
	
	/* normalize component */
	
	var tab_bar_component = normalizeComponent(
	  src_tab_barvue_type_script_lang_js_,
	  tab_barvue_type_template_id_2031f33a_render,
	  tab_barvue_type_template_id_2031f33a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tab_bar_api; }
	tab_bar_component.options.__file = "packages/tabs/src/tab-bar.vue"
	/* harmony default export */ var tab_bar = (tab_bar_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
	
	
	
	
	function noop() {}
	var tab_navvue_type_script_lang_js_firstUpperCase = function firstUpperCase(str) {
	  return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
	    return L.toUpperCase();
	  });
	};
	
	/* harmony default export */ var tab_navvue_type_script_lang_js_ = ({
	  name: 'TabNav',
	
	  components: {
	    TabBar: tab_bar
	  },
	
	  inject: ['rootTabs'],
	
	  props: {
	    panes: Array,
	    currentName: String,
	    editable: Boolean,
	    onTabClick: {
	      type: Function,
	      default: noop
	    },
	    onTabRemove: {
	      type: Function,
	      default: noop
	    },
	    type: String,
	    stretch: Boolean
	  },
	
	  data: function data() {
	    return {
	      scrollable: false,
	      navOffset: 0,
	      isFocus: false,
	      focusable: true
	    };
	  },
	
	
	  computed: {
	    navStyle: function navStyle() {
	      var dir = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'X' : 'Y';
	      return {
	        transform: 'translate' + dir + '(-' + this.navOffset + 'px)'
	      };
	    },
	    sizeName: function sizeName() {
	      return ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
	    }
	  },
	
	  methods: {
	    scrollPrev: function scrollPrev() {
	      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
	      var currentOffset = this.navOffset;
	
	      if (!currentOffset) return;
	
	      var newOffset = currentOffset > containerSize ? currentOffset - containerSize : 0;
	
	      this.navOffset = newOffset;
	    },
	    scrollNext: function scrollNext() {
	      var navSize = this.$refs.nav['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
	      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
	      var currentOffset = this.navOffset;
	
	      if (navSize - currentOffset <= containerSize) return;
	
	      var newOffset = navSize - currentOffset > containerSize * 2 ? currentOffset + containerSize : navSize - containerSize;
	
	      this.navOffset = newOffset;
	    },
	    scrollToActiveTab: function scrollToActiveTab() {
	      if (!this.scrollable) return;
	      var nav = this.$refs.nav;
	      var activeTab = this.$el.querySelector('.is-active');
	      if (!activeTab) return;
	      var navScroll = this.$refs.navScroll;
	      var isHorizontal = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1;
	      var activeTabBounding = activeTab.getBoundingClientRect();
	      var navScrollBounding = navScroll.getBoundingClientRect();
	      var maxOffset = isHorizontal ? nav.offsetWidth - navScrollBounding.width : nav.offsetHeight - navScrollBounding.height;
	      var currentOffset = this.navOffset;
	      var newOffset = currentOffset;
	
	      if (isHorizontal) {
	        if (activeTabBounding.left < navScrollBounding.left) {
	          newOffset = currentOffset - (navScrollBounding.left - activeTabBounding.left);
	        }
	        if (activeTabBounding.right > navScrollBounding.right) {
	          newOffset = currentOffset + activeTabBounding.right - navScrollBounding.right;
	        }
	      } else {
	        if (activeTabBounding.top < navScrollBounding.top) {
	          newOffset = currentOffset - (navScrollBounding.top - activeTabBounding.top);
	        }
	        if (activeTabBounding.bottom > navScrollBounding.bottom) {
	          newOffset = currentOffset + (activeTabBounding.bottom - navScrollBounding.bottom);
	        }
	      }
	      newOffset = Math.max(newOffset, 0);
	      this.navOffset = Math.min(newOffset, maxOffset);
	    },
	    update: function update() {
	      if (!this.$refs.nav) return;
	      var sizeName = this.sizeName;
	      var navSize = this.$refs.nav['offset' + tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];
	      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];
	      var currentOffset = this.navOffset;
	
	      if (containerSize < navSize) {
	        var _currentOffset = this.navOffset;
	        this.scrollable = this.scrollable || {};
	        this.scrollable.prev = _currentOffset;
	        this.scrollable.next = _currentOffset + containerSize < navSize;
	        if (navSize - _currentOffset < containerSize) {
	          this.navOffset = navSize - containerSize;
	        }
	      } else {
	        this.scrollable = false;
	        if (currentOffset > 0) {
	          this.navOffset = 0;
	        }
	      }
	    },
	    changeTab: function changeTab(e) {
	      var keyCode = e.keyCode;
	      var nextIndex = void 0;
	      var currentIndex = void 0,
	          tabList = void 0;
	      if ([37, 38, 39, 40].indexOf(keyCode) !== -1) {
	        // 左右上下键更换tab
	        tabList = e.currentTarget.querySelectorAll('[role=tab]');
	        currentIndex = Array.prototype.indexOf.call(tabList, e.target);
	      } else {
	        return;
	      }
	      if (keyCode === 37 || keyCode === 38) {
	        // left
	        if (currentIndex === 0) {
	          // first
	          nextIndex = tabList.length - 1;
	        } else {
	          nextIndex = currentIndex - 1;
	        }
	      } else {
	        // right
	        if (currentIndex < tabList.length - 1) {
	          // not last
	          nextIndex = currentIndex + 1;
	        } else {
	          nextIndex = 0;
	        }
	      }
	      tabList[nextIndex].focus(); // 改变焦点元素
	      tabList[nextIndex].click(); // 选中下一个tab
	      this.setFocus();
	    },
	    setFocus: function setFocus() {
	      if (this.focusable) {
	        this.isFocus = true;
	      }
	    },
	    removeFocus: function removeFocus() {
	      this.isFocus = false;
	    },
	    visibilityChangeHandler: function visibilityChangeHandler() {
	      var _this = this;
	
	      var visibility = document.visibilityState;
	      if (visibility === 'hidden') {
	        this.focusable = false;
	      } else if (visibility === 'visible') {
	        setTimeout(function () {
	          _this.focusable = true;
	        }, 50);
	      }
	    },
	    windowBlurHandler: function windowBlurHandler() {
	      this.focusable = false;
	    },
	    windowFocusHandler: function windowFocusHandler() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.focusable = true;
	      }, 50);
	    }
	  },
	
	  updated: function updated() {
	    this.update();
	  },
	  render: function render(h) {
	    var _this3 = this;
	
	    var type = this.type,
	        panes = this.panes,
	        editable = this.editable,
	        stretch = this.stretch,
	        onTabClick = this.onTabClick,
	        onTabRemove = this.onTabRemove,
	        navStyle = this.navStyle,
	        scrollable = this.scrollable,
	        scrollNext = this.scrollNext,
	        scrollPrev = this.scrollPrev,
	        changeTab = this.changeTab,
	        setFocus = this.setFocus,
	        removeFocus = this.removeFocus;
	
	    var scrollBtn = scrollable ? [h(
	      'span',
	      { 'class': ['el-tabs__nav-prev', scrollable.prev ? '' : 'is-disabled'], on: {
	          'click': scrollPrev
	        }
	      },
	      [h('i', { 'class': 'el-icon-arrow-left' })]
	    ), h(
	      'span',
	      { 'class': ['el-tabs__nav-next', scrollable.next ? '' : 'is-disabled'], on: {
	          'click': scrollNext
	        }
	      },
	      [h('i', { 'class': 'el-icon-arrow-right' })]
	    )] : null;
	
	    var tabs = this._l(panes, function (pane, index) {
	      var _ref;
	
	      var tabName = pane.name || pane.index || index;
	      var closable = pane.isClosable || editable;
	
	      pane.index = '' + index;
	
	      var btnClose = closable ? h('span', { 'class': 'el-icon-close', on: {
	          'click': function click(ev) {
	            onTabRemove(pane, ev);
	          }
	        }
	      }) : null;
	
	      var tabLabelContent = pane.$slots.label || pane.label;
	      var tabindex = pane.active ? 0 : -1;
	      return h(
	        'div',
	        {
	          'class': (_ref = {
	            'el-tabs__item': true
	          }, _ref['is-' + _this3.rootTabs.tabPosition] = true, _ref['is-active'] = pane.active, _ref['is-disabled'] = pane.disabled, _ref['is-closable'] = closable, _ref['is-focus'] = _this3.isFocus, _ref),
	          attrs: { id: 'tab-' + tabName,
	
	            'aria-controls': 'pane-' + tabName,
	            role: 'tab',
	            'aria-selected': pane.active,
	
	            tabindex: tabindex
	          },
	          key: 'tab-' + tabName, ref: 'tabs', refInFor: true,
	          on: {
	            'focus': function focus() {
	              setFocus();
	            },
	            'blur': function blur() {
	              removeFocus();
	            },
	            'click': function click(ev) {
	              removeFocus();onTabClick(pane, tabName, ev);
	            },
	            'keydown': function keydown(ev) {
	              if (closable && (ev.keyCode === 46 || ev.keyCode === 8)) {
	                onTabRemove(pane, ev);
	              }
	            }
	          }
	        },
	        [tabLabelContent, btnClose]
	      );
	    });
	    return h(
	      'div',
	      { 'class': ['el-tabs__nav-wrap', scrollable ? 'is-scrollable' : '', 'is-' + this.rootTabs.tabPosition] },
	      [scrollBtn, h(
	        'div',
	        { 'class': ['el-tabs__nav-scroll'], ref: 'navScroll' },
	        [h(
	          'div',
	          {
	            'class': ['el-tabs__nav', 'is-' + this.rootTabs.tabPosition, stretch && ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'is-stretch' : ''],
	            ref: 'nav',
	            style: navStyle,
	            attrs: { role: 'tablist'
	            },
	            on: {
	              'keydown': changeTab
	            }
	          },
	          [!type ? h('tab-bar', {
	            attrs: { tabs: panes }
	          }) : null, tabs]
	        )]
	      )]
	    );
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    Object(resize_event_["addResizeListener"])(this.$el, this.update);
	    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
	    window.addEventListener('blur', this.windowBlurHandler);
	    window.addEventListener('focus', this.windowFocusHandler);
	    setTimeout(function () {
	      _this4.scrollToActiveTab();
	    }, 0);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el && this.update) Object(resize_event_["removeResizeListener"])(this.$el, this.update);
	    document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
	    window.removeEventListener('blur', this.windowBlurHandler);
	    window.removeEventListener('focus', this.windowFocusHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tab_navvue_type_script_lang_js_ = (tab_navvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue
	var tab_nav_render, tab_nav_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var tab_nav_component = normalizeComponent(
	  src_tab_navvue_type_script_lang_js_,
	  tab_nav_render,
	  tab_nav_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tab_nav_api; }
	tab_nav_component.options.__file = "packages/tabs/src/tab-nav.vue"
	/* harmony default export */ var tab_nav = (tab_nav_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
	
	
	
	/* harmony default export */ var tabsvue_type_script_lang_js_ = ({
	  name: 'ElTabs',
	
	  components: {
	    TabNav: tab_nav
	  },
	
	  props: {
	    type: String,
	    activeName: String,
	    closable: Boolean,
	    addable: Boolean,
	    value: {},
	    editable: Boolean,
	    tabPosition: {
	      type: String,
	      default: 'top'
	    },
	    beforeLeave: Function,
	    stretch: Boolean
	  },
	
	  provide: function provide() {
	    return {
	      rootTabs: this
	    };
	  },
	  data: function data() {
	    return {
	      currentName: this.value || this.activeName,
	      panes: []
	    };
	  },
	
	
	  watch: {
	    activeName: function activeName(value) {
	      this.setCurrentName(value);
	    },
	    value: function value(_value) {
	      this.setCurrentName(_value);
	    },
	    currentName: function currentName(value) {
	      var _this = this;
	
	      if (this.$refs.nav) {
	        this.$nextTick(function () {
	          _this.$refs.nav.$nextTick(function (_) {
	            _this.$refs.nav.scrollToActiveTab();
	          });
	        });
	      }
	    }
	  },
	
	  methods: {
	    calcPaneInstances: function calcPaneInstances() {
	      var _this2 = this;
	
	      var isForceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.$slots.default) {
	        var paneSlots = this.$slots.default.filter(function (vnode) {
	          return vnode.tag && vnode.componentOptions && vnode.componentOptions.Ctor.options.name === 'ElTabPane';
	        });
	        // update indeed
	        var panes = paneSlots.map(function (_ref) {
	          var componentInstance = _ref.componentInstance;
	          return componentInstance;
	        });
	        var panesChanged = !(panes.length === this.panes.length && panes.every(function (pane, index) {
	          return pane === _this2.panes[index];
	        }));
	        if (isForceUpdate || panesChanged) {
	          this.panes = panes;
	        }
	      } else if (this.panes.length !== 0) {
	        this.panes = [];
	      }
	    },
	    handleTabClick: function handleTabClick(tab, tabName, event) {
	      if (tab.disabled) return;
	      this.setCurrentName(tabName);
	      this.$emit('tab-click', tab, event);
	    },
	    handleTabRemove: function handleTabRemove(pane, ev) {
	      if (pane.disabled) return;
	      ev.stopPropagation();
	      this.$emit('edit', pane.name, 'remove');
	      this.$emit('tab-remove', pane.name);
	    },
	    handleTabAdd: function handleTabAdd() {
	      this.$emit('edit', null, 'add');
	      this.$emit('tab-add');
	    },
	    setCurrentName: function setCurrentName(value) {
	      var _this3 = this;
	
	      var changeCurrentName = function changeCurrentName() {
	        _this3.currentName = value;
	        _this3.$emit('input', value);
	      };
	      if (this.currentName !== value && this.beforeLeave) {
	        var before = this.beforeLeave(value, this.currentName);
	        if (before && before.then) {
	          before.then(function () {
	            changeCurrentName();
	            _this3.$refs.nav && _this3.$refs.nav.removeFocus();
	          }, function () {
	            // https://github.com/ElemeFE/element/pull/14816
	            // ignore promise rejection in `before-leave` hook
	          });
	        } else if (before !== false) {
	          changeCurrentName();
	        }
	      } else {
	        changeCurrentName();
	      }
	    }
	  },
	
	  render: function render(h) {
	    var _ref2;
	
	    var type = this.type,
	        handleTabClick = this.handleTabClick,
	        handleTabRemove = this.handleTabRemove,
	        handleTabAdd = this.handleTabAdd,
	        currentName = this.currentName,
	        panes = this.panes,
	        editable = this.editable,
	        addable = this.addable,
	        tabPosition = this.tabPosition,
	        stretch = this.stretch;
	
	
	    var newButton = editable || addable ? h(
	      'span',
	      {
	        'class': 'el-tabs__new-tab',
	        on: {
	          'click': handleTabAdd,
	          'keydown': function keydown(ev) {
	            if (ev.keyCode === 13) {
	              handleTabAdd();
	            }
	          }
	        },
	        attrs: {
	          tabindex: '0'
	        }
	      },
	      [h('i', { 'class': 'el-icon-plus' })]
	    ) : null;
	
	    var navData = {
	      props: {
	        currentName: currentName,
	        onTabClick: handleTabClick,
	        onTabRemove: handleTabRemove,
	        editable: editable,
	        type: type,
	        panes: panes,
	        stretch: stretch
	      },
	      ref: 'nav'
	    };
	    var header = h(
	      'div',
	      { 'class': ['el-tabs__header', 'is-' + tabPosition] },
	      [newButton, h('tab-nav', navData)]
	    );
	    var panels = h(
	      'div',
	      { 'class': 'el-tabs__content' },
	      [this.$slots.default]
	    );
	
	    return h(
	      'div',
	      { 'class': (_ref2 = {
	          'el-tabs': true,
	          'el-tabs--card': type === 'card'
	        }, _ref2['el-tabs--' + tabPosition] = true, _ref2['el-tabs--border-card'] = type === 'border-card', _ref2) },
	      [tabPosition !== 'bottom' ? [header, panels] : [panels, header]]
	    );
	  },
	  created: function created() {
	    if (!this.currentName) {
	      this.setCurrentName('0');
	    }
	
	    this.$on('tab-nav-update', this.calcPaneInstances.bind(null, true));
	  },
	  mounted: function mounted() {
	    this.calcPaneInstances();
	  },
	  updated: function updated() {
	    this.calcPaneInstances();
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tabsvue_type_script_lang_js_ = (tabsvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue
	var tabs_render, tabs_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var tabs_component = normalizeComponent(
	  src_tabsvue_type_script_lang_js_,
	  tabs_render,
	  tabs_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tabs_api; }
	tabs_component.options.__file = "packages/tabs/src/tabs.vue"
	/* harmony default export */ var tabs = (tabs_component.exports);
	// CONCATENATED MODULE: ./packages/tabs/index.js
	
	
	/* istanbul ignore next */
	tabs.install = function (Vue) {
	  Vue.component(tabs.name, tabs);
	};
	
	/* harmony default export */ var packages_tabs = (tabs);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&
	var tab_panevue_type_template_id_9145a070_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return !_vm.lazy || _vm.loaded || _vm.active
	    ? _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.active,
	              expression: "active"
	            }
	          ],
	          staticClass: "el-tab-pane",
	          attrs: {
	            role: "tabpanel",
	            "aria-hidden": !_vm.active,
	            id: "pane-" + _vm.paneName,
	            "aria-labelledby": "tab-" + _vm.paneName
	          }
	        },
	        [_vm._t("default")],
	        2
	      )
	    : _vm._e()
	}
	var tab_panevue_type_template_id_9145a070_staticRenderFns = []
	tab_panevue_type_template_id_9145a070_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var tab_panevue_type_script_lang_js_ = ({
	  name: 'ElTabPane',
	
	  componentName: 'ElTabPane',
	
	  props: {
	    label: String,
	    labelContent: Function,
	    name: String,
	    closable: Boolean,
	    disabled: Boolean,
	    lazy: Boolean
	  },
	
	  data: function data() {
	    return {
	      index: null,
	      loaded: false
	    };
	  },
	
	
	  computed: {
	    isClosable: function isClosable() {
	      return this.closable || this.$parent.closable;
	    },
	    active: function active() {
	      var active = this.$parent.currentName === (this.name || this.index);
	      if (active) {
	        this.loaded = true;
	      }
	      return active;
	    },
	    paneName: function paneName() {
	      return this.name || this.index;
	    }
	  },
	
	  updated: function updated() {
	    this.$parent.$emit('tab-nav-update');
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tab_panevue_type_script_lang_js_ = (tab_panevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue
	
	
	
	
	
	/* normalize component */
	
	var tab_pane_component = normalizeComponent(
	  src_tab_panevue_type_script_lang_js_,
	  tab_panevue_type_template_id_9145a070_render,
	  tab_panevue_type_template_id_9145a070_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tab_pane_api; }
	tab_pane_component.options.__file = "packages/tabs/src/tab-pane.vue"
	/* harmony default export */ var tab_pane = (tab_pane_component.exports);
	// CONCATENATED MODULE: ./packages/tab-pane/index.js
	
	
	/* istanbul ignore next */
	tab_pane.install = function (Vue) {
	  Vue.component(tab_pane.name, tab_pane);
	};
	
	/* harmony default export */ var packages_tab_pane = (tab_pane);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var tagvue_type_script_lang_js_ = ({
	  name: 'ElTag',
	  props: {
	    text: String,
	    closable: Boolean,
	    type: String,
	    hit: Boolean,
	    disableTransitions: Boolean,
	    color: String,
	    size: String,
	    effect: {
	      type: String,
	      default: 'light',
	      validator: function validator(val) {
	        return ['dark', 'light', 'plain'].indexOf(val) !== -1;
	      }
	    }
	  },
	  methods: {
	    handleClose: function handleClose(event) {
	      event.stopPropagation();
	      this.$emit('close', event);
	    },
	    handleClick: function handleClick(event) {
	      this.$emit('click', event);
	    }
	  },
	  computed: {
	    tagSize: function tagSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    }
	  },
	  render: function render(h) {
	    var type = this.type,
	        tagSize = this.tagSize,
	        hit = this.hit,
	        effect = this.effect;
	
	    var classes = ['el-tag', type ? 'el-tag--' + type : '', tagSize ? 'el-tag--' + tagSize : '', effect ? 'el-tag--' + effect : '', hit && 'is-hit'];
	    var tagEl = h(
	      'span',
	      {
	        'class': classes,
	        style: { backgroundColor: this.color },
	        on: {
	          'click': this.handleClick
	        }
	      },
	      [this.$slots.default, this.closable && h('i', { 'class': 'el-tag__close el-icon-close', on: {
	          'click': this.handleClose
	        }
	      })]
	    );
	
	    return this.disableTransitions ? tagEl : h(
	      'transition',
	      {
	        attrs: { name: 'el-zoom-in-center' }
	      },
	      [tagEl]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tagvue_type_script_lang_js_ = (tagvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue
	var tag_render, tag_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var tag_component = normalizeComponent(
	  src_tagvue_type_script_lang_js_,
	  tag_render,
	  tag_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tag_api; }
	tag_component.options.__file = "packages/tag/src/tag.vue"
	/* harmony default export */ var tag = (tag_component.exports);
	// CONCATENATED MODULE: ./packages/tag/index.js
	
	
	/* istanbul ignore next */
	tag.install = function (Vue) {
	  Vue.component(tag.name, tag);
	};
	
	/* harmony default export */ var packages_tag = (tag);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=template&id=547575a6&
	var treevue_type_template_id_547575a6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-tree",
	      class: {
	        "el-tree--highlight-current": _vm.highlightCurrent,
	        "is-dragging": !!_vm.dragState.draggingNode,
	        "is-drop-not-allow": !_vm.dragState.allowDrop,
	        "is-drop-inner": _vm.dragState.dropType === "inner"
	      },
	      attrs: { role: "tree" }
	    },
	    [
	      _vm._l(_vm.root.childNodes, function(child) {
	        return _c("el-tree-node", {
	          key: _vm.getNodeKey(child),
	          attrs: {
	            node: child,
	            props: _vm.props,
	            "render-after-expand": _vm.renderAfterExpand,
	            "show-checkbox": _vm.showCheckbox,
	            "render-content": _vm.renderContent
	          },
	          on: { "node-expand": _vm.handleNodeExpand }
	        })
	      }),
	      _vm.isEmpty
	        ? _c("div", { staticClass: "el-tree__empty-block" }, [
	            _c("span", { staticClass: "el-tree__empty-text" }, [
	              _vm._v(_vm._s(_vm.emptyText))
	            ])
	          ])
	        : _vm._e(),
	      _c("div", {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.dragState.showDropIndicator,
	            expression: "dragState.showDropIndicator"
	          }
	        ],
	        ref: "dropIndicator",
	        staticClass: "el-tree__drop-indicator"
	      })
	    ],
	    2
	  )
	}
	var treevue_type_template_id_547575a6_staticRenderFns = []
	treevue_type_template_id_547575a6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=template&id=547575a6&
	
	// CONCATENATED MODULE: ./packages/tree/src/model/util.js
	var NODE_KEY = '$treeNodeId';
	
	var markNodeData = function markNodeData(node, data) {
	  if (!data || data[NODE_KEY]) return;
	  Object.defineProperty(data, NODE_KEY, {
	    value: node.id,
	    enumerable: false,
	    configurable: false,
	    writable: false
	  });
	};
	
	var util_getNodeKey = function getNodeKey(key, data) {
	  if (!key) return data[NODE_KEY];
	  return data[key];
	};
	
	var findNearestComponent = function findNearestComponent(element, componentName) {
	  var target = element;
	  while (target && target.tagName !== 'BODY') {
	    if (target.__vue__ && target.__vue__.$options.name === componentName) {
	      return target.__vue__;
	    }
	    target = target.parentNode;
	  }
	  return null;
	};
	// CONCATENATED MODULE: ./packages/tree/src/model/node.js
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function node_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	
	var getChildState = function getChildState(node) {
	  var all = true;
	  var none = true;
	  var allWithoutDisable = true;
	  for (var i = 0, j = node.length; i < j; i++) {
	    var n = node[i];
	    if (n.checked !== true || n.indeterminate) {
	      all = false;
	      if (!n.disabled) {
	        allWithoutDisable = false;
	      }
	    }
	    if (n.checked !== false || n.indeterminate) {
	      none = false;
	    }
	  }
	
	  return { all: all, none: none, allWithoutDisable: allWithoutDisable, half: !all && !none };
	};
	
	var reInitChecked = function reInitChecked(node) {
	  if (node.childNodes.length === 0) return;
	
	  var _getChildState = getChildState(node.childNodes),
	      all = _getChildState.all,
	      none = _getChildState.none,
	      half = _getChildState.half;
	
	  if (all) {
	    node.checked = true;
	    node.indeterminate = false;
	  } else if (half) {
	    node.checked = false;
	    node.indeterminate = true;
	  } else if (none) {
	    node.checked = false;
	    node.indeterminate = false;
	  }
	
	  var parent = node.parent;
	  if (!parent || parent.level === 0) return;
	
	  if (!node.store.checkStrictly) {
	    reInitChecked(parent);
	  }
	};
	
	var getPropertyFromData = function getPropertyFromData(node, prop) {
	  var props = node.store.props;
	  var data = node.data || {};
	  var config = props[prop];
	
	  if (typeof config === 'function') {
	    return config(data, node);
	  } else if (typeof config === 'string') {
	    return data[config];
	  } else if (typeof config === 'undefined') {
	    var dataProp = data[prop];
	    return dataProp === undefined ? '' : dataProp;
	  }
	};
	
	var nodeIdSeed = 0;
	
	var node_Node = function () {
	  function Node(options) {
	    node_classCallCheck(this, Node);
	
	    this.id = nodeIdSeed++;
	    this.text = null;
	    this.checked = false;
	    this.indeterminate = false;
	    this.data = null;
	    this.expanded = false;
	    this.parent = null;
	    this.visible = true;
	    this.isCurrent = false;
	
	    for (var name in options) {
	      if (options.hasOwnProperty(name)) {
	        this[name] = options[name];
	      }
	    }
	
	    // internal
	    this.level = 0;
	    this.loaded = false;
	    this.childNodes = [];
	    this.loading = false;
	
	    if (this.parent) {
	      this.level = this.parent.level + 1;
	    }
	
	    var store = this.store;
	    if (!store) {
	      throw new Error('[Node]store is required!');
	    }
	    store.registerNode(this);
	
	    var props = store.props;
	    if (props && typeof props.isLeaf !== 'undefined') {
	      var isLeaf = getPropertyFromData(this, 'isLeaf');
	      if (typeof isLeaf === 'boolean') {
	        this.isLeafByUser = isLeaf;
	      }
	    }
	
	    if (store.lazy !== true && this.data) {
	      this.setData(this.data);
	
	      if (store.defaultExpandAll) {
	        this.expanded = true;
	      }
	    } else if (this.level > 0 && store.lazy && store.defaultExpandAll) {
	      this.expand();
	    }
	    if (!Array.isArray(this.data)) {
	      markNodeData(this, this.data);
	    }
	    if (!this.data) return;
	    var defaultExpandedKeys = store.defaultExpandedKeys;
	    var key = store.key;
	    if (key && defaultExpandedKeys && defaultExpandedKeys.indexOf(this.key) !== -1) {
	      this.expand(null, store.autoExpandParent);
	    }
	
	    if (key && store.currentNodeKey !== undefined && this.key === store.currentNodeKey) {
	      store.currentNode = this;
	      store.currentNode.isCurrent = true;
	    }
	
	    if (store.lazy) {
	      store._initDefaultCheckedNode(this);
	    }
	
	    this.updateLeafState();
	  }
	
	  Node.prototype.setData = function setData(data) {
	    if (!Array.isArray(data)) {
	      markNodeData(this, data);
	    }
	
	    this.data = data;
	    this.childNodes = [];
	
	    var children = void 0;
	    if (this.level === 0 && this.data instanceof Array) {
	      children = this.data;
	    } else {
	      children = getPropertyFromData(this, 'children') || [];
	    }
	
	    for (var i = 0, j = children.length; i < j; i++) {
	      this.insertChild({ data: children[i] });
	    }
	  };
	
	  Node.prototype.contains = function contains(target) {
	    var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var walk = function walk(parent) {
	      var children = parent.childNodes || [];
	      var result = false;
	      for (var i = 0, j = children.length; i < j; i++) {
	        var child = children[i];
	        if (child === target || deep && walk(child)) {
	          result = true;
	          break;
	        }
	      }
	      return result;
	    };
	
	    return walk(this);
	  };
	
	  Node.prototype.remove = function remove() {
	    var parent = this.parent;
	    if (parent) {
	      parent.removeChild(this);
	    }
	  };
	
	  Node.prototype.insertChild = function insertChild(child, index, batch) {
	    if (!child) throw new Error('insertChild error: child is required.');
	
	    if (!(child instanceof Node)) {
	      if (!batch) {
	        var children = this.getChildren(true);
	        if (children.indexOf(child.data) === -1) {
	          if (typeof index === 'undefined' || index < 0) {
	            children.push(child.data);
	          } else {
	            children.splice(index, 0, child.data);
	          }
	        }
	      }
	      merge_default()(child, {
	        parent: this,
	        store: this.store
	      });
	      child = new Node(child);
	    }
	
	    child.level = this.level + 1;
	
	    if (typeof index === 'undefined' || index < 0) {
	      this.childNodes.push(child);
	    } else {
	      this.childNodes.splice(index, 0, child);
	    }
	
	    this.updateLeafState();
	  };
	
	  Node.prototype.insertBefore = function insertBefore(child, ref) {
	    var index = void 0;
	    if (ref) {
	      index = this.childNodes.indexOf(ref);
	    }
	    this.insertChild(child, index);
	  };
	
	  Node.prototype.insertAfter = function insertAfter(child, ref) {
	    var index = void 0;
	    if (ref) {
	      index = this.childNodes.indexOf(ref);
	      if (index !== -1) index += 1;
	    }
	    this.insertChild(child, index);
	  };
	
	  Node.prototype.removeChild = function removeChild(child) {
	    var children = this.getChildren() || [];
	    var dataIndex = children.indexOf(child.data);
	    if (dataIndex > -1) {
	      children.splice(dataIndex, 1);
	    }
	
	    var index = this.childNodes.indexOf(child);
	
	    if (index > -1) {
	      this.store && this.store.deregisterNode(child);
	      child.parent = null;
	      this.childNodes.splice(index, 1);
	    }
	
	    this.updateLeafState();
	  };
	
	  Node.prototype.removeChildByData = function removeChildByData(data) {
	    var targetNode = null;
	
	    for (var i = 0; i < this.childNodes.length; i++) {
	      if (this.childNodes[i].data === data) {
	        targetNode = this.childNodes[i];
	        break;
	      }
	    }
	
	    if (targetNode) {
	      this.removeChild(targetNode);
	    }
	  };
	
	  Node.prototype.expand = function expand(callback, expandParent) {
	    var _this = this;
	
	    var done = function done() {
	      if (expandParent) {
	        var parent = _this.parent;
	        while (parent.level > 0) {
	          parent.expanded = true;
	          parent = parent.parent;
	        }
	      }
	      _this.expanded = true;
	      if (callback) callback();
	    };
	
	    if (this.shouldLoadData()) {
	      this.loadData(function (data) {
	        if (data instanceof Array) {
	          if (_this.checked) {
	            _this.setChecked(true, true);
	          } else if (!_this.store.checkStrictly) {
	            reInitChecked(_this);
	          }
	          done();
	        }
	      });
	    } else {
	      done();
	    }
	  };
	
	  Node.prototype.doCreateChildren = function doCreateChildren(array) {
	    var _this2 = this;
	
	    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    array.forEach(function (item) {
	      _this2.insertChild(merge_default()({ data: item }, defaultProps), undefined, true);
	    });
	  };
	
	  Node.prototype.collapse = function collapse() {
	    this.expanded = false;
	  };
	
	  Node.prototype.shouldLoadData = function shouldLoadData() {
	    return this.store.lazy === true && this.store.load && !this.loaded;
	  };
	
	  Node.prototype.updateLeafState = function updateLeafState() {
	    if (this.store.lazy === true && this.loaded !== true && typeof this.isLeafByUser !== 'undefined') {
	      this.isLeaf = this.isLeafByUser;
	      return;
	    }
	    var childNodes = this.childNodes;
	    if (!this.store.lazy || this.store.lazy === true && this.loaded === true) {
	      this.isLeaf = !childNodes || childNodes.length === 0;
	      return;
	    }
	    this.isLeaf = false;
	  };
	
	  Node.prototype.setChecked = function setChecked(value, deep, recursion, passValue) {
	    var _this3 = this;
	
	    this.indeterminate = value === 'half';
	    this.checked = value === true;
	
	    if (this.store.checkStrictly) return;
	
	    if (!(this.shouldLoadData() && !this.store.checkDescendants)) {
	      var _getChildState2 = getChildState(this.childNodes),
	          all = _getChildState2.all,
	          allWithoutDisable = _getChildState2.allWithoutDisable;
	
	      if (!this.isLeaf && !all && allWithoutDisable) {
	        this.checked = false;
	        value = false;
	      }
	
	      var handleDescendants = function handleDescendants() {
	        if (deep) {
	          var childNodes = _this3.childNodes;
	          for (var i = 0, j = childNodes.length; i < j; i++) {
	            var child = childNodes[i];
	            passValue = passValue || value !== false;
	            var isCheck = child.disabled ? child.checked : passValue;
	            child.setChecked(isCheck, deep, true, passValue);
	          }
	
	          var _getChildState3 = getChildState(childNodes),
	              half = _getChildState3.half,
	              _all = _getChildState3.all;
	
	          if (!_all) {
	            _this3.checked = _all;
	            _this3.indeterminate = half;
	          }
	        }
	      };
	
	      if (this.shouldLoadData()) {
	        // Only work on lazy load data.
	        this.loadData(function () {
	          handleDescendants();
	          reInitChecked(_this3);
	        }, {
	          checked: value !== false
	        });
	        return;
	      } else {
	        handleDescendants();
	      }
	    }
	
	    var parent = this.parent;
	    if (!parent || parent.level === 0) return;
	
	    if (!recursion) {
	      reInitChecked(parent);
	    }
	  };
	
	  Node.prototype.getChildren = function getChildren() {
	    var forceInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    // this is data
	    if (this.level === 0) return this.data;
	    var data = this.data;
	    if (!data) return null;
	
	    var props = this.store.props;
	    var children = 'children';
	    if (props) {
	      children = props.children || 'children';
	    }
	
	    if (data[children] === undefined) {
	      data[children] = null;
	    }
	
	    if (forceInit && !data[children]) {
	      data[children] = [];
	    }
	
	    return data[children];
	  };
	
	  Node.prototype.updateChildren = function updateChildren() {
	    var _this4 = this;
	
	    var newData = this.getChildren() || [];
	    var oldData = this.childNodes.map(function (node) {
	      return node.data;
	    });
	
	    var newDataMap = {};
	    var newNodes = [];
	
	    newData.forEach(function (item, index) {
	      var key = item[NODE_KEY];
	      var isNodeExists = !!key && Object(util_["arrayFindIndex"])(oldData, function (data) {
	        return data[NODE_KEY] === key;
	      }) >= 0;
	      if (isNodeExists) {
	        newDataMap[key] = { index: index, data: item };
	      } else {
	        newNodes.push({ index: index, data: item });
	      }
	    });
	
	    if (!this.store.lazy) {
	      oldData.forEach(function (item) {
	        if (!newDataMap[item[NODE_KEY]]) _this4.removeChildByData(item);
	      });
	    }
	
	    newNodes.forEach(function (_ref) {
	      var index = _ref.index,
	          data = _ref.data;
	
	      _this4.insertChild({ data: data }, index);
	    });
	
	    this.updateLeafState();
	  };
	
	  Node.prototype.loadData = function loadData(callback) {
	    var _this5 = this;
	
	    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (this.store.lazy === true && this.store.load && !this.loaded && (!this.loading || Object.keys(defaultProps).length)) {
	      this.loading = true;
	
	      var resolve = function resolve(children) {
	        _this5.loaded = true;
	        _this5.loading = false;
	        _this5.childNodes = [];
	
	        _this5.doCreateChildren(children, defaultProps);
	
	        _this5.updateLeafState();
	        if (callback) {
	          callback.call(_this5, children);
	        }
	      };
	
	      this.store.load(this, resolve);
	    } else {
	      if (callback) {
	        callback.call(this);
	      }
	    }
	  };
	
	  _createClass(Node, [{
	    key: 'label',
	    get: function get() {
	      return getPropertyFromData(this, 'label');
	    }
	  }, {
	    key: 'key',
	    get: function get() {
	      var nodeKey = this.store.key;
	      if (this.data) return this.data[nodeKey];
	      return null;
	    }
	  }, {
	    key: 'disabled',
	    get: function get() {
	      return getPropertyFromData(this, 'disabled');
	    }
	  }, {
	    key: 'nextSibling',
	    get: function get() {
	      var parent = this.parent;
	      if (parent) {
	        var index = parent.childNodes.indexOf(this);
	        if (index > -1) {
	          return parent.childNodes[index + 1];
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'previousSibling',
	    get: function get() {
	      var parent = this.parent;
	      if (parent) {
	        var index = parent.childNodes.indexOf(this);
	        if (index > -1) {
	          return index > 0 ? parent.childNodes[index - 1] : null;
	        }
	      }
	      return null;
	    }
	  }]);
	
	  return Node;
	}();
	
	/* harmony default export */ var model_node = (node_Node);
	// CONCATENATED MODULE: ./packages/tree/src/model/tree-store.js
	var tree_store_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function tree_store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var tree_store_TreeStore = function () {
	  function TreeStore(options) {
	    var _this = this;
	
	    tree_store_classCallCheck(this, TreeStore);
	
	    this.currentNode = null;
	    this.currentNodeKey = null;
	
	    for (var option in options) {
	      if (options.hasOwnProperty(option)) {
	        this[option] = options[option];
	      }
	    }
	
	    this.nodesMap = {};
	
	    this.root = new model_node({
	      data: this.data,
	      store: this
	    });
	
	    if (this.lazy && this.load) {
	      var loadFn = this.load;
	      loadFn(this.root, function (data) {
	        _this.root.doCreateChildren(data);
	        _this._initDefaultCheckedNodes();
	      });
	    } else {
	      this._initDefaultCheckedNodes();
	    }
	  }
	
	  TreeStore.prototype.filter = function filter(value) {
	    var filterNodeMethod = this.filterNodeMethod;
	    var lazy = this.lazy;
	    var traverse = function traverse(node) {
	      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
	      childNodes.forEach(function (child) {
	        child.visible = filterNodeMethod.call(child, value, child.data, child);
	
	        traverse(child);
	      });
	
	      if (!node.visible && childNodes.length) {
	        var allHidden = true;
	        allHidden = !childNodes.some(function (child) {
	          return child.visible;
	        });
	
	        if (node.root) {
	          node.root.visible = allHidden === false;
	        } else {
	          node.visible = allHidden === false;
	        }
	      }
	      if (!value) return;
	
	      if (node.visible && !node.isLeaf && !lazy) node.expand();
	    };
	
	    traverse(this);
	  };
	
	  TreeStore.prototype.setData = function setData(newVal) {
	    var instanceChanged = newVal !== this.root.data;
	    if (instanceChanged) {
	      this.root.setData(newVal);
	      this._initDefaultCheckedNodes();
	    } else {
	      this.root.updateChildren();
	    }
	  };
	
	  TreeStore.prototype.getNode = function getNode(data) {
	    if (data instanceof model_node) return data;
	    var key = (typeof data === 'undefined' ? 'undefined' : tree_store_typeof(data)) !== 'object' ? data : util_getNodeKey(this.key, data);
	    return this.nodesMap[key] || null;
	  };
	
	  TreeStore.prototype.insertBefore = function insertBefore(data, refData) {
	    var refNode = this.getNode(refData);
	    refNode.parent.insertBefore({ data: data }, refNode);
	  };
	
	  TreeStore.prototype.insertAfter = function insertAfter(data, refData) {
	    var refNode = this.getNode(refData);
	    refNode.parent.insertAfter({ data: data }, refNode);
	  };
	
	  TreeStore.prototype.remove = function remove(data) {
	    var node = this.getNode(data);
	
	    if (node && node.parent) {
	      if (node === this.currentNode) {
	        this.currentNode = null;
	      }
	      node.parent.removeChild(node);
	    }
	  };
	
	  TreeStore.prototype.append = function append(data, parentData) {
	    var parentNode = parentData ? this.getNode(parentData) : this.root;
	
	    if (parentNode) {
	      parentNode.insertChild({ data: data });
	    }
	  };
	
	  TreeStore.prototype._initDefaultCheckedNodes = function _initDefaultCheckedNodes() {
	    var _this2 = this;
	
	    var defaultCheckedKeys = this.defaultCheckedKeys || [];
	    var nodesMap = this.nodesMap;
	
	    defaultCheckedKeys.forEach(function (checkedKey) {
	      var node = nodesMap[checkedKey];
	
	      if (node) {
	        node.setChecked(true, !_this2.checkStrictly);
	      }
	    });
	  };
	
	  TreeStore.prototype._initDefaultCheckedNode = function _initDefaultCheckedNode(node) {
	    var defaultCheckedKeys = this.defaultCheckedKeys || [];
	
	    if (defaultCheckedKeys.indexOf(node.key) !== -1) {
	      node.setChecked(true, !this.checkStrictly);
	    }
	  };
	
	  TreeStore.prototype.setDefaultCheckedKey = function setDefaultCheckedKey(newVal) {
	    if (newVal !== this.defaultCheckedKeys) {
	      this.defaultCheckedKeys = newVal;
	      this._initDefaultCheckedNodes();
	    }
	  };
	
	  TreeStore.prototype.registerNode = function registerNode(node) {
	    var key = this.key;
	    if (!key || !node || !node.data) return;
	
	    var nodeKey = node.key;
	    if (nodeKey !== undefined) this.nodesMap[node.key] = node;
	  };
	
	  TreeStore.prototype.deregisterNode = function deregisterNode(node) {
	    var _this3 = this;
	
	    var key = this.key;
	    if (!key || !node || !node.data) return;
	
	    node.childNodes.forEach(function (child) {
	      _this3.deregisterNode(child);
	    });
	
	    delete this.nodesMap[node.key];
	  };
	
	  TreeStore.prototype.getCheckedNodes = function getCheckedNodes() {
	    var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var includeHalfChecked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var checkedNodes = [];
	    var traverse = function traverse(node) {
	      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
	      childNodes.forEach(function (child) {
	        if ((child.checked || includeHalfChecked && child.indeterminate) && (!leafOnly || leafOnly && child.isLeaf)) {
	          checkedNodes.push(child.data);
	        }
	
	        traverse(child);
	      });
	    };
	
	    traverse(this);
	
	    return checkedNodes;
	  };
	
	  TreeStore.prototype.getCheckedKeys = function getCheckedKeys() {
	    var _this4 = this;
	
	    var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    return this.getCheckedNodes(leafOnly).map(function (data) {
	      return (data || {})[_this4.key];
	    });
	  };
	
	  TreeStore.prototype.getHalfCheckedNodes = function getHalfCheckedNodes() {
	    var nodes = [];
	    var traverse = function traverse(node) {
	      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
	      childNodes.forEach(function (child) {
	        if (child.indeterminate) {
	          nodes.push(child.data);
	        }
	
	        traverse(child);
	      });
	    };
	
	    traverse(this);
	
	    return nodes;
	  };
	
	  TreeStore.prototype.getHalfCheckedKeys = function getHalfCheckedKeys() {
	    var _this5 = this;
	
	    return this.getHalfCheckedNodes().map(function (data) {
	      return (data || {})[_this5.key];
	    });
	  };
	
	  TreeStore.prototype._getAllNodes = function _getAllNodes() {
	    var allNodes = [];
	    var nodesMap = this.nodesMap;
	    for (var nodeKey in nodesMap) {
	      if (nodesMap.hasOwnProperty(nodeKey)) {
	        allNodes.push(nodesMap[nodeKey]);
	      }
	    }
	
	    return allNodes;
	  };
	
	  TreeStore.prototype.updateChildren = function updateChildren(key, data) {
	    var node = this.nodesMap[key];
	    if (!node) return;
	    var childNodes = node.childNodes;
	    for (var i = childNodes.length - 1; i >= 0; i--) {
	      var child = childNodes[i];
	      this.remove(child.data);
	    }
	    for (var _i = 0, j = data.length; _i < j; _i++) {
	      var _child = data[_i];
	      this.append(_child, node.data);
	    }
	  };
	
	  TreeStore.prototype._setCheckedKeys = function _setCheckedKeys(key) {
	    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var checkedKeys = arguments[2];
	
	    var allNodes = this._getAllNodes().sort(function (a, b) {
	      return b.level - a.level;
	    });
	    var cache = Object.create(null);
	    var keys = Object.keys(checkedKeys);
	    allNodes.forEach(function (node) {
	      return node.setChecked(false, false);
	    });
	    for (var i = 0, j = allNodes.length; i < j; i++) {
	      var node = allNodes[i];
	      var nodeKey = node.data[key].toString();
	      var checked = keys.indexOf(nodeKey) > -1;
	      if (!checked) {
	        if (node.checked && !cache[nodeKey]) {
	          node.setChecked(false, false);
	        }
	        continue;
	      }
	
	      var parent = node.parent;
	      while (parent && parent.level > 0) {
	        cache[parent.data[key]] = true;
	        parent = parent.parent;
	      }
	
	      if (node.isLeaf || this.checkStrictly) {
	        node.setChecked(true, false);
	        continue;
	      }
	      node.setChecked(true, true);
	
	      if (leafOnly) {
	        (function () {
	          node.setChecked(false, false);
	          var traverse = function traverse(node) {
	            var childNodes = node.childNodes;
	            childNodes.forEach(function (child) {
	              if (!child.isLeaf) {
	                child.setChecked(false, false);
	              }
	              traverse(child);
	            });
	          };
	          traverse(node);
	        })();
	      }
	    }
	  };
	
	  TreeStore.prototype.setCheckedNodes = function setCheckedNodes(array) {
	    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var key = this.key;
	    var checkedKeys = {};
	    array.forEach(function (item) {
	      checkedKeys[(item || {})[key]] = true;
	    });
	
	    this._setCheckedKeys(key, leafOnly, checkedKeys);
	  };
	
	  TreeStore.prototype.setCheckedKeys = function setCheckedKeys(keys) {
	    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    this.defaultCheckedKeys = keys;
	    var key = this.key;
	    var checkedKeys = {};
	    keys.forEach(function (key) {
	      checkedKeys[key] = true;
	    });
	
	    this._setCheckedKeys(key, leafOnly, checkedKeys);
	  };
	
	  TreeStore.prototype.setDefaultExpandedKeys = function setDefaultExpandedKeys(keys) {
	    var _this6 = this;
	
	    keys = keys || [];
	    this.defaultExpandedKeys = keys;
	
	    keys.forEach(function (key) {
	      var node = _this6.getNode(key);
	      if (node) node.expand(null, _this6.autoExpandParent);
	    });
	  };
	
	  TreeStore.prototype.setChecked = function setChecked(data, checked, deep) {
	    var node = this.getNode(data);
	
	    if (node) {
	      node.setChecked(!!checked, deep);
	    }
	  };
	
	  TreeStore.prototype.getCurrentNode = function getCurrentNode() {
	    return this.currentNode;
	  };
	
	  TreeStore.prototype.setCurrentNode = function setCurrentNode(currentNode) {
	    var prevCurrentNode = this.currentNode;
	    if (prevCurrentNode) {
	      prevCurrentNode.isCurrent = false;
	    }
	    this.currentNode = currentNode;
	    this.currentNode.isCurrent = true;
	  };
	
	  TreeStore.prototype.setUserCurrentNode = function setUserCurrentNode(node) {
	    var key = node[this.key];
	    var currNode = this.nodesMap[key];
	    this.setCurrentNode(currNode);
	  };
	
	  TreeStore.prototype.setCurrentNodeKey = function setCurrentNodeKey(key) {
	    if (key === null || key === undefined) {
	      this.currentNode && (this.currentNode.isCurrent = false);
	      this.currentNode = null;
	      return;
	    }
	    var node = this.getNode(key);
	    if (node) {
	      this.setCurrentNode(node);
	    }
	  };
	
	  return TreeStore;
	}();
	
	/* harmony default export */ var tree_store = (tree_store_TreeStore);
	;
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&
	var tree_nodevue_type_template_id_3ba3ef0e_render = function() {
	  var this$1 = this
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.node.visible,
	          expression: "node.visible"
	        }
	      ],
	      ref: "node",
	      staticClass: "el-tree-node",
	      class: {
	        "is-expanded": _vm.expanded,
	        "is-current": _vm.node.isCurrent,
	        "is-hidden": !_vm.node.visible,
	        "is-focusable": !_vm.node.disabled,
	        "is-checked": !_vm.node.disabled && _vm.node.checked
	      },
	      attrs: {
	        role: "treeitem",
	        tabindex: "-1",
	        "aria-expanded": _vm.expanded,
	        "aria-disabled": _vm.node.disabled,
	        "aria-checked": _vm.node.checked,
	        draggable: _vm.tree.draggable
	      },
	      on: {
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.handleClick($event)
	        },
	        contextmenu: function($event) {
	          return this$1.handleContextMenu($event)
	        },
	        dragstart: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDragStart($event)
	        },
	        dragover: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDragOver($event)
	        },
	        dragend: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDragEnd($event)
	        },
	        drop: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDrop($event)
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          staticClass: "el-tree-node__content",
	          style: {
	            "padding-left": (_vm.node.level - 1) * _vm.tree.indent + "px"
	          }
	        },
	        [
	          _c("span", {
	            class: [
	              {
	                "is-leaf": _vm.node.isLeaf,
	                expanded: !_vm.node.isLeaf && _vm.expanded
	              },
	              "el-tree-node__expand-icon",
	              _vm.tree.iconClass ? _vm.tree.iconClass : "el-icon-caret-right"
	            ],
	            on: {
	              click: function($event) {
	                $event.stopPropagation()
	                return _vm.handleExpandIconClick($event)
	              }
	            }
	          }),
	          _vm.showCheckbox
	            ? _c("el-checkbox", {
	                attrs: {
	                  indeterminate: _vm.node.indeterminate,
	                  disabled: !!_vm.node.disabled
	                },
	                on: { change: _vm.handleCheckChange },
	                nativeOn: {
	                  click: function($event) {
	                    $event.stopPropagation()
	                  }
	                },
	                model: {
	                  value: _vm.node.checked,
	                  callback: function($$v) {
	                    _vm.$set(_vm.node, "checked", $$v)
	                  },
	                  expression: "node.checked"
	                }
	              })
	            : _vm._e(),
	          _vm.node.loading
	            ? _c("span", {
	                staticClass: "el-tree-node__loading-icon el-icon-loading"
	              })
	            : _vm._e(),
	          _c("node-content", { attrs: { node: _vm.node } })
	        ],
	        1
	      ),
	      _c("el-collapse-transition", [
	        !_vm.renderAfterExpand || _vm.childNodeRendered
	          ? _c(
	              "div",
	              {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: _vm.expanded,
	                    expression: "expanded"
	                  }
	                ],
	                staticClass: "el-tree-node__children",
	                attrs: { role: "group", "aria-expanded": _vm.expanded }
	              },
	              _vm._l(_vm.node.childNodes, function(child) {
	                return _c("el-tree-node", {
	                  key: _vm.getNodeKey(child),
	                  attrs: {
	                    "render-content": _vm.renderContent,
	                    "render-after-expand": _vm.renderAfterExpand,
	                    "show-checkbox": _vm.showCheckbox,
	                    node: child
	                  },
	                  on: { "node-expand": _vm.handleChildNodeExpand }
	                })
	              }),
	              1
	            )
	          : _vm._e()
	      ])
	    ],
	    1
	  )
	}
	var tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns = []
	tree_nodevue_type_template_id_3ba3ef0e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var tree_nodevue_type_script_lang_js_ = ({
	  name: 'ElTreeNode',
	
	  componentName: 'ElTreeNode',
	
	  mixins: [emitter_default.a],
	
	  props: {
	    node: {
	      default: function _default() {
	        return {};
	      }
	    },
	    props: {},
	    renderContent: Function,
	    renderAfterExpand: {
	      type: Boolean,
	      default: true
	    },
	    showCheckbox: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  components: {
	    ElCollapseTransition: collapse_transition_default.a,
	    ElCheckbox: checkbox_default.a,
	    NodeContent: {
	      props: {
	        node: {
	          required: true
	        }
	      },
	      render: function render(h) {
	        var parent = this.$parent;
	        var tree = parent.tree;
	        var node = this.node;
	        var data = node.data,
	            store = node.store;
	
	        return parent.renderContent ? parent.renderContent.call(parent._renderProxy, h, { _self: tree.$vnode.context, node: node, data: data, store: store }) : tree.$scopedSlots.default ? tree.$scopedSlots.default({ node: node, data: data }) : h(
	          'span',
	          { 'class': 'el-tree-node__label' },
	          [node.label]
	        );
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      tree: null,
	      expanded: false,
	      childNodeRendered: false,
	      oldChecked: null,
	      oldIndeterminate: null
	    };
	  },
	
	
	  watch: {
	    'node.indeterminate': function nodeIndeterminate(val) {
	      this.handleSelectChange(this.node.checked, val);
	    },
	    'node.checked': function nodeChecked(val) {
	      this.handleSelectChange(val, this.node.indeterminate);
	    },
	    'node.expanded': function nodeExpanded(val) {
	      var _this = this;
	
	      this.$nextTick(function () {
	        return _this.expanded = val;
	      });
	      if (val) {
	        this.childNodeRendered = true;
	      }
	    }
	  },
	
	  methods: {
	    getNodeKey: function getNodeKey(node) {
	      return util_getNodeKey(this.tree.nodeKey, node.data);
	    },
	    handleSelectChange: function handleSelectChange(checked, indeterminate) {
	      if (this.oldChecked !== checked && this.oldIndeterminate !== indeterminate) {
	        this.tree.$emit('check-change', this.node.data, checked, indeterminate);
	      }
	      this.oldChecked = checked;
	      this.indeterminate = indeterminate;
	    },
	    handleClick: function handleClick() {
	      var store = this.tree.store;
	      store.setCurrentNode(this.node);
	      this.tree.$emit('current-change', store.currentNode ? store.currentNode.data : null, store.currentNode);
	      this.tree.currentNode = this;
	      if (this.tree.expandOnClickNode) {
	        this.handleExpandIconClick();
	      }
	      if (this.tree.checkOnClickNode && !this.node.disabled) {
	        this.handleCheckChange(null, {
	          target: { checked: !this.node.checked }
	        });
	      }
	      this.tree.$emit('node-click', this.node.data, this.node, this);
	    },
	    handleContextMenu: function handleContextMenu(event) {
	      if (this.tree._events['node-contextmenu'] && this.tree._events['node-contextmenu'].length > 0) {
	        event.stopPropagation();
	        event.preventDefault();
	      }
	      this.tree.$emit('node-contextmenu', event, this.node.data, this.node, this);
	    },
	    handleExpandIconClick: function handleExpandIconClick() {
	      if (this.node.isLeaf) return;
	      if (this.expanded) {
	        this.tree.$emit('node-collapse', this.node.data, this.node, this);
	        this.node.collapse();
	      } else {
	        this.node.expand();
	        this.$emit('node-expand', this.node.data, this.node, this);
	      }
	    },
	    handleCheckChange: function handleCheckChange(value, ev) {
	      var _this2 = this;
	
	      this.node.setChecked(ev.target.checked, !this.tree.checkStrictly);
	      this.$nextTick(function () {
	        var store = _this2.tree.store;
	        _this2.tree.$emit('check', _this2.node.data, {
	          checkedNodes: store.getCheckedNodes(),
	          checkedKeys: store.getCheckedKeys(),
	          halfCheckedNodes: store.getHalfCheckedNodes(),
	          halfCheckedKeys: store.getHalfCheckedKeys()
	        });
	      });
	    },
	    handleChildNodeExpand: function handleChildNodeExpand(nodeData, node, instance) {
	      this.broadcast('ElTreeNode', 'tree-node-expand', node);
	      this.tree.$emit('node-expand', nodeData, node, instance);
	    },
	    handleDragStart: function handleDragStart(event) {
	      if (!this.tree.draggable) return;
	      this.tree.$emit('tree-node-drag-start', event, this);
	    },
	    handleDragOver: function handleDragOver(event) {
	      if (!this.tree.draggable) return;
	      this.tree.$emit('tree-node-drag-over', event, this);
	      event.preventDefault();
	    },
	    handleDrop: function handleDrop(event) {
	      event.preventDefault();
	    },
	    handleDragEnd: function handleDragEnd(event) {
	      if (!this.tree.draggable) return;
	      this.tree.$emit('tree-node-drag-end', event, this);
	    }
	  },
	
	  created: function created() {
	    var _this3 = this;
	
	    var parent = this.$parent;
	
	    if (parent.isTree) {
	      this.tree = parent;
	    } else {
	      this.tree = parent.tree;
	    }
	
	    var tree = this.tree;
	    if (!tree) {
	      console.warn('Can not find node\'s tree.');
	    }
	
	    var props = tree.props || {};
	    var childrenKey = props['children'] || 'children';
	
	    this.$watch('node.data.' + childrenKey, function () {
	      _this3.node.updateChildren();
	    });
	
	    if (this.node.expanded) {
	      this.expanded = true;
	      this.childNodeRendered = true;
	    }
	
	    if (this.tree.accordion) {
	      this.$on('tree-node-expand', function (node) {
	        if (_this3.node !== node) {
	          _this3.node.collapse();
	        }
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tree_nodevue_type_script_lang_js_ = (tree_nodevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue
	
	
	
	
	
	/* normalize component */
	
	var tree_node_component = normalizeComponent(
	  src_tree_nodevue_type_script_lang_js_,
	  tree_nodevue_type_template_id_3ba3ef0e_render,
	  tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tree_node_api; }
	tree_node_component.options.__file = "packages/tree/src/tree-node.vue"
	/* harmony default export */ var tree_node = (tree_node_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	/* harmony default export */ var treevue_type_script_lang_js_ = ({
	  name: 'ElTree',
	
	  mixins: [emitter_default.a],
	
	  components: {
	    ElTreeNode: tree_node
	  },
	
	  data: function data() {
	    return {
	      store: null,
	      root: null,
	      currentNode: null,
	      treeItems: null,
	      checkboxItems: [],
	      dragState: {
	        showDropIndicator: false,
	        draggingNode: null,
	        dropNode: null,
	        allowDrop: true
	      }
	    };
	  },
	
	
	  props: {
	    data: {
	      type: Array
	    },
	    emptyText: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.tree.emptyText');
	      }
	    },
	    renderAfterExpand: {
	      type: Boolean,
	      default: true
	    },
	    nodeKey: String,
	    checkStrictly: Boolean,
	    defaultExpandAll: Boolean,
	    expandOnClickNode: {
	      type: Boolean,
	      default: true
	    },
	    checkOnClickNode: Boolean,
	    checkDescendants: {
	      type: Boolean,
	      default: false
	    },
	    autoExpandParent: {
	      type: Boolean,
	      default: true
	    },
	    defaultCheckedKeys: Array,
	    defaultExpandedKeys: Array,
	    currentNodeKey: [String, Number],
	    renderContent: Function,
	    showCheckbox: {
	      type: Boolean,
	      default: false
	    },
	    draggable: {
	      type: Boolean,
	      default: false
	    },
	    allowDrag: Function,
	    allowDrop: Function,
	    props: {
	      default: function _default() {
	        return {
	          children: 'children',
	          label: 'label',
	          disabled: 'disabled'
	        };
	      }
	    },
	    lazy: {
	      type: Boolean,
	      default: false
	    },
	    highlightCurrent: Boolean,
	    load: Function,
	    filterNodeMethod: Function,
	    accordion: Boolean,
	    indent: {
	      type: Number,
	      default: 18
	    },
	    iconClass: String
	  },
	
	  computed: {
	    children: {
	      set: function set(value) {
	        this.data = value;
	      },
	      get: function get() {
	        return this.data;
	      }
	    },
	
	    treeItemArray: function treeItemArray() {
	      return Array.prototype.slice.call(this.treeItems);
	    },
	    isEmpty: function isEmpty() {
	      var childNodes = this.root.childNodes;
	
	      return !childNodes || childNodes.length === 0 || childNodes.every(function (_ref) {
	        var visible = _ref.visible;
	        return !visible;
	      });
	    }
	  },
	
	  watch: {
	    defaultCheckedKeys: function defaultCheckedKeys(newVal) {
	      this.store.setDefaultCheckedKey(newVal);
	    },
	    defaultExpandedKeys: function defaultExpandedKeys(newVal) {
	      this.store.defaultExpandedKeys = newVal;
	      this.store.setDefaultExpandedKeys(newVal);
	    },
	    data: function data(newVal) {
	      this.store.setData(newVal);
	    },
	    checkboxItems: function checkboxItems(val) {
	      Array.prototype.forEach.call(val, function (checkbox) {
	        checkbox.setAttribute('tabindex', -1);
	      });
	    },
	    checkStrictly: function checkStrictly(newVal) {
	      this.store.checkStrictly = newVal;
	    }
	  },
	
	  methods: {
	    filter: function filter(value) {
	      if (!this.filterNodeMethod) throw new Error('[Tree] filterNodeMethod is required when filter');
	      this.store.filter(value);
	    },
	    getNodeKey: function getNodeKey(node) {
	      return util_getNodeKey(this.nodeKey, node.data);
	    },
	    getNodePath: function getNodePath(data) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in getNodePath');
	      var node = this.store.getNode(data);
	      if (!node) return [];
	      var path = [node.data];
	      var parent = node.parent;
	      while (parent && parent !== this.root) {
	        path.push(parent.data);
	        parent = parent.parent;
	      }
	      return path.reverse();
	    },
	    getCheckedNodes: function getCheckedNodes(leafOnly, includeHalfChecked) {
	      return this.store.getCheckedNodes(leafOnly, includeHalfChecked);
	    },
	    getCheckedKeys: function getCheckedKeys(leafOnly) {
	      return this.store.getCheckedKeys(leafOnly);
	    },
	    getCurrentNode: function getCurrentNode() {
	      var currentNode = this.store.getCurrentNode();
	      return currentNode ? currentNode.data : null;
	    },
	    getCurrentKey: function getCurrentKey() {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in getCurrentKey');
	      var currentNode = this.getCurrentNode();
	      return currentNode ? currentNode[this.nodeKey] : null;
	    },
	    setCheckedNodes: function setCheckedNodes(nodes, leafOnly) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedNodes');
	      this.store.setCheckedNodes(nodes, leafOnly);
	    },
	    setCheckedKeys: function setCheckedKeys(keys, leafOnly) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedKeys');
	      this.store.setCheckedKeys(keys, leafOnly);
	    },
	    setChecked: function setChecked(data, checked, deep) {
	      this.store.setChecked(data, checked, deep);
	    },
	    getHalfCheckedNodes: function getHalfCheckedNodes() {
	      return this.store.getHalfCheckedNodes();
	    },
	    getHalfCheckedKeys: function getHalfCheckedKeys() {
	      return this.store.getHalfCheckedKeys();
	    },
	    setCurrentNode: function setCurrentNode(node) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCurrentNode');
	      this.store.setUserCurrentNode(node);
	    },
	    setCurrentKey: function setCurrentKey(key) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCurrentKey');
	      this.store.setCurrentNodeKey(key);
	    },
	    getNode: function getNode(data) {
	      return this.store.getNode(data);
	    },
	    remove: function remove(data) {
	      this.store.remove(data);
	    },
	    append: function append(data, parentNode) {
	      this.store.append(data, parentNode);
	    },
	    insertBefore: function insertBefore(data, refNode) {
	      this.store.insertBefore(data, refNode);
	    },
	    insertAfter: function insertAfter(data, refNode) {
	      this.store.insertAfter(data, refNode);
	    },
	    handleNodeExpand: function handleNodeExpand(nodeData, node, instance) {
	      this.broadcast('ElTreeNode', 'tree-node-expand', node);
	      this.$emit('node-expand', nodeData, node, instance);
	    },
	    updateKeyChildren: function updateKeyChildren(key, data) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in updateKeyChild');
	      this.store.updateChildren(key, data);
	    },
	    initTabIndex: function initTabIndex() {
	      this.treeItems = this.$el.querySelectorAll('.is-focusable[role=treeitem]');
	      this.checkboxItems = this.$el.querySelectorAll('input[type=checkbox]');
	      var checkedItem = this.$el.querySelectorAll('.is-checked[role=treeitem]');
	      if (checkedItem.length) {
	        checkedItem[0].setAttribute('tabindex', 0);
	        return;
	      }
	      this.treeItems[0] && this.treeItems[0].setAttribute('tabindex', 0);
	    },
	    handleKeydown: function handleKeydown(ev) {
	      var currentItem = ev.target;
	      if (currentItem.className.indexOf('el-tree-node') === -1) return;
	      var keyCode = ev.keyCode;
	      this.treeItems = this.$el.querySelectorAll('.is-focusable[role=treeitem]');
	      var currentIndex = this.treeItemArray.indexOf(currentItem);
	      var nextIndex = void 0;
	      if ([38, 40].indexOf(keyCode) > -1) {
	        // up、down
	        ev.preventDefault();
	        if (keyCode === 38) {
	          // up
	          nextIndex = currentIndex !== 0 ? currentIndex - 1 : 0;
	        } else {
	          nextIndex = currentIndex < this.treeItemArray.length - 1 ? currentIndex + 1 : 0;
	        }
	        this.treeItemArray[nextIndex].focus(); // 选中
	      }
	      if ([37, 39].indexOf(keyCode) > -1) {
	        // left、right 展开
	        ev.preventDefault();
	        currentItem.click(); // 选中
	      }
	      var hasInput = currentItem.querySelector('[type="checkbox"]');
	      if ([13, 32].indexOf(keyCode) > -1 && hasInput) {
	        // space enter选中checkbox
	        ev.preventDefault();
	        hasInput.click();
	      }
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.isTree = true;
	
	    this.store = new tree_store({
	      key: this.nodeKey,
	      data: this.data,
	      lazy: this.lazy,
	      props: this.props,
	      load: this.load,
	      currentNodeKey: this.currentNodeKey,
	      checkStrictly: this.checkStrictly,
	      checkDescendants: this.checkDescendants,
	      defaultCheckedKeys: this.defaultCheckedKeys,
	      defaultExpandedKeys: this.defaultExpandedKeys,
	      autoExpandParent: this.autoExpandParent,
	      defaultExpandAll: this.defaultExpandAll,
	      filterNodeMethod: this.filterNodeMethod
	    });
	
	    this.root = this.store.root;
	
	    var dragState = this.dragState;
	    this.$on('tree-node-drag-start', function (event, treeNode) {
	      if (typeof _this.allowDrag === 'function' && !_this.allowDrag(treeNode.node)) {
	        event.preventDefault();
	        return false;
	      }
	      event.dataTransfer.effectAllowed = 'move';
	
	      // wrap in try catch to address IE's error when first param is 'text/plain'
	      try {
	        // setData is required for draggable to work in FireFox
	        // the content has to be '' so dragging a node out of the tree won't open a new tab in FireFox
	        event.dataTransfer.setData('text/plain', '');
	      } catch (e) {}
	      dragState.draggingNode = treeNode;
	      _this.$emit('node-drag-start', treeNode.node, event);
	    });
	
	    this.$on('tree-node-drag-over', function (event, treeNode) {
	      var dropNode = findNearestComponent(event.target, 'ElTreeNode');
	      var oldDropNode = dragState.dropNode;
	      if (oldDropNode && oldDropNode !== dropNode) {
	        Object(dom_["removeClass"])(oldDropNode.$el, 'is-drop-inner');
	      }
	      var draggingNode = dragState.draggingNode;
	      if (!draggingNode || !dropNode) return;
	
	      var dropPrev = true;
	      var dropInner = true;
	      var dropNext = true;
	      var userAllowDropInner = true;
	      if (typeof _this.allowDrop === 'function') {
	        dropPrev = _this.allowDrop(draggingNode.node, dropNode.node, 'prev');
	        userAllowDropInner = dropInner = _this.allowDrop(draggingNode.node, dropNode.node, 'inner');
	        dropNext = _this.allowDrop(draggingNode.node, dropNode.node, 'next');
	      }
	      event.dataTransfer.dropEffect = dropInner ? 'move' : 'none';
	      if ((dropPrev || dropInner || dropNext) && oldDropNode !== dropNode) {
	        if (oldDropNode) {
	          _this.$emit('node-drag-leave', draggingNode.node, oldDropNode.node, event);
	        }
	        _this.$emit('node-drag-enter', draggingNode.node, dropNode.node, event);
	      }
	
	      if (dropPrev || dropInner || dropNext) {
	        dragState.dropNode = dropNode;
	      }
	
	      if (dropNode.node.nextSibling === draggingNode.node) {
	        dropNext = false;
	      }
	      if (dropNode.node.previousSibling === draggingNode.node) {
	        dropPrev = false;
	      }
	      if (dropNode.node.contains(draggingNode.node, false)) {
	        dropInner = false;
	      }
	      if (draggingNode.node === dropNode.node || draggingNode.node.contains(dropNode.node)) {
	        dropPrev = false;
	        dropInner = false;
	        dropNext = false;
	      }
	
	      var targetPosition = dropNode.$el.getBoundingClientRect();
	      var treePosition = _this.$el.getBoundingClientRect();
	
	      var dropType = void 0;
	      var prevPercent = dropPrev ? dropInner ? 0.25 : dropNext ? 0.45 : 1 : -1;
	      var nextPercent = dropNext ? dropInner ? 0.75 : dropPrev ? 0.55 : 0 : 1;
	
	      var indicatorTop = -9999;
	      var distance = event.clientY - targetPosition.top;
	      if (distance < targetPosition.height * prevPercent) {
	        dropType = 'before';
	      } else if (distance > targetPosition.height * nextPercent) {
	        dropType = 'after';
	      } else if (dropInner) {
	        dropType = 'inner';
	      } else {
	        dropType = 'none';
	      }
	
	      var iconPosition = dropNode.$el.querySelector('.el-tree-node__expand-icon').getBoundingClientRect();
	      var dropIndicator = _this.$refs.dropIndicator;
	      if (dropType === 'before') {
	        indicatorTop = iconPosition.top - treePosition.top;
	      } else if (dropType === 'after') {
	        indicatorTop = iconPosition.bottom - treePosition.top;
	      }
	      dropIndicator.style.top = indicatorTop + 'px';
	      dropIndicator.style.left = iconPosition.right - treePosition.left + 'px';
	
	      if (dropType === 'inner') {
	        Object(dom_["addClass"])(dropNode.$el, 'is-drop-inner');
	      } else {
	        Object(dom_["removeClass"])(dropNode.$el, 'is-drop-inner');
	      }
	
	      dragState.showDropIndicator = dropType === 'before' || dropType === 'after';
	      dragState.allowDrop = dragState.showDropIndicator || userAllowDropInner;
	      dragState.dropType = dropType;
	      _this.$emit('node-drag-over', draggingNode.node, dropNode.node, event);
	    });
	
	    this.$on('tree-node-drag-end', function (event) {
	      var draggingNode = dragState.draggingNode,
	          dropType = dragState.dropType,
	          dropNode = dragState.dropNode;
	
	      event.preventDefault();
	      event.dataTransfer.dropEffect = 'move';
	
	      if (draggingNode && dropNode) {
	        var draggingNodeCopy = { data: draggingNode.node.data };
	        if (dropType !== 'none') {
	          draggingNode.node.remove();
	        }
	        if (dropType === 'before') {
	          dropNode.node.parent.insertBefore(draggingNodeCopy, dropNode.node);
	        } else if (dropType === 'after') {
	          dropNode.node.parent.insertAfter(draggingNodeCopy, dropNode.node);
	        } else if (dropType === 'inner') {
	          dropNode.node.insertChild(draggingNodeCopy);
	        }
	        if (dropType !== 'none') {
	          _this.store.registerNode(draggingNodeCopy);
	        }
	
	        Object(dom_["removeClass"])(dropNode.$el, 'is-drop-inner');
	
	        _this.$emit('node-drag-end', draggingNode.node, dropNode.node, dropType, event);
	        if (dropType !== 'none') {
	          _this.$emit('node-drop', draggingNode.node, dropNode.node, dropType, event);
	        }
	      }
	      if (draggingNode && !dropNode) {
	        _this.$emit('node-drag-end', draggingNode.node, null, dropType, event);
	      }
	
	      dragState.showDropIndicator = false;
	      dragState.draggingNode = null;
	      dragState.dropNode = null;
	      dragState.allowDrop = true;
	    });
	  },
	  mounted: function mounted() {
	    this.initTabIndex();
	    this.$el.addEventListener('keydown', this.handleKeydown);
	  },
	  updated: function updated() {
	    this.treeItems = this.$el.querySelectorAll('[role=treeitem]');
	    this.checkboxItems = this.$el.querySelectorAll('input[type=checkbox]');
	  }
	});
	// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_treevue_type_script_lang_js_ = (treevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tree/src/tree.vue
	
	
	
	
	
	/* normalize component */
	
	var tree_component = normalizeComponent(
	  src_treevue_type_script_lang_js_,
	  treevue_type_template_id_547575a6_render,
	  treevue_type_template_id_547575a6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tree_api; }
	tree_component.options.__file = "packages/tree/src/tree.vue"
	/* harmony default export */ var src_tree = (tree_component.exports);
	// CONCATENATED MODULE: ./packages/tree/index.js
	
	
	/* istanbul ignore next */
	src_tree.install = function (Vue) {
	  Vue.component(src_tree.name, src_tree);
	};
	
	/* harmony default export */ var packages_tree = (src_tree);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=template&id=6e53341b&
	var mainvue_type_template_id_6e53341b_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-alert-fade" } }, [
	    _c(
	      "div",
	      {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.visible,
	            expression: "visible"
	          }
	        ],
	        staticClass: "el-alert",
	        class: [
	          _vm.typeClass,
	          _vm.center ? "is-center" : "",
	          "is-" + _vm.effect
	        ],
	        attrs: { role: "alert" }
	      },
	      [
	        _vm.showIcon
	          ? _c("i", {
	              staticClass: "el-alert__icon",
	              class: [_vm.iconClass, _vm.isBigIcon]
	            })
	          : _vm._e(),
	        _c("div", { staticClass: "el-alert__content" }, [
	          _vm.title || _vm.$slots.title
	            ? _c(
	                "span",
	                { staticClass: "el-alert__title", class: [_vm.isBoldTitle] },
	                [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
	                2
	              )
	            : _vm._e(),
	          _vm.$slots.default && !_vm.description
	            ? _c(
	                "p",
	                { staticClass: "el-alert__description" },
	                [_vm._t("default")],
	                2
	              )
	            : _vm._e(),
	          _vm.description && !_vm.$slots.default
	            ? _c("p", { staticClass: "el-alert__description" }, [
	                _vm._v(_vm._s(_vm.description))
	              ])
	            : _vm._e(),
	          _c(
	            "i",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.closable,
	                  expression: "closable"
	                }
	              ],
	              staticClass: "el-alert__closebtn",
	              class: {
	                "is-customed": _vm.closeText !== "",
	                "el-icon-close": _vm.closeText === ""
	              },
	              on: {
	                click: function($event) {
	                  _vm.close()
	                }
	              }
	            },
	            [_vm._v(_vm._s(_vm.closeText))]
	          )
	        ])
	      ]
	    )
	  ])
	}
	var mainvue_type_template_id_6e53341b_staticRenderFns = []
	mainvue_type_template_id_6e53341b_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=template&id=6e53341b&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var TYPE_CLASSES_MAP = {
	  'success': 'el-icon-success',
	  'warning': 'el-icon-warning',
	  'error': 'el-icon-error'
	};
	/* harmony default export */ var alert_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElAlert',
	
	  props: {
	    title: {
	      type: String,
	      default: ''
	    },
	    description: {
	      type: String,
	      default: ''
	    },
	    type: {
	      type: String,
	      default: 'info'
	    },
	    closable: {
	      type: Boolean,
	      default: true
	    },
	    closeText: {
	      type: String,
	      default: ''
	    },
	    showIcon: Boolean,
	    center: Boolean,
	    effect: {
	      type: String,
	      default: 'light',
	      validator: function validator(value) {
	        return ['light', 'dark'].indexOf(value) !== -1;
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      visible: true
	    };
	  },
	
	
	  methods: {
	    close: function close() {
	      this.visible = false;
	      this.$emit('close');
	    }
	  },
	
	  computed: {
	    typeClass: function typeClass() {
	      return 'el-alert--' + this.type;
	    },
	    iconClass: function iconClass() {
	      return TYPE_CLASSES_MAP[this.type] || 'el-icon-info';
	    },
	    isBigIcon: function isBigIcon() {
	      return this.description || this.$slots.default ? 'is-big' : '';
	    },
	    isBoldTitle: function isBoldTitle() {
	      return this.description || this.$slots.default ? 'is-bold' : '';
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_alert_src_mainvue_type_script_lang_js_ = (alert_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/alert/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var alert_src_main_component = normalizeComponent(
	  packages_alert_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_6e53341b_render,
	  mainvue_type_template_id_6e53341b_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var alert_src_main_api; }
	alert_src_main_component.options.__file = "packages/alert/src/main.vue"
	/* harmony default export */ var alert_src_main = (alert_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/alert/index.js
	
	
	/* istanbul ignore next */
	alert_src_main.install = function (Vue) {
	  Vue.component(alert_src_main.name, alert_src_main);
	};
	
	/* harmony default export */ var packages_alert = (alert_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
	var mainvue_type_template_id_43dbc3d8_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-notification-fade" } }, [
	    _c(
	      "div",
	      {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.visible,
	            expression: "visible"
	          }
	        ],
	        class: ["el-notification", _vm.customClass, _vm.horizontalClass],
	        style: _vm.positionStyle,
	        attrs: { role: "alert" },
	        on: {
	          mouseenter: function($event) {
	            _vm.clearTimer()
	          },
	          mouseleave: function($event) {
	            _vm.startTimer()
	          },
	          click: _vm.click
	        }
	      },
	      [
	        _vm.type || _vm.iconClass
	          ? _c("i", {
	              staticClass: "el-notification__icon",
	              class: [_vm.typeClass, _vm.iconClass]
	            })
	          : _vm._e(),
	        _c(
	          "div",
	          {
	            staticClass: "el-notification__group",
	            class: { "is-with-icon": _vm.typeClass || _vm.iconClass }
	          },
	          [
	            _c("h2", {
	              staticClass: "el-notification__title",
	              domProps: { textContent: _vm._s(_vm.title) }
	            }),
	            _c(
	              "div",
	              {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: _vm.message,
	                    expression: "message"
	                  }
	                ],
	                staticClass: "el-notification__content"
	              },
	              [
	                _vm._t("default", [
	                  !_vm.dangerouslyUseHTMLString
	                    ? _c("p", [_vm._v(_vm._s(_vm.message))])
	                    : _c("p", { domProps: { innerHTML: _vm._s(_vm.message) } })
	                ])
	              ],
	              2
	            ),
	            _vm.showClose
	              ? _c("div", {
	                  staticClass: "el-notification__closeBtn el-icon-close",
	                  on: {
	                    click: function($event) {
	                      $event.stopPropagation()
	                      return _vm.close($event)
	                    }
	                  }
	                })
	              : _vm._e()
	          ]
	        )
	      ]
	    )
	  ])
	}
	var mainvue_type_template_id_43dbc3d8_staticRenderFns = []
	mainvue_type_template_id_43dbc3d8_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var mainvue_type_script_lang_js_typeMap = {
	  success: 'success',
	  info: 'info',
	  warning: 'warning',
	  error: 'error'
	};
	
	/* harmony default export */ var notification_src_mainvue_type_script_lang_js_ = ({
	  data: function data() {
	    return {
	      visible: false,
	      title: '',
	      message: '',
	      duration: 4500,
	      type: '',
	      showClose: true,
	      customClass: '',
	      iconClass: '',
	      onClose: null,
	      onClick: null,
	      closed: false,
	      verticalOffset: 0,
	      timer: null,
	      dangerouslyUseHTMLString: false,
	      position: 'top-right'
	    };
	  },
	
	
	  computed: {
	    typeClass: function typeClass() {
	      return this.type && mainvue_type_script_lang_js_typeMap[this.type] ? 'el-icon-' + mainvue_type_script_lang_js_typeMap[this.type] : '';
	    },
	    horizontalClass: function horizontalClass() {
	      return this.position.indexOf('right') > -1 ? 'right' : 'left';
	    },
	    verticalProperty: function verticalProperty() {
	      return (/^top-/.test(this.position) ? 'top' : 'bottom'
	      );
	    },
	    positionStyle: function positionStyle() {
	      var _ref;
	
	      return _ref = {}, _ref[this.verticalProperty] = this.verticalOffset + 'px', _ref;
	    }
	  },
	
	  watch: {
	    closed: function closed(newVal) {
	      if (newVal) {
	        this.visible = false;
	        this.$el.addEventListener('transitionend', this.destroyElement);
	      }
	    }
	  },
	
	  methods: {
	    destroyElement: function destroyElement() {
	      this.$el.removeEventListener('transitionend', this.destroyElement);
	      this.$destroy(true);
	      this.$el.parentNode.removeChild(this.$el);
	    },
	    click: function click() {
	      if (typeof this.onClick === 'function') {
	        this.onClick();
	      }
	    },
	    close: function close() {
	      this.closed = true;
	      if (typeof this.onClose === 'function') {
	        this.onClose();
	      }
	    },
	    clearTimer: function clearTimer() {
	      clearTimeout(this.timer);
	    },
	    startTimer: function startTimer() {
	      var _this = this;
	
	      if (this.duration > 0) {
	        this.timer = setTimeout(function () {
	          if (!_this.closed) {
	            _this.close();
	          }
	        }, this.duration);
	      }
	    },
	    keydown: function keydown(e) {
	      if (e.keyCode === 46 || e.keyCode === 8) {
	        this.clearTimer(); // detele 取消倒计时
	      } else if (e.keyCode === 27) {
	        // esc关闭消息
	        if (!this.closed) {
	          this.close();
	        }
	      } else {
	        this.startTimer(); // 恢复倒计时
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    if (this.duration > 0) {
	      this.timer = setTimeout(function () {
	        if (!_this2.closed) {
	          _this2.close();
	        }
	      }, this.duration);
	    }
	    document.addEventListener('keydown', this.keydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this.keydown);
	  }
	});
	// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_notification_src_mainvue_type_script_lang_js_ = (notification_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/notification/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var notification_src_main_component = normalizeComponent(
	  packages_notification_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_43dbc3d8_render,
	  mainvue_type_template_id_43dbc3d8_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var notification_src_main_api; }
	notification_src_main_component.options.__file = "packages/notification/src/main.vue"
	/* harmony default export */ var notification_src_main = (notification_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/notification/src/main.js
	
	
	
	
	
	var NotificationConstructor = external_vue_default.a.extend(notification_src_main);
	
	var src_main_instance = void 0;
	var instances = [];
	var seed = 1;
	
	var main_Notification = function Notification(options) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  options = merge_default()({}, options);
	  var userOnClose = options.onClose;
	  var id = 'notification_' + seed++;
	  var position = options.position || 'top-right';
	
	  options.onClose = function () {
	    Notification.close(id, userOnClose);
	  };
	
	  src_main_instance = new NotificationConstructor({
	    data: options
	  });
	
	  if (Object(vdom_["isVNode"])(options.message)) {
	    src_main_instance.$slots.default = [options.message];
	    options.message = 'REPLACED_BY_VNODE';
	  }
	  src_main_instance.id = id;
	  src_main_instance.$mount();
	  document.body.appendChild(src_main_instance.$el);
	  src_main_instance.visible = true;
	  src_main_instance.dom = src_main_instance.$el;
	  src_main_instance.dom.style.zIndex = popup_["PopupManager"].nextZIndex();
	
	  var verticalOffset = options.offset || 0;
	  instances.filter(function (item) {
	    return item.position === position;
	  }).forEach(function (item) {
	    verticalOffset += item.$el.offsetHeight + 16;
	  });
	  verticalOffset += 16;
	  src_main_instance.verticalOffset = verticalOffset;
	  instances.push(src_main_instance);
	  return src_main_instance;
	};
	
	['success', 'warning', 'info', 'error'].forEach(function (type) {
	  main_Notification[type] = function (options) {
	    if (typeof options === 'string' || Object(vdom_["isVNode"])(options)) {
	      options = {
	        message: options
	      };
	    }
	    options.type = type;
	    return main_Notification(options);
	  };
	});
	
	main_Notification.close = function (id, userOnClose) {
	  var index = -1;
	  var len = instances.length;
	  var instance = instances.filter(function (instance, i) {
	    if (instance.id === id) {
	      index = i;
	      return true;
	    }
	    return false;
	  })[0];
	  if (!instance) return;
	
	  if (typeof userOnClose === 'function') {
	    userOnClose(instance);
	  }
	  instances.splice(index, 1);
	
	  if (len <= 1) return;
	  var position = instance.position;
	  var removedHeight = instance.dom.offsetHeight;
	  for (var i = index; i < len - 1; i++) {
	    if (instances[i].position === position) {
	      instances[i].dom.style[instance.verticalProperty] = parseInt(instances[i].dom.style[instance.verticalProperty], 10) - removedHeight - 16 + 'px';
	    }
	  }
	};
	
	main_Notification.closeAll = function () {
	  for (var i = instances.length - 1; i >= 0; i--) {
	    instances[i].close();
	  }
	};
	
	/* harmony default export */ var packages_notification_src_main = (main_Notification);
	// CONCATENATED MODULE: ./packages/notification/index.js
	
	/* harmony default export */ var notification = (packages_notification_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=template&id=32708644&
	var mainvue_type_template_id_32708644_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-slider",
	      class: {
	        "is-vertical": _vm.vertical,
	        "el-slider--with-input": _vm.showInput
	      },
	      attrs: {
	        role: "slider",
	        "aria-valuemin": _vm.min,
	        "aria-valuemax": _vm.max,
	        "aria-orientation": _vm.vertical ? "vertical" : "horizontal",
	        "aria-disabled": _vm.sliderDisabled
	      }
	    },
	    [
	      _vm.showInput && !_vm.range
	        ? _c("el-input-number", {
	            ref: "input",
	            staticClass: "el-slider__input",
	            attrs: {
	              step: _vm.step,
	              disabled: _vm.sliderDisabled,
	              controls: _vm.showInputControls,
	              min: _vm.min,
	              max: _vm.max,
	              debounce: _vm.debounce,
	              size: _vm.inputSize
	            },
	            on: { change: _vm.emitChange },
	            model: {
	              value: _vm.firstValue,
	              callback: function($$v) {
	                _vm.firstValue = $$v
	              },
	              expression: "firstValue"
	            }
	          })
	        : _vm._e(),
	      _c(
	        "div",
	        {
	          ref: "slider",
	          staticClass: "el-slider__runway",
	          class: { "show-input": _vm.showInput, disabled: _vm.sliderDisabled },
	          style: _vm.runwayStyle,
	          on: { click: _vm.onSliderClick }
	        },
	        [
	          _c("div", { staticClass: "el-slider__bar", style: _vm.barStyle }),
	          _c("slider-button", {
	            ref: "button1",
	            attrs: {
	              vertical: _vm.vertical,
	              "tooltip-class": _vm.tooltipClass
	            },
	            model: {
	              value: _vm.firstValue,
	              callback: function($$v) {
	                _vm.firstValue = $$v
	              },
	              expression: "firstValue"
	            }
	          }),
	          _vm.range
	            ? _c("slider-button", {
	                ref: "button2",
	                attrs: {
	                  vertical: _vm.vertical,
	                  "tooltip-class": _vm.tooltipClass
	                },
	                model: {
	                  value: _vm.secondValue,
	                  callback: function($$v) {
	                    _vm.secondValue = $$v
	                  },
	                  expression: "secondValue"
	                }
	              })
	            : _vm._e(),
	          _vm._l(_vm.stops, function(item, key) {
	            return _vm.showStops
	              ? _c("div", {
	                  key: key,
	                  staticClass: "el-slider__stop",
	                  style: _vm.getStopStyle(item)
	                })
	              : _vm._e()
	          }),
	          _vm.markList.length > 0
	            ? [
	                _c(
	                  "div",
	                  _vm._l(_vm.markList, function(item, key) {
	                    return _c("div", {
	                      key: key,
	                      staticClass: "el-slider__stop el-slider__marks-stop",
	                      style: _vm.getStopStyle(item.position)
	                    })
	                  }),
	                  0
	                ),
	                _c(
	                  "div",
	                  { staticClass: "el-slider__marks" },
	                  _vm._l(_vm.markList, function(item, key) {
	                    return _c("slider-marker", {
	                      key: key,
	                      style: _vm.getStopStyle(item.position),
	                      attrs: { mark: item.mark }
	                    })
	                  }),
	                  1
	                )
	              ]
	            : _vm._e()
	        ],
	        2
	      )
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_32708644_staticRenderFns = []
	mainvue_type_template_id_32708644_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=template&id=32708644&
	
	// EXTERNAL MODULE: external "element-ui/lib/input-number"
	var input_number_ = __webpack_require__(41);
	var input_number_default = /*#__PURE__*/__webpack_require__.n(input_number_);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&
	var buttonvue_type_template_id_e72d2ad2_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      ref: "button",
	      staticClass: "el-slider__button-wrapper",
	      class: { hover: _vm.hovering, dragging: _vm.dragging },
	      style: _vm.wrapperStyle,
	      attrs: { tabindex: "0" },
	      on: {
	        mouseenter: _vm.handleMouseEnter,
	        mouseleave: _vm.handleMouseLeave,
	        mousedown: _vm.onButtonDown,
	        touchstart: _vm.onButtonDown,
	        focus: _vm.handleMouseEnter,
	        blur: _vm.handleMouseLeave,
	        keydown: [
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "left", 37, $event.key, [
	                "Left",
	                "ArrowLeft"
	              ])
	            ) {
	              return null
	            }
	            if ("button" in $event && $event.button !== 0) {
	              return null
	            }
	            return _vm.onLeftKeyDown($event)
	          },
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "right", 39, $event.key, [
	                "Right",
	                "ArrowRight"
	              ])
	            ) {
	              return null
	            }
	            if ("button" in $event && $event.button !== 2) {
	              return null
	            }
	            return _vm.onRightKeyDown($event)
	          },
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "down", 40, $event.key, [
	                "Down",
	                "ArrowDown"
	              ])
	            ) {
	              return null
	            }
	            $event.preventDefault()
	            return _vm.onLeftKeyDown($event)
	          },
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
	            ) {
	              return null
	            }
	            $event.preventDefault()
	            return _vm.onRightKeyDown($event)
	          }
	        ]
	      }
	    },
	    [
	      _c(
	        "el-tooltip",
	        {
	          ref: "tooltip",
	          attrs: {
	            placement: "top",
	            "popper-class": _vm.tooltipClass,
	            disabled: !_vm.showTooltip
	          }
	        },
	        [
	          _c("span", { attrs: { slot: "content" }, slot: "content" }, [
	            _vm._v(_vm._s(_vm.formatValue))
	          ]),
	          _c("div", {
	            staticClass: "el-slider__button",
	            class: { hover: _vm.hovering, dragging: _vm.dragging }
	          })
	        ]
	      )
	    ],
	    1
	  )
	}
	var buttonvue_type_template_id_e72d2ad2_staticRenderFns = []
	buttonvue_type_template_id_e72d2ad2_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var slider_src_buttonvue_type_script_lang_js_ = ({
	  name: 'ElSliderButton',
	
	  components: {
	    ElTooltip: tooltip_default.a
	  },
	
	  props: {
	    value: {
	      type: Number,
	      default: 0
	    },
	    vertical: {
	      type: Boolean,
	      default: false
	    },
	    tooltipClass: String
	  },
	
	  data: function data() {
	    return {
	      hovering: false,
	      dragging: false,
	      isClick: false,
	      startX: 0,
	      currentX: 0,
	      startY: 0,
	      currentY: 0,
	      startPosition: 0,
	      newPosition: null,
	      oldValue: this.value
	    };
	  },
	
	
	  computed: {
	    disabled: function disabled() {
	      return this.$parent.sliderDisabled;
	    },
	    max: function max() {
	      return this.$parent.max;
	    },
	    min: function min() {
	      return this.$parent.min;
	    },
	    step: function step() {
	      return this.$parent.step;
	    },
	    showTooltip: function showTooltip() {
	      return this.$parent.showTooltip;
	    },
	    precision: function precision() {
	      return this.$parent.precision;
	    },
	    currentPosition: function currentPosition() {
	      return (this.value - this.min) / (this.max - this.min) * 100 + '%';
	    },
	    enableFormat: function enableFormat() {
	      return this.$parent.formatTooltip instanceof Function;
	    },
	    formatValue: function formatValue() {
	      return this.enableFormat && this.$parent.formatTooltip(this.value) || this.value;
	    },
	    wrapperStyle: function wrapperStyle() {
	      return this.vertical ? { bottom: this.currentPosition } : { left: this.currentPosition };
	    }
	  },
	
	  watch: {
	    dragging: function dragging(val) {
	      this.$parent.dragging = val;
	    }
	  },
	
	  methods: {
	    displayTooltip: function displayTooltip() {
	      this.$refs.tooltip && (this.$refs.tooltip.showPopper = true);
	    },
	    hideTooltip: function hideTooltip() {
	      this.$refs.tooltip && (this.$refs.tooltip.showPopper = false);
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      this.hovering = true;
	      this.displayTooltip();
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      this.hovering = false;
	      this.hideTooltip();
	    },
	    onButtonDown: function onButtonDown(event) {
	      if (this.disabled) return;
	      event.preventDefault();
	      this.onDragStart(event);
	      window.addEventListener('mousemove', this.onDragging);
	      window.addEventListener('touchmove', this.onDragging);
	      window.addEventListener('mouseup', this.onDragEnd);
	      window.addEventListener('touchend', this.onDragEnd);
	      window.addEventListener('contextmenu', this.onDragEnd);
	    },
	    onLeftKeyDown: function onLeftKeyDown() {
	      if (this.disabled) return;
	      this.newPosition = parseFloat(this.currentPosition) - this.step / (this.max - this.min) * 100;
	      this.setPosition(this.newPosition);
	      this.$parent.emitChange();
	    },
	    onRightKeyDown: function onRightKeyDown() {
	      if (this.disabled) return;
	      this.newPosition = parseFloat(this.currentPosition) + this.step / (this.max - this.min) * 100;
	      this.setPosition(this.newPosition);
	      this.$parent.emitChange();
	    },
	    onDragStart: function onDragStart(event) {
	      this.dragging = true;
	      this.isClick = true;
	      if (event.type === 'touchstart') {
	        event.clientY = event.touches[0].clientY;
	        event.clientX = event.touches[0].clientX;
	      }
	      if (this.vertical) {
	        this.startY = event.clientY;
	      } else {
	        this.startX = event.clientX;
	      }
	      this.startPosition = parseFloat(this.currentPosition);
	      this.newPosition = this.startPosition;
	    },
	    onDragging: function onDragging(event) {
	      if (this.dragging) {
	        this.isClick = false;
	        this.displayTooltip();
	        this.$parent.resetSize();
	        var diff = 0;
	        if (event.type === 'touchmove') {
	          event.clientY = event.touches[0].clientY;
	          event.clientX = event.touches[0].clientX;
	        }
	        if (this.vertical) {
	          this.currentY = event.clientY;
	          diff = (this.startY - this.currentY) / this.$parent.sliderSize * 100;
	        } else {
	          this.currentX = event.clientX;
	          diff = (this.currentX - this.startX) / this.$parent.sliderSize * 100;
	        }
	        this.newPosition = this.startPosition + diff;
	        this.setPosition(this.newPosition);
	      }
	    },
	    onDragEnd: function onDragEnd() {
	      var _this = this;
	
	      if (this.dragging) {
	        /*
	         * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
	         * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
	         */
	        setTimeout(function () {
	          _this.dragging = false;
	          _this.hideTooltip();
	          if (!_this.isClick) {
	            _this.setPosition(_this.newPosition);
	            _this.$parent.emitChange();
	          }
	        }, 0);
	        window.removeEventListener('mousemove', this.onDragging);
	        window.removeEventListener('touchmove', this.onDragging);
	        window.removeEventListener('mouseup', this.onDragEnd);
	        window.removeEventListener('touchend', this.onDragEnd);
	        window.removeEventListener('contextmenu', this.onDragEnd);
	      }
	    },
	    setPosition: function setPosition(newPosition) {
	      var _this2 = this;
	
	      if (newPosition === null || isNaN(newPosition)) return;
	      if (newPosition < 0) {
	        newPosition = 0;
	      } else if (newPosition > 100) {
	        newPosition = 100;
	      }
	      var lengthPerStep = 100 / ((this.max - this.min) / this.step);
	      var steps = Math.round(newPosition / lengthPerStep);
	      var value = steps * lengthPerStep * (this.max - this.min) * 0.01 + this.min;
	      value = parseFloat(value.toFixed(this.precision));
	      this.$emit('input', value);
	      this.$nextTick(function () {
	        _this2.displayTooltip();
	        _this2.$refs.tooltip && _this2.$refs.tooltip.updatePopper();
	      });
	      if (!this.dragging && this.value !== this.oldValue) {
	        this.oldValue = this.value;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_slider_src_buttonvue_type_script_lang_js_ = (slider_src_buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/slider/src/button.vue
	
	
	
	
	
	/* normalize component */
	
	var src_button_component = normalizeComponent(
	  packages_slider_src_buttonvue_type_script_lang_js_,
	  buttonvue_type_template_id_e72d2ad2_render,
	  buttonvue_type_template_id_e72d2ad2_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_button_api; }
	src_button_component.options.__file = "packages/slider/src/button.vue"
	/* harmony default export */ var slider_src_button = (src_button_component.exports);
	// CONCATENATED MODULE: ./packages/slider/src/marker.js
	/* harmony default export */ var marker = ({
	  name: 'ElMarker',
	
	  props: {
	    mark: {
	      type: [String, Object]
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	
	    var label = typeof this.mark === 'string' ? this.mark : this.mark.label;
	
	    return h(
	      'div',
	      { 'class': 'el-slider__marks-text', style: this.mark.style || {} },
	      [label]
	    );
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var slider_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElSlider',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	
	  props: {
	    min: {
	      type: Number,
	      default: 0
	    },
	    max: {
	      type: Number,
	      default: 100
	    },
	    step: {
	      type: Number,
	      default: 1
	    },
	    value: {
	      type: [Number, Array],
	      default: 0
	    },
	    showInput: {
	      type: Boolean,
	      default: false
	    },
	    showInputControls: {
	      type: Boolean,
	      default: true
	    },
	    inputSize: {
	      type: String,
	      default: 'small'
	    },
	    showStops: {
	      type: Boolean,
	      default: false
	    },
	    showTooltip: {
	      type: Boolean,
	      default: true
	    },
	    formatTooltip: Function,
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    range: {
	      type: Boolean,
	      default: false
	    },
	    vertical: {
	      type: Boolean,
	      default: false
	    },
	    height: {
	      type: String
	    },
	    debounce: {
	      type: Number,
	      default: 300
	    },
	    label: {
	      type: String
	    },
	    tooltipClass: String,
	    marks: Object
	  },
	
	  components: {
	    ElInputNumber: input_number_default.a,
	    SliderButton: slider_src_button,
	    SliderMarker: marker
	  },
	
	  data: function data() {
	    return {
	      firstValue: null,
	      secondValue: null,
	      oldValue: null,
	      dragging: false,
	      sliderSize: 1
	    };
	  },
	
	
	  watch: {
	    value: function value(val, oldVal) {
	      if (this.dragging || Array.isArray(val) && Array.isArray(oldVal) && val.every(function (item, index) {
	        return item === oldVal[index];
	      })) {
	        return;
	      }
	      this.setValues();
	    },
	    dragging: function dragging(val) {
	      if (!val) {
	        this.setValues();
	      }
	    },
	    firstValue: function firstValue(val) {
	      if (this.range) {
	        this.$emit('input', [this.minValue, this.maxValue]);
	      } else {
	        this.$emit('input', val);
	      }
	    },
	    secondValue: function secondValue() {
	      if (this.range) {
	        this.$emit('input', [this.minValue, this.maxValue]);
	      }
	    },
	    min: function min() {
	      this.setValues();
	    },
	    max: function max() {
	      this.setValues();
	    }
	  },
	
	  methods: {
	    valueChanged: function valueChanged() {
	      var _this = this;
	
	      if (this.range) {
	        return ![this.minValue, this.maxValue].every(function (item, index) {
	          return item === _this.oldValue[index];
	        });
	      } else {
	        return this.value !== this.oldValue;
	      }
	    },
	    setValues: function setValues() {
	      if (this.min > this.max) {
	        console.error('[Element Error][Slider]min should not be greater than max.');
	        return;
	      }
	      var val = this.value;
	      if (this.range && Array.isArray(val)) {
	        if (val[1] < this.min) {
	          this.$emit('input', [this.min, this.min]);
	        } else if (val[0] > this.max) {
	          this.$emit('input', [this.max, this.max]);
	        } else if (val[0] < this.min) {
	          this.$emit('input', [this.min, val[1]]);
	        } else if (val[1] > this.max) {
	          this.$emit('input', [val[0], this.max]);
	        } else {
	          this.firstValue = val[0];
	          this.secondValue = val[1];
	          if (this.valueChanged()) {
	            this.dispatch('ElFormItem', 'el.form.change', [this.minValue, this.maxValue]);
	            this.oldValue = val.slice();
	          }
	        }
	      } else if (!this.range && typeof val === 'number' && !isNaN(val)) {
	        if (val < this.min) {
	          this.$emit('input', this.min);
	        } else if (val > this.max) {
	          this.$emit('input', this.max);
	        } else {
	          this.firstValue = val;
	          if (this.valueChanged()) {
	            this.dispatch('ElFormItem', 'el.form.change', val);
	            this.oldValue = val;
	          }
	        }
	      }
	    },
	    setPosition: function setPosition(percent) {
	      var targetValue = this.min + percent * (this.max - this.min) / 100;
	      if (!this.range) {
	        this.$refs.button1.setPosition(percent);
	        return;
	      }
	      var button = void 0;
	      if (Math.abs(this.minValue - targetValue) < Math.abs(this.maxValue - targetValue)) {
	        button = this.firstValue < this.secondValue ? 'button1' : 'button2';
	      } else {
	        button = this.firstValue > this.secondValue ? 'button1' : 'button2';
	      }
	      this.$refs[button].setPosition(percent);
	    },
	    onSliderClick: function onSliderClick(event) {
	      if (this.sliderDisabled || this.dragging) return;
	      this.resetSize();
	      if (this.vertical) {
	        var sliderOffsetBottom = this.$refs.slider.getBoundingClientRect().bottom;
	        this.setPosition((sliderOffsetBottom - event.clientY) / this.sliderSize * 100);
	      } else {
	        var sliderOffsetLeft = this.$refs.slider.getBoundingClientRect().left;
	        this.setPosition((event.clientX - sliderOffsetLeft) / this.sliderSize * 100);
	      }
	      this.emitChange();
	    },
	    resetSize: function resetSize() {
	      if (this.$refs.slider) {
	        this.sliderSize = this.$refs.slider['client' + (this.vertical ? 'Height' : 'Width')];
	      }
	    },
	    emitChange: function emitChange() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        _this2.$emit('change', _this2.range ? [_this2.minValue, _this2.maxValue] : _this2.value);
	      });
	    },
	    getStopStyle: function getStopStyle(position) {
	      return this.vertical ? { 'bottom': position + '%' } : { 'left': position + '%' };
	    }
	  },
	
	  computed: {
	    stops: function stops() {
	      var _this3 = this;
	
	      if (!this.showStops || this.min > this.max) return [];
	      if (this.step === 0) {
	         false && false;
	        return [];
	      }
	      var stopCount = (this.max - this.min) / this.step;
	      var stepWidth = 100 * this.step / (this.max - this.min);
	      var result = [];
	      for (var i = 1; i < stopCount; i++) {
	        result.push(i * stepWidth);
	      }
	      if (this.range) {
	        return result.filter(function (step) {
	          return step < 100 * (_this3.minValue - _this3.min) / (_this3.max - _this3.min) || step > 100 * (_this3.maxValue - _this3.min) / (_this3.max - _this3.min);
	        });
	      } else {
	        return result.filter(function (step) {
	          return step > 100 * (_this3.firstValue - _this3.min) / (_this3.max - _this3.min);
	        });
	      }
	    },
	    markList: function markList() {
	      var _this4 = this;
	
	      if (!this.marks) {
	        return [];
	      }
	
	      var marksKeys = Object.keys(this.marks);
	      return marksKeys.map(parseFloat).sort(function (a, b) {
	        return a - b;
	      }).filter(function (point) {
	        return point <= _this4.max && point >= _this4.min;
	      }).map(function (point) {
	        return {
	          point: point,
	          position: (point - _this4.min) * 100 / (_this4.max - _this4.min),
	          mark: _this4.marks[point]
	        };
	      });
	    },
	    minValue: function minValue() {
	      return Math.min(this.firstValue, this.secondValue);
	    },
	    maxValue: function maxValue() {
	      return Math.max(this.firstValue, this.secondValue);
	    },
	    barSize: function barSize() {
	      return this.range ? 100 * (this.maxValue - this.minValue) / (this.max - this.min) + '%' : 100 * (this.firstValue - this.min) / (this.max - this.min) + '%';
	    },
	    barStart: function barStart() {
	      return this.range ? 100 * (this.minValue - this.min) / (this.max - this.min) + '%' : '0%';
	    },
	    precision: function precision() {
	      var precisions = [this.min, this.max, this.step].map(function (item) {
	        var decimal = ('' + item).split('.')[1];
	        return decimal ? decimal.length : 0;
	      });
	      return Math.max.apply(null, precisions);
	    },
	    runwayStyle: function runwayStyle() {
	      return this.vertical ? { height: this.height } : {};
	    },
	    barStyle: function barStyle() {
	      return this.vertical ? {
	        height: this.barSize,
	        bottom: this.barStart
	      } : {
	        width: this.barSize,
	        left: this.barStart
	      };
	    },
	    sliderDisabled: function sliderDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  mounted: function mounted() {
	    var valuetext = void 0;
	    if (this.range) {
	      if (Array.isArray(this.value)) {
	        this.firstValue = Math.max(this.min, this.value[0]);
	        this.secondValue = Math.min(this.max, this.value[1]);
	      } else {
	        this.firstValue = this.min;
	        this.secondValue = this.max;
	      }
	      this.oldValue = [this.firstValue, this.secondValue];
	      valuetext = this.firstValue + '-' + this.secondValue;
	    } else {
	      if (typeof this.value !== 'number' || isNaN(this.value)) {
	        this.firstValue = this.min;
	      } else {
	        this.firstValue = Math.min(this.max, Math.max(this.min, this.value));
	      }
	      this.oldValue = this.firstValue;
	      valuetext = this.firstValue;
	    }
	    this.$el.setAttribute('aria-valuetext', valuetext);
	
	    // label screen reader
	    this.$el.setAttribute('aria-label', this.label ? this.label : 'slider between ' + this.min + ' and ' + this.max);
	
	    this.resetSize();
	    window.addEventListener('resize', this.resetSize);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.resetSize);
	  }
	});
	// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_slider_src_mainvue_type_script_lang_js_ = (slider_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/slider/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var slider_src_main_component = normalizeComponent(
	  packages_slider_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_32708644_render,
	  mainvue_type_template_id_32708644_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var slider_src_main_api; }
	slider_src_main_component.options.__file = "packages/slider/src/main.vue"
	/* harmony default export */ var slider_src_main = (slider_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/slider/index.js
	
	
	/* istanbul ignore next */
	slider_src_main.install = function (Vue) {
	  Vue.component(slider_src_main.name, slider_src_main);
	};
	
	/* harmony default export */ var slider = (slider_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
	var loadingvue_type_template_id_eee0a7ac_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-loading-fade" },
	      on: { "after-leave": _vm.handleAfterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-loading-mask",
	          class: [_vm.customClass, { "is-fullscreen": _vm.fullscreen }],
	          style: { backgroundColor: _vm.background || "" }
	        },
	        [
	          _c("div", { staticClass: "el-loading-spinner" }, [
	            !_vm.spinner
	              ? _c(
	                  "svg",
	                  {
	                    staticClass: "circular",
	                    attrs: { viewBox: "25 25 50 50" }
	                  },
	                  [
	                    _c("circle", {
	                      staticClass: "path",
	                      attrs: { cx: "50", cy: "50", r: "20", fill: "none" }
	                    })
	                  ]
	                )
	              : _c("i", { class: _vm.spinner }),
	            _vm.text
	              ? _c("p", { staticClass: "el-loading-text" }, [
	                  _vm._v(_vm._s(_vm.text))
	                ])
	              : _vm._e()
	          ])
	        ]
	      )
	    ]
	  )
	}
	var loadingvue_type_template_id_eee0a7ac_staticRenderFns = []
	loadingvue_type_template_id_eee0a7ac_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var loadingvue_type_script_lang_js_ = ({
	  data: function data() {
	    return {
	      text: null,
	      spinner: null,
	      background: null,
	      fullscreen: true,
	      visible: false,
	      customClass: ''
	    };
	  },
	
	
	  methods: {
	    handleAfterLeave: function handleAfterLeave() {
	      this.$emit('after-leave');
	    },
	    setText: function setText(text) {
	      this.text = text;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_loadingvue_type_script_lang_js_ = (loadingvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/loading/src/loading.vue
	
	
	
	
	
	/* normalize component */
	
	var loading_component = normalizeComponent(
	  src_loadingvue_type_script_lang_js_,
	  loadingvue_type_template_id_eee0a7ac_render,
	  loadingvue_type_template_id_eee0a7ac_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var loading_api; }
	loading_component.options.__file = "packages/loading/src/loading.vue"
	/* harmony default export */ var loading = (loading_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/utils/after-leave"
	var after_leave_ = __webpack_require__(32);
	var after_leave_default = /*#__PURE__*/__webpack_require__.n(after_leave_);
	
	// CONCATENATED MODULE: ./packages/loading/src/directive.js
	
	
	
	
	
	var Mask = external_vue_default.a.extend(loading);
	
	var loadingDirective = {};
	loadingDirective.install = function (Vue) {
	  if (Vue.prototype.$isServer) return;
	  var toggleLoading = function toggleLoading(el, binding) {
	    if (binding.value) {
	      Vue.nextTick(function () {
	        if (binding.modifiers.fullscreen) {
	          el.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	          el.originalOverflow = Object(dom_["getStyle"])(document.body, 'overflow');
	          el.maskStyle.zIndex = popup_["PopupManager"].nextZIndex();
	
	          Object(dom_["addClass"])(el.mask, 'is-fullscreen');
	          insertDom(document.body, el, binding);
	        } else {
	          Object(dom_["removeClass"])(el.mask, 'is-fullscreen');
	
	          if (binding.modifiers.body) {
	            el.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	
	            ['top', 'left'].forEach(function (property) {
	              var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
	              el.maskStyle[property] = el.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] - parseInt(Object(dom_["getStyle"])(document.body, 'margin-' + property), 10) + 'px';
	            });
	            ['height', 'width'].forEach(function (property) {
	              el.maskStyle[property] = el.getBoundingClientRect()[property] + 'px';
	            });
	
	            insertDom(document.body, el, binding);
	          } else {
	            el.originalPosition = Object(dom_["getStyle"])(el, 'position');
	            insertDom(el, el, binding);
	          }
	        }
	      });
	    } else {
	      after_leave_default()(el.instance, function (_) {
	        if (!el.instance.hiding) return;
	        el.domVisible = false;
	        var target = binding.modifiers.fullscreen || binding.modifiers.body ? document.body : el;
	        Object(dom_["removeClass"])(target, 'el-loading-parent--relative');
	        Object(dom_["removeClass"])(target, 'el-loading-parent--hidden');
	        el.instance.hiding = false;
	      }, 300, true);
	      el.instance.visible = false;
	      el.instance.hiding = true;
	    }
	  };
	  var insertDom = function insertDom(parent, el, binding) {
	    if (!el.domVisible && Object(dom_["getStyle"])(el, 'display') !== 'none' && Object(dom_["getStyle"])(el, 'visibility') !== 'hidden') {
	      Object.keys(el.maskStyle).forEach(function (property) {
	        el.mask.style[property] = el.maskStyle[property];
	      });
	
	      if (el.originalPosition !== 'absolute' && el.originalPosition !== 'fixed') {
	        Object(dom_["addClass"])(parent, 'el-loading-parent--relative');
	      }
	      if (binding.modifiers.fullscreen && binding.modifiers.lock) {
	        Object(dom_["addClass"])(parent, 'el-loading-parent--hidden');
	      }
	      el.domVisible = true;
	
	      parent.appendChild(el.mask);
	      Vue.nextTick(function () {
	        if (el.instance.hiding) {
	          el.instance.$emit('after-leave');
	        } else {
	          el.instance.visible = true;
	        }
	      });
	      el.domInserted = true;
	    } else if (el.domVisible && el.instance.hiding === true) {
	      el.instance.visible = true;
	      el.instance.hiding = false;
	    }
	  };
	
	  Vue.directive('loading', {
	    bind: function bind(el, binding, vnode) {
	      var textExr = el.getAttribute('element-loading-text');
	      var spinnerExr = el.getAttribute('element-loading-spinner');
	      var backgroundExr = el.getAttribute('element-loading-background');
	      var customClassExr = el.getAttribute('element-loading-custom-class');
	      var vm = vnode.context;
	      var mask = new Mask({
	        el: document.createElement('div'),
	        data: {
	          text: vm && vm[textExr] || textExr,
	          spinner: vm && vm[spinnerExr] || spinnerExr,
	          background: vm && vm[backgroundExr] || backgroundExr,
	          customClass: vm && vm[customClassExr] || customClassExr,
	          fullscreen: !!binding.modifiers.fullscreen
	        }
	      });
	      el.instance = mask;
	      el.mask = mask.$el;
	      el.maskStyle = {};
	
	      binding.value && toggleLoading(el, binding);
	    },
	
	    update: function update(el, binding) {
	      el.instance.setText(el.getAttribute('element-loading-text'));
	      if (binding.oldValue !== binding.value) {
	        toggleLoading(el, binding);
	      }
	    },
	
	    unbind: function unbind(el, binding) {
	      if (el.domInserted) {
	        el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
	        toggleLoading(el, { value: false, modifiers: binding.modifiers });
	      }
	      el.instance && el.instance.$destroy();
	    }
	  });
	};
	
	/* harmony default export */ var src_directive = (loadingDirective);
	// CONCATENATED MODULE: ./packages/loading/src/index.js
	
	
	
	
	
	
	
	var LoadingConstructor = external_vue_default.a.extend(loading);
	
	var src_defaults = {
	  text: null,
	  fullscreen: true,
	  body: false,
	  lock: false,
	  customClass: ''
	};
	
	var fullscreenLoading = void 0;
	
	LoadingConstructor.prototype.originalPosition = '';
	LoadingConstructor.prototype.originalOverflow = '';
	
	LoadingConstructor.prototype.close = function () {
	  var _this = this;
	
	  if (this.fullscreen) {
	    fullscreenLoading = undefined;
	  }
	  after_leave_default()(this, function (_) {
	    var target = _this.fullscreen || _this.body ? document.body : _this.target;
	    Object(dom_["removeClass"])(target, 'el-loading-parent--relative');
	    Object(dom_["removeClass"])(target, 'el-loading-parent--hidden');
	    if (_this.$el && _this.$el.parentNode) {
	      _this.$el.parentNode.removeChild(_this.$el);
	    }
	    _this.$destroy();
	  }, 300);
	  this.visible = false;
	};
	
	var src_addStyle = function addStyle(options, parent, instance) {
	  var maskStyle = {};
	  if (options.fullscreen) {
	    instance.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	    instance.originalOverflow = Object(dom_["getStyle"])(document.body, 'overflow');
	    maskStyle.zIndex = popup_["PopupManager"].nextZIndex();
	  } else if (options.body) {
	    instance.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	    ['top', 'left'].forEach(function (property) {
	      var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
	      maskStyle[property] = options.target.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] + 'px';
	    });
	    ['height', 'width'].forEach(function (property) {
	      maskStyle[property] = options.target.getBoundingClientRect()[property] + 'px';
	    });
	  } else {
	    instance.originalPosition = Object(dom_["getStyle"])(parent, 'position');
	  }
	  Object.keys(maskStyle).forEach(function (property) {
	    instance.$el.style[property] = maskStyle[property];
	  });
	};
	
	var src_Loading = function Loading() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (external_vue_default.a.prototype.$isServer) return;
	  options = merge_default()({}, src_defaults, options);
	  if (typeof options.target === 'string') {
	    options.target = document.querySelector(options.target);
	  }
	  options.target = options.target || document.body;
	  if (options.target !== document.body) {
	    options.fullscreen = false;
	  } else {
	    options.body = true;
	  }
	  if (options.fullscreen && fullscreenLoading) {
	    return fullscreenLoading;
	  }
	
	  var parent = options.body ? document.body : options.target;
	  var instance = new LoadingConstructor({
	    el: document.createElement('div'),
	    data: options
	  });
	
	  src_addStyle(options, parent, instance);
	  if (instance.originalPosition !== 'absolute' && instance.originalPosition !== 'fixed') {
	    Object(dom_["addClass"])(parent, 'el-loading-parent--relative');
	  }
	  if (options.fullscreen && options.lock) {
	    Object(dom_["addClass"])(parent, 'el-loading-parent--hidden');
	  }
	  parent.appendChild(instance.$el);
	  external_vue_default.a.nextTick(function () {
	    instance.visible = true;
	  });
	  if (options.fullscreen) {
	    fullscreenLoading = instance;
	  }
	  return instance;
	};
	
	/* harmony default export */ var src = (src_Loading);
	// CONCATENATED MODULE: ./packages/loading/index.js
	
	
	
	/* harmony default export */ var packages_loading = ({
	  install: function install(Vue) {
	    Vue.use(src_directive);
	    Vue.prototype.$loading = src;
	  },
	
	  directive: src_directive,
	  service: src
	});
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&
	var iconvue_type_template_id_cb3fe7f4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("i", { class: "el-icon-" + _vm.name })
	}
	var iconvue_type_template_id_cb3fe7f4_staticRenderFns = []
	iconvue_type_template_id_cb3fe7f4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	
	/* harmony default export */ var iconvue_type_script_lang_js_ = ({
	  name: 'ElIcon',
	
	  props: {
	    name: String
	  }
	});
	// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_iconvue_type_script_lang_js_ = (iconvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/icon/src/icon.vue
	
	
	
	
	
	/* normalize component */
	
	var icon_component = normalizeComponent(
	  src_iconvue_type_script_lang_js_,
	  iconvue_type_template_id_cb3fe7f4_render,
	  iconvue_type_template_id_cb3fe7f4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var icon_api; }
	icon_component.options.__file = "packages/icon/src/icon.vue"
	/* harmony default export */ var icon = (icon_component.exports);
	// CONCATENATED MODULE: ./packages/icon/index.js
	
	
	/* istanbul ignore next */
	icon.install = function (Vue) {
	  Vue.component(icon.name, icon);
	};
	
	/* harmony default export */ var packages_icon = (icon);
	// CONCATENATED MODULE: ./packages/row/src/row.js
	/* harmony default export */ var src_row = ({
	  name: 'ElRow',
	
	  componentName: 'ElRow',
	
	  props: {
	    tag: {
	      type: String,
	      default: 'div'
	    },
	    gutter: Number,
	    type: String,
	    justify: {
	      type: String,
	      default: 'start'
	    },
	    align: {
	      type: String,
	      default: 'top'
	    }
	  },
	
	  computed: {
	    style: function style() {
	      var ret = {};
	
	      if (this.gutter) {
	        ret.marginLeft = '-' + this.gutter / 2 + 'px';
	        ret.marginRight = ret.marginLeft;
	      }
	
	      return ret;
	    }
	  },
	
	  render: function render(h) {
	    return h(this.tag, {
	      class: ['el-row', this.justify !== 'start' ? 'is-justify-' + this.justify : '', this.align !== 'top' ? 'is-align-' + this.align : '', { 'el-row--flex': this.type === 'flex' }],
	      style: this.style
	    }, this.$slots.default);
	  }
	});
	// CONCATENATED MODULE: ./packages/row/index.js
	
	
	/* istanbul ignore next */
	src_row.install = function (Vue) {
	  Vue.component(src_row.name, src_row);
	};
	
	/* harmony default export */ var packages_row = (src_row);
	// CONCATENATED MODULE: ./packages/col/src/col.js
	var col_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* harmony default export */ var col = ({
	  name: 'ElCol',
	
	  props: {
	    span: {
	      type: Number,
	      default: 24
	    },
	    tag: {
	      type: String,
	      default: 'div'
	    },
	    offset: Number,
	    pull: Number,
	    push: Number,
	    xs: [Number, Object],
	    sm: [Number, Object],
	    md: [Number, Object],
	    lg: [Number, Object],
	    xl: [Number, Object]
	  },
	
	  computed: {
	    gutter: function gutter() {
	      var parent = this.$parent;
	      while (parent && parent.$options.componentName !== 'ElRow') {
	        parent = parent.$parent;
	      }
	      return parent ? parent.gutter : 0;
	    }
	  },
	  render: function render(h) {
	    var _this = this;
	
	    var classList = [];
	    var style = {};
	
	    if (this.gutter) {
	      style.paddingLeft = this.gutter / 2 + 'px';
	      style.paddingRight = style.paddingLeft;
	    }
	
	    ['span', 'offset', 'pull', 'push'].forEach(function (prop) {
	      if (_this[prop] || _this[prop] === 0) {
	        classList.push(prop !== 'span' ? 'el-col-' + prop + '-' + _this[prop] : 'el-col-' + _this[prop]);
	      }
	    });
	
	    ['xs', 'sm', 'md', 'lg', 'xl'].forEach(function (size) {
	      if (typeof _this[size] === 'number') {
	        classList.push('el-col-' + size + '-' + _this[size]);
	      } else if (col_typeof(_this[size]) === 'object') {
	        var props = _this[size];
	        Object.keys(props).forEach(function (prop) {
	          classList.push(prop !== 'span' ? 'el-col-' + size + '-' + prop + '-' + props[prop] : 'el-col-' + size + '-' + props[prop]);
	        });
	      }
	    });
	
	    return h(this.tag, {
	      class: ['el-col', classList],
	      style: style
	    }, this.$slots.default);
	  }
	});
	// CONCATENATED MODULE: ./packages/col/index.js
	
	
	/* istanbul ignore next */
	col.install = function (Vue) {
	  Vue.component(col.name, col);
	};
	
	/* harmony default export */ var packages_col = (col);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&
	var upload_listvue_type_template_id_173fedf5_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition-group",
	    {
	      class: [
	        "el-upload-list",
	        "el-upload-list--" + _vm.listType,
	        { "is-disabled": _vm.disabled }
	      ],
	      attrs: { tag: "ul", name: "el-list" }
	    },
	    _vm._l(_vm.files, function(file) {
	      return _c(
	        "li",
	        {
	          key: file.uid,
	          class: [
	            "el-upload-list__item",
	            "is-" + file.status,
	            _vm.focusing ? "focusing" : ""
	          ],
	          attrs: { tabindex: "0" },
	          on: {
	            keydown: function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
	                  "Backspace",
	                  "Delete",
	                  "Del"
	                ])
	              ) {
	                return null
	              }
	              !_vm.disabled && _vm.$emit("remove", file)
	            },
	            focus: function($event) {
	              _vm.focusing = true
	            },
	            blur: function($event) {
	              _vm.focusing = false
	            },
	            click: function($event) {
	              _vm.focusing = false
	            }
	          }
	        },
	        [
	          _vm._t(
	            "default",
	            [
	              file.status !== "uploading" &&
	              ["picture-card", "picture"].indexOf(_vm.listType) > -1
	                ? _c("img", {
	                    staticClass: "el-upload-list__item-thumbnail",
	                    attrs: { src: file.url, alt: "" }
	                  })
	                : _vm._e(),
	              _c(
	                "a",
	                {
	                  staticClass: "el-upload-list__item-name",
	                  on: {
	                    click: function($event) {
	                      _vm.handleClick(file)
	                    }
	                  }
	                },
	                [
	                  _c("i", { staticClass: "el-icon-document" }),
	                  _vm._v(_vm._s(file.name) + "\n      ")
	                ]
	              ),
	              _c(
	                "label",
	                { staticClass: "el-upload-list__item-status-label" },
	                [
	                  _c("i", {
	                    class: {
	                      "el-icon-upload-success": true,
	                      "el-icon-circle-check": _vm.listType === "text",
	                      "el-icon-check":
	                        ["picture-card", "picture"].indexOf(_vm.listType) > -1
	                    }
	                  })
	                ]
	              ),
	              !_vm.disabled
	                ? _c("i", {
	                    staticClass: "el-icon-close",
	                    on: {
	                      click: function($event) {
	                        _vm.$emit("remove", file)
	                      }
	                    }
	                  })
	                : _vm._e(),
	              !_vm.disabled
	                ? _c("i", { staticClass: "el-icon-close-tip" }, [
	                    _vm._v(_vm._s(_vm.t("el.upload.deleteTip")))
	                  ])
	                : _vm._e(),
	              file.status === "uploading"
	                ? _c("el-progress", {
	                    attrs: {
	                      type: _vm.listType === "picture-card" ? "circle" : "line",
	                      "stroke-width": _vm.listType === "picture-card" ? 6 : 2,
	                      percentage: _vm.parsePercentage(file.percentage)
	                    }
	                  })
	                : _vm._e(),
	              _vm.listType === "picture-card"
	                ? _c("span", { staticClass: "el-upload-list__item-actions" }, [
	                    _vm.handlePreview && _vm.listType === "picture-card"
	                      ? _c(
	                          "span",
	                          {
	                            staticClass: "el-upload-list__item-preview",
	                            on: {
	                              click: function($event) {
	                                _vm.handlePreview(file)
	                              }
	                            }
	                          },
	                          [_c("i", { staticClass: "el-icon-zoom-in" })]
	                        )
	                      : _vm._e(),
	                    !_vm.disabled
	                      ? _c(
	                          "span",
	                          {
	                            staticClass: "el-upload-list__item-delete",
	                            on: {
	                              click: function($event) {
	                                _vm.$emit("remove", file)
	                              }
	                            }
	                          },
	                          [_c("i", { staticClass: "el-icon-delete" })]
	                        )
	                      : _vm._e()
	                  ])
	                : _vm._e()
	            ],
	            { file: file }
	          )
	        ],
	        2
	      )
	    }),
	    0
	  )
	}
	var upload_listvue_type_template_id_173fedf5_staticRenderFns = []
	upload_listvue_type_template_id_173fedf5_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&
	
	// EXTERNAL MODULE: external "element-ui/lib/progress"
	var progress_ = __webpack_require__(33);
	var progress_default = /*#__PURE__*/__webpack_require__.n(progress_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var upload_listvue_type_script_lang_js_ = ({
	
	  name: 'ElUploadList',
	
	  mixins: [locale_default.a],
	
	  data: function data() {
	    return {
	      focusing: false
	    };
	  },
	
	  components: { ElProgress: progress_default.a },
	
	  props: {
	    files: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    handlePreview: Function,
	    listType: String
	  },
	  methods: {
	    parsePercentage: function parsePercentage(val) {
	      return parseInt(val, 10);
	    },
	    handleClick: function handleClick(file) {
	      this.handlePreview && this.handlePreview(file);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_upload_listvue_type_script_lang_js_ = (upload_listvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue
	
	
	
	
	
	/* normalize component */
	
	var upload_list_component = normalizeComponent(
	  src_upload_listvue_type_script_lang_js_,
	  upload_listvue_type_template_id_173fedf5_render,
	  upload_listvue_type_template_id_173fedf5_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var upload_list_api; }
	upload_list_component.options.__file = "packages/upload/src/upload-list.vue"
	/* harmony default export */ var upload_list = (upload_list_component.exports);
	// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
	var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(24);
	var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);
	
	// CONCATENATED MODULE: ./packages/upload/src/ajax.js
	function getError(action, option, xhr) {
	  var msg = void 0;
	  if (xhr.response) {
	    msg = '' + (xhr.response.error || xhr.response);
	  } else if (xhr.responseText) {
	    msg = '' + xhr.responseText;
	  } else {
	    msg = 'fail to post ' + action + ' ' + xhr.status;
	  }
	
	  var err = new Error(msg);
	  err.status = xhr.status;
	  err.method = 'post';
	  err.url = action;
	  return err;
	}
	
	function getBody(xhr) {
	  var text = xhr.responseText || xhr.response;
	  if (!text) {
	    return text;
	  }
	
	  try {
	    return JSON.parse(text);
	  } catch (e) {
	    return text;
	  }
	}
	
	function upload(option) {
	  if (typeof XMLHttpRequest === 'undefined') {
	    return;
	  }
	
	  var xhr = new XMLHttpRequest();
	  var action = option.action;
	
	  if (xhr.upload) {
	    xhr.upload.onprogress = function progress(e) {
	      if (e.total > 0) {
	        e.percent = e.loaded / e.total * 100;
	      }
	      option.onProgress(e);
	    };
	  }
	
	  var formData = new FormData();
	
	  if (option.data) {
	    Object.keys(option.data).forEach(function (key) {
	      formData.append(key, option.data[key]);
	    });
	  }
	
	  formData.append(option.filename, option.file, option.file.name);
	
	  xhr.onerror = function error(e) {
	    option.onError(e);
	  };
	
	  xhr.onload = function onload() {
	    if (xhr.status < 200 || xhr.status >= 300) {
	      return option.onError(getError(action, option, xhr));
	    }
	
	    option.onSuccess(getBody(xhr));
	  };
	
	  xhr.open('post', action, true);
	
	  if (option.withCredentials && 'withCredentials' in xhr) {
	    xhr.withCredentials = true;
	  }
	
	  var headers = option.headers || {};
	
	  for (var item in headers) {
	    if (headers.hasOwnProperty(item) && headers[item] !== null) {
	      xhr.setRequestHeader(item, headers[item]);
	    }
	  }
	  xhr.send(formData);
	  return xhr;
	}
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&
	var upload_draggervue_type_template_id_7ebbf219_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-upload-dragger",
	      class: {
	        "is-dragover": _vm.dragover
	      },
	      on: {
	        drop: function($event) {
	          $event.preventDefault()
	          return _vm.onDrop($event)
	        },
	        dragover: function($event) {
	          $event.preventDefault()
	          return _vm.onDragover($event)
	        },
	        dragleave: function($event) {
	          $event.preventDefault()
	          _vm.dragover = false
	        }
	      }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var upload_draggervue_type_template_id_7ebbf219_staticRenderFns = []
	upload_draggervue_type_template_id_7ebbf219_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var upload_draggervue_type_script_lang_js_ = ({
	  name: 'ElUploadDrag',
	  props: {
	    disabled: Boolean
	  },
	  inject: {
	    uploader: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      dragover: false
	    };
	  },
	
	  methods: {
	    onDragover: function onDragover() {
	      if (!this.disabled) {
	        this.dragover = true;
	      }
	    },
	    onDrop: function onDrop(e) {
	      if (this.disabled || !this.uploader) return;
	      var accept = this.uploader.accept;
	      this.dragover = false;
	      if (!accept) {
	        this.$emit('file', e.dataTransfer.files);
	        return;
	      }
	      this.$emit('file', [].slice.call(e.dataTransfer.files).filter(function (file) {
	        var type = file.type,
	            name = file.name;
	
	        var extension = name.indexOf('.') > -1 ? '.' + name.split('.').pop() : '';
	        var baseType = type.replace(/\/.*$/, '');
	        return accept.split(',').map(function (type) {
	          return type.trim();
	        }).filter(function (type) {
	          return type;
	        }).some(function (acceptedType) {
	          if (/\..+$/.test(acceptedType)) {
	            return extension === acceptedType;
	          }
	          if (/\/\*$/.test(acceptedType)) {
	            return baseType === acceptedType.replace(/\/\*$/, '');
	          }
	          if (/^[^\/]+\/[^\/]+$/.test(acceptedType)) {
	            return type === acceptedType;
	          }
	          return false;
	        });
	      }));
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_upload_draggervue_type_script_lang_js_ = (upload_draggervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue
	
	
	
	
	
	/* normalize component */
	
	var upload_dragger_component = normalizeComponent(
	  src_upload_draggervue_type_script_lang_js_,
	  upload_draggervue_type_template_id_7ebbf219_render,
	  upload_draggervue_type_template_id_7ebbf219_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var upload_dragger_api; }
	upload_dragger_component.options.__file = "packages/upload/src/upload-dragger.vue"
	/* harmony default export */ var upload_dragger = (upload_dragger_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload.vue?vue&type=script&lang=js&
	
	
	
	
	
	/* harmony default export */ var uploadvue_type_script_lang_js_ = ({
	  inject: ['uploader'],
	  components: {
	    UploadDragger: upload_dragger
	  },
	  props: {
	    type: String,
	    action: {
	      type: String,
	      required: true
	    },
	    name: {
	      type: String,
	      default: 'file'
	    },
	    data: Object,
	    headers: Object,
	    withCredentials: Boolean,
	    multiple: Boolean,
	    accept: String,
	    onStart: Function,
	    onProgress: Function,
	    onSuccess: Function,
	    onError: Function,
	    beforeUpload: Function,
	    drag: Boolean,
	    onPreview: {
	      type: Function,
	      default: function _default() {}
	    },
	    onRemove: {
	      type: Function,
	      default: function _default() {}
	    },
	    fileList: Array,
	    autoUpload: Boolean,
	    listType: String,
	    httpRequest: {
	      type: Function,
	      default: upload
	    },
	    disabled: Boolean,
	    limit: Number,
	    onExceed: Function
	  },
	
	  data: function data() {
	    return {
	      mouseover: false,
	      reqs: {}
	    };
	  },
	
	
	  methods: {
	    isImage: function isImage(str) {
	      return str.indexOf('image') !== -1;
	    },
	    handleChange: function handleChange(ev) {
	      var files = ev.target.files;
	
	      if (!files) return;
	      this.uploadFiles(files);
	    },
	    uploadFiles: function uploadFiles(files) {
	      var _this = this;
	
	      if (this.limit && this.fileList.length + files.length > this.limit) {
	        this.onExceed && this.onExceed(files, this.fileList);
	        return;
	      }
	
	      var postFiles = Array.prototype.slice.call(files);
	      if (!this.multiple) {
	        postFiles = postFiles.slice(0, 1);
	      }
	
	      if (postFiles.length === 0) {
	        return;
	      }
	
	      postFiles.forEach(function (rawFile) {
	        _this.onStart(rawFile);
	        if (_this.autoUpload) _this.upload(rawFile);
	      });
	    },
	    upload: function upload(rawFile) {
	      var _this2 = this;
	
	      this.$refs.input.value = null;
	
	      if (!this.beforeUpload) {
	        return this.post(rawFile);
	      }
	
	      var before = this.beforeUpload(rawFile);
	      if (before && before.then) {
	        before.then(function (processedFile) {
	          var fileType = Object.prototype.toString.call(processedFile);
	
	          if (fileType === '[object File]' || fileType === '[object Blob]') {
	            if (fileType === '[object Blob]') {
	              processedFile = new File([processedFile], rawFile.name, {
	                type: rawFile.type
	              });
	            }
	            for (var p in rawFile) {
	              if (rawFile.hasOwnProperty(p)) {
	                processedFile[p] = rawFile[p];
	              }
	            }
	            _this2.post(processedFile);
	          } else {
	            _this2.post(rawFile);
	          }
	        }, function () {
	          _this2.onRemove(null, rawFile);
	        });
	      } else if (before !== false) {
	        this.post(rawFile);
	      } else {
	        this.onRemove(null, rawFile);
	      }
	    },
	    abort: function abort(file) {
	      var reqs = this.reqs;
	
	      if (file) {
	        var uid = file;
	        if (file.uid) uid = file.uid;
	        if (reqs[uid]) {
	          reqs[uid].abort();
	        }
	      } else {
	        Object.keys(reqs).forEach(function (uid) {
	          if (reqs[uid]) reqs[uid].abort();
	          delete reqs[uid];
	        });
	      }
	    },
	    post: function post(rawFile) {
	      var _this3 = this;
	
	      var uid = rawFile.uid;
	
	      var options = {
	        headers: this.headers,
	        withCredentials: this.withCredentials,
	        file: rawFile,
	        data: this.data,
	        filename: this.name,
	        action: this.action,
	        onProgress: function onProgress(e) {
	          _this3.onProgress(e, rawFile);
	        },
	        onSuccess: function onSuccess(res) {
	          _this3.onSuccess(res, rawFile);
	          delete _this3.reqs[uid];
	        },
	        onError: function onError(err) {
	          _this3.onError(err, rawFile);
	          delete _this3.reqs[uid];
	        }
	      };
	      var req = this.httpRequest(options);
	      this.reqs[uid] = req;
	      if (req && req.then) {
	        req.then(options.onSuccess, options.onError);
	      }
	    },
	    handleClick: function handleClick() {
	      if (!this.disabled) {
	        this.$refs.input.value = null;
	        this.$refs.input.click();
	      }
	    },
	    handleKeydown: function handleKeydown(e) {
	      if (e.target !== e.currentTarget) return;
	      if (e.keyCode === 13 || e.keyCode === 32) {
	        this.handleClick();
	      }
	    }
	  },
	
	  render: function render(h) {
	    var handleClick = this.handleClick,
	        drag = this.drag,
	        name = this.name,
	        handleChange = this.handleChange,
	        multiple = this.multiple,
	        accept = this.accept,
	        listType = this.listType,
	        uploadFiles = this.uploadFiles,
	        disabled = this.disabled,
	        handleKeydown = this.handleKeydown;
	
	    var data = {
	      class: {
	        'el-upload': true
	      },
	      on: {
	        click: handleClick,
	        keydown: handleKeydown
	      }
	    };
	    data.class['el-upload--' + listType] = true;
	    return h(
	      'div',
	      external_babel_helper_vue_jsx_merge_props_default()([data, {
	        attrs: { tabindex: '0' }
	      }]),
	      [drag ? h(
	        'upload-dragger',
	        {
	          attrs: { disabled: disabled },
	          on: {
	            'file': uploadFiles
	          }
	        },
	        [this.$slots.default]
	      ) : this.$slots.default, h('input', { 'class': 'el-upload__input', attrs: { type: 'file', name: name, multiple: multiple, accept: accept },
	        ref: 'input', on: {
	          'change': handleChange
	        }
	      })]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/upload.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_uploadvue_type_script_lang_js_ = (uploadvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/upload.vue
	var upload_render, upload_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var upload_component = normalizeComponent(
	  src_uploadvue_type_script_lang_js_,
	  upload_render,
	  upload_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var upload_api; }
	upload_component.options.__file = "packages/upload/src/upload.vue"
	/* harmony default export */ var src_upload = (upload_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/index.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	function srcvue_type_script_lang_js_noop() {}
	
	/* harmony default export */ var srcvue_type_script_lang_js_ = ({
	  name: 'ElUpload',
	
	  mixins: [migrating_default.a],
	
	  components: {
	    ElProgress: progress_default.a,
	    UploadList: upload_list,
	    Upload: src_upload
	  },
	
	  provide: function provide() {
	    return {
	      uploader: this
	    };
	  },
	
	
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	
	  props: {
	    action: {
	      type: String,
	      required: true
	    },
	    headers: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    data: Object,
	    multiple: Boolean,
	    name: {
	      type: String,
	      default: 'file'
	    },
	    drag: Boolean,
	    dragger: Boolean,
	    withCredentials: Boolean,
	    showFileList: {
	      type: Boolean,
	      default: true
	    },
	    accept: String,
	    type: {
	      type: String,
	      default: 'select'
	    },
	    beforeUpload: Function,
	    beforeRemove: Function,
	    onRemove: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onChange: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onPreview: {
	      type: Function
	    },
	    onSuccess: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onProgress: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onError: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    fileList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    autoUpload: {
	      type: Boolean,
	      default: true
	    },
	    listType: {
	      type: String,
	      default: 'text' // text,picture,picture-card
	    },
	    httpRequest: Function,
	    disabled: Boolean,
	    limit: Number,
	    onExceed: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    }
	  },
	
	  data: function data() {
	    return {
	      uploadFiles: [],
	      dragOver: false,
	      draging: false,
	      tempIndex: 1
	    };
	  },
	
	
	  computed: {
	    uploadDisabled: function uploadDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  watch: {
	    listType: function listType(type) {
	      if (type === 'picture-card' || type === 'picture') {
	        this.uploadFiles = this.uploadFiles.map(function (file) {
	          if (!file.url && file.raw) {
	            try {
	              file.url = URL.createObjectURL(file.raw);
	            } catch (err) {
	              console.error('[Element Error][Upload]', err);
	            }
	          }
	          return file;
	        });
	      }
	    },
	
	    fileList: {
	      immediate: true,
	      handler: function handler(fileList) {
	        var _this = this;
	
	        this.uploadFiles = fileList.map(function (item) {
	          item.uid = item.uid || Date.now() + _this.tempIndex++;
	          item.status = item.status || 'success';
	          return item;
	        });
	      }
	    }
	  },
	
	  methods: {
	    handleStart: function handleStart(rawFile) {
	      rawFile.uid = Date.now() + this.tempIndex++;
	      var file = {
	        status: 'ready',
	        name: rawFile.name,
	        size: rawFile.size,
	        percentage: 0,
	        uid: rawFile.uid,
	        raw: rawFile
	      };
	
	      if (this.listType === 'picture-card' || this.listType === 'picture') {
	        try {
	          file.url = URL.createObjectURL(rawFile);
	        } catch (err) {
	          console.error('[Element Error][Upload]', err);
	          return;
	        }
	      }
	
	      this.uploadFiles.push(file);
	      this.onChange(file, this.uploadFiles);
	    },
	    handleProgress: function handleProgress(ev, rawFile) {
	      var file = this.getFile(rawFile);
	      this.onProgress(ev, file, this.uploadFiles);
	      file.status = 'uploading';
	      file.percentage = ev.percent || 0;
	    },
	    handleSuccess: function handleSuccess(res, rawFile) {
	      var file = this.getFile(rawFile);
	
	      if (file) {
	        file.status = 'success';
	        file.response = res;
	
	        this.onSuccess(res, file, this.uploadFiles);
	        this.onChange(file, this.uploadFiles);
	      }
	    },
	    handleError: function handleError(err, rawFile) {
	      var file = this.getFile(rawFile);
	      var fileList = this.uploadFiles;
	
	      file.status = 'fail';
	
	      fileList.splice(fileList.indexOf(file), 1);
	
	      this.onError(err, file, this.uploadFiles);
	      this.onChange(file, this.uploadFiles);
	    },
	    handleRemove: function handleRemove(file, raw) {
	      var _this2 = this;
	
	      if (raw) {
	        file = this.getFile(raw);
	      }
	      var doRemove = function doRemove() {
	        _this2.abort(file);
	        var fileList = _this2.uploadFiles;
	        fileList.splice(fileList.indexOf(file), 1);
	        _this2.onRemove(file, fileList);
	      };
	
	      if (!this.beforeRemove) {
	        doRemove();
	      } else if (typeof this.beforeRemove === 'function') {
	        var before = this.beforeRemove(file, this.uploadFiles);
	        if (before && before.then) {
	          before.then(function () {
	            doRemove();
	          }, srcvue_type_script_lang_js_noop);
	        } else if (before !== false) {
	          doRemove();
	        }
	      }
	    },
	    getFile: function getFile(rawFile) {
	      var fileList = this.uploadFiles;
	      var target = void 0;
	      fileList.every(function (item) {
	        target = rawFile.uid === item.uid ? item : null;
	        return !target;
	      });
	      return target;
	    },
	    abort: function abort(file) {
	      this.$refs['upload-inner'].abort(file);
	    },
	    clearFiles: function clearFiles() {
	      this.uploadFiles = [];
	    },
	    submit: function submit() {
	      var _this3 = this;
	
	      this.uploadFiles.filter(function (file) {
	        return file.status === 'ready';
	      }).forEach(function (file) {
	        _this3.$refs['upload-inner'].upload(file.raw);
	      });
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'default-file-list': 'default-file-list is renamed to file-list.',
	          'show-upload-list': 'show-upload-list is renamed to show-file-list.',
	          'thumbnail-mode': 'thumbnail-mode has been deprecated, you can implement the same effect according to this case: http://element.eleme.io/#/zh-CN/component/upload#yong-hu-tou-xiang-shang-chuan'
	        }
	      };
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.uploadFiles.forEach(function (file) {
	      if (file.url && file.url.indexOf('blob:') === 0) {
	        URL.revokeObjectURL(file.url);
	      }
	    });
	  },
	  render: function render(h) {
	    var _this4 = this;
	
	    var uploadList = void 0;
	
	    if (this.showFileList) {
	      uploadList = h(
	        upload_list,
	        {
	          attrs: {
	            disabled: this.uploadDisabled,
	            listType: this.listType,
	            files: this.uploadFiles,
	
	            handlePreview: this.onPreview },
	          on: {
	            'remove': this.handleRemove
	          }
	        },
	        [function (props) {
	          if (_this4.$scopedSlots.file) {
	            return _this4.$scopedSlots.file({
	              file: props.file
	            });
	          }
	        }]
	      );
	    }
	
	    var uploadData = {
	      props: {
	        type: this.type,
	        drag: this.drag,
	        action: this.action,
	        multiple: this.multiple,
	        'before-upload': this.beforeUpload,
	        'with-credentials': this.withCredentials,
	        headers: this.headers,
	        name: this.name,
	        data: this.data,
	        accept: this.accept,
	        fileList: this.uploadFiles,
	        autoUpload: this.autoUpload,
	        listType: this.listType,
	        disabled: this.uploadDisabled,
	        limit: this.limit,
	        'on-exceed': this.onExceed,
	        'on-start': this.handleStart,
	        'on-progress': this.handleProgress,
	        'on-success': this.handleSuccess,
	        'on-error': this.handleError,
	        'on-preview': this.onPreview,
	        'on-remove': this.handleRemove,
	        'http-request': this.httpRequest
	      },
	      ref: 'upload-inner'
	    };
	
	    var trigger = this.$slots.trigger || this.$slots.default;
	    var uploadComponent = h(
	      'upload',
	      uploadData,
	      [trigger]
	    );
	
	    return h('div', [this.listType === 'picture-card' ? uploadList : '', this.$slots.trigger ? [uploadComponent, this.$slots.default] : uploadComponent, this.$slots.tip, this.listType !== 'picture-card' ? uploadList : '']);
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/index.vue?vue&type=script&lang=js&
	 /* harmony default export */ var upload_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/index.vue
	var src_render, src_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var upload_src_component = normalizeComponent(
	  upload_srcvue_type_script_lang_js_,
	  src_render,
	  src_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_api; }
	upload_src_component.options.__file = "packages/upload/src/index.vue"
	/* harmony default export */ var upload_src = (upload_src_component.exports);
	// CONCATENATED MODULE: ./packages/upload/index.js
	
	
	/* istanbul ignore next */
	upload_src.install = function (Vue) {
	  Vue.component(upload_src.name, upload_src);
	};
	
	/* harmony default export */ var packages_upload = (upload_src);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	var progressvue_type_template_id_229ee406_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-progress",
	      class: [
	        "el-progress--" + _vm.type,
	        _vm.status ? "is-" + _vm.status : "",
	        {
	          "el-progress--without-text": !_vm.showText,
	          "el-progress--text-inside": _vm.textInside
	        }
	      ],
	      attrs: {
	        role: "progressbar",
	        "aria-valuenow": _vm.percentage,
	        "aria-valuemin": "0",
	        "aria-valuemax": "100"
	      }
	    },
	    [
	      _vm.type === "line"
	        ? _c("div", { staticClass: "el-progress-bar" }, [
	            _c(
	              "div",
	              {
	                staticClass: "el-progress-bar__outer",
	                style: { height: _vm.strokeWidth + "px" }
	              },
	              [
	                _c(
	                  "div",
	                  {
	                    staticClass: "el-progress-bar__inner",
	                    style: _vm.barStyle
	                  },
	                  [
	                    _vm.showText && _vm.textInside
	                      ? _c(
	                          "div",
	                          { staticClass: "el-progress-bar__innerText" },
	                          [_vm._v(_vm._s(_vm.content))]
	                        )
	                      : _vm._e()
	                  ]
	                )
	              ]
	            )
	          ])
	        : _c(
	            "div",
	            {
	              staticClass: "el-progress-circle",
	              style: { height: _vm.width + "px", width: _vm.width + "px" }
	            },
	            [
	              _c("svg", { attrs: { viewBox: "0 0 100 100" } }, [
	                _c("path", {
	                  staticClass: "el-progress-circle__track",
	                  style: _vm.trailPathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: "#e5e9f2",
	                    "stroke-width": _vm.relativeStrokeWidth,
	                    fill: "none"
	                  }
	                }),
	                _c("path", {
	                  staticClass: "el-progress-circle__path",
	                  style: _vm.circlePathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: _vm.stroke,
	                    fill: "none",
	                    "stroke-linecap": _vm.strokeLinecap,
	                    "stroke-width": _vm.percentage ? _vm.relativeStrokeWidth : 0
	                  }
	                })
	              ])
	            ]
	          ),
	      _vm.showText && !_vm.textInside
	        ? _c(
	            "div",
	            {
	              staticClass: "el-progress__text",
	              style: { fontSize: _vm.progressTextSize + "px" }
	            },
	            [
	              !_vm.status
	                ? [_vm._v(_vm._s(_vm.content))]
	                : _c("i", { class: _vm.iconClass })
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var progressvue_type_template_id_229ee406_staticRenderFns = []
	progressvue_type_template_id_229ee406_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var progressvue_type_script_lang_js_ = ({
	  name: 'ElProgress',
	  props: {
	    type: {
	      type: String,
	      default: 'line',
	      validator: function validator(val) {
	        return ['line', 'circle', 'dashboard'].indexOf(val) > -1;
	      }
	    },
	    percentage: {
	      type: Number,
	      default: 0,
	      required: true,
	      validator: function validator(val) {
	        return val >= 0 && val <= 100;
	      }
	    },
	    status: {
	      type: String,
	      validator: function validator(val) {
	        return ['success', 'exception', 'warning'].indexOf(val) > -1;
	      }
	    },
	    strokeWidth: {
	      type: Number,
	      default: 6
	    },
	    strokeLinecap: {
	      type: String,
	      default: 'round'
	    },
	    textInside: {
	      type: Boolean,
	      default: false
	    },
	    width: {
	      type: Number,
	      default: 126
	    },
	    showText: {
	      type: Boolean,
	      default: true
	    },
	    color: {
	      type: [String, Array, Function],
	      default: ''
	    },
	    format: Function
	  },
	  computed: {
	    barStyle: function barStyle() {
	      var style = {};
	      style.width = this.percentage + '%';
	      style.backgroundColor = this.getCurrentColor(this.percentage);
	      return style;
	    },
	    relativeStrokeWidth: function relativeStrokeWidth() {
	      return (this.strokeWidth / this.width * 100).toFixed(1);
	    },
	    radius: function radius() {
	      if (this.type === 'circle' || this.type === 'dashboard') {
	        return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
	      } else {
	        return 0;
	      }
	    },
	    trackPath: function trackPath() {
	      var radius = this.radius;
	      var isDashboard = this.type === 'dashboard';
	      return '\n        M 50 50\n        m 0 ' + (isDashboard ? '' : '-') + radius + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '-' : '') + radius * 2 + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '' : '-') + radius * 2 + '\n        ';
	    },
	    perimeter: function perimeter() {
	      return 2 * Math.PI * this.radius;
	    },
	    rate: function rate() {
	      return this.type === 'dashboard' ? 0.75 : 1;
	    },
	    strokeDashoffset: function strokeDashoffset() {
	      var offset = -1 * this.perimeter * (1 - this.rate) / 2;
	      return offset + 'px';
	    },
	    trailPathStyle: function trailPathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset
	      };
	    },
	    circlePathStyle: function circlePathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate * (this.percentage / 100) + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset,
	        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
	      };
	    },
	    stroke: function stroke() {
	      var ret = void 0;
	      if (this.color) {
	        ret = this.getCurrentColor(this.percentage);
	      } else {
	        switch (this.status) {
	          case 'success':
	            ret = '#13ce66';
	            break;
	          case 'exception':
	            ret = '#ff4949';
	            break;
	          case 'warning':
	            ret = '#e6a23c';
	            break;
	          default:
	            ret = '#20a0ff';
	        }
	      }
	      return ret;
	    },
	    iconClass: function iconClass() {
	      if (this.status === 'warning') {
	        return 'el-icon-warning';
	      }
	      if (this.type === 'line') {
	        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
	      } else {
	        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
	      }
	    },
	    progressTextSize: function progressTextSize() {
	      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
	    },
	    content: function content() {
	      if (typeof this.format === 'function') {
	        return this.format(this.percentage) || '';
	      } else {
	        return this.percentage + '%';
	      }
	    }
	  },
	  methods: {
	    getCurrentColor: function getCurrentColor(percentage) {
	      if (typeof this.color === 'function') {
	        return this.color(percentage);
	      } else if (typeof this.color === 'string') {
	        return this.color;
	      } else {
	        return this.getLevelColor(percentage);
	      }
	    },
	    getLevelColor: function getLevelColor(percentage) {
	      var colorArray = this.getColorArray().sort(function (a, b) {
	        return a.percentage - b.percentage;
	      });
	
	      for (var i = 0; i < colorArray.length; i++) {
	        if (colorArray[i].percentage > percentage) {
	          return colorArray[i].color;
	        }
	      }
	      return colorArray[colorArray.length - 1].color;
	    },
	    getColorArray: function getColorArray() {
	      var color = this.color;
	      var span = 100 / color.length;
	      return color.map(function (seriesColor, index) {
	        if (typeof seriesColor === 'string') {
	          return {
	            color: seriesColor,
	            percentage: (index + 1) * span
	          };
	        }
	        return seriesColor;
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_progressvue_type_script_lang_js_ = (progressvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue
	
	
	
	
	
	/* normalize component */
	
	var progress_component = normalizeComponent(
	  src_progressvue_type_script_lang_js_,
	  progressvue_type_template_id_229ee406_render,
	  progressvue_type_template_id_229ee406_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var progress_api; }
	progress_component.options.__file = "packages/progress/src/progress.vue"
	/* harmony default export */ var progress = (progress_component.exports);
	// CONCATENATED MODULE: ./packages/progress/index.js
	
	
	/* istanbul ignore next */
	progress.install = function (Vue) {
	  Vue.component(progress.name, progress);
	};
	
	/* harmony default export */ var packages_progress = (progress);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&
	var spinnervue_type_template_id_697b8538_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("span", { staticClass: "el-spinner" }, [
	    _c(
	      "svg",
	      {
	        staticClass: "el-spinner-inner",
	        style: { width: _vm.radius / 2 + "px", height: _vm.radius / 2 + "px" },
	        attrs: { viewBox: "0 0 50 50" }
	      },
	      [
	        _c("circle", {
	          staticClass: "path",
	          attrs: {
	            cx: "25",
	            cy: "25",
	            r: "20",
	            fill: "none",
	            stroke: _vm.strokeColor,
	            "stroke-width": _vm.strokeWidth
	          }
	        })
	      ]
	    )
	  ])
	}
	var spinnervue_type_template_id_697b8538_staticRenderFns = []
	spinnervue_type_template_id_697b8538_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var spinnervue_type_script_lang_js_ = ({
	  name: 'ElSpinner',
	  props: {
	    type: String,
	    radius: {
	      type: Number,
	      default: 100
	    },
	    strokeWidth: {
	      type: Number,
	      default: 5
	    },
	    strokeColor: {
	      type: String,
	      default: '#efefef'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_spinnervue_type_script_lang_js_ = (spinnervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue
	
	
	
	
	
	/* normalize component */
	
	var spinner_component = normalizeComponent(
	  src_spinnervue_type_script_lang_js_,
	  spinnervue_type_template_id_697b8538_render,
	  spinnervue_type_template_id_697b8538_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var spinner_api; }
	spinner_component.options.__file = "packages/spinner/src/spinner.vue"
	/* harmony default export */ var spinner = (spinner_component.exports);
	// CONCATENATED MODULE: ./packages/spinner/index.js
	
	
	/* istanbul ignore next */
	spinner.install = function (Vue) {
	  Vue.component(spinner.name, spinner);
	};
	
	/* harmony default export */ var packages_spinner = (spinner);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=template&id=455b9f60&
	var mainvue_type_template_id_455b9f60_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-message-fade" },
	      on: { "after-leave": _vm.handleAfterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          class: [
	            "el-message",
	            _vm.type && !_vm.iconClass ? "el-message--" + _vm.type : "",
	            _vm.center ? "is-center" : "",
	            _vm.showClose ? "is-closable" : "",
	            _vm.customClass
	          ],
	          style: _vm.positionStyle,
	          attrs: { role: "alert" },
	          on: { mouseenter: _vm.clearTimer, mouseleave: _vm.startTimer }
	        },
	        [
	          _vm.iconClass
	            ? _c("i", { class: _vm.iconClass })
	            : _c("i", { class: _vm.typeClass }),
	          _vm._t("default", [
	            !_vm.dangerouslyUseHTMLString
	              ? _c("p", { staticClass: "el-message__content" }, [
	                  _vm._v(_vm._s(_vm.message))
	                ])
	              : _c("p", {
	                  staticClass: "el-message__content",
	                  domProps: { innerHTML: _vm._s(_vm.message) }
	                })
	          ]),
	          _vm.showClose
	            ? _c("i", {
	                staticClass: "el-message__closeBtn el-icon-close",
	                on: { click: _vm.close }
	              })
	            : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var mainvue_type_template_id_455b9f60_staticRenderFns = []
	mainvue_type_template_id_455b9f60_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=template&id=455b9f60&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var src_mainvue_type_script_lang_js_typeMap = {
	  success: 'success',
	  info: 'info',
	  warning: 'warning',
	  error: 'error'
	};
	
	/* harmony default export */ var message_src_mainvue_type_script_lang_js_ = ({
	  data: function data() {
	    return {
	      visible: false,
	      message: '',
	      duration: 3000,
	      type: 'info',
	      iconClass: '',
	      customClass: '',
	      onClose: null,
	      showClose: false,
	      closed: false,
	      verticalOffset: 20,
	      timer: null,
	      dangerouslyUseHTMLString: false,
	      center: false
	    };
	  },
	
	
	  computed: {
	    typeClass: function typeClass() {
	      return this.type && !this.iconClass ? 'el-message__icon el-icon-' + src_mainvue_type_script_lang_js_typeMap[this.type] : '';
	    },
	    positionStyle: function positionStyle() {
	      return {
	        'top': this.verticalOffset + 'px'
	      };
	    }
	  },
	
	  watch: {
	    closed: function closed(newVal) {
	      if (newVal) {
	        this.visible = false;
	      }
	    }
	  },
	
	  methods: {
	    handleAfterLeave: function handleAfterLeave() {
	      this.$destroy(true);
	      this.$el.parentNode.removeChild(this.$el);
	    },
	    close: function close() {
	      this.closed = true;
	      if (typeof this.onClose === 'function') {
	        this.onClose(this);
	      }
	    },
	    clearTimer: function clearTimer() {
	      clearTimeout(this.timer);
	    },
	    startTimer: function startTimer() {
	      var _this = this;
	
	      if (this.duration > 0) {
	        this.timer = setTimeout(function () {
	          if (!_this.closed) {
	            _this.close();
	          }
	        }, this.duration);
	      }
	    },
	    keydown: function keydown(e) {
	      if (e.keyCode === 27) {
	        // esc关闭消息
	        if (!this.closed) {
	          this.close();
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.startTimer();
	    document.addEventListener('keydown', this.keydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this.keydown);
	  }
	});
	// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_message_src_mainvue_type_script_lang_js_ = (message_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/message/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var message_src_main_component = normalizeComponent(
	  packages_message_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_455b9f60_render,
	  mainvue_type_template_id_455b9f60_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var message_src_main_api; }
	message_src_main_component.options.__file = "packages/message/src/main.vue"
	/* harmony default export */ var message_src_main = (message_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/message/src/main.js
	
	
	
	
	var MessageConstructor = external_vue_default.a.extend(message_src_main);
	
	var message_src_main_instance = void 0;
	var main_instances = [];
	var main_seed = 1;
	
	var main_Message = function Message(options) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  options = options || {};
	  if (typeof options === 'string') {
	    options = {
	      message: options
	    };
	  }
	  var userOnClose = options.onClose;
	  var id = 'message_' + main_seed++;
	
	  options.onClose = function () {
	    Message.close(id, userOnClose);
	  };
	  message_src_main_instance = new MessageConstructor({
	    data: options
	  });
	  message_src_main_instance.id = id;
	  if (Object(vdom_["isVNode"])(message_src_main_instance.message)) {
	    message_src_main_instance.$slots.default = [message_src_main_instance.message];
	    message_src_main_instance.message = null;
	  }
	  message_src_main_instance.$mount();
	  document.body.appendChild(message_src_main_instance.$el);
	  var verticalOffset = options.offset || 20;
	  main_instances.forEach(function (item) {
	    verticalOffset += item.$el.offsetHeight + 16;
	  });
	  message_src_main_instance.verticalOffset = verticalOffset;
	  message_src_main_instance.visible = true;
	  message_src_main_instance.$el.style.zIndex = popup_["PopupManager"].nextZIndex();
	  main_instances.push(message_src_main_instance);
	  return message_src_main_instance;
	};
	
	['success', 'warning', 'info', 'error'].forEach(function (type) {
	  main_Message[type] = function (options) {
	    if (typeof options === 'string') {
	      options = {
	        message: options
	      };
	    }
	    options.type = type;
	    return main_Message(options);
	  };
	});
	
	main_Message.close = function (id, userOnClose) {
	  var len = main_instances.length;
	  var index = -1;
	  var removedHeight = void 0;
	  for (var i = 0; i < len; i++) {
	    if (id === main_instances[i].id) {
	      removedHeight = main_instances[i].$el.offsetHeight;
	      index = i;
	      if (typeof userOnClose === 'function') {
	        userOnClose(main_instances[i]);
	      }
	      main_instances.splice(i, 1);
	      break;
	    }
	  }
	  if (len <= 1 || index === -1 || index > main_instances.length - 1) return;
	  for (var _i = index; _i < len - 1; _i++) {
	    var dom = main_instances[_i].$el;
	    dom.style['top'] = parseInt(dom.style['top'], 10) - removedHeight - 16 + 'px';
	  }
	};
	
	main_Message.closeAll = function () {
	  for (var i = main_instances.length - 1; i >= 0; i--) {
	    main_instances[i].close();
	  }
	};
	
	/* harmony default export */ var packages_message_src_main = (main_Message);
	// CONCATENATED MODULE: ./packages/message/index.js
	
	/* harmony default export */ var packages_message = (packages_message_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&
	var mainvue_type_template_id_7ccb6598_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    { staticClass: "el-badge" },
	    [
	      _vm._t("default"),
	      _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
	        _c("sup", {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value:
	                !_vm.hidden && (_vm.content || _vm.content === 0 || _vm.isDot),
	              expression: "!hidden && (content || content === 0 || isDot)"
	            }
	          ],
	          staticClass: "el-badge__content",
	          class: [
	            "el-badge__content--" + _vm.type,
	            {
	              "is-fixed": _vm.$slots.default,
	              "is-dot": _vm.isDot
	            }
	          ],
	          domProps: { textContent: _vm._s(_vm.content) }
	        })
	      ])
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_7ccb6598_staticRenderFns = []
	mainvue_type_template_id_7ccb6598_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var badge_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElBadge',
	
	  props: {
	    value: [String, Number],
	    max: Number,
	    isDot: Boolean,
	    hidden: Boolean,
	    type: {
	      type: String,
	      validator: function validator(val) {
	        return ['primary', 'success', 'warning', 'info', 'danger'].indexOf(val) > -1;
	      }
	    }
	  },
	
	  computed: {
	    content: function content() {
	      if (this.isDot) return;
	
	      var value = this.value;
	      var max = this.max;
	
	      if (typeof value === 'number' && typeof max === 'number') {
	        return max < value ? max + '+' : value;
	      }
	
	      return value;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_badge_src_mainvue_type_script_lang_js_ = (badge_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/badge/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var badge_src_main_component = normalizeComponent(
	  packages_badge_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_7ccb6598_render,
	  mainvue_type_template_id_7ccb6598_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var badge_src_main_api; }
	badge_src_main_component.options.__file = "packages/badge/src/main.vue"
	/* harmony default export */ var badge_src_main = (badge_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/badge/index.js
	
	
	/* istanbul ignore next */
	badge_src_main.install = function (Vue) {
	  Vue.component(badge_src_main.name, badge_src_main);
	};
	
	/* harmony default export */ var badge = (badge_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
	var mainvue_type_template_id_59a4a40f_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-card",
	      class: _vm.shadow ? "is-" + _vm.shadow + "-shadow" : "is-always-shadow"
	    },
	    [
	      _vm.$slots.header || _vm.header
	        ? _c(
	            "div",
	            { staticClass: "el-card__header" },
	            [_vm._t("header", [_vm._v(_vm._s(_vm.header))])],
	            2
	          )
	        : _vm._e(),
	      _c(
	        "div",
	        { staticClass: "el-card__body", style: _vm.bodyStyle },
	        [_vm._t("default")],
	        2
	      )
	    ]
	  )
	}
	var mainvue_type_template_id_59a4a40f_staticRenderFns = []
	mainvue_type_template_id_59a4a40f_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var card_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElCard',
	  props: {
	    header: {},
	    bodyStyle: {},
	    shadow: {
	      type: String
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_card_src_mainvue_type_script_lang_js_ = (card_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/card/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var card_src_main_component = normalizeComponent(
	  packages_card_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_59a4a40f_render,
	  mainvue_type_template_id_59a4a40f_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var card_src_main_api; }
	card_src_main_component.options.__file = "packages/card/src/main.vue"
	/* harmony default export */ var card_src_main = (card_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/card/index.js
	
	
	/* istanbul ignore next */
	card_src_main.install = function (Vue) {
	  Vue.component(card_src_main.name, card_src_main);
	};
	
	/* harmony default export */ var card = (card_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=template&id=ada57782&
	var mainvue_type_template_id_ada57782_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-rate",
	      attrs: {
	        role: "slider",
	        "aria-valuenow": _vm.currentValue,
	        "aria-valuetext": _vm.text,
	        "aria-valuemin": "0",
	        "aria-valuemax": _vm.max,
	        tabindex: "0"
	      },
	      on: { keydown: _vm.handleKey }
	    },
	    [
	      _vm._l(_vm.max, function(item, key) {
	        return _c(
	          "span",
	          {
	            key: key,
	            staticClass: "el-rate__item",
	            style: { cursor: _vm.rateDisabled ? "auto" : "pointer" },
	            on: {
	              mousemove: function($event) {
	                _vm.setCurrentValue(item, $event)
	              },
	              mouseleave: _vm.resetCurrentValue,
	              click: function($event) {
	                _vm.selectValue(item)
	              }
	            }
	          },
	          [
	            _c(
	              "i",
	              {
	                staticClass: "el-rate__icon",
	                class: [
	                  _vm.classes[item - 1],
	                  { hover: _vm.hoverIndex === item }
	                ],
	                style: _vm.getIconStyle(item)
	              },
	              [
	                _vm.showDecimalIcon(item)
	                  ? _c("i", {
	                      staticClass: "el-rate__decimal",
	                      class: _vm.decimalIconClass,
	                      style: _vm.decimalStyle
	                    })
	                  : _vm._e()
	              ]
	            )
	          ]
	        )
	      }),
	      _vm.showText || _vm.showScore
	        ? _c(
	            "span",
	            { staticClass: "el-rate__text", style: { color: _vm.textColor } },
	            [_vm._v(_vm._s(_vm.text))]
	          )
	        : _vm._e()
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_ada57782_staticRenderFns = []
	mainvue_type_template_id_ada57782_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=template&id=ada57782&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/types"
	var types_ = __webpack_require__(18);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var rate_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElRate',
	
	  mixins: [migrating_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      pointerAtLeftHalf: true,
	      currentValue: this.value,
	      hoverIndex: -1
	    };
	  },
	
	
	  props: {
	    value: {
	      type: Number,
	      default: 0
	    },
	    lowThreshold: {
	      type: Number,
	      default: 2
	    },
	    highThreshold: {
	      type: Number,
	      default: 4
	    },
	    max: {
	      type: Number,
	      default: 5
	    },
	    colors: {
	      type: [Array, Object],
	      default: function _default() {
	        return ['#F7BA2A', '#F7BA2A', '#F7BA2A'];
	      }
	    },
	    voidColor: {
	      type: String,
	      default: '#C6D1DE'
	    },
	    disabledVoidColor: {
	      type: String,
	      default: '#EFF2F7'
	    },
	    iconClasses: {
	      type: [Array, Object],
	      default: function _default() {
	        return ['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on'];
	      }
	    },
	    voidIconClass: {
	      type: String,
	      default: 'el-icon-star-off'
	    },
	    disabledVoidIconClass: {
	      type: String,
	      default: 'el-icon-star-on'
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    allowHalf: {
	      type: Boolean,
	      default: false
	    },
	    showText: {
	      type: Boolean,
	      default: false
	    },
	    showScore: {
	      type: Boolean,
	      default: false
	    },
	    textColor: {
	      type: String,
	      default: '#1f2d3d'
	    },
	    texts: {
	      type: Array,
	      default: function _default() {
	        return ['极差', '失望', '一般', '满意', '惊喜'];
	      }
	    },
	    scoreTemplate: {
	      type: String,
	      default: '{value}'
	    }
	  },
	
	  computed: {
	    text: function text() {
	      var result = '';
	      if (this.showScore) {
	        result = this.scoreTemplate.replace(/\{\s*value\s*\}/, this.rateDisabled ? this.value : this.currentValue);
	      } else if (this.showText) {
	        result = this.texts[Math.ceil(this.currentValue) - 1];
	      }
	      return result;
	    },
	    decimalStyle: function decimalStyle() {
	      var width = '';
	      if (this.rateDisabled) {
	        width = this.valueDecimal + '%';
	      } else if (this.allowHalf) {
	        width = '50%';
	      }
	      return {
	        color: this.activeColor,
	        width: width
	      };
	    },
	    valueDecimal: function valueDecimal() {
	      return this.value * 100 - Math.floor(this.value) * 100;
	    },
	    classMap: function classMap() {
	      var _ref;
	
	      return Array.isArray(this.iconClasses) ? (_ref = {}, _ref[this.lowThreshold] = this.iconClasses[0], _ref[this.highThreshold] = { value: this.iconClasses[1], excluded: true }, _ref[this.max] = this.iconClasses[2], _ref) : this.iconClasses;
	    },
	    decimalIconClass: function decimalIconClass() {
	      return this.getValueFromMap(this.value, this.classMap);
	    },
	    voidClass: function voidClass() {
	      return this.rateDisabled ? this.disabledVoidIconClass : this.voidIconClass;
	    },
	    activeClass: function activeClass() {
	      return this.getValueFromMap(this.currentValue, this.classMap);
	    },
	    colorMap: function colorMap() {
	      var _ref2;
	
	      return Array.isArray(this.colors) ? (_ref2 = {}, _ref2[this.lowThreshold] = this.colors[0], _ref2[this.highThreshold] = { value: this.colors[1], excluded: true }, _ref2[this.max] = this.colors[2], _ref2) : this.colors;
	    },
	    activeColor: function activeColor() {
	      return this.getValueFromMap(this.currentValue, this.colorMap);
	    },
	    classes: function classes() {
	      var result = [];
	      var i = 0;
	      var threshold = this.currentValue;
	      if (this.allowHalf && this.currentValue !== Math.floor(this.currentValue)) {
	        threshold--;
	      }
	      for (; i < threshold; i++) {
	        result.push(this.activeClass);
	      }
	      for (; i < this.max; i++) {
	        result.push(this.voidClass);
	      }
	      return result;
	    },
	    rateDisabled: function rateDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	      this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'text-template': 'text-template is renamed to score-template.'
	        }
	      };
	    },
	    getValueFromMap: function getValueFromMap(value, map) {
	      var matchedKeys = Object.keys(map).filter(function (key) {
	        var val = map[key];
	        var excluded = Object(types_["isObject"])(val) ? val.excluded : false;
	        return excluded ? value < key : value <= key;
	      }).sort(function (a, b) {
	        return a - b;
	      });
	      var matchedValue = map[matchedKeys[0]];
	      return Object(types_["isObject"])(matchedValue) ? matchedValue.value : matchedValue || '';
	    },
	    showDecimalIcon: function showDecimalIcon(item) {
	      var showWhenDisabled = this.rateDisabled && this.valueDecimal > 0 && item - 1 < this.value && item > this.value;
	      /* istanbul ignore next */
	      var showWhenAllowHalf = this.allowHalf && this.pointerAtLeftHalf && item - 0.5 <= this.currentValue && item > this.currentValue;
	      return showWhenDisabled || showWhenAllowHalf;
	    },
	    getIconStyle: function getIconStyle(item) {
	      var voidColor = this.rateDisabled ? this.disabledVoidColor : this.voidColor;
	      return {
	        color: item <= this.currentValue ? this.activeColor : voidColor
	      };
	    },
	    selectValue: function selectValue(value) {
	      if (this.rateDisabled) {
	        return;
	      }
	      if (this.allowHalf && this.pointerAtLeftHalf) {
	        this.$emit('input', this.currentValue);
	        this.$emit('change', this.currentValue);
	      } else {
	        this.$emit('input', value);
	        this.$emit('change', value);
	      }
	    },
	    handleKey: function handleKey(e) {
	      if (this.rateDisabled) {
	        return;
	      }
	      var currentValue = this.currentValue;
	      var keyCode = e.keyCode;
	      if (keyCode === 38 || keyCode === 39) {
	        // left / down
	        if (this.allowHalf) {
	          currentValue += 0.5;
	        } else {
	          currentValue += 1;
	        }
	        e.stopPropagation();
	        e.preventDefault();
	      } else if (keyCode === 37 || keyCode === 40) {
	        if (this.allowHalf) {
	          currentValue -= 0.5;
	        } else {
	          currentValue -= 1;
	        }
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      currentValue = currentValue < 0 ? 0 : currentValue;
	      currentValue = currentValue > this.max ? this.max : currentValue;
	
	      this.$emit('input', currentValue);
	      this.$emit('change', currentValue);
	    },
	    setCurrentValue: function setCurrentValue(value, event) {
	      if (this.rateDisabled) {
	        return;
	      }
	      /* istanbul ignore if */
	      if (this.allowHalf) {
	        var target = event.target;
	        if (Object(dom_["hasClass"])(target, 'el-rate__item')) {
	          target = target.querySelector('.el-rate__icon');
	        }
	        if (Object(dom_["hasClass"])(target, 'el-rate__decimal')) {
	          target = target.parentNode;
	        }
	        this.pointerAtLeftHalf = event.offsetX * 2 <= target.clientWidth;
	        this.currentValue = this.pointerAtLeftHalf ? value - 0.5 : value;
	      } else {
	        this.currentValue = value;
	      }
	      this.hoverIndex = value;
	    },
	    resetCurrentValue: function resetCurrentValue() {
	      if (this.rateDisabled) {
	        return;
	      }
	      if (this.allowHalf) {
	        this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
	      }
	      this.currentValue = this.value;
	      this.hoverIndex = -1;
	    }
	  },
	
	  created: function created() {
	    if (!this.value) {
	      this.$emit('input', 0);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_rate_src_mainvue_type_script_lang_js_ = (rate_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/rate/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var rate_src_main_component = normalizeComponent(
	  packages_rate_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_ada57782_render,
	  mainvue_type_template_id_ada57782_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var rate_src_main_api; }
	rate_src_main_component.options.__file = "packages/rate/src/main.vue"
	/* harmony default export */ var rate_src_main = (rate_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/rate/index.js
	
	
	/* istanbul ignore next */
	rate_src_main.install = function (Vue) {
	  Vue.component(rate_src_main.name, rate_src_main);
	};
	
	/* harmony default export */ var rate = (rate_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&
	var stepsvue_type_template_id_3c6b6dc0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-steps",
	      class: [
	        !_vm.simple && "el-steps--" + _vm.direction,
	        _vm.simple && "el-steps--simple"
	      ]
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var stepsvue_type_template_id_3c6b6dc0_staticRenderFns = []
	stepsvue_type_template_id_3c6b6dc0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var stepsvue_type_script_lang_js_ = ({
	  name: 'ElSteps',
	
	  mixins: [migrating_default.a],
	
	  props: {
	    space: [Number, String],
	    active: Number,
	    direction: {
	      type: String,
	      default: 'horizontal'
	    },
	    alignCenter: Boolean,
	    simple: Boolean,
	    finishStatus: {
	      type: String,
	      default: 'finish'
	    },
	    processStatus: {
	      type: String,
	      default: 'process'
	    }
	  },
	
	  data: function data() {
	    return {
	      steps: [],
	      stepOffset: 0
	    };
	  },
	
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'center': 'center is removed.'
	        }
	      };
	    }
	  },
	
	  watch: {
	    active: function active(newVal, oldVal) {
	      this.$emit('change', newVal, oldVal);
	    },
	    steps: function steps(_steps) {
	      _steps.forEach(function (child, index) {
	        child.index = index;
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_stepsvue_type_script_lang_js_ = (stepsvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/steps/src/steps.vue
	
	
	
	
	
	/* normalize component */
	
	var steps_component = normalizeComponent(
	  src_stepsvue_type_script_lang_js_,
	  stepsvue_type_template_id_3c6b6dc0_render,
	  stepsvue_type_template_id_3c6b6dc0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var steps_api; }
	steps_component.options.__file = "packages/steps/src/steps.vue"
	/* harmony default export */ var steps = (steps_component.exports);
	// CONCATENATED MODULE: ./packages/steps/index.js
	
	
	/* istanbul ignore next */
	steps.install = function (Vue) {
	  Vue.component(steps.name, steps);
	};
	
	/* harmony default export */ var packages_steps = (steps);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=template&id=f414a87a&
	var stepvue_type_template_id_f414a87a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-step",
	      class: [
	        !_vm.isSimple && "is-" + _vm.$parent.direction,
	        _vm.isSimple && "is-simple",
	        _vm.isLast && !_vm.space && !_vm.isCenter && "is-flex",
	        _vm.isCenter && !_vm.isVertical && !_vm.isSimple && "is-center"
	      ],
	      style: _vm.style
	    },
	    [
	      _c(
	        "div",
	        { staticClass: "el-step__head", class: "is-" + _vm.currentStatus },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-step__line",
	              style: _vm.isLast
	                ? ""
	                : { marginRight: _vm.$parent.stepOffset + "px" }
	            },
	            [
	              _c("i", {
	                staticClass: "el-step__line-inner",
	                style: _vm.lineStyle
	              })
	            ]
	          ),
	          _c(
	            "div",
	            {
	              staticClass: "el-step__icon",
	              class: "is-" + (_vm.icon ? "icon" : "text")
	            },
	            [
	              _vm.currentStatus !== "success" && _vm.currentStatus !== "error"
	                ? _vm._t("icon", [
	                    _vm.icon
	                      ? _c("i", {
	                          staticClass: "el-step__icon-inner",
	                          class: [_vm.icon]
	                        })
	                      : _vm._e(),
	                    !_vm.icon && !_vm.isSimple
	                      ? _c("div", { staticClass: "el-step__icon-inner" }, [
	                          _vm._v(_vm._s(_vm.index + 1))
	                        ])
	                      : _vm._e()
	                  ])
	                : _c("i", {
	                    staticClass: "el-step__icon-inner is-status",
	                    class: [
	                      "el-icon-" +
	                        (_vm.currentStatus === "success" ? "check" : "close")
	                    ]
	                  })
	            ],
	            2
	          )
	        ]
	      ),
	      _c("div", { staticClass: "el-step__main" }, [
	        _c(
	          "div",
	          {
	            ref: "title",
	            staticClass: "el-step__title",
	            class: ["is-" + _vm.currentStatus]
	          },
	          [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
	          2
	        ),
	        _vm.isSimple
	          ? _c("div", { staticClass: "el-step__arrow" })
	          : _c(
	              "div",
	              {
	                staticClass: "el-step__description",
	                class: ["is-" + _vm.currentStatus]
	              },
	              [_vm._t("description", [_vm._v(_vm._s(_vm.description))])],
	              2
	            )
	      ])
	    ]
	  )
	}
	var stepvue_type_template_id_f414a87a_staticRenderFns = []
	stepvue_type_template_id_f414a87a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=template&id=f414a87a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var stepvue_type_script_lang_js_ = ({
	  name: 'ElStep',
	
	  props: {
	    title: String,
	    icon: String,
	    description: String,
	    status: String
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      lineStyle: {},
	      internalStatus: ''
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    this.$parent.steps.push(this);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var steps = this.$parent.steps;
	    var index = steps.indexOf(this);
	    if (index >= 0) {
	      steps.splice(index, 1);
	    }
	  },
	
	
	  computed: {
	    currentStatus: function currentStatus() {
	      return this.status || this.internalStatus;
	    },
	    prevStatus: function prevStatus() {
	      var prevStep = this.$parent.steps[this.index - 1];
	      return prevStep ? prevStep.currentStatus : 'wait';
	    },
	    isCenter: function isCenter() {
	      return this.$parent.alignCenter;
	    },
	    isVertical: function isVertical() {
	      return this.$parent.direction === 'vertical';
	    },
	    isSimple: function isSimple() {
	      return this.$parent.simple;
	    },
	    isLast: function isLast() {
	      var parent = this.$parent;
	      return parent.steps[parent.steps.length - 1] === this;
	    },
	    stepsCount: function stepsCount() {
	      return this.$parent.steps.length;
	    },
	    space: function space() {
	      var isSimple = this.isSimple,
	          space = this.$parent.space;
	
	      return isSimple ? '' : space;
	    },
	
	    style: function style() {
	      var style = {};
	      var parent = this.$parent;
	      var len = parent.steps.length;
	
	      var space = typeof this.space === 'number' ? this.space + 'px' : this.space ? this.space : 100 / (len - (this.isCenter ? 0 : 1)) + '%';
	      style.flexBasis = space;
	      if (this.isVertical) return style;
	      if (this.isLast) {
	        style.maxWidth = 100 / this.stepsCount + '%';
	      } else {
	        style.marginRight = -this.$parent.stepOffset + 'px';
	      }
	
	      return style;
	    }
	  },
	
	  methods: {
	    updateStatus: function updateStatus(val) {
	      var prevChild = this.$parent.$children[this.index - 1];
	
	      if (val > this.index) {
	        this.internalStatus = this.$parent.finishStatus;
	      } else if (val === this.index && this.prevStatus !== 'error') {
	        this.internalStatus = this.$parent.processStatus;
	      } else {
	        this.internalStatus = 'wait';
	      }
	
	      if (prevChild) prevChild.calcProgress(this.internalStatus);
	    },
	    calcProgress: function calcProgress(status) {
	      var step = 100;
	      var style = {};
	
	      style.transitionDelay = 150 * this.index + 'ms';
	      if (status === this.$parent.processStatus) {
	        step = this.currentStatus !== 'error' ? 0 : 0;
	      } else if (status === 'wait') {
	        step = 0;
	        style.transitionDelay = -150 * this.index + 'ms';
	      }
	
	      style.borderWidth = step && !this.isSimple ? '1px' : 0;
	      this.$parent.direction === 'vertical' ? style.height = step + '%' : style.width = step + '%';
	
	      this.lineStyle = style;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var unwatch = this.$watch('index', function (val) {
	      _this.$watch('$parent.active', _this.updateStatus, { immediate: true });
	      _this.$watch('$parent.processStatus', function () {
	        var activeIndex = _this.$parent.active;
	        _this.updateStatus(activeIndex);
	      }, { immediate: true });
	      unwatch();
	    });
	  }
	});
	// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_stepvue_type_script_lang_js_ = (stepvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/steps/src/step.vue
	
	
	
	
	
	/* normalize component */
	
	var step_component = normalizeComponent(
	  src_stepvue_type_script_lang_js_,
	  stepvue_type_template_id_f414a87a_render,
	  stepvue_type_template_id_f414a87a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var step_api; }
	step_component.options.__file = "packages/steps/src/step.vue"
	/* harmony default export */ var step = (step_component.exports);
	// CONCATENATED MODULE: ./packages/step/index.js
	
	
	/* istanbul ignore next */
	step.install = function (Vue) {
	  Vue.component(step.name, step);
	};
	
	/* harmony default export */ var packages_step = (step);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&
	var mainvue_type_template_id_5d5d1482_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: _vm.carouselClasses,
	      on: {
	        mouseenter: function($event) {
	          $event.stopPropagation()
	          return _vm.handleMouseEnter($event)
	        },
	        mouseleave: function($event) {
	          $event.stopPropagation()
	          return _vm.handleMouseLeave($event)
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          staticClass: "el-carousel__container",
	          style: { height: _vm.height }
	        },
	        [
	          _vm.arrowDisplay
	            ? _c("transition", { attrs: { name: "carousel-arrow-left" } }, [
	                _c(
	                  "button",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value:
	                          (_vm.arrow === "always" || _vm.hover) &&
	                          (_vm.loop || _vm.activeIndex > 0),
	                        expression:
	                          "(arrow === 'always' || hover) && (loop || activeIndex > 0)"
	                      }
	                    ],
	                    staticClass: "el-carousel__arrow el-carousel__arrow--left",
	                    attrs: { type: "button" },
	                    on: {
	                      mouseenter: function($event) {
	                        _vm.handleButtonEnter("left")
	                      },
	                      mouseleave: _vm.handleButtonLeave,
	                      click: function($event) {
	                        $event.stopPropagation()
	                        _vm.throttledArrowClick(_vm.activeIndex - 1)
	                      }
	                    }
	                  },
	                  [_c("i", { staticClass: "el-icon-arrow-left" })]
	                )
	              ])
	            : _vm._e(),
	          _vm.arrowDisplay
	            ? _c("transition", { attrs: { name: "carousel-arrow-right" } }, [
	                _c(
	                  "button",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value:
	                          (_vm.arrow === "always" || _vm.hover) &&
	                          (_vm.loop || _vm.activeIndex < _vm.items.length - 1),
	                        expression:
	                          "(arrow === 'always' || hover) && (loop || activeIndex < items.length - 1)"
	                      }
	                    ],
	                    staticClass: "el-carousel__arrow el-carousel__arrow--right",
	                    attrs: { type: "button" },
	                    on: {
	                      mouseenter: function($event) {
	                        _vm.handleButtonEnter("right")
	                      },
	                      mouseleave: _vm.handleButtonLeave,
	                      click: function($event) {
	                        $event.stopPropagation()
	                        _vm.throttledArrowClick(_vm.activeIndex + 1)
	                      }
	                    }
	                  },
	                  [_c("i", { staticClass: "el-icon-arrow-right" })]
	                )
	              ])
	            : _vm._e(),
	          _vm._t("default")
	        ],
	        2
	      ),
	      _vm.indicatorPosition !== "none"
	        ? _c(
	            "ul",
	            { class: _vm.indicatorsClasses },
	            _vm._l(_vm.items, function(item, index) {
	              return _c(
	                "li",
	                {
	                  key: index,
	                  class: [
	                    "el-carousel__indicator",
	                    "el-carousel__indicator--" + _vm.direction,
	                    { "is-active": index === _vm.activeIndex }
	                  ],
	                  on: {
	                    mouseenter: function($event) {
	                      _vm.throttledIndicatorHover(index)
	                    },
	                    click: function($event) {
	                      $event.stopPropagation()
	                      _vm.handleIndicatorClick(index)
	                    }
	                  }
	                },
	                [
	                  _c("button", { staticClass: "el-carousel__button" }, [
	                    _vm.hasLabel
	                      ? _c("span", [_vm._v(_vm._s(item.label))])
	                      : _vm._e()
	                  ])
	                ]
	              )
	            }),
	            0
	          )
	        : _vm._e()
	    ]
	  )
	}
	var mainvue_type_template_id_5d5d1482_staticRenderFns = []
	mainvue_type_template_id_5d5d1482_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&
	
	// EXTERNAL MODULE: external "throttle-debounce/throttle"
	var throttle_ = __webpack_require__(25);
	var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var carousel_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElCarousel',
	
	  props: {
	    initialIndex: {
	      type: Number,
	      default: 0
	    },
	    height: String,
	    trigger: {
	      type: String,
	      default: 'hover'
	    },
	    autoplay: {
	      type: Boolean,
	      default: true
	    },
	    interval: {
	      type: Number,
	      default: 3000
	    },
	    indicatorPosition: String,
	    indicator: {
	      type: Boolean,
	      default: true
	    },
	    arrow: {
	      type: String,
	      default: 'hover'
	    },
	    type: String,
	    loop: {
	      type: Boolean,
	      default: true
	    },
	    direction: {
	      type: String,
	      default: 'horizontal',
	      validator: function validator(val) {
	        return ['horizontal', 'vertical'].indexOf(val) !== -1;
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      items: [],
	      activeIndex: -1,
	      containerWidth: 0,
	      timer: null,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    arrowDisplay: function arrowDisplay() {
	      return this.arrow !== 'never' && this.direction !== 'vertical';
	    },
	    hasLabel: function hasLabel() {
	      return this.items.some(function (item) {
	        return item.label.toString().length > 0;
	      });
	    },
	    carouselClasses: function carouselClasses() {
	      var classes = ['el-carousel', 'el-carousel--' + this.direction];
	      if (this.type === 'card') {
	        classes.push('el-carousel--card');
	      }
	      return classes;
	    },
	    indicatorsClasses: function indicatorsClasses() {
	      var classes = ['el-carousel__indicators', 'el-carousel__indicators--' + this.direction];
	      if (this.hasLabel) {
	        classes.push('el-carousel__indicators--labels');
	      }
	      if (this.indicatorPosition === 'outside' || this.type === 'card') {
	        classes.push('el-carousel__indicators--outside');
	      }
	      return classes;
	    }
	  },
	
	  watch: {
	    items: function items(val) {
	      if (val.length > 0) this.setActiveItem(this.initialIndex);
	    },
	    activeIndex: function activeIndex(val, oldVal) {
	      this.resetItemPosition(oldVal);
	      if (oldVal > -1) {
	        this.$emit('change', val, oldVal);
	      }
	    },
	    autoplay: function autoplay(val) {
	      val ? this.startTimer() : this.pauseTimer();
	    },
	    loop: function loop() {
	      this.setActiveItem(this.activeIndex);
	    }
	  },
	
	  methods: {
	    handleMouseEnter: function handleMouseEnter() {
	      this.hover = true;
	      this.pauseTimer();
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      this.hover = false;
	      this.startTimer();
	    },
	    itemInStage: function itemInStage(item, index) {
	      var length = this.items.length;
	      if (index === length - 1 && item.inStage && this.items[0].active || item.inStage && this.items[index + 1] && this.items[index + 1].active) {
	        return 'left';
	      } else if (index === 0 && item.inStage && this.items[length - 1].active || item.inStage && this.items[index - 1] && this.items[index - 1].active) {
	        return 'right';
	      }
	      return false;
	    },
	    handleButtonEnter: function handleButtonEnter(arrow) {
	      var _this = this;
	
	      if (this.direction === 'vertical') return;
	      this.items.forEach(function (item, index) {
	        if (arrow === _this.itemInStage(item, index)) {
	          item.hover = true;
	        }
	      });
	    },
	    handleButtonLeave: function handleButtonLeave() {
	      if (this.direction === 'vertical') return;
	      this.items.forEach(function (item) {
	        item.hover = false;
	      });
	    },
	    updateItems: function updateItems() {
	      this.items = this.$children.filter(function (child) {
	        return child.$options.name === 'ElCarouselItem';
	      });
	    },
	    resetItemPosition: function resetItemPosition(oldIndex) {
	      var _this2 = this;
	
	      this.items.forEach(function (item, index) {
	        item.translateItem(index, _this2.activeIndex, oldIndex);
	      });
	    },
	    playSlides: function playSlides() {
	      if (this.activeIndex < this.items.length - 1) {
	        this.activeIndex++;
	      } else if (this.loop) {
	        this.activeIndex = 0;
	      }
	    },
	    pauseTimer: function pauseTimer() {
	      if (this.timer) {
	        clearInterval(this.timer);
	        this.timer = null;
	      }
	    },
	    startTimer: function startTimer() {
	      if (this.interval <= 0 || !this.autoplay || this.timer) return;
	      this.timer = setInterval(this.playSlides, this.interval);
	    },
	    setActiveItem: function setActiveItem(index) {
	      if (typeof index === 'string') {
	        var filteredItems = this.items.filter(function (item) {
	          return item.name === index;
	        });
	        if (filteredItems.length > 0) {
	          index = this.items.indexOf(filteredItems[0]);
	        }
	      }
	      index = Number(index);
	      if (isNaN(index) || index !== Math.floor(index)) {
	        console.warn('[Element Warn][Carousel]index must be an integer.');
	        return;
	      }
	      var length = this.items.length;
	      var oldIndex = this.activeIndex;
	      if (index < 0) {
	        this.activeIndex = this.loop ? length - 1 : 0;
	      } else if (index >= length) {
	        this.activeIndex = this.loop ? 0 : length - 1;
	      } else {
	        this.activeIndex = index;
	      }
	      if (oldIndex === this.activeIndex) {
	        this.resetItemPosition(oldIndex);
	      }
	    },
	    prev: function prev() {
	      this.setActiveItem(this.activeIndex - 1);
	    },
	    next: function next() {
	      this.setActiveItem(this.activeIndex + 1);
	    },
	    handleIndicatorClick: function handleIndicatorClick(index) {
	      this.activeIndex = index;
	    },
	    handleIndicatorHover: function handleIndicatorHover(index) {
	      if (this.trigger === 'hover' && index !== this.activeIndex) {
	        this.activeIndex = index;
	      }
	    }
	  },
	
	  created: function created() {
	    var _this3 = this;
	
	    this.throttledArrowClick = throttle_default()(300, true, function (index) {
	      _this3.setActiveItem(index);
	    });
	    this.throttledIndicatorHover = throttle_default()(300, function (index) {
	      _this3.handleIndicatorHover(index);
	    });
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.updateItems();
	    this.$nextTick(function () {
	      Object(resize_event_["addResizeListener"])(_this4.$el, _this4.resetItemPosition);
	      if (_this4.initialIndex < _this4.items.length && _this4.initialIndex >= 0) {
	        _this4.activeIndex = _this4.initialIndex;
	      }
	      _this4.startTimer();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el) Object(resize_event_["removeResizeListener"])(this.$el, this.resetItemPosition);
	    this.pauseTimer();
	  }
	});
	// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_carousel_src_mainvue_type_script_lang_js_ = (carousel_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/carousel/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var carousel_src_main_component = normalizeComponent(
	  packages_carousel_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5d5d1482_render,
	  mainvue_type_template_id_5d5d1482_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var carousel_src_main_api; }
	carousel_src_main_component.options.__file = "packages/carousel/src/main.vue"
	/* harmony default export */ var carousel_src_main = (carousel_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/carousel/index.js
	
	
	/* istanbul ignore next */
	carousel_src_main.install = function (Vue) {
	  Vue.component(carousel_src_main.name, carousel_src_main);
	};
	
	/* harmony default export */ var carousel = (carousel_src_main);
	// CONCATENATED MODULE: ./packages/scrollbar/src/util.js
	var BAR_MAP = {
	  vertical: {
	    offset: 'offsetHeight',
	    scroll: 'scrollTop',
	    scrollSize: 'scrollHeight',
	    size: 'height',
	    key: 'vertical',
	    axis: 'Y',
	    client: 'clientY',
	    direction: 'top'
	  },
	  horizontal: {
	    offset: 'offsetWidth',
	    scroll: 'scrollLeft',
	    scrollSize: 'scrollWidth',
	    size: 'width',
	    key: 'horizontal',
	    axis: 'X',
	    client: 'clientX',
	    direction: 'left'
	  }
	};
	
	function renderThumbStyle(_ref) {
	  var move = _ref.move,
	      size = _ref.size,
	      bar = _ref.bar;
	
	  var style = {};
	  var translate = 'translate' + bar.axis + '(' + move + '%)';
	
	  style[bar.size] = size;
	  style.transform = translate;
	  style.msTransform = translate;
	  style.webkitTransform = translate;
	
	  return style;
	};
	// CONCATENATED MODULE: ./packages/scrollbar/src/bar.js
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var src_bar = ({
	  name: 'Bar',
	
	  props: {
	    vertical: Boolean,
	    size: String,
	    move: Number
	  },
	
	  computed: {
	    bar: function bar() {
	      return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
	    },
	    wrap: function wrap() {
	      return this.$parent.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var size = this.size,
	        move = this.move,
	        bar = this.bar;
	
	
	    return h(
	      'div',
	      {
	        'class': ['el-scrollbar__bar', 'is-' + bar.key],
	        on: {
	          'mousedown': this.clickTrackHandler
	        }
	      },
	      [h('div', {
	        ref: 'thumb',
	        'class': 'el-scrollbar__thumb',
	        on: {
	          'mousedown': this.clickThumbHandler
	        },
	
	        style: renderThumbStyle({ size: size, move: move, bar: bar }) })]
	    );
	  },
	
	
	  methods: {
	    clickThumbHandler: function clickThumbHandler(e) {
	      // prevent click event of right button
	      if (e.ctrlKey || e.button === 2) {
	        return;
	      }
	      this.startDrag(e);
	      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
	    },
	    clickTrackHandler: function clickTrackHandler(e) {
	      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
	      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
	      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    startDrag: function startDrag(e) {
	      e.stopImmediatePropagation();
	      this.cursorDown = true;
	
	      Object(dom_["on"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      Object(dom_["on"])(document, 'mouseup', this.mouseUpDocumentHandler);
	      document.onselectstart = function () {
	        return false;
	      };
	    },
	    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
	      if (this.cursorDown === false) return;
	      var prevPage = this[this.bar.axis];
	
	      if (!prevPage) return;
	
	      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
	      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
	      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
	      this.cursorDown = false;
	      this[this.bar.axis] = 0;
	      Object(dom_["off"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      document.onselectstart = null;
	    }
	  },
	
	  destroyed: function destroyed() {
	    Object(dom_["off"])(document, 'mouseup', this.mouseUpDocumentHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/src/main.js
	// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js
	
	
	
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var scrollbar_src_main = ({
	  name: 'ElScrollbar',
	
	  components: { Bar: src_bar },
	
	  props: {
	    native: Boolean,
	    wrapStyle: {},
	    wrapClass: {},
	    viewClass: {},
	    viewStyle: {},
	    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
	    tag: {
	      type: String,
	      default: 'div'
	    }
	  },
	
	  data: function data() {
	    return {
	      sizeWidth: '0',
	      sizeHeight: '0',
	      moveX: 0,
	      moveY: 0
	    };
	  },
	
	
	  computed: {
	    wrap: function wrap() {
	      return this.$refs.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var gutter = scrollbar_width_default()();
	    var style = this.wrapStyle;
	
	    if (gutter) {
	      var gutterWith = '-' + gutter + 'px';
	      var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';
	
	      if (Array.isArray(this.wrapStyle)) {
	        style = Object(util_["toObject"])(this.wrapStyle);
	        style.marginRight = style.marginBottom = gutterWith;
	      } else if (typeof this.wrapStyle === 'string') {
	        style += gutterStyle;
	      } else {
	        style = gutterStyle;
	      }
	    }
	    var view = h(this.tag, {
	      class: ['el-scrollbar__view', this.viewClass],
	      style: this.viewStyle,
	      ref: 'resize'
	    }, this.$slots.default);
	    var wrap = h(
	      'div',
	      {
	        ref: 'wrap',
	        style: style,
	        on: {
	          'scroll': this.handleScroll
	        },
	
	        'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] },
	      [[view]]
	    );
	    var nodes = void 0;
	
	    if (!this.native) {
	      nodes = [wrap, h(src_bar, {
	        attrs: {
	          move: this.moveX,
	          size: this.sizeWidth }
	      }), h(src_bar, {
	        attrs: {
	          vertical: true,
	          move: this.moveY,
	          size: this.sizeHeight }
	      })];
	    } else {
	      nodes = [h(
	        'div',
	        {
	          ref: 'wrap',
	          'class': [this.wrapClass, 'el-scrollbar__wrap'],
	          style: style },
	        [[view]]
	      )];
	    }
	    return h('div', { class: 'el-scrollbar' }, nodes);
	  },
	
	
	  methods: {
	    handleScroll: function handleScroll() {
	      var wrap = this.wrap;
	
	      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
	      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
	    },
	    update: function update() {
	      var heightPercentage = void 0,
	          widthPercentage = void 0;
	      var wrap = this.wrap;
	      if (!wrap) return;
	
	      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
	      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;
	
	      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
	      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.native) return;
	    this.$nextTick(this.update);
	    !this.noresize && Object(resize_event_["addResizeListener"])(this.$refs.resize, this.update);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.native) return;
	    !this.noresize && Object(resize_event_["removeResizeListener"])(this.$refs.resize, this.update);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/index.js
	
	
	/* istanbul ignore next */
	scrollbar_src_main.install = function (Vue) {
	  Vue.component(scrollbar_src_main.name, scrollbar_src_main);
	};
	
	/* harmony default export */ var scrollbar = (scrollbar_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&
	var itemvue_type_template_id_1801ae19_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.ready,
	          expression: "ready"
	        }
	      ],
	      staticClass: "el-carousel__item",
	      class: {
	        "is-active": _vm.active,
	        "el-carousel__item--card": _vm.$parent.type === "card",
	        "is-in-stage": _vm.inStage,
	        "is-hover": _vm.hover,
	        "is-animating": _vm.animating
	      },
	      style: _vm.itemStyle,
	      on: { click: _vm.handleItemClick }
	    },
	    [
	      _vm.$parent.type === "card"
	        ? _c("div", {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: !_vm.active,
	                expression: "!active"
	              }
	            ],
	            staticClass: "el-carousel__mask"
	          })
	        : _vm._e(),
	      _vm._t("default")
	    ],
	    2
	  )
	}
	var itemvue_type_template_id_1801ae19_staticRenderFns = []
	itemvue_type_template_id_1801ae19_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	var CARD_SCALE = 0.83;
	/* harmony default export */ var itemvue_type_script_lang_js_ = ({
	  name: 'ElCarouselItem',
	
	  props: {
	    name: String,
	    label: {
	      type: [String, Number],
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      hover: false,
	      translate: 0,
	      scale: 1,
	      active: false,
	      ready: false,
	      inStage: false,
	      animating: false
	    };
	  },
	
	
	  methods: {
	    processIndex: function processIndex(index, activeIndex, length) {
	      if (activeIndex === 0 && index === length - 1) {
	        return -1;
	      } else if (activeIndex === length - 1 && index === 0) {
	        return length;
	      } else if (index < activeIndex - 1 && activeIndex - index >= length / 2) {
	        return length + 1;
	      } else if (index > activeIndex + 1 && index - activeIndex >= length / 2) {
	        return -2;
	      }
	      return index;
	    },
	    calcCardTranslate: function calcCardTranslate(index, activeIndex) {
	      var parentWidth = this.$parent.$el.offsetWidth;
	      if (this.inStage) {
	        return parentWidth * ((2 - CARD_SCALE) * (index - activeIndex) + 1) / 4;
	      } else if (index < activeIndex) {
	        return -(1 + CARD_SCALE) * parentWidth / 4;
	      } else {
	        return (3 + CARD_SCALE) * parentWidth / 4;
	      }
	    },
	    calcTranslate: function calcTranslate(index, activeIndex, isVertical) {
	      var distance = this.$parent.$el[isVertical ? 'offsetHeight' : 'offsetWidth'];
	      return distance * (index - activeIndex);
	    },
	    translateItem: function translateItem(index, activeIndex, oldIndex) {
	      var parentType = this.$parent.type;
	      var parentDirection = this.parentDirection;
	      var length = this.$parent.items.length;
	      if (parentType !== 'card' && oldIndex !== undefined) {
	        this.animating = index === activeIndex || index === oldIndex;
	      }
	      if (index !== activeIndex && length > 2 && this.$parent.loop) {
	        index = this.processIndex(index, activeIndex, length);
	      }
	      if (parentType === 'card') {
	        if (parentDirection === 'vertical') {
	          console.warn('[Element Warn][Carousel]vertical direction is not supported in card mode');
	        }
	        this.inStage = Math.round(Math.abs(index - activeIndex)) <= 1;
	        this.active = index === activeIndex;
	        this.translate = this.calcCardTranslate(index, activeIndex);
	        this.scale = this.active ? 1 : CARD_SCALE;
	      } else {
	        this.active = index === activeIndex;
	        var isVertical = parentDirection === 'vertical';
	        this.translate = this.calcTranslate(index, activeIndex, isVertical);
	      }
	      this.ready = true;
	    },
	    handleItemClick: function handleItemClick() {
	      var parent = this.$parent;
	      if (parent && parent.type === 'card') {
	        var index = parent.items.indexOf(this);
	        parent.setActiveItem(index);
	      }
	    }
	  },
	
	  computed: {
	    parentDirection: function parentDirection() {
	      return this.$parent.direction;
	    },
	    itemStyle: function itemStyle() {
	      var translateType = this.parentDirection === 'vertical' ? 'translateY' : 'translateX';
	      var value = translateType + '(' + this.translate + 'px) scale(' + this.scale + ')';
	      var style = {
	        transform: value
	      };
	      return Object(util_["autoprefixer"])(style);
	    }
	  },
	
	  created: function created() {
	    this.$parent && this.$parent.updateItems();
	  },
	  destroyed: function destroyed() {
	    this.$parent && this.$parent.updateItems();
	  }
	});
	// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_itemvue_type_script_lang_js_ = (itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/carousel/src/item.vue
	
	
	
	
	
	/* normalize component */
	
	var item_component = normalizeComponent(
	  src_itemvue_type_script_lang_js_,
	  itemvue_type_template_id_1801ae19_render,
	  itemvue_type_template_id_1801ae19_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var item_api; }
	item_component.options.__file = "packages/carousel/src/item.vue"
	/* harmony default export */ var src_item = (item_component.exports);
	// CONCATENATED MODULE: ./packages/carousel-item/index.js
	
	
	/* istanbul ignore next */
	src_item.install = function (Vue) {
	  Vue.component(src_item.name, src_item);
	};
	
	/* harmony default export */ var carousel_item = (src_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&
	var collapsevue_type_template_id_461d57f4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-collapse",
	      attrs: { role: "tablist", "aria-multiselectable": "true" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var collapsevue_type_template_id_461d57f4_staticRenderFns = []
	collapsevue_type_template_id_461d57f4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var collapsevue_type_script_lang_js_ = ({
	  name: 'ElCollapse',
	
	  componentName: 'ElCollapse',
	
	  props: {
	    accordion: Boolean,
	    value: {
	      type: [Array, String, Number],
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      activeNames: [].concat(this.value)
	    };
	  },
	  provide: function provide() {
	    return {
	      collapse: this
	    };
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      this.activeNames = [].concat(_value);
	    }
	  },
	
	  methods: {
	    setActiveNames: function setActiveNames(activeNames) {
	      activeNames = [].concat(activeNames);
	      var value = this.accordion ? activeNames[0] : activeNames;
	      this.activeNames = activeNames;
	      this.$emit('input', value);
	      this.$emit('change', value);
	    },
	    handleItemClick: function handleItemClick(item) {
	      if (this.accordion) {
	        this.setActiveNames((this.activeNames[0] || this.activeNames[0] === 0) && this.activeNames[0] === item.name ? '' : item.name);
	      } else {
	        var activeNames = this.activeNames.slice(0);
	        var index = activeNames.indexOf(item.name);
	
	        if (index > -1) {
	          activeNames.splice(index, 1);
	        } else {
	          activeNames.push(item.name);
	        }
	        this.setActiveNames(activeNames);
	      }
	    }
	  },
	
	  created: function created() {
	    this.$on('item-click', this.handleItemClick);
	  }
	});
	// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_collapsevue_type_script_lang_js_ = (collapsevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue
	
	
	
	
	
	/* normalize component */
	
	var collapse_component = normalizeComponent(
	  src_collapsevue_type_script_lang_js_,
	  collapsevue_type_template_id_461d57f4_render,
	  collapsevue_type_template_id_461d57f4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var collapse_api; }
	collapse_component.options.__file = "packages/collapse/src/collapse.vue"
	/* harmony default export */ var collapse = (collapse_component.exports);
	// CONCATENATED MODULE: ./packages/collapse/index.js
	
	
	/* istanbul ignore next */
	collapse.install = function (Vue) {
	  Vue.component(collapse.name, collapse);
	};
	
	/* harmony default export */ var packages_collapse = (collapse);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&
	var collapse_itemvue_type_template_id_2d05faac_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-collapse-item",
	      class: { "is-active": _vm.isActive, "is-disabled": _vm.disabled }
	    },
	    [
	      _c(
	        "div",
	        {
	          attrs: {
	            role: "tab",
	            "aria-expanded": _vm.isActive,
	            "aria-controls": "el-collapse-content-" + _vm.id,
	            "aria-describedby": "el-collapse-content-" + _vm.id
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-collapse-item__header",
	              class: {
	                focusing: _vm.focusing,
	                "is-active": _vm.isActive
	              },
	              attrs: {
	                role: "button",
	                id: "el-collapse-head-" + _vm.id,
	                tabindex: _vm.disabled ? undefined : 0
	              },
	              on: {
	                click: _vm.handleHeaderClick,
	                keyup: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "space", 32, $event.key, [
	                      " ",
	                      "Spacebar"
	                    ]) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  $event.stopPropagation()
	                  return _vm.handleEnterClick($event)
	                },
	                focus: _vm.handleFocus,
	                blur: function($event) {
	                  _vm.focusing = false
	                }
	              }
	            },
	            [
	              _vm._t("title", [_vm._v(_vm._s(_vm.title))]),
	              _c("i", {
	                staticClass: "el-collapse-item__arrow el-icon-arrow-right",
	                class: { "is-active": _vm.isActive }
	              })
	            ],
	            2
	          )
	        ]
	      ),
	      _c("el-collapse-transition", [
	        _c(
	          "div",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.isActive,
	                expression: "isActive"
	              }
	            ],
	            staticClass: "el-collapse-item__wrap",
	            attrs: {
	              role: "tabpanel",
	              "aria-hidden": !_vm.isActive,
	              "aria-labelledby": "el-collapse-head-" + _vm.id,
	              id: "el-collapse-content-" + _vm.id
	            }
	          },
	          [
	            _c(
	              "div",
	              { staticClass: "el-collapse-item__content" },
	              [_vm._t("default")],
	              2
	            )
	          ]
	        )
	      ])
	    ],
	    1
	  )
	}
	var collapse_itemvue_type_template_id_2d05faac_staticRenderFns = []
	collapse_itemvue_type_template_id_2d05faac_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var collapse_itemvue_type_script_lang_js_ = ({
	  name: 'ElCollapseItem',
	
	  componentName: 'ElCollapseItem',
	
	  mixins: [emitter_default.a],
	
	  components: { ElCollapseTransition: collapse_transition_default.a },
	
	  data: function data() {
	    return {
	      contentWrapStyle: {
	        height: 'auto',
	        display: 'block'
	      },
	      contentHeight: 0,
	      focusing: false,
	      isClick: false,
	      id: Object(util_["generateId"])()
	    };
	  },
	
	
	  inject: ['collapse'],
	
	  props: {
	    title: String,
	    name: {
	      type: [String, Number],
	      default: function _default() {
	        return this._uid;
	      }
	    },
	    disabled: Boolean
	  },
	
	  computed: {
	    isActive: function isActive() {
	      return this.collapse.activeNames.indexOf(this.name) > -1;
	    }
	  },
	
	  methods: {
	    handleFocus: function handleFocus() {
	      var _this = this;
	
	      setTimeout(function () {
	        if (!_this.isClick) {
	          _this.focusing = true;
	        } else {
	          _this.isClick = false;
	        }
	      }, 50);
	    },
	    handleHeaderClick: function handleHeaderClick() {
	      if (this.disabled) return;
	      this.dispatch('ElCollapse', 'item-click', this);
	      this.focusing = false;
	      this.isClick = true;
	    },
	    handleEnterClick: function handleEnterClick() {
	      this.dispatch('ElCollapse', 'item-click', this);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_collapse_itemvue_type_script_lang_js_ = (collapse_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue
	
	
	
	
	
	/* normalize component */
	
	var collapse_item_component = normalizeComponent(
	  src_collapse_itemvue_type_script_lang_js_,
	  collapse_itemvue_type_template_id_2d05faac_render,
	  collapse_itemvue_type_template_id_2d05faac_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var collapse_item_api; }
	collapse_item_component.options.__file = "packages/collapse/src/collapse-item.vue"
	/* harmony default export */ var collapse_item = (collapse_item_component.exports);
	// CONCATENATED MODULE: ./packages/collapse-item/index.js
	
	
	/* istanbul ignore next */
	collapse_item.install = function (Vue) {
	  Vue.component(collapse_item.name, collapse_item);
	};
	
	/* harmony default export */ var packages_collapse_item = (collapse_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&
	var cascadervue_type_template_id_032537a6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: function() {
	            return _vm.toggleDropDownVisible(false)
	          },
	          expression: "() => toggleDropDownVisible(false)"
	        }
	      ],
	      ref: "reference",
	      class: [
	        "el-cascader",
	        _vm.realSize && "el-cascader--" + _vm.realSize,
	        { "is-disabled": _vm.isDisabled }
	      ],
	      on: {
	        mouseenter: function($event) {
	          _vm.inputHover = true
	        },
	        mouseleave: function($event) {
	          _vm.inputHover = false
	        },
	        click: function() {
	          return _vm.toggleDropDownVisible(_vm.readonly ? undefined : true)
	        },
	        keydown: _vm.handleKeyDown
	      }
	    },
	    [
	      _c(
	        "el-input",
	        {
	          ref: "input",
	          class: { "is-focus": _vm.dropDownVisible },
	          attrs: {
	            size: _vm.realSize,
	            placeholder: _vm.placeholder,
	            readonly: _vm.readonly,
	            disabled: _vm.isDisabled,
	            "validate-event": false
	          },
	          on: {
	            focus: _vm.handleFocus,
	            blur: _vm.handleBlur,
	            input: _vm.handleInput
	          },
	          model: {
	            value: _vm.multiple ? _vm.presentText : _vm.inputValue,
	            callback: function($$v) {
	              _vm.multiple ? _vm.presentText : (_vm.inputValue = $$v)
	            },
	            expression: "multiple ? presentText : inputValue"
	          }
	        },
	        [
	          _c("template", { slot: "suffix" }, [
	            _vm.clearBtnVisible
	              ? _c("i", {
	                  key: "clear",
	                  staticClass: "el-input__icon el-icon-circle-close",
	                  on: {
	                    click: function($event) {
	                      $event.stopPropagation()
	                      return _vm.handleClear($event)
	                    }
	                  }
	                })
	              : _c("i", {
	                  key: "arrow-down",
	                  class: [
	                    "el-input__icon",
	                    "el-icon-arrow-down",
	                    _vm.dropDownVisible && "is-reverse"
	                  ],
	                  on: {
	                    click: function($event) {
	                      $event.stopPropagation()
	                      _vm.toggleDropDownVisible()
	                    }
	                  }
	                })
	          ])
	        ],
	        2
	      ),
	      _vm.multiple
	        ? _c(
	            "div",
	            { staticClass: "el-cascader__tags" },
	            [
	              _vm._l(_vm.presentTags, function(tag, index) {
	                return _c(
	                  "el-tag",
	                  {
	                    key: tag.key,
	                    attrs: {
	                      type: "info",
	                      size: _vm.tagSize,
	                      hit: tag.hitState,
	                      closable: tag.closable,
	                      "disable-transitions": ""
	                    },
	                    on: {
	                      close: function($event) {
	                        _vm.deleteTag(index)
	                      }
	                    }
	                  },
	                  [_c("span", [_vm._v(_vm._s(tag.text))])]
	                )
	              }),
	              _vm.filterable && !_vm.isDisabled
	                ? _c("input", {
	                    directives: [
	                      {
	                        name: "model",
	                        rawName: "v-model.trim",
	                        value: _vm.inputValue,
	                        expression: "inputValue",
	                        modifiers: { trim: true }
	                      }
	                    ],
	                    staticClass: "el-cascader__search-input",
	                    attrs: {
	                      type: "text",
	                      placeholder: _vm.presentTags.length ? "" : _vm.placeholder
	                    },
	                    domProps: { value: _vm.inputValue },
	                    on: {
	                      input: [
	                        function($event) {
	                          if ($event.target.composing) {
	                            return
	                          }
	                          _vm.inputValue = $event.target.value.trim()
	                        },
	                        function(e) {
	                          return _vm.handleInput(_vm.inputValue, e)
	                        }
	                      ],
	                      click: function($event) {
	                        $event.stopPropagation()
	                        _vm.toggleDropDownVisible(true)
	                      },
	                      keydown: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "delete",
	                            [8, 46],
	                            $event.key,
	                            ["Backspace", "Delete", "Del"]
	                          )
	                        ) {
	                          return null
	                        }
	                        return _vm.handleDelete($event)
	                      },
	                      blur: function($event) {
	                        _vm.$forceUpdate()
	                      }
	                    }
	                  })
	                : _vm._e()
	            ],
	            2
	          )
	        : _vm._e(),
	      _c(
	        "transition",
	        {
	          attrs: { name: "el-zoom-in-top" },
	          on: { "after-leave": _vm.handleDropdownLeave }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.dropDownVisible,
	                  expression: "dropDownVisible"
	                }
	              ],
	              ref: "popper",
	              class: ["el-popper", "el-cascader__dropdown", _vm.popperClass]
	            },
	            [
	              _c("el-cascader-panel", {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: !_vm.filtering,
	                    expression: "!filtering"
	                  }
	                ],
	                ref: "panel",
	                attrs: {
	                  options: _vm.options,
	                  props: _vm.config,
	                  border: false,
	                  "render-label": _vm.$scopedSlots.default
	                },
	                on: {
	                  "expand-change": _vm.handleExpandChange,
	                  close: function($event) {
	                    _vm.toggleDropDownVisible(false)
	                  }
	                },
	                model: {
	                  value: _vm.checkedValue,
	                  callback: function($$v) {
	                    _vm.checkedValue = $$v
	                  },
	                  expression: "checkedValue"
	                }
	              }),
	              _vm.filterable
	                ? _c(
	                    "el-scrollbar",
	                    {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.filtering,
	                          expression: "filtering"
	                        }
	                      ],
	                      ref: "suggestionPanel",
	                      staticClass: "el-cascader__suggestion-panel",
	                      attrs: {
	                        tag: "ul",
	                        "view-class": "el-cascader__suggestion-list"
	                      },
	                      nativeOn: {
	                        keydown: function($event) {
	                          return _vm.handleSuggestionKeyDown($event)
	                        }
	                      }
	                    },
	                    [
	                      _vm.suggestions.length
	                        ? _vm._l(_vm.suggestions, function(item, index) {
	                            return _c(
	                              "li",
	                              {
	                                key: item.uid,
	                                class: [
	                                  "el-cascader__suggestion-item",
	                                  item.checked && "is-checked"
	                                ],
	                                attrs: { tabindex: -1 },
	                                on: {
	                                  click: function($event) {
	                                    _vm.handleSuggestionClick(index)
	                                  }
	                                }
	                              },
	                              [
	                                _c("span", [_vm._v(_vm._s(item.text))]),
	                                item.checked
	                                  ? _c("i", { staticClass: "el-icon-check" })
	                                  : _vm._e()
	                              ]
	                            )
	                          })
	                        : _vm._t("empty", [
	                            _c(
	                              "li",
	                              { staticClass: "el-cascader__empty-text" },
	                              [_vm._v(_vm._s(_vm.t("el.cascader.noMatch")))]
	                            )
	                          ])
	                    ],
	                    2
	                  )
	                : _vm._e()
	            ],
	            1
	          )
	        ]
	      )
	    ],
	    1
	  )
	}
	var cascadervue_type_template_id_032537a6_staticRenderFns = []
	cascadervue_type_template_id_032537a6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&
	
	// EXTERNAL MODULE: external "element-ui/lib/cascader-panel"
	var cascader_panel_ = __webpack_require__(42);
	var cascader_panel_default = /*#__PURE__*/__webpack_require__.n(cascader_panel_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
	var aria_utils_ = __webpack_require__(34);
	var aria_utils_default = /*#__PURE__*/__webpack_require__.n(aria_utils_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var KeyCode = aria_utils_default.a.keys;
	
	var MigratingProps = {
	  expandTrigger: {
	    newProp: 'expandTrigger',
	    type: String
	  },
	  changeOnSelect: {
	    newProp: 'checkStrictly',
	    type: Boolean
	  },
	  hoverThreshold: {
	    newProp: 'hoverThreshold',
	    type: Number
	  }
	};
	
	var PopperMixin = {
	  props: {
	    placement: {
	      type: String,
	      default: 'bottom-start'
	    },
	    appendToBody: vue_popper_default.a.props.appendToBody,
	    visibleArrow: {
	      type: Boolean,
	      default: true
	    },
	    arrowOffset: vue_popper_default.a.props.arrowOffset,
	    offset: vue_popper_default.a.props.offset,
	    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
	    popperOptions: vue_popper_default.a.props.popperOptions
	  },
	  methods: vue_popper_default.a.methods,
	  data: vue_popper_default.a.data,
	  beforeDestroy: vue_popper_default.a.beforeDestroy
	};
	
	var InputSizeMap = {
	  medium: 36,
	  small: 32,
	  mini: 28
	};
	
	/* harmony default export */ var cascadervue_type_script_lang_js_ = ({
	  name: 'ElCascader',
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  mixins: [PopperMixin, emitter_default.a, locale_default.a, migrating_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElTag: tag_default.a,
	    ElScrollbar: scrollbar_default.a,
	    ElCascaderPanel: cascader_panel_default.a
	  },
	
	  props: {
	    value: {},
	    options: Array,
	    props: Object,
	    size: String,
	    placeholder: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.cascader.placeholder');
	      }
	    },
	    disabled: Boolean,
	    clearable: Boolean,
	    filterable: Boolean,
	    filterMethod: Function,
	    separator: {
	      type: String,
	      default: ' / '
	    },
	    showAllLevels: {
	      type: Boolean,
	      default: true
	    },
	    collapseTags: Boolean,
	    debounce: {
	      type: Number,
	      default: 300
	    },
	    beforeFilter: {
	      type: Function,
	      default: function _default() {
	        return function () {};
	      }
	    },
	    popperClass: String
	  },
	
	  data: function data() {
	    return {
	      dropDownVisible: false,
	      checkedValue: this.value || null,
	      inputHover: false,
	      inputValue: null,
	      presentText: null,
	      presentTags: [],
	      checkedNodes: [],
	      filtering: false,
	      suggestions: [],
	      inputInitialHeight: 0,
	      pressDeleteCount: 0
	    };
	  },
	
	
	  computed: {
	    realSize: function realSize() {
	      var _elFormItemSize = (this.elFormItem || {}).elFormItemSize;
	      return this.size || _elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    tagSize: function tagSize() {
	      return ['small', 'mini'].indexOf(this.realSize) > -1 ? 'mini' : 'small';
	    },
	    isDisabled: function isDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    config: function config() {
	      var config = this.props || {};
	      var $attrs = this.$attrs;
	
	
	      Object.keys(MigratingProps).forEach(function (oldProp) {
	        var _MigratingProps$oldPr = MigratingProps[oldProp],
	            newProp = _MigratingProps$oldPr.newProp,
	            type = _MigratingProps$oldPr.type;
	
	        var oldValue = $attrs[oldProp] || $attrs[Object(util_["kebabCase"])(oldProp)];
	        if (Object(shared_["isDef"])(oldProp) && !Object(shared_["isDef"])(config[newProp])) {
	          if (type === Boolean && oldValue === '') {
	            oldValue = true;
	          }
	          config[newProp] = oldValue;
	        }
	      });
	
	      return config;
	    },
	    multiple: function multiple() {
	      return this.config.multiple;
	    },
	    leafOnly: function leafOnly() {
	      return !this.config.checkStrictly;
	    },
	    readonly: function readonly() {
	      return !this.filterable || this.multiple;
	    },
	    clearBtnVisible: function clearBtnVisible() {
	      if (!this.clearable || this.isDisabled || this.filtering || !this.inputHover) {
	        return false;
	      }
	
	      return this.multiple ? !!this.checkedNodes.filter(function (node) {
	        return !node.isDisabled;
	      }).length : !!this.presentText;
	    },
	    panel: function panel() {
	      return this.$refs.panel;
	    }
	  },
	
	  watch: {
	    disabled: function disabled() {
	      this.computePresentContent();
	    },
	    value: function value(val) {
	      if (!Object(util_["isEqual"])(val, this.checkedValue)) {
	        this.checkedValue = val;
	        this.computePresentContent();
	      }
	    },
	    checkedValue: function checkedValue(val) {
	      var value = this.value,
	          dropDownVisible = this.dropDownVisible;
	      var _config = this.config,
	          checkStrictly = _config.checkStrictly,
	          multiple = _config.multiple;
	
	
	      if (!Object(util_["isEqual"])(val, value) || Object(types_["isUndefined"])(value)) {
	        this.computePresentContent();
	        // hide dropdown when single mode
	        if (!multiple && !checkStrictly && dropDownVisible) {
	          this.toggleDropDownVisible(false);
	        }
	
	        this.$emit('input', val);
	        this.$emit('change', val);
	        this.dispatch('ElFormItem', 'el.form.change', [val]);
	      }
	    },
	
	    options: {
	      handler: function handler() {
	        this.$nextTick(this.computePresentContent);
	      },
	      deep: true
	    },
	    presentText: function presentText(val) {
	      this.inputValue = val;
	    },
	    presentTags: function presentTags(val, oldVal) {
	      if (this.multiple && (val.length || oldVal.length)) {
	        this.$nextTick(this.updateStyle);
	      }
	    },
	    filtering: function filtering(val) {
	      this.$nextTick(this.updatePopper);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var input = this.$refs.input;
	
	    if (input && input.$el) {
	      this.inputInitialHeight = input.$el.offsetHeight || InputSizeMap[this.realSize] || 40;
	    }
	
	    if (!Object(util_["isEmpty"])(this.value)) {
	      this.computePresentContent();
	    }
	
	    this.filterHandler = debounce_default()(this.debounce, function () {
	      var inputValue = _this.inputValue;
	
	
	      if (!inputValue) {
	        _this.filtering = false;
	        return;
	      }
	
	      var before = _this.beforeFilter(inputValue);
	      if (before && before.then) {
	        before.then(_this.getSuggestions);
	      } else if (before !== false) {
	        _this.getSuggestions();
	      } else {
	        _this.filtering = false;
	      }
	    });
	
	    Object(resize_event_["addResizeListener"])(this.$el, this.updateStyle);
	  },
	  beforeDestroy: function beforeDestroy() {
	    Object(resize_event_["removeResizeListener"])(this.$el, this.updateStyle);
	  },
	
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'expand-trigger': 'expand-trigger is removed, use `props.expandTrigger` instead.',
	          'change-on-select': 'change-on-select is removed, use `props.checkStrictly` instead.',
	          'hover-threshold': 'hover-threshold is removed, use `props.hoverThreshold` instead'
	        },
	        events: {
	          'active-item-change': 'active-item-change is renamed to expand-change'
	        }
	      };
	    },
	    toggleDropDownVisible: function toggleDropDownVisible(visible) {
	      var _this2 = this;
	
	      if (this.isDisabled) return;
	
	      var dropDownVisible = this.dropDownVisible;
	      var input = this.$refs.input;
	
	      visible = Object(shared_["isDef"])(visible) ? visible : !dropDownVisible;
	      if (visible !== dropDownVisible) {
	        this.dropDownVisible = visible;
	        if (visible) {
	          this.$nextTick(function () {
	            _this2.updatePopper();
	            _this2.panel.scrollIntoView();
	          });
	        }
	        input.$refs.input.setAttribute('aria-expanded', visible);
	        this.$emit('visible-change', visible);
	      }
	    },
	    handleDropdownLeave: function handleDropdownLeave() {
	      this.filtering = false;
	      this.inputValue = this.presentText;
	    },
	    handleKeyDown: function handleKeyDown(event) {
	      switch (event.keyCode) {
	        case KeyCode.enter:
	          this.toggleDropDownVisible();
	          break;
	        case KeyCode.down:
	          this.toggleDropDownVisible(true);
	          this.focusFirstNode();
	          event.preventDefault();
	          break;
	        case KeyCode.esc:
	        case KeyCode.tab:
	          this.toggleDropDownVisible(false);
	          break;
	      }
	    },
	    handleFocus: function handleFocus(e) {
	      this.$emit('focus', e);
	    },
	    handleBlur: function handleBlur(e) {
	      this.$emit('blur', e);
	    },
	    handleInput: function handleInput(val, event) {
	      !this.dropDownVisible && this.toggleDropDownVisible(true);
	
	      if (event && event.isComposing) return;
	      if (val) {
	        this.filterHandler();
	      } else {
	        this.filtering = false;
	      }
	    },
	    handleClear: function handleClear() {
	      this.presentText = '';
	      this.panel.clearCheckedNodes();
	    },
	    handleExpandChange: function handleExpandChange(value) {
	      this.$nextTick(this.updatePopper.bind(this));
	      this.$emit('expand-change', value);
	      this.$emit('active-item-change', value); // Deprecated
	    },
	    focusFirstNode: function focusFirstNode() {
	      var _this3 = this;
	
	      this.$nextTick(function () {
	        var filtering = _this3.filtering;
	        var _$refs = _this3.$refs,
	            popper = _$refs.popper,
	            suggestionPanel = _$refs.suggestionPanel;
	
	        var firstNode = null;
	
	        if (filtering && suggestionPanel) {
	          firstNode = suggestionPanel.$el.querySelector('.el-cascader__suggestion-item');
	        } else {
	          var firstMenu = popper.querySelector('.el-cascader-menu');
	          firstNode = firstMenu.querySelector('.el-cascader-node[tabindex="-1"]');
	        }
	
	        if (firstNode) {
	          firstNode.focus();
	          !filtering && firstNode.click();
	        }
	      });
	    },
	    computePresentContent: function computePresentContent() {
	      var _this4 = this;
	
	      // nextTick is required, because checked nodes may not change right now
	      this.$nextTick(function () {
	        if (_this4.config.multiple) {
	          _this4.computePresentTags();
	          _this4.presentText = _this4.presentTags.length ? ' ' : null;
	        } else {
	          _this4.computePresentText();
	        }
	      });
	    },
	    computePresentText: function computePresentText() {
	      var checkedValue = this.checkedValue,
	          config = this.config;
	
	      if (!Object(util_["isEmpty"])(checkedValue)) {
	        var node = this.panel.getNodeByValue(checkedValue);
	        if (node && (config.checkStrictly || node.isLeaf)) {
	          this.presentText = node.getText(this.showAllLevels, this.separator);
	          return;
	        }
	      }
	      this.presentText = null;
	    },
	    computePresentTags: function computePresentTags() {
	      var isDisabled = this.isDisabled,
	          leafOnly = this.leafOnly,
	          showAllLevels = this.showAllLevels,
	          separator = this.separator,
	          collapseTags = this.collapseTags;
	
	      var checkedNodes = this.getCheckedNodes(leafOnly);
	      var tags = [];
	
	      var genTag = function genTag(node) {
	        return {
	          node: node,
	          key: node.uid,
	          text: node.getText(showAllLevels, separator),
	          hitState: false,
	          closable: !isDisabled && !node.isDisabled
	        };
	      };
	
	      if (checkedNodes.length) {
	        var first = checkedNodes[0],
	            rest = checkedNodes.slice(1);
	
	        var restCount = rest.length;
	        tags.push(genTag(first));
	
	        if (restCount) {
	          if (collapseTags) {
	            tags.push({
	              key: -1,
	              text: '+ ' + restCount,
	              closable: false
	            });
	          } else {
	            rest.forEach(function (node) {
	              return tags.push(genTag(node));
	            });
	          }
	        }
	      }
	
	      this.checkedNodes = checkedNodes;
	      this.presentTags = tags;
	    },
	    getSuggestions: function getSuggestions() {
	      var _this5 = this;
	
	      var filterMethod = this.filterMethod;
	
	
	      if (!Object(types_["isFunction"])(filterMethod)) {
	        filterMethod = function filterMethod(node, keyword) {
	          return node.text.includes(keyword);
	        };
	      }
	
	      var suggestions = this.panel.getFlattedNodes(this.leafOnly).filter(function (node) {
	        if (node.isDisabled) return false;
	        node.text = node.getText(_this5.showAllLevels, _this5.separator) || '';
	        return filterMethod(node, _this5.inputValue);
	      });
	
	      if (this.multiple) {
	        this.presentTags.forEach(function (tag) {
	          tag.hitState = false;
	        });
	      } else {
	        suggestions.forEach(function (node) {
	          node.checked = Object(util_["isEqual"])(_this5.checkedValue, node.getValueByOption());
	        });
	      }
	
	      this.filtering = true;
	      this.suggestions = suggestions;
	      this.$nextTick(this.updatePopper);
	    },
	    handleSuggestionKeyDown: function handleSuggestionKeyDown(event) {
	      var keyCode = event.keyCode,
	          target = event.target;
	
	      switch (keyCode) {
	        case KeyCode.enter:
	          target.click();
	          break;
	        case KeyCode.up:
	          var prev = target.previousElementSibling;
	          prev && prev.focus();
	          break;
	        case KeyCode.down:
	          var next = target.nextElementSibling;
	          next && next.focus();
	          break;
	        case KeyCode.esc:
	        case KeyCode.tab:
	          this.toggleDropDownVisible(false);
	          break;
	      }
	    },
	    handleDelete: function handleDelete() {
	      var inputValue = this.inputValue,
	          pressDeleteCount = this.pressDeleteCount,
	          presentTags = this.presentTags;
	
	      var lastIndex = presentTags.length - 1;
	      var lastTag = presentTags[lastIndex];
	      this.pressDeleteCount = inputValue ? 0 : pressDeleteCount + 1;
	
	      if (!lastTag) return;
	
	      if (this.pressDeleteCount) {
	        if (lastTag.hitState) {
	          this.deleteTag(lastIndex);
	        } else {
	          lastTag.hitState = true;
	        }
	      }
	    },
	    handleSuggestionClick: function handleSuggestionClick(index) {
	      var multiple = this.multiple;
	
	      var targetNode = this.suggestions[index];
	
	      if (multiple) {
	        var checked = targetNode.checked;
	
	        targetNode.doCheck(!checked);
	        this.panel.calculateMultiCheckedValue();
	      } else {
	        this.checkedValue = targetNode.getValueByOption();
	        this.toggleDropDownVisible(false);
	      }
	    },
	    deleteTag: function deleteTag(index) {
	      var checkedValue = this.checkedValue;
	
	      var val = checkedValue[index];
	      this.checkedValue = checkedValue.filter(function (n, i) {
	        return i !== index;
	      });
	      this.$emit('remove-tag', val);
	    },
	    updateStyle: function updateStyle() {
	      var $el = this.$el,
	          inputInitialHeight = this.inputInitialHeight;
	
	      if (this.$isServer || !$el) return;
	
	      var suggestionPanel = this.$refs.suggestionPanel;
	
	      var inputInner = $el.querySelector('.el-input__inner');
	
	      if (!inputInner) return;
	
	      var tags = $el.querySelector('.el-cascader__tags');
	      var suggestionPanelEl = null;
	
	      if (suggestionPanel && (suggestionPanelEl = suggestionPanel.$el)) {
	        var suggestionList = suggestionPanelEl.querySelector('.el-cascader__suggestion-list');
	        suggestionList.style.minWidth = inputInner.offsetWidth + 'px';
	      }
	
	      if (tags) {
	        var offsetHeight = tags.offsetHeight;
	
	        var height = Math.max(offsetHeight + 6, inputInitialHeight) + 'px';
	        inputInner.style.height = height;
	        this.updatePopper();
	      }
	    },
	
	
	    /**
	     * public methods
	    */
	    getCheckedNodes: function getCheckedNodes(leafOnly) {
	      return this.panel.getCheckedNodes(leafOnly);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascadervue_type_script_lang_js_ = (cascadervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue
	
	
	
	
	
	/* normalize component */
	
	var cascader_component = normalizeComponent(
	  src_cascadervue_type_script_lang_js_,
	  cascadervue_type_template_id_032537a6_render,
	  cascadervue_type_template_id_032537a6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_api; }
	cascader_component.options.__file = "packages/cascader/src/cascader.vue"
	/* harmony default export */ var cascader = (cascader_component.exports);
	// CONCATENATED MODULE: ./packages/cascader/index.js
	
	
	/* istanbul ignore next */
	cascader.install = function (Vue) {
	  Vue.component(cascader.name, cascader);
	};
	
	/* harmony default export */ var packages_cascader = (cascader);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&
	var mainvue_type_template_id_55c8ade7_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.hide,
	          expression: "hide"
	        }
	      ],
	      class: [
	        "el-color-picker",
	        _vm.colorDisabled ? "is-disabled" : "",
	        _vm.colorSize ? "el-color-picker--" + _vm.colorSize : ""
	      ]
	    },
	    [
	      _vm.colorDisabled
	        ? _c("div", { staticClass: "el-color-picker__mask" })
	        : _vm._e(),
	      _c(
	        "div",
	        {
	          staticClass: "el-color-picker__trigger",
	          on: { click: _vm.handleTrigger }
	        },
	        [
	          _c(
	            "span",
	            {
	              staticClass: "el-color-picker__color",
	              class: { "is-alpha": _vm.showAlpha }
	            },
	            [
	              _c("span", {
	                staticClass: "el-color-picker__color-inner",
	                style: {
	                  backgroundColor: _vm.displayedColor
	                }
	              }),
	              !_vm.value && !_vm.showPanelColor
	                ? _c("span", {
	                    staticClass: "el-color-picker__empty el-icon-close"
	                  })
	                : _vm._e()
	            ]
	          ),
	          _c("span", {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.value || _vm.showPanelColor,
	                expression: "value || showPanelColor"
	              }
	            ],
	            staticClass: "el-color-picker__icon el-icon-arrow-down"
	          })
	        ]
	      ),
	      _c("picker-dropdown", {
	        ref: "dropdown",
	        class: ["el-color-picker__panel", _vm.popperClass || ""],
	        attrs: {
	          color: _vm.color,
	          "show-alpha": _vm.showAlpha,
	          predefine: _vm.predefine
	        },
	        on: { pick: _vm.confirmValue, clear: _vm.clearValue },
	        model: {
	          value: _vm.showPicker,
	          callback: function($$v) {
	            _vm.showPicker = $$v
	          },
	          expression: "showPicker"
	        }
	      })
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_55c8ade7_staticRenderFns = []
	mainvue_type_template_id_55c8ade7_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&
	
	// CONCATENATED MODULE: ./packages/color-picker/src/color.js
	var color_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function color_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var hsv2hsl = function hsv2hsl(hue, sat, val) {
	  return [hue, sat * val / ((hue = (2 - sat) * val) < 1 ? hue : 2 - hue) || 0, hue / 2];
	};
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	var isOnePointZero = function isOnePointZero(n) {
	  return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
	};
	
	var isPercentage = function isPercentage(n) {
	  return typeof n === 'string' && n.indexOf('%') !== -1;
	};
	
	// Take input from [0, n] and return it as [0, 1]
	var bound01 = function bound01(value, max) {
	  if (isOnePointZero(value)) value = '100%';
	
	  var processPercent = isPercentage(value);
	  value = Math.min(max, Math.max(0, parseFloat(value)));
	
	  // Automatically convert percentage into number
	  if (processPercent) {
	    value = parseInt(value * max, 10) / 100;
	  }
	
	  // Handle floating point rounding errors
	  if (Math.abs(value - max) < 0.000001) {
	    return 1;
	  }
	
	  // Convert into [0, 1] range if it isn't already
	  return value % max / parseFloat(max);
	};
	
	var INT_HEX_MAP = { 10: 'A', 11: 'B', 12: 'C', 13: 'D', 14: 'E', 15: 'F' };
	
	var toHex = function toHex(_ref) {
	  var r = _ref.r,
	      g = _ref.g,
	      b = _ref.b;
	
	  var hexOne = function hexOne(value) {
	    value = Math.min(Math.round(value), 255);
	    var high = Math.floor(value / 16);
	    var low = value % 16;
	    return '' + (INT_HEX_MAP[high] || high) + (INT_HEX_MAP[low] || low);
	  };
	
	  if (isNaN(r) || isNaN(g) || isNaN(b)) return '';
	
	  return '#' + hexOne(r) + hexOne(g) + hexOne(b);
	};
	
	var HEX_INT_MAP = { A: 10, B: 11, C: 12, D: 13, E: 14, F: 15 };
	
	var parseHexChannel = function parseHexChannel(hex) {
	  if (hex.length === 2) {
	    return (HEX_INT_MAP[hex[0].toUpperCase()] || +hex[0]) * 16 + (HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1]);
	  }
	
	  return HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1];
	};
	
	var hsl2hsv = function hsl2hsv(hue, sat, light) {
	  sat = sat / 100;
	  light = light / 100;
	  var smin = sat;
	  var lmin = Math.max(light, 0.01);
	  var sv = void 0;
	  var v = void 0;
	
	  light *= 2;
	  sat *= light <= 1 ? light : 2 - light;
	  smin *= lmin <= 1 ? lmin : 2 - lmin;
	  v = (light + sat) / 2;
	  sv = light === 0 ? 2 * smin / (lmin + smin) : 2 * sat / (light + sat);
	
	  return {
	    h: hue,
	    s: sv * 100,
	    v: v * 100
	  };
	};
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	var rgb2hsv = function rgb2hsv(r, g, b) {
	  r = bound01(r, 255);
	  g = bound01(g, 255);
	  b = bound01(b, 255);
	
	  var max = Math.max(r, g, b);
	  var min = Math.min(r, g, b);
	  var h = void 0,
	      s = void 0;
	  var v = max;
	
	  var d = max - min;
	  s = max === 0 ? 0 : d / max;
	
	  if (max === min) {
	    h = 0; // achromatic
	  } else {
	    switch (max) {
	      case r:
	        h = (g - b) / d + (g < b ? 6 : 0);
	        break;
	      case g:
	        h = (b - r) / d + 2;
	        break;
	      case b:
	        h = (r - g) / d + 4;
	        break;
	    }
	    h /= 6;
	  }
	
	  return { h: h * 360, s: s * 100, v: v * 100 };
	};
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	var hsv2rgb = function hsv2rgb(h, s, v) {
	  h = bound01(h, 360) * 6;
	  s = bound01(s, 100);
	  v = bound01(v, 100);
	
	  var i = Math.floor(h);
	  var f = h - i;
	  var p = v * (1 - s);
	  var q = v * (1 - f * s);
	  var t = v * (1 - (1 - f) * s);
	  var mod = i % 6;
	  var r = [v, q, p, p, t, v][mod];
	  var g = [t, v, v, q, p, p][mod];
	  var b = [p, p, t, v, v, q][mod];
	
	  return {
	    r: Math.round(r * 255),
	    g: Math.round(g * 255),
	    b: Math.round(b * 255)
	  };
	};
	
	var Color = function () {
	  function Color(options) {
	    color_classCallCheck(this, Color);
	
	    this._hue = 0;
	    this._saturation = 100;
	    this._value = 100;
	    this._alpha = 100;
	
	    this.enableAlpha = false;
	    this.format = 'hex';
	    this.value = '';
	
	    options = options || {};
	
	    for (var option in options) {
	      if (options.hasOwnProperty(option)) {
	        this[option] = options[option];
	      }
	    }
	
	    this.doOnChange();
	  }
	
	  Color.prototype.set = function set(prop, value) {
	    if (arguments.length === 1 && (typeof prop === 'undefined' ? 'undefined' : color_typeof(prop)) === 'object') {
	      for (var p in prop) {
	        if (prop.hasOwnProperty(p)) {
	          this.set(p, prop[p]);
	        }
	      }
	
	      return;
	    }
	
	    this['_' + prop] = value;
	    this.doOnChange();
	  };
	
	  Color.prototype.get = function get(prop) {
	    return this['_' + prop];
	  };
	
	  Color.prototype.toRgb = function toRgb() {
	    return hsv2rgb(this._hue, this._saturation, this._value);
	  };
	
	  Color.prototype.fromString = function fromString(value) {
	    var _this = this;
	
	    if (!value) {
	      this._hue = 0;
	      this._saturation = 100;
	      this._value = 100;
	
	      this.doOnChange();
	      return;
	    }
	
	    var fromHSV = function fromHSV(h, s, v) {
	      _this._hue = Math.max(0, Math.min(360, h));
	      _this._saturation = Math.max(0, Math.min(100, s));
	      _this._value = Math.max(0, Math.min(100, v));
	
	      _this.doOnChange();
	    };
	
	    if (value.indexOf('hsl') !== -1) {
	      var parts = value.replace(/hsla|hsl|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
	        return val !== '';
	      }).map(function (val, index) {
	        return index > 2 ? parseFloat(val) : parseInt(val, 10);
	      });
	
	      if (parts.length === 4) {
	        this._alpha = Math.floor(parseFloat(parts[3]) * 100);
	      } else if (parts.length === 3) {
	        this._alpha = 100;
	      }
	      if (parts.length >= 3) {
	        var _hsl2hsv = hsl2hsv(parts[0], parts[1], parts[2]),
	            h = _hsl2hsv.h,
	            s = _hsl2hsv.s,
	            v = _hsl2hsv.v;
	
	        fromHSV(h, s, v);
	      }
	    } else if (value.indexOf('hsv') !== -1) {
	      var _parts = value.replace(/hsva|hsv|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
	        return val !== '';
	      }).map(function (val, index) {
	        return index > 2 ? parseFloat(val) : parseInt(val, 10);
	      });
	
	      if (_parts.length === 4) {
	        this._alpha = Math.floor(parseFloat(_parts[3]) * 100);
	      } else if (_parts.length === 3) {
	        this._alpha = 100;
	      }
	      if (_parts.length >= 3) {
	        fromHSV(_parts[0], _parts[1], _parts[2]);
	      }
	    } else if (value.indexOf('rgb') !== -1) {
	      var _parts2 = value.replace(/rgba|rgb|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
	        return val !== '';
	      }).map(function (val, index) {
	        return index > 2 ? parseFloat(val) : parseInt(val, 10);
	      });
	
	      if (_parts2.length === 4) {
	        this._alpha = Math.floor(parseFloat(_parts2[3]) * 100);
	      } else if (_parts2.length === 3) {
	        this._alpha = 100;
	      }
	      if (_parts2.length >= 3) {
	        var _rgb2hsv = rgb2hsv(_parts2[0], _parts2[1], _parts2[2]),
	            _h = _rgb2hsv.h,
	            _s = _rgb2hsv.s,
	            _v = _rgb2hsv.v;
	
	        fromHSV(_h, _s, _v);
	      }
	    } else if (value.indexOf('#') !== -1) {
	      var hex = value.replace('#', '').trim();
	      if (!/^(?:[0-9a-fA-F]{3}){1,2}$/.test(hex)) return;
	      var r = void 0,
	          g = void 0,
	          b = void 0;
	
	      if (hex.length === 3) {
	        r = parseHexChannel(hex[0] + hex[0]);
	        g = parseHexChannel(hex[1] + hex[1]);
	        b = parseHexChannel(hex[2] + hex[2]);
	      } else if (hex.length === 6 || hex.length === 8) {
	        r = parseHexChannel(hex.substring(0, 2));
	        g = parseHexChannel(hex.substring(2, 4));
	        b = parseHexChannel(hex.substring(4, 6));
	      }
	
	      if (hex.length === 8) {
	        this._alpha = Math.floor(parseHexChannel(hex.substring(6)) / 255 * 100);
	      } else if (hex.length === 3 || hex.length === 6) {
	        this._alpha = 100;
	      }
	
	      var _rgb2hsv2 = rgb2hsv(r, g, b),
	          _h2 = _rgb2hsv2.h,
	          _s2 = _rgb2hsv2.s,
	          _v2 = _rgb2hsv2.v;
	
	      fromHSV(_h2, _s2, _v2);
	    }
	  };
	
	  Color.prototype.compare = function compare(color) {
	    return Math.abs(color._hue - this._hue) < 2 && Math.abs(color._saturation - this._saturation) < 1 && Math.abs(color._value - this._value) < 1 && Math.abs(color._alpha - this._alpha) < 1;
	  };
	
	  Color.prototype.doOnChange = function doOnChange() {
	    var _hue = this._hue,
	        _saturation = this._saturation,
	        _value = this._value,
	        _alpha = this._alpha,
	        format = this.format;
	
	
	    if (this.enableAlpha) {
	      switch (format) {
	        case 'hsl':
	          var hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);
	          this.value = 'hsla(' + _hue + ', ' + Math.round(hsl[1] * 100) + '%, ' + Math.round(hsl[2] * 100) + '%, ' + _alpha / 100 + ')';
	          break;
	        case 'hsv':
	          this.value = 'hsva(' + _hue + ', ' + Math.round(_saturation) + '%, ' + Math.round(_value) + '%, ' + _alpha / 100 + ')';
	          break;
	        default:
	          var _hsv2rgb = hsv2rgb(_hue, _saturation, _value),
	              r = _hsv2rgb.r,
	              g = _hsv2rgb.g,
	              b = _hsv2rgb.b;
	
	          this.value = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + _alpha / 100 + ')';
	      }
	    } else {
	      switch (format) {
	        case 'hsl':
	          var _hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);
	          this.value = 'hsl(' + _hue + ', ' + Math.round(_hsl[1] * 100) + '%, ' + Math.round(_hsl[2] * 100) + '%)';
	          break;
	        case 'hsv':
	          this.value = 'hsv(' + _hue + ', ' + Math.round(_saturation) + '%, ' + Math.round(_value) + '%)';
	          break;
	        case 'rgb':
	          var _hsv2rgb2 = hsv2rgb(_hue, _saturation, _value),
	              _r = _hsv2rgb2.r,
	              _g = _hsv2rgb2.g,
	              _b = _hsv2rgb2.b;
	
	          this.value = 'rgb(' + _r + ', ' + _g + ', ' + _b + ')';
	          break;
	        default:
	          this.value = toHex(hsv2rgb(_hue, _saturation, _value));
	      }
	    }
	  };
	
	  return Color;
	}();
	
	/* harmony default export */ var src_color = (Color);
	;
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&
	var picker_dropdownvue_type_template_id_06601625_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.showPopper,
	              expression: "showPopper"
	            }
	          ],
	          staticClass: "el-color-dropdown"
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-color-dropdown__main-wrapper" },
	            [
	              _c("hue-slider", {
	                ref: "hue",
	                staticStyle: { float: "right" },
	                attrs: { color: _vm.color, vertical: "" }
	              }),
	              _c("sv-panel", { ref: "sl", attrs: { color: _vm.color } })
	            ],
	            1
	          ),
	          _vm.showAlpha
	            ? _c("alpha-slider", { ref: "alpha", attrs: { color: _vm.color } })
	            : _vm._e(),
	          _vm.predefine
	            ? _c("predefine", {
	                attrs: { color: _vm.color, colors: _vm.predefine }
	              })
	            : _vm._e(),
	          _c(
	            "div",
	            { staticClass: "el-color-dropdown__btns" },
	            [
	              _c(
	                "span",
	                { staticClass: "el-color-dropdown__value" },
	                [
	                  _c("el-input", {
	                    attrs: { "validate-event": false, size: "mini" },
	                    on: { blur: _vm.handleConfirm },
	                    nativeOn: {
	                      keyup: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "enter",
	                            13,
	                            $event.key,
	                            "Enter"
	                          )
	                        ) {
	                          return null
	                        }
	                        return _vm.handleConfirm($event)
	                      }
	                    },
	                    model: {
	                      value: _vm.customInput,
	                      callback: function($$v) {
	                        _vm.customInput = $$v
	                      },
	                      expression: "customInput"
	                    }
	                  })
	                ],
	                1
	              ),
	              _c(
	                "el-button",
	                {
	                  staticClass: "el-color-dropdown__link-btn",
	                  attrs: { size: "mini", type: "text" },
	                  on: {
	                    click: function($event) {
	                      _vm.$emit("clear")
	                    }
	                  }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.colorpicker.clear")) +
	                      "\n      "
	                  )
	                ]
	              ),
	              _c(
	                "el-button",
	                {
	                  staticClass: "el-color-dropdown__btn",
	                  attrs: { plain: "", size: "mini" },
	                  on: { click: _vm.confirmValue }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.colorpicker.confirm")) +
	                      "\n      "
	                  )
	                ]
	              )
	            ],
	            1
	          )
	        ],
	        1
	      )
	    ]
	  )
	}
	var picker_dropdownvue_type_template_id_06601625_staticRenderFns = []
	picker_dropdownvue_type_template_id_06601625_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&
	var sv_panelvue_type_template_id_d8583596_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-color-svpanel",
	      style: {
	        backgroundColor: _vm.background
	      }
	    },
	    [
	      _c("div", { staticClass: "el-color-svpanel__white" }),
	      _c("div", { staticClass: "el-color-svpanel__black" }),
	      _c(
	        "div",
	        {
	          staticClass: "el-color-svpanel__cursor",
	          style: {
	            top: _vm.cursorTop + "px",
	            left: _vm.cursorLeft + "px"
	          }
	        },
	        [_c("div")]
	      )
	    ]
	  )
	}
	var sv_panelvue_type_template_id_d8583596_staticRenderFns = []
	sv_panelvue_type_template_id_d8583596_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&
	
	// CONCATENATED MODULE: ./packages/color-picker/src/draggable.js
	
	var isDragging = false;
	
	/* harmony default export */ var draggable = (function (element, options) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  var moveFn = function moveFn(event) {
	    if (options.drag) {
	      options.drag(event);
	    }
	  };
	  var upFn = function upFn(event) {
	    document.removeEventListener('mousemove', moveFn);
	    document.removeEventListener('mouseup', upFn);
	    document.onselectstart = null;
	    document.ondragstart = null;
	
	    isDragging = false;
	
	    if (options.end) {
	      options.end(event);
	    }
	  };
	  element.addEventListener('mousedown', function (event) {
	    if (isDragging) return;
	    document.onselectstart = function () {
	      return false;
	    };
	    document.ondragstart = function () {
	      return false;
	    };
	
	    document.addEventListener('mousemove', moveFn);
	    document.addEventListener('mouseup', upFn);
	    isDragging = true;
	
	    if (options.start) {
	      options.start(event);
	    }
	  });
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var sv_panelvue_type_script_lang_js_ = ({
	  name: 'el-sl-panel',
	
	  props: {
	    color: {
	      required: true
	    }
	  },
	
	  computed: {
	    colorValue: function colorValue() {
	      var hue = this.color.get('hue');
	      var value = this.color.get('value');
	      return { hue: hue, value: value };
	    }
	  },
	
	  watch: {
	    colorValue: function colorValue() {
	      this.update();
	    }
	  },
	
	  methods: {
	    update: function update() {
	      var saturation = this.color.get('saturation');
	      var value = this.color.get('value');
	
	      var el = this.$el;
	      var width = el.clientWidth,
	          height = el.clientHeight;
	
	
	      this.cursorLeft = saturation * width / 100;
	      this.cursorTop = (100 - value) * height / 100;
	
	      this.background = 'hsl(' + this.color.get('hue') + ', 100%, 50%)';
	    },
	    handleDrag: function handleDrag(event) {
	      var el = this.$el;
	      var rect = el.getBoundingClientRect();
	
	      var left = event.clientX - rect.left;
	      var top = event.clientY - rect.top;
	      left = Math.max(0, left);
	      left = Math.min(left, rect.width);
	
	      top = Math.max(0, top);
	      top = Math.min(top, rect.height);
	
	      this.cursorLeft = left;
	      this.cursorTop = top;
	      this.color.set({
	        saturation: left / rect.width * 100,
	        value: 100 - top / rect.height * 100
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    draggable(this.$el, {
	      drag: function drag(event) {
	        _this.handleDrag(event);
	      },
	      end: function end(event) {
	        _this.handleDrag(event);
	      }
	    });
	
	    this.update();
	  },
	  data: function data() {
	    return {
	      cursorTop: 0,
	      cursorLeft: 0,
	      background: 'hsl(0, 100%, 50%)'
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_sv_panelvue_type_script_lang_js_ = (sv_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var sv_panel_component = normalizeComponent(
	  components_sv_panelvue_type_script_lang_js_,
	  sv_panelvue_type_template_id_d8583596_render,
	  sv_panelvue_type_template_id_d8583596_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var sv_panel_api; }
	sv_panel_component.options.__file = "packages/color-picker/src/components/sv-panel.vue"
	/* harmony default export */ var sv_panel = (sv_panel_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&
	var hue_slidervue_type_template_id_5cdc43b1_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-color-hue-slider",
	      class: { "is-vertical": _vm.vertical }
	    },
	    [
	      _c("div", {
	        ref: "bar",
	        staticClass: "el-color-hue-slider__bar",
	        on: { click: _vm.handleClick }
	      }),
	      _c("div", {
	        ref: "thumb",
	        staticClass: "el-color-hue-slider__thumb",
	        style: {
	          left: _vm.thumbLeft + "px",
	          top: _vm.thumbTop + "px"
	        }
	      })
	    ]
	  )
	}
	var hue_slidervue_type_template_id_5cdc43b1_staticRenderFns = []
	hue_slidervue_type_template_id_5cdc43b1_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var hue_slidervue_type_script_lang_js_ = ({
	  name: 'el-color-hue-slider',
	
	  props: {
	    color: {
	      required: true
	    },
	
	    vertical: Boolean
	  },
	
	  data: function data() {
	    return {
	      thumbLeft: 0,
	      thumbTop: 0
	    };
	  },
	
	
	  computed: {
	    hueValue: function hueValue() {
	      var hue = this.color.get('hue');
	      return hue;
	    }
	  },
	
	  watch: {
	    hueValue: function hueValue() {
	      this.update();
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(event) {
	      var thumb = this.$refs.thumb;
	      var target = event.target;
	
	      if (target !== thumb) {
	        this.handleDrag(event);
	      }
	    },
	    handleDrag: function handleDrag(event) {
	      var rect = this.$el.getBoundingClientRect();
	      var thumb = this.$refs.thumb;
	
	      var hue = void 0;
	
	      if (!this.vertical) {
	        var left = event.clientX - rect.left;
	        left = Math.min(left, rect.width - thumb.offsetWidth / 2);
	        left = Math.max(thumb.offsetWidth / 2, left);
	
	        hue = Math.round((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth) * 360);
	      } else {
	        var top = event.clientY - rect.top;
	        top = Math.min(top, rect.height - thumb.offsetHeight / 2);
	        top = Math.max(thumb.offsetHeight / 2, top);
	
	        hue = Math.round((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight) * 360);
	      }
	
	      this.color.set('hue', hue);
	    },
	    getThumbLeft: function getThumbLeft() {
	      if (this.vertical) return 0;
	      var el = this.$el;
	      var hue = this.color.get('hue');
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(hue * (el.offsetWidth - thumb.offsetWidth / 2) / 360);
	    },
	    getThumbTop: function getThumbTop() {
	      if (!this.vertical) return 0;
	      var el = this.$el;
	      var hue = this.color.get('hue');
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(hue * (el.offsetHeight - thumb.offsetHeight / 2) / 360);
	    },
	    update: function update() {
	      this.thumbLeft = this.getThumbLeft();
	      this.thumbTop = this.getThumbTop();
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var _$refs = this.$refs,
	        bar = _$refs.bar,
	        thumb = _$refs.thumb;
	
	
	    var dragConfig = {
	      drag: function drag(event) {
	        _this.handleDrag(event);
	      },
	      end: function end(event) {
	        _this.handleDrag(event);
	      }
	    };
	
	    draggable(bar, dragConfig);
	    draggable(thumb, dragConfig);
	    this.update();
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_hue_slidervue_type_script_lang_js_ = (hue_slidervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue
	
	
	
	
	
	/* normalize component */
	
	var hue_slider_component = normalizeComponent(
	  components_hue_slidervue_type_script_lang_js_,
	  hue_slidervue_type_template_id_5cdc43b1_render,
	  hue_slidervue_type_template_id_5cdc43b1_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var hue_slider_api; }
	hue_slider_component.options.__file = "packages/color-picker/src/components/hue-slider.vue"
	/* harmony default export */ var hue_slider = (hue_slider_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&
	var alpha_slidervue_type_template_id_068c66cb_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-color-alpha-slider",
	      class: { "is-vertical": _vm.vertical }
	    },
	    [
	      _c("div", {
	        ref: "bar",
	        staticClass: "el-color-alpha-slider__bar",
	        style: {
	          background: _vm.background
	        },
	        on: { click: _vm.handleClick }
	      }),
	      _c("div", {
	        ref: "thumb",
	        staticClass: "el-color-alpha-slider__thumb",
	        style: {
	          left: _vm.thumbLeft + "px",
	          top: _vm.thumbTop + "px"
	        }
	      })
	    ]
	  )
	}
	var alpha_slidervue_type_template_id_068c66cb_staticRenderFns = []
	alpha_slidervue_type_template_id_068c66cb_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var alpha_slidervue_type_script_lang_js_ = ({
	  name: 'el-color-alpha-slider',
	
	  props: {
	    color: {
	      required: true
	    },
	    vertical: Boolean
	  },
	
	  watch: {
	    'color._alpha': function color_alpha() {
	      this.update();
	    },
	    'color.value': function colorValue() {
	      this.update();
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(event) {
	      var thumb = this.$refs.thumb;
	      var target = event.target;
	
	      if (target !== thumb) {
	        this.handleDrag(event);
	      }
	    },
	    handleDrag: function handleDrag(event) {
	      var rect = this.$el.getBoundingClientRect();
	      var thumb = this.$refs.thumb;
	
	
	      if (!this.vertical) {
	        var left = event.clientX - rect.left;
	        left = Math.max(thumb.offsetWidth / 2, left);
	        left = Math.min(left, rect.width - thumb.offsetWidth / 2);
	
	        this.color.set('alpha', Math.round((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth) * 100));
	      } else {
	        var top = event.clientY - rect.top;
	        top = Math.max(thumb.offsetHeight / 2, top);
	        top = Math.min(top, rect.height - thumb.offsetHeight / 2);
	
	        this.color.set('alpha', Math.round((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight) * 100));
	      }
	    },
	    getThumbLeft: function getThumbLeft() {
	      if (this.vertical) return 0;
	      var el = this.$el;
	      var alpha = this.color._alpha;
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(alpha * (el.offsetWidth - thumb.offsetWidth / 2) / 100);
	    },
	    getThumbTop: function getThumbTop() {
	      if (!this.vertical) return 0;
	      var el = this.$el;
	      var alpha = this.color._alpha;
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(alpha * (el.offsetHeight - thumb.offsetHeight / 2) / 100);
	    },
	    getBackground: function getBackground() {
	      if (this.color && this.color.value) {
	        var _color$toRgb = this.color.toRgb(),
	            r = _color$toRgb.r,
	            g = _color$toRgb.g,
	            b = _color$toRgb.b;
	
	        return 'linear-gradient(to right, rgba(' + r + ', ' + g + ', ' + b + ', 0) 0%, rgba(' + r + ', ' + g + ', ' + b + ', 1) 100%)';
	      }
	      return null;
	    },
	    update: function update() {
	      this.thumbLeft = this.getThumbLeft();
	      this.thumbTop = this.getThumbTop();
	      this.background = this.getBackground();
	    }
	  },
	
	  data: function data() {
	    return {
	      thumbLeft: 0,
	      thumbTop: 0,
	      background: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var _$refs = this.$refs,
	        bar = _$refs.bar,
	        thumb = _$refs.thumb;
	
	
	    var dragConfig = {
	      drag: function drag(event) {
	        _this.handleDrag(event);
	      },
	      end: function end(event) {
	        _this.handleDrag(event);
	      }
	    };
	
	    draggable(bar, dragConfig);
	    draggable(thumb, dragConfig);
	    this.update();
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_alpha_slidervue_type_script_lang_js_ = (alpha_slidervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue
	
	
	
	
	
	/* normalize component */
	
	var alpha_slider_component = normalizeComponent(
	  components_alpha_slidervue_type_script_lang_js_,
	  alpha_slidervue_type_template_id_068c66cb_render,
	  alpha_slidervue_type_template_id_068c66cb_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var alpha_slider_api; }
	alpha_slider_component.options.__file = "packages/color-picker/src/components/alpha-slider.vue"
	/* harmony default export */ var alpha_slider = (alpha_slider_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&
	var predefinevue_type_template_id_06e03093_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-color-predefine" }, [
	    _c(
	      "div",
	      { staticClass: "el-color-predefine__colors" },
	      _vm._l(_vm.rgbaColors, function(item, index) {
	        return _c(
	          "div",
	          {
	            key: _vm.colors[index],
	            staticClass: "el-color-predefine__color-selector",
	            class: { selected: item.selected, "is-alpha": item._alpha < 100 },
	            on: {
	              click: function($event) {
	                _vm.handleSelect(index)
	              }
	            }
	          },
	          [_c("div", { style: { "background-color": item.value } })]
	        )
	      }),
	      0
	    )
	  ])
	}
	var predefinevue_type_template_id_06e03093_staticRenderFns = []
	predefinevue_type_template_id_06e03093_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var predefinevue_type_script_lang_js_ = ({
	  props: {
	    colors: { type: Array, required: true },
	    color: { required: true }
	  },
	  data: function data() {
	    return {
	      rgbaColors: this.parseColors(this.colors, this.color)
	    };
	  },
	
	  methods: {
	    handleSelect: function handleSelect(index) {
	      this.color.fromString(this.colors[index]);
	    },
	    parseColors: function parseColors(colors, color) {
	      return colors.map(function (value) {
	        var c = new src_color();
	        c.enableAlpha = true;
	        c.format = 'rgba';
	        c.fromString(value);
	        c.selected = c.value === color.value;
	        return c;
	      });
	    }
	  },
	  watch: {
	    '$parent.currentColor': function $parentCurrentColor(val) {
	      var color = new src_color();
	      color.fromString(val);
	
	      this.rgbaColors.forEach(function (item) {
	        item.selected = color.compare(item);
	      });
	    },
	    colors: function colors(newVal) {
	      this.rgbaColors = this.parseColors(newVal, this.color);
	    },
	    color: function color(newVal) {
	      this.rgbaColors = this.parseColors(this.colors, newVal);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_predefinevue_type_script_lang_js_ = (predefinevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue
	
	
	
	
	
	/* normalize component */
	
	var predefine_component = normalizeComponent(
	  components_predefinevue_type_script_lang_js_,
	  predefinevue_type_template_id_06e03093_render,
	  predefinevue_type_template_id_06e03093_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var predefine_api; }
	predefine_component.options.__file = "packages/color-picker/src/components/predefine.vue"
	/* harmony default export */ var predefine = (predefine_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var picker_dropdownvue_type_script_lang_js_ = ({
	  name: 'el-color-picker-dropdown',
	
	  mixins: [vue_popper_default.a, locale_default.a],
	
	  components: {
	    SvPanel: sv_panel,
	    HueSlider: hue_slider,
	    AlphaSlider: alpha_slider,
	    ElInput: input_default.a,
	    ElButton: button_default.a,
	    Predefine: predefine
	  },
	
	  props: {
	    color: {
	      required: true
	    },
	    showAlpha: Boolean,
	    predefine: Array
	  },
	
	  data: function data() {
	    return {
	      customInput: ''
	    };
	  },
	
	
	  computed: {
	    currentColor: function currentColor() {
	      var parent = this.$parent;
	      return !parent.value && !parent.showPanelColor ? '' : parent.color.value;
	    }
	  },
	
	  methods: {
	    confirmValue: function confirmValue() {
	      this.$emit('pick');
	    },
	    handleConfirm: function handleConfirm() {
	      this.color.fromString(this.customInput);
	    }
	  },
	
	  mounted: function mounted() {
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.referenceElm = this.$parent.$el;
	  },
	
	
	  watch: {
	    showPopper: function showPopper(val) {
	      var _this = this;
	
	      if (val === true) {
	        this.$nextTick(function () {
	          var _$refs = _this.$refs,
	              sl = _$refs.sl,
	              hue = _$refs.hue,
	              alpha = _$refs.alpha;
	
	          sl && sl.update();
	          hue && hue.update();
	          alpha && alpha.update();
	        });
	      }
	    },
	
	
	    currentColor: {
	      immediate: true,
	      handler: function handler(val) {
	        this.customInput = val;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_picker_dropdownvue_type_script_lang_js_ = (picker_dropdownvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue
	
	
	
	
	
	/* normalize component */
	
	var picker_dropdown_component = normalizeComponent(
	  components_picker_dropdownvue_type_script_lang_js_,
	  picker_dropdownvue_type_template_id_06601625_render,
	  picker_dropdownvue_type_template_id_06601625_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var picker_dropdown_api; }
	picker_dropdown_component.options.__file = "packages/color-picker/src/components/picker-dropdown.vue"
	/* harmony default export */ var picker_dropdown = (picker_dropdown_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var color_picker_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElColorPicker',
	
	  mixins: [emitter_default.a],
	
	  props: {
	    value: String,
	    showAlpha: Boolean,
	    colorFormat: String,
	    disabled: Boolean,
	    size: String,
	    popperClass: String,
	    predefine: Array
	  },
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  computed: {
	    displayedColor: function displayedColor() {
	      if (!this.value && !this.showPanelColor) {
	        return 'transparent';
	      }
	
	      return this.displayedRgb(this.color, this.showAlpha);
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    colorSize: function colorSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    colorDisabled: function colorDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      if (!val) {
	        this.showPanelColor = false;
	      } else if (val && val !== this.color.value) {
	        this.color.fromString(val);
	      }
	    },
	
	    color: {
	      deep: true,
	      handler: function handler() {
	        this.showPanelColor = true;
	      }
	    },
	    displayedColor: function displayedColor(val) {
	      if (!this.showPicker) return;
	      var currentValueColor = new src_color({
	        enableAlpha: this.showAlpha,
	        format: this.colorFormat
	      });
	      currentValueColor.fromString(this.value);
	
	      var currentValueColorRgb = this.displayedRgb(currentValueColor, this.showAlpha);
	      if (val !== currentValueColorRgb) {
	        this.$emit('active-change', val);
	      }
	    }
	  },
	
	  methods: {
	    handleTrigger: function handleTrigger() {
	      if (this.colorDisabled) return;
	      this.showPicker = !this.showPicker;
	    },
	    confirmValue: function confirmValue() {
	      var value = this.color.value;
	      this.$emit('input', value);
	      this.$emit('change', value);
	      this.dispatch('ElFormItem', 'el.form.change', value);
	      this.showPicker = false;
	    },
	    clearValue: function clearValue() {
	      this.$emit('input', null);
	      this.$emit('change', null);
	      if (this.value !== null) {
	        this.dispatch('ElFormItem', 'el.form.change', null);
	      }
	      this.showPanelColor = false;
	      this.showPicker = false;
	      this.resetColor();
	    },
	    hide: function hide() {
	      this.showPicker = false;
	      this.resetColor();
	    },
	    resetColor: function resetColor() {
	      var _this = this;
	
	      this.$nextTick(function (_) {
	        if (_this.value) {
	          _this.color.fromString(_this.value);
	        } else {
	          _this.showPanelColor = false;
	        }
	      });
	    },
	    displayedRgb: function displayedRgb(color, showAlpha) {
	      if (!(color instanceof src_color)) {
	        throw Error('color should be instance of Color Class');
	      }
	
	      var _color$toRgb = color.toRgb(),
	          r = _color$toRgb.r,
	          g = _color$toRgb.g,
	          b = _color$toRgb.b;
	
	      return showAlpha ? 'rgba(' + r + ', ' + g + ', ' + b + ', ' + color.get('alpha') / 100 + ')' : 'rgb(' + r + ', ' + g + ', ' + b + ')';
	    }
	  },
	
	  mounted: function mounted() {
	    var value = this.value;
	    if (value) {
	      this.color.fromString(value);
	    }
	    this.popperElm = this.$refs.dropdown.$el;
	  },
	  data: function data() {
	    var color = new src_color({
	      enableAlpha: this.showAlpha,
	      format: this.colorFormat
	    });
	
	    return {
	      color: color,
	      showPicker: false,
	      showPanelColor: false
	    };
	  },
	
	
	  components: {
	    PickerDropdown: picker_dropdown
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_color_picker_src_mainvue_type_script_lang_js_ = (color_picker_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var color_picker_src_main_component = normalizeComponent(
	  packages_color_picker_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_55c8ade7_render,
	  mainvue_type_template_id_55c8ade7_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var color_picker_src_main_api; }
	color_picker_src_main_component.options.__file = "packages/color-picker/src/main.vue"
	/* harmony default export */ var color_picker_src_main = (color_picker_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/color-picker/index.js
	
	
	/* istanbul ignore next */
	color_picker_src_main.install = function (Vue) {
	  Vue.component(color_picker_src_main.name, color_picker_src_main);
	};
	
	/* harmony default export */ var color_picker = (color_picker_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&
	var mainvue_type_template_id_5c654dd8_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    { staticClass: "el-transfer" },
	    [
	      _c(
	        "transfer-panel",
	        _vm._b(
	          {
	            ref: "leftPanel",
	            attrs: {
	              data: _vm.sourceData,
	              title: _vm.titles[0] || _vm.t("el.transfer.titles.0"),
	              "default-checked": _vm.leftDefaultChecked,
	              placeholder:
	                _vm.filterPlaceholder || _vm.t("el.transfer.filterPlaceholder")
	            },
	            on: { "checked-change": _vm.onSourceCheckedChange }
	          },
	          "transfer-panel",
	          _vm.$props,
	          false
	        ),
	        [_vm._t("left-footer")],
	        2
	      ),
	      _c(
	        "div",
	        { staticClass: "el-transfer__buttons" },
	        [
	          _c(
	            "el-button",
	            {
	              class: [
	                "el-transfer__button",
	                _vm.hasButtonTexts ? "is-with-texts" : ""
	              ],
	              attrs: {
	                type: "primary",
	                disabled: _vm.rightChecked.length === 0
	              },
	              nativeOn: {
	                click: function($event) {
	                  return _vm.addToLeft($event)
	                }
	              }
	            },
	            [
	              _c("i", { staticClass: "el-icon-arrow-left" }),
	              _vm.buttonTexts[0] !== undefined
	                ? _c("span", [_vm._v(_vm._s(_vm.buttonTexts[0]))])
	                : _vm._e()
	            ]
	          ),
	          _c(
	            "el-button",
	            {
	              class: [
	                "el-transfer__button",
	                _vm.hasButtonTexts ? "is-with-texts" : ""
	              ],
	              attrs: {
	                type: "primary",
	                disabled: _vm.leftChecked.length === 0
	              },
	              nativeOn: {
	                click: function($event) {
	                  return _vm.addToRight($event)
	                }
	              }
	            },
	            [
	              _vm.buttonTexts[1] !== undefined
	                ? _c("span", [_vm._v(_vm._s(_vm.buttonTexts[1]))])
	                : _vm._e(),
	              _c("i", { staticClass: "el-icon-arrow-right" })
	            ]
	          )
	        ],
	        1
	      ),
	      _c(
	        "transfer-panel",
	        _vm._b(
	          {
	            ref: "rightPanel",
	            attrs: {
	              data: _vm.targetData,
	              title: _vm.titles[1] || _vm.t("el.transfer.titles.1"),
	              "default-checked": _vm.rightDefaultChecked,
	              placeholder:
	                _vm.filterPlaceholder || _vm.t("el.transfer.filterPlaceholder")
	            },
	            on: { "checked-change": _vm.onTargetCheckedChange }
	          },
	          "transfer-panel",
	          _vm.$props,
	          false
	        ),
	        [_vm._t("right-footer")],
	        2
	      )
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_5c654dd8_staticRenderFns = []
	mainvue_type_template_id_5c654dd8_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&
	var transfer_panelvue_type_template_id_2ddab8bd_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-transfer-panel" }, [
	    _c(
	      "p",
	      { staticClass: "el-transfer-panel__header" },
	      [
	        _c(
	          "el-checkbox",
	          {
	            attrs: { indeterminate: _vm.isIndeterminate },
	            on: { change: _vm.handleAllCheckedChange },
	            model: {
	              value: _vm.allChecked,
	              callback: function($$v) {
	                _vm.allChecked = $$v
	              },
	              expression: "allChecked"
	            }
	          },
	          [
	            _vm._v("\n      " + _vm._s(_vm.title) + "\n      "),
	            _c("span", [_vm._v(_vm._s(_vm.checkedSummary))])
	          ]
	        )
	      ],
	      1
	    ),
	    _c(
	      "div",
	      {
	        class: [
	          "el-transfer-panel__body",
	          _vm.hasFooter ? "is-with-footer" : ""
	        ]
	      },
	      [
	        _vm.filterable
	          ? _c(
	              "el-input",
	              {
	                staticClass: "el-transfer-panel__filter",
	                attrs: { size: "small", placeholder: _vm.placeholder },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.inputHover = true
	                  },
	                  mouseleave: function($event) {
	                    _vm.inputHover = false
	                  }
	                },
	                model: {
	                  value: _vm.query,
	                  callback: function($$v) {
	                    _vm.query = $$v
	                  },
	                  expression: "query"
	                }
	              },
	              [
	                _c("i", {
	                  class: ["el-input__icon", "el-icon-" + _vm.inputIcon],
	                  attrs: { slot: "prefix" },
	                  on: { click: _vm.clearQuery },
	                  slot: "prefix"
	                })
	              ]
	            )
	          : _vm._e(),
	        _c(
	          "el-checkbox-group",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: !_vm.hasNoMatch && _vm.data.length > 0,
	                expression: "!hasNoMatch && data.length > 0"
	              }
	            ],
	            staticClass: "el-transfer-panel__list",
	            class: { "is-filterable": _vm.filterable },
	            model: {
	              value: _vm.checked,
	              callback: function($$v) {
	                _vm.checked = $$v
	              },
	              expression: "checked"
	            }
	          },
	          _vm._l(_vm.filteredData, function(item) {
	            return _c(
	              "el-checkbox",
	              {
	                key: item[_vm.keyProp],
	                staticClass: "el-transfer-panel__item",
	                attrs: {
	                  label: item[_vm.keyProp],
	                  disabled: item[_vm.disabledProp]
	                }
	              },
	              [_c("option-content", { attrs: { option: item } })],
	              1
	            )
	          }),
	          1
	        ),
	        _c(
	          "p",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.hasNoMatch,
	                expression: "hasNoMatch"
	              }
	            ],
	            staticClass: "el-transfer-panel__empty"
	          },
	          [_vm._v(_vm._s(_vm.t("el.transfer.noMatch")))]
	        ),
	        _c(
	          "p",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.data.length === 0 && !_vm.hasNoMatch,
	                expression: "data.length === 0 && !hasNoMatch"
	              }
	            ],
	            staticClass: "el-transfer-panel__empty"
	          },
	          [_vm._v(_vm._s(_vm.t("el.transfer.noData")))]
	        )
	      ],
	      1
	    ),
	    _vm.hasFooter
	      ? _c(
	          "p",
	          { staticClass: "el-transfer-panel__footer" },
	          [_vm._t("default")],
	          2
	        )
	      : _vm._e()
	  ])
	}
	var transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns = []
	transfer_panelvue_type_template_id_2ddab8bd_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var transfer_panelvue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  name: 'ElTransferPanel',
	
	  componentName: 'ElTransferPanel',
	
	  components: {
	    ElCheckboxGroup: checkbox_group_default.a,
	    ElCheckbox: checkbox_default.a,
	    ElInput: input_default.a,
	    OptionContent: {
	      props: {
	        option: Object
	      },
	      render: function render(h) {
	        var getParent = function getParent(vm) {
	          if (vm.$options.componentName === 'ElTransferPanel') {
	            return vm;
	          } else if (vm.$parent) {
	            return getParent(vm.$parent);
	          } else {
	            return vm;
	          }
	        };
	        var panel = getParent(this);
	        var transfer = panel.$parent || panel;
	        return panel.renderContent ? panel.renderContent(h, this.option) : transfer.$scopedSlots.default ? transfer.$scopedSlots.default({ option: this.option }) : h('span', [this.option[panel.labelProp] || this.option[panel.keyProp]]);
	      }
	    }
	  },
	
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    renderContent: Function,
	    placeholder: String,
	    title: String,
	    filterable: Boolean,
	    format: Object,
	    filterMethod: Function,
	    defaultChecked: Array,
	    props: Object
	  },
	
	  data: function data() {
	    return {
	      checked: [],
	      allChecked: false,
	      query: '',
	      inputHover: false,
	      checkChangeByUser: true
	    };
	  },
	
	
	  watch: {
	    checked: function checked(val, oldVal) {
	      this.updateAllChecked();
	      if (this.checkChangeByUser) {
	        var movedKeys = val.concat(oldVal).filter(function (v) {
	          return val.indexOf(v) === -1 || oldVal.indexOf(v) === -1;
	        });
	        this.$emit('checked-change', val, movedKeys);
	      } else {
	        this.$emit('checked-change', val);
	        this.checkChangeByUser = true;
	      }
	    },
	    data: function data() {
	      var _this = this;
	
	      var checked = [];
	      var filteredDataKeys = this.filteredData.map(function (item) {
	        return item[_this.keyProp];
	      });
	      this.checked.forEach(function (item) {
	        if (filteredDataKeys.indexOf(item) > -1) {
	          checked.push(item);
	        }
	      });
	      this.checkChangeByUser = false;
	      this.checked = checked;
	    },
	    checkableData: function checkableData() {
	      this.updateAllChecked();
	    },
	
	
	    defaultChecked: {
	      immediate: true,
	      handler: function handler(val, oldVal) {
	        var _this2 = this;
	
	        if (oldVal && val.length === oldVal.length && val.every(function (item) {
	          return oldVal.indexOf(item) > -1;
	        })) return;
	        var checked = [];
	        var checkableDataKeys = this.checkableData.map(function (item) {
	          return item[_this2.keyProp];
	        });
	        val.forEach(function (item) {
	          if (checkableDataKeys.indexOf(item) > -1) {
	            checked.push(item);
	          }
	        });
	        this.checkChangeByUser = false;
	        this.checked = checked;
	      }
	    }
	  },
	
	  computed: {
	    filteredData: function filteredData() {
	      var _this3 = this;
	
	      return this.data.filter(function (item) {
	        if (typeof _this3.filterMethod === 'function') {
	          return _this3.filterMethod(_this3.query, item);
	        } else {
	          var label = item[_this3.labelProp] || item[_this3.keyProp].toString();
	          return label.toLowerCase().indexOf(_this3.query.toLowerCase()) > -1;
	        }
	      });
	    },
	    checkableData: function checkableData() {
	      var _this4 = this;
	
	      return this.filteredData.filter(function (item) {
	        return !item[_this4.disabledProp];
	      });
	    },
	    checkedSummary: function checkedSummary() {
	      var checkedLength = this.checked.length;
	      var dataLength = this.data.length;
	      var _format = this.format,
	          noChecked = _format.noChecked,
	          hasChecked = _format.hasChecked;
	
	      if (noChecked && hasChecked) {
	        return checkedLength > 0 ? hasChecked.replace(/\${checked}/g, checkedLength).replace(/\${total}/g, dataLength) : noChecked.replace(/\${total}/g, dataLength);
	      } else {
	        return checkedLength + '/' + dataLength;
	      }
	    },
	    isIndeterminate: function isIndeterminate() {
	      var checkedLength = this.checked.length;
	      return checkedLength > 0 && checkedLength < this.checkableData.length;
	    },
	    hasNoMatch: function hasNoMatch() {
	      return this.query.length > 0 && this.filteredData.length === 0;
	    },
	    inputIcon: function inputIcon() {
	      return this.query.length > 0 && this.inputHover ? 'circle-close' : 'search';
	    },
	    labelProp: function labelProp() {
	      return this.props.label || 'label';
	    },
	    keyProp: function keyProp() {
	      return this.props.key || 'key';
	    },
	    disabledProp: function disabledProp() {
	      return this.props.disabled || 'disabled';
	    },
	    hasFooter: function hasFooter() {
	      return !!this.$slots.default;
	    }
	  },
	
	  methods: {
	    updateAllChecked: function updateAllChecked() {
	      var _this5 = this;
	
	      var checkableDataKeys = this.checkableData.map(function (item) {
	        return item[_this5.keyProp];
	      });
	      this.allChecked = checkableDataKeys.length > 0 && checkableDataKeys.every(function (item) {
	        return _this5.checked.indexOf(item) > -1;
	      });
	    },
	    handleAllCheckedChange: function handleAllCheckedChange(value) {
	      var _this6 = this;
	
	      this.checked = value ? this.checkableData.map(function (item) {
	        return item[_this6.keyProp];
	      }) : [];
	    },
	    clearQuery: function clearQuery() {
	      if (this.inputIcon === 'circle-close') {
	        this.query = '';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_transfer_panelvue_type_script_lang_js_ = (transfer_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var transfer_panel_component = normalizeComponent(
	  src_transfer_panelvue_type_script_lang_js_,
	  transfer_panelvue_type_template_id_2ddab8bd_render,
	  transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var transfer_panel_api; }
	transfer_panel_component.options.__file = "packages/transfer/src/transfer-panel.vue"
	/* harmony default export */ var transfer_panel = (transfer_panel_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	/* harmony default export */ var transfer_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElTransfer',
	
	  mixins: [emitter_default.a, locale_default.a, migrating_default.a],
	
	  components: {
	    TransferPanel: transfer_panel,
	    ElButton: button_default.a
	  },
	
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    titles: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    buttonTexts: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    filterPlaceholder: {
	      type: String,
	      default: ''
	    },
	    filterMethod: Function,
	    leftDefaultChecked: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    rightDefaultChecked: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    renderContent: Function,
	    value: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    format: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    filterable: Boolean,
	    props: {
	      type: Object,
	      default: function _default() {
	        return {
	          label: 'label',
	          key: 'key',
	          disabled: 'disabled'
	        };
	      }
	    },
	    targetOrder: {
	      type: String,
	      default: 'original'
	    }
	  },
	
	  data: function data() {
	    return {
	      leftChecked: [],
	      rightChecked: []
	    };
	  },
	
	
	  computed: {
	    dataObj: function dataObj() {
	      var key = this.props.key;
	      return this.data.reduce(function (o, cur) {
	        return (o[cur[key]] = cur) && o;
	      }, {});
	    },
	    sourceData: function sourceData() {
	      var _this = this;
	
	      return this.data.filter(function (item) {
	        return _this.value.indexOf(item[_this.props.key]) === -1;
	      });
	    },
	    targetData: function targetData() {
	      var _this2 = this;
	
	      if (this.targetOrder === 'original') {
	        return this.data.filter(function (item) {
	          return _this2.value.indexOf(item[_this2.props.key]) > -1;
	        });
	      } else {
	        return this.value.reduce(function (arr, cur) {
	          var val = _this2.dataObj[cur];
	          if (val) {
	            arr.push(val);
	          }
	          return arr;
	        }, []);
	      }
	    },
	    hasButtonTexts: function hasButtonTexts() {
	      return this.buttonTexts.length === 2;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.dispatch('ElFormItem', 'el.form.change', val);
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'footer-format': 'footer-format is renamed to format.'
	        }
	      };
	    },
	    onSourceCheckedChange: function onSourceCheckedChange(val, movedKeys) {
	      this.leftChecked = val;
	      if (movedKeys === undefined) return;
	      this.$emit('left-check-change', val, movedKeys);
	    },
	    onTargetCheckedChange: function onTargetCheckedChange(val, movedKeys) {
	      this.rightChecked = val;
	      if (movedKeys === undefined) return;
	      this.$emit('right-check-change', val, movedKeys);
	    },
	    addToLeft: function addToLeft() {
	      var currentValue = this.value.slice();
	      this.rightChecked.forEach(function (item) {
	        var index = currentValue.indexOf(item);
	        if (index > -1) {
	          currentValue.splice(index, 1);
	        }
	      });
	      this.$emit('input', currentValue);
	      this.$emit('change', currentValue, 'left', this.rightChecked);
	    },
	    addToRight: function addToRight() {
	      var _this3 = this;
	
	      var currentValue = this.value.slice();
	      var itemsToBeMoved = [];
	      var key = this.props.key;
	      this.data.forEach(function (item) {
	        var itemKey = item[key];
	        if (_this3.leftChecked.indexOf(itemKey) > -1 && _this3.value.indexOf(itemKey) === -1) {
	          itemsToBeMoved.push(itemKey);
	        }
	      });
	      currentValue = this.targetOrder === 'unshift' ? itemsToBeMoved.concat(currentValue) : currentValue.concat(itemsToBeMoved);
	      this.$emit('input', currentValue);
	      this.$emit('change', currentValue, 'right', this.leftChecked);
	    },
	    clearQuery: function clearQuery(which) {
	      if (which === 'left') {
	        this.$refs.leftPanel.query = '';
	      } else if (which === 'right') {
	        this.$refs.rightPanel.query = '';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_transfer_src_mainvue_type_script_lang_js_ = (transfer_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/transfer/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var transfer_src_main_component = normalizeComponent(
	  packages_transfer_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5c654dd8_render,
	  mainvue_type_template_id_5c654dd8_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var transfer_src_main_api; }
	transfer_src_main_component.options.__file = "packages/transfer/src/main.vue"
	/* harmony default export */ var transfer_src_main = (transfer_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/transfer/index.js
	
	
	/* istanbul ignore next */
	transfer_src_main.install = function (Vue) {
	  Vue.component(transfer_src_main.name, transfer_src_main);
	};
	
	/* harmony default export */ var transfer = (transfer_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=template&id=5bf181d4&
	var mainvue_type_template_id_5bf181d4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "section",
	    { staticClass: "el-container", class: { "is-vertical": _vm.isVertical } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_5bf181d4_staticRenderFns = []
	mainvue_type_template_id_5bf181d4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=template&id=5bf181d4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var container_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElContainer',
	
	  componentName: 'ElContainer',
	
	  props: {
	    direction: String
	  },
	
	  computed: {
	    isVertical: function isVertical() {
	      if (this.direction === 'vertical') {
	        return true;
	      } else if (this.direction === 'horizontal') {
	        return false;
	      }
	      return this.$slots && this.$slots.default ? this.$slots.default.some(function (vnode) {
	        var tag = vnode.componentOptions && vnode.componentOptions.tag;
	        return tag === 'el-header' || tag === 'el-footer';
	      }) : false;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_container_src_mainvue_type_script_lang_js_ = (container_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/container/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var container_src_main_component = normalizeComponent(
	  packages_container_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5bf181d4_render,
	  mainvue_type_template_id_5bf181d4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var container_src_main_api; }
	container_src_main_component.options.__file = "packages/container/src/main.vue"
	/* harmony default export */ var container_src_main = (container_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/container/index.js
	
	
	/* istanbul ignore next */
	container_src_main.install = function (Vue) {
	  Vue.component(container_src_main.name, container_src_main);
	};
	
	/* harmony default export */ var packages_container = (container_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=template&id=2b296ab2&
	var mainvue_type_template_id_2b296ab2_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "header",
	    { staticClass: "el-header", style: { height: _vm.height } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_2b296ab2_staticRenderFns = []
	mainvue_type_template_id_2b296ab2_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=template&id=2b296ab2&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var header_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElHeader',
	
	  componentName: 'ElHeader',
	
	  props: {
	    height: {
	      type: String,
	      default: '60px'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_header_src_mainvue_type_script_lang_js_ = (header_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/header/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var header_src_main_component = normalizeComponent(
	  packages_header_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_2b296ab2_render,
	  mainvue_type_template_id_2b296ab2_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var header_src_main_api; }
	header_src_main_component.options.__file = "packages/header/src/main.vue"
	/* harmony default export */ var header_src_main = (header_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/header/index.js
	
	
	/* istanbul ignore next */
	header_src_main.install = function (Vue) {
	  Vue.component(header_src_main.name, header_src_main);
	};
	
	/* harmony default export */ var header = (header_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=template&id=03411dbf&
	var mainvue_type_template_id_03411dbf_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "aside",
	    { staticClass: "el-aside", style: { width: _vm.width } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_03411dbf_staticRenderFns = []
	mainvue_type_template_id_03411dbf_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=template&id=03411dbf&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var aside_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElAside',
	
	  componentName: 'ElAside',
	
	  props: {
	    width: {
	      type: String,
	      default: '300px'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_aside_src_mainvue_type_script_lang_js_ = (aside_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/aside/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var aside_src_main_component = normalizeComponent(
	  packages_aside_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_03411dbf_render,
	  mainvue_type_template_id_03411dbf_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var aside_src_main_api; }
	aside_src_main_component.options.__file = "packages/aside/src/main.vue"
	/* harmony default export */ var aside_src_main = (aside_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/aside/index.js
	
	
	/* istanbul ignore next */
	aside_src_main.install = function (Vue) {
	  Vue.component(aside_src_main.name, aside_src_main);
	};
	
	/* harmony default export */ var aside = (aside_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=template&id=2a3a7406&
	var mainvue_type_template_id_2a3a7406_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("main", { staticClass: "el-main" }, [_vm._t("default")], 2)
	}
	var mainvue_type_template_id_2a3a7406_staticRenderFns = []
	mainvue_type_template_id_2a3a7406_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=template&id=2a3a7406&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var main_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElMain',
	  componentName: 'ElMain'
	});
	// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_main_src_mainvue_type_script_lang_js_ = (main_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/main/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var main_src_main_component = normalizeComponent(
	  packages_main_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_2a3a7406_render,
	  mainvue_type_template_id_2a3a7406_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var main_src_main_api; }
	main_src_main_component.options.__file = "packages/main/src/main.vue"
	/* harmony default export */ var main_src_main = (main_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/main/index.js
	
	
	/* istanbul ignore next */
	main_src_main.install = function (Vue) {
	  Vue.component(main_src_main.name, main_src_main);
	};
	
	/* harmony default export */ var packages_main = (main_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=template&id=80210338&
	var mainvue_type_template_id_80210338_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "footer",
	    { staticClass: "el-footer", style: { height: _vm.height } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_80210338_staticRenderFns = []
	mainvue_type_template_id_80210338_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=template&id=80210338&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var footer_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElFooter',
	
	  componentName: 'ElFooter',
	
	  props: {
	    height: {
	      type: String,
	      default: '60px'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_footer_src_mainvue_type_script_lang_js_ = (footer_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/footer/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var footer_src_main_component = normalizeComponent(
	  packages_footer_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_80210338_render,
	  mainvue_type_template_id_80210338_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var footer_src_main_api; }
	footer_src_main_component.options.__file = "packages/footer/src/main.vue"
	/* harmony default export */ var footer_src_main = (footer_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/footer/index.js
	
	
	/* istanbul ignore next */
	footer_src_main.install = function (Vue) {
	  Vue.component(footer_src_main.name, footer_src_main);
	};
	
	/* harmony default export */ var footer = (footer_src_main);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/main.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var timeline_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElTimeline',
	
	  props: {
	    reverse: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  provide: function provide() {
	    return {
	      timeline: this
	    };
	  },
	  render: function render() {
	    var h = arguments[0];
	
	    var reverse = this.reverse;
	    var classes = {
	      'el-timeline': true,
	      'is-reverse': reverse
	    };
	    var slots = this.$slots.default || [];
	    if (reverse) {
	      slots = slots.reverse();
	    }
	    return h(
	      'ul',
	      { 'class': classes },
	      [slots]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/timeline/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_timeline_src_mainvue_type_script_lang_js_ = (timeline_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/timeline/src/main.vue
	var main_render, main_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var timeline_src_main_component = normalizeComponent(
	  packages_timeline_src_mainvue_type_script_lang_js_,
	  main_render,
	  main_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var timeline_src_main_api; }
	timeline_src_main_component.options.__file = "packages/timeline/src/main.vue"
	/* harmony default export */ var timeline_src_main = (timeline_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/timeline/index.js
	
	
	/* istanbul ignore next */
	timeline_src_main.install = function (Vue) {
	  Vue.component(timeline_src_main.name, timeline_src_main);
	};
	
	/* harmony default export */ var timeline = (timeline_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&
	var itemvue_type_template_id_61a69e50_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("li", { staticClass: "el-timeline-item" }, [
	    _c("div", { staticClass: "el-timeline-item__tail" }),
	    !_vm.$slots.dot
	      ? _c(
	          "div",
	          {
	            staticClass: "el-timeline-item__node",
	            class: [
	              "el-timeline-item__node--" + (_vm.size || ""),
	              "el-timeline-item__node--" + (_vm.type || "")
	            ],
	            style: {
	              backgroundColor: _vm.color
	            }
	          },
	          [
	            _vm.icon
	              ? _c("i", {
	                  staticClass: "el-timeline-item__icon",
	                  class: _vm.icon
	                })
	              : _vm._e()
	          ]
	        )
	      : _vm._e(),
	    _vm.$slots.dot
	      ? _c("div", { staticClass: "el-timeline-item__dot" }, [_vm._t("dot")], 2)
	      : _vm._e(),
	    _c("div", { staticClass: "el-timeline-item__wrapper" }, [
	      !_vm.hideTimestamp && _vm.placement === "top"
	        ? _c("div", { staticClass: "el-timeline-item__timestamp is-top" }, [
	            _vm._v("\n      " + _vm._s(_vm.timestamp) + "\n    ")
	          ])
	        : _vm._e(),
	      _c(
	        "div",
	        { staticClass: "el-timeline-item__content" },
	        [_vm._t("default")],
	        2
	      ),
	      !_vm.hideTimestamp && _vm.placement === "bottom"
	        ? _c("div", { staticClass: "el-timeline-item__timestamp is-bottom" }, [
	            _vm._v("\n      " + _vm._s(_vm.timestamp) + "\n    ")
	          ])
	        : _vm._e()
	    ])
	  ])
	}
	var itemvue_type_template_id_61a69e50_staticRenderFns = []
	itemvue_type_template_id_61a69e50_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var timeline_src_itemvue_type_script_lang_js_ = ({
	  name: 'ElTimelineItem',
	
	  inject: ['timeline'],
	
	  props: {
	    timestamp: String,
	
	    hideTimestamp: {
	      type: Boolean,
	      default: false
	    },
	
	    placement: {
	      type: String,
	      default: 'bottom'
	    },
	
	    type: String,
	
	    color: String,
	
	    size: {
	      type: String,
	      default: 'normal'
	    },
	
	    icon: String
	  }
	});
	// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_timeline_src_itemvue_type_script_lang_js_ = (timeline_src_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/timeline/src/item.vue
	
	
	
	
	
	/* normalize component */
	
	var src_item_component = normalizeComponent(
	  packages_timeline_src_itemvue_type_script_lang_js_,
	  itemvue_type_template_id_61a69e50_render,
	  itemvue_type_template_id_61a69e50_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_item_api; }
	src_item_component.options.__file = "packages/timeline/src/item.vue"
	/* harmony default export */ var timeline_src_item = (src_item_component.exports);
	// CONCATENATED MODULE: ./packages/timeline-item/index.js
	
	
	/* istanbul ignore next */
	timeline_src_item.install = function (Vue) {
	  Vue.component(timeline_src_item.name, timeline_src_item);
	};
	
	/* harmony default export */ var timeline_item = (timeline_src_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=template&id=01cf3b65&
	var mainvue_type_template_id_01cf3b65_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "a",
	    _vm._b(
	      {
	        class: [
	          "el-link",
	          _vm.type ? "el-link--" + _vm.type : "",
	          _vm.disabled && "is-disabled",
	          _vm.underline && !_vm.disabled && "is-underline"
	        ],
	        attrs: { href: _vm.disabled ? null : _vm.href },
	        on: { click: _vm.handleClick }
	      },
	      "a",
	      _vm.$attrs,
	      false
	    ),
	    [
	      _vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(),
	      _vm.$slots.default
	        ? _c("span", { staticClass: "el-link--inner" }, [_vm._t("default")], 2)
	        : _vm._e(),
	      _vm.$slots.icon ? [_vm.$slots.icon ? _vm._t("icon") : _vm._e()] : _vm._e()
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_01cf3b65_staticRenderFns = []
	mainvue_type_template_id_01cf3b65_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=template&id=01cf3b65&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	/* harmony default export */ var link_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElLink',
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    underline: {
	      type: Boolean,
	      default: true
	    },
	    disabled: Boolean,
	    href: String,
	    icon: String
	  },
	
	  methods: {
	    handleClick: function handleClick(event) {
	      if (!this.disabled) {
	        if (!this.href) {
	          this.$emit('click', event);
	        }
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_link_src_mainvue_type_script_lang_js_ = (link_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/link/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var link_src_main_component = normalizeComponent(
	  packages_link_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_01cf3b65_render,
	  mainvue_type_template_id_01cf3b65_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var link_src_main_api; }
	link_src_main_component.options.__file = "packages/link/src/main.vue"
	/* harmony default export */ var link_src_main = (link_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/link/index.js
	
	
	/* istanbul ignore next */
	link_src_main.install = function (Vue) {
	  Vue.component(link_src_main.name, link_src_main);
	};
	
	/* harmony default export */ var packages_link = (link_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&
	var mainvue_type_template_id_7fa02a7e_functional_true_render = function(_h, _vm) {
	  var _c = _vm._c
	  return _c(
	    "div",
	    _vm._g(
	      _vm._b(
	        {
	          class: [
	            _vm.data.staticClass,
	            "el-divider",
	            "el-divider--" + _vm.props.direction
	          ]
	        },
	        "div",
	        _vm.data.attrs,
	        false
	      ),
	      _vm.listeners
	    ),
	    [
	      _vm.slots().default && _vm.props.direction !== "vertical"
	        ? _c(
	            "div",
	            { class: ["el-divider__text", "is-" + _vm.props.contentPosition] },
	            [_vm._t("default")],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns = []
	mainvue_type_template_id_7fa02a7e_functional_true_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var divider_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElDivider',
	  props: {
	    direction: {
	      type: String,
	      default: 'horizontal',
	      validator: function validator(val) {
	        return ['horizontal', 'vertical'].indexOf(val) !== -1;
	      }
	    },
	    contentPosition: {
	      type: String,
	      default: 'center',
	      validator: function validator(val) {
	        return ['left', 'center', 'right'].indexOf(val) !== -1;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_divider_src_mainvue_type_script_lang_js_ = (divider_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/divider/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var divider_src_main_component = normalizeComponent(
	  packages_divider_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_7fa02a7e_functional_true_render,
	  mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns,
	  true,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var divider_src_main_api; }
	divider_src_main_component.options.__file = "packages/divider/src/main.vue"
	/* harmony default export */ var divider_src_main = (divider_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/divider/index.js
	
	
	/* istanbul ignore next */
	divider_src_main.install = function (Vue) {
	  Vue.component(divider_src_main.name, divider_src_main);
	};
	
	/* harmony default export */ var divider = (divider_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=template&id=44d84a7c&
	var mainvue_type_template_id_44d84a7c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    { staticClass: "el-image" },
	    [
	      _vm.loading
	        ? _vm._t("placeholder", [
	            _c("div", { staticClass: "el-image__placeholder" })
	          ])
	        : _vm.error
	        ? _vm._t("error", [
	            _c("div", { staticClass: "el-image__error" }, [
	              _vm._v(_vm._s(_vm.t("el.image.error")))
	            ])
	          ])
	        : _c(
	            "img",
	            _vm._g(
	              _vm._b(
	                {
	                  staticClass: "el-image__inner",
	                  class: {
	                    "el-image__inner--center": _vm.alignCenter,
	                    "el-image__preview": _vm.preview
	                  },
	                  style: _vm.imageStyle,
	                  attrs: { src: _vm.src },
	                  on: { click: _vm.clickHandler }
	                },
	                "img",
	                _vm.$attrs,
	                false
	              ),
	              _vm.$listeners
	            )
	          ),
	      _vm.preview
	        ? [
	            _vm.showViewer
	              ? _c("image-viewer", {
	                  attrs: {
	                    "z-index": _vm.zIndex,
	                    "initial-index": _vm.imageIndex,
	                    "on-close": _vm.closeViewer,
	                    "url-list": _vm.previewSrcList
	                  }
	                })
	              : _vm._e()
	          ]
	        : _vm._e()
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_44d84a7c_staticRenderFns = []
	mainvue_type_template_id_44d84a7c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=template&id=44d84a7c&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&
	var image_viewervue_type_template_id_5e73b307_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "viewer-fade" } }, [
	    _c(
	      "div",
	      {
	        ref: "el-image-viewer__wrapper",
	        staticClass: "el-image-viewer__wrapper",
	        style: { "z-index": _vm.zIndex },
	        attrs: { tabindex: "-1" }
	      },
	      [
	        _c("div", {
	          staticClass: "el-image-viewer__mask",
	          on: {
	            click: function($event) {
	              if ($event.target !== $event.currentTarget) {
	                return null
	              }
	              return _vm.handleMaskClick($event)
	            }
	          }
	        }),
	        _c(
	          "span",
	          {
	            staticClass: "el-image-viewer__btn el-image-viewer__close",
	            on: { click: _vm.hide }
	          },
	          [_c("i", { staticClass: "el-icon-close" })]
	        ),
	        !_vm.isSingle
	          ? [
	              _c(
	                "span",
	                {
	                  staticClass: "el-image-viewer__btn el-image-viewer__prev",
	                  class: { "is-disabled": !_vm.infinite && _vm.isFirst },
	                  on: { click: _vm.prev }
	                },
	                [_c("i", { staticClass: "el-icon-arrow-left" })]
	              ),
	              _c(
	                "span",
	                {
	                  staticClass: "el-image-viewer__btn el-image-viewer__next",
	                  class: { "is-disabled": !_vm.infinite && _vm.isLast },
	                  on: { click: _vm.next }
	                },
	                [_c("i", { staticClass: "el-icon-arrow-right" })]
	              )
	            ]
	          : _vm._e(),
	        _c(
	          "div",
	          { staticClass: "el-image-viewer__btn el-image-viewer__actions" },
	          [
	            _c("div", { staticClass: "el-image-viewer__actions__inner" }, [
	              _c("i", {
	                staticClass: "el-icon-zoom-out",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("zoomOut")
	                  }
	                }
	              }),
	              _c("i", {
	                staticClass: "el-icon-zoom-in",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("zoomIn")
	                  }
	                }
	              }),
	              _c("i", { staticClass: "el-image-viewer__actions__divider" }),
	              _c("i", { class: _vm.mode.icon, on: { click: _vm.toggleMode } }),
	              _c("i", { staticClass: "el-image-viewer__actions__divider" }),
	              _c("i", {
	                staticClass: "el-icon-refresh-left",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("anticlocelise")
	                  }
	                }
	              }),
	              _c("i", {
	                staticClass: "el-icon-refresh-right",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("clocelise")
	                  }
	                }
	              })
	            ])
	          ]
	        ),
	        _c(
	          "div",
	          { staticClass: "el-image-viewer__canvas" },
	          _vm._l(_vm.urlList, function(url, i) {
	            return i === _vm.index
	              ? _c("img", {
	                  key: url,
	                  ref: "img",
	                  refInFor: true,
	                  staticClass: "el-image-viewer__img",
	                  style: _vm.imgStyle,
	                  attrs: { src: _vm.currentImg },
	                  on: {
	                    load: _vm.handleImgLoad,
	                    error: _vm.handleImgError,
	                    mousedown: _vm.handleMouseDown
	                  }
	                })
	              : _vm._e()
	          }),
	          0
	        )
	      ],
	      2
	    )
	  ])
	}
	var image_viewervue_type_template_id_5e73b307_staticRenderFns = []
	image_viewervue_type_template_id_5e73b307_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
	var image_viewervue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	var Mode = {
	  CONTAIN: {
	    name: 'contain',
	    icon: 'el-icon-full-screen'
	  },
	  ORIGINAL: {
	    name: 'original',
	    icon: 'el-icon-c-scale-to-original'
	  }
	};
	
	var mousewheelEventName = Object(util_["isFirefox"])() ? 'DOMMouseScroll' : 'mousewheel';
	
	/* harmony default export */ var image_viewervue_type_script_lang_js_ = ({
	  name: 'elImageViewer',
	
	  props: {
	    urlList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    zIndex: {
	      type: Number,
	      default: 2000
	    },
	    onSwitch: {
	      type: Function,
	      default: function _default() {}
	    },
	    onClose: {
	      type: Function,
	      default: function _default() {}
	    },
	    initialIndex: {
	      type: Number,
	      default: 0
	    },
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    maskClosable: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      index: this.initialIndex,
	      isShow: false,
	      infinite: true,
	      loading: false,
	      mode: Mode.CONTAIN,
	      transform: {
	        scale: 1,
	        deg: 0,
	        offsetX: 0,
	        offsetY: 0,
	        enableTransition: false
	      }
	    };
	  },
	
	  computed: {
	    isSingle: function isSingle() {
	      return this.urlList.length <= 1;
	    },
	    isFirst: function isFirst() {
	      return this.index === 0;
	    },
	    isLast: function isLast() {
	      return this.index === this.urlList.length - 1;
	    },
	    currentImg: function currentImg() {
	      return this.urlList[this.index];
	    },
	    imgStyle: function imgStyle() {
	      var _transform = this.transform,
	          scale = _transform.scale,
	          deg = _transform.deg,
	          offsetX = _transform.offsetX,
	          offsetY = _transform.offsetY,
	          enableTransition = _transform.enableTransition;
	
	      var style = {
	        transform: 'scale(' + scale + ') rotate(' + deg + 'deg)',
	        transition: enableTransition ? 'transform .3s' : '',
	        'margin-left': offsetX + 'px',
	        'margin-top': offsetY + 'px'
	      };
	      if (this.mode === Mode.CONTAIN) {
	        style.maxWidth = style.maxHeight = '100%';
	      }
	      return style;
	    }
	  },
	  watch: {
	    index: {
	      handler: function handler(val) {
	        this.reset();
	        this.onSwitch(val);
	      }
	    },
	    currentImg: function currentImg(val) {
	      var _this = this;
	
	      this.$nextTick(function (_) {
	        var $img = _this.$refs.img[0];
	        if (!$img.complete) {
	          _this.loading = true;
	        }
	      });
	    }
	  },
	  methods: {
	    hide: function hide() {
	      this.deviceSupportUninstall();
	      this.onClose();
	    },
	    deviceSupportInstall: function deviceSupportInstall() {
	      var _this2 = this;
	
	      this._keyDownHandler = Object(util_["rafThrottle"])(function (e) {
	        var keyCode = e.keyCode;
	        switch (keyCode) {
	          // ESC
	          case 27:
	            _this2.hide();
	            break;
	          // SPACE
	          case 32:
	            _this2.toggleMode();
	            break;
	          // LEFT_ARROW
	          case 37:
	            _this2.prev();
	            break;
	          // UP_ARROW
	          case 38:
	            _this2.handleActions('zoomIn');
	            break;
	          // RIGHT_ARROW
	          case 39:
	            _this2.next();
	            break;
	          // DOWN_ARROW
	          case 40:
	            _this2.handleActions('zoomOut');
	            break;
	        }
	      });
	      this._mouseWheelHandler = Object(util_["rafThrottle"])(function (e) {
	        var delta = e.wheelDelta ? e.wheelDelta : -e.detail;
	        if (delta > 0) {
	          _this2.handleActions('zoomIn', {
	            zoomRate: 0.015,
	            enableTransition: false
	          });
	        } else {
	          _this2.handleActions('zoomOut', {
	            zoomRate: 0.015,
	            enableTransition: false
	          });
	        }
	      });
	      Object(dom_["on"])(document, 'keydown', this._keyDownHandler);
	      Object(dom_["on"])(document, mousewheelEventName, this._mouseWheelHandler);
	    },
	    deviceSupportUninstall: function deviceSupportUninstall() {
	      Object(dom_["off"])(document, 'keydown', this._keyDownHandler);
	      Object(dom_["off"])(document, mousewheelEventName, this._mouseWheelHandler);
	      this._keyDownHandler = null;
	      this._mouseWheelHandler = null;
	    },
	    handleImgLoad: function handleImgLoad(e) {
	      this.loading = false;
	    },
	    handleImgError: function handleImgError(e) {
	      this.loading = false;
	      e.target.alt = '加载失败';
	    },
	    handleMouseDown: function handleMouseDown(e) {
	      var _this3 = this;
	
	      if (this.loading || e.button !== 0) return;
	
	      var _transform2 = this.transform,
	          offsetX = _transform2.offsetX,
	          offsetY = _transform2.offsetY;
	
	      var startX = e.pageX;
	      var startY = e.pageY;
	      this._dragHandler = Object(util_["rafThrottle"])(function (ev) {
	        _this3.transform.offsetX = offsetX + ev.pageX - startX;
	        _this3.transform.offsetY = offsetY + ev.pageY - startY;
	      });
	      Object(dom_["on"])(document, 'mousemove', this._dragHandler);
	      Object(dom_["on"])(document, 'mouseup', function (ev) {
	        Object(dom_["off"])(document, 'mousemove', _this3._dragHandler);
	      });
	
	      e.preventDefault();
	    },
	    handleMaskClick: function handleMaskClick() {
	      if (this.maskClosable) {
	        this.hide();
	      }
	    },
	    reset: function reset() {
	      this.transform = {
	        scale: 1,
	        deg: 0,
	        offsetX: 0,
	        offsetY: 0,
	        enableTransition: false
	      };
	    },
	    toggleMode: function toggleMode() {
	      if (this.loading) return;
	
	      var modeNames = Object.keys(Mode);
	      var modeValues = Object.values(Mode);
	      var index = modeValues.indexOf(this.mode);
	      var nextIndex = (index + 1) % modeNames.length;
	      this.mode = Mode[modeNames[nextIndex]];
	      this.reset();
	    },
	    prev: function prev() {
	      if (this.isFirst && !this.infinite) return;
	      var len = this.urlList.length;
	      this.index = (this.index - 1 + len) % len;
	    },
	    next: function next() {
	      if (this.isLast && !this.infinite) return;
	      var len = this.urlList.length;
	      this.index = (this.index + 1) % len;
	    },
	    handleActions: function handleActions(action) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.loading) return;
	
	      var _zoomRate$rotateDeg$e = image_viewervue_type_script_lang_js_extends({
	        zoomRate: 0.2,
	        rotateDeg: 90,
	        enableTransition: true
	      }, options),
	          zoomRate = _zoomRate$rotateDeg$e.zoomRate,
	          rotateDeg = _zoomRate$rotateDeg$e.rotateDeg,
	          enableTransition = _zoomRate$rotateDeg$e.enableTransition;
	
	      var transform = this.transform;
	
	      switch (action) {
	        case 'zoomOut':
	          if (transform.scale > 0.2) {
	            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
	          }
	          break;
	        case 'zoomIn':
	          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
	          break;
	        case 'clocelise':
	          transform.deg += rotateDeg;
	          break;
	        case 'anticlocelise':
	          transform.deg -= rotateDeg;
	          break;
	      }
	      transform.enableTransition = enableTransition;
	    }
	  },
	  mounted: function mounted() {
	    this.deviceSupportInstall();
	    if (this.appendToBody) {
	      document.body.appendChild(this.$el);
	    }
	    // add tabindex then wrapper can be focusable via Javascript
	    // focus wrapper so arrow key can't cause inner scroll behavior underneath
	    this.$refs['el-image-viewer__wrapper'].focus();
	  },
	  destroyed: function destroyed() {
	    // if appendToBody is true, remove DOM node after destroy
	    if (this.appendToBody && this.$el && this.$el.parentNode) {
	      this.$el.parentNode.removeChild(this.$el);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_image_viewervue_type_script_lang_js_ = (image_viewervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue
	
	
	
	
	
	/* normalize component */
	
	var image_viewer_component = normalizeComponent(
	  src_image_viewervue_type_script_lang_js_,
	  image_viewervue_type_template_id_5e73b307_render,
	  image_viewervue_type_template_id_5e73b307_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var image_viewer_api; }
	image_viewer_component.options.__file = "packages/image/src/image-viewer.vue"
	/* harmony default export */ var image_viewer = (image_viewer_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	var isSupportObjectFit = function isSupportObjectFit() {
	  return document.documentElement.style.objectFit !== undefined;
	};
	
	var ObjectFit = {
	  NONE: 'none',
	  CONTAIN: 'contain',
	  COVER: 'cover',
	  FILL: 'fill',
	  SCALE_DOWN: 'scale-down'
	};
	
	var prevOverflow = '';
	
	/* harmony default export */ var image_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElImage',
	
	  mixins: [locale_default.a],
	  inheritAttrs: false,
	
	  components: {
	    ImageViewer: image_viewer
	  },
	
	  props: {
	    src: String,
	    fit: String,
	    lazy: Boolean,
	    scrollContainer: {},
	    previewSrcList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    zIndex: {
	      type: Number,
	      default: 2000
	    }
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      error: false,
	      show: !this.lazy,
	      imageWidth: 0,
	      imageHeight: 0,
	      showViewer: false
	    };
	  },
	
	
	  computed: {
	    imageStyle: function imageStyle() {
	      var fit = this.fit;
	
	      if (!this.$isServer && fit) {
	        return isSupportObjectFit() ? { 'object-fit': fit } : this.getImageStyle(fit);
	      }
	      return {};
	    },
	    alignCenter: function alignCenter() {
	      return !this.$isServer && !isSupportObjectFit() && this.fit !== ObjectFit.FILL;
	    },
	    preview: function preview() {
	      var previewSrcList = this.previewSrcList;
	
	      return Array.isArray(previewSrcList) && previewSrcList.length > 0;
	    },
	    imageIndex: function imageIndex() {
	      var previewIndex = 0;
	      var srcIndex = this.previewSrcList.indexOf(this.src);
	      if (srcIndex >= 0) {
	        previewIndex = srcIndex;
	      }
	      return previewIndex;
	    }
	  },
	
	  watch: {
	    src: function src(val) {
	      this.show && this.loadImage();
	    },
	    show: function show(val) {
	      val && this.loadImage();
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.lazy) {
	      this.addLazyLoadListener();
	    } else {
	      this.loadImage();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.lazy && this.removeLazyLoadListener();
	  },
	
	
	  methods: {
	    loadImage: function loadImage() {
	      var _this = this;
	
	      if (this.$isServer) return;
	
	      // reset status
	      this.loading = true;
	      this.error = false;
	
	      var img = new Image();
	      img.onload = function (e) {
	        return _this.handleLoad(e, img);
	      };
	      img.onerror = this.handleError.bind(this);
	
	      // bind html attrs
	      // so it can behave consistently
	      Object.keys(this.$attrs).forEach(function (key) {
	        var value = _this.$attrs[key];
	        img.setAttribute(key, value);
	      });
	      img.src = this.src;
	    },
	    handleLoad: function handleLoad(e, img) {
	      this.imageWidth = img.width;
	      this.imageHeight = img.height;
	      this.loading = false;
	      this.error = false;
	    },
	    handleError: function handleError(e) {
	      this.loading = false;
	      this.error = true;
	      this.$emit('error', e);
	    },
	    handleLazyLoad: function handleLazyLoad() {
	      if (Object(dom_["isInContainer"])(this.$el, this._scrollContainer)) {
	        this.show = true;
	        this.removeLazyLoadListener();
	      }
	    },
	    addLazyLoadListener: function addLazyLoadListener() {
	      if (this.$isServer) return;
	
	      var scrollContainer = this.scrollContainer;
	
	      var _scrollContainer = null;
	
	      if (Object(types_["isHtmlElement"])(scrollContainer)) {
	        _scrollContainer = scrollContainer;
	      } else if (Object(types_["isString"])(scrollContainer)) {
	        _scrollContainer = document.querySelector(scrollContainer);
	      } else {
	        _scrollContainer = Object(dom_["getScrollContainer"])(this.$el);
	      }
	
	      if (_scrollContainer) {
	        this._scrollContainer = _scrollContainer;
	        this._lazyLoadHandler = throttle_default()(200, this.handleLazyLoad);
	        Object(dom_["on"])(_scrollContainer, 'scroll', this._lazyLoadHandler);
	        this.handleLazyLoad();
	      }
	    },
	    removeLazyLoadListener: function removeLazyLoadListener() {
	      var _scrollContainer = this._scrollContainer,
	          _lazyLoadHandler = this._lazyLoadHandler;
	
	
	      if (this.$isServer || !_scrollContainer || !_lazyLoadHandler) return;
	
	      Object(dom_["off"])(_scrollContainer, 'scroll', _lazyLoadHandler);
	      this._scrollContainer = null;
	      this._lazyLoadHandler = null;
	    },
	
	    /**
	     * simulate object-fit behavior to compatible with IE11 and other browsers which not support object-fit
	     */
	    getImageStyle: function getImageStyle(fit) {
	      var imageWidth = this.imageWidth,
	          imageHeight = this.imageHeight;
	      var _$el = this.$el,
	          containerWidth = _$el.clientWidth,
	          containerHeight = _$el.clientHeight;
	
	
	      if (!imageWidth || !imageHeight || !containerWidth || !containerHeight) return {};
	
	      var vertical = imageWidth / imageHeight < 1;
	
	      if (fit === ObjectFit.SCALE_DOWN) {
	        var isSmaller = imageWidth < containerWidth && imageHeight < containerHeight;
	        fit = isSmaller ? ObjectFit.NONE : ObjectFit.CONTAIN;
	      }
	
	      switch (fit) {
	        case ObjectFit.NONE:
	          return { width: 'auto', height: 'auto' };
	        case ObjectFit.CONTAIN:
	          return vertical ? { width: 'auto' } : { height: 'auto' };
	        case ObjectFit.COVER:
	          return vertical ? { height: 'auto' } : { width: 'auto' };
	        default:
	          return {};
	      }
	    },
	    clickHandler: function clickHandler() {
	      // don't show viewer when preview is false
	      if (!this.preview) {
	        return;
	      }
	      // prevent body scroll
	      prevOverflow = document.body.style.overflow;
	      document.body.style.overflow = 'hidden';
	      this.showViewer = true;
	    },
	    closeViewer: function closeViewer() {
	      document.body.style.overflow = prevOverflow;
	      this.showViewer = false;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_image_src_mainvue_type_script_lang_js_ = (image_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/image/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var image_src_main_component = normalizeComponent(
	  packages_image_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_44d84a7c_render,
	  mainvue_type_template_id_44d84a7c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var image_src_main_api; }
	image_src_main_component.options.__file = "packages/image/src/main.vue"
	/* harmony default export */ var image_src_main = (image_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/image/index.js
	
	
	/* istanbul ignore next */
	image_src_main.install = function (Vue) {
	  Vue.component(image_src_main.name, image_src_main);
	};
	
	/* harmony default export */ var packages_image = (image_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&
	var mainvue_type_template_id_6d9756be_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-calendar" }, [
	    _c("div", { staticClass: "el-calendar__header" }, [
	      _c("div", { staticClass: "el-calendar__title" }, [
	        _vm._v("\n      " + _vm._s(_vm.i18nDate) + "\n    ")
	      ]),
	      _vm.validatedRange.length === 0
	        ? _c(
	            "div",
	            { staticClass: "el-calendar__button-group" },
	            [
	              _c(
	                "el-button-group",
	                [
	                  _c(
	                    "el-button",
	                    {
	                      attrs: { type: "plain", size: "mini" },
	                      on: {
	                        click: function($event) {
	                          _vm.selectDate("prev-month")
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.t("el.datepicker.prevMonth")) +
	                          "\n        "
	                      )
	                    ]
	                  ),
	                  _c(
	                    "el-button",
	                    {
	                      attrs: { type: "plain", size: "mini" },
	                      on: {
	                        click: function($event) {
	                          _vm.selectDate("today")
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.t("el.datepicker.today")) +
	                          "\n        "
	                      )
	                    ]
	                  ),
	                  _c(
	                    "el-button",
	                    {
	                      attrs: { type: "plain", size: "mini" },
	                      on: {
	                        click: function($event) {
	                          _vm.selectDate("next-month")
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.t("el.datepicker.nextMonth")) +
	                          "\n        "
	                      )
	                    ]
	                  )
	                ],
	                1
	              )
	            ],
	            1
	          )
	        : _vm._e()
	    ]),
	    _vm.validatedRange.length === 0
	      ? _c(
	          "div",
	          { key: "no-range", staticClass: "el-calendar__body" },
	          [
	            _c("date-table", {
	              attrs: {
	                date: _vm.date,
	                "selected-day": _vm.realSelectedDay,
	                "first-day-of-week": _vm.realFirstDayOfWeek
	              },
	              on: { pick: _vm.pickDay }
	            })
	          ],
	          1
	        )
	      : _c(
	          "div",
	          { key: "has-range", staticClass: "el-calendar__body" },
	          _vm._l(_vm.validatedRange, function(range, index) {
	            return _c("date-table", {
	              key: index,
	              attrs: {
	                date: range[0],
	                "selected-day": _vm.realSelectedDay,
	                range: range,
	                "hide-header": index !== 0,
	                "first-day-of-week": _vm.realFirstDayOfWeek
	              },
	              on: { pick: _vm.pickDay }
	            })
	          }),
	          1
	        )
	  ])
	}
	var mainvue_type_template_id_6d9756be_staticRenderFns = []
	mainvue_type_template_id_6d9756be_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/date"
	var date_ = __webpack_require__(20);
	var date_default = /*#__PURE__*/__webpack_require__.n(date_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/date-table.vue?vue&type=script&lang=js&
	
	
	
	
	/* harmony default export */ var src_date_tablevue_type_script_lang_js_ = ({
	  props: {
	    selectedDay: String, // formated date yyyy-MM-dd
	    range: {
	      type: Array,
	      validator: function validator(val) {
	        if (!(val && val.length)) return true;
	        var start = val[0],
	            end = val[1];
	
	        return Object(date_util_["validateRangeInOneMonth"])(start, end);
	      }
	    },
	    date: Date,
	    hideHeader: Boolean,
	    firstDayOfWeek: Number
	  },
	
	  inject: ['elCalendar'],
	
	  data: function data() {
	    return {
	      WEEK_DAYS: Object(date_util_["getI18nSettings"])().dayNames
	    };
	  },
	
	
	  methods: {
	    toNestedArr: function toNestedArr(days) {
	      return Object(date_util_["range"])(days.length / 7).map(function (_, index) {
	        var start = index * 7;
	        return days.slice(start, start + 7);
	      });
	    },
	    getFormateDate: function getFormateDate(day, type) {
	      if (!day || ['prev', 'current', 'next'].indexOf(type) === -1) {
	        throw new Error('invalid day or type');
	      }
	      var prefix = this.curMonthDatePrefix;
	      if (type === 'prev') {
	        prefix = this.prevMonthDatePrefix;
	      } else if (type === 'next') {
	        prefix = this.nextMonthDatePrefix;
	      }
	      day = ('00' + day).slice(-2);
	      return prefix + '-' + day;
	    },
	    getCellClass: function getCellClass(_ref) {
	      var text = _ref.text,
	          type = _ref.type;
	
	      var classes = [type];
	      if (type === 'current') {
	        var date = this.getFormateDate(text, type);
	        if (date === this.selectedDay) {
	          classes.push('is-selected');
	        }
	        if (date === this.formatedToday) {
	          classes.push('is-today');
	        }
	      }
	      return classes;
	    },
	    pickDay: function pickDay(_ref2) {
	      var text = _ref2.text,
	          type = _ref2.type;
	
	      var date = this.getFormateDate(text, type);
	      this.$emit('pick', date);
	    },
	    cellRenderProxy: function cellRenderProxy(_ref3) {
	      var text = _ref3.text,
	          type = _ref3.type;
	      var h = this.$createElement;
	
	      var render = this.elCalendar.$scopedSlots.dateCell;
	      if (!render) return h('span', [text]);
	
	      var day = this.getFormateDate(text, type);
	      var date = new Date(day);
	      var data = {
	        isSelected: this.selectedDay === day,
	        type: type + '-month',
	        day: day
	      };
	      return render({ date: date, data: data });
	    }
	  },
	
	  computed: {
	    prevMonthDatePrefix: function prevMonthDatePrefix() {
	      var temp = new Date(this.date.getTime());
	      temp.setDate(0);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    curMonthDatePrefix: function curMonthDatePrefix() {
	      return date_default.a.format(this.date, 'yyyy-MM');
	    },
	    nextMonthDatePrefix: function nextMonthDatePrefix() {
	      var temp = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    formatedToday: function formatedToday() {
	      return this.elCalendar.formatedToday;
	    },
	    isInRange: function isInRange() {
	      return this.range && this.range.length;
	    },
	    rows: function rows() {
	      var days = [];
	      // if range exists, should render days in range.
	      if (this.isInRange) {
	        var _range = this.range,
	            start = _range[0],
	            end = _range[1];
	
	        var currentMonthRange = Object(date_util_["range"])(end.getDate() - start.getDate() + 1).map(function (_, index) {
	          return {
	            text: start.getDate() + index,
	            type: 'current'
	          };
	        });
	        var remaining = currentMonthRange.length % 7;
	        remaining = remaining === 0 ? 0 : 7 - remaining;
	        var nextMonthRange = Object(date_util_["range"])(remaining).map(function (_, index) {
	          return {
	            text: index + 1,
	            type: 'next'
	          };
	        });
	        days = currentMonthRange.concat(nextMonthRange);
	      } else {
	        var date = this.date;
	        var firstDay = Object(date_util_["getFirstDayOfMonth"])(date);
	        firstDay = firstDay === 0 ? 7 : firstDay;
	        var firstDayOfWeek = typeof this.firstDayOfWeek === 'number' ? this.firstDayOfWeek : 1;
	        var prevMonthDays = Object(date_util_["getPrevMonthLastDays"])(date, firstDay - firstDayOfWeek).map(function (day) {
	          return {
	            text: day,
	            type: 'prev'
	          };
	        });
	        var currentMonthDays = Object(date_util_["getMonthDays"])(date).map(function (day) {
	          return {
	            text: day,
	            type: 'current'
	          };
	        });
	        days = [].concat(prevMonthDays, currentMonthDays);
	        var nextMonthDays = Object(date_util_["range"])(42 - days.length).map(function (_, index) {
	          return {
	            text: index + 1,
	            type: 'next'
	          };
	        });
	        days = days.concat(nextMonthDays);
	      }
	      return this.toNestedArr(days);
	    },
	    weekDays: function weekDays() {
	      var start = this.firstDayOfWeek;
	      var WEEK_DAYS = this.WEEK_DAYS;
	
	
	      if (typeof start !== 'number' || start === 0) {
	        return WEEK_DAYS.slice();
	      } else {
	        return WEEK_DAYS.slice(start).concat(WEEK_DAYS.slice(0, start));
	      }
	    }
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var h = arguments[0];
	
	    var thead = this.hideHeader ? null : h('thead', [this.weekDays.map(function (day) {
	      return h(
	        'th',
	        { key: day },
	        [day]
	      );
	    })]);
	    return h(
	      'table',
	      {
	        'class': {
	          'el-calendar-table': true,
	          'is-range': this.isInRange
	        },
	        attrs: { cellspacing: '0',
	          cellpadding: '0' }
	      },
	      [thead, h('tbody', [this.rows.map(function (row, index) {
	        return h(
	          'tr',
	          {
	            'class': {
	              'el-calendar-table__row': true,
	              'el-calendar-table__row--hide-border': index === 0 && _this.hideHeader
	            },
	            key: index },
	          [row.map(function (cell, key) {
	            return h(
	              'td',
	              { key: key,
	                'class': _this.getCellClass(cell),
	                on: {
	                  'click': _this.pickDay.bind(_this, cell)
	                }
	              },
	              [h(
	                'div',
	                { 'class': 'el-calendar-day' },
	                [_this.cellRenderProxy(cell)]
	              )]
	            );
	          })]
	        );
	      })])]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var calendar_src_date_tablevue_type_script_lang_js_ = (src_date_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue
	var date_table_render, date_table_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var src_date_table_component = normalizeComponent(
	  calendar_src_date_tablevue_type_script_lang_js_,
	  date_table_render,
	  date_table_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_date_table_api; }
	src_date_table_component.options.__file = "packages/calendar/src/date-table.vue"
	/* harmony default export */ var src_date_table = (src_date_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var validTypes = ['prev-month', 'today', 'next-month'];
	var weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	var oneDay = 86400000;
	
	/* harmony default export */ var calendar_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElCalendar',
	
	  mixins: [locale_default.a],
	
	  components: {
	    DateTable: src_date_table,
	    ElButton: button_default.a,
	    ElButtonGroup: button_group_default.a
	  },
	
	  props: {
	    value: [Date, String, Number],
	    range: {
	      type: Array,
	      validator: function validator(range) {
	        if (Array.isArray(range)) {
	          return range.length === 2 && range.every(function (item) {
	            return typeof item === 'string' || typeof item === 'number' || item instanceof Date;
	          });
	        } else {
	          return true;
	        }
	      }
	    },
	    firstDayOfWeek: {
	      type: Number,
	      default: 1
	    }
	  },
	
	  provide: function provide() {
	    return {
	      elCalendar: this
	    };
	  },
	
	
	  methods: {
	    pickDay: function pickDay(day) {
	      this.realSelectedDay = day;
	    },
	    selectDate: function selectDate(type) {
	      if (validTypes.indexOf(type) === -1) {
	        throw new Error('invalid type ' + type);
	      }
	      var day = '';
	      if (type === 'prev-month') {
	        day = this.prevMonthDatePrefix + '-01';
	      } else if (type === 'next-month') {
	        day = this.nextMonthDatePrefix + '-01';
	      } else {
	        day = this.formatedToday;
	      }
	
	      if (day === this.formatedDate) return;
	      this.pickDay(day);
	    },
	    toDate: function toDate(val) {
	      if (!val) {
	        throw new Error('invalid val');
	      }
	      return val instanceof Date ? val : new Date(val);
	    },
	    rangeValidator: function rangeValidator(date, isStart) {
	      var firstDayOfWeek = this.realFirstDayOfWeek;
	      var expected = isStart ? firstDayOfWeek : firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
	      var message = (isStart ? 'start' : 'end') + ' of range should be ' + weekDays[expected] + '.';
	      if (date.getDay() !== expected) {
	        console.warn('[ElementCalendar]', message, 'Invalid range will be ignored.');
	        return false;
	      }
	      return true;
	    }
	  },
	
	  computed: {
	    prevMonthDatePrefix: function prevMonthDatePrefix() {
	      var temp = new Date(this.date.getTime());
	      temp.setDate(0);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    curMonthDatePrefix: function curMonthDatePrefix() {
	      return date_default.a.format(this.date, 'yyyy-MM');
	    },
	    nextMonthDatePrefix: function nextMonthDatePrefix() {
	      var temp = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    formatedDate: function formatedDate() {
	      return date_default.a.format(this.date, 'yyyy-MM-dd');
	    },
	    i18nDate: function i18nDate() {
	      var year = this.date.getFullYear();
	      var month = this.date.getMonth() + 1;
	      return year + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + month);
	    },
	    formatedToday: function formatedToday() {
	      return date_default.a.format(this.now, 'yyyy-MM-dd');
	    },
	
	
	    realSelectedDay: {
	      get: function get() {
	        if (!this.value) return this.selectedDay;
	        return this.formatedDate;
	      },
	      set: function set(val) {
	        this.selectedDay = val;
	        var date = new Date(val);
	        this.$emit('input', date);
	      }
	    },
	
	    date: function date() {
	      if (!this.value) {
	        if (this.realSelectedDay) {
	          var d = this.selectedDay.split('-');
	          return new Date(d[0], d[1] - 1, d[2]);
	        } else if (this.validatedRange.length) {
	          return this.validatedRange[0][0];
	        }
	        return this.now;
	      } else {
	        return this.toDate(this.value);
	      }
	    },
	
	
	    // if range is valid, we get a two-digit array
	    validatedRange: function validatedRange() {
	      var _this = this;
	
	      var range = this.range;
	      if (!range) return [];
	      range = range.reduce(function (prev, val, index) {
	        var date = _this.toDate(val);
	        if (_this.rangeValidator(date, index === 0)) {
	          prev = prev.concat(date);
	        }
	        return prev;
	      }, []);
	      if (range.length === 2) {
	        var _range = range,
	            start = _range[0],
	            end = _range[1];
	
	        if (start > end) {
	          console.warn('[ElementCalendar]end time should be greater than start time');
	          return [];
	        }
	        // start time and end time in one month
	        if (Object(date_util_["validateRangeInOneMonth"])(start, end)) {
	          return [[start, end]];
	        }
	        var data = [];
	        var startDay = new Date(start.getFullYear(), start.getMonth() + 1, 1);
	        var lastDay = this.toDate(startDay.getTime() - oneDay);
	        if (!Object(date_util_["validateRangeInOneMonth"])(startDay, end)) {
	          console.warn('[ElementCalendar]start time and end time interval must not exceed two months');
	          return [];
	        }
	        // 第一个月的时间范围
	        data.push([start, lastDay]);
	        // 下一月的时间范围，需要计算一下该月的第一个周起始日
	        var firstDayOfWeek = this.realFirstDayOfWeek;
	        var nextMontFirstDay = startDay.getDay();
	        var interval = 0;
	        if (nextMontFirstDay !== firstDayOfWeek) {
	          if (firstDayOfWeek === 0) {
	            interval = 7 - nextMontFirstDay;
	          } else {
	            interval = firstDayOfWeek - nextMontFirstDay;
	            interval = interval > 0 ? interval : 7 + interval;
	          }
	        }
	        startDay = this.toDate(startDay.getTime() + interval * oneDay);
	        if (startDay.getDate() < end.getDate()) {
	          data.push([startDay, end]);
	        }
	        return data;
	      }
	      return [];
	    },
	    realFirstDayOfWeek: function realFirstDayOfWeek() {
	      if (this.firstDayOfWeek < 1 || this.firstDayOfWeek > 6) {
	        return 0;
	      }
	      return Math.floor(this.firstDayOfWeek);
	    }
	  },
	
	  data: function data() {
	    return {
	      selectedDay: '',
	      now: new Date()
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_calendar_src_mainvue_type_script_lang_js_ = (calendar_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/calendar/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var calendar_src_main_component = normalizeComponent(
	  packages_calendar_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_6d9756be_render,
	  mainvue_type_template_id_6d9756be_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var calendar_src_main_api; }
	calendar_src_main_component.options.__file = "packages/calendar/src/main.vue"
	/* harmony default export */ var calendar_src_main = (calendar_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/calendar/index.js
	
	
	/* istanbul ignore next */
	calendar_src_main.install = function (Vue) {
	  Vue.component(calendar_src_main.name, calendar_src_main);
	};
	
	/* harmony default export */ var calendar = (calendar_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&
	var mainvue_type_template_id_257dd4a9_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-fade-in" } }, [
	    _vm.visible
	      ? _c(
	          "div",
	          {
	            staticClass: "el-backtop",
	            style: {
	              right: _vm.styleRight,
	              bottom: _vm.styleBottom
	            },
	            on: {
	              click: function($event) {
	                $event.stopPropagation()
	                return _vm.handleClick($event)
	              }
	            }
	          },
	          [
	            _vm._t("default", [_c("el-icon", { attrs: { name: "caret-top" } })])
	          ],
	          2
	        )
	      : _vm._e()
	  ])
	}
	var mainvue_type_template_id_257dd4a9_staticRenderFns = []
	mainvue_type_template_id_257dd4a9_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	var cubic = function cubic(value) {
	  return Math.pow(value, 3);
	};
	var easeInOutCubic = function easeInOutCubic(value) {
	  return value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2;
	};
	
	/* harmony default export */ var backtop_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElBacktop',
	
	  props: {
	    visibilityHeight: {
	      type: Number,
	      default: 200
	    },
	    target: [String],
	    right: {
	      type: Number,
	      default: 40
	    },
	    bottom: {
	      type: Number,
	      default: 40
	    }
	  },
	
	  data: function data() {
	    return {
	      el: null,
	      container: null,
	      visible: false
	    };
	  },
	
	
	  computed: {
	    styleBottom: function styleBottom() {
	      return this.bottom + 'px';
	    },
	    styleRight: function styleRight() {
	      return this.right + 'px';
	    }
	  },
	
	  mounted: function mounted() {
	    this.init();
	    this.throttledScrollHandler = throttle_default()(300, this.onScroll);
	    this.container.addEventListener('scroll', this.throttledScrollHandler);
	  },
	
	
	  methods: {
	    init: function init() {
	      this.container = document;
	      this.el = document.documentElement;
	      if (this.target) {
	        this.el = document.querySelector(this.target);
	        if (!this.el) {
	          throw new Error('target is not existed: ' + this.target);
	        }
	        this.container = this.el;
	      }
	    },
	    onScroll: function onScroll() {
	      var scrollTop = this.el.scrollTop;
	      this.visible = scrollTop >= this.visibilityHeight;
	    },
	    handleClick: function handleClick(e) {
	      this.scrollToTop();
	      this.$emit('click', e);
	    },
	    scrollToTop: function scrollToTop() {
	      var el = this.el;
	      var beginTime = Date.now();
	      var beginValue = el.scrollTop;
	      var rAF = window.requestAnimationFrame || function (func) {
	        return setTimeout(func, 16);
	      };
	      var frameFunc = function frameFunc() {
	        var progress = (Date.now() - beginTime) / 500;
	        if (progress < 1) {
	          el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
	          rAF(frameFunc);
	        } else {
	          el.scrollTop = 0;
	        }
	      };
	      rAF(frameFunc);
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.container.removeEventListener('scroll', this.throttledScrollHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_backtop_src_mainvue_type_script_lang_js_ = (backtop_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/backtop/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var backtop_src_main_component = normalizeComponent(
	  packages_backtop_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_257dd4a9_render,
	  mainvue_type_template_id_257dd4a9_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var backtop_src_main_api; }
	backtop_src_main_component.options.__file = "packages/backtop/src/main.vue"
	/* harmony default export */ var backtop_src_main = (backtop_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/backtop/index.js
	
	
	/* istanbul ignore next */
	backtop_src_main.install = function (Vue) {
	  Vue.component(backtop_src_main.name, backtop_src_main);
	};
	
	/* harmony default export */ var backtop = (backtop_src_main);
	// CONCATENATED MODULE: ./packages/infinite-scroll/src/main.js
	
	
	
	
	var getStyleComputedProperty = function getStyleComputedProperty(element, property) {
	  if (element === window) {
	    element = document.documentElement;
	  }
	
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	};
	
	var entries = function entries(obj) {
	  return Object.keys(obj || {}).map(function (key) {
	    return [key, obj[key]];
	  });
	};
	
	var getPositionSize = function getPositionSize(el, prop) {
	  return el === window || el === document ? document.documentElement[prop] : el[prop];
	};
	
	var getOffsetHeight = function getOffsetHeight(el) {
	  return getPositionSize(el, 'offsetHeight');
	};
	
	var getClientHeight = function getClientHeight(el) {
	  return getPositionSize(el, 'clientHeight');
	};
	
	var scope = 'ElInfiniteScroll';
	var attributes = {
	  delay: {
	    type: Number,
	    default: 200
	  },
	  distance: {
	    type: Number,
	    default: 0
	  },
	  disabled: {
	    type: Boolean,
	    default: false
	  },
	  immediate: {
	    type: Boolean,
	    default: true
	  }
	};
	
	var main_getScrollOptions = function getScrollOptions(el, vm) {
	  if (!Object(types_["isHtmlElement"])(el)) return {};
	
	  return entries(attributes).reduce(function (map, _ref) {
	    var key = _ref[0],
	        option = _ref[1];
	    var type = option.type,
	        defaultValue = option.default;
	
	    var value = el.getAttribute('infinite-scroll-' + key);
	    value = Object(types_["isUndefined"])(vm[value]) ? value : vm[value];
	    switch (type) {
	      case Number:
	        value = Number(value);
	        value = Number.isNaN(value) ? defaultValue : value;
	        break;
	      case Boolean:
	        value = Object(types_["isDefined"])(value) ? value === 'false' ? false : Boolean(value) : defaultValue;
	        break;
	      default:
	        value = type(value);
	    }
	    map[key] = value;
	    return map;
	  }, {});
	};
	
	var getElementTop = function getElementTop(el) {
	  return el.getBoundingClientRect().top;
	};
	
	var main_handleScroll = function handleScroll(cb) {
	  var _scope = this[scope],
	      el = _scope.el,
	      vm = _scope.vm,
	      container = _scope.container,
	      observer = _scope.observer;
	
	  var _getScrollOptions = main_getScrollOptions(el, vm),
	      distance = _getScrollOptions.distance,
	      disabled = _getScrollOptions.disabled;
	
	  if (disabled) return;
	
	  var containerInfo = container.getBoundingClientRect();
	  if (!containerInfo.width && !containerInfo.height) return;
	
	  var shouldTrigger = false;
	
	  if (container === el) {
	    // be aware of difference between clientHeight & offsetHeight & window.getComputedStyle().height
	    var scrollBottom = container.scrollTop + getClientHeight(container);
	    shouldTrigger = container.scrollHeight - scrollBottom <= distance;
	  } else {
	    var heightBelowTop = getOffsetHeight(el) + getElementTop(el) - getElementTop(container);
	    var offsetHeight = getOffsetHeight(container);
	    var borderBottom = Number.parseFloat(getStyleComputedProperty(container, 'borderBottomWidth'));
	    shouldTrigger = heightBelowTop - offsetHeight + borderBottom <= distance;
	  }
	
	  if (shouldTrigger && Object(types_["isFunction"])(cb)) {
	    cb.call(vm);
	  } else if (observer) {
	    observer.disconnect();
	    this[scope].observer = null;
	  }
	};
	
	/* harmony default export */ var infinite_scroll_src_main = ({
	  name: 'InfiniteScroll',
	  inserted: function inserted(el, binding, vnode) {
	    var cb = binding.value;
	
	    var vm = vnode.context;
	    // only include vertical scroll
	    var container = Object(dom_["getScrollContainer"])(el, true);
	
	    var _getScrollOptions2 = main_getScrollOptions(el, vm),
	        delay = _getScrollOptions2.delay,
	        immediate = _getScrollOptions2.immediate;
	
	    var onScroll = debounce_default()(delay, main_handleScroll.bind(el, cb));
	
	    el[scope] = { el: el, vm: vm, container: container, onScroll: onScroll };
	
	    if (container) {
	      container.addEventListener('scroll', onScroll);
	
	      if (immediate) {
	        var observer = el[scope].observer = new MutationObserver(onScroll);
	        observer.observe(container, { childList: true, subtree: true });
	        onScroll();
	      }
	    }
	  },
	  unbind: function unbind(el) {
	    var _el$scope = el[scope],
	        container = _el$scope.container,
	        onScroll = _el$scope.onScroll;
	
	    if (container) {
	      container.removeEventListener('scroll', onScroll);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/infinite-scroll/index.js
	
	
	/* istanbul ignore next */
	infinite_scroll_src_main.install = function (Vue) {
	  Vue.directive(infinite_scroll_src_main.name, infinite_scroll_src_main);
	};
	
	/* harmony default export */ var infinite_scroll = (infinite_scroll_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=template&id=5070954c&
	var mainvue_type_template_id_5070954c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-page-header" }, [
	    _c(
	      "div",
	      {
	        staticClass: "el-page-header__left",
	        on: {
	          click: function($event) {
	            _vm.$emit("back")
	          }
	        }
	      },
	      [
	        _c("i", { staticClass: "el-icon-back" }),
	        _c(
	          "div",
	          { staticClass: "el-page-header__title" },
	          [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
	          2
	        )
	      ]
	    ),
	    _c(
	      "div",
	      { staticClass: "el-page-header__content" },
	      [_vm._t("content", [_vm._v(_vm._s(_vm.content))])],
	      2
	    )
	  ])
	}
	var mainvue_type_template_id_5070954c_staticRenderFns = []
	mainvue_type_template_id_5070954c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=template&id=5070954c&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	/* harmony default export */ var page_header_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElPageHeader',
	
	  props: {
	    title: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.pageHeader.title');
	      }
	    },
	    content: String
	  }
	});
	// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_page_header_src_mainvue_type_script_lang_js_ = (page_header_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/page-header/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var page_header_src_main_component = normalizeComponent(
	  packages_page_header_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5070954c_render,
	  mainvue_type_template_id_5070954c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var page_header_src_main_api; }
	page_header_src_main_component.options.__file = "packages/page-header/src/main.vue"
	/* harmony default export */ var page_header_src_main = (page_header_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/page-header/index.js
	
	
	/* istanbul ignore next */
	page_header_src_main.install = function (Vue) {
	  Vue.component(page_header_src_main.name, page_header_src_main);
	};
	
	/* harmony default export */ var page_header = (page_header_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	var cascader_panelvue_type_template_id_34932346_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: ["el-cascader-panel", _vm.border && "is-bordered"],
	      on: { keydown: _vm.handleKeyDown }
	    },
	    _vm._l(_vm.menus, function(menu, index) {
	      return _c("cascader-menu", {
	        key: index,
	        ref: "menu",
	        refInFor: true,
	        attrs: { index: index, nodes: menu }
	      })
	    }),
	    1
	  )
	}
	var cascader_panelvue_type_template_id_34932346_staticRenderFns = []
	cascader_panelvue_type_template_id_34932346_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	
	// EXTERNAL MODULE: external "element-ui/lib/radio"
	var radio_ = __webpack_require__(43);
	var radio_default = /*#__PURE__*/__webpack_require__.n(radio_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	
	/* harmony default export */ var cascader_nodevue_type_script_lang_js_ = ({
	  inject: ['panel'],
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElRadio: radio_default.a
	  },
	
	  props: {
	    node: {
	      required: true
	    },
	    nodeId: String
	  },
	
	  computed: {
	    config: function config() {
	      return this.panel.config;
	    },
	    isLeaf: function isLeaf() {
	      return this.node.isLeaf;
	    },
	    isDisabled: function isDisabled() {
	      return this.node.isDisabled;
	    },
	    checkedValue: function checkedValue() {
	      return this.panel.checkedValue;
	    },
	    isChecked: function isChecked() {
	      return this.node.isSameNode(this.checkedValue);
	    },
	    inActivePath: function inActivePath() {
	      return this.isInPath(this.panel.activePath);
	    },
	    inCheckedPath: function inCheckedPath() {
	      var _this = this;
	
	      if (!this.config.checkStrictly) return false;
	
	      return this.panel.checkedNodePaths.some(function (checkedPath) {
	        return _this.isInPath(checkedPath);
	      });
	    },
	    value: function value() {
	      return this.node.getValueByOption();
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand() {
	      var _this2 = this;
	
	      var panel = this.panel,
	          node = this.node,
	          isDisabled = this.isDisabled,
	          config = this.config;
	      var multiple = config.multiple,
	          checkStrictly = config.checkStrictly;
	
	
	      if (!checkStrictly && isDisabled || node.loading) return;
	
	      if (config.lazy && !node.loaded) {
	        panel.lazyLoad(node, function () {
	          // do not use cached leaf value here, invoke this.isLeaf to get new value.
	          var isLeaf = _this2.isLeaf;
	
	
	          if (!isLeaf) _this2.handleExpand();
	          if (multiple) {
	            // if leaf sync checked state, else clear checked state
	            var checked = isLeaf ? node.checked : false;
	            _this2.handleMultiCheckChange(checked);
	          }
	        });
	      } else {
	        panel.handleExpand(node);
	      }
	    },
	    handleCheckChange: function handleCheckChange() {
	      var panel = this.panel,
	          value = this.value,
	          node = this.node;
	
	      panel.handleCheckChange(value);
	      panel.handleExpand(node);
	    },
	    handleMultiCheckChange: function handleMultiCheckChange(checked) {
	      this.node.doCheck(checked);
	      this.panel.calculateMultiCheckedValue();
	    },
	    isInPath: function isInPath(pathNodes) {
	      var node = this.node;
	
	      var selectedPathNode = pathNodes[node.level - 1] || {};
	      return selectedPathNode.uid === node.uid;
	    },
	    renderPrefix: function renderPrefix(h) {
	      var isLeaf = this.isLeaf,
	          isChecked = this.isChecked,
	          config = this.config;
	      var checkStrictly = config.checkStrictly,
	          multiple = config.multiple;
	
	
	      if (multiple) {
	        return this.renderCheckbox(h);
	      } else if (checkStrictly) {
	        return this.renderRadio(h);
	      } else if (isLeaf && isChecked) {
	        return this.renderCheckIcon(h);
	      }
	
	      return null;
	    },
	    renderPostfix: function renderPostfix(h) {
	      var node = this.node,
	          isLeaf = this.isLeaf;
	
	
	      if (node.loading) {
	        return this.renderLoadingIcon(h);
	      } else if (!isLeaf) {
	        return this.renderExpandIcon(h);
	      }
	
	      return null;
	    },
	    renderCheckbox: function renderCheckbox(h) {
	      var node = this.node,
	          config = this.config,
	          isDisabled = this.isDisabled;
	
	      var events = {
	        on: { change: this.handleMultiCheckChange },
	        nativeOn: {}
	      };
	
	      if (config.checkStrictly) {
	        // when every node is selectable, click event should not trigger expand event.
	        events.nativeOn.click = stopPropagation;
	      }
	
	      return h('el-checkbox', external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          value: node.checked,
	          indeterminate: node.indeterminate,
	          disabled: isDisabled
	        }
	      }, events]));
	    },
	    renderRadio: function renderRadio(h) {
	      var checkedValue = this.checkedValue,
	          value = this.value,
	          isDisabled = this.isDisabled;
	
	      // to keep same reference if value cause radio's checked state is calculated by reference comparision;
	
	      if (Object(util_["isEqual"])(value, checkedValue)) {
	        value = checkedValue;
	      }
	
	      return h(
	        'el-radio',
	        {
	          attrs: {
	            value: checkedValue,
	            label: value,
	            disabled: isDisabled
	          },
	          on: {
	            'change': this.handleCheckChange
	          },
	          nativeOn: {
	            'click': stopPropagation
	          }
	        },
	        [h('span')]
	      );
	    },
	    renderCheckIcon: function renderCheckIcon(h) {
	      return h('i', { 'class': 'el-icon-check el-cascader-node__prefix' });
	    },
	    renderLoadingIcon: function renderLoadingIcon(h) {
	      return h('i', { 'class': 'el-icon-loading el-cascader-node__postfix' });
	    },
	    renderExpandIcon: function renderExpandIcon(h) {
	      return h('i', { 'class': 'el-icon-arrow-right el-cascader-node__postfix' });
	    },
	    renderContent: function renderContent(h) {
	      var panel = this.panel,
	          node = this.node;
	
	      var render = panel.renderLabelFn;
	      var vnode = render ? render({ node: node, data: node.data }) : null;
	
	      return h(
	        'span',
	        { 'class': 'el-cascader-node__label' },
	        [vnode || node.label]
	      );
	    }
	  },
	
	  render: function render(h) {
	    var _this3 = this;
	
	    var inActivePath = this.inActivePath,
	        inCheckedPath = this.inCheckedPath,
	        isChecked = this.isChecked,
	        isLeaf = this.isLeaf,
	        isDisabled = this.isDisabled,
	        config = this.config,
	        nodeId = this.nodeId;
	    var expandTrigger = config.expandTrigger,
	        checkStrictly = config.checkStrictly,
	        multiple = config.multiple;
	
	    var disabled = !checkStrictly && isDisabled;
	    var events = { on: {} };
	
	    if (expandTrigger === 'click') {
	      events.on.click = this.handleExpand;
	    } else {
	      events.on.mouseenter = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	      events.on.focus = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	    }
	    if (isLeaf && !isDisabled && !checkStrictly && !multiple) {
	      events.on.click = this.handleCheckChange;
	    }
	
	    return h(
	      'li',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          role: 'menuitem',
	          id: nodeId,
	          'aria-expanded': inActivePath,
	          tabindex: disabled ? null : -1
	        },
	        'class': {
	          'el-cascader-node': true,
	          'is-selectable': checkStrictly,
	          'in-active-path': inActivePath,
	          'in-checked-path': inCheckedPath,
	          'is-active': isChecked,
	          'is-disabled': disabled
	        }
	      }, events]),
	      [this.renderPrefix(h), this.renderContent(h), this.renderPostfix(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_nodevue_type_script_lang_js_ = (cascader_nodevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
	var cascader_node_render, cascader_node_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var cascader_node_component = normalizeComponent(
	  src_cascader_nodevue_type_script_lang_js_,
	  cascader_node_render,
	  cascader_node_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_node_api; }
	cascader_node_component.options.__file = "packages/cascader-panel/src/cascader-node.vue"
	/* harmony default export */ var cascader_node = (cascader_node_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	
	/* harmony default export */ var cascader_menuvue_type_script_lang_js_ = ({
	  name: 'ElCascaderMenu',
	
	  mixins: [locale_default.a],
	
	  inject: ['panel'],
	
	  components: {
	    ElScrollbar: scrollbar_default.a,
	    CascaderNode: cascader_node
	  },
	
	  props: {
	    nodes: {
	      type: Array,
	      required: true
	    },
	    index: Number
	  },
	
	  data: function data() {
	    return {
	      activeNode: null,
	      hoverTimer: null,
	      id: Object(util_["generateId"])()
	    };
	  },
	
	
	  computed: {
	    isEmpty: function isEmpty() {
	      return !this.nodes.length;
	    },
	    menuId: function menuId() {
	      return 'cascader-menu-' + this.id + '-' + this.index;
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand(e) {
	      this.activeNode = e.target;
	    },
	    handleMouseMove: function handleMouseMove(e) {
	      var activeNode = this.activeNode,
	          hoverTimer = this.hoverTimer;
	      var hoverZone = this.$refs.hoverZone;
	
	
	      if (!activeNode || !hoverZone) return;
	
	      if (activeNode.contains(e.target)) {
	        clearTimeout(hoverTimer);
	
	        var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
	            left = _$el$getBoundingClien.left;
	
	        var startX = e.clientX - left;
	        var _$el = this.$el,
	            offsetWidth = _$el.offsetWidth,
	            offsetHeight = _$el.offsetHeight;
	
	        var top = activeNode.offsetTop;
	        var bottom = top + activeNode.offsetHeight;
	
	        hoverZone.innerHTML = '\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + top + ' L' + offsetWidth + ' 0 V' + top + ' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + bottom + ' L' + offsetWidth + ' ' + offsetHeight + ' V' + bottom + ' Z" />\n        ';
	      } else if (!hoverTimer) {
	        this.hoverTimer = setTimeout(this.clearHoverZone, this.panel.config.hoverThreshold);
	      }
	    },
	    clearHoverZone: function clearHoverZone() {
	      var hoverZone = this.$refs.hoverZone;
	
	      if (!hoverZone) return;
	      hoverZone.innerHTML = '';
	    },
	    renderEmptyText: function renderEmptyText(h) {
	      return h(
	        'div',
	        { 'class': 'el-cascader-menu__empty-text' },
	        [this.t('el.cascader.noData')]
	      );
	    },
	    renderNodeList: function renderNodeList(h) {
	      var menuId = this.menuId;
	      var isHoverMenu = this.panel.isHoverMenu;
	
	      var events = { on: {} };
	
	      if (isHoverMenu) {
	        events.on.expand = this.handleExpand;
	      }
	
	      var nodes = this.nodes.map(function (node, index) {
	        var hasChildren = node.hasChildren;
	
	        return h('cascader-node', external_babel_helper_vue_jsx_merge_props_default()([{
	          key: node.uid,
	          attrs: { node: node,
	            'node-id': menuId + '-' + index,
	            'aria-haspopup': hasChildren,
	            'aria-owns': hasChildren ? menuId : null
	          }
	        }, events]));
	      });
	
	      return [].concat(nodes, [isHoverMenu ? h('svg', { ref: 'hoverZone', 'class': 'el-cascader-menu__hover-zone' }) : null]);
	    }
	  },
	
	  render: function render(h) {
	    var isEmpty = this.isEmpty,
	        menuId = this.menuId;
	
	    var events = { nativeOn: {} };
	
	    // optimize hover to expand experience (#8010)
	    if (this.panel.isHoverMenu) {
	      events.nativeOn.mousemove = this.handleMouseMove;
	      // events.nativeOn.mouseleave = this.clearHoverZone;
	    }
	
	    return h(
	      'el-scrollbar',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          tag: 'ul',
	          role: 'menu',
	          id: menuId,
	
	          'wrap-class': 'el-cascader-menu__wrap',
	          'view-class': {
	            'el-cascader-menu__list': true,
	            'is-empty': isEmpty
	          }
	        },
	        'class': 'el-cascader-menu' }, events]),
	      [isEmpty ? this.renderEmptyText(h) : this.renderNodeList(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_menuvue_type_script_lang_js_ = (cascader_menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
	var cascader_menu_render, cascader_menu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var cascader_menu_component = normalizeComponent(
	  src_cascader_menuvue_type_script_lang_js_,
	  cascader_menu_render,
	  cascader_menu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_menu_api; }
	cascader_menu_component.options.__file = "packages/cascader-panel/src/cascader-menu.vue"
	/* harmony default export */ var cascader_menu = (cascader_menu_component.exports);
	// CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
	var node_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function src_node_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var uid = 0;
	
	var src_node_Node = function () {
	  function Node(data, config, parentNode) {
	    src_node_classCallCheck(this, Node);
	
	    this.data = data;
	    this.config = config;
	    this.parent = parentNode || null;
	    this.level = !this.parent ? 1 : this.parent.level + 1;
	    this.uid = uid++;
	
	    this.initState();
	    this.initChildren();
	  }
	
	  Node.prototype.initState = function initState() {
	    var _config = this.config,
	        valueKey = _config.value,
	        labelKey = _config.label;
	
	
	    this.value = this.data[valueKey];
	    this.label = this.data[labelKey];
	    this.pathNodes = this.calculatePathNodes();
	    this.path = this.pathNodes.map(function (node) {
	      return node.value;
	    });
	    this.pathLabels = this.pathNodes.map(function (node) {
	      return node.label;
	    });
	
	    // lazy load
	    this.loading = false;
	    this.loaded = false;
	  };
	
	  Node.prototype.initChildren = function initChildren() {
	    var _this = this;
	
	    var config = this.config;
	
	    var childrenKey = config.children;
	    var childrenData = this.data[childrenKey];
	    this.hasChildren = Array.isArray(childrenData);
	    this.children = (childrenData || []).map(function (child) {
	      return new Node(child, config, _this);
	    });
	  };
	
	  Node.prototype.calculatePathNodes = function calculatePathNodes() {
	    var nodes = [this];
	    var parent = this.parent;
	
	    while (parent) {
	      nodes.unshift(parent);
	      parent = parent.parent;
	    }
	
	    return nodes;
	  };
	
	  Node.prototype.getPath = function getPath() {
	    return this.path;
	  };
	
	  Node.prototype.getValue = function getValue() {
	    return this.value;
	  };
	
	  Node.prototype.getValueByOption = function getValueByOption() {
	    return this.config.emitPath ? this.getPath() : this.getValue();
	  };
	
	  Node.prototype.getText = function getText(allLevels, separator) {
	    return allLevels ? this.pathLabels.join(separator) : this.label;
	  };
	
	  Node.prototype.isSameNode = function isSameNode(checkedValue) {
	    var value = this.getValueByOption();
	    return this.config.multiple && Array.isArray(checkedValue) ? checkedValue.some(function (val) {
	      return Object(util_["isEqual"])(val, value);
	    }) : Object(util_["isEqual"])(checkedValue, value);
	  };
	
	  Node.prototype.broadcast = function broadcast(event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var handlerName = 'onParent' + Object(util_["capitalize"])(event);
	
	    this.children.forEach(function (child) {
	      if (child) {
	        // bottom up
	        child.broadcast.apply(child, [event].concat(args));
	        child[handlerName] && child[handlerName].apply(child, args);
	      }
	    });
	  };
	
	  Node.prototype.emit = function emit(event) {
	    var parent = this.parent;
	
	    var handlerName = 'onChild' + Object(util_["capitalize"])(event);
	    if (parent) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      parent[handlerName] && parent[handlerName].apply(parent, args);
	      parent.emit.apply(parent, [event].concat(args));
	    }
	  };
	
	  Node.prototype.onParentCheck = function onParentCheck(checked) {
	    if (!this.isDisabled) {
	      this.setCheckState(checked);
	    }
	  };
	
	  Node.prototype.onChildCheck = function onChildCheck() {
	    var children = this.children;
	
	    var validChildren = children.filter(function (child) {
	      return !child.isDisabled;
	    });
	    var checked = validChildren.length ? validChildren.every(function (child) {
	      return child.checked;
	    }) : false;
	
	    this.setCheckState(checked);
	  };
	
	  Node.prototype.setCheckState = function setCheckState(checked) {
	    var totalNum = this.children.length;
	    var checkedNum = this.children.reduce(function (c, p) {
	      var num = p.checked ? 1 : p.indeterminate ? 0.5 : 0;
	      return c + num;
	    }, 0);
	
	    this.checked = checked;
	    this.indeterminate = checkedNum !== totalNum && checkedNum > 0;
	  };
	
	  Node.prototype.syncCheckState = function syncCheckState(checkedValue) {
	    var value = this.getValueByOption();
	    var checked = this.isSameNode(checkedValue, value);
	
	    this.doCheck(checked);
	  };
	
	  Node.prototype.doCheck = function doCheck(checked) {
	    if (this.checked !== checked) {
	      if (this.config.checkStrictly) {
	        this.checked = checked;
	      } else {
	        // bottom up to unify the calculation of the indeterminate state
	        this.broadcast('check', checked);
	        this.setCheckState(checked);
	        this.emit('check');
	      }
	    }
	  };
	
	  node_createClass(Node, [{
	    key: 'isDisabled',
	    get: function get() {
	      var data = this.data,
	          parent = this.parent,
	          config = this.config;
	
	      var disabledKey = config.disabled;
	      var checkStrictly = config.checkStrictly;
	
	      return data[disabledKey] || !checkStrictly && parent && parent.isDisabled;
	    }
	  }, {
	    key: 'isLeaf',
	    get: function get() {
	      var data = this.data,
	          loaded = this.loaded,
	          hasChildren = this.hasChildren,
	          children = this.children;
	      var _config2 = this.config,
	          lazy = _config2.lazy,
	          leafKey = _config2.leaf;
	
	      if (lazy) {
	        var isLeaf = Object(shared_["isDef"])(data[leafKey]) ? data[leafKey] : loaded ? !children.length : false;
	        this.hasChildren = !isLeaf;
	        return isLeaf;
	      }
	      return !hasChildren;
	    }
	  }]);
	
	  return Node;
	}();
	
	/* harmony default export */ var src_node = (src_node_Node);
	// CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
	function store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var flatNodes = function flatNodes(data, leafOnly) {
	  return data.reduce(function (res, node) {
	    if (node.isLeaf) {
	      res.push(node);
	    } else {
	      !leafOnly && res.push(node);
	      res = res.concat(flatNodes(node.children, leafOnly));
	    }
	    return res;
	  }, []);
	};
	
	var store_Store = function () {
	  function Store(data, config) {
	    store_classCallCheck(this, Store);
	
	    this.config = config;
	    this.initNodes(data);
	  }
	
	  Store.prototype.initNodes = function initNodes(data) {
	    var _this = this;
	
	    data = Object(util_["coerceTruthyValueToArray"])(data);
	    this.nodes = data.map(function (nodeData) {
	      return new src_node(nodeData, _this.config);
	    });
	    this.flattedNodes = this.getFlattedNodes(false, false);
	    this.leafNodes = this.getFlattedNodes(true, false);
	  };
	
	  Store.prototype.appendNode = function appendNode(nodeData, parentNode) {
	    var node = new src_node(nodeData, this.config, parentNode);
	    var children = parentNode ? parentNode.children : this.nodes;
	
	    children.push(node);
	  };
	
	  Store.prototype.appendNodes = function appendNodes(nodeDataList, parentNode) {
	    var _this2 = this;
	
	    nodeDataList = Object(util_["coerceTruthyValueToArray"])(nodeDataList);
	    nodeDataList.forEach(function (nodeData) {
	      return _this2.appendNode(nodeData, parentNode);
	    });
	  };
	
	  Store.prototype.getNodes = function getNodes() {
	    return this.nodes;
	  };
	
	  Store.prototype.getFlattedNodes = function getFlattedNodes(leafOnly) {
	    var cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var cachedNodes = leafOnly ? this.leafNodes : this.flattedNodes;
	    return cached ? cachedNodes : flatNodes(this.nodes, leafOnly);
	  };
	
	  Store.prototype.getNodeByValue = function getNodeByValue(value) {
	    if (value) {
	      var nodes = this.getFlattedNodes(false, !this.config.lazy).filter(function (node) {
	        return Object(util_["valueEquals"])(node.path, value) || node.value === value;
	      });
	      return nodes && nodes.length ? nodes[0] : null;
	    }
	    return null;
	  };
	
	  return Store;
	}();
	
	/* harmony default export */ var cascader_panel_src_store = (store_Store);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	var cascader_panelvue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var cascader_panelvue_type_script_lang_js_KeyCode = aria_utils_default.a.keys;
	
	var DefaultProps = {
	  expandTrigger: 'click', // or hover
	  multiple: false,
	  checkStrictly: false, // whether all nodes can be selected
	  emitPath: true, // wether to emit an array of all levels value in which node is located
	  lazy: false,
	  lazyLoad: util_["noop"],
	  value: 'value',
	  label: 'label',
	  children: 'children',
	  leaf: 'leaf',
	  disabled: 'disabled',
	  hoverThreshold: 500
	};
	
	var cascader_panelvue_type_script_lang_js_isLeaf = function isLeaf(el) {
	  return !el.getAttribute('aria-owns');
	};
	
	var getSibling = function getSibling(el, distance) {
	  var parentNode = el.parentNode;
	
	  if (parentNode) {
	    var siblings = parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');
	    var index = Array.prototype.indexOf.call(siblings, el);
	    return siblings[index + distance] || null;
	  }
	  return null;
	};
	
	var getMenuIndex = function getMenuIndex(el, distance) {
	  if (!el) return;
	  var pieces = el.id.split('-');
	  return Number(pieces[pieces.length - 2]);
	};
	
	var focusNode = function focusNode(el) {
	  if (!el) return;
	  el.focus();
	  !cascader_panelvue_type_script_lang_js_isLeaf(el) && el.click();
	};
	
	var checkNode = function checkNode(el) {
	  if (!el) return;
	
	  var input = el.querySelector('input');
	  if (input) {
	    input.click();
	  } else if (cascader_panelvue_type_script_lang_js_isLeaf(el)) {
	    el.click();
	  }
	};
	
	/* harmony default export */ var cascader_panelvue_type_script_lang_js_ = ({
	  name: 'ElCascaderPanel',
	
	  components: {
	    CascaderMenu: cascader_menu
	  },
	
	  props: {
	    value: {},
	    options: Array,
	    props: Object,
	    border: {
	      type: Boolean,
	      default: true
	    },
	    renderLabel: Function
	  },
	
	  provide: function provide() {
	    return {
	      panel: this
	    };
	  },
	  data: function data() {
	    return {
	      checkedValue: null,
	      checkedNodePaths: [],
	      store: [],
	      menus: [],
	      activePath: [],
	      loadCount: 0
	    };
	  },
	
	
	  computed: {
	    config: function config() {
	      return merge_default()(cascader_panelvue_type_script_lang_js_extends({}, DefaultProps), this.props || {});
	    },
	    multiple: function multiple() {
	      return this.config.multiple;
	    },
	    checkStrictly: function checkStrictly() {
	      return this.config.checkStrictly;
	    },
	    leafOnly: function leafOnly() {
	      return !this.checkStrictly;
	    },
	    isHoverMenu: function isHoverMenu() {
	      return this.config.expandTrigger === 'hover';
	    },
	    renderLabelFn: function renderLabelFn() {
	      return this.renderLabel || this.$scopedSlots.default;
	    }
	  },
	
	  watch: {
	    options: {
	      handler: function handler() {
	        this.initStore();
	      },
	      immediate: true,
	      deep: true
	    },
	    value: function value() {
	      this.syncCheckedValue();
	      this.checkStrictly && this.calculateCheckedNodePaths();
	    },
	    checkedValue: function checkedValue(val) {
	      if (!Object(util_["isEqual"])(val, this.value)) {
	        this.checkStrictly && this.calculateCheckedNodePaths();
	        this.$emit('input', val);
	        this.$emit('change', val);
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    if (!Object(util_["isEmpty"])(this.value)) {
	      this.syncCheckedValue();
	    }
	  },
	
	
	  methods: {
	    initStore: function initStore() {
	      var config = this.config,
	          options = this.options;
	
	      if (config.lazy && Object(util_["isEmpty"])(options)) {
	        this.lazyLoad();
	      } else {
	        this.store = new cascader_panel_src_store(options, config);
	        this.menus = [this.store.getNodes()];
	        this.syncMenuState();
	      }
	    },
	    syncCheckedValue: function syncCheckedValue() {
	      var value = this.value,
	          checkedValue = this.checkedValue;
	
	      if (!Object(util_["isEqual"])(value, checkedValue)) {
	        this.checkedValue = value;
	        this.syncMenuState();
	      }
	    },
	    syncMenuState: function syncMenuState() {
	      var multiple = this.multiple,
	          checkStrictly = this.checkStrictly;
	
	      this.syncActivePath();
	      multiple && this.syncMultiCheckState();
	      checkStrictly && this.calculateCheckedNodePaths();
	      this.$nextTick(this.scrollIntoView);
	    },
	    syncMultiCheckState: function syncMultiCheckState() {
	      var _this = this;
	
	      var nodes = this.getFlattedNodes(this.leafOnly);
	
	      nodes.forEach(function (node) {
	        node.syncCheckState(_this.checkedValue);
	      });
	    },
	    syncActivePath: function syncActivePath() {
	      var _this2 = this;
	
	      var store = this.store,
	          multiple = this.multiple,
	          activePath = this.activePath,
	          checkedValue = this.checkedValue;
	
	
	      if (!Object(util_["isEmpty"])(activePath)) {
	        var nodes = activePath.map(function (node) {
	          return _this2.getNodeByValue(node.getValue());
	        });
	        this.expandNodes(nodes);
	      } else if (!Object(util_["isEmpty"])(checkedValue)) {
	        var value = multiple ? checkedValue[0] : checkedValue;
	        var checkedNode = this.getNodeByValue(value) || {};
	        var _nodes = (checkedNode.pathNodes || []).slice(0, -1);
	        this.expandNodes(_nodes);
	      } else {
	        this.activePath = [];
	        this.menus = [store.getNodes()];
	      }
	    },
	    expandNodes: function expandNodes(nodes) {
	      var _this3 = this;
	
	      nodes.forEach(function (node) {
	        return _this3.handleExpand(node, true /* silent */);
	      });
	    },
	    calculateCheckedNodePaths: function calculateCheckedNodePaths() {
	      var _this4 = this;
	
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      var checkedValues = multiple ? Object(util_["coerceTruthyValueToArray"])(checkedValue) : [checkedValue];
	      this.checkedNodePaths = checkedValues.map(function (v) {
	        var checkedNode = _this4.getNodeByValue(v);
	        return checkedNode ? checkedNode.pathNodes : [];
	      });
	    },
	    handleKeyDown: function handleKeyDown(e) {
	      var target = e.target,
	          keyCode = e.keyCode;
	
	
	      switch (keyCode) {
	        case cascader_panelvue_type_script_lang_js_KeyCode.up:
	          var prev = getSibling(target, -1);
	          focusNode(prev);
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.down:
	          var next = getSibling(target, 1);
	          focusNode(next);
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.left:
	          var preMenu = this.$refs.menu[getMenuIndex(target) - 1];
	          if (preMenu) {
	            var expandedNode = preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');
	            focusNode(expandedNode);
	          }
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.right:
	          var nextMenu = this.$refs.menu[getMenuIndex(target) + 1];
	          if (nextMenu) {
	            var firstNode = nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');
	            focusNode(firstNode);
	          }
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.enter:
	          checkNode(target);
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.esc:
	        case cascader_panelvue_type_script_lang_js_KeyCode.tab:
	          this.$emit('close');
	          break;
	        default:
	          return;
	      }
	    },
	    handleExpand: function handleExpand(node, silent) {
	      var activePath = this.activePath;
	      var level = node.level;
	
	      var path = activePath.slice(0, level - 1);
	      var menus = this.menus.slice(0, level);
	
	      if (!node.isLeaf) {
	        path.push(node);
	        menus.push(node.children);
	      }
	
	      this.activePath = path;
	      this.menus = menus;
	
	      if (!silent) {
	        var pathValues = path.map(function (node) {
	          return node.getValue();
	        });
	        var activePathValues = activePath.map(function (node) {
	          return node.getValue();
	        });
	        if (!Object(util_["valueEquals"])(pathValues, activePathValues)) {
	          this.$emit('active-item-change', pathValues); // Deprecated
	          this.$emit('expand-change', pathValues);
	        }
	      }
	    },
	    handleCheckChange: function handleCheckChange(value) {
	      this.checkedValue = value;
	    },
	    lazyLoad: function lazyLoad(node, onFullfiled) {
	      var _this5 = this;
	
	      var config = this.config;
	
	      if (!node) {
	        node = node || { root: true, level: 0 };
	        this.store = new cascader_panel_src_store([], config);
	        this.menus = [this.store.getNodes()];
	      }
	      node.loading = true;
	      var resolve = function resolve(dataList) {
	        var parent = node.root ? null : node;
	        dataList && dataList.length && _this5.store.appendNodes(dataList, parent);
	        node.loading = false;
	        node.loaded = true;
	
	        // dispose default value on lazy load mode
	        if (Array.isArray(_this5.checkedValue)) {
	          var nodeValue = _this5.checkedValue[_this5.loadCount++];
	          var valueKey = _this5.config.value;
	          var leafKey = _this5.config.leaf;
	
	          if (Array.isArray(dataList) && dataList.filter(function (item) {
	            return item[valueKey] === nodeValue;
	          }).length > 0) {
	            var checkedNode = _this5.store.getNodeByValue(nodeValue);
	
	            if (!checkedNode.data[leafKey]) {
	              _this5.lazyLoad(checkedNode, function () {
	                _this5.handleExpand(checkedNode);
	              });
	            }
	
	            if (_this5.loadCount === _this5.checkedValue.length) {
	              _this5.$parent.computePresentText();
	            }
	          }
	        }
	
	        onFullfiled && onFullfiled(dataList);
	      };
	      config.lazyLoad(node, resolve);
	    },
	
	
	    /**
	     * public methods
	    */
	    calculateMultiCheckedValue: function calculateMultiCheckedValue() {
	      this.checkedValue = this.getCheckedNodes(this.leafOnly).map(function (node) {
	        return node.getValueByOption();
	      });
	    },
	    scrollIntoView: function scrollIntoView() {
	      if (this.$isServer) return;
	
	      var menus = this.$refs.menu || [];
	      menus.forEach(function (menu) {
	        var menuElement = menu.$el;
	        if (menuElement) {
	          var container = menuElement.querySelector('.el-scrollbar__wrap');
	          var activeNode = menuElement.querySelector('.el-cascader-node.is-active') || menuElement.querySelector('.el-cascader-node.in-active-path');
	          scroll_into_view_default()(container, activeNode);
	        }
	      });
	    },
	    getNodeByValue: function getNodeByValue(val) {
	      return this.store.getNodeByValue(val);
	    },
	    getFlattedNodes: function getFlattedNodes(leafOnly) {
	      var cached = !this.config.lazy;
	      return this.store.getFlattedNodes(leafOnly, cached);
	    },
	    getCheckedNodes: function getCheckedNodes(leafOnly) {
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      if (multiple) {
	        var nodes = this.getFlattedNodes(leafOnly);
	        return nodes.filter(function (node) {
	          return node.checked;
	        });
	      } else {
	        return Object(util_["isEmpty"])(checkedValue) ? [] : [this.getNodeByValue(checkedValue)];
	      }
	    },
	    clearCheckedNodes: function clearCheckedNodes() {
	      var config = this.config,
	          leafOnly = this.leafOnly;
	      var multiple = config.multiple,
	          emitPath = config.emitPath;
	
	      if (multiple) {
	        this.getCheckedNodes(leafOnly).filter(function (node) {
	          return !node.isDisabled;
	        }).forEach(function (node) {
	          return node.doCheck(false);
	        });
	        this.calculateMultiCheckedValue();
	      } else {
	        this.checkedValue = emitPath ? [] : null;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_panelvue_type_script_lang_js_ = (cascader_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var cascader_panel_component = normalizeComponent(
	  src_cascader_panelvue_type_script_lang_js_,
	  cascader_panelvue_type_template_id_34932346_render,
	  cascader_panelvue_type_template_id_34932346_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_panel_api; }
	cascader_panel_component.options.__file = "packages/cascader-panel/src/cascader-panel.vue"
	/* harmony default export */ var cascader_panel = (cascader_panel_component.exports);
	// CONCATENATED MODULE: ./packages/cascader-panel/index.js
	
	
	/* istanbul ignore next */
	cascader_panel.install = function (Vue) {
	  Vue.component(cascader_panel.name, cascader_panel);
	};
	
	/* harmony default export */ var packages_cascader_panel = (cascader_panel);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/avatar/src/main.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var avatar_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElAvatar',
	
	  props: {
	    size: {
	      type: [Number, String],
	      validator: function validator(val) {
	        if (typeof val === 'string') {
	          return ['large', 'medium', 'small'].includes(val);
	        }
	        return typeof val === 'number';
	      }
	    },
	    shape: {
	      type: String,
	      default: 'circle',
	      validator: function validator(val) {
	        return ['circle', 'square'].includes(val);
	      }
	    },
	    icon: String,
	    src: String,
	    alt: String,
	    srcSet: String,
	    error: Function,
	    fit: {
	      type: String,
	      default: 'cover'
	    }
	  },
	
	  data: function data() {
	    return {
	      isImageExist: true
	    };
	  },
	
	
	  computed: {
	    avatarClass: function avatarClass() {
	      var size = this.size,
	          icon = this.icon,
	          shape = this.shape;
	
	      var classList = ['el-avatar'];
	
	      if (size && typeof size === 'string') {
	        classList.push('el-avatar--' + size);
	      }
	
	      if (icon) {
	        classList.push('el-avatar--icon');
	      }
	
	      if (shape) {
	        classList.push('el-avatar--' + shape);
	      }
	
	      return classList.join(' ');
	    }
	  },
	
	  methods: {
	    handleError: function handleError() {
	      var error = this.error;
	
	      var errorFlag = error ? error() : undefined;
	      if (errorFlag !== false) {
	        this.isImageExist = false;
	      }
	    },
	    renderAvatar: function renderAvatar() {
	      var h = this.$createElement;
	      var icon = this.icon,
	          src = this.src,
	          alt = this.alt,
	          isImageExist = this.isImageExist,
	          srcSet = this.srcSet,
	          fit = this.fit;
	
	
	      if (isImageExist && src) {
	        return h('img', {
	          attrs: {
	            src: src,
	
	            alt: alt,
	            srcSet: srcSet
	          },
	          on: {
	            'error': this.handleError
	          },
	          style: { 'object-fit': fit } });
	      }
	
	      if (icon) {
	        return h('i', { 'class': icon });
	      }
	
	      return this.$slots.default;
	    }
	  },
	
	  render: function render() {
	    var h = arguments[0];
	    var avatarClass = this.avatarClass,
	        size = this.size;
	
	
	    var sizeStyle = typeof size === 'number' ? {
	      height: size + 'px',
	      width: size + 'px',
	      lineHeight: size + 'px'
	    } : {};
	
	    return h(
	      'span',
	      { 'class': avatarClass, style: sizeStyle },
	      [this.renderAvatar()]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/avatar/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_avatar_src_mainvue_type_script_lang_js_ = (avatar_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/avatar/src/main.vue
	var src_main_render, src_main_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var avatar_src_main_component = normalizeComponent(
	  packages_avatar_src_mainvue_type_script_lang_js_,
	  src_main_render,
	  src_main_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var avatar_src_main_api; }
	avatar_src_main_component.options.__file = "packages/avatar/src/main.vue"
	/* harmony default export */ var avatar_src_main = (avatar_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/avatar/index.js
	
	
	/* istanbul ignore next */
	avatar_src_main.install = function (Vue) {
	  Vue.component(avatar_src_main.name, avatar_src_main);
	};
	
	/* harmony default export */ var avatar = (avatar_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=template&id=a4885264&
	var mainvue_type_template_id_a4885264_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-drawer-fade" },
	      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-drawer__wrapper",
	          attrs: { tabindex: "-1" }
	        },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-drawer__container",
	              class: _vm.visible && "el-drawer__open",
	              attrs: { role: "document", tabindex: "-1" },
	              on: {
	                click: function($event) {
	                  if ($event.target !== $event.currentTarget) {
	                    return null
	                  }
	                  return _vm.handleWrapperClick($event)
	                }
	              }
	            },
	            [
	              _c(
	                "div",
	                {
	                  ref: "drawer",
	                  staticClass: "el-drawer",
	                  class: [_vm.direction, _vm.customClass],
	                  style: _vm.isHorizontal
	                    ? "width: " + _vm.size
	                    : "height: " + _vm.size,
	                  attrs: {
	                    "aria-modal": "true",
	                    "aria-labelledby": "el-drawer__title",
	                    "aria-label": _vm.title,
	                    role: "dialog",
	                    tabindex: "-1"
	                  }
	                },
	                [
	                  _vm.withHeader
	                    ? _c(
	                        "header",
	                        {
	                          staticClass: "el-drawer__header",
	                          attrs: { id: "el-drawer__title" }
	                        },
	                        [
	                          _vm._t("title", [
	                            _c(
	                              "span",
	                              { attrs: { role: "heading", title: _vm.title } },
	                              [_vm._v(_vm._s(_vm.title))]
	                            )
	                          ]),
	                          _vm.showClose
	                            ? _c(
	                                "button",
	                                {
	                                  staticClass: "el-drawer__close-btn",
	                                  attrs: {
	                                    "aria-label":
	                                      "close " + (_vm.title || "drawer"),
	                                    type: "button"
	                                  },
	                                  on: { click: _vm.closeDrawer }
	                                },
	                                [
	                                  _c("i", {
	                                    staticClass:
	                                      "el-dialog__close el-icon el-icon-close"
	                                  })
	                                ]
	                              )
	                            : _vm._e()
	                        ],
	                        2
	                      )
	                    : _vm._e(),
	                  _vm.rendered
	                    ? _c(
	                        "section",
	                        { staticClass: "el-drawer__body" },
	                        [_vm._t("default")],
	                        2
	                      )
	                    : _vm._e()
	                ]
	              )
	            ]
	          )
	        ]
	      )
	    ]
	  )
	}
	var mainvue_type_template_id_a4885264_staticRenderFns = []
	mainvue_type_template_id_a4885264_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=template&id=a4885264&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var drawer_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElDrawer',
	  mixins: [popup_default.a, emitter_default.a],
	  props: {
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	    beforeClose: {
	      type: Function
	    },
	    customClass: {
	      type: String,
	      default: ''
	    },
	    closeOnPressEscape: {
	      type: Boolean,
	      default: true
	    },
	    destroyOnClose: {
	      type: Boolean,
	      default: false
	    },
	    modal: {
	      type: Boolean,
	      default: true
	    },
	    direction: {
	      type: String,
	      default: 'rtl',
	      validator: function validator(val) {
	        return ['ltr', 'rtl', 'ttb', 'btt'].indexOf(val) !== -1;
	      }
	    },
	    modalAppendToBody: {
	      type: Boolean,
	      default: true
	    },
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	    size: {
	      type: String,
	      default: '30%'
	    },
	    title: {
	      type: String,
	      default: ''
	    },
	    visible: {
	      type: Boolean
	    },
	    wrapperClosable: {
	      type: Boolean,
	      default: true
	    },
	    withHeader: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    isHorizontal: function isHorizontal() {
	      return this.direction === 'rtl' || this.direction === 'ltr';
	    }
	  },
	  data: function data() {
	    return {
	      closed: false,
	      prevActiveElement: null
	    };
	  },
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.closed = false;
	        this.$emit('open');
	        if (this.appendToBody) {
	          document.body.appendChild(this.$el);
	        }
	        this.prevActiveElement = document.activeElement;
	      } else {
	        if (!this.closed) this.$emit('close');
	        this.$nextTick(function () {
	          if (_this.prevActiveElement) {
	            _this.prevActiveElement.focus();
	          }
	        });
	      }
	    }
	  },
	  methods: {
	    afterEnter: function afterEnter() {
	      this.$emit('opened');
	    },
	    afterLeave: function afterLeave() {
	      this.$emit('closed');
	    },
	    hide: function hide(cancel) {
	      if (cancel !== false) {
	        this.$emit('update:visible', false);
	        this.$emit('close');
	        if (this.destroyOnClose === true) {
	          this.rendered = false;
	        }
	        this.closed = true;
	      }
	    },
	    handleWrapperClick: function handleWrapperClick() {
	      if (this.wrapperClosable) {
	        this.closeDrawer();
	      }
	    },
	    closeDrawer: function closeDrawer() {
	      if (typeof this.beforeClose === 'function') {
	        this.beforeClose(this.hide);
	      } else {
	        this.hide();
	      }
	    },
	    handleClose: function handleClose() {
	      // This method here will be called by PopupManger, when the `closeOnPressEscape` was set to true
	      // pressing `ESC` will call this method, and also close the drawer.
	      // This method also calls `beforeClose` if there was one.
	      this.closeDrawer();
	    }
	  },
	  mounted: function mounted() {
	    if (this.visible) {
	      this.rendered = true;
	      this.open();
	    }
	  },
	  destroyed: function destroyed() {
	    // if appendToBody is true, remove DOM node after destroy
	    if (this.appendToBody && this.$el && this.$el.parentNode) {
	      this.$el.parentNode.removeChild(this.$el);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_drawer_src_mainvue_type_script_lang_js_ = (drawer_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/drawer/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var drawer_src_main_component = normalizeComponent(
	  packages_drawer_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_a4885264_render,
	  mainvue_type_template_id_a4885264_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var drawer_src_main_api; }
	drawer_src_main_component.options.__file = "packages/drawer/src/main.vue"
	/* harmony default export */ var drawer_src_main = (drawer_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/drawer/index.js
	
	
	/* istanbul ignore next */
	drawer_src_main.install = function (Vue) {
	  Vue.component(drawer_src_main.name, drawer_src_main);
	};
	
	/* harmony default export */ var drawer = (drawer_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&
	var mainvue_type_template_id_048de730_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "el-popover",
	    _vm._b(
	      {
	        attrs: { trigger: "click" },
	        model: {
	          value: _vm.visible,
	          callback: function($$v) {
	            _vm.visible = $$v
	          },
	          expression: "visible"
	        }
	      },
	      "el-popover",
	      _vm.$attrs,
	      false
	    ),
	    [
	      _c("div", { staticClass: "el-popconfirm" }, [
	        _c("p", { staticClass: "el-popconfirm__main" }, [
	          !_vm.hideIcon
	            ? _c("i", {
	                staticClass: "el-popconfirm__icon",
	                class: _vm.icon,
	                style: { color: _vm.iconColor }
	              })
	            : _vm._e(),
	          _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
	        ]),
	        _c(
	          "div",
	          { staticClass: "el-popconfirm__action" },
	          [
	            _c(
	              "el-button",
	              {
	                attrs: { size: "mini", type: _vm.cancelButtonType },
	                on: { click: _vm.cancel }
	              },
	              [
	                _vm._v(
	                  "\n        " +
	                    _vm._s(_vm.displayCancelButtonText) +
	                    "\n      "
	                )
	              ]
	            ),
	            _c(
	              "el-button",
	              {
	                attrs: { size: "mini", type: _vm.confirmButtonType },
	                on: { click: _vm.confirm }
	              },
	              [
	                _vm._v(
	                  "\n        " +
	                    _vm._s(_vm.displayConfirmButtonText) +
	                    "\n      "
	                )
	              ]
	            )
	          ],
	          1
	        )
	      ]),
	      _vm._t("reference", null, { slot: "reference" })
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_048de730_staticRenderFns = []
	mainvue_type_template_id_048de730_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&
	
	// EXTERNAL MODULE: external "element-ui/lib/popover"
	var popover_ = __webpack_require__(44);
	var popover_default = /*#__PURE__*/__webpack_require__.n(popover_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var popconfirm_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElPopconfirm',
	  props: {
	    title: {
	      type: String
	    },
	    confirmButtonText: {
	      type: String
	    },
	    cancelButtonText: {
	      type: String
	    },
	    confirmButtonType: {
	      type: String,
	      default: 'primary'
	    },
	    cancelButtonType: {
	      type: String,
	      default: 'text'
	    },
	    icon: {
	      type: String,
	      default: 'el-icon-question'
	    },
	    iconColor: {
	      type: String,
	      default: '#f90'
	    },
	    hideIcon: {
	      type: Boolean,
	      default: false
	    }
	  },
	  components: {
	    ElPopover: popover_default.a,
	    ElButton: button_default.a
	  },
	  data: function data() {
	    return {
	      visible: false
	    };
	  },
	
	  computed: {
	    displayConfirmButtonText: function displayConfirmButtonText() {
	      return this.confirmButtonText || Object(lib_locale_["t"])('el.popconfirm.confirmButtonText');
	    },
	    displayCancelButtonText: function displayCancelButtonText() {
	      return this.cancelButtonText || Object(lib_locale_["t"])('el.popconfirm.cancelButtonText');
	    }
	  },
	  methods: {
	    confirm: function confirm() {
	      this.visible = false;
	      this.$emit('confirm');
	    },
	    cancel: function cancel() {
	      this.visible = false;
	      this.$emit('cancel');
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_popconfirm_src_mainvue_type_script_lang_js_ = (popconfirm_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var popconfirm_src_main_component = normalizeComponent(
	  packages_popconfirm_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_048de730_render,
	  mainvue_type_template_id_048de730_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var popconfirm_src_main_api; }
	popconfirm_src_main_component.options.__file = "packages/popconfirm/src/main.vue"
	/* harmony default export */ var popconfirm_src_main = (popconfirm_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/popconfirm/index.js
	
	
	/* istanbul ignore next */
	popconfirm_src_main.install = function (Vue) {
	  Vue.component(popconfirm_src_main.name, popconfirm_src_main);
	};
	
	/* harmony default export */ var popconfirm = (popconfirm_src_main);
	// CONCATENATED MODULE: ./src/index.js
	/* Automatically generated by './build/bin/build-entry.js' */
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var components = [packages_pagination, dialog, packages_autocomplete, packages_dropdown, packages_dropdown_menu, packages_dropdown_item, packages_menu, packages_submenu, packages_menu_item, packages_menu_item_group, packages_input, packages_input_number, packages_radio, packages_radio_group, packages_radio_button, packages_checkbox, packages_checkbox_button, packages_checkbox_group, packages_switch, packages_select, packages_option, packages_option_group, packages_button, packages_button_group, packages_table, packages_table_column, packages_date_picker, packages_time_select, packages_time_picker, popover, packages_tooltip, packages_breadcrumb, packages_breadcrumb_item, packages_form, packages_form_item, packages_tabs, packages_tab_pane, packages_tag, packages_tree, packages_alert, slider, packages_icon, packages_row, packages_col, packages_upload, packages_progress, packages_spinner, badge, card, rate, packages_steps, packages_step, carousel, scrollbar, carousel_item, packages_collapse, packages_collapse_item, packages_cascader, color_picker, transfer, packages_container, header, aside, packages_main, footer, timeline, timeline_item, packages_link, divider, packages_image, calendar, backtop, page_header, packages_cascader_panel, avatar, drawer, popconfirm, collapse_transition_default.a];
	
	var src_install = function install(Vue) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  lib_locale_default.a.use(opts.locale);
	  lib_locale_default.a.i18n(opts.i18n);
	
	  components.forEach(function (component) {
	    Vue.component(component.name, component);
	  });
	
	  Vue.use(infinite_scroll);
	  Vue.use(packages_loading.directive);
	
	  Vue.prototype.$ELEMENT = {
	    size: opts.size || '',
	    zIndex: opts.zIndex || 2000
	  };
	
	  Vue.prototype.$loading = packages_loading.service;
	  Vue.prototype.$msgbox = message_box;
	  Vue.prototype.$alert = message_box.alert;
	  Vue.prototype.$confirm = message_box.confirm;
	  Vue.prototype.$prompt = message_box.prompt;
	  Vue.prototype.$notify = notification;
	  Vue.prototype.$message = packages_message;
	};
	
	/* istanbul ignore if */
	if (typeof window !== 'undefined' && window.Vue) {
	  src_install(window.Vue);
	}
	
	/* harmony default export */ var src_0 = __webpack_exports__["default"] = ({
	  version: '2.15.0',
	  locale: lib_locale_default.a.use,
	  i18n: lib_locale_default.a.i18n,
	  install: src_install,
	  CollapseTransition: collapse_transition_default.a,
	  Loading: packages_loading,
	  Pagination: packages_pagination,
	  Dialog: dialog,
	  Autocomplete: packages_autocomplete,
	  Dropdown: packages_dropdown,
	  DropdownMenu: packages_dropdown_menu,
	  DropdownItem: packages_dropdown_item,
	  Menu: packages_menu,
	  Submenu: packages_submenu,
	  MenuItem: packages_menu_item,
	  MenuItemGroup: packages_menu_item_group,
	  Input: packages_input,
	  InputNumber: packages_input_number,
	  Radio: packages_radio,
	  RadioGroup: packages_radio_group,
	  RadioButton: packages_radio_button,
	  Checkbox: packages_checkbox,
	  CheckboxButton: packages_checkbox_button,
	  CheckboxGroup: packages_checkbox_group,
	  Switch: packages_switch,
	  Select: packages_select,
	  Option: packages_option,
	  OptionGroup: packages_option_group,
	  Button: packages_button,
	  ButtonGroup: packages_button_group,
	  Table: packages_table,
	  TableColumn: packages_table_column,
	  DatePicker: packages_date_picker,
	  TimeSelect: packages_time_select,
	  TimePicker: packages_time_picker,
	  Popover: popover,
	  Tooltip: packages_tooltip,
	  MessageBox: message_box,
	  Breadcrumb: packages_breadcrumb,
	  BreadcrumbItem: packages_breadcrumb_item,
	  Form: packages_form,
	  FormItem: packages_form_item,
	  Tabs: packages_tabs,
	  TabPane: packages_tab_pane,
	  Tag: packages_tag,
	  Tree: packages_tree,
	  Alert: packages_alert,
	  Notification: notification,
	  Slider: slider,
	  Icon: packages_icon,
	  Row: packages_row,
	  Col: packages_col,
	  Upload: packages_upload,
	  Progress: packages_progress,
	  Spinner: packages_spinner,
	  Message: packages_message,
	  Badge: badge,
	  Card: card,
	  Rate: rate,
	  Steps: packages_steps,
	  Step: packages_step,
	  Carousel: carousel,
	  Scrollbar: scrollbar,
	  CarouselItem: carousel_item,
	  Collapse: packages_collapse,
	  CollapseItem: packages_collapse_item,
	  Cascader: packages_cascader,
	  ColorPicker: color_picker,
	  Transfer: transfer,
	  Container: packages_container,
	  Header: header,
	  Aside: aside,
	  Main: packages_main,
	  Footer: footer,
	  Timeline: timeline,
	  TimelineItem: timeline_item,
	  Link: packages_link,
	  Divider: divider,
	  Image: packages_image,
	  Calendar: calendar,
	  Backtop: backtop,
	  InfiniteScroll: infinite_scroll,
	  PageHeader: page_header,
	  CascaderPanel: packages_cascader_panel,
	  Avatar: avatar,
	  Drawer: drawer,
	  Popconfirm: popconfirm
	});
	
	/***/ })
	/******/ ])["default"];

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 114);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 10:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(79);
	
	/***/ }),
	
	/***/ 114:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        "el-input-number",
	        _vm.inputNumberSize ? "el-input-number--" + _vm.inputNumberSize : "",
	        { "is-disabled": _vm.inputNumberDisabled },
	        { "is-without-controls": !_vm.controls },
	        { "is-controls-right": _vm.controlsAtRight }
	      ],
	      on: {
	        dragstart: function($event) {
	          $event.preventDefault()
	        }
	      }
	    },
	    [
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.decrease,
	                  expression: "decrease"
	                }
	              ],
	              staticClass: "el-input-number__decrease",
	              class: { "is-disabled": _vm.minDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.decrease($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class:
	                  "el-icon-" + (_vm.controlsAtRight ? "arrow-down" : "minus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.increase,
	                  expression: "increase"
	                }
	              ],
	              staticClass: "el-input-number__increase",
	              class: { "is-disabled": _vm.maxDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.increase($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class: "el-icon-" + (_vm.controlsAtRight ? "arrow-up" : "plus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _c("el-input", {
	        ref: "input",
	        attrs: {
	          value: _vm.displayValue,
	          placeholder: _vm.placeholder,
	          disabled: _vm.inputNumberDisabled,
	          size: _vm.inputNumberSize,
	          max: _vm.max,
	          min: _vm.min,
	          name: _vm.name,
	          label: _vm.label
	        },
	        on: {
	          blur: _vm.handleBlur,
	          focus: _vm.handleFocus,
	          input: _vm.handleInput,
	          change: _vm.handleInputChange
	        },
	        nativeOn: {
	          keydown: [
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.increase($event)
	            },
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "down", 40, $event.key, [
	                  "Down",
	                  "ArrowDown"
	                ])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.decrease($event)
	            }
	          ]
	        }
	      })
	    ],
	    1
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	
	// EXTERNAL MODULE: external "element-ui/lib/input"
	var input_ = __webpack_require__(10);
	var input_default = /*#__PURE__*/__webpack_require__.n(input_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
	var focus_ = __webpack_require__(22);
	var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);
	
	// EXTERNAL MODULE: ./src/directives/repeat-click.js
	var repeat_click = __webpack_require__(30);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var input_numbervue_type_script_lang_js_ = ({
	  name: 'ElInputNumber',
	  mixins: [focus_default()('input')],
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	  directives: {
	    repeatClick: repeat_click["a" /* default */]
	  },
	  components: {
	    ElInput: input_default.a
	  },
	  props: {
	    step: {
	      type: Number,
	      default: 1
	    },
	    stepStrictly: {
	      type: Boolean,
	      default: false
	    },
	    max: {
	      type: Number,
	      default: Infinity
	    },
	    min: {
	      type: Number,
	      default: -Infinity
	    },
	    value: {},
	    disabled: Boolean,
	    size: String,
	    controls: {
	      type: Boolean,
	      default: true
	    },
	    controlsPosition: {
	      type: String,
	      default: ''
	    },
	    name: String,
	    label: String,
	    placeholder: String,
	    precision: {
	      type: Number,
	      validator: function validator(val) {
	        return val >= 0 && val === parseInt(val, 10);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: 0,
	      userInput: null
	    };
	  },
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(value) {
	        var newVal = value === undefined ? value : Number(value);
	        if (newVal !== undefined) {
	          if (isNaN(newVal)) {
	            return;
	          }
	
	          if (this.stepStrictly) {
	            var stepPrecision = this.getPrecision(this.step);
	            var precisionFactor = Math.pow(10, stepPrecision);
	            newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
	          }
	
	          if (this.precision !== undefined) {
	            newVal = this.toPrecision(newVal, this.precision);
	          }
	        }
	        if (newVal >= this.max) newVal = this.max;
	        if (newVal <= this.min) newVal = this.min;
	        this.currentValue = newVal;
	        this.userInput = null;
	        this.$emit('input', newVal);
	      }
	    }
	  },
	  computed: {
	    minDisabled: function minDisabled() {
	      return this._decrease(this.value, this.step) < this.min;
	    },
	    maxDisabled: function maxDisabled() {
	      return this._increase(this.value, this.step) > this.max;
	    },
	    numPrecision: function numPrecision() {
	      var value = this.value,
	          step = this.step,
	          getPrecision = this.getPrecision,
	          precision = this.precision;
	
	      var stepPrecision = getPrecision(step);
	      if (precision !== undefined) {
	        if (stepPrecision > precision) {
	          console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
	        }
	        return precision;
	      } else {
	        return Math.max(getPrecision(value), stepPrecision);
	      }
	    },
	    controlsAtRight: function controlsAtRight() {
	      return this.controls && this.controlsPosition === 'right';
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    inputNumberSize: function inputNumberSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputNumberDisabled: function inputNumberDisabled() {
	      return this.disabled || !!(this.elForm || {}).disabled;
	    },
	    displayValue: function displayValue() {
	      if (this.userInput !== null) {
	        return this.userInput;
	      }
	
	      var currentValue = this.currentValue;
	
	      if (typeof currentValue === 'number') {
	        if (this.stepStrictly) {
	          var stepPrecision = this.getPrecision(this.step);
	          var precisionFactor = Math.pow(10, stepPrecision);
	          currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
	        }
	
	        if (this.precision !== undefined) {
	          currentValue = currentValue.toFixed(this.precision);
	        }
	      }
	
	      return currentValue;
	    }
	  },
	  methods: {
	    toPrecision: function toPrecision(num, precision) {
	      if (precision === undefined) precision = this.numPrecision;
	      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
	    },
	    getPrecision: function getPrecision(value) {
	      if (value === undefined) return 0;
	      var valueString = value.toString();
	      var dotPosition = valueString.indexOf('.');
	      var precision = 0;
	      if (dotPosition !== -1) {
	        precision = valueString.length - dotPosition - 1;
	      }
	      return precision;
	    },
	    _increase: function _increase(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
	      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
	    },
	    _decrease: function _decrease(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	
	      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
	    },
	    increase: function increase() {
	      if (this.inputNumberDisabled || this.maxDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._increase(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    decrease: function decrease() {
	      if (this.inputNumberDisabled || this.minDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._decrease(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    handleBlur: function handleBlur(event) {
	      this.$emit('blur', event);
	    },
	    handleFocus: function handleFocus(event) {
	      this.$emit('focus', event);
	    },
	    setCurrentValue: function setCurrentValue(newVal) {
	      var oldVal = this.currentValue;
	      if (typeof newVal === 'number' && this.precision !== undefined) {
	        newVal = this.toPrecision(newVal, this.precision);
	      }
	      if (newVal >= this.max) newVal = this.max;
	      if (newVal <= this.min) newVal = this.min;
	      if (oldVal === newVal) return;
	      this.userInput = null;
	      this.$emit('input', newVal);
	      this.$emit('change', newVal, oldVal);
	      this.currentValue = newVal;
	    },
	    handleInput: function handleInput(value) {
	      this.userInput = value;
	    },
	    handleInputChange: function handleInputChange(value) {
	      var newVal = value === '' ? undefined : Number(value);
	      if (!isNaN(newVal) || value === '') {
	        this.setCurrentValue(newVal);
	      }
	      this.userInput = null;
	    },
	    select: function select() {
	      this.$refs.input.select();
	    }
	  },
	  mounted: function mounted() {
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('role', 'spinbutton');
	    innerInput.setAttribute('aria-valuemax', this.max);
	    innerInput.setAttribute('aria-valuemin', this.min);
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
	  },
	  updated: function updated() {
	    if (!this.$refs || !this.$refs.input) return;
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	  }
	});
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_input_numbervue_type_script_lang_js_ = (input_numbervue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_input_numbervue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/input-number/src/input-number.vue"
	/* harmony default export */ var input_number = (component.exports);
	// CONCATENATED MODULE: ./packages/input-number/index.js
	
	
	/* istanbul ignore next */
	input_number.install = function (Vue) {
	  Vue.component(input_number.name, input_number);
	};
	
	/* harmony default export */ var packages_input_number = __webpack_exports__["default"] = (input_number);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(23);
	
	/***/ }),
	
	/***/ 22:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(81);
	
	/***/ }),
	
	/***/ 30:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
	/* harmony import */ var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__);
	
	
	/* harmony default export */ __webpack_exports__["a"] = ({
	  bind: function bind(el, binding, vnode) {
	    var interval = null;
	    var startTime = void 0;
	    var handler = function handler() {
	      return vnode.context[binding.expression].apply();
	    };
	    var clear = function clear() {
	      if (Date.now() - startTime < 100) {
	        handler();
	      }
	      clearInterval(interval);
	      interval = null;
	    };
	
	    Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["on"])(el, 'mousedown', function (e) {
	      if (e.button !== 0) return;
	      startTime = Date.now();
	      Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["once"])(document, 'mouseup', clear);
	      clearInterval(interval);
	      interval = setInterval(handler, 100);
	    });
	  }
	});
	
	/***/ })
	
	/******/ });

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (Vue) {
	
	  /**
	   * template
	   *
	   * @param {String} string
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  function template(string) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (args.length === 1 && _typeof(args[0]) === 'object') {
	      args = args[0];
	    }
	
	    if (!args || !args.hasOwnProperty) {
	      args = {};
	    }
	
	    return string.replace(RE_NARGS, function (match, prefix, i, index) {
	      var result = void 0;
	
	      if (string[index - 1] === '{' && string[index + match.length] === '}') {
	        return i;
	      } else {
	        result = (0, _util.hasOwn)(args, i) ? args[i] : null;
	        if (result === null || result === undefined) {
	          return '';
	        }
	
	        return result;
	      }
	    });
	  }
	
	  return template;
	};
	
	var _util = __webpack_require__(21);
	
	var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
	/**
	 *  String format template
	 *  - Inspired:
	 *    https://github.com/Matt-Esch/string-template/index.js
	 */

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  el: {
	    colorpicker: {
	      confirm: '确定',
	      clear: '清空'
	    },
	    datepicker: {
	      now: '此刻',
	      today: '今天',
	      cancel: '取消',
	      clear: '清空',
	      confirm: '确定',
	      selectDate: '选择日期',
	      selectTime: '选择时间',
	      startDate: '开始日期',
	      startTime: '开始时间',
	      endDate: '结束日期',
	      endTime: '结束时间',
	      prevYear: '前一年',
	      nextYear: '后一年',
	      prevMonth: '上个月',
	      nextMonth: '下个月',
	      year: '年',
	      month1: '1 月',
	      month2: '2 月',
	      month3: '3 月',
	      month4: '4 月',
	      month5: '5 月',
	      month6: '6 月',
	      month7: '7 月',
	      month8: '8 月',
	      month9: '9 月',
	      month10: '10 月',
	      month11: '11 月',
	      month12: '12 月',
	      // week: '周次',
	      weeks: {
	        sun: '日',
	        mon: '一',
	        tue: '二',
	        wed: '三',
	        thu: '四',
	        fri: '五',
	        sat: '六'
	      },
	      months: {
	        jan: '一月',
	        feb: '二月',
	        mar: '三月',
	        apr: '四月',
	        may: '五月',
	        jun: '六月',
	        jul: '七月',
	        aug: '八月',
	        sep: '九月',
	        oct: '十月',
	        nov: '十一月',
	        dec: '十二月'
	      }
	    },
	    select: {
	      loading: '加载中',
	      noMatch: '无匹配数据',
	      noData: '无数据',
	      placeholder: '请选择'
	    },
	    cascader: {
	      noMatch: '无匹配数据',
	      loading: '加载中',
	      placeholder: '请选择',
	      noData: '暂无数据'
	    },
	    pagination: {
	      goto: '前往',
	      pagesize: '条/页',
	      total: '共 {total} 条',
	      pageClassifier: '页'
	    },
	    messagebox: {
	      title: '提示',
	      confirm: '确定',
	      cancel: '取消',
	      error: '输入的数据不合法!'
	    },
	    upload: {
	      deleteTip: '按 delete 键可删除',
	      delete: '删除',
	      preview: '查看图片',
	      continue: '继续上传'
	    },
	    table: {
	      emptyText: '暂无数据',
	      confirmFilter: '筛选',
	      resetFilter: '重置',
	      clearFilter: '全部',
	      sumText: '合计'
	    },
	    tree: {
	      emptyText: '暂无数据'
	    },
	    transfer: {
	      noMatch: '无匹配数据',
	      noData: '无数据',
	      titles: ['列表 1', '列表 2'],
	      filterPlaceholder: '请输入搜索内容',
	      noCheckedFormat: '共 {total} 项',
	      hasCheckedFormat: '已选 {checked}/{total} 项'
	    },
	    image: {
	      error: '加载失败'
	    },
	    pageHeader: {
	      title: '返回'
	    },
	    popconfirm: {
	      confirmButtonText: '确定',
	      cancelButtonText: '取消'
	    }
	  }
	};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 53);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(21);
	
	/***/ }),
	
	/***/ 33:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-dropdown__item",
	      class: {
	        selected: _vm.itemSelected,
	        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
	        hover: _vm.hover
	      },
	      on: {
	        mouseenter: _vm.hoverItem,
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.selectOptionClick($event)
	        }
	      }
	    },
	    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var optionvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOption',
	
	  componentName: 'ElOption',
	
	  inject: ['select'],
	
	  props: {
	    value: {
	      required: true
	    },
	    label: [String, Number],
	    created: Boolean,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      groupDisabled: false,
	      visible: true,
	      hitState: false,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    isObject: function isObject() {
	      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
	    },
	    currentLabel: function currentLabel() {
	      return this.label || (this.isObject ? '' : this.value);
	    },
	    currentValue: function currentValue() {
	      return this.value || this.label || '';
	    },
	    itemSelected: function itemSelected() {
	      if (!this.select.multiple) {
	        return this.isEqual(this.value, this.select.value);
	      } else {
	        return this.contains(this.select.value, this.value);
	      }
	    },
	    limitReached: function limitReached() {
	      if (this.select.multiple) {
	        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
	      } else {
	        return false;
	      }
	    }
	  },
	
	  watch: {
	    currentLabel: function currentLabel() {
	      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
	    },
	    value: function value(val, oldVal) {
	      var _select = this.select,
	          remote = _select.remote,
	          valueKey = _select.valueKey;
	
	      if (!this.created && !remote) {
	        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
	          return;
	        }
	        this.dispatch('ElSelect', 'setSelected');
	      }
	    }
	  },
	
	  methods: {
	    isEqual: function isEqual(a, b) {
	      if (!this.isObject) {
	        return a === b;
	      } else {
	        var valueKey = this.select.valueKey;
	        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
	      }
	    },
	    contains: function contains() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var target = arguments[1];
	
	      if (!this.isObject) {
	        return arr && arr.indexOf(target) > -1;
	      } else {
	        var valueKey = this.select.valueKey;
	        return arr && arr.some(function (item) {
	          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
	        });
	      }
	    },
	    handleGroupDisabled: function handleGroupDisabled(val) {
	      this.groupDisabled = val;
	    },
	    hoverItem: function hoverItem() {
	      if (!this.disabled && !this.groupDisabled) {
	        this.select.hoverIndex = this.select.options.indexOf(this);
	      }
	    },
	    selectOptionClick: function selectOptionClick() {
	      if (this.disabled !== true && this.groupDisabled !== true) {
	        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
	      }
	    },
	    queryChange: function queryChange(query) {
	      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
	      if (!this.visible) {
	        this.select.filteredOptionsCount--;
	      }
	    }
	  },
	
	  created: function created() {
	    this.select.options.push(this);
	    this.select.cachedOptions.push(this);
	    this.select.optionsCount++;
	    this.select.filteredOptionsCount++;
	
	    this.$on('queryChange', this.queryChange);
	    this.$on('handleGroupDisabled', this.handleGroupDisabled);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _select2 = this.select,
	        selected = _select2.selected,
	        multiple = _select2.multiple;
	
	    var selectedOptions = multiple ? selected : [selected];
	    var index = this.select.cachedOptions.indexOf(this);
	    var selectedIndex = selectedOptions.indexOf(this);
	
	    // if option is not selected, remove it from cache
	    if (index > -1 && selectedIndex < 0) {
	      this.select.cachedOptions.splice(index, 1);
	    }
	    this.select.onOptionDestroy(this.select.options.indexOf(this));
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_optionvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/select/src/option.vue"
	/* harmony default export */ var src_option = __webpack_exports__["a"] = (component.exports);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(33);
	
	/***/ }),
	
	/***/ 53:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _select_src_option__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33);
	
	
	/* istanbul ignore next */
	_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = function (Vue) {
	  Vue.component(_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 74);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(23);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(21);
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(58);
	
	/***/ }),
	
	/***/ 7:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(6);
	
	/***/ }),
	
	/***/ 74:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "span",
	    [
	      _c(
	        "transition",
	        {
	          attrs: { name: _vm.transition },
	          on: {
	            "after-enter": _vm.handleAfterEnter,
	            "after-leave": _vm.handleAfterLeave
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.disabled && _vm.showPopper,
	                  expression: "!disabled && showPopper"
	                }
	              ],
	              ref: "popper",
	              staticClass: "el-popover el-popper",
	              class: [_vm.popperClass, _vm.content && "el-popover--plain"],
	              style: { width: _vm.width + "px" },
	              attrs: {
	                role: "tooltip",
	                id: _vm.tooltipId,
	                "aria-hidden":
	                  _vm.disabled || !_vm.showPopper ? "true" : "false"
	              }
	            },
	            [
	              _vm.title
	                ? _c("div", {
	                    staticClass: "el-popover__title",
	                    domProps: { textContent: _vm._s(_vm.title) }
	                  })
	                : _vm._e(),
	              _vm._t("default", [_vm._v(_vm._s(_vm.content))])
	            ],
	            2
	          )
	        ]
	      ),
	      _c(
	        "span",
	        { ref: "wrapper", staticClass: "el-popover__reference-wrapper" },
	        [_vm._t("reference")],
	        2
	      )
	    ],
	    1
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(2);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var mainvue_type_script_lang_js_ = ({
	  name: 'ElPopover',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    trigger: {
	      type: String,
	      default: 'click',
	      validator: function validator(value) {
	        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
	      }
	    },
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    closeDelay: {
	      type: Number,
	      default: 200
	    },
	    title: String,
	    disabled: Boolean,
	    content: String,
	    reference: {},
	    popperClass: String,
	    width: {},
	    visibleArrow: {
	      default: true
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    transition: {
	      type: String,
	      default: 'fade-in-linear'
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  computed: {
	    tooltipId: function tooltipId() {
	      return 'el-popover-' + Object(util_["generateId"])();
	    }
	  },
	  watch: {
	    showPopper: function showPopper(val) {
	      if (this.disabled) {
	        return;
	      }
	      val ? this.$emit('show') : this.$emit('hide');
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var reference = this.referenceElm = this.reference || this.$refs.reference;
	    var popper = this.popper || this.$refs.popper;
	
	    if (!reference && this.$refs.wrapper.children) {
	      reference = this.referenceElm = this.$refs.wrapper.children[0];
	    }
	    // 可访问性
	    if (reference) {
	      Object(dom_["addClass"])(reference, 'el-popover__reference');
	      reference.setAttribute('aria-describedby', this.tooltipId);
	      reference.setAttribute('tabindex', this.tabindex); // tab序列
	      popper.setAttribute('tabindex', 0);
	
	      if (this.trigger !== 'click') {
	        Object(dom_["on"])(reference, 'focusin', function () {
	          _this.handleFocus();
	          var instance = reference.__vue__;
	          if (instance && typeof instance.focus === 'function') {
	            instance.focus();
	          }
	        });
	        Object(dom_["on"])(popper, 'focusin', this.handleFocus);
	        Object(dom_["on"])(reference, 'focusout', this.handleBlur);
	        Object(dom_["on"])(popper, 'focusout', this.handleBlur);
	      }
	      Object(dom_["on"])(reference, 'keydown', this.handleKeydown);
	      Object(dom_["on"])(reference, 'click', this.handleClick);
	    }
	    if (this.trigger === 'click') {
	      Object(dom_["on"])(reference, 'click', this.doToggle);
	      Object(dom_["on"])(document, 'click', this.handleDocumentClick);
	    } else if (this.trigger === 'hover') {
	      Object(dom_["on"])(reference, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(popper, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(reference, 'mouseleave', this.handleMouseLeave);
	      Object(dom_["on"])(popper, 'mouseleave', this.handleMouseLeave);
	    } else if (this.trigger === 'focus') {
	      if (this.tabindex < 0) {
	        console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');
	      }
	      if (reference.querySelector('input, textarea')) {
	        Object(dom_["on"])(reference, 'focusin', this.doShow);
	        Object(dom_["on"])(reference, 'focusout', this.doClose);
	      } else {
	        Object(dom_["on"])(reference, 'mousedown', this.doShow);
	        Object(dom_["on"])(reference, 'mouseup', this.doClose);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.cleanup();
	  },
	  deactivated: function deactivated() {
	    this.cleanup();
	  },
	
	
	  methods: {
	    doToggle: function doToggle() {
	      this.showPopper = !this.showPopper;
	    },
	    doShow: function doShow() {
	      this.showPopper = true;
	    },
	    doClose: function doClose() {
	      this.showPopper = false;
	    },
	    handleFocus: function handleFocus() {
	      Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = true;
	    },
	    handleClick: function handleClick() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	    },
	    handleBlur: function handleBlur() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = false;
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      var _this2 = this;
	
	      clearTimeout(this._timer);
	      if (this.openDelay) {
	        this._timer = setTimeout(function () {
	          _this2.showPopper = true;
	        }, this.openDelay);
	      } else {
	        this.showPopper = true;
	      }
	    },
	    handleKeydown: function handleKeydown(ev) {
	      if (ev.keyCode === 27 && this.trigger !== 'manual') {
	        // esc
	        this.doClose();
	      }
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      var _this3 = this;
	
	      clearTimeout(this._timer);
	      if (this.closeDelay) {
	        this._timer = setTimeout(function () {
	          _this3.showPopper = false;
	        }, this.closeDelay);
	      } else {
	        this.showPopper = false;
	      }
	    },
	    handleDocumentClick: function handleDocumentClick(e) {
	      var reference = this.reference || this.$refs.reference;
	      var popper = this.popper || this.$refs.popper;
	
	      if (!reference && this.$refs.wrapper.children) {
	        reference = this.referenceElm = this.$refs.wrapper.children[0];
	      }
	      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
	      this.showPopper = false;
	    },
	    handleAfterEnter: function handleAfterEnter() {
	      this.$emit('after-enter');
	    },
	    handleAfterLeave: function handleAfterLeave() {
	      this.$emit('after-leave');
	      this.doDestroy();
	    },
	    cleanup: function cleanup() {
	      if (this.openDelay || this.closeDelay) {
	        clearTimeout(this._timer);
	      }
	    }
	  },
	
	  destroyed: function destroyed() {
	    var reference = this.reference;
	
	    Object(dom_["off"])(reference, 'click', this.doToggle);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'focusin', this.doShow);
	    Object(dom_["off"])(reference, 'focusout', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mouseleave', this.handleMouseLeave);
	    Object(dom_["off"])(reference, 'mouseenter', this.handleMouseEnter);
	    Object(dom_["off"])(document, 'click', this.handleDocumentClick);
	  }
	});
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/popover/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_mainvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/popover/src/main.vue"
	/* harmony default export */ var main = (component.exports);
	// CONCATENATED MODULE: ./packages/popover/src/directive.js
	var getReference = function getReference(el, binding, vnode) {
	  var _ref = binding.expression ? binding.value : binding.arg;
	  var popper = vnode.context.$refs[_ref];
	  if (popper) {
	    if (Array.isArray(popper)) {
	      popper[0].$refs.reference = el;
	    } else {
	      popper.$refs.reference = el;
	    }
	  }
	};
	
	/* harmony default export */ var directive = ({
	  bind: function bind(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  },
	  inserted: function inserted(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  }
	});
	// EXTERNAL MODULE: external "vue"
	var external_vue_ = __webpack_require__(7);
	var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
	
	// CONCATENATED MODULE: ./packages/popover/index.js
	
	
	
	
	external_vue_default.a.directive('popover', directive);
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.directive('popover', directive);
	  Vue.component(main.name, main);
	};
	main.directive = directive;
	
	/* harmony default export */ var popover = __webpack_exports__["default"] = (main);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 119);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 119:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-progress",
	      class: [
	        "el-progress--" + _vm.type,
	        _vm.status ? "is-" + _vm.status : "",
	        {
	          "el-progress--without-text": !_vm.showText,
	          "el-progress--text-inside": _vm.textInside
	        }
	      ],
	      attrs: {
	        role: "progressbar",
	        "aria-valuenow": _vm.percentage,
	        "aria-valuemin": "0",
	        "aria-valuemax": "100"
	      }
	    },
	    [
	      _vm.type === "line"
	        ? _c("div", { staticClass: "el-progress-bar" }, [
	            _c(
	              "div",
	              {
	                staticClass: "el-progress-bar__outer",
	                style: { height: _vm.strokeWidth + "px" }
	              },
	              [
	                _c(
	                  "div",
	                  {
	                    staticClass: "el-progress-bar__inner",
	                    style: _vm.barStyle
	                  },
	                  [
	                    _vm.showText && _vm.textInside
	                      ? _c(
	                          "div",
	                          { staticClass: "el-progress-bar__innerText" },
	                          [_vm._v(_vm._s(_vm.content))]
	                        )
	                      : _vm._e()
	                  ]
	                )
	              ]
	            )
	          ])
	        : _c(
	            "div",
	            {
	              staticClass: "el-progress-circle",
	              style: { height: _vm.width + "px", width: _vm.width + "px" }
	            },
	            [
	              _c("svg", { attrs: { viewBox: "0 0 100 100" } }, [
	                _c("path", {
	                  staticClass: "el-progress-circle__track",
	                  style: _vm.trailPathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: "#e5e9f2",
	                    "stroke-width": _vm.relativeStrokeWidth,
	                    fill: "none"
	                  }
	                }),
	                _c("path", {
	                  staticClass: "el-progress-circle__path",
	                  style: _vm.circlePathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: _vm.stroke,
	                    fill: "none",
	                    "stroke-linecap": _vm.strokeLinecap,
	                    "stroke-width": _vm.percentage ? _vm.relativeStrokeWidth : 0
	                  }
	                })
	              ])
	            ]
	          ),
	      _vm.showText && !_vm.textInside
	        ? _c(
	            "div",
	            {
	              staticClass: "el-progress__text",
	              style: { fontSize: _vm.progressTextSize + "px" }
	            },
	            [
	              !_vm.status
	                ? [_vm._v(_vm._s(_vm.content))]
	                : _c("i", { class: _vm.iconClass })
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var progressvue_type_script_lang_js_ = ({
	  name: 'ElProgress',
	  props: {
	    type: {
	      type: String,
	      default: 'line',
	      validator: function validator(val) {
	        return ['line', 'circle', 'dashboard'].indexOf(val) > -1;
	      }
	    },
	    percentage: {
	      type: Number,
	      default: 0,
	      required: true,
	      validator: function validator(val) {
	        return val >= 0 && val <= 100;
	      }
	    },
	    status: {
	      type: String,
	      validator: function validator(val) {
	        return ['success', 'exception', 'warning'].indexOf(val) > -1;
	      }
	    },
	    strokeWidth: {
	      type: Number,
	      default: 6
	    },
	    strokeLinecap: {
	      type: String,
	      default: 'round'
	    },
	    textInside: {
	      type: Boolean,
	      default: false
	    },
	    width: {
	      type: Number,
	      default: 126
	    },
	    showText: {
	      type: Boolean,
	      default: true
	    },
	    color: {
	      type: [String, Array, Function],
	      default: ''
	    },
	    format: Function
	  },
	  computed: {
	    barStyle: function barStyle() {
	      var style = {};
	      style.width = this.percentage + '%';
	      style.backgroundColor = this.getCurrentColor(this.percentage);
	      return style;
	    },
	    relativeStrokeWidth: function relativeStrokeWidth() {
	      return (this.strokeWidth / this.width * 100).toFixed(1);
	    },
	    radius: function radius() {
	      if (this.type === 'circle' || this.type === 'dashboard') {
	        return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
	      } else {
	        return 0;
	      }
	    },
	    trackPath: function trackPath() {
	      var radius = this.radius;
	      var isDashboard = this.type === 'dashboard';
	      return '\n        M 50 50\n        m 0 ' + (isDashboard ? '' : '-') + radius + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '-' : '') + radius * 2 + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '' : '-') + radius * 2 + '\n        ';
	    },
	    perimeter: function perimeter() {
	      return 2 * Math.PI * this.radius;
	    },
	    rate: function rate() {
	      return this.type === 'dashboard' ? 0.75 : 1;
	    },
	    strokeDashoffset: function strokeDashoffset() {
	      var offset = -1 * this.perimeter * (1 - this.rate) / 2;
	      return offset + 'px';
	    },
	    trailPathStyle: function trailPathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset
	      };
	    },
	    circlePathStyle: function circlePathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate * (this.percentage / 100) + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset,
	        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
	      };
	    },
	    stroke: function stroke() {
	      var ret = void 0;
	      if (this.color) {
	        ret = this.getCurrentColor(this.percentage);
	      } else {
	        switch (this.status) {
	          case 'success':
	            ret = '#13ce66';
	            break;
	          case 'exception':
	            ret = '#ff4949';
	            break;
	          case 'warning':
	            ret = '#e6a23c';
	            break;
	          default:
	            ret = '#20a0ff';
	        }
	      }
	      return ret;
	    },
	    iconClass: function iconClass() {
	      if (this.status === 'warning') {
	        return 'el-icon-warning';
	      }
	      if (this.type === 'line') {
	        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
	      } else {
	        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
	      }
	    },
	    progressTextSize: function progressTextSize() {
	      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
	    },
	    content: function content() {
	      if (typeof this.format === 'function') {
	        return this.format(this.percentage) || '';
	      } else {
	        return this.percentage + '%';
	      }
	    }
	  },
	  methods: {
	    getCurrentColor: function getCurrentColor(percentage) {
	      if (typeof this.color === 'function') {
	        return this.color(percentage);
	      } else if (typeof this.color === 'string') {
	        return this.color;
	      } else {
	        return this.getLevelColor(percentage);
	      }
	    },
	    getLevelColor: function getLevelColor(percentage) {
	      var colorArray = this.getColorArray().sort(function (a, b) {
	        return a.percentage - b.percentage;
	      });
	
	      for (var i = 0; i < colorArray.length; i++) {
	        if (colorArray[i].percentage > percentage) {
	          return colorArray[i].color;
	        }
	      }
	      return colorArray[colorArray.length - 1].color;
	    },
	    getColorArray: function getColorArray() {
	      var color = this.color;
	      var span = 100 / color.length;
	      return color.map(function (seriesColor, index) {
	        if (typeof seriesColor === 'string') {
	          return {
	            color: seriesColor,
	            percentage: (index + 1) * span
	          };
	        }
	        return seriesColor;
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_progressvue_type_script_lang_js_ = (progressvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_progressvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/progress/src/progress.vue"
	/* harmony default export */ var progress = (component.exports);
	// CONCATENATED MODULE: ./packages/progress/index.js
	
	
	/* istanbul ignore next */
	progress.install = function (Vue) {
	  Vue.component(progress.name, progress);
	};
	
	/* harmony default export */ var packages_progress = __webpack_exports__["default"] = (progress);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 61);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 10:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(79);
	
	/***/ }),
	
	/***/ 12:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(134);
	
	/***/ }),
	
	/***/ 14:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(83);
	
	/***/ }),
	
	/***/ 16:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(85);
	
	/***/ }),
	
	/***/ 17:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(59);
	
	/***/ }),
	
	/***/ 21:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(57);
	
	/***/ }),
	
	/***/ 22:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(81);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(21);
	
	/***/ }),
	
	/***/ 31:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(86);
	
	/***/ }),
	
	/***/ 33:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-dropdown__item",
	      class: {
	        selected: _vm.itemSelected,
	        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
	        hover: _vm.hover
	      },
	      on: {
	        mouseenter: _vm.hoverItem,
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.selectOptionClick($event)
	        }
	      }
	    },
	    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var optionvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOption',
	
	  componentName: 'ElOption',
	
	  inject: ['select'],
	
	  props: {
	    value: {
	      required: true
	    },
	    label: [String, Number],
	    created: Boolean,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      groupDisabled: false,
	      visible: true,
	      hitState: false,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    isObject: function isObject() {
	      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
	    },
	    currentLabel: function currentLabel() {
	      return this.label || (this.isObject ? '' : this.value);
	    },
	    currentValue: function currentValue() {
	      return this.value || this.label || '';
	    },
	    itemSelected: function itemSelected() {
	      if (!this.select.multiple) {
	        return this.isEqual(this.value, this.select.value);
	      } else {
	        return this.contains(this.select.value, this.value);
	      }
	    },
	    limitReached: function limitReached() {
	      if (this.select.multiple) {
	        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
	      } else {
	        return false;
	      }
	    }
	  },
	
	  watch: {
	    currentLabel: function currentLabel() {
	      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
	    },
	    value: function value(val, oldVal) {
	      var _select = this.select,
	          remote = _select.remote,
	          valueKey = _select.valueKey;
	
	      if (!this.created && !remote) {
	        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
	          return;
	        }
	        this.dispatch('ElSelect', 'setSelected');
	      }
	    }
	  },
	
	  methods: {
	    isEqual: function isEqual(a, b) {
	      if (!this.isObject) {
	        return a === b;
	      } else {
	        var valueKey = this.select.valueKey;
	        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
	      }
	    },
	    contains: function contains() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var target = arguments[1];
	
	      if (!this.isObject) {
	        return arr && arr.indexOf(target) > -1;
	      } else {
	        var valueKey = this.select.valueKey;
	        return arr && arr.some(function (item) {
	          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
	        });
	      }
	    },
	    handleGroupDisabled: function handleGroupDisabled(val) {
	      this.groupDisabled = val;
	    },
	    hoverItem: function hoverItem() {
	      if (!this.disabled && !this.groupDisabled) {
	        this.select.hoverIndex = this.select.options.indexOf(this);
	      }
	    },
	    selectOptionClick: function selectOptionClick() {
	      if (this.disabled !== true && this.groupDisabled !== true) {
	        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
	      }
	    },
	    queryChange: function queryChange(query) {
	      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
	      if (!this.visible) {
	        this.select.filteredOptionsCount--;
	      }
	    }
	  },
	
	  created: function created() {
	    this.select.options.push(this);
	    this.select.cachedOptions.push(this);
	    this.select.optionsCount++;
	    this.select.filteredOptionsCount++;
	
	    this.$on('queryChange', this.queryChange);
	    this.$on('handleGroupDisabled', this.handleGroupDisabled);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _select2 = this.select,
	        selected = _select2.selected,
	        multiple = _select2.multiple;
	
	    var selectedOptions = multiple ? selected : [selected];
	    var index = this.select.cachedOptions.indexOf(this);
	    var selectedIndex = selectedOptions.indexOf(this);
	
	    // if option is not selected, remove it from cache
	    if (index > -1 && selectedIndex < 0) {
	      this.select.cachedOptions.splice(index, 1);
	    }
	    this.select.onOptionDestroy(this.select.options.indexOf(this));
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_optionvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/select/src/option.vue"
	/* harmony default export */ var src_option = __webpack_exports__["a"] = (component.exports);
	
	/***/ }),
	
	/***/ 37:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(133);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(33);
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(58);
	
	/***/ }),
	
	/***/ 6:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(82);
	
	/***/ }),
	
	/***/ 61:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.handleClose,
	          expression: "handleClose"
	        }
	      ],
	      staticClass: "el-select",
	      class: [_vm.selectSize ? "el-select--" + _vm.selectSize : ""],
	      on: {
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.toggleMenu($event)
	        }
	      }
	    },
	    [
	      _vm.multiple
	        ? _c(
	            "div",
	            {
	              ref: "tags",
	              staticClass: "el-select__tags",
	              style: { "max-width": _vm.inputWidth - 32 + "px", width: "100%" }
	            },
	            [
	              _vm.collapseTags && _vm.selected.length
	                ? _c(
	                    "span",
	                    [
	                      _c(
	                        "el-tag",
	                        {
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: _vm.selected[0].hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, _vm.selected[0])
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(_vm.selected[0].currentLabel))
	                          ])
	                        ]
	                      ),
	                      _vm.selected.length > 1
	                        ? _c(
	                            "el-tag",
	                            {
	                              attrs: {
	                                closable: false,
	                                size: _vm.collapseTagSize,
	                                type: "info",
	                                "disable-transitions": ""
	                              }
	                            },
	                            [
	                              _c(
	                                "span",
	                                { staticClass: "el-select__tags-text" },
	                                [_vm._v("+ " + _vm._s(_vm.selected.length - 1))]
	                              )
	                            ]
	                          )
	                        : _vm._e()
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              !_vm.collapseTags
	                ? _c(
	                    "transition-group",
	                    { on: { "after-leave": _vm.resetInputHeight } },
	                    _vm._l(_vm.selected, function(item) {
	                      return _c(
	                        "el-tag",
	                        {
	                          key: _vm.getValueKey(item),
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: item.hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, item)
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(item.currentLabel))
	                          ])
	                        ]
	                      )
	                    }),
	                    1
	                  )
	                : _vm._e(),
	              _vm.filterable
	                ? _c("input", {
	                    directives: [
	                      {
	                        name: "model",
	                        rawName: "v-model",
	                        value: _vm.query,
	                        expression: "query"
	                      }
	                    ],
	                    ref: "input",
	                    staticClass: "el-select__input",
	                    class: [_vm.selectSize ? "is-" + _vm.selectSize : ""],
	                    style: {
	                      "flex-grow": "1",
	                      width: _vm.inputLength / (_vm.inputWidth - 32) + "%",
	                      "max-width": _vm.inputWidth - 42 + "px"
	                    },
	                    attrs: {
	                      type: "text",
	                      disabled: _vm.selectDisabled,
	                      autocomplete: _vm.autoComplete || _vm.autocomplete
	                    },
	                    domProps: { value: _vm.query },
	                    on: {
	                      focus: _vm.handleFocus,
	                      blur: function($event) {
	                        _vm.softFocus = false
	                      },
	                      keyup: _vm.managePlaceholder,
	                      keydown: [
	                        _vm.resetInputState,
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "down", 40, $event.key, [
	                              "Down",
	                              "ArrowDown"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("next")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "up", 38, $event.key, [
	                              "Up",
	                              "ArrowUp"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("prev")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "enter",
	                              13,
	                              $event.key,
	                              "Enter"
	                            )
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          return _vm.selectOption($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "esc", 27, $event.key, [
	                              "Esc",
	                              "Escape"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.stopPropagation()
	                          $event.preventDefault()
	                          _vm.visible = false
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "delete",
	                              [8, 46],
	                              $event.key,
	                              ["Backspace", "Delete", "Del"]
	                            )
	                          ) {
	                            return null
	                          }
	                          return _vm.deletePrevTag($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                          ) {
	                            return null
	                          }
	                          _vm.visible = false
	                        }
	                      ],
	                      compositionstart: _vm.handleComposition,
	                      compositionupdate: _vm.handleComposition,
	                      compositionend: _vm.handleComposition,
	                      input: [
	                        function($event) {
	                          if ($event.target.composing) {
	                            return
	                          }
	                          _vm.query = $event.target.value
	                        },
	                        _vm.debouncedQueryChange
	                      ]
	                    }
	                  })
	                : _vm._e()
	            ],
	            1
	          )
	        : _vm._e(),
	      _c(
	        "el-input",
	        {
	          ref: "reference",
	          class: { "is-focus": _vm.visible },
	          attrs: {
	            type: "text",
	            placeholder: _vm.currentPlaceholder,
	            name: _vm.name,
	            id: _vm.id,
	            autocomplete: _vm.autoComplete || _vm.autocomplete,
	            size: _vm.selectSize,
	            disabled: _vm.selectDisabled,
	            readonly: _vm.readonly,
	            "validate-event": false,
	            tabindex: _vm.multiple && _vm.filterable ? "-1" : null
	          },
	          on: { focus: _vm.handleFocus, blur: _vm.handleBlur },
	          nativeOn: {
	            keyup: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            keydown: [
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "down", 40, $event.key, [
	                    "Down",
	                    "ArrowDown"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("next")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "up", 38, $event.key, [
	                    "Up",
	                    "ArrowUp"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("prev")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                ) {
	                  return null
	                }
	                $event.preventDefault()
	                return _vm.selectOption($event)
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "esc", 27, $event.key, [
	                    "Esc",
	                    "Escape"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.visible = false
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                ) {
	                  return null
	                }
	                _vm.visible = false
	              }
	            ],
	            paste: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            mouseenter: function($event) {
	              _vm.inputHovering = true
	            },
	            mouseleave: function($event) {
	              _vm.inputHovering = false
	            }
	          },
	          model: {
	            value: _vm.selectedLabel,
	            callback: function($$v) {
	              _vm.selectedLabel = $$v
	            },
	            expression: "selectedLabel"
	          }
	        },
	        [
	          _vm.$slots.prefix
	            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
	            : _vm._e(),
	          _c("template", { slot: "suffix" }, [
	            _c("i", {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.showClose,
	                  expression: "!showClose"
	                }
	              ],
	              class: [
	                "el-select__caret",
	                "el-input__icon",
	                "el-icon-" + _vm.iconClass
	              ]
	            }),
	            _vm.showClose
	              ? _c("i", {
	                  staticClass:
	                    "el-select__caret el-input__icon el-icon-circle-close",
	                  on: { click: _vm.handleClearClick }
	                })
	              : _vm._e()
	          ])
	        ],
	        2
	      ),
	      _c(
	        "transition",
	        {
	          attrs: { name: "el-zoom-in-top" },
	          on: {
	            "before-enter": _vm.handleMenuEnter,
	            "after-leave": _vm.doDestroy
	          }
	        },
	        [
	          _c(
	            "el-select-menu",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.visible && _vm.emptyText !== false,
	                  expression: "visible && emptyText !== false"
	                }
	              ],
	              ref: "popper",
	              attrs: { "append-to-body": _vm.popperAppendToBody }
	            },
	            [
	              _c(
	                "el-scrollbar",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.options.length > 0 && !_vm.loading,
	                      expression: "options.length > 0 && !loading"
	                    }
	                  ],
	                  ref: "scrollbar",
	                  class: {
	                    "is-empty":
	                      !_vm.allowCreate &&
	                      _vm.query &&
	                      _vm.filteredOptionsCount === 0
	                  },
	                  attrs: {
	                    tag: "ul",
	                    "wrap-class": "el-select-dropdown__wrap",
	                    "view-class": "el-select-dropdown__list"
	                  }
	                },
	                [
	                  _vm.showNewOption
	                    ? _c("el-option", {
	                        attrs: { value: _vm.query, created: "" }
	                      })
	                    : _vm._e(),
	                  _vm._t("default")
	                ],
	                2
	              ),
	              _vm.emptyText &&
	              (!_vm.allowCreate ||
	                _vm.loading ||
	                (_vm.allowCreate && _vm.options.length === 0))
	                ? [
	                    _vm.$slots.empty
	                      ? _vm._t("empty")
	                      : _c("p", { staticClass: "el-select-dropdown__empty" }, [
	                          _vm._v(
	                            "\n          " +
	                              _vm._s(_vm.emptyText) +
	                              "\n        "
	                          )
	                        ])
	                  ]
	                : _vm._e()
	            ],
	            2
	          )
	        ],
	        1
	      )
	    ],
	    1
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
	var focus_ = __webpack_require__(22);
	var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
	var locale_ = __webpack_require__(6);
	var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);
	
	// EXTERNAL MODULE: external "element-ui/lib/input"
	var input_ = __webpack_require__(10);
	var input_default = /*#__PURE__*/__webpack_require__.n(input_);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	var select_dropdownvue_type_template_id_06828748_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-select-dropdown el-popper",
	      class: [{ "is-multiple": _vm.$parent.multiple }, _vm.popperClass],
	      style: { minWidth: _vm.minWidth }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var select_dropdownvue_type_template_id_06828748_staticRenderFns = []
	select_dropdownvue_type_template_id_06828748_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var select_dropdownvue_type_script_lang_js_ = ({
	  name: 'ElSelectDropdown',
	
	  componentName: 'ElSelectDropdown',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    placement: {
	      default: 'bottom-start'
	    },
	
	    boundariesPadding: {
	      default: 0
	    },
	
	    popperOptions: {
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    },
	
	    visibleArrow: {
	      default: true
	    },
	
	    appendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      minWidth: ''
	    };
	  },
	
	
	  computed: {
	    popperClass: function popperClass() {
	      return this.$parent.popperClass;
	    }
	  },
	
	  watch: {
	    '$parent.inputWidth': function $parentInputWidth() {
	      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.referenceElm = this.$parent.$refs.reference.$el;
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.$on('updatePopper', function () {
	      if (_this.$parent.visible) _this.updatePopper();
	    });
	    this.$on('destroyPopper', this.destroyPopper);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_select_dropdownvue_type_script_lang_js_ = (select_dropdownvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_select_dropdownvue_type_script_lang_js_,
	  select_dropdownvue_type_template_id_06828748_render,
	  select_dropdownvue_type_template_id_06828748_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/select/src/select-dropdown.vue"
	/* harmony default export */ var select_dropdown = (component.exports);
	// EXTERNAL MODULE: ./packages/select/src/option.vue + 4 modules
	var src_option = __webpack_require__(33);
	
	// EXTERNAL MODULE: external "element-ui/lib/tag"
	var tag_ = __webpack_require__(37);
	var tag_default = /*#__PURE__*/__webpack_require__.n(tag_);
	
	// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
	var scrollbar_ = __webpack_require__(14);
	var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);
	
	// EXTERNAL MODULE: external "throttle-debounce/debounce"
	var debounce_ = __webpack_require__(17);
	var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
	var clickoutside_ = __webpack_require__(12);
	var clickoutside_default = /*#__PURE__*/__webpack_require__.n(clickoutside_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
	var resize_event_ = __webpack_require__(16);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
	var scroll_into_view_ = __webpack_require__(31);
	var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
	/* harmony default export */ var navigation_mixin = ({
	  data: function data() {
	    return {
	      hoverOption: -1
	    };
	  },
	
	
	  computed: {
	    optionsAllDisabled: function optionsAllDisabled() {
	      return this.options.filter(function (option) {
	        return option.visible;
	      }).every(function (option) {
	        return option.disabled;
	      });
	    }
	  },
	
	  watch: {
	    hoverIndex: function hoverIndex(val) {
	      var _this = this;
	
	      if (typeof val === 'number' && val > -1) {
	        this.hoverOption = this.options[val] || {};
	      }
	      this.options.forEach(function (option) {
	        option.hover = _this.hoverOption === option;
	      });
	    }
	  },
	
	  methods: {
	    navigateOptions: function navigateOptions(direction) {
	      var _this2 = this;
	
	      if (!this.visible) {
	        this.visible = true;
	        return;
	      }
	      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
	      if (!this.optionsAllDisabled) {
	        if (direction === 'next') {
	          this.hoverIndex++;
	          if (this.hoverIndex === this.options.length) {
	            this.hoverIndex = 0;
	          }
	        } else if (direction === 'prev') {
	          this.hoverIndex--;
	          if (this.hoverIndex < 0) {
	            this.hoverIndex = this.options.length - 1;
	          }
	        }
	        var option = this.options[this.hoverIndex];
	        if (option.disabled === true || option.groupDisabled === true || !option.visible) {
	          this.navigateOptions(direction);
	        }
	        this.$nextTick(function () {
	          return _this2.scrollToOption(_this2.hoverOption);
	        });
	      }
	    }
	  }
	});
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(21);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var selectvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a, locale_default.a, focus_default()('reference'), navigation_mixin],
	
	  name: 'ElSelect',
	
	  componentName: 'ElSelect',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  provide: function provide() {
	    return {
	      'select': this
	    };
	  },
	
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    readonly: function readonly() {
	      return !this.filterable || this.multiple || !Object(util_["isIE"])() && !Object(util_["isEdge"])() && !this.visible;
	    },
	    showClose: function showClose() {
	      var hasValue = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== undefined && this.value !== null && this.value !== '';
	      var criteria = this.clearable && !this.selectDisabled && this.inputHovering && hasValue;
	      return criteria;
	    },
	    iconClass: function iconClass() {
	      return this.remote && this.filterable ? '' : this.visible ? 'arrow-up is-reverse' : 'arrow-up';
	    },
	    debounce: function debounce() {
	      return this.remote ? 300 : 0;
	    },
	    emptyText: function emptyText() {
	      if (this.loading) {
	        return this.loadingText || this.t('el.select.loading');
	      } else {
	        if (this.remote && this.query === '' && this.options.length === 0) return false;
	        if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
	          return this.noMatchText || this.t('el.select.noMatch');
	        }
	        if (this.options.length === 0) {
	          return this.noDataText || this.t('el.select.noData');
	        }
	      }
	      return null;
	    },
	    showNewOption: function showNewOption() {
	      var _this = this;
	
	      var hasExistingOption = this.options.filter(function (option) {
	        return !option.created;
	      }).some(function (option) {
	        return option.currentLabel === _this.query;
	      });
	      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
	    },
	    selectSize: function selectSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    selectDisabled: function selectDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    collapseTagSize: function collapseTagSize() {
	      return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
	    },
	    propPlaceholder: function propPlaceholder() {
	      return typeof this.placeholder !== 'undefined' ? this.placeholder : this.t('el.select.placeholder');
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElSelectMenu: select_dropdown,
	    ElOption: src_option["a" /* default */],
	    ElTag: tag_default.a,
	    ElScrollbar: scrollbar_default.a
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  props: {
	    name: String,
	    id: String,
	    value: {
	      required: true
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    automaticDropdown: Boolean,
	    size: String,
	    disabled: Boolean,
	    clearable: Boolean,
	    filterable: Boolean,
	    allowCreate: Boolean,
	    loading: Boolean,
	    popperClass: String,
	    remote: Boolean,
	    loadingText: String,
	    noMatchText: String,
	    noDataText: String,
	    remoteMethod: Function,
	    filterMethod: Function,
	    multiple: Boolean,
	    multipleLimit: {
	      type: Number,
	      default: 0
	    },
	    placeholder: {
	      type: String,
	      required: false
	    },
	    defaultFirstOption: Boolean,
	    reserveKeyword: Boolean,
	    valueKey: {
	      type: String,
	      default: 'value'
	    },
	    collapseTags: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      options: [],
	      cachedOptions: [],
	      createdLabel: null,
	      createdSelected: false,
	      selected: this.multiple ? [] : {},
	      inputLength: 20,
	      inputWidth: 0,
	      initialInputHeight: 0,
	      cachedPlaceHolder: '',
	      optionsCount: 0,
	      filteredOptionsCount: 0,
	      visible: false,
	      softFocus: false,
	      selectedLabel: '',
	      hoverIndex: -1,
	      query: '',
	      previousQuery: null,
	      inputHovering: false,
	      currentPlaceholder: '',
	      menuVisibleOnFocus: false,
	      isOnComposition: false,
	      isSilentBlur: false
	    };
	  },
	
	
	  watch: {
	    selectDisabled: function selectDisabled() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        _this2.resetInputHeight();
	      });
	    },
	    propPlaceholder: function propPlaceholder(val) {
	      this.cachedPlaceHolder = this.currentPlaceholder = val;
	    },
	    value: function value(val, oldVal) {
	      if (this.multiple) {
	        this.resetInputHeight();
	        if (val && val.length > 0 || this.$refs.input && this.query !== '') {
	          this.currentPlaceholder = '';
	        } else {
	          this.currentPlaceholder = this.cachedPlaceHolder;
	        }
	        if (this.filterable && !this.reserveKeyword) {
	          this.query = '';
	          this.handleQueryChange(this.query);
	        }
	      }
	      this.setSelected();
	      if (this.filterable && !this.multiple) {
	        this.inputLength = 20;
	      }
	      if (!Object(util_["valueEquals"])(val, oldVal)) {
	        this.dispatch('ElFormItem', 'el.form.change', val);
	      }
	    },
	    visible: function visible(val) {
	      var _this3 = this;
	
	      if (!val) {
	        this.broadcast('ElSelectDropdown', 'destroyPopper');
	        if (this.$refs.input) {
	          this.$refs.input.blur();
	        }
	        this.query = '';
	        this.previousQuery = null;
	        this.selectedLabel = '';
	        this.inputLength = 20;
	        this.menuVisibleOnFocus = false;
	        this.resetHoverIndex();
	        this.$nextTick(function () {
	          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
	            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
	          }
	        });
	        if (!this.multiple) {
	          if (this.selected) {
	            if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
	              this.selectedLabel = this.createdLabel;
	            } else {
	              this.selectedLabel = this.selected.currentLabel;
	            }
	            if (this.filterable) this.query = this.selectedLabel;
	          }
	
	          if (this.filterable) {
	            this.currentPlaceholder = this.cachedPlaceHolder;
	          }
	        }
	      } else {
	        this.broadcast('ElSelectDropdown', 'updatePopper');
	        if (this.filterable) {
	          this.query = this.remote ? '' : this.selectedLabel;
	          this.handleQueryChange(this.query);
	          if (this.multiple) {
	            this.$refs.input.focus();
	          } else {
	            if (!this.remote) {
	              this.broadcast('ElOption', 'queryChange', '');
	              this.broadcast('ElOptionGroup', 'queryChange');
	            }
	
	            if (this.selectedLabel) {
	              this.currentPlaceholder = this.selectedLabel;
	              this.selectedLabel = '';
	            }
	          }
	        }
	      }
	      this.$emit('visible-change', val);
	    },
	    options: function options() {
	      var _this4 = this;
	
	      if (this.$isServer) return;
	      this.$nextTick(function () {
	        _this4.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      if (this.multiple) {
	        this.resetInputHeight();
	      }
	      var inputs = this.$el.querySelectorAll('input');
	      if ([].indexOf.call(inputs, document.activeElement) === -1) {
	        this.setSelected();
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    }
	  },
	
	  methods: {
	    handleComposition: function handleComposition(event) {
	      var _this5 = this;
	
	      var text = event.target.value;
	      if (event.type === 'compositionend') {
	        this.isOnComposition = false;
	        this.$nextTick(function (_) {
	          return _this5.handleQueryChange(text);
	        });
	      } else {
	        var lastCharacter = text[text.length - 1] || '';
	        this.isOnComposition = !Object(shared_["isKorean"])(lastCharacter);
	      }
	    },
	    handleQueryChange: function handleQueryChange(val) {
	      var _this6 = this;
	
	      if (this.previousQuery === val || this.isOnComposition) return;
	      if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
	        this.previousQuery = val;
	        return;
	      }
	      this.previousQuery = val;
	      this.$nextTick(function () {
	        if (_this6.visible) _this6.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      this.hoverIndex = -1;
	      if (this.multiple && this.filterable) {
	        this.$nextTick(function () {
	          var length = _this6.$refs.input.value.length * 15 + 20;
	          _this6.inputLength = _this6.collapseTags ? Math.min(50, length) : length;
	          _this6.managePlaceholder();
	          _this6.resetInputHeight();
	        });
	      }
	      if (this.remote && typeof this.remoteMethod === 'function') {
	        this.hoverIndex = -1;
	        this.remoteMethod(val);
	      } else if (typeof this.filterMethod === 'function') {
	        this.filterMethod(val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      } else {
	        this.filteredOptionsCount = this.optionsCount;
	        this.broadcast('ElOption', 'queryChange', val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    },
	    scrollToOption: function scrollToOption(option) {
	      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
	      if (this.$refs.popper && target) {
	        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
	        scroll_into_view_default()(menu, target);
	      }
	      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
	    },
	    handleMenuEnter: function handleMenuEnter() {
	      var _this7 = this;
	
	      this.$nextTick(function () {
	        return _this7.scrollToOption(_this7.selected);
	      });
	    },
	    emitChange: function emitChange(val) {
	      if (!Object(util_["valueEquals"])(this.value, val)) {
	        this.$emit('change', val);
	      }
	    },
	    getOption: function getOption(value) {
	      var option = void 0;
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
	      var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';
	
	      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
	        var cachedOption = this.cachedOptions[i];
	        var isEqual = isObject ? Object(util_["getValueByPath"])(cachedOption.value, this.valueKey) === Object(util_["getValueByPath"])(value, this.valueKey) : cachedOption.value === value;
	        if (isEqual) {
	          option = cachedOption;
	          break;
	        }
	      }
	      if (option) return option;
	      var label = !isObject && !isNull && !isUndefined ? value : '';
	      var newOption = {
	        value: value,
	        currentLabel: label
	      };
	      if (this.multiple) {
	        newOption.hitState = false;
	      }
	      return newOption;
	    },
	    setSelected: function setSelected() {
	      var _this8 = this;
	
	      if (!this.multiple) {
	        var option = this.getOption(this.value);
	        if (option.created) {
	          this.createdLabel = option.currentLabel;
	          this.createdSelected = true;
	        } else {
	          this.createdSelected = false;
	        }
	        this.selectedLabel = option.currentLabel;
	        this.selected = option;
	        if (this.filterable) this.query = this.selectedLabel;
	        return;
	      }
	      var result = [];
	      if (Array.isArray(this.value)) {
	        this.value.forEach(function (value) {
	          result.push(_this8.getOption(value));
	        });
	      }
	      this.selected = result;
	      this.$nextTick(function () {
	        _this8.resetInputHeight();
	      });
	    },
	    handleFocus: function handleFocus(event) {
	      if (!this.softFocus) {
	        if (this.automaticDropdown || this.filterable) {
	          this.visible = true;
	          if (this.filterable) {
	            this.menuVisibleOnFocus = true;
	          }
	        }
	        this.$emit('focus', event);
	      } else {
	        this.softFocus = false;
	      }
	    },
	    blur: function blur() {
	      this.visible = false;
	      this.$refs.reference.blur();
	    },
	    handleBlur: function handleBlur(event) {
	      var _this9 = this;
	
	      setTimeout(function () {
	        if (_this9.isSilentBlur) {
	          _this9.isSilentBlur = false;
	        } else {
	          _this9.$emit('blur', event);
	        }
	      }, 50);
	      this.softFocus = false;
	    },
	    handleClearClick: function handleClearClick(event) {
	      this.deleteSelected(event);
	    },
	    doDestroy: function doDestroy() {
	      this.$refs.popper && this.$refs.popper.doDestroy();
	    },
	    handleClose: function handleClose() {
	      this.visible = false;
	    },
	    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
	      if (!Array.isArray(this.selected)) return;
	      var option = this.selected[this.selected.length - 1];
	      if (!option) return;
	
	      if (hit === true || hit === false) {
	        option.hitState = hit;
	        return hit;
	      }
	
	      option.hitState = !option.hitState;
	      return option.hitState;
	    },
	    deletePrevTag: function deletePrevTag(e) {
	      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
	        var value = this.value.slice();
	        value.pop();
	        this.$emit('input', value);
	        this.emitChange(value);
	      }
	    },
	    managePlaceholder: function managePlaceholder() {
	      if (this.currentPlaceholder !== '') {
	        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
	      }
	    },
	    resetInputState: function resetInputState(e) {
	      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
	      this.inputLength = this.$refs.input.value.length * 15 + 20;
	      this.resetInputHeight();
	    },
	    resetInputHeight: function resetInputHeight() {
	      var _this10 = this;
	
	      if (this.collapseTags && !this.filterable) return;
	      this.$nextTick(function () {
	        if (!_this10.$refs.reference) return;
	        var inputChildNodes = _this10.$refs.reference.$el.childNodes;
	        var input = [].filter.call(inputChildNodes, function (item) {
	          return item.tagName === 'INPUT';
	        })[0];
	        var tags = _this10.$refs.tags;
	        var sizeInMap = _this10.initialInputHeight || 40;
	        input.style.height = _this10.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
	        if (_this10.visible && _this10.emptyText !== false) {
	          _this10.broadcast('ElSelectDropdown', 'updatePopper');
	        }
	      });
	    },
	    resetHoverIndex: function resetHoverIndex() {
	      var _this11 = this;
	
	      setTimeout(function () {
	        if (!_this11.multiple) {
	          _this11.hoverIndex = _this11.options.indexOf(_this11.selected);
	        } else {
	          if (_this11.selected.length > 0) {
	            _this11.hoverIndex = Math.min.apply(null, _this11.selected.map(function (item) {
	              return _this11.options.indexOf(item);
	            }));
	          } else {
	            _this11.hoverIndex = -1;
	          }
	        }
	      }, 300);
	    },
	    handleOptionSelect: function handleOptionSelect(option, byClick) {
	      var _this12 = this;
	
	      if (this.multiple) {
	        var value = (this.value || []).slice();
	        var optionIndex = this.getValueIndex(value, option.value);
	        if (optionIndex > -1) {
	          value.splice(optionIndex, 1);
	        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
	          value.push(option.value);
	        }
	        this.$emit('input', value);
	        this.emitChange(value);
	        if (option.created) {
	          this.query = '';
	          this.handleQueryChange('');
	          this.inputLength = 20;
	        }
	        if (this.filterable) this.$refs.input.focus();
	      } else {
	        this.$emit('input', option.value);
	        this.emitChange(option.value);
	        this.visible = false;
	      }
	      this.isSilentBlur = byClick;
	      this.setSoftFocus();
	      if (this.visible) return;
	      this.$nextTick(function () {
	        _this12.scrollToOption(option);
	      });
	    },
	    setSoftFocus: function setSoftFocus() {
	      this.softFocus = true;
	      var input = this.$refs.input || this.$refs.reference;
	      if (input) {
	        input.focus();
	      }
	    },
	    getValueIndex: function getValueIndex() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var value = arguments[1];
	
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      if (!isObject) {
	        return arr.indexOf(value);
	      } else {
	        var valueKey = this.valueKey;
	        var index = -1;
	        arr.some(function (item, i) {
	          if (Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(value, valueKey)) {
	            index = i;
	            return true;
	          }
	          return false;
	        });
	        return index;
	      }
	    },
	    toggleMenu: function toggleMenu() {
	      if (!this.selectDisabled) {
	        if (this.menuVisibleOnFocus) {
	          this.menuVisibleOnFocus = false;
	        } else {
	          this.visible = !this.visible;
	        }
	        if (this.visible) {
	          (this.$refs.input || this.$refs.reference).focus();
	        }
	      }
	    },
	    selectOption: function selectOption() {
	      if (!this.visible) {
	        this.toggleMenu();
	      } else {
	        if (this.options[this.hoverIndex]) {
	          this.handleOptionSelect(this.options[this.hoverIndex]);
	        }
	      }
	    },
	    deleteSelected: function deleteSelected(event) {
	      event.stopPropagation();
	      var value = this.multiple ? [] : '';
	      this.$emit('input', value);
	      this.emitChange(value);
	      this.visible = false;
	      this.$emit('clear');
	    },
	    deleteTag: function deleteTag(event, tag) {
	      var index = this.selected.indexOf(tag);
	      if (index > -1 && !this.selectDisabled) {
	        var value = this.value.slice();
	        value.splice(index, 1);
	        this.$emit('input', value);
	        this.emitChange(value);
	        this.$emit('remove-tag', tag.value);
	      }
	      event.stopPropagation();
	    },
	    onInputChange: function onInputChange() {
	      if (this.filterable && this.query !== this.selectedLabel) {
	        this.query = this.selectedLabel;
	        this.handleQueryChange(this.query);
	      }
	    },
	    onOptionDestroy: function onOptionDestroy(index) {
	      if (index > -1) {
	        this.optionsCount--;
	        this.filteredOptionsCount--;
	        this.options.splice(index, 1);
	      }
	    },
	    resetInputWidth: function resetInputWidth() {
	      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
	    },
	    handleResize: function handleResize() {
	      this.resetInputWidth();
	      if (this.multiple) this.resetInputHeight();
	    },
	    checkDefaultFirstOption: function checkDefaultFirstOption() {
	      this.hoverIndex = -1;
	      // highlight the created option
	      var hasCreated = false;
	      for (var i = this.options.length - 1; i >= 0; i--) {
	        if (this.options[i].created) {
	          hasCreated = true;
	          this.hoverIndex = i;
	          break;
	        }
	      }
	      if (hasCreated) return;
	      for (var _i = 0; _i !== this.options.length; ++_i) {
	        var option = this.options[_i];
	        if (this.query) {
	          // highlight first options that passes the filter
	          if (!option.disabled && !option.groupDisabled && option.visible) {
	            this.hoverIndex = _i;
	            break;
	          }
	        } else {
	          // highlight currently selected option
	          if (option.itemSelected) {
	            this.hoverIndex = _i;
	            break;
	          }
	        }
	      }
	    },
	    getValueKey: function getValueKey(item) {
	      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
	        return item.value;
	      } else {
	        return Object(util_["getValueByPath"])(item.value, this.valueKey);
	      }
	    }
	  },
	
	  created: function created() {
	    var _this13 = this;
	
	    this.cachedPlaceHolder = this.currentPlaceholder = this.propPlaceholder;
	    if (this.multiple && !Array.isArray(this.value)) {
	      this.$emit('input', []);
	    }
	    if (!this.multiple && Array.isArray(this.value)) {
	      this.$emit('input', '');
	    }
	
	    this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
	      _this13.onInputChange();
	    });
	
	    this.debouncedQueryChange = debounce_default()(this.debounce, function (e) {
	      _this13.handleQueryChange(e.target.value);
	    });
	
	    this.$on('handleOptionClick', this.handleOptionSelect);
	    this.$on('setSelected', this.setSelected);
	  },
	  mounted: function mounted() {
	    var _this14 = this;
	
	    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
	      this.currentPlaceholder = '';
	    }
	    Object(resize_event_["addResizeListener"])(this.$el, this.handleResize);
	
	    var reference = this.$refs.reference;
	    if (reference && reference.$el) {
	      var sizeMap = {
	        medium: 36,
	        small: 32,
	        mini: 28
	      };
	      var input = reference.$el.querySelector('input');
	      this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.selectSize];
	    }
	    if (this.remote && this.multiple) {
	      this.resetInputHeight();
	    }
	    this.$nextTick(function () {
	      if (reference && reference.$el) {
	        _this14.inputWidth = reference.$el.getBoundingClientRect().width;
	      }
	    });
	    this.setSelected();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el && this.handleResize) Object(resize_event_["removeResizeListener"])(this.$el, this.handleResize);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_selectvue_type_script_lang_js_ = (selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/select.vue
	
	
	
	
	
	/* normalize component */
	
	var select_component = Object(componentNormalizer["a" /* default */])(
	  src_selectvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var select_api; }
	select_component.options.__file = "packages/select/src/select.vue"
	/* harmony default export */ var src_select = (select_component.exports);
	// CONCATENATED MODULE: ./packages/select/index.js
	
	
	/* istanbul ignore next */
	src_select.install = function (Vue) {
	  Vue.component(src_select.name, src_select);
	};
	
	/* harmony default export */ var packages_select = __webpack_exports__["default"] = (src_select);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 131);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 131:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// EXTERNAL MODULE: external "throttle-debounce/debounce"
	var debounce_ = __webpack_require__(17);
	var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(2);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// EXTERNAL MODULE: external "vue"
	var external_vue_ = __webpack_require__(7);
	var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
	
	// CONCATENATED MODULE: ./packages/tooltip/src/main.js
	
	
	
	
	
	
	/* harmony default export */ var main = ({
	  name: 'ElTooltip',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    disabled: Boolean,
	    manual: Boolean,
	    effect: {
	      type: String,
	      default: 'dark'
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    popperClass: String,
	    content: String,
	    visibleArrow: {
	      default: true
	    },
	    transition: {
	      type: String,
	      default: 'el-fade-in-linear'
	    },
	    popperOptions: {
	      default: function _default() {
	        return {
	          boundariesPadding: 10,
	          gpuAcceleration: false
	        };
	      }
	    },
	    enterable: {
	      type: Boolean,
	      default: true
	    },
	    hideAfter: {
	      type: Number,
	      default: 0
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      tooltipId: 'el-tooltip-' + Object(util_["generateId"])(),
	      timeoutPending: null,
	      focusing: false
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    if (this.$isServer) return;
	
	    this.popperVM = new external_vue_default.a({
	      data: { node: '' },
	      render: function render(h) {
	        return this.node;
	      }
	    }).$mount();
	
	    this.debounceClose = debounce_default()(200, function () {
	      return _this.handleClosePopper();
	    });
	  },
	  render: function render(h) {
	    var _this2 = this;
	
	    if (this.popperVM) {
	      this.popperVM.node = h(
	        'transition',
	        {
	          attrs: {
	            name: this.transition
	          },
	          on: {
	            'afterLeave': this.doDestroy
	          }
	        },
	        [h(
	          'div',
	          {
	            on: {
	              'mouseleave': function mouseleave() {
	                _this2.setExpectedState(false);_this2.debounceClose();
	              },
	              'mouseenter': function mouseenter() {
	                _this2.setExpectedState(true);
	              }
	            },
	
	            ref: 'popper',
	            attrs: { role: 'tooltip',
	              id: this.tooltipId,
	              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
	            },
	            directives: [{
	              name: 'show',
	              value: !this.disabled && this.showPopper
	            }],
	
	            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] },
	          [this.$slots.content || this.content]
	        )]
	      );
	    }
	
	    var firstElement = this.getFirstElement();
	    if (!firstElement) return null;
	
	    var data = firstElement.data = firstElement.data || {};
	    data.staticClass = this.addTooltipClass(data.staticClass);
	
	    return firstElement;
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.referenceElm = this.$el;
	    if (this.$el.nodeType === 1) {
	      this.$el.setAttribute('aria-describedby', this.tooltipId);
	      this.$el.setAttribute('tabindex', this.tabindex);
	      Object(dom_["on"])(this.referenceElm, 'mouseenter', this.show);
	      Object(dom_["on"])(this.referenceElm, 'mouseleave', this.hide);
	      Object(dom_["on"])(this.referenceElm, 'focus', function () {
	        if (!_this3.$slots.default || !_this3.$slots.default.length) {
	          _this3.handleFocus();
	          return;
	        }
	        var instance = _this3.$slots.default[0].componentInstance;
	        if (instance && instance.focus) {
	          instance.focus();
	        } else {
	          _this3.handleFocus();
	        }
	      });
	      Object(dom_["on"])(this.referenceElm, 'blur', this.handleBlur);
	      Object(dom_["on"])(this.referenceElm, 'click', this.removeFocusing);
	    }
	    // fix issue https://github.com/ElemeFE/element/issues/14424
	    if (this.value && this.popperVM) {
	      this.popperVM.$nextTick(function () {
	        if (_this3.value) {
	          _this3.updatePopper();
	        }
	      });
	    }
	  },
	
	  watch: {
	    focusing: function focusing(val) {
	      if (val) {
	        Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      } else {
	        Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      }
	    }
	  },
	  methods: {
	    show: function show() {
	      this.setExpectedState(true);
	      this.handleShowPopper();
	    },
	    hide: function hide() {
	      this.setExpectedState(false);
	      this.debounceClose();
	    },
	    handleFocus: function handleFocus() {
	      this.focusing = true;
	      this.show();
	    },
	    handleBlur: function handleBlur() {
	      this.focusing = false;
	      this.hide();
	    },
	    removeFocusing: function removeFocusing() {
	      this.focusing = false;
	    },
	    addTooltipClass: function addTooltipClass(prev) {
	      if (!prev) {
	        return 'el-tooltip';
	      } else {
	        return 'el-tooltip ' + prev.replace('el-tooltip', '');
	      }
	    },
	    handleShowPopper: function handleShowPopper() {
	      var _this4 = this;
	
	      if (!this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this4.showPopper = true;
	      }, this.openDelay);
	
	      if (this.hideAfter > 0) {
	        this.timeoutPending = setTimeout(function () {
	          _this4.showPopper = false;
	        }, this.hideAfter);
	      }
	    },
	    handleClosePopper: function handleClosePopper() {
	      if (this.enterable && this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	
	      if (this.timeoutPending) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.showPopper = false;
	
	      if (this.disabled) {
	        this.doDestroy();
	      }
	    },
	    setExpectedState: function setExpectedState(expectedState) {
	      if (expectedState === false) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.expectedState = expectedState;
	    },
	    getFirstElement: function getFirstElement() {
	      var slots = this.$slots.default;
	      if (!Array.isArray(slots)) return null;
	      var element = null;
	      for (var index = 0; index < slots.length; index++) {
	        if (slots[index] && slots[index].tag) {
	          element = slots[index];
	        };
	      }
	      return element;
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.popperVM && this.popperVM.$destroy();
	  },
	  destroyed: function destroyed() {
	    var reference = this.referenceElm;
	    if (reference.nodeType === 1) {
	      Object(dom_["off"])(reference, 'mouseenter', this.show);
	      Object(dom_["off"])(reference, 'mouseleave', this.hide);
	      Object(dom_["off"])(reference, 'focus', this.handleFocus);
	      Object(dom_["off"])(reference, 'blur', this.handleBlur);
	      Object(dom_["off"])(reference, 'click', this.removeFocusing);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tooltip/index.js
	
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.component(main.name, main);
	};
	
	/* harmony default export */ var tooltip = __webpack_exports__["default"] = (main);
	
	/***/ }),
	
	/***/ 17:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(59);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(23);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(21);
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(58);
	
	/***/ }),
	
	/***/ 7:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(6);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dom = __webpack_require__(23);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Transition = function () {
	  function Transition() {
	    _classCallCheck(this, Transition);
	  }
	
	  Transition.prototype.beforeEnter = function beforeEnter(el) {
	    (0, _dom.addClass)(el, 'collapse-transition');
	    if (!el.dataset) el.dataset = {};
	
	    el.dataset.oldPaddingTop = el.style.paddingTop;
	    el.dataset.oldPaddingBottom = el.style.paddingBottom;
	
	    el.style.height = '0';
	    el.style.paddingTop = 0;
	    el.style.paddingBottom = 0;
	  };
	
	  Transition.prototype.enter = function enter(el) {
	    el.dataset.oldOverflow = el.style.overflow;
	    if (el.scrollHeight !== 0) {
	      el.style.height = el.scrollHeight + 'px';
	      el.style.paddingTop = el.dataset.oldPaddingTop;
	      el.style.paddingBottom = el.dataset.oldPaddingBottom;
	    } else {
	      el.style.height = '';
	      el.style.paddingTop = el.dataset.oldPaddingTop;
	      el.style.paddingBottom = el.dataset.oldPaddingBottom;
	    }
	
	    el.style.overflow = 'hidden';
	  };
	
	  Transition.prototype.afterEnter = function afterEnter(el) {
	    // for safari: remove class then reset height is necessary
	    (0, _dom.removeClass)(el, 'collapse-transition');
	    el.style.height = '';
	    el.style.overflow = el.dataset.oldOverflow;
	  };
	
	  Transition.prototype.beforeLeave = function beforeLeave(el) {
	    if (!el.dataset) el.dataset = {};
	    el.dataset.oldPaddingTop = el.style.paddingTop;
	    el.dataset.oldPaddingBottom = el.style.paddingBottom;
	    el.dataset.oldOverflow = el.style.overflow;
	
	    el.style.height = el.scrollHeight + 'px';
	    el.style.overflow = 'hidden';
	  };
	
	  Transition.prototype.leave = function leave(el) {
	    if (el.scrollHeight !== 0) {
	      // for safari: add class after set height, or it will jump to zero height suddenly, weired
	      (0, _dom.addClass)(el, 'collapse-transition');
	      el.style.height = 0;
	      el.style.paddingTop = 0;
	      el.style.paddingBottom = 0;
	    }
	  };
	
	  Transition.prototype.afterLeave = function afterLeave(el) {
	    (0, _dom.removeClass)(el, 'collapse-transition');
	    el.style.height = '';
	    el.style.overflow = el.dataset.oldOverflow;
	    el.style.paddingTop = el.dataset.oldPaddingTop;
	    el.style.paddingBottom = el.dataset.oldPaddingBottom;
	  };
	
	  return Transition;
	}();
	
	exports.default = {
	  name: 'ElCollapseTransition',
	  functional: true,
	  render: function render(h, _ref) {
	    var children = _ref.children;
	
	    var data = {
	      on: new Transition()
	    };
	
	    return h('transition', data, children);
	  }
	};

/***/ }),
/* 284 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (instance, callback) {
	  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	  var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!instance || !callback) throw new Error('instance & callback is required');
	  var called = false;
	  var afterLeaveCallback = function afterLeaveCallback() {
	    if (called) return;
	    called = true;
	    if (callback) {
	      callback.apply(null, arguments);
	    }
	  };
	  if (once) {
	    instance.$once('after-leave', afterLeaveCallback);
	  } else {
	    instance.$on('after-leave', afterLeaveCallback);
	  }
	  setTimeout(function () {
	    afterLeaveCallback();
	  }, speed + 100);
	};
	
	; /**
	   * Bind after-leave event for vue instance. Make sure after-leave is called in any browsers.
	   *
	   * @param {Vue} instance Vue instance.
	   * @param {Function} callback callback of after-leave event
	   * @param {Number} speed the speed of transition, default value is 300ms
	   * @param {Boolean} once weather bind after-leave once. default value is false.
	   */

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ariaUtils = __webpack_require__(84);
	
	var _ariaUtils2 = _interopRequireDefault(_ariaUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @constructor
	 * @desc Dialog object providing modal focus management.
	 *
	 * Assumptions: The element serving as the dialog container is present in the
	 * DOM and hidden. The dialog container has role='dialog'.
	 *
	 * @param dialogId
	 *          The ID of the element serving as the dialog container.
	 * @param focusAfterClosed
	 *          Either the DOM node or the ID of the DOM node to focus when the
	 *          dialog closes.
	 * @param focusFirst
	 *          Optional parameter containing either the DOM node or the ID of the
	 *          DOM node to focus when the dialog opens. If not specified, the
	 *          first focusable element in the dialog will receive focus.
	 */
	var aria = aria || {};
	var tabEvent;
	
	aria.Dialog = function (dialog, focusAfterClosed, focusFirst) {
	  var _this = this;
	
	  this.dialogNode = dialog;
	  if (this.dialogNode === null || this.dialogNode.getAttribute('role') !== 'dialog') {
	    throw new Error('Dialog() requires a DOM element with ARIA role of dialog.');
	  }
	
	  if (typeof focusAfterClosed === 'string') {
	    this.focusAfterClosed = document.getElementById(focusAfterClosed);
	  } else if ((typeof focusAfterClosed === 'undefined' ? 'undefined' : _typeof(focusAfterClosed)) === 'object') {
	    this.focusAfterClosed = focusAfterClosed;
	  } else {
	    this.focusAfterClosed = null;
	  }
	
	  if (typeof focusFirst === 'string') {
	    this.focusFirst = document.getElementById(focusFirst);
	  } else if ((typeof focusFirst === 'undefined' ? 'undefined' : _typeof(focusFirst)) === 'object') {
	    this.focusFirst = focusFirst;
	  } else {
	    this.focusFirst = null;
	  }
	
	  if (this.focusFirst) {
	    this.focusFirst.focus();
	  } else {
	    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
	  }
	
	  this.lastFocus = document.activeElement;
	  tabEvent = function tabEvent(e) {
	    _this.trapFocus(e);
	  };
	  this.addListeners();
	};
	
	aria.Dialog.prototype.addListeners = function () {
	  document.addEventListener('focus', tabEvent, true);
	};
	
	aria.Dialog.prototype.removeListeners = function () {
	  document.removeEventListener('focus', tabEvent, true);
	};
	
	aria.Dialog.prototype.closeDialog = function () {
	  var _this2 = this;
	
	  this.removeListeners();
	  if (this.focusAfterClosed) {
	    setTimeout(function () {
	      _this2.focusAfterClosed.focus();
	    });
	  }
	};
	
	aria.Dialog.prototype.trapFocus = function (event) {
	  if (_ariaUtils2.default.IgnoreUtilFocusChanges) {
	    return;
	  }
	  if (this.dialogNode.contains(event.target)) {
	    this.lastFocus = event.target;
	  } else {
	    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
	    if (this.lastFocus === document.activeElement) {
	      _ariaUtils2.default.focusLastDescendant(this.dialogNode);
	    }
	    this.lastFocus = document.activeElement;
	  }
	};
	
	exports.default = aria.Dialog;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.validateRangeInOneMonth = exports.extractTimeFormat = exports.extractDateFormat = exports.nextYear = exports.prevYear = exports.nextMonth = exports.prevMonth = exports.changeYearMonthAndClampDate = exports.timeWithinRange = exports.limitTimeRange = exports.clearMilliseconds = exports.clearTime = exports.modifyWithTimeString = exports.modifyTime = exports.modifyDate = exports.range = exports.getRangeMinutes = exports.getMonthDays = exports.getPrevMonthLastDays = exports.getRangeHours = exports.getWeekNumber = exports.getStartDateOfMonth = exports.nextDate = exports.prevDate = exports.getFirstDayOfMonth = exports.getDayCountOfYear = exports.getDayCountOfMonth = exports.parseDate = exports.formatDate = exports.isDateObject = exports.isDate = exports.toDate = exports.getI18nSettings = undefined;
	
	var _date = __webpack_require__(135);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _locale = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weeks = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
	var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
	
	var newArray = function newArray(start, end) {
	  var result = [];
	  for (var i = start; i <= end; i++) {
	    result.push(i);
	  }
	  return result;
	};
	
	var getI18nSettings = exports.getI18nSettings = function getI18nSettings() {
	  return {
	    dayNamesShort: weeks.map(function (week) {
	      return (0, _locale.t)('el.datepicker.weeks.' + week);
	    }),
	    dayNames: weeks.map(function (week) {
	      return (0, _locale.t)('el.datepicker.weeks.' + week);
	    }),
	    monthNamesShort: months.map(function (month) {
	      return (0, _locale.t)('el.datepicker.months.' + month);
	    }),
	    monthNames: months.map(function (month, index) {
	      return (0, _locale.t)('el.datepicker.month' + (index + 1));
	    }),
	    amPm: ['am', 'pm']
	  };
	};
	
	var toDate = exports.toDate = function toDate(date) {
	  return isDate(date) ? new Date(date) : null;
	};
	
	var isDate = exports.isDate = function isDate(date) {
	  if (date === null || date === undefined) return false;
	  if (isNaN(new Date(date).getTime())) return false;
	  if (Array.isArray(date)) return false; // deal with `new Date([ new Date() ]) -> new Date()`
	  return true;
	};
	
	var isDateObject = exports.isDateObject = function isDateObject(val) {
	  return val instanceof Date;
	};
	
	var formatDate = exports.formatDate = function formatDate(date, format) {
	  date = toDate(date);
	  if (!date) return '';
	  return _date2.default.format(date, format || 'yyyy-MM-dd', getI18nSettings());
	};
	
	var parseDate = exports.parseDate = function parseDate(string, format) {
	  return _date2.default.parse(string, format || 'yyyy-MM-dd', getI18nSettings());
	};
	
	var getDayCountOfMonth = exports.getDayCountOfMonth = function getDayCountOfMonth(year, month) {
	  if (month === 3 || month === 5 || month === 8 || month === 10) {
	    return 30;
	  }
	
	  if (month === 1) {
	    if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
	      return 29;
	    } else {
	      return 28;
	    }
	  }
	
	  return 31;
	};
	
	var getDayCountOfYear = exports.getDayCountOfYear = function getDayCountOfYear(year) {
	  var isLeapYear = year % 400 === 0 || year % 100 !== 0 && year % 4 === 0;
	  return isLeapYear ? 366 : 365;
	};
	
	var getFirstDayOfMonth = exports.getFirstDayOfMonth = function getFirstDayOfMonth(date) {
	  var temp = new Date(date.getTime());
	  temp.setDate(1);
	  return temp.getDay();
	};
	
	// see: https://stackoverflow.com/questions/3674539/incrementing-a-date-in-javascript
	// {prev, next} Date should work for Daylight Saving Time
	// Adding 24 * 60 * 60 * 1000 does not work in the above scenario
	var prevDate = exports.prevDate = function prevDate(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount);
	};
	
	var nextDate = exports.nextDate = function nextDate(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
	};
	
	var getStartDateOfMonth = exports.getStartDateOfMonth = function getStartDateOfMonth(year, month) {
	  var result = new Date(year, month, 1);
	  var day = result.getDay();
	
	  if (day === 0) {
	    return prevDate(result, 7);
	  } else {
	    return prevDate(result, day);
	  }
	};
	
	var getWeekNumber = exports.getWeekNumber = function getWeekNumber(src) {
	  if (!isDate(src)) return null;
	  var date = new Date(src.getTime());
	  date.setHours(0, 0, 0, 0);
	  // Thursday in current week decides the year.
	  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
	  // January 4 is always in week 1.
	  var week1 = new Date(date.getFullYear(), 0, 4);
	  // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
	  // Rounding should be fine for Daylight Saving Time. Its shift should never be more than 12 hours.
	  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
	};
	
	var getRangeHours = exports.getRangeHours = function getRangeHours(ranges) {
	  var hours = [];
	  var disabledHours = [];
	
	  (ranges || []).forEach(function (range) {
	    var value = range.map(function (date) {
	      return date.getHours();
	    });
	
	    disabledHours = disabledHours.concat(newArray(value[0], value[1]));
	  });
	
	  if (disabledHours.length) {
	    for (var i = 0; i < 24; i++) {
	      hours[i] = disabledHours.indexOf(i) === -1;
	    }
	  } else {
	    for (var _i = 0; _i < 24; _i++) {
	      hours[_i] = false;
	    }
	  }
	
	  return hours;
	};
	
	var getPrevMonthLastDays = exports.getPrevMonthLastDays = function getPrevMonthLastDays(date, amount) {
	  if (amount <= 0) return [];
	  var temp = new Date(date.getTime());
	  temp.setDate(0);
	  var lastDay = temp.getDate();
	  return range(amount).map(function (_, index) {
	    return lastDay - (amount - index - 1);
	  });
	};
	
	var getMonthDays = exports.getMonthDays = function getMonthDays(date) {
	  var temp = new Date(date.getFullYear(), date.getMonth() + 1, 0);
	  var days = temp.getDate();
	  return range(days).map(function (_, index) {
	    return index + 1;
	  });
	};
	
	function setRangeData(arr, start, end, value) {
	  for (var i = start; i < end; i++) {
	    arr[i] = value;
	  }
	}
	
	var getRangeMinutes = exports.getRangeMinutes = function getRangeMinutes(ranges, hour) {
	  var minutes = new Array(60);
	
	  if (ranges.length > 0) {
	    ranges.forEach(function (range) {
	      var start = range[0];
	      var end = range[1];
	      var startHour = start.getHours();
	      var startMinute = start.getMinutes();
	      var endHour = end.getHours();
	      var endMinute = end.getMinutes();
	      if (startHour === hour && endHour !== hour) {
	        setRangeData(minutes, startMinute, 60, true);
	      } else if (startHour === hour && endHour === hour) {
	        setRangeData(minutes, startMinute, endMinute + 1, true);
	      } else if (startHour !== hour && endHour === hour) {
	        setRangeData(minutes, 0, endMinute + 1, true);
	      } else if (startHour < hour && endHour > hour) {
	        setRangeData(minutes, 0, 60, true);
	      }
	    });
	  } else {
	    setRangeData(minutes, 0, 60, true);
	  }
	  return minutes;
	};
	
	var range = exports.range = function range(n) {
	  // see https://stackoverflow.com/questions/3746725/create-a-javascript-array-containing-1-n
	  return Array.apply(null, { length: n }).map(function (_, n) {
	    return n;
	  });
	};
	
	var modifyDate = exports.modifyDate = function modifyDate(date, y, m, d) {
	  return new Date(y, m, d, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
	};
	
	var modifyTime = exports.modifyTime = function modifyTime(date, h, m, s) {
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), h, m, s, date.getMilliseconds());
	};
	
	var modifyWithTimeString = exports.modifyWithTimeString = function modifyWithTimeString(date, time) {
	  if (date == null || !time) {
	    return date;
	  }
	  time = parseDate(time, 'HH:mm:ss');
	  return modifyTime(date, time.getHours(), time.getMinutes(), time.getSeconds());
	};
	
	var clearTime = exports.clearTime = function clearTime(date) {
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	var clearMilliseconds = exports.clearMilliseconds = function clearMilliseconds(date) {
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), 0);
	};
	
	var limitTimeRange = exports.limitTimeRange = function limitTimeRange(date, ranges) {
	  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'HH:mm:ss';
	
	  // TODO: refactory a more elegant solution
	  if (ranges.length === 0) return date;
	  var normalizeDate = function normalizeDate(date) {
	    return _date2.default.parse(_date2.default.format(date, format), format);
	  };
	  var ndate = normalizeDate(date);
	  var nranges = ranges.map(function (range) {
	    return range.map(normalizeDate);
	  });
	  if (nranges.some(function (nrange) {
	    return ndate >= nrange[0] && ndate <= nrange[1];
	  })) return date;
	
	  var minDate = nranges[0][0];
	  var maxDate = nranges[0][0];
	
	  nranges.forEach(function (nrange) {
	    minDate = new Date(Math.min(nrange[0], minDate));
	    maxDate = new Date(Math.max(nrange[1], minDate));
	  });
	
	  var ret = ndate < minDate ? minDate : maxDate;
	  // preserve Year/Month/Date
	  return modifyDate(ret, date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	var timeWithinRange = exports.timeWithinRange = function timeWithinRange(date, selectableRange, format) {
	  var limitedDate = limitTimeRange(date, selectableRange, format);
	  return limitedDate.getTime() === date.getTime();
	};
	
	var changeYearMonthAndClampDate = exports.changeYearMonthAndClampDate = function changeYearMonthAndClampDate(date, year, month) {
	  // clamp date to the number of days in `year`, `month`
	  // eg: (2010-1-31, 2010, 2) => 2010-2-28
	  var monthDate = Math.min(date.getDate(), getDayCountOfMonth(year, month));
	  return modifyDate(date, year, month, monthDate);
	};
	
	var prevMonth = exports.prevMonth = function prevMonth(date) {
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return month === 0 ? changeYearMonthAndClampDate(date, year - 1, 11) : changeYearMonthAndClampDate(date, year, month - 1);
	};
	
	var nextMonth = exports.nextMonth = function nextMonth(date) {
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return month === 11 ? changeYearMonthAndClampDate(date, year + 1, 0) : changeYearMonthAndClampDate(date, year, month + 1);
	};
	
	var prevYear = exports.prevYear = function prevYear(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return changeYearMonthAndClampDate(date, year - amount, month);
	};
	
	var nextYear = exports.nextYear = function nextYear(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return changeYearMonthAndClampDate(date, year + amount, month);
	};
	
	var extractDateFormat = exports.extractDateFormat = function extractDateFormat(format) {
	  return format.replace(/\W?m{1,2}|\W?ZZ/g, '').replace(/\W?h{1,2}|\W?s{1,3}|\W?a/gi, '').trim();
	};
	
	var extractTimeFormat = exports.extractTimeFormat = function extractTimeFormat(format) {
	  return format.replace(/\W?D{1,2}|\W?Do|\W?d{1,4}|\W?M{1,4}|\W?y{2,4}/g, '').trim();
	};
	
	var validateRangeInOneMonth = exports.validateRangeInOneMonth = function validateRangeInOneMonth(start, end) {
	  return start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
	};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version {{version}}
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	
	//
	// Cross module loader
	// Supported: Node, AMD, Browser globals
	//
	;(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.Popper = factory();
	    }
	})(undefined, function () {
	
	    'use strict';
	
	    var root = window;
	
	    // default options
	    var DEFAULTS = {
	        // placement of the popper
	        placement: 'bottom',
	
	        gpuAcceleration: true,
	
	        // shift popper from its origin by the given amount of pixels (can be negative)
	        offset: 0,
	
	        // the element which will act as boundary of the popper
	        boundariesElement: 'viewport',
	
	        // amount of pixel used to define a minimum distance between the boundaries and the popper
	        boundariesPadding: 5,
	
	        // popper will try to prevent overflow following this order,
	        // by default, then, it could overflow on the left and on top of the boundariesElement
	        preventOverflowOrder: ['left', 'right', 'top', 'bottom'],
	
	        // the behavior used by flip to change the placement of the popper
	        flipBehavior: 'flip',
	
	        arrowElement: '[x-arrow]',
	
	        arrowOffset: 0,
	
	        // list of functions used to modify the offsets before they are applied to the popper
	        modifiers: ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle'],
	
	        modifiersIgnored: [],
	
	        forceAbsolute: false
	    };
	
	    /**
	     * Create a new Popper.js instance
	     * @constructor Popper
	     * @param {HTMLElement} reference - The reference element used to position the popper
	     * @param {HTMLElement|Object} popper
	     *      The HTML element used as popper, or a configuration used to generate the popper.
	     * @param {String} [popper.tagName='div'] The tag name of the generated popper.
	     * @param {Array} [popper.classNames=['popper']] Array of classes to apply to the generated popper.
	     * @param {Array} [popper.attributes] Array of attributes to apply, specify `attr:value` to assign a value to it.
	     * @param {HTMLElement|String} [popper.parent=window.document.body] The parent element, given as HTMLElement or as query string.
	     * @param {String} [popper.content=''] The content of the popper, it can be text, html, or node; if it is not text, set `contentType` to `html` or `node`.
	     * @param {String} [popper.contentType='text'] If `html`, the `content` will be parsed as HTML. If `node`, it will be appended as-is.
	     * @param {String} [popper.arrowTagName='div'] Same as `popper.tagName` but for the arrow element.
	     * @param {Array} [popper.arrowClassNames='popper__arrow'] Same as `popper.classNames` but for the arrow element.
	     * @param {String} [popper.arrowAttributes=['x-arrow']] Same as `popper.attributes` but for the arrow element.
	     * @param {Object} options
	     * @param {String} [options.placement=bottom]
	     *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -right),
	     *      left(-start, -end)`
	     *
	     * @param {HTMLElement|String} [options.arrowElement='[x-arrow]']
	     *      The DOM Node used as arrow for the popper, or a CSS selector used to get the DOM node. It must be child of
	     *      its parent Popper. Popper.js will apply to the given element the style required to align the arrow with its
	     *      reference element.
	     *      By default, it will look for a child node of the popper with the `x-arrow` attribute.
	     *
	     * @param {Boolean} [options.gpuAcceleration=true]
	     *      When this property is set to true, the popper position will be applied using CSS3 translate3d, allowing the
	     *      browser to use the GPU to accelerate the rendering.
	     *      If set to false, the popper will be placed using `top` and `left` properties, not using the GPU.
	     *
	     * @param {Number} [options.offset=0]
	     *      Amount of pixels the popper will be shifted (can be negative).
	     *
	     * @param {String|Element} [options.boundariesElement='viewport']
	     *      The element which will define the boundaries of the popper position, the popper will never be placed outside
	     *      of the defined boundaries (except if `keepTogether` is enabled)
	     *
	     * @param {Number} [options.boundariesPadding=5]
	     *      Additional padding for the boundaries
	     *
	     * @param {Array} [options.preventOverflowOrder=['left', 'right', 'top', 'bottom']]
	     *      Order used when Popper.js tries to avoid overflows from the boundaries, they will be checked in order,
	     *      this means that the last ones will never overflow
	     *
	     * @param {String|Array} [options.flipBehavior='flip']
	     *      The behavior used by the `flip` modifier to change the placement of the popper when the latter is trying to
	     *      overlap its reference element. Defining `flip` as value, the placement will be flipped on
	     *      its axis (`right - left`, `top - bottom`).
	     *      You can even pass an array of placements (eg: `['right', 'left', 'top']` ) to manually specify
	     *      how alter the placement when a flip is needed. (eg. in the above example, it would first flip from right to left,
	     *      then, if even in its new placement, the popper is overlapping its reference element, it will be moved to top)
	     *
	     * @param {Array} [options.modifiers=[ 'shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle']]
	     *      List of functions used to modify the data before they are applied to the popper, add your custom functions
	     *      to this array to edit the offsets and placement.
	     *      The function should reflect the @params and @returns of preventOverflow
	     *
	     * @param {Array} [options.modifiersIgnored=[]]
	     *      Put here any built-in modifier name you want to exclude from the modifiers list
	     *      The function should reflect the @params and @returns of preventOverflow
	     *
	     * @param {Boolean} [options.removeOnDestroy=false]
	     *      Set to true if you want to automatically remove the popper when you call the `destroy` method.
	     */
	    function Popper(reference, popper, options) {
	        this._reference = reference.jquery ? reference[0] : reference;
	        this.state = {};
	
	        // if the popper variable is a configuration object, parse it to generate an HTMLElement
	        // generate a default popper if is not defined
	        var isNotDefined = typeof popper === 'undefined' || popper === null;
	        var isConfig = popper && Object.prototype.toString.call(popper) === '[object Object]';
	        if (isNotDefined || isConfig) {
	            this._popper = this.parse(isConfig ? popper : {});
	        }
	        // otherwise, use the given HTMLElement as popper
	        else {
	                this._popper = popper.jquery ? popper[0] : popper;
	            }
	
	        // with {} we create a new object with the options inside it
	        this._options = Object.assign({}, DEFAULTS, options);
	
	        // refactoring modifiers' list
	        this._options.modifiers = this._options.modifiers.map(function (modifier) {
	            // remove ignored modifiers
	            if (this._options.modifiersIgnored.indexOf(modifier) !== -1) return;
	
	            // set the x-placement attribute before everything else because it could be used to add margins to the popper
	            // margins needs to be calculated to get the correct popper offsets
	            if (modifier === 'applyStyle') {
	                this._popper.setAttribute('x-placement', this._options.placement);
	            }
	
	            // return predefined modifier identified by string or keep the custom one
	            return this.modifiers[modifier] || modifier;
	        }.bind(this));
	
	        // make sure to apply the popper position before any computation
	        this.state.position = this._getPosition(this._popper, this._reference);
	        setStyle(this._popper, { position: this.state.position, top: 0 });
	
	        // fire the first update to position the popper in the right place
	        this.update();
	
	        // setup event listeners, they will take care of update the position in specific situations
	        this._setupEventListeners();
	        return this;
	    }
	
	    //
	    // Methods
	    //
	    /**
	     * Destroy the popper
	     * @method
	     * @memberof Popper
	     */
	    Popper.prototype.destroy = function () {
	        this._popper.removeAttribute('x-placement');
	        this._popper.style.left = '';
	        this._popper.style.position = '';
	        this._popper.style.top = '';
	        this._popper.style[getSupportedPropertyName('transform')] = '';
	        this._removeEventListeners();
	
	        // remove the popper if user explicity asked for the deletion on destroy
	        if (this._options.removeOnDestroy) {
	            this._popper.remove();
	        }
	        return this;
	    };
	
	    /**
	     * Updates the position of the popper, computing the new offsets and applying the new style
	     * @method
	     * @memberof Popper
	     */
	    Popper.prototype.update = function () {
	        var data = { instance: this, styles: {} };
	
	        // store placement inside the data object, modifiers will be able to edit `placement` if needed
	        // and refer to _originalPlacement to know the original value
	        data.placement = this._options.placement;
	        data._originalPlacement = this._options.placement;
	
	        // compute the popper and reference offsets and put them inside data.offsets
	        data.offsets = this._getOffsets(this._popper, this._reference, data.placement);
	
	        // get boundaries
	        data.boundaries = this._getBoundaries(data, this._options.boundariesPadding, this._options.boundariesElement);
	
	        data = this.runModifiers(data, this._options.modifiers);
	
	        if (typeof this.state.updateCallback === 'function') {
	            this.state.updateCallback(data);
	        }
	    };
	
	    /**
	     * If a function is passed, it will be executed after the initialization of popper with as first argument the Popper instance.
	     * @method
	     * @memberof Popper
	     * @param {Function} callback
	     */
	    Popper.prototype.onCreate = function (callback) {
	        // the createCallbacks return as first argument the popper instance
	        callback(this);
	        return this;
	    };
	
	    /**
	     * If a function is passed, it will be executed after each update of popper with as first argument the set of coordinates and informations
	     * used to style popper and its arrow.
	     * NOTE: it doesn't get fired on the first call of the `Popper.update()` method inside the `Popper` constructor!
	     * @method
	     * @memberof Popper
	     * @param {Function} callback
	     */
	    Popper.prototype.onUpdate = function (callback) {
	        this.state.updateCallback = callback;
	        return this;
	    };
	
	    /**
	     * Helper used to generate poppers from a configuration file
	     * @method
	     * @memberof Popper
	     * @param config {Object} configuration
	     * @returns {HTMLElement} popper
	     */
	    Popper.prototype.parse = function (config) {
	        var defaultConfig = {
	            tagName: 'div',
	            classNames: ['popper'],
	            attributes: [],
	            parent: root.document.body,
	            content: '',
	            contentType: 'text',
	            arrowTagName: 'div',
	            arrowClassNames: ['popper__arrow'],
	            arrowAttributes: ['x-arrow']
	        };
	        config = Object.assign({}, defaultConfig, config);
	
	        var d = root.document;
	
	        var popper = d.createElement(config.tagName);
	        addClassNames(popper, config.classNames);
	        addAttributes(popper, config.attributes);
	        if (config.contentType === 'node') {
	            popper.appendChild(config.content.jquery ? config.content[0] : config.content);
	        } else if (config.contentType === 'html') {
	            popper.innerHTML = config.content;
	        } else {
	            popper.textContent = config.content;
	        }
	
	        if (config.arrowTagName) {
	            var arrow = d.createElement(config.arrowTagName);
	            addClassNames(arrow, config.arrowClassNames);
	            addAttributes(arrow, config.arrowAttributes);
	            popper.appendChild(arrow);
	        }
	
	        var parent = config.parent.jquery ? config.parent[0] : config.parent;
	
	        // if the given parent is a string, use it to match an element
	        // if more than one element is matched, the first one will be used as parent
	        // if no elements are matched, the script will throw an error
	        if (typeof parent === 'string') {
	            parent = d.querySelectorAll(config.parent);
	            if (parent.length > 1) {
	                console.warn('WARNING: the given `parent` query(' + config.parent + ') matched more than one element, the first one will be used');
	            }
	            if (parent.length === 0) {
	                throw 'ERROR: the given `parent` doesn\'t exists!';
	            }
	            parent = parent[0];
	        }
	        // if the given parent is a DOM nodes list or an array of nodes with more than one element,
	        // the first one will be used as parent
	        if (parent.length > 1 && parent instanceof Element === false) {
	            console.warn('WARNING: you have passed as parent a list of elements, the first one will be used');
	            parent = parent[0];
	        }
	
	        // append the generated popper to its parent
	        parent.appendChild(popper);
	
	        return popper;
	
	        /**
	         * Adds class names to the given element
	         * @function
	         * @ignore
	         * @param {HTMLElement} target
	         * @param {Array} classes
	         */
	        function addClassNames(element, classNames) {
	            classNames.forEach(function (className) {
	                element.classList.add(className);
	            });
	        }
	
	        /**
	         * Adds attributes to the given element
	         * @function
	         * @ignore
	         * @param {HTMLElement} target
	         * @param {Array} attributes
	         * @example
	         * addAttributes(element, [ 'data-info:foobar' ]);
	         */
	        function addAttributes(element, attributes) {
	            attributes.forEach(function (attribute) {
	                element.setAttribute(attribute.split(':')[0], attribute.split(':')[1] || '');
	            });
	        }
	    };
	
	    /**
	     * Helper used to get the position which will be applied to the popper
	     * @method
	     * @memberof Popper
	     * @param config {HTMLElement} popper element
	     * @param reference {HTMLElement} reference element
	     * @returns {String} position
	     */
	    Popper.prototype._getPosition = function (popper, reference) {
	        var container = getOffsetParent(reference);
	
	        if (this._options.forceAbsolute) {
	            return 'absolute';
	        }
	
	        // Decide if the popper will be fixed
	        // If the reference element is inside a fixed context, the popper will be fixed as well to allow them to scroll together
	        var isParentFixed = isFixed(reference, container);
	        return isParentFixed ? 'fixed' : 'absolute';
	    };
	
	    /**
	     * Get offsets to the popper
	     * @method
	     * @memberof Popper
	     * @access private
	     * @param {Element} popper - the popper element
	     * @param {Element} reference - the reference element (the popper will be relative to this)
	     * @returns {Object} An object containing the offsets which will be applied to the popper
	     */
	    Popper.prototype._getOffsets = function (popper, reference, placement) {
	        placement = placement.split('-')[0];
	        var popperOffsets = {};
	
	        popperOffsets.position = this.state.position;
	        var isParentFixed = popperOffsets.position === 'fixed';
	
	        //
	        // Get reference element position
	        //
	        var referenceOffsets = getOffsetRectRelativeToCustomParent(reference, getOffsetParent(popper), isParentFixed);
	
	        //
	        // Get popper sizes
	        //
	        var popperRect = getOuterSizes(popper);
	
	        //
	        // Compute offsets of popper
	        //
	
	        // depending by the popper placement we have to compute its offsets slightly differently
	        if (['right', 'left'].indexOf(placement) !== -1) {
	            popperOffsets.top = referenceOffsets.top + referenceOffsets.height / 2 - popperRect.height / 2;
	            if (placement === 'left') {
	                popperOffsets.left = referenceOffsets.left - popperRect.width;
	            } else {
	                popperOffsets.left = referenceOffsets.right;
	            }
	        } else {
	            popperOffsets.left = referenceOffsets.left + referenceOffsets.width / 2 - popperRect.width / 2;
	            if (placement === 'top') {
	                popperOffsets.top = referenceOffsets.top - popperRect.height;
	            } else {
	                popperOffsets.top = referenceOffsets.bottom;
	            }
	        }
	
	        // Add width and height to our offsets object
	        popperOffsets.width = popperRect.width;
	        popperOffsets.height = popperRect.height;
	
	        return {
	            popper: popperOffsets,
	            reference: referenceOffsets
	        };
	    };
	
	    /**
	     * Setup needed event listeners used to update the popper position
	     * @method
	     * @memberof Popper
	     * @access private
	     */
	    Popper.prototype._setupEventListeners = function () {
	        // NOTE: 1 DOM access here
	        this.state.updateBound = this.update.bind(this);
	        root.addEventListener('resize', this.state.updateBound);
	        // if the boundariesElement is window we don't need to listen for the scroll event
	        if (this._options.boundariesElement !== 'window') {
	            var target = getScrollParent(this._reference);
	            // here it could be both `body` or `documentElement` thanks to Firefox, we then check both
	            if (target === root.document.body || target === root.document.documentElement) {
	                target = root;
	            }
	            target.addEventListener('scroll', this.state.updateBound);
	            this.state.scrollTarget = target;
	        }
	    };
	
	    /**
	     * Remove event listeners used to update the popper position
	     * @method
	     * @memberof Popper
	     * @access private
	     */
	    Popper.prototype._removeEventListeners = function () {
	        // NOTE: 1 DOM access here
	        root.removeEventListener('resize', this.state.updateBound);
	        if (this._options.boundariesElement !== 'window' && this.state.scrollTarget) {
	            this.state.scrollTarget.removeEventListener('scroll', this.state.updateBound);
	            this.state.scrollTarget = null;
	        }
	        this.state.updateBound = null;
	    };
	
	    /**
	     * Computed the boundaries limits and return them
	     * @method
	     * @memberof Popper
	     * @access private
	     * @param {Object} data - Object containing the property "offsets" generated by `_getOffsets`
	     * @param {Number} padding - Boundaries padding
	     * @param {Element} boundariesElement - Element used to define the boundaries
	     * @returns {Object} Coordinates of the boundaries
	     */
	    Popper.prototype._getBoundaries = function (data, padding, boundariesElement) {
	        // NOTE: 1 DOM access here
	        var boundaries = {};
	        var width, height;
	        if (boundariesElement === 'window') {
	            var body = root.document.body,
	                html = root.document.documentElement;
	
	            height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	            width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
	
	            boundaries = {
	                top: 0,
	                right: width,
	                bottom: height,
	                left: 0
	            };
	        } else if (boundariesElement === 'viewport') {
	            var offsetParent = getOffsetParent(this._popper);
	            var scrollParent = getScrollParent(this._popper);
	            var offsetParentRect = getOffsetRect(offsetParent);
	
	            // Thanks the fucking native API, `document.body.scrollTop` & `document.documentElement.scrollTop`
	            var getScrollTopValue = function getScrollTopValue(element) {
	                return element == document.body ? Math.max(document.documentElement.scrollTop, document.body.scrollTop) : element.scrollTop;
	            };
	            var getScrollLeftValue = function getScrollLeftValue(element) {
	                return element == document.body ? Math.max(document.documentElement.scrollLeft, document.body.scrollLeft) : element.scrollLeft;
	            };
	
	            // if the popper is fixed we don't have to substract scrolling from the boundaries
	            var scrollTop = data.offsets.popper.position === 'fixed' ? 0 : getScrollTopValue(scrollParent);
	            var scrollLeft = data.offsets.popper.position === 'fixed' ? 0 : getScrollLeftValue(scrollParent);
	
	            boundaries = {
	                top: 0 - (offsetParentRect.top - scrollTop),
	                right: root.document.documentElement.clientWidth - (offsetParentRect.left - scrollLeft),
	                bottom: root.document.documentElement.clientHeight - (offsetParentRect.top - scrollTop),
	                left: 0 - (offsetParentRect.left - scrollLeft)
	            };
	        } else {
	            if (getOffsetParent(this._popper) === boundariesElement) {
	                boundaries = {
	                    top: 0,
	                    left: 0,
	                    right: boundariesElement.clientWidth,
	                    bottom: boundariesElement.clientHeight
	                };
	            } else {
	                boundaries = getOffsetRect(boundariesElement);
	            }
	        }
	        boundaries.left += padding;
	        boundaries.right -= padding;
	        boundaries.top = boundaries.top + padding;
	        boundaries.bottom = boundaries.bottom - padding;
	        return boundaries;
	    };
	
	    /**
	     * Loop trough the list of modifiers and run them in order, each of them will then edit the data object
	     * @method
	     * @memberof Popper
	     * @access public
	     * @param {Object} data
	     * @param {Array} modifiers
	     * @param {Function} ends
	     */
	    Popper.prototype.runModifiers = function (data, modifiers, ends) {
	        var modifiersToRun = modifiers.slice();
	        if (ends !== undefined) {
	            modifiersToRun = this._options.modifiers.slice(0, getArrayKeyIndex(this._options.modifiers, ends));
	        }
	
	        modifiersToRun.forEach(function (modifier) {
	            if (isFunction(modifier)) {
	                data = modifier.call(this, data);
	            }
	        }.bind(this));
	
	        return data;
	    };
	
	    /**
	     * Helper used to know if the given modifier depends from another one.
	     * @method
	     * @memberof Popper
	     * @param {String} requesting - name of requesting modifier
	     * @param {String} requested - name of requested modifier
	     * @returns {Boolean}
	     */
	    Popper.prototype.isModifierRequired = function (requesting, requested) {
	        var index = getArrayKeyIndex(this._options.modifiers, requesting);
	        return !!this._options.modifiers.slice(0, index).filter(function (modifier) {
	            return modifier === requested;
	        }).length;
	    };
	
	    //
	    // Modifiers
	    //
	
	    /**
	     * Modifiers list
	     * @namespace Popper.modifiers
	     * @memberof Popper
	     * @type {Object}
	     */
	    Popper.prototype.modifiers = {};
	
	    /**
	     * Apply the computed styles to the popper element
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The same data object
	     */
	    Popper.prototype.modifiers.applyStyle = function (data) {
	        // apply the final offsets to the popper
	        // NOTE: 1 DOM access here
	        var styles = {
	            position: data.offsets.popper.position
	        };
	
	        // round top and left to avoid blurry text
	        var left = Math.round(data.offsets.popper.left);
	        var top = Math.round(data.offsets.popper.top);
	
	        // if gpuAcceleration is set to true and transform is supported, we use `translate3d` to apply the position to the popper
	        // we automatically use the supported prefixed version if needed
	        var prefixedProperty;
	        if (this._options.gpuAcceleration && (prefixedProperty = getSupportedPropertyName('transform'))) {
	            styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	            styles.top = 0;
	            styles.left = 0;
	        }
	        // othwerise, we use the standard `left` and `top` properties
	        else {
	                styles.left = left;
	                styles.top = top;
	            }
	
	        // any property present in `data.styles` will be applied to the popper,
	        // in this way we can make the 3rd party modifiers add custom styles to it
	        // Be aware, modifiers could override the properties defined in the previous
	        // lines of this modifier!
	        Object.assign(styles, data.styles);
	
	        setStyle(this._popper, styles);
	
	        // set an attribute which will be useful to style the tooltip (use it to properly position its arrow)
	        // NOTE: 1 DOM access here
	        this._popper.setAttribute('x-placement', data.placement);
	
	        // if the arrow modifier is required and the arrow style has been computed, apply the arrow style
	        if (this.isModifierRequired(this.modifiers.applyStyle, this.modifiers.arrow) && data.offsets.arrow) {
	            setStyle(data.arrowElement, data.offsets.arrow);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to shift the popper on the start or end of its reference element side
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.shift = function (data) {
	        var placement = data.placement;
	        var basePlacement = placement.split('-')[0];
	        var shiftVariation = placement.split('-')[1];
	
	        // if shift shiftVariation is specified, run the modifier
	        if (shiftVariation) {
	            var reference = data.offsets.reference;
	            var popper = getPopperClientRect(data.offsets.popper);
	
	            var shiftOffsets = {
	                y: {
	                    start: { top: reference.top },
	                    end: { top: reference.top + reference.height - popper.height }
	                },
	                x: {
	                    start: { left: reference.left },
	                    end: { left: reference.left + reference.width - popper.width }
	                }
	            };
	
	            var axis = ['bottom', 'top'].indexOf(basePlacement) !== -1 ? 'x' : 'y';
	
	            data.offsets.popper = Object.assign(popper, shiftOffsets[axis][shiftVariation]);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to make sure the popper does not overflows from it's boundaries
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.preventOverflow = function (data) {
	        var order = this._options.preventOverflowOrder;
	        var popper = getPopperClientRect(data.offsets.popper);
	
	        var check = {
	            left: function left() {
	                var left = popper.left;
	                if (popper.left < data.boundaries.left) {
	                    left = Math.max(popper.left, data.boundaries.left);
	                }
	                return { left: left };
	            },
	            right: function right() {
	                var left = popper.left;
	                if (popper.right > data.boundaries.right) {
	                    left = Math.min(popper.left, data.boundaries.right - popper.width);
	                }
	                return { left: left };
	            },
	            top: function top() {
	                var top = popper.top;
	                if (popper.top < data.boundaries.top) {
	                    top = Math.max(popper.top, data.boundaries.top);
	                }
	                return { top: top };
	            },
	            bottom: function bottom() {
	                var top = popper.top;
	                if (popper.bottom > data.boundaries.bottom) {
	                    top = Math.min(popper.top, data.boundaries.bottom - popper.height);
	                }
	                return { top: top };
	            }
	        };
	
	        order.forEach(function (direction) {
	            data.offsets.popper = Object.assign(popper, check[direction]());
	        });
	
	        return data;
	    };
	
	    /**
	     * Modifier used to make sure the popper is always near its reference
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.keepTogether = function (data) {
	        var popper = getPopperClientRect(data.offsets.popper);
	        var reference = data.offsets.reference;
	        var f = Math.floor;
	
	        if (popper.right < f(reference.left)) {
	            data.offsets.popper.left = f(reference.left) - popper.width;
	        }
	        if (popper.left > f(reference.right)) {
	            data.offsets.popper.left = f(reference.right);
	        }
	        if (popper.bottom < f(reference.top)) {
	            data.offsets.popper.top = f(reference.top) - popper.height;
	        }
	        if (popper.top > f(reference.bottom)) {
	            data.offsets.popper.top = f(reference.bottom);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to flip the placement of the popper when the latter is starting overlapping its reference element.
	     * Requires the `preventOverflow` modifier before it in order to work.
	     * **NOTE:** This modifier will run all its previous modifiers everytime it tries to flip the popper!
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.flip = function (data) {
	        // check if preventOverflow is in the list of modifiers before the flip modifier.
	        // otherwise flip would not work as expected.
	        if (!this.isModifierRequired(this.modifiers.flip, this.modifiers.preventOverflow)) {
	            console.warn('WARNING: preventOverflow modifier is required by flip modifier in order to work, be sure to include it before flip!');
	            return data;
	        }
	
	        if (data.flipped && data.placement === data._originalPlacement) {
	            // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	            return data;
	        }
	
	        var placement = data.placement.split('-')[0];
	        var placementOpposite = getOppositePlacement(placement);
	        var variation = data.placement.split('-')[1] || '';
	
	        var flipOrder = [];
	        if (this._options.flipBehavior === 'flip') {
	            flipOrder = [placement, placementOpposite];
	        } else {
	            flipOrder = this._options.flipBehavior;
	        }
	
	        flipOrder.forEach(function (step, index) {
	            if (placement !== step || flipOrder.length === index + 1) {
	                return;
	            }
	
	            placement = data.placement.split('-')[0];
	            placementOpposite = getOppositePlacement(placement);
	
	            var popperOffsets = getPopperClientRect(data.offsets.popper);
	
	            // this boolean is used to distinguish right and bottom from top and left
	            // they need different computations to get flipped
	            var a = ['right', 'bottom'].indexOf(placement) !== -1;
	
	            // using Math.floor because the reference offsets may contain decimals we are not going to consider here
	            if (a && Math.floor(data.offsets.reference[placement]) > Math.floor(popperOffsets[placementOpposite]) || !a && Math.floor(data.offsets.reference[placement]) < Math.floor(popperOffsets[placementOpposite])) {
	                // we'll use this boolean to detect any flip loop
	                data.flipped = true;
	                data.placement = flipOrder[index + 1];
	                if (variation) {
	                    data.placement += '-' + variation;
	                }
	                data.offsets.popper = this._getOffsets(this._popper, this._reference, data.placement).popper;
	
	                data = this.runModifiers(data, this._options.modifiers, this._flip);
	            }
	        }.bind(this));
	        return data;
	    };
	
	    /**
	     * Modifier used to add an offset to the popper, useful if you more granularity positioning your popper.
	     * The offsets will shift the popper on the side of its reference element.
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.offset = function (data) {
	        var offset = this._options.offset;
	        var popper = data.offsets.popper;
	
	        if (data.placement.indexOf('left') !== -1) {
	            popper.top -= offset;
	        } else if (data.placement.indexOf('right') !== -1) {
	            popper.top += offset;
	        } else if (data.placement.indexOf('top') !== -1) {
	            popper.left -= offset;
	        } else if (data.placement.indexOf('bottom') !== -1) {
	            popper.left += offset;
	        }
	        return data;
	    };
	
	    /**
	     * Modifier used to move the arrows on the edge of the popper to make sure them are always between the popper and the reference element
	     * It will use the CSS outer size of the arrow element to know how many pixels of conjuction are needed
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.arrow = function (data) {
	        var arrow = this._options.arrowElement;
	        var arrowOffset = this._options.arrowOffset;
	
	        // if the arrowElement is a string, suppose it's a CSS selector
	        if (typeof arrow === 'string') {
	            arrow = this._popper.querySelector(arrow);
	        }
	
	        // if arrow element is not found, don't run the modifier
	        if (!arrow) {
	            return data;
	        }
	
	        // the arrow element must be child of its popper
	        if (!this._popper.contains(arrow)) {
	            console.warn('WARNING: `arrowElement` must be child of its popper element!');
	            return data;
	        }
	
	        // arrow depends on keepTogether in order to work
	        if (!this.isModifierRequired(this.modifiers.arrow, this.modifiers.keepTogether)) {
	            console.warn('WARNING: keepTogether modifier is required by arrow modifier in order to work, be sure to include it before arrow!');
	            return data;
	        }
	
	        var arrowStyle = {};
	        var placement = data.placement.split('-')[0];
	        var popper = getPopperClientRect(data.offsets.popper);
	        var reference = data.offsets.reference;
	        var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	        var len = isVertical ? 'height' : 'width';
	        var side = isVertical ? 'top' : 'left';
	        var translate = isVertical ? 'translateY' : 'translateX';
	        var altSide = isVertical ? 'left' : 'top';
	        var opSide = isVertical ? 'bottom' : 'right';
	        var arrowSize = getOuterSizes(arrow)[len];
	
	        //
	        // extends keepTogether behavior making sure the popper and its reference have enough pixels in conjuction
	        //
	
	        // top/left side
	        if (reference[opSide] - arrowSize < popper[side]) {
	            data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowSize);
	        }
	        // bottom/right side
	        if (reference[side] + arrowSize > popper[opSide]) {
	            data.offsets.popper[side] += reference[side] + arrowSize - popper[opSide];
	        }
	
	        // compute center of the popper
	        var center = reference[side] + (arrowOffset || reference[len] / 2 - arrowSize / 2);
	
	        var sideValue = center - popper[side];
	
	        // prevent arrow from being placed not contiguously to its popper
	        sideValue = Math.max(Math.min(popper[len] - arrowSize - 8, sideValue), 8);
	        arrowStyle[side] = sideValue;
	        arrowStyle[altSide] = ''; // make sure to remove any old style from the arrow
	
	        data.offsets.arrow = arrowStyle;
	        data.arrowElement = arrow;
	
	        return data;
	    };
	
	    //
	    // Helpers
	    //
	
	    /**
	     * Get the outer sizes of the given element (offset size + margins)
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Object} object containing width and height properties
	     */
	    function getOuterSizes(element) {
	        // NOTE: 1 DOM access here
	        var _display = element.style.display,
	            _visibility = element.style.visibility;
	        element.style.display = 'block';element.style.visibility = 'hidden';
	        var calcWidthToForceRepaint = element.offsetWidth;
	
	        // original method
	        var styles = root.getComputedStyle(element);
	        var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
	        var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
	        var result = { width: element.offsetWidth + y, height: element.offsetHeight + x };
	
	        // reset element styles
	        element.style.display = _display;element.style.visibility = _visibility;
	        return result;
	    }
	
	    /**
	     * Get the opposite placement of the given one/
	     * @function
	     * @ignore
	     * @argument {String} placement
	     * @returns {String} flipped placement
	     */
	    function getOppositePlacement(placement) {
	        var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	        return placement.replace(/left|right|bottom|top/g, function (matched) {
	            return hash[matched];
	        });
	    }
	
	    /**
	     * Given the popper offsets, generate an output similar to getBoundingClientRect
	     * @function
	     * @ignore
	     * @argument {Object} popperOffsets
	     * @returns {Object} ClientRect like output
	     */
	    function getPopperClientRect(popperOffsets) {
	        var offsets = Object.assign({}, popperOffsets);
	        offsets.right = offsets.left + offsets.width;
	        offsets.bottom = offsets.top + offsets.height;
	        return offsets;
	    }
	
	    /**
	     * Given an array and the key to find, returns its index
	     * @function
	     * @ignore
	     * @argument {Array} arr
	     * @argument keyToFind
	     * @returns index or null
	     */
	    function getArrayKeyIndex(arr, keyToFind) {
	        var i = 0,
	            key;
	        for (key in arr) {
	            if (arr[key] === keyToFind) {
	                return i;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    /**
	     * Get CSS computed property of the given element
	     * @function
	     * @ignore
	     * @argument {Eement} element
	     * @argument {String} property
	     */
	    function getStyleComputedProperty(element, property) {
	        // NOTE: 1 DOM access here
	        var css = root.getComputedStyle(element, null);
	        return css[property];
	    }
	
	    /**
	     * Returns the offset parent of the given element
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Element} offset parent
	     */
	    function getOffsetParent(element) {
	        // NOTE: 1 DOM access here
	        var offsetParent = element.offsetParent;
	        return offsetParent === root.document.body || !offsetParent ? root.document.documentElement : offsetParent;
	    }
	
	    /**
	     * Returns the scrolling parent of the given element
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Element} offset parent
	     */
	    function getScrollParent(element) {
	        var parent = element.parentNode;
	
	        if (!parent) {
	            return element;
	        }
	
	        if (parent === root.document) {
	            // Firefox puts the scrollTOp value on `documentElement` instead of `body`, we then check which of them is
	            // greater than 0 and return the proper element
	            if (root.document.body.scrollTop || root.document.body.scrollLeft) {
	                return root.document.body;
	            } else {
	                return root.document.documentElement;
	            }
	        }
	
	        // Firefox want us to check `-x` and `-y` variations as well
	        if (['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1) {
	            // If the detected scrollParent is body, we perform an additional check on its parentNode
	            // in this way we'll get body if the browser is Chrome-ish, or documentElement otherwise
	            // fixes issue #65
	            return parent;
	        }
	        return getScrollParent(element.parentNode);
	    }
	
	    /**
	     * Check if the given element is fixed or is inside a fixed parent
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @argument {Element} customContainer
	     * @returns {Boolean} answer to "isFixed?"
	     */
	    function isFixed(element) {
	        if (element === root.document.body) {
	            return false;
	        }
	        if (getStyleComputedProperty(element, 'position') === 'fixed') {
	            return true;
	        }
	        return element.parentNode ? isFixed(element.parentNode) : element;
	    }
	
	    /**
	     * Set the style to the given popper
	     * @function
	     * @ignore
	     * @argument {Element} element - Element to apply the style to
	     * @argument {Object} styles - Object with a list of properties and values which will be applied to the element
	     */
	    function setStyle(element, styles) {
	        function is_numeric(n) {
	            return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	        }
	        Object.keys(styles).forEach(function (prop) {
	            var unit = '';
	            // add unit if the value is numeric and is one of the following
	            if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && is_numeric(styles[prop])) {
	                unit = 'px';
	            }
	            element.style[prop] = styles[prop] + unit;
	        });
	    }
	
	    /**
	     * Check if the given variable is a function
	     * @function
	     * @ignore
	     * @argument {*} functionToCheck - variable to check
	     * @returns {Boolean} answer to: is a function?
	     */
	    function isFunction(functionToCheck) {
	        var getType = {};
	        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	    }
	
	    /**
	     * Get the position of the given element, relative to its offset parent
	     * @function
	     * @ignore
	     * @param {Element} element
	     * @return {Object} position - Coordinates of the element and its `scrollTop`
	     */
	    function getOffsetRect(element) {
	        var elementRect = {
	            width: element.offsetWidth,
	            height: element.offsetHeight,
	            left: element.offsetLeft,
	            top: element.offsetTop
	        };
	
	        elementRect.right = elementRect.left + elementRect.width;
	        elementRect.bottom = elementRect.top + elementRect.height;
	
	        // position
	        return elementRect;
	    }
	
	    /**
	     * Get bounding client rect of given element
	     * @function
	     * @ignore
	     * @param {HTMLElement} element
	     * @return {Object} client rect
	     */
	    function getBoundingClientRect(element) {
	        var rect = element.getBoundingClientRect();
	
	        // whether the IE version is lower than 11
	        var isIE = navigator.userAgent.indexOf("MSIE") != -1;
	
	        // fix ie document bounding top always 0 bug
	        var rectTop = isIE && element.tagName === 'HTML' ? -element.scrollTop : rect.top;
	
	        return {
	            left: rect.left,
	            top: rectTop,
	            right: rect.right,
	            bottom: rect.bottom,
	            width: rect.right - rect.left,
	            height: rect.bottom - rectTop
	        };
	    }
	
	    /**
	     * Given an element and one of its parents, return the offset
	     * @function
	     * @ignore
	     * @param {HTMLElement} element
	     * @param {HTMLElement} parent
	     * @return {Object} rect
	     */
	    function getOffsetRectRelativeToCustomParent(element, parent, fixed) {
	        var elementRect = getBoundingClientRect(element);
	        var parentRect = getBoundingClientRect(parent);
	
	        if (fixed) {
	            var scrollParent = getScrollParent(parent);
	            parentRect.top += scrollParent.scrollTop;
	            parentRect.bottom += scrollParent.scrollTop;
	            parentRect.left += scrollParent.scrollLeft;
	            parentRect.right += scrollParent.scrollLeft;
	        }
	
	        var rect = {
	            top: elementRect.top - parentRect.top,
	            left: elementRect.left - parentRect.left,
	            bottom: elementRect.top - parentRect.top + elementRect.height,
	            right: elementRect.left - parentRect.left + elementRect.width,
	            width: elementRect.width,
	            height: elementRect.height
	        };
	        return rect;
	    }
	
	    /**
	     * Get the prefixed supported property name
	     * @function
	     * @ignore
	     * @argument {String} property (camelCase)
	     * @returns {String} prefixed property (camelCase)
	     */
	    function getSupportedPropertyName(property) {
	        var prefixes = ['', 'ms', 'webkit', 'moz', 'o'];
	
	        for (var i = 0; i < prefixes.length; i++) {
	            var toCheck = prefixes[i] ? prefixes[i] + property.charAt(0).toUpperCase() + property.slice(1) : property;
	            if (typeof root.document.body.style[toCheck] !== 'undefined') {
	                return toCheck;
	            }
	        }
	        return null;
	    }
	
	    /**
	     * The Object.assign() method is used to copy the values of all enumerable own properties from one or more source
	     * objects to a target object. It will return the target object.
	     * This polyfill doesn't support symbol properties, since ES5 doesn't have symbols anyway
	     * Source: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	     * @function
	     * @ignore
	     */
	    if (!Object.assign) {
	        Object.defineProperty(Object, 'assign', {
	            enumerable: false,
	            configurable: true,
	            writable: true,
	            value: function value(target) {
	                if (target === undefined || target === null) {
	                    throw new TypeError('Cannot convert first argument to object');
	                }
	
	                var to = Object(target);
	                for (var i = 1; i < arguments.length; i++) {
	                    var nextSource = arguments[i];
	                    if (nextSource === undefined || nextSource === null) {
	                        continue;
	                    }
	                    nextSource = Object(nextSource);
	
	                    var keysArray = Object.keys(nextSource);
	                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	                        var nextKey = keysArray[nextIndex];
	                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	                        if (desc !== undefined && desc.enumerable) {
	                            to[nextKey] = nextSource[nextKey];
	                        }
	                    }
	                }
	                return to;
	            }
	        });
	    }
	
	    return Popper;
	});

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _dom = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasModal = false;
	var hasInitZIndex = false;
	var zIndex = void 0;
	
	var getModal = function getModal() {
	  if (_vue2.default.prototype.$isServer) return;
	  var modalDom = PopupManager.modalDom;
	  if (modalDom) {
	    hasModal = true;
	  } else {
	    hasModal = false;
	    modalDom = document.createElement('div');
	    PopupManager.modalDom = modalDom;
	
	    modalDom.addEventListener('touchmove', function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    modalDom.addEventListener('click', function () {
	      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
	    });
	  }
	
	  return modalDom;
	};
	
	var instances = {};
	
	var PopupManager = {
	  modalFade: true,
	
	  getInstance: function getInstance(id) {
	    return instances[id];
	  },
	
	  register: function register(id, instance) {
	    if (id && instance) {
	      instances[id] = instance;
	    }
	  },
	
	  deregister: function deregister(id) {
	    if (id) {
	      instances[id] = null;
	      delete instances[id];
	    }
	  },
	
	  nextZIndex: function nextZIndex() {
	    return PopupManager.zIndex++;
	  },
	
	  modalStack: [],
	
	  doOnModalClick: function doOnModalClick() {
	    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
	    if (!topItem) return;
	
	    var instance = PopupManager.getInstance(topItem.id);
	    if (instance && instance.closeOnClickModal) {
	      instance.close();
	    }
	  },
	
	  openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
	    if (_vue2.default.prototype.$isServer) return;
	    if (!id || zIndex === undefined) return;
	    this.modalFade = modalFade;
	
	    var modalStack = this.modalStack;
	
	    for (var i = 0, j = modalStack.length; i < j; i++) {
	      var item = modalStack[i];
	      if (item.id === id) {
	        return;
	      }
	    }
	
	    var modalDom = getModal();
	
	    (0, _dom.addClass)(modalDom, 'v-modal');
	    if (this.modalFade && !hasModal) {
	      (0, _dom.addClass)(modalDom, 'v-modal-enter');
	    }
	    if (modalClass) {
	      var classArr = modalClass.trim().split(/\s+/);
	      classArr.forEach(function (item) {
	        return (0, _dom.addClass)(modalDom, item);
	      });
	    }
	    setTimeout(function () {
	      (0, _dom.removeClass)(modalDom, 'v-modal-enter');
	    }, 200);
	
	    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
	      dom.parentNode.appendChild(modalDom);
	    } else {
	      document.body.appendChild(modalDom);
	    }
	
	    if (zIndex) {
	      modalDom.style.zIndex = zIndex;
	    }
	    modalDom.tabIndex = 0;
	    modalDom.style.display = '';
	
	    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
	  },
	
	  closeModal: function closeModal(id) {
	    var modalStack = this.modalStack;
	    var modalDom = getModal();
	
	    if (modalStack.length > 0) {
	      var topItem = modalStack[modalStack.length - 1];
	      if (topItem.id === id) {
	        if (topItem.modalClass) {
	          var classArr = topItem.modalClass.trim().split(/\s+/);
	          classArr.forEach(function (item) {
	            return (0, _dom.removeClass)(modalDom, item);
	          });
	        }
	
	        modalStack.pop();
	        if (modalStack.length > 0) {
	          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
	        }
	      } else {
	        for (var i = modalStack.length - 1; i >= 0; i--) {
	          if (modalStack[i].id === id) {
	            modalStack.splice(i, 1);
	            break;
	          }
	        }
	      }
	    }
	
	    if (modalStack.length === 0) {
	      if (this.modalFade) {
	        (0, _dom.addClass)(modalDom, 'v-modal-leave');
	      }
	      setTimeout(function () {
	        if (modalStack.length === 0) {
	          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
	          modalDom.style.display = 'none';
	          PopupManager.modalDom = undefined;
	        }
	        (0, _dom.removeClass)(modalDom, 'v-modal-leave');
	      }, 200);
	    }
	  }
	};
	
	Object.defineProperty(PopupManager, 'zIndex', {
	  configurable: true,
	  get: function get() {
	    if (!hasInitZIndex) {
	      zIndex = zIndex || (_vue2.default.prototype.$ELEMENT || {}).zIndex || 2000;
	      hasInitZIndex = true;
	    }
	    return zIndex;
	  },
	  set: function set(value) {
	    zIndex = value;
	  }
	});
	
	var getTopPopup = function getTopPopup() {
	  if (_vue2.default.prototype.$isServer) return;
	  if (PopupManager.modalStack.length > 0) {
	    var topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
	    if (!topPopup) return;
	    var instance = PopupManager.getInstance(topPopup.id);
	
	    return instance;
	  }
	};
	
	if (!_vue2.default.prototype.$isServer) {
	  // handle `esc` key when the popup is shown
	  window.addEventListener('keydown', function (event) {
	    if (event.keyCode === 27) {
	      var topPopup = getTopPopup();
	
	      if (topPopup && topPopup.closeOnPressEscape) {
	        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close();
	      }
	    }
	  });
	}
	
	exports.default = PopupManager;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.isVNode = isVNode;
	
	var _util = __webpack_require__(21);
	
	function isVNode(node) {
	  return node !== null && (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object' && (0, _util.hasOwn)(node, 'componentOptions');
	};

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(404);
	module.exports = self.fetch.bind(self);


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(300);


/***/ }),
/* 297 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	/*jslint evil: true */
	
	'use strict';
	
	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners:
	    canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2004-present Facebook. All Rights Reserved.
	 *
	 * @providesModule UserAgent_DEPRECATED
	 */
	
	/**
	 *  Provides entirely client-side User Agent and OS detection. You should prefer
	 *  the non-deprecated UserAgent module when possible, which exposes our
	 *  authoritative server-side PHP-based detection to the client.
	 *
	 *  Usage is straightforward:
	 *
	 *    if (UserAgent_DEPRECATED.ie()) {
	 *      //  IE
	 *    }
	 *
	 *  You can also do version checks:
	 *
	 *    if (UserAgent_DEPRECATED.ie() >= 7) {
	 *      //  IE7 or better
	 *    }
	 *
	 *  The browser functions will return NaN if the browser does not match, so
	 *  you can also do version compares the other way:
	 *
	 *    if (UserAgent_DEPRECATED.ie() < 7) {
	 *      //  IE6 or worse
	 *    }
	 *
	 *  Note that the version is a float and may include a minor version number,
	 *  so you should always use range operators to perform comparisons, not
	 *  strict equality.
	 *
	 *  **Note:** You should **strongly** prefer capability detection to browser
	 *  version detection where it's reasonable:
	 *
	 *    http://www.quirksmode.org/js/support.html
	 *
	 *  Further, we have a large number of mature wrapper functions and classes
	 *  which abstract away many browser irregularities. Check the documentation,
	 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
	 *  another copy of "event || window.event".
	 *
	 */
	
	var _populated = false;
	
	// Browsers
	var _ie, _firefox, _opera, _webkit, _chrome;
	
	// Actual IE browser for compatibility mode
	var _ie_real_version;
	
	// Platforms
	var _osx, _windows, _linux, _android;
	
	// Architectures
	var _win64;
	
	// Devices
	var _iphone, _ipad, _native;
	
	var _mobile;
	
	function _populate() {
	  if (_populated) {
	    return;
	  }
	
	  _populated = true;
	
	  // To work around buggy JS libraries that can't handle multi-digit
	  // version numbers, Opera 10's user agent string claims it's Opera
	  // 9, then later includes a Version/X.Y field:
	  //
	  // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
	  var uas = navigator.userAgent;
	  var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
	  var os    = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);
	
	  _iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
	  _ipad = /\b(iP[ao]d)/.exec(uas);
	  _android = /Android/i.exec(uas);
	  _native = /FBAN\/\w+;/i.exec(uas);
	  _mobile = /Mobile/i.exec(uas);
	
	  // Note that the IE team blog would have you believe you should be checking
	  // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
	  // from either x64 or ia64;  so ultimately, you should just check for Win64
	  // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
	  // Windows will send 'WOW64' instead.
	  _win64 = !!(/Win64/.exec(uas));
	
	  if (agent) {
	    _ie = agent[1] ? parseFloat(agent[1]) : (
	          agent[5] ? parseFloat(agent[5]) : NaN);
	    // IE compatibility mode
	    if (_ie && document && document.documentMode) {
	      _ie = document.documentMode;
	    }
	    // grab the "true" ie version from the trident token if available
	    var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
	    _ie_real_version = trident ? parseFloat(trident[1]) + 4 : _ie;
	
	    _firefox = agent[2] ? parseFloat(agent[2]) : NaN;
	    _opera   = agent[3] ? parseFloat(agent[3]) : NaN;
	    _webkit  = agent[4] ? parseFloat(agent[4]) : NaN;
	    if (_webkit) {
	      // We do not add the regexp to the above test, because it will always
	      // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
	      // the userAgent string.
	      agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
	      _chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
	    } else {
	      _chrome = NaN;
	    }
	  } else {
	    _ie = _firefox = _opera = _chrome = _webkit = NaN;
	  }
	
	  if (os) {
	    if (os[1]) {
	      // Detect OS X version.  If no version number matches, set _osx to true.
	      // Version examples:  10, 10_6_1, 10.7
	      // Parses version number as a float, taking only first two sets of
	      // digits.  If only one set of digits is found, returns just the major
	      // version number.
	      var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);
	
	      _osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
	    } else {
	      _osx = false;
	    }
	    _windows = !!os[2];
	    _linux   = !!os[3];
	  } else {
	    _osx = _windows = _linux = false;
	  }
	}
	
	var UserAgent_DEPRECATED = {
	
	  /**
	   *  Check if the UA is Internet Explorer.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  ie: function() {
	    return _populate() || _ie;
	  },
	
	  /**
	   * Check if we're in Internet Explorer compatibility mode.
	   *
	   * @return bool true if in compatibility mode, false if
	   * not compatibility mode or not ie
	   */
	  ieCompatibilityMode: function() {
	    return _populate() || (_ie_real_version > _ie);
	  },
	
	
	  /**
	   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
	   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
	   * this when we don't need it -- tracked by #601957.
	   */
	  ie64: function() {
	    return UserAgent_DEPRECATED.ie() && _win64;
	  },
	
	  /**
	   *  Check if the UA is Firefox.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  firefox: function() {
	    return _populate() || _firefox;
	  },
	
	
	  /**
	   *  Check if the UA is Opera.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  opera: function() {
	    return _populate() || _opera;
	  },
	
	
	  /**
	   *  Check if the UA is WebKit.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  webkit: function() {
	    return _populate() || _webkit;
	  },
	
	  /**
	   *  For Push
	   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
	   */
	  safari: function() {
	    return UserAgent_DEPRECATED.webkit();
	  },
	
	  /**
	   *  Check if the UA is a Chrome browser.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  chrome : function() {
	    return _populate() || _chrome;
	  },
	
	
	  /**
	   *  Check if the user is running Windows.
	   *
	   *  @return bool `true' if the user's OS is Windows.
	   */
	  windows: function() {
	    return _populate() || _windows;
	  },
	
	
	  /**
	   *  Check if the user is running Mac OS X.
	   *
	   *  @return float|bool   Returns a float if a version number is detected,
	   *                       otherwise true/false.
	   */
	  osx: function() {
	    return _populate() || _osx;
	  },
	
	  /**
	   * Check if the user is running Linux.
	   *
	   * @return bool `true' if the user's OS is some flavor of Linux.
	   */
	  linux: function() {
	    return _populate() || _linux;
	  },
	
	  /**
	   * Check if the user is running on an iPhone or iPod platform.
	   *
	   * @return bool `true' if the user is running some flavor of the
	   *    iPhone OS.
	   */
	  iphone: function() {
	    return _populate() || _iphone;
	  },
	
	  mobile: function() {
	    return _populate() || (_iphone || _ipad || _android || _mobile);
	  },
	
	  nativeApp: function() {
	    // webviews inside of the native apps
	    return _populate() || _native;
	  },
	
	  android: function() {
	    return _populate() || _android;
	  },
	
	  ipad: function() {
	    return _populate() || _ipad;
	  }
	};
	
	module.exports = UserAgent_DEPRECATED;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(297);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature =
	    document.implementation &&
	    document.implementation.hasFeature &&
	    // always returns true in newer browsers as per the standard.
	    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	    document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM ||
	      capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule normalizeWheel
	 * @typechecks
	 */
	
	'use strict';
	
	var UserAgent_DEPRECATED = __webpack_require__(298);
	
	var isEventSupported = __webpack_require__(299);
	
	
	// Reasonable defaults
	var PIXEL_STEP  = 10;
	var LINE_HEIGHT = 40;
	var PAGE_HEIGHT = 800;
	
	/**
	 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
	 * complicated, thus this doc is long and (hopefully) detailed enough to answer
	 * your questions.
	 *
	 * If you need to react to the mouse wheel in a predictable way, this code is
	 * like your bestest friend. * hugs *
	 *
	 * As of today, there are 4 DOM event types you can listen to:
	 *
	 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
	 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
	 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
	 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
	 *
	 * So what to do?  The is the best:
	 *
	 *   normalizeWheel.getEventType();
	 *
	 * In your event callback, use this code to get sane interpretation of the
	 * deltas.  This code will return an object with properties:
	 *
	 *   spinX   -- normalized spin speed (use for zoom) - x plane
	 *   spinY   -- " - y plane
	 *   pixelX  -- normalized distance (to pixels) - x plane
	 *   pixelY  -- " - y plane
	 *
	 * Wheel values are provided by the browser assuming you are using the wheel to
	 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
	 * significantly on different platforms and browsers, forgetting that you can
	 * scroll at different speeds.  Some devices (like trackpads) emit more events
	 * at smaller increments with fine granularity, and some emit massive jumps with
	 * linear speed or acceleration.
	 *
	 * This code does its best to normalize the deltas for you:
	 *
	 *   - spin is trying to normalize how far the wheel was spun (or trackpad
	 *     dragged).  This is super useful for zoom support where you want to
	 *     throw away the chunky scroll steps on the PC and make those equal to
	 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
	 *     resolve a single slow step on a wheel to 1.
	 *
	 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
	 *     get the crazy differences between browsers, but at least it'll be in
	 *     pixels!
	 *
	 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
	 *     should translate to positive value zooming IN, negative zooming OUT.
	 *     This matches the newer 'wheel' event.
	 *
	 * Why are there spinX, spinY (or pixels)?
	 *
	 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
	 *     with a mouse.  It results in side-scrolling in the browser by default.
	 *
	 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
	 *
	 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
	 *     probably is by browsers in conjunction with fancy 3D controllers .. but
	 *     you know.
	 *
	 * Implementation info:
	 *
	 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
	 * average mouse:
	 *
	 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
	 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
	 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
	 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
	 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
	 *
	 * On the trackpad:
	 *
	 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
	 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
	 *
	 * On other/older browsers.. it's more complicated as there can be multiple and
	 * also missing delta values.
	 *
	 * The 'wheel' event is more standard:
	 *
	 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
	 *
	 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
	 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
	 * backward compatibility with older events.  Those other values help us
	 * better normalize spin speed.  Example of what the browsers provide:
	 *
	 *                          | event.wheelDelta | event.detail
	 *        ------------------+------------------+--------------
	 *          Safari v5/OS X  |       -120       |       0
	 *          Safari v5/Win7  |       -120       |       0
	 *         Chrome v17/OS X  |       -120       |       0
	 *         Chrome v17/Win7  |       -120       |       0
	 *                IE9/Win7  |       -120       |   undefined
	 *         Firefox v4/OS X  |     undefined    |       1
	 *         Firefox v4/Win7  |     undefined    |       3
	 *
	 */
	function normalizeWheel(/*object*/ event) /*object*/ {
	  var sX = 0, sY = 0,       // spinX, spinY
	      pX = 0, pY = 0;       // pixelX, pixelY
	
	  // Legacy
	  if ('detail'      in event) { sY = event.detail; }
	  if ('wheelDelta'  in event) { sY = -event.wheelDelta / 120; }
	  if ('wheelDeltaY' in event) { sY = -event.wheelDeltaY / 120; }
	  if ('wheelDeltaX' in event) { sX = -event.wheelDeltaX / 120; }
	
	  // side scrolling on FF with DOMMouseScroll
	  if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
	    sX = sY;
	    sY = 0;
	  }
	
	  pX = sX * PIXEL_STEP;
	  pY = sY * PIXEL_STEP;
	
	  if ('deltaY' in event) { pY = event.deltaY; }
	  if ('deltaX' in event) { pX = event.deltaX; }
	
	  if ((pX || pY) && event.deltaMode) {
	    if (event.deltaMode == 1) {          // delta in LINE units
	      pX *= LINE_HEIGHT;
	      pY *= LINE_HEIGHT;
	    } else {                             // delta in PAGE units
	      pX *= PAGE_HEIGHT;
	      pY *= PAGE_HEIGHT;
	    }
	  }
	
	  // Fall-back if spin cannot be determined
	  if (pX && !sX) { sX = (pX < 1) ? -1 : 1; }
	  if (pY && !sY) { sY = (pY < 1) ? -1 : 1; }
	
	  return { spinX  : sX,
	           spinY  : sY,
	           pixelX : pX,
	           pixelY : pY };
	}
	
	
	/**
	 * The best combination if you prefer spinX + spinY normalization.  It favors
	 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
	 * 'wheel' event, making spin speed determination impossible.
	 */
	normalizeWheel.getEventType = function() /*string*/ {
	  return (UserAgent_DEPRECATED.firefox())
	           ? 'DOMMouseScroll'
	           : (isEventSupported('wheel'))
	               ? 'wheel'
	               : 'mousewheel';
	};
	
	module.exports = normalizeWheel;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(303);
	var parse = __webpack_require__(302);
	var formats = __webpack_require__(139);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(140);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos));
	            val = options.decoder(part.slice(pos + 1));
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function parseObjectRecursive(chain, val, options) {
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj;
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(parseObject(chain, val, options));
	    } else {
	        obj = options.plainObjects ? Object.create(null) : {};
	        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	        var index = parseInt(cleanRoot, 10);
	        if (
	            !isNaN(index) &&
	            root !== cleanRoot &&
	            String(index) === cleanRoot &&
	            index >= 0 &&
	            (options.parseArrays && index <= options.arrayLimit)
	        ) {
	            obj = [];
	            obj[index] = parseObject(chain, val, options);
	        } else {
	            obj[cleanRoot] = parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts || {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(140);
	var formats = __webpack_require__(139);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
	        return prefix;
	    }
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify( // eslint-disable-line func-name-matching
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        } else {
	            values = values.concat(stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts || {};
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
	    if (typeof options.format === 'undefined') {
	        options.format = formats.default;
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encode ? encoder : null,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly
	        ));
	    }
	
	    return keys.join(delimiter);
	};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(88)))

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var throttle = __webpack_require__(89);
	var debounce = __webpack_require__(59);
	
	module.exports = {
		throttle: throttle,
		debounce: debounce
	};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(305);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _constant = __webpack_require__(7);
	
	var _popup = __webpack_require__(39);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _popup2 = _interopRequireDefault(__webpack_require__(37));
	
	var _loading = _interopRequireDefault(__webpack_require__(18));
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('action-sheet'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function ActionSheet(h, props, slots, ctx) {
	  var title = props.title,
	      cancelText = props.cancelText;
	
	  function onCancel() {
	    (0, _functional.emit)(ctx, 'input', false);
	    (0, _functional.emit)(ctx, 'cancel');
	  }
	
	  function Header() {
	    if (title) {
	      return h("div", {
	        "class": bem('header')
	      }, [title, h(_icon.default, {
	        "attrs": {
	          "name": props.closeIcon
	        },
	        "class": bem('close'),
	        "on": {
	          "click": onCancel
	        }
	      })]);
	    }
	  }
	
	  function Content() {
	    if (slots.default) {
	      return h("div", {
	        "class": bem('content')
	      }, [slots.default()]);
	    }
	  }
	
	  function Option(item, index) {
	    var disabled = item.disabled,
	        loading = item.loading,
	        callback = item.callback;
	
	    function onClickOption(event) {
	      event.stopPropagation();
	
	      if (disabled || loading) {
	        return;
	      }
	
	      if (callback) {
	        callback(item);
	      }
	
	      (0, _functional.emit)(ctx, 'select', item, index);
	
	      if (props.closeOnClickAction) {
	        (0, _functional.emit)(ctx, 'input', false);
	      }
	    }
	
	    function OptionContent() {
	      if (loading) {
	        return h(_loading.default, {
	          "attrs": {
	            "size": "20px"
	          }
	        });
	      }
	
	      return [h("span", {
	        "class": bem('name')
	      }, [item.name]), item.subname && h("span", {
	        "class": bem('subname')
	      }, [item.subname])];
	    }
	
	    return h("button", {
	      "attrs": {
	        "type": "button"
	      },
	      "class": [bem('item', {
	        disabled: disabled,
	        loading: loading
	      }), item.className, _constant.BORDER_TOP],
	      "style": {
	        color: item.color
	      },
	      "on": {
	        "click": onClickOption
	      }
	    }, [OptionContent()]);
	  }
	
	  function CancelText() {
	    if (cancelText) {
	      return h("button", {
	        "attrs": {
	          "type": "button"
	        },
	        "class": bem('cancel'),
	        "on": {
	          "click": onCancel
	        }
	      }, [cancelText]);
	    }
	  }
	
	  var Description = props.description && h("div", {
	    "class": bem('description')
	  }, [props.description]);
	  return h(_popup2.default, (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem(),
	    "attrs": {
	      "position": "bottom",
	      "round": props.round,
	      "value": props.value,
	      "overlay": props.overlay,
	      "duration": props.duration,
	      "lazyRender": props.lazyRender,
	      "lockScroll": props.lockScroll,
	      "getContainer": props.getContainer,
	      "closeOnPopstate": props.closeOnPopstate,
	      "closeOnClickOverlay": props.closeOnClickOverlay,
	      "safeAreaInsetBottom": props.safeAreaInsetBottom
	    }
	  }, (0, _functional.inherit)(ctx, true)]), [Header(), Description, props.actions && props.actions.map(Option), Content(), CancelText()]);
	}
	
	ActionSheet.props = (0, _extends2.default)({}, _popup.popupMixinProps, {
	  title: String,
	  actions: Array,
	  duration: [Number, String],
	  cancelText: String,
	  description: String,
	  getContainer: [String, Function],
	  closeOnPopstate: Boolean,
	  closeOnClickAction: Boolean,
	  round: {
	    type: Boolean,
	    default: true
	  },
	  closeIcon: {
	    type: String,
	    default: 'cross'
	  },
	  safeAreaInsetBottom: {
	    type: Boolean,
	    default: true
	  },
	  overlay: {
	    type: Boolean,
	    default: true
	  },
	  closeOnClickOverlay: {
	    type: Boolean,
	    default: true
	  }
	});
	
	var _default = createComponent(ActionSheet);
	
	exports.default = _default;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _system = __webpack_require__(175);
	
	var _cell = _interopRequireDefault(__webpack_require__(15));
	
	var _field = _interopRequireDefault(__webpack_require__(34));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('address-edit-detail'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	var android = (0, _system.isAndroid)();
	
	var _default = createComponent({
	  props: {
	    value: String,
	    errorMessage: String,
	    focused: Boolean,
	    detailRows: [Number, String],
	    searchResult: Array,
	    detailMaxlength: [Number, String],
	    showSearchResult: Boolean
	  },
	  computed: {
	    shouldShowSearchResult: function shouldShowSearchResult() {
	      return this.focused && this.searchResult && this.showSearchResult;
	    }
	  },
	  methods: {
	    onSelect: function onSelect(express) {
	      this.$emit('select-search', express);
	      this.$emit('input', ((express.address || '') + " " + (express.name || '')).trim());
	    },
	    onFinish: function onFinish() {
	      this.$refs.field.blur();
	    },
	    genFinish: function genFinish() {
	      var h = this.$createElement;
	      var show = this.value && this.focused && android;
	
	      if (show) {
	        return h("div", {
	          "class": bem('finish'),
	          "on": {
	            "click": this.onFinish
	          }
	        }, [t('complete')]);
	      }
	    },
	    genSearchResult: function genSearchResult() {
	      var _this = this;
	
	      var h = this.$createElement;
	      var value = this.value,
	          shouldShowSearchResult = this.shouldShowSearchResult,
	          searchResult = this.searchResult;
	
	      if (shouldShowSearchResult) {
	        return searchResult.map(function (express) {
	          return h(_cell.default, {
	            "key": express.name + express.address,
	            "attrs": {
	              "clickable": true,
	              "border": false,
	              "icon": "location-o",
	              "label": express.address
	            },
	            "class": bem('search-item'),
	            "on": {
	              "click": function click() {
	                _this.onSelect(express);
	              }
	            },
	            "scopedSlots": {
	              title: function title() {
	                if (express.name) {
	                  var text = express.name.replace(value, "<span class=" + bem('keyword') + ">" + value + "</span>");
	                  return h("div", {
	                    "domProps": {
	                      "innerHTML": text
	                    }
	                  });
	                }
	              }
	            }
	          });
	        });
	      }
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h(_cell.default, {
	      "class": bem()
	    }, [h(_field.default, {
	      "attrs": {
	        "autosize": true,
	        "rows": this.detailRows,
	        "clearable": !android,
	        "type": "textarea",
	        "value": this.value,
	        "errorMessage": this.errorMessage,
	        "border": !this.shouldShowSearchResult,
	        "label": t('label'),
	        "maxlength": this.detailMaxlength,
	        "placeholder": t('placeholder')
	      },
	      "ref": "field",
	      "scopedSlots": {
	        icon: this.genFinish
	      },
	      "on": (0, _extends2.default)({}, this.$listeners)
	    }), this.genSearchResult()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _mobile = __webpack_require__(174);
	
	var _area = _interopRequireDefault(__webpack_require__(141));
	
	var _field = _interopRequireDefault(__webpack_require__(34));
	
	var _popup = _interopRequireDefault(__webpack_require__(37));
	
	var _toast = _interopRequireDefault(__webpack_require__(64));
	
	var _button = _interopRequireDefault(__webpack_require__(17));
	
	var _dialog = _interopRequireDefault(__webpack_require__(94));
	
	var _Detail = _interopRequireDefault(__webpack_require__(313));
	
	var _switchCell = _interopRequireDefault(__webpack_require__(165));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('address-edit'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	var defaultData = {
	  name: '',
	  tel: '',
	  country: '',
	  province: '',
	  city: '',
	  county: '',
	  areaCode: '',
	  postalCode: '',
	  addressDetail: '',
	  isDefault: false
	};
	
	function isPostal(value) {
	  return /^\d{6}$/.test(value);
	}
	
	var _default2 = createComponent({
	  props: {
	    areaList: Object,
	    isSaving: Boolean,
	    isDeleting: Boolean,
	    validator: Function,
	    showDelete: Boolean,
	    showPostal: Boolean,
	    searchResult: Array,
	    showSetDefault: Boolean,
	    showSearchResult: Boolean,
	    saveButtonText: String,
	    deleteButtonText: String,
	    showArea: {
	      type: Boolean,
	      default: true
	    },
	    showDetail: {
	      type: Boolean,
	      default: true
	    },
	    disableArea: Boolean,
	    detailRows: {
	      type: [Number, String],
	      default: 1
	    },
	    detailMaxlength: {
	      type: [Number, String],
	      default: 200
	    },
	    addressInfo: {
	      type: Object,
	      default: function _default() {
	        return (0, _extends2.default)({}, defaultData);
	      }
	    },
	    telValidator: {
	      type: Function,
	      default: _mobile.isMobile
	    },
	    postalValidator: {
	      type: Function,
	      default: isPostal
	    },
	    areaColumnsPlaceholder: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      data: {},
	      showAreaPopup: false,
	      detailFocused: false,
	      errorInfo: {
	        tel: '',
	        name: '',
	        areaCode: '',
	        postalCode: '',
	        addressDetail: ''
	      }
	    };
	  },
	  computed: {
	    areaListLoaded: function areaListLoaded() {
	      return (0, _utils.isObject)(this.areaList) && Object.keys(this.areaList).length;
	    },
	    areaText: function areaText() {
	      var _this$data = this.data,
	          country = _this$data.country,
	          province = _this$data.province,
	          city = _this$data.city,
	          county = _this$data.county,
	          areaCode = _this$data.areaCode;
	
	      if (areaCode) {
	        var arr = [country, province, city, county];
	
	        if (province && province === city) {
	          arr.splice(1, 1);
	        }
	
	        return arr.filter(function (text) {
	          return text;
	        }).join('/');
	      }
	
	      return '';
	    }
	  },
	  watch: {
	    addressInfo: {
	      handler: function handler(val) {
	        this.data = (0, _extends2.default)({}, defaultData, {}, val);
	        this.setAreaCode(val.areaCode);
	      },
	      deep: true,
	      immediate: true
	    },
	    areaList: function areaList() {
	      this.setAreaCode(this.data.areaCode);
	    }
	  },
	  methods: {
	    onFocus: function onFocus(key) {
	      this.errorInfo[key] = '';
	      this.detailFocused = key === 'addressDetail';
	      this.$emit('focus', key);
	    },
	    onChangeDetail: function onChangeDetail(val) {
	      this.data.addressDetail = val;
	      this.$emit('change-detail', val);
	    },
	    onAreaConfirm: function onAreaConfirm(values) {
	      values = values.filter(function (value) {
	        return !!value;
	      });
	
	      if (values.some(function (value) {
	        return !value.code;
	      })) {
	        (0, _toast.default)(t('areaEmpty'));
	        return;
	      }
	
	      this.showAreaPopup = false;
	      this.assignAreaValues();
	      this.$emit('change-area', values);
	    },
	    assignAreaValues: function assignAreaValues() {
	      var area = this.$refs.area;
	
	      if (area) {
	        var detail = area.getArea();
	        detail.areaCode = detail.code;
	        delete detail.code;
	        (0, _extends2.default)(this.data, detail);
	      }
	    },
	    onSave: function onSave() {
	      var _this = this;
	
	      var items = ['name', 'tel'];
	
	      if (this.showArea) {
	        items.push('areaCode');
	      }
	
	      if (this.showDetail) {
	        items.push('addressDetail');
	      }
	
	      if (this.showPostal) {
	        items.push('postalCode');
	      }
	
	      var isValid = items.every(function (item) {
	        var msg = _this.getErrorMessage(item);
	
	        if (msg) {
	          _this.errorInfo[item] = msg;
	        }
	
	        return !msg;
	      });
	
	      if (isValid && !this.isSaving) {
	        this.$emit('save', this.data);
	      }
	    },
	    getErrorMessage: function getErrorMessage(key) {
	      var value = String(this.data[key] || '').trim();
	
	      if (this.validator) {
	        var message = this.validator(key, value);
	
	        if (message) {
	          return message;
	        }
	      }
	
	      switch (key) {
	        case 'name':
	          return value ? '' : t('nameEmpty');
	
	        case 'tel':
	          return this.telValidator(value) ? '' : t('telInvalid');
	
	        case 'areaCode':
	          return value ? '' : t('areaEmpty');
	
	        case 'addressDetail':
	          return value ? '' : t('addressEmpty');
	
	        case 'postalCode':
	          return value && !this.postalValidator(value) ? t('postalEmpty') : '';
	      }
	    },
	    onDelete: function onDelete() {
	      var _this2 = this;
	
	      _dialog.default.confirm({
	        title: t('confirmDelete')
	      }).then(function () {
	        _this2.$emit('delete', _this2.data);
	      }).catch(function () {
	        _this2.$emit('cancel-delete', _this2.data);
	      });
	    },
	    // get values of area component
	    getArea: function getArea() {
	      return this.$refs.area ? this.$refs.area.getValues() : [];
	    },
	    // set area code to area component
	    setAreaCode: function setAreaCode(code) {
	      this.data.areaCode = code || '';
	
	      if (code) {
	        this.$nextTick(this.assignAreaValues);
	      }
	    },
	    // @exposed-api
	    setAddressDetail: function setAddressDetail(value) {
	      this.data.addressDetail = value;
	    },
	    onDetailBlur: function onDetailBlur() {
	      var _this3 = this;
	
	      // await for click search event
	      setTimeout(function () {
	        _this3.detailFocused = false;
	      });
	    }
	  },
	  render: function render() {
	    var _this4 = this;
	
	    var h = arguments[0];
	    var data = this.data,
	        errorInfo = this.errorInfo,
	        searchResult = this.searchResult,
	        disableArea = this.disableArea;
	
	    var onFocus = function onFocus(name) {
	      return function () {
	        return _this4.onFocus(name);
	      };
	    }; // hide bottom field when use search && detail get focused
	
	
	    var hideBottomFields = searchResult && searchResult.length && this.detailFocused;
	    return h("div", {
	      "class": bem()
	    }, [h("div", {
	      "class": bem('fields')
	    }, [h(_field.default, {
	      "attrs": {
	        "clearable": true,
	        "label": t('name'),
	        "placeholder": t('namePlaceholder'),
	        "errorMessage": errorInfo.name
	      },
	      "on": {
	        "focus": onFocus('name')
	      },
	      "model": {
	        value: data.name,
	        callback: function callback($$v) {
	          _this4.$set(data, "name", $$v);
	        }
	      }
	    }), h(_field.default, {
	      "attrs": {
	        "clearable": true,
	        "type": "tel",
	        "label": t('tel'),
	        "placeholder": t('telPlaceholder'),
	        "errorMessage": errorInfo.tel
	      },
	      "on": {
	        "focus": onFocus('tel')
	      },
	      "model": {
	        value: data.tel,
	        callback: function callback($$v) {
	          _this4.$set(data, "tel", $$v);
	        }
	      }
	    }), h(_field.default, {
	      "directives": [{
	        name: "show",
	        value: this.showArea
	      }],
	      "attrs": {
	        "readonly": true,
	        "clickable": !disableArea,
	        "label": t('area'),
	        "placeholder": t('areaPlaceholder'),
	        "errorMessage": errorInfo.areaCode,
	        "rightIcon": !disableArea ? 'arrow' : null,
	        "value": this.areaText
	      },
	      "on": {
	        "focus": onFocus('areaCode'),
	        "click": function click() {
	          _this4.showAreaPopup = !disableArea;
	        }
	      }
	    }), h(_Detail.default, {
	      "directives": [{
	        name: "show",
	        value: this.showDetail
	      }],
	      "attrs": {
	        "focused": this.detailFocused,
	        "value": data.addressDetail,
	        "errorMessage": errorInfo.addressDetail,
	        "detailRows": this.detailRows,
	        "detailMaxlength": this.detailMaxlength,
	        "searchResult": this.searchResult,
	        "showSearchResult": this.showSearchResult
	      },
	      "on": {
	        "focus": onFocus('addressDetail'),
	        "blur": this.onDetailBlur,
	        "input": this.onChangeDetail,
	        "select-search": function selectSearch(event) {
	          _this4.$emit('select-search', event);
	        }
	      }
	    }), this.showPostal && h(_field.default, {
	      "directives": [{
	        name: "show",
	        value: !hideBottomFields
	      }],
	      "attrs": {
	        "type": "tel",
	        "maxlength": "6",
	        "label": t('postal'),
	        "placeholder": t('postal'),
	        "errorMessage": errorInfo.postalCode
	      },
	      "on": {
	        "focus": onFocus('postalCode')
	      },
	      "model": {
	        value: data.postalCode,
	        callback: function callback($$v) {
	          _this4.$set(data, "postalCode", $$v);
	        }
	      }
	    }), this.slots()]), this.showSetDefault && h(_switchCell.default, {
	      "class": bem('default'),
	      "directives": [{
	        name: "show",
	        value: !hideBottomFields
	      }],
	      "attrs": {
	        "title": t('defaultAddress')
	      },
	      "on": {
	        "change": function change(event) {
	          _this4.$emit('change-default', event);
	        }
	      },
	      "model": {
	        value: data.isDefault,
	        callback: function callback($$v) {
	          _this4.$set(data, "isDefault", $$v);
	        }
	      }
	    }), h("div", {
	      "directives": [{
	        name: "show",
	        value: !hideBottomFields
	      }],
	      "class": bem('buttons')
	    }, [h(_button.default, {
	      "attrs": {
	        "block": true,
	        "round": true,
	        "loading": this.isSaving,
	        "type": "danger",
	        "text": this.saveButtonText || t('save')
	      },
	      "on": {
	        "click": this.onSave
	      }
	    }), this.showDelete && h(_button.default, {
	      "attrs": {
	        "block": true,
	        "round": true,
	        "loading": this.isDeleting,
	        "text": this.deleteButtonText || t('delete')
	      },
	      "on": {
	        "click": this.onDelete
	      }
	    })]), h(_popup.default, {
	      "attrs": {
	        "position": "bottom",
	        "lazyRender": false,
	        "getContainer": "body"
	      },
	      "model": {
	        value: _this4.showAreaPopup,
	        callback: function callback($$v) {
	          _this4.showAreaPopup = $$v;
	        }
	      }
	    }, [h(_area.default, {
	      "ref": "area",
	      "attrs": {
	        "loading": !this.areaListLoaded,
	        "value": data.areaCode,
	        "areaList": this.areaList,
	        "columnsPlaceholder": this.areaColumnsPlaceholder
	      },
	      "on": {
	        "confirm": this.onAreaConfirm,
	        "cancel": function cancel() {
	          _this4.showAreaPopup = false;
	        }
	      }
	    })])]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _tag = _interopRequireDefault(__webpack_require__(63));
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _cell = _interopRequireDefault(__webpack_require__(15));
	
	var _radio = _interopRequireDefault(__webpack_require__(99));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('address-item'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function AddressItem(h, props, slots, ctx) {
	  var disabled = props.disabled,
	      switchable = props.switchable;
	
	  function onClick() {
	    if (switchable) {
	      (0, _functional.emit)(ctx, 'select');
	    }
	
	    (0, _functional.emit)(ctx, 'click');
	  }
	
	  var genRightIcon = function genRightIcon() {
	    return h(_icon.default, {
	      "attrs": {
	        "name": "edit"
	      },
	      "class": bem('edit'),
	      "on": {
	        "click": function click(event) {
	          event.stopPropagation();
	          (0, _functional.emit)(ctx, 'edit');
	          (0, _functional.emit)(ctx, 'click');
	        }
	      }
	    });
	  };
	
	  function genTag() {
	    if (props.data.isDefault && props.defaultTagText) {
	      return h(_tag.default, {
	        "attrs": {
	          "type": "danger",
	          "round": true
	        },
	        "class": bem('tag')
	      }, [props.defaultTagText]);
	    }
	  }
	
	  function genContent() {
	    var data = props.data;
	    var Info = [h("div", {
	      "class": bem('name')
	    }, [data.name + " " + data.tel, genTag()]), h("div", {
	      "class": bem('address')
	    }, [data.address])];
	
	    if (switchable && !disabled) {
	      return h(_radio.default, {
	        "attrs": {
	          "name": data.id,
	          "iconSize": 18
	        }
	      }, [Info]);
	    }
	
	    return Info;
	  }
	
	  return h("div", {
	    "class": bem({
	      disabled: disabled
	    }),
	    "on": {
	      "click": onClick
	    }
	  }, [h(_cell.default, (0, _babelHelperVueJsxMergeProps.default)([{
	    "attrs": {
	      "border": false,
	      "valueClass": bem('value')
	    },
	    "scopedSlots": {
	      default: genContent,
	      'right-icon': genRightIcon
	    }
	  }, (0, _functional.inherit)(ctx)])), slots.bottom == null ? void 0 : slots.bottom((0, _extends2.default)({}, props.data, {
	    disabled: disabled
	  }))]);
	}
	
	AddressItem.props = {
	  data: Object,
	  disabled: Boolean,
	  switchable: Boolean,
	  defaultTagText: String
	};
	
	var _default = createComponent(AddressItem);
	
	exports.default = _default;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _button = _interopRequireDefault(__webpack_require__(17));
	
	var _radioGroup = _interopRequireDefault(__webpack_require__(98));
	
	var _Item = _interopRequireDefault(__webpack_require__(315));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('address-list'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	function AddressList(h, props, slots, ctx) {
	  function genList(list, disabled) {
	    if (!list) {
	      return;
	    }
	
	    return list.map(function (item, index) {
	      return h(_Item.default, {
	        "attrs": {
	          "data": item,
	          "disabled": disabled,
	          "switchable": props.switchable,
	          "defaultTagText": props.defaultTagText
	        },
	        "key": item.id,
	        "scopedSlots": {
	          bottom: slots['item-bottom']
	        },
	        "on": {
	          "select": function select() {
	            (0, _functional.emit)(ctx, disabled ? 'select-disabled' : 'select', item, index);
	
	            if (!disabled) {
	              (0, _functional.emit)(ctx, 'input', item.id);
	            }
	          },
	          "edit": function edit() {
	            (0, _functional.emit)(ctx, disabled ? 'edit-disabled' : 'edit', item, index);
	          },
	          "click": function click() {
	            (0, _functional.emit)(ctx, 'click-item', item, index);
	          }
	        }
	      });
	    });
	  }
	
	  var List = genList(props.list);
	  var DisabledList = genList(props.disabledList, true);
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem()
	  }, (0, _functional.inherit)(ctx)]), [slots.top == null ? void 0 : slots.top(), h(_radioGroup.default, {
	    "attrs": {
	      "value": props.value
	    }
	  }, [List]), props.disabledText && h("div", {
	    "class": bem('disabled-text')
	  }, [props.disabledText]), DisabledList, slots.default == null ? void 0 : slots.default(), h("div", {
	    "class": bem('bottom')
	  }, [h(_button.default, {
	    "attrs": {
	      "round": true,
	      "block": true,
	      "type": "danger",
	      "text": props.addButtonText || t('add')
	    },
	    "class": bem('add'),
	    "on": {
	      "click": function click() {
	        (0, _functional.emit)(ctx, 'add');
	      }
	    }
	  })])]);
	}
	
	AddressList.props = {
	  list: Array,
	  value: [Number, String],
	  disabledList: Array,
	  disabledText: String,
	  addButtonText: String,
	  defaultTagText: String,
	  switchable: {
	    type: Boolean,
	    default: true
	  }
	};
	
	var _default = createComponent(AddressList);
	
	exports.default = _default;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _utils2 = __webpack_require__(90);
	
	var _createNamespace = (0, _utils.createNamespace)('calendar-header'),
	    createComponent = _createNamespace[0];
	
	var _default = createComponent({
	  props: {
	    title: String,
	    subtitle: String,
	    showTitle: Boolean,
	    showSubtitle: Boolean
	  },
	  methods: {
	    genTitle: function genTitle() {
	      var h = this.$createElement;
	
	      if (this.showTitle) {
	        var title = this.slots('title') || this.title || (0, _utils2.t)('title');
	        return h("div", {
	          "class": (0, _utils2.bem)('header-title')
	        }, [title]);
	      }
	    },
	    genSubtitle: function genSubtitle() {
	      var h = this.$createElement;
	
	      if (this.showSubtitle) {
	        return h("div", {
	          "class": (0, _utils2.bem)('header-subtitle')
	        }, [this.subtitle]);
	      }
	    },
	    genWeekDays: function genWeekDays() {
	      var h = this.$createElement;
	      var weekdays = (0, _utils2.t)('weekdays');
	      return h("div", {
	        "class": (0, _utils2.bem)('weekdays')
	      }, [weekdays.map(function (item) {
	        return h("span", {
	          "class": (0, _utils2.bem)('weekday')
	        }, [item]);
	      })]);
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "class": (0, _utils2.bem)('header')
	    }, [this.genTitle(), this.genSubtitle(), this.genWeekDays()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _utils2 = __webpack_require__(90);
	
	var _utils3 = __webpack_require__(93);
	
	var _createNamespace = (0, _utils.createNamespace)('calendar-month'),
	    createComponent = _createNamespace[0];
	
	var _default = createComponent({
	  props: {
	    date: Date,
	    type: String,
	    color: String,
	    minDate: Date,
	    maxDate: Date,
	    showMark: Boolean,
	    rowHeight: [Number, String],
	    formatter: Function,
	    currentDate: [Date, Array],
	    showSubtitle: Boolean,
	    showMonthTitle: Boolean
	  },
	  data: function data() {
	    return {
	      visible: false
	    };
	  },
	  computed: {
	    title: function title() {
	      return (0, _utils2.formatMonthTitle)(this.date);
	    },
	    offset: function offset() {
	      return this.date.getDay();
	    },
	    totalDay: function totalDay() {
	      return (0, _utils3.getMonthEndDay)(this.date.getFullYear(), this.date.getMonth() + 1);
	    },
	    monthStyle: function monthStyle() {
	      if (!this.visible) {
	        var padding = Math.ceil((this.totalDay + this.offset) / 7) * this.rowHeight;
	        return {
	          paddingBottom: padding + "px"
	        };
	      }
	    },
	    days: function days() {
	      var days = [];
	      var year = this.date.getFullYear();
	      var month = this.date.getMonth();
	
	      for (var day = 1; day <= this.totalDay; day++) {
	        var date = new Date(year, month, day);
	        var type = this.getDayType(date);
	        var config = {
	          date: date,
	          type: type,
	          text: day,
	          bottomInfo: this.getBottomInfo(type)
	        };
	
	        if (this.formatter) {
	          config = this.formatter(config);
	        }
	
	        days.push(config);
	      }
	
	      return days;
	    }
	  },
	  mounted: function mounted() {
	    this.height = this.$el.getBoundingClientRect().height;
	  },
	  methods: {
	    scrollIntoView: function scrollIntoView() {
	      if (this.showSubtitle) {
	        this.$refs.days.scrollIntoView();
	      } else {
	        this.$refs.month.scrollIntoView();
	      }
	    },
	    getMultipleDayType: function getMultipleDayType(day) {
	      var _this = this;
	
	      var isSelected = function isSelected(date) {
	        return _this.currentDate.some(function (item) {
	          return (0, _utils2.compareDay)(item, date) === 0;
	        });
	      };
	
	      if (isSelected(day)) {
	        var prevDay = (0, _utils2.getPrevDay)(day);
	        var nextDay = (0, _utils2.getNextDay)(day);
	        var prevSelected = isSelected(prevDay);
	        var nextSelected = isSelected(nextDay);
	
	        if (prevSelected && nextSelected) {
	          return 'multiple-middle';
	        }
	
	        if (prevSelected) {
	          return 'end';
	        }
	
	        return nextSelected ? 'start' : 'multiple-selected';
	      }
	
	      return '';
	    },
	    getRangeDayType: function getRangeDayType(day) {
	      var _this$currentDate = this.currentDate,
	          startDay = _this$currentDate[0],
	          endDay = _this$currentDate[1];
	
	      if (!startDay) {
	        return;
	      }
	
	      var compareToStart = (0, _utils2.compareDay)(day, startDay);
	
	      if (compareToStart === 0) {
	        return 'start';
	      }
	
	      if (!endDay) {
	        return;
	      }
	
	      var compareToEnd = (0, _utils2.compareDay)(day, endDay);
	
	      if (compareToEnd === 0) {
	        return 'end';
	      }
	
	      if (compareToStart > 0 && compareToEnd < 0) {
	        return 'middle';
	      }
	    },
	    getDayType: function getDayType(day) {
	      var type = this.type,
	          minDate = this.minDate,
	          maxDate = this.maxDate,
	          currentDate = this.currentDate;
	
	      if ((0, _utils2.compareDay)(day, minDate) < 0 || (0, _utils2.compareDay)(day, maxDate) > 0) {
	        return 'disabled';
	      }
	
	      if (type === 'single') {
	        return (0, _utils2.compareDay)(day, currentDate) === 0 ? 'selected' : '';
	      }
	
	      if (type === 'multiple') {
	        return this.getMultipleDayType(day);
	      }
	      /* istanbul ignore else */
	
	
	      if (type === 'range') {
	        return this.getRangeDayType(day);
	      }
	    },
	    getBottomInfo: function getBottomInfo(type) {
	      if (this.type === 'range') {
	        if (type === 'start') {
	          return (0, _utils2.t)('start');
	        }
	
	        if (type === 'end') {
	          return (0, _utils2.t)('end');
	        }
	      }
	    },
	    getDayStyle: function getDayStyle(type, index) {
	      var style = {};
	
	      if (index === 0) {
	        style.marginLeft = 100 * this.offset / 7 + "%";
	      }
	
	      if (this.rowHeight !== _utils2.ROW_HEIGHT) {
	        style.height = this.rowHeight + "px";
	      }
	
	      if (this.color) {
	        if (type === 'start' || type === 'end' || type === 'multiple-selected' || type === 'multiple-middle') {
	          style.background = this.color;
	        } else if (type === 'middle') {
	          style.color = this.color;
	        }
	      }
	
	      return style;
	    },
	    genTitle: function genTitle() {
	      var h = this.$createElement;
	
	      if (this.showMonthTitle) {
	        return h("div", {
	          "class": (0, _utils2.bem)('month-title')
	        }, [this.title]);
	      }
	    },
	    genMark: function genMark() {
	      var h = this.$createElement;
	
	      if (this.showMark) {
	        return h("div", {
	          "class": (0, _utils2.bem)('month-mark')
	        }, [this.date.getMonth() + 1]);
	      }
	    },
	    genDays: function genDays() {
	      var h = this.$createElement;
	
	      if (this.visible) {
	        return h("div", {
	          "ref": "days",
	          "attrs": {
	            "role": "grid"
	          },
	          "class": (0, _utils2.bem)('days')
	        }, [this.genMark(), this.days.map(this.genDay)]);
	      }
	
	      return h("div", {
	        "ref": "days"
	      });
	    },
	    genDay: function genDay(item, index) {
	      var _this2 = this;
	
	      var h = this.$createElement;
	      var type = item.type,
	          topInfo = item.topInfo,
	          bottomInfo = item.bottomInfo;
	      var style = this.getDayStyle(type, index);
	      var disabled = type === 'disabled';
	
	      var onClick = function onClick() {
	        if (!disabled) {
	          _this2.$emit('click', item);
	        }
	      };
	
	      var TopInfo = topInfo && h("div", {
	        "class": (0, _utils2.bem)('top-info')
	      }, [topInfo]);
	      var BottomInfo = bottomInfo && h("div", {
	        "class": (0, _utils2.bem)('bottom-info')
	      }, [bottomInfo]);
	
	      if (type === 'selected') {
	        return h("div", {
	          "attrs": {
	            "role": "gridcell",
	            "tabindex": disabled ? null : -1
	          },
	          "style": style,
	          "class": [(0, _utils2.bem)('day'), item.className],
	          "on": {
	            "click": onClick
	          }
	        }, [h("div", {
	          "class": (0, _utils2.bem)('selected-day'),
	          "style": {
	            background: this.color
	          }
	        }, [TopInfo, item.text, BottomInfo])]);
	      }
	
	      return h("div", {
	        "attrs": {
	          "role": "gridcell",
	          "tabindex": disabled ? null : -1
	        },
	        "style": style,
	        "class": [(0, _utils2.bem)('day', type), item.className],
	        "on": {
	          "click": onClick
	        }
	      }, [TopInfo, item.text, BottomInfo]);
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "class": (0, _utils2.bem)('month'),
	      "ref": "month",
	      "style": this.monthStyle
	    }, [this.genTitle(), this.genDays()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _date = __webpack_require__(173);
	
	var _scroll = __webpack_require__(22);
	
	var _utils = __webpack_require__(90);
	
	var _popup = _interopRequireDefault(__webpack_require__(37));
	
	var _button = _interopRequireDefault(__webpack_require__(17));
	
	var _toast = _interopRequireDefault(__webpack_require__(64));
	
	var _Month = _interopRequireDefault(__webpack_require__(318));
	
	var _Header = _interopRequireDefault(__webpack_require__(317));
	
	// Utils
	// Components
	var _default2 = (0, _utils.createComponent)({
	  props: {
	    title: String,
	    color: String,
	    value: Boolean,
	    formatter: Function,
	    confirmText: String,
	    rangePrompt: String,
	    defaultDate: [Date, Array],
	    getContainer: [String, Function],
	    closeOnPopstate: Boolean,
	    confirmDisabledText: String,
	    type: {
	      type: String,
	      default: 'single'
	    },
	    minDate: {
	      type: Date,
	      validator: _date.isDate,
	      default: function _default() {
	        return new Date();
	      }
	    },
	    maxDate: {
	      type: Date,
	      validator: _date.isDate,
	      default: function _default() {
	        var now = new Date();
	        return new Date(now.getFullYear(), now.getMonth() + 6, now.getDate());
	      }
	    },
	    position: {
	      type: String,
	      default: 'bottom'
	    },
	    rowHeight: {
	      type: [Number, String],
	      default: _utils.ROW_HEIGHT
	    },
	    round: {
	      type: Boolean,
	      default: true
	    },
	    poppable: {
	      type: Boolean,
	      default: true
	    },
	    showMark: {
	      type: Boolean,
	      default: true
	    },
	    showTitle: {
	      type: Boolean,
	      default: true
	    },
	    showConfirm: {
	      type: Boolean,
	      default: true
	    },
	    showSubtitle: {
	      type: Boolean,
	      default: true
	    },
	    safeAreaInsetBottom: {
	      type: Boolean,
	      default: true
	    },
	    closeOnClickOverlay: {
	      type: Boolean,
	      default: true
	    },
	    maxRange: {
	      type: [Number, String],
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      subtitle: '',
	      currentDate: this.getInitialDate()
	    };
	  },
	  computed: {
	    months: function months() {
	      var months = [];
	      var cursor = new Date(this.minDate);
	      cursor.setDate(1);
	
	      do {
	        months.push(new Date(cursor));
	        cursor.setMonth(cursor.getMonth() + 1);
	      } while ((0, _utils.compareMonth)(cursor, this.maxDate) !== 1);
	
	      return months;
	    },
	    buttonDisabled: function buttonDisabled() {
	      var type = this.type,
	          currentDate = this.currentDate;
	
	      if (type === 'range') {
	        return !currentDate[0] || !currentDate[1];
	      }
	
	      if (type === 'multiple') {
	        return !currentDate.length;
	      }
	
	      return !currentDate;
	    }
	  },
	  watch: {
	    type: 'reset',
	    value: function value(val) {
	      if (val) {
	        this.initRect();
	        this.scrollIntoView();
	      }
	    },
	    defaultDate: function defaultDate(val) {
	      this.currentDate = val;
	      this.scrollIntoView();
	    }
	  },
	  mounted: function mounted() {
	    if (this.value || !this.poppable) {
	      this.initRect();
	      this.scrollIntoView();
	    }
	  },
	  methods: {
	    // @exposed-api
	    reset: function reset() {
	      this.currentDate = this.getInitialDate();
	      this.scrollIntoView();
	    },
	    initRect: function initRect() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        // add Math.floor to avoid decimal height issues
	        // https://github.com/youzan/vant/issues/5640
	        _this.bodyHeight = Math.floor(_this.$refs.body.getBoundingClientRect().height);
	
	        _this.onScroll();
	      });
	    },
	    // scroll to current month
	    scrollIntoView: function scrollIntoView() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        var currentDate = _this2.currentDate;
	        var targetDate = _this2.type === 'single' ? currentDate : currentDate[0];
	        var displayed = _this2.value || !_this2.poppable;
	        /* istanbul ignore if */
	
	        if (!targetDate || !displayed) {
	          return;
	        }
	
	        _this2.months.some(function (month, index) {
	          if ((0, _utils.compareMonth)(month, targetDate) === 0) {
	            _this2.$refs.months[index].scrollIntoView();
	
	            return true;
	          }
	
	          return false;
	        });
	      });
	    },
	    getInitialDate: function getInitialDate() {
	      var type = this.type,
	          defaultDate = this.defaultDate,
	          minDate = this.minDate;
	
	      if (type === 'range') {
	        var _ref = defaultDate || [],
	            startDay = _ref[0],
	            endDay = _ref[1];
	
	        return [startDay || minDate, endDay || (0, _utils.getNextDay)(minDate)];
	      }
	
	      if (type === 'multiple') {
	        return [defaultDate || minDate];
	      }
	
	      return defaultDate || minDate;
	    },
	    // calculate the position of the elements
	    // and find the elements that needs to be rendered
	    onScroll: function onScroll() {
	      var _this$$refs = this.$refs,
	          body = _this$$refs.body,
	          months = _this$$refs.months;
	      var top = (0, _scroll.getScrollTop)(body);
	      var bottom = top + this.bodyHeight;
	      var heights = months.map(function (item) {
	        return item.height;
	      });
	      var heightSum = heights.reduce(function (a, b) {
	        return a + b;
	      }, 0); // iOS scroll bounce may exceed the range
	
	      /* istanbul ignore next */
	
	      if (top < 0 || bottom > heightSum && top > 0) {
	        return;
	      }
	
	      var height = 0;
	      var currentMonth;
	
	      for (var i = 0; i < months.length; i++) {
	        var visible = height <= bottom && height + heights[i] >= top;
	
	        if (visible && !currentMonth) {
	          currentMonth = months[i];
	        }
	
	        months[i].visible = visible;
	        height += heights[i];
	      }
	      /* istanbul ignore else */
	
	
	      if (currentMonth) {
	        this.subtitle = currentMonth.title;
	      }
	    },
	    onClickDay: function onClickDay(item) {
	      var date = item.date;
	      var type = this.type,
	          currentDate = this.currentDate;
	
	      if (type === 'range') {
	        var startDay = currentDate[0],
	            endDay = currentDate[1];
	
	        if (startDay && !endDay) {
	          var compareToStart = (0, _utils.compareDay)(date, startDay);
	
	          if (compareToStart === 1) {
	            this.select([startDay, date], true);
	          } else if (compareToStart === -1) {
	            this.select([date, null]);
	          }
	        } else {
	          this.select([date, null]);
	        }
	      } else if (type === 'multiple') {
	        var selectedIndex;
	        var selected = this.currentDate.some(function (dateItem, index) {
	          var equal = (0, _utils.compareDay)(dateItem, date) === 0;
	
	          if (equal) {
	            selectedIndex = index;
	          }
	
	          return equal;
	        });
	
	        if (selected) {
	          currentDate.splice(selectedIndex, 1);
	        } else {
	          this.select([].concat(currentDate, [date]));
	        }
	      } else {
	        this.select(date, true);
	      }
	    },
	    togglePopup: function togglePopup(val) {
	      this.$emit('input', val);
	    },
	    select: function select(date, complete) {
	      this.currentDate = date;
	      this.$emit('select', (0, _utils.copyDates)(this.currentDate));
	
	      if (complete && this.type === 'range') {
	        var valid = this.checkRange();
	
	        if (!valid) {
	          return;
	        }
	      }
	
	      if (complete && !this.showConfirm) {
	        this.onConfirm();
	      }
	    },
	    checkRange: function checkRange() {
	      var maxRange = this.maxRange,
	          currentDate = this.currentDate,
	          rangePrompt = this.rangePrompt;
	
	      if (maxRange && (0, _utils.calcDateNum)(currentDate) > maxRange) {
	        (0, _toast.default)(rangePrompt || (0, _utils.t)('rangePrompt', maxRange));
	        return false;
	      }
	
	      return true;
	    },
	    onConfirm: function onConfirm() {
	      if (this.type === 'range' && !this.checkRange()) {
	        return;
	      }
	
	      this.$emit('confirm', (0, _utils.copyDates)(this.currentDate));
	    },
	    genMonth: function genMonth(date, index) {
	      var h = this.$createElement;
	      var showMonthTitle = index !== 0 || !this.showSubtitle;
	      return h(_Month.default, {
	        "ref": "months",
	        "refInFor": true,
	        "attrs": {
	          "date": date,
	          "type": this.type,
	          "color": this.color,
	          "minDate": this.minDate,
	          "maxDate": this.maxDate,
	          "showMark": this.showMark,
	          "formatter": this.formatter,
	          "rowHeight": this.rowHeight,
	          "currentDate": this.currentDate,
	          "showSubtitle": this.showSubtitle,
	          "showMonthTitle": showMonthTitle
	        },
	        "on": {
	          "click": this.onClickDay
	        }
	      });
	    },
	    genFooterContent: function genFooterContent() {
	      var h = this.$createElement;
	      var slot = this.slots('footer');
	
	      if (slot) {
	        return slot;
	      }
	
	      if (this.showConfirm) {
	        var text = this.buttonDisabled ? this.confirmDisabledText : this.confirmText;
	        return h(_button.default, {
	          "attrs": {
	            "round": true,
	            "block": true,
	            "type": "danger",
	            "color": this.color,
	            "disabled": this.buttonDisabled,
	            "nativeType": "text"
	          },
	          "class": (0, _utils.bem)('confirm'),
	          "on": {
	            "click": this.onConfirm
	          }
	        }, [text || (0, _utils.t)('confirm')]);
	      }
	    },
	    genFooter: function genFooter() {
	      var h = this.$createElement;
	      return h("div", {
	        "class": (0, _utils.bem)('footer', {
	          'safe-area-inset-bottom': this.safeAreaInsetBottom
	        })
	      }, [this.genFooterContent()]);
	    },
	    genCalendar: function genCalendar() {
	      var _this3 = this;
	
	      var h = this.$createElement;
	      return h("div", {
	        "class": (0, _utils.bem)()
	      }, [h(_Header.default, {
	        "attrs": {
	          "title": this.title,
	          "showTitle": this.showTitle,
	          "subtitle": this.subtitle,
	          "showSubtitle": this.showSubtitle
	        },
	        "scopedSlots": {
	          title: function title() {
	            return _this3.slots('title');
	          }
	        }
	      }), h("div", {
	        "ref": "body",
	        "class": (0, _utils.bem)('body'),
	        "on": {
	          "scroll": this.onScroll
	        }
	      }, [this.months.map(this.genMonth)]), this.genFooter()]);
	    }
	  },
	  render: function render() {
	    var _this4 = this;
	
	    var h = arguments[0];
	
	    if (this.poppable) {
	      var _attrs;
	
	      var createListener = function createListener(name) {
	        return function () {
	          return _this4.$emit(name);
	        };
	      };
	
	      return h(_popup.default, {
	        "attrs": (_attrs = {
	          "round": true,
	          "value": this.value
	        }, _attrs["round"] = this.round, _attrs["position"] = this.position, _attrs["closeable"] = this.showTitle || this.showSubtitle, _attrs["getContainer"] = this.getContainer, _attrs["closeOnPopstate"] = this.closeOnPopstate, _attrs["closeOnClickOverlay"] = this.closeOnClickOverlay, _attrs),
	        "class": (0, _utils.bem)('popup'),
	        "on": {
	          "input": this.togglePopup,
	          "open": createListener('open'),
	          "opened": createListener('opened'),
	          "close": createListener('close'),
	          "closed": createListener('closed')
	        }
	      }, [this.genCalendar()]);
	    }
	
	    return this.genCalendar();
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _tag = _interopRequireDefault(__webpack_require__(63));
	
	var _image = _interopRequireDefault(__webpack_require__(60));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('card'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function Card(h, props, slots, ctx) {
	  var thumb = props.thumb;
	  var showNum = slots.num || (0, _utils.isDef)(props.num);
	  var showPrice = slots.price || (0, _utils.isDef)(props.price);
	  var showOriginPrice = slots['origin-price'] || (0, _utils.isDef)(props.originPrice);
	  var showBottom = showNum || showPrice || showOriginPrice || slots.bottom;
	
	  function onThumbClick(event) {
	    (0, _functional.emit)(ctx, 'click-thumb', event);
	  }
	
	  function ThumbTag() {
	    if (slots.tag || props.tag) {
	      return h("div", {
	        "class": bem('tag')
	      }, [slots.tag ? slots.tag() : h(_tag.default, {
	        "attrs": {
	          "mark": true,
	          "type": "danger"
	        }
	      }, [props.tag])]);
	    }
	  }
	
	  function Thumb() {
	    if (slots.thumb || thumb) {
	      return h("a", {
	        "attrs": {
	          "href": props.thumbLink
	        },
	        "class": bem('thumb'),
	        "on": {
	          "click": onThumbClick
	        }
	      }, [slots.thumb ? slots.thumb() : h(_image.default, {
	        "attrs": {
	          "src": thumb,
	          "width": "100%",
	          "height": "100%",
	          "fit": "cover",
	          "lazy-load": props.lazyLoad
	        }
	      }), ThumbTag()]);
	    }
	  }
	
	  function Title() {
	    if (slots.title) {
	      return slots.title();
	    }
	
	    if (props.title) {
	      return h("div", {
	        "class": [bem('title'), 'van-multi-ellipsis--l2']
	      }, [props.title]);
	    }
	  }
	
	  function Desc() {
	    if (slots.desc) {
	      return slots.desc();
	    }
	
	    if (props.desc) {
	      return h("div", {
	        "class": [bem('desc'), 'van-ellipsis']
	      }, [props.desc]);
	    }
	  }
	
	  function PriceContent() {
	    var priceArr = props.price.toString().split('.');
	    return h("div", [h("span", {
	      "class": bem('price-currency')
	    }, [props.currency]), h("span", {
	      "class": bem('price-integer')
	    }, [priceArr[0]]), ".", h("span", {
	      "class": bem('price-decimal')
	    }, [priceArr[1]])]);
	  }
	
	  function Price() {
	    if (showPrice) {
	      return h("div", {
	        "class": bem('price')
	      }, [slots.price ? slots.price() : PriceContent()]);
	    }
	  }
	
	  function OriginPrice() {
	    if (showOriginPrice) {
	      var slot = slots['origin-price'];
	      return h("div", {
	        "class": bem('origin-price')
	      }, [slot ? slot() : props.currency + " " + props.originPrice]);
	    }
	  }
	
	  function Num() {
	    if (showNum) {
	      return h("div", {
	        "class": bem('num')
	      }, [slots.num ? slots.num() : "x" + props.num]);
	    }
	  }
	
	  function Footer() {
	    if (slots.footer) {
	      return h("div", {
	        "class": bem('footer')
	      }, [slots.footer()]);
	    }
	  }
	
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem()
	  }, (0, _functional.inherit)(ctx, true)]), [h("div", {
	    "class": bem('header')
	  }, [Thumb(), h("div", {
	    "class": bem('content', {
	      centered: props.centered
	    })
	  }, [h("div", [Title(), Desc(), slots.tags == null ? void 0 : slots.tags()]), showBottom && h("div", {
	    "class": "van-card__bottom"
	  }, [slots['price-top'] == null ? void 0 : slots['price-top'](), Price(), OriginPrice(), Num(), slots.bottom == null ? void 0 : slots.bottom()])])]), Footer()]);
	}
	
	Card.props = {
	  tag: String,
	  desc: String,
	  thumb: String,
	  title: String,
	  centered: Boolean,
	  lazyLoad: Boolean,
	  thumbLink: String,
	  num: [Number, String],
	  price: [Number, String],
	  originPrice: [Number, String],
	  currency: {
	    type: String,
	    default: '¥'
	  }
	};
	
	var _default = createComponent(Card);
	
	exports.default = _default;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _field = __webpack_require__(27);
	
	var _relation = __webpack_require__(9);
	
	var _createNamespace = (0, _utils.createNamespace)('checkbox-group'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default2 = createComponent({
	  mixins: [(0, _relation.ParentMixin)('vanCheckbox'), _field.FieldMixin],
	  props: {
	    max: [Number, String],
	    disabled: Boolean,
	    direction: String,
	    iconSize: [Number, String],
	    checkedColor: String,
	    value: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  watch: {
	    value: function value(val) {
	      this.$emit('change', val);
	    }
	  },
	  methods: {
	    // @exposed-api
	    toggleAll: function toggleAll(checked) {
	      if (checked === false) {
	        this.$emit('input', []);
	        return;
	      }
	
	      var children = this.children;
	
	      if (!checked) {
	        children = children.filter(function (item) {
	          return !item.checked;
	        });
	      }
	
	      var names = children.map(function (item) {
	        return item.name;
	      });
	      this.$emit('input', names);
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "class": bem([this.direction])
	    }, [this.slots()]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _raf = __webpack_require__(45);
	
	var _constant = __webpack_require__(7);
	
	var _createNamespace = (0, _utils.createNamespace)('circle'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var PERIMETER = 3140;
	var uid = 0;
	
	function format(rate) {
	  return Math.min(Math.max(rate, 0), 100);
	}
	
	function getPath(clockwise, viewBoxSize) {
	  var sweepFlag = clockwise ? 1 : 0;
	  return "M " + viewBoxSize / 2 + " " + viewBoxSize / 2 + " m 0, -500 a 500, 500 0 1, " + sweepFlag + " 0, 1000 a 500, 500 0 1, " + sweepFlag + " 0, -1000";
	}
	
	var _default = createComponent({
	  props: {
	    text: String,
	    strokeLinecap: String,
	    value: {
	      type: Number,
	      default: 0
	    },
	    speed: {
	      type: [Number, String],
	      default: 0
	    },
	    size: {
	      type: [Number, String],
	      default: 100
	    },
	    fill: {
	      type: String,
	      default: 'none'
	    },
	    rate: {
	      type: [Number, String],
	      default: 100
	    },
	    layerColor: {
	      type: String,
	      default: _constant.WHITE
	    },
	    color: {
	      type: [String, Object],
	      default: _constant.BLUE
	    },
	    strokeWidth: {
	      type: [Number, String],
	      default: 40
	    },
	    clockwise: {
	      type: Boolean,
	      default: true
	    }
	  },
	  beforeCreate: function beforeCreate() {
	    this.uid = "van-circle-gradient-" + uid++;
	  },
	  computed: {
	    style: function style() {
	      var size = (0, _utils.addUnit)(this.size);
	      return {
	        width: size,
	        height: size
	      };
	    },
	    path: function path() {
	      return getPath(this.clockwise, this.viewBoxSize);
	    },
	    viewBoxSize: function viewBoxSize() {
	      return +this.strokeWidth + 1000;
	    },
	    layerStyle: function layerStyle() {
	      var offset = PERIMETER * this.value / 100;
	      return {
	        stroke: "" + this.color,
	        strokeWidth: +this.strokeWidth + 1 + "px",
	        strokeLinecap: this.strokeLinecap,
	        strokeDasharray: offset + "px " + PERIMETER + "px"
	      };
	    },
	    hoverStyle: function hoverStyle() {
	      return {
	        fill: "" + this.fill,
	        stroke: "" + this.layerColor,
	        strokeWidth: this.strokeWidth + "px"
	      };
	    },
	    gradient: function gradient() {
	      return (0, _utils.isObject)(this.color);
	    },
	    LinearGradient: function LinearGradient() {
	      var _this = this;
	
	      var h = this.$createElement;
	
	      if (!this.gradient) {
	        return;
	      }
	
	      var Stops = Object.keys(this.color).sort(function (a, b) {
	        return parseFloat(a) - parseFloat(b);
	      }).map(function (key, index) {
	        return h("stop", {
	          "key": index,
	          "attrs": {
	            "offset": key,
	            "stop-color": _this.color[key]
	          }
	        });
	      });
	      return h("defs", [h("linearGradient", {
	        "attrs": {
	          "id": this.uid,
	          "x1": "100%",
	          "y1": "0%",
	          "x2": "0%",
	          "y2": "0%"
	        }
	      }, [Stops])]);
	    }
	  },
	  watch: {
	    rate: {
	      handler: function handler(rate) {
	        this.startTime = Date.now();
	        this.startRate = this.value;
	        this.endRate = format(rate);
	        this.increase = this.endRate > this.startRate;
	        this.duration = Math.abs((this.startRate - this.endRate) * 1000 / this.speed);
	
	        if (this.speed) {
	          (0, _raf.cancelRaf)(this.rafId);
	          this.rafId = (0, _raf.raf)(this.animate);
	        } else {
	          this.$emit('input', this.endRate);
	        }
	      },
	      immediate: true
	    }
	  },
	  methods: {
	    animate: function animate() {
	      var now = Date.now();
	      var progress = Math.min((now - this.startTime) / this.duration, 1);
	      var rate = progress * (this.endRate - this.startRate) + this.startRate;
	      this.$emit('input', format(parseFloat(rate.toFixed(1))));
	
	      if (this.increase ? rate < this.endRate : rate > this.endRate) {
	        this.rafId = (0, _raf.raf)(this.animate);
	      }
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "class": bem(),
	      "style": this.style
	    }, [h("svg", {
	      "attrs": {
	        "viewBox": "0 0 " + this.viewBoxSize + " " + this.viewBoxSize
	      }
	    }, [this.LinearGradient, h("path", {
	      "class": bem('hover'),
	      "style": this.hoverStyle,
	      "attrs": {
	        "d": this.path
	      }
	    }), h("path", {
	      "attrs": {
	        "d": this.path,
	        "stroke": this.gradient ? "url(#" + this.uid + ")" : this.color
	      },
	      "class": bem('layer'),
	      "style": this.layerStyle
	    })]), this.slots() || this.text && h("div", {
	      "class": bem('text')
	    }, [this.text])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _createNamespace = (0, _utils.createNamespace)('col'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  props: {
	    span: [Number, String],
	    offset: [Number, String],
	    tag: {
	      type: String,
	      default: 'div'
	    }
	  },
	  computed: {
	    gutter: function gutter() {
	      return this.$parent && Number(this.$parent.gutter) || 0;
	    },
	    style: function style() {
	      var padding = this.gutter / 2 + "px";
	      return this.gutter ? {
	        paddingLeft: padding,
	        paddingRight: padding
	      } : {};
	    }
	  },
	  methods: {
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	    }
	  },
	  render: function render() {
	    var _bem;
	
	    var h = arguments[0];
	    var span = this.span,
	        offset = this.offset;
	    return h(this.tag, {
	      "style": this.style,
	      "class": bem((_bem = {}, _bem[span] = span, _bem["offset-" + offset] = offset, _bem)),
	      "on": {
	        "click": this.onClick
	      }
	    }, [this.slots()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _constant = __webpack_require__(7);
	
	var _raf = __webpack_require__(45);
	
	var _relation = __webpack_require__(9);
	
	var _cell = _interopRequireDefault(__webpack_require__(15));
	
	var _shared = __webpack_require__(92);
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('collapse-item'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var CELL_SLOTS = ['title', 'icon', 'right-icon'];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ChildrenMixin)('vanCollapse')],
	  props: (0, _extends2.default)({}, _shared.cellProps, {
	    name: [Number, String],
	    disabled: Boolean,
	    isLink: {
	      type: Boolean,
	      default: true
	    }
	  }),
	  data: function data() {
	    return {
	      show: null,
	      inited: null
	    };
	  },
	  computed: {
	    currentName: function currentName() {
	      return (0, _utils.isDef)(this.name) ? this.name : this.index;
	    },
	    expanded: function expanded() {
	      var _this = this;
	
	      if (!this.parent) {
	        return null;
	      }
	
	      var _this$parent = this.parent,
	          value = _this$parent.value,
	          accordion = _this$parent.accordion;
	
	      if (false) {
	        console.error('[Vant] Collapse: type of prop "value" should be Array');
	        return;
	      }
	
	      return accordion ? value === this.currentName : value.some(function (name) {
	        return name === _this.currentName;
	      });
	    }
	  },
	  created: function created() {
	    this.show = this.expanded;
	    this.inited = this.expanded;
	  },
	  watch: {
	    expanded: function expanded(_expanded, prev) {
	      var _this2 = this;
	
	      if (prev === null) {
	        return;
	      }
	
	      if (_expanded) {
	        this.show = true;
	        this.inited = true;
	      } // Use raf: flick when opened in safari
	      // Use nextTick: closing animation failed when set `user-select: none`
	
	
	      var nextTick = _expanded ? this.$nextTick : _raf.raf;
	      nextTick(function () {
	        var _this2$$refs = _this2.$refs,
	            content = _this2$$refs.content,
	            wrapper = _this2$$refs.wrapper;
	
	        if (!content || !wrapper) {
	          return;
	        }
	
	        var offsetHeight = content.offsetHeight;
	
	        if (offsetHeight) {
	          var contentHeight = offsetHeight + "px";
	          wrapper.style.height = _expanded ? 0 : contentHeight; // use double raf to ensure animation can start in mobile safari
	
	          (0, _raf.doubleRaf)(function () {
	            wrapper.style.height = _expanded ? contentHeight : 0;
	          });
	        } else {
	          _this2.onTransitionEnd();
	        }
	      });
	    }
	  },
	  methods: {
	    onClick: function onClick() {
	      if (this.disabled) {
	        return;
	      }
	
	      var parent = this.parent,
	          currentName = this.currentName;
	      var close = parent.accordion && currentName === parent.value;
	      var name = close ? '' : currentName;
	      parent.switch(name, !this.expanded);
	    },
	    onTransitionEnd: function onTransitionEnd() {
	      if (!this.expanded) {
	        this.show = false;
	      } else {
	        this.$refs.wrapper.style.height = '';
	      }
	    },
	    genTitle: function genTitle() {
	      var _this3 = this;
	
	      var h = this.$createElement;
	      var disabled = this.disabled,
	          expanded = this.expanded;
	      var titleSlots = CELL_SLOTS.reduce(function (slots, name) {
	        if (_this3.slots(name)) {
	          slots[name] = function () {
	            return _this3.slots(name);
	          };
	        }
	
	        return slots;
	      }, {});
	
	      if (this.slots('value')) {
	        titleSlots.default = function () {
	          return _this3.slots('value');
	        };
	      }
	
	      return h(_cell.default, {
	        "attrs": {
	          "role": "button",
	          "tabindex": disabled ? -1 : 0,
	          "aria-expanded": String(expanded)
	        },
	        "class": bem('title', {
	          disabled: disabled,
	          expanded: expanded
	        }),
	        "on": {
	          "click": this.onClick
	        },
	        "scopedSlots": titleSlots,
	        "props": (0, _extends2.default)({}, this.$props)
	      });
	    },
	    genContent: function genContent() {
	      var h = this.$createElement;
	
	      if (this.inited) {
	        return h("div", {
	          "directives": [{
	            name: "show",
	            value: this.show
	          }],
	          "ref": "wrapper",
	          "class": bem('wrapper'),
	          "on": {
	            "transitionend": this.onTransitionEnd
	          }
	        }, [h("div", {
	          "ref": "content",
	          "class": bem('content')
	        }, [this.slots()])]);
	      }
	    }
	  },
	  render: function render() {
	    var _ref;
	
	    var h = arguments[0];
	    return h("div", {
	      "class": [bem(), (_ref = {}, _ref[_constant.BORDER_TOP] = this.index, _ref)]
	    }, [this.genTitle(), this.genContent()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _relation = __webpack_require__(9);
	
	var _constant = __webpack_require__(7);
	
	var _createNamespace = (0, _utils.createNamespace)('collapse'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ParentMixin)('vanCollapse')],
	  props: {
	    accordion: Boolean,
	    value: [String, Number, Array],
	    border: {
	      type: Boolean,
	      default: true
	    }
	  },
	  methods: {
	    switch: function _switch(name, expanded) {
	      if (!this.accordion) {
	        name = expanded ? this.value.concat(name) : this.value.filter(function (activeName) {
	          return activeName !== name;
	        });
	      }
	
	      this.$emit('change', name);
	      this.$emit('input', name);
	    }
	  },
	  render: function render() {
	    var _ref;
	
	    var h = arguments[0];
	    return h("div", {
	      "class": [bem(), (_ref = {}, _ref[_constant.BORDER_TOP_BOTTOM] = this.border, _ref)]
	    }, [this.slots()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _cell = _interopRequireDefault(__webpack_require__(15));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('contact-card'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	function ContactCard(h, props, slots, ctx) {
	  var type = props.type,
	      editable = props.editable;
	
	  function onClick(event) {
	    if (editable) {
	      (0, _functional.emit)(ctx, 'click', event);
	    }
	  }
	
	  function Content() {
	    if (type === 'add') {
	      return props.addText || t('addText');
	    }
	
	    return [h("div", [t('name') + "\uFF1A" + props.name]), h("div", [t('tel') + "\uFF1A" + props.tel])];
	  }
	
	  return h(_cell.default, (0, _babelHelperVueJsxMergeProps.default)([{
	    "attrs": {
	      "center": true,
	      "border": false,
	      "isLink": editable,
	      "valueClass": bem('value'),
	      "icon": type === 'edit' ? 'contact' : 'add-square'
	    },
	    "class": bem([type]),
	    "on": {
	      "click": onClick
	    }
	  }, (0, _functional.inherit)(ctx)]), [Content()]);
	}
	
	ContactCard.props = {
	  tel: String,
	  name: String,
	  addText: String,
	  editable: {
	    type: Boolean,
	    default: true
	  },
	  type: {
	    type: String,
	    default: 'add'
	  }
	};
	
	var _default = createComponent(ContactCard);
	
	exports.default = _default;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _mobile = __webpack_require__(174);
	
	var _cell = _interopRequireDefault(__webpack_require__(15));
	
	var _field = _interopRequireDefault(__webpack_require__(34));
	
	var _button = _interopRequireDefault(__webpack_require__(17));
	
	var _dialog = _interopRequireDefault(__webpack_require__(94));
	
	var _switch = _interopRequireDefault(__webpack_require__(101));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('contact-edit'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	var defaultContact = {
	  tel: '',
	  name: ''
	};
	
	var _default2 = createComponent({
	  props: {
	    isEdit: Boolean,
	    isSaving: Boolean,
	    isDeleting: Boolean,
	    showSetDefault: Boolean,
	    setDefaultLabel: String,
	    contactInfo: {
	      type: Object,
	      default: function _default() {
	        return (0, _extends2.default)({}, defaultContact);
	      }
	    },
	    telValidator: {
	      type: Function,
	      default: _mobile.isMobile
	    }
	  },
	  data: function data() {
	    return {
	      data: (0, _extends2.default)({}, defaultContact, {}, this.contactInfo),
	      errorInfo: {
	        name: '',
	        tel: ''
	      }
	    };
	  },
	  watch: {
	    contactInfo: function contactInfo(val) {
	      this.data = (0, _extends2.default)({}, defaultContact, {}, val);
	    }
	  },
	  methods: {
	    onFocus: function onFocus(key) {
	      this.errorInfo[key] = '';
	    },
	    getErrorMessageByKey: function getErrorMessageByKey(key) {
	      var value = this.data[key].trim();
	
	      switch (key) {
	        case 'name':
	          return value ? '' : t('nameInvalid');
	
	        case 'tel':
	          return this.telValidator(value) ? '' : t('telInvalid');
	      }
	    },
	    onSave: function onSave() {
	      var _this = this;
	
	      var isValid = ['name', 'tel'].every(function (item) {
	        var msg = _this.getErrorMessageByKey(item);
	
	        if (msg) {
	          _this.errorInfo[item] = msg;
	        }
	
	        return !msg;
	      });
	
	      if (isValid && !this.isSaving) {
	        this.$emit('save', this.data);
	      }
	    },
	    onDelete: function onDelete() {
	      var _this2 = this;
	
	      _dialog.default.confirm({
	        message: t('confirmDelete')
	      }).then(function () {
	        _this2.$emit('delete', _this2.data);
	      });
	    }
	  },
	  render: function render() {
	    var _this3 = this;
	
	    var h = arguments[0];
	    var data = this.data,
	        errorInfo = this.errorInfo;
	
	    var onFocus = function onFocus(name) {
	      return function () {
	        return _this3.onFocus(name);
	      };
	    };
	
	    return h("div", {
	      "class": bem()
	    }, [h("div", {
	      "class": bem('fields')
	    }, [h(_field.default, {
	      "attrs": {
	        "clearable": true,
	        "maxlength": "30",
	        "label": t('name'),
	        "placeholder": t('nameEmpty'),
	        "errorMessage": errorInfo.name
	      },
	      "on": {
	        "focus": onFocus('name')
	      },
	      "model": {
	        value: data.name,
	        callback: function callback($$v) {
	          _this3.$set(data, "name", $$v);
	        }
	      }
	    }), h(_field.default, {
	      "attrs": {
	        "clearable": true,
	        "type": "tel",
	        "label": t('tel'),
	        "placeholder": t('telEmpty'),
	        "errorMessage": errorInfo.tel
	      },
	      "on": {
	        "focus": onFocus('tel')
	      },
	      "model": {
	        value: data.tel,
	        callback: function callback($$v) {
	          _this3.$set(data, "tel", $$v);
	        }
	      }
	    })]), this.showSetDefault && h(_cell.default, {
	      "attrs": {
	        "title": this.setDefaultLabel,
	        "border": false
	      },
	      "class": bem('switch-cell')
	    }, [h(_switch.default, {
	      "attrs": {
	        "size": 24
	      },
	      "on": {
	        "change": function change(event) {
	          _this3.$emit('change-default', event);
	        }
	      },
	      "model": {
	        value: data.isDefault,
	        callback: function callback($$v) {
	          _this3.$set(data, "isDefault", $$v);
	        }
	      }
	    })]), h("div", {
	      "class": bem('buttons')
	    }, [h(_button.default, {
	      "attrs": {
	        "block": true,
	        "round": true,
	        "type": "danger",
	        "text": t('save'),
	        "loading": this.isSaving
	      },
	      "on": {
	        "click": this.onSave
	      }
	    }), this.isEdit && h(_button.default, {
	      "attrs": {
	        "block": true,
	        "round": true,
	        "text": t('delete'),
	        "loading": this.isDeleting
	      },
	      "on": {
	        "click": this.onDelete
	      }
	    })])]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _constant = __webpack_require__(7);
	
	var _functional = __webpack_require__(5);
	
	var _tag = _interopRequireDefault(__webpack_require__(63));
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _cell = _interopRequireDefault(__webpack_require__(15));
	
	var _radio = _interopRequireDefault(__webpack_require__(99));
	
	var _button = _interopRequireDefault(__webpack_require__(17));
	
	var _radioGroup = _interopRequireDefault(__webpack_require__(98));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('contact-list'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	function ContactList(h, props, slots, ctx) {
	  var List = props.list && props.list.map(function (item, index) {
	    function onClick() {
	      (0, _functional.emit)(ctx, 'input', item.id);
	      (0, _functional.emit)(ctx, 'select', item, index);
	    }
	
	    function RightIcon() {
	      return h(_radio.default, {
	        "attrs": {
	          "name": item.id,
	          "iconSize": 16,
	          "checkedColor": _constant.RED
	        },
	        "on": {
	          "click": onClick
	        }
	      });
	    }
	
	    function LeftIcon() {
	      return h(_icon.default, {
	        "attrs": {
	          "name": "edit"
	        },
	        "class": bem('edit'),
	        "on": {
	          "click": function click(event) {
	            event.stopPropagation();
	            (0, _functional.emit)(ctx, 'edit', item, index);
	          }
	        }
	      });
	    }
	
	    function Content() {
	      var nodes = [item.name + "\uFF0C" + item.tel];
	
	      if (item.isDefault && props.defaultTagText) {
	        nodes.push(h(_tag.default, {
	          "attrs": {
	            "type": "danger",
	            "round": true
	          },
	          "class": bem('item-tag')
	        }, [props.defaultTagText]));
	      }
	
	      return nodes;
	    }
	
	    return h(_cell.default, {
	      "key": item.id,
	      "attrs": {
	        "isLink": true,
	        "center": true,
	        "valueClass": bem('item-value')
	      },
	      "class": bem('item'),
	      "scopedSlots": {
	        icon: LeftIcon,
	        default: Content,
	        'right-icon': RightIcon
	      },
	      "on": {
	        "click": onClick
	      }
	    });
	  });
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem()
	  }, (0, _functional.inherit)(ctx)]), [h(_radioGroup.default, {
	    "attrs": {
	      "value": props.value
	    },
	    "class": bem('group')
	  }, [List]), h("div", {
	    "class": bem('bottom')
	  }, [h(_button.default, {
	    "attrs": {
	      "round": true,
	      "block": true,
	      "type": "danger",
	      "text": props.addText || t('addText')
	    },
	    "class": bem('add'),
	    "on": {
	      "click": function click() {
	        (0, _functional.emit)(ctx, 'add');
	      }
	    }
	  })])]);
	}
	
	ContactList.props = {
	  value: null,
	  list: Array,
	  addText: String,
	  defaultTagText: String
	};
	
	var _default = createComponent(ContactList);
	
	exports.default = _default;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _raf = __webpack_require__(45);
	
	var _utils2 = __webpack_require__(330);
	
	var _createNamespace = (0, _utils.createNamespace)('count-down'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  props: {
	    millisecond: Boolean,
	    time: {
	      type: [Number, String],
	      default: 0
	    },
	    format: {
	      type: String,
	      default: 'HH:mm:ss'
	    },
	    autoStart: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      remain: 0
	    };
	  },
	  computed: {
	    timeData: function timeData() {
	      return (0, _utils2.parseTimeData)(this.remain);
	    },
	    formattedTime: function formattedTime() {
	      return (0, _utils2.parseFormat)(this.format, this.timeData);
	    }
	  },
	  watch: {
	    time: {
	      immediate: true,
	      handler: 'reset'
	    }
	  },
	  activated: function activated() {
	    if (this.keepAlivePaused) {
	      this.counting = true;
	      this.keepAlivePaused = false;
	      this.tick();
	    }
	  },
	  deactivated: function deactivated() {
	    if (this.counting) {
	      this.pause();
	      this.keepAlivePaused = true;
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.pause();
	  },
	  methods: {
	    // @exposed-api
	    start: function start() {
	      if (this.counting) {
	        return;
	      }
	
	      this.counting = true;
	      this.endTime = Date.now() + this.remain;
	      this.tick();
	    },
	    // @exposed-api
	    pause: function pause() {
	      this.counting = false;
	      (0, _raf.cancelRaf)(this.rafId);
	    },
	    // @exposed-api
	    reset: function reset() {
	      this.pause();
	      this.remain = +this.time;
	
	      if (this.autoStart) {
	        this.start();
	      }
	    },
	    tick: function tick() {
	      if (this.millisecond) {
	        this.microTick();
	      } else {
	        this.macroTick();
	      }
	    },
	    microTick: function microTick() {
	      var _this = this;
	
	      this.rafId = (0, _raf.raf)(function () {
	        /* istanbul ignore if */
	        // in case of call reset immediately after finish
	        if (!_this.counting) {
	          return;
	        }
	
	        _this.setRemain(_this.getRemain());
	
	        if (_this.remain > 0) {
	          _this.microTick();
	        }
	      });
	    },
	    macroTick: function macroTick() {
	      var _this2 = this;
	
	      this.rafId = (0, _raf.raf)(function () {
	        /* istanbul ignore if */
	        // in case of call reset immediately after finish
	        if (!_this2.counting) {
	          return;
	        }
	
	        var remain = _this2.getRemain();
	
	        if (!(0, _utils2.isSameSecond)(remain, _this2.remain) || remain === 0) {
	          _this2.setRemain(remain);
	        }
	
	        if (_this2.remain > 0) {
	          _this2.macroTick();
	        }
	      });
	    },
	    getRemain: function getRemain() {
	      return Math.max(this.endTime - Date.now(), 0);
	    },
	    setRemain: function setRemain(remain) {
	      this.remain = remain;
	      this.$emit('change', this.timeData);
	
	      if (remain === 0) {
	        this.pause();
	        this.$emit('finish');
	      }
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "class": bem()
	    }, [this.slots('default', this.timeData) || this.formattedTime]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.parseTimeData = parseTimeData;
	exports.parseFormat = parseFormat;
	exports.isSameSecond = isSameSecond;
	
	var _string = __webpack_require__(38);
	
	var SECOND = 1000;
	var MINUTE = 60 * SECOND;
	var HOUR = 60 * MINUTE;
	var DAY = 24 * HOUR;
	
	function parseTimeData(time) {
	  var days = Math.floor(time / DAY);
	  var hours = Math.floor(time % DAY / HOUR);
	  var minutes = Math.floor(time % HOUR / MINUTE);
	  var seconds = Math.floor(time % MINUTE / SECOND);
	  var milliseconds = Math.floor(time % SECOND);
	  return {
	    days: days,
	    hours: hours,
	    minutes: minutes,
	    seconds: seconds,
	    milliseconds: milliseconds
	  };
	}
	
	function parseFormat(format, timeData) {
	  var days = timeData.days;
	  var hours = timeData.hours,
	      minutes = timeData.minutes,
	      seconds = timeData.seconds,
	      milliseconds = timeData.milliseconds;
	
	  if (format.indexOf('DD') === -1) {
	    hours += days * 24;
	  } else {
	    format = format.replace('DD', (0, _string.padZero)(days));
	  }
	
	  if (format.indexOf('HH') === -1) {
	    minutes += hours * 60;
	  } else {
	    format = format.replace('HH', (0, _string.padZero)(hours));
	  }
	
	  if (format.indexOf('mm') === -1) {
	    seconds += minutes * 60;
	  } else {
	    format = format.replace('mm', (0, _string.padZero)(minutes));
	  }
	
	  if (format.indexOf('ss') === -1) {
	    milliseconds += seconds * 1000;
	  } else {
	    format = format.replace('ss', (0, _string.padZero)(seconds));
	  }
	
	  if (format.indexOf('S') !== -1) {
	    var ms = (0, _string.padZero)(milliseconds, 3);
	
	    if (format.indexOf('SSS') !== -1) {
	      format = format.replace('SSS', ms);
	    } else if (format.indexOf('SS') !== -1) {
	      format = format.replace('SS', ms.slice(0, 2));
	    } else {
	      format = format.replace('S', ms.charAt(0));
	    }
	  }
	
	  return format;
	}
	
	function isSameSecond(time1, time2) {
	  return Math.floor(time1 / 1000) === Math.floor(time2 / 1000);
	}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _cell = _interopRequireDefault(__webpack_require__(15));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('coupon-cell'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	function formatValue(props) {
	  var coupons = props.coupons,
	      chosenCoupon = props.chosenCoupon,
	      currency = props.currency;
	  var coupon = coupons[+chosenCoupon];
	
	  if (coupon) {
	    var value = coupon.value || coupon.denominations || 0;
	    return "-" + currency + (value / 100).toFixed(2);
	  }
	
	  return coupons.length === 0 ? t('tips') : t('count', coupons.length);
	}
	
	function CouponCell(h, props, slots, ctx) {
	  var valueClass = props.coupons[+props.chosenCoupon] ? 'van-coupon-cell--selected' : '';
	  var value = formatValue(props);
	  return h(_cell.default, (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem(),
	    "attrs": {
	      "value": value,
	      "title": props.title || t('title'),
	      "border": props.border,
	      "isLink": props.editable,
	      "valueClass": valueClass
	    }
	  }, (0, _functional.inherit)(ctx, true)]));
	}
	
	CouponCell.model = {
	  prop: 'chosenCoupon'
	};
	CouponCell.props = {
	  title: String,
	  coupons: {
	    type: Array,
	    default: function _default() {
	      return [];
	    }
	  },
	  currency: {
	    type: String,
	    default: '¥'
	  },
	  border: {
	    type: Boolean,
	    default: true
	  },
	  editable: {
	    type: Boolean,
	    default: true
	  },
	  chosenCoupon: {
	    type: [Number, String],
	    default: -1
	  }
	};
	
	var _default2 = createComponent(CouponCell);
	
	exports.default = _default2;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _tab = _interopRequireDefault(__webpack_require__(167));
	
	var _tabs = _interopRequireDefault(__webpack_require__(168));
	
	var _field = _interopRequireDefault(__webpack_require__(34));
	
	var _button = _interopRequireDefault(__webpack_require__(17));
	
	var _coupon = _interopRequireDefault(__webpack_require__(143));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('coupon-list'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	var EMPTY_IMAGE = 'https://img.yzcdn.cn/vant/coupon-empty.png';
	
	var _default2 = createComponent({
	  model: {
	    prop: 'code'
	  },
	  props: {
	    code: String,
	    closeButtonText: String,
	    inputPlaceholder: String,
	    enabledTitle: String,
	    disabledTitle: String,
	    exchangeButtonText: String,
	    exchangeButtonLoading: Boolean,
	    exchangeButtonDisabled: Boolean,
	    exchangeMinLength: {
	      type: Number,
	      default: 1
	    },
	    chosenCoupon: {
	      type: Number,
	      default: -1
	    },
	    coupons: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    disabledCoupons: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    displayedCouponIndex: {
	      type: Number,
	      default: -1
	    },
	    showExchangeBar: {
	      type: Boolean,
	      default: true
	    },
	    showCloseButton: {
	      type: Boolean,
	      default: true
	    },
	    showCount: {
	      type: Boolean,
	      default: true
	    },
	    currency: {
	      type: String,
	      default: '¥'
	    },
	    emptyImage: {
	      type: String,
	      default: EMPTY_IMAGE
	    }
	  },
	  data: function data() {
	    return {
	      tab: 0,
	      winHeight: window.innerHeight,
	      currentCode: this.code || ''
	    };
	  },
	  computed: {
	    buttonDisabled: function buttonDisabled() {
	      return !this.exchangeButtonLoading && (this.exchangeButtonDisabled || !this.currentCode || this.currentCode.length < this.exchangeMinLength);
	    },
	    listStyle: function listStyle() {
	      return {
	        height: this.winHeight - (this.showExchangeBar ? 140 : 94) + 'px'
	      };
	    }
	  },
	  watch: {
	    code: function code(_code) {
	      this.currentCode = _code;
	    },
	    currentCode: function currentCode(code) {
	      this.$emit('input', code);
	    },
	    displayedCouponIndex: 'scrollToShowCoupon'
	  },
	  mounted: function mounted() {
	    this.scrollToShowCoupon(this.displayedCouponIndex);
	  },
	  methods: {
	    onClickExchangeButton: function onClickExchangeButton() {
	      this.$emit('exchange', this.currentCode); // auto clear currentCode when not use vModel
	
	      if (!this.code) {
	        this.currentCode = '';
	      }
	    },
	    // scroll to show specific coupon
	    scrollToShowCoupon: function scrollToShowCoupon(index) {
	      var _this = this;
	
	      if (index === -1) {
	        return;
	      }
	
	      this.$nextTick(function () {
	        var _this$$refs = _this.$refs,
	            card = _this$$refs.card,
	            list = _this$$refs.list;
	        /* istanbul ignore next */
	
	        if (list && card && card[index]) {
	          list.scrollTop = card[index].$el.offsetTop - 100;
	        }
	      });
	    },
	    genEmpty: function genEmpty() {
	      var h = this.$createElement;
	      return h("div", {
	        "class": bem('empty')
	      }, [h("img", {
	        "attrs": {
	          "src": this.emptyImage
	        }
	      }), h("p", [t('empty')])]);
	    },
	    genExchangeButton: function genExchangeButton() {
	      var h = this.$createElement;
	      return h(_button.default, {
	        "attrs": {
	          "plain": true,
	          "type": "danger",
	          "text": this.exchangeButtonText || t('exchange'),
	          "loading": this.exchangeButtonLoading,
	          "disabled": this.buttonDisabled
	        },
	        "class": bem('exchange'),
	        "on": {
	          "click": this.onClickExchangeButton
	        }
	      });
	    }
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var h = arguments[0];
	    var coupons = this.coupons,
	        disabledCoupons = this.disabledCoupons;
	    var count = this.showCount ? " (" + coupons.length + ")" : '';
	    var title = (this.enabledTitle || t('enable')) + count;
	    var disabledCount = this.showCount ? " (" + disabledCoupons.length + ")" : '';
	    var disabledTitle = (this.disabledTitle || t('disabled')) + disabledCount;
	    var ExchangeBar = this.showExchangeBar && h("div", {
	      "class": bem('exchange-bar')
	    }, [h(_field.default, {
	      "attrs": {
	        "clearable": true,
	        "border": false,
	        "placeholder": this.inputPlaceholder || t('placeholder'),
	        "maxlength": "20"
	      },
	      "class": bem('field'),
	      "model": {
	        value: _this2.currentCode,
	        callback: function callback($$v) {
	          _this2.currentCode = $$v;
	        }
	      }
	    }), this.genExchangeButton()]);
	
	    var onChange = function onChange(index) {
	      return function () {
	        return _this2.$emit('change', index);
	      };
	    };
	
	    var CouponTab = h(_tab.default, {
	      "attrs": {
	        "title": title
	      }
	    }, [h("div", {
	      "class": bem('list', {
	        'with-bottom': this.showCloseButton
	      }),
	      "style": this.listStyle
	    }, [coupons.map(function (coupon, index) {
	      return h(_coupon.default, {
	        "ref": "card",
	        "key": coupon.id,
	        "attrs": {
	          "coupon": coupon,
	          "currency": _this2.currency,
	          "chosen": index === _this2.chosenCoupon
	        },
	        "nativeOn": {
	          "click": onChange(index)
	        }
	      });
	    }), !coupons.length && this.genEmpty()])]);
	    var DisabledCouponTab = h(_tab.default, {
	      "attrs": {
	        "title": disabledTitle
	      }
	    }, [h("div", {
	      "class": bem('list', {
	        'with-bottom': this.showCloseButton
	      }),
	      "style": this.listStyle
	    }, [disabledCoupons.map(function (coupon) {
	      return h(_coupon.default, {
	        "attrs": {
	          "disabled": true,
	          "coupon": coupon,
	          "currency": _this2.currency
	        },
	        "key": coupon.id
	      });
	    }), !disabledCoupons.length && this.genEmpty()])]);
	    return h("div", {
	      "class": bem()
	    }, [ExchangeBar, h(_tabs.default, {
	      "class": bem('tab'),
	      "attrs": {
	        "border": false
	      },
	      "model": {
	        value: _this2.tab,
	        callback: function callback($$v) {
	          _this2.tab = $$v;
	        }
	      }
	    }, [CouponTab, DisabledCouponTab]), h("div", {
	      "class": bem('bottom')
	    }, [h(_button.default, {
	      "directives": [{
	        name: "show",
	        value: this.showCloseButton
	      }],
	      "attrs": {
	        "round": true,
	        "type": "danger",
	        "block": true,
	        "text": this.closeButtonText || t('close')
	      },
	      "class": bem('close'),
	      "on": {
	        "click": onChange(-1)
	      }
	    })])]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _date = __webpack_require__(173);
	
	var _string = __webpack_require__(38);
	
	var _utils2 = __webpack_require__(93);
	
	var _shared = __webpack_require__(144);
	
	var currentYear = new Date().getFullYear();
	
	var _createNamespace = (0, _utils.createNamespace)('date-picker'),
	    createComponent = _createNamespace[0];
	
	var _default2 = createComponent({
	  mixins: [_shared.TimePickerMixin],
	  props: (0, _extends2.default)({}, _shared.sharedProps, {
	    type: {
	      type: String,
	      default: 'datetime'
	    },
	    minDate: {
	      type: Date,
	      default: function _default() {
	        return new Date(currentYear - 10, 0, 1);
	      },
	      validator: _date.isDate
	    },
	    maxDate: {
	      type: Date,
	      default: function _default() {
	        return new Date(currentYear + 10, 11, 31);
	      },
	      validator: _date.isDate
	    }
	  }),
	  watch: {
	    filter: 'updateInnerValue',
	    minDate: 'updateInnerValue',
	    maxDate: 'updateInnerValue',
	    value: function value(val) {
	      val = this.formatValue(val);
	
	      if (val.valueOf() !== this.innerValue.valueOf()) {
	        this.innerValue = val;
	      }
	    }
	  },
	  computed: {
	    ranges: function ranges() {
	      var _this$getBoundary = this.getBoundary('max', this.innerValue),
	          maxYear = _this$getBoundary.maxYear,
	          maxDate = _this$getBoundary.maxDate,
	          maxMonth = _this$getBoundary.maxMonth,
	          maxHour = _this$getBoundary.maxHour,
	          maxMinute = _this$getBoundary.maxMinute;
	
	      var _this$getBoundary2 = this.getBoundary('min', this.innerValue),
	          minYear = _this$getBoundary2.minYear,
	          minDate = _this$getBoundary2.minDate,
	          minMonth = _this$getBoundary2.minMonth,
	          minHour = _this$getBoundary2.minHour,
	          minMinute = _this$getBoundary2.minMinute;
	
	      var result = [{
	        type: 'year',
	        range: [minYear, maxYear]
	      }, {
	        type: 'month',
	        range: [minMonth, maxMonth]
	      }, {
	        type: 'day',
	        range: [minDate, maxDate]
	      }, {
	        type: 'hour',
	        range: [minHour, maxHour]
	      }, {
	        type: 'minute',
	        range: [minMinute, maxMinute]
	      }];
	      if (this.type === 'date') result.splice(3, 2);
	      if (this.type === 'year-month') result.splice(2, 3);
	      return result;
	    }
	  },
	  methods: {
	    formatValue: function formatValue(value) {
	      if (!(0, _date.isDate)(value)) {
	        value = this.minDate;
	      }
	
	      value = Math.max(value, this.minDate.getTime());
	      value = Math.min(value, this.maxDate.getTime());
	      return new Date(value);
	    },
	    getBoundary: function getBoundary(type, value) {
	      var _ref;
	
	      var boundary = this[type + "Date"];
	      var year = boundary.getFullYear();
	      var month = 1;
	      var date = 1;
	      var hour = 0;
	      var minute = 0;
	
	      if (type === 'max') {
	        month = 12;
	        date = (0, _utils2.getMonthEndDay)(value.getFullYear(), value.getMonth() + 1);
	        hour = 23;
	        minute = 59;
	      }
	
	      if (value.getFullYear() === year) {
	        month = boundary.getMonth() + 1;
	
	        if (value.getMonth() + 1 === month) {
	          date = boundary.getDate();
	
	          if (value.getDate() === date) {
	            hour = boundary.getHours();
	
	            if (value.getHours() === hour) {
	              minute = boundary.getMinutes();
	            }
	          }
	        }
	      }
	
	      return _ref = {}, _ref[type + "Year"] = year, _ref[type + "Month"] = month, _ref[type + "Date"] = date, _ref[type + "Hour"] = hour, _ref[type + "Minute"] = minute, _ref;
	    },
	    updateInnerValue: function updateInnerValue() {
	      var _this = this;
	
	      var indexes = this.getPicker().getIndexes();
	
	      var getValue = function getValue(index) {
	        var values = _this.originColumns[index].values;
	        return (0, _utils2.getTrueValue)(values[indexes[index]]);
	      };
	
	      var year = getValue(0);
	      var month = getValue(1);
	      var maxDate = (0, _utils2.getMonthEndDay)(year, month);
	      var date;
	
	      if (this.type === 'year-month') {
	        date = 1;
	      } else {
	        date = getValue(2);
	      }
	
	      date = date > maxDate ? maxDate : date;
	      var hour = 0;
	      var minute = 0;
	
	      if (this.type === 'datetime') {
	        hour = getValue(3);
	        minute = getValue(4);
	      }
	
	      var value = new Date(year, month - 1, date, hour, minute);
	      this.innerValue = this.formatValue(value);
	    },
	    onChange: function onChange(picker) {
	      var _this2 = this;
	
	      this.updateInnerValue();
	      this.$nextTick(function () {
	        _this2.$nextTick(function () {
	          _this2.$emit('change', picker);
	        });
	      });
	    },
	    updateColumnValue: function updateColumnValue() {
	      var _this3 = this;
	
	      var value = this.innerValue;
	      var formatter = this.formatter;
	      var values = [formatter('year', "" + value.getFullYear()), formatter('month', (0, _string.padZero)(value.getMonth() + 1)), formatter('day', (0, _string.padZero)(value.getDate()))];
	
	      if (this.type === 'datetime') {
	        values.push(formatter('hour', (0, _string.padZero)(value.getHours())), formatter('minute', (0, _string.padZero)(value.getMinutes())));
	      }
	
	      if (this.type === 'year-month') {
	        values = values.slice(0, 2);
	      }
	
	      this.$nextTick(function () {
	        _this3.getPicker().setValues(values);
	      });
	    }
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _string = __webpack_require__(38);
	
	var _number = __webpack_require__(47);
	
	var _shared = __webpack_require__(144);
	
	var _createNamespace = (0, _utils.createNamespace)('time-picker'),
	    createComponent = _createNamespace[0];
	
	var _default = createComponent({
	  mixins: [_shared.TimePickerMixin],
	  props: (0, _extends2.default)({}, _shared.sharedProps, {
	    minHour: {
	      type: [Number, String],
	      default: 0
	    },
	    maxHour: {
	      type: [Number, String],
	      default: 23
	    },
	    minMinute: {
	      type: [Number, String],
	      default: 0
	    },
	    maxMinute: {
	      type: [Number, String],
	      default: 59
	    }
	  }),
	  computed: {
	    ranges: function ranges() {
	      return [{
	        type: 'hour',
	        range: [+this.minHour, +this.maxHour]
	      }, {
	        type: 'minute',
	        range: [+this.minMinute, +this.maxMinute]
	      }];
	    }
	  },
	  watch: {
	    filter: 'updateInnerValue',
	    minHour: 'updateInnerValue',
	    maxHour: 'updateInnerValue',
	    minMinute: 'updateInnerValue',
	    maxMinute: 'updateInnerValue',
	    value: function value(val) {
	      val = this.formatValue(val);
	
	      if (val !== this.innerValue) {
	        this.innerValue = val;
	        this.updateColumnValue();
	      }
	    }
	  },
	  methods: {
	    formatValue: function formatValue(value) {
	      if (!value) {
	        value = (0, _string.padZero)(this.minHour) + ":" + (0, _string.padZero)(this.minMinute);
	      }
	
	      var _value$split = value.split(':'),
	          hour = _value$split[0],
	          minute = _value$split[1];
	
	      hour = (0, _string.padZero)((0, _number.range)(hour, this.minHour, this.maxHour));
	      minute = (0, _string.padZero)((0, _number.range)(minute, this.minMinute, this.maxMinute));
	      return hour + ":" + minute;
	    },
	    updateInnerValue: function updateInnerValue() {
	      var _this$getPicker$getIn = this.getPicker().getIndexes(),
	          hourIndex = _this$getPicker$getIn[0],
	          minuteIndex = _this$getPicker$getIn[1];
	
	      var _this$originColumns = this.originColumns,
	          hourColumn = _this$originColumns[0],
	          minuteColumn = _this$originColumns[1];
	      var hour = hourColumn.values[hourIndex] || hourColumn.values[0];
	      var minute = minuteColumn.values[minuteIndex] || minuteColumn.values[0];
	      this.innerValue = this.formatValue(hour + ":" + minute);
	      this.updateColumnValue();
	    },
	    onChange: function onChange(picker) {
	      var _this = this;
	
	      this.updateInnerValue();
	      this.$nextTick(function () {
	        _this.$nextTick(function () {
	          _this.$emit('change', picker);
	        });
	      });
	    },
	    updateColumnValue: function updateColumnValue() {
	      var _this2 = this;
	
	      var formatter = this.formatter;
	      var pair = this.innerValue.split(':');
	      var values = [formatter('hour', pair[0]), formatter('minute', pair[1])];
	      this.$nextTick(function () {
	        _this2.getPicker().setValues(values);
	      });
	    }
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _TimePicker = _interopRequireDefault(__webpack_require__(334));
	
	var _DatePicker = _interopRequireDefault(__webpack_require__(333));
	
	var _createNamespace = (0, _utils.createNamespace)('datetime-picker'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  props: (0, _extends2.default)({}, _TimePicker.default.props, {}, _DatePicker.default.props),
	  methods: {
	    // @exposed-api
	    getPicker: function getPicker() {
	      return this.$refs.root.getPicker();
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    var Component = this.type === 'time' ? _TimePicker.default : _DatePicker.default;
	    return h(Component, {
	      "ref": "root",
	      "class": bem(),
	      "props": (0, _extends2.default)({}, this.$props),
	      "on": (0, _extends2.default)({}, this.$listeners)
	    });
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _constant = __webpack_require__(7);
	
	var _popup = __webpack_require__(39);
	
	var _button = _interopRequireDefault(__webpack_require__(17));
	
	var _createNamespace = (0, _utils.createNamespace)('dialog'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	var _default = createComponent({
	  mixins: [(0, _popup.PopupMixin)()],
	  props: {
	    title: String,
	    width: [Number, String],
	    message: String,
	    className: null,
	    callback: Function,
	    beforeClose: Function,
	    messageAlign: String,
	    cancelButtonText: String,
	    cancelButtonColor: String,
	    confirmButtonText: String,
	    confirmButtonColor: String,
	    showCancelButton: Boolean,
	    transition: {
	      type: String,
	      default: 'van-dialog-bounce'
	    },
	    showConfirmButton: {
	      type: Boolean,
	      default: true
	    },
	    overlay: {
	      type: Boolean,
	      default: true
	    },
	    closeOnClickOverlay: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      loading: {
	        confirm: false,
	        cancel: false
	      }
	    };
	  },
	  methods: {
	    onClickOverlay: function onClickOverlay() {
	      this.handleAction('overlay');
	    },
	    handleAction: function handleAction(action) {
	      var _this = this;
	
	      this.$emit(action); // show not trigger close event when hidden
	
	      if (!this.value) {
	        return;
	      }
	
	      if (this.beforeClose) {
	        this.loading[action] = true;
	        this.beforeClose(action, function (state) {
	          if (state !== false && _this.loading[action]) {
	            _this.onClose(action);
	          }
	
	          _this.loading.confirm = false;
	          _this.loading.cancel = false;
	        });
	      } else {
	        this.onClose(action);
	      }
	    },
	    onClose: function onClose(action) {
	      this.close();
	
	      if (this.callback) {
	        this.callback(action);
	      }
	    },
	    onOpened: function onOpened() {
	      this.$emit('opened');
	    },
	    onClosed: function onClosed() {
	      this.$emit('closed');
	    },
	    genButtons: function genButtons() {
	      var _this2 = this,
	          _ref;
	
	      var h = this.$createElement;
	      var multiple = this.showCancelButton && this.showConfirmButton;
	      return h("div", {
	        "class": [_constant.BORDER_TOP, bem('footer', {
	          buttons: multiple
	        })]
	      }, [this.showCancelButton && h(_button.default, {
	        "attrs": {
	          "size": "large",
	          "loading": this.loading.cancel,
	          "text": this.cancelButtonText || t('cancel')
	        },
	        "class": bem('cancel'),
	        "style": {
	          color: this.cancelButtonColor
	        },
	        "on": {
	          "click": function click() {
	            _this2.handleAction('cancel');
	          }
	        }
	      }), this.showConfirmButton && h(_button.default, {
	        "attrs": {
	          "size": "large",
	          "loading": this.loading.confirm,
	          "text": this.confirmButtonText || t('confirm')
	        },
	        "class": [bem('confirm'), (_ref = {}, _ref[_constant.BORDER_LEFT] = multiple, _ref)],
	        "style": {
	          color: this.confirmButtonColor
	        },
	        "on": {
	          "click": function click() {
	            _this2.handleAction('confirm');
	          }
	        }
	      })]);
	    }
	  },
	  render: function render() {
	    var _bem;
	
	    var h = arguments[0];
	
	    if (!this.shouldRender) {
	      return;
	    }
	
	    var message = this.message,
	        messageAlign = this.messageAlign;
	    var messageSlot = this.slots();
	    var title = this.slots('title') || this.title;
	    var Title = title && h("div", {
	      "class": bem('header', {
	        isolated: !message && !messageSlot
	      })
	    }, [title]);
	    var Content = (messageSlot || message) && h("div", {
	      "class": bem('content')
	    }, [messageSlot || h("div", {
	      "domProps": {
	        "innerHTML": message
	      },
	      "class": bem('message', (_bem = {
	        'has-title': title
	      }, _bem[messageAlign] = messageAlign, _bem))
	    })]);
	    return h("transition", {
	      "attrs": {
	        "name": this.transition
	      },
	      "on": {
	        "afterEnter": this.onOpened,
	        "afterLeave": this.onClosed
	      }
	    }, [h("div", {
	      "directives": [{
	        name: "show",
	        value: this.value
	      }],
	      "attrs": {
	        "role": "dialog",
	        "aria-labelledby": this.title || message
	      },
	      "class": [bem(), this.className],
	      "style": {
	        width: (0, _utils.addUnit)(this.width)
	      }
	    }, [Title, Content, this.genButtons()])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	// Utils
	var _createNamespace = (0, _utils.createNamespace)('divider'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function Divider(h, props, slots, ctx) {
	  var _bem;
	
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "attrs": {
	      "role": "separator"
	    },
	    "style": {
	      borderColor: props.borderColor
	    },
	    "class": bem((_bem = {
	      dashed: props.dashed,
	      hairline: props.hairline
	    }, _bem["content-" + props.contentPosition] = slots.default, _bem))
	  }, (0, _functional.inherit)(ctx, true)]), [slots.default && slots.default()]);
	}
	
	Divider.props = {
	  dashed: Boolean,
	  hairline: {
	    type: Boolean,
	    default: true
	  },
	  contentPosition: {
	    type: String,
	    default: 'center'
	  }
	};
	
	var _default = createComponent(Divider);
	
	exports.default = _default;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _event = __webpack_require__(10);
	
	var _portal = __webpack_require__(149);
	
	var _relation = __webpack_require__(9);
	
	var _cell = _interopRequireDefault(__webpack_require__(15));
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _popup = _interopRequireDefault(__webpack_require__(37));
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('dropdown-item'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default2 = createComponent({
	  mixins: [(0, _portal.PortalMixin)({
	    ref: 'wrapper'
	  }), (0, _relation.ChildrenMixin)('vanDropdownMenu')],
	  props: {
	    value: null,
	    title: String,
	    disabled: Boolean,
	    titleClass: String,
	    options: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      transition: true,
	      showPopup: false,
	      showWrapper: false
	    };
	  },
	  computed: {
	    displayTitle: function displayTitle() {
	      var _this = this;
	
	      if (this.title) {
	        return this.title;
	      }
	
	      var match = this.options.filter(function (option) {
	        return option.value === _this.value;
	      });
	      return match.length ? match[0].text : '';
	    }
	  },
	  watch: {
	    showPopup: function showPopup(val) {
	      this.bindScroll(val);
	    }
	  },
	  beforeCreate: function beforeCreate() {
	    var _this2 = this;
	
	    var createEmitter = function createEmitter(eventName) {
	      return function () {
	        return _this2.$emit(eventName);
	      };
	    };
	
	    this.onOpen = createEmitter('open');
	    this.onClose = createEmitter('close');
	    this.onOpened = createEmitter('opened');
	  },
	  methods: {
	    // @exposed-api
	    toggle: function toggle(show, options) {
	      if (show === void 0) {
	        show = !this.showPopup;
	      }
	
	      if (options === void 0) {
	        options = {};
	      }
	
	      if (show === this.showPopup) {
	        return;
	      }
	
	      this.transition = !options.immediate;
	      this.showPopup = show;
	
	      if (show) {
	        this.parent.updateOffset();
	        this.showWrapper = true;
	      }
	    },
	    bindScroll: function bindScroll(bind) {
	      var scroller = this.parent.scroller;
	      var action = bind ? _event.on : _event.off;
	      action(scroller, 'scroll', this.onScroll, true);
	    },
	    onScroll: function onScroll() {
	      this.parent.updateOffset();
	    },
	    onClickWrapper: function onClickWrapper(event) {
	      // prevent being identified as clicking outside and closed when use get-contaienr
	      if (this.getContainer) {
	        event.stopPropagation();
	      }
	    }
	  },
	  render: function render() {
	    var _this3 = this;
	
	    var h = arguments[0];
	    var _this$parent = this.parent,
	        zIndex = _this$parent.zIndex,
	        offset = _this$parent.offset,
	        overlay = _this$parent.overlay,
	        duration = _this$parent.duration,
	        direction = _this$parent.direction,
	        activeColor = _this$parent.activeColor,
	        closeOnClickOverlay = _this$parent.closeOnClickOverlay;
	    var Options = this.options.map(function (option) {
	      var active = option.value === _this3.value;
	      return h(_cell.default, {
	        "attrs": {
	          "clickable": true,
	          "icon": option.icon,
	          "title": option.text
	        },
	        "key": option.value,
	        "class": bem('option', {
	          active: active
	        }),
	        "style": {
	          color: active ? activeColor : ''
	        },
	        "on": {
	          "click": function click() {
	            _this3.showPopup = false;
	
	            if (option.value !== _this3.value) {
	              _this3.$emit('input', option.value);
	
	              _this3.$emit('change', option.value);
	            }
	          }
	        }
	      }, [active && h(_icon.default, {
	        "class": bem('icon'),
	        "attrs": {
	          "color": activeColor,
	          "name": "success"
	        }
	      })]);
	    });
	    var style = {
	      zIndex: zIndex
	    };
	
	    if (direction === 'down') {
	      style.top = offset + "px";
	    } else {
	      style.bottom = offset + "px";
	    }
	
	    return h("div", [h("div", {
	      "directives": [{
	        name: "show",
	        value: this.showWrapper
	      }],
	      "ref": "wrapper",
	      "style": style,
	      "class": bem([direction]),
	      "on": {
	        "click": this.onClickWrapper
	      }
	    }, [h(_popup.default, {
	      "attrs": {
	        "overlay": overlay,
	        "position": direction === 'down' ? 'top' : 'bottom',
	        "duration": this.transition ? duration : 0,
	        "closeOnClickOverlay": closeOnClickOverlay,
	        "overlayStyle": {
	          position: 'absolute'
	        }
	      },
	      "class": bem('content'),
	      "on": {
	        "open": this.onOpen,
	        "close": this.onClose,
	        "opened": this.onOpened,
	        "closed": function closed() {
	          _this3.showWrapper = false;
	
	          _this3.$emit('closed');
	        }
	      },
	      "model": {
	        value: _this3.showPopup,
	        callback: function callback($$v) {
	          _this3.showPopup = $$v;
	        }
	      }
	    }, [Options, this.slots('default')])])]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _constant = __webpack_require__(7);
	
	var _scroll = __webpack_require__(22);
	
	var _relation = __webpack_require__(9);
	
	var _clickOutside = __webpack_require__(147);
	
	// Utils
	// Mixins
	var _createNamespace = (0, _utils.createNamespace)('dropdown-menu'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ParentMixin)('vanDropdownMenu'), (0, _clickOutside.ClickOutsideMixin)({
	    event: 'click',
	    method: 'onClickOutside'
	  })],
	  props: {
	    zIndex: [Number, String],
	    activeColor: String,
	    overlay: {
	      type: Boolean,
	      default: true
	    },
	    duration: {
	      type: [Number, String],
	      default: 0.2
	    },
	    direction: {
	      type: String,
	      default: 'down'
	    },
	    closeOnClickOverlay: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      offset: 0
	    };
	  },
	  computed: {
	    scroller: function scroller() {
	      return (0, _scroll.getScroller)(this.$el);
	    }
	  },
	  methods: {
	    updateOffset: function updateOffset() {
	      if (!this.$refs.menu) {
	        return;
	      }
	
	      var rect = this.$refs.menu.getBoundingClientRect();
	
	      if (this.direction === 'down') {
	        this.offset = rect.bottom;
	      } else {
	        this.offset = window.innerHeight - rect.top;
	      }
	    },
	    toggleItem: function toggleItem(active) {
	      this.children.forEach(function (item, index) {
	        if (index === active) {
	          item.toggle();
	        } else if (item.showPopup) {
	          item.toggle(false, {
	            immediate: true
	          });
	        }
	      });
	    },
	    onClickOutside: function onClickOutside() {
	      this.children.forEach(function (item) {
	        item.toggle(false);
	      });
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var h = arguments[0];
	    var Titles = this.children.map(function (item, index) {
	      return h("div", {
	        "attrs": {
	          "role": "button",
	          "tabindex": item.disabled ? -1 : 0
	        },
	        "class": bem('item', {
	          disabled: item.disabled
	        }),
	        "on": {
	          "click": function click() {
	            if (!item.disabled) {
	              _this.toggleItem(index);
	            }
	          }
	        }
	      }, [h("span", {
	        "class": [bem('title', {
	          active: item.showPopup,
	          down: item.showPopup === (_this.direction === 'down')
	        }), item.titleClass],
	        "style": {
	          color: item.showPopup ? _this.activeColor : ''
	        }
	      }, [h("div", {
	        "class": "van-ellipsis"
	      }, [item.slots('title') || item.displayTitle])])]);
	    });
	    return h("div", {
	      "ref": "menu",
	      "class": [bem(), _constant.BORDER_TOP_BOTTOM]
	    }, [Titles, this.slots('default')]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _createNamespace = (0, _utils.createNamespace)('form'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  props: {
	    colon: Boolean,
	    labelWidth: [Number, String],
	    labelAlign: String,
	    inputAlign: String,
	    scrollToError: Boolean,
	    validateFirst: Boolean,
	    errorMessageAlign: String,
	    validateTrigger: {
	      type: String,
	      default: 'onBlur'
	    }
	  },
	  provide: function provide() {
	    return {
	      vanForm: this
	    };
	  },
	  data: function data() {
	    return {
	      fields: []
	    };
	  },
	  methods: {
	    validateSeq: function validateSeq() {
	      var _this = this;
	
	      return new Promise(function (resolve, reject) {
	        var errors = [];
	
	        _this.fields.reduce(function (promise, field) {
	          return promise.then(function () {
	            if (!errors.length) {
	              return field.validate().then(function (error) {
	                if (error) {
	                  errors.push(error);
	                }
	              });
	            }
	          });
	        }, Promise.resolve()).then(function () {
	          if (errors.length) {
	            reject(errors);
	          } else {
	            resolve();
	          }
	        });
	      });
	    },
	    validateAll: function validateAll() {
	      var _this2 = this;
	
	      return new Promise(function (resolve, reject) {
	        Promise.all(_this2.fields.map(function (item) {
	          return item.validate();
	        })).then(function (errors) {
	          errors = errors.filter(function (item) {
	            return item;
	          });
	
	          if (errors.length) {
	            reject(errors);
	          } else {
	            resolve();
	          }
	        });
	      });
	    },
	    // @exposed-api
	    validate: function validate(name) {
	      if (name) {
	        return this.validateField(name);
	      }
	
	      return this.validateFirst ? this.validateSeq() : this.validateAll();
	    },
	    validateField: function validateField(name) {
	      var matched = this.fields.filter(function (item) {
	        return item.name === name;
	      });
	
	      if (matched.length) {
	        return new Promise(function (resolve, reject) {
	          matched[0].validate().then(function (error) {
	            if (error) {
	              reject(error);
	            } else {
	              resolve();
	            }
	          });
	        });
	      }
	
	      return Promise.reject();
	    },
	    // @exposed-api
	    resetValidation: function resetValidation(name) {
	      this.fields.forEach(function (item) {
	        if (!name || item.name === name) {
	          item.resetValidation();
	        }
	      });
	    },
	    // @exposed-api
	    scrollToField: function scrollToField(name) {
	      this.fields.forEach(function (item) {
	        if (item.name === name) {
	          item.$el.scrollIntoView();
	        }
	      });
	    },
	    getValues: function getValues() {
	      return this.fields.reduce(function (form, field) {
	        form[field.name] = field.formValue;
	        return form;
	      }, {});
	    },
	    onSubmit: function onSubmit(event) {
	      event.preventDefault();
	      this.submit();
	    },
	    // @exposed-api
	    submit: function submit() {
	      var _this3 = this;
	
	      var values = this.getValues();
	      this.validate().then(function () {
	        _this3.$emit('submit', values);
	      }).catch(function (errors) {
	        _this3.$emit('failed', {
	          values: values,
	          errors: errors
	        });
	
	        if (_this3.scrollToError) {
	          _this3.scrollToField(errors[0].name);
	        }
	      });
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("form", {
	      "class": bem(),
	      "on": {
	        "submit": this.onSubmit
	      }
	    }, [this.slots()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _router = __webpack_require__(24);
	
	var _relation = __webpack_require__(9);
	
	var _button = _interopRequireDefault(__webpack_require__(17));
	
	var _createNamespace = (0, _utils.createNamespace)('goods-action-button'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ChildrenMixin)('vanGoodsAction')],
	  props: (0, _extends2.default)({}, _router.routeProps, {
	    type: String,
	    text: String,
	    icon: String,
	    color: String,
	    loading: Boolean,
	    disabled: Boolean
	  }),
	  computed: {
	    isFirst: function isFirst() {
	      var prev = this.parent && this.parent.children[this.index - 1];
	      return !prev || prev.$options.name !== this.$options.name;
	    },
	    isLast: function isLast() {
	      var next = this.parent && this.parent.children[this.index + 1];
	      return !next || next.$options.name !== this.$options.name;
	    }
	  },
	  methods: {
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	      (0, _router.route)(this.$router, this);
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h(_button.default, {
	      "class": bem([{
	        first: this.isFirst,
	        last: this.isLast
	      }, this.type]),
	      "attrs": {
	        "square": true,
	        "size": "large",
	        "type": this.type,
	        "icon": this.icon,
	        "color": this.color,
	        "loading": this.loading,
	        "disabled": this.disabled
	      },
	      "on": {
	        "click": this.onClick
	      }
	    }, [this.slots() || this.text]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _router = __webpack_require__(24);
	
	var _relation = __webpack_require__(9);
	
	var _info = _interopRequireDefault(__webpack_require__(35));
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _createNamespace = (0, _utils.createNamespace)('goods-action-icon'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ChildrenMixin)('vanGoodsAction')],
	  props: (0, _extends2.default)({}, _router.routeProps, {
	    dot: Boolean,
	    text: String,
	    icon: String,
	    color: String,
	    info: [Number, String],
	    iconClass: null
	  }),
	  methods: {
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	      (0, _router.route)(this.$router, this);
	    },
	    genIcon: function genIcon() {
	      var h = this.$createElement;
	      var slot = this.slots('icon');
	
	      if (slot) {
	        return h("div", {
	          "class": bem('icon')
	        }, [slot, h(_info.default, {
	          "attrs": {
	            "dot": this.dot,
	            "info": this.info
	          }
	        })]);
	      }
	
	      return h(_icon.default, {
	        "class": [bem('icon'), this.iconClass],
	        "attrs": {
	          "tag": "div",
	          "dot": this.dot,
	          "info": this.info,
	          "name": this.icon,
	          "color": this.color
	        }
	      });
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "attrs": {
	        "role": "button",
	        "tabindex": "0"
	      },
	      "class": bem(),
	      "on": {
	        "click": this.onClick
	      }
	    }, [this.genIcon(), this.slots() || this.text]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _relation = __webpack_require__(9);
	
	var _createNamespace = (0, _utils.createNamespace)('goods-action'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ParentMixin)('vanGoodsAction')],
	  props: {
	    safeAreaInsetBottom: Boolean
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "class": bem({
	        'safe-area-inset-bottom': this.safeAreaInsetBottom
	      })
	    }, [this.slots()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _constant = __webpack_require__(7);
	
	var _router = __webpack_require__(24);
	
	var _relation = __webpack_require__(9);
	
	var _info = _interopRequireDefault(__webpack_require__(35));
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('grid-item'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ChildrenMixin)('vanGrid')],
	  props: (0, _extends2.default)({}, _router.routeProps, {
	    dot: Boolean,
	    text: String,
	    icon: String,
	    iconPrefix: String,
	    info: [Number, String]
	  }),
	  computed: {
	    style: function style() {
	      var _this$parent = this.parent,
	          square = _this$parent.square,
	          gutter = _this$parent.gutter,
	          columnNum = _this$parent.columnNum;
	      var percent = 100 / columnNum + "%";
	      var style = {
	        flexBasis: percent
	      };
	
	      if (square) {
	        style.paddingTop = percent;
	      } else if (gutter) {
	        var gutterValue = (0, _utils.addUnit)(gutter);
	        style.paddingRight = gutterValue;
	
	        if (this.index >= columnNum) {
	          style.marginTop = gutterValue;
	        }
	      }
	
	      return style;
	    },
	    contentStyle: function contentStyle() {
	      var _this$parent2 = this.parent,
	          square = _this$parent2.square,
	          gutter = _this$parent2.gutter;
	
	      if (square && gutter) {
	        var gutterValue = (0, _utils.addUnit)(gutter);
	        return {
	          right: gutterValue,
	          bottom: gutterValue,
	          height: 'auto'
	        };
	      }
	    }
	  },
	  methods: {
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	      (0, _router.route)(this.$router, this);
	    },
	    genIcon: function genIcon() {
	      var h = this.$createElement;
	      var iconSlot = this.slots('icon');
	
	      if (iconSlot) {
	        return h("div", {
	          "class": bem('icon-wrapper')
	        }, [iconSlot, h(_info.default, {
	          "attrs": {
	            "dot": this.dot,
	            "info": this.info
	          }
	        })]);
	      }
	
	      if (this.icon) {
	        return h(_icon.default, {
	          "attrs": {
	            "name": this.icon,
	            "dot": this.dot,
	            "info": this.info,
	            "size": this.parent.iconSize,
	            "classPrefix": this.iconPrefix
	          },
	          "class": bem('icon')
	        });
	      }
	    },
	    getText: function getText() {
	      var h = this.$createElement;
	      var textSlot = this.slots('text');
	
	      if (textSlot) {
	        return textSlot;
	      }
	
	      if (this.text) {
	        return h("span", {
	          "class": bem('text')
	        }, [this.text]);
	      }
	    },
	    genContent: function genContent() {
	      var slot = this.slots();
	
	      if (slot) {
	        return slot;
	      }
	
	      return [this.genIcon(), this.getText()];
	    }
	  },
	  render: function render() {
	    var _ref;
	
	    var h = arguments[0];
	    var _this$parent3 = this.parent,
	        center = _this$parent3.center,
	        border = _this$parent3.border,
	        square = _this$parent3.square,
	        gutter = _this$parent3.gutter,
	        clickable = _this$parent3.clickable;
	    return h("div", {
	      "class": [bem({
	        square: square
	      })],
	      "style": this.style
	    }, [h("div", {
	      "style": this.contentStyle,
	      "attrs": {
	        "role": clickable ? 'button' : null,
	        "tabindex": clickable ? 0 : null
	      },
	      "class": [bem('content', {
	        center: center,
	        square: square,
	        clickable: clickable,
	        surround: border && gutter
	      }), (_ref = {}, _ref[_constant.BORDER] = border, _ref)],
	      "on": {
	        "click": this.onClick
	      }
	    }, [this.genContent()])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _constant = __webpack_require__(7);
	
	var _relation = __webpack_require__(9);
	
	var _createNamespace = (0, _utils.createNamespace)('grid'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ParentMixin)('vanGrid')],
	  props: {
	    square: Boolean,
	    gutter: [Number, String],
	    iconSize: [Number, String],
	    clickable: Boolean,
	    columnNum: {
	      type: [Number, String],
	      default: 4
	    },
	    center: {
	      type: Boolean,
	      default: true
	    },
	    border: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    style: function style() {
	      var gutter = this.gutter;
	
	      if (gutter) {
	        return {
	          paddingLeft: (0, _utils.addUnit)(gutter)
	        };
	      }
	    }
	  },
	  render: function render() {
	    var _ref;
	
	    var h = arguments[0];
	    return h("div", {
	      "style": this.style,
	      "class": [bem(), (_ref = {}, _ref[_constant.BORDER_TOP] = this.border && !this.gutter, _ref)]
	    }, [this.slots()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _number = __webpack_require__(47);
	
	var _event = __webpack_require__(10);
	
	var _popup = __webpack_require__(39);
	
	var _touch = __webpack_require__(19);
	
	var _image = _interopRequireDefault(__webpack_require__(60));
	
	var _swipe = _interopRequireDefault(__webpack_require__(164));
	
	var _loading = _interopRequireDefault(__webpack_require__(18));
	
	var _swipeItem = _interopRequireDefault(__webpack_require__(163));
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('image-preview'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function getDistance(touches) {
	  return Math.sqrt(Math.pow(touches[0].clientX - touches[1].clientX, 2) + Math.pow(touches[0].clientY - touches[1].clientY, 2));
	}
	
	var _default2 = createComponent({
	  mixins: [(0, _popup.PopupMixin)({
	    skipToggleEvent: true
	  }), _touch.TouchMixin],
	  props: {
	    className: null,
	    lazyLoad: Boolean,
	    asyncClose: Boolean,
	    showIndicators: Boolean,
	    images: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    loop: {
	      type: Boolean,
	      default: true
	    },
	    swipeDuration: {
	      type: [Number, String],
	      default: 500
	    },
	    overlay: {
	      type: Boolean,
	      default: true
	    },
	    showIndex: {
	      type: Boolean,
	      default: true
	    },
	    startPosition: {
	      type: [Number, String],
	      default: 0
	    },
	    minZoom: {
	      type: [Number, String],
	      default: 1 / 3
	    },
	    maxZoom: {
	      type: [Number, String],
	      default: 3
	    },
	    overlayClass: {
	      type: String,
	      default: bem('overlay')
	    },
	    closeable: Boolean,
	    closeIcon: {
	      type: String,
	      default: 'clear'
	    },
	    closeIconPosition: {
	      type: String,
	      default: 'top-right'
	    }
	  },
	  data: function data() {
	    return {
	      scale: 1,
	      moveX: 0,
	      moveY: 0,
	      active: 0,
	      moving: false,
	      zooming: false,
	      doubleClickTimer: null
	    };
	  },
	  computed: {
	    imageStyle: function imageStyle() {
	      var scale = this.scale;
	      var style = {
	        transitionDuration: this.zooming || this.moving ? '0s' : '.3s'
	      };
	
	      if (scale !== 1) {
	        style.transform = "scale3d(" + scale + ", " + scale + ", 1) translate(" + this.moveX / scale + "px, " + this.moveY / scale + "px)";
	      }
	
	      return style;
	    }
	  },
	  watch: {
	    value: function value(val) {
	      var _this = this;
	
	      if (val) {
	        this.setActive(+this.startPosition);
	        this.$nextTick(function () {
	          _this.$refs.swipe.swipeTo(+_this.startPosition, {
	            immediate: true
	          });
	        });
	      } else {
	        this.$emit('close', {
	          index: this.active,
	          url: this.images[this.active]
	        });
	      }
	    },
	    startPosition: function startPosition(val) {
	      this.setActive(val);
	    },
	    shouldRender: {
	      handler: function handler(val) {
	        var _this2 = this;
	
	        if (val) {
	          this.$nextTick(function () {
	            var swipe = _this2.$refs.swipe.$el;
	            (0, _event.on)(swipe, 'touchstart', _this2.onWrapperTouchStart);
	            (0, _event.on)(swipe, 'touchmove', _event.preventDefault);
	            (0, _event.on)(swipe, 'touchend', _this2.onWrapperTouchEnd);
	            (0, _event.on)(swipe, 'touchcancel', _this2.onWrapperTouchEnd);
	          });
	        }
	      },
	      immediate: true
	    }
	  },
	  methods: {
	    emitClose: function emitClose() {
	      if (!this.asyncClose) {
	        this.$emit('input', false);
	      }
	    },
	    onWrapperTouchStart: function onWrapperTouchStart() {
	      this.touchStartTime = new Date();
	    },
	    onWrapperTouchEnd: function onWrapperTouchEnd(event) {
	      var _this3 = this;
	
	      (0, _event.preventDefault)(event);
	      var deltaTime = new Date() - this.touchStartTime;
	
	      var _ref = this.$refs.swipe || {},
	          _ref$offsetX = _ref.offsetX,
	          offsetX = _ref$offsetX === void 0 ? 0 : _ref$offsetX,
	          _ref$offsetY = _ref.offsetY,
	          offsetY = _ref$offsetY === void 0 ? 0 : _ref$offsetY; // prevent long tap to close component
	
	
	      if (deltaTime < 300 && offsetX < 10 && offsetY < 10) {
	        if (!this.doubleClickTimer) {
	          this.doubleClickTimer = setTimeout(function () {
	            _this3.emitClose();
	
	            _this3.doubleClickTimer = null;
	          }, 300);
	        } else {
	          clearTimeout(this.doubleClickTimer);
	          this.doubleClickTimer = null;
	          this.toggleScale();
	        }
	      }
	    },
	    startMove: function startMove(event) {
	      var image = event.currentTarget;
	      var rect = image.getBoundingClientRect();
	      var winWidth = window.innerWidth;
	      var winHeight = window.innerHeight;
	      this.touchStart(event);
	      this.moving = true;
	      this.startMoveX = this.moveX;
	      this.startMoveY = this.moveY;
	      this.maxMoveX = Math.max(0, (rect.width - winWidth) / 2);
	      this.maxMoveY = Math.max(0, (rect.height - winHeight) / 2);
	    },
	    startZoom: function startZoom(event) {
	      this.moving = false;
	      this.zooming = true;
	      this.startScale = this.scale;
	      this.startDistance = getDistance(event.touches);
	    },
	    onImageTouchStart: function onImageTouchStart(event) {
	      var touches = event.touches;
	
	      var _ref2 = this.$refs.swipe || {},
	          _ref2$offsetX = _ref2.offsetX,
	          offsetX = _ref2$offsetX === void 0 ? 0 : _ref2$offsetX;
	
	      if (touches.length === 1 && this.scale !== 1) {
	        this.startMove(event);
	      }
	      /* istanbul ignore else */
	      else if (touches.length === 2 && !offsetX) {
	          this.startZoom(event);
	        }
	    },
	    onImageTouchMove: function onImageTouchMove(event) {
	      var touches = event.touches;
	
	      if (this.moving || this.zooming) {
	        (0, _event.preventDefault)(event, true);
	      }
	
	      if (this.moving) {
	        this.touchMove(event);
	        var moveX = this.deltaX + this.startMoveX;
	        var moveY = this.deltaY + this.startMoveY;
	        this.moveX = (0, _number.range)(moveX, -this.maxMoveX, this.maxMoveX);
	        this.moveY = (0, _number.range)(moveY, -this.maxMoveY, this.maxMoveY);
	      }
	
	      if (this.zooming && touches.length === 2) {
	        var distance = getDistance(touches);
	        var scale = this.startScale * distance / this.startDistance;
	        this.setScale(scale);
	      }
	    },
	    onImageTouchEnd: function onImageTouchEnd(event) {
	      /* istanbul ignore else */
	      if (this.moving || this.zooming) {
	        var stopPropagation = true;
	
	        if (this.moving && this.startMoveX === this.moveX && this.startMoveY === this.moveY) {
	          stopPropagation = false;
	        }
	
	        if (!event.touches.length) {
	          this.moving = false;
	          this.zooming = false;
	          this.startMoveX = 0;
	          this.startMoveY = 0;
	          this.startScale = 1;
	
	          if (this.scale < 1) {
	            this.resetScale();
	          }
	        }
	
	        if (stopPropagation) {
	          (0, _event.preventDefault)(event, true);
	        }
	      }
	    },
	    setActive: function setActive(active) {
	      this.resetScale();
	
	      if (active !== this.active) {
	        this.active = active;
	        this.$emit('change', active);
	      }
	    },
	    setScale: function setScale(scale) {
	      var value = (0, _number.range)(scale, +this.minZoom, +this.maxZoom);
	      this.scale = value;
	      this.$emit('scale', {
	        index: this.active,
	        scale: value
	      });
	    },
	    resetScale: function resetScale() {
	      this.setScale(1);
	      this.moveX = 0;
	      this.moveY = 0;
	    },
	    toggleScale: function toggleScale() {
	      var scale = this.scale > 1 ? 1 : 2;
	      this.setScale(scale);
	      this.moveX = 0;
	      this.moveY = 0;
	    },
	    genIndex: function genIndex() {
	      var h = this.$createElement;
	
	      if (this.showIndex) {
	        return h("div", {
	          "class": bem('index')
	        }, [this.slots('index') || this.active + 1 + " / " + this.images.length]);
	      }
	    },
	    genCover: function genCover() {
	      var h = this.$createElement;
	      var cover = this.slots('cover');
	
	      if (cover) {
	        return h("div", {
	          "class": bem('cover')
	        }, [cover]);
	      }
	    },
	    genImages: function genImages() {
	      var _this4 = this;
	
	      var h = this.$createElement;
	      var imageSlots = {
	        loading: function loading() {
	          return h(_loading.default, {
	            "attrs": {
	              "type": "spinner"
	            }
	          });
	        }
	      };
	      return h(_swipe.default, {
	        "ref": "swipe",
	        "attrs": {
	          "loop": this.loop,
	          "indicatorColor": "white",
	          "duration": this.swipeDuration,
	          "initialSwipe": this.startPosition,
	          "showIndicators": this.showIndicators
	        },
	        "class": bem('swipe'),
	        "on": {
	          "change": this.setActive
	        }
	      }, [this.images.map(function (image, index) {
	        return h(_swipeItem.default, [h(_image.default, {
	          "attrs": {
	            "src": image,
	            "fit": "contain",
	            "lazyLoad": _this4.lazyLoad
	          },
	          "class": bem('image'),
	          "scopedSlots": imageSlots,
	          "style": index === _this4.active ? _this4.imageStyle : null,
	          "nativeOn": {
	            "touchstart": _this4.onImageTouchStart,
	            "touchmove": _this4.onImageTouchMove,
	            "touchend": _this4.onImageTouchEnd,
	            "touchcancel": _this4.onImageTouchEnd
	          }
	        })]);
	      })]);
	    },
	    genClose: function genClose() {
	      var h = this.$createElement;
	
	      if (this.closeable) {
	        return h(_icon.default, {
	          "attrs": {
	            "role": "button",
	            "name": this.closeIcon
	          },
	          "class": bem('close-icon', this.closeIconPosition),
	          "on": {
	            "click": this.emitClose
	          }
	        });
	      }
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	
	    if (!this.shouldRender) {
	      return;
	    }
	
	    return h("transition", {
	      "attrs": {
	        "name": "van-fade"
	      }
	    }, [h("div", {
	      "directives": [{
	        name: "show",
	        value: this.value
	      }],
	      "class": [bem(), this.className]
	    }, [this.genClose(), this.genImages(), this.genIndex(), this.genCover()])]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _relation = __webpack_require__(9);
	
	var _constant = __webpack_require__(7);
	
	var _createNamespace = (0, _utils.createNamespace)('index-anchor'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ChildrenMixin)('vanIndexBar', {
	    indexKey: 'childrenIndex'
	  })],
	  props: {
	    index: [Number, String]
	  },
	  data: function data() {
	    return {
	      top: 0,
	      left: null,
	      width: null,
	      active: false
	    };
	  },
	  computed: {
	    sticky: function sticky() {
	      return this.active && this.parent.sticky;
	    },
	    anchorStyle: function anchorStyle() {
	      if (this.sticky) {
	        return {
	          zIndex: "" + this.parent.zIndex,
	          left: this.left ? this.left + "px" : null,
	          width: this.width ? this.width + "px" : null,
	          transform: "translate3d(0, " + this.top + "px, 0)",
	          color: this.parent.highlightColor
	        };
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.height = this.$el.offsetHeight;
	  },
	  methods: {
	    scrollIntoView: function scrollIntoView() {
	      this.$el.scrollIntoView();
	    }
	  },
	  render: function render() {
	    var _ref;
	
	    var h = arguments[0];
	    var sticky = this.sticky;
	    return h("div", {
	      "style": {
	        height: sticky ? this.height + "px" : null
	      }
	    }, [h("div", {
	      "style": this.anchorStyle,
	      "class": [bem({
	        sticky: sticky
	      }), (_ref = {}, _ref[_constant.BORDER_BOTTOM] = sticky, _ref)]
	    }, [this.slots('default') || this.index])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _style = __webpack_require__(46);
	
	var _event = __webpack_require__(10);
	
	var _scroll = __webpack_require__(22);
	
	var _touch = __webpack_require__(19);
	
	var _relation = __webpack_require__(9);
	
	var _bindEvent = __webpack_require__(36);
	
	// Utils
	// Mixins
	function genAlphabet() {
	  var indexList = [];
	  var charCodeOfA = 'A'.charCodeAt(0);
	
	  for (var i = 0; i < 26; i++) {
	    indexList.push(String.fromCharCode(charCodeOfA + i));
	  }
	
	  return indexList;
	}
	
	var _createNamespace = (0, _utils.createNamespace)('index-bar'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [_touch.TouchMixin, (0, _relation.ParentMixin)('vanIndexBar'), (0, _bindEvent.BindEventMixin)(function (bind) {
	    if (!this.scroller) {
	      this.scroller = (0, _scroll.getScroller)(this.$el);
	    }
	
	    bind(this.scroller, 'scroll', this.onScroll);
	  })],
	  props: {
	    zIndex: [Number, String],
	    highlightColor: String,
	    sticky: {
	      type: Boolean,
	      default: true
	    },
	    stickyOffsetTop: {
	      type: Number,
	      default: 0
	    },
	    indexList: {
	      type: Array,
	      default: genAlphabet
	    }
	  },
	  data: function data() {
	    return {
	      activeAnchorIndex: null
	    };
	  },
	  computed: {
	    sidebarStyle: function sidebarStyle() {
	      if ((0, _utils.isDef)(this.zIndex)) {
	        return {
	          zIndex: this.zIndex + 1
	        };
	      }
	    },
	    highlightStyle: function highlightStyle() {
	      var highlightColor = this.highlightColor;
	
	      if (highlightColor) {
	        return {
	          color: highlightColor
	        };
	      }
	    }
	  },
	  watch: {
	    indexList: function indexList() {
	      this.$nextTick(this.onScroll);
	    }
	  },
	  methods: {
	    onScroll: function onScroll() {
	      var _this = this;
	
	      if ((0, _style.isHidden)(this.$el)) {
	        return;
	      }
	
	      var scrollTop = (0, _scroll.getScrollTop)(this.scroller);
	      var scrollerRect = this.getScrollerRect();
	      var rects = this.children.map(function (item) {
	        return {
	          height: item.height,
	          top: _this.getElementTop(item.$el, scrollerRect)
	        };
	      });
	      var active = this.getActiveAnchorIndex(scrollTop, rects);
	      this.activeAnchorIndex = this.indexList[active];
	
	      if (this.sticky) {
	        this.children.forEach(function (item, index) {
	          if (index === active || index === active - 1) {
	            var rect = item.$el.getBoundingClientRect();
	            item.left = rect.left;
	            item.width = rect.width;
	          } else {
	            item.left = null;
	            item.width = null;
	          }
	
	          if (index === active) {
	            item.active = true;
	            item.top = Math.max(_this.stickyOffsetTop, rects[index].top - scrollTop) + scrollerRect.top;
	          } else if (index === active - 1) {
	            var activeItemTop = rects[active].top - scrollTop;
	            item.active = activeItemTop > 0;
	            item.top = activeItemTop + scrollerRect.top - item.height;
	          } else {
	            item.active = false;
	          }
	        });
	      }
	    },
	    getScrollerRect: function getScrollerRect() {
	      if (this.scroller.getBoundingClientRect) {
	        return this.scroller.getBoundingClientRect();
	      }
	
	      return {
	        top: 0,
	        left: 0
	      };
	    },
	    getElementTop: function getElementTop(ele, scrollerRect) {
	      var scroller = this.scroller;
	
	      if (scroller === window || scroller === document.body) {
	        return (0, _scroll.getElementTop)(ele);
	      }
	
	      var eleRect = ele.getBoundingClientRect();
	      return eleRect.top - scrollerRect.top + (0, _scroll.getScrollTop)(scroller);
	    },
	    getActiveAnchorIndex: function getActiveAnchorIndex(scrollTop, rects) {
	      for (var i = this.children.length - 1; i >= 0; i--) {
	        var prevHeight = i > 0 ? rects[i - 1].height : 0;
	        var reachTop = this.sticky ? prevHeight + this.stickyOffsetTop : 0;
	
	        if (scrollTop + reachTop >= rects[i].top) {
	          return i;
	        }
	      }
	
	      return -1;
	    },
	    onClick: function onClick(event) {
	      this.scrollToElement(event.target);
	    },
	    onTouchMove: function onTouchMove(event) {
	      this.touchMove(event);
	
	      if (this.direction === 'vertical') {
	        (0, _event.preventDefault)(event);
	        var _event$touches$ = event.touches[0],
	            clientX = _event$touches$.clientX,
	            clientY = _event$touches$.clientY;
	        var target = document.elementFromPoint(clientX, clientY);
	
	        if (target) {
	          var index = target.dataset.index;
	          /* istanbul ignore else */
	
	          if (this.touchActiveIndex !== index) {
	            this.touchActiveIndex = index;
	            this.scrollToElement(target);
	          }
	        }
	      }
	    },
	    scrollToElement: function scrollToElement(element) {
	      var index = element.dataset.index;
	
	      if (!index) {
	        return;
	      }
	
	      var match = this.children.filter(function (item) {
	        return String(item.index) === index;
	      });
	
	      if (match[0]) {
	        match[0].scrollIntoView();
	
	        if (this.sticky && this.stickyOffsetTop) {
	          (0, _scroll.setRootScrollTop)((0, _scroll.getRootScrollTop)() - this.stickyOffsetTop);
	        }
	
	        this.$emit('select', match[0].index);
	      }
	    },
	    onTouchEnd: function onTouchEnd() {
	      this.active = null;
	    }
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var h = arguments[0];
	    var Indexes = this.indexList.map(function (index) {
	      var active = index === _this2.activeAnchorIndex;
	      return h("span", {
	        "class": bem('index', {
	          active: active
	        }),
	        "style": active ? _this2.highlightStyle : null,
	        "attrs": {
	          "data-index": index
	        }
	      }, [index]);
	    });
	    return h("div", {
	      "class": bem()
	    }, [h("div", {
	      "class": bem('sidebar'),
	      "style": this.sidebarStyle,
	      "on": {
	        "click": this.onClick,
	        "touchstart": this.touchStart,
	        "touchmove": this.onTouchMove,
	        "touchend": this.onTouchEnd,
	        "touchcancel": this.onTouchEnd
	      }
	    }, [Indexes]), this.slots('default')]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.install = install;
	exports.default = exports.version = void 0;
	
	var _actionSheet = _interopRequireDefault(__webpack_require__(312));
	
	exports.ActionSheet = _actionSheet.default;
	
	var _addressEdit = _interopRequireDefault(__webpack_require__(314));
	
	exports.AddressEdit = _addressEdit.default;
	
	var _addressList = _interopRequireDefault(__webpack_require__(316));
	
	exports.AddressList = _addressList.default;
	
	var _area = _interopRequireDefault(__webpack_require__(141));
	
	exports.Area = _area.default;
	
	var _button = _interopRequireDefault(__webpack_require__(17));
	
	exports.Button = _button.default;
	
	var _calendar = _interopRequireDefault(__webpack_require__(319));
	
	exports.Calendar = _calendar.default;
	
	var _card = _interopRequireDefault(__webpack_require__(320));
	
	exports.Card = _card.default;
	
	var _cell = _interopRequireDefault(__webpack_require__(15));
	
	exports.Cell = _cell.default;
	
	var _cellGroup = _interopRequireDefault(__webpack_require__(91));
	
	exports.CellGroup = _cellGroup.default;
	
	var _checkbox = _interopRequireDefault(__webpack_require__(142));
	
	exports.Checkbox = _checkbox.default;
	
	var _checkboxGroup = _interopRequireDefault(__webpack_require__(321));
	
	exports.CheckboxGroup = _checkboxGroup.default;
	
	var _circle = _interopRequireDefault(__webpack_require__(322));
	
	exports.Circle = _circle.default;
	
	var _col = _interopRequireDefault(__webpack_require__(323));
	
	exports.Col = _col.default;
	
	var _collapse = _interopRequireDefault(__webpack_require__(325));
	
	exports.Collapse = _collapse.default;
	
	var _collapseItem = _interopRequireDefault(__webpack_require__(324));
	
	exports.CollapseItem = _collapseItem.default;
	
	var _contactCard = _interopRequireDefault(__webpack_require__(326));
	
	exports.ContactCard = _contactCard.default;
	
	var _contactEdit = _interopRequireDefault(__webpack_require__(327));
	
	exports.ContactEdit = _contactEdit.default;
	
	var _contactList = _interopRequireDefault(__webpack_require__(328));
	
	exports.ContactList = _contactList.default;
	
	var _countDown = _interopRequireDefault(__webpack_require__(329));
	
	exports.CountDown = _countDown.default;
	
	var _coupon = _interopRequireDefault(__webpack_require__(143));
	
	exports.Coupon = _coupon.default;
	
	var _couponCell = _interopRequireDefault(__webpack_require__(331));
	
	exports.CouponCell = _couponCell.default;
	
	var _couponList = _interopRequireDefault(__webpack_require__(332));
	
	exports.CouponList = _couponList.default;
	
	var _datetimePicker = _interopRequireDefault(__webpack_require__(335));
	
	exports.DatetimePicker = _datetimePicker.default;
	
	var _dialog = _interopRequireDefault(__webpack_require__(94));
	
	exports.Dialog = _dialog.default;
	
	var _divider = _interopRequireDefault(__webpack_require__(337));
	
	exports.Divider = _divider.default;
	
	var _dropdownItem = _interopRequireDefault(__webpack_require__(338));
	
	exports.DropdownItem = _dropdownItem.default;
	
	var _dropdownMenu = _interopRequireDefault(__webpack_require__(339));
	
	exports.DropdownMenu = _dropdownMenu.default;
	
	var _field = _interopRequireDefault(__webpack_require__(34));
	
	exports.Field = _field.default;
	
	var _form = _interopRequireDefault(__webpack_require__(340));
	
	exports.Form = _form.default;
	
	var _goodsAction = _interopRequireDefault(__webpack_require__(343));
	
	exports.GoodsAction = _goodsAction.default;
	
	var _goodsActionButton = _interopRequireDefault(__webpack_require__(341));
	
	exports.GoodsActionButton = _goodsActionButton.default;
	
	var _goodsActionIcon = _interopRequireDefault(__webpack_require__(342));
	
	exports.GoodsActionIcon = _goodsActionIcon.default;
	
	var _grid = _interopRequireDefault(__webpack_require__(345));
	
	exports.Grid = _grid.default;
	
	var _gridItem = _interopRequireDefault(__webpack_require__(344));
	
	exports.GridItem = _gridItem.default;
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	exports.Icon = _icon.default;
	
	var _image = _interopRequireDefault(__webpack_require__(60));
	
	exports.Image = _image.default;
	
	var _imagePreview = _interopRequireDefault(__webpack_require__(95));
	
	exports.ImagePreview = _imagePreview.default;
	
	var _indexAnchor = _interopRequireDefault(__webpack_require__(347));
	
	exports.IndexAnchor = _indexAnchor.default;
	
	var _indexBar = _interopRequireDefault(__webpack_require__(348));
	
	exports.IndexBar = _indexBar.default;
	
	var _info = _interopRequireDefault(__webpack_require__(35));
	
	exports.Info = _info.default;
	
	var _lazyload = _interopRequireDefault(__webpack_require__(350));
	
	exports.Lazyload = _lazyload.default;
	
	var _list = _interopRequireDefault(__webpack_require__(351));
	
	exports.List = _list.default;
	
	var _loading = _interopRequireDefault(__webpack_require__(18));
	
	exports.Loading = _loading.default;
	
	var _locale = _interopRequireDefault(__webpack_require__(61));
	
	exports.Locale = _locale.default;
	
	var _navBar = _interopRequireDefault(__webpack_require__(356));
	
	exports.NavBar = _navBar.default;
	
	var _noticeBar = _interopRequireDefault(__webpack_require__(357));
	
	exports.NoticeBar = _noticeBar.default;
	
	var _notify = _interopRequireDefault(__webpack_require__(359));
	
	exports.Notify = _notify.default;
	
	var _numberKeyboard = _interopRequireDefault(__webpack_require__(361));
	
	exports.NumberKeyboard = _numberKeyboard.default;
	
	var _overlay = _interopRequireDefault(__webpack_require__(150));
	
	exports.Overlay = _overlay.default;
	
	var _pagination = _interopRequireDefault(__webpack_require__(362));
	
	exports.Pagination = _pagination.default;
	
	var _panel = _interopRequireDefault(__webpack_require__(363));
	
	exports.Panel = _panel.default;
	
	var _passwordInput = _interopRequireDefault(__webpack_require__(364));
	
	exports.PasswordInput = _passwordInput.default;
	
	var _picker = _interopRequireDefault(__webpack_require__(96));
	
	exports.Picker = _picker.default;
	
	var _popup = _interopRequireDefault(__webpack_require__(37));
	
	exports.Popup = _popup.default;
	
	var _progress = _interopRequireDefault(__webpack_require__(366));
	
	exports.Progress = _progress.default;
	
	var _pullRefresh = _interopRequireDefault(__webpack_require__(367));
	
	exports.PullRefresh = _pullRefresh.default;
	
	var _radio = _interopRequireDefault(__webpack_require__(99));
	
	exports.Radio = _radio.default;
	
	var _radioGroup = _interopRequireDefault(__webpack_require__(98));
	
	exports.RadioGroup = _radioGroup.default;
	
	var _rate = _interopRequireDefault(__webpack_require__(368));
	
	exports.Rate = _rate.default;
	
	var _row = _interopRequireDefault(__webpack_require__(369));
	
	exports.Row = _row.default;
	
	var _search = _interopRequireDefault(__webpack_require__(370));
	
	exports.Search = _search.default;
	
	var _sidebar = _interopRequireDefault(__webpack_require__(152));
	
	exports.Sidebar = _sidebar.default;
	
	var _sidebarItem = _interopRequireDefault(__webpack_require__(151));
	
	exports.SidebarItem = _sidebarItem.default;
	
	var _skeleton = _interopRequireDefault(__webpack_require__(371));
	
	exports.Skeleton = _skeleton.default;
	
	var _sku = _interopRequireDefault(__webpack_require__(374));
	
	exports.Sku = _sku.default;
	
	var _slider = _interopRequireDefault(__webpack_require__(376));
	
	exports.Slider = _slider.default;
	
	var _step = _interopRequireDefault(__webpack_require__(377));
	
	exports.Step = _step.default;
	
	var _stepper = _interopRequireDefault(__webpack_require__(161));
	
	exports.Stepper = _stepper.default;
	
	var _steps = _interopRequireDefault(__webpack_require__(378));
	
	exports.Steps = _steps.default;
	
	var _sticky = _interopRequireDefault(__webpack_require__(162));
	
	exports.Sticky = _sticky.default;
	
	var _submitBar = _interopRequireDefault(__webpack_require__(379));
	
	exports.SubmitBar = _submitBar.default;
	
	var _swipe = _interopRequireDefault(__webpack_require__(164));
	
	exports.Swipe = _swipe.default;
	
	var _swipeCell = _interopRequireDefault(__webpack_require__(380));
	
	exports.SwipeCell = _swipeCell.default;
	
	var _swipeItem = _interopRequireDefault(__webpack_require__(163));
	
	exports.SwipeItem = _swipeItem.default;
	
	var _switch = _interopRequireDefault(__webpack_require__(101));
	
	exports.Switch = _switch.default;
	
	var _switchCell = _interopRequireDefault(__webpack_require__(165));
	
	exports.SwitchCell = _switchCell.default;
	
	var _tab = _interopRequireDefault(__webpack_require__(167));
	
	exports.Tab = _tab.default;
	
	var _tabbar = _interopRequireDefault(__webpack_require__(382));
	
	exports.Tabbar = _tabbar.default;
	
	var _tabbarItem = _interopRequireDefault(__webpack_require__(381));
	
	exports.TabbarItem = _tabbarItem.default;
	
	var _tabs = _interopRequireDefault(__webpack_require__(168));
	
	exports.Tabs = _tabs.default;
	
	var _tag = _interopRequireDefault(__webpack_require__(63));
	
	exports.Tag = _tag.default;
	
	var _toast = _interopRequireDefault(__webpack_require__(64));
	
	exports.Toast = _toast.default;
	
	var _treeSelect = _interopRequireDefault(__webpack_require__(388));
	
	exports.TreeSelect = _treeSelect.default;
	
	var _uploader = _interopRequireDefault(__webpack_require__(169));
	
	exports.Uploader = _uploader.default;
	var version = '2.5.5';
	exports.version = version;
	
	function install(Vue) {
	  var components = [_actionSheet.default, _addressEdit.default, _addressList.default, _area.default, _button.default, _calendar.default, _card.default, _cell.default, _cellGroup.default, _checkbox.default, _checkboxGroup.default, _circle.default, _col.default, _collapse.default, _collapseItem.default, _contactCard.default, _contactEdit.default, _contactList.default, _countDown.default, _coupon.default, _couponCell.default, _couponList.default, _datetimePicker.default, _dialog.default, _divider.default, _dropdownItem.default, _dropdownMenu.default, _field.default, _form.default, _goodsAction.default, _goodsActionButton.default, _goodsActionIcon.default, _grid.default, _gridItem.default, _icon.default, _image.default, _imagePreview.default, _indexAnchor.default, _indexBar.default, _info.default, _list.default, _loading.default, _locale.default, _navBar.default, _noticeBar.default, _notify.default, _numberKeyboard.default, _overlay.default, _pagination.default, _panel.default, _passwordInput.default, _picker.default, _popup.default, _progress.default, _pullRefresh.default, _radio.default, _radioGroup.default, _rate.default, _row.default, _search.default, _sidebar.default, _sidebarItem.default, _skeleton.default, _sku.default, _slider.default, _step.default, _stepper.default, _steps.default, _sticky.default, _submitBar.default, _swipe.default, _swipeCell.default, _swipeItem.default, _switch.default, _switchCell.default, _tab.default, _tabbar.default, _tabbarItem.default, _tabs.default, _tag.default, _toast.default, _treeSelect.default, _uploader.default];
	  components.forEach(function (item) {
	    if (item.install) {
	      Vue.use(item);
	    } else if (item.name) {
	      Vue.component(item.name, item);
	    }
	  });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	  install(window.Vue);
	}
	
	var _default = {
	  install: install,
	  version: version
	};
	exports.default = _default;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _vueLazyload = _interopRequireDefault(__webpack_require__(397));
	
	var _default = _vueLazyload.default;
	exports.default = _default;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _style = __webpack_require__(46);
	
	var _scroll = __webpack_require__(22);
	
	var _bindEvent = __webpack_require__(36);
	
	var _loading = _interopRequireDefault(__webpack_require__(18));
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('list'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	var _default = createComponent({
	  mixins: [(0, _bindEvent.BindEventMixin)(function (bind) {
	    if (!this.scroller) {
	      this.scroller = (0, _scroll.getScroller)(this.$el);
	    }
	
	    bind(this.scroller, 'scroll', this.check);
	  })],
	  model: {
	    prop: 'loading'
	  },
	  props: {
	    error: Boolean,
	    loading: Boolean,
	    finished: Boolean,
	    errorText: String,
	    loadingText: String,
	    finishedText: String,
	    immediateCheck: {
	      type: Boolean,
	      default: true
	    },
	    offset: {
	      type: [Number, String],
	      default: 300
	    },
	    direction: {
	      type: String,
	      default: 'down'
	    }
	  },
	  data: function data() {
	    return {
	      // use sync innerLoading state to avoid repeated loading in some edge cases
	      innerLoading: this.loading
	    };
	  },
	  updated: function updated() {
	    this.innerLoading = this.loading;
	  },
	  mounted: function mounted() {
	    if (this.immediateCheck) {
	      this.check();
	    }
	  },
	  watch: {
	    loading: 'check',
	    finished: 'check'
	  },
	  methods: {
	    // @exposed-api
	    check: function check() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        if (_this.innerLoading || _this.finished || _this.error) {
	          return;
	        }
	
	        var el = _this.$el,
	            scroller = _this.scroller,
	            offset = _this.offset,
	            direction = _this.direction;
	        var scrollerRect;
	
	        if (scroller.getBoundingClientRect) {
	          scrollerRect = scroller.getBoundingClientRect();
	        } else {
	          scrollerRect = {
	            top: 0,
	            bottom: scroller.innerHeight
	          };
	        }
	
	        var scrollerHeight = scrollerRect.bottom - scrollerRect.top;
	        /* istanbul ignore next */
	
	        if (!scrollerHeight || (0, _style.isHidden)(el)) {
	          return false;
	        }
	
	        var isReachEdge = false;
	
	        var placeholderRect = _this.$refs.placeholder.getBoundingClientRect();
	
	        if (direction === 'up') {
	          isReachEdge = scrollerRect.top - placeholderRect.top <= offset;
	        } else {
	          isReachEdge = placeholderRect.bottom - scrollerRect.bottom <= offset;
	        }
	
	        if (isReachEdge) {
	          _this.innerLoading = true;
	
	          _this.$emit('input', true);
	
	          _this.$emit('load');
	        }
	      });
	    },
	    clickErrorText: function clickErrorText() {
	      this.$emit('update:error', false);
	      this.check();
	    },
	    genLoading: function genLoading() {
	      var h = this.$createElement;
	
	      if (this.innerLoading && !this.finished) {
	        return h("div", {
	          "class": bem('loading'),
	          "key": "loading"
	        }, [this.slots('loading') || h(_loading.default, {
	          "attrs": {
	            "size": "16"
	          }
	        }, [this.loadingText || t('loading')])]);
	      }
	    },
	    genFinishedText: function genFinishedText() {
	      var h = this.$createElement;
	
	      if (this.finished) {
	        var text = this.slots('finished') || this.finishedText;
	
	        if (text) {
	          return h("div", {
	            "class": bem('finished-text')
	          }, [text]);
	        }
	      }
	    },
	    genErrorText: function genErrorText() {
	      var h = this.$createElement;
	
	      if (this.error) {
	        var text = this.slots('error') || this.errorText;
	
	        if (text) {
	          return h("div", {
	            "on": {
	              "click": this.clickErrorText
	            },
	            "class": bem('error-text')
	          }, [text]);
	        }
	      }
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    var Placeholder = h("div", {
	      "ref": "placeholder",
	      "class": bem('placeholder')
	    });
	    return h("div", {
	      "class": bem(),
	      "attrs": {
	        "role": "feed",
	        "aria-busy": this.innerLoading
	      }
	    }, [this.direction === 'down' ? this.slots() : Placeholder, this.genLoading(), this.genFinishedText(), this.genErrorText(), this.direction === 'up' ? this.slots() : Placeholder]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  name: '姓名',
	  tel: '电话',
	  save: '保存',
	  confirm: '确认',
	  cancel: '取消',
	  delete: '删除',
	  complete: '完成',
	  loading: '加载中...',
	  telEmpty: '请填写电话',
	  nameEmpty: '请填写姓名',
	  nameInvalid: '请输入正确的姓名',
	  confirmDelete: '确定要删除吗',
	  telInvalid: '请输入正确的手机号',
	  vanCalendar: {
	    end: '结束',
	    start: '开始',
	    title: '日期选择',
	    confirm: '确定',
	    weekdays: ['日', '一', '二', '三', '四', '五', '六'],
	    monthTitle: function monthTitle(year, month) {
	      return year + "\u5E74" + month + "\u6708";
	    },
	    rangePrompt: function rangePrompt(maxRange) {
	      return "\u9009\u62E9\u5929\u6570\u4E0D\u80FD\u8D85\u8FC7 " + maxRange + " \u5929";
	    }
	  },
	  vanContactCard: {
	    addText: '添加联系人'
	  },
	  vanContactList: {
	    addText: '新建联系人'
	  },
	  vanPagination: {
	    prev: '上一页',
	    next: '下一页'
	  },
	  vanPullRefresh: {
	    pulling: '下拉即可刷新...',
	    loosing: '释放即可刷新...'
	  },
	  vanSubmitBar: {
	    label: '合计：'
	  },
	  vanCoupon: {
	    unlimited: '无使用门槛',
	    discount: function discount(_discount) {
	      return _discount + "\u6298";
	    },
	    condition: function condition(_condition) {
	      return "\u6EE1" + _condition + "\u5143\u53EF\u7528";
	    }
	  },
	  vanCouponCell: {
	    title: '优惠券',
	    tips: '暂无可用',
	    count: function count(_count) {
	      return _count + "\u5F20\u53EF\u7528";
	    }
	  },
	  vanCouponList: {
	    empty: '暂无优惠券',
	    exchange: '兑换',
	    close: '不使用优惠券',
	    enable: '可用',
	    disabled: '不可用',
	    placeholder: '请输入优惠码'
	  },
	  vanAddressEdit: {
	    area: '地区',
	    postal: '邮政编码',
	    areaEmpty: '请选择地区',
	    addressEmpty: '请填写详细地址',
	    postalEmpty: '邮政编码格式不正确',
	    defaultAddress: '设为默认收货地址',
	    telPlaceholder: '收货人手机号',
	    namePlaceholder: '收货人姓名',
	    areaPlaceholder: '选择省 / 市 / 区'
	  },
	  vanAddressEditDetail: {
	    label: '详细地址',
	    placeholder: '街道门牌、楼层房间号等信息'
	  },
	  vanAddressList: {
	    add: '新增地址'
	  }
	};
	exports.default = _default;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.CloseOnPopstateMixin = void 0;
	
	var _event = __webpack_require__(10);
	
	var _bindEvent = __webpack_require__(36);
	
	var CloseOnPopstateMixin = {
	  mixins: [(0, _bindEvent.BindEventMixin)(function (bind, isBind) {
	    this.handlePopstate(isBind && this.closeOnPopstate);
	  })],
	  props: {
	    closeOnPopstate: Boolean
	  },
	  data: function data() {
	    return {
	      bindStatus: false
	    };
	  },
	  watch: {
	    closeOnPopstate: function closeOnPopstate(val) {
	      this.handlePopstate(val);
	    }
	  },
	  methods: {
	    handlePopstate: function handlePopstate(bind) {
	      var _this = this;
	
	      /* istanbul ignore if */
	      if (this.$isServer) {
	        return;
	      }
	
	      if (this.bindStatus !== bind) {
	        this.bindStatus = bind;
	        var action = bind ? _event.on : _event.off;
	        action(window, 'popstate', function () {
	          _this.close();
	
	          _this.shouldReopen = false;
	        });
	      }
	    }
	  }
	};
	exports.CloseOnPopstateMixin = CloseOnPopstateMixin;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.updateOverlay = updateOverlay;
	exports.openOverlay = openOverlay;
	exports.closeOverlay = closeOverlay;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _overlay = _interopRequireDefault(__webpack_require__(150));
	
	var _context = __webpack_require__(148);
	
	var _functional = __webpack_require__(5);
	
	var defaultConfig = {
	  className: '',
	  customStyle: {}
	};
	var overlay; // close popup when click overlay && closeOnClickOverlay is true
	
	function onClickOverlay() {
	  if (_context.context.top) {
	    var vm = _context.context.top.vm;
	    vm.$emit('click-overlay');
	
	    if (vm.closeOnClickOverlay) {
	      if (vm.onClickOverlay) {
	        vm.onClickOverlay();
	      } else {
	        vm.close();
	      }
	    }
	  }
	}
	
	function mountOverlay() {
	  overlay = (0, _functional.mount)(_overlay.default, {
	    on: {
	      click: onClickOverlay
	    }
	  });
	}
	
	function updateOverlay() {
	  if (!overlay) {
	    mountOverlay();
	  }
	
	  if (_context.context.top) {
	    var _context$top = _context.context.top,
	        vm = _context$top.vm,
	        config = _context$top.config;
	    var el = vm.$el;
	
	    if (el && el.parentNode) {
	      el.parentNode.insertBefore(overlay.$el, el);
	    } else {
	      document.body.appendChild(overlay.$el);
	    }
	
	    (0, _extends2.default)(overlay, defaultConfig, config, {
	      show: true
	    });
	  } else {
	    overlay.show = false;
	  }
	}
	
	function openOverlay(vm, config) {
	  if (!_context.context.stack.some(function (item) {
	    return item.vm === vm;
	  })) {
	    _context.context.stack.push({
	      vm: vm,
	      config: config
	    });
	
	    updateOverlay();
	  }
	}
	
	function closeOverlay(vm) {
	  var stack = _context.context.stack;
	
	  if (stack.length) {
	    if (_context.context.top.vm === vm) {
	      stack.pop();
	      updateOverlay();
	    } else {
	      _context.context.stack = stack.filter(function (item) {
	        return item.vm !== vm;
	      });
	    }
	  }
	}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.SlotsMixin = void 0;
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	/**
	 * Use scopedSlots in Vue 2.6+
	 * downgrade to slots in lower version
	 */
	var SlotsMixin = _vue.default.extend({
	  methods: {
	    slots: function slots(name, props) {
	      if (name === void 0) {
	        name = 'default';
	      }
	
	      var $slots = this.$slots,
	          $scopedSlots = this.$scopedSlots;
	      var scopedSlot = $scopedSlots[name];
	
	      if (scopedSlot) {
	        return scopedSlot(props);
	      }
	
	      return $slots[name];
	    }
	  }
	});
	
	exports.SlotsMixin = SlotsMixin;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _constant = __webpack_require__(7);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('nav-bar'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function NavBar(h, props, slots, ctx) {
	  var _ref;
	
	  function LeftPart() {
	    if (slots.left) {
	      return slots.left();
	    }
	
	    return [props.leftArrow && h(_icon.default, {
	      "class": bem('arrow'),
	      "attrs": {
	        "name": "arrow-left"
	      }
	    }), props.leftText && h("span", {
	      "class": bem('text')
	    }, [props.leftText])];
	  }
	
	  function RightPart() {
	    if (slots.right) {
	      return slots.right();
	    }
	
	    if (props.rightText) {
	      return h("span", {
	        "class": bem('text')
	      }, [props.rightText]);
	    }
	  }
	
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "style": {
	      zIndex: props.zIndex
	    },
	    "class": [bem({
	      fixed: props.fixed
	    }), (_ref = {}, _ref[_constant.BORDER_BOTTOM] = props.border, _ref)]
	  }, (0, _functional.inherit)(ctx)]), [h("div", {
	    "class": bem('left'),
	    "on": {
	      "click": ctx.listeners['click-left'] || _utils.noop
	    }
	  }, [LeftPart()]), h("div", {
	    "class": [bem('title'), 'van-ellipsis']
	  }, [slots.title ? slots.title() : props.title]), h("div", {
	    "class": bem('right'),
	    "on": {
	      "click": ctx.listeners['click-right'] || _utils.noop
	    }
	  }, [RightPart()])]);
	}
	
	NavBar.props = {
	  title: String,
	  fixed: Boolean,
	  zIndex: [Number, String],
	  leftText: String,
	  rightText: String,
	  leftArrow: Boolean,
	  border: {
	    type: Boolean,
	    default: true
	  }
	};
	
	var _default = createComponent(NavBar);
	
	exports.default = _default;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _createNamespace = (0, _utils.createNamespace)('notice-bar'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  props: {
	    text: String,
	    mode: String,
	    color: String,
	    leftIcon: String,
	    wrapable: Boolean,
	    background: String,
	    scrollable: {
	      type: Boolean,
	      default: true
	    },
	    delay: {
	      type: [Number, String],
	      default: 1
	    },
	    speed: {
	      type: [Number, String],
	      default: 50
	    }
	  },
	  data: function data() {
	    return {
	      wrapWidth: 0,
	      firstRound: true,
	      duration: 0,
	      offsetWidth: 0,
	      showNoticeBar: true,
	      animationClass: ''
	    };
	  },
	  watch: {
	    text: {
	      handler: function handler() {
	        var _this = this;
	
	        this.$nextTick(function () {
	          var _this$$refs = _this.$refs,
	              wrap = _this$$refs.wrap,
	              content = _this$$refs.content;
	
	          if (!wrap || !content) {
	            return;
	          }
	
	          var wrapWidth = wrap.getBoundingClientRect().width;
	          var offsetWidth = content.getBoundingClientRect().width;
	
	          if (_this.scrollable && offsetWidth > wrapWidth) {
	            _this.wrapWidth = wrapWidth;
	            _this.offsetWidth = offsetWidth;
	            _this.duration = offsetWidth / _this.speed;
	            _this.animationClass = bem('play');
	          }
	        });
	      },
	      immediate: true
	    }
	  },
	  methods: {
	    onClickIcon: function onClickIcon(event) {
	      if (this.mode === 'closeable') {
	        this.showNoticeBar = false;
	        this.$emit('close', event);
	      }
	    },
	    onAnimationEnd: function onAnimationEnd() {
	      var _this2 = this;
	
	      this.firstRound = false;
	      this.$nextTick(function () {
	        _this2.duration = (_this2.offsetWidth + _this2.wrapWidth) / _this2.speed;
	        _this2.animationClass = bem('play--infinite');
	      });
	    }
	  },
	  render: function render() {
	    var _this3 = this;
	
	    var h = arguments[0];
	    var slots = this.slots,
	        mode = this.mode,
	        leftIcon = this.leftIcon,
	        onClickIcon = this.onClickIcon;
	    var barStyle = {
	      color: this.color,
	      background: this.background
	    };
	    var contentStyle = {
	      paddingLeft: this.firstRound ? 0 : this.wrapWidth + 'px',
	      animationDelay: (this.firstRound ? this.delay : 0) + 's',
	      animationDuration: this.duration + 's'
	    };
	
	    function LeftIcon() {
	      var slot = slots('left-icon');
	
	      if (slot) {
	        return slot;
	      }
	
	      if (leftIcon) {
	        return h(_icon.default, {
	          "class": bem('left-icon'),
	          "attrs": {
	            "name": leftIcon
	          }
	        });
	      }
	    }
	
	    function RightIcon() {
	      var slot = slots('right-icon');
	
	      if (slot) {
	        return slot;
	      }
	
	      var iconName;
	
	      if (mode === 'closeable') {
	        iconName = 'cross';
	      } else if (mode === 'link') {
	        iconName = 'arrow';
	      }
	
	      if (iconName) {
	        return h(_icon.default, {
	          "class": bem('right-icon'),
	          "attrs": {
	            "name": iconName
	          },
	          "on": {
	            "click": onClickIcon
	          }
	        });
	      }
	    }
	
	    return h("div", {
	      "attrs": {
	        "role": "alert"
	      },
	      "directives": [{
	        name: "show",
	        value: this.showNoticeBar
	      }],
	      "class": bem({
	        wrapable: this.wrapable
	      }),
	      "style": barStyle,
	      "on": {
	        "click": function click(event) {
	          _this3.$emit('click', event);
	        }
	      }
	    }, [LeftIcon(), h("div", {
	      "ref": "wrap",
	      "class": bem('wrap'),
	      "attrs": {
	        "role": "marquee"
	      }
	    }, [h("div", {
	      "ref": "content",
	      "class": [bem('content'), this.animationClass, {
	        'van-ellipsis': !this.scrollable && !this.wrapable
	      }],
	      "style": contentStyle,
	      "on": {
	        "animationend": this.onAnimationEnd,
	        "webkitAnimationEnd": this.onAnimationEnd
	      }
	    }, [this.slots() || this.text])]), RightIcon()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _popup = __webpack_require__(39);
	
	var _popup2 = _interopRequireDefault(__webpack_require__(37));
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('notify'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function Notify(h, props, slots, ctx) {
	  var style = {
	    color: props.color,
	    background: props.background
	  };
	  return h(_popup2.default, (0, _babelHelperVueJsxMergeProps.default)([{
	    "attrs": {
	      "value": props.value,
	      "position": "top",
	      "overlay": false,
	      "duration": 0.2,
	      "lockScroll": false
	    },
	    "style": style,
	    "class": [bem([props.type]), props.className]
	  }, (0, _functional.inherit)(ctx, true)]), [props.message]);
	}
	
	Notify.props = (0, _extends2.default)({}, _popup.popupMixinProps, {
	  color: String,
	  message: [Number, String],
	  duration: [Number, String],
	  className: null,
	  background: String,
	  getContainer: [String, Function],
	  type: {
	    type: String,
	    default: 'danger'
	  }
	});
	
	var _default = createComponent(Notify);
	
	exports.default = _default;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	var _Notify = _interopRequireDefault(__webpack_require__(358));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var timer;
	var instance;
	
	function parseOptions(message) {
	  return (0, _utils.isObject)(message) ? message : {
	    message: message
	  };
	}
	
	function Notify(options) {
	  /* istanbul ignore if */
	  if (_utils.isServer) {
	    return;
	  }
	
	  if (!instance) {
	    instance = (0, _functional.mount)(_Notify.default, {
	      on: {
	        click: function click(event) {
	          if (instance.onClick) {
	            instance.onClick(event);
	          }
	        },
	        close: function close() {
	          if (instance.onClose) {
	            instance.onClose();
	          }
	        },
	        opened: function opened() {
	          if (instance.onOpened) {
	            instance.onOpened();
	          }
	        }
	      }
	    });
	  }
	
	  options = (0, _extends2.default)({}, Notify.currentOptions, {}, parseOptions(options));
	  (0, _extends2.default)(instance, options);
	  clearTimeout(timer);
	
	  if (options.duration && options.duration > 0) {
	    timer = setTimeout(Notify.clear, options.duration);
	  }
	
	  return instance;
	}
	
	function defaultOptions() {
	  return {
	    type: 'danger',
	    value: true,
	    message: '',
	    color: undefined,
	    background: undefined,
	    duration: 3000,
	    className: '',
	    onClose: null,
	    onClick: null,
	    onOpened: null
	  };
	}
	
	Notify.clear = function () {
	  if (instance) {
	    instance.value = false;
	  }
	};
	
	Notify.currentOptions = defaultOptions();
	
	Notify.setDefaultOptions = function (options) {
	  (0, _extends2.default)(Notify.currentOptions, options);
	};
	
	Notify.resetDefaultOptions = function () {
	  Notify.currentOptions = defaultOptions();
	};
	
	Notify.install = function () {
	  _vue.default.use(_Notify.default);
	};
	
	_vue.default.prototype.$notify = Notify;
	var _default = Notify;
	exports.default = _default;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _touch = __webpack_require__(19);
	
	var _constant = __webpack_require__(7);
	
	var _createNamespace = (0, _utils.createNamespace)('key'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default2 = createComponent({
	  mixins: [_touch.TouchMixin],
	  props: {
	    type: String,
	    text: [Number, String],
	    theme: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      active: false
	    };
	  },
	  computed: {
	    className: function className() {
	      var classNames = this.theme.slice(0);
	
	      if (this.active) {
	        classNames.push('active');
	      }
	
	      if (this.type) {
	        classNames.push(this.type);
	      }
	
	      return bem(classNames);
	    }
	  },
	  mounted: function mounted() {
	    this.bindTouchEvent(this.$el);
	  },
	  methods: {
	    onTouchStart: function onTouchStart(event) {
	      // compatible with Vue 2.6 event bubble bug
	      event.stopPropagation();
	      this.touchStart(event);
	      this.active = true;
	    },
	    onTouchMove: function onTouchMove(event) {
	      this.touchMove(event);
	
	      if (this.direction) {
	        this.active = false;
	      }
	    },
	    onTouchEnd: function onTouchEnd() {
	      if (this.active) {
	        this.active = false;
	        this.$emit('press', this.text, this.type);
	      }
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("i", {
	      "attrs": {
	        "role": "button",
	        "tabindex": "0"
	      },
	      "class": [_constant.BORDER, this.className]
	    }, [this.slots('default') || this.text]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _event = __webpack_require__(10);
	
	var _constant = __webpack_require__(7);
	
	var _bindEvent = __webpack_require__(36);
	
	var _Key = _interopRequireDefault(__webpack_require__(360));
	
	var _createNamespace = (0, _utils.createNamespace)('number-keyboard'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	var CLOSE_KEY_THEME = ['blue', 'big'];
	var DELETE_KEY_THEME = ['delete', 'big', 'gray'];
	
	var _default = createComponent({
	  mixins: [(0, _bindEvent.BindEventMixin)(function (bind) {
	    if (this.hideOnClickOutside) {
	      bind(document.body, 'touchstart', this.onBlur);
	    }
	  })],
	  model: {
	    event: 'update:value'
	  },
	  props: {
	    show: Boolean,
	    title: String,
	    zIndex: [Number, String],
	    closeButtonText: String,
	    deleteButtonText: String,
	    theme: {
	      type: String,
	      default: 'default'
	    },
	    value: {
	      type: String,
	      default: ''
	    },
	    extraKey: {
	      type: String,
	      default: ''
	    },
	    maxlength: {
	      type: [Number, String],
	      default: Number.MAX_VALUE
	    },
	    transition: {
	      type: Boolean,
	      default: true
	    },
	    showDeleteKey: {
	      type: Boolean,
	      default: true
	    },
	    hideOnClickOutside: {
	      type: Boolean,
	      default: true
	    },
	    safeAreaInsetBottom: {
	      type: Boolean,
	      default: true
	    }
	  },
	  watch: {
	    show: function show(val) {
	      if (!this.transition) {
	        this.$emit(val ? 'show' : 'hide');
	      }
	    }
	  },
	  computed: {
	    keys: function keys() {
	      var keys = [];
	
	      for (var i = 1; i <= 9; i++) {
	        keys.push({
	          text: i
	        });
	      }
	
	      switch (this.theme) {
	        case 'default':
	          keys.push({
	            text: this.extraKey,
	            theme: ['gray'],
	            type: 'extra'
	          }, {
	            text: 0
	          }, {
	            text: this.deleteText,
	            theme: ['gray'],
	            type: 'delete'
	          });
	          break;
	
	        case 'custom':
	          keys.push({
	            text: 0,
	            theme: ['middle']
	          }, {
	            text: this.extraKey,
	            type: 'extra'
	          });
	          break;
	      }
	
	      return keys;
	    },
	    deleteText: function deleteText() {
	      return this.deleteButtonText || t('delete');
	    }
	  },
	  methods: {
	    onBlur: function onBlur() {
	      this.show && this.$emit('blur');
	    },
	    onClose: function onClose() {
	      this.$emit('close');
	      this.onBlur();
	    },
	    onAnimationEnd: function onAnimationEnd() {
	      this.$emit(this.show ? 'show' : 'hide');
	    },
	    onPress: function onPress(text, type) {
	      if (text === '') {
	        return;
	      }
	
	      var value = this.value;
	
	      if (type === 'delete') {
	        this.$emit('delete');
	        this.$emit('update:value', value.slice(0, value.length - 1));
	      } else if (type === 'close') {
	        this.onClose();
	      } else if (value.length < this.maxlength) {
	        this.$emit('input', text);
	        this.$emit('update:value', value + text);
	      }
	    },
	    genTitle: function genTitle() {
	      var h = this.$createElement;
	      var title = this.title,
	          theme = this.theme,
	          closeButtonText = this.closeButtonText;
	      var titleLeft = this.slots('title-left');
	      var showClose = closeButtonText && theme === 'default';
	      var showTitle = title || showClose || titleLeft;
	
	      if (!showTitle) {
	        return;
	      }
	
	      return h("div", {
	        "class": [bem('title'), _constant.BORDER_TOP]
	      }, [titleLeft && h("span", {
	        "class": bem('title-left')
	      }, [titleLeft]), title && h("span", [title]), showClose && h("span", {
	        "attrs": {
	          "role": "button",
	          "tabindex": "0"
	        },
	        "class": bem('close'),
	        "on": {
	          "click": this.onClose
	        }
	      }, [closeButtonText])]);
	    },
	    genKeys: function genKeys() {
	      var _this = this;
	
	      var h = this.$createElement;
	      return this.keys.map(function (key) {
	        return h(_Key.default, {
	          "key": key.text,
	          "attrs": {
	            "text": key.text,
	            "type": key.type,
	            "theme": key.theme
	          },
	          "on": {
	            "press": _this.onPress
	          }
	        }, [key.type === 'delete' && _this.slots('delete'), key.type === 'extra' && _this.slots('extra-key')]);
	      });
	    },
	    genSidebar: function genSidebar() {
	      var h = this.$createElement;
	
	      if (this.theme === 'custom') {
	        return h("div", {
	          "class": bem('sidebar')
	        }, [h(_Key.default, {
	          "attrs": {
	            "text": this.deleteText,
	            "type": "delete",
	            "theme": DELETE_KEY_THEME
	          },
	          "on": {
	            "press": this.onPress
	          }
	        }, [this.slots('delete')]), h(_Key.default, {
	          "attrs": {
	            "text": this.closeButtonText,
	            "type": "close",
	            "theme": CLOSE_KEY_THEME
	          },
	          "on": {
	            "press": this.onPress
	          }
	        })]);
	      }
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("transition", {
	      "attrs": {
	        "name": this.transition ? 'van-slide-up' : ''
	      }
	    }, [h("div", {
	      "directives": [{
	        name: "show",
	        value: this.show
	      }],
	      "style": {
	        zIndex: this.zIndex
	      },
	      "class": bem([this.theme, {
	        'safe-area-inset-bottom': this.safeAreaInsetBottom
	      }]),
	      "on": {
	        "touchstart": _event.stopPropagation,
	        "animationend": this.onAnimationEnd,
	        "webkitAnimationEnd": this.onAnimationEnd
	      }
	    }, [this.genTitle(), h("div", {
	      "class": bem('body')
	    }, [this.genKeys(), this.genSidebar()])])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _constant = __webpack_require__(7);
	
	var _createNamespace = (0, _utils.createNamespace)('pagination'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	function makePage(number, text, active) {
	  return {
	    number: number,
	    text: text,
	    active: active
	  };
	}
	
	var _default = createComponent({
	  props: {
	    prevText: String,
	    nextText: String,
	    forceEllipses: Boolean,
	    mode: {
	      type: String,
	      default: 'multi'
	    },
	    value: {
	      type: Number,
	      default: 0
	    },
	    pageCount: {
	      type: [Number, String],
	      default: 0
	    },
	    totalItems: {
	      type: [Number, String],
	      default: 0
	    },
	    itemsPerPage: {
	      type: [Number, String],
	      default: 10
	    },
	    showPageSize: {
	      type: [Number, String],
	      default: 5
	    }
	  },
	  computed: {
	    count: function count() {
	      var count = this.pageCount || Math.ceil(this.totalItems / this.itemsPerPage);
	      return Math.max(1, count);
	    },
	    pages: function pages() {
	      var pages = [];
	      var pageCount = this.count;
	      var showPageSize = +this.showPageSize;
	
	      if (this.mode !== 'multi') {
	        return pages;
	      } // Default page limits
	
	
	      var startPage = 1;
	      var endPage = pageCount;
	      var isMaxSized = showPageSize < pageCount; // recompute if showPageSize
	
	      if (isMaxSized) {
	        // Current page is displayed in the middle of the visible ones
	        startPage = Math.max(this.value - Math.floor(showPageSize / 2), 1);
	        endPage = startPage + showPageSize - 1; // Adjust if limit is exceeded
	
	        if (endPage > pageCount) {
	          endPage = pageCount;
	          startPage = endPage - showPageSize + 1;
	        }
	      } // Add page number links
	
	
	      for (var number = startPage; number <= endPage; number++) {
	        var page = makePage(number, number, number === this.value);
	        pages.push(page);
	      } // Add links to move between page sets
	
	
	      if (isMaxSized && showPageSize > 0 && this.forceEllipses) {
	        if (startPage > 1) {
	          var previousPageSet = makePage(startPage - 1, '...', false);
	          pages.unshift(previousPageSet);
	        }
	
	        if (endPage < pageCount) {
	          var nextPageSet = makePage(endPage + 1, '...', false);
	          pages.push(nextPageSet);
	        }
	      }
	
	      return pages;
	    }
	  },
	  watch: {
	    value: {
	      handler: function handler(page) {
	        this.select(page || this.value);
	      },
	      immediate: true
	    }
	  },
	  methods: {
	    select: function select(page, emitChange) {
	      page = Math.min(this.count, Math.max(1, page));
	
	      if (this.value !== page) {
	        this.$emit('input', page);
	
	        if (emitChange) {
	          this.$emit('change', page);
	        }
	      }
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var h = arguments[0];
	    var value = this.value;
	    var simple = this.mode !== 'multi';
	
	    var onSelect = function onSelect(value) {
	      return function () {
	        _this.select(value, true);
	      };
	    };
	
	    return h("ul", {
	      "class": bem({
	        simple: simple
	      })
	    }, [h("li", {
	      "class": [bem('item', {
	        disabled: value === 1
	      }), bem('prev'), _constant.BORDER],
	      "on": {
	        "click": onSelect(value - 1)
	      }
	    }, [this.prevText || t('prev')]), this.pages.map(function (page) {
	      return h("li", {
	        "class": [bem('item', {
	          active: page.active
	        }), bem('page'), _constant.BORDER],
	        "on": {
	          "click": onSelect(page.number)
	        }
	      }, [page.text]);
	    }), simple && h("li", {
	      "class": bem('page-desc')
	    }, [this.slots('pageDesc') || value + "/" + this.count]), h("li", {
	      "class": [bem('item', {
	        disabled: value === this.count
	      }), bem('next'), _constant.BORDER],
	      "on": {
	        "click": onSelect(value + 1)
	      }
	    }, [this.nextText || t('next')])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _constant = __webpack_require__(7);
	
	var _cell = _interopRequireDefault(__webpack_require__(15));
	
	var _cellGroup = _interopRequireDefault(__webpack_require__(91));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('panel'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function Panel(h, props, slots, ctx) {
	  var Content = function Content() {
	    return [slots.header ? slots.header() : h(_cell.default, {
	      "attrs": {
	        "icon": props.icon,
	        "label": props.desc,
	        "title": props.title,
	        "value": props.status,
	        "valueClass": bem('header-value')
	      },
	      "class": bem('header')
	    }), h("div", {
	      "class": bem('content')
	    }, [slots.default && slots.default()]), slots.footer && h("div", {
	      "class": [bem('footer'), _constant.BORDER_TOP]
	    }, [slots.footer()])];
	  };
	
	  return h(_cellGroup.default, (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem(),
	    "scopedSlots": {
	      default: Content
	    }
	  }, (0, _functional.inherit)(ctx, true)]));
	}
	
	Panel.props = {
	  icon: String,
	  desc: String,
	  title: String,
	  status: String
	};
	
	var _default = createComponent(Panel);
	
	exports.default = _default;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _constant = __webpack_require__(7);
	
	// Utils
	var _createNamespace = (0, _utils.createNamespace)('password-input'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function PasswordInput(h, props, slots, ctx) {
	  var _ref;
	
	  var mask = props.mask,
	      value = props.value,
	      length = props.length,
	      gutter = props.gutter,
	      focused = props.focused,
	      errorInfo = props.errorInfo;
	  var info = errorInfo || props.info;
	  var Points = [];
	
	  for (var i = 0; i < length; i++) {
	    var _class;
	
	    var _char = value[i];
	    var showBorder = i !== 0 && !gutter;
	    var showCursor = focused && i === value.length;
	    var style = void 0;
	
	    if (i !== 0 && gutter) {
	      style = {
	        marginLeft: (0, _utils.addUnit)(gutter)
	      };
	    }
	
	    Points.push(h("li", {
	      "class": (_class = {}, _class[_constant.BORDER_LEFT] = showBorder, _class),
	      "style": style
	    }, [mask ? h("i", {
	      "style": {
	        visibility: _char ? 'visible' : 'hidden'
	      }
	    }) : _char, showCursor && h("div", {
	      "class": bem('cursor')
	    })]));
	  }
	
	  return h("div", {
	    "class": bem()
	  }, [h("ul", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": [bem('security'), (_ref = {}, _ref[_constant.BORDER_SURROUND] = !gutter, _ref)],
	    "on": {
	      "touchstart": function touchstart(event) {
	        event.stopPropagation();
	        (0, _functional.emit)(ctx, 'focus', event);
	      }
	    }
	  }, (0, _functional.inherit)(ctx, true)]), [Points]), info && h("div", {
	    "class": bem(errorInfo ? 'error-info' : 'info')
	  }, [info])]);
	}
	
	PasswordInput.props = {
	  info: String,
	  gutter: [Number, String],
	  focused: Boolean,
	  errorInfo: String,
	  mask: {
	    type: Boolean,
	    default: true
	  },
	  value: {
	    type: String,
	    default: ''
	  },
	  length: {
	    type: [Number, String],
	    default: 6
	  }
	};
	
	var _default = createComponent(PasswordInput);
	
	exports.default = _default;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _deepClone = __webpack_require__(394);
	
	var _utils = __webpack_require__(1);
	
	var _number = __webpack_require__(47);
	
	var _event = __webpack_require__(10);
	
	var _touch = __webpack_require__(19);
	
	var DEFAULT_DURATION = 200; // 惯性滑动思路:
	// 在手指离开屏幕时，如果和上一次 move 时的间隔小于 `MOMENTUM_LIMIT_TIME` 且 move
	// 距离大于 `MOMENTUM_LIMIT_DISTANCE` 时，执行惯性滑动
	
	var MOMENTUM_LIMIT_TIME = 300;
	var MOMENTUM_LIMIT_DISTANCE = 15;
	
	var _createNamespace = (0, _utils.createNamespace)('picker-column'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function getElementTranslateY(element) {
	  var style = window.getComputedStyle(element);
	  var transform = style.transform || style.webkitTransform;
	  var translateY = transform.slice(7, transform.length - 1).split(', ')[5];
	  return Number(translateY);
	}
	
	function isOptionDisabled(option) {
	  return (0, _utils.isObject)(option) && option.disabled;
	}
	
	var _default2 = createComponent({
	  mixins: [_touch.TouchMixin],
	  props: {
	    valueKey: String,
	    allowHtml: Boolean,
	    className: String,
	    itemHeight: [Number, String],
	    defaultIndex: Number,
	    swipeDuration: [Number, String],
	    visibleItemCount: [Number, String],
	    initialOptions: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      offset: 0,
	      duration: 0,
	      options: (0, _deepClone.deepClone)(this.initialOptions),
	      currentIndex: this.defaultIndex
	    };
	  },
	  created: function created() {
	    if (this.$parent.children) {
	      this.$parent.children.push(this);
	    }
	
	    this.setIndex(this.currentIndex);
	  },
	  mounted: function mounted() {
	    this.bindTouchEvent(this.$el);
	  },
	  destroyed: function destroyed() {
	    var children = this.$parent.children;
	
	    if (children) {
	      children.splice(children.indexOf(this), 1);
	    }
	  },
	  watch: {
	    initialOptions: 'setOptions',
	    defaultIndex: function defaultIndex(val) {
	      this.setIndex(val);
	    }
	  },
	  computed: {
	    count: function count() {
	      return this.options.length;
	    },
	    baseOffset: function baseOffset() {
	      return this.itemHeight * (this.visibleItemCount - 1) / 2;
	    }
	  },
	  methods: {
	    setOptions: function setOptions(options) {
	      if (JSON.stringify(options) !== JSON.stringify(this.options)) {
	        this.options = (0, _deepClone.deepClone)(options);
	        this.setIndex(this.defaultIndex);
	      }
	    },
	    onTouchStart: function onTouchStart(event) {
	      this.touchStart(event);
	
	      if (this.moving) {
	        var translateY = getElementTranslateY(this.$refs.wrapper);
	        this.offset = Math.min(0, translateY - this.baseOffset);
	        this.startOffset = this.offset;
	      } else {
	        this.startOffset = this.offset;
	      }
	
	      this.duration = 0;
	      this.transitionEndTrigger = null;
	      this.touchStartTime = Date.now();
	      this.momentumOffset = this.startOffset;
	    },
	    onTouchMove: function onTouchMove(event) {
	      this.touchMove(event);
	
	      if (this.direction === 'vertical') {
	        this.moving = true;
	        (0, _event.preventDefault)(event, true);
	      }
	
	      this.offset = (0, _number.range)(this.startOffset + this.deltaY, -(this.count * this.itemHeight), this.itemHeight);
	      var now = Date.now();
	
	      if (now - this.touchStartTime > MOMENTUM_LIMIT_TIME) {
	        this.touchStartTime = now;
	        this.momentumOffset = this.offset;
	      }
	    },
	    onTouchEnd: function onTouchEnd() {
	      var _this = this;
	
	      var distance = this.offset - this.momentumOffset;
	      var duration = Date.now() - this.touchStartTime;
	      var allowMomentum = duration < MOMENTUM_LIMIT_TIME && Math.abs(distance) > MOMENTUM_LIMIT_DISTANCE;
	
	      if (allowMomentum) {
	        this.momentum(distance, duration);
	        return;
	      }
	
	      var index = this.getIndexByOffset(this.offset);
	      this.duration = DEFAULT_DURATION;
	      this.setIndex(index, true); // compatible with desktop scenario
	      // use setTimeout to skip the click event triggered after touchstart
	
	      setTimeout(function () {
	        _this.moving = false;
	      }, 0);
	    },
	    onTransitionEnd: function onTransitionEnd() {
	      this.stopMomentum();
	    },
	    onClickItem: function onClickItem(index) {
	      if (this.moving) {
	        return;
	      }
	
	      this.duration = DEFAULT_DURATION;
	      this.setIndex(index, true);
	    },
	    adjustIndex: function adjustIndex(index) {
	      index = (0, _number.range)(index, 0, this.count);
	
	      for (var i = index; i < this.count; i++) {
	        if (!isOptionDisabled(this.options[i])) return i;
	      }
	
	      for (var _i = index - 1; _i >= 0; _i--) {
	        if (!isOptionDisabled(this.options[_i])) return _i;
	      }
	    },
	    getOptionText: function getOptionText(option) {
	      if ((0, _utils.isObject)(option) && this.valueKey in option) {
	        return option[this.valueKey];
	      }
	
	      return option;
	    },
	    setIndex: function setIndex(index, emitChange) {
	      var _this2 = this;
	
	      index = this.adjustIndex(index) || 0;
	      var offset = -index * this.itemHeight;
	
	      var trigger = function trigger() {
	        if (index !== _this2.currentIndex) {
	          _this2.currentIndex = index;
	
	          if (emitChange) {
	            _this2.$emit('change', index);
	          }
	        }
	      }; // trigger the change event after transitionend when moving
	
	
	      if (this.moving && offset !== this.offset) {
	        this.transitionEndTrigger = trigger;
	      } else {
	        trigger();
	      }
	
	      this.offset = offset;
	    },
	    setValue: function setValue(value) {
	      var options = this.options;
	
	      for (var i = 0; i < options.length; i++) {
	        if (this.getOptionText(options[i]) === value) {
	          return this.setIndex(i);
	        }
	      }
	    },
	    getValue: function getValue() {
	      return this.options[this.currentIndex];
	    },
	    getIndexByOffset: function getIndexByOffset(offset) {
	      return (0, _number.range)(Math.round(-offset / this.itemHeight), 0, this.count - 1);
	    },
	    momentum: function momentum(distance, duration) {
	      var speed = Math.abs(distance / duration);
	      distance = this.offset + speed / 0.002 * (distance < 0 ? -1 : 1);
	      var index = this.getIndexByOffset(distance);
	      this.duration = +this.swipeDuration;
	      this.setIndex(index, true);
	    },
	    stopMomentum: function stopMomentum() {
	      this.moving = false;
	      this.duration = 0;
	
	      if (this.transitionEndTrigger) {
	        this.transitionEndTrigger();
	        this.transitionEndTrigger = null;
	      }
	    },
	    genOptions: function genOptions() {
	      var _this3 = this;
	
	      var h = this.$createElement;
	      var optionStyle = {
	        height: this.itemHeight + "px"
	      };
	      return this.options.map(function (option, index) {
	        var text = _this3.getOptionText(option);
	
	        var disabled = isOptionDisabled(option);
	        var data = {
	          style: optionStyle,
	          attrs: {
	            role: 'button',
	            tabindex: disabled ? -1 : 0
	          },
	          class: ['van-ellipsis', bem('item', {
	            disabled: disabled,
	            selected: index === _this3.currentIndex
	          })],
	          on: {
	            click: function click() {
	              _this3.onClickItem(index);
	            }
	          }
	        };
	
	        if (_this3.allowHtml) {
	          data.domProps = {
	            innerHTML: text
	          };
	        }
	
	        return h("li", (0, _babelHelperVueJsxMergeProps.default)([{}, data]), [_this3.allowHtml ? '' : text]);
	      });
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    var wrapperStyle = {
	      transform: "translate3d(0, " + (this.offset + this.baseOffset) + "px, 0)",
	      transitionDuration: this.duration + "ms",
	      transitionProperty: this.duration ? 'all' : 'none',
	      lineHeight: this.itemHeight + "px"
	    };
	    return h("div", {
	      "class": [bem(), this.className]
	    }, [h("ul", {
	      "ref": "wrapper",
	      "style": wrapperStyle,
	      "class": bem('wrapper'),
	      "on": {
	        "transitionend": this.onTransitionEnd
	      }
	    }, [this.genOptions()])]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _createNamespace = (0, _utils.createNamespace)('progress'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  props: {
	    color: String,
	    inactive: Boolean,
	    pivotText: String,
	    textColor: String,
	    pivotColor: String,
	    trackColor: String,
	    strokeWidth: [Number, String],
	    percentage: {
	      type: [Number, String],
	      required: true,
	      validator: function validator(value) {
	        return value >= 0 && value <= 100;
	      }
	    },
	    showPivot: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      pivotWidth: 0,
	      progressWidth: 0
	    };
	  },
	  mounted: function mounted() {
	    this.setWidth();
	  },
	  watch: {
	    showPivot: 'setWidth',
	    pivotText: 'setWidth'
	  },
	  methods: {
	    setWidth: function setWidth() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.progressWidth = _this.$el.offsetWidth;
	        _this.pivotWidth = _this.$refs.pivot ? _this.$refs.pivot.offsetWidth : 0;
	      });
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    var pivotText = this.pivotText,
	        percentage = this.percentage;
	    var text = (0, _utils.isDef)(pivotText) ? pivotText : percentage + '%';
	    var showPivot = this.showPivot && text;
	    var background = this.inactive ? '#cacaca' : this.color;
	    var pivotStyle = {
	      color: this.textColor,
	      left: (this.progressWidth - this.pivotWidth) * percentage / 100 + "px",
	      background: this.pivotColor || background
	    };
	    var portionStyle = {
	      background: background,
	      width: this.progressWidth * percentage / 100 + 'px'
	    };
	    var wrapperStyle = {
	      background: this.trackColor,
	      height: (0, _utils.addUnit)(this.strokeWidth)
	    };
	    return h("div", {
	      "class": bem(),
	      "style": wrapperStyle
	    }, [h("span", {
	      "class": bem('portion'),
	      "style": portionStyle
	    }, [showPivot && h("span", {
	      "ref": "pivot",
	      "style": pivotStyle,
	      "class": bem('pivot')
	    }, [text])])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _event = __webpack_require__(10);
	
	var _scroll = __webpack_require__(22);
	
	var _touch = __webpack_require__(19);
	
	var _loading = _interopRequireDefault(__webpack_require__(18));
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('pull-refresh'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	var DEFAULT_HEAD_HEIGHT = 50;
	var TEXT_STATUS = ['pulling', 'loosing', 'success'];
	
	var _default = createComponent({
	  mixins: [_touch.TouchMixin],
	  props: {
	    disabled: Boolean,
	    successText: String,
	    pullingText: String,
	    loosingText: String,
	    loadingText: String,
	    value: {
	      type: Boolean,
	      required: true
	    },
	    successDuration: {
	      type: [Number, String],
	      default: 500
	    },
	    animationDuration: {
	      type: [Number, String],
	      default: 300
	    },
	    headHeight: {
	      type: [Number, String],
	      default: DEFAULT_HEAD_HEIGHT
	    }
	  },
	  data: function data() {
	    return {
	      status: 'normal',
	      distance: 0,
	      duration: 0
	    };
	  },
	  computed: {
	    touchable: function touchable() {
	      return this.status !== 'loading' && this.status !== 'success' && !this.disabled;
	    },
	    headStyle: function headStyle() {
	      if (this.headHeight !== DEFAULT_HEAD_HEIGHT) {
	        return {
	          height: this.headHeight + "px"
	        };
	      }
	    }
	  },
	  watch: {
	    value: function value(loading) {
	      this.duration = this.animationDuration;
	
	      if (loading) {
	        this.setStatus(+this.headHeight, true);
	      } else if (this.slots('success') || this.successText) {
	        this.showSuccessTip();
	      } else {
	        this.setStatus(0, false);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.bindTouchEvent(this.$refs.track);
	    this.scrollEl = (0, _scroll.getScroller)(this.$el);
	  },
	  methods: {
	    checkPullStart: function checkPullStart(event) {
	      this.ceiling = (0, _scroll.getScrollTop)(this.scrollEl) === 0;
	
	      if (this.ceiling) {
	        this.duration = 0;
	        this.touchStart(event);
	      }
	    },
	    onTouchStart: function onTouchStart(event) {
	      if (this.touchable) {
	        this.checkPullStart(event);
	      }
	    },
	    onTouchMove: function onTouchMove(event) {
	      if (!this.touchable) {
	        return;
	      }
	
	      if (!this.ceiling) {
	        this.checkPullStart(event);
	      }
	
	      this.touchMove(event);
	
	      if (this.ceiling && this.deltaY >= 0 && this.direction === 'vertical') {
	        (0, _event.preventDefault)(event);
	        this.setStatus(this.ease(this.deltaY));
	      }
	    },
	    onTouchEnd: function onTouchEnd() {
	      var _this = this;
	
	      if (this.touchable && this.ceiling && this.deltaY) {
	        this.duration = this.animationDuration;
	
	        if (this.status === 'loosing') {
	          this.setStatus(+this.headHeight, true);
	          this.$emit('input', true); // ensure value change can be watched
	
	          this.$nextTick(function () {
	            _this.$emit('refresh');
	          });
	        } else {
	          this.setStatus(0);
	        }
	      }
	    },
	    ease: function ease(distance) {
	      var headHeight = +this.headHeight;
	
	      if (distance > headHeight) {
	        if (distance < headHeight * 2) {
	          distance = headHeight + (distance - headHeight) / 2;
	        } else {
	          distance = headHeight * 1.5 + (distance - headHeight * 2) / 4;
	        }
	      }
	
	      return Math.round(distance);
	    },
	    setStatus: function setStatus(distance, isLoading) {
	      var status;
	
	      if (isLoading) {
	        status = 'loading';
	      } else if (distance === 0) {
	        status = 'normal';
	      } else {
	        status = distance < this.headHeight ? 'pulling' : 'loosing';
	      }
	
	      this.distance = distance;
	
	      if (status !== this.status) {
	        this.status = status;
	      }
	    },
	    genStatus: function genStatus() {
	      var h = this.$createElement;
	      var status = this.status,
	          distance = this.distance;
	      var slot = this.slots(status, {
	        distance: distance
	      });
	
	      if (slot) {
	        return slot;
	      }
	
	      var nodes = [];
	      var text = this[status + "Text"] || t(status);
	
	      if (TEXT_STATUS.indexOf(status) !== -1) {
	        nodes.push(h("div", {
	          "class": bem('text')
	        }, [text]));
	      }
	
	      if (status === 'loading') {
	        nodes.push(h(_loading.default, {
	          "attrs": {
	            "size": "16"
	          }
	        }, [text]));
	      }
	
	      return nodes;
	    },
	    showSuccessTip: function showSuccessTip() {
	      var _this2 = this;
	
	      this.status = 'success';
	      setTimeout(function () {
	        _this2.setStatus(0);
	      }, this.successDuration);
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    var style = {
	      transitionDuration: this.duration + "ms",
	      transform: this.distance ? "translate3d(0," + this.distance + "px, 0)" : ''
	    };
	    return h("div", {
	      "class": bem()
	    }, [h("div", {
	      "ref": "track",
	      "class": bem('track'),
	      "style": style
	    }, [h("div", {
	      "class": bem('head'),
	      "style": this.headStyle
	    }, [this.genStatus()]), this.slots()])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _event = __webpack_require__(10);
	
	var _touch = __webpack_require__(19);
	
	var _field = __webpack_require__(27);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('rate'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function getRateStatus(value, index, allowHalf) {
	  if (value >= index) {
	    return 'full';
	  }
	
	  if (value + 0.5 >= index && allowHalf) {
	    return 'half';
	  }
	
	  return 'void';
	}
	
	var _default = createComponent({
	  mixins: [_touch.TouchMixin, _field.FieldMixin],
	  props: {
	    size: [Number, String],
	    color: String,
	    gutter: [Number, String],
	    readonly: Boolean,
	    disabled: Boolean,
	    allowHalf: Boolean,
	    voidColor: String,
	    iconPrefix: String,
	    disabledColor: String,
	    value: {
	      type: Number,
	      default: 0
	    },
	    icon: {
	      type: String,
	      default: 'star'
	    },
	    voidIcon: {
	      type: String,
	      default: 'star-o'
	    },
	    count: {
	      type: [Number, String],
	      default: 5
	    },
	    touchable: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    list: function list() {
	      var list = [];
	
	      for (var i = 1; i <= this.count; i++) {
	        list.push(getRateStatus(this.value, i, this.allowHalf));
	      }
	
	      return list;
	    },
	    sizeWithUnit: function sizeWithUnit() {
	      return (0, _utils.addUnit)(this.size);
	    },
	    gutterWithUnit: function gutterWithUnit() {
	      return (0, _utils.addUnit)(this.gutter);
	    }
	  },
	  mounted: function mounted() {
	    this.bindTouchEvent(this.$el);
	  },
	  methods: {
	    select: function select(index) {
	      if (!this.disabled && !this.readonly && index !== this.value) {
	        this.$emit('input', index);
	        this.$emit('change', index);
	      }
	    },
	    onTouchStart: function onTouchStart(event) {
	      var _this = this;
	
	      if (this.readonly || this.disabled || !this.touchable) {
	        return;
	      }
	
	      this.touchStart(event);
	      var rects = this.$refs.items.map(function (item) {
	        return item.getBoundingClientRect();
	      });
	      var ranges = [];
	      rects.forEach(function (rect, index) {
	        if (_this.allowHalf) {
	          ranges.push({
	            score: index + 0.5,
	            left: rect.left
	          }, {
	            score: index + 1,
	            left: rect.left + rect.width / 2
	          });
	        } else {
	          ranges.push({
	            score: index + 1,
	            left: rect.left
	          });
	        }
	      });
	      this.ranges = ranges;
	    },
	    onTouchMove: function onTouchMove(event) {
	      if (this.readonly || this.disabled || !this.touchable) {
	        return;
	      }
	
	      this.touchMove(event);
	
	      if (this.direction === 'horizontal') {
	        (0, _event.preventDefault)(event);
	        var clientX = event.touches[0].clientX;
	        this.select(this.getScoreByPosition(clientX));
	      }
	    },
	    getScoreByPosition: function getScoreByPosition(x) {
	      for (var i = this.ranges.length - 1; i > 0; i--) {
	        if (x > this.ranges[i].left) {
	          return this.ranges[i].score;
	        }
	      }
	
	      return this.allowHalf ? 0.5 : 1;
	    },
	    genStar: function genStar(status, index) {
	      var _this2 = this;
	
	      var h = this.$createElement;
	      var icon = this.icon,
	          color = this.color,
	          count = this.count,
	          voidIcon = this.voidIcon,
	          disabled = this.disabled,
	          voidColor = this.voidColor,
	          disabledColor = this.disabledColor;
	      var score = index + 1;
	      var isFull = status === 'full';
	      var isVoid = status === 'void';
	      var style;
	
	      if (this.gutterWithUnit && score !== +count) {
	        style = {
	          paddingRight: this.gutterWithUnit
	        };
	      }
	
	      return h("div", {
	        "ref": "items",
	        "refInFor": true,
	        "key": index,
	        "attrs": {
	          "role": "radio",
	          "tabindex": "0",
	          "aria-setsize": count,
	          "aria-posinset": score,
	          "aria-checked": String(!isVoid)
	        },
	        "style": style,
	        "class": bem('item')
	      }, [h(_icon.default, {
	        "attrs": {
	          "size": this.sizeWithUnit,
	          "name": isFull ? icon : voidIcon,
	          "color": disabled ? disabledColor : isFull ? color : voidColor,
	          "classPrefix": this.iconPrefix,
	          "data-score": score
	        },
	        "class": bem('icon', {
	          disabled: disabled,
	          full: isFull
	        }),
	        "on": {
	          "click": function click() {
	            _this2.select(score);
	          }
	        }
	      }), this.allowHalf && h(_icon.default, {
	        "attrs": {
	          "size": this.sizeWithUnit,
	          "name": isVoid ? voidIcon : icon,
	          "color": disabled ? disabledColor : isVoid ? voidColor : color,
	          "classPrefix": this.iconPrefix,
	          "data-score": score - 0.5
	        },
	        "class": bem('icon', ['half', {
	          disabled: disabled,
	          full: !isVoid
	        }]),
	        "on": {
	          "click": function click() {
	            _this2.select(score - 0.5);
	          }
	        }
	      })]);
	    }
	  },
	  render: function render() {
	    var _this3 = this;
	
	    var h = arguments[0];
	    return h("div", {
	      "class": bem({
	        readonly: this.readonly,
	        disabled: this.disabled
	      }),
	      "attrs": {
	        "tabindex": "0",
	        "role": "radiogroup"
	      }
	    }, [this.list.map(function (status, index) {
	      return _this3.genStar(status, index);
	    })]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _createNamespace = (0, _utils.createNamespace)('row'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  props: {
	    type: String,
	    align: String,
	    justify: String,
	    tag: {
	      type: String,
	      default: 'div'
	    },
	    gutter: {
	      type: [Number, String],
	      default: 0
	    }
	  },
	  methods: {
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	    }
	  },
	  render: function render() {
	    var _bem;
	
	    var h = arguments[0];
	    var align = this.align,
	        justify = this.justify;
	    var flex = this.type === 'flex';
	    var margin = "-" + Number(this.gutter) / 2 + "px";
	    var style = this.gutter ? {
	      marginLeft: margin,
	      marginRight: margin
	    } : {};
	    return h(this.tag, {
	      "style": style,
	      "class": bem((_bem = {
	        flex: flex
	      }, _bem["align-" + align] = flex && align, _bem["justify-" + justify] = flex && justify, _bem)),
	      "on": {
	        "click": this.onClick
	      }
	    }, [this.slots()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _event = __webpack_require__(10);
	
	var _field = _interopRequireDefault(__webpack_require__(34));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('search'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	function Search(h, props, slots, ctx) {
	  function Label() {
	    if (slots.label || props.label) {
	      return h("div", {
	        "class": bem('label')
	      }, [slots.label ? slots.label() : props.label]);
	    }
	  }
	
	  function Action() {
	    if (!props.showAction) {
	      return;
	    }
	
	    function onCancel() {
	      if (slots.action) {
	        return;
	      }
	
	      (0, _functional.emit)(ctx, 'input', '');
	      (0, _functional.emit)(ctx, 'cancel');
	    }
	
	    return h("div", {
	      "class": bem('action'),
	      "attrs": {
	        "role": "button",
	        "tabindex": "0"
	      },
	      "on": {
	        "click": onCancel
	      }
	    }, [slots.action ? slots.action() : props.actionText || t('cancel')]);
	  }
	
	  var fieldData = {
	    attrs: ctx.data.attrs,
	    on: (0, _extends2.default)({}, ctx.listeners, {
	      keypress: function keypress(event) {
	        // press enter
	        if (event.keyCode === 13) {
	          (0, _event.preventDefault)(event);
	          (0, _functional.emit)(ctx, 'search', props.value);
	        }
	
	        (0, _functional.emit)(ctx, 'keypress', event);
	      }
	    })
	  };
	  var inheritData = (0, _functional.inherit)(ctx);
	  inheritData.attrs = undefined;
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem({
	      'show-action': props.showAction
	    }),
	    "style": {
	      background: props.background
	    }
	  }, inheritData]), [slots.left == null ? void 0 : slots.left(), h("div", {
	    "class": bem('content', props.shape)
	  }, [Label(), h(_field.default, (0, _babelHelperVueJsxMergeProps.default)([{
	    "attrs": {
	      "type": "search",
	      "border": false,
	      "value": props.value,
	      "leftIcon": props.leftIcon,
	      "rightIcon": props.rightIcon,
	      "clearable": props.clearable
	    },
	    "scopedSlots": {
	      'left-icon': slots['left-icon'],
	      'right-icon': slots['right-icon']
	    }
	  }, fieldData]))]), Action()]);
	}
	
	Search.props = {
	  value: String,
	  label: String,
	  rightIcon: String,
	  actionText: String,
	  showAction: Boolean,
	  background: String,
	  shape: {
	    type: String,
	    default: 'square'
	  },
	  clearable: {
	    type: Boolean,
	    default: true
	  },
	  leftIcon: {
	    type: String,
	    default: 'search'
	  }
	};
	
	var _default = createComponent(Search);
	
	exports.default = _default;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	// Utils
	var _createNamespace = (0, _utils.createNamespace)('skeleton'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var DEFAULT_ROW_WIDTH = '100%';
	var DEFAULT_LAST_ROW_WIDTH = '60%';
	
	function Skeleton(h, props, slots, ctx) {
	  if (!props.loading) {
	    return slots.default && slots.default();
	  }
	
	  function Title() {
	    if (props.title) {
	      return h("h3", {
	        "class": bem('title'),
	        "style": {
	          width: (0, _utils.addUnit)(props.titleWidth)
	        }
	      });
	    }
	  }
	
	  function Rows() {
	    var Rows = [];
	    var rowWidth = props.rowWidth;
	
	    function getRowWidth(index) {
	      if (rowWidth === DEFAULT_ROW_WIDTH && index === +props.row - 1) {
	        return DEFAULT_LAST_ROW_WIDTH;
	      }
	
	      if (Array.isArray(rowWidth)) {
	        return rowWidth[index];
	      }
	
	      return rowWidth;
	    }
	
	    for (var i = 0; i < props.row; i++) {
	      Rows.push(h("div", {
	        "class": bem('row'),
	        "style": {
	          width: (0, _utils.addUnit)(getRowWidth(i))
	        }
	      }));
	    }
	
	    return Rows;
	  }
	
	  function Avatar() {
	    if (props.avatar) {
	      var size = (0, _utils.addUnit)(props.avatarSize);
	      return h("div", {
	        "class": bem('avatar', props.avatarShape),
	        "style": {
	          width: size,
	          height: size
	        }
	      });
	    }
	  }
	
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem({
	      animate: props.animate
	    })
	  }, (0, _functional.inherit)(ctx)]), [Avatar(), h("div", {
	    "class": bem('content')
	  }, [Title(), Rows()])]);
	}
	
	Skeleton.props = {
	  title: Boolean,
	  avatar: Boolean,
	  row: {
	    type: [Number, String],
	    default: 0
	  },
	  loading: {
	    type: Boolean,
	    default: true
	  },
	  animate: {
	    type: Boolean,
	    default: true
	  },
	  avatarSize: {
	    type: String,
	    default: '32px'
	  },
	  avatarShape: {
	    type: String,
	    default: 'round'
	  },
	  titleWidth: {
	    type: [Number, String],
	    default: '40%'
	  },
	  rowWidth: {
	    type: [Number, String, Array],
	    default: DEFAULT_ROW_WIDTH
	  }
	};
	
	var _default = createComponent(Skeleton);
	
	exports.default = _default;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends5 = _interopRequireDefault(__webpack_require__(3));
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	var _popup = _interopRequireDefault(__webpack_require__(37));
	
	var _toast = _interopRequireDefault(__webpack_require__(64));
	
	var _imagePreview = _interopRequireDefault(__webpack_require__(95));
	
	var _SkuHeader = _interopRequireDefault(__webpack_require__(154));
	
	var _SkuHeaderItem = _interopRequireDefault(__webpack_require__(155));
	
	var _SkuRow = _interopRequireDefault(__webpack_require__(157));
	
	var _SkuRowItem = _interopRequireDefault(__webpack_require__(158));
	
	var _SkuRowPropItem = _interopRequireDefault(__webpack_require__(159));
	
	var _SkuStepper = _interopRequireDefault(__webpack_require__(160));
	
	var _SkuMessages = _interopRequireDefault(__webpack_require__(156));
	
	var _SkuActions = _interopRequireDefault(__webpack_require__(153));
	
	var _utils = __webpack_require__(1);
	
	var _skuHelper = __webpack_require__(100);
	
	var _constants = __webpack_require__(62);
	
	var namespace = (0, _utils.createNamespace)('sku');
	var createComponent = namespace[0],
	    bem = namespace[1],
	    t = namespace[2];
	var QUOTA_LIMIT = _constants.LIMIT_TYPE.QUOTA_LIMIT;
	
	var _default2 = createComponent({
	  props: {
	    sku: Object,
	    priceTag: String,
	    goods: Object,
	    value: Boolean,
	    buyText: String,
	    goodsId: [Number, String],
	    hideStock: Boolean,
	    addCartText: String,
	    stepperTitle: String,
	    getContainer: [String, Function],
	    hideQuotaText: Boolean,
	    hideSelectedText: Boolean,
	    resetStepperOnHide: Boolean,
	    customSkuValidator: Function,
	    closeOnClickOverlay: Boolean,
	    disableStepperInput: Boolean,
	    safeAreaInsetBottom: Boolean,
	    resetSelectedSkuOnHide: Boolean,
	    properties: Array,
	    quota: {
	      type: Number,
	      default: 0
	    },
	    quotaUsed: {
	      type: Number,
	      default: 0
	    },
	    startSaleNum: {
	      type: Number,
	      default: 1
	    },
	    initialSku: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    stockThreshold: {
	      type: Number,
	      default: 50
	    },
	    showSoldoutSku: {
	      type: Boolean,
	      default: true
	    },
	    showAddCartBtn: {
	      type: Boolean,
	      default: true
	    },
	    bodyOffsetTop: {
	      type: Number,
	      default: 200
	    },
	    messageConfig: {
	      type: Object,
	      default: function _default() {
	        return {
	          initialMessages: {},
	          placeholderMap: {},
	          uploadImg: function uploadImg() {
	            return Promise.resolve();
	          },
	          uploadMaxSize: 5
	        };
	      }
	    },
	    customStepperConfig: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    previewOnClickImage: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      selectedSku: {},
	      selectedProp: {},
	      selectedNum: 1,
	      show: this.value
	    };
	  },
	  watch: {
	    show: function show(val) {
	      this.$emit('input', val);
	
	      if (!val) {
	        this.$emit('sku-close', {
	          selectedSkuValues: this.selectedSkuValues,
	          selectedNum: this.selectedNum,
	          selectedSkuComb: this.selectedSkuComb
	        });
	
	        if (this.resetStepperOnHide) {
	          this.resetStepper();
	        }
	
	        if (this.resetSelectedSkuOnHide) {
	          this.resetSelectedSku();
	        }
	      }
	    },
	    value: function value(val) {
	      this.show = val;
	    },
	    skuTree: 'resetSelectedSku',
	    initialSku: function initialSku() {
	      this.resetStepper();
	      this.resetSelectedSku();
	    }
	  },
	  computed: {
	    skuGroupClass: function skuGroupClass() {
	      return ['van-sku-group-container', {
	        'van-sku-group-container--hide-soldout': !this.showSoldoutSku
	      }];
	    },
	    bodyStyle: function bodyStyle() {
	      if (this.$isServer) {
	        return;
	      } // header高度82px, sku actions高度50px，如果改动了样式自己传下bodyOffsetTop调整下
	
	
	      var maxHeight = window.innerHeight - this.bodyOffsetTop;
	      return {
	        maxHeight: maxHeight + 'px'
	      };
	    },
	    isSkuCombSelected: function isSkuCombSelected() {
	      var _this = this;
	
	      // SKU 未选完
	      if (this.hasSku && !(0, _skuHelper.isAllSelected)(this.skuTree, this.selectedSku)) {
	        return false;
	      } // 属性未全选
	
	
	      if (this.propList.some(function (it) {
	        return (_this.selectedProp[it.k_id] || []).length < 1;
	      })) {
	        return false;
	      }
	
	      return true;
	    },
	    isSkuEmpty: function isSkuEmpty() {
	      return Object.keys(this.sku).length === 0;
	    },
	    hasSku: function hasSku() {
	      return !this.sku.none_sku;
	    },
	    hasSkuOrAttr: function hasSkuOrAttr() {
	      return this.hasSku || this.propList.length > 0;
	    },
	    selectedSkuComb: function selectedSkuComb() {
	      var skuComb = null;
	
	      if (this.isSkuCombSelected) {
	        if (this.hasSku) {
	          skuComb = (0, _skuHelper.getSkuComb)(this.sku.list, this.selectedSku);
	        } else {
	          skuComb = {
	            id: this.sku.collection_id,
	            price: Math.round(this.sku.price * 100),
	            stock_num: this.sku.stock_num
	          };
	        }
	
	        if (skuComb) {
	          skuComb.properties = (0, _skuHelper.getSelectedProperties)(this.propList, this.selectedProp);
	          skuComb.property_price = this.selectedPropValues.reduce(function (acc, cur) {
	            return acc + (cur.price || 0);
	          }, 0);
	        }
	      }
	
	      return skuComb;
	    },
	    selectedSkuValues: function selectedSkuValues() {
	      return (0, _skuHelper.getSelectedSkuValues)(this.skuTree, this.selectedSku);
	    },
	    selectedPropValues: function selectedPropValues() {
	      return (0, _skuHelper.getSelectedPropValues)(this.propList, this.selectedProp);
	    },
	    price: function price() {
	      if (this.selectedSkuComb) {
	        return ((this.selectedSkuComb.price + this.selectedSkuComb.property_price) / 100).toFixed(2);
	      } // sku.price是一个格式化好的价格区间
	
	
	      return this.sku.price;
	    },
	    originPrice: function originPrice() {
	      if (this.selectedSkuComb && this.selectedSkuComb.origin_price) {
	        return ((this.selectedSkuComb.origin_price + this.selectedSkuComb.property_price) / 100).toFixed(2);
	      }
	
	      return this.sku.origin_price;
	    },
	    skuTree: function skuTree() {
	      return this.sku.tree || [];
	    },
	    propList: function propList() {
	      return this.properties || [];
	    },
	    imageList: function imageList() {
	      var imageList = [this.goods.picture];
	
	      if (this.skuTree.length > 0) {
	        this.skuTree.forEach(function (treeItem) {
	          if (!treeItem.v) {
	            return;
	          }
	
	          treeItem.v.forEach(function (vItem) {
	            var img = vItem.previewImgUrl || vItem.imgUrl || vItem.img_url;
	
	            if (img) {
	              imageList.push(img);
	            }
	          });
	        });
	      }
	
	      return imageList;
	    },
	    stock: function stock() {
	      var stockNum = this.customStepperConfig.stockNum;
	
	      if (stockNum !== undefined) {
	        return stockNum;
	      }
	
	      if (this.selectedSkuComb) {
	        return this.selectedSkuComb.stock_num;
	      }
	
	      return this.sku.stock_num;
	    },
	    stockText: function stockText() {
	      var h = this.$createElement;
	      var stockFormatter = this.customStepperConfig.stockFormatter;
	      if (stockFormatter) return stockFormatter(this.stock);
	      return [t('stock') + " ", h("span", {
	        "class": bem('stock-num', {
	          highlight: this.stock < this.stockThreshold
	        })
	      }, [this.stock]), " " + t('stockUnit')];
	    },
	    selectedText: function selectedText() {
	      var _this2 = this;
	
	      if (this.selectedSkuComb) {
	        var values = this.selectedSkuValues.concat(this.selectedPropValues);
	        return t('selected') + " " + values.map(function (item) {
	          return item.name;
	        }).join('；');
	      }
	
	      var unselectedSku = this.skuTree.filter(function (item) {
	        return _this2.selectedSku[item.k_s] === _constants.UNSELECTED_SKU_VALUE_ID;
	      }).map(function (item) {
	        return item.k;
	      });
	      var unselectedProp = this.propList.filter(function (item) {
	        return (_this2.selectedProp[item.k_id] || []).length < 1;
	      }).map(function (item) {
	        return item.k;
	      });
	      return t('select') + " " + unselectedSku.concat(unselectedProp).join('；');
	    }
	  },
	  created: function created() {
	    var skuEventBus = new _vue.default();
	    this.skuEventBus = skuEventBus;
	    skuEventBus.$on('sku:select', this.onSelect);
	    skuEventBus.$on('sku:propSelect', this.onPropSelect);
	    skuEventBus.$on('sku:numChange', this.onNumChange);
	    skuEventBus.$on('sku:previewImage', this.onPreviewImage);
	    skuEventBus.$on('sku:overLimit', this.onOverLimit);
	    skuEventBus.$on('sku:stepperState', this.onStepperState);
	    skuEventBus.$on('sku:addCart', this.onAddCart);
	    skuEventBus.$on('sku:buy', this.onBuy);
	    this.resetStepper();
	    this.resetSelectedSku(); // 组件初始化后的钩子，抛出skuEventBus
	
	    this.$emit('after-sku-create', skuEventBus);
	  },
	  methods: {
	    resetStepper: function resetStepper() {
	      var skuStepper = this.$refs.skuStepper;
	      var selectedNum = this.initialSku.selectedNum;
	      var num = (0, _utils.isDef)(selectedNum) ? selectedNum : this.startSaleNum; // 用来缓存不合法的情况
	
	      this.stepperError = null;
	
	      if (skuStepper) {
	        skuStepper.setCurrentNum(num);
	      } else {
	        // 当首次加载（skuStepper 为空）时，传入数量如果不合法，可能会存在问题
	        this.selectedNum = num;
	      }
	    },
	    // @exposed-api
	    resetSelectedSku: function resetSelectedSku() {
	      var _this3 = this;
	
	      this.selectedSku = {}; // 重置 selectedSku
	
	      this.skuTree.forEach(function (item) {
	        _this3.selectedSku[item.k_s] = _this3.initialSku[item.k_s] || _constants.UNSELECTED_SKU_VALUE_ID;
	      }); // 只有一个 sku 规格值时默认选中
	
	      this.skuTree.forEach(function (item) {
	        var key = item.k_s;
	        var valueId = item.v[0].id;
	
	        if (item.v.length === 1 && (0, _skuHelper.isSkuChoosable)(_this3.sku.list, _this3.selectedSku, {
	          key: key,
	          valueId: valueId
	        })) {
	          _this3.selectedSku[key] = valueId;
	        }
	      });
	      var skuValues = this.selectedSkuValues;
	
	      if (skuValues.length > 0) {
	        this.$nextTick(function () {
	          _this3.$emit('sku-selected', {
	            skuValue: skuValues[skuValues.length - 1],
	            selectedSku: _this3.selectedSku,
	            selectedSkuComb: _this3.selectedSkuComb
	          });
	        });
	      } // 重置商品属性
	
	
	      this.selectedProp = {};
	      var _this$initialSku$sele = this.initialSku.selectedProp,
	          selectedProp = _this$initialSku$sele === void 0 ? {} : _this$initialSku$sele; // 只有一个属性值时，默认选中，且选中外部传入信息
	
	      this.propList.forEach(function (item) {
	        if (item.v && item.v.length === 1) {
	          _this3.selectedProp[item.k_id] = [item.v[0].id];
	        } else if (selectedProp[item.k_id]) {
	          _this3.selectedProp[item.k_id] = selectedProp[item.k_id];
	        }
	      });
	      var propValues = this.selectedPropValues;
	
	      if (propValues.length > 0) {
	        this.$emit('sku-prop-selected', {
	          propValue: propValues[propValues.length - 1],
	          selectedProp: this.selectedProp,
	          selectedSkuComb: this.selectedSkuComb
	        });
	      }
	    },
	    getSkuMessages: function getSkuMessages() {
	      return this.$refs.skuMessages ? this.$refs.skuMessages.getMessages() : {};
	    },
	    getSkuCartMessages: function getSkuCartMessages() {
	      return this.$refs.skuMessages ? this.$refs.skuMessages.getCartMessages() : {};
	    },
	    validateSkuMessages: function validateSkuMessages() {
	      return this.$refs.skuMessages ? this.$refs.skuMessages.validateMessages() : '';
	    },
	    validateSku: function validateSku() {
	      if (this.selectedNum === 0) {
	        return t('unavailable');
	      }
	
	      if (this.isSkuCombSelected) {
	        return this.validateSkuMessages();
	      } // 自定义sku校验
	
	
	      if (this.customSkuValidator) {
	        var err = this.customSkuValidator(this);
	        if (err) return err;
	      }
	
	      return t('selectSku');
	    },
	    onSelect: function onSelect(skuValue) {
	      var _extends2, _extends3;
	
	      // 点击已选中的sku时则取消选中
	      this.selectedSku = this.selectedSku[skuValue.skuKeyStr] === skuValue.id ? (0, _extends5.default)({}, this.selectedSku, (_extends2 = {}, _extends2[skuValue.skuKeyStr] = _constants.UNSELECTED_SKU_VALUE_ID, _extends2)) : (0, _extends5.default)({}, this.selectedSku, (_extends3 = {}, _extends3[skuValue.skuKeyStr] = skuValue.id, _extends3));
	      this.$emit('sku-selected', {
	        skuValue: skuValue,
	        selectedSku: this.selectedSku,
	        selectedSkuComb: this.selectedSkuComb
	      });
	    },
	    onPropSelect: function onPropSelect(propValue) {
	      var _extends4;
	
	      var arr = this.selectedProp[propValue.skuKeyStr] || [];
	      var pos = arr.indexOf(propValue.id);
	
	      if (pos > -1) {
	        arr.splice(pos, 1);
	      } else if (propValue.multiple) {
	        arr.push(propValue.id);
	      } else {
	        arr.splice(0, 1, propValue.id);
	      }
	
	      this.selectedProp = (0, _extends5.default)({}, this.selectedProp, (_extends4 = {}, _extends4[propValue.skuKeyStr] = arr, _extends4));
	      this.$emit('sku-prop-selected', {
	        propValue: propValue,
	        selectedProp: this.selectedProp,
	        selectedSkuComb: this.selectedSkuComb
	      });
	    },
	    onNumChange: function onNumChange(num) {
	      this.selectedNum = num;
	    },
	    onPreviewImage: function onPreviewImage(indexImage) {
	      var _this4 = this;
	
	      var previewOnClickImage = this.previewOnClickImage;
	      var index = this.imageList.findIndex(function (image) {
	        return image === indexImage;
	      });
	      var params = {
	        index: index,
	        imageList: this.imageList,
	        indexImage: indexImage
	      };
	      this.$emit('open-preview', params);
	
	      if (!previewOnClickImage) {
	        return;
	      }
	
	      (0, _imagePreview.default)({
	        images: this.imageList,
	        startPosition: index,
	        closeOnPopstate: true,
	        onClose: function onClose() {
	          _this4.$emit('close-preview', params);
	        }
	      });
	    },
	    onOverLimit: function onOverLimit(data) {
	      var action = data.action,
	          limitType = data.limitType,
	          quota = data.quota,
	          quotaUsed = data.quotaUsed;
	      var handleOverLimit = this.customStepperConfig.handleOverLimit;
	
	      if (handleOverLimit) {
	        handleOverLimit(data);
	        return;
	      }
	
	      if (action === 'minus') {
	        if (this.startSaleNum > 1) {
	          (0, _toast.default)(t('minusStartTip', this.startSaleNum));
	        } else {
	          (0, _toast.default)(t('minusTip'));
	        }
	      } else if (action === 'plus') {
	        if (limitType === QUOTA_LIMIT) {
	          if (quotaUsed > 0) {
	            (0, _toast.default)(t('quotaUsedTip', quota, quotaUsed));
	          } else {
	            (0, _toast.default)(t('quotaTip', quota));
	          }
	        } else {
	          (0, _toast.default)(t('soldout'));
	        }
	      }
	    },
	    onStepperState: function onStepperState(data) {
	      if (data.valid) {
	        this.stepperError = null;
	      } else {
	        this.stepperError = (0, _extends5.default)({}, data, {
	          action: 'plus'
	        });
	      }
	    },
	    onAddCart: function onAddCart() {
	      this.onBuyOrAddCart('add-cart');
	    },
	    onBuy: function onBuy() {
	      this.onBuyOrAddCart('buy-clicked');
	    },
	    onBuyOrAddCart: function onBuyOrAddCart(type) {
	      // 有信息表示该sku根本不符合购买条件
	      if (this.stepperError) {
	        return this.onOverLimit(this.stepperError);
	      }
	
	      var error = this.validateSku();
	
	      if (error) {
	        (0, _toast.default)(error);
	      } else {
	        this.$emit(type, this.getSkuData());
	      }
	    },
	    // @exposed-api
	    getSkuData: function getSkuData() {
	      return {
	        goodsId: this.goodsId,
	        selectedNum: this.selectedNum,
	        selectedSkuComb: this.selectedSkuComb,
	        messages: this.getSkuMessages(),
	        cartMessages: this.getSkuCartMessages()
	      };
	    }
	  },
	  render: function render() {
	    var _this5 = this;
	
	    var h = arguments[0];
	
	    if (this.isSkuEmpty) {
	      return;
	    }
	
	    var sku = this.sku,
	        goods = this.goods,
	        price = this.price,
	        originPrice = this.originPrice,
	        skuEventBus = this.skuEventBus,
	        selectedSku = this.selectedSku,
	        selectedProp = this.selectedProp,
	        selectedNum = this.selectedNum,
	        stepperTitle = this.stepperTitle,
	        selectedSkuComb = this.selectedSkuComb;
	    var slotsProps = {
	      price: price,
	      originPrice: originPrice,
	      selectedNum: selectedNum,
	      skuEventBus: skuEventBus,
	      selectedSku: selectedSku,
	      selectedSkuComb: selectedSkuComb
	    };
	
	    var slots = function slots(name) {
	      return _this5.slots(name, slotsProps);
	    };
	
	    var Header = slots('sku-header') || h(_SkuHeader.default, {
	      "attrs": {
	        "sku": sku,
	        "goods": goods,
	        "skuEventBus": skuEventBus,
	        "selectedSku": selectedSku
	      }
	    }, [h("template", {
	      "slot": "sku-header-image-extra"
	    }, [slots('sku-header-image-extra')]), slots('sku-header-price') || h("div", {
	      "class": "van-sku__goods-price"
	    }, [h("span", {
	      "class": "van-sku__price-symbol"
	    }, ["\uFFE5"]), h("span", {
	      "class": "van-sku__price-num"
	    }, [price]), this.priceTag && h("span", {
	      "class": "van-sku__price-tag"
	    }, [this.priceTag])]), slots('sku-header-origin-price') || originPrice && h(_SkuHeaderItem.default, [t('originPrice'), " \uFFE5", originPrice]), !this.hideStock && h(_SkuHeaderItem.default, [h("span", {
	      "class": "van-sku__stock"
	    }, [this.stockText])]), this.hasSkuOrAttr && !this.hideSelectedText && h(_SkuHeaderItem.default, [this.selectedText]), slots('sku-header-extra')]);
	    var Group = slots('sku-group') || this.hasSkuOrAttr && h("div", {
	      "class": this.skuGroupClass
	    }, [this.skuTree.map(function (skuTreeItem) {
	      return h(_SkuRow.default, {
	        "attrs": {
	          "skuRow": skuTreeItem
	        }
	      }, [skuTreeItem.v.map(function (skuValue) {
	        return h(_SkuRowItem.default, {
	          "attrs": {
	            "skuList": sku.list,
	            "skuValue": skuValue,
	            "selectedSku": selectedSku,
	            "skuEventBus": skuEventBus,
	            "skuKeyStr": skuTreeItem.k_s
	          }
	        });
	      })]);
	    }), this.propList.map(function (skuTreeItem) {
	      return h(_SkuRow.default, {
	        "attrs": {
	          "skuRow": skuTreeItem
	        }
	      }, [skuTreeItem.v.map(function (skuValue) {
	        return h(_SkuRowPropItem.default, {
	          "attrs": {
	            "skuValue": skuValue,
	            "skuKeyStr": skuTreeItem.k_id + '',
	            "selectedProp": selectedProp,
	            "skuEventBus": skuEventBus,
	            "multiple": skuTreeItem.is_multiple
	          }
	        });
	      })]);
	    })]);
	    var Stepper = slots('sku-stepper') || h(_SkuStepper.default, {
	      "ref": "skuStepper",
	      "attrs": {
	        "stock": this.stock,
	        "quota": this.quota,
	        "quotaUsed": this.quotaUsed,
	        "startSaleNum": this.startSaleNum,
	        "skuEventBus": skuEventBus,
	        "selectedNum": selectedNum,
	        "selectedSku": selectedSku,
	        "stepperTitle": stepperTitle,
	        "skuStockNum": sku.stock_num,
	        "disableStepperInput": this.disableStepperInput,
	        "customStepperConfig": this.customStepperConfig,
	        "hideQuotaText": this.hideQuotaText
	      },
	      "on": {
	        "change": function change(event) {
	          _this5.$emit('stepper-change', event);
	        }
	      }
	    });
	    var Messages = slots('sku-messages') || h(_SkuMessages.default, {
	      "ref": "skuMessages",
	      "attrs": {
	        "goodsId": this.goodsId,
	        "messageConfig": this.messageConfig,
	        "messages": sku.messages
	      }
	    });
	    var Actions = slots('sku-actions') || h(_SkuActions.default, {
	      "attrs": {
	        "buyText": this.buyText,
	        "skuEventBus": skuEventBus,
	        "addCartText": this.addCartText,
	        "showAddCartBtn": this.showAddCartBtn
	      }
	    });
	    return h(_popup.default, {
	      "attrs": {
	        "round": true,
	        "closeable": true,
	        "position": "bottom",
	        "getContainer": this.getContainer,
	        "closeOnClickOverlay": this.closeOnClickOverlay,
	        "safeAreaInsetBottom": this.safeAreaInsetBottom
	      },
	      "class": "van-sku-container",
	      "model": {
	        value: _this5.show,
	        callback: function callback($$v) {
	          _this5.show = $$v;
	        }
	      }
	    }, [Header, h("div", {
	      "class": "van-sku-body",
	      "style": this.bodyStyle
	    }, [slots('sku-body-top'), Group, slots('extra-sku-group'), Stepper, Messages]), slots('sku-actions-top'), Actions]);
	  }
	});
	
	exports.default = _default2;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _loading = _interopRequireDefault(__webpack_require__(18));
	
	var _uploader = _interopRequireDefault(__webpack_require__(169));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('sku-img-uploader'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	var _default = createComponent({
	  props: {
	    value: String,
	    uploadImg: Function,
	    maxSize: {
	      type: Number,
	      default: 6
	    }
	  },
	  data: function data() {
	    return {
	      // 正在上传的图片 base64
	      paddingImg: '',
	      uploadFail: false
	    };
	  },
	  methods: {
	    afterReadFile: function afterReadFile(file) {
	      var _this = this;
	
	      // 上传文件
	      this.paddingImg = file.content;
	      this.uploadFail = false;
	      this.uploadImg(file.file, file.content).then(function (img) {
	        _this.$emit('input', img);
	
	        _this.$nextTick(function () {
	          _this.paddingImg = '';
	        });
	      }).catch(function () {
	        _this.uploadFail = true;
	      });
	    },
	    onOversize: function onOversize() {
	      this.$toast(t('oversize', this.maxSize));
	    },
	    genUploader: function genUploader(content, disabled) {
	      if (disabled === void 0) {
	        disabled = false;
	      }
	
	      var h = this.$createElement;
	      return h(_uploader.default, {
	        "class": bem('uploader'),
	        "attrs": {
	          "disabled": disabled,
	          "afterRead": this.afterReadFile,
	          "maxSize": this.maxSize * 1024 * 1024
	        },
	        "on": {
	          "oversize": this.onOversize
	        }
	      }, [h("div", {
	        "class": bem('img')
	      }, [content])]);
	    },
	    genMask: function genMask() {
	      var h = this.$createElement;
	      return h("div", {
	        "class": bem('mask')
	      }, [this.uploadFail ? [h(_icon.default, {
	        "attrs": {
	          "name": "warning-o",
	          "size": "20px"
	        }
	      }), h("div", {
	        "class": bem('warn-text'),
	        "domProps": {
	          "innerHTML": t('fail')
	        }
	      })] : h(_loading.default, {
	        "attrs": {
	          "type": "spinner",
	          "size": "20px",
	          "color": "white"
	        }
	      })]);
	    }
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var h = arguments[0];
	    return h("div", {
	      "class": bem()
	    }, [this.value && this.genUploader([h("img", {
	      "attrs": {
	        "src": this.value
	      }
	    }), h(_icon.default, {
	      "attrs": {
	        "name": "clear"
	      },
	      "class": bem('delete'),
	      "on": {
	        "click": function click() {
	          _this2.$emit('input', '');
	        }
	      }
	    })], true), this.paddingImg && this.genUploader([h("img", {
	      "attrs": {
	        "src": this.paddingImg
	      }
	    }), this.genMask()], !this.uploadFail), !this.value && !this.paddingImg && this.genUploader(h("div", {
	      "class": bem('trigger')
	    }, [h(_icon.default, {
	      "attrs": {
	        "name": "photograph",
	        "size": "22px"
	      }
	    })]))]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _lang = _interopRequireDefault(__webpack_require__(375));
	
	var _constants = _interopRequireDefault(__webpack_require__(62));
	
	var _skuHelper = _interopRequireDefault(__webpack_require__(100));
	
	var _Sku = _interopRequireDefault(__webpack_require__(372));
	
	var _locale = _interopRequireDefault(__webpack_require__(61));
	
	var _SkuActions = _interopRequireDefault(__webpack_require__(153));
	
	var _SkuHeader = _interopRequireDefault(__webpack_require__(154));
	
	var _SkuHeaderItem = _interopRequireDefault(__webpack_require__(155));
	
	var _SkuMessages = _interopRequireDefault(__webpack_require__(156));
	
	var _SkuStepper = _interopRequireDefault(__webpack_require__(160));
	
	var _SkuRow = _interopRequireDefault(__webpack_require__(157));
	
	var _SkuRowItem = _interopRequireDefault(__webpack_require__(158));
	
	var _SkuRowPropItem = _interopRequireDefault(__webpack_require__(159));
	
	// Utils
	// Components
	_locale.default.add(_lang.default);
	
	_Sku.default.SkuActions = _SkuActions.default;
	_Sku.default.SkuHeader = _SkuHeader.default;
	_Sku.default.SkuHeaderItem = _SkuHeaderItem.default;
	_Sku.default.SkuMessages = _SkuMessages.default;
	_Sku.default.SkuStepper = _SkuStepper.default;
	_Sku.default.SkuRow = _SkuRow.default;
	_Sku.default.SkuRowItem = _SkuRowItem.default;
	_Sku.default.SkuRowPropItem = _SkuRowPropItem.default;
	_Sku.default.skuHelper = _skuHelper.default;
	_Sku.default.skuConstants = _constants.default;
	var _default = _Sku.default;
	exports.default = _default;

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	/**
	 * Sku only provide zh-CN lang by default
	 */
	var _default = {
	  'zh-CN': {
	    vanSku: {
	      select: '选择',
	      selected: '已选',
	      selectSku: '请先选择商品规格',
	      soldout: '库存不足',
	      originPrice: '原价',
	      minusTip: '至少选择一件',
	      minusStartTip: function minusStartTip(start) {
	        return start + "\u4EF6\u8D77\u552E";
	      },
	      unavailable: '商品已经无法购买啦',
	      stock: '剩余',
	      stockUnit: '件',
	      quotaTip: function quotaTip(quota) {
	        return "\u6BCF\u4EBA\u9650\u8D2D" + quota + "\u4EF6";
	      },
	      quotaUsedTip: function quotaUsedTip(quota, count) {
	        return "\u6BCF\u4EBA\u9650\u8D2D" + quota + "\u4EF6\uFF0C\u4F60\u5DF2\u8D2D\u4E70" + count + "\u4EF6";
	      }
	    },
	    vanSkuActions: {
	      buy: '立即购买',
	      addCart: '加入购物车'
	    },
	    vanSkuImgUploader: {
	      oversize: function oversize(maxSize) {
	        return "\u6700\u5927\u53EF\u4E0A\u4F20\u56FE\u7247\u4E3A" + maxSize + "MB\uFF0C\u8BF7\u5C1D\u8BD5\u538B\u7F29\u56FE\u7247\u5C3A\u5BF8";
	      },
	      fail: '上传失败<br />重新上传'
	    },
	    vanSkuStepper: {
	      quotaLimit: function quotaLimit(quota) {
	        return "\u9650\u8D2D" + quota + "\u4EF6";
	      },
	      quotaStart: function quotaStart(start) {
	        return start + "\u4EF6\u8D77\u552E";
	      },
	      comma: '，',
	      num: '购买数量'
	    },
	    vanSkuMessages: {
	      fill: '请填写',
	      upload: '请上传',
	      imageLabel: '仅限一张',
	      invalid: {
	        tel: '请填写正确的数字格式留言',
	        mobile: '手机号长度为6-20位数字',
	        email: '请填写正确的邮箱',
	        id_no: '请填写正确的身份证号码'
	      },
	      placeholder: {
	        id_no: '输入身份证号码',
	        text: '输入文本',
	        tel: '输入数字',
	        email: '输入邮箱',
	        date: '点击选择日期',
	        time: '点击选择时间',
	        textarea: '点击填写段落文本',
	        mobile: '输入手机号码'
	      }
	    },
	    vanSkuRow: {
	      multiple: '可多选'
	    }
	  }
	};
	exports.default = _default;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _event = __webpack_require__(10);
	
	var _touch = __webpack_require__(19);
	
	var _field = __webpack_require__(27);
	
	var _createNamespace = (0, _utils.createNamespace)('slider'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [_touch.TouchMixin, _field.FieldMixin],
	  props: {
	    disabled: Boolean,
	    vertical: Boolean,
	    barHeight: [Number, String],
	    buttonSize: [Number, String],
	    activeColor: String,
	    inactiveColor: String,
	    min: {
	      type: [Number, String],
	      default: 0
	    },
	    max: {
	      type: [Number, String],
	      default: 100
	    },
	    step: {
	      type: [Number, String],
	      default: 1
	    },
	    value: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      dragStatus: ''
	    };
	  },
	  computed: {
	    range: function range() {
	      return this.max - this.min;
	    },
	    buttonStyle: function buttonStyle() {
	      if (this.buttonSize) {
	        var size = (0, _utils.addUnit)(this.buttonSize);
	        return {
	          width: size,
	          height: size
	        };
	      }
	    }
	  },
	  created: function created() {
	    // format initial value
	    this.updateValue(this.value);
	  },
	  mounted: function mounted() {
	    this.bindTouchEvent(this.$refs.wrapper);
	  },
	  methods: {
	    onTouchStart: function onTouchStart(event) {
	      if (this.disabled) {
	        return;
	      }
	
	      this.touchStart(event);
	      this.startValue = this.format(this.value);
	      this.dragStatus = 'start';
	    },
	    onTouchMove: function onTouchMove(event) {
	      if (this.disabled) {
	        return;
	      }
	
	      if (this.dragStatus === 'start') {
	        this.$emit('drag-start');
	      }
	
	      (0, _event.preventDefault)(event, true);
	      this.touchMove(event);
	      this.dragStatus = 'draging';
	      var rect = this.$el.getBoundingClientRect();
	      var delta = this.vertical ? this.deltaY : this.deltaX;
	      var total = this.vertical ? rect.height : rect.width;
	      var diff = delta / total * this.range;
	      this.newValue = this.startValue + diff;
	      this.updateValue(this.newValue);
	    },
	    onTouchEnd: function onTouchEnd() {
	      if (this.disabled) {
	        return;
	      }
	
	      if (this.dragStatus === 'draging') {
	        this.updateValue(this.newValue, true);
	        this.$emit('drag-end');
	      }
	
	      this.dragStatus = '';
	    },
	    onClick: function onClick(event) {
	      event.stopPropagation();
	      if (this.disabled) return;
	      var rect = this.$el.getBoundingClientRect();
	      var delta = this.vertical ? event.clientY - rect.top : event.clientX - rect.left;
	      var total = this.vertical ? rect.height : rect.width;
	      var value = +this.min + delta / total * this.range;
	      this.startValue = this.value;
	      this.updateValue(value, true);
	    },
	    updateValue: function updateValue(value, end) {
	      value = this.format(value);
	
	      if (value !== this.value) {
	        this.$emit('input', value);
	      }
	
	      if (end && value !== this.startValue) {
	        this.$emit('change', value);
	      }
	    },
	    format: function format(value) {
	      return Math.round(Math.max(this.min, Math.min(value, this.max)) / this.step) * this.step;
	    }
	  },
	  render: function render() {
	    var _barStyle;
	
	    var h = arguments[0];
	    var vertical = this.vertical;
	    var style = {
	      background: this.inactiveColor
	    };
	    var mainAxis = vertical ? 'height' : 'width';
	    var crossAxis = vertical ? 'width' : 'height';
	    var barStyle = (_barStyle = {}, _barStyle[mainAxis] = (this.value - this.min) * 100 / this.range + "%", _barStyle[crossAxis] = (0, _utils.addUnit)(this.barHeight), _barStyle.background = this.activeColor, _barStyle);
	
	    if (this.dragStatus) {
	      barStyle.transition = 'none';
	    }
	
	    return h("div", {
	      "style": style,
	      "class": bem({
	        disabled: this.disabled,
	        vertical: vertical
	      }),
	      "on": {
	        "click": this.onClick
	      }
	    }, [h("div", {
	      "class": bem('bar'),
	      "style": barStyle
	    }, [h("div", {
	      "ref": "wrapper",
	      "attrs": {
	        "role": "slider",
	        "tabindex": this.disabled ? -1 : 0,
	        "aria-valuemin": this.min,
	        "aria-valuenow": this.value,
	        "aria-valuemax": this.max,
	        "aria-orientation": this.vertical ? 'vertical' : 'horizontal'
	      },
	      "class": bem('button-wrapper')
	    }, [this.slots('button') || h("div", {
	      "class": bem('button'),
	      "style": this.buttonStyle
	    })])])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _constant = __webpack_require__(7);
	
	var _relation = __webpack_require__(9);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _createNamespace = (0, _utils.createNamespace)('step'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ChildrenMixin)('vanSteps')],
	  computed: {
	    status: function status() {
	      if (this.index < this.parent.active) {
	        return 'finish';
	      }
	
	      if (this.index === +this.parent.active) {
	        return 'process';
	      }
	    },
	    active: function active() {
	      return this.status === 'process';
	    }
	  },
	  methods: {
	    genCircle: function genCircle() {
	      var h = this.$createElement;
	      var _this$parent = this.parent,
	          activeIcon = _this$parent.activeIcon,
	          activeColor = _this$parent.activeColor,
	          inactiveIcon = _this$parent.inactiveIcon;
	
	      if (this.active) {
	        return this.slots('active-icon') || h(_icon.default, {
	          "class": bem('icon', 'active'),
	          "attrs": {
	            "name": activeIcon,
	            "color": activeColor
	          }
	        });
	      }
	
	      var inactiveIconSlot = this.slots('inactive-icon');
	
	      if (inactiveIcon || inactiveIconSlot) {
	        return inactiveIconSlot || h(_icon.default, {
	          "class": bem('icon'),
	          "attrs": {
	            "name": inactiveIcon
	          }
	        });
	      }
	
	      return h("i", {
	        "class": bem('circle')
	      });
	    }
	  },
	  render: function render() {
	    var _ref;
	
	    var h = arguments[0];
	    var status = this.status,
	        active = this.active;
	    var _this$parent2 = this.parent,
	        activeColor = _this$parent2.activeColor,
	        direction = _this$parent2.direction;
	    var titleStyle = active && {
	      color: activeColor
	    };
	    var lineStyle = status === 'finish' && {
	      background: activeColor
	    };
	    return h("div", {
	      "class": [_constant.BORDER, bem([direction, (_ref = {}, _ref[status] = status, _ref)])]
	    }, [h("div", {
	      "class": bem('title', {
	        active: active
	      }),
	      "style": titleStyle
	    }, [this.slots()]), h("div", {
	      "class": bem('circle-container')
	    }, [this.genCircle()]), h("div", {
	      "class": bem('line'),
	      "style": lineStyle
	    })]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _relation = __webpack_require__(9);
	
	var _createNamespace = (0, _utils.createNamespace)('steps'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ParentMixin)('vanSteps')],
	  props: {
	    activeColor: String,
	    inactiveIcon: String,
	    active: {
	      type: [Number, String],
	      default: 0
	    },
	    direction: {
	      type: String,
	      default: 'horizontal'
	    },
	    activeIcon: {
	      type: String,
	      default: 'checked'
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "class": bem([this.direction])
	    }, [h("div", {
	      "class": bem('items')
	    }, [this.slots()])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _button = _interopRequireDefault(__webpack_require__(17));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('submit-bar'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1],
	    t = _createNamespace[2];
	
	function SubmitBar(h, props, slots, ctx) {
	  var tip = props.tip,
	      price = props.price,
	      tipIcon = props.tipIcon;
	
	  function Text() {
	    if (typeof price === 'number') {
	      var priceArr = (price / 100).toFixed(props.decimalLength).split('.');
	      var decimalStr = props.decimalLength ? "." + priceArr[1] : '';
	      return h("div", {
	        "style": {
	          textAlign: props.textAlign ? props.textAlign : ''
	        },
	        "class": bem('text')
	      }, [h("span", [props.label || t('label')]), h("span", {
	        "class": bem('price')
	      }, [props.currency, h("span", {
	        "class": bem('price', 'integer')
	      }, [priceArr[0]]), decimalStr]), props.suffixLabel && h("span", {
	        "class": bem('suffix-label')
	      }, [props.suffixLabel])]);
	    }
	  }
	
	  function Tip() {
	    if (slots.tip || tip) {
	      return h("div", {
	        "class": bem('tip')
	      }, [tipIcon && h(_icon.default, {
	        "class": bem('tip-icon'),
	        "attrs": {
	          "name": tipIcon
	        }
	      }), tip && h("span", {
	        "class": bem('tip-text')
	      }, [tip]), slots.tip && slots.tip()]);
	    }
	  }
	
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem({
	      'safe-area-inset-bottom': props.safeAreaInsetBottom
	    })
	  }, (0, _functional.inherit)(ctx)]), [slots.top && slots.top(), Tip(), h("div", {
	    "class": bem('bar')
	  }, [slots.default && slots.default(), Text(), h(_button.default, {
	    "attrs": {
	      "round": true,
	      "type": props.buttonType,
	      "loading": props.loading,
	      "disabled": props.disabled,
	      "text": props.loading ? '' : props.buttonText
	    },
	    "class": bem('button', props.buttonType),
	    "on": {
	      "click": function click() {
	        (0, _functional.emit)(ctx, 'submit');
	      }
	    }
	  })])]);
	}
	
	SubmitBar.props = {
	  tip: String,
	  label: String,
	  price: Number,
	  tipIcon: String,
	  loading: Boolean,
	  disabled: Boolean,
	  textAlign: String,
	  buttonText: String,
	  suffixLabel: String,
	  safeAreaInsetBottom: Boolean,
	  decimalLength: {
	    type: [Number, String],
	    default: 2
	  },
	  currency: {
	    type: String,
	    default: '¥'
	  },
	  buttonType: {
	    type: String,
	    default: 'danger'
	  }
	};
	
	var _default = createComponent(SubmitBar);
	
	exports.default = _default;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _number = __webpack_require__(47);
	
	var _event = __webpack_require__(10);
	
	var _touch = __webpack_require__(19);
	
	var _clickOutside = __webpack_require__(147);
	
	// Utils
	// Mixins
	var _createNamespace = (0, _utils.createNamespace)('swipe-cell'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var THRESHOLD = 0.15;
	
	var _default = createComponent({
	  mixins: [_touch.TouchMixin, (0, _clickOutside.ClickOutsideMixin)({
	    event: 'touchstart',
	    method: 'onClick'
	  })],
	  props: {
	    // @deprecated
	    // should be removed in next major version, use beforeClose instead
	    onClose: Function,
	    disabled: Boolean,
	    leftWidth: [Number, String],
	    rightWidth: [Number, String],
	    beforeClose: Function,
	    stopPropagation: Boolean,
	    name: {
	      type: [Number, String],
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      offset: 0,
	      dragging: false
	    };
	  },
	  computed: {
	    computedLeftWidth: function computedLeftWidth() {
	      return +this.leftWidth || this.getWidthByRef('left');
	    },
	    computedRightWidth: function computedRightWidth() {
	      return +this.rightWidth || this.getWidthByRef('right');
	    }
	  },
	  mounted: function mounted() {
	    this.bindTouchEvent(this.$el);
	  },
	  methods: {
	    getWidthByRef: function getWidthByRef(ref) {
	      if (this.$refs[ref]) {
	        var rect = this.$refs[ref].getBoundingClientRect();
	        return rect.width;
	      }
	
	      return 0;
	    },
	    // @exposed-api
	    open: function open(position) {
	      var offset = position === 'left' ? this.computedLeftWidth : -this.computedRightWidth;
	      this.opened = true;
	      this.offset = offset;
	      this.$emit('open', {
	        position: position,
	        name: this.name,
	        // @deprecated
	        // should be removed in next major version
	        detail: this.name
	      });
	    },
	    // @exposed-api
	    close: function close(position) {
	      this.offset = 0;
	
	      if (this.opened) {
	        this.opened = false;
	        this.$emit('close', {
	          position: position,
	          name: this.name
	        });
	      }
	    },
	    onTouchStart: function onTouchStart(event) {
	      if (this.disabled) {
	        return;
	      }
	
	      this.startOffset = this.offset;
	      this.touchStart(event);
	    },
	    onTouchMove: function onTouchMove(event) {
	      if (this.disabled) {
	        return;
	      }
	
	      this.touchMove(event);
	
	      if (this.direction === 'horizontal') {
	        this.dragging = true;
	        this.lockClick = true;
	        var isPrevent = !this.opened || this.deltaX * this.startOffset < 0;
	
	        if (isPrevent) {
	          (0, _event.preventDefault)(event, this.stopPropagation);
	        }
	
	        this.offset = (0, _number.range)(this.deltaX + this.startOffset, -this.computedRightWidth, this.computedLeftWidth);
	      }
	    },
	    onTouchEnd: function onTouchEnd() {
	      var _this = this;
	
	      if (this.disabled) {
	        return;
	      }
	
	      if (this.dragging) {
	        this.toggle(this.offset > 0 ? 'left' : 'right');
	        this.dragging = false; // compatible with desktop scenario
	
	        setTimeout(function () {
	          _this.lockClick = false;
	        }, 0);
	      }
	    },
	    toggle: function toggle(direction) {
	      var offset = Math.abs(this.offset);
	      var threshold = this.opened ? 1 - THRESHOLD : THRESHOLD;
	      var computedLeftWidth = this.computedLeftWidth,
	          computedRightWidth = this.computedRightWidth;
	
	      if (computedRightWidth && direction === 'right' && offset > computedRightWidth * threshold) {
	        this.open('right');
	      } else if (computedLeftWidth && direction === 'left' && offset > computedLeftWidth * threshold) {
	        this.open('left');
	      } else {
	        this.close();
	      }
	    },
	    onClick: function onClick(position) {
	      if (position === void 0) {
	        position = 'outside';
	      }
	
	      this.$emit('click', position);
	
	      if (this.opened && !this.lockClick) {
	        if (this.beforeClose) {
	          this.beforeClose({
	            position: position,
	            name: this.name,
	            instance: this
	          });
	        } else if (this.onClose) {
	          this.onClose(position, this, {
	            name: this.name
	          });
	        } else {
	          this.close(position);
	        }
	      }
	    },
	    getClickHandler: function getClickHandler(position, stop) {
	      var _this2 = this;
	
	      return function (event) {
	        if (stop) {
	          event.stopPropagation();
	        }
	
	        _this2.onClick(position);
	      };
	    },
	    genLeftPart: function genLeftPart() {
	      var h = this.$createElement;
	      var content = this.slots('left');
	
	      if (content) {
	        return h("div", {
	          "ref": "left",
	          "class": bem('left'),
	          "on": {
	            "click": this.getClickHandler('left', true)
	          }
	        }, [content]);
	      }
	    },
	    genRightPart: function genRightPart() {
	      var h = this.$createElement;
	      var content = this.slots('right');
	
	      if (content) {
	        return h("div", {
	          "ref": "right",
	          "class": bem('right'),
	          "on": {
	            "click": this.getClickHandler('right', true)
	          }
	        }, [content]);
	      }
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    var wrapperStyle = {
	      transform: "translate3d(" + this.offset + "px, 0, 0)",
	      transitionDuration: this.dragging ? '0s' : '.6s'
	    };
	    return h("div", {
	      "class": bem(),
	      "on": {
	        "click": this.getClickHandler('cell')
	      }
	    }, [h("div", {
	      "class": bem('wrapper'),
	      "style": wrapperStyle
	    }, [this.genLeftPart(), this.slots(), this.genRightPart()])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _router = __webpack_require__(24);
	
	var _relation = __webpack_require__(9);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _info = _interopRequireDefault(__webpack_require__(35));
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('tabbar-item'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ChildrenMixin)('vanTabbar')],
	  props: (0, _extends2.default)({}, _router.routeProps, {
	    dot: Boolean,
	    icon: String,
	    name: [Number, String],
	    info: [Number, String],
	    iconPrefix: String
	  }),
	  data: function data() {
	    return {
	      active: false
	    };
	  },
	  computed: {
	    routeActive: function routeActive() {
	      var to = this.to,
	          $route = this.$route;
	
	      if (to && $route) {
	        var config = (0, _utils.isObject)(to) ? to : {
	          path: to
	        };
	        var pathMatched = config.path === $route.path;
	        var nameMatched = (0, _utils.isDef)(config.name) && config.name === $route.name;
	        return pathMatched || nameMatched;
	      }
	    }
	  },
	  methods: {
	    onClick: function onClick(event) {
	      this.parent.onChange(this.name || this.index);
	      this.$emit('click', event);
	      (0, _router.route)(this.$router, this);
	    },
	    genIcon: function genIcon(active) {
	      var h = this.$createElement;
	      var slot = this.slots('icon', {
	        active: active
	      });
	
	      if (slot) {
	        return slot;
	      }
	
	      if (this.icon) {
	        return h(_icon.default, {
	          "attrs": {
	            "name": this.icon,
	            "classPrefix": this.iconPrefix
	          }
	        });
	      }
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    var active = this.parent.route ? this.routeActive : this.active;
	    var color = this.parent[active ? 'activeColor' : 'inactiveColor'];
	    return h("div", {
	      "class": bem({
	        active: active
	      }),
	      "style": {
	        color: color
	      },
	      "on": {
	        "click": this.onClick
	      }
	    }, [h("div", {
	      "class": bem('icon')
	    }, [this.genIcon(active), h(_info.default, {
	      "attrs": {
	        "dot": this.dot,
	        "info": this.info
	      }
	    })]), h("div", {
	      "class": bem('text')
	    }, [this.slots('default', {
	      active: active
	    })])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _relation = __webpack_require__(9);
	
	var _constant = __webpack_require__(7);
	
	var _createNamespace = (0, _utils.createNamespace)('tabbar'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _relation.ParentMixin)('vanTabbar')],
	  props: {
	    route: Boolean,
	    zIndex: [Number, String],
	    activeColor: String,
	    inactiveColor: String,
	    safeAreaInsetBottom: Boolean,
	    value: {
	      type: [Number, String],
	      default: 0
	    },
	    border: {
	      type: Boolean,
	      default: true
	    },
	    fixed: {
	      type: Boolean,
	      default: true
	    }
	  },
	  watch: {
	    value: 'setActiveItem',
	    children: 'setActiveItem'
	  },
	  methods: {
	    setActiveItem: function setActiveItem() {
	      var _this = this;
	
	      this.children.forEach(function (item, index) {
	        item.active = (item.name || index) === _this.value;
	      });
	    },
	    onChange: function onChange(active) {
	      if (active !== this.value) {
	        this.$emit('input', active);
	        this.$emit('change', active);
	      }
	    }
	  },
	  render: function render() {
	    var _ref;
	
	    var h = arguments[0];
	    return h("div", {
	      "style": {
	        zIndex: this.zIndex
	      },
	      "class": [(_ref = {}, _ref[_constant.BORDER_TOP_BOTTOM] = this.border, _ref), bem({
	        fixed: this.fixed,
	        'safe-area-inset-bottom': this.safeAreaInsetBottom
	      })]
	    }, [this.slots()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(1);
	
	var _touch = __webpack_require__(19);
	
	var _createNamespace = (0, _utils.createNamespace)('tabs'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var MIN_SWIPE_DISTANCE = 50;
	
	var _default = createComponent({
	  mixins: [_touch.TouchMixin],
	  props: {
	    count: Number,
	    duration: [Number, String],
	    animated: Boolean,
	    swipeable: Boolean,
	    currentIndex: Number
	  },
	  computed: {
	    style: function style() {
	      if (this.animated) {
	        return {
	          transform: "translate3d(" + -1 * this.currentIndex * 100 + "%, 0, 0)",
	          transitionDuration: this.duration + "s"
	        };
	      }
	    },
	    listeners: function listeners() {
	      if (this.swipeable) {
	        return {
	          touchstart: this.touchStart,
	          touchmove: this.touchMove,
	          touchend: this.onTouchEnd,
	          touchcancel: this.onTouchEnd
	        };
	      }
	    }
	  },
	  methods: {
	    // watch swipe touch end
	    onTouchEnd: function onTouchEnd() {
	      var direction = this.direction,
	          deltaX = this.deltaX,
	          currentIndex = this.currentIndex;
	      /* istanbul ignore else */
	
	      if (direction === 'horizontal' && this.offsetX >= MIN_SWIPE_DISTANCE) {
	        /* istanbul ignore else */
	        if (deltaX > 0 && currentIndex !== 0) {
	          this.$emit('change', currentIndex - 1);
	        } else if (deltaX < 0 && currentIndex !== this.count - 1) {
	          this.$emit('change', currentIndex + 1);
	        }
	      }
	    },
	    genChildren: function genChildren() {
	      var h = this.$createElement;
	
	      if (this.animated) {
	        return h("div", {
	          "class": bem('track'),
	          "style": this.style
	        }, [this.slots()]);
	      }
	
	      return this.slots();
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "class": bem('content', {
	        animated: this.animated
	      }),
	      "on": (0, _extends2.default)({}, this.listeners)
	    }, [this.genChildren()]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _info = _interopRequireDefault(__webpack_require__(35));
	
	var _createNamespace = (0, _utils.createNamespace)('tab'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  props: {
	    dot: Boolean,
	    type: String,
	    info: [Number, String],
	    color: String,
	    title: String,
	    isActive: Boolean,
	    ellipsis: Boolean,
	    disabled: Boolean,
	    scrollable: Boolean,
	    activeColor: String,
	    inactiveColor: String,
	    swipeThreshold: [Number, String]
	  },
	  computed: {
	    style: function style() {
	      var style = {};
	      var color = this.color,
	          isActive = this.isActive;
	      var isCard = this.type === 'card'; // card theme color
	
	      if (color && isCard) {
	        style.borderColor = color;
	
	        if (!this.disabled) {
	          if (isActive) {
	            style.backgroundColor = color;
	          } else {
	            style.color = color;
	          }
	        }
	      }
	
	      var titleColor = isActive ? this.activeColor : this.inactiveColor;
	
	      if (titleColor) {
	        style.color = titleColor;
	      }
	
	      if (this.scrollable && this.ellipsis) {
	        style.flexBasis = 88 / this.swipeThreshold + "%";
	      }
	
	      return style;
	    }
	  },
	  methods: {
	    onClick: function onClick() {
	      this.$emit('click');
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	    return h("div", {
	      "attrs": {
	        "role": "tab",
	        "aria-selected": this.isActive
	      },
	      "class": [bem({
	        active: this.isActive,
	        disabled: this.disabled,
	        complete: !this.ellipsis
	      }), {
	        'van-ellipsis': this.ellipsis
	      }],
	      "style": this.style,
	      "on": {
	        "click": this.onClick
	      }
	    }, [h("span", {
	      "class": bem('text')
	    }, [this.slots() || this.title, h(_info.default, {
	      "attrs": {
	        "dot": this.dot,
	        "info": this.info
	      }
	    })])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.scrollLeftTo = scrollLeftTo;
	exports.scrollTopTo = scrollTopTo;
	
	var _raf = __webpack_require__(45);
	
	var _scroll = __webpack_require__(22);
	
	var scrollLeftRafId;
	
	function scrollLeftTo(scroller, to, duration) {
	  (0, _raf.cancelRaf)(scrollLeftRafId);
	  var count = 0;
	  var from = scroller.scrollLeft;
	  var frames = duration === 0 ? 1 : Math.round(duration * 1000 / 16);
	
	  function animate() {
	    scroller.scrollLeft += (to - from) / frames;
	
	    if (++count < frames) {
	      scrollLeftRafId = (0, _raf.raf)(animate);
	    }
	  }
	
	  animate();
	}
	
	function scrollTopTo(scroller, to, duration, callback) {
	  var current = (0, _scroll.getScrollTop)(scroller);
	  var isDown = current < to;
	  var frames = duration === 0 ? 1 : Math.round(duration * 1000 / 16);
	  var step = (to - current) / frames;
	
	  function animate() {
	    current += step;
	
	    if (isDown && current > to || !isDown && current < to) {
	      current = to;
	    }
	
	    (0, _scroll.setScrollTop)(scroller, current);
	
	    if (isDown && current < to || !isDown && current > to) {
	      (0, _raf.raf)(animate);
	    } else if (callback) {
	      (0, _raf.raf)(callback);
	    }
	  }
	
	  animate();
	}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _utils = __webpack_require__(1);
	
	var _lockClick = __webpack_require__(387);
	
	var _popup = __webpack_require__(39);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _loading = _interopRequireDefault(__webpack_require__(18));
	
	// Utils
	// Mixins
	// Components
	var _createNamespace = (0, _utils.createNamespace)('toast'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	var _default = createComponent({
	  mixins: [(0, _popup.PopupMixin)()],
	  props: {
	    icon: String,
	    className: null,
	    iconPrefix: String,
	    loadingType: String,
	    forbidClick: Boolean,
	    closeOnClick: Boolean,
	    message: [Number, String],
	    type: {
	      type: String,
	      default: 'text'
	    },
	    position: {
	      type: String,
	      default: 'middle'
	    },
	    transition: {
	      type: String,
	      default: 'van-fade'
	    },
	    lockScroll: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      clickable: false
	    };
	  },
	  mounted: function mounted() {
	    this.toggleClickable();
	  },
	  destroyed: function destroyed() {
	    this.toggleClickable();
	  },
	  watch: {
	    value: 'toggleClickable',
	    forbidClick: 'toggleClickable'
	  },
	  methods: {
	    onClick: function onClick() {
	      if (this.closeOnClick) {
	        this.close();
	      }
	    },
	    toggleClickable: function toggleClickable() {
	      var clickable = this.value && this.forbidClick;
	
	      if (this.clickable !== clickable) {
	        this.clickable = clickable;
	        (0, _lockClick.lockClick)(clickable);
	      }
	    },
	
	    /* istanbul ignore next */
	    onAfterEnter: function onAfterEnter() {
	      this.$emit('opened');
	
	      if (this.onOpened) {
	        this.onOpened();
	      }
	    },
	    onAfterLeave: function onAfterLeave() {
	      this.$emit('closed');
	    },
	    genIcon: function genIcon() {
	      var h = this.$createElement;
	      var icon = this.icon,
	          type = this.type,
	          iconPrefix = this.iconPrefix,
	          loadingType = this.loadingType;
	      var hasIcon = icon || type === 'success' || type === 'fail';
	
	      if (hasIcon) {
	        return h(_icon.default, {
	          "class": bem('icon'),
	          "attrs": {
	            "classPrefix": iconPrefix,
	            "name": icon || type
	          }
	        });
	      }
	
	      if (type === 'loading') {
	        return h(_loading.default, {
	          "class": bem('loading'),
	          "attrs": {
	            "type": loadingType
	          }
	        });
	      }
	    },
	    genMessage: function genMessage() {
	      var h = this.$createElement;
	      var type = this.type,
	          message = this.message;
	
	      if (!(0, _utils.isDef)(message) || message === '') {
	        return;
	      }
	
	      if (type === 'html') {
	        return h("div", {
	          "class": bem('text'),
	          "domProps": {
	            "innerHTML": message
	          }
	        });
	      }
	
	      return h("div", {
	        "class": bem('text')
	      }, [message]);
	    }
	  },
	  render: function render() {
	    var _ref;
	
	    var h = arguments[0];
	    return h("transition", {
	      "attrs": {
	        "name": this.transition
	      },
	      "on": {
	        "afterEnter": this.onAfterEnter,
	        "afterLeave": this.onAfterLeave
	      }
	    }, [h("div", {
	      "directives": [{
	        name: "show",
	        value: this.value
	      }],
	      "class": [bem([this.position, (_ref = {}, _ref[this.type] = !this.icon, _ref)]), this.className],
	      "on": {
	        "click": this.onClick
	      }
	    }, [this.genIcon(), this.genMessage()])]);
	  }
	});
	
	exports.default = _default;

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.lockClick = lockClick;
	var lockCount = 0;
	
	function lockClick(lock) {
	  if (lock) {
	    if (!lockCount) {
	      document.body.classList.add('van-toast--unclickable');
	    }
	
	    lockCount++;
	  } else {
	    lockCount--;
	
	    if (!lockCount) {
	      document.body.classList.remove('van-toast--unclickable');
	    }
	  }
	}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(1);
	
	var _functional = __webpack_require__(5);
	
	var _icon = _interopRequireDefault(__webpack_require__(8));
	
	var _sidebar = _interopRequireDefault(__webpack_require__(152));
	
	var _sidebarItem = _interopRequireDefault(__webpack_require__(151));
	
	// Utils
	// Components
	var _createNamespace = (0, _utils.createNamespace)('tree-select'),
	    createComponent = _createNamespace[0],
	    bem = _createNamespace[1];
	
	function TreeSelect(h, props, slots, ctx) {
	  var height = props.height,
	      items = props.items,
	      mainActiveIndex = props.mainActiveIndex,
	      activeId = props.activeId;
	  var selectedItem = items[+mainActiveIndex] || {};
	  var subItems = selectedItem.children || [];
	  var isMultiple = Array.isArray(activeId);
	
	  function isActiveItem(id) {
	    return isMultiple ? activeId.indexOf(id) !== -1 : activeId === id;
	  }
	
	  var Navs = items.map(function (item) {
	    return h(_sidebarItem.default, {
	      "attrs": {
	        "dot": item.dot,
	        "info": item.info,
	        "title": item.text,
	        "disabled": item.disabled
	      },
	      "class": [bem('nav-item'), item.className]
	    });
	  });
	
	  function Content() {
	    if (slots.content) {
	      return slots.content();
	    }
	
	    return subItems.map(function (item) {
	      return h("div", {
	        "key": item.id,
	        "class": ['van-ellipsis', bem('item', {
	          active: isActiveItem(item.id),
	          disabled: item.disabled
	        })],
	        "on": {
	          "click": function click() {
	            if (!item.disabled) {
	              var newActiveId = item.id;
	
	              if (isMultiple) {
	                newActiveId = activeId.slice();
	                var index = newActiveId.indexOf(item.id);
	
	                if (index !== -1) {
	                  newActiveId.splice(index, 1);
	                } else if (newActiveId.length < props.max) {
	                  newActiveId.push(item.id);
	                }
	              }
	
	              (0, _functional.emit)(ctx, 'update:active-id', newActiveId);
	              (0, _functional.emit)(ctx, 'click-item', item); // compatible with legacy usage, should be removed in next major version
	
	              (0, _functional.emit)(ctx, 'itemclick', item);
	            }
	          }
	        }
	      }, [item.text, isActiveItem(item.id) && h(_icon.default, {
	        "attrs": {
	          "name": "checked"
	        },
	        "class": bem('selected')
	      })]);
	    });
	  }
	
	  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
	    "class": bem(),
	    "style": {
	      height: (0, _utils.addUnit)(height)
	    }
	  }, (0, _functional.inherit)(ctx)]), [h(_sidebar.default, {
	    "class": bem('nav'),
	    "attrs": {
	      "activeKey": mainActiveIndex
	    },
	    "on": {
	      "change": function change(index) {
	        (0, _functional.emit)(ctx, 'update:main-active-index', index);
	        (0, _functional.emit)(ctx, 'click-nav', index); // compatible with legacy usage, should be removed in next major version
	
	        (0, _functional.emit)(ctx, 'navclick', index);
	      }
	    }
	  }, [Navs]), h("div", {
	    "class": bem('content')
	  }, [Content()])]);
	}
	
	TreeSelect.props = {
	  max: {
	    type: [Number, String],
	    default: Infinity
	  },
	  items: {
	    type: Array,
	    default: function _default() {
	      return [];
	    }
	  },
	  height: {
	    type: [Number, String],
	    default: 300
	  },
	  activeId: {
	    type: [Number, String, Array],
	    default: 0
	  },
	  mainActiveIndex: {
	    type: [Number, String],
	    default: 0
	  }
	};
	
	var _default2 = createComponent(TreeSelect);
	
	exports.default = _default2;

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.toArray = toArray;
	exports.readFile = readFile;
	exports.isOversize = isOversize;
	exports.isImageUrl = isImageUrl;
	exports.isImageFile = isImageFile;
	
	function toArray(item) {
	  if (Array.isArray(item)) {
	    return item;
	  }
	
	  return [item];
	}
	
	function readFile(file, resultType) {
	  return new Promise(function (resolve) {
	    if (resultType === 'file') {
	      resolve();
	      return;
	    }
	
	    var reader = new FileReader();
	
	    reader.onload = function (event) {
	      resolve(event.target.result);
	    };
	
	    if (resultType === 'dataUrl') {
	      reader.readAsDataURL(file);
	    } else if (resultType === 'text') {
	      reader.readAsText(file);
	    }
	  });
	}
	
	function isOversize(files, maxSize) {
	  return toArray(files).some(function (file) {
	    return file.size > maxSize;
	  });
	}
	
	var IMAGE_REGEXP = /\.(jpeg|jpg|gif|png|svg|webp|jfif|bmp|dpg)/i;
	
	function isImageUrl(url) {
	  return IMAGE_REGEXP.test(url);
	}
	
	function isImageFile(item) {
	  // some special urls cannot be recognized
	  // user can add `isImage` flag to mark it as an image url
	  if (item.isImage) {
	    return true;
	  }
	
	  if (item.file && item.file.type) {
	    return item.file.type.indexOf('image') === 0;
	  }
	
	  if (item.url) {
	    return isImageUrl(item.url);
	  }
	
	  if (item.content) {
	    return item.content.indexOf('data:image') === 0;
	  }
	
	  return false;
	}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.createBEM = createBEM;
	
	/**
	 * bem helper
	 * b() // 'button'
	 * b('text') // 'button__text'
	 * b({ disabled }) // 'button button--disabled'
	 * b('text', { disabled }) // 'button__text button__text--disabled'
	 * b(['disabled', 'primary']) // 'button button--disabled button--primary'
	 */
	var ELEMENT = '__';
	var MODS = '--';
	
	function join(name, el, symbol) {
	  return el ? name + symbol + el : name;
	}
	
	function prefix(name, mods) {
	  if (typeof mods === 'string') {
	    return join(name, mods, MODS);
	  }
	
	  if (Array.isArray(mods)) {
	    return mods.map(function (item) {
	      return prefix(name, item);
	    });
	  }
	
	  var ret = {};
	
	  if (mods) {
	    Object.keys(mods).forEach(function (key) {
	      ret[name + MODS + key] = mods[key];
	    });
	  }
	
	  return ret;
	}
	
	function createBEM(name) {
	  return function (el, mods) {
	    if (el && typeof el !== 'string') {
	      mods = el;
	      el = '';
	    }
	
	    el = join(name, el, ELEMENT);
	    return mods ? [el, prefix(el, mods)] : el;
	  };
	}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.unifySlots = unifySlots;
	exports.createComponent = createComponent;
	
	__webpack_require__(61);
	
	var _ = __webpack_require__(1);
	
	var _string = __webpack_require__(38);
	
	var _slots = __webpack_require__(355);
	
	var _vue = _interopRequireDefault(__webpack_require__(6));
	
	/**
	 * Create a basic component with common options
	 */
	function install(Vue) {
	  var name = this.name;
	  Vue.component(name, this);
	  Vue.component((0, _string.camelize)("-" + name), this);
	} // unify slots & scopedSlots
	
	
	function unifySlots(context) {
	  // use data.scopedSlots in lower Vue version
	  var scopedSlots = context.scopedSlots || context.data.scopedSlots || {};
	  var slots = context.slots();
	  Object.keys(slots).forEach(function (key) {
	    if (!scopedSlots[key]) {
	      scopedSlots[key] = function () {
	        return slots[key];
	      };
	    }
	  });
	  return scopedSlots;
	} // should be removed after Vue 3
	
	
	function transformFunctionComponent(pure) {
	  return {
	    functional: true,
	    props: pure.props,
	    model: pure.model,
	    render: function render(h, context) {
	      return pure(h, context.props, unifySlots(context), context);
	    }
	  };
	}
	
	function createComponent(name) {
	  return function (sfc) {
	    if ((0, _.isFunction)(sfc)) {
	      sfc = transformFunctionComponent(sfc);
	    }
	
	    if (!sfc.functional) {
	      sfc.mixins = sfc.mixins || [];
	      sfc.mixins.push(_slots.SlotsMixin);
	    }
	
	    sfc.name = name;
	    sfc.install = install;
	    return sfc;
	  };
	}

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	exports.__esModule = true;
	exports.createI18N = createI18N;
	
	var _ = __webpack_require__(1);
	
	var _string = __webpack_require__(38);
	
	var _locale = _interopRequireDefault(__webpack_require__(61));
	
	function createI18N(name) {
	  var prefix = (0, _string.camelize)(name) + '.';
	  return function (path) {
	    var messages = _locale.default.messages();
	
	    var message = (0, _.get)(messages, prefix + path) || (0, _.get)(messages, path);
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _.isFunction)(message) ? message.apply(void 0, args) : message;
	  };
	}

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createNamespace = createNamespace;
	
	var _bem = __webpack_require__(390);
	
	var _component = __webpack_require__(391);
	
	var _i18n = __webpack_require__(392);
	
	function createNamespace(name) {
	  name = 'van-' + name;
	  return [(0, _component.createComponent)(name), (0, _bem.createBEM)(name), (0, _i18n.createI18N)(name)];
	}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.deepClone = deepClone;
	
	var _deepAssign = __webpack_require__(170);
	
	function deepClone(obj) {
	  if (Array.isArray(obj)) {
	    return obj.map(function (item) {
	      return deepClone(item);
	    });
	  }
	
	  if (typeof obj === 'object') {
	    return (0, _deepAssign.deepAssign)({}, obj);
	  }
	
	  return obj;
	}

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.addUnit = addUnit;
	
	var _ = __webpack_require__(1);
	
	var _number = __webpack_require__(65);
	
	function addUnit(value) {
	  if (!(0, _.isDef)(value)) {
	    return undefined;
	  }
	
	  value = String(value);
	  return (0, _number.isNumeric)(value) ? value + "px" : value;
	}

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isEmail = isEmail;
	
	/* eslint-disable */
	function isEmail(value) {
	  var reg = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
	  return reg.test(value);
	}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Vue-Lazyload.js v1.2.3
	 * (c) 2018 Awe <hilongjw@gmail.com>
	 * Released under the MIT License.
	 */
	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):e.VueLazyload=t()}(this,function(){"use strict";function e(e){return e.constructor&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}function t(e){e=e||{};var t=arguments.length,i=0;if(1===t)return e;for(;++i<t;){var o=arguments[i];g(e)&&(e=o),r(o)&&n(e,o)}return e}function n(e,n){m(e,n);for(var o in n)if("__proto__"!==o&&i(n,o)){var a=n[o];r(a)?("undefined"===L(e[o])&&"function"===L(a)&&(e[o]=a),e[o]=t(e[o]||{},a)):e[o]=a}return e}function r(e){return"object"===L(e)||"function"===L(e)}function i(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function o(e,t){if(e.length){var n=e.indexOf(t);return n>-1?e.splice(n,1):void 0}}function a(e,t){for(var n=!1,r=0,i=e.length;r<i;r++)if(t(e[r])){n=!0;break}return n}function s(e,t){if("IMG"===e.tagName&&e.getAttribute("data-srcset")){var n=e.getAttribute("data-srcset"),r=[],i=e.parentNode,o=i.offsetWidth*t,a=void 0,s=void 0,u=void 0;n=n.trim().split(","),n.map(function(e){e=e.trim(),a=e.lastIndexOf(" "),-1===a?(s=e,u=999998):(s=e.substr(0,a),u=parseInt(e.substr(a+1,e.length-a-2),10)),r.push([u,s])}),r.sort(function(e,t){if(e[0]<t[0])return-1;if(e[0]>t[0])return 1;if(e[0]===t[0]){if(-1!==t[1].indexOf(".webp",t[1].length-5))return 1;if(-1!==e[1].indexOf(".webp",e[1].length-5))return-1}return 0});for(var l="",d=void 0,c=r.length,h=0;h<c;h++)if(d=r[h],d[0]>=o){l=d[1];break}return l}}function u(e,t){for(var n=void 0,r=0,i=e.length;r<i;r++)if(t(e[r])){n=e[r];break}return n}function l(){if(!k)return!1;var e=!0,t=document;try{var n=t.createElement("object");n.type="image/webp",n.style.visibility="hidden",n.innerHTML="!",t.body.appendChild(n),e=!n.offsetWidth,t.body.removeChild(n)}catch(t){e=!1}return e}function d(e,t){var n=null,r=0;return function(){if(!n){var i=Date.now()-r,o=this,a=arguments,s=function(){r=Date.now(),n=!1,e.apply(o,a)};i>=t?s():n=setTimeout(s,t)}}}function c(e){return null!==e&&"object"===(void 0===e?"undefined":p(e))}function h(e){if(!(e instanceof Object))return[];if(Object.keys)return Object.keys(e);var t=[];for(var n in e)e.hasOwnProperty(n)&&t.push(n);return t}function f(e){for(var t=e.length,n=[],r=0;r<t;r++)n.push(e[r]);return n}function v(){}var p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},b=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},y=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),g=function(e){return null==e||"function"!=typeof e&&"object"!==(void 0===e?"undefined":p(e))},m=function(e,t){if(null===e||void 0===e)throw new TypeError("expected first argument to be an object.");if(void 0===t||"undefined"==typeof Symbol)return e;if("function"!=typeof Object.getOwnPropertySymbols)return e;for(var n=Object.prototype.propertyIsEnumerable,r=Object(e),i=arguments.length,o=0;++o<i;)for(var a=Object(arguments[o]),s=Object.getOwnPropertySymbols(a),u=0;u<s.length;u++){var l=s[u];n.call(a,l)&&(r[l]=a[l])}return r},w=Object.prototype.toString,L=function(t){var n=void 0===t?"undefined":p(t);return"undefined"===n?"undefined":null===t?"null":!0===t||!1===t||t instanceof Boolean?"boolean":"string"===n||t instanceof String?"string":"number"===n||t instanceof Number?"number":"function"===n||t instanceof Function?void 0!==t.constructor.name&&"Generator"===t.constructor.name.slice(0,9)?"generatorfunction":"function":void 0!==Array.isArray&&Array.isArray(t)?"array":t instanceof RegExp?"regexp":t instanceof Date?"date":(n=w.call(t),"[object RegExp]"===n?"regexp":"[object Date]"===n?"date":"[object Arguments]"===n?"arguments":"[object Error]"===n?"error":"[object Promise]"===n?"promise":e(t)?"buffer":"[object Set]"===n?"set":"[object WeakSet]"===n?"weakset":"[object Map]"===n?"map":"[object WeakMap]"===n?"weakmap":"[object Symbol]"===n?"symbol":"[object Map Iterator]"===n?"mapiterator":"[object Set Iterator]"===n?"setiterator":"[object String Iterator]"===n?"stringiterator":"[object Array Iterator]"===n?"arrayiterator":"[object Int8Array]"===n?"int8array":"[object Uint8Array]"===n?"uint8array":"[object Uint8ClampedArray]"===n?"uint8clampedarray":"[object Int16Array]"===n?"int16array":"[object Uint16Array]"===n?"uint16array":"[object Int32Array]"===n?"int32array":"[object Uint32Array]"===n?"uint32array":"[object Float32Array]"===n?"float32array":"[object Float64Array]"===n?"float64array":"object")},_=t,k="undefined"!=typeof window,E=k&&"IntersectionObserver"in window,A={event:"event",observer:"observer"},j=function(){function e(e,t){t=t||{bubbles:!1,cancelable:!1,detail:void 0};var n=document.createEvent("CustomEvent");return n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),n}if(k)return"function"==typeof window.CustomEvent?window.CustomEvent:(e.prototype=window.Event.prototype,e)}(),z=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return k?window.devicePixelRatio||e:e},T=function(){if(k){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){e=!0}});window.addEventListener("test",null,t)}catch(e){}return e}}(),O={on:function(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];T?e.addEventListener(t,n,{capture:r,passive:!0}):e.addEventListener(t,n,r)},off:function(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];e.removeEventListener(t,n,r)}},I=function(e,t,n){var r=new Image;r.src=e.src,r.onload=function(){t({naturalHeight:r.naturalHeight,naturalWidth:r.naturalWidth,src:r.src})},r.onerror=function(e){n(e)}},x=function(e,t){return"undefined"!=typeof getComputedStyle?getComputedStyle(e,null).getPropertyValue(t):e.style[t]},S=function(e){return x(e,"overflow")+x(e,"overflow-y")+x(e,"overflow-x")},$=function(e){if(k){if(!(e instanceof HTMLElement))return window;for(var t=e;t&&t!==document.body&&t!==document.documentElement&&t.parentNode;){if(/(scroll|auto)/.test(S(t)))return t;t=t.parentNode}return window}},H={},Q=function(){function e(t){var n=t.el,r=t.src,i=t.error,o=t.loading,a=t.bindType,s=t.$parent,u=t.options,l=t.elRenderer;b(this,e),this.el=n,this.src=r,this.error=i,this.loading=o,this.bindType=a,this.attempt=0,this.naturalHeight=0,this.naturalWidth=0,this.options=u,this.rect=null,this.$parent=s,this.elRenderer=l,this.performanceData={init:Date.now(),loadStart:0,loadEnd:0},this.filter(),this.initState(),this.render("loading",!1)}return y(e,[{key:"initState",value:function(){this.el.dataset.src=this.src,this.state={error:!1,loaded:!1,rendered:!1}}},{key:"record",value:function(e){this.performanceData[e]=Date.now()}},{key:"update",value:function(e){var t=e.src,n=e.loading,r=e.error,i=this.src;this.src=t,this.loading=n,this.error=r,this.filter(),i!==this.src&&(this.attempt=0,this.initState())}},{key:"getRect",value:function(){this.rect=this.el.getBoundingClientRect()}},{key:"checkInView",value:function(){return this.getRect(),this.rect.top<window.innerHeight*this.options.preLoad&&this.rect.bottom>this.options.preLoadTop&&this.rect.left<window.innerWidth*this.options.preLoad&&this.rect.right>0}},{key:"filter",value:function(){var e=this;h(this.options.filter).map(function(t){e.options.filter[t](e,e.options)})}},{key:"renderLoading",value:function(e){var t=this;I({src:this.loading},function(n){t.render("loading",!1),e()},function(){e(),t.options.silent||console.warn("VueLazyload log: load failed with loading image("+t.loading+")")})}},{key:"load",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:v;return this.attempt>this.options.attempt-1&&this.state.error?(this.options.silent||console.log("VueLazyload log: "+this.src+" tried too more than "+this.options.attempt+" times"),void t()):this.state.loaded||H[this.src]?(this.state.loaded=!0,t(),this.render("loaded",!0)):void this.renderLoading(function(){e.attempt++,e.record("loadStart"),I({src:e.src},function(n){e.naturalHeight=n.naturalHeight,e.naturalWidth=n.naturalWidth,e.state.loaded=!0,e.state.error=!1,e.record("loadEnd"),e.render("loaded",!1),H[e.src]=1,t()},function(t){!e.options.silent&&console.error(t),e.state.error=!0,e.state.loaded=!1,e.render("error",!1)})})}},{key:"render",value:function(e,t){this.elRenderer(this,e,t)}},{key:"performance",value:function(){var e="loading",t=0;return this.state.loaded&&(e="loaded",t=(this.performanceData.loadEnd-this.performanceData.loadStart)/1e3),this.state.error&&(e="error"),{src:this.src,state:e,time:t}}},{key:"destroy",value:function(){this.el=null,this.src=null,this.error=null,this.loading=null,this.bindType=null,this.attempt=0}}]),e}(),C="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",R=["scroll","wheel","mousewheel","resize","animationend","transitionend","touchmove"],W={rootMargin:"0px",threshold:0},D=function(e){return function(){function t(e){var n=e.preLoad,r=e.error,i=e.throttleWait,o=e.preLoadTop,a=e.dispatchEvent,s=e.loading,u=e.attempt,c=e.silent,h=void 0===c||c,f=e.scale,v=e.listenEvents,p=(e.hasbind,e.filter),y=e.adapter,g=e.observer,m=e.observerOptions;b(this,t),this.version="1.2.3",this.mode=A.event,this.ListenerQueue=[],this.TargetIndex=0,this.TargetQueue=[],this.options={silent:h,dispatchEvent:!!a,throttleWait:i||200,preLoad:n||1.3,preLoadTop:o||0,error:r||C,loading:s||C,attempt:u||3,scale:f||z(f),ListenEvents:v||R,hasbind:!1,supportWebp:l(),filter:p||{},adapter:y||{},observer:!!g,observerOptions:m||W},this._initEvent(),this.lazyLoadHandler=d(this._lazyLoadHandler.bind(this),this.options.throttleWait),this.setMode(this.options.observer?A.observer:A.event)}return y(t,[{key:"config",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};_(this.options,e)}},{key:"performance",value:function(){var e=[];return this.ListenerQueue.map(function(t){e.push(t.performance())}),e}},{key:"addLazyBox",value:function(e){this.ListenerQueue.push(e),k&&(this._addListenerTarget(window),this._observer&&this._observer.observe(e.el),e.$el&&e.$el.parentNode&&this._addListenerTarget(e.$el.parentNode))}},{key:"add",value:function(t,n,r){var i=this;if(a(this.ListenerQueue,function(e){return e.el===t}))return this.update(t,n),e.nextTick(this.lazyLoadHandler);var o=this._valueFormatter(n.value),u=o.src,l=o.loading,d=o.error;e.nextTick(function(){u=s(t,i.options.scale)||u,i._observer&&i._observer.observe(t);var o=Object.keys(n.modifiers)[0],a=void 0;o&&(a=r.context.$refs[o],a=a?a.$el||a:document.getElementById(o)),a||(a=$(t));var c=new Q({bindType:n.arg,$parent:a,el:t,loading:l,error:d,src:u,elRenderer:i._elRenderer.bind(i),options:i.options});i.ListenerQueue.push(c),k&&(i._addListenerTarget(window),i._addListenerTarget(a)),i.lazyLoadHandler(),e.nextTick(function(){return i.lazyLoadHandler()})})}},{key:"update",value:function(t,n){var r=this,i=this._valueFormatter(n.value),o=i.src,a=i.loading,l=i.error;o=s(t,this.options.scale)||o;var d=u(this.ListenerQueue,function(e){return e.el===t});d&&d.update({src:o,loading:a,error:l}),this._observer&&(this._observer.unobserve(t),this._observer.observe(t)),this.lazyLoadHandler(),e.nextTick(function(){return r.lazyLoadHandler()})}},{key:"remove",value:function(e){if(e){this._observer&&this._observer.unobserve(e);var t=u(this.ListenerQueue,function(t){return t.el===e});t&&(this._removeListenerTarget(t.$parent),this._removeListenerTarget(window),o(this.ListenerQueue,t)&&t.destroy())}}},{key:"removeComponent",value:function(e){e&&(o(this.ListenerQueue,e),this._observer&&this._observer.unobserve(e.el),e.$parent&&e.$el.parentNode&&this._removeListenerTarget(e.$el.parentNode),this._removeListenerTarget(window))}},{key:"setMode",value:function(e){var t=this;E||e!==A.observer||(e=A.event),this.mode=e,e===A.event?(this._observer&&(this.ListenerQueue.forEach(function(e){t._observer.unobserve(e.el)}),this._observer=null),this.TargetQueue.forEach(function(e){t._initListen(e.el,!0)})):(this.TargetQueue.forEach(function(e){t._initListen(e.el,!1)}),this._initIntersectionObserver())}},{key:"_addListenerTarget",value:function(e){if(e){var t=u(this.TargetQueue,function(t){return t.el===e});return t?t.childrenCount++:(t={el:e,id:++this.TargetIndex,childrenCount:1,listened:!0},this.mode===A.event&&this._initListen(t.el,!0),this.TargetQueue.push(t)),this.TargetIndex}}},{key:"_removeListenerTarget",value:function(e){var t=this;this.TargetQueue.forEach(function(n,r){n.el===e&&(--n.childrenCount||(t._initListen(n.el,!1),t.TargetQueue.splice(r,1),n=null))})}},{key:"_initListen",value:function(e,t){var n=this;this.options.ListenEvents.forEach(function(r){return O[t?"on":"off"](e,r,n.lazyLoadHandler)})}},{key:"_initEvent",value:function(){var e=this;this.Event={listeners:{loading:[],loaded:[],error:[]}},this.$on=function(t,n){e.Event.listeners[t].push(n)},this.$once=function(t,n){function r(){i.$off(t,r),n.apply(i,arguments)}var i=e;e.$on(t,r)},this.$off=function(t,n){if(!n)return void(e.Event.listeners[t]=[]);o(e.Event.listeners[t],n)},this.$emit=function(t,n,r){e.Event.listeners[t].forEach(function(e){return e(n,r)})}}},{key:"_lazyLoadHandler",value:function(){var e=this,t=!1;this.ListenerQueue.forEach(function(n,r){n.state.loaded||(t=n.checkInView())&&n.load(function(){!n.error&&n.loaded&&e.ListenerQueue.splice(r,1)})})}},{key:"_initIntersectionObserver",value:function(){var e=this;E&&(this._observer=new IntersectionObserver(this._observerHandler.bind(this),this.options.observerOptions),this.ListenerQueue.length&&this.ListenerQueue.forEach(function(t){e._observer.observe(t.el)}))}},{key:"_observerHandler",value:function(e,t){var n=this;e.forEach(function(e){e.isIntersecting&&n.ListenerQueue.forEach(function(t){if(t.el===e.target){if(t.state.loaded)return n._observer.unobserve(t.el);t.load()}})})}},{key:"_elRenderer",value:function(e,t,n){if(e.el){var r=e.el,i=e.bindType,o=void 0;switch(t){case"loading":o=e.loading;break;case"error":o=e.error;break;default:o=e.src}if(i?r.style[i]='url("'+o+'")':r.getAttribute("src")!==o&&r.setAttribute("src",o),r.setAttribute("lazy",t),this.$emit(t,e,n),this.options.adapter[t]&&this.options.adapter[t](e,this.options),this.options.dispatchEvent){var a=new j(t,{detail:e});r.dispatchEvent(a)}}}},{key:"_valueFormatter",value:function(e){var t=e,n=this.options.loading,r=this.options.error;return c(e)&&(e.src||this.options.silent||console.error("Vue Lazyload warning: miss src with "+e),t=e.src,n=e.loading||this.options.loading,r=e.error||this.options.error),{src:t,loading:n,error:r}}}]),t}()},B=function(e){return{props:{tag:{type:String,default:"div"}},render:function(e){return!1===this.show?e(this.tag):e(this.tag,null,this.$slots.default)},data:function(){return{el:null,state:{loaded:!1},rect:{},show:!1}},mounted:function(){this.el=this.$el,e.addLazyBox(this),e.lazyLoadHandler()},beforeDestroy:function(){e.removeComponent(this)},methods:{getRect:function(){this.rect=this.$el.getBoundingClientRect()},checkInView:function(){return this.getRect(),k&&this.rect.top<window.innerHeight*e.options.preLoad&&this.rect.bottom>0&&this.rect.left<window.innerWidth*e.options.preLoad&&this.rect.right>0},load:function(){this.show=!0,this.state.loaded=!0,this.$emit("show",this)}}}},V=function(){function e(t){var n=t.lazy;b(this,e),this.lazy=n,n.lazyContainerMananger=this,this._queue=[]}return y(e,[{key:"bind",value:function(e,t,n){var r=new N({el:e,binding:t,vnode:n,lazy:this.lazy});this._queue.push(r)}},{key:"update",value:function(e,t,n){var r=u(this._queue,function(t){return t.el===e});r&&r.update({el:e,binding:t,vnode:n})}},{key:"unbind",value:function(e,t,n){var r=u(this._queue,function(t){return t.el===e});r&&(r.clear(),o(this._queue,r))}}]),e}(),M={selector:"img"},N=function(){function e(t){var n=t.el,r=t.binding,i=t.vnode,o=t.lazy;b(this,e),this.el=null,this.vnode=i,this.binding=r,this.options={},this.lazy=o,this._queue=[],this.update({el:n,binding:r})}return y(e,[{key:"update",value:function(e){var t=this,n=e.el,r=e.binding;this.el=n,this.options=_({},M,r.value),this.getImgs().forEach(function(e){t.lazy.add(e,_({},t.binding,{value:{src:e.dataset.src,error:e.dataset.error,loading:e.dataset.loading}}),t.vnode)})}},{key:"getImgs",value:function(){return f(this.el.querySelectorAll(this.options.selector))}},{key:"clear",value:function(){var e=this;this.getImgs().forEach(function(t){return e.lazy.remove(t)}),this.vnode=null,this.binding=null,this.lazy=null}}]),e}();return{install:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=D(e),r=new n(t),i=new V({lazy:r}),o="2"===e.version.split(".")[0];e.prototype.$Lazyload=r,t.lazyComponent&&e.component("lazy-component",B(r)),o?(e.directive("lazy",{bind:r.add.bind(r),update:r.update.bind(r),componentUpdated:r.lazyLoadHandler.bind(r),unbind:r.remove.bind(r)}),e.directive("lazy-container",{bind:i.bind.bind(i),update:i.update.bind(i),unbind:i.unbind.bind(i)})):(e.directive("lazy",{bind:r.lazyLoadHandler.bind(r),update:function(e,t){_(this.vm.$refs,this.vm.$els),r.add(this.el,{modifiers:this.modifiers||{},arg:this.arg,value:e,oldValue:t},{context:this.vm})},unbind:function(){r.remove(this.el)}}),e.directive("lazy-container",{update:function(e,t){i.update(this.el,{modifiers:this.modifiers||{},arg:this.arg,value:e,oldValue:t},{context:this.vm})},unbind:function(){i.unbind(this.el)}}))}}});


/***/ }),
/* 398 */,
/* 399 */,
/* 400 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	/**
	 * Merge an array of objects into one.
	 *
	 * @param {Array<Object>} arr
	 * @return {Object}
	 */
	
	
	
	/**
	 * Get the first item that pass the test
	 * by second argument function
	 *
	 * @param {Array} list
	 * @param {Function} f
	 * @return {*}
	 */
	function find(list, f) {
	  return list.filter(f)[0];
	}
	
	/**
	 * Deep copy the given object considering circular structure.
	 * This function caches all nested objects and its copies.
	 * If it detects circular structure, use cached copy to avoid infinite loop.
	 *
	 * @param {*} obj
	 * @param {Array<Object>} cache
	 * @return {*}
	 */
	function deepCopy(obj) {
	  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  // just return if obj is immutable value
	  if (obj === null || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
	    return obj;
	  }
	
	  // if obj is hit, it is in circular structure
	  var hit = find(cache, function (c) {
	    return c.original === obj;
	  });
	  if (hit) {
	    return hit.copy;
	  }
	
	  var copy = Array.isArray(obj) ? [] : {};
	  // put the copy into cache at first
	  // because we want to refer it in recursive deepCopy
	  cache.push({
	    original: obj,
	    copy: copy
	  });
	
	  Object.keys(obj).forEach(function (key) {
	    copy[key] = deepCopy(obj[key], cache);
	  });
	
	  return copy;
	}
	
	/**
	 * Check whether the given value is Object or not
	 *
	 * @param {*} obj
	 * @return {Boolean}
	 */
	
	
	
	/**
	 * Get state sub tree by given keys.
	 *
	 * @param {Object} state
	 * @param {Array<String>} nestedKeys
	 * @return {Object}
	 */
	
	// Credits: borrowed code from fcomb/redux-logger
	
	function createLogger() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$collapsed = _ref.collapsed,
	      collapsed = _ref$collapsed === undefined ? true : _ref$collapsed,
	      _ref$transformer = _ref.transformer,
	      transformer = _ref$transformer === undefined ? function (state) {
	    return state;
	  } : _ref$transformer,
	      _ref$mutationTransfor = _ref.mutationTransformer,
	      mutationTransformer = _ref$mutationTransfor === undefined ? function (mut) {
	    return mut;
	  } : _ref$mutationTransfor;
	
	  return function (store) {
	    var prevState = deepCopy(store.state);
	
	    store.subscribe(function (mutation, state) {
	      if (typeof console === 'undefined') {
	        return;
	      }
	      var nextState = deepCopy(state);
	      var time = new Date();
	      var formattedTime = ' @ ' + pad(time.getHours(), 2) + ':' + pad(time.getMinutes(), 2) + ':' + pad(time.getSeconds(), 2) + '.' + pad(time.getMilliseconds(), 3);
	      var formattedMutation = mutationTransformer(mutation);
	      var message = 'mutation ' + mutation.type + formattedTime;
	      var startMessage = collapsed ? console.groupCollapsed : console.group;
	
	      // render
	      try {
	        startMessage.call(console, message);
	      } catch (e) {
	        console.log(message);
	      }
	
	      console.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
	      console.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
	      console.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
	
	      try {
	        console.groupEnd();
	      } catch (e) {
	        console.log('—— log end ——');
	      }
	
	      prevState = nextState;
	    });
	  };
	}
	
	function repeat(str, times) {
	  return new Array(times + 1).join(str);
	}
	
	function pad(num, maxLength) {
	  return repeat('0', maxLength - num.toString().length) + num;
	}
	
	module.exports = createLogger;


/***/ }),
/* 401 */,
/* 402 */,
/* 403 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 404 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ })
]);


// WEBPACK FOOTER //
// static/js/vendor.0509cfc3f66f98a692e9.1615801888628.js